function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire806c"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire806c"] = parcelRequire;
}
parcelRequire.register("c2VSo", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0243656f51a2fb4f$export$ffb0004e005737fa; }, function (v) { return $0243656f51a2fb4f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $0243656f51a2fb4f$export$5f8d39834fd61797; }, function (v) { return $0243656f51a2fb4f$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $0243656f51a2fb4f$export$e2c29f18771995cb; }, function (v) { return $0243656f51a2fb4f$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $0243656f51a2fb4f$export$74bf444e3cd11ea5; }, function (v) { return $0243656f51a2fb4f$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $0243656f51a2fb4f$export$dca3b0875bd9a954; }, function (v) { return $0243656f51a2fb4f$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $0243656f51a2fb4f$export$16fa2f45be04daa8; }, function (v) { return $0243656f51a2fb4f$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $0243656f51a2fb4f$export$221d75b3f55bb0bd; }, function (v) { return $0243656f51a2fb4f$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $0243656f51a2fb4f$export$ae55be85d98224ed; }, function (v) { return $0243656f51a2fb4f$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $0243656f51a2fb4f$export$e530037191fcd5d7; }, function (v) { return $0243656f51a2fb4f$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $0243656f51a2fb4f$export$fd42f52fd3ae1109; }, function (v) { return $0243656f51a2fb4f$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $0243656f51a2fb4f$export$c8a8987d4410bf2d; }, function (v) { return $0243656f51a2fb4f$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $0243656f51a2fb4f$export$d38cd72104c1f0e9; }, function (v) { return $0243656f51a2fb4f$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $0243656f51a2fb4f$export$7d1e3a5e95ceca43; }, function (v) { return $0243656f51a2fb4f$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $0243656f51a2fb4f$export$257a8862b851cb5b; }, function (v) { return $0243656f51a2fb4f$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $0243656f51a2fb4f$export$a8257692ac88316c; }, function (v) { return $0243656f51a2fb4f$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $0243656f51a2fb4f$export$488013bae63b21da; }, function (v) { return $0243656f51a2fb4f$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $0243656f51a2fb4f$export$7c73462e0d25e514; }, function (v) { return $0243656f51a2fb4f$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $0243656f51a2fb4f$export$35808ee640e87ca7; }, function (v) { return $0243656f51a2fb4f$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $0243656f51a2fb4f$export$fae74005e78b1a27; }, function (v) { return $0243656f51a2fb4f$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $0243656f51a2fb4f$export$dc8fbce3eb94dc1e; }, function (v) { return $0243656f51a2fb4f$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $0243656f51a2fb4f$export$6d9c69b0de29b591; }, function (v) { return $0243656f51a2fb4f$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $0243656f51a2fb4f$export$d5a552a76deda3c2; }, function (v) { return $0243656f51a2fb4f$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $0243656f51a2fb4f$export$e5c5a5f917a5871c; }, function (v) { return $0243656f51a2fb4f$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $0243656f51a2fb4f$export$1538c33de8887b59; }, function (v) { return $0243656f51a2fb4f$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $0243656f51a2fb4f$export$13e3392192263954; }, function (v) { return $0243656f51a2fb4f$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $0243656f51a2fb4f$export$b8f5890fc79d6aca; }, function (v) { return $0243656f51a2fb4f$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $0243656f51a2fb4f$export$60241385465d0a34; }, function (v) { return $0243656f51a2fb4f$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $0243656f51a2fb4f$export$83d89fbfd8236492; }, function (v) { return $0243656f51a2fb4f$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0243656f51a2fb4f$export$ffb0004e005737fa;
var $0243656f51a2fb4f$export$5f8d39834fd61797;
var $0243656f51a2fb4f$export$e2c29f18771995cb;
var $0243656f51a2fb4f$export$74bf444e3cd11ea5;
var $0243656f51a2fb4f$export$dca3b0875bd9a954;
var $0243656f51a2fb4f$export$16fa2f45be04daa8;
var $0243656f51a2fb4f$export$221d75b3f55bb0bd;
var $0243656f51a2fb4f$export$ae55be85d98224ed;
var $0243656f51a2fb4f$export$e530037191fcd5d7;
var $0243656f51a2fb4f$export$fd42f52fd3ae1109;
var $0243656f51a2fb4f$export$c8a8987d4410bf2d;
var $0243656f51a2fb4f$export$d38cd72104c1f0e9;
var $0243656f51a2fb4f$export$7d1e3a5e95ceca43;
var $0243656f51a2fb4f$export$257a8862b851cb5b;
var $0243656f51a2fb4f$export$a8257692ac88316c;
var $0243656f51a2fb4f$export$488013bae63b21da;
var $0243656f51a2fb4f$export$7c73462e0d25e514;
var $0243656f51a2fb4f$export$35808ee640e87ca7;
var $0243656f51a2fb4f$export$fae74005e78b1a27;
var $0243656f51a2fb4f$export$dc8fbce3eb94dc1e;
var $0243656f51a2fb4f$export$6d9c69b0de29b591;
var $0243656f51a2fb4f$export$d5a552a76deda3c2;
var $0243656f51a2fb4f$export$e5c5a5f917a5871c;
var $0243656f51a2fb4f$export$1538c33de8887b59;
var $0243656f51a2fb4f$export$13e3392192263954;
var $0243656f51a2fb4f$export$b8f5890fc79d6aca;
var $0243656f51a2fb4f$export$60241385465d0a34;
var $0243656f51a2fb4f$export$83d89fbfd8236492;
"use strict";

var $bDppX = parcelRequire("bDppX");
var $0243656f51a2fb4f$var$n = 60103, $0243656f51a2fb4f$var$p = 60106;
$0243656f51a2fb4f$export$ffb0004e005737fa = 60107;
$0243656f51a2fb4f$export$5f8d39834fd61797 = 60108;
$0243656f51a2fb4f$export$e2c29f18771995cb = 60114;
var $0243656f51a2fb4f$var$q = 60109, $0243656f51a2fb4f$var$r = 60110, $0243656f51a2fb4f$var$t = 60112;
$0243656f51a2fb4f$export$74bf444e3cd11ea5 = 60113;
var $0243656f51a2fb4f$var$u = 60115, $0243656f51a2fb4f$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $0243656f51a2fb4f$var$w = Symbol.for;
    $0243656f51a2fb4f$var$n = $0243656f51a2fb4f$var$w("react.element");
    $0243656f51a2fb4f$var$p = $0243656f51a2fb4f$var$w("react.portal");
    $0243656f51a2fb4f$export$ffb0004e005737fa = $0243656f51a2fb4f$var$w("react.fragment");
    $0243656f51a2fb4f$export$5f8d39834fd61797 = $0243656f51a2fb4f$var$w("react.strict_mode");
    $0243656f51a2fb4f$export$e2c29f18771995cb = $0243656f51a2fb4f$var$w("react.profiler");
    $0243656f51a2fb4f$var$q = $0243656f51a2fb4f$var$w("react.provider");
    $0243656f51a2fb4f$var$r = $0243656f51a2fb4f$var$w("react.context");
    $0243656f51a2fb4f$var$t = $0243656f51a2fb4f$var$w("react.forward_ref");
    $0243656f51a2fb4f$export$74bf444e3cd11ea5 = $0243656f51a2fb4f$var$w("react.suspense");
    $0243656f51a2fb4f$var$u = $0243656f51a2fb4f$var$w("react.memo");
    $0243656f51a2fb4f$var$v = $0243656f51a2fb4f$var$w("react.lazy");
}
var $0243656f51a2fb4f$var$x = "function" === typeof Symbol && Symbol.iterator;
function $0243656f51a2fb4f$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0243656f51a2fb4f$var$x && a[$0243656f51a2fb4f$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $0243656f51a2fb4f$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0243656f51a2fb4f$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $0243656f51a2fb4f$var$B = {};
function $0243656f51a2fb4f$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $0243656f51a2fb4f$var$B;
    this.updater = c || $0243656f51a2fb4f$var$A;
}
$0243656f51a2fb4f$var$C.prototype.isReactComponent = {};
$0243656f51a2fb4f$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($0243656f51a2fb4f$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$0243656f51a2fb4f$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $0243656f51a2fb4f$var$D() {}
$0243656f51a2fb4f$var$D.prototype = $0243656f51a2fb4f$var$C.prototype;
function $0243656f51a2fb4f$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $0243656f51a2fb4f$var$B;
    this.updater = c || $0243656f51a2fb4f$var$A;
}
var $0243656f51a2fb4f$var$F = $0243656f51a2fb4f$var$E.prototype = new $0243656f51a2fb4f$var$D;
$0243656f51a2fb4f$var$F.constructor = $0243656f51a2fb4f$var$E;
$bDppX($0243656f51a2fb4f$var$F, $0243656f51a2fb4f$var$C.prototype);
$0243656f51a2fb4f$var$F.isPureReactComponent = !0;
var $0243656f51a2fb4f$var$G = {
    current: null
}, $0243656f51a2fb4f$var$H = Object.prototype.hasOwnProperty, $0243656f51a2fb4f$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0243656f51a2fb4f$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$0243656f51a2fb4f$var$H.call(b, e) && !$0243656f51a2fb4f$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $0243656f51a2fb4f$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $0243656f51a2fb4f$var$G.current
    };
}
function $0243656f51a2fb4f$var$K(a, b) {
    return {
        $$typeof: $0243656f51a2fb4f$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $0243656f51a2fb4f$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $0243656f51a2fb4f$var$n;
}
function $0243656f51a2fb4f$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $0243656f51a2fb4f$var$M = /\/+/g;
function $0243656f51a2fb4f$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $0243656f51a2fb4f$var$escape("" + a.key) : b.toString(36);
}
function $0243656f51a2fb4f$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $0243656f51a2fb4f$var$n:
                case $0243656f51a2fb4f$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $0243656f51a2fb4f$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($0243656f51a2fb4f$var$M, "$&/") + "/"), $0243656f51a2fb4f$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($0243656f51a2fb4f$var$L(d) && (d = $0243656f51a2fb4f$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($0243656f51a2fb4f$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $0243656f51a2fb4f$var$N(k, g);
        h += $0243656f51a2fb4f$var$O(k, b, c, f, d);
    }
    else if (f = $0243656f51a2fb4f$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $0243656f51a2fb4f$var$N(k, g++), h += $0243656f51a2fb4f$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($0243656f51a2fb4f$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $0243656f51a2fb4f$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $0243656f51a2fb4f$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $0243656f51a2fb4f$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $0243656f51a2fb4f$var$R = {
    current: null
};
function $0243656f51a2fb4f$var$S() {
    var a = $0243656f51a2fb4f$var$R.current;
    if (null === a) throw Error($0243656f51a2fb4f$var$z(321));
    return a;
}
var $0243656f51a2fb4f$var$T = {
    ReactCurrentDispatcher: $0243656f51a2fb4f$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $0243656f51a2fb4f$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $bDppX
};
$0243656f51a2fb4f$export$dca3b0875bd9a954 = {
    map: $0243656f51a2fb4f$var$P,
    forEach: function(a, b, c) {
        $0243656f51a2fb4f$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $0243656f51a2fb4f$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $0243656f51a2fb4f$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$0243656f51a2fb4f$var$L(a)) throw Error($0243656f51a2fb4f$var$z(143));
        return a;
    }
};
$0243656f51a2fb4f$export$16fa2f45be04daa8 = $0243656f51a2fb4f$var$C;
$0243656f51a2fb4f$export$221d75b3f55bb0bd = $0243656f51a2fb4f$var$E;
$0243656f51a2fb4f$export$ae55be85d98224ed = $0243656f51a2fb4f$var$T;
$0243656f51a2fb4f$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($0243656f51a2fb4f$var$z(267, a));
    var e = $bDppX({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $0243656f51a2fb4f$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$0243656f51a2fb4f$var$H.call(b, f) && !$0243656f51a2fb4f$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $0243656f51a2fb4f$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$0243656f51a2fb4f$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $0243656f51a2fb4f$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $0243656f51a2fb4f$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$0243656f51a2fb4f$export$c8a8987d4410bf2d = $0243656f51a2fb4f$var$J;
$0243656f51a2fb4f$export$d38cd72104c1f0e9 = function(a) {
    var b = $0243656f51a2fb4f$var$J.bind(null, a);
    b.type = a;
    return b;
};
$0243656f51a2fb4f$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$0243656f51a2fb4f$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $0243656f51a2fb4f$var$t,
        render: a
    };
};
$0243656f51a2fb4f$export$a8257692ac88316c = $0243656f51a2fb4f$var$L;
$0243656f51a2fb4f$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $0243656f51a2fb4f$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $0243656f51a2fb4f$var$Q
    };
};
$0243656f51a2fb4f$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $0243656f51a2fb4f$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$0243656f51a2fb4f$export$35808ee640e87ca7 = function(a, b) {
    return $0243656f51a2fb4f$var$S().useCallback(a, b);
};
$0243656f51a2fb4f$export$fae74005e78b1a27 = function(a, b) {
    return $0243656f51a2fb4f$var$S().useContext(a, b);
};
$0243656f51a2fb4f$export$dc8fbce3eb94dc1e = function() {};
$0243656f51a2fb4f$export$6d9c69b0de29b591 = function(a, b) {
    return $0243656f51a2fb4f$var$S().useEffect(a, b);
};
$0243656f51a2fb4f$export$d5a552a76deda3c2 = function(a, b, c) {
    return $0243656f51a2fb4f$var$S().useImperativeHandle(a, b, c);
};
$0243656f51a2fb4f$export$e5c5a5f917a5871c = function(a, b) {
    return $0243656f51a2fb4f$var$S().useLayoutEffect(a, b);
};
$0243656f51a2fb4f$export$1538c33de8887b59 = function(a, b) {
    return $0243656f51a2fb4f$var$S().useMemo(a, b);
};
$0243656f51a2fb4f$export$13e3392192263954 = function(a, b, c) {
    return $0243656f51a2fb4f$var$S().useReducer(a, b, c);
};
$0243656f51a2fb4f$export$b8f5890fc79d6aca = function(a) {
    return $0243656f51a2fb4f$var$S().useRef(a);
};
$0243656f51a2fb4f$export$60241385465d0a34 = function(a) {
    return $0243656f51a2fb4f$var$S().useState(a);
};
$0243656f51a2fb4f$export$83d89fbfd8236492 = "17.0.2";

});
parcelRequire.register("bDppX", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $87870da89e628224$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $87870da89e628224$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $87870da89e628224$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $87870da89e628224$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $87870da89e628224$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $87870da89e628224$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $87870da89e628224$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($87870da89e628224$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($87870da89e628224$var$getOwnPropertySymbols) {
            symbols = $87870da89e628224$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($87870da89e628224$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


parcelRequire.register("j3WDN", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $8j5uN = parcelRequire("8j5uN");
function $de0bc8fe92a13a51$var$emptyFunction() {}
function $de0bc8fe92a13a51$var$emptyFunctionWithReset() {}
$de0bc8fe92a13a51$var$emptyFunctionWithReset.resetWarningCache = $de0bc8fe92a13a51$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $8j5uN) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $de0bc8fe92a13a51$var$emptyFunctionWithReset,
        resetWarningCache: $de0bc8fe92a13a51$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("8j5uN", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $60c45c6b0cb44b91$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $60c45c6b0cb44b91$var$ReactPropTypesSecret;

});


parcelRequire.register("8aMPt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $5f352257af3f3198$export$1e511d4a378977f5; }, function (v) { return $5f352257af3f3198$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $5f352257af3f3198$export$2e2bcd8739ae039; }, function (v) { return $5f352257af3f3198$export$2e2bcd8739ae039 = v; });
var $5f352257af3f3198$export$1e511d4a378977f5;
var $5f352257af3f3198$export$2e2bcd8739ae039;
"use strict";
$5f352257af3f3198$export$1e511d4a378977f5 = true;
$5f352257af3f3198$export$2e2bcd8739ae039 = $5f352257af3f3198$var$createWebStorage;

var $5f352257af3f3198$var$_getStorage = $5f352257af3f3198$var$_interopRequireDefault((parcelRequire("aqD6n")));
function $5f352257af3f3198$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5f352257af3f3198$var$createWebStorage(type) {
    var storage = (0, $5f352257af3f3198$var$_getStorage.default)(type);
    return {
        getItem: function getItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.getItem(key));
            });
        },
        setItem: function setItem(key, item) {
            return new Promise(function(resolve, reject) {
                resolve(storage.setItem(key, item));
            });
        },
        removeItem: function removeItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.removeItem(key));
            });
        }
    };
}

});
parcelRequire.register("aqD6n", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $797aa9eb66a3bbbd$export$1e511d4a378977f5; }, function (v) { return $797aa9eb66a3bbbd$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $797aa9eb66a3bbbd$export$2e2bcd8739ae039; }, function (v) { return $797aa9eb66a3bbbd$export$2e2bcd8739ae039 = v; });
var $797aa9eb66a3bbbd$export$1e511d4a378977f5;
var $797aa9eb66a3bbbd$export$2e2bcd8739ae039;
"use strict";
$797aa9eb66a3bbbd$export$1e511d4a378977f5 = true;
$797aa9eb66a3bbbd$export$2e2bcd8739ae039 = $797aa9eb66a3bbbd$var$getStorage;
function $797aa9eb66a3bbbd$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $797aa9eb66a3bbbd$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $797aa9eb66a3bbbd$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $797aa9eb66a3bbbd$var$_typeof(obj);
}
function $797aa9eb66a3bbbd$var$noop() {}
var $797aa9eb66a3bbbd$var$noopStorage = {
    getItem: $797aa9eb66a3bbbd$var$noop,
    setItem: $797aa9eb66a3bbbd$var$noop,
    removeItem: $797aa9eb66a3bbbd$var$noop
};
function $797aa9eb66a3bbbd$var$hasStorage(storageType) {
    if ((typeof self === "undefined" ? "undefined" : $797aa9eb66a3bbbd$var$_typeof(self)) !== "object" || !(storageType in self)) return false;
    try {
        var storage = self[storageType];
        var testKey = "redux-persist ".concat(storageType, " test");
        storage.setItem(testKey, "test");
        storage.getItem(testKey);
        storage.removeItem(testKey);
    } catch (e) {
        return false;
    }
    return true;
}
function $797aa9eb66a3bbbd$var$getStorage(type) {
    var storageType = "".concat(type, "Storage");
    if ($797aa9eb66a3bbbd$var$hasStorage(storageType)) return self[storageType];
    else return $797aa9eb66a3bbbd$var$noopStorage;
}

});


parcelRequire.register("bOn4p", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $8996427687624ba8$export$2b8d127b894957b9; }, function (v) { return $8996427687624ba8$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $8996427687624ba8$export$cea3a54a6425200c; }, function (v) { return $8996427687624ba8$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $8996427687624ba8$export$a7c73072b1a182ae; }, function (v) { return $8996427687624ba8$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $8996427687624ba8$export$9f27bc3417b4524d; }, function (v) { return $8996427687624ba8$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $8996427687624ba8$export$db77ccec0bb4ccac; }, function (v) { return $8996427687624ba8$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $8996427687624ba8$export$8392c0c9d3dcbd35; }, function (v) { return $8996427687624ba8$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $8996427687624ba8$export$ffb0004e005737fa; }, function (v) { return $8996427687624ba8$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $8996427687624ba8$export$b624eff549462981; }, function (v) { return $8996427687624ba8$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $8996427687624ba8$export$7897aa7841a5380c; }, function (v) { return $8996427687624ba8$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $8996427687624ba8$export$602eac185826482c; }, function (v) { return $8996427687624ba8$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $8996427687624ba8$export$e2c29f18771995cb; }, function (v) { return $8996427687624ba8$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $8996427687624ba8$export$5f8d39834fd61797; }, function (v) { return $8996427687624ba8$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $8996427687624ba8$export$74bf444e3cd11ea5; }, function (v) { return $8996427687624ba8$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $8996427687624ba8$export$92387174baf9b227; }, function (v) { return $8996427687624ba8$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $8996427687624ba8$export$ec112efeb987d9c6; }, function (v) { return $8996427687624ba8$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $8996427687624ba8$export$b706b080d889d2c9; }, function (v) { return $8996427687624ba8$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $8996427687624ba8$export$5be5a87408f70ddc; }, function (v) { return $8996427687624ba8$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $8996427687624ba8$export$45a5e7f76e0caa8d; }, function (v) { return $8996427687624ba8$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $8996427687624ba8$export$455c2e768291efa6; }, function (v) { return $8996427687624ba8$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $8996427687624ba8$export$9522e17588c12572; }, function (v) { return $8996427687624ba8$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $8996427687624ba8$export$2110ac352bb060b9; }, function (v) { return $8996427687624ba8$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $8996427687624ba8$export$56885ab8b9c456ab; }, function (v) { return $8996427687624ba8$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $8996427687624ba8$export$d927fcb6adf8f9de; }, function (v) { return $8996427687624ba8$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $8996427687624ba8$export$b82d16f27459e05a; }, function (v) { return $8996427687624ba8$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $8996427687624ba8$export$522c17b4f5e123e8; }, function (v) { return $8996427687624ba8$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $8996427687624ba8$export$1aabd8a0274ecfd6; }, function (v) { return $8996427687624ba8$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $8996427687624ba8$export$9b621391a187a31a; }, function (v) { return $8996427687624ba8$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $8996427687624ba8$export$f5bbd400c2f4426f; }, function (v) { return $8996427687624ba8$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8996427687624ba8$export$2b8d127b894957b9;
var $8996427687624ba8$export$cea3a54a6425200c;
var $8996427687624ba8$export$a7c73072b1a182ae;
var $8996427687624ba8$export$9f27bc3417b4524d;
var $8996427687624ba8$export$db77ccec0bb4ccac;
var $8996427687624ba8$export$8392c0c9d3dcbd35;
var $8996427687624ba8$export$ffb0004e005737fa;
var $8996427687624ba8$export$b624eff549462981;
var $8996427687624ba8$export$7897aa7841a5380c;
var $8996427687624ba8$export$602eac185826482c;
var $8996427687624ba8$export$e2c29f18771995cb;
var $8996427687624ba8$export$5f8d39834fd61797;
var $8996427687624ba8$export$74bf444e3cd11ea5;
var $8996427687624ba8$export$92387174baf9b227;
var $8996427687624ba8$export$ec112efeb987d9c6;
var $8996427687624ba8$export$b706b080d889d2c9;
var $8996427687624ba8$export$5be5a87408f70ddc;
var $8996427687624ba8$export$45a5e7f76e0caa8d;
var $8996427687624ba8$export$455c2e768291efa6;
var $8996427687624ba8$export$9522e17588c12572;
var $8996427687624ba8$export$2110ac352bb060b9;
var $8996427687624ba8$export$56885ab8b9c456ab;
var $8996427687624ba8$export$d927fcb6adf8f9de;
var $8996427687624ba8$export$b82d16f27459e05a;
var $8996427687624ba8$export$522c17b4f5e123e8;
var $8996427687624ba8$export$1aabd8a0274ecfd6;
var $8996427687624ba8$export$9b621391a187a31a;
var $8996427687624ba8$export$f5bbd400c2f4426f;
"use strict";
var $8996427687624ba8$var$b = "function" === typeof Symbol && Symbol.for, $8996427687624ba8$var$c = $8996427687624ba8$var$b ? Symbol.for("react.element") : 60103, $8996427687624ba8$var$d = $8996427687624ba8$var$b ? Symbol.for("react.portal") : 60106, $8996427687624ba8$var$e = $8996427687624ba8$var$b ? Symbol.for("react.fragment") : 60107, $8996427687624ba8$var$f = $8996427687624ba8$var$b ? Symbol.for("react.strict_mode") : 60108, $8996427687624ba8$var$g = $8996427687624ba8$var$b ? Symbol.for("react.profiler") : 60114, $8996427687624ba8$var$h = $8996427687624ba8$var$b ? Symbol.for("react.provider") : 60109, $8996427687624ba8$var$k = $8996427687624ba8$var$b ? Symbol.for("react.context") : 60110, $8996427687624ba8$var$l = $8996427687624ba8$var$b ? Symbol.for("react.async_mode") : 60111, $8996427687624ba8$var$m = $8996427687624ba8$var$b ? Symbol.for("react.concurrent_mode") : 60111, $8996427687624ba8$var$n = $8996427687624ba8$var$b ? Symbol.for("react.forward_ref") : 60112, $8996427687624ba8$var$p = $8996427687624ba8$var$b ? Symbol.for("react.suspense") : 60113, $8996427687624ba8$var$q = $8996427687624ba8$var$b ? Symbol.for("react.suspense_list") : 60120, $8996427687624ba8$var$r = $8996427687624ba8$var$b ? Symbol.for("react.memo") : 60115, $8996427687624ba8$var$t = $8996427687624ba8$var$b ? Symbol.for("react.lazy") : 60116, $8996427687624ba8$var$v = $8996427687624ba8$var$b ? Symbol.for("react.block") : 60121, $8996427687624ba8$var$w = $8996427687624ba8$var$b ? Symbol.for("react.fundamental") : 60117, $8996427687624ba8$var$x = $8996427687624ba8$var$b ? Symbol.for("react.responder") : 60118, $8996427687624ba8$var$y = $8996427687624ba8$var$b ? Symbol.for("react.scope") : 60119;
function $8996427687624ba8$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $8996427687624ba8$var$c:
                switch(a = a.type, a){
                    case $8996427687624ba8$var$l:
                    case $8996427687624ba8$var$m:
                    case $8996427687624ba8$var$e:
                    case $8996427687624ba8$var$g:
                    case $8996427687624ba8$var$f:
                    case $8996427687624ba8$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $8996427687624ba8$var$k:
                            case $8996427687624ba8$var$n:
                            case $8996427687624ba8$var$t:
                            case $8996427687624ba8$var$r:
                            case $8996427687624ba8$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $8996427687624ba8$var$d:
                return u;
        }
    }
}
function $8996427687624ba8$var$A(a) {
    return $8996427687624ba8$var$z(a) === $8996427687624ba8$var$m;
}
$8996427687624ba8$export$2b8d127b894957b9 = $8996427687624ba8$var$l;
$8996427687624ba8$export$cea3a54a6425200c = $8996427687624ba8$var$m;
$8996427687624ba8$export$a7c73072b1a182ae = $8996427687624ba8$var$k;
$8996427687624ba8$export$9f27bc3417b4524d = $8996427687624ba8$var$h;
$8996427687624ba8$export$db77ccec0bb4ccac = $8996427687624ba8$var$c;
$8996427687624ba8$export$8392c0c9d3dcbd35 = $8996427687624ba8$var$n;
$8996427687624ba8$export$ffb0004e005737fa = $8996427687624ba8$var$e;
$8996427687624ba8$export$b624eff549462981 = $8996427687624ba8$var$t;
$8996427687624ba8$export$7897aa7841a5380c = $8996427687624ba8$var$r;
$8996427687624ba8$export$602eac185826482c = $8996427687624ba8$var$d;
$8996427687624ba8$export$e2c29f18771995cb = $8996427687624ba8$var$g;
$8996427687624ba8$export$5f8d39834fd61797 = $8996427687624ba8$var$f;
$8996427687624ba8$export$74bf444e3cd11ea5 = $8996427687624ba8$var$p;
$8996427687624ba8$export$92387174baf9b227 = function(a) {
    return $8996427687624ba8$var$A(a) || $8996427687624ba8$var$z(a) === $8996427687624ba8$var$l;
};
$8996427687624ba8$export$ec112efeb987d9c6 = $8996427687624ba8$var$A;
$8996427687624ba8$export$b706b080d889d2c9 = function(a) {
    return $8996427687624ba8$var$z(a) === $8996427687624ba8$var$k;
};
$8996427687624ba8$export$5be5a87408f70ddc = function(a) {
    return $8996427687624ba8$var$z(a) === $8996427687624ba8$var$h;
};
$8996427687624ba8$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8996427687624ba8$var$c;
};
$8996427687624ba8$export$455c2e768291efa6 = function(a) {
    return $8996427687624ba8$var$z(a) === $8996427687624ba8$var$n;
};
$8996427687624ba8$export$9522e17588c12572 = function(a) {
    return $8996427687624ba8$var$z(a) === $8996427687624ba8$var$e;
};
$8996427687624ba8$export$2110ac352bb060b9 = function(a) {
    return $8996427687624ba8$var$z(a) === $8996427687624ba8$var$t;
};
$8996427687624ba8$export$56885ab8b9c456ab = function(a) {
    return $8996427687624ba8$var$z(a) === $8996427687624ba8$var$r;
};
$8996427687624ba8$export$d927fcb6adf8f9de = function(a) {
    return $8996427687624ba8$var$z(a) === $8996427687624ba8$var$d;
};
$8996427687624ba8$export$b82d16f27459e05a = function(a) {
    return $8996427687624ba8$var$z(a) === $8996427687624ba8$var$g;
};
$8996427687624ba8$export$522c17b4f5e123e8 = function(a) {
    return $8996427687624ba8$var$z(a) === $8996427687624ba8$var$f;
};
$8996427687624ba8$export$1aabd8a0274ecfd6 = function(a) {
    return $8996427687624ba8$var$z(a) === $8996427687624ba8$var$p;
};
$8996427687624ba8$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $8996427687624ba8$var$e || a === $8996427687624ba8$var$m || a === $8996427687624ba8$var$g || a === $8996427687624ba8$var$f || a === $8996427687624ba8$var$p || a === $8996427687624ba8$var$q || "object" === typeof a && null !== a && (a.$$typeof === $8996427687624ba8$var$t || a.$$typeof === $8996427687624ba8$var$r || a.$$typeof === $8996427687624ba8$var$h || a.$$typeof === $8996427687624ba8$var$k || a.$$typeof === $8996427687624ba8$var$n || a.$$typeof === $8996427687624ba8$var$w || a.$$typeof === $8996427687624ba8$var$x || a.$$typeof === $8996427687624ba8$var$y || a.$$typeof === $8996427687624ba8$var$v);
};
$8996427687624ba8$export$f5bbd400c2f4426f = $8996427687624ba8$var$z;

});

parcelRequire.register("aCwoi", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $7bb694203b61db71$export$a7c73072b1a182ae; }, function (v) { return $7bb694203b61db71$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $7bb694203b61db71$export$9f27bc3417b4524d; }, function (v) { return $7bb694203b61db71$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $7bb694203b61db71$export$db77ccec0bb4ccac; }, function (v) { return $7bb694203b61db71$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $7bb694203b61db71$export$8392c0c9d3dcbd35; }, function (v) { return $7bb694203b61db71$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $7bb694203b61db71$export$ffb0004e005737fa; }, function (v) { return $7bb694203b61db71$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $7bb694203b61db71$export$b624eff549462981; }, function (v) { return $7bb694203b61db71$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $7bb694203b61db71$export$7897aa7841a5380c; }, function (v) { return $7bb694203b61db71$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $7bb694203b61db71$export$602eac185826482c; }, function (v) { return $7bb694203b61db71$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $7bb694203b61db71$export$e2c29f18771995cb; }, function (v) { return $7bb694203b61db71$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $7bb694203b61db71$export$5f8d39834fd61797; }, function (v) { return $7bb694203b61db71$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $7bb694203b61db71$export$74bf444e3cd11ea5; }, function (v) { return $7bb694203b61db71$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $7bb694203b61db71$export$92387174baf9b227; }, function (v) { return $7bb694203b61db71$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $7bb694203b61db71$export$ec112efeb987d9c6; }, function (v) { return $7bb694203b61db71$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $7bb694203b61db71$export$b706b080d889d2c9; }, function (v) { return $7bb694203b61db71$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $7bb694203b61db71$export$5be5a87408f70ddc; }, function (v) { return $7bb694203b61db71$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $7bb694203b61db71$export$45a5e7f76e0caa8d; }, function (v) { return $7bb694203b61db71$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $7bb694203b61db71$export$455c2e768291efa6; }, function (v) { return $7bb694203b61db71$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $7bb694203b61db71$export$9522e17588c12572; }, function (v) { return $7bb694203b61db71$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $7bb694203b61db71$export$2110ac352bb060b9; }, function (v) { return $7bb694203b61db71$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $7bb694203b61db71$export$56885ab8b9c456ab; }, function (v) { return $7bb694203b61db71$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $7bb694203b61db71$export$d927fcb6adf8f9de; }, function (v) { return $7bb694203b61db71$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $7bb694203b61db71$export$b82d16f27459e05a; }, function (v) { return $7bb694203b61db71$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $7bb694203b61db71$export$522c17b4f5e123e8; }, function (v) { return $7bb694203b61db71$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $7bb694203b61db71$export$1aabd8a0274ecfd6; }, function (v) { return $7bb694203b61db71$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $7bb694203b61db71$export$9b621391a187a31a; }, function (v) { return $7bb694203b61db71$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $7bb694203b61db71$export$f5bbd400c2f4426f; }, function (v) { return $7bb694203b61db71$export$f5bbd400c2f4426f = v; });
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7bb694203b61db71$export$a7c73072b1a182ae;
var $7bb694203b61db71$export$9f27bc3417b4524d;
var $7bb694203b61db71$export$db77ccec0bb4ccac;
var $7bb694203b61db71$export$8392c0c9d3dcbd35;
var $7bb694203b61db71$export$ffb0004e005737fa;
var $7bb694203b61db71$export$b624eff549462981;
var $7bb694203b61db71$export$7897aa7841a5380c;
var $7bb694203b61db71$export$602eac185826482c;
var $7bb694203b61db71$export$e2c29f18771995cb;
var $7bb694203b61db71$export$5f8d39834fd61797;
var $7bb694203b61db71$export$74bf444e3cd11ea5;
var $7bb694203b61db71$export$92387174baf9b227;
var $7bb694203b61db71$export$ec112efeb987d9c6;
var $7bb694203b61db71$export$b706b080d889d2c9;
var $7bb694203b61db71$export$5be5a87408f70ddc;
var $7bb694203b61db71$export$45a5e7f76e0caa8d;
var $7bb694203b61db71$export$455c2e768291efa6;
var $7bb694203b61db71$export$9522e17588c12572;
var $7bb694203b61db71$export$2110ac352bb060b9;
var $7bb694203b61db71$export$56885ab8b9c456ab;
var $7bb694203b61db71$export$d927fcb6adf8f9de;
var $7bb694203b61db71$export$b82d16f27459e05a;
var $7bb694203b61db71$export$522c17b4f5e123e8;
var $7bb694203b61db71$export$1aabd8a0274ecfd6;
var $7bb694203b61db71$export$9b621391a187a31a;
var $7bb694203b61db71$export$f5bbd400c2f4426f;
"use strict";
var $7bb694203b61db71$var$b = 60103, $7bb694203b61db71$var$c = 60106, $7bb694203b61db71$var$d = 60107, $7bb694203b61db71$var$e = 60108, $7bb694203b61db71$var$f = 60114, $7bb694203b61db71$var$g = 60109, $7bb694203b61db71$var$h = 60110, $7bb694203b61db71$var$k = 60112, $7bb694203b61db71$var$l = 60113, $7bb694203b61db71$var$m = 60120, $7bb694203b61db71$var$n = 60115, $7bb694203b61db71$var$p = 60116, $7bb694203b61db71$var$q = 60121, $7bb694203b61db71$var$r = 60122, $7bb694203b61db71$var$u = 60117, $7bb694203b61db71$var$v = 60129, $7bb694203b61db71$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $7bb694203b61db71$var$x = Symbol.for;
    $7bb694203b61db71$var$b = $7bb694203b61db71$var$x("react.element");
    $7bb694203b61db71$var$c = $7bb694203b61db71$var$x("react.portal");
    $7bb694203b61db71$var$d = $7bb694203b61db71$var$x("react.fragment");
    $7bb694203b61db71$var$e = $7bb694203b61db71$var$x("react.strict_mode");
    $7bb694203b61db71$var$f = $7bb694203b61db71$var$x("react.profiler");
    $7bb694203b61db71$var$g = $7bb694203b61db71$var$x("react.provider");
    $7bb694203b61db71$var$h = $7bb694203b61db71$var$x("react.context");
    $7bb694203b61db71$var$k = $7bb694203b61db71$var$x("react.forward_ref");
    $7bb694203b61db71$var$l = $7bb694203b61db71$var$x("react.suspense");
    $7bb694203b61db71$var$m = $7bb694203b61db71$var$x("react.suspense_list");
    $7bb694203b61db71$var$n = $7bb694203b61db71$var$x("react.memo");
    $7bb694203b61db71$var$p = $7bb694203b61db71$var$x("react.lazy");
    $7bb694203b61db71$var$q = $7bb694203b61db71$var$x("react.block");
    $7bb694203b61db71$var$r = $7bb694203b61db71$var$x("react.server.block");
    $7bb694203b61db71$var$u = $7bb694203b61db71$var$x("react.fundamental");
    $7bb694203b61db71$var$v = $7bb694203b61db71$var$x("react.debug_trace_mode");
    $7bb694203b61db71$var$w = $7bb694203b61db71$var$x("react.legacy_hidden");
}
function $7bb694203b61db71$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $7bb694203b61db71$var$b:
                switch(a = a.type, a){
                    case $7bb694203b61db71$var$d:
                    case $7bb694203b61db71$var$f:
                    case $7bb694203b61db71$var$e:
                    case $7bb694203b61db71$var$l:
                    case $7bb694203b61db71$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $7bb694203b61db71$var$h:
                            case $7bb694203b61db71$var$k:
                            case $7bb694203b61db71$var$p:
                            case $7bb694203b61db71$var$n:
                            case $7bb694203b61db71$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $7bb694203b61db71$var$c:
                return t;
        }
    }
}
var $7bb694203b61db71$var$z = $7bb694203b61db71$var$g, $7bb694203b61db71$var$A = $7bb694203b61db71$var$b, $7bb694203b61db71$var$B = $7bb694203b61db71$var$k, $7bb694203b61db71$var$C = $7bb694203b61db71$var$d, $7bb694203b61db71$var$D = $7bb694203b61db71$var$p, $7bb694203b61db71$var$E = $7bb694203b61db71$var$n, $7bb694203b61db71$var$F = $7bb694203b61db71$var$c, $7bb694203b61db71$var$G = $7bb694203b61db71$var$f, $7bb694203b61db71$var$H = $7bb694203b61db71$var$e, $7bb694203b61db71$var$I = $7bb694203b61db71$var$l;
$7bb694203b61db71$export$a7c73072b1a182ae = $7bb694203b61db71$var$h;
$7bb694203b61db71$export$9f27bc3417b4524d = $7bb694203b61db71$var$z;
$7bb694203b61db71$export$db77ccec0bb4ccac = $7bb694203b61db71$var$A;
$7bb694203b61db71$export$8392c0c9d3dcbd35 = $7bb694203b61db71$var$B;
$7bb694203b61db71$export$ffb0004e005737fa = $7bb694203b61db71$var$C;
$7bb694203b61db71$export$b624eff549462981 = $7bb694203b61db71$var$D;
$7bb694203b61db71$export$7897aa7841a5380c = $7bb694203b61db71$var$E;
$7bb694203b61db71$export$602eac185826482c = $7bb694203b61db71$var$F;
$7bb694203b61db71$export$e2c29f18771995cb = $7bb694203b61db71$var$G;
$7bb694203b61db71$export$5f8d39834fd61797 = $7bb694203b61db71$var$H;
$7bb694203b61db71$export$74bf444e3cd11ea5 = $7bb694203b61db71$var$I;
$7bb694203b61db71$export$92387174baf9b227 = function() {
    return !1;
};
$7bb694203b61db71$export$ec112efeb987d9c6 = function() {
    return !1;
};
$7bb694203b61db71$export$b706b080d889d2c9 = function(a) {
    return $7bb694203b61db71$var$y(a) === $7bb694203b61db71$var$h;
};
$7bb694203b61db71$export$5be5a87408f70ddc = function(a) {
    return $7bb694203b61db71$var$y(a) === $7bb694203b61db71$var$g;
};
$7bb694203b61db71$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $7bb694203b61db71$var$b;
};
$7bb694203b61db71$export$455c2e768291efa6 = function(a) {
    return $7bb694203b61db71$var$y(a) === $7bb694203b61db71$var$k;
};
$7bb694203b61db71$export$9522e17588c12572 = function(a) {
    return $7bb694203b61db71$var$y(a) === $7bb694203b61db71$var$d;
};
$7bb694203b61db71$export$2110ac352bb060b9 = function(a) {
    return $7bb694203b61db71$var$y(a) === $7bb694203b61db71$var$p;
};
$7bb694203b61db71$export$56885ab8b9c456ab = function(a) {
    return $7bb694203b61db71$var$y(a) === $7bb694203b61db71$var$n;
};
$7bb694203b61db71$export$d927fcb6adf8f9de = function(a) {
    return $7bb694203b61db71$var$y(a) === $7bb694203b61db71$var$c;
};
$7bb694203b61db71$export$b82d16f27459e05a = function(a) {
    return $7bb694203b61db71$var$y(a) === $7bb694203b61db71$var$f;
};
$7bb694203b61db71$export$522c17b4f5e123e8 = function(a) {
    return $7bb694203b61db71$var$y(a) === $7bb694203b61db71$var$e;
};
$7bb694203b61db71$export$1aabd8a0274ecfd6 = function(a) {
    return $7bb694203b61db71$var$y(a) === $7bb694203b61db71$var$l;
};
$7bb694203b61db71$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $7bb694203b61db71$var$d || a === $7bb694203b61db71$var$f || a === $7bb694203b61db71$var$v || a === $7bb694203b61db71$var$e || a === $7bb694203b61db71$var$l || a === $7bb694203b61db71$var$m || a === $7bb694203b61db71$var$w || "object" === typeof a && null !== a && (a.$$typeof === $7bb694203b61db71$var$p || a.$$typeof === $7bb694203b61db71$var$n || a.$$typeof === $7bb694203b61db71$var$g || a.$$typeof === $7bb694203b61db71$var$h || a.$$typeof === $7bb694203b61db71$var$k || a.$$typeof === $7bb694203b61db71$var$u || a.$$typeof === $7bb694203b61db71$var$q || a[0] === $7bb694203b61db71$var$r) ? !0 : !1;
};
$7bb694203b61db71$export$f5bbd400c2f4426f = $7bb694203b61db71$var$y;

});

parcelRequire.register("jozO0", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e1ec086d45566806$export$ae55be85d98224ed; }, function (v) { return $e1ec086d45566806$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $e1ec086d45566806$export$d39a5bbd09211389; }, function (v) { return $e1ec086d45566806$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $e1ec086d45566806$export$466bfc07425424d5; }, function (v) { return $e1ec086d45566806$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $e1ec086d45566806$export$cd75ccfd720a3cd4; }, function (v) { return $e1ec086d45566806$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $e1ec086d45566806$export$fa8d919ba61d84db; }, function (v) { return $e1ec086d45566806$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "render", function () { return $e1ec086d45566806$export$b3890eb0ae9dca99; }, function (v) { return $e1ec086d45566806$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $e1ec086d45566806$export$502457920280e6be; }, function (v) { return $e1ec086d45566806$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $e1ec086d45566806$export$c78a37762a8d58e1; }, function (v) { return $e1ec086d45566806$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_createPortal", function () { return $e1ec086d45566806$export$2577ef5d2565d52f; }, function (v) { return $e1ec086d45566806$export$2577ef5d2565d52f = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $e1ec086d45566806$export$dc54d992c10e8a18; }, function (v) { return $e1ec086d45566806$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $e1ec086d45566806$export$83d89fbfd8236492; }, function (v) { return $e1ec086d45566806$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $e1ec086d45566806$export$ae55be85d98224ed;
var $e1ec086d45566806$export$d39a5bbd09211389;
var $e1ec086d45566806$export$466bfc07425424d5;
var $e1ec086d45566806$export$cd75ccfd720a3cd4;
var $e1ec086d45566806$export$fa8d919ba61d84db;
var $e1ec086d45566806$export$b3890eb0ae9dca99;
var $e1ec086d45566806$export$502457920280e6be;
var $e1ec086d45566806$export$c78a37762a8d58e1;
var $e1ec086d45566806$export$2577ef5d2565d52f;
var $e1ec086d45566806$export$dc54d992c10e8a18;
var $e1ec086d45566806$export$83d89fbfd8236492;
"use strict";

var $cQNHH = parcelRequire("cQNHH");

var $bDppX = parcelRequire("bDppX");

var $1MX31 = parcelRequire("1MX31");
function $e1ec086d45566806$var$y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$cQNHH) throw Error($e1ec086d45566806$var$y(227));
var $e1ec086d45566806$var$ba = new Set, $e1ec086d45566806$var$ca = {};
function $e1ec086d45566806$var$da(a, b) {
    $e1ec086d45566806$var$ea(a, b);
    $e1ec086d45566806$var$ea(a + "Capture", b);
}
function $e1ec086d45566806$var$ea(a, b) {
    $e1ec086d45566806$var$ca[a] = b;
    for(a = 0; a < b.length; a++)$e1ec086d45566806$var$ba.add(b[a]);
}
var $e1ec086d45566806$var$fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e1ec086d45566806$var$ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $e1ec086d45566806$var$ia = Object.prototype.hasOwnProperty, $e1ec086d45566806$var$ja = {}, $e1ec086d45566806$var$ka = {};
function $e1ec086d45566806$var$la(a) {
    if ($e1ec086d45566806$var$ia.call($e1ec086d45566806$var$ka, a)) return !0;
    if ($e1ec086d45566806$var$ia.call($e1ec086d45566806$var$ja, a)) return !1;
    if ($e1ec086d45566806$var$ha.test(a)) return $e1ec086d45566806$var$ka[a] = !0;
    $e1ec086d45566806$var$ja[a] = !0;
    return !1;
}
function $e1ec086d45566806$var$ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $e1ec086d45566806$var$na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $e1ec086d45566806$var$ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $e1ec086d45566806$var$B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $e1ec086d45566806$var$D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $e1ec086d45566806$var$D[a] = new $e1ec086d45566806$var$B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $e1ec086d45566806$var$D[b] = new $e1ec086d45566806$var$B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $e1ec086d45566806$var$D[a] = new $e1ec086d45566806$var$B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $e1ec086d45566806$var$D[a] = new $e1ec086d45566806$var$B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $e1ec086d45566806$var$D[a] = new $e1ec086d45566806$var$B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $e1ec086d45566806$var$D[a] = new $e1ec086d45566806$var$B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $e1ec086d45566806$var$D[a] = new $e1ec086d45566806$var$B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $e1ec086d45566806$var$D[a] = new $e1ec086d45566806$var$B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $e1ec086d45566806$var$D[a] = new $e1ec086d45566806$var$B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $e1ec086d45566806$var$oa = /[\-:]([a-z])/g;
function $e1ec086d45566806$var$pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($e1ec086d45566806$var$oa, $e1ec086d45566806$var$pa);
    $e1ec086d45566806$var$D[b] = new $e1ec086d45566806$var$B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($e1ec086d45566806$var$oa, $e1ec086d45566806$var$pa);
    $e1ec086d45566806$var$D[b] = new $e1ec086d45566806$var$B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($e1ec086d45566806$var$oa, $e1ec086d45566806$var$pa);
    $e1ec086d45566806$var$D[b] = new $e1ec086d45566806$var$B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $e1ec086d45566806$var$D[a] = new $e1ec086d45566806$var$B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$e1ec086d45566806$var$D.xlinkHref = new $e1ec086d45566806$var$B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $e1ec086d45566806$var$D[a] = new $e1ec086d45566806$var$B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $e1ec086d45566806$var$qa(a, b, c, d) {
    var e = $e1ec086d45566806$var$D.hasOwnProperty(b) ? $e1ec086d45566806$var$D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || ($e1ec086d45566806$var$na(b, c, e, d) && (c = null), d || null === e ? $e1ec086d45566806$var$la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var $e1ec086d45566806$var$ra = $cQNHH.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $e1ec086d45566806$var$sa = 60103, $e1ec086d45566806$var$ta = 60106, $e1ec086d45566806$var$ua = 60107, $e1ec086d45566806$var$wa = 60108, $e1ec086d45566806$var$xa = 60114, $e1ec086d45566806$var$ya = 60109, $e1ec086d45566806$var$za = 60110, $e1ec086d45566806$var$Aa = 60112, $e1ec086d45566806$var$Ba = 60113, $e1ec086d45566806$var$Ca = 60120, $e1ec086d45566806$var$Da = 60115, $e1ec086d45566806$var$Ea = 60116, $e1ec086d45566806$var$Fa = 60121, $e1ec086d45566806$var$Ga = 60128, $e1ec086d45566806$var$Ha = 60129, $e1ec086d45566806$var$Ia = 60130, $e1ec086d45566806$var$Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $e1ec086d45566806$var$E = Symbol.for;
    $e1ec086d45566806$var$sa = $e1ec086d45566806$var$E("react.element");
    $e1ec086d45566806$var$ta = $e1ec086d45566806$var$E("react.portal");
    $e1ec086d45566806$var$ua = $e1ec086d45566806$var$E("react.fragment");
    $e1ec086d45566806$var$wa = $e1ec086d45566806$var$E("react.strict_mode");
    $e1ec086d45566806$var$xa = $e1ec086d45566806$var$E("react.profiler");
    $e1ec086d45566806$var$ya = $e1ec086d45566806$var$E("react.provider");
    $e1ec086d45566806$var$za = $e1ec086d45566806$var$E("react.context");
    $e1ec086d45566806$var$Aa = $e1ec086d45566806$var$E("react.forward_ref");
    $e1ec086d45566806$var$Ba = $e1ec086d45566806$var$E("react.suspense");
    $e1ec086d45566806$var$Ca = $e1ec086d45566806$var$E("react.suspense_list");
    $e1ec086d45566806$var$Da = $e1ec086d45566806$var$E("react.memo");
    $e1ec086d45566806$var$Ea = $e1ec086d45566806$var$E("react.lazy");
    $e1ec086d45566806$var$Fa = $e1ec086d45566806$var$E("react.block");
    $e1ec086d45566806$var$E("react.scope");
    $e1ec086d45566806$var$Ga = $e1ec086d45566806$var$E("react.opaque.id");
    $e1ec086d45566806$var$Ha = $e1ec086d45566806$var$E("react.debug_trace_mode");
    $e1ec086d45566806$var$Ia = $e1ec086d45566806$var$E("react.offscreen");
    $e1ec086d45566806$var$Ja = $e1ec086d45566806$var$E("react.legacy_hidden");
}
var $e1ec086d45566806$var$Ka = "function" === typeof Symbol && Symbol.iterator;
function $e1ec086d45566806$var$La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e1ec086d45566806$var$Ka && a[$e1ec086d45566806$var$Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e1ec086d45566806$var$Ma;
function $e1ec086d45566806$var$Na(a) {
    if (void 0 === $e1ec086d45566806$var$Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $e1ec086d45566806$var$Ma = b && b[1] || "";
    }
    return "\n" + $e1ec086d45566806$var$Ma + a;
}
var $e1ec086d45566806$var$Oa = !1;
function $e1ec086d45566806$var$Pa(a, b) {
    if (!a || $e1ec086d45566806$var$Oa) return "";
    $e1ec086d45566806$var$Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $e1ec086d45566806$var$Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $e1ec086d45566806$var$Na(a) : "";
}
function $e1ec086d45566806$var$Qa(a) {
    switch(a.tag){
        case 5:
            return $e1ec086d45566806$var$Na(a.type);
        case 16:
            return $e1ec086d45566806$var$Na("Lazy");
        case 13:
            return $e1ec086d45566806$var$Na("Suspense");
        case 19:
            return $e1ec086d45566806$var$Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $e1ec086d45566806$var$Pa(a.type, !1), a;
        case 11:
            return a = $e1ec086d45566806$var$Pa(a.type.render, !1), a;
        case 22:
            return a = $e1ec086d45566806$var$Pa(a.type._render, !1), a;
        case 1:
            return a = $e1ec086d45566806$var$Pa(a.type, !0), a;
        default:
            return "";
    }
}
function $e1ec086d45566806$var$Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $e1ec086d45566806$var$ua:
            return "Fragment";
        case $e1ec086d45566806$var$ta:
            return "Portal";
        case $e1ec086d45566806$var$xa:
            return "Profiler";
        case $e1ec086d45566806$var$wa:
            return "StrictMode";
        case $e1ec086d45566806$var$Ba:
            return "Suspense";
        case $e1ec086d45566806$var$Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $e1ec086d45566806$var$za:
            return (a.displayName || "Context") + ".Consumer";
        case $e1ec086d45566806$var$ya:
            return (a._context.displayName || "Context") + ".Provider";
        case $e1ec086d45566806$var$Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case $e1ec086d45566806$var$Da:
            return $e1ec086d45566806$var$Ra(a.type);
        case $e1ec086d45566806$var$Fa:
            return $e1ec086d45566806$var$Ra(a._render);
        case $e1ec086d45566806$var$Ea:
            b = a._payload;
            a = a._init;
            try {
                return $e1ec086d45566806$var$Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function $e1ec086d45566806$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function $e1ec086d45566806$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $e1ec086d45566806$var$Ua(a) {
    var b = $e1ec086d45566806$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $e1ec086d45566806$var$Va(a) {
    a._valueTracker || (a._valueTracker = $e1ec086d45566806$var$Ua(a));
}
function $e1ec086d45566806$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $e1ec086d45566806$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $e1ec086d45566806$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $e1ec086d45566806$var$Ya(a, b) {
    var c = b.checked;
    return $bDppX({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $e1ec086d45566806$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $e1ec086d45566806$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $e1ec086d45566806$var$$a(a, b) {
    b = b.checked;
    null != b && $e1ec086d45566806$var$qa(a, "checked", b, !1);
}
function $e1ec086d45566806$var$ab(a, b) {
    $e1ec086d45566806$var$$a(a, b);
    var c = $e1ec086d45566806$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $e1ec086d45566806$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $e1ec086d45566806$var$bb(a, b.type, $e1ec086d45566806$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $e1ec086d45566806$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $e1ec086d45566806$var$bb(a, b, c) {
    if ("number" !== b || $e1ec086d45566806$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function $e1ec086d45566806$var$db(a) {
    var b = "";
    $cQNHH.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $e1ec086d45566806$var$eb(a, b) {
    a = $bDppX({
        children: void 0
    }, b);
    if (b = $e1ec086d45566806$var$db(b.children)) a.children = b;
    return a;
}
function $e1ec086d45566806$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $e1ec086d45566806$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $e1ec086d45566806$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($e1ec086d45566806$var$y(91));
    return $bDppX({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $e1ec086d45566806$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($e1ec086d45566806$var$y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error($e1ec086d45566806$var$y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $e1ec086d45566806$var$Sa(c)
    };
}
function $e1ec086d45566806$var$ib(a, b) {
    var c = $e1ec086d45566806$var$Sa(b.value), d = $e1ec086d45566806$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $e1ec086d45566806$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var $e1ec086d45566806$var$kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function $e1ec086d45566806$var$lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $e1ec086d45566806$var$mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $e1ec086d45566806$var$lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $e1ec086d45566806$var$nb, $e1ec086d45566806$var$ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== $e1ec086d45566806$var$kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        $e1ec086d45566806$var$nb = $e1ec086d45566806$var$nb || document.createElement("div");
        $e1ec086d45566806$var$nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $e1ec086d45566806$var$nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $e1ec086d45566806$var$pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $e1ec086d45566806$var$qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $e1ec086d45566806$var$rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($e1ec086d45566806$var$qb).forEach(function(a) {
    $e1ec086d45566806$var$rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $e1ec086d45566806$var$qb[b] = $e1ec086d45566806$var$qb[a];
    });
});
function $e1ec086d45566806$var$sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $e1ec086d45566806$var$qb.hasOwnProperty(a) && $e1ec086d45566806$var$qb[a] ? ("" + b).trim() : b + "px";
}
function $e1ec086d45566806$var$tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $e1ec086d45566806$var$sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $e1ec086d45566806$var$ub = $bDppX({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $e1ec086d45566806$var$vb(a, b) {
    if (b) {
        if ($e1ec086d45566806$var$ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($e1ec086d45566806$var$y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($e1ec086d45566806$var$y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error($e1ec086d45566806$var$y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($e1ec086d45566806$var$y(62));
    }
}
function $e1ec086d45566806$var$wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function $e1ec086d45566806$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $e1ec086d45566806$var$yb = null, $e1ec086d45566806$var$zb = null, $e1ec086d45566806$var$Ab = null;
function $e1ec086d45566806$var$Bb(a) {
    if (a = $e1ec086d45566806$var$Cb(a)) {
        if ("function" !== typeof $e1ec086d45566806$var$yb) throw Error($e1ec086d45566806$var$y(280));
        var b = a.stateNode;
        b && (b = $e1ec086d45566806$var$Db(b), $e1ec086d45566806$var$yb(a.stateNode, a.type, b));
    }
}
function $e1ec086d45566806$var$Eb(a) {
    $e1ec086d45566806$var$zb ? $e1ec086d45566806$var$Ab ? $e1ec086d45566806$var$Ab.push(a) : $e1ec086d45566806$var$Ab = [
        a
    ] : $e1ec086d45566806$var$zb = a;
}
function $e1ec086d45566806$var$Fb() {
    if ($e1ec086d45566806$var$zb) {
        var a = $e1ec086d45566806$var$zb, b = $e1ec086d45566806$var$Ab;
        $e1ec086d45566806$var$Ab = $e1ec086d45566806$var$zb = null;
        $e1ec086d45566806$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$e1ec086d45566806$var$Bb(b[a]);
    }
}
function $e1ec086d45566806$var$Gb(a, b) {
    return a(b);
}
function $e1ec086d45566806$var$Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function $e1ec086d45566806$var$Ib() {}
var $e1ec086d45566806$var$Jb = $e1ec086d45566806$var$Gb, $e1ec086d45566806$var$Kb = !1, $e1ec086d45566806$var$Lb = !1;
function $e1ec086d45566806$var$Mb() {
    if (null !== $e1ec086d45566806$var$zb || null !== $e1ec086d45566806$var$Ab) $e1ec086d45566806$var$Ib(), $e1ec086d45566806$var$Fb();
}
function $e1ec086d45566806$var$Nb(a, b, c) {
    if ($e1ec086d45566806$var$Lb) return a(b, c);
    $e1ec086d45566806$var$Lb = !0;
    try {
        return $e1ec086d45566806$var$Jb(a, b, c);
    } finally{
        $e1ec086d45566806$var$Lb = !1, $e1ec086d45566806$var$Mb();
    }
}
function $e1ec086d45566806$var$Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $e1ec086d45566806$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($e1ec086d45566806$var$y(231, b, typeof c));
    return c;
}
var $e1ec086d45566806$var$Pb = !1;
if ($e1ec086d45566806$var$fa) try {
    var $e1ec086d45566806$var$Qb = {};
    Object.defineProperty($e1ec086d45566806$var$Qb, "passive", {
        get: function() {
            $e1ec086d45566806$var$Pb = !0;
        }
    });
    window.addEventListener("test", $e1ec086d45566806$var$Qb, $e1ec086d45566806$var$Qb);
    window.removeEventListener("test", $e1ec086d45566806$var$Qb, $e1ec086d45566806$var$Qb);
} catch (a) {
    $e1ec086d45566806$var$Pb = !1;
}
function $e1ec086d45566806$var$Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $e1ec086d45566806$var$Sb = !1, $e1ec086d45566806$var$Tb = null, $e1ec086d45566806$var$Ub = !1, $e1ec086d45566806$var$Vb = null, $e1ec086d45566806$var$Wb = {
    onError: function(a) {
        $e1ec086d45566806$var$Sb = !0;
        $e1ec086d45566806$var$Tb = a;
    }
};
function $e1ec086d45566806$var$Xb(a, b, c, d, e, f, g, h, k) {
    $e1ec086d45566806$var$Sb = !1;
    $e1ec086d45566806$var$Tb = null;
    $e1ec086d45566806$var$Rb.apply($e1ec086d45566806$var$Wb, arguments);
}
function $e1ec086d45566806$var$Yb(a, b, c, d, e, f, g, h, k) {
    $e1ec086d45566806$var$Xb.apply(this, arguments);
    if ($e1ec086d45566806$var$Sb) {
        if ($e1ec086d45566806$var$Sb) {
            var l = $e1ec086d45566806$var$Tb;
            $e1ec086d45566806$var$Sb = !1;
            $e1ec086d45566806$var$Tb = null;
        } else throw Error($e1ec086d45566806$var$y(198));
        $e1ec086d45566806$var$Ub || ($e1ec086d45566806$var$Ub = !0, $e1ec086d45566806$var$Vb = l);
    }
}
function $e1ec086d45566806$var$Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $e1ec086d45566806$var$$b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $e1ec086d45566806$var$ac(a) {
    if ($e1ec086d45566806$var$Zb(a) !== a) throw Error($e1ec086d45566806$var$y(188));
}
function $e1ec086d45566806$var$bc(a) {
    var b = a.alternate;
    if (!b) {
        b = $e1ec086d45566806$var$Zb(a);
        if (null === b) throw Error($e1ec086d45566806$var$y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $e1ec086d45566806$var$ac(e), a;
                if (f === d) return $e1ec086d45566806$var$ac(e), b;
                f = f.sibling;
            }
            throw Error($e1ec086d45566806$var$y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($e1ec086d45566806$var$y(189));
            }
        }
        if (c.alternate !== d) throw Error($e1ec086d45566806$var$y(190));
    }
    if (3 !== c.tag) throw Error($e1ec086d45566806$var$y(188));
    return c.stateNode.current === c ? a : b;
}
function $e1ec086d45566806$var$cc(a) {
    a = $e1ec086d45566806$var$bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function $e1ec086d45566806$var$dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var $e1ec086d45566806$var$ec, $e1ec086d45566806$var$fc, $e1ec086d45566806$var$gc, $e1ec086d45566806$var$hc, $e1ec086d45566806$var$ic = !1, $e1ec086d45566806$var$jc = [], $e1ec086d45566806$var$kc = null, $e1ec086d45566806$var$lc = null, $e1ec086d45566806$var$mc = null, $e1ec086d45566806$var$nc = new Map, $e1ec086d45566806$var$oc = new Map, $e1ec086d45566806$var$pc = [], $e1ec086d45566806$var$qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $e1ec086d45566806$var$rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function $e1ec086d45566806$var$sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $e1ec086d45566806$var$kc = null;
            break;
        case "dragenter":
        case "dragleave":
            $e1ec086d45566806$var$lc = null;
            break;
        case "mouseover":
        case "mouseout":
            $e1ec086d45566806$var$mc = null;
            break;
        case "pointerover":
        case "pointerout":
            $e1ec086d45566806$var$nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e1ec086d45566806$var$oc.delete(b.pointerId);
    }
}
function $e1ec086d45566806$var$tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = $e1ec086d45566806$var$rc(b, c, d, e, f), null !== b && (b = $e1ec086d45566806$var$Cb(b), null !== b && $e1ec086d45566806$var$fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $e1ec086d45566806$var$uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $e1ec086d45566806$var$kc = $e1ec086d45566806$var$tc($e1ec086d45566806$var$kc, a, b, c, d, e), !0;
        case "dragenter":
            return $e1ec086d45566806$var$lc = $e1ec086d45566806$var$tc($e1ec086d45566806$var$lc, a, b, c, d, e), !0;
        case "mouseover":
            return $e1ec086d45566806$var$mc = $e1ec086d45566806$var$tc($e1ec086d45566806$var$mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $e1ec086d45566806$var$nc.set(f, $e1ec086d45566806$var$tc($e1ec086d45566806$var$nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $e1ec086d45566806$var$oc.set(f, $e1ec086d45566806$var$tc($e1ec086d45566806$var$oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $e1ec086d45566806$var$vc(a) {
    var b = $e1ec086d45566806$var$wc(a.target);
    if (null !== b) {
        var c = $e1ec086d45566806$var$Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $e1ec086d45566806$var$$b(c), null !== b) {
                    a.blockedOn = b;
                    $e1ec086d45566806$var$hc(a.lanePriority, function() {
                        $1MX31.unstable_runWithPriority(a.priority, function() {
                            $e1ec086d45566806$var$gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $e1ec086d45566806$var$xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $e1ec086d45566806$var$yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = $e1ec086d45566806$var$Cb(c), null !== b && $e1ec086d45566806$var$fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $e1ec086d45566806$var$zc(a, b, c) {
    $e1ec086d45566806$var$xc(a) && c.delete(b);
}
function $e1ec086d45566806$var$Ac() {
    for($e1ec086d45566806$var$ic = !1; 0 < $e1ec086d45566806$var$jc.length;){
        var a = $e1ec086d45566806$var$jc[0];
        if (null !== a.blockedOn) {
            a = $e1ec086d45566806$var$Cb(a.blockedOn);
            null !== a && $e1ec086d45566806$var$ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = $e1ec086d45566806$var$yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && $e1ec086d45566806$var$jc.shift();
    }
    null !== $e1ec086d45566806$var$kc && $e1ec086d45566806$var$xc($e1ec086d45566806$var$kc) && ($e1ec086d45566806$var$kc = null);
    null !== $e1ec086d45566806$var$lc && $e1ec086d45566806$var$xc($e1ec086d45566806$var$lc) && ($e1ec086d45566806$var$lc = null);
    null !== $e1ec086d45566806$var$mc && $e1ec086d45566806$var$xc($e1ec086d45566806$var$mc) && ($e1ec086d45566806$var$mc = null);
    $e1ec086d45566806$var$nc.forEach($e1ec086d45566806$var$zc);
    $e1ec086d45566806$var$oc.forEach($e1ec086d45566806$var$zc);
}
function $e1ec086d45566806$var$Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $e1ec086d45566806$var$ic || ($e1ec086d45566806$var$ic = !0, $1MX31.unstable_scheduleCallback($1MX31.unstable_NormalPriority, $e1ec086d45566806$var$Ac)));
}
function $e1ec086d45566806$var$Cc(a) {
    function b(b) {
        return $e1ec086d45566806$var$Bc(b, a);
    }
    if (0 < $e1ec086d45566806$var$jc.length) {
        $e1ec086d45566806$var$Bc($e1ec086d45566806$var$jc[0], a);
        for(var c = 1; c < $e1ec086d45566806$var$jc.length; c++){
            var d = $e1ec086d45566806$var$jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $e1ec086d45566806$var$kc && $e1ec086d45566806$var$Bc($e1ec086d45566806$var$kc, a);
    null !== $e1ec086d45566806$var$lc && $e1ec086d45566806$var$Bc($e1ec086d45566806$var$lc, a);
    null !== $e1ec086d45566806$var$mc && $e1ec086d45566806$var$Bc($e1ec086d45566806$var$mc, a);
    $e1ec086d45566806$var$nc.forEach(b);
    $e1ec086d45566806$var$oc.forEach(b);
    for(c = 0; c < $e1ec086d45566806$var$pc.length; c++)d = $e1ec086d45566806$var$pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $e1ec086d45566806$var$pc.length && (c = $e1ec086d45566806$var$pc[0], null === c.blockedOn);)$e1ec086d45566806$var$vc(c), null === c.blockedOn && $e1ec086d45566806$var$pc.shift();
}
function $e1ec086d45566806$var$Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $e1ec086d45566806$var$Ec = {
    animationend: $e1ec086d45566806$var$Dc("Animation", "AnimationEnd"),
    animationiteration: $e1ec086d45566806$var$Dc("Animation", "AnimationIteration"),
    animationstart: $e1ec086d45566806$var$Dc("Animation", "AnimationStart"),
    transitionend: $e1ec086d45566806$var$Dc("Transition", "TransitionEnd")
}, $e1ec086d45566806$var$Fc = {}, $e1ec086d45566806$var$Gc = {};
$e1ec086d45566806$var$fa && ($e1ec086d45566806$var$Gc = document.createElement("div").style, "AnimationEvent" in window || (delete $e1ec086d45566806$var$Ec.animationend.animation, delete $e1ec086d45566806$var$Ec.animationiteration.animation, delete $e1ec086d45566806$var$Ec.animationstart.animation), "TransitionEvent" in window || delete $e1ec086d45566806$var$Ec.transitionend.transition);
function $e1ec086d45566806$var$Hc(a) {
    if ($e1ec086d45566806$var$Fc[a]) return $e1ec086d45566806$var$Fc[a];
    if (!$e1ec086d45566806$var$Ec[a]) return a;
    var b = $e1ec086d45566806$var$Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $e1ec086d45566806$var$Gc) return $e1ec086d45566806$var$Fc[a] = b[c];
    return a;
}
var $e1ec086d45566806$var$Ic = $e1ec086d45566806$var$Hc("animationend"), $e1ec086d45566806$var$Jc = $e1ec086d45566806$var$Hc("animationiteration"), $e1ec086d45566806$var$Kc = $e1ec086d45566806$var$Hc("animationstart"), $e1ec086d45566806$var$Lc = $e1ec086d45566806$var$Hc("transitionend"), $e1ec086d45566806$var$Mc = new Map, $e1ec086d45566806$var$Nc = new Map, $e1ec086d45566806$var$Oc = [
    "abort",
    "abort",
    $e1ec086d45566806$var$Ic,
    "animationEnd",
    $e1ec086d45566806$var$Jc,
    "animationIteration",
    $e1ec086d45566806$var$Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $e1ec086d45566806$var$Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function $e1ec086d45566806$var$Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        $e1ec086d45566806$var$Nc.set(d, b);
        $e1ec086d45566806$var$Mc.set(d, e);
        $e1ec086d45566806$var$da(e, [
            d
        ]);
    }
}
var $e1ec086d45566806$var$Qc = $1MX31.unstable_now;
$e1ec086d45566806$var$Qc();
var $e1ec086d45566806$var$F = 8;
function $e1ec086d45566806$var$Rc(a) {
    if (0 !== (1 & a)) return $e1ec086d45566806$var$F = 15, 1;
    if (0 !== (2 & a)) return $e1ec086d45566806$var$F = 14, 2;
    if (0 !== (4 & a)) return $e1ec086d45566806$var$F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return $e1ec086d45566806$var$F = 12, b;
    if (0 !== (a & 32)) return $e1ec086d45566806$var$F = 11, 32;
    b = 192 & a;
    if (0 !== b) return $e1ec086d45566806$var$F = 10, b;
    if (0 !== (a & 256)) return $e1ec086d45566806$var$F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return $e1ec086d45566806$var$F = 8, b;
    if (0 !== (a & 4096)) return $e1ec086d45566806$var$F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return $e1ec086d45566806$var$F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return $e1ec086d45566806$var$F = 5, b;
    if (a & 67108864) return $e1ec086d45566806$var$F = 4, 67108864;
    if (0 !== (a & 134217728)) return $e1ec086d45566806$var$F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return $e1ec086d45566806$var$F = 2, b;
    if (0 !== (1073741824 & a)) return $e1ec086d45566806$var$F = 1, 1073741824;
    $e1ec086d45566806$var$F = 8;
    return a;
}
function $e1ec086d45566806$var$Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function $e1ec086d45566806$var$Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error($e1ec086d45566806$var$y(358, a));
    }
}
function $e1ec086d45566806$var$Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return $e1ec086d45566806$var$F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = $e1ec086d45566806$var$F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = $e1ec086d45566806$var$Rc(k), e = $e1ec086d45566806$var$F) : (h &= f, 0 !== h && (d = $e1ec086d45566806$var$Rc(h), e = $e1ec086d45566806$var$F));
    } else f = c & ~g, 0 !== f ? (d = $e1ec086d45566806$var$Rc(f), e = $e1ec086d45566806$var$F) : 0 !== h && (d = $e1ec086d45566806$var$Rc(h), e = $e1ec086d45566806$var$F);
    if (0 === d) return 0;
    d = 31 - $e1ec086d45566806$var$Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        $e1ec086d45566806$var$Rc(b);
        if (e <= $e1ec086d45566806$var$F) return b;
        $e1ec086d45566806$var$F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $e1ec086d45566806$var$Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $e1ec086d45566806$var$Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $e1ec086d45566806$var$Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = $e1ec086d45566806$var$Yc(24 & ~b), 0 === a ? $e1ec086d45566806$var$Xc(10, b) : a;
        case 10:
            return a = $e1ec086d45566806$var$Yc(192 & ~b), 0 === a ? $e1ec086d45566806$var$Xc(8, b) : a;
        case 8:
            return a = $e1ec086d45566806$var$Yc(3584 & ~b), 0 === a && (a = $e1ec086d45566806$var$Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = $e1ec086d45566806$var$Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error($e1ec086d45566806$var$y(358, a));
}
function $e1ec086d45566806$var$Yc(a) {
    return a & -a;
}
function $e1ec086d45566806$var$Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $e1ec086d45566806$var$$c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - $e1ec086d45566806$var$Vc(b);
    a[b] = c;
}
var $e1ec086d45566806$var$Vc = Math.clz32 ? Math.clz32 : $e1ec086d45566806$var$ad, $e1ec086d45566806$var$bd = Math.log, $e1ec086d45566806$var$cd = Math.LN2;
function $e1ec086d45566806$var$ad(a) {
    return 0 === a ? 32 : 31 - ($e1ec086d45566806$var$bd(a) / $e1ec086d45566806$var$cd | 0) | 0;
}
var $e1ec086d45566806$var$dd = $1MX31.unstable_UserBlockingPriority, $e1ec086d45566806$var$ed = $1MX31.unstable_runWithPriority, $e1ec086d45566806$var$fd = !0;
function $e1ec086d45566806$var$gd(a, b, c, d) {
    $e1ec086d45566806$var$Kb || $e1ec086d45566806$var$Ib();
    var e = $e1ec086d45566806$var$hd, f = $e1ec086d45566806$var$Kb;
    $e1ec086d45566806$var$Kb = !0;
    try {
        $e1ec086d45566806$var$Hb(e, a, b, c, d);
    } finally{
        ($e1ec086d45566806$var$Kb = f) || $e1ec086d45566806$var$Mb();
    }
}
function $e1ec086d45566806$var$id(a, b, c, d) {
    $e1ec086d45566806$var$ed($e1ec086d45566806$var$dd, $e1ec086d45566806$var$hd.bind(null, a, b, c, d));
}
function $e1ec086d45566806$var$hd(a, b, c, d) {
    if ($e1ec086d45566806$var$fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < $e1ec086d45566806$var$jc.length && -1 < $e1ec086d45566806$var$qc.indexOf(a)) a = $e1ec086d45566806$var$rc(null, a, b, c, d), $e1ec086d45566806$var$jc.push(a);
        else {
            var f = $e1ec086d45566806$var$yc(a, b, c, d);
            if (null === f) e && $e1ec086d45566806$var$sc(a, d);
            else {
                if (e) {
                    if (-1 < $e1ec086d45566806$var$qc.indexOf(a)) {
                        a = $e1ec086d45566806$var$rc(f, a, b, c, d);
                        $e1ec086d45566806$var$jc.push(a);
                        return;
                    }
                    if ($e1ec086d45566806$var$uc(f, a, b, c, d)) return;
                    $e1ec086d45566806$var$sc(a, d);
                }
                $e1ec086d45566806$var$jd(a, b, d, null, c);
            }
        }
    }
}
function $e1ec086d45566806$var$yc(a, b, c, d) {
    var e = $e1ec086d45566806$var$xb(d);
    e = $e1ec086d45566806$var$wc(e);
    if (null !== e) {
        var f = $e1ec086d45566806$var$Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $e1ec086d45566806$var$$b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    $e1ec086d45566806$var$jd(a, b, d, e, c);
    return null;
}
var $e1ec086d45566806$var$kd = null, $e1ec086d45566806$var$ld = null, $e1ec086d45566806$var$md = null;
function $e1ec086d45566806$var$nd() {
    if ($e1ec086d45566806$var$md) return $e1ec086d45566806$var$md;
    var a, b = $e1ec086d45566806$var$ld, c = b.length, d, e = "value" in $e1ec086d45566806$var$kd ? $e1ec086d45566806$var$kd.value : $e1ec086d45566806$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $e1ec086d45566806$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $e1ec086d45566806$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $e1ec086d45566806$var$pd() {
    return !0;
}
function $e1ec086d45566806$var$qd() {
    return !1;
}
function $e1ec086d45566806$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $e1ec086d45566806$var$pd : $e1ec086d45566806$var$qd;
        this.isPropagationStopped = $e1ec086d45566806$var$qd;
        return this;
    }
    $bDppX(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $e1ec086d45566806$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $e1ec086d45566806$var$pd);
        },
        persist: function() {},
        isPersistent: $e1ec086d45566806$var$pd
    });
    return b;
}
var $e1ec086d45566806$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e1ec086d45566806$var$td = $e1ec086d45566806$var$rd($e1ec086d45566806$var$sd), $e1ec086d45566806$var$ud = $bDppX({}, $e1ec086d45566806$var$sd, {
    view: 0,
    detail: 0
}), $e1ec086d45566806$var$vd = $e1ec086d45566806$var$rd($e1ec086d45566806$var$ud), $e1ec086d45566806$var$wd, $e1ec086d45566806$var$xd, $e1ec086d45566806$var$yd, $e1ec086d45566806$var$Ad = $bDppX({}, $e1ec086d45566806$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e1ec086d45566806$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $e1ec086d45566806$var$yd && ($e1ec086d45566806$var$yd && "mousemove" === a.type ? ($e1ec086d45566806$var$wd = a.screenX - $e1ec086d45566806$var$yd.screenX, $e1ec086d45566806$var$xd = a.screenY - $e1ec086d45566806$var$yd.screenY) : $e1ec086d45566806$var$xd = $e1ec086d45566806$var$wd = 0, $e1ec086d45566806$var$yd = a);
        return $e1ec086d45566806$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $e1ec086d45566806$var$xd;
    }
}), $e1ec086d45566806$var$Bd = $e1ec086d45566806$var$rd($e1ec086d45566806$var$Ad), $e1ec086d45566806$var$Cd = $bDppX({}, $e1ec086d45566806$var$Ad, {
    dataTransfer: 0
}), $e1ec086d45566806$var$Dd = $e1ec086d45566806$var$rd($e1ec086d45566806$var$Cd), $e1ec086d45566806$var$Ed = $bDppX({}, $e1ec086d45566806$var$ud, {
    relatedTarget: 0
}), $e1ec086d45566806$var$Fd = $e1ec086d45566806$var$rd($e1ec086d45566806$var$Ed), $e1ec086d45566806$var$Gd = $bDppX({}, $e1ec086d45566806$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e1ec086d45566806$var$Hd = $e1ec086d45566806$var$rd($e1ec086d45566806$var$Gd), $e1ec086d45566806$var$Id = $bDppX({}, $e1ec086d45566806$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $e1ec086d45566806$var$Jd = $e1ec086d45566806$var$rd($e1ec086d45566806$var$Id), $e1ec086d45566806$var$Kd = $bDppX({}, $e1ec086d45566806$var$sd, {
    data: 0
}), $e1ec086d45566806$var$Ld = $e1ec086d45566806$var$rd($e1ec086d45566806$var$Kd), $e1ec086d45566806$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e1ec086d45566806$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e1ec086d45566806$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e1ec086d45566806$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $e1ec086d45566806$var$Od[a]) ? !!b[a] : !1;
}
function $e1ec086d45566806$var$zd() {
    return $e1ec086d45566806$var$Pd;
}
var $e1ec086d45566806$var$Qd = $bDppX({}, $e1ec086d45566806$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $e1ec086d45566806$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $e1ec086d45566806$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $e1ec086d45566806$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e1ec086d45566806$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $e1ec086d45566806$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $e1ec086d45566806$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $e1ec086d45566806$var$Rd = $e1ec086d45566806$var$rd($e1ec086d45566806$var$Qd), $e1ec086d45566806$var$Sd = $bDppX({}, $e1ec086d45566806$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e1ec086d45566806$var$Td = $e1ec086d45566806$var$rd($e1ec086d45566806$var$Sd), $e1ec086d45566806$var$Ud = $bDppX({}, $e1ec086d45566806$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e1ec086d45566806$var$zd
}), $e1ec086d45566806$var$Vd = $e1ec086d45566806$var$rd($e1ec086d45566806$var$Ud), $e1ec086d45566806$var$Wd = $bDppX({}, $e1ec086d45566806$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e1ec086d45566806$var$Xd = $e1ec086d45566806$var$rd($e1ec086d45566806$var$Wd), $e1ec086d45566806$var$Yd = $bDppX({}, $e1ec086d45566806$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e1ec086d45566806$var$Zd = $e1ec086d45566806$var$rd($e1ec086d45566806$var$Yd), $e1ec086d45566806$var$$d = [
    9,
    13,
    27,
    32
], $e1ec086d45566806$var$ae = $e1ec086d45566806$var$fa && "CompositionEvent" in window, $e1ec086d45566806$var$be = null;
$e1ec086d45566806$var$fa && "documentMode" in document && ($e1ec086d45566806$var$be = document.documentMode);
var $e1ec086d45566806$var$ce = $e1ec086d45566806$var$fa && "TextEvent" in window && !$e1ec086d45566806$var$be, $e1ec086d45566806$var$de = $e1ec086d45566806$var$fa && (!$e1ec086d45566806$var$ae || $e1ec086d45566806$var$be && 8 < $e1ec086d45566806$var$be && 11 >= $e1ec086d45566806$var$be), $e1ec086d45566806$var$ee = String.fromCharCode(32), $e1ec086d45566806$var$fe = !1;
function $e1ec086d45566806$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $e1ec086d45566806$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e1ec086d45566806$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $e1ec086d45566806$var$ie = !1;
function $e1ec086d45566806$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $e1ec086d45566806$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $e1ec086d45566806$var$fe = !0;
            return $e1ec086d45566806$var$ee;
        case "textInput":
            return a = b.data, a === $e1ec086d45566806$var$ee && $e1ec086d45566806$var$fe ? null : a;
        default:
            return null;
    }
}
function $e1ec086d45566806$var$ke(a, b) {
    if ($e1ec086d45566806$var$ie) return "compositionend" === a || !$e1ec086d45566806$var$ae && $e1ec086d45566806$var$ge(a, b) ? (a = $e1ec086d45566806$var$nd(), $e1ec086d45566806$var$md = $e1ec086d45566806$var$ld = $e1ec086d45566806$var$kd = null, $e1ec086d45566806$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $e1ec086d45566806$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $e1ec086d45566806$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e1ec086d45566806$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$e1ec086d45566806$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $e1ec086d45566806$var$ne(a, b, c, d) {
    $e1ec086d45566806$var$Eb(d);
    b = $e1ec086d45566806$var$oe(b, "onChange");
    0 < b.length && (c = new $e1ec086d45566806$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $e1ec086d45566806$var$pe = null, $e1ec086d45566806$var$qe = null;
function $e1ec086d45566806$var$re(a) {
    $e1ec086d45566806$var$se(a, 0);
}
function $e1ec086d45566806$var$te(a) {
    var b = $e1ec086d45566806$var$ue(a);
    if ($e1ec086d45566806$var$Wa(b)) return a;
}
function $e1ec086d45566806$var$ve(a, b) {
    if ("change" === a) return b;
}
var $e1ec086d45566806$var$we = !1;
if ($e1ec086d45566806$var$fa) {
    var $e1ec086d45566806$var$xe;
    if ($e1ec086d45566806$var$fa) {
        var $e1ec086d45566806$var$ye = "oninput" in document;
        if (!$e1ec086d45566806$var$ye) {
            var $e1ec086d45566806$var$ze = document.createElement("div");
            $e1ec086d45566806$var$ze.setAttribute("oninput", "return;");
            $e1ec086d45566806$var$ye = "function" === typeof $e1ec086d45566806$var$ze.oninput;
        }
        $e1ec086d45566806$var$xe = $e1ec086d45566806$var$ye;
    } else $e1ec086d45566806$var$xe = !1;
    $e1ec086d45566806$var$we = $e1ec086d45566806$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $e1ec086d45566806$var$Ae() {
    $e1ec086d45566806$var$pe && ($e1ec086d45566806$var$pe.detachEvent("onpropertychange", $e1ec086d45566806$var$Be), $e1ec086d45566806$var$qe = $e1ec086d45566806$var$pe = null);
}
function $e1ec086d45566806$var$Be(a) {
    if ("value" === a.propertyName && $e1ec086d45566806$var$te($e1ec086d45566806$var$qe)) {
        var b = [];
        $e1ec086d45566806$var$ne(b, $e1ec086d45566806$var$qe, a, $e1ec086d45566806$var$xb(a));
        a = $e1ec086d45566806$var$re;
        if ($e1ec086d45566806$var$Kb) a(b);
        else {
            $e1ec086d45566806$var$Kb = !0;
            try {
                $e1ec086d45566806$var$Gb(a, b);
            } finally{
                $e1ec086d45566806$var$Kb = !1, $e1ec086d45566806$var$Mb();
            }
        }
    }
}
function $e1ec086d45566806$var$Ce(a, b, c) {
    "focusin" === a ? ($e1ec086d45566806$var$Ae(), $e1ec086d45566806$var$pe = b, $e1ec086d45566806$var$qe = c, $e1ec086d45566806$var$pe.attachEvent("onpropertychange", $e1ec086d45566806$var$Be)) : "focusout" === a && $e1ec086d45566806$var$Ae();
}
function $e1ec086d45566806$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $e1ec086d45566806$var$te($e1ec086d45566806$var$qe);
}
function $e1ec086d45566806$var$Ee(a, b) {
    if ("click" === a) return $e1ec086d45566806$var$te(b);
}
function $e1ec086d45566806$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $e1ec086d45566806$var$te(b);
}
function $e1ec086d45566806$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e1ec086d45566806$var$He = "function" === typeof Object.is ? Object.is : $e1ec086d45566806$var$Ge, $e1ec086d45566806$var$Ie = Object.prototype.hasOwnProperty;
function $e1ec086d45566806$var$Je(a, b) {
    if ($e1ec086d45566806$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!$e1ec086d45566806$var$Ie.call(b, c[d]) || !$e1ec086d45566806$var$He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function $e1ec086d45566806$var$Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $e1ec086d45566806$var$Le(a, b) {
    var c = $e1ec086d45566806$var$Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $e1ec086d45566806$var$Ke(c);
    }
}
function $e1ec086d45566806$var$Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $e1ec086d45566806$var$Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $e1ec086d45566806$var$Ne() {
    for(var a = window, b = $e1ec086d45566806$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $e1ec086d45566806$var$Xa(a.document);
    }
    return b;
}
function $e1ec086d45566806$var$Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var $e1ec086d45566806$var$Pe = $e1ec086d45566806$var$fa && "documentMode" in document && 11 >= document.documentMode, $e1ec086d45566806$var$Qe = null, $e1ec086d45566806$var$Re = null, $e1ec086d45566806$var$Se = null, $e1ec086d45566806$var$Te = !1;
function $e1ec086d45566806$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $e1ec086d45566806$var$Te || null == $e1ec086d45566806$var$Qe || $e1ec086d45566806$var$Qe !== $e1ec086d45566806$var$Xa(d) || (d = $e1ec086d45566806$var$Qe, "selectionStart" in d && $e1ec086d45566806$var$Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $e1ec086d45566806$var$Se && $e1ec086d45566806$var$Je($e1ec086d45566806$var$Se, d) || ($e1ec086d45566806$var$Se = d, d = $e1ec086d45566806$var$oe($e1ec086d45566806$var$Re, "onSelect"), 0 < d.length && (b = new $e1ec086d45566806$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $e1ec086d45566806$var$Qe)));
}
$e1ec086d45566806$var$Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
$e1ec086d45566806$var$Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
$e1ec086d45566806$var$Pc($e1ec086d45566806$var$Oc, 2);
for(var $e1ec086d45566806$var$Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), $e1ec086d45566806$var$We = 0; $e1ec086d45566806$var$We < $e1ec086d45566806$var$Ve.length; $e1ec086d45566806$var$We++)$e1ec086d45566806$var$Nc.set($e1ec086d45566806$var$Ve[$e1ec086d45566806$var$We], 0);
$e1ec086d45566806$var$ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e1ec086d45566806$var$ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e1ec086d45566806$var$ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e1ec086d45566806$var$ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e1ec086d45566806$var$da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e1ec086d45566806$var$da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e1ec086d45566806$var$da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e1ec086d45566806$var$da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e1ec086d45566806$var$da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e1ec086d45566806$var$da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e1ec086d45566806$var$Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e1ec086d45566806$var$Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat($e1ec086d45566806$var$Xe));
function $e1ec086d45566806$var$Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $e1ec086d45566806$var$Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function $e1ec086d45566806$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e1ec086d45566806$var$Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e1ec086d45566806$var$Ze(e, h, l);
                f = k;
            }
        }
    }
    if ($e1ec086d45566806$var$Ub) throw a = $e1ec086d45566806$var$Vb, $e1ec086d45566806$var$Ub = !1, $e1ec086d45566806$var$Vb = null, a;
}
function $e1ec086d45566806$var$G(a, b) {
    var c = $e1ec086d45566806$var$$e(b), d = a + "__bubble";
    c.has(d) || ($e1ec086d45566806$var$af(b, a, 2, !1), c.add(d));
}
var $e1ec086d45566806$var$bf = "_reactListening" + Math.random().toString(36).slice(2);
function $e1ec086d45566806$var$cf(a) {
    a[$e1ec086d45566806$var$bf] || (a[$e1ec086d45566806$var$bf] = !0, $e1ec086d45566806$var$ba.forEach(function(b) {
        $e1ec086d45566806$var$Ye.has(b) || $e1ec086d45566806$var$df(b, !1, a, null);
        $e1ec086d45566806$var$df(b, !0, a, null);
    }));
}
function $e1ec086d45566806$var$df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && $e1ec086d45566806$var$Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e1ec086d45566806$var$$e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), $e1ec086d45566806$var$af(f, a, e, b), g.add(h));
}
function $e1ec086d45566806$var$af(a, b, c, d) {
    var e = $e1ec086d45566806$var$Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = $e1ec086d45566806$var$gd;
            break;
        case 1:
            e = $e1ec086d45566806$var$id;
            break;
        default:
            e = $e1ec086d45566806$var$hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$e1ec086d45566806$var$Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $e1ec086d45566806$var$jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $e1ec086d45566806$var$wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $e1ec086d45566806$var$Nb(function() {
        var d = f, e = $e1ec086d45566806$var$xb(c), g = [];
        a: {
            var h = $e1ec086d45566806$var$Mc.get(a);
            if (void 0 !== h) {
                var k = $e1ec086d45566806$var$td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === $e1ec086d45566806$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $e1ec086d45566806$var$Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = $e1ec086d45566806$var$Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = $e1ec086d45566806$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $e1ec086d45566806$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $e1ec086d45566806$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $e1ec086d45566806$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $e1ec086d45566806$var$Vd;
                        break;
                    case $e1ec086d45566806$var$Ic:
                    case $e1ec086d45566806$var$Jc:
                    case $e1ec086d45566806$var$Kc:
                        k = $e1ec086d45566806$var$Hd;
                        break;
                    case $e1ec086d45566806$var$Lc:
                        k = $e1ec086d45566806$var$Xd;
                        break;
                    case "scroll":
                        k = $e1ec086d45566806$var$vd;
                        break;
                    case "wheel":
                        k = $e1ec086d45566806$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $e1ec086d45566806$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $e1ec086d45566806$var$Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = $e1ec086d45566806$var$Ob(t, u), null != v && w.push($e1ec086d45566806$var$ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && ($e1ec086d45566806$var$wc(x) || x[$e1ec086d45566806$var$ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? $e1ec086d45566806$var$wc(x) : null, null !== x && (z = $e1ec086d45566806$var$Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = $e1ec086d45566806$var$Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $e1ec086d45566806$var$Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : $e1ec086d45566806$var$ue(k);
                        q = null == x ? h : $e1ec086d45566806$var$ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        $e1ec086d45566806$var$wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = $e1ec086d45566806$var$gf(q))t++;
                            q = 0;
                            for(v = u; v; v = $e1ec086d45566806$var$gf(v))q++;
                            for(; 0 < t - q;)w = $e1ec086d45566806$var$gf(w), t--;
                            for(; 0 < q - t;)u = $e1ec086d45566806$var$gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = $e1ec086d45566806$var$gf(w);
                                u = $e1ec086d45566806$var$gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $e1ec086d45566806$var$hf(g, h, k, w, !1);
                        null !== x && null !== z && $e1ec086d45566806$var$hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? $e1ec086d45566806$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = $e1ec086d45566806$var$ve;
                else if ($e1ec086d45566806$var$me(h)) {
                    if ($e1ec086d45566806$var$we) J = $e1ec086d45566806$var$Fe;
                    else {
                        J = $e1ec086d45566806$var$De;
                        var K = $e1ec086d45566806$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = $e1ec086d45566806$var$Ee);
                if (J && (J = J(a, d))) {
                    $e1ec086d45566806$var$ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && $e1ec086d45566806$var$bb(h, "number", h.value);
            }
            K = d ? $e1ec086d45566806$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($e1ec086d45566806$var$me(K) || "true" === K.contentEditable) $e1ec086d45566806$var$Qe = K, $e1ec086d45566806$var$Re = d, $e1ec086d45566806$var$Se = null;
                    break;
                case "focusout":
                    $e1ec086d45566806$var$Se = $e1ec086d45566806$var$Re = $e1ec086d45566806$var$Qe = null;
                    break;
                case "mousedown":
                    $e1ec086d45566806$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e1ec086d45566806$var$Te = !1;
                    $e1ec086d45566806$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($e1ec086d45566806$var$Pe) break;
                case "keydown":
                case "keyup":
                    $e1ec086d45566806$var$Ue(g, c, e);
            }
            var Q;
            if ($e1ec086d45566806$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else $e1ec086d45566806$var$ie ? $e1ec086d45566806$var$ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && ($e1ec086d45566806$var$de && "ko" !== c.locale && ($e1ec086d45566806$var$ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && $e1ec086d45566806$var$ie && (Q = $e1ec086d45566806$var$nd()) : ($e1ec086d45566806$var$kd = e, $e1ec086d45566806$var$ld = "value" in $e1ec086d45566806$var$kd ? $e1ec086d45566806$var$kd.value : $e1ec086d45566806$var$kd.textContent, $e1ec086d45566806$var$ie = !0)), K = $e1ec086d45566806$var$oe(d, L), 0 < K.length && (L = new $e1ec086d45566806$var$Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = $e1ec086d45566806$var$he(c), null !== Q && (L.data = Q))));
            if (Q = $e1ec086d45566806$var$ce ? $e1ec086d45566806$var$je(a, c) : $e1ec086d45566806$var$ke(a, c)) d = $e1ec086d45566806$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $e1ec086d45566806$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        $e1ec086d45566806$var$se(g, b);
    });
}
function $e1ec086d45566806$var$ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $e1ec086d45566806$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $e1ec086d45566806$var$Ob(a, c), null != f && d.unshift($e1ec086d45566806$var$ef(a, f, e)), f = $e1ec086d45566806$var$Ob(a, b), null != f && d.push($e1ec086d45566806$var$ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function $e1ec086d45566806$var$gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $e1ec086d45566806$var$hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $e1ec086d45566806$var$Ob(c, f), null != k && g.unshift($e1ec086d45566806$var$ef(c, k, h))) : e || (k = $e1ec086d45566806$var$Ob(c, f), null != k && g.push($e1ec086d45566806$var$ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function $e1ec086d45566806$var$jf() {}
var $e1ec086d45566806$var$kf = null, $e1ec086d45566806$var$lf = null;
function $e1ec086d45566806$var$mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function $e1ec086d45566806$var$nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $e1ec086d45566806$var$of = "function" === typeof setTimeout ? setTimeout : void 0, $e1ec086d45566806$var$pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function $e1ec086d45566806$var$qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function $e1ec086d45566806$var$rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function $e1ec086d45566806$var$sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $e1ec086d45566806$var$tf = 0;
function $e1ec086d45566806$var$uf(a) {
    return {
        $$typeof: $e1ec086d45566806$var$Ga,
        toString: a,
        valueOf: a
    };
}
var $e1ec086d45566806$var$vf = Math.random().toString(36).slice(2), $e1ec086d45566806$var$wf = "__reactFiber$" + $e1ec086d45566806$var$vf, $e1ec086d45566806$var$xf = "__reactProps$" + $e1ec086d45566806$var$vf, $e1ec086d45566806$var$ff = "__reactContainer$" + $e1ec086d45566806$var$vf, $e1ec086d45566806$var$yf = "__reactEvents$" + $e1ec086d45566806$var$vf;
function $e1ec086d45566806$var$wc(a) {
    var b = a[$e1ec086d45566806$var$wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$e1ec086d45566806$var$ff] || c[$e1ec086d45566806$var$wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $e1ec086d45566806$var$sf(a); null !== a;){
                if (c = a[$e1ec086d45566806$var$wf]) return c;
                a = $e1ec086d45566806$var$sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $e1ec086d45566806$var$Cb(a) {
    a = a[$e1ec086d45566806$var$wf] || a[$e1ec086d45566806$var$ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $e1ec086d45566806$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($e1ec086d45566806$var$y(33));
}
function $e1ec086d45566806$var$Db(a) {
    return a[$e1ec086d45566806$var$xf] || null;
}
function $e1ec086d45566806$var$$e(a) {
    var b = a[$e1ec086d45566806$var$yf];
    void 0 === b && (b = a[$e1ec086d45566806$var$yf] = new Set);
    return b;
}
var $e1ec086d45566806$var$zf = [], $e1ec086d45566806$var$Af = -1;
function $e1ec086d45566806$var$Bf(a) {
    return {
        current: a
    };
}
function $e1ec086d45566806$var$H(a) {
    0 > $e1ec086d45566806$var$Af || (a.current = $e1ec086d45566806$var$zf[$e1ec086d45566806$var$Af], $e1ec086d45566806$var$zf[$e1ec086d45566806$var$Af] = null, $e1ec086d45566806$var$Af--);
}
function $e1ec086d45566806$var$I(a, b) {
    $e1ec086d45566806$var$Af++;
    $e1ec086d45566806$var$zf[$e1ec086d45566806$var$Af] = a.current;
    a.current = b;
}
var $e1ec086d45566806$var$Cf = {}, $e1ec086d45566806$var$M = $e1ec086d45566806$var$Bf($e1ec086d45566806$var$Cf), $e1ec086d45566806$var$N = $e1ec086d45566806$var$Bf(!1), $e1ec086d45566806$var$Df = $e1ec086d45566806$var$Cf;
function $e1ec086d45566806$var$Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $e1ec086d45566806$var$Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $e1ec086d45566806$var$Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $e1ec086d45566806$var$Gf() {
    $e1ec086d45566806$var$H($e1ec086d45566806$var$N);
    $e1ec086d45566806$var$H($e1ec086d45566806$var$M);
}
function $e1ec086d45566806$var$Hf(a, b, c) {
    if ($e1ec086d45566806$var$M.current !== $e1ec086d45566806$var$Cf) throw Error($e1ec086d45566806$var$y(168));
    $e1ec086d45566806$var$I($e1ec086d45566806$var$M, b);
    $e1ec086d45566806$var$I($e1ec086d45566806$var$N, c);
}
function $e1ec086d45566806$var$If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error($e1ec086d45566806$var$y(108, $e1ec086d45566806$var$Ra(b) || "Unknown", e));
    return $bDppX({}, c, d);
}
function $e1ec086d45566806$var$Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $e1ec086d45566806$var$Cf;
    $e1ec086d45566806$var$Df = $e1ec086d45566806$var$M.current;
    $e1ec086d45566806$var$I($e1ec086d45566806$var$M, a);
    $e1ec086d45566806$var$I($e1ec086d45566806$var$N, $e1ec086d45566806$var$N.current);
    return !0;
}
function $e1ec086d45566806$var$Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($e1ec086d45566806$var$y(169));
    c ? (a = $e1ec086d45566806$var$If(a, b, $e1ec086d45566806$var$Df), d.__reactInternalMemoizedMergedChildContext = a, $e1ec086d45566806$var$H($e1ec086d45566806$var$N), $e1ec086d45566806$var$H($e1ec086d45566806$var$M), $e1ec086d45566806$var$I($e1ec086d45566806$var$M, a)) : $e1ec086d45566806$var$H($e1ec086d45566806$var$N);
    $e1ec086d45566806$var$I($e1ec086d45566806$var$N, c);
}
var $e1ec086d45566806$var$Lf = null, $e1ec086d45566806$var$Mf = null, $e1ec086d45566806$var$Nf = $1MX31.unstable_runWithPriority, $e1ec086d45566806$var$Of = $1MX31.unstable_scheduleCallback, $e1ec086d45566806$var$Pf = $1MX31.unstable_cancelCallback, $e1ec086d45566806$var$Qf = $1MX31.unstable_shouldYield, $e1ec086d45566806$var$Rf = $1MX31.unstable_requestPaint, $e1ec086d45566806$var$Sf = $1MX31.unstable_now, $e1ec086d45566806$var$Tf = $1MX31.unstable_getCurrentPriorityLevel, $e1ec086d45566806$var$Uf = $1MX31.unstable_ImmediatePriority, $e1ec086d45566806$var$Vf = $1MX31.unstable_UserBlockingPriority, $e1ec086d45566806$var$Wf = $1MX31.unstable_NormalPriority, $e1ec086d45566806$var$Xf = $1MX31.unstable_LowPriority, $e1ec086d45566806$var$Yf = $1MX31.unstable_IdlePriority, $e1ec086d45566806$var$Zf = {}, $e1ec086d45566806$var$$f = void 0 !== $e1ec086d45566806$var$Rf ? $e1ec086d45566806$var$Rf : function() {}, $e1ec086d45566806$var$ag = null, $e1ec086d45566806$var$bg = null, $e1ec086d45566806$var$cg = !1, $e1ec086d45566806$var$dg = $e1ec086d45566806$var$Sf(), $e1ec086d45566806$var$O = 1E4 > $e1ec086d45566806$var$dg ? $e1ec086d45566806$var$Sf : function() {
    return $e1ec086d45566806$var$Sf() - $e1ec086d45566806$var$dg;
};
function $e1ec086d45566806$var$eg() {
    switch($e1ec086d45566806$var$Tf()){
        case $e1ec086d45566806$var$Uf:
            return 99;
        case $e1ec086d45566806$var$Vf:
            return 98;
        case $e1ec086d45566806$var$Wf:
            return 97;
        case $e1ec086d45566806$var$Xf:
            return 96;
        case $e1ec086d45566806$var$Yf:
            return 95;
        default:
            throw Error($e1ec086d45566806$var$y(332));
    }
}
function $e1ec086d45566806$var$fg(a) {
    switch(a){
        case 99:
            return $e1ec086d45566806$var$Uf;
        case 98:
            return $e1ec086d45566806$var$Vf;
        case 97:
            return $e1ec086d45566806$var$Wf;
        case 96:
            return $e1ec086d45566806$var$Xf;
        case 95:
            return $e1ec086d45566806$var$Yf;
        default:
            throw Error($e1ec086d45566806$var$y(332));
    }
}
function $e1ec086d45566806$var$gg(a, b) {
    a = $e1ec086d45566806$var$fg(a);
    return $e1ec086d45566806$var$Nf(a, b);
}
function $e1ec086d45566806$var$hg(a, b, c) {
    a = $e1ec086d45566806$var$fg(a);
    return $e1ec086d45566806$var$Of(a, b, c);
}
function $e1ec086d45566806$var$ig() {
    if (null !== $e1ec086d45566806$var$bg) {
        var a = $e1ec086d45566806$var$bg;
        $e1ec086d45566806$var$bg = null;
        $e1ec086d45566806$var$Pf(a);
    }
    $e1ec086d45566806$var$jg();
}
function $e1ec086d45566806$var$jg() {
    if (!$e1ec086d45566806$var$cg && null !== $e1ec086d45566806$var$ag) {
        $e1ec086d45566806$var$cg = !0;
        var a = 0;
        try {
            var b = $e1ec086d45566806$var$ag;
            $e1ec086d45566806$var$gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            $e1ec086d45566806$var$ag = null;
        } catch (c) {
            throw null !== $e1ec086d45566806$var$ag && ($e1ec086d45566806$var$ag = $e1ec086d45566806$var$ag.slice(a + 1)), $e1ec086d45566806$var$Of($e1ec086d45566806$var$Uf, $e1ec086d45566806$var$ig), c;
        } finally{
            $e1ec086d45566806$var$cg = !1;
        }
    }
}
var $e1ec086d45566806$var$kg = $e1ec086d45566806$var$ra.ReactCurrentBatchConfig;
function $e1ec086d45566806$var$lg(a, b) {
    if (a && a.defaultProps) {
        b = $bDppX({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $e1ec086d45566806$var$mg = $e1ec086d45566806$var$Bf(null), $e1ec086d45566806$var$ng = null, $e1ec086d45566806$var$og = null, $e1ec086d45566806$var$pg = null;
function $e1ec086d45566806$var$qg() {
    $e1ec086d45566806$var$pg = $e1ec086d45566806$var$og = $e1ec086d45566806$var$ng = null;
}
function $e1ec086d45566806$var$rg(a) {
    var b = $e1ec086d45566806$var$mg.current;
    $e1ec086d45566806$var$H($e1ec086d45566806$var$mg);
    a.type._context._currentValue = b;
}
function $e1ec086d45566806$var$sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function $e1ec086d45566806$var$tg(a, b) {
    $e1ec086d45566806$var$ng = a;
    $e1ec086d45566806$var$pg = $e1ec086d45566806$var$og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($e1ec086d45566806$var$ug = !0), a.firstContext = null);
}
function $e1ec086d45566806$var$vg(a, b) {
    if ($e1ec086d45566806$var$pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) $e1ec086d45566806$var$pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === $e1ec086d45566806$var$og) {
            if (null === $e1ec086d45566806$var$ng) throw Error($e1ec086d45566806$var$y(308));
            $e1ec086d45566806$var$og = b;
            $e1ec086d45566806$var$ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else $e1ec086d45566806$var$og = $e1ec086d45566806$var$og.next = b;
    }
    return a._currentValue;
}
var $e1ec086d45566806$var$wg = !1;
function $e1ec086d45566806$var$xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function $e1ec086d45566806$var$yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $e1ec086d45566806$var$zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e1ec086d45566806$var$Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function $e1ec086d45566806$var$Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $e1ec086d45566806$var$Cg(a, b, c, d) {
    var e = a.updateQueue;
    $e1ec086d45566806$var$wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $bDppX({}, A, h);
                            break a;
                        case 2:
                            $e1ec086d45566806$var$wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        $e1ec086d45566806$var$Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function $e1ec086d45566806$var$Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($e1ec086d45566806$var$y(191, e));
            e.call(d);
        }
    }
}
var $e1ec086d45566806$var$Fg = (new $cQNHH.Component).refs;
function $e1ec086d45566806$var$Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $bDppX({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $e1ec086d45566806$var$Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $e1ec086d45566806$var$Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e1ec086d45566806$var$Hg(), e = $e1ec086d45566806$var$Ig(a), f = $e1ec086d45566806$var$zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        $e1ec086d45566806$var$Ag(a, f);
        $e1ec086d45566806$var$Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e1ec086d45566806$var$Hg(), e = $e1ec086d45566806$var$Ig(a), f = $e1ec086d45566806$var$zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        $e1ec086d45566806$var$Ag(a, f);
        $e1ec086d45566806$var$Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $e1ec086d45566806$var$Hg(), d = $e1ec086d45566806$var$Ig(a), e = $e1ec086d45566806$var$zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        $e1ec086d45566806$var$Ag(a, e);
        $e1ec086d45566806$var$Jg(a, d, c);
    }
};
function $e1ec086d45566806$var$Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$e1ec086d45566806$var$Je(c, d) || !$e1ec086d45566806$var$Je(e, f) : !0;
}
function $e1ec086d45566806$var$Mg(a, b, c) {
    var d = !1, e = $e1ec086d45566806$var$Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $e1ec086d45566806$var$vg(f) : (e = $e1ec086d45566806$var$Ff(b) ? $e1ec086d45566806$var$Df : $e1ec086d45566806$var$M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $e1ec086d45566806$var$Ef(a, e) : $e1ec086d45566806$var$Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $e1ec086d45566806$var$Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $e1ec086d45566806$var$Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $e1ec086d45566806$var$Kg.enqueueReplaceState(b, b.state, null);
}
function $e1ec086d45566806$var$Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $e1ec086d45566806$var$Fg;
    $e1ec086d45566806$var$xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $e1ec086d45566806$var$vg(f) : (f = $e1ec086d45566806$var$Ff(b) ? $e1ec086d45566806$var$Df : $e1ec086d45566806$var$M.current, e.context = $e1ec086d45566806$var$Ef(a, f));
    $e1ec086d45566806$var$Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($e1ec086d45566806$var$Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $e1ec086d45566806$var$Kg.enqueueReplaceState(e, e.state, null), $e1ec086d45566806$var$Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var $e1ec086d45566806$var$Pg = Array.isArray;
function $e1ec086d45566806$var$Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($e1ec086d45566806$var$y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($e1ec086d45566806$var$y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === $e1ec086d45566806$var$Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error($e1ec086d45566806$var$y(284));
        if (!c._owner) throw Error($e1ec086d45566806$var$y(290, a));
    }
    return a;
}
function $e1ec086d45566806$var$Rg(a, b) {
    if ("textarea" !== a.type) throw Error($e1ec086d45566806$var$y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function $e1ec086d45566806$var$Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $e1ec086d45566806$var$Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $e1ec086d45566806$var$Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = $e1ec086d45566806$var$Qg(a, b, c), d.return = a, d;
        d = $e1ec086d45566806$var$Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $e1ec086d45566806$var$Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $e1ec086d45566806$var$Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $e1ec086d45566806$var$Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = $e1ec086d45566806$var$Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $e1ec086d45566806$var$sa:
                    return c = $e1ec086d45566806$var$Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = $e1ec086d45566806$var$Qg(a, null, b), c.return = a, c;
                case $e1ec086d45566806$var$ta:
                    return b = $e1ec086d45566806$var$Wg(b, a.mode, c), b.return = a, b;
            }
            if ($e1ec086d45566806$var$Pg(b) || $e1ec086d45566806$var$La(b)) return b = $e1ec086d45566806$var$Xg(b, a.mode, c, null), b.return = a, b;
            $e1ec086d45566806$var$Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $e1ec086d45566806$var$sa:
                    return c.key === e ? c.type === $e1ec086d45566806$var$ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $e1ec086d45566806$var$ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if ($e1ec086d45566806$var$Pg(c) || $e1ec086d45566806$var$La(c)) return null !== e ? null : n(a, b, c, d, null);
            $e1ec086d45566806$var$Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $e1ec086d45566806$var$sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === $e1ec086d45566806$var$ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $e1ec086d45566806$var$ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if ($e1ec086d45566806$var$Pg(d) || $e1ec086d45566806$var$La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $e1ec086d45566806$var$Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = $e1ec086d45566806$var$La(h);
        if ("function" !== typeof l) throw Error($e1ec086d45566806$var$y(150));
        h = l.call(h);
        if (null == h) throw Error($e1ec086d45566806$var$y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === $e1ec086d45566806$var$ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case $e1ec086d45566806$var$sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === $e1ec086d45566806$var$ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = $e1ec086d45566806$var$Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === $e1ec086d45566806$var$ua ? (d = $e1ec086d45566806$var$Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $e1ec086d45566806$var$Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = $e1ec086d45566806$var$Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $e1ec086d45566806$var$ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = $e1ec086d45566806$var$Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $e1ec086d45566806$var$Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if ($e1ec086d45566806$var$Pg(f)) return x(a, d, f, h);
        if ($e1ec086d45566806$var$La(f)) return w(a, d, f, h);
        l && $e1ec086d45566806$var$Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error($e1ec086d45566806$var$y(152, $e1ec086d45566806$var$Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var $e1ec086d45566806$var$Yg = $e1ec086d45566806$var$Sg(!0), $e1ec086d45566806$var$Zg = $e1ec086d45566806$var$Sg(!1), $e1ec086d45566806$var$$g = {}, $e1ec086d45566806$var$ah = $e1ec086d45566806$var$Bf($e1ec086d45566806$var$$g), $e1ec086d45566806$var$bh = $e1ec086d45566806$var$Bf($e1ec086d45566806$var$$g), $e1ec086d45566806$var$ch = $e1ec086d45566806$var$Bf($e1ec086d45566806$var$$g);
function $e1ec086d45566806$var$dh(a) {
    if (a === $e1ec086d45566806$var$$g) throw Error($e1ec086d45566806$var$y(174));
    return a;
}
function $e1ec086d45566806$var$eh(a, b) {
    $e1ec086d45566806$var$I($e1ec086d45566806$var$ch, b);
    $e1ec086d45566806$var$I($e1ec086d45566806$var$bh, a);
    $e1ec086d45566806$var$I($e1ec086d45566806$var$ah, $e1ec086d45566806$var$$g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $e1ec086d45566806$var$mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $e1ec086d45566806$var$mb(b, a);
    }
    $e1ec086d45566806$var$H($e1ec086d45566806$var$ah);
    $e1ec086d45566806$var$I($e1ec086d45566806$var$ah, b);
}
function $e1ec086d45566806$var$fh() {
    $e1ec086d45566806$var$H($e1ec086d45566806$var$ah);
    $e1ec086d45566806$var$H($e1ec086d45566806$var$bh);
    $e1ec086d45566806$var$H($e1ec086d45566806$var$ch);
}
function $e1ec086d45566806$var$gh(a) {
    $e1ec086d45566806$var$dh($e1ec086d45566806$var$ch.current);
    var b = $e1ec086d45566806$var$dh($e1ec086d45566806$var$ah.current);
    var c = $e1ec086d45566806$var$mb(b, a.type);
    b !== c && ($e1ec086d45566806$var$I($e1ec086d45566806$var$bh, a), $e1ec086d45566806$var$I($e1ec086d45566806$var$ah, c));
}
function $e1ec086d45566806$var$hh(a) {
    $e1ec086d45566806$var$bh.current === a && ($e1ec086d45566806$var$H($e1ec086d45566806$var$ah), $e1ec086d45566806$var$H($e1ec086d45566806$var$bh));
}
var $e1ec086d45566806$var$P = $e1ec086d45566806$var$Bf(0);
function $e1ec086d45566806$var$ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $e1ec086d45566806$var$jh = null, $e1ec086d45566806$var$kh = null, $e1ec086d45566806$var$lh = !1;
function $e1ec086d45566806$var$mh(a, b) {
    var c = $e1ec086d45566806$var$nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function $e1ec086d45566806$var$oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function $e1ec086d45566806$var$ph(a) {
    if ($e1ec086d45566806$var$lh) {
        var b = $e1ec086d45566806$var$kh;
        if (b) {
            var c = b;
            if (!$e1ec086d45566806$var$oh(a, b)) {
                b = $e1ec086d45566806$var$rf(c.nextSibling);
                if (!b || !$e1ec086d45566806$var$oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    $e1ec086d45566806$var$lh = !1;
                    $e1ec086d45566806$var$jh = a;
                    return;
                }
                $e1ec086d45566806$var$mh($e1ec086d45566806$var$jh, c);
            }
            $e1ec086d45566806$var$jh = a;
            $e1ec086d45566806$var$kh = $e1ec086d45566806$var$rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, $e1ec086d45566806$var$lh = !1, $e1ec086d45566806$var$jh = a;
    }
}
function $e1ec086d45566806$var$qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $e1ec086d45566806$var$jh = a;
}
function $e1ec086d45566806$var$rh(a) {
    if (a !== $e1ec086d45566806$var$jh) return !1;
    if (!$e1ec086d45566806$var$lh) return $e1ec086d45566806$var$qh(a), $e1ec086d45566806$var$lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !$e1ec086d45566806$var$nf(b, a.memoizedProps)) for(b = $e1ec086d45566806$var$kh; b;)$e1ec086d45566806$var$mh(a, b), b = $e1ec086d45566806$var$rf(b.nextSibling);
    $e1ec086d45566806$var$qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($e1ec086d45566806$var$y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $e1ec086d45566806$var$kh = $e1ec086d45566806$var$rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $e1ec086d45566806$var$kh = null;
        }
    } else $e1ec086d45566806$var$kh = $e1ec086d45566806$var$jh ? $e1ec086d45566806$var$rf(a.stateNode.nextSibling) : null;
    return !0;
}
function $e1ec086d45566806$var$sh() {
    $e1ec086d45566806$var$kh = $e1ec086d45566806$var$jh = null;
    $e1ec086d45566806$var$lh = !1;
}
var $e1ec086d45566806$var$th = [];
function $e1ec086d45566806$var$uh() {
    for(var a = 0; a < $e1ec086d45566806$var$th.length; a++)$e1ec086d45566806$var$th[a]._workInProgressVersionPrimary = null;
    $e1ec086d45566806$var$th.length = 0;
}
var $e1ec086d45566806$var$vh = $e1ec086d45566806$var$ra.ReactCurrentDispatcher, $e1ec086d45566806$var$wh = $e1ec086d45566806$var$ra.ReactCurrentBatchConfig, $e1ec086d45566806$var$xh = 0, $e1ec086d45566806$var$R = null, $e1ec086d45566806$var$S = null, $e1ec086d45566806$var$T = null, $e1ec086d45566806$var$yh = !1, $e1ec086d45566806$var$zh = !1;
function $e1ec086d45566806$var$Ah() {
    throw Error($e1ec086d45566806$var$y(321));
}
function $e1ec086d45566806$var$Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e1ec086d45566806$var$He(a[c], b[c])) return !1;
    return !0;
}
function $e1ec086d45566806$var$Ch(a, b, c, d, e, f) {
    $e1ec086d45566806$var$xh = f;
    $e1ec086d45566806$var$R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $e1ec086d45566806$var$vh.current = null === a || null === a.memoizedState ? $e1ec086d45566806$var$Dh : $e1ec086d45566806$var$Eh;
    a = c(d, e);
    if ($e1ec086d45566806$var$zh) {
        f = 0;
        do {
            $e1ec086d45566806$var$zh = !1;
            if (!(25 > f)) throw Error($e1ec086d45566806$var$y(301));
            f += 1;
            $e1ec086d45566806$var$T = $e1ec086d45566806$var$S = null;
            b.updateQueue = null;
            $e1ec086d45566806$var$vh.current = $e1ec086d45566806$var$Fh;
            a = c(d, e);
        }while ($e1ec086d45566806$var$zh);
    }
    $e1ec086d45566806$var$vh.current = $e1ec086d45566806$var$Gh;
    b = null !== $e1ec086d45566806$var$S && null !== $e1ec086d45566806$var$S.next;
    $e1ec086d45566806$var$xh = 0;
    $e1ec086d45566806$var$T = $e1ec086d45566806$var$S = $e1ec086d45566806$var$R = null;
    $e1ec086d45566806$var$yh = !1;
    if (b) throw Error($e1ec086d45566806$var$y(300));
    return a;
}
function $e1ec086d45566806$var$Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e1ec086d45566806$var$T ? $e1ec086d45566806$var$R.memoizedState = $e1ec086d45566806$var$T = a : $e1ec086d45566806$var$T = $e1ec086d45566806$var$T.next = a;
    return $e1ec086d45566806$var$T;
}
function $e1ec086d45566806$var$Ih() {
    if (null === $e1ec086d45566806$var$S) {
        var a = $e1ec086d45566806$var$R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $e1ec086d45566806$var$S.next;
    var b = null === $e1ec086d45566806$var$T ? $e1ec086d45566806$var$R.memoizedState : $e1ec086d45566806$var$T.next;
    if (null !== b) $e1ec086d45566806$var$T = b, $e1ec086d45566806$var$S = a;
    else {
        if (null === a) throw Error($e1ec086d45566806$var$y(310));
        $e1ec086d45566806$var$S = a;
        a = {
            memoizedState: $e1ec086d45566806$var$S.memoizedState,
            baseState: $e1ec086d45566806$var$S.baseState,
            baseQueue: $e1ec086d45566806$var$S.baseQueue,
            queue: $e1ec086d45566806$var$S.queue,
            next: null
        };
        null === $e1ec086d45566806$var$T ? $e1ec086d45566806$var$R.memoizedState = $e1ec086d45566806$var$T = a : $e1ec086d45566806$var$T = $e1ec086d45566806$var$T.next = a;
    }
    return $e1ec086d45566806$var$T;
}
function $e1ec086d45566806$var$Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $e1ec086d45566806$var$Kh(a) {
    var b = $e1ec086d45566806$var$Ih(), c = b.queue;
    if (null === c) throw Error($e1ec086d45566806$var$y(311));
    c.lastRenderedReducer = a;
    var d = $e1ec086d45566806$var$S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if (($e1ec086d45566806$var$xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                $e1ec086d45566806$var$R.lanes |= l;
                $e1ec086d45566806$var$Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $e1ec086d45566806$var$He(d, b.memoizedState) || ($e1ec086d45566806$var$ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $e1ec086d45566806$var$Lh(a) {
    var b = $e1ec086d45566806$var$Ih(), c = b.queue;
    if (null === c) throw Error($e1ec086d45566806$var$y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e1ec086d45566806$var$He(f, b.memoizedState) || ($e1ec086d45566806$var$ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $e1ec086d45566806$var$Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = ($e1ec086d45566806$var$xh & a) === a) b._workInProgressVersionPrimary = d, $e1ec086d45566806$var$th.push(b);
    if (a) return c(b._source);
    $e1ec086d45566806$var$th.push(b);
    throw Error($e1ec086d45566806$var$y(350));
}
function $e1ec086d45566806$var$Nh(a, b, c, d) {
    var e = $e1ec086d45566806$var$U;
    if (null === e) throw Error($e1ec086d45566806$var$y(349));
    var f = b._getVersion, g = f(b._source), h = $e1ec086d45566806$var$vh.current, k = h.useState(function() {
        return $e1ec086d45566806$var$Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = $e1ec086d45566806$var$T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = $e1ec086d45566806$var$R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!$e1ec086d45566806$var$He(g, a)) {
            a = c(b._source);
            $e1ec086d45566806$var$He(n, a) || (l(a), a = $e1ec086d45566806$var$Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - $e1ec086d45566806$var$Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = $e1ec086d45566806$var$Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    $e1ec086d45566806$var$He(C, c) && $e1ec086d45566806$var$He(x, b) && $e1ec086d45566806$var$He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: $e1ec086d45566806$var$Jh,
        lastRenderedState: n
    }, a.dispatch = l = $e1ec086d45566806$var$Oh.bind(null, $e1ec086d45566806$var$R, a), k.queue = a, k.baseQueue = null, n = $e1ec086d45566806$var$Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function $e1ec086d45566806$var$Ph(a, b, c) {
    var d = $e1ec086d45566806$var$Ih();
    return $e1ec086d45566806$var$Nh(d, a, b, c);
}
function $e1ec086d45566806$var$Qh(a) {
    var b = $e1ec086d45566806$var$Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: $e1ec086d45566806$var$Jh,
        lastRenderedState: a
    };
    a = a.dispatch = $e1ec086d45566806$var$Oh.bind(null, $e1ec086d45566806$var$R, a);
    return [
        b.memoizedState,
        a
    ];
}
function $e1ec086d45566806$var$Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $e1ec086d45566806$var$R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, $e1ec086d45566806$var$R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $e1ec086d45566806$var$Sh(a) {
    var b = $e1ec086d45566806$var$Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function $e1ec086d45566806$var$Th() {
    return $e1ec086d45566806$var$Ih().memoizedState;
}
function $e1ec086d45566806$var$Uh(a, b, c, d) {
    var e = $e1ec086d45566806$var$Hh();
    $e1ec086d45566806$var$R.flags |= a;
    e.memoizedState = $e1ec086d45566806$var$Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function $e1ec086d45566806$var$Vh(a, b, c, d) {
    var e = $e1ec086d45566806$var$Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $e1ec086d45566806$var$S) {
        var g = $e1ec086d45566806$var$S.memoizedState;
        f = g.destroy;
        if (null !== d && $e1ec086d45566806$var$Bh(d, g.deps)) {
            $e1ec086d45566806$var$Rh(b, c, f, d);
            return;
        }
    }
    $e1ec086d45566806$var$R.flags |= a;
    e.memoizedState = $e1ec086d45566806$var$Rh(1 | b, c, f, d);
}
function $e1ec086d45566806$var$Wh(a, b) {
    return $e1ec086d45566806$var$Uh(516, 4, a, b);
}
function $e1ec086d45566806$var$Xh(a, b) {
    return $e1ec086d45566806$var$Vh(516, 4, a, b);
}
function $e1ec086d45566806$var$Yh(a, b) {
    return $e1ec086d45566806$var$Vh(4, 2, a, b);
}
function $e1ec086d45566806$var$Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $e1ec086d45566806$var$$h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $e1ec086d45566806$var$Vh(4, 2, $e1ec086d45566806$var$Zh.bind(null, b, a), c);
}
function $e1ec086d45566806$var$ai() {}
function $e1ec086d45566806$var$bi(a, b) {
    var c = $e1ec086d45566806$var$Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e1ec086d45566806$var$Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e1ec086d45566806$var$ci(a, b) {
    var c = $e1ec086d45566806$var$Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e1ec086d45566806$var$Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e1ec086d45566806$var$di(a, b) {
    var c = $e1ec086d45566806$var$eg();
    $e1ec086d45566806$var$gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    $e1ec086d45566806$var$gg(97 < c ? 97 : c, function() {
        var c = $e1ec086d45566806$var$wh.transition;
        $e1ec086d45566806$var$wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            $e1ec086d45566806$var$wh.transition = c;
        }
    });
}
function $e1ec086d45566806$var$Oh(a, b, c) {
    var d = $e1ec086d45566806$var$Hg(), e = $e1ec086d45566806$var$Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === $e1ec086d45566806$var$R || null !== g && g === $e1ec086d45566806$var$R) $e1ec086d45566806$var$zh = $e1ec086d45566806$var$yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if ($e1ec086d45566806$var$He(k, h)) return;
        } catch (l) {} finally{}
        $e1ec086d45566806$var$Jg(a, e, d);
    }
}
var $e1ec086d45566806$var$Gh = {
    readContext: $e1ec086d45566806$var$vg,
    useCallback: $e1ec086d45566806$var$Ah,
    useContext: $e1ec086d45566806$var$Ah,
    useEffect: $e1ec086d45566806$var$Ah,
    useImperativeHandle: $e1ec086d45566806$var$Ah,
    useLayoutEffect: $e1ec086d45566806$var$Ah,
    useMemo: $e1ec086d45566806$var$Ah,
    useReducer: $e1ec086d45566806$var$Ah,
    useRef: $e1ec086d45566806$var$Ah,
    useState: $e1ec086d45566806$var$Ah,
    useDebugValue: $e1ec086d45566806$var$Ah,
    useDeferredValue: $e1ec086d45566806$var$Ah,
    useTransition: $e1ec086d45566806$var$Ah,
    useMutableSource: $e1ec086d45566806$var$Ah,
    useOpaqueIdentifier: $e1ec086d45566806$var$Ah,
    unstable_isNewReconciler: !1
}, $e1ec086d45566806$var$Dh = {
    readContext: $e1ec086d45566806$var$vg,
    useCallback: function(a, b) {
        $e1ec086d45566806$var$Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $e1ec086d45566806$var$vg,
    useEffect: $e1ec086d45566806$var$Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $e1ec086d45566806$var$Uh(4, 2, $e1ec086d45566806$var$Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $e1ec086d45566806$var$Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $e1ec086d45566806$var$Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $e1ec086d45566806$var$Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = $e1ec086d45566806$var$Oh.bind(null, $e1ec086d45566806$var$R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: $e1ec086d45566806$var$Sh,
    useState: $e1ec086d45566806$var$Qh,
    useDebugValue: $e1ec086d45566806$var$ai,
    useDeferredValue: function(a) {
        var b = $e1ec086d45566806$var$Qh(a), c = b[0], d = b[1];
        $e1ec086d45566806$var$Wh(function() {
            var b = $e1ec086d45566806$var$wh.transition;
            $e1ec086d45566806$var$wh.transition = 1;
            try {
                d(a);
            } finally{
                $e1ec086d45566806$var$wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = $e1ec086d45566806$var$Qh(!1), b = a[0];
        a = $e1ec086d45566806$var$di.bind(null, a[1]);
        $e1ec086d45566806$var$Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = $e1ec086d45566806$var$Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return $e1ec086d45566806$var$Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if ($e1ec086d45566806$var$lh) {
            var a = !1, b = $e1ec086d45566806$var$uf(function() {
                a || (a = !0, c("r:" + ($e1ec086d45566806$var$tf++).toString(36)));
                throw Error($e1ec086d45566806$var$y(355));
            }), c = $e1ec086d45566806$var$Qh(b)[1];
            0 === ($e1ec086d45566806$var$R.mode & 2) && ($e1ec086d45566806$var$R.flags |= 516, $e1ec086d45566806$var$Rh(5, function() {
                c("r:" + ($e1ec086d45566806$var$tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + ($e1ec086d45566806$var$tf++).toString(36);
        $e1ec086d45566806$var$Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, $e1ec086d45566806$var$Eh = {
    readContext: $e1ec086d45566806$var$vg,
    useCallback: $e1ec086d45566806$var$bi,
    useContext: $e1ec086d45566806$var$vg,
    useEffect: $e1ec086d45566806$var$Xh,
    useImperativeHandle: $e1ec086d45566806$var$$h,
    useLayoutEffect: $e1ec086d45566806$var$Yh,
    useMemo: $e1ec086d45566806$var$ci,
    useReducer: $e1ec086d45566806$var$Kh,
    useRef: $e1ec086d45566806$var$Th,
    useState: function() {
        return $e1ec086d45566806$var$Kh($e1ec086d45566806$var$Jh);
    },
    useDebugValue: $e1ec086d45566806$var$ai,
    useDeferredValue: function(a) {
        var b = $e1ec086d45566806$var$Kh($e1ec086d45566806$var$Jh), c = b[0], d = b[1];
        $e1ec086d45566806$var$Xh(function() {
            var b = $e1ec086d45566806$var$wh.transition;
            $e1ec086d45566806$var$wh.transition = 1;
            try {
                d(a);
            } finally{
                $e1ec086d45566806$var$wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = $e1ec086d45566806$var$Kh($e1ec086d45566806$var$Jh)[0];
        return [
            $e1ec086d45566806$var$Th().current,
            a
        ];
    },
    useMutableSource: $e1ec086d45566806$var$Ph,
    useOpaqueIdentifier: function() {
        return $e1ec086d45566806$var$Kh($e1ec086d45566806$var$Jh)[0];
    },
    unstable_isNewReconciler: !1
}, $e1ec086d45566806$var$Fh = {
    readContext: $e1ec086d45566806$var$vg,
    useCallback: $e1ec086d45566806$var$bi,
    useContext: $e1ec086d45566806$var$vg,
    useEffect: $e1ec086d45566806$var$Xh,
    useImperativeHandle: $e1ec086d45566806$var$$h,
    useLayoutEffect: $e1ec086d45566806$var$Yh,
    useMemo: $e1ec086d45566806$var$ci,
    useReducer: $e1ec086d45566806$var$Lh,
    useRef: $e1ec086d45566806$var$Th,
    useState: function() {
        return $e1ec086d45566806$var$Lh($e1ec086d45566806$var$Jh);
    },
    useDebugValue: $e1ec086d45566806$var$ai,
    useDeferredValue: function(a) {
        var b = $e1ec086d45566806$var$Lh($e1ec086d45566806$var$Jh), c = b[0], d = b[1];
        $e1ec086d45566806$var$Xh(function() {
            var b = $e1ec086d45566806$var$wh.transition;
            $e1ec086d45566806$var$wh.transition = 1;
            try {
                d(a);
            } finally{
                $e1ec086d45566806$var$wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = $e1ec086d45566806$var$Lh($e1ec086d45566806$var$Jh)[0];
        return [
            $e1ec086d45566806$var$Th().current,
            a
        ];
    },
    useMutableSource: $e1ec086d45566806$var$Ph,
    useOpaqueIdentifier: function() {
        return $e1ec086d45566806$var$Lh($e1ec086d45566806$var$Jh)[0];
    },
    unstable_isNewReconciler: !1
}, $e1ec086d45566806$var$ei = $e1ec086d45566806$var$ra.ReactCurrentOwner, $e1ec086d45566806$var$ug = !1;
function $e1ec086d45566806$var$fi(a, b, c, d) {
    b.child = null === a ? $e1ec086d45566806$var$Zg(b, null, c, d) : $e1ec086d45566806$var$Yg(b, a.child, c, d);
}
function $e1ec086d45566806$var$gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $e1ec086d45566806$var$tg(b, e);
    d = $e1ec086d45566806$var$Ch(a, b, c, d, f, e);
    if (null !== a && !$e1ec086d45566806$var$ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, $e1ec086d45566806$var$hi(a, b, e);
    b.flags |= 1;
    $e1ec086d45566806$var$fi(a, b, d, e);
    return b.child;
}
function $e1ec086d45566806$var$ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !$e1ec086d45566806$var$ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, $e1ec086d45566806$var$ki(a, b, g, d, e, f);
        a = $e1ec086d45566806$var$Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : $e1ec086d45566806$var$Je, c(e, d) && a.ref === b.ref)) return $e1ec086d45566806$var$hi(a, b, f);
    b.flags |= 1;
    a = $e1ec086d45566806$var$Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $e1ec086d45566806$var$ki(a, b, c, d, e, f) {
    if (null !== a && $e1ec086d45566806$var$Je(a.memoizedProps, d) && a.ref === b.ref) {
        if ($e1ec086d45566806$var$ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && ($e1ec086d45566806$var$ug = !0);
        else return b.lanes = a.lanes, $e1ec086d45566806$var$hi(a, b, f);
    }
    return $e1ec086d45566806$var$li(a, b, c, d, f);
}
function $e1ec086d45566806$var$mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, $e1ec086d45566806$var$ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, $e1ec086d45566806$var$ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, $e1ec086d45566806$var$ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $e1ec086d45566806$var$ni(b, d);
    $e1ec086d45566806$var$fi(a, b, e, c);
    return b.child;
}
function $e1ec086d45566806$var$oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function $e1ec086d45566806$var$li(a, b, c, d, e) {
    var f = $e1ec086d45566806$var$Ff(c) ? $e1ec086d45566806$var$Df : $e1ec086d45566806$var$M.current;
    f = $e1ec086d45566806$var$Ef(b, f);
    $e1ec086d45566806$var$tg(b, e);
    c = $e1ec086d45566806$var$Ch(a, b, c, d, f, e);
    if (null !== a && !$e1ec086d45566806$var$ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, $e1ec086d45566806$var$hi(a, b, e);
    b.flags |= 1;
    $e1ec086d45566806$var$fi(a, b, c, e);
    return b.child;
}
function $e1ec086d45566806$var$pi(a, b, c, d, e) {
    if ($e1ec086d45566806$var$Ff(c)) {
        var f = !0;
        $e1ec086d45566806$var$Jf(b);
    } else f = !1;
    $e1ec086d45566806$var$tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), $e1ec086d45566806$var$Mg(b, c, d), $e1ec086d45566806$var$Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $e1ec086d45566806$var$vg(l) : (l = $e1ec086d45566806$var$Ff(c) ? $e1ec086d45566806$var$Df : $e1ec086d45566806$var$M.current, l = $e1ec086d45566806$var$Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $e1ec086d45566806$var$Ng(b, g, d, l);
        $e1ec086d45566806$var$wg = !1;
        var p = b.memoizedState;
        g.state = p;
        $e1ec086d45566806$var$Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || $e1ec086d45566806$var$N.current || $e1ec086d45566806$var$wg ? ("function" === typeof n && ($e1ec086d45566806$var$Gg(b, c, n, d), k = b.memoizedState), (h = $e1ec086d45566806$var$wg || $e1ec086d45566806$var$Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        $e1ec086d45566806$var$yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $e1ec086d45566806$var$lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $e1ec086d45566806$var$vg(k) : (k = $e1ec086d45566806$var$Ff(c) ? $e1ec086d45566806$var$Df : $e1ec086d45566806$var$M.current, k = $e1ec086d45566806$var$Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && $e1ec086d45566806$var$Ng(b, g, d, k);
        $e1ec086d45566806$var$wg = !1;
        p = b.memoizedState;
        g.state = p;
        $e1ec086d45566806$var$Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || $e1ec086d45566806$var$N.current || $e1ec086d45566806$var$wg ? ("function" === typeof C && ($e1ec086d45566806$var$Gg(b, c, C, d), x = b.memoizedState), (l = $e1ec086d45566806$var$wg || $e1ec086d45566806$var$Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return $e1ec086d45566806$var$qi(a, b, c, d, f, e);
}
function $e1ec086d45566806$var$qi(a, b, c, d, e, f) {
    $e1ec086d45566806$var$oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && $e1ec086d45566806$var$Kf(b, c, !1), $e1ec086d45566806$var$hi(a, b, f);
    d = b.stateNode;
    $e1ec086d45566806$var$ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $e1ec086d45566806$var$Yg(b, a.child, null, f), b.child = $e1ec086d45566806$var$Yg(b, null, h, f)) : $e1ec086d45566806$var$fi(a, b, h, f);
    b.memoizedState = d.state;
    e && $e1ec086d45566806$var$Kf(b, c, !0);
    return b.child;
}
function $e1ec086d45566806$var$ri(a) {
    var b = a.stateNode;
    b.pendingContext ? $e1ec086d45566806$var$Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $e1ec086d45566806$var$Hf(a, b.context, !1);
    $e1ec086d45566806$var$eh(a, b.containerInfo);
}
var $e1ec086d45566806$var$si = {
    dehydrated: null,
    retryLane: 0
};
function $e1ec086d45566806$var$ti(a, b, c) {
    var d = b.pendingProps, e = $e1ec086d45566806$var$P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    $e1ec086d45566806$var$I($e1ec086d45566806$var$P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && $e1ec086d45566806$var$ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = $e1ec086d45566806$var$ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = $e1ec086d45566806$var$si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = $e1ec086d45566806$var$ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = $e1ec086d45566806$var$si, b.lanes = 33554432, a;
        c = $e1ec086d45566806$var$vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = $e1ec086d45566806$var$wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = $e1ec086d45566806$var$si, d;
        c = $e1ec086d45566806$var$xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = $e1ec086d45566806$var$wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = $e1ec086d45566806$var$si, d;
    c = $e1ec086d45566806$var$xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function $e1ec086d45566806$var$ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = $e1ec086d45566806$var$vi(b, e, 0, null);
    c = $e1ec086d45566806$var$Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function $e1ec086d45566806$var$xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = $e1ec086d45566806$var$Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function $e1ec086d45566806$var$wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = $e1ec086d45566806$var$Tg(g, h);
    null !== a ? d = $e1ec086d45566806$var$Tg(a, d) : (d = $e1ec086d45566806$var$Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function $e1ec086d45566806$var$yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    $e1ec086d45566806$var$sg(a.return, b);
}
function $e1ec086d45566806$var$zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function $e1ec086d45566806$var$Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $e1ec086d45566806$var$fi(a, b, d.children, c);
    d = $e1ec086d45566806$var$P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $e1ec086d45566806$var$yi(a, c);
            else if (19 === a.tag) $e1ec086d45566806$var$yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $e1ec086d45566806$var$I($e1ec086d45566806$var$P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $e1ec086d45566806$var$ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $e1ec086d45566806$var$zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $e1ec086d45566806$var$ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $e1ec086d45566806$var$zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            $e1ec086d45566806$var$zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $e1ec086d45566806$var$hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $e1ec086d45566806$var$Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error($e1ec086d45566806$var$y(153));
        if (null !== b.child) {
            a = b.child;
            c = $e1ec086d45566806$var$Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $e1ec086d45566806$var$Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var $e1ec086d45566806$var$Bi, $e1ec086d45566806$var$Ci, $e1ec086d45566806$var$Di, $e1ec086d45566806$var$Ei;
$e1ec086d45566806$var$Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$e1ec086d45566806$var$Ci = function() {};
$e1ec086d45566806$var$Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $e1ec086d45566806$var$dh($e1ec086d45566806$var$ah.current);
        var f = null;
        switch(c){
            case "input":
                e = $e1ec086d45566806$var$Ya(a, e);
                d = $e1ec086d45566806$var$Ya(a, d);
                f = [];
                break;
            case "option":
                e = $e1ec086d45566806$var$eb(a, e);
                d = $e1ec086d45566806$var$eb(a, d);
                f = [];
                break;
            case "select":
                e = $bDppX({}, e, {
                    value: void 0
                });
                d = $bDppX({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $e1ec086d45566806$var$gb(a, e);
                d = $e1ec086d45566806$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $e1ec086d45566806$var$jf);
        }
        $e1ec086d45566806$var$vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($e1ec086d45566806$var$ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($e1ec086d45566806$var$ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && $e1ec086d45566806$var$G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === $e1ec086d45566806$var$Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$e1ec086d45566806$var$Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $e1ec086d45566806$var$Fi(a, b) {
    if (!$e1ec086d45566806$var$lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $e1ec086d45566806$var$Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return $e1ec086d45566806$var$Ff(b.type) && $e1ec086d45566806$var$Gf(), null;
        case 3:
            $e1ec086d45566806$var$fh();
            $e1ec086d45566806$var$H($e1ec086d45566806$var$N);
            $e1ec086d45566806$var$H($e1ec086d45566806$var$M);
            $e1ec086d45566806$var$uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $e1ec086d45566806$var$rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            $e1ec086d45566806$var$Ci(b);
            return null;
        case 5:
            $e1ec086d45566806$var$hh(b);
            var e = $e1ec086d45566806$var$dh($e1ec086d45566806$var$ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $e1ec086d45566806$var$Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($e1ec086d45566806$var$y(166));
                    return null;
                }
                a = $e1ec086d45566806$var$dh($e1ec086d45566806$var$ah.current);
                if ($e1ec086d45566806$var$rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$e1ec086d45566806$var$wf] = b;
                    d[$e1ec086d45566806$var$xf] = f;
                    switch(c){
                        case "dialog":
                            $e1ec086d45566806$var$G("cancel", d);
                            $e1ec086d45566806$var$G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $e1ec086d45566806$var$G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < $e1ec086d45566806$var$Xe.length; a++)$e1ec086d45566806$var$G($e1ec086d45566806$var$Xe[a], d);
                            break;
                        case "source":
                            $e1ec086d45566806$var$G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $e1ec086d45566806$var$G("error", d);
                            $e1ec086d45566806$var$G("load", d);
                            break;
                        case "details":
                            $e1ec086d45566806$var$G("toggle", d);
                            break;
                        case "input":
                            $e1ec086d45566806$var$Za(d, f);
                            $e1ec086d45566806$var$G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $e1ec086d45566806$var$G("invalid", d);
                            break;
                        case "textarea":
                            $e1ec086d45566806$var$hb(d, f), $e1ec086d45566806$var$G("invalid", d);
                    }
                    $e1ec086d45566806$var$vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : $e1ec086d45566806$var$ca.hasOwnProperty(g) && null != e && "onScroll" === g && $e1ec086d45566806$var$G("scroll", d));
                    switch(c){
                        case "input":
                            $e1ec086d45566806$var$Va(d);
                            $e1ec086d45566806$var$cb(d, f, !0);
                            break;
                        case "textarea":
                            $e1ec086d45566806$var$Va(d);
                            $e1ec086d45566806$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $e1ec086d45566806$var$jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === $e1ec086d45566806$var$kb.html && (a = $e1ec086d45566806$var$lb(c));
                    a === $e1ec086d45566806$var$kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$e1ec086d45566806$var$wf] = b;
                    a[$e1ec086d45566806$var$xf] = d;
                    $e1ec086d45566806$var$Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = $e1ec086d45566806$var$wb(c, d);
                    switch(c){
                        case "dialog":
                            $e1ec086d45566806$var$G("cancel", a);
                            $e1ec086d45566806$var$G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $e1ec086d45566806$var$G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $e1ec086d45566806$var$Xe.length; e++)$e1ec086d45566806$var$G($e1ec086d45566806$var$Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            $e1ec086d45566806$var$G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $e1ec086d45566806$var$G("error", a);
                            $e1ec086d45566806$var$G("load", a);
                            e = d;
                            break;
                        case "details":
                            $e1ec086d45566806$var$G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            $e1ec086d45566806$var$Za(a, d);
                            e = $e1ec086d45566806$var$Ya(a, d);
                            $e1ec086d45566806$var$G("invalid", a);
                            break;
                        case "option":
                            e = $e1ec086d45566806$var$eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $bDppX({}, d, {
                                value: void 0
                            });
                            $e1ec086d45566806$var$G("invalid", a);
                            break;
                        case "textarea":
                            $e1ec086d45566806$var$hb(a, d);
                            e = $e1ec086d45566806$var$gb(a, d);
                            $e1ec086d45566806$var$G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    $e1ec086d45566806$var$vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? $e1ec086d45566806$var$tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $e1ec086d45566806$var$ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $e1ec086d45566806$var$pb(a, k) : "number" === typeof k && $e1ec086d45566806$var$pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($e1ec086d45566806$var$ca.hasOwnProperty(f) ? null != k && "onScroll" === f && $e1ec086d45566806$var$G("scroll", a) : null != k && $e1ec086d45566806$var$qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            $e1ec086d45566806$var$Va(a);
                            $e1ec086d45566806$var$cb(a, d, !1);
                            break;
                        case "textarea":
                            $e1ec086d45566806$var$Va(a);
                            $e1ec086d45566806$var$jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + $e1ec086d45566806$var$Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? $e1ec086d45566806$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $e1ec086d45566806$var$fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = $e1ec086d45566806$var$jf);
                    }
                    $e1ec086d45566806$var$mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) $e1ec086d45566806$var$Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($e1ec086d45566806$var$y(166));
                c = $e1ec086d45566806$var$dh($e1ec086d45566806$var$ch.current);
                $e1ec086d45566806$var$dh($e1ec086d45566806$var$ah.current);
                $e1ec086d45566806$var$rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[$e1ec086d45566806$var$wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$e1ec086d45566806$var$wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            $e1ec086d45566806$var$H($e1ec086d45566806$var$P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && $e1ec086d45566806$var$rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== ($e1ec086d45566806$var$P.current & 1)) 0 === $e1ec086d45566806$var$V && ($e1ec086d45566806$var$V = 3);
                else {
                    if (0 === $e1ec086d45566806$var$V || 3 === $e1ec086d45566806$var$V) $e1ec086d45566806$var$V = 4;
                    null === $e1ec086d45566806$var$U || 0 === ($e1ec086d45566806$var$Dg & 134217727) && 0 === ($e1ec086d45566806$var$Hi & 134217727) || $e1ec086d45566806$var$Ii($e1ec086d45566806$var$U, $e1ec086d45566806$var$W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return $e1ec086d45566806$var$fh(), $e1ec086d45566806$var$Ci(b), null === a && $e1ec086d45566806$var$cf(b.stateNode.containerInfo), null;
        case 10:
            return $e1ec086d45566806$var$rg(b), null;
        case 17:
            return $e1ec086d45566806$var$Ff(b.type) && $e1ec086d45566806$var$Gf(), null;
        case 19:
            $e1ec086d45566806$var$H($e1ec086d45566806$var$P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) $e1ec086d45566806$var$Fi(d, !1);
                else {
                    if (0 !== $e1ec086d45566806$var$V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = $e1ec086d45566806$var$ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            $e1ec086d45566806$var$Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $e1ec086d45566806$var$I($e1ec086d45566806$var$P, $e1ec086d45566806$var$P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && $e1ec086d45566806$var$O() > $e1ec086d45566806$var$Ji && (b.flags |= 64, f = !0, $e1ec086d45566806$var$Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = $e1ec086d45566806$var$ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $e1ec086d45566806$var$Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !$e1ec086d45566806$var$lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $e1ec086d45566806$var$O() - d.renderingStartTime > $e1ec086d45566806$var$Ji && 1073741824 !== c && (b.flags |= 64, f = !0, $e1ec086d45566806$var$Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $e1ec086d45566806$var$O(), c.sibling = null, b = $e1ec086d45566806$var$P.current, $e1ec086d45566806$var$I($e1ec086d45566806$var$P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return $e1ec086d45566806$var$Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error($e1ec086d45566806$var$y(156, b.tag));
}
function $e1ec086d45566806$var$Li(a) {
    switch(a.tag){
        case 1:
            $e1ec086d45566806$var$Ff(a.type) && $e1ec086d45566806$var$Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            $e1ec086d45566806$var$fh();
            $e1ec086d45566806$var$H($e1ec086d45566806$var$N);
            $e1ec086d45566806$var$H($e1ec086d45566806$var$M);
            $e1ec086d45566806$var$uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error($e1ec086d45566806$var$y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return $e1ec086d45566806$var$hh(a), null;
        case 13:
            return $e1ec086d45566806$var$H($e1ec086d45566806$var$P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return $e1ec086d45566806$var$H($e1ec086d45566806$var$P), null;
        case 4:
            return $e1ec086d45566806$var$fh(), null;
        case 10:
            return $e1ec086d45566806$var$rg(a), null;
        case 23:
        case 24:
            return $e1ec086d45566806$var$Ki(), null;
        default:
            return null;
    }
}
function $e1ec086d45566806$var$Mi(a, b) {
    try {
        var c = "", d = b;
        do c += $e1ec086d45566806$var$Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function $e1ec086d45566806$var$Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $e1ec086d45566806$var$Oi = "function" === typeof WeakMap ? WeakMap : Map;
function $e1ec086d45566806$var$Pi(a, b, c) {
    c = $e1ec086d45566806$var$zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $e1ec086d45566806$var$Qi || ($e1ec086d45566806$var$Qi = !0, $e1ec086d45566806$var$Ri = d);
        $e1ec086d45566806$var$Ni(a, b);
    };
    return c;
}
function $e1ec086d45566806$var$Si(a, b, c) {
    c = $e1ec086d45566806$var$zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            $e1ec086d45566806$var$Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === $e1ec086d45566806$var$Ti ? $e1ec086d45566806$var$Ti = new Set([
            this
        ]) : $e1ec086d45566806$var$Ti.add(this), $e1ec086d45566806$var$Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var $e1ec086d45566806$var$Ui = "function" === typeof WeakSet ? WeakSet : Set;
function $e1ec086d45566806$var$Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            $e1ec086d45566806$var$Wi(a, c);
        }
        else b.current = null;
    }
}
function $e1ec086d45566806$var$Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : $e1ec086d45566806$var$lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && $e1ec086d45566806$var$qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error($e1ec086d45566806$var$y(163));
}
function $e1ec086d45566806$var$Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && ($e1ec086d45566806$var$Zi(c, a), $e1ec086d45566806$var$$i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : $e1ec086d45566806$var$lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && $e1ec086d45566806$var$Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                $e1ec086d45566806$var$Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && $e1ec086d45566806$var$mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && $e1ec086d45566806$var$Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error($e1ec086d45566806$var$y(163));
}
function $e1ec086d45566806$var$aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = $e1ec086d45566806$var$sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function $e1ec086d45566806$var$bj(a, b) {
    if ($e1ec086d45566806$var$Mf && "function" === typeof $e1ec086d45566806$var$Mf.onCommitFiberUnmount) try {
        $e1ec086d45566806$var$Mf.onCommitFiberUnmount($e1ec086d45566806$var$Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) $e1ec086d45566806$var$Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                $e1ec086d45566806$var$Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            $e1ec086d45566806$var$Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                $e1ec086d45566806$var$Wi(b, f);
            }
            break;
        case 5:
            $e1ec086d45566806$var$Vi(b);
            break;
        case 4:
            $e1ec086d45566806$var$cj(a, b);
    }
}
function $e1ec086d45566806$var$dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function $e1ec086d45566806$var$ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $e1ec086d45566806$var$fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if ($e1ec086d45566806$var$ej(b)) break a;
            b = b.return;
        }
        throw Error($e1ec086d45566806$var$y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error($e1ec086d45566806$var$y(161));
    }
    c.flags & 16 && ($e1ec086d45566806$var$pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || $e1ec086d45566806$var$ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? $e1ec086d45566806$var$gj(a, c, b) : $e1ec086d45566806$var$hj(a, c, b);
}
function $e1ec086d45566806$var$gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $e1ec086d45566806$var$jf));
    else if (4 !== d && (a = a.child, null !== a)) for($e1ec086d45566806$var$gj(a, b, c), a = a.sibling; null !== a;)$e1ec086d45566806$var$gj(a, b, c), a = a.sibling;
}
function $e1ec086d45566806$var$hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($e1ec086d45566806$var$hj(a, b, c), a = a.sibling; null !== a;)$e1ec086d45566806$var$hj(a, b, c), a = a.sibling;
}
function $e1ec086d45566806$var$cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error($e1ec086d45566806$var$y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if ($e1ec086d45566806$var$bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if ($e1ec086d45566806$var$bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function $e1ec086d45566806$var$ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[$e1ec086d45566806$var$xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $e1ec086d45566806$var$$a(c, d);
                    $e1ec086d45566806$var$wb(a, e);
                    b = $e1ec086d45566806$var$wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? $e1ec086d45566806$var$tb(c, h) : "dangerouslySetInnerHTML" === g ? $e1ec086d45566806$var$ob(c, h) : "children" === g ? $e1ec086d45566806$var$pb(c, h) : $e1ec086d45566806$var$qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            $e1ec086d45566806$var$ab(c, d);
                            break;
                        case "textarea":
                            $e1ec086d45566806$var$ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? $e1ec086d45566806$var$fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? $e1ec086d45566806$var$fb(c, !!d.multiple, d.defaultValue, !0) : $e1ec086d45566806$var$fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error($e1ec086d45566806$var$y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, $e1ec086d45566806$var$Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && ($e1ec086d45566806$var$jj = $e1ec086d45566806$var$O(), $e1ec086d45566806$var$aj(b.child, !0));
            $e1ec086d45566806$var$kj(b);
            return;
        case 19:
            $e1ec086d45566806$var$kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            $e1ec086d45566806$var$aj(b, null !== b.memoizedState);
            return;
    }
    throw Error($e1ec086d45566806$var$y(163));
}
function $e1ec086d45566806$var$kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $e1ec086d45566806$var$Ui);
        b.forEach(function(b) {
            var d = $e1ec086d45566806$var$lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $e1ec086d45566806$var$mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var $e1ec086d45566806$var$nj = Math.ceil, $e1ec086d45566806$var$oj = $e1ec086d45566806$var$ra.ReactCurrentDispatcher, $e1ec086d45566806$var$pj = $e1ec086d45566806$var$ra.ReactCurrentOwner, $e1ec086d45566806$var$X = 0, $e1ec086d45566806$var$U = null, $e1ec086d45566806$var$Y = null, $e1ec086d45566806$var$W = 0, $e1ec086d45566806$var$qj = 0, $e1ec086d45566806$var$rj = $e1ec086d45566806$var$Bf(0), $e1ec086d45566806$var$V = 0, $e1ec086d45566806$var$sj = null, $e1ec086d45566806$var$tj = 0, $e1ec086d45566806$var$Dg = 0, $e1ec086d45566806$var$Hi = 0, $e1ec086d45566806$var$uj = 0, $e1ec086d45566806$var$vj = null, $e1ec086d45566806$var$jj = 0, $e1ec086d45566806$var$Ji = Infinity;
function $e1ec086d45566806$var$wj() {
    $e1ec086d45566806$var$Ji = $e1ec086d45566806$var$O() + 500;
}
var $e1ec086d45566806$var$Z = null, $e1ec086d45566806$var$Qi = !1, $e1ec086d45566806$var$Ri = null, $e1ec086d45566806$var$Ti = null, $e1ec086d45566806$var$xj = !1, $e1ec086d45566806$var$yj = null, $e1ec086d45566806$var$zj = 90, $e1ec086d45566806$var$Aj = [], $e1ec086d45566806$var$Bj = [], $e1ec086d45566806$var$Cj = null, $e1ec086d45566806$var$Dj = 0, $e1ec086d45566806$var$Ej = null, $e1ec086d45566806$var$Fj = -1, $e1ec086d45566806$var$Gj = 0, $e1ec086d45566806$var$Hj = 0, $e1ec086d45566806$var$Ij = null, $e1ec086d45566806$var$Jj = !1;
function $e1ec086d45566806$var$Hg() {
    return 0 !== ($e1ec086d45566806$var$X & 48) ? $e1ec086d45566806$var$O() : -1 !== $e1ec086d45566806$var$Fj ? $e1ec086d45566806$var$Fj : $e1ec086d45566806$var$Fj = $e1ec086d45566806$var$O();
}
function $e1ec086d45566806$var$Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === $e1ec086d45566806$var$eg() ? 1 : 2;
    0 === $e1ec086d45566806$var$Gj && ($e1ec086d45566806$var$Gj = $e1ec086d45566806$var$tj);
    if (0 !== $e1ec086d45566806$var$kg.transition) {
        0 !== $e1ec086d45566806$var$Hj && ($e1ec086d45566806$var$Hj = null !== $e1ec086d45566806$var$vj ? $e1ec086d45566806$var$vj.pendingLanes : 0);
        a = $e1ec086d45566806$var$Gj;
        var b = 4186112 & ~$e1ec086d45566806$var$Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = $e1ec086d45566806$var$eg();
    0 !== ($e1ec086d45566806$var$X & 4) && 98 === a ? a = $e1ec086d45566806$var$Xc(12, $e1ec086d45566806$var$Gj) : (a = $e1ec086d45566806$var$Sc(a), a = $e1ec086d45566806$var$Xc(a, $e1ec086d45566806$var$Gj));
    return a;
}
function $e1ec086d45566806$var$Jg(a, b, c) {
    if (50 < $e1ec086d45566806$var$Dj) throw $e1ec086d45566806$var$Dj = 0, $e1ec086d45566806$var$Ej = null, Error($e1ec086d45566806$var$y(185));
    a = $e1ec086d45566806$var$Kj(a, b);
    if (null === a) return null;
    $e1ec086d45566806$var$$c(a, b, c);
    a === $e1ec086d45566806$var$U && ($e1ec086d45566806$var$Hi |= b, 4 === $e1ec086d45566806$var$V && $e1ec086d45566806$var$Ii(a, $e1ec086d45566806$var$W));
    var d = $e1ec086d45566806$var$eg();
    1 === b ? 0 !== ($e1ec086d45566806$var$X & 8) && 0 === ($e1ec086d45566806$var$X & 48) ? $e1ec086d45566806$var$Lj(a) : ($e1ec086d45566806$var$Mj(a, c), 0 === $e1ec086d45566806$var$X && ($e1ec086d45566806$var$wj(), $e1ec086d45566806$var$ig())) : (0 === ($e1ec086d45566806$var$X & 4) || 98 !== d && 99 !== d || (null === $e1ec086d45566806$var$Cj ? $e1ec086d45566806$var$Cj = new Set([
        a
    ]) : $e1ec086d45566806$var$Cj.add(a)), $e1ec086d45566806$var$Mj(a, c));
    $e1ec086d45566806$var$vj = a;
}
function $e1ec086d45566806$var$Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function $e1ec086d45566806$var$Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - $e1ec086d45566806$var$Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                $e1ec086d45566806$var$Rc(k);
                var n = $e1ec086d45566806$var$F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = $e1ec086d45566806$var$Uc(a, a === $e1ec086d45566806$var$U ? $e1ec086d45566806$var$W : 0);
    b = $e1ec086d45566806$var$F;
    if (0 === d) null !== c && (c !== $e1ec086d45566806$var$Zf && $e1ec086d45566806$var$Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== $e1ec086d45566806$var$Zf && $e1ec086d45566806$var$Pf(c);
        }
        15 === b ? (c = $e1ec086d45566806$var$Lj.bind(null, a), null === $e1ec086d45566806$var$ag ? ($e1ec086d45566806$var$ag = [
            c
        ], $e1ec086d45566806$var$bg = $e1ec086d45566806$var$Of($e1ec086d45566806$var$Uf, $e1ec086d45566806$var$jg)) : $e1ec086d45566806$var$ag.push(c), c = $e1ec086d45566806$var$Zf) : 14 === b ? c = $e1ec086d45566806$var$hg(99, $e1ec086d45566806$var$Lj.bind(null, a)) : (c = $e1ec086d45566806$var$Tc(b), c = $e1ec086d45566806$var$hg(c, $e1ec086d45566806$var$Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $e1ec086d45566806$var$Nj(a) {
    $e1ec086d45566806$var$Fj = -1;
    $e1ec086d45566806$var$Hj = $e1ec086d45566806$var$Gj = 0;
    if (0 !== ($e1ec086d45566806$var$X & 48)) throw Error($e1ec086d45566806$var$y(327));
    var b = a.callbackNode;
    if ($e1ec086d45566806$var$Oj() && a.callbackNode !== b) return null;
    var c = $e1ec086d45566806$var$Uc(a, a === $e1ec086d45566806$var$U ? $e1ec086d45566806$var$W : 0);
    if (0 === c) return null;
    var d = c;
    var e = $e1ec086d45566806$var$X;
    $e1ec086d45566806$var$X |= 16;
    var f = $e1ec086d45566806$var$Pj();
    if ($e1ec086d45566806$var$U !== a || $e1ec086d45566806$var$W !== d) $e1ec086d45566806$var$wj(), $e1ec086d45566806$var$Qj(a, d);
    for(;;)try {
        $e1ec086d45566806$var$Rj();
        break;
    } catch (h) {
        $e1ec086d45566806$var$Sj(a, h);
    }
    $e1ec086d45566806$var$qg();
    $e1ec086d45566806$var$oj.current = f;
    $e1ec086d45566806$var$X = e;
    null !== $e1ec086d45566806$var$Y ? d = 0 : ($e1ec086d45566806$var$U = null, $e1ec086d45566806$var$W = 0, d = $e1ec086d45566806$var$V);
    if (0 !== ($e1ec086d45566806$var$tj & $e1ec086d45566806$var$Hi)) $e1ec086d45566806$var$Qj(a, 0);
    else if (0 !== d) {
        2 === d && ($e1ec086d45566806$var$X |= 64, a.hydrate && (a.hydrate = !1, $e1ec086d45566806$var$qf(a.containerInfo)), c = $e1ec086d45566806$var$Wc(a), 0 !== c && (d = $e1ec086d45566806$var$Tj(a, c)));
        if (1 === d) throw b = $e1ec086d45566806$var$sj, $e1ec086d45566806$var$Qj(a, 0), $e1ec086d45566806$var$Ii(a, c), $e1ec086d45566806$var$Mj(a, $e1ec086d45566806$var$O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error($e1ec086d45566806$var$y(345));
            case 2:
                $e1ec086d45566806$var$Uj(a);
                break;
            case 3:
                $e1ec086d45566806$var$Ii(a, c);
                if ((c & 62914560) === c && (d = $e1ec086d45566806$var$jj + 500 - $e1ec086d45566806$var$O(), 10 < d)) {
                    if (0 !== $e1ec086d45566806$var$Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        $e1ec086d45566806$var$Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = $e1ec086d45566806$var$of($e1ec086d45566806$var$Uj.bind(null, a), d);
                    break;
                }
                $e1ec086d45566806$var$Uj(a);
                break;
            case 4:
                $e1ec086d45566806$var$Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - $e1ec086d45566806$var$Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = $e1ec086d45566806$var$O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * $e1ec086d45566806$var$nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = $e1ec086d45566806$var$of($e1ec086d45566806$var$Uj.bind(null, a), c);
                    break;
                }
                $e1ec086d45566806$var$Uj(a);
                break;
            case 5:
                $e1ec086d45566806$var$Uj(a);
                break;
            default:
                throw Error($e1ec086d45566806$var$y(329));
        }
    }
    $e1ec086d45566806$var$Mj(a, $e1ec086d45566806$var$O());
    return a.callbackNode === b ? $e1ec086d45566806$var$Nj.bind(null, a) : null;
}
function $e1ec086d45566806$var$Ii(a, b) {
    b &= ~$e1ec086d45566806$var$uj;
    b &= ~$e1ec086d45566806$var$Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $e1ec086d45566806$var$Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $e1ec086d45566806$var$Lj(a) {
    if (0 !== ($e1ec086d45566806$var$X & 48)) throw Error($e1ec086d45566806$var$y(327));
    $e1ec086d45566806$var$Oj();
    if (a === $e1ec086d45566806$var$U && 0 !== (a.expiredLanes & $e1ec086d45566806$var$W)) {
        var b = $e1ec086d45566806$var$W;
        var c = $e1ec086d45566806$var$Tj(a, b);
        0 !== ($e1ec086d45566806$var$tj & $e1ec086d45566806$var$Hi) && (b = $e1ec086d45566806$var$Uc(a, b), c = $e1ec086d45566806$var$Tj(a, b));
    } else b = $e1ec086d45566806$var$Uc(a, 0), c = $e1ec086d45566806$var$Tj(a, b);
    0 !== a.tag && 2 === c && ($e1ec086d45566806$var$X |= 64, a.hydrate && (a.hydrate = !1, $e1ec086d45566806$var$qf(a.containerInfo)), b = $e1ec086d45566806$var$Wc(a), 0 !== b && (c = $e1ec086d45566806$var$Tj(a, b)));
    if (1 === c) throw c = $e1ec086d45566806$var$sj, $e1ec086d45566806$var$Qj(a, 0), $e1ec086d45566806$var$Ii(a, b), $e1ec086d45566806$var$Mj(a, $e1ec086d45566806$var$O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $e1ec086d45566806$var$Uj(a);
    $e1ec086d45566806$var$Mj(a, $e1ec086d45566806$var$O());
    return null;
}
function $e1ec086d45566806$var$Vj() {
    if (null !== $e1ec086d45566806$var$Cj) {
        var a = $e1ec086d45566806$var$Cj;
        $e1ec086d45566806$var$Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            $e1ec086d45566806$var$Mj(a, $e1ec086d45566806$var$O());
        });
    }
    $e1ec086d45566806$var$ig();
}
function $e1ec086d45566806$var$Wj(a, b) {
    var c = $e1ec086d45566806$var$X;
    $e1ec086d45566806$var$X |= 1;
    try {
        return a(b);
    } finally{
        $e1ec086d45566806$var$X = c, 0 === $e1ec086d45566806$var$X && ($e1ec086d45566806$var$wj(), $e1ec086d45566806$var$ig());
    }
}
function $e1ec086d45566806$var$Xj(a, b) {
    var c = $e1ec086d45566806$var$X;
    $e1ec086d45566806$var$X &= -2;
    $e1ec086d45566806$var$X |= 8;
    try {
        return a(b);
    } finally{
        $e1ec086d45566806$var$X = c, 0 === $e1ec086d45566806$var$X && ($e1ec086d45566806$var$wj(), $e1ec086d45566806$var$ig());
    }
}
function $e1ec086d45566806$var$ni(a, b) {
    $e1ec086d45566806$var$I($e1ec086d45566806$var$rj, $e1ec086d45566806$var$qj);
    $e1ec086d45566806$var$qj |= b;
    $e1ec086d45566806$var$tj |= b;
}
function $e1ec086d45566806$var$Ki() {
    $e1ec086d45566806$var$qj = $e1ec086d45566806$var$rj.current;
    $e1ec086d45566806$var$H($e1ec086d45566806$var$rj);
}
function $e1ec086d45566806$var$Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $e1ec086d45566806$var$pf(c));
    if (null !== $e1ec086d45566806$var$Y) for(c = $e1ec086d45566806$var$Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $e1ec086d45566806$var$Gf();
                break;
            case 3:
                $e1ec086d45566806$var$fh();
                $e1ec086d45566806$var$H($e1ec086d45566806$var$N);
                $e1ec086d45566806$var$H($e1ec086d45566806$var$M);
                $e1ec086d45566806$var$uh();
                break;
            case 5:
                $e1ec086d45566806$var$hh(d);
                break;
            case 4:
                $e1ec086d45566806$var$fh();
                break;
            case 13:
                $e1ec086d45566806$var$H($e1ec086d45566806$var$P);
                break;
            case 19:
                $e1ec086d45566806$var$H($e1ec086d45566806$var$P);
                break;
            case 10:
                $e1ec086d45566806$var$rg(d);
                break;
            case 23:
            case 24:
                $e1ec086d45566806$var$Ki();
        }
        c = c.return;
    }
    $e1ec086d45566806$var$U = a;
    $e1ec086d45566806$var$Y = $e1ec086d45566806$var$Tg(a.current, null);
    $e1ec086d45566806$var$W = $e1ec086d45566806$var$qj = $e1ec086d45566806$var$tj = b;
    $e1ec086d45566806$var$V = 0;
    $e1ec086d45566806$var$sj = null;
    $e1ec086d45566806$var$uj = $e1ec086d45566806$var$Hi = $e1ec086d45566806$var$Dg = 0;
}
function $e1ec086d45566806$var$Sj(a, b) {
    do {
        var c = $e1ec086d45566806$var$Y;
        try {
            $e1ec086d45566806$var$qg();
            $e1ec086d45566806$var$vh.current = $e1ec086d45566806$var$Gh;
            if ($e1ec086d45566806$var$yh) {
                for(var d = $e1ec086d45566806$var$R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $e1ec086d45566806$var$yh = !1;
            }
            $e1ec086d45566806$var$xh = 0;
            $e1ec086d45566806$var$T = $e1ec086d45566806$var$S = $e1ec086d45566806$var$R = null;
            $e1ec086d45566806$var$zh = !1;
            $e1ec086d45566806$var$pj.current = null;
            if (null === c || null === c.return) {
                $e1ec086d45566806$var$V = 1;
                $e1ec086d45566806$var$sj = b;
                $e1ec086d45566806$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $e1ec086d45566806$var$W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== ($e1ec086d45566806$var$P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = $e1ec086d45566806$var$zg(-1, 1);
                                        t.tag = 2;
                                        $e1ec086d45566806$var$Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new $e1ec086d45566806$var$Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = $e1ec086d45566806$var$Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error(($e1ec086d45566806$var$Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== $e1ec086d45566806$var$V && ($e1ec086d45566806$var$V = 2);
                k = $e1ec086d45566806$var$Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = $e1ec086d45566806$var$Pi(p, f, b);
                            $e1ec086d45566806$var$Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === $e1ec086d45566806$var$Ti || !$e1ec086d45566806$var$Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = $e1ec086d45566806$var$Si(p, f, b);
                                $e1ec086d45566806$var$Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            $e1ec086d45566806$var$Zj(c);
        } catch (va) {
            b = va;
            $e1ec086d45566806$var$Y === c && null !== c && ($e1ec086d45566806$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $e1ec086d45566806$var$Pj() {
    var a = $e1ec086d45566806$var$oj.current;
    $e1ec086d45566806$var$oj.current = $e1ec086d45566806$var$Gh;
    return null === a ? $e1ec086d45566806$var$Gh : a;
}
function $e1ec086d45566806$var$Tj(a, b) {
    var c = $e1ec086d45566806$var$X;
    $e1ec086d45566806$var$X |= 16;
    var d = $e1ec086d45566806$var$Pj();
    $e1ec086d45566806$var$U === a && $e1ec086d45566806$var$W === b || $e1ec086d45566806$var$Qj(a, b);
    for(;;)try {
        $e1ec086d45566806$var$ak();
        break;
    } catch (e) {
        $e1ec086d45566806$var$Sj(a, e);
    }
    $e1ec086d45566806$var$qg();
    $e1ec086d45566806$var$X = c;
    $e1ec086d45566806$var$oj.current = d;
    if (null !== $e1ec086d45566806$var$Y) throw Error($e1ec086d45566806$var$y(261));
    $e1ec086d45566806$var$U = null;
    $e1ec086d45566806$var$W = 0;
    return $e1ec086d45566806$var$V;
}
function $e1ec086d45566806$var$ak() {
    for(; null !== $e1ec086d45566806$var$Y;)$e1ec086d45566806$var$bk($e1ec086d45566806$var$Y);
}
function $e1ec086d45566806$var$Rj() {
    for(; null !== $e1ec086d45566806$var$Y && !$e1ec086d45566806$var$Qf();)$e1ec086d45566806$var$bk($e1ec086d45566806$var$Y);
}
function $e1ec086d45566806$var$bk(a) {
    var b = $e1ec086d45566806$var$ck(a.alternate, a, $e1ec086d45566806$var$qj);
    a.memoizedProps = a.pendingProps;
    null === b ? $e1ec086d45566806$var$Zj(a) : $e1ec086d45566806$var$Y = b;
    $e1ec086d45566806$var$pj.current = null;
}
function $e1ec086d45566806$var$Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = $e1ec086d45566806$var$Gi(c, b, $e1ec086d45566806$var$qj);
            if (null !== c) {
                $e1ec086d45566806$var$Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== ($e1ec086d45566806$var$qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = $e1ec086d45566806$var$Li(b);
            if (null !== c) {
                c.flags &= 2047;
                $e1ec086d45566806$var$Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            $e1ec086d45566806$var$Y = b;
            return;
        }
        $e1ec086d45566806$var$Y = b = a;
    }while (null !== b);
    0 === $e1ec086d45566806$var$V && ($e1ec086d45566806$var$V = 5);
}
function $e1ec086d45566806$var$Uj(a) {
    var b = $e1ec086d45566806$var$eg();
    $e1ec086d45566806$var$gg(99, $e1ec086d45566806$var$dk.bind(null, a, b));
    return null;
}
function $e1ec086d45566806$var$dk(a, b) {
    do $e1ec086d45566806$var$Oj();
    while (null !== $e1ec086d45566806$var$yj);
    if (0 !== ($e1ec086d45566806$var$X & 48)) throw Error($e1ec086d45566806$var$y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($e1ec086d45566806$var$y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - $e1ec086d45566806$var$Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== $e1ec086d45566806$var$Cj && 0 === (d & 24) && $e1ec086d45566806$var$Cj.has(a) && $e1ec086d45566806$var$Cj.delete(a);
    a === $e1ec086d45566806$var$U && ($e1ec086d45566806$var$Y = $e1ec086d45566806$var$U = null, $e1ec086d45566806$var$W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = $e1ec086d45566806$var$X;
        $e1ec086d45566806$var$X |= 32;
        $e1ec086d45566806$var$pj.current = null;
        $e1ec086d45566806$var$kf = $e1ec086d45566806$var$fd;
        g = $e1ec086d45566806$var$Ne();
        if ($e1ec086d45566806$var$Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        $e1ec086d45566806$var$lf = {
            focusedElem: g,
            selectionRange: h
        };
        $e1ec086d45566806$var$fd = !1;
        $e1ec086d45566806$var$Ij = null;
        $e1ec086d45566806$var$Jj = !1;
        $e1ec086d45566806$var$Z = d;
        do try {
            $e1ec086d45566806$var$ek();
        } catch (va) {
            if (null === $e1ec086d45566806$var$Z) throw Error($e1ec086d45566806$var$y(330));
            $e1ec086d45566806$var$Wi($e1ec086d45566806$var$Z, va);
            $e1ec086d45566806$var$Z = $e1ec086d45566806$var$Z.nextEffect;
        }
        while (null !== $e1ec086d45566806$var$Z);
        $e1ec086d45566806$var$Ij = null;
        $e1ec086d45566806$var$Z = d;
        do try {
            for(g = a; null !== $e1ec086d45566806$var$Z;){
                var t = $e1ec086d45566806$var$Z.flags;
                t & 16 && $e1ec086d45566806$var$pb($e1ec086d45566806$var$Z.stateNode, "");
                if (t & 128) {
                    var q = $e1ec086d45566806$var$Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        $e1ec086d45566806$var$fj($e1ec086d45566806$var$Z);
                        $e1ec086d45566806$var$Z.flags &= -3;
                        break;
                    case 6:
                        $e1ec086d45566806$var$fj($e1ec086d45566806$var$Z);
                        $e1ec086d45566806$var$Z.flags &= -3;
                        $e1ec086d45566806$var$ij($e1ec086d45566806$var$Z.alternate, $e1ec086d45566806$var$Z);
                        break;
                    case 1024:
                        $e1ec086d45566806$var$Z.flags &= -1025;
                        break;
                    case 1028:
                        $e1ec086d45566806$var$Z.flags &= -1025;
                        $e1ec086d45566806$var$ij($e1ec086d45566806$var$Z.alternate, $e1ec086d45566806$var$Z);
                        break;
                    case 4:
                        $e1ec086d45566806$var$ij($e1ec086d45566806$var$Z.alternate, $e1ec086d45566806$var$Z);
                        break;
                    case 8:
                        h = $e1ec086d45566806$var$Z;
                        $e1ec086d45566806$var$cj(g, h);
                        var J = h.alternate;
                        $e1ec086d45566806$var$dj(h);
                        null !== J && $e1ec086d45566806$var$dj(J);
                }
                $e1ec086d45566806$var$Z = $e1ec086d45566806$var$Z.nextEffect;
            }
        } catch (va) {
            if (null === $e1ec086d45566806$var$Z) throw Error($e1ec086d45566806$var$y(330));
            $e1ec086d45566806$var$Wi($e1ec086d45566806$var$Z, va);
            $e1ec086d45566806$var$Z = $e1ec086d45566806$var$Z.nextEffect;
        }
        while (null !== $e1ec086d45566806$var$Z);
        v = $e1ec086d45566806$var$lf;
        q = $e1ec086d45566806$var$Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && $e1ec086d45566806$var$Me(t.ownerDocument.documentElement, t)) {
            null !== g && $e1ec086d45566806$var$Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = $e1ec086d45566806$var$Le(t, J), f = $e1ec086d45566806$var$Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        $e1ec086d45566806$var$fd = !!$e1ec086d45566806$var$kf;
        $e1ec086d45566806$var$lf = $e1ec086d45566806$var$kf = null;
        a.current = c;
        $e1ec086d45566806$var$Z = d;
        do try {
            for(t = a; null !== $e1ec086d45566806$var$Z;){
                var K = $e1ec086d45566806$var$Z.flags;
                K & 36 && $e1ec086d45566806$var$Yi(t, $e1ec086d45566806$var$Z.alternate, $e1ec086d45566806$var$Z);
                if (K & 128) {
                    q = void 0;
                    var Q = $e1ec086d45566806$var$Z.ref;
                    if (null !== Q) {
                        var L = $e1ec086d45566806$var$Z.stateNode;
                        switch($e1ec086d45566806$var$Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                $e1ec086d45566806$var$Z = $e1ec086d45566806$var$Z.nextEffect;
            }
        } catch (va) {
            if (null === $e1ec086d45566806$var$Z) throw Error($e1ec086d45566806$var$y(330));
            $e1ec086d45566806$var$Wi($e1ec086d45566806$var$Z, va);
            $e1ec086d45566806$var$Z = $e1ec086d45566806$var$Z.nextEffect;
        }
        while (null !== $e1ec086d45566806$var$Z);
        $e1ec086d45566806$var$Z = null;
        $e1ec086d45566806$var$$f();
        $e1ec086d45566806$var$X = e;
    } else a.current = c;
    if ($e1ec086d45566806$var$xj) $e1ec086d45566806$var$xj = !1, $e1ec086d45566806$var$yj = a, $e1ec086d45566806$var$zj = b;
    else for($e1ec086d45566806$var$Z = d; null !== $e1ec086d45566806$var$Z;)b = $e1ec086d45566806$var$Z.nextEffect, $e1ec086d45566806$var$Z.nextEffect = null, $e1ec086d45566806$var$Z.flags & 8 && (K = $e1ec086d45566806$var$Z, K.sibling = null, K.stateNode = null), $e1ec086d45566806$var$Z = b;
    d = a.pendingLanes;
    0 === d && ($e1ec086d45566806$var$Ti = null);
    1 === d ? a === $e1ec086d45566806$var$Ej ? $e1ec086d45566806$var$Dj++ : ($e1ec086d45566806$var$Dj = 0, $e1ec086d45566806$var$Ej = a) : $e1ec086d45566806$var$Dj = 0;
    c = c.stateNode;
    if ($e1ec086d45566806$var$Mf && "function" === typeof $e1ec086d45566806$var$Mf.onCommitFiberRoot) try {
        $e1ec086d45566806$var$Mf.onCommitFiberRoot($e1ec086d45566806$var$Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    $e1ec086d45566806$var$Mj(a, $e1ec086d45566806$var$O());
    if ($e1ec086d45566806$var$Qi) throw $e1ec086d45566806$var$Qi = !1, a = $e1ec086d45566806$var$Ri, $e1ec086d45566806$var$Ri = null, a;
    if (0 !== ($e1ec086d45566806$var$X & 8)) return null;
    $e1ec086d45566806$var$ig();
    return null;
}
function $e1ec086d45566806$var$ek() {
    for(; null !== $e1ec086d45566806$var$Z;){
        var a = $e1ec086d45566806$var$Z.alternate;
        $e1ec086d45566806$var$Jj || null === $e1ec086d45566806$var$Ij || (0 !== ($e1ec086d45566806$var$Z.flags & 8) ? $e1ec086d45566806$var$dc($e1ec086d45566806$var$Z, $e1ec086d45566806$var$Ij) && ($e1ec086d45566806$var$Jj = !0) : 13 === $e1ec086d45566806$var$Z.tag && $e1ec086d45566806$var$mj(a, $e1ec086d45566806$var$Z) && $e1ec086d45566806$var$dc($e1ec086d45566806$var$Z, $e1ec086d45566806$var$Ij) && ($e1ec086d45566806$var$Jj = !0));
        var b = $e1ec086d45566806$var$Z.flags;
        0 !== (b & 256) && $e1ec086d45566806$var$Xi(a, $e1ec086d45566806$var$Z);
        0 === (b & 512) || $e1ec086d45566806$var$xj || ($e1ec086d45566806$var$xj = !0, $e1ec086d45566806$var$hg(97, function() {
            $e1ec086d45566806$var$Oj();
            return null;
        }));
        $e1ec086d45566806$var$Z = $e1ec086d45566806$var$Z.nextEffect;
    }
}
function $e1ec086d45566806$var$Oj() {
    if (90 !== $e1ec086d45566806$var$zj) {
        var a = 97 < $e1ec086d45566806$var$zj ? 97 : $e1ec086d45566806$var$zj;
        $e1ec086d45566806$var$zj = 90;
        return $e1ec086d45566806$var$gg(a, $e1ec086d45566806$var$fk);
    }
    return !1;
}
function $e1ec086d45566806$var$$i(a, b) {
    $e1ec086d45566806$var$Aj.push(b, a);
    $e1ec086d45566806$var$xj || ($e1ec086d45566806$var$xj = !0, $e1ec086d45566806$var$hg(97, function() {
        $e1ec086d45566806$var$Oj();
        return null;
    }));
}
function $e1ec086d45566806$var$Zi(a, b) {
    $e1ec086d45566806$var$Bj.push(b, a);
    $e1ec086d45566806$var$xj || ($e1ec086d45566806$var$xj = !0, $e1ec086d45566806$var$hg(97, function() {
        $e1ec086d45566806$var$Oj();
        return null;
    }));
}
function $e1ec086d45566806$var$fk() {
    if (null === $e1ec086d45566806$var$yj) return !1;
    var a = $e1ec086d45566806$var$yj;
    $e1ec086d45566806$var$yj = null;
    if (0 !== ($e1ec086d45566806$var$X & 48)) throw Error($e1ec086d45566806$var$y(331));
    var b = $e1ec086d45566806$var$X;
    $e1ec086d45566806$var$X |= 32;
    var c = $e1ec086d45566806$var$Bj;
    $e1ec086d45566806$var$Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error($e1ec086d45566806$var$y(330));
            $e1ec086d45566806$var$Wi(f, k);
        }
    }
    c = $e1ec086d45566806$var$Aj;
    $e1ec086d45566806$var$Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error($e1ec086d45566806$var$y(330));
            $e1ec086d45566806$var$Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    $e1ec086d45566806$var$X = b;
    $e1ec086d45566806$var$ig();
    return !0;
}
function $e1ec086d45566806$var$gk(a, b, c) {
    b = $e1ec086d45566806$var$Mi(c, b);
    b = $e1ec086d45566806$var$Pi(a, b, 1);
    $e1ec086d45566806$var$Ag(a, b);
    b = $e1ec086d45566806$var$Hg();
    a = $e1ec086d45566806$var$Kj(a, 1);
    null !== a && ($e1ec086d45566806$var$$c(a, 1, b), $e1ec086d45566806$var$Mj(a, b));
}
function $e1ec086d45566806$var$Wi(a, b) {
    if (3 === a.tag) $e1ec086d45566806$var$gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            $e1ec086d45566806$var$gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $e1ec086d45566806$var$Ti || !$e1ec086d45566806$var$Ti.has(d))) {
                a = $e1ec086d45566806$var$Mi(b, a);
                var e = $e1ec086d45566806$var$Si(c, a, 1);
                $e1ec086d45566806$var$Ag(c, e);
                e = $e1ec086d45566806$var$Hg();
                c = $e1ec086d45566806$var$Kj(c, 1);
                if (null !== c) $e1ec086d45566806$var$$c(c, 1, e), $e1ec086d45566806$var$Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === $e1ec086d45566806$var$Ti || !$e1ec086d45566806$var$Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function $e1ec086d45566806$var$Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $e1ec086d45566806$var$Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    $e1ec086d45566806$var$U === a && ($e1ec086d45566806$var$W & c) === c && (4 === $e1ec086d45566806$var$V || 3 === $e1ec086d45566806$var$V && ($e1ec086d45566806$var$W & 62914560) === $e1ec086d45566806$var$W && 500 > $e1ec086d45566806$var$O() - $e1ec086d45566806$var$jj ? $e1ec086d45566806$var$Qj(a, 0) : $e1ec086d45566806$var$uj |= c);
    $e1ec086d45566806$var$Mj(a, b);
}
function $e1ec086d45566806$var$lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === $e1ec086d45566806$var$eg() ? 1 : 2 : (0 === $e1ec086d45566806$var$Gj && ($e1ec086d45566806$var$Gj = $e1ec086d45566806$var$tj), b = $e1ec086d45566806$var$Yc(62914560 & ~$e1ec086d45566806$var$Gj), 0 === b && (b = 4194304)));
    c = $e1ec086d45566806$var$Hg();
    a = $e1ec086d45566806$var$Kj(a, b);
    null !== a && ($e1ec086d45566806$var$$c(a, b, c), $e1ec086d45566806$var$Mj(a, c));
}
var $e1ec086d45566806$var$ck;
$e1ec086d45566806$var$ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $e1ec086d45566806$var$N.current) $e1ec086d45566806$var$ug = !0;
        else if (0 !== (c & d)) $e1ec086d45566806$var$ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            $e1ec086d45566806$var$ug = !1;
            switch(b.tag){
                case 3:
                    $e1ec086d45566806$var$ri(b);
                    $e1ec086d45566806$var$sh();
                    break;
                case 5:
                    $e1ec086d45566806$var$gh(b);
                    break;
                case 1:
                    $e1ec086d45566806$var$Ff(b.type) && $e1ec086d45566806$var$Jf(b);
                    break;
                case 4:
                    $e1ec086d45566806$var$eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    $e1ec086d45566806$var$I($e1ec086d45566806$var$mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return $e1ec086d45566806$var$ti(a, b, c);
                        $e1ec086d45566806$var$I($e1ec086d45566806$var$P, $e1ec086d45566806$var$P.current & 1);
                        b = $e1ec086d45566806$var$hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    $e1ec086d45566806$var$I($e1ec086d45566806$var$P, $e1ec086d45566806$var$P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return $e1ec086d45566806$var$Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    $e1ec086d45566806$var$I($e1ec086d45566806$var$P, $e1ec086d45566806$var$P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, $e1ec086d45566806$var$mi(a, b, c);
            }
            return $e1ec086d45566806$var$hi(a, b, c);
        }
    } else $e1ec086d45566806$var$ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = $e1ec086d45566806$var$Ef(b, $e1ec086d45566806$var$M.current);
            $e1ec086d45566806$var$tg(b, c);
            e = $e1ec086d45566806$var$Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if ($e1ec086d45566806$var$Ff(d)) {
                    var f = !0;
                    $e1ec086d45566806$var$Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                $e1ec086d45566806$var$xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && $e1ec086d45566806$var$Gg(b, d, g, a);
                e.updater = $e1ec086d45566806$var$Kg;
                b.stateNode = e;
                e._reactInternals = b;
                $e1ec086d45566806$var$Og(b, d, a, c);
                b = $e1ec086d45566806$var$qi(null, b, d, !0, f, c);
            } else b.tag = 0, $e1ec086d45566806$var$fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = $e1ec086d45566806$var$hk(e);
                a = $e1ec086d45566806$var$lg(e, a);
                switch(f){
                    case 0:
                        b = $e1ec086d45566806$var$li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = $e1ec086d45566806$var$pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = $e1ec086d45566806$var$gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = $e1ec086d45566806$var$ii(null, b, e, $e1ec086d45566806$var$lg(e.type, a), d, c);
                        break a;
                }
                throw Error($e1ec086d45566806$var$y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e1ec086d45566806$var$lg(d, e), $e1ec086d45566806$var$li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e1ec086d45566806$var$lg(d, e), $e1ec086d45566806$var$pi(a, b, d, e, c);
        case 3:
            $e1ec086d45566806$var$ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error($e1ec086d45566806$var$y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            $e1ec086d45566806$var$yg(a, b);
            $e1ec086d45566806$var$Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) $e1ec086d45566806$var$sh(), b = $e1ec086d45566806$var$hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) $e1ec086d45566806$var$kh = $e1ec086d45566806$var$rf(b.stateNode.containerInfo.firstChild), $e1ec086d45566806$var$jh = b, f = $e1ec086d45566806$var$lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], $e1ec086d45566806$var$th.push(f);
                    c = $e1ec086d45566806$var$Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else $e1ec086d45566806$var$fi(a, b, d, c), $e1ec086d45566806$var$sh();
                b = b.child;
            }
            return b;
        case 5:
            return $e1ec086d45566806$var$gh(b), null === a && $e1ec086d45566806$var$ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $e1ec086d45566806$var$nf(d, e) ? g = null : null !== f && $e1ec086d45566806$var$nf(d, f) && (b.flags |= 16), $e1ec086d45566806$var$oi(a, b), $e1ec086d45566806$var$fi(a, b, g, c), b.child;
        case 6:
            return null === a && $e1ec086d45566806$var$ph(b), null;
        case 13:
            return $e1ec086d45566806$var$ti(a, b, c);
        case 4:
            return $e1ec086d45566806$var$eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $e1ec086d45566806$var$Yg(b, null, d, c) : $e1ec086d45566806$var$fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e1ec086d45566806$var$lg(d, e), $e1ec086d45566806$var$gi(a, b, d, e, c);
        case 7:
            return $e1ec086d45566806$var$fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $e1ec086d45566806$var$fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $e1ec086d45566806$var$fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                $e1ec086d45566806$var$I($e1ec086d45566806$var$mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $e1ec086d45566806$var$He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !$e1ec086d45566806$var$N.current) {
                            b = $e1ec086d45566806$var$hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = $e1ec086d45566806$var$zg(-1, c & -c), l.tag = 2, $e1ec086d45566806$var$Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    $e1ec086d45566806$var$sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                $e1ec086d45566806$var$fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, $e1ec086d45566806$var$tg(b, c), e = $e1ec086d45566806$var$vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, $e1ec086d45566806$var$fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = $e1ec086d45566806$var$lg(e, b.pendingProps), f = $e1ec086d45566806$var$lg(e.type, f), $e1ec086d45566806$var$ii(a, b, e, f, d, c);
        case 15:
            return $e1ec086d45566806$var$ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e1ec086d45566806$var$lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, $e1ec086d45566806$var$Ff(d) ? (a = !0, $e1ec086d45566806$var$Jf(b)) : a = !1, $e1ec086d45566806$var$tg(b, c), $e1ec086d45566806$var$Mg(b, d, e), $e1ec086d45566806$var$Og(b, d, e, c), $e1ec086d45566806$var$qi(null, b, d, !0, a, c);
        case 19:
            return $e1ec086d45566806$var$Ai(a, b, c);
        case 23:
            return $e1ec086d45566806$var$mi(a, b, c);
        case 24:
            return $e1ec086d45566806$var$mi(a, b, c);
    }
    throw Error($e1ec086d45566806$var$y(156, b.tag));
};
function $e1ec086d45566806$var$ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e1ec086d45566806$var$nh(a, b, c, d) {
    return new $e1ec086d45566806$var$ik(a, b, c, d);
}
function $e1ec086d45566806$var$ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $e1ec086d45566806$var$hk(a) {
    if ("function" === typeof a) return $e1ec086d45566806$var$ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $e1ec086d45566806$var$Aa) return 11;
        if (a === $e1ec086d45566806$var$Da) return 14;
    }
    return 2;
}
function $e1ec086d45566806$var$Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = $e1ec086d45566806$var$nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $e1ec086d45566806$var$Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $e1ec086d45566806$var$ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $e1ec086d45566806$var$ua:
            return $e1ec086d45566806$var$Xg(c.children, e, f, b);
        case $e1ec086d45566806$var$Ha:
            g = 8;
            e |= 16;
            break;
        case $e1ec086d45566806$var$wa:
            g = 8;
            e |= 1;
            break;
        case $e1ec086d45566806$var$xa:
            return a = $e1ec086d45566806$var$nh(12, c, b, e | 8), a.elementType = $e1ec086d45566806$var$xa, a.type = $e1ec086d45566806$var$xa, a.lanes = f, a;
        case $e1ec086d45566806$var$Ba:
            return a = $e1ec086d45566806$var$nh(13, c, b, e), a.type = $e1ec086d45566806$var$Ba, a.elementType = $e1ec086d45566806$var$Ba, a.lanes = f, a;
        case $e1ec086d45566806$var$Ca:
            return a = $e1ec086d45566806$var$nh(19, c, b, e), a.elementType = $e1ec086d45566806$var$Ca, a.lanes = f, a;
        case $e1ec086d45566806$var$Ia:
            return $e1ec086d45566806$var$vi(c, e, f, b);
        case $e1ec086d45566806$var$Ja:
            return a = $e1ec086d45566806$var$nh(24, c, b, e), a.elementType = $e1ec086d45566806$var$Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $e1ec086d45566806$var$ya:
                    g = 10;
                    break a;
                case $e1ec086d45566806$var$za:
                    g = 9;
                    break a;
                case $e1ec086d45566806$var$Aa:
                    g = 11;
                    break a;
                case $e1ec086d45566806$var$Da:
                    g = 14;
                    break a;
                case $e1ec086d45566806$var$Ea:
                    g = 16;
                    d = null;
                    break a;
                case $e1ec086d45566806$var$Fa:
                    g = 22;
                    break a;
            }
            throw Error($e1ec086d45566806$var$y(130, null == a ? a : typeof a, ""));
    }
    b = $e1ec086d45566806$var$nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $e1ec086d45566806$var$Xg(a, b, c, d) {
    a = $e1ec086d45566806$var$nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function $e1ec086d45566806$var$vi(a, b, c, d) {
    a = $e1ec086d45566806$var$nh(23, a, d, b);
    a.elementType = $e1ec086d45566806$var$Ia;
    a.lanes = c;
    return a;
}
function $e1ec086d45566806$var$Ug(a, b, c) {
    a = $e1ec086d45566806$var$nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function $e1ec086d45566806$var$Wg(a, b, c) {
    b = $e1ec086d45566806$var$nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $e1ec086d45566806$var$jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = $e1ec086d45566806$var$Zc(0);
    this.expirationTimes = $e1ec086d45566806$var$Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e1ec086d45566806$var$Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function $e1ec086d45566806$var$kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $e1ec086d45566806$var$ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $e1ec086d45566806$var$lk(a, b, c, d) {
    var e = b.current, f = $e1ec086d45566806$var$Hg(), g = $e1ec086d45566806$var$Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if ($e1ec086d45566806$var$Zb(c) !== c || 1 !== c.tag) throw Error($e1ec086d45566806$var$y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if ($e1ec086d45566806$var$Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error($e1ec086d45566806$var$y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if ($e1ec086d45566806$var$Ff(k)) {
                c = $e1ec086d45566806$var$If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = $e1ec086d45566806$var$Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $e1ec086d45566806$var$zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    $e1ec086d45566806$var$Ag(e, b);
    $e1ec086d45566806$var$Jg(e, g, f);
    return g;
}
function $e1ec086d45566806$var$mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $e1ec086d45566806$var$nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $e1ec086d45566806$var$ok(a, b) {
    $e1ec086d45566806$var$nk(a, b);
    (a = a.alternate) && $e1ec086d45566806$var$nk(a, b);
}
function $e1ec086d45566806$var$pk() {
    return null;
}
function $e1ec086d45566806$var$qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new $e1ec086d45566806$var$jk(a, b, null != c && !0 === c.hydrate);
    b = $e1ec086d45566806$var$nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    $e1ec086d45566806$var$xg(b);
    a[$e1ec086d45566806$var$ff] = c.current;
    $e1ec086d45566806$var$cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
$e1ec086d45566806$var$qk.prototype.render = function(a) {
    $e1ec086d45566806$var$lk(a, this._internalRoot, null, null);
};
$e1ec086d45566806$var$qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    $e1ec086d45566806$var$lk(null, a, null, function() {
        b[$e1ec086d45566806$var$ff] = null;
    });
};
function $e1ec086d45566806$var$rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $e1ec086d45566806$var$sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new $e1ec086d45566806$var$qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function $e1ec086d45566806$var$tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $e1ec086d45566806$var$mk(g);
                h.call(a);
            };
        }
        $e1ec086d45566806$var$lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = $e1ec086d45566806$var$sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = $e1ec086d45566806$var$mk(g);
                k.call(a);
            };
        }
        $e1ec086d45566806$var$Xj(function() {
            $e1ec086d45566806$var$lk(b, g, a, e);
        });
    }
    return $e1ec086d45566806$var$mk(g);
}
$e1ec086d45566806$var$ec = function(a) {
    if (13 === a.tag) {
        var b = $e1ec086d45566806$var$Hg();
        $e1ec086d45566806$var$Jg(a, 4, b);
        $e1ec086d45566806$var$ok(a, 4);
    }
};
$e1ec086d45566806$var$fc = function(a) {
    if (13 === a.tag) {
        var b = $e1ec086d45566806$var$Hg();
        $e1ec086d45566806$var$Jg(a, 67108864, b);
        $e1ec086d45566806$var$ok(a, 67108864);
    }
};
$e1ec086d45566806$var$gc = function(a) {
    if (13 === a.tag) {
        var b = $e1ec086d45566806$var$Hg(), c = $e1ec086d45566806$var$Ig(a);
        $e1ec086d45566806$var$Jg(a, c, b);
        $e1ec086d45566806$var$ok(a, c);
    }
};
$e1ec086d45566806$var$hc = function(a, b) {
    return b();
};
$e1ec086d45566806$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $e1ec086d45566806$var$ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $e1ec086d45566806$var$Db(d);
                        if (!e) throw Error($e1ec086d45566806$var$y(90));
                        $e1ec086d45566806$var$Wa(d);
                        $e1ec086d45566806$var$ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $e1ec086d45566806$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $e1ec086d45566806$var$fb(a, !!c.multiple, b, !1);
    }
};
$e1ec086d45566806$var$Gb = $e1ec086d45566806$var$Wj;
$e1ec086d45566806$var$Hb = function(a, b, c, d, e) {
    var f = $e1ec086d45566806$var$X;
    $e1ec086d45566806$var$X |= 4;
    try {
        return $e1ec086d45566806$var$gg(98, a.bind(null, b, c, d, e));
    } finally{
        $e1ec086d45566806$var$X = f, 0 === $e1ec086d45566806$var$X && ($e1ec086d45566806$var$wj(), $e1ec086d45566806$var$ig());
    }
};
$e1ec086d45566806$var$Ib = function() {
    0 === ($e1ec086d45566806$var$X & 49) && ($e1ec086d45566806$var$Vj(), $e1ec086d45566806$var$Oj());
};
$e1ec086d45566806$var$Jb = function(a, b) {
    var c = $e1ec086d45566806$var$X;
    $e1ec086d45566806$var$X |= 2;
    try {
        return a(b);
    } finally{
        $e1ec086d45566806$var$X = c, 0 === $e1ec086d45566806$var$X && ($e1ec086d45566806$var$wj(), $e1ec086d45566806$var$ig());
    }
};
function $e1ec086d45566806$var$uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$e1ec086d45566806$var$rk(b)) throw Error($e1ec086d45566806$var$y(200));
    return $e1ec086d45566806$var$kk(a, b, null, c);
}
var $e1ec086d45566806$var$vk = {
    Events: [
        $e1ec086d45566806$var$Cb,
        $e1ec086d45566806$var$ue,
        $e1ec086d45566806$var$Db,
        $e1ec086d45566806$var$Eb,
        $e1ec086d45566806$var$Fb,
        $e1ec086d45566806$var$Oj,
        {
            current: !1
        }
    ]
}, $e1ec086d45566806$var$wk = {
    findFiberByHostInstance: $e1ec086d45566806$var$wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var $e1ec086d45566806$var$xk = {
    bundleType: $e1ec086d45566806$var$wk.bundleType,
    version: $e1ec086d45566806$var$wk.version,
    rendererPackageName: $e1ec086d45566806$var$wk.rendererPackageName,
    rendererConfig: $e1ec086d45566806$var$wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $e1ec086d45566806$var$ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $e1ec086d45566806$var$cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $e1ec086d45566806$var$wk.findFiberByHostInstance || $e1ec086d45566806$var$pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e1ec086d45566806$var$yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e1ec086d45566806$var$yk.isDisabled && $e1ec086d45566806$var$yk.supportsFiber) try {
        $e1ec086d45566806$var$Lf = $e1ec086d45566806$var$yk.inject($e1ec086d45566806$var$xk), $e1ec086d45566806$var$Mf = $e1ec086d45566806$var$yk;
    } catch (a) {}
}
$e1ec086d45566806$export$ae55be85d98224ed = $e1ec086d45566806$var$vk;
$e1ec086d45566806$export$d39a5bbd09211389 = $e1ec086d45566806$var$uk;
$e1ec086d45566806$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($e1ec086d45566806$var$y(188));
        throw Error($e1ec086d45566806$var$y(268, Object.keys(a)));
    }
    a = $e1ec086d45566806$var$cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$e1ec086d45566806$export$cd75ccfd720a3cd4 = function(a, b) {
    var c = $e1ec086d45566806$var$X;
    if (0 !== (c & 48)) return a(b);
    $e1ec086d45566806$var$X |= 1;
    try {
        if (a) return $e1ec086d45566806$var$gg(99, a.bind(null, b));
    } finally{
        $e1ec086d45566806$var$X = c, $e1ec086d45566806$var$ig();
    }
};
$e1ec086d45566806$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$e1ec086d45566806$var$rk(b)) throw Error($e1ec086d45566806$var$y(200));
    return $e1ec086d45566806$var$tk(null, a, b, !0, c);
};
$e1ec086d45566806$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$e1ec086d45566806$var$rk(b)) throw Error($e1ec086d45566806$var$y(200));
    return $e1ec086d45566806$var$tk(null, a, b, !1, c);
};
$e1ec086d45566806$export$502457920280e6be = function(a) {
    if (!$e1ec086d45566806$var$rk(a)) throw Error($e1ec086d45566806$var$y(40));
    return a._reactRootContainer ? ($e1ec086d45566806$var$Xj(function() {
        $e1ec086d45566806$var$tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$e1ec086d45566806$var$ff] = null;
        });
    }), !0) : !1;
};
$e1ec086d45566806$export$c78a37762a8d58e1 = $e1ec086d45566806$var$Wj;
$e1ec086d45566806$export$2577ef5d2565d52f = function(a, b) {
    return $e1ec086d45566806$var$uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
$e1ec086d45566806$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$e1ec086d45566806$var$rk(c)) throw Error($e1ec086d45566806$var$y(200));
    if (null == a || void 0 === a._reactInternals) throw Error($e1ec086d45566806$var$y(38));
    return $e1ec086d45566806$var$tk(a, b, c, !1, d);
};
$e1ec086d45566806$export$83d89fbfd8236492 = "17.0.2";

});
parcelRequire.register("cQNHH", function(module, exports) {
"use strict";

module.exports = (parcelRequire("c2VSo"));

});

parcelRequire.register("1MX31", function(module, exports) {
"use strict";

module.exports = (parcelRequire("e32xz"));

});
parcelRequire.register("e32xz", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $a3a350f95ccae46a$export$c4744153514ff05d; }, function (v) { return $a3a350f95ccae46a$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $a3a350f95ccae46a$export$b5836b71941fa3ed; }, function (v) { return $a3a350f95ccae46a$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $a3a350f95ccae46a$export$d66a1c1c77bd778b; }, function (v) { return $a3a350f95ccae46a$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $a3a350f95ccae46a$export$3e506c1ccc9cc1a7; }, function (v) { return $a3a350f95ccae46a$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $a3a350f95ccae46a$export$e26fe2ed2fa76875; }, function (v) { return $a3a350f95ccae46a$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $a3a350f95ccae46a$export$502329bbf4b505b1; }, function (v) { return $a3a350f95ccae46a$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $a3a350f95ccae46a$export$6e3807111c4874c4; }, function (v) { return $a3a350f95ccae46a$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $a3a350f95ccae46a$export$c27134553091fb3a; }, function (v) { return $a3a350f95ccae46a$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $a3a350f95ccae46a$export$33ee1acdc04fd2a2; }, function (v) { return $a3a350f95ccae46a$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $a3a350f95ccae46a$export$b00a404bbd5edef2; }, function (v) { return $a3a350f95ccae46a$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $a3a350f95ccae46a$export$8352ce38b91d0c62; }, function (v) { return $a3a350f95ccae46a$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $a3a350f95ccae46a$export$d3dfb8e4810cb555; }, function (v) { return $a3a350f95ccae46a$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $a3a350f95ccae46a$export$839f9183b0465a69; }, function (v) { return $a3a350f95ccae46a$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $a3a350f95ccae46a$export$72fdf0e06517287b; }, function (v) { return $a3a350f95ccae46a$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $a3a350f95ccae46a$export$4b844e58a3e414b4; }, function (v) { return $a3a350f95ccae46a$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $a3a350f95ccae46a$export$816d2913ae6b83b1; }, function (v) { return $a3a350f95ccae46a$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $a3a350f95ccae46a$export$61bcfe829111a1d0; }, function (v) { return $a3a350f95ccae46a$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $a3a350f95ccae46a$export$7ee8c9beb337bc3f; }, function (v) { return $a3a350f95ccae46a$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $a3a350f95ccae46a$export$cf845f2c119da08a; }, function (v) { return $a3a350f95ccae46a$export$cf845f2c119da08a = v; });
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a3a350f95ccae46a$export$c4744153514ff05d;
var $a3a350f95ccae46a$export$b5836b71941fa3ed;
var $a3a350f95ccae46a$export$d66a1c1c77bd778b;
var $a3a350f95ccae46a$export$3e506c1ccc9cc1a7;
var $a3a350f95ccae46a$export$e26fe2ed2fa76875;
var $a3a350f95ccae46a$export$502329bbf4b505b1;
var $a3a350f95ccae46a$export$6e3807111c4874c4;
var $a3a350f95ccae46a$export$c27134553091fb3a;
var $a3a350f95ccae46a$export$33ee1acdc04fd2a2;
var $a3a350f95ccae46a$export$b00a404bbd5edef2;
var $a3a350f95ccae46a$export$8352ce38b91d0c62;
var $a3a350f95ccae46a$export$d3dfb8e4810cb555;
var $a3a350f95ccae46a$export$839f9183b0465a69;
var $a3a350f95ccae46a$export$72fdf0e06517287b;
var $a3a350f95ccae46a$export$4b844e58a3e414b4;
var $a3a350f95ccae46a$export$816d2913ae6b83b1;
var $a3a350f95ccae46a$export$61bcfe829111a1d0;
var $a3a350f95ccae46a$export$7ee8c9beb337bc3f;
var $a3a350f95ccae46a$export$cf845f2c119da08a;
"use strict";
var $a3a350f95ccae46a$var$f, $a3a350f95ccae46a$var$g, $a3a350f95ccae46a$var$h, $a3a350f95ccae46a$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $a3a350f95ccae46a$var$l = performance;
    $a3a350f95ccae46a$export$c4744153514ff05d = function() {
        return $a3a350f95ccae46a$var$l.now();
    };
} else {
    var $a3a350f95ccae46a$var$p = Date, $a3a350f95ccae46a$var$q = $a3a350f95ccae46a$var$p.now();
    $a3a350f95ccae46a$export$c4744153514ff05d = function() {
        return $a3a350f95ccae46a$var$p.now() - $a3a350f95ccae46a$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $a3a350f95ccae46a$var$t = null, $a3a350f95ccae46a$var$u = null, $a3a350f95ccae46a$var$w = function() {
        if (null !== $a3a350f95ccae46a$var$t) try {
            var a = $a3a350f95ccae46a$export$c4744153514ff05d();
            $a3a350f95ccae46a$var$t(!0, a);
            $a3a350f95ccae46a$var$t = null;
        } catch (b) {
            throw setTimeout($a3a350f95ccae46a$var$w, 0), b;
        }
    };
    $a3a350f95ccae46a$var$f = function(a) {
        null !== $a3a350f95ccae46a$var$t ? setTimeout($a3a350f95ccae46a$var$f, 0, a) : ($a3a350f95ccae46a$var$t = a, setTimeout($a3a350f95ccae46a$var$w, 0));
    };
    $a3a350f95ccae46a$var$g = function(a, b) {
        $a3a350f95ccae46a$var$u = setTimeout(a, b);
    };
    $a3a350f95ccae46a$var$h = function() {
        clearTimeout($a3a350f95ccae46a$var$u);
    };
    $a3a350f95ccae46a$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $a3a350f95ccae46a$var$k = $a3a350f95ccae46a$export$d66a1c1c77bd778b = function() {};
} else {
    var $a3a350f95ccae46a$var$x = window.setTimeout, $a3a350f95ccae46a$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $a3a350f95ccae46a$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $a3a350f95ccae46a$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $a3a350f95ccae46a$var$A = !1, $a3a350f95ccae46a$var$B = null, $a3a350f95ccae46a$var$C = -1, $a3a350f95ccae46a$var$D = 5, $a3a350f95ccae46a$var$E = 0;
    $a3a350f95ccae46a$export$b5836b71941fa3ed = function() {
        return $a3a350f95ccae46a$export$c4744153514ff05d() >= $a3a350f95ccae46a$var$E;
    };
    $a3a350f95ccae46a$var$k = function() {};
    $a3a350f95ccae46a$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $a3a350f95ccae46a$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $a3a350f95ccae46a$var$F = new MessageChannel, $a3a350f95ccae46a$var$G = $a3a350f95ccae46a$var$F.port2;
    $a3a350f95ccae46a$var$F.port1.onmessage = function() {
        if (null !== $a3a350f95ccae46a$var$B) {
            var a = $a3a350f95ccae46a$export$c4744153514ff05d();
            $a3a350f95ccae46a$var$E = a + $a3a350f95ccae46a$var$D;
            try {
                $a3a350f95ccae46a$var$B(!0, a) ? $a3a350f95ccae46a$var$G.postMessage(null) : ($a3a350f95ccae46a$var$A = !1, $a3a350f95ccae46a$var$B = null);
            } catch (b) {
                throw $a3a350f95ccae46a$var$G.postMessage(null), b;
            }
        } else $a3a350f95ccae46a$var$A = !1;
    };
    $a3a350f95ccae46a$var$f = function(a) {
        $a3a350f95ccae46a$var$B = a;
        $a3a350f95ccae46a$var$A || ($a3a350f95ccae46a$var$A = !0, $a3a350f95ccae46a$var$G.postMessage(null));
    };
    $a3a350f95ccae46a$var$g = function(a, b) {
        $a3a350f95ccae46a$var$C = $a3a350f95ccae46a$var$x(function() {
            a($a3a350f95ccae46a$export$c4744153514ff05d());
        }, b);
    };
    $a3a350f95ccae46a$var$h = function() {
        $a3a350f95ccae46a$var$y($a3a350f95ccae46a$var$C);
        $a3a350f95ccae46a$var$C = -1;
    };
}
function $a3a350f95ccae46a$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $a3a350f95ccae46a$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $a3a350f95ccae46a$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $a3a350f95ccae46a$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $a3a350f95ccae46a$var$I(n, c)) void 0 !== r && 0 > $a3a350f95ccae46a$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $a3a350f95ccae46a$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $a3a350f95ccae46a$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $a3a350f95ccae46a$var$L = [], $a3a350f95ccae46a$var$M = [], $a3a350f95ccae46a$var$N = 1, $a3a350f95ccae46a$var$O = null, $a3a350f95ccae46a$var$P = 3, $a3a350f95ccae46a$var$Q = !1, $a3a350f95ccae46a$var$R = !1, $a3a350f95ccae46a$var$S = !1;
function $a3a350f95ccae46a$var$T(a) {
    for(var b = $a3a350f95ccae46a$var$J($a3a350f95ccae46a$var$M); null !== b;){
        if (null === b.callback) $a3a350f95ccae46a$var$K($a3a350f95ccae46a$var$M);
        else if (b.startTime <= a) $a3a350f95ccae46a$var$K($a3a350f95ccae46a$var$M), b.sortIndex = b.expirationTime, $a3a350f95ccae46a$var$H($a3a350f95ccae46a$var$L, b);
        else break;
        b = $a3a350f95ccae46a$var$J($a3a350f95ccae46a$var$M);
    }
}
function $a3a350f95ccae46a$var$U(a) {
    $a3a350f95ccae46a$var$S = !1;
    $a3a350f95ccae46a$var$T(a);
    if (!$a3a350f95ccae46a$var$R) {
        if (null !== $a3a350f95ccae46a$var$J($a3a350f95ccae46a$var$L)) $a3a350f95ccae46a$var$R = !0, $a3a350f95ccae46a$var$f($a3a350f95ccae46a$var$V);
        else {
            var b = $a3a350f95ccae46a$var$J($a3a350f95ccae46a$var$M);
            null !== b && $a3a350f95ccae46a$var$g($a3a350f95ccae46a$var$U, b.startTime - a);
        }
    }
}
function $a3a350f95ccae46a$var$V(a, b) {
    $a3a350f95ccae46a$var$R = !1;
    $a3a350f95ccae46a$var$S && ($a3a350f95ccae46a$var$S = !1, $a3a350f95ccae46a$var$h());
    $a3a350f95ccae46a$var$Q = !0;
    var c = $a3a350f95ccae46a$var$P;
    try {
        $a3a350f95ccae46a$var$T(b);
        for($a3a350f95ccae46a$var$O = $a3a350f95ccae46a$var$J($a3a350f95ccae46a$var$L); null !== $a3a350f95ccae46a$var$O && (!($a3a350f95ccae46a$var$O.expirationTime > b) || a && !$a3a350f95ccae46a$export$b5836b71941fa3ed());){
            var d = $a3a350f95ccae46a$var$O.callback;
            if ("function" === typeof d) {
                $a3a350f95ccae46a$var$O.callback = null;
                $a3a350f95ccae46a$var$P = $a3a350f95ccae46a$var$O.priorityLevel;
                var e = d($a3a350f95ccae46a$var$O.expirationTime <= b);
                b = $a3a350f95ccae46a$export$c4744153514ff05d();
                "function" === typeof e ? $a3a350f95ccae46a$var$O.callback = e : $a3a350f95ccae46a$var$O === $a3a350f95ccae46a$var$J($a3a350f95ccae46a$var$L) && $a3a350f95ccae46a$var$K($a3a350f95ccae46a$var$L);
                $a3a350f95ccae46a$var$T(b);
            } else $a3a350f95ccae46a$var$K($a3a350f95ccae46a$var$L);
            $a3a350f95ccae46a$var$O = $a3a350f95ccae46a$var$J($a3a350f95ccae46a$var$L);
        }
        if (null !== $a3a350f95ccae46a$var$O) var m = !0;
        else {
            var n = $a3a350f95ccae46a$var$J($a3a350f95ccae46a$var$M);
            null !== n && $a3a350f95ccae46a$var$g($a3a350f95ccae46a$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $a3a350f95ccae46a$var$O = null, $a3a350f95ccae46a$var$P = c, $a3a350f95ccae46a$var$Q = !1;
    }
}
var $a3a350f95ccae46a$var$W = $a3a350f95ccae46a$var$k;
$a3a350f95ccae46a$export$3e506c1ccc9cc1a7 = 5;
$a3a350f95ccae46a$export$e26fe2ed2fa76875 = 1;
$a3a350f95ccae46a$export$502329bbf4b505b1 = 4;
$a3a350f95ccae46a$export$6e3807111c4874c4 = 3;
$a3a350f95ccae46a$export$c27134553091fb3a = null;
$a3a350f95ccae46a$export$33ee1acdc04fd2a2 = 2;
$a3a350f95ccae46a$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$a3a350f95ccae46a$export$8352ce38b91d0c62 = function() {
    $a3a350f95ccae46a$var$R || $a3a350f95ccae46a$var$Q || ($a3a350f95ccae46a$var$R = !0, $a3a350f95ccae46a$var$f($a3a350f95ccae46a$var$V));
};
$a3a350f95ccae46a$export$d3dfb8e4810cb555 = function() {
    return $a3a350f95ccae46a$var$P;
};
$a3a350f95ccae46a$export$839f9183b0465a69 = function() {
    return $a3a350f95ccae46a$var$J($a3a350f95ccae46a$var$L);
};
$a3a350f95ccae46a$export$72fdf0e06517287b = function(a) {
    switch($a3a350f95ccae46a$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $a3a350f95ccae46a$var$P;
    }
    var c = $a3a350f95ccae46a$var$P;
    $a3a350f95ccae46a$var$P = b;
    try {
        return a();
    } finally{
        $a3a350f95ccae46a$var$P = c;
    }
};
$a3a350f95ccae46a$export$4b844e58a3e414b4 = function() {};
$a3a350f95ccae46a$export$816d2913ae6b83b1 = $a3a350f95ccae46a$var$W;
$a3a350f95ccae46a$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $a3a350f95ccae46a$var$P;
    $a3a350f95ccae46a$var$P = a;
    try {
        return b();
    } finally{
        $a3a350f95ccae46a$var$P = c;
    }
};
$a3a350f95ccae46a$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $a3a350f95ccae46a$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $a3a350f95ccae46a$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $a3a350f95ccae46a$var$H($a3a350f95ccae46a$var$M, a), null === $a3a350f95ccae46a$var$J($a3a350f95ccae46a$var$L) && a === $a3a350f95ccae46a$var$J($a3a350f95ccae46a$var$M) && ($a3a350f95ccae46a$var$S ? $a3a350f95ccae46a$var$h() : $a3a350f95ccae46a$var$S = !0, $a3a350f95ccae46a$var$g($a3a350f95ccae46a$var$U, c - d))) : (a.sortIndex = e, $a3a350f95ccae46a$var$H($a3a350f95ccae46a$var$L, a), $a3a350f95ccae46a$var$R || $a3a350f95ccae46a$var$Q || ($a3a350f95ccae46a$var$R = !0, $a3a350f95ccae46a$var$f($a3a350f95ccae46a$var$V)));
    return a;
};
$a3a350f95ccae46a$export$cf845f2c119da08a = function(a) {
    var b = $a3a350f95ccae46a$var$P;
    return function() {
        var c = $a3a350f95ccae46a$var$P;
        $a3a350f95ccae46a$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $a3a350f95ccae46a$var$P = c;
        }
    };
};

});



parcelRequire.register("9FMI2", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $70adba078f2f3fbb$export$2b8d127b894957b9; }, function (v) { return $70adba078f2f3fbb$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $70adba078f2f3fbb$export$cea3a54a6425200c; }, function (v) { return $70adba078f2f3fbb$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $70adba078f2f3fbb$export$a7c73072b1a182ae; }, function (v) { return $70adba078f2f3fbb$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $70adba078f2f3fbb$export$9f27bc3417b4524d; }, function (v) { return $70adba078f2f3fbb$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $70adba078f2f3fbb$export$db77ccec0bb4ccac; }, function (v) { return $70adba078f2f3fbb$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $70adba078f2f3fbb$export$8392c0c9d3dcbd35; }, function (v) { return $70adba078f2f3fbb$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $70adba078f2f3fbb$export$ffb0004e005737fa; }, function (v) { return $70adba078f2f3fbb$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $70adba078f2f3fbb$export$b624eff549462981; }, function (v) { return $70adba078f2f3fbb$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $70adba078f2f3fbb$export$7897aa7841a5380c; }, function (v) { return $70adba078f2f3fbb$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $70adba078f2f3fbb$export$602eac185826482c; }, function (v) { return $70adba078f2f3fbb$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $70adba078f2f3fbb$export$e2c29f18771995cb; }, function (v) { return $70adba078f2f3fbb$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $70adba078f2f3fbb$export$5f8d39834fd61797; }, function (v) { return $70adba078f2f3fbb$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $70adba078f2f3fbb$export$74bf444e3cd11ea5; }, function (v) { return $70adba078f2f3fbb$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $70adba078f2f3fbb$export$92387174baf9b227; }, function (v) { return $70adba078f2f3fbb$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $70adba078f2f3fbb$export$ec112efeb987d9c6; }, function (v) { return $70adba078f2f3fbb$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $70adba078f2f3fbb$export$b706b080d889d2c9; }, function (v) { return $70adba078f2f3fbb$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $70adba078f2f3fbb$export$5be5a87408f70ddc; }, function (v) { return $70adba078f2f3fbb$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $70adba078f2f3fbb$export$45a5e7f76e0caa8d; }, function (v) { return $70adba078f2f3fbb$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $70adba078f2f3fbb$export$455c2e768291efa6; }, function (v) { return $70adba078f2f3fbb$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $70adba078f2f3fbb$export$9522e17588c12572; }, function (v) { return $70adba078f2f3fbb$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $70adba078f2f3fbb$export$2110ac352bb060b9; }, function (v) { return $70adba078f2f3fbb$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $70adba078f2f3fbb$export$56885ab8b9c456ab; }, function (v) { return $70adba078f2f3fbb$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $70adba078f2f3fbb$export$d927fcb6adf8f9de; }, function (v) { return $70adba078f2f3fbb$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $70adba078f2f3fbb$export$b82d16f27459e05a; }, function (v) { return $70adba078f2f3fbb$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $70adba078f2f3fbb$export$522c17b4f5e123e8; }, function (v) { return $70adba078f2f3fbb$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $70adba078f2f3fbb$export$1aabd8a0274ecfd6; }, function (v) { return $70adba078f2f3fbb$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $70adba078f2f3fbb$export$9b621391a187a31a; }, function (v) { return $70adba078f2f3fbb$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $70adba078f2f3fbb$export$f5bbd400c2f4426f; }, function (v) { return $70adba078f2f3fbb$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $70adba078f2f3fbb$export$2b8d127b894957b9;
var $70adba078f2f3fbb$export$cea3a54a6425200c;
var $70adba078f2f3fbb$export$a7c73072b1a182ae;
var $70adba078f2f3fbb$export$9f27bc3417b4524d;
var $70adba078f2f3fbb$export$db77ccec0bb4ccac;
var $70adba078f2f3fbb$export$8392c0c9d3dcbd35;
var $70adba078f2f3fbb$export$ffb0004e005737fa;
var $70adba078f2f3fbb$export$b624eff549462981;
var $70adba078f2f3fbb$export$7897aa7841a5380c;
var $70adba078f2f3fbb$export$602eac185826482c;
var $70adba078f2f3fbb$export$e2c29f18771995cb;
var $70adba078f2f3fbb$export$5f8d39834fd61797;
var $70adba078f2f3fbb$export$74bf444e3cd11ea5;
var $70adba078f2f3fbb$export$92387174baf9b227;
var $70adba078f2f3fbb$export$ec112efeb987d9c6;
var $70adba078f2f3fbb$export$b706b080d889d2c9;
var $70adba078f2f3fbb$export$5be5a87408f70ddc;
var $70adba078f2f3fbb$export$45a5e7f76e0caa8d;
var $70adba078f2f3fbb$export$455c2e768291efa6;
var $70adba078f2f3fbb$export$9522e17588c12572;
var $70adba078f2f3fbb$export$2110ac352bb060b9;
var $70adba078f2f3fbb$export$56885ab8b9c456ab;
var $70adba078f2f3fbb$export$d927fcb6adf8f9de;
var $70adba078f2f3fbb$export$b82d16f27459e05a;
var $70adba078f2f3fbb$export$522c17b4f5e123e8;
var $70adba078f2f3fbb$export$1aabd8a0274ecfd6;
var $70adba078f2f3fbb$export$9b621391a187a31a;
var $70adba078f2f3fbb$export$f5bbd400c2f4426f;
"use strict";
var $70adba078f2f3fbb$var$b = "function" === typeof Symbol && Symbol.for, $70adba078f2f3fbb$var$c = $70adba078f2f3fbb$var$b ? Symbol.for("react.element") : 60103, $70adba078f2f3fbb$var$d = $70adba078f2f3fbb$var$b ? Symbol.for("react.portal") : 60106, $70adba078f2f3fbb$var$e = $70adba078f2f3fbb$var$b ? Symbol.for("react.fragment") : 60107, $70adba078f2f3fbb$var$f = $70adba078f2f3fbb$var$b ? Symbol.for("react.strict_mode") : 60108, $70adba078f2f3fbb$var$g = $70adba078f2f3fbb$var$b ? Symbol.for("react.profiler") : 60114, $70adba078f2f3fbb$var$h = $70adba078f2f3fbb$var$b ? Symbol.for("react.provider") : 60109, $70adba078f2f3fbb$var$k = $70adba078f2f3fbb$var$b ? Symbol.for("react.context") : 60110, $70adba078f2f3fbb$var$l = $70adba078f2f3fbb$var$b ? Symbol.for("react.async_mode") : 60111, $70adba078f2f3fbb$var$m = $70adba078f2f3fbb$var$b ? Symbol.for("react.concurrent_mode") : 60111, $70adba078f2f3fbb$var$n = $70adba078f2f3fbb$var$b ? Symbol.for("react.forward_ref") : 60112, $70adba078f2f3fbb$var$p = $70adba078f2f3fbb$var$b ? Symbol.for("react.suspense") : 60113, $70adba078f2f3fbb$var$q = $70adba078f2f3fbb$var$b ? Symbol.for("react.suspense_list") : 60120, $70adba078f2f3fbb$var$r = $70adba078f2f3fbb$var$b ? Symbol.for("react.memo") : 60115, $70adba078f2f3fbb$var$t = $70adba078f2f3fbb$var$b ? Symbol.for("react.lazy") : 60116, $70adba078f2f3fbb$var$v = $70adba078f2f3fbb$var$b ? Symbol.for("react.block") : 60121, $70adba078f2f3fbb$var$w = $70adba078f2f3fbb$var$b ? Symbol.for("react.fundamental") : 60117, $70adba078f2f3fbb$var$x = $70adba078f2f3fbb$var$b ? Symbol.for("react.responder") : 60118, $70adba078f2f3fbb$var$y = $70adba078f2f3fbb$var$b ? Symbol.for("react.scope") : 60119;
function $70adba078f2f3fbb$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $70adba078f2f3fbb$var$c:
                switch(a = a.type, a){
                    case $70adba078f2f3fbb$var$l:
                    case $70adba078f2f3fbb$var$m:
                    case $70adba078f2f3fbb$var$e:
                    case $70adba078f2f3fbb$var$g:
                    case $70adba078f2f3fbb$var$f:
                    case $70adba078f2f3fbb$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $70adba078f2f3fbb$var$k:
                            case $70adba078f2f3fbb$var$n:
                            case $70adba078f2f3fbb$var$t:
                            case $70adba078f2f3fbb$var$r:
                            case $70adba078f2f3fbb$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $70adba078f2f3fbb$var$d:
                return u;
        }
    }
}
function $70adba078f2f3fbb$var$A(a) {
    return $70adba078f2f3fbb$var$z(a) === $70adba078f2f3fbb$var$m;
}
$70adba078f2f3fbb$export$2b8d127b894957b9 = $70adba078f2f3fbb$var$l;
$70adba078f2f3fbb$export$cea3a54a6425200c = $70adba078f2f3fbb$var$m;
$70adba078f2f3fbb$export$a7c73072b1a182ae = $70adba078f2f3fbb$var$k;
$70adba078f2f3fbb$export$9f27bc3417b4524d = $70adba078f2f3fbb$var$h;
$70adba078f2f3fbb$export$db77ccec0bb4ccac = $70adba078f2f3fbb$var$c;
$70adba078f2f3fbb$export$8392c0c9d3dcbd35 = $70adba078f2f3fbb$var$n;
$70adba078f2f3fbb$export$ffb0004e005737fa = $70adba078f2f3fbb$var$e;
$70adba078f2f3fbb$export$b624eff549462981 = $70adba078f2f3fbb$var$t;
$70adba078f2f3fbb$export$7897aa7841a5380c = $70adba078f2f3fbb$var$r;
$70adba078f2f3fbb$export$602eac185826482c = $70adba078f2f3fbb$var$d;
$70adba078f2f3fbb$export$e2c29f18771995cb = $70adba078f2f3fbb$var$g;
$70adba078f2f3fbb$export$5f8d39834fd61797 = $70adba078f2f3fbb$var$f;
$70adba078f2f3fbb$export$74bf444e3cd11ea5 = $70adba078f2f3fbb$var$p;
$70adba078f2f3fbb$export$92387174baf9b227 = function(a) {
    return $70adba078f2f3fbb$var$A(a) || $70adba078f2f3fbb$var$z(a) === $70adba078f2f3fbb$var$l;
};
$70adba078f2f3fbb$export$ec112efeb987d9c6 = $70adba078f2f3fbb$var$A;
$70adba078f2f3fbb$export$b706b080d889d2c9 = function(a) {
    return $70adba078f2f3fbb$var$z(a) === $70adba078f2f3fbb$var$k;
};
$70adba078f2f3fbb$export$5be5a87408f70ddc = function(a) {
    return $70adba078f2f3fbb$var$z(a) === $70adba078f2f3fbb$var$h;
};
$70adba078f2f3fbb$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $70adba078f2f3fbb$var$c;
};
$70adba078f2f3fbb$export$455c2e768291efa6 = function(a) {
    return $70adba078f2f3fbb$var$z(a) === $70adba078f2f3fbb$var$n;
};
$70adba078f2f3fbb$export$9522e17588c12572 = function(a) {
    return $70adba078f2f3fbb$var$z(a) === $70adba078f2f3fbb$var$e;
};
$70adba078f2f3fbb$export$2110ac352bb060b9 = function(a) {
    return $70adba078f2f3fbb$var$z(a) === $70adba078f2f3fbb$var$t;
};
$70adba078f2f3fbb$export$56885ab8b9c456ab = function(a) {
    return $70adba078f2f3fbb$var$z(a) === $70adba078f2f3fbb$var$r;
};
$70adba078f2f3fbb$export$d927fcb6adf8f9de = function(a) {
    return $70adba078f2f3fbb$var$z(a) === $70adba078f2f3fbb$var$d;
};
$70adba078f2f3fbb$export$b82d16f27459e05a = function(a) {
    return $70adba078f2f3fbb$var$z(a) === $70adba078f2f3fbb$var$g;
};
$70adba078f2f3fbb$export$522c17b4f5e123e8 = function(a) {
    return $70adba078f2f3fbb$var$z(a) === $70adba078f2f3fbb$var$f;
};
$70adba078f2f3fbb$export$1aabd8a0274ecfd6 = function(a) {
    return $70adba078f2f3fbb$var$z(a) === $70adba078f2f3fbb$var$p;
};
$70adba078f2f3fbb$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $70adba078f2f3fbb$var$e || a === $70adba078f2f3fbb$var$m || a === $70adba078f2f3fbb$var$g || a === $70adba078f2f3fbb$var$f || a === $70adba078f2f3fbb$var$p || a === $70adba078f2f3fbb$var$q || "object" === typeof a && null !== a && (a.$$typeof === $70adba078f2f3fbb$var$t || a.$$typeof === $70adba078f2f3fbb$var$r || a.$$typeof === $70adba078f2f3fbb$var$h || a.$$typeof === $70adba078f2f3fbb$var$k || a.$$typeof === $70adba078f2f3fbb$var$n || a.$$typeof === $70adba078f2f3fbb$var$w || a.$$typeof === $70adba078f2f3fbb$var$x || a.$$typeof === $70adba078f2f3fbb$var$y || a.$$typeof === $70adba078f2f3fbb$var$v);
};
$70adba078f2f3fbb$export$f5bbd400c2f4426f = $70adba078f2f3fbb$var$z;

});

parcelRequire.register("kGntY", function(module, exports) {

var $iYrGz = parcelRequire("iYrGz");

var $gE0HP = parcelRequire("gE0HP");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $iYrGz.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $gE0HP;
module.exports = isBuffer;

});
parcelRequire.register("iYrGz", function(module, exports) {

var $jlhWK = parcelRequire("jlhWK");
/** Detect free variable `self`. */ var $dd034e5ff071505a$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $dd034e5ff071505a$var$root = $jlhWK || $dd034e5ff071505a$var$freeSelf || Function("return this")();
module.exports = $dd034e5ff071505a$var$root;

});
parcelRequire.register("jlhWK", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $e14de64625fd17b7$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $e14de64625fd17b7$var$freeGlobal;

});


parcelRequire.register("gE0HP", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $c1e0edf11f2970df$var$stubFalse() {
    return false;
}
module.exports = $c1e0edf11f2970df$var$stubFalse;

});


parcelRequire.register("4Nl3a", function(module, exports) {

var $jlhWK = parcelRequire("jlhWK");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $jlhWK.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRequire.register("gJKos", function(module, exports) {

var $iYrGz = parcelRequire("iYrGz");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $iYrGz.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRequire.register("6XRb5", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MissingRefError = exports.ValidationError = exports.CodeGen = exports.Name = exports.nil = exports.stringify = exports.str = exports._ = exports.KeywordCxt = void 0;

var $5U9XR = parcelRequire("5U9XR");

var $6yzWZ = parcelRequire("6yzWZ");

var $eqmRb = parcelRequire("eqmRb");

var $cmDZ6 = parcelRequire("cmDZ6");
const META_SUPPORT_DATA = [
    "/properties"
];
const META_SCHEMA_ID = "http://json-schema.org/draft-07/schema";
class Ajv extends $5U9XR.default {
    _addVocabularies() {
        super._addVocabularies();
        $6yzWZ.default.forEach((v)=>this.addVocabulary(v));
        if (this.opts.discriminator) this.addKeyword($eqmRb.default);
    }
    _addDefaultMetaSchema() {
        super._addDefaultMetaSchema();
        if (!this.opts.meta) return;
        const metaSchema = this.opts.$data ? this.$dataMetaSchema($cmDZ6, META_SUPPORT_DATA) : $cmDZ6;
        this.addMetaSchema(metaSchema, META_SCHEMA_ID, false);
        this.refs["http://json-schema.org/schema"] = META_SCHEMA_ID;
    }
    defaultMeta() {
        return this.opts.defaultMeta = super.defaultMeta() || (this.getSchema(META_SCHEMA_ID) ? META_SCHEMA_ID : undefined);
    }
}
module.exports = exports = Ajv;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Ajv;

var $6DSbS = parcelRequire("6DSbS");
Object.defineProperty(exports, "KeywordCxt", {
    enumerable: true,
    get: function() {
        return $6DSbS.KeywordCxt;
    }
});

var $6Vb5F = parcelRequire("6Vb5F");
Object.defineProperty(exports, "_", {
    enumerable: true,
    get: function() {
        return $6Vb5F._;
    }
});
Object.defineProperty(exports, "str", {
    enumerable: true,
    get: function() {
        return $6Vb5F.str;
    }
});
Object.defineProperty(exports, "stringify", {
    enumerable: true,
    get: function() {
        return $6Vb5F.stringify;
    }
});
Object.defineProperty(exports, "nil", {
    enumerable: true,
    get: function() {
        return $6Vb5F.nil;
    }
});
Object.defineProperty(exports, "Name", {
    enumerable: true,
    get: function() {
        return $6Vb5F.Name;
    }
});
Object.defineProperty(exports, "CodeGen", {
    enumerable: true,
    get: function() {
        return $6Vb5F.CodeGen;
    }
});

var $iM4Un = parcelRequire("iM4Un");
Object.defineProperty(exports, "ValidationError", {
    enumerable: true,
    get: function() {
        return $iM4Un.default;
    }
});

var $6XLO0 = parcelRequire("6XLO0");
Object.defineProperty(exports, "MissingRefError", {
    enumerable: true,
    get: function() {
        return $6XLO0.default;
    }
});

});
parcelRequire.register("5U9XR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodeGen = module.exports.Name = module.exports.nil = module.exports.stringify = module.exports.str = module.exports._ = module.exports.KeywordCxt = void 0;

var $6DSbS = parcelRequire("6DSbS");
Object.defineProperty(module.exports, "KeywordCxt", {
    enumerable: true,
    get: function() {
        return $6DSbS.KeywordCxt;
    }
});

var $6Vb5F = parcelRequire("6Vb5F");
Object.defineProperty(module.exports, "_", {
    enumerable: true,
    get: function() {
        return $6Vb5F._;
    }
});
Object.defineProperty(module.exports, "str", {
    enumerable: true,
    get: function() {
        return $6Vb5F.str;
    }
});
Object.defineProperty(module.exports, "stringify", {
    enumerable: true,
    get: function() {
        return $6Vb5F.stringify;
    }
});
Object.defineProperty(module.exports, "nil", {
    enumerable: true,
    get: function() {
        return $6Vb5F.nil;
    }
});
Object.defineProperty(module.exports, "Name", {
    enumerable: true,
    get: function() {
        return $6Vb5F.Name;
    }
});
Object.defineProperty(module.exports, "CodeGen", {
    enumerable: true,
    get: function() {
        return $6Vb5F.CodeGen;
    }
});

var $iM4Un = parcelRequire("iM4Un");

var $6XLO0 = parcelRequire("6XLO0");

var $j5Abb = parcelRequire("j5Abb");

var $PkPFY = parcelRequire("PkPFY");

var $6Vb5F = parcelRequire("6Vb5F");

var $1Oy4e = parcelRequire("1Oy4e");

var $5jmf7 = parcelRequire("5jmf7");

var $k2074 = parcelRequire("k2074");

var $RgrKG = parcelRequire("RgrKG");

var $bXTio = parcelRequire("bXTio");
const $44c9e97a8f5af912$var$defaultRegExp = (str, flags)=>new RegExp(str, flags);
$44c9e97a8f5af912$var$defaultRegExp.code = "new RegExp";
const $44c9e97a8f5af912$var$META_IGNORE_OPTIONS = [
    "removeAdditional",
    "useDefaults",
    "coerceTypes"
];
const $44c9e97a8f5af912$var$EXT_SCOPE_NAMES = new Set([
    "validate",
    "serialize",
    "parse",
    "wrapper",
    "root",
    "schema",
    "keyword",
    "pattern",
    "formats",
    "validate$data",
    "func",
    "obj",
    "Error"
]);
const $44c9e97a8f5af912$var$removedOptions = {
    errorDataPath: "",
    format: "`validateFormats: false` can be used instead.",
    nullable: '"nullable" keyword is supported by default.',
    jsonPointers: "Deprecated jsPropertySyntax can be used instead.",
    extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.",
    missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.",
    processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`",
    sourceCode: "Use option `code: {source: true}`",
    strictDefaults: "It is default now, see option `strict`.",
    strictKeywords: "It is default now, see option `strict`.",
    uniqueItems: '"uniqueItems" keyword is always validated.',
    unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).",
    cache: "Map is used as cache, schema object as key.",
    serialize: "Map is used as cache, schema object as key.",
    ajvErrors: "It is default now."
};
const $44c9e97a8f5af912$var$deprecatedOptions = {
    ignoreKeywordsWithRef: "",
    jsPropertySyntax: "",
    unicode: '"minLength"/"maxLength" account for unicode characters by default.'
};
const $44c9e97a8f5af912$var$MAX_EXPRESSION = 200;
// eslint-disable-next-line complexity
function $44c9e97a8f5af912$var$requiredOptions(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
    const s = o.strict;
    const _optz = (_a = o.code) === null || _a === void 0 ? void 0 : _a.optimize;
    const optimize = _optz === true || _optz === undefined ? 1 : _optz || 0;
    const regExp = (_c = (_b = o.code) === null || _b === void 0 ? void 0 : _b.regExp) !== null && _c !== void 0 ? _c : $44c9e97a8f5af912$var$defaultRegExp;
    const uriResolver = (_d = o.uriResolver) !== null && _d !== void 0 ? _d : $bXTio.default;
    return {
        strictSchema: (_f = (_e = o.strictSchema) !== null && _e !== void 0 ? _e : s) !== null && _f !== void 0 ? _f : true,
        strictNumbers: (_h = (_g = o.strictNumbers) !== null && _g !== void 0 ? _g : s) !== null && _h !== void 0 ? _h : true,
        strictTypes: (_k = (_j = o.strictTypes) !== null && _j !== void 0 ? _j : s) !== null && _k !== void 0 ? _k : "log",
        strictTuples: (_m = (_l = o.strictTuples) !== null && _l !== void 0 ? _l : s) !== null && _m !== void 0 ? _m : "log",
        strictRequired: (_p = (_o = o.strictRequired) !== null && _o !== void 0 ? _o : s) !== null && _p !== void 0 ? _p : false,
        code: o.code ? {
            ...o.code,
            optimize: optimize,
            regExp: regExp
        } : {
            optimize: optimize,
            regExp: regExp
        },
        loopRequired: (_q = o.loopRequired) !== null && _q !== void 0 ? _q : $44c9e97a8f5af912$var$MAX_EXPRESSION,
        loopEnum: (_r = o.loopEnum) !== null && _r !== void 0 ? _r : $44c9e97a8f5af912$var$MAX_EXPRESSION,
        meta: (_s = o.meta) !== null && _s !== void 0 ? _s : true,
        messages: (_t = o.messages) !== null && _t !== void 0 ? _t : true,
        inlineRefs: (_u = o.inlineRefs) !== null && _u !== void 0 ? _u : true,
        schemaId: (_v = o.schemaId) !== null && _v !== void 0 ? _v : "$id",
        addUsedSchema: (_w = o.addUsedSchema) !== null && _w !== void 0 ? _w : true,
        validateSchema: (_x = o.validateSchema) !== null && _x !== void 0 ? _x : true,
        validateFormats: (_y = o.validateFormats) !== null && _y !== void 0 ? _y : true,
        unicodeRegExp: (_z = o.unicodeRegExp) !== null && _z !== void 0 ? _z : true,
        int32range: (_0 = o.int32range) !== null && _0 !== void 0 ? _0 : true,
        uriResolver: uriResolver
    };
}
class $44c9e97a8f5af912$var$Ajv {
    _addVocabularies() {
        this.addKeyword("$async");
    }
    _addDefaultMetaSchema() {
        const { $data: $data, meta: meta, schemaId: schemaId } = this.opts;
        let _dataRefSchema = $RgrKG;
        if (schemaId === "id") {
            _dataRefSchema = {
                ...$RgrKG
            };
            _dataRefSchema.id = _dataRefSchema.$id;
            delete _dataRefSchema.$id;
        }
        if (meta && $data) this.addMetaSchema(_dataRefSchema, _dataRefSchema[schemaId], false);
    }
    defaultMeta() {
        const { meta: meta, schemaId: schemaId } = this.opts;
        return this.opts.defaultMeta = typeof meta == "object" ? meta[schemaId] || meta : undefined;
    }
    validate(schemaKeyRef, data // to be validated
    ) {
        let v;
        if (typeof schemaKeyRef == "string") {
            v = this.getSchema(schemaKeyRef);
            if (!v) throw new Error(`no schema with key or ref "${schemaKeyRef}"`);
        } else v = this.compile(schemaKeyRef);
        const valid = v(data);
        if (!("$async" in v)) this.errors = v.errors;
        return valid;
    }
    compile(schema, _meta) {
        const sch = this._addSchema(schema, _meta);
        return sch.validate || this._compileSchemaEnv(sch);
    }
    compileAsync(schema, meta) {
        if (typeof this.opts.loadSchema != "function") throw new Error("options.loadSchema should be a function");
        const { loadSchema: loadSchema } = this.opts;
        return runCompileAsync.call(this, schema, meta);
        async function runCompileAsync(_schema, _meta) {
            await loadMetaSchema.call(this, _schema.$schema);
            const sch = this._addSchema(_schema, _meta);
            return sch.validate || _compileAsync.call(this, sch);
        }
        async function loadMetaSchema($ref) {
            if ($ref && !this.getSchema($ref)) await runCompileAsync.call(this, {
                $ref: $ref
            }, true);
        }
        async function _compileAsync(sch) {
            try {
                return this._compileSchemaEnv(sch);
            } catch (e) {
                if (!(e instanceof $6XLO0.default)) throw e;
                checkLoaded.call(this, e);
                await loadMissingSchema.call(this, e.missingSchema);
                return _compileAsync.call(this, sch);
            }
        }
        function checkLoaded({ missingSchema: ref, missingRef: missingRef }) {
            if (this.refs[ref]) throw new Error(`AnySchema ${ref} is loaded but ${missingRef} cannot be resolved`);
        }
        async function loadMissingSchema(ref) {
            const _schema = await _loadSchema.call(this, ref);
            if (!this.refs[ref]) await loadMetaSchema.call(this, _schema.$schema);
            if (!this.refs[ref]) this.addSchema(_schema, ref, meta);
        }
        async function _loadSchema(ref) {
            const p = this._loading[ref];
            if (p) return p;
            try {
                return await (this._loading[ref] = loadSchema(ref));
            } finally{
                delete this._loading[ref];
            }
        }
    }
    // Adds schema to the instance
    addSchema(schema, key, _meta, _validateSchema = this.opts.validateSchema // false to skip schema validation. Used internally, option validateSchema should be used instead.
    ) {
        if (Array.isArray(schema)) {
            for (const sch of schema)this.addSchema(sch, undefined, _meta, _validateSchema);
            return this;
        }
        let id;
        if (typeof schema === "object") {
            const { schemaId: schemaId } = this.opts;
            id = schema[schemaId];
            if (id !== undefined && typeof id != "string") throw new Error(`schema ${schemaId} must be string`);
        }
        key = (0, $1Oy4e.normalizeId)(key || id);
        this._checkUnique(key);
        this.schemas[key] = this._addSchema(schema, _meta, key, _validateSchema, true);
        return this;
    }
    // Add schema that will be used to validate other schemas
    // options in META_IGNORE_OPTIONS are alway set to false
    addMetaSchema(schema, key, _validateSchema = this.opts.validateSchema // false to skip schema validation, can be used to override validateSchema option for meta-schema
    ) {
        this.addSchema(schema, key, true, _validateSchema);
        return this;
    }
    //  Validate schema against its meta-schema
    validateSchema(schema, throwOrLogError) {
        if (typeof schema == "boolean") return true;
        let $schema;
        $schema = schema.$schema;
        if ($schema !== undefined && typeof $schema != "string") throw new Error("$schema must be a string");
        $schema = $schema || this.opts.defaultMeta || this.defaultMeta();
        if (!$schema) {
            this.logger.warn("meta-schema not available");
            this.errors = null;
            return true;
        }
        const valid = this.validate($schema, schema);
        if (!valid && throwOrLogError) {
            const message = "schema is invalid: " + this.errorsText();
            if (this.opts.validateSchema === "log") this.logger.error(message);
            else throw new Error(message);
        }
        return valid;
    }
    // Get compiled schema by `key` or `ref`.
    // (`key` that was passed to `addSchema` or full schema reference - `schema.$id` or resolved id)
    getSchema(keyRef) {
        let sch;
        while(typeof (sch = $44c9e97a8f5af912$var$getSchEnv.call(this, keyRef)) == "string")keyRef = sch;
        if (sch === undefined) {
            const { schemaId: schemaId } = this.opts;
            const root = new $PkPFY.SchemaEnv({
                schema: {},
                schemaId: schemaId
            });
            sch = $PkPFY.resolveSchema.call(this, root, keyRef);
            if (!sch) return;
            this.refs[keyRef] = sch;
        }
        return sch.validate || this._compileSchemaEnv(sch);
    }
    // Remove cached schema(s).
    // If no parameter is passed all schemas but meta-schemas are removed.
    // If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
    // Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
    removeSchema(schemaKeyRef) {
        if (schemaKeyRef instanceof RegExp) {
            this._removeAllSchemas(this.schemas, schemaKeyRef);
            this._removeAllSchemas(this.refs, schemaKeyRef);
            return this;
        }
        switch(typeof schemaKeyRef){
            case "undefined":
                this._removeAllSchemas(this.schemas);
                this._removeAllSchemas(this.refs);
                this._cache.clear();
                return this;
            case "string":
                {
                    const sch = $44c9e97a8f5af912$var$getSchEnv.call(this, schemaKeyRef);
                    if (typeof sch == "object") this._cache.delete(sch.schema);
                    delete this.schemas[schemaKeyRef];
                    delete this.refs[schemaKeyRef];
                    return this;
                }
            case "object":
                {
                    const cacheKey = schemaKeyRef;
                    this._cache.delete(cacheKey);
                    let id = schemaKeyRef[this.opts.schemaId];
                    if (id) {
                        id = (0, $1Oy4e.normalizeId)(id);
                        delete this.schemas[id];
                        delete this.refs[id];
                    }
                    return this;
                }
            default:
                throw new Error("ajv.removeSchema: invalid parameter");
        }
    }
    // add "vocabulary" - a collection of keywords
    addVocabulary(definitions) {
        for (const def of definitions)this.addKeyword(def);
        return this;
    }
    addKeyword(kwdOrDef, def // deprecated
    ) {
        let keyword;
        if (typeof kwdOrDef == "string") {
            keyword = kwdOrDef;
            if (typeof def == "object") {
                this.logger.warn("these parameters are deprecated, see docs for addKeyword");
                def.keyword = keyword;
            }
        } else if (typeof kwdOrDef == "object" && def === undefined) {
            def = kwdOrDef;
            keyword = def.keyword;
            if (Array.isArray(keyword) && !keyword.length) throw new Error("addKeywords: keyword must be string or non-empty array");
        } else throw new Error("invalid addKeywords parameters");
        $44c9e97a8f5af912$var$checkKeyword.call(this, keyword, def);
        if (!def) {
            (0, $k2074.eachItem)(keyword, (kwd)=>$44c9e97a8f5af912$var$addRule.call(this, kwd));
            return this;
        }
        $44c9e97a8f5af912$var$keywordMetaschema.call(this, def);
        const definition = {
            ...def,
            type: (0, $5jmf7.getJSONTypes)(def.type),
            schemaType: (0, $5jmf7.getJSONTypes)(def.schemaType)
        };
        (0, $k2074.eachItem)(keyword, definition.type.length === 0 ? (k)=>$44c9e97a8f5af912$var$addRule.call(this, k, definition) : (k)=>definition.type.forEach((t)=>$44c9e97a8f5af912$var$addRule.call(this, k, definition, t)));
        return this;
    }
    getKeyword(keyword) {
        const rule = this.RULES.all[keyword];
        return typeof rule == "object" ? rule.definition : !!rule;
    }
    // Remove keyword
    removeKeyword(keyword) {
        // TODO return type should be Ajv
        const { RULES: RULES } = this;
        delete RULES.keywords[keyword];
        delete RULES.all[keyword];
        for (const group of RULES.rules){
            const i = group.rules.findIndex((rule)=>rule.keyword === keyword);
            if (i >= 0) group.rules.splice(i, 1);
        }
        return this;
    }
    // Add format
    addFormat(name, format) {
        if (typeof format == "string") format = new RegExp(format);
        this.formats[name] = format;
        return this;
    }
    errorsText(errors = this.errors, { separator: separator = ", ", dataVar: dataVar = "data" } = {} // optional options with properties `separator` and `dataVar`
    ) {
        if (!errors || errors.length === 0) return "No errors";
        return errors.map((e)=>`${dataVar}${e.instancePath} ${e.message}`).reduce((text, msg)=>text + separator + msg);
    }
    $dataMetaSchema(metaSchema, keywordsJsonPointers) {
        const rules = this.RULES.all;
        metaSchema = JSON.parse(JSON.stringify(metaSchema));
        for (const jsonPointer of keywordsJsonPointers){
            const segments = jsonPointer.split("/").slice(1); // first segment is an empty string
            let keywords = metaSchema;
            for (const seg of segments)keywords = keywords[seg];
            for(const key in rules){
                const rule = rules[key];
                if (typeof rule != "object") continue;
                const { $data: $data } = rule.definition;
                const schema = keywords[key];
                if ($data && schema) keywords[key] = $44c9e97a8f5af912$var$schemaOrData(schema);
            }
        }
        return metaSchema;
    }
    _removeAllSchemas(schemas, regex) {
        for(const keyRef in schemas){
            const sch = schemas[keyRef];
            if (!regex || regex.test(keyRef)) {
                if (typeof sch == "string") delete schemas[keyRef];
                else if (sch && !sch.meta) {
                    this._cache.delete(sch.schema);
                    delete schemas[keyRef];
                }
            }
        }
    }
    _addSchema(schema, meta, baseId, validateSchema = this.opts.validateSchema, addSchema = this.opts.addUsedSchema) {
        let id;
        const { schemaId: schemaId } = this.opts;
        if (typeof schema == "object") id = schema[schemaId];
        else {
            if (this.opts.jtd) throw new Error("schema must be object");
            else if (typeof schema != "boolean") throw new Error("schema must be object or boolean");
        }
        let sch = this._cache.get(schema);
        if (sch !== undefined) return sch;
        baseId = (0, $1Oy4e.normalizeId)(id || baseId);
        const localRefs = $1Oy4e.getSchemaRefs.call(this, schema, baseId);
        sch = new $PkPFY.SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            meta: meta,
            baseId: baseId,
            localRefs: localRefs
        });
        this._cache.set(sch.schema, sch);
        if (addSchema && !baseId.startsWith("#")) {
            // TODO atm it is allowed to overwrite schemas without id (instead of not adding them)
            if (baseId) this._checkUnique(baseId);
            this.refs[baseId] = sch;
        }
        if (validateSchema) this.validateSchema(schema, true);
        return sch;
    }
    _checkUnique(id) {
        if (this.schemas[id] || this.refs[id]) throw new Error(`schema with key or id "${id}" already exists`);
    }
    _compileSchemaEnv(sch) {
        if (sch.meta) this._compileMetaSchema(sch);
        else $PkPFY.compileSchema.call(this, sch);
        /* istanbul ignore if */ if (!sch.validate) throw new Error("ajv implementation error");
        return sch.validate;
    }
    _compileMetaSchema(sch) {
        const currentOpts = this.opts;
        this.opts = this._metaOpts;
        try {
            $PkPFY.compileSchema.call(this, sch);
        } finally{
            this.opts = currentOpts;
        }
    }
    constructor(opts = {}){
        this.schemas = {};
        this.refs = {};
        this.formats = {};
        this._compilations = new Set();
        this._loading = {};
        this._cache = new Map();
        opts = this.opts = {
            ...opts,
            ...$44c9e97a8f5af912$var$requiredOptions(opts)
        };
        const { es5: es5, lines: lines } = this.opts.code;
        this.scope = new $6Vb5F.ValueScope({
            scope: {},
            prefixes: $44c9e97a8f5af912$var$EXT_SCOPE_NAMES,
            es5: es5,
            lines: lines
        });
        this.logger = $44c9e97a8f5af912$var$getLogger(opts.logger);
        const formatOpt = opts.validateFormats;
        opts.validateFormats = false;
        this.RULES = (0, $j5Abb.getRules)();
        $44c9e97a8f5af912$var$checkOptions.call(this, $44c9e97a8f5af912$var$removedOptions, opts, "NOT SUPPORTED");
        $44c9e97a8f5af912$var$checkOptions.call(this, $44c9e97a8f5af912$var$deprecatedOptions, opts, "DEPRECATED", "warn");
        this._metaOpts = $44c9e97a8f5af912$var$getMetaSchemaOptions.call(this);
        if (opts.formats) $44c9e97a8f5af912$var$addInitialFormats.call(this);
        this._addVocabularies();
        this._addDefaultMetaSchema();
        if (opts.keywords) $44c9e97a8f5af912$var$addInitialKeywords.call(this, opts.keywords);
        if (typeof opts.meta == "object") this.addMetaSchema(opts.meta);
        $44c9e97a8f5af912$var$addInitialSchemas.call(this);
        opts.validateFormats = formatOpt;
    }
}
module.exports.default = $44c9e97a8f5af912$var$Ajv;
$44c9e97a8f5af912$var$Ajv.ValidationError = $iM4Un.default;
$44c9e97a8f5af912$var$Ajv.MissingRefError = $6XLO0.default;
function $44c9e97a8f5af912$var$checkOptions(checkOpts, options, msg, log = "error") {
    for(const key in checkOpts){
        const opt = key;
        if (opt in options) this.logger[log](`${msg}: option ${key}. ${checkOpts[opt]}`);
    }
}
function $44c9e97a8f5af912$var$getSchEnv(keyRef) {
    keyRef = (0, $1Oy4e.normalizeId)(keyRef); // TODO tests fail without this line
    return this.schemas[keyRef] || this.refs[keyRef];
}
function $44c9e97a8f5af912$var$addInitialSchemas() {
    const optsSchemas = this.opts.schemas;
    if (!optsSchemas) return;
    if (Array.isArray(optsSchemas)) this.addSchema(optsSchemas);
    else for(const key in optsSchemas)this.addSchema(optsSchemas[key], key);
}
function $44c9e97a8f5af912$var$addInitialFormats() {
    for(const name in this.opts.formats){
        const format = this.opts.formats[name];
        if (format) this.addFormat(name, format);
    }
}
function $44c9e97a8f5af912$var$addInitialKeywords(defs) {
    if (Array.isArray(defs)) {
        this.addVocabulary(defs);
        return;
    }
    this.logger.warn("keywords option as map is deprecated, pass array");
    for(const keyword in defs){
        const def = defs[keyword];
        if (!def.keyword) def.keyword = keyword;
        this.addKeyword(def);
    }
}
function $44c9e97a8f5af912$var$getMetaSchemaOptions() {
    const metaOpts = {
        ...this.opts
    };
    for (const opt of $44c9e97a8f5af912$var$META_IGNORE_OPTIONS)delete metaOpts[opt];
    return metaOpts;
}
const $44c9e97a8f5af912$var$noLogs = {
    log () {},
    warn () {},
    error () {}
};
function $44c9e97a8f5af912$var$getLogger(logger) {
    if (logger === false) return $44c9e97a8f5af912$var$noLogs;
    if (logger === undefined) return console;
    if (logger.log && logger.warn && logger.error) return logger;
    throw new Error("logger must implement log, warn and error methods");
}
const $44c9e97a8f5af912$var$KEYWORD_NAME = /^[a-z_$][a-z0-9_$:-]*$/i;
function $44c9e97a8f5af912$var$checkKeyword(keyword, def) {
    const { RULES: RULES } = this;
    (0, $k2074.eachItem)(keyword, (kwd)=>{
        if (RULES.keywords[kwd]) throw new Error(`Keyword ${kwd} is already defined`);
        if (!$44c9e97a8f5af912$var$KEYWORD_NAME.test(kwd)) throw new Error(`Keyword ${kwd} has invalid name`);
    });
    if (!def) return;
    if (def.$data && !("code" in def || "validate" in def)) throw new Error('$data keyword must have "code" or "validate" function');
}
function $44c9e97a8f5af912$var$addRule(keyword, definition, dataType) {
    var _a;
    const post = definition === null || definition === void 0 ? void 0 : definition.post;
    if (dataType && post) throw new Error('keyword with "post" flag cannot have "type"');
    const { RULES: RULES } = this;
    let ruleGroup = post ? RULES.post : RULES.rules.find(({ type: t })=>t === dataType);
    if (!ruleGroup) {
        ruleGroup = {
            type: dataType,
            rules: []
        };
        RULES.rules.push(ruleGroup);
    }
    RULES.keywords[keyword] = true;
    if (!definition) return;
    const rule = {
        keyword: keyword,
        definition: {
            ...definition,
            type: (0, $5jmf7.getJSONTypes)(definition.type),
            schemaType: (0, $5jmf7.getJSONTypes)(definition.schemaType)
        }
    };
    if (definition.before) $44c9e97a8f5af912$var$addBeforeRule.call(this, ruleGroup, rule, definition.before);
    else ruleGroup.rules.push(rule);
    RULES.all[keyword] = rule;
    (_a = definition.implements) === null || _a === void 0 || _a.forEach((kwd)=>this.addKeyword(kwd));
}
function $44c9e97a8f5af912$var$addBeforeRule(ruleGroup, rule, before) {
    const i = ruleGroup.rules.findIndex((_rule)=>_rule.keyword === before);
    if (i >= 0) ruleGroup.rules.splice(i, 0, rule);
    else {
        ruleGroup.rules.push(rule);
        this.logger.warn(`rule ${before} is not defined`);
    }
}
function $44c9e97a8f5af912$var$keywordMetaschema(def) {
    let { metaSchema: metaSchema } = def;
    if (metaSchema === undefined) return;
    if (def.$data && this.opts.$data) metaSchema = $44c9e97a8f5af912$var$schemaOrData(metaSchema);
    def.validateSchema = this.compile(metaSchema, true);
}
const $44c9e97a8f5af912$var$$dataRef = {
    $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
};
function $44c9e97a8f5af912$var$schemaOrData(schema) {
    return {
        anyOf: [
            schema,
            $44c9e97a8f5af912$var$$dataRef
        ]
    };
}

});
parcelRequire.register("6DSbS", function(module, exports) {
"use strict";
let $4d606bbbe8055188$var$_ = (t)=>t, $4d606bbbe8055188$var$t, $4d606bbbe8055188$var$t1, $4d606bbbe8055188$var$t2, $4d606bbbe8055188$var$t3, $4d606bbbe8055188$var$t4, $4d606bbbe8055188$var$t5, $4d606bbbe8055188$var$t6, $4d606bbbe8055188$var$t7, $4d606bbbe8055188$var$t8, $4d606bbbe8055188$var$t9, $4d606bbbe8055188$var$t10, $4d606bbbe8055188$var$t11, $4d606bbbe8055188$var$t12, $4d606bbbe8055188$var$t13, $4d606bbbe8055188$var$t14, $4d606bbbe8055188$var$t15, $4d606bbbe8055188$var$t16, $4d606bbbe8055188$var$t17, $4d606bbbe8055188$var$t18, $4d606bbbe8055188$var$t19, $4d606bbbe8055188$var$t20, $4d606bbbe8055188$var$t21, $4d606bbbe8055188$var$t22, $4d606bbbe8055188$var$t23, $4d606bbbe8055188$var$t24, $4d606bbbe8055188$var$t25, $4d606bbbe8055188$var$t26, $4d606bbbe8055188$var$t27, $4d606bbbe8055188$var$t28, $4d606bbbe8055188$var$t29, $4d606bbbe8055188$var$t30, $4d606bbbe8055188$var$t31, $4d606bbbe8055188$var$t32, $4d606bbbe8055188$var$t33, $4d606bbbe8055188$var$t34, $4d606bbbe8055188$var$t35, $4d606bbbe8055188$var$t36, $4d606bbbe8055188$var$t37, $4d606bbbe8055188$var$t38;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getData = module.exports.KeywordCxt = module.exports.validateFunctionCode = void 0;

var $jmiRE = parcelRequire("jmiRE");

var $5jmf7 = parcelRequire("5jmf7");

var $5g9SJ = parcelRequire("5g9SJ");

var $5jmf7 = parcelRequire("5jmf7");

var $6MDI7 = parcelRequire("6MDI7");

var $Emq0w = parcelRequire("Emq0w");

var $9KkQJ = parcelRequire("9KkQJ");

var $6Vb5F = parcelRequire("6Vb5F");

var $eXNSw = parcelRequire("eXNSw");

var $1Oy4e = parcelRequire("1Oy4e");

var $k2074 = parcelRequire("k2074");

var $lWojU = parcelRequire("lWojU");
// schema compilation - generates validation function, subschemaCode (below) is used for subschemas
function $4d606bbbe8055188$var$validateFunctionCode(it) {
    if ($4d606bbbe8055188$var$isSchemaObj(it)) {
        $4d606bbbe8055188$var$checkKeywords(it);
        if ($4d606bbbe8055188$var$schemaCxtHasRules(it)) {
            $4d606bbbe8055188$var$topSchemaObjCode(it);
            return;
        }
    }
    $4d606bbbe8055188$var$validateFunction(it, ()=>(0, $jmiRE.topBoolOrEmptySchema)(it));
}
module.exports.validateFunctionCode = $4d606bbbe8055188$var$validateFunctionCode;
function $4d606bbbe8055188$var$validateFunction({ gen: gen, validateName: validateName, schema: schema, schemaEnv: schemaEnv, opts: opts }, body) {
    if (opts.code.es5) gen.func(validateName, (0, $6Vb5F._)($4d606bbbe8055188$var$t || ($4d606bbbe8055188$var$t = $4d606bbbe8055188$var$_`${0}, ${0}`), $eXNSw.default.data, $eXNSw.default.valCxt), schemaEnv.$async, ()=>{
        gen.code((0, $6Vb5F._)($4d606bbbe8055188$var$t1 || ($4d606bbbe8055188$var$t1 = $4d606bbbe8055188$var$_`"use strict"; ${0}`), $4d606bbbe8055188$var$funcSourceUrl(schema, opts)));
        $4d606bbbe8055188$var$destructureValCxtES5(gen, opts);
        gen.code(body);
    });
    else gen.func(validateName, (0, $6Vb5F._)($4d606bbbe8055188$var$t2 || ($4d606bbbe8055188$var$t2 = $4d606bbbe8055188$var$_`${0}, ${0}`), $eXNSw.default.data, $4d606bbbe8055188$var$destructureValCxt(opts)), schemaEnv.$async, ()=>gen.code($4d606bbbe8055188$var$funcSourceUrl(schema, opts)).code(body));
}
function $4d606bbbe8055188$var$destructureValCxt(opts) {
    return (0, $6Vb5F._)($4d606bbbe8055188$var$t4 || ($4d606bbbe8055188$var$t4 = $4d606bbbe8055188$var$_`{${0}="", ${0}, ${0}, ${0}=${0}${0}}={}`), $eXNSw.default.instancePath, $eXNSw.default.parentData, $eXNSw.default.parentDataProperty, $eXNSw.default.rootData, $eXNSw.default.data, opts.dynamicRef ? (0, $6Vb5F._)($4d606bbbe8055188$var$t3 || ($4d606bbbe8055188$var$t3 = $4d606bbbe8055188$var$_`, ${0}={}`), $eXNSw.default.dynamicAnchors) : $6Vb5F.nil);
}
function $4d606bbbe8055188$var$destructureValCxtES5(gen, opts) {
    gen.if($eXNSw.default.valCxt, ()=>{
        gen.var($eXNSw.default.instancePath, (0, $6Vb5F._)($4d606bbbe8055188$var$t5 || ($4d606bbbe8055188$var$t5 = $4d606bbbe8055188$var$_`${0}.${0}`), $eXNSw.default.valCxt, $eXNSw.default.instancePath));
        gen.var($eXNSw.default.parentData, (0, $6Vb5F._)($4d606bbbe8055188$var$t6 || ($4d606bbbe8055188$var$t6 = $4d606bbbe8055188$var$_`${0}.${0}`), $eXNSw.default.valCxt, $eXNSw.default.parentData));
        gen.var($eXNSw.default.parentDataProperty, (0, $6Vb5F._)($4d606bbbe8055188$var$t7 || ($4d606bbbe8055188$var$t7 = $4d606bbbe8055188$var$_`${0}.${0}`), $eXNSw.default.valCxt, $eXNSw.default.parentDataProperty));
        gen.var($eXNSw.default.rootData, (0, $6Vb5F._)($4d606bbbe8055188$var$t8 || ($4d606bbbe8055188$var$t8 = $4d606bbbe8055188$var$_`${0}.${0}`), $eXNSw.default.valCxt, $eXNSw.default.rootData));
        if (opts.dynamicRef) gen.var($eXNSw.default.dynamicAnchors, (0, $6Vb5F._)($4d606bbbe8055188$var$t9 || ($4d606bbbe8055188$var$t9 = $4d606bbbe8055188$var$_`${0}.${0}`), $eXNSw.default.valCxt, $eXNSw.default.dynamicAnchors));
    }, ()=>{
        gen.var($eXNSw.default.instancePath, (0, $6Vb5F._)($4d606bbbe8055188$var$t10 || ($4d606bbbe8055188$var$t10 = $4d606bbbe8055188$var$_`""`)));
        gen.var($eXNSw.default.parentData, (0, $6Vb5F._)($4d606bbbe8055188$var$t11 || ($4d606bbbe8055188$var$t11 = $4d606bbbe8055188$var$_`undefined`)));
        gen.var($eXNSw.default.parentDataProperty, (0, $6Vb5F._)($4d606bbbe8055188$var$t12 || ($4d606bbbe8055188$var$t12 = $4d606bbbe8055188$var$_`undefined`)));
        gen.var($eXNSw.default.rootData, $eXNSw.default.data);
        if (opts.dynamicRef) gen.var($eXNSw.default.dynamicAnchors, (0, $6Vb5F._)($4d606bbbe8055188$var$t13 || ($4d606bbbe8055188$var$t13 = $4d606bbbe8055188$var$_`{}`)));
    });
}
function $4d606bbbe8055188$var$topSchemaObjCode(it) {
    const { schema: schema, opts: opts, gen: gen } = it;
    $4d606bbbe8055188$var$validateFunction(it, ()=>{
        if (opts.$comment && schema.$comment) $4d606bbbe8055188$var$commentKeyword(it);
        $4d606bbbe8055188$var$checkNoDefault(it);
        gen.let($eXNSw.default.vErrors, null);
        gen.let($eXNSw.default.errors, 0);
        if (opts.unevaluated) $4d606bbbe8055188$var$resetEvaluated(it);
        $4d606bbbe8055188$var$typeAndKeywords(it);
        $4d606bbbe8055188$var$returnResults(it);
    });
    return;
}
function $4d606bbbe8055188$var$resetEvaluated(it) {
    // TODO maybe some hook to execute it in the end to check whether props/items are Name, as in assignEvaluated
    const { gen: gen, validateName: validateName } = it;
    it.evaluated = gen.const("evaluated", (0, $6Vb5F._)($4d606bbbe8055188$var$t14 || ($4d606bbbe8055188$var$t14 = $4d606bbbe8055188$var$_`${0}.evaluated`), validateName));
    gen.if((0, $6Vb5F._)($4d606bbbe8055188$var$t15 || ($4d606bbbe8055188$var$t15 = $4d606bbbe8055188$var$_`${0}.dynamicProps`), it.evaluated), ()=>gen.assign((0, $6Vb5F._)($4d606bbbe8055188$var$t16 || ($4d606bbbe8055188$var$t16 = $4d606bbbe8055188$var$_`${0}.props`), it.evaluated), (0, $6Vb5F._)($4d606bbbe8055188$var$t17 || ($4d606bbbe8055188$var$t17 = $4d606bbbe8055188$var$_`undefined`))));
    gen.if((0, $6Vb5F._)($4d606bbbe8055188$var$t18 || ($4d606bbbe8055188$var$t18 = $4d606bbbe8055188$var$_`${0}.dynamicItems`), it.evaluated), ()=>gen.assign((0, $6Vb5F._)($4d606bbbe8055188$var$t19 || ($4d606bbbe8055188$var$t19 = $4d606bbbe8055188$var$_`${0}.items`), it.evaluated), (0, $6Vb5F._)($4d606bbbe8055188$var$t20 || ($4d606bbbe8055188$var$t20 = $4d606bbbe8055188$var$_`undefined`))));
}
function $4d606bbbe8055188$var$funcSourceUrl(schema, opts) {
    const schId = typeof schema == "object" && schema[opts.schemaId];
    return schId && (opts.code.source || opts.code.process) ? (0, $6Vb5F._)($4d606bbbe8055188$var$t21 || ($4d606bbbe8055188$var$t21 = $4d606bbbe8055188$var$_`/*# sourceURL=${0} */`), schId) : $6Vb5F.nil;
}
// schema compilation - this function is used recursively to generate code for sub-schemas
function $4d606bbbe8055188$var$subschemaCode(it, valid) {
    if ($4d606bbbe8055188$var$isSchemaObj(it)) {
        $4d606bbbe8055188$var$checkKeywords(it);
        if ($4d606bbbe8055188$var$schemaCxtHasRules(it)) {
            $4d606bbbe8055188$var$subSchemaObjCode(it, valid);
            return;
        }
    }
    (0, $jmiRE.boolOrEmptySchema)(it, valid);
}
function $4d606bbbe8055188$var$schemaCxtHasRules({ schema: schema, self: self }) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (self.RULES.all[key]) return true;
    return false;
}
function $4d606bbbe8055188$var$isSchemaObj(it) {
    return typeof it.schema != "boolean";
}
function $4d606bbbe8055188$var$subSchemaObjCode(it, valid) {
    const { schema: schema, gen: gen, opts: opts } = it;
    if (opts.$comment && schema.$comment) $4d606bbbe8055188$var$commentKeyword(it);
    $4d606bbbe8055188$var$updateContext(it);
    $4d606bbbe8055188$var$checkAsyncSchema(it);
    const errsCount = gen.const("_errs", $eXNSw.default.errors);
    $4d606bbbe8055188$var$typeAndKeywords(it, errsCount);
    // TODO var
    gen.var(valid, (0, $6Vb5F._)($4d606bbbe8055188$var$t22 || ($4d606bbbe8055188$var$t22 = $4d606bbbe8055188$var$_`${0} === ${0}`), errsCount, $eXNSw.default.errors));
}
function $4d606bbbe8055188$var$checkKeywords(it) {
    (0, $k2074.checkUnknownRules)(it);
    $4d606bbbe8055188$var$checkRefsAndKeywords(it);
}
function $4d606bbbe8055188$var$typeAndKeywords(it, errsCount) {
    if (it.opts.jtd) return $4d606bbbe8055188$var$schemaKeywords(it, [], false, errsCount);
    const types = (0, $5jmf7.getSchemaTypes)(it.schema);
    const checkedTypes = (0, $5jmf7.coerceAndCheckDataType)(it, types);
    $4d606bbbe8055188$var$schemaKeywords(it, types, !checkedTypes, errsCount);
}
function $4d606bbbe8055188$var$checkRefsAndKeywords(it) {
    const { schema: schema, errSchemaPath: errSchemaPath, opts: opts, self: self } = it;
    if (schema.$ref && opts.ignoreKeywordsWithRef && (0, $k2074.schemaHasRulesButRef)(schema, self.RULES)) self.logger.warn(`$ref: keywords ignored in schema at path "${errSchemaPath}"`);
}
function $4d606bbbe8055188$var$checkNoDefault(it) {
    const { schema: schema, opts: opts } = it;
    if (schema.default !== undefined && opts.useDefaults && opts.strictSchema) (0, $k2074.checkStrictMode)(it, "default is ignored in the schema root");
}
function $4d606bbbe8055188$var$updateContext(it) {
    const schId = it.schema[it.opts.schemaId];
    if (schId) it.baseId = (0, $1Oy4e.resolveUrl)(it.opts.uriResolver, it.baseId, schId);
}
function $4d606bbbe8055188$var$checkAsyncSchema(it) {
    if (it.schema.$async && !it.schemaEnv.$async) throw new Error("async schema in sync schema");
}
function $4d606bbbe8055188$var$commentKeyword({ gen: gen, schemaEnv: schemaEnv, schema: schema, errSchemaPath: errSchemaPath, opts: opts }) {
    const msg = schema.$comment;
    if (opts.$comment === true) gen.code((0, $6Vb5F._)($4d606bbbe8055188$var$t23 || ($4d606bbbe8055188$var$t23 = $4d606bbbe8055188$var$_`${0}.logger.log(${0})`), $eXNSw.default.self, msg));
    else if (typeof opts.$comment == "function") {
        const schemaPath = (0, $6Vb5F.str)($4d606bbbe8055188$var$t24 || ($4d606bbbe8055188$var$t24 = $4d606bbbe8055188$var$_`${0}/$comment`), errSchemaPath);
        const rootName = gen.scopeValue("root", {
            ref: schemaEnv.root
        });
        gen.code((0, $6Vb5F._)($4d606bbbe8055188$var$t25 || ($4d606bbbe8055188$var$t25 = $4d606bbbe8055188$var$_`${0}.opts.$comment(${0}, ${0}, ${0}.schema)`), $eXNSw.default.self, msg, schemaPath, rootName));
    }
}
function $4d606bbbe8055188$var$returnResults(it) {
    const { gen: gen, schemaEnv: schemaEnv, validateName: validateName, ValidationError: ValidationError, opts: opts } = it;
    if (schemaEnv.$async) // TODO assign unevaluated
    gen.if((0, $6Vb5F._)($4d606bbbe8055188$var$t26 || ($4d606bbbe8055188$var$t26 = $4d606bbbe8055188$var$_`${0} === 0`), $eXNSw.default.errors), ()=>gen.return($eXNSw.default.data), ()=>gen.throw((0, $6Vb5F._)($4d606bbbe8055188$var$t27 || ($4d606bbbe8055188$var$t27 = $4d606bbbe8055188$var$_`new ${0}(${0})`), ValidationError, $eXNSw.default.vErrors)));
    else {
        gen.assign((0, $6Vb5F._)($4d606bbbe8055188$var$t28 || ($4d606bbbe8055188$var$t28 = $4d606bbbe8055188$var$_`${0}.errors`), validateName), $eXNSw.default.vErrors);
        if (opts.unevaluated) $4d606bbbe8055188$var$assignEvaluated(it);
        gen.return((0, $6Vb5F._)($4d606bbbe8055188$var$t29 || ($4d606bbbe8055188$var$t29 = $4d606bbbe8055188$var$_`${0} === 0`), $eXNSw.default.errors));
    }
}
function $4d606bbbe8055188$var$assignEvaluated({ gen: gen, evaluated: evaluated, props: props, items: items }) {
    if (props instanceof $6Vb5F.Name) gen.assign((0, $6Vb5F._)($4d606bbbe8055188$var$t30 || ($4d606bbbe8055188$var$t30 = $4d606bbbe8055188$var$_`${0}.props`), evaluated), props);
    if (items instanceof $6Vb5F.Name) gen.assign((0, $6Vb5F._)($4d606bbbe8055188$var$t31 || ($4d606bbbe8055188$var$t31 = $4d606bbbe8055188$var$_`${0}.items`), evaluated), items);
}
function $4d606bbbe8055188$var$schemaKeywords(it, types, typeErrors, errsCount) {
    const { gen: gen, schema: schema, data: data, allErrors: allErrors, opts: opts, self: self } = it;
    const { RULES: RULES } = self;
    if (schema.$ref && (opts.ignoreKeywordsWithRef || !(0, $k2074.schemaHasRulesButRef)(schema, RULES))) {
        gen.block(()=>$4d606bbbe8055188$var$keywordCode(it, "$ref", RULES.all.$ref.definition)); // TODO typecast
        return;
    }
    if (!opts.jtd) $4d606bbbe8055188$var$checkStrictTypes(it, types);
    gen.block(()=>{
        for (const group of RULES.rules)groupKeywords(group);
        groupKeywords(RULES.post);
    });
    function groupKeywords(group) {
        if (!(0, $5g9SJ.shouldUseGroup)(schema, group)) return;
        if (group.type) {
            gen.if((0, $5jmf7.checkDataType)(group.type, data, opts.strictNumbers));
            $4d606bbbe8055188$var$iterateKeywords(it, group);
            if (types.length === 1 && types[0] === group.type && typeErrors) {
                gen.else();
                (0, $5jmf7.reportTypeError)(it);
            }
            gen.endIf();
        } else $4d606bbbe8055188$var$iterateKeywords(it, group);
        // TODO make it "ok" call?
        if (!allErrors) gen.if((0, $6Vb5F._)($4d606bbbe8055188$var$t32 || ($4d606bbbe8055188$var$t32 = $4d606bbbe8055188$var$_`${0} === ${0}`), $eXNSw.default.errors, errsCount || 0));
    }
}
function $4d606bbbe8055188$var$iterateKeywords(it, group) {
    const { gen: gen, schema: schema, opts: { useDefaults: useDefaults } } = it;
    if (useDefaults) (0, $6MDI7.assignDefaults)(it, group.type);
    gen.block(()=>{
        for (const rule of group.rules)if ((0, $5g9SJ.shouldUseRule)(schema, rule)) $4d606bbbe8055188$var$keywordCode(it, rule.keyword, rule.definition, group.type);
    });
}
function $4d606bbbe8055188$var$checkStrictTypes(it, types) {
    if (it.schemaEnv.meta || !it.opts.strictTypes) return;
    $4d606bbbe8055188$var$checkContextTypes(it, types);
    if (!it.opts.allowUnionTypes) $4d606bbbe8055188$var$checkMultipleTypes(it, types);
    $4d606bbbe8055188$var$checkKeywordTypes(it, it.dataTypes);
}
function $4d606bbbe8055188$var$checkContextTypes(it, types) {
    if (!types.length) return;
    if (!it.dataTypes.length) {
        it.dataTypes = types;
        return;
    }
    types.forEach((t)=>{
        if (!$4d606bbbe8055188$var$includesType(it.dataTypes, t)) $4d606bbbe8055188$var$strictTypesError(it, `type "${t}" not allowed by context "${it.dataTypes.join(",")}"`);
    });
    $4d606bbbe8055188$var$narrowSchemaTypes(it, types);
}
function $4d606bbbe8055188$var$checkMultipleTypes(it, ts) {
    if (ts.length > 1 && !(ts.length === 2 && ts.includes("null"))) $4d606bbbe8055188$var$strictTypesError(it, "use allowUnionTypes to allow union type keyword");
}
function $4d606bbbe8055188$var$checkKeywordTypes(it, ts) {
    const rules = it.self.RULES.all;
    for(const keyword in rules){
        const rule = rules[keyword];
        if (typeof rule == "object" && (0, $5g9SJ.shouldUseRule)(it.schema, rule)) {
            const { type: type } = rule.definition;
            if (type.length && !type.some((t)=>$4d606bbbe8055188$var$hasApplicableType(ts, t))) $4d606bbbe8055188$var$strictTypesError(it, `missing type "${type.join(",")}" for keyword "${keyword}"`);
        }
    }
}
function $4d606bbbe8055188$var$hasApplicableType(schTs, kwdT) {
    return schTs.includes(kwdT) || kwdT === "number" && schTs.includes("integer");
}
function $4d606bbbe8055188$var$includesType(ts, t) {
    return ts.includes(t) || t === "integer" && ts.includes("number");
}
function $4d606bbbe8055188$var$narrowSchemaTypes(it, withTypes) {
    const ts = [];
    for (const t of it.dataTypes){
        if ($4d606bbbe8055188$var$includesType(withTypes, t)) ts.push(t);
        else if (withTypes.includes("integer") && t === "number") ts.push("integer");
    }
    it.dataTypes = ts;
}
function $4d606bbbe8055188$var$strictTypesError(it, msg) {
    const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
    msg += ` at "${schemaPath}" (strictTypes)`;
    (0, $k2074.checkStrictMode)(it, msg, it.opts.strictTypes);
}
class $4d606bbbe8055188$var$KeywordCxt {
    result(condition, successAction, failAction) {
        this.failResult((0, $6Vb5F.not)(condition), successAction, failAction);
    }
    failResult(condition, successAction, failAction) {
        this.gen.if(condition);
        if (failAction) failAction();
        else this.error();
        if (successAction) {
            this.gen.else();
            successAction();
            if (this.allErrors) this.gen.endIf();
        } else if (this.allErrors) this.gen.endIf();
        else this.gen.else();
    }
    pass(condition, failAction) {
        this.failResult((0, $6Vb5F.not)(condition), undefined, failAction);
    }
    fail(condition) {
        if (condition === undefined) {
            this.error();
            if (!this.allErrors) this.gen.if(false); // this branch will be removed by gen.optimize
            return;
        }
        this.gen.if(condition);
        this.error();
        if (this.allErrors) this.gen.endIf();
        else this.gen.else();
    }
    fail$data(condition) {
        if (!this.$data) return this.fail(condition);
        const { schemaCode: schemaCode } = this;
        this.fail((0, $6Vb5F._)($4d606bbbe8055188$var$t33 || ($4d606bbbe8055188$var$t33 = $4d606bbbe8055188$var$_`${0} !== undefined && (${0})`), schemaCode, (0, $6Vb5F.or)(this.invalid$data(), condition)));
    }
    error(append, errorParams, errorPaths) {
        if (errorParams) {
            this.setParams(errorParams);
            this._error(append, errorPaths);
            this.setParams({});
            return;
        }
        this._error(append, errorPaths);
    }
    _error(append, errorPaths) {
        (append ? $lWojU.reportExtraError : $lWojU.reportError)(this, this.def.error, errorPaths);
    }
    $dataError() {
        (0, $lWojU.reportError)(this, this.def.$dataError || $lWojU.keyword$DataError);
    }
    reset() {
        if (this.errsCount === undefined) throw new Error('add "trackErrors" to keyword definition');
        (0, $lWojU.resetErrorsCount)(this.gen, this.errsCount);
    }
    ok(cond) {
        if (!this.allErrors) this.gen.if(cond);
    }
    setParams(obj, assign) {
        if (assign) Object.assign(this.params, obj);
        else this.params = obj;
    }
    block$data(valid, codeBlock, $dataValid = $6Vb5F.nil) {
        this.gen.block(()=>{
            this.check$data(valid, $dataValid);
            codeBlock();
        });
    }
    check$data(valid = $6Vb5F.nil, $dataValid = $6Vb5F.nil) {
        if (!this.$data) return;
        const { gen: gen, schemaCode: schemaCode, schemaType: schemaType, def: def } = this;
        gen.if((0, $6Vb5F.or)((0, $6Vb5F._)($4d606bbbe8055188$var$t34 || ($4d606bbbe8055188$var$t34 = $4d606bbbe8055188$var$_`${0} === undefined`), schemaCode), $dataValid));
        if (valid !== $6Vb5F.nil) gen.assign(valid, true);
        if (schemaType.length || def.validateSchema) {
            gen.elseIf(this.invalid$data());
            this.$dataError();
            if (valid !== $6Vb5F.nil) gen.assign(valid, false);
        }
        gen.else();
    }
    invalid$data() {
        const { gen: gen, schemaCode: schemaCode, schemaType: schemaType, def: def, it: it } = this;
        return (0, $6Vb5F.or)(wrong$DataType(), invalid$DataSchema());
        function wrong$DataType() {
            if (schemaType.length) {
                /* istanbul ignore if */ if (!(schemaCode instanceof $6Vb5F.Name)) throw new Error("ajv implementation error");
                const st = Array.isArray(schemaType) ? schemaType : [
                    schemaType
                ];
                return (0, $6Vb5F._)($4d606bbbe8055188$var$t35 || ($4d606bbbe8055188$var$t35 = $4d606bbbe8055188$var$_`${0}`), (0, $5jmf7.checkDataTypes)(st, schemaCode, it.opts.strictNumbers, $5jmf7.DataType.Wrong));
            }
            return $6Vb5F.nil;
        }
        function invalid$DataSchema() {
            if (def.validateSchema) {
                const validateSchemaRef = gen.scopeValue("validate$data", {
                    ref: def.validateSchema
                }); // TODO value.code for standalone
                return (0, $6Vb5F._)($4d606bbbe8055188$var$t36 || ($4d606bbbe8055188$var$t36 = $4d606bbbe8055188$var$_`!${0}(${0})`), validateSchemaRef, schemaCode);
            }
            return $6Vb5F.nil;
        }
    }
    subschema(appl, valid) {
        const subschema = (0, $9KkQJ.getSubschema)(this.it, appl);
        (0, $9KkQJ.extendSubschemaData)(subschema, this.it, appl);
        (0, $9KkQJ.extendSubschemaMode)(subschema, appl);
        const nextContext = {
            ...this.it,
            ...subschema,
            items: undefined,
            props: undefined
        };
        $4d606bbbe8055188$var$subschemaCode(nextContext, valid);
        return nextContext;
    }
    mergeEvaluated(schemaCxt, toName) {
        const { it: it, gen: gen } = this;
        if (!it.opts.unevaluated) return;
        if (it.props !== true && schemaCxt.props !== undefined) it.props = $k2074.mergeEvaluated.props(gen, schemaCxt.props, it.props, toName);
        if (it.items !== true && schemaCxt.items !== undefined) it.items = $k2074.mergeEvaluated.items(gen, schemaCxt.items, it.items, toName);
    }
    mergeValidEvaluated(schemaCxt, valid) {
        const { it: it, gen: gen } = this;
        if (it.opts.unevaluated && (it.props !== true || it.items !== true)) {
            gen.if(valid, ()=>this.mergeEvaluated(schemaCxt, $6Vb5F.Name));
            return true;
        }
    }
    constructor(it, def, keyword){
        (0, $Emq0w.validateKeywordUsage)(it, def, keyword);
        this.gen = it.gen;
        this.allErrors = it.allErrors;
        this.keyword = keyword;
        this.data = it.data;
        this.schema = it.schema[keyword];
        this.$data = def.$data && it.opts.$data && this.schema && this.schema.$data;
        this.schemaValue = (0, $k2074.schemaRefOrVal)(it, this.schema, keyword, this.$data);
        this.schemaType = def.schemaType;
        this.parentSchema = it.schema;
        this.params = {};
        this.it = it;
        this.def = def;
        if (this.$data) this.schemaCode = it.gen.const("vSchema", $4d606bbbe8055188$var$getData(this.$data, it));
        else {
            this.schemaCode = this.schemaValue;
            if (!(0, $Emq0w.validSchemaType)(this.schema, def.schemaType, def.allowUndefined)) throw new Error(`${keyword} value must be ${JSON.stringify(def.schemaType)}`);
        }
        if ("code" in def ? def.trackErrors : def.errors !== false) this.errsCount = it.gen.const("_errs", $eXNSw.default.errors);
    }
}
module.exports.KeywordCxt = $4d606bbbe8055188$var$KeywordCxt;
function $4d606bbbe8055188$var$keywordCode(it, keyword, def, ruleType) {
    const cxt = new $4d606bbbe8055188$var$KeywordCxt(it, def, keyword);
    if ("code" in def) def.code(cxt, ruleType);
    else if (cxt.$data && def.validate) (0, $Emq0w.funcKeywordCode)(cxt, def);
    else if ("macro" in def) (0, $Emq0w.macroKeywordCode)(cxt, def);
    else if (def.compile || def.validate) (0, $Emq0w.funcKeywordCode)(cxt, def);
}
const $4d606bbbe8055188$var$JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
const $4d606bbbe8055188$var$RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function $4d606bbbe8055188$var$getData($data, { dataLevel: dataLevel, dataNames: dataNames, dataPathArr: dataPathArr }) {
    let jsonPointer;
    let data;
    if ($data === "") return $eXNSw.default.rootData;
    if ($data[0] === "/") {
        if (!$4d606bbbe8055188$var$JSON_POINTER.test($data)) throw new Error(`Invalid JSON-pointer: ${$data}`);
        jsonPointer = $data;
        data = $eXNSw.default.rootData;
    } else {
        const matches = $4d606bbbe8055188$var$RELATIVE_JSON_POINTER.exec($data);
        if (!matches) throw new Error(`Invalid JSON-pointer: ${$data}`);
        const up = +matches[1];
        jsonPointer = matches[2];
        if (jsonPointer === "#") {
            if (up >= dataLevel) throw new Error(errorMsg("property/index", up));
            return dataPathArr[dataLevel - up];
        }
        if (up > dataLevel) throw new Error(errorMsg("data", up));
        data = dataNames[dataLevel - up];
        if (!jsonPointer) return data;
    }
    let expr = data;
    const segments = jsonPointer.split("/");
    for (const segment of segments)if (segment) {
        data = (0, $6Vb5F._)($4d606bbbe8055188$var$t37 || ($4d606bbbe8055188$var$t37 = $4d606bbbe8055188$var$_`${0}${0}`), data, (0, $6Vb5F.getProperty)((0, $k2074.unescapeJsonPointer)(segment)));
        expr = (0, $6Vb5F._)($4d606bbbe8055188$var$t38 || ($4d606bbbe8055188$var$t38 = $4d606bbbe8055188$var$_`${0} && ${0}`), expr, data);
    }
    return expr;
    function errorMsg(pointerType, up) {
        return `Cannot access ${pointerType} ${up} levels up, current level is ${dataLevel}`;
    }
}
module.exports.getData = $4d606bbbe8055188$var$getData;

});
parcelRequire.register("jmiRE", function(module, exports) {
"use strict";
let $e17eb47938f51ce0$var$_ = (t)=>t, $e17eb47938f51ce0$var$t;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.boolOrEmptySchema = module.exports.topBoolOrEmptySchema = void 0;

var $lWojU = parcelRequire("lWojU");

var $6Vb5F = parcelRequire("6Vb5F");

var $eXNSw = parcelRequire("eXNSw");
const $e17eb47938f51ce0$var$boolError = {
    message: "boolean schema is false"
};
function $e17eb47938f51ce0$var$topBoolOrEmptySchema(it) {
    const { gen: gen, schema: schema, validateName: validateName } = it;
    if (schema === false) $e17eb47938f51ce0$var$falseSchemaError(it, false);
    else if (typeof schema == "object" && schema.$async === true) gen.return($eXNSw.default.data);
    else {
        gen.assign((0, $6Vb5F._)($e17eb47938f51ce0$var$t || ($e17eb47938f51ce0$var$t = $e17eb47938f51ce0$var$_`${0}.errors`), validateName), null);
        gen.return(true);
    }
}
module.exports.topBoolOrEmptySchema = $e17eb47938f51ce0$var$topBoolOrEmptySchema;
function $e17eb47938f51ce0$var$boolOrEmptySchema(it, valid) {
    const { gen: gen, schema: schema } = it;
    if (schema === false) {
        gen.var(valid, false); // TODO var
        $e17eb47938f51ce0$var$falseSchemaError(it);
    } else gen.var(valid, true); // TODO var
}
module.exports.boolOrEmptySchema = $e17eb47938f51ce0$var$boolOrEmptySchema;
function $e17eb47938f51ce0$var$falseSchemaError(it, overrideAllErrors) {
    const { gen: gen, data: data } = it;
    // TODO maybe some other interface should be used for non-keyword validation errors...
    const cxt = {
        gen: gen,
        keyword: "false schema",
        data: data,
        schema: false,
        schemaCode: false,
        schemaValue: false,
        params: {},
        it: it
    };
    (0, $lWojU.reportError)(cxt, $e17eb47938f51ce0$var$boolError, undefined, overrideAllErrors);
}

});
parcelRequire.register("lWojU", function(module, exports) {
"use strict";
let $ff91e139ef07fea7$var$_ = (t)=>t, $ff91e139ef07fea7$var$t, $ff91e139ef07fea7$var$t1, $ff91e139ef07fea7$var$t2, $ff91e139ef07fea7$var$t3, $ff91e139ef07fea7$var$t4, $ff91e139ef07fea7$var$t5, $ff91e139ef07fea7$var$t6, $ff91e139ef07fea7$var$t7, $ff91e139ef07fea7$var$t8, $ff91e139ef07fea7$var$t9, $ff91e139ef07fea7$var$t10, $ff91e139ef07fea7$var$t11, $ff91e139ef07fea7$var$t12, $ff91e139ef07fea7$var$t13, $ff91e139ef07fea7$var$t14, $ff91e139ef07fea7$var$t15, $ff91e139ef07fea7$var$t16, $ff91e139ef07fea7$var$t17, $ff91e139ef07fea7$var$t18, $ff91e139ef07fea7$var$t19, $ff91e139ef07fea7$var$t20, $ff91e139ef07fea7$var$t21, $ff91e139ef07fea7$var$t22, $ff91e139ef07fea7$var$t23, $ff91e139ef07fea7$var$t24;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extendErrors = module.exports.resetErrorsCount = module.exports.reportExtraError = module.exports.reportError = module.exports.keyword$DataError = module.exports.keywordError = void 0;

var $6Vb5F = parcelRequire("6Vb5F");

var $k2074 = parcelRequire("k2074");

var $eXNSw = parcelRequire("eXNSw");
module.exports.keywordError = {
    message: ({ keyword: keyword })=>(0, $6Vb5F.str)($ff91e139ef07fea7$var$t || ($ff91e139ef07fea7$var$t = $ff91e139ef07fea7$var$_`must pass "${0}" keyword validation`), keyword)
};
module.exports.keyword$DataError = {
    message: ({ keyword: keyword, schemaType: schemaType })=>schemaType ? (0, $6Vb5F.str)($ff91e139ef07fea7$var$t1 || ($ff91e139ef07fea7$var$t1 = $ff91e139ef07fea7$var$_`"${0}" keyword must be ${0} ($data)`), keyword, schemaType) : (0, $6Vb5F.str)($ff91e139ef07fea7$var$t2 || ($ff91e139ef07fea7$var$t2 = $ff91e139ef07fea7$var$_`"${0}" keyword is invalid ($data)`), keyword)
};
function $ff91e139ef07fea7$var$reportError(cxt, error = module.exports.keywordError, errorPaths, overrideAllErrors) {
    const { it: it } = cxt;
    const { gen: gen, compositeRule: compositeRule, allErrors: allErrors } = it;
    const errObj = $ff91e139ef07fea7$var$errorObjectCode(cxt, error, errorPaths);
    if (overrideAllErrors !== null && overrideAllErrors !== void 0 ? overrideAllErrors : compositeRule || allErrors) $ff91e139ef07fea7$var$addError(gen, errObj);
    else $ff91e139ef07fea7$var$returnErrors(it, (0, $6Vb5F._)($ff91e139ef07fea7$var$t3 || ($ff91e139ef07fea7$var$t3 = $ff91e139ef07fea7$var$_`[${0}]`), errObj));
}
module.exports.reportError = $ff91e139ef07fea7$var$reportError;
function $ff91e139ef07fea7$var$reportExtraError(cxt, error = module.exports.keywordError, errorPaths) {
    const { it: it } = cxt;
    const { gen: gen, compositeRule: compositeRule, allErrors: allErrors } = it;
    const errObj = $ff91e139ef07fea7$var$errorObjectCode(cxt, error, errorPaths);
    $ff91e139ef07fea7$var$addError(gen, errObj);
    if (!(compositeRule || allErrors)) $ff91e139ef07fea7$var$returnErrors(it, $eXNSw.default.vErrors);
}
module.exports.reportExtraError = $ff91e139ef07fea7$var$reportExtraError;
function $ff91e139ef07fea7$var$resetErrorsCount(gen, errsCount) {
    gen.assign($eXNSw.default.errors, errsCount);
    gen.if((0, $6Vb5F._)($ff91e139ef07fea7$var$t4 || ($ff91e139ef07fea7$var$t4 = $ff91e139ef07fea7$var$_`${0} !== null`), $eXNSw.default.vErrors), ()=>gen.if(errsCount, ()=>gen.assign((0, $6Vb5F._)($ff91e139ef07fea7$var$t5 || ($ff91e139ef07fea7$var$t5 = $ff91e139ef07fea7$var$_`${0}.length`), $eXNSw.default.vErrors), errsCount), ()=>gen.assign($eXNSw.default.vErrors, null)));
}
module.exports.resetErrorsCount = $ff91e139ef07fea7$var$resetErrorsCount;
function $ff91e139ef07fea7$var$extendErrors({ gen: gen, keyword: keyword, schemaValue: schemaValue, data: data, errsCount: errsCount, it: it }) {
    /* istanbul ignore if */ if (errsCount === undefined) throw new Error("ajv implementation error");
    const err = gen.name("err");
    gen.forRange("i", errsCount, $eXNSw.default.errors, (i)=>{
        gen.const(err, (0, $6Vb5F._)($ff91e139ef07fea7$var$t6 || ($ff91e139ef07fea7$var$t6 = $ff91e139ef07fea7$var$_`${0}[${0}]`), $eXNSw.default.vErrors, i));
        gen.if((0, $6Vb5F._)($ff91e139ef07fea7$var$t7 || ($ff91e139ef07fea7$var$t7 = $ff91e139ef07fea7$var$_`${0}.instancePath === undefined`), err), ()=>gen.assign((0, $6Vb5F._)($ff91e139ef07fea7$var$t8 || ($ff91e139ef07fea7$var$t8 = $ff91e139ef07fea7$var$_`${0}.instancePath`), err), (0, $6Vb5F.strConcat)($eXNSw.default.instancePath, it.errorPath)));
        gen.assign((0, $6Vb5F._)($ff91e139ef07fea7$var$t9 || ($ff91e139ef07fea7$var$t9 = $ff91e139ef07fea7$var$_`${0}.schemaPath`), err), (0, $6Vb5F.str)($ff91e139ef07fea7$var$t10 || ($ff91e139ef07fea7$var$t10 = $ff91e139ef07fea7$var$_`${0}/${0}`), it.errSchemaPath, keyword));
        if (it.opts.verbose) {
            gen.assign((0, $6Vb5F._)($ff91e139ef07fea7$var$t11 || ($ff91e139ef07fea7$var$t11 = $ff91e139ef07fea7$var$_`${0}.schema`), err), schemaValue);
            gen.assign((0, $6Vb5F._)($ff91e139ef07fea7$var$t12 || ($ff91e139ef07fea7$var$t12 = $ff91e139ef07fea7$var$_`${0}.data`), err), data);
        }
    });
}
module.exports.extendErrors = $ff91e139ef07fea7$var$extendErrors;
function $ff91e139ef07fea7$var$addError(gen, errObj) {
    const err = gen.const("err", errObj);
    gen.if((0, $6Vb5F._)($ff91e139ef07fea7$var$t13 || ($ff91e139ef07fea7$var$t13 = $ff91e139ef07fea7$var$_`${0} === null`), $eXNSw.default.vErrors), ()=>gen.assign($eXNSw.default.vErrors, (0, $6Vb5F._)($ff91e139ef07fea7$var$t14 || ($ff91e139ef07fea7$var$t14 = $ff91e139ef07fea7$var$_`[${0}]`), err)), (0, $6Vb5F._)($ff91e139ef07fea7$var$t15 || ($ff91e139ef07fea7$var$t15 = $ff91e139ef07fea7$var$_`${0}.push(${0})`), $eXNSw.default.vErrors, err));
    gen.code((0, $6Vb5F._)($ff91e139ef07fea7$var$t16 || ($ff91e139ef07fea7$var$t16 = $ff91e139ef07fea7$var$_`${0}++`), $eXNSw.default.errors));
}
function $ff91e139ef07fea7$var$returnErrors(it, errs) {
    const { gen: gen, validateName: validateName, schemaEnv: schemaEnv } = it;
    if (schemaEnv.$async) gen.throw((0, $6Vb5F._)($ff91e139ef07fea7$var$t17 || ($ff91e139ef07fea7$var$t17 = $ff91e139ef07fea7$var$_`new ${0}(${0})`), it.ValidationError, errs));
    else {
        gen.assign((0, $6Vb5F._)($ff91e139ef07fea7$var$t18 || ($ff91e139ef07fea7$var$t18 = $ff91e139ef07fea7$var$_`${0}.errors`), validateName), errs);
        gen.return(false);
    }
}
const $ff91e139ef07fea7$var$E = {
    keyword: new $6Vb5F.Name("keyword"),
    schemaPath: new $6Vb5F.Name("schemaPath"),
    params: new $6Vb5F.Name("params"),
    propertyName: new $6Vb5F.Name("propertyName"),
    message: new $6Vb5F.Name("message"),
    schema: new $6Vb5F.Name("schema"),
    parentSchema: new $6Vb5F.Name("parentSchema")
};
function $ff91e139ef07fea7$var$errorObjectCode(cxt, error, errorPaths) {
    const { createErrors: createErrors } = cxt.it;
    if (createErrors === false) return (0, $6Vb5F._)($ff91e139ef07fea7$var$t19 || ($ff91e139ef07fea7$var$t19 = $ff91e139ef07fea7$var$_`{}`));
    return $ff91e139ef07fea7$var$errorObject(cxt, error, errorPaths);
}
function $ff91e139ef07fea7$var$errorObject(cxt, error, errorPaths = {}) {
    const { gen: gen, it: it } = cxt;
    const keyValues = [
        $ff91e139ef07fea7$var$errorInstancePath(it, errorPaths),
        $ff91e139ef07fea7$var$errorSchemaPath(cxt, errorPaths)
    ];
    $ff91e139ef07fea7$var$extraErrorProps(cxt, error, keyValues);
    return gen.object(...keyValues);
}
function $ff91e139ef07fea7$var$errorInstancePath({ errorPath: errorPath }, { instancePath: instancePath }) {
    const instPath = instancePath ? (0, $6Vb5F.str)($ff91e139ef07fea7$var$t20 || ($ff91e139ef07fea7$var$t20 = $ff91e139ef07fea7$var$_`${0}${0}`), errorPath, (0, $k2074.getErrorPath)(instancePath, $k2074.Type.Str)) : errorPath;
    return [
        $eXNSw.default.instancePath,
        (0, $6Vb5F.strConcat)($eXNSw.default.instancePath, instPath)
    ];
}
function $ff91e139ef07fea7$var$errorSchemaPath({ keyword: keyword, it: { errSchemaPath: errSchemaPath } }, { schemaPath: schemaPath, parentSchema: parentSchema }) {
    let schPath = parentSchema ? errSchemaPath : (0, $6Vb5F.str)($ff91e139ef07fea7$var$t21 || ($ff91e139ef07fea7$var$t21 = $ff91e139ef07fea7$var$_`${0}/${0}`), errSchemaPath, keyword);
    if (schemaPath) schPath = (0, $6Vb5F.str)($ff91e139ef07fea7$var$t22 || ($ff91e139ef07fea7$var$t22 = $ff91e139ef07fea7$var$_`${0}${0}`), schPath, (0, $k2074.getErrorPath)(schemaPath, $k2074.Type.Str));
    return [
        $ff91e139ef07fea7$var$E.schemaPath,
        schPath
    ];
}
function $ff91e139ef07fea7$var$extraErrorProps(cxt, { params: params, message: message }, keyValues) {
    const { keyword: keyword, data: data, schemaValue: schemaValue, it: it } = cxt;
    const { opts: opts, propertyName: propertyName, topSchemaRef: topSchemaRef, schemaPath: schemaPath } = it;
    keyValues.push([
        $ff91e139ef07fea7$var$E.keyword,
        keyword
    ], [
        $ff91e139ef07fea7$var$E.params,
        typeof params == "function" ? params(cxt) : params || (0, $6Vb5F._)($ff91e139ef07fea7$var$t23 || ($ff91e139ef07fea7$var$t23 = $ff91e139ef07fea7$var$_`{}`))
    ]);
    if (opts.messages) keyValues.push([
        $ff91e139ef07fea7$var$E.message,
        typeof message == "function" ? message(cxt) : message
    ]);
    if (opts.verbose) keyValues.push([
        $ff91e139ef07fea7$var$E.schema,
        schemaValue
    ], [
        $ff91e139ef07fea7$var$E.parentSchema,
        (0, $6Vb5F._)($ff91e139ef07fea7$var$t24 || ($ff91e139ef07fea7$var$t24 = $ff91e139ef07fea7$var$_`${0}${0}`), topSchemaRef, schemaPath)
    ], [
        $eXNSw.default.data,
        data
    ]);
    if (propertyName) keyValues.push([
        $ff91e139ef07fea7$var$E.propertyName,
        propertyName
    ]);
}

});
parcelRequire.register("6Vb5F", function(module, exports) {
"use strict";
let $50a0ab402ce08534$var$_ = (t)=>t, $50a0ab402ce08534$var$t, $50a0ab402ce08534$var$t1, $50a0ab402ce08534$var$t2, $50a0ab402ce08534$var$t3, $50a0ab402ce08534$var$t4, $50a0ab402ce08534$var$t5;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.or = module.exports.and = module.exports.not = module.exports.CodeGen = module.exports.operators = module.exports.varKinds = module.exports.ValueScopeName = module.exports.ValueScope = module.exports.Scope = module.exports.Name = module.exports.regexpCode = module.exports.stringify = module.exports.getProperty = module.exports.nil = module.exports.strConcat = module.exports.str = module.exports._ = void 0;

var $yjrkC = parcelRequire("yjrkC");

var $kzaMy = parcelRequire("kzaMy");

var $yjrkC = parcelRequire("yjrkC");
Object.defineProperty(module.exports, "_", {
    enumerable: true,
    get: function() {
        return $yjrkC._;
    }
});
Object.defineProperty(module.exports, "str", {
    enumerable: true,
    get: function() {
        return $yjrkC.str;
    }
});
Object.defineProperty(module.exports, "strConcat", {
    enumerable: true,
    get: function() {
        return $yjrkC.strConcat;
    }
});
Object.defineProperty(module.exports, "nil", {
    enumerable: true,
    get: function() {
        return $yjrkC.nil;
    }
});
Object.defineProperty(module.exports, "getProperty", {
    enumerable: true,
    get: function() {
        return $yjrkC.getProperty;
    }
});
Object.defineProperty(module.exports, "stringify", {
    enumerable: true,
    get: function() {
        return $yjrkC.stringify;
    }
});
Object.defineProperty(module.exports, "regexpCode", {
    enumerable: true,
    get: function() {
        return $yjrkC.regexpCode;
    }
});
Object.defineProperty(module.exports, "Name", {
    enumerable: true,
    get: function() {
        return $yjrkC.Name;
    }
});

var $kzaMy = parcelRequire("kzaMy");
Object.defineProperty(module.exports, "Scope", {
    enumerable: true,
    get: function() {
        return $kzaMy.Scope;
    }
});
Object.defineProperty(module.exports, "ValueScope", {
    enumerable: true,
    get: function() {
        return $kzaMy.ValueScope;
    }
});
Object.defineProperty(module.exports, "ValueScopeName", {
    enumerable: true,
    get: function() {
        return $kzaMy.ValueScopeName;
    }
});
Object.defineProperty(module.exports, "varKinds", {
    enumerable: true,
    get: function() {
        return $kzaMy.varKinds;
    }
});
module.exports.operators = {
    GT: new $yjrkC._Code(">"),
    GTE: new $yjrkC._Code(">="),
    LT: new $yjrkC._Code("<"),
    LTE: new $yjrkC._Code("<="),
    EQ: new $yjrkC._Code("==="),
    NEQ: new $yjrkC._Code("!=="),
    NOT: new $yjrkC._Code("!"),
    OR: new $yjrkC._Code("||"),
    AND: new $yjrkC._Code("&&"),
    ADD: new $yjrkC._Code("+")
};
class $50a0ab402ce08534$var$Node {
    optimizeNodes() {
        return this;
    }
    optimizeNames(_names, _constants) {
        return this;
    }
}
class $50a0ab402ce08534$var$Def extends $50a0ab402ce08534$var$Node {
    render({ es5: es5, _n: _n }) {
        const varKind = es5 ? $kzaMy.varKinds.var : this.varKind;
        const rhs = this.rhs === undefined ? "" : ` = ${this.rhs}`;
        return `${varKind} ${this.name}${rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (!names[this.name.str]) return;
        if (this.rhs) this.rhs = $50a0ab402ce08534$var$optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        return this.rhs instanceof $yjrkC._CodeOrName ? this.rhs.names : {};
    }
    constructor(varKind, name, rhs){
        super();
        this.varKind = varKind;
        this.name = name;
        this.rhs = rhs;
    }
}
class $50a0ab402ce08534$var$Assign extends $50a0ab402ce08534$var$Node {
    render({ _n: _n }) {
        return `${this.lhs} = ${this.rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (this.lhs instanceof $yjrkC.Name && !names[this.lhs.str] && !this.sideEffects) return;
        this.rhs = $50a0ab402ce08534$var$optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        const names = this.lhs instanceof $yjrkC.Name ? {} : {
            ...this.lhs.names
        };
        return $50a0ab402ce08534$var$addExprNames(names, this.rhs);
    }
    constructor(lhs, rhs, sideEffects){
        super();
        this.lhs = lhs;
        this.rhs = rhs;
        this.sideEffects = sideEffects;
    }
}
class $50a0ab402ce08534$var$AssignOp extends $50a0ab402ce08534$var$Assign {
    render({ _n: _n }) {
        return `${this.lhs} ${this.op}= ${this.rhs};` + _n;
    }
    constructor(lhs, op, rhs, sideEffects){
        super(lhs, rhs, sideEffects);
        this.op = op;
    }
}
class $50a0ab402ce08534$var$Label extends $50a0ab402ce08534$var$Node {
    render({ _n: _n }) {
        return `${this.label}:` + _n;
    }
    constructor(label){
        super();
        this.label = label;
        this.names = {};
    }
}
class $50a0ab402ce08534$var$Break extends $50a0ab402ce08534$var$Node {
    render({ _n: _n }) {
        const label = this.label ? ` ${this.label}` : "";
        return `break${label};` + _n;
    }
    constructor(label){
        super();
        this.label = label;
        this.names = {};
    }
}
class $50a0ab402ce08534$var$Throw extends $50a0ab402ce08534$var$Node {
    render({ _n: _n }) {
        return `throw ${this.error};` + _n;
    }
    get names() {
        return this.error.names;
    }
    constructor(error){
        super();
        this.error = error;
    }
}
class $50a0ab402ce08534$var$AnyCode extends $50a0ab402ce08534$var$Node {
    render({ _n: _n }) {
        return `${this.code};` + _n;
    }
    optimizeNodes() {
        return `${this.code}` ? this : undefined;
    }
    optimizeNames(names, constants) {
        this.code = $50a0ab402ce08534$var$optimizeExpr(this.code, names, constants);
        return this;
    }
    get names() {
        return this.code instanceof $yjrkC._CodeOrName ? this.code.names : {};
    }
    constructor(code){
        super();
        this.code = code;
    }
}
class $50a0ab402ce08534$var$ParentNode extends $50a0ab402ce08534$var$Node {
    render(opts) {
        return this.nodes.reduce((code, n)=>code + n.render(opts), "");
    }
    optimizeNodes() {
        const { nodes: nodes } = this;
        let i = nodes.length;
        while(i--){
            const n = nodes[i].optimizeNodes();
            if (Array.isArray(n)) nodes.splice(i, 1, ...n);
            else if (n) nodes[i] = n;
            else nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    optimizeNames(names, constants) {
        const { nodes: nodes } = this;
        let i = nodes.length;
        while(i--){
            // iterating backwards improves 1-pass optimization
            const n = nodes[i];
            if (n.optimizeNames(names, constants)) continue;
            $50a0ab402ce08534$var$subtractNames(names, n.names);
            nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    get names() {
        return this.nodes.reduce((names, n)=>$50a0ab402ce08534$var$addNames(names, n.names), {});
    }
    constructor(nodes = []){
        super();
        this.nodes = nodes;
    }
}
class $50a0ab402ce08534$var$BlockNode extends $50a0ab402ce08534$var$ParentNode {
    render(opts) {
        return "{" + opts._n + super.render(opts) + "}" + opts._n;
    }
}
class $50a0ab402ce08534$var$Root extends $50a0ab402ce08534$var$ParentNode {
}
class $50a0ab402ce08534$var$Else extends $50a0ab402ce08534$var$BlockNode {
}
$50a0ab402ce08534$var$Else.kind = "else";
class $50a0ab402ce08534$var$If extends $50a0ab402ce08534$var$BlockNode {
    render(opts) {
        let code = `if(${this.condition})` + super.render(opts);
        if (this.else) code += "else " + this.else.render(opts);
        return code;
    }
    optimizeNodes() {
        super.optimizeNodes();
        const cond = this.condition;
        if (cond === true) return this.nodes; // else is ignored here
        let e = this.else;
        if (e) {
            const ns = e.optimizeNodes();
            e = this.else = Array.isArray(ns) ? new $50a0ab402ce08534$var$Else(ns) : ns;
        }
        if (e) {
            if (cond === false) return e instanceof $50a0ab402ce08534$var$If ? e : e.nodes;
            if (this.nodes.length) return this;
            return new $50a0ab402ce08534$var$If($50a0ab402ce08534$var$not(cond), e instanceof $50a0ab402ce08534$var$If ? [
                e
            ] : e.nodes);
        }
        if (cond === false || !this.nodes.length) return undefined;
        return this;
    }
    optimizeNames(names, constants) {
        var _a;
        this.else = (_a = this.else) === null || _a === void 0 ? void 0 : _a.optimizeNames(names, constants);
        if (!(super.optimizeNames(names, constants) || this.else)) return;
        this.condition = $50a0ab402ce08534$var$optimizeExpr(this.condition, names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        $50a0ab402ce08534$var$addExprNames(names, this.condition);
        if (this.else) $50a0ab402ce08534$var$addNames(names, this.else.names);
        return names;
    }
    constructor(condition, nodes){
        super(nodes);
        this.condition = condition;
    }
}
$50a0ab402ce08534$var$If.kind = "if";
class $50a0ab402ce08534$var$For extends $50a0ab402ce08534$var$BlockNode {
}
$50a0ab402ce08534$var$For.kind = "for";
class $50a0ab402ce08534$var$ForLoop extends $50a0ab402ce08534$var$For {
    render(opts) {
        return `for(${this.iteration})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants)) return;
        this.iteration = $50a0ab402ce08534$var$optimizeExpr(this.iteration, names, constants);
        return this;
    }
    get names() {
        return $50a0ab402ce08534$var$addNames(super.names, this.iteration.names);
    }
    constructor(iteration){
        super();
        this.iteration = iteration;
    }
}
class $50a0ab402ce08534$var$ForRange extends $50a0ab402ce08534$var$For {
    render(opts) {
        const varKind = opts.es5 ? $kzaMy.varKinds.var : this.varKind;
        const { name: name, from: from, to: to } = this;
        return `for(${varKind} ${name}=${from}; ${name}<${to}; ${name}++)` + super.render(opts);
    }
    get names() {
        const names = $50a0ab402ce08534$var$addExprNames(super.names, this.from);
        return $50a0ab402ce08534$var$addExprNames(names, this.to);
    }
    constructor(varKind, name, from, to){
        super();
        this.varKind = varKind;
        this.name = name;
        this.from = from;
        this.to = to;
    }
}
class $50a0ab402ce08534$var$ForIter extends $50a0ab402ce08534$var$For {
    render(opts) {
        return `for(${this.varKind} ${this.name} ${this.loop} ${this.iterable})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants)) return;
        this.iterable = $50a0ab402ce08534$var$optimizeExpr(this.iterable, names, constants);
        return this;
    }
    get names() {
        return $50a0ab402ce08534$var$addNames(super.names, this.iterable.names);
    }
    constructor(loop, varKind, name, iterable){
        super();
        this.loop = loop;
        this.varKind = varKind;
        this.name = name;
        this.iterable = iterable;
    }
}
class $50a0ab402ce08534$var$Func extends $50a0ab402ce08534$var$BlockNode {
    render(opts) {
        const _async = this.async ? "async " : "";
        return `${_async}function ${this.name}(${this.args})` + super.render(opts);
    }
    constructor(name, args, async){
        super();
        this.name = name;
        this.args = args;
        this.async = async;
    }
}
$50a0ab402ce08534$var$Func.kind = "func";
class $50a0ab402ce08534$var$Return extends $50a0ab402ce08534$var$ParentNode {
    render(opts) {
        return "return " + super.render(opts);
    }
}
$50a0ab402ce08534$var$Return.kind = "return";
class $50a0ab402ce08534$var$Try extends $50a0ab402ce08534$var$BlockNode {
    render(opts) {
        let code = "try" + super.render(opts);
        if (this.catch) code += this.catch.render(opts);
        if (this.finally) code += this.finally.render(opts);
        return code;
    }
    optimizeNodes() {
        var _a, _b;
        super.optimizeNodes();
        (_a = this.catch) === null || _a === void 0 || _a.optimizeNodes();
        (_b = this.finally) === null || _b === void 0 || _b.optimizeNodes();
        return this;
    }
    optimizeNames(names, constants) {
        var _a, _b;
        super.optimizeNames(names, constants);
        (_a = this.catch) === null || _a === void 0 || _a.optimizeNames(names, constants);
        (_b = this.finally) === null || _b === void 0 || _b.optimizeNames(names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        if (this.catch) $50a0ab402ce08534$var$addNames(names, this.catch.names);
        if (this.finally) $50a0ab402ce08534$var$addNames(names, this.finally.names);
        return names;
    }
}
class $50a0ab402ce08534$var$Catch extends $50a0ab402ce08534$var$BlockNode {
    render(opts) {
        return `catch(${this.error})` + super.render(opts);
    }
    constructor(error){
        super();
        this.error = error;
    }
}
$50a0ab402ce08534$var$Catch.kind = "catch";
class $50a0ab402ce08534$var$Finally extends $50a0ab402ce08534$var$BlockNode {
    render(opts) {
        return "finally" + super.render(opts);
    }
}
$50a0ab402ce08534$var$Finally.kind = "finally";
class $50a0ab402ce08534$var$CodeGen {
    toString() {
        return this._root.render(this.opts);
    }
    // returns unique name in the internal scope
    name(prefix) {
        return this._scope.name(prefix);
    }
    // reserves unique name in the external scope
    scopeName(prefix) {
        return this._extScope.name(prefix);
    }
    // reserves unique name in the external scope and assigns value to it
    scopeValue(prefixOrName, value) {
        const name = this._extScope.value(prefixOrName, value);
        const vs = this._values[name.prefix] || (this._values[name.prefix] = new Set());
        vs.add(name);
        return name;
    }
    getScopeValue(prefix, keyOrRef) {
        return this._extScope.getValue(prefix, keyOrRef);
    }
    // return code that assigns values in the external scope to the names that are used internally
    // (same names that were returned by gen.scopeName or gen.scopeValue)
    scopeRefs(scopeName) {
        return this._extScope.scopeRefs(scopeName, this._values);
    }
    scopeCode() {
        return this._extScope.scopeCode(this._values);
    }
    _def(varKind, nameOrPrefix, rhs, constant) {
        const name = this._scope.toName(nameOrPrefix);
        if (rhs !== undefined && constant) this._constants[name.str] = rhs;
        this._leafNode(new $50a0ab402ce08534$var$Def(varKind, name, rhs));
        return name;
    }
    // `const` declaration (`var` in es5 mode)
    const(nameOrPrefix, rhs, _constant) {
        return this._def($kzaMy.varKinds.const, nameOrPrefix, rhs, _constant);
    }
    // `let` declaration with optional assignment (`var` in es5 mode)
    let(nameOrPrefix, rhs, _constant) {
        return this._def($kzaMy.varKinds.let, nameOrPrefix, rhs, _constant);
    }
    // `var` declaration with optional assignment
    var(nameOrPrefix, rhs, _constant) {
        return this._def($kzaMy.varKinds.var, nameOrPrefix, rhs, _constant);
    }
    // assignment code
    assign(lhs, rhs, sideEffects) {
        return this._leafNode(new $50a0ab402ce08534$var$Assign(lhs, rhs, sideEffects));
    }
    // `+=` code
    add(lhs, rhs) {
        return this._leafNode(new $50a0ab402ce08534$var$AssignOp(lhs, module.exports.operators.ADD, rhs));
    }
    // appends passed SafeExpr to code or executes Block
    code(c) {
        if (typeof c == "function") c();
        else if (c !== $yjrkC.nil) this._leafNode(new $50a0ab402ce08534$var$AnyCode(c));
        return this;
    }
    // returns code for object literal for the passed argument list of key-value pairs
    object(...keyValues) {
        const code = [
            "{"
        ];
        for (const [key, value] of keyValues){
            if (code.length > 1) code.push(",");
            code.push(key);
            if (key !== value || this.opts.es5) {
                code.push(":");
                (0, $yjrkC.addCodeArg)(code, value);
            }
        }
        code.push("}");
        return new $yjrkC._Code(code);
    }
    // `if` clause (or statement if `thenBody` and, optionally, `elseBody` are passed)
    if(condition, thenBody, elseBody) {
        this._blockNode(new $50a0ab402ce08534$var$If(condition));
        if (thenBody && elseBody) this.code(thenBody).else().code(elseBody).endIf();
        else if (thenBody) this.code(thenBody).endIf();
        else if (elseBody) throw new Error('CodeGen: "else" body without "then" body');
        return this;
    }
    // `else if` clause - invalid without `if` or after `else` clauses
    elseIf(condition) {
        return this._elseNode(new $50a0ab402ce08534$var$If(condition));
    }
    // `else` clause - only valid after `if` or `else if` clauses
    else() {
        return this._elseNode(new $50a0ab402ce08534$var$Else());
    }
    // end `if` statement (needed if gen.if was used only with condition)
    endIf() {
        return this._endBlockNode($50a0ab402ce08534$var$If, $50a0ab402ce08534$var$Else);
    }
    _for(node, forBody) {
        this._blockNode(node);
        if (forBody) this.code(forBody).endFor();
        return this;
    }
    // a generic `for` clause (or statement if `forBody` is passed)
    for(iteration, forBody) {
        return this._for(new $50a0ab402ce08534$var$ForLoop(iteration), forBody);
    }
    // `for` statement for a range of values
    forRange(nameOrPrefix, from, to, forBody, varKind = this.opts.es5 ? $kzaMy.varKinds.var : $kzaMy.varKinds.let) {
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new $50a0ab402ce08534$var$ForRange(varKind, name, from, to), ()=>forBody(name));
    }
    // `for-of` statement (in es5 mode replace with a normal for loop)
    forOf(nameOrPrefix, iterable, forBody, varKind = $kzaMy.varKinds.const) {
        const name = this._scope.toName(nameOrPrefix);
        if (this.opts.es5) {
            const arr = iterable instanceof $yjrkC.Name ? iterable : this.var("_arr", iterable);
            return this.forRange("_i", 0, (0, $yjrkC._)($50a0ab402ce08534$var$t || ($50a0ab402ce08534$var$t = $50a0ab402ce08534$var$_`${0}.length`), arr), (i)=>{
                this.var(name, (0, $yjrkC._)($50a0ab402ce08534$var$t1 || ($50a0ab402ce08534$var$t1 = $50a0ab402ce08534$var$_`${0}[${0}]`), arr, i));
                forBody(name);
            });
        }
        return this._for(new $50a0ab402ce08534$var$ForIter("of", varKind, name, iterable), ()=>forBody(name));
    }
    // `for-in` statement.
    // With option `ownProperties` replaced with a `for-of` loop for object keys
    forIn(nameOrPrefix, obj, forBody, varKind = this.opts.es5 ? $kzaMy.varKinds.var : $kzaMy.varKinds.const) {
        if (this.opts.ownProperties) return this.forOf(nameOrPrefix, (0, $yjrkC._)($50a0ab402ce08534$var$t2 || ($50a0ab402ce08534$var$t2 = $50a0ab402ce08534$var$_`Object.keys(${0})`), obj), forBody);
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new $50a0ab402ce08534$var$ForIter("in", varKind, name, obj), ()=>forBody(name));
    }
    // end `for` loop
    endFor() {
        return this._endBlockNode($50a0ab402ce08534$var$For);
    }
    // `label` statement
    label(label) {
        return this._leafNode(new $50a0ab402ce08534$var$Label(label));
    }
    // `break` statement
    break(label) {
        return this._leafNode(new $50a0ab402ce08534$var$Break(label));
    }
    // `return` statement
    return(value) {
        const node = new $50a0ab402ce08534$var$Return();
        this._blockNode(node);
        this.code(value);
        if (node.nodes.length !== 1) throw new Error('CodeGen: "return" should have one node');
        return this._endBlockNode($50a0ab402ce08534$var$Return);
    }
    // `try` statement
    try(tryBody, catchCode, finallyCode) {
        if (!catchCode && !finallyCode) throw new Error('CodeGen: "try" without "catch" and "finally"');
        const node = new $50a0ab402ce08534$var$Try();
        this._blockNode(node);
        this.code(tryBody);
        if (catchCode) {
            const error = this.name("e");
            this._currNode = node.catch = new $50a0ab402ce08534$var$Catch(error);
            catchCode(error);
        }
        if (finallyCode) {
            this._currNode = node.finally = new $50a0ab402ce08534$var$Finally();
            this.code(finallyCode);
        }
        return this._endBlockNode($50a0ab402ce08534$var$Catch, $50a0ab402ce08534$var$Finally);
    }
    // `throw` statement
    throw(error) {
        return this._leafNode(new $50a0ab402ce08534$var$Throw(error));
    }
    // start self-balancing block
    block(body, nodeCount) {
        this._blockStarts.push(this._nodes.length);
        if (body) this.code(body).endBlock(nodeCount);
        return this;
    }
    // end the current self-balancing block
    endBlock(nodeCount) {
        const len = this._blockStarts.pop();
        if (len === undefined) throw new Error("CodeGen: not in self-balancing block");
        const toClose = this._nodes.length - len;
        if (toClose < 0 || nodeCount !== undefined && toClose !== nodeCount) throw new Error(`CodeGen: wrong number of nodes: ${toClose} vs ${nodeCount} expected`);
        this._nodes.length = len;
        return this;
    }
    // `function` heading (or definition if funcBody is passed)
    func(name, args = $yjrkC.nil, async, funcBody) {
        this._blockNode(new $50a0ab402ce08534$var$Func(name, args, async));
        if (funcBody) this.code(funcBody).endFunc();
        return this;
    }
    // end function definition
    endFunc() {
        return this._endBlockNode($50a0ab402ce08534$var$Func);
    }
    optimize(n = 1) {
        while(n-- > 0){
            this._root.optimizeNodes();
            this._root.optimizeNames(this._root.names, this._constants);
        }
    }
    _leafNode(node) {
        this._currNode.nodes.push(node);
        return this;
    }
    _blockNode(node) {
        this._currNode.nodes.push(node);
        this._nodes.push(node);
    }
    _endBlockNode(N1, N2) {
        const n = this._currNode;
        if (n instanceof N1 || N2 && n instanceof N2) {
            this._nodes.pop();
            return this;
        }
        throw new Error(`CodeGen: not in block "${N2 ? `${N1.kind}/${N2.kind}` : N1.kind}"`);
    }
    _elseNode(node) {
        const n = this._currNode;
        if (!(n instanceof $50a0ab402ce08534$var$If)) throw new Error('CodeGen: "else" without "if"');
        this._currNode = n.else = node;
        return this;
    }
    get _root() {
        return this._nodes[0];
    }
    get _currNode() {
        const ns = this._nodes;
        return ns[ns.length - 1];
    }
    set _currNode(node) {
        const ns = this._nodes;
        ns[ns.length - 1] = node;
    }
    constructor(extScope, opts = {}){
        this._values = {};
        this._blockStarts = [];
        this._constants = {};
        this.opts = {
            ...opts,
            _n: opts.lines ? "\n" : ""
        };
        this._extScope = extScope;
        this._scope = new $kzaMy.Scope({
            parent: extScope
        });
        this._nodes = [
            new $50a0ab402ce08534$var$Root()
        ];
    }
}
module.exports.CodeGen = $50a0ab402ce08534$var$CodeGen;
function $50a0ab402ce08534$var$addNames(names, from) {
    for(const n in from)names[n] = (names[n] || 0) + (from[n] || 0);
    return names;
}
function $50a0ab402ce08534$var$addExprNames(names, from) {
    return from instanceof $yjrkC._CodeOrName ? $50a0ab402ce08534$var$addNames(names, from.names) : names;
}
function $50a0ab402ce08534$var$optimizeExpr(expr, names, constants) {
    if (expr instanceof $yjrkC.Name) return replaceName(expr);
    if (!canOptimize(expr)) return expr;
    return new $yjrkC._Code(expr._items.reduce((items, c)=>{
        if (c instanceof $yjrkC.Name) c = replaceName(c);
        if (c instanceof $yjrkC._Code) items.push(...c._items);
        else items.push(c);
        return items;
    }, []));
    function replaceName(n) {
        const c = constants[n.str];
        if (c === undefined || names[n.str] !== 1) return n;
        delete names[n.str];
        return c;
    }
    function canOptimize(e) {
        return e instanceof $yjrkC._Code && e._items.some((c)=>c instanceof $yjrkC.Name && names[c.str] === 1 && constants[c.str] !== undefined);
    }
}
function $50a0ab402ce08534$var$subtractNames(names, from) {
    for(const n in from)names[n] = (names[n] || 0) - (from[n] || 0);
}
function $50a0ab402ce08534$var$not(x) {
    return typeof x == "boolean" || typeof x == "number" || x === null ? !x : (0, $yjrkC._)($50a0ab402ce08534$var$t3 || ($50a0ab402ce08534$var$t3 = $50a0ab402ce08534$var$_`!${0}`), $50a0ab402ce08534$var$par(x));
}
module.exports.not = $50a0ab402ce08534$var$not;
const $50a0ab402ce08534$var$andCode = $50a0ab402ce08534$var$mappend(module.exports.operators.AND);
// boolean AND (&&) expression with the passed arguments
function $50a0ab402ce08534$var$and(...args) {
    return args.reduce($50a0ab402ce08534$var$andCode);
}
module.exports.and = $50a0ab402ce08534$var$and;
const $50a0ab402ce08534$var$orCode = $50a0ab402ce08534$var$mappend(module.exports.operators.OR);
// boolean OR (||) expression with the passed arguments
function $50a0ab402ce08534$var$or(...args) {
    return args.reduce($50a0ab402ce08534$var$orCode);
}
module.exports.or = $50a0ab402ce08534$var$or;
function $50a0ab402ce08534$var$mappend(op) {
    return (x, y)=>x === $yjrkC.nil ? y : y === $yjrkC.nil ? x : (0, $yjrkC._)($50a0ab402ce08534$var$t4 || ($50a0ab402ce08534$var$t4 = $50a0ab402ce08534$var$_`${0} ${0} ${0}`), $50a0ab402ce08534$var$par(x), op, $50a0ab402ce08534$var$par(y));
}
function $50a0ab402ce08534$var$par(x) {
    return x instanceof $yjrkC.Name ? x : (0, $yjrkC._)($50a0ab402ce08534$var$t5 || ($50a0ab402ce08534$var$t5 = $50a0ab402ce08534$var$_`(${0})`), x);
}

});
parcelRequire.register("yjrkC", function(module, exports) {
"use strict";
let $0672416fa0550d12$var$_ = (t)=>t, $0672416fa0550d12$var$t, $0672416fa0550d12$var$t1;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.regexpCode = module.exports.getEsmExportName = module.exports.getProperty = module.exports.safeStringify = module.exports.stringify = module.exports.strConcat = module.exports.addCodeArg = module.exports.str = module.exports._ = module.exports.nil = module.exports._Code = module.exports.Name = module.exports.IDENTIFIER = module.exports._CodeOrName = void 0;
class $0672416fa0550d12$var$_CodeOrName {
}
module.exports._CodeOrName = $0672416fa0550d12$var$_CodeOrName;
module.exports.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
class $0672416fa0550d12$var$Name extends $0672416fa0550d12$var$_CodeOrName {
    toString() {
        return this.str;
    }
    emptyStr() {
        return false;
    }
    get names() {
        return {
            [this.str]: 1
        };
    }
    constructor(s){
        super();
        if (!module.exports.IDENTIFIER.test(s)) throw new Error("CodeGen: name must be a valid identifier");
        this.str = s;
    }
}
module.exports.Name = $0672416fa0550d12$var$Name;
class $0672416fa0550d12$var$_Code extends $0672416fa0550d12$var$_CodeOrName {
    toString() {
        return this.str;
    }
    emptyStr() {
        if (this._items.length > 1) return false;
        const item = this._items[0];
        return item === "" || item === '""';
    }
    get str() {
        var _a;
        return (_a = this._str) !== null && _a !== void 0 ? _a : this._str = this._items.reduce((s, c)=>`${s}${c}`, "");
    }
    get names() {
        var _a;
        return (_a = this._names) !== null && _a !== void 0 ? _a : this._names = this._items.reduce((names, c)=>{
            if (c instanceof $0672416fa0550d12$var$Name) names[c.str] = (names[c.str] || 0) + 1;
            return names;
        }, {});
    }
    constructor(code){
        super();
        this._items = typeof code === "string" ? [
            code
        ] : code;
    }
}
module.exports._Code = $0672416fa0550d12$var$_Code;
module.exports.nil = new $0672416fa0550d12$var$_Code("");
function $0672416fa0550d12$var$_1(strs, ...args) {
    const code = [
        strs[0]
    ];
    let i = 0;
    while(i < args.length){
        $0672416fa0550d12$var$addCodeArg(code, args[i]);
        code.push(strs[++i]);
    }
    return new $0672416fa0550d12$var$_Code(code);
}
module.exports._ = $0672416fa0550d12$var$_1;
const $0672416fa0550d12$var$plus = new $0672416fa0550d12$var$_Code("+");
function $0672416fa0550d12$var$str(strs, ...args) {
    const expr = [
        $0672416fa0550d12$var$safeStringify(strs[0])
    ];
    let i = 0;
    while(i < args.length){
        expr.push($0672416fa0550d12$var$plus);
        $0672416fa0550d12$var$addCodeArg(expr, args[i]);
        expr.push($0672416fa0550d12$var$plus, $0672416fa0550d12$var$safeStringify(strs[++i]));
    }
    $0672416fa0550d12$var$optimize(expr);
    return new $0672416fa0550d12$var$_Code(expr);
}
module.exports.str = $0672416fa0550d12$var$str;
function $0672416fa0550d12$var$addCodeArg(code, arg) {
    if (arg instanceof $0672416fa0550d12$var$_Code) code.push(...arg._items);
    else if (arg instanceof $0672416fa0550d12$var$Name) code.push(arg);
    else code.push($0672416fa0550d12$var$interpolate(arg));
}
module.exports.addCodeArg = $0672416fa0550d12$var$addCodeArg;
function $0672416fa0550d12$var$optimize(expr) {
    let i = 1;
    while(i < expr.length - 1){
        if (expr[i] === $0672416fa0550d12$var$plus) {
            const res = $0672416fa0550d12$var$mergeExprItems(expr[i - 1], expr[i + 1]);
            if (res !== undefined) {
                expr.splice(i - 1, 3, res);
                continue;
            }
            expr[i++] = "+";
        }
        i++;
    }
}
function $0672416fa0550d12$var$mergeExprItems(a, b) {
    if (b === '""') return a;
    if (a === '""') return b;
    if (typeof a == "string") {
        if (b instanceof $0672416fa0550d12$var$Name || a[a.length - 1] !== '"') return;
        if (typeof b != "string") return `${a.slice(0, -1)}${b}"`;
        if (b[0] === '"') return a.slice(0, -1) + b.slice(1);
        return;
    }
    if (typeof b == "string" && b[0] === '"' && !(a instanceof $0672416fa0550d12$var$Name)) return `"${a}${b.slice(1)}`;
    return;
}
function $0672416fa0550d12$var$strConcat(c1, c2) {
    return c2.emptyStr() ? c1 : c1.emptyStr() ? c2 : $0672416fa0550d12$var$str($0672416fa0550d12$var$t || ($0672416fa0550d12$var$t = $0672416fa0550d12$var$_`${0}${0}`), c1, c2);
}
module.exports.strConcat = $0672416fa0550d12$var$strConcat;
// TODO do not allow arrays here
function $0672416fa0550d12$var$interpolate(x) {
    return typeof x == "number" || typeof x == "boolean" || x === null ? x : $0672416fa0550d12$var$safeStringify(Array.isArray(x) ? x.join(",") : x);
}
function $0672416fa0550d12$var$stringify(x) {
    return new $0672416fa0550d12$var$_Code($0672416fa0550d12$var$safeStringify(x));
}
module.exports.stringify = $0672416fa0550d12$var$stringify;
function $0672416fa0550d12$var$safeStringify(x) {
    return JSON.stringify(x).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
}
module.exports.safeStringify = $0672416fa0550d12$var$safeStringify;
function $0672416fa0550d12$var$getProperty(key) {
    return typeof key == "string" && module.exports.IDENTIFIER.test(key) ? new $0672416fa0550d12$var$_Code(`.${key}`) : $0672416fa0550d12$var$_1($0672416fa0550d12$var$t1 || ($0672416fa0550d12$var$t1 = $0672416fa0550d12$var$_`[${0}]`), key);
}
module.exports.getProperty = $0672416fa0550d12$var$getProperty;
//Does best effort to format the name properly
function $0672416fa0550d12$var$getEsmExportName(key) {
    if (typeof key == "string" && module.exports.IDENTIFIER.test(key)) return new $0672416fa0550d12$var$_Code(`${key}`);
    throw new Error(`CodeGen: invalid export name: ${key}, use explicit $id name mapping`);
}
module.exports.getEsmExportName = $0672416fa0550d12$var$getEsmExportName;
function $0672416fa0550d12$var$regexpCode(rx) {
    return new $0672416fa0550d12$var$_Code(rx.toString());
}
module.exports.regexpCode = $0672416fa0550d12$var$regexpCode;

});

parcelRequire.register("kzaMy", function(module, exports) {
"use strict";
let $ef8f70a9eb454352$var$_ = (t)=>t, $ef8f70a9eb454352$var$t, $ef8f70a9eb454352$var$t1, $ef8f70a9eb454352$var$t2, $ef8f70a9eb454352$var$t3, $ef8f70a9eb454352$var$t4;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ValueScope = module.exports.ValueScopeName = module.exports.Scope = module.exports.varKinds = module.exports.UsedValueState = void 0;

var $yjrkC = parcelRequire("yjrkC");
class $ef8f70a9eb454352$var$ValueError extends Error {
    constructor(name){
        super(`CodeGen: "code" for ${name} not defined`);
        this.value = name.value;
    }
}
var $ef8f70a9eb454352$var$UsedValueState;
(function(UsedValueState) {
    UsedValueState[UsedValueState["Started"] = 0] = "Started";
    UsedValueState[UsedValueState["Completed"] = 1] = "Completed";
})($ef8f70a9eb454352$var$UsedValueState = module.exports.UsedValueState || (module.exports.UsedValueState = {}));
module.exports.varKinds = {
    const: new $yjrkC.Name("const"),
    let: new $yjrkC.Name("let"),
    var: new $yjrkC.Name("var")
};
class $ef8f70a9eb454352$var$Scope {
    toName(nameOrPrefix) {
        return nameOrPrefix instanceof $yjrkC.Name ? nameOrPrefix : this.name(nameOrPrefix);
    }
    name(prefix) {
        return new $yjrkC.Name(this._newName(prefix));
    }
    _newName(prefix) {
        const ng = this._names[prefix] || this._nameGroup(prefix);
        return `${prefix}${ng.index++}`;
    }
    _nameGroup(prefix) {
        var _a, _b;
        if (((_b = (_a = this._parent) === null || _a === void 0 ? void 0 : _a._prefixes) === null || _b === void 0 ? void 0 : _b.has(prefix)) || this._prefixes && !this._prefixes.has(prefix)) throw new Error(`CodeGen: prefix "${prefix}" is not allowed in this scope`);
        return this._names[prefix] = {
            prefix: prefix,
            index: 0
        };
    }
    constructor({ prefixes: prefixes, parent: parent } = {}){
        this._names = {};
        this._prefixes = prefixes;
        this._parent = parent;
    }
}
module.exports.Scope = $ef8f70a9eb454352$var$Scope;
class $ef8f70a9eb454352$var$ValueScopeName extends $yjrkC.Name {
    setValue(value, { property: property, itemIndex: itemIndex }) {
        this.value = value;
        this.scopePath = (0, $yjrkC._)($ef8f70a9eb454352$var$t || ($ef8f70a9eb454352$var$t = $ef8f70a9eb454352$var$_`.${0}[${0}]`), new $yjrkC.Name(property), itemIndex);
    }
    constructor(prefix, nameStr){
        super(nameStr);
        this.prefix = prefix;
    }
}
module.exports.ValueScopeName = $ef8f70a9eb454352$var$ValueScopeName;
const $ef8f70a9eb454352$var$line = (0, $yjrkC._)($ef8f70a9eb454352$var$t1 || ($ef8f70a9eb454352$var$t1 = $ef8f70a9eb454352$var$_`\n`));
class $ef8f70a9eb454352$var$ValueScope extends $ef8f70a9eb454352$var$Scope {
    get() {
        return this._scope;
    }
    name(prefix) {
        return new $ef8f70a9eb454352$var$ValueScopeName(prefix, this._newName(prefix));
    }
    value(nameOrPrefix, value) {
        var _a;
        if (value.ref === undefined) throw new Error("CodeGen: ref must be passed in value");
        const name = this.toName(nameOrPrefix);
        const { prefix: prefix } = name;
        const valueKey = (_a = value.key) !== null && _a !== void 0 ? _a : value.ref;
        let vs = this._values[prefix];
        if (vs) {
            const _name = vs.get(valueKey);
            if (_name) return _name;
        } else vs = this._values[prefix] = new Map();
        vs.set(valueKey, name);
        const s = this._scope[prefix] || (this._scope[prefix] = []);
        const itemIndex = s.length;
        s[itemIndex] = value.ref;
        name.setValue(value, {
            property: prefix,
            itemIndex: itemIndex
        });
        return name;
    }
    getValue(prefix, keyOrRef) {
        const vs = this._values[prefix];
        if (!vs) return;
        return vs.get(keyOrRef);
    }
    scopeRefs(scopeName, values = this._values) {
        return this._reduceValues(values, (name)=>{
            if (name.scopePath === undefined) throw new Error(`CodeGen: name "${name}" has no value`);
            return (0, $yjrkC._)($ef8f70a9eb454352$var$t2 || ($ef8f70a9eb454352$var$t2 = $ef8f70a9eb454352$var$_`${0}${0}`), scopeName, name.scopePath);
        });
    }
    scopeCode(values = this._values, usedValues, getCode) {
        return this._reduceValues(values, (name)=>{
            if (name.value === undefined) throw new Error(`CodeGen: name "${name}" has no value`);
            return name.value.code;
        }, usedValues, getCode);
    }
    _reduceValues(values, valueCode, usedValues = {}, getCode) {
        let code = $yjrkC.nil;
        for(const prefix in values){
            const vs = values[prefix];
            if (!vs) continue;
            const nameSet = usedValues[prefix] = usedValues[prefix] || new Map();
            vs.forEach((name)=>{
                if (nameSet.has(name)) return;
                nameSet.set(name, $ef8f70a9eb454352$var$UsedValueState.Started);
                let c = valueCode(name);
                if (c) {
                    const def = this.opts.es5 ? module.exports.varKinds.var : module.exports.varKinds.const;
                    code = (0, $yjrkC._)($ef8f70a9eb454352$var$t3 || ($ef8f70a9eb454352$var$t3 = $ef8f70a9eb454352$var$_`${0}${0} ${0} = ${0};${0}`), code, def, name, c, this.opts._n);
                } else if (c = getCode === null || getCode === void 0 ? void 0 : getCode(name)) code = (0, $yjrkC._)($ef8f70a9eb454352$var$t4 || ($ef8f70a9eb454352$var$t4 = $ef8f70a9eb454352$var$_`${0}${0}${0}`), code, c, this.opts._n);
                else throw new $ef8f70a9eb454352$var$ValueError(name);
                nameSet.set(name, $ef8f70a9eb454352$var$UsedValueState.Completed);
            });
        }
        return code;
    }
    constructor(opts){
        super(opts);
        this._values = {};
        this._scope = opts.scope;
        this.opts = {
            ...opts,
            _n: opts.lines ? $ef8f70a9eb454352$var$line : $yjrkC.nil
        };
    }
}
module.exports.ValueScope = $ef8f70a9eb454352$var$ValueScope;

});


parcelRequire.register("k2074", function(module, exports) {
"use strict";
let $e95414ff479a0601$var$_ = (t)=>t, $e95414ff479a0601$var$t, $e95414ff479a0601$var$t1, $e95414ff479a0601$var$t2, $e95414ff479a0601$var$t3, $e95414ff479a0601$var$t4, $e95414ff479a0601$var$t5, $e95414ff479a0601$var$t6, $e95414ff479a0601$var$t7, $e95414ff479a0601$var$t8, $e95414ff479a0601$var$t9, $e95414ff479a0601$var$t10, $e95414ff479a0601$var$t11, $e95414ff479a0601$var$t12, $e95414ff479a0601$var$t13, $e95414ff479a0601$var$t14, $e95414ff479a0601$var$t15, $e95414ff479a0601$var$t16, $e95414ff479a0601$var$t17;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkStrictMode = module.exports.getErrorPath = module.exports.Type = module.exports.useFunc = module.exports.setEvaluated = module.exports.evaluatedPropsToName = module.exports.mergeEvaluated = module.exports.eachItem = module.exports.unescapeJsonPointer = module.exports.escapeJsonPointer = module.exports.escapeFragment = module.exports.unescapeFragment = module.exports.schemaRefOrVal = module.exports.schemaHasRulesButRef = module.exports.schemaHasRules = module.exports.checkUnknownRules = module.exports.alwaysValidSchema = module.exports.toHash = void 0;

var $6Vb5F = parcelRequire("6Vb5F");

var $yjrkC = parcelRequire("yjrkC");
// TODO refactor to use Set
function $e95414ff479a0601$var$toHash(arr) {
    const hash = {};
    for (const item of arr)hash[item] = true;
    return hash;
}
module.exports.toHash = $e95414ff479a0601$var$toHash;
function $e95414ff479a0601$var$alwaysValidSchema(it, schema) {
    if (typeof schema == "boolean") return schema;
    if (Object.keys(schema).length === 0) return true;
    $e95414ff479a0601$var$checkUnknownRules(it, schema);
    return !$e95414ff479a0601$var$schemaHasRules(schema, it.self.RULES.all);
}
module.exports.alwaysValidSchema = $e95414ff479a0601$var$alwaysValidSchema;
function $e95414ff479a0601$var$checkUnknownRules(it, schema = it.schema) {
    const { opts: opts, self: self } = it;
    if (!opts.strictSchema) return;
    if (typeof schema === "boolean") return;
    const rules = self.RULES.keywords;
    for(const key in schema)if (!rules[key]) $e95414ff479a0601$var$checkStrictMode(it, `unknown keyword: "${key}"`);
}
module.exports.checkUnknownRules = $e95414ff479a0601$var$checkUnknownRules;
function $e95414ff479a0601$var$schemaHasRules(schema, rules) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (rules[key]) return true;
    return false;
}
module.exports.schemaHasRules = $e95414ff479a0601$var$schemaHasRules;
function $e95414ff479a0601$var$schemaHasRulesButRef(schema, RULES) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (key !== "$ref" && RULES.all[key]) return true;
    return false;
}
module.exports.schemaHasRulesButRef = $e95414ff479a0601$var$schemaHasRulesButRef;
function $e95414ff479a0601$var$schemaRefOrVal({ topSchemaRef: topSchemaRef, schemaPath: schemaPath }, schema, keyword, $data) {
    if (!$data) {
        if (typeof schema == "number" || typeof schema == "boolean") return schema;
        if (typeof schema == "string") return (0, $6Vb5F._)($e95414ff479a0601$var$t || ($e95414ff479a0601$var$t = $e95414ff479a0601$var$_`${0}`), schema);
    }
    return (0, $6Vb5F._)($e95414ff479a0601$var$t1 || ($e95414ff479a0601$var$t1 = $e95414ff479a0601$var$_`${0}${0}${0}`), topSchemaRef, schemaPath, (0, $6Vb5F.getProperty)(keyword));
}
module.exports.schemaRefOrVal = $e95414ff479a0601$var$schemaRefOrVal;
function $e95414ff479a0601$var$unescapeFragment(str) {
    return $e95414ff479a0601$var$unescapeJsonPointer(decodeURIComponent(str));
}
module.exports.unescapeFragment = $e95414ff479a0601$var$unescapeFragment;
function $e95414ff479a0601$var$escapeFragment(str) {
    return encodeURIComponent($e95414ff479a0601$var$escapeJsonPointer(str));
}
module.exports.escapeFragment = $e95414ff479a0601$var$escapeFragment;
function $e95414ff479a0601$var$escapeJsonPointer(str) {
    if (typeof str == "number") return `${str}`;
    return str.replace(/~/g, "~0").replace(/\//g, "~1");
}
module.exports.escapeJsonPointer = $e95414ff479a0601$var$escapeJsonPointer;
function $e95414ff479a0601$var$unescapeJsonPointer(str) {
    return str.replace(/~1/g, "/").replace(/~0/g, "~");
}
module.exports.unescapeJsonPointer = $e95414ff479a0601$var$unescapeJsonPointer;
function $e95414ff479a0601$var$eachItem(xs, f) {
    if (Array.isArray(xs)) for (const x of xs)f(x);
    else f(xs);
}
module.exports.eachItem = $e95414ff479a0601$var$eachItem;
function $e95414ff479a0601$var$makeMergeEvaluated({ mergeNames: mergeNames, mergeToName: mergeToName, mergeValues: mergeValues, resultToName: resultToName }) {
    return (gen, from, to, toName)=>{
        const res = to === undefined ? from : to instanceof $6Vb5F.Name ? (from instanceof $6Vb5F.Name ? mergeNames(gen, from, to) : mergeToName(gen, from, to), to) : from instanceof $6Vb5F.Name ? (mergeToName(gen, to, from), from) : mergeValues(from, to);
        return toName === $6Vb5F.Name && !(res instanceof $6Vb5F.Name) ? resultToName(gen, res) : res;
    };
}
module.exports.mergeEvaluated = {
    props: $e95414ff479a0601$var$makeMergeEvaluated({
        mergeNames: (gen, from, to)=>gen.if((0, $6Vb5F._)($e95414ff479a0601$var$t2 || ($e95414ff479a0601$var$t2 = $e95414ff479a0601$var$_`${0} !== true && ${0} !== undefined`), to, from), ()=>{
                gen.if((0, $6Vb5F._)($e95414ff479a0601$var$t3 || ($e95414ff479a0601$var$t3 = $e95414ff479a0601$var$_`${0} === true`), from), ()=>gen.assign(to, true), ()=>gen.assign(to, (0, $6Vb5F._)($e95414ff479a0601$var$t4 || ($e95414ff479a0601$var$t4 = $e95414ff479a0601$var$_`${0} || {}`), to)).code((0, $6Vb5F._)($e95414ff479a0601$var$t5 || ($e95414ff479a0601$var$t5 = $e95414ff479a0601$var$_`Object.assign(${0}, ${0})`), to, from)));
            }),
        mergeToName: (gen, from, to)=>gen.if((0, $6Vb5F._)($e95414ff479a0601$var$t6 || ($e95414ff479a0601$var$t6 = $e95414ff479a0601$var$_`${0} !== true`), to), ()=>{
                if (from === true) gen.assign(to, true);
                else {
                    gen.assign(to, (0, $6Vb5F._)($e95414ff479a0601$var$t7 || ($e95414ff479a0601$var$t7 = $e95414ff479a0601$var$_`${0} || {}`), to));
                    $e95414ff479a0601$var$setEvaluated(gen, to, from);
                }
            }),
        mergeValues: (from, to)=>from === true ? true : {
                ...from,
                ...to
            },
        resultToName: $e95414ff479a0601$var$evaluatedPropsToName
    }),
    items: $e95414ff479a0601$var$makeMergeEvaluated({
        mergeNames: (gen, from, to)=>gen.if((0, $6Vb5F._)($e95414ff479a0601$var$t8 || ($e95414ff479a0601$var$t8 = $e95414ff479a0601$var$_`${0} !== true && ${0} !== undefined`), to, from), ()=>gen.assign(to, (0, $6Vb5F._)($e95414ff479a0601$var$t9 || ($e95414ff479a0601$var$t9 = $e95414ff479a0601$var$_`${0} === true ? true : ${0} > ${0} ? ${0} : ${0}`), from, to, from, to, from))),
        mergeToName: (gen, from, to)=>gen.if((0, $6Vb5F._)($e95414ff479a0601$var$t10 || ($e95414ff479a0601$var$t10 = $e95414ff479a0601$var$_`${0} !== true`), to), ()=>gen.assign(to, from === true ? true : (0, $6Vb5F._)($e95414ff479a0601$var$t11 || ($e95414ff479a0601$var$t11 = $e95414ff479a0601$var$_`${0} > ${0} ? ${0} : ${0}`), to, from, to, from))),
        mergeValues: (from, to)=>from === true ? true : Math.max(from, to),
        resultToName: (gen, items)=>gen.var("items", items)
    })
};
function $e95414ff479a0601$var$evaluatedPropsToName(gen, ps) {
    if (ps === true) return gen.var("props", true);
    const props = gen.var("props", (0, $6Vb5F._)($e95414ff479a0601$var$t12 || ($e95414ff479a0601$var$t12 = $e95414ff479a0601$var$_`{}`)));
    if (ps !== undefined) $e95414ff479a0601$var$setEvaluated(gen, props, ps);
    return props;
}
module.exports.evaluatedPropsToName = $e95414ff479a0601$var$evaluatedPropsToName;
function $e95414ff479a0601$var$setEvaluated(gen, props, ps) {
    Object.keys(ps).forEach((p)=>gen.assign((0, $6Vb5F._)($e95414ff479a0601$var$t13 || ($e95414ff479a0601$var$t13 = $e95414ff479a0601$var$_`${0}${0}`), props, (0, $6Vb5F.getProperty)(p)), true));
}
module.exports.setEvaluated = $e95414ff479a0601$var$setEvaluated;
const $e95414ff479a0601$var$snippets = {};
function $e95414ff479a0601$var$useFunc(gen, f) {
    return gen.scopeValue("func", {
        ref: f,
        code: $e95414ff479a0601$var$snippets[f.code] || ($e95414ff479a0601$var$snippets[f.code] = new $yjrkC._Code(f.code))
    });
}
module.exports.useFunc = $e95414ff479a0601$var$useFunc;
var $e95414ff479a0601$var$Type;
(function(Type) {
    Type[Type["Num"] = 0] = "Num";
    Type[Type["Str"] = 1] = "Str";
})($e95414ff479a0601$var$Type = module.exports.Type || (module.exports.Type = {}));
function $e95414ff479a0601$var$getErrorPath(dataProp, dataPropType, jsPropertySyntax) {
    // let path
    if (dataProp instanceof $6Vb5F.Name) {
        const isNumber = dataPropType === $e95414ff479a0601$var$Type.Num;
        return jsPropertySyntax ? isNumber ? (0, $6Vb5F._)($e95414ff479a0601$var$t14 || ($e95414ff479a0601$var$t14 = $e95414ff479a0601$var$_`"[" + ${0} + "]"`), dataProp) : (0, $6Vb5F._)($e95414ff479a0601$var$t15 || ($e95414ff479a0601$var$t15 = $e95414ff479a0601$var$_`"['" + ${0} + "']"`), dataProp) : isNumber ? (0, $6Vb5F._)($e95414ff479a0601$var$t16 || ($e95414ff479a0601$var$t16 = $e95414ff479a0601$var$_`"/" + ${0}`), dataProp) : (0, $6Vb5F._)($e95414ff479a0601$var$t17 || ($e95414ff479a0601$var$t17 = $e95414ff479a0601$var$_`"/" + ${0}.replace(/~/g, "~0").replace(/\\//g, "~1")`), dataProp); // TODO maybe use global escapePointer
    }
    return jsPropertySyntax ? (0, $6Vb5F.getProperty)(dataProp).toString() : "/" + $e95414ff479a0601$var$escapeJsonPointer(dataProp);
}
module.exports.getErrorPath = $e95414ff479a0601$var$getErrorPath;
function $e95414ff479a0601$var$checkStrictMode(it, msg, mode = it.opts.strictSchema) {
    if (!mode) return;
    msg = `strict mode: ${msg}`;
    if (mode === true) throw new Error(msg);
    it.self.logger.warn(msg);
}
module.exports.checkStrictMode = $e95414ff479a0601$var$checkStrictMode;

});

parcelRequire.register("eXNSw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6Vb5F = parcelRequire("6Vb5F");
const $ae4d442c16687400$var$names = {
    // validation function arguments
    data: new $6Vb5F.Name("data"),
    // args passed from referencing schema
    valCxt: new $6Vb5F.Name("valCxt"),
    instancePath: new $6Vb5F.Name("instancePath"),
    parentData: new $6Vb5F.Name("parentData"),
    parentDataProperty: new $6Vb5F.Name("parentDataProperty"),
    rootData: new $6Vb5F.Name("rootData"),
    dynamicAnchors: new $6Vb5F.Name("dynamicAnchors"),
    // function scoped variables
    vErrors: new $6Vb5F.Name("vErrors"),
    errors: new $6Vb5F.Name("errors"),
    this: new $6Vb5F.Name("this"),
    // "globals"
    self: new $6Vb5F.Name("self"),
    scope: new $6Vb5F.Name("scope"),
    // JTD serialize/parse name for JSON string and position
    json: new $6Vb5F.Name("json"),
    jsonPos: new $6Vb5F.Name("jsonPos"),
    jsonLen: new $6Vb5F.Name("jsonLen"),
    jsonPart: new $6Vb5F.Name("jsonPart")
};
module.exports.default = $ae4d442c16687400$var$names;

});



parcelRequire.register("5jmf7", function(module, exports) {
"use strict";
let $3ddffb16b124534c$var$_ = (t)=>t, $3ddffb16b124534c$var$t, $3ddffb16b124534c$var$t1, $3ddffb16b124534c$var$t2, $3ddffb16b124534c$var$t3, $3ddffb16b124534c$var$t4, $3ddffb16b124534c$var$t5, $3ddffb16b124534c$var$t6, $3ddffb16b124534c$var$t7, $3ddffb16b124534c$var$t8, $3ddffb16b124534c$var$t9, $3ddffb16b124534c$var$t10, $3ddffb16b124534c$var$t11, $3ddffb16b124534c$var$t12, $3ddffb16b124534c$var$t13, $3ddffb16b124534c$var$t14, $3ddffb16b124534c$var$t15, $3ddffb16b124534c$var$t16, $3ddffb16b124534c$var$t17, $3ddffb16b124534c$var$t18, $3ddffb16b124534c$var$t19, $3ddffb16b124534c$var$t20, $3ddffb16b124534c$var$t21, $3ddffb16b124534c$var$t22, $3ddffb16b124534c$var$t23, $3ddffb16b124534c$var$t24, $3ddffb16b124534c$var$t25, $3ddffb16b124534c$var$t26, $3ddffb16b124534c$var$t27, $3ddffb16b124534c$var$t28, $3ddffb16b124534c$var$t29, $3ddffb16b124534c$var$t30, $3ddffb16b124534c$var$t31, $3ddffb16b124534c$var$t32;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.reportTypeError = module.exports.checkDataTypes = module.exports.checkDataType = module.exports.coerceAndCheckDataType = module.exports.getJSONTypes = module.exports.getSchemaTypes = module.exports.DataType = void 0;

var $j5Abb = parcelRequire("j5Abb");

var $5g9SJ = parcelRequire("5g9SJ");

var $lWojU = parcelRequire("lWojU");

var $6Vb5F = parcelRequire("6Vb5F");

var $k2074 = parcelRequire("k2074");
var $3ddffb16b124534c$var$DataType;
(function(DataType) {
    DataType[DataType["Correct"] = 0] = "Correct";
    DataType[DataType["Wrong"] = 1] = "Wrong";
})($3ddffb16b124534c$var$DataType = module.exports.DataType || (module.exports.DataType = {}));
function $3ddffb16b124534c$var$getSchemaTypes(schema) {
    const types = $3ddffb16b124534c$var$getJSONTypes(schema.type);
    const hasNull = types.includes("null");
    if (hasNull) {
        if (schema.nullable === false) throw new Error("type: null contradicts nullable: false");
    } else {
        if (!types.length && schema.nullable !== undefined) throw new Error('"nullable" cannot be used without "type"');
        if (schema.nullable === true) types.push("null");
    }
    return types;
}
module.exports.getSchemaTypes = $3ddffb16b124534c$var$getSchemaTypes;
function $3ddffb16b124534c$var$getJSONTypes(ts) {
    const types = Array.isArray(ts) ? ts : ts ? [
        ts
    ] : [];
    if (types.every($j5Abb.isJSONType)) return types;
    throw new Error("type must be JSONType or JSONType[]: " + types.join(","));
}
module.exports.getJSONTypes = $3ddffb16b124534c$var$getJSONTypes;
function $3ddffb16b124534c$var$coerceAndCheckDataType(it, types) {
    const { gen: gen, data: data, opts: opts } = it;
    const coerceTo = $3ddffb16b124534c$var$coerceToTypes(types, opts.coerceTypes);
    const checkTypes = types.length > 0 && !(coerceTo.length === 0 && types.length === 1 && (0, $5g9SJ.schemaHasRulesForType)(it, types[0]));
    if (checkTypes) {
        const wrongType = $3ddffb16b124534c$var$checkDataTypes(types, data, opts.strictNumbers, $3ddffb16b124534c$var$DataType.Wrong);
        gen.if(wrongType, ()=>{
            if (coerceTo.length) $3ddffb16b124534c$var$coerceData(it, types, coerceTo);
            else $3ddffb16b124534c$var$reportTypeError(it);
        });
    }
    return checkTypes;
}
module.exports.coerceAndCheckDataType = $3ddffb16b124534c$var$coerceAndCheckDataType;
const $3ddffb16b124534c$var$COERCIBLE = new Set([
    "string",
    "number",
    "integer",
    "boolean",
    "null"
]);
function $3ddffb16b124534c$var$coerceToTypes(types, coerceTypes) {
    return coerceTypes ? types.filter((t)=>$3ddffb16b124534c$var$COERCIBLE.has(t) || coerceTypes === "array" && t === "array") : [];
}
function $3ddffb16b124534c$var$coerceData(it, types, coerceTo) {
    const { gen: gen, data: data, opts: opts } = it;
    const dataType = gen.let("dataType", (0, $6Vb5F._)($3ddffb16b124534c$var$t || ($3ddffb16b124534c$var$t = $3ddffb16b124534c$var$_`typeof ${0}`), data));
    const coerced = gen.let("coerced", (0, $6Vb5F._)($3ddffb16b124534c$var$t1 || ($3ddffb16b124534c$var$t1 = $3ddffb16b124534c$var$_`undefined`)));
    if (opts.coerceTypes === "array") gen.if((0, $6Vb5F._)($3ddffb16b124534c$var$t2 || ($3ddffb16b124534c$var$t2 = $3ddffb16b124534c$var$_`${0} == 'object' && Array.isArray(${0}) && ${0}.length == 1`), dataType, data, data), ()=>gen.assign(data, (0, $6Vb5F._)($3ddffb16b124534c$var$t3 || ($3ddffb16b124534c$var$t3 = $3ddffb16b124534c$var$_`${0}[0]`), data)).assign(dataType, (0, $6Vb5F._)($3ddffb16b124534c$var$t4 || ($3ddffb16b124534c$var$t4 = $3ddffb16b124534c$var$_`typeof ${0}`), data)).if($3ddffb16b124534c$var$checkDataTypes(types, data, opts.strictNumbers), ()=>gen.assign(coerced, data)));
    gen.if((0, $6Vb5F._)($3ddffb16b124534c$var$t5 || ($3ddffb16b124534c$var$t5 = $3ddffb16b124534c$var$_`${0} !== undefined`), coerced));
    for (const t of coerceTo)if ($3ddffb16b124534c$var$COERCIBLE.has(t) || t === "array" && opts.coerceTypes === "array") coerceSpecificType(t);
    gen.else();
    $3ddffb16b124534c$var$reportTypeError(it);
    gen.endIf();
    gen.if((0, $6Vb5F._)($3ddffb16b124534c$var$t6 || ($3ddffb16b124534c$var$t6 = $3ddffb16b124534c$var$_`${0} !== undefined`), coerced), ()=>{
        gen.assign(data, coerced);
        $3ddffb16b124534c$var$assignParentData(it, coerced);
    });
    function coerceSpecificType(t) {
        switch(t){
            case "string":
                gen.elseIf((0, $6Vb5F._)($3ddffb16b124534c$var$t7 || ($3ddffb16b124534c$var$t7 = $3ddffb16b124534c$var$_`${0} == "number" || ${0} == "boolean"`), dataType, dataType)).assign(coerced, (0, $6Vb5F._)($3ddffb16b124534c$var$t8 || ($3ddffb16b124534c$var$t8 = $3ddffb16b124534c$var$_`"" + ${0}`), data)).elseIf((0, $6Vb5F._)($3ddffb16b124534c$var$t9 || ($3ddffb16b124534c$var$t9 = $3ddffb16b124534c$var$_`${0} === null`), data)).assign(coerced, (0, $6Vb5F._)($3ddffb16b124534c$var$t10 || ($3ddffb16b124534c$var$t10 = $3ddffb16b124534c$var$_`""`)));
                return;
            case "number":
                gen.elseIf((0, $6Vb5F._)($3ddffb16b124534c$var$t11 || ($3ddffb16b124534c$var$t11 = $3ddffb16b124534c$var$_`${0} == "boolean" || ${0} === null
              || (${0} == "string" && ${0} && ${0} == +${0})`), dataType, data, dataType, data, data, data)).assign(coerced, (0, $6Vb5F._)($3ddffb16b124534c$var$t12 || ($3ddffb16b124534c$var$t12 = $3ddffb16b124534c$var$_`+${0}`), data));
                return;
            case "integer":
                gen.elseIf((0, $6Vb5F._)($3ddffb16b124534c$var$t13 || ($3ddffb16b124534c$var$t13 = $3ddffb16b124534c$var$_`${0} === "boolean" || ${0} === null
              || (${0} === "string" && ${0} && ${0} == +${0} && !(${0} % 1))`), dataType, data, dataType, data, data, data, data)).assign(coerced, (0, $6Vb5F._)($3ddffb16b124534c$var$t14 || ($3ddffb16b124534c$var$t14 = $3ddffb16b124534c$var$_`+${0}`), data));
                return;
            case "boolean":
                gen.elseIf((0, $6Vb5F._)($3ddffb16b124534c$var$t15 || ($3ddffb16b124534c$var$t15 = $3ddffb16b124534c$var$_`${0} === "false" || ${0} === 0 || ${0} === null`), data, data, data)).assign(coerced, false).elseIf((0, $6Vb5F._)($3ddffb16b124534c$var$t16 || ($3ddffb16b124534c$var$t16 = $3ddffb16b124534c$var$_`${0} === "true" || ${0} === 1`), data, data)).assign(coerced, true);
                return;
            case "null":
                gen.elseIf((0, $6Vb5F._)($3ddffb16b124534c$var$t17 || ($3ddffb16b124534c$var$t17 = $3ddffb16b124534c$var$_`${0} === "" || ${0} === 0 || ${0} === false`), data, data, data));
                gen.assign(coerced, null);
                return;
            case "array":
                gen.elseIf((0, $6Vb5F._)($3ddffb16b124534c$var$t18 || ($3ddffb16b124534c$var$t18 = $3ddffb16b124534c$var$_`${0} === "string" || ${0} === "number"
              || ${0} === "boolean" || ${0} === null`), dataType, dataType, dataType, data)).assign(coerced, (0, $6Vb5F._)($3ddffb16b124534c$var$t19 || ($3ddffb16b124534c$var$t19 = $3ddffb16b124534c$var$_`[${0}]`), data));
        }
    }
}
function $3ddffb16b124534c$var$assignParentData({ gen: gen, parentData: parentData, parentDataProperty: parentDataProperty }, expr) {
    // TODO use gen.property
    gen.if((0, $6Vb5F._)($3ddffb16b124534c$var$t20 || ($3ddffb16b124534c$var$t20 = $3ddffb16b124534c$var$_`${0} !== undefined`), parentData), ()=>gen.assign((0, $6Vb5F._)($3ddffb16b124534c$var$t21 || ($3ddffb16b124534c$var$t21 = $3ddffb16b124534c$var$_`${0}[${0}]`), parentData, parentDataProperty), expr));
}
function $3ddffb16b124534c$var$checkDataType(dataType, data, strictNums, correct = $3ddffb16b124534c$var$DataType.Correct) {
    const EQ = correct === $3ddffb16b124534c$var$DataType.Correct ? $6Vb5F.operators.EQ : $6Vb5F.operators.NEQ;
    let cond;
    switch(dataType){
        case "null":
            return (0, $6Vb5F._)($3ddffb16b124534c$var$t22 || ($3ddffb16b124534c$var$t22 = $3ddffb16b124534c$var$_`${0} ${0} null`), data, EQ);
        case "array":
            cond = (0, $6Vb5F._)($3ddffb16b124534c$var$t23 || ($3ddffb16b124534c$var$t23 = $3ddffb16b124534c$var$_`Array.isArray(${0})`), data);
            break;
        case "object":
            cond = (0, $6Vb5F._)($3ddffb16b124534c$var$t24 || ($3ddffb16b124534c$var$t24 = $3ddffb16b124534c$var$_`${0} && typeof ${0} == "object" && !Array.isArray(${0})`), data, data, data);
            break;
        case "integer":
            cond = numCond((0, $6Vb5F._)($3ddffb16b124534c$var$t25 || ($3ddffb16b124534c$var$t25 = $3ddffb16b124534c$var$_`!(${0} % 1) && !isNaN(${0})`), data, data));
            break;
        case "number":
            cond = numCond();
            break;
        default:
            return (0, $6Vb5F._)($3ddffb16b124534c$var$t26 || ($3ddffb16b124534c$var$t26 = $3ddffb16b124534c$var$_`typeof ${0} ${0} ${0}`), data, EQ, dataType);
    }
    return correct === $3ddffb16b124534c$var$DataType.Correct ? cond : (0, $6Vb5F.not)(cond);
    function numCond(_cond = $6Vb5F.nil) {
        return (0, $6Vb5F.and)((0, $6Vb5F._)($3ddffb16b124534c$var$t27 || ($3ddffb16b124534c$var$t27 = $3ddffb16b124534c$var$_`typeof ${0} == "number"`), data), _cond, strictNums ? (0, $6Vb5F._)($3ddffb16b124534c$var$t28 || ($3ddffb16b124534c$var$t28 = $3ddffb16b124534c$var$_`isFinite(${0})`), data) : $6Vb5F.nil);
    }
}
module.exports.checkDataType = $3ddffb16b124534c$var$checkDataType;
function $3ddffb16b124534c$var$checkDataTypes(dataTypes, data, strictNums, correct) {
    if (dataTypes.length === 1) return $3ddffb16b124534c$var$checkDataType(dataTypes[0], data, strictNums, correct);
    let cond;
    const types = (0, $k2074.toHash)(dataTypes);
    if (types.array && types.object) {
        const notObj = (0, $6Vb5F._)($3ddffb16b124534c$var$t29 || ($3ddffb16b124534c$var$t29 = $3ddffb16b124534c$var$_`typeof ${0} != "object"`), data);
        cond = types.null ? notObj : (0, $6Vb5F._)($3ddffb16b124534c$var$t30 || ($3ddffb16b124534c$var$t30 = $3ddffb16b124534c$var$_`!${0} || ${0}`), data, notObj);
        delete types.null;
        delete types.array;
        delete types.object;
    } else cond = $6Vb5F.nil;
    if (types.number) delete types.integer;
    for(const t in types)cond = (0, $6Vb5F.and)(cond, $3ddffb16b124534c$var$checkDataType(t, data, strictNums, correct));
    return cond;
}
module.exports.checkDataTypes = $3ddffb16b124534c$var$checkDataTypes;
const $3ddffb16b124534c$var$typeError = {
    message: ({ schema: schema })=>`must be ${schema}`,
    params: ({ schema: schema, schemaValue: schemaValue })=>typeof schema == "string" ? (0, $6Vb5F._)($3ddffb16b124534c$var$t31 || ($3ddffb16b124534c$var$t31 = $3ddffb16b124534c$var$_`{type: ${0}}`), schema) : (0, $6Vb5F._)($3ddffb16b124534c$var$t32 || ($3ddffb16b124534c$var$t32 = $3ddffb16b124534c$var$_`{type: ${0}}`), schemaValue)
};
function $3ddffb16b124534c$var$reportTypeError(it) {
    const cxt = $3ddffb16b124534c$var$getTypeErrorContext(it);
    (0, $lWojU.reportError)(cxt, $3ddffb16b124534c$var$typeError);
}
module.exports.reportTypeError = $3ddffb16b124534c$var$reportTypeError;
function $3ddffb16b124534c$var$getTypeErrorContext(it) {
    const { gen: gen, data: data, schema: schema } = it;
    const schemaCode = (0, $k2074.schemaRefOrVal)(it, schema, "type");
    return {
        gen: gen,
        keyword: "type",
        data: data,
        schema: schema.type,
        schemaCode: schemaCode,
        schemaValue: schemaCode,
        parentSchema: schema,
        params: {},
        it: it
    };
}

});
parcelRequire.register("j5Abb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRules = module.exports.isJSONType = void 0;
const $de5a8c69874e9778$var$_jsonTypes = [
    "string",
    "number",
    "integer",
    "boolean",
    "null",
    "object",
    "array"
];
const $de5a8c69874e9778$var$jsonTypes = new Set($de5a8c69874e9778$var$_jsonTypes);
function $de5a8c69874e9778$var$isJSONType(x) {
    return typeof x == "string" && $de5a8c69874e9778$var$jsonTypes.has(x);
}
module.exports.isJSONType = $de5a8c69874e9778$var$isJSONType;
function $de5a8c69874e9778$var$getRules() {
    const groups = {
        number: {
            type: "number",
            rules: []
        },
        string: {
            type: "string",
            rules: []
        },
        array: {
            type: "array",
            rules: []
        },
        object: {
            type: "object",
            rules: []
        }
    };
    return {
        types: {
            ...groups,
            integer: true,
            boolean: true,
            null: true
        },
        rules: [
            {
                rules: []
            },
            groups.number,
            groups.string,
            groups.array,
            groups.object
        ],
        post: {
            rules: []
        },
        all: {},
        keywords: {}
    };
}
module.exports.getRules = $de5a8c69874e9778$var$getRules;

});

parcelRequire.register("5g9SJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shouldUseRule = module.exports.shouldUseGroup = module.exports.schemaHasRulesForType = void 0;
function $3d461ca9b15225a6$var$schemaHasRulesForType({ schema: schema, self: self }, type) {
    const group = self.RULES.types[type];
    return group && group !== true && $3d461ca9b15225a6$var$shouldUseGroup(schema, group);
}
module.exports.schemaHasRulesForType = $3d461ca9b15225a6$var$schemaHasRulesForType;
function $3d461ca9b15225a6$var$shouldUseGroup(schema, group) {
    return group.rules.some((rule)=>$3d461ca9b15225a6$var$shouldUseRule(schema, rule));
}
module.exports.shouldUseGroup = $3d461ca9b15225a6$var$shouldUseGroup;
function $3d461ca9b15225a6$var$shouldUseRule(schema, rule) {
    var _a;
    return schema[rule.keyword] !== undefined || ((_a = rule.definition.implements) === null || _a === void 0 ? void 0 : _a.some((kwd)=>schema[kwd] !== undefined));
}
module.exports.shouldUseRule = $3d461ca9b15225a6$var$shouldUseRule;

});


parcelRequire.register("6MDI7", function(module, exports) {
"use strict";
let $4f06077463f2c60b$var$_ = (t)=>t, $4f06077463f2c60b$var$t, $4f06077463f2c60b$var$t1, $4f06077463f2c60b$var$t2, $4f06077463f2c60b$var$t3;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assignDefaults = void 0;

var $6Vb5F = parcelRequire("6Vb5F");

var $k2074 = parcelRequire("k2074");
function $4f06077463f2c60b$var$assignDefaults(it, ty) {
    const { properties: properties, items: items } = it.schema;
    if (ty === "object" && properties) for(const key in properties)$4f06077463f2c60b$var$assignDefault(it, key, properties[key].default);
    else if (ty === "array" && Array.isArray(items)) items.forEach((sch, i)=>$4f06077463f2c60b$var$assignDefault(it, i, sch.default));
}
module.exports.assignDefaults = $4f06077463f2c60b$var$assignDefaults;
function $4f06077463f2c60b$var$assignDefault(it, prop, defaultValue) {
    const { gen: gen, compositeRule: compositeRule, data: data, opts: opts } = it;
    if (defaultValue === undefined) return;
    const childData = (0, $6Vb5F._)($4f06077463f2c60b$var$t || ($4f06077463f2c60b$var$t = $4f06077463f2c60b$var$_`${0}${0}`), data, (0, $6Vb5F.getProperty)(prop));
    if (compositeRule) {
        (0, $k2074.checkStrictMode)(it, `default is ignored for: ${childData}`);
        return;
    }
    let condition = (0, $6Vb5F._)($4f06077463f2c60b$var$t1 || ($4f06077463f2c60b$var$t1 = $4f06077463f2c60b$var$_`${0} === undefined`), childData);
    if (opts.useDefaults === "empty") condition = (0, $6Vb5F._)($4f06077463f2c60b$var$t2 || ($4f06077463f2c60b$var$t2 = $4f06077463f2c60b$var$_`${0} || ${0} === null || ${0} === ""`), condition, childData, childData);
    // `${childData} === undefined` +
    // (opts.useDefaults === "empty" ? ` || ${childData} === null || ${childData} === ""` : "")
    gen.if(condition, (0, $6Vb5F._)($4f06077463f2c60b$var$t3 || ($4f06077463f2c60b$var$t3 = $4f06077463f2c60b$var$_`${0} = ${0}`), childData, (0, $6Vb5F.stringify)(defaultValue)));
}

});

parcelRequire.register("Emq0w", function(module, exports) {
"use strict";
let $0795206248189896$var$_ = (t)=>t, $0795206248189896$var$t, $0795206248189896$var$t1, $0795206248189896$var$t2, $0795206248189896$var$t3, $0795206248189896$var$t4, $0795206248189896$var$t5, $0795206248189896$var$t6, $0795206248189896$var$t7, $0795206248189896$var$t8, $0795206248189896$var$t9;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateKeywordUsage = module.exports.validSchemaType = module.exports.funcKeywordCode = module.exports.macroKeywordCode = void 0;

var $6Vb5F = parcelRequire("6Vb5F");

var $eXNSw = parcelRequire("eXNSw");

var $5Cgzr = parcelRequire("5Cgzr");

var $lWojU = parcelRequire("lWojU");
function $0795206248189896$var$macroKeywordCode(cxt, def) {
    const { gen: gen, keyword: keyword, schema: schema, parentSchema: parentSchema, it: it } = cxt;
    const macroSchema = def.macro.call(it.self, schema, parentSchema, it);
    const schemaRef = $0795206248189896$var$useKeyword(gen, keyword, macroSchema);
    if (it.opts.validateSchema !== false) it.self.validateSchema(macroSchema, true);
    const valid = gen.name("valid");
    cxt.subschema({
        schema: macroSchema,
        schemaPath: $6Vb5F.nil,
        errSchemaPath: `${it.errSchemaPath}/${keyword}`,
        topSchemaRef: schemaRef,
        compositeRule: true
    }, valid);
    cxt.pass(valid, ()=>cxt.error(true));
}
module.exports.macroKeywordCode = $0795206248189896$var$macroKeywordCode;
function $0795206248189896$var$funcKeywordCode(cxt, def) {
    var _a;
    const { gen: gen, keyword: keyword, schema: schema, parentSchema: parentSchema, $data: $data, it: it } = cxt;
    $0795206248189896$var$checkAsyncKeyword(it, def);
    const validate = !$data && def.compile ? def.compile.call(it.self, schema, parentSchema, it) : def.validate;
    const validateRef = $0795206248189896$var$useKeyword(gen, keyword, validate);
    const valid = gen.let("valid");
    cxt.block$data(valid, validateKeyword);
    cxt.ok((_a = def.valid) !== null && _a !== void 0 ? _a : valid);
    function validateKeyword() {
        if (def.errors === false) {
            assignValid();
            if (def.modifying) $0795206248189896$var$modifyData(cxt);
            reportErrs(()=>cxt.error());
        } else {
            const ruleErrs = def.async ? validateAsync() : validateSync();
            if (def.modifying) $0795206248189896$var$modifyData(cxt);
            reportErrs(()=>$0795206248189896$var$addErrs(cxt, ruleErrs));
        }
    }
    function validateAsync() {
        const ruleErrs = gen.let("ruleErrs", null);
        gen.try(()=>assignValid((0, $6Vb5F._)($0795206248189896$var$t || ($0795206248189896$var$t = $0795206248189896$var$_`await `))), (e)=>gen.assign(valid, false).if((0, $6Vb5F._)($0795206248189896$var$t1 || ($0795206248189896$var$t1 = $0795206248189896$var$_`${0} instanceof ${0}`), e, it.ValidationError), ()=>gen.assign(ruleErrs, (0, $6Vb5F._)($0795206248189896$var$t2 || ($0795206248189896$var$t2 = $0795206248189896$var$_`${0}.errors`), e)), ()=>gen.throw(e)));
        return ruleErrs;
    }
    function validateSync() {
        const validateErrs = (0, $6Vb5F._)($0795206248189896$var$t3 || ($0795206248189896$var$t3 = $0795206248189896$var$_`${0}.errors`), validateRef);
        gen.assign(validateErrs, null);
        assignValid($6Vb5F.nil);
        return validateErrs;
    }
    function assignValid(_await = def.async ? (0, $6Vb5F._)($0795206248189896$var$t4 || ($0795206248189896$var$t4 = $0795206248189896$var$_`await `)) : $6Vb5F.nil) {
        const passCxt = it.opts.passContext ? $eXNSw.default.this : $eXNSw.default.self;
        const passSchema = !("compile" in def && !$data || def.schema === false);
        gen.assign(valid, (0, $6Vb5F._)($0795206248189896$var$t5 || ($0795206248189896$var$t5 = $0795206248189896$var$_`${0}${0}`), _await, (0, $5Cgzr.callValidateCode)(cxt, validateRef, passCxt, passSchema)), def.modifying);
    }
    function reportErrs(errors) {
        var _a;
        gen.if((0, $6Vb5F.not)((_a = def.valid) !== null && _a !== void 0 ? _a : valid), errors);
    }
}
module.exports.funcKeywordCode = $0795206248189896$var$funcKeywordCode;
function $0795206248189896$var$modifyData(cxt) {
    const { gen: gen, data: data, it: it } = cxt;
    gen.if(it.parentData, ()=>gen.assign(data, (0, $6Vb5F._)($0795206248189896$var$t6 || ($0795206248189896$var$t6 = $0795206248189896$var$_`${0}[${0}]`), it.parentData, it.parentDataProperty)));
}
function $0795206248189896$var$addErrs(cxt, errs) {
    const { gen: gen } = cxt;
    gen.if((0, $6Vb5F._)($0795206248189896$var$t7 || ($0795206248189896$var$t7 = $0795206248189896$var$_`Array.isArray(${0})`), errs), ()=>{
        gen.assign($eXNSw.default.vErrors, (0, $6Vb5F._)($0795206248189896$var$t8 || ($0795206248189896$var$t8 = $0795206248189896$var$_`${0} === null ? ${0} : ${0}.concat(${0})`), $eXNSw.default.vErrors, errs, $eXNSw.default.vErrors, errs)).assign($eXNSw.default.errors, (0, $6Vb5F._)($0795206248189896$var$t9 || ($0795206248189896$var$t9 = $0795206248189896$var$_`${0}.length`), $eXNSw.default.vErrors));
        (0, $lWojU.extendErrors)(cxt);
    }, ()=>cxt.error());
}
function $0795206248189896$var$checkAsyncKeyword({ schemaEnv: schemaEnv }, def) {
    if (def.async && !schemaEnv.$async) throw new Error("async keyword in sync schema");
}
function $0795206248189896$var$useKeyword(gen, keyword, result) {
    if (result === undefined) throw new Error(`keyword "${keyword}" failed to compile`);
    return gen.scopeValue("keyword", typeof result == "function" ? {
        ref: result
    } : {
        ref: result,
        code: (0, $6Vb5F.stringify)(result)
    });
}
function $0795206248189896$var$validSchemaType(schema, schemaType, allowUndefined = false) {
    // TODO add tests
    return !schemaType.length || schemaType.some((st)=>st === "array" ? Array.isArray(schema) : st === "object" ? schema && typeof schema == "object" && !Array.isArray(schema) : typeof schema == st || allowUndefined && typeof schema == "undefined");
}
module.exports.validSchemaType = $0795206248189896$var$validSchemaType;
function $0795206248189896$var$validateKeywordUsage({ schema: schema, opts: opts, self: self, errSchemaPath: errSchemaPath }, def, keyword) {
    /* istanbul ignore if */ if (Array.isArray(def.keyword) ? !def.keyword.includes(keyword) : def.keyword !== keyword) throw new Error("ajv implementation error");
    const deps = def.dependencies;
    if (deps === null || deps === void 0 ? void 0 : deps.some((kwd)=>!Object.prototype.hasOwnProperty.call(schema, kwd))) throw new Error(`parent schema must have dependencies of ${keyword}: ${deps.join(",")}`);
    if (def.validateSchema) {
        const valid = def.validateSchema(schema[keyword]);
        if (!valid) {
            const msg = `keyword "${keyword}" value is invalid at path "${errSchemaPath}": ` + self.errorsText(def.validateSchema.errors);
            if (opts.validateSchema === "log") self.logger.error(msg);
            else throw new Error(msg);
        }
    }
}
module.exports.validateKeywordUsage = $0795206248189896$var$validateKeywordUsage;

});
parcelRequire.register("5Cgzr", function(module, exports) {
"use strict";
let $416d5af80bd40638$var$_ = (t)=>t, $416d5af80bd40638$var$t, $416d5af80bd40638$var$t1, $416d5af80bd40638$var$t2, $416d5af80bd40638$var$t3, $416d5af80bd40638$var$t4, $416d5af80bd40638$var$t5, $416d5af80bd40638$var$t6, $416d5af80bd40638$var$t7, $416d5af80bd40638$var$t8, $416d5af80bd40638$var$t9, $416d5af80bd40638$var$t10, $416d5af80bd40638$var$t11, $416d5af80bd40638$var$t12, $416d5af80bd40638$var$t13, $416d5af80bd40638$var$t14;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateUnion = module.exports.validateArray = module.exports.usePattern = module.exports.callValidateCode = module.exports.schemaProperties = module.exports.allSchemaProperties = module.exports.noPropertyInData = module.exports.propertyInData = module.exports.isOwnProperty = module.exports.hasPropFunc = module.exports.reportMissingProp = module.exports.checkMissingProp = module.exports.checkReportMissingProp = void 0;

var $6Vb5F = parcelRequire("6Vb5F");

var $k2074 = parcelRequire("k2074");

var $eXNSw = parcelRequire("eXNSw");

var $k2074 = parcelRequire("k2074");
function $416d5af80bd40638$var$checkReportMissingProp(cxt, prop) {
    const { gen: gen, data: data, it: it } = cxt;
    gen.if($416d5af80bd40638$var$noPropertyInData(gen, data, prop, it.opts.ownProperties), ()=>{
        cxt.setParams({
            missingProperty: (0, $6Vb5F._)($416d5af80bd40638$var$t || ($416d5af80bd40638$var$t = $416d5af80bd40638$var$_`${0}`), prop)
        }, true);
        cxt.error();
    });
}
module.exports.checkReportMissingProp = $416d5af80bd40638$var$checkReportMissingProp;
function $416d5af80bd40638$var$checkMissingProp({ gen: gen, data: data, it: { opts: opts } }, properties, missing) {
    return (0, $6Vb5F.or)(...properties.map((prop)=>(0, $6Vb5F.and)($416d5af80bd40638$var$noPropertyInData(gen, data, prop, opts.ownProperties), (0, $6Vb5F._)($416d5af80bd40638$var$t1 || ($416d5af80bd40638$var$t1 = $416d5af80bd40638$var$_`${0} = ${0}`), missing, prop))));
}
module.exports.checkMissingProp = $416d5af80bd40638$var$checkMissingProp;
function $416d5af80bd40638$var$reportMissingProp(cxt, missing) {
    cxt.setParams({
        missingProperty: missing
    }, true);
    cxt.error();
}
module.exports.reportMissingProp = $416d5af80bd40638$var$reportMissingProp;
function $416d5af80bd40638$var$hasPropFunc(gen) {
    return gen.scopeValue("func", {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        ref: Object.prototype.hasOwnProperty,
        code: (0, $6Vb5F._)($416d5af80bd40638$var$t2 || ($416d5af80bd40638$var$t2 = $416d5af80bd40638$var$_`Object.prototype.hasOwnProperty`))
    });
}
module.exports.hasPropFunc = $416d5af80bd40638$var$hasPropFunc;
function $416d5af80bd40638$var$isOwnProperty(gen, data, property) {
    return (0, $6Vb5F._)($416d5af80bd40638$var$t3 || ($416d5af80bd40638$var$t3 = $416d5af80bd40638$var$_`${0}.call(${0}, ${0})`), $416d5af80bd40638$var$hasPropFunc(gen), data, property);
}
module.exports.isOwnProperty = $416d5af80bd40638$var$isOwnProperty;
function $416d5af80bd40638$var$propertyInData(gen, data, property, ownProperties) {
    const cond = (0, $6Vb5F._)($416d5af80bd40638$var$t4 || ($416d5af80bd40638$var$t4 = $416d5af80bd40638$var$_`${0}${0} !== undefined`), data, (0, $6Vb5F.getProperty)(property));
    return ownProperties ? (0, $6Vb5F._)($416d5af80bd40638$var$t5 || ($416d5af80bd40638$var$t5 = $416d5af80bd40638$var$_`${0} && ${0}`), cond, $416d5af80bd40638$var$isOwnProperty(gen, data, property)) : cond;
}
module.exports.propertyInData = $416d5af80bd40638$var$propertyInData;
function $416d5af80bd40638$var$noPropertyInData(gen, data, property, ownProperties) {
    const cond = (0, $6Vb5F._)($416d5af80bd40638$var$t6 || ($416d5af80bd40638$var$t6 = $416d5af80bd40638$var$_`${0}${0} === undefined`), data, (0, $6Vb5F.getProperty)(property));
    return ownProperties ? (0, $6Vb5F.or)(cond, (0, $6Vb5F.not)($416d5af80bd40638$var$isOwnProperty(gen, data, property))) : cond;
}
module.exports.noPropertyInData = $416d5af80bd40638$var$noPropertyInData;
function $416d5af80bd40638$var$allSchemaProperties(schemaMap) {
    return schemaMap ? Object.keys(schemaMap).filter((p)=>p !== "__proto__") : [];
}
module.exports.allSchemaProperties = $416d5af80bd40638$var$allSchemaProperties;
function $416d5af80bd40638$var$schemaProperties(it, schemaMap) {
    return $416d5af80bd40638$var$allSchemaProperties(schemaMap).filter((p)=>!(0, $k2074.alwaysValidSchema)(it, schemaMap[p]));
}
module.exports.schemaProperties = $416d5af80bd40638$var$schemaProperties;
function $416d5af80bd40638$var$callValidateCode({ schemaCode: schemaCode, data: data, it: { gen: gen, topSchemaRef: topSchemaRef, schemaPath: schemaPath, errorPath: errorPath }, it: it }, func, context, passSchema) {
    const dataAndSchema = passSchema ? (0, $6Vb5F._)($416d5af80bd40638$var$t7 || ($416d5af80bd40638$var$t7 = $416d5af80bd40638$var$_`${0}, ${0}, ${0}${0}`), schemaCode, data, topSchemaRef, schemaPath) : data;
    const valCxt = [
        [
            $eXNSw.default.instancePath,
            (0, $6Vb5F.strConcat)($eXNSw.default.instancePath, errorPath)
        ],
        [
            $eXNSw.default.parentData,
            it.parentData
        ],
        [
            $eXNSw.default.parentDataProperty,
            it.parentDataProperty
        ],
        [
            $eXNSw.default.rootData,
            $eXNSw.default.rootData
        ]
    ];
    if (it.opts.dynamicRef) valCxt.push([
        $eXNSw.default.dynamicAnchors,
        $eXNSw.default.dynamicAnchors
    ]);
    const args = (0, $6Vb5F._)($416d5af80bd40638$var$t8 || ($416d5af80bd40638$var$t8 = $416d5af80bd40638$var$_`${0}, ${0}`), dataAndSchema, gen.object(...valCxt));
    return context !== $6Vb5F.nil ? (0, $6Vb5F._)($416d5af80bd40638$var$t9 || ($416d5af80bd40638$var$t9 = $416d5af80bd40638$var$_`${0}.call(${0}, ${0})`), func, context, args) : (0, $6Vb5F._)($416d5af80bd40638$var$t10 || ($416d5af80bd40638$var$t10 = $416d5af80bd40638$var$_`${0}(${0})`), func, args);
}
module.exports.callValidateCode = $416d5af80bd40638$var$callValidateCode;
const $416d5af80bd40638$var$newRegExp = (0, $6Vb5F._)($416d5af80bd40638$var$t11 || ($416d5af80bd40638$var$t11 = $416d5af80bd40638$var$_`new RegExp`));
function $416d5af80bd40638$var$usePattern({ gen: gen, it: { opts: opts } }, pattern) {
    const u = opts.unicodeRegExp ? "u" : "";
    const { regExp: regExp } = opts.code;
    const rx = regExp(pattern, u);
    return gen.scopeValue("pattern", {
        key: rx.toString(),
        ref: rx,
        code: (0, $6Vb5F._)($416d5af80bd40638$var$t12 || ($416d5af80bd40638$var$t12 = $416d5af80bd40638$var$_`${0}(${0}, ${0})`), regExp.code === "new RegExp" ? $416d5af80bd40638$var$newRegExp : (0, $k2074.useFunc)(gen, regExp), pattern, u)
    });
}
module.exports.usePattern = $416d5af80bd40638$var$usePattern;
function $416d5af80bd40638$var$validateArray(cxt) {
    const { gen: gen, data: data, keyword: keyword, it: it } = cxt;
    const valid = gen.name("valid");
    if (it.allErrors) {
        const validArr = gen.let("valid", true);
        validateItems(()=>gen.assign(validArr, false));
        return validArr;
    }
    gen.var(valid, true);
    validateItems(()=>gen.break());
    return valid;
    function validateItems(notValid) {
        const len = gen.const("len", (0, $6Vb5F._)($416d5af80bd40638$var$t13 || ($416d5af80bd40638$var$t13 = $416d5af80bd40638$var$_`${0}.length`), data));
        gen.forRange("i", 0, len, (i)=>{
            cxt.subschema({
                keyword: keyword,
                dataProp: i,
                dataPropType: $k2074.Type.Num
            }, valid);
            gen.if((0, $6Vb5F.not)(valid), notValid);
        });
    }
}
module.exports.validateArray = $416d5af80bd40638$var$validateArray;
function $416d5af80bd40638$var$validateUnion(cxt) {
    const { gen: gen, schema: schema, keyword: keyword, it: it } = cxt;
    /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
    const alwaysValid = schema.some((sch)=>(0, $k2074.alwaysValidSchema)(it, sch));
    if (alwaysValid && !it.opts.unevaluated) return;
    const valid = gen.let("valid", false);
    const schValid = gen.name("_valid");
    gen.block(()=>schema.forEach((_sch, i)=>{
            const schCxt = cxt.subschema({
                keyword: keyword,
                schemaProp: i,
                compositeRule: true
            }, schValid);
            gen.assign(valid, (0, $6Vb5F._)($416d5af80bd40638$var$t14 || ($416d5af80bd40638$var$t14 = $416d5af80bd40638$var$_`${0} || ${0}`), valid, schValid));
            const merged = cxt.mergeValidEvaluated(schCxt, schValid);
            // can short-circuit if `unevaluatedProperties/Items` not supported (opts.unevaluated !== true)
            // or if all properties and items were evaluated (it.props === true && it.items === true)
            if (!merged) gen.if((0, $6Vb5F.not)(valid));
        }));
    cxt.result(valid, ()=>cxt.reset(), ()=>cxt.error(true));
}
module.exports.validateUnion = $416d5af80bd40638$var$validateUnion;

});


parcelRequire.register("9KkQJ", function(module, exports) {
"use strict";
let $718895362d334ad8$var$_ = (t)=>t, $718895362d334ad8$var$t, $718895362d334ad8$var$t1, $718895362d334ad8$var$t2, $718895362d334ad8$var$t3, $718895362d334ad8$var$t4;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extendSubschemaMode = module.exports.extendSubschemaData = module.exports.getSubschema = void 0;

var $6Vb5F = parcelRequire("6Vb5F");

var $k2074 = parcelRequire("k2074");
function $718895362d334ad8$var$getSubschema(it, { keyword: keyword, schemaProp: schemaProp, schema: schema, schemaPath: schemaPath, errSchemaPath: errSchemaPath, topSchemaRef: topSchemaRef }) {
    if (keyword !== undefined && schema !== undefined) throw new Error('both "keyword" and "schema" passed, only one allowed');
    if (keyword !== undefined) {
        const sch = it.schema[keyword];
        return schemaProp === undefined ? {
            schema: sch,
            schemaPath: (0, $6Vb5F._)($718895362d334ad8$var$t || ($718895362d334ad8$var$t = $718895362d334ad8$var$_`${0}${0}`), it.schemaPath, (0, $6Vb5F.getProperty)(keyword)),
            errSchemaPath: `${it.errSchemaPath}/${keyword}`
        } : {
            schema: sch[schemaProp],
            schemaPath: (0, $6Vb5F._)($718895362d334ad8$var$t1 || ($718895362d334ad8$var$t1 = $718895362d334ad8$var$_`${0}${0}${0}`), it.schemaPath, (0, $6Vb5F.getProperty)(keyword), (0, $6Vb5F.getProperty)(schemaProp)),
            errSchemaPath: `${it.errSchemaPath}/${keyword}/${(0, $k2074.escapeFragment)(schemaProp)}`
        };
    }
    if (schema !== undefined) {
        if (schemaPath === undefined || errSchemaPath === undefined || topSchemaRef === undefined) throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
        return {
            schema: schema,
            schemaPath: schemaPath,
            topSchemaRef: topSchemaRef,
            errSchemaPath: errSchemaPath
        };
    }
    throw new Error('either "keyword" or "schema" must be passed');
}
module.exports.getSubschema = $718895362d334ad8$var$getSubschema;
function $718895362d334ad8$var$extendSubschemaData(subschema, it, { dataProp: dataProp, dataPropType: dpType, data: data, dataTypes: dataTypes, propertyName: propertyName }) {
    if (data !== undefined && dataProp !== undefined) throw new Error('both "data" and "dataProp" passed, only one allowed');
    const { gen: gen } = it;
    if (dataProp !== undefined) {
        const { errorPath: errorPath, dataPathArr: dataPathArr, opts: opts } = it;
        const nextData = gen.let("data", (0, $6Vb5F._)($718895362d334ad8$var$t2 || ($718895362d334ad8$var$t2 = $718895362d334ad8$var$_`${0}${0}`), it.data, (0, $6Vb5F.getProperty)(dataProp)), true);
        dataContextProps(nextData);
        subschema.errorPath = (0, $6Vb5F.str)($718895362d334ad8$var$t3 || ($718895362d334ad8$var$t3 = $718895362d334ad8$var$_`${0}${0}`), errorPath, (0, $k2074.getErrorPath)(dataProp, dpType, opts.jsPropertySyntax));
        subschema.parentDataProperty = (0, $6Vb5F._)($718895362d334ad8$var$t4 || ($718895362d334ad8$var$t4 = $718895362d334ad8$var$_`${0}`), dataProp);
        subschema.dataPathArr = [
            ...dataPathArr,
            subschema.parentDataProperty
        ];
    }
    if (data !== undefined) {
        const nextData = data instanceof $6Vb5F.Name ? data : gen.let("data", data, true); // replaceable if used once?
        dataContextProps(nextData);
        if (propertyName !== undefined) subschema.propertyName = propertyName;
    // TODO something is possibly wrong here with not changing parentDataProperty and not appending dataPathArr
    }
    if (dataTypes) subschema.dataTypes = dataTypes;
    function dataContextProps(_nextData) {
        subschema.data = _nextData;
        subschema.dataLevel = it.dataLevel + 1;
        subschema.dataTypes = [];
        it.definedProperties = new Set();
        subschema.parentData = it.data;
        subschema.dataNames = [
            ...it.dataNames,
            _nextData
        ];
    }
}
module.exports.extendSubschemaData = $718895362d334ad8$var$extendSubschemaData;
function $718895362d334ad8$var$extendSubschemaMode(subschema, { jtdDiscriminator: jtdDiscriminator, jtdMetadata: jtdMetadata, compositeRule: compositeRule, createErrors: createErrors, allErrors: allErrors }) {
    if (compositeRule !== undefined) subschema.compositeRule = compositeRule;
    if (createErrors !== undefined) subschema.createErrors = createErrors;
    if (allErrors !== undefined) subschema.allErrors = allErrors;
    subschema.jtdDiscriminator = jtdDiscriminator; // not inherited
    subschema.jtdMetadata = jtdMetadata; // not inherited
}
module.exports.extendSubschemaMode = $718895362d334ad8$var$extendSubschemaMode;

});

parcelRequire.register("1Oy4e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSchemaRefs = module.exports.resolveUrl = module.exports.normalizeId = module.exports._getFullPath = module.exports.getFullPath = module.exports.inlineRef = void 0;

var $k2074 = parcelRequire("k2074");

var $brcIF = parcelRequire("brcIF");

var $aVbog = parcelRequire("aVbog");
// TODO refactor to use keyword definitions
const $1524e3063b4b6aa4$var$SIMPLE_INLINED = new Set([
    "type",
    "format",
    "pattern",
    "maxLength",
    "minLength",
    "maxProperties",
    "minProperties",
    "maxItems",
    "minItems",
    "maximum",
    "minimum",
    "uniqueItems",
    "multipleOf",
    "required",
    "enum",
    "const"
]);
function $1524e3063b4b6aa4$var$inlineRef(schema, limit = true) {
    if (typeof schema == "boolean") return true;
    if (limit === true) return !$1524e3063b4b6aa4$var$hasRef(schema);
    if (!limit) return false;
    return $1524e3063b4b6aa4$var$countKeys(schema) <= limit;
}
module.exports.inlineRef = $1524e3063b4b6aa4$var$inlineRef;
const $1524e3063b4b6aa4$var$REF_KEYWORDS = new Set([
    "$ref",
    "$recursiveRef",
    "$recursiveAnchor",
    "$dynamicRef",
    "$dynamicAnchor"
]);
function $1524e3063b4b6aa4$var$hasRef(schema) {
    for(const key in schema){
        if ($1524e3063b4b6aa4$var$REF_KEYWORDS.has(key)) return true;
        const sch = schema[key];
        if (Array.isArray(sch) && sch.some($1524e3063b4b6aa4$var$hasRef)) return true;
        if (typeof sch == "object" && $1524e3063b4b6aa4$var$hasRef(sch)) return true;
    }
    return false;
}
function $1524e3063b4b6aa4$var$countKeys(schema) {
    let count = 0;
    for(const key in schema){
        if (key === "$ref") return Infinity;
        count++;
        if ($1524e3063b4b6aa4$var$SIMPLE_INLINED.has(key)) continue;
        if (typeof schema[key] == "object") (0, $k2074.eachItem)(schema[key], (sch)=>count += $1524e3063b4b6aa4$var$countKeys(sch));
        if (count === Infinity) return Infinity;
    }
    return count;
}
function $1524e3063b4b6aa4$var$getFullPath(resolver, id = "", normalize) {
    if (normalize !== false) id = $1524e3063b4b6aa4$var$normalizeId(id);
    const p = resolver.parse(id);
    return $1524e3063b4b6aa4$var$_getFullPath(resolver, p);
}
module.exports.getFullPath = $1524e3063b4b6aa4$var$getFullPath;
function $1524e3063b4b6aa4$var$_getFullPath(resolver, p) {
    const serialized = resolver.serialize(p);
    return serialized.split("#")[0] + "#";
}
module.exports._getFullPath = $1524e3063b4b6aa4$var$_getFullPath;
const $1524e3063b4b6aa4$var$TRAILING_SLASH_HASH = /#\/?$/;
function $1524e3063b4b6aa4$var$normalizeId(id) {
    return id ? id.replace($1524e3063b4b6aa4$var$TRAILING_SLASH_HASH, "") : "";
}
module.exports.normalizeId = $1524e3063b4b6aa4$var$normalizeId;
function $1524e3063b4b6aa4$var$resolveUrl(resolver, baseId, id) {
    id = $1524e3063b4b6aa4$var$normalizeId(id);
    return resolver.resolve(baseId, id);
}
module.exports.resolveUrl = $1524e3063b4b6aa4$var$resolveUrl;
const $1524e3063b4b6aa4$var$ANCHOR = /^[a-z_][-a-z0-9._]*$/i;
function $1524e3063b4b6aa4$var$getSchemaRefs(schema, baseId) {
    if (typeof schema == "boolean") return {};
    const { schemaId: schemaId, uriResolver: uriResolver } = this.opts;
    const schId = $1524e3063b4b6aa4$var$normalizeId(schema[schemaId] || baseId);
    const baseIds = {
        "": schId
    };
    const pathPrefix = $1524e3063b4b6aa4$var$getFullPath(uriResolver, schId, false);
    const localRefs = {};
    const schemaRefs = new Set();
    $aVbog(schema, {
        allKeys: true
    }, (sch, jsonPtr, _, parentJsonPtr)=>{
        if (parentJsonPtr === undefined) return;
        const fullPath = pathPrefix + jsonPtr;
        let baseId = baseIds[parentJsonPtr];
        if (typeof sch[schemaId] == "string") baseId = addRef.call(this, sch[schemaId]);
        addAnchor.call(this, sch.$anchor);
        addAnchor.call(this, sch.$dynamicAnchor);
        baseIds[jsonPtr] = baseId;
        function addRef(ref) {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const _resolve = this.opts.uriResolver.resolve;
            ref = $1524e3063b4b6aa4$var$normalizeId(baseId ? _resolve(baseId, ref) : ref);
            if (schemaRefs.has(ref)) throw ambiguos(ref);
            schemaRefs.add(ref);
            let schOrRef = this.refs[ref];
            if (typeof schOrRef == "string") schOrRef = this.refs[schOrRef];
            if (typeof schOrRef == "object") checkAmbiguosRef(sch, schOrRef.schema, ref);
            else if (ref !== $1524e3063b4b6aa4$var$normalizeId(fullPath)) {
                if (ref[0] === "#") {
                    checkAmbiguosRef(sch, localRefs[ref], ref);
                    localRefs[ref] = sch;
                } else this.refs[ref] = fullPath;
            }
            return ref;
        }
        function addAnchor(anchor) {
            if (typeof anchor == "string") {
                if (!$1524e3063b4b6aa4$var$ANCHOR.test(anchor)) throw new Error(`invalid anchor "${anchor}"`);
                addRef.call(this, `#${anchor}`);
            }
        }
    });
    return localRefs;
    function checkAmbiguosRef(sch1, sch2, ref) {
        if (sch2 !== undefined && !$brcIF(sch1, sch2)) throw ambiguos(ref);
    }
    function ambiguos(ref) {
        return new Error(`reference "${ref}" resolves to more than one schema`);
    }
}
module.exports.getSchemaRefs = $1524e3063b4b6aa4$var$getSchemaRefs;

});
parcelRequire.register("brcIF", function(module, exports) {
"use strict";
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRequire.register("aVbog", function(module, exports) {
"use strict";
var $7f381023186c38d9$var$traverse = module.exports = function(schema, opts, cb) {
    // Legacy support for v0.3.1 and earlier.
    if (typeof opts == "function") {
        cb = opts;
        opts = {};
    }
    cb = opts.cb || cb;
    var pre = typeof cb == "function" ? cb : cb.pre || function() {};
    var post = cb.post || function() {};
    $7f381023186c38d9$var$_traverse(opts, pre, post, schema, "", schema);
};
$7f381023186c38d9$var$traverse.keywords = {
    additionalItems: true,
    items: true,
    contains: true,
    additionalProperties: true,
    propertyNames: true,
    not: true,
    if: true,
    then: true,
    else: true
};
$7f381023186c38d9$var$traverse.arrayKeywords = {
    items: true,
    allOf: true,
    anyOf: true,
    oneOf: true
};
$7f381023186c38d9$var$traverse.propsKeywords = {
    $defs: true,
    definitions: true,
    properties: true,
    patternProperties: true,
    dependencies: true
};
$7f381023186c38d9$var$traverse.skipKeywords = {
    default: true,
    enum: true,
    const: true,
    required: true,
    maximum: true,
    minimum: true,
    exclusiveMaximum: true,
    exclusiveMinimum: true,
    multipleOf: true,
    maxLength: true,
    minLength: true,
    pattern: true,
    format: true,
    maxItems: true,
    minItems: true,
    uniqueItems: true,
    maxProperties: true,
    minProperties: true
};
function $7f381023186c38d9$var$_traverse(opts, pre, post, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
    if (schema && typeof schema == "object" && !Array.isArray(schema)) {
        pre(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
        for(var key in schema){
            var sch = schema[key];
            if (Array.isArray(sch)) {
                if (key in $7f381023186c38d9$var$traverse.arrayKeywords) for(var i = 0; i < sch.length; i++)$7f381023186c38d9$var$_traverse(opts, pre, post, sch[i], jsonPtr + "/" + key + "/" + i, rootSchema, jsonPtr, key, schema, i);
            } else if (key in $7f381023186c38d9$var$traverse.propsKeywords) {
                if (sch && typeof sch == "object") for(var prop in sch)$7f381023186c38d9$var$_traverse(opts, pre, post, sch[prop], jsonPtr + "/" + key + "/" + $7f381023186c38d9$var$escapeJsonPtr(prop), rootSchema, jsonPtr, key, schema, prop);
            } else if (key in $7f381023186c38d9$var$traverse.keywords || opts.allKeys && !(key in $7f381023186c38d9$var$traverse.skipKeywords)) $7f381023186c38d9$var$_traverse(opts, pre, post, sch, jsonPtr + "/" + key, rootSchema, jsonPtr, key, schema);
        }
        post(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
    }
}
function $7f381023186c38d9$var$escapeJsonPtr(str) {
    return str.replace(/~/g, "~0").replace(/\//g, "~1");
}

});



parcelRequire.register("iM4Un", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $dab0845b69bf0f42$var$ValidationError extends Error {
    constructor(errors){
        super("validation failed");
        this.errors = errors;
        this.ajv = this.validation = true;
    }
}
module.exports.default = $dab0845b69bf0f42$var$ValidationError;

});

parcelRequire.register("6XLO0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1Oy4e = parcelRequire("1Oy4e");
class $511d55edfae3d8c4$var$MissingRefError extends Error {
    constructor(resolver, baseId, ref, msg){
        super(msg || `can't resolve reference ${ref} from id ${baseId}`);
        this.missingRef = (0, $1Oy4e.resolveUrl)(resolver, baseId, ref);
        this.missingSchema = (0, $1Oy4e.normalizeId)((0, $1Oy4e.getFullPath)(resolver, this.missingRef));
    }
}
module.exports.default = $511d55edfae3d8c4$var$MissingRefError;

});

parcelRequire.register("PkPFY", function(module, exports) {
"use strict";
let $09a4ec6ead26992f$var$_ = (t)=>t, $09a4ec6ead26992f$var$t, $09a4ec6ead26992f$var$t1;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveSchema = module.exports.getCompilingSchema = module.exports.resolveRef = module.exports.compileSchema = module.exports.SchemaEnv = void 0;

var $6Vb5F = parcelRequire("6Vb5F");

var $iM4Un = parcelRequire("iM4Un");

var $eXNSw = parcelRequire("eXNSw");

var $1Oy4e = parcelRequire("1Oy4e");

var $k2074 = parcelRequire("k2074");

var $6DSbS = parcelRequire("6DSbS");
class $09a4ec6ead26992f$var$SchemaEnv {
    constructor(env){
        var _a;
        this.refs = {};
        this.dynamicAnchors = {};
        let schema;
        if (typeof env.schema == "object") schema = env.schema;
        this.schema = env.schema;
        this.schemaId = env.schemaId;
        this.root = env.root || this;
        this.baseId = (_a = env.baseId) !== null && _a !== void 0 ? _a : (0, $1Oy4e.normalizeId)(schema === null || schema === void 0 ? void 0 : schema[env.schemaId || "$id"]);
        this.schemaPath = env.schemaPath;
        this.localRefs = env.localRefs;
        this.meta = env.meta;
        this.$async = schema === null || schema === void 0 ? void 0 : schema.$async;
        this.refs = {};
    }
}
module.exports.SchemaEnv = $09a4ec6ead26992f$var$SchemaEnv;
// let codeSize = 0
// let nodeCount = 0
// Compiles schema in SchemaEnv
function $09a4ec6ead26992f$var$compileSchema(sch) {
    // TODO refactor - remove compilations
    const _sch = $09a4ec6ead26992f$var$getCompilingSchema.call(this, sch);
    if (_sch) return _sch;
    const rootId = (0, $1Oy4e.getFullPath)(this.opts.uriResolver, sch.root.baseId); // TODO if getFullPath removed 1 tests fails
    const { es5: es5, lines: lines } = this.opts.code;
    const { ownProperties: ownProperties } = this.opts;
    const gen = new $6Vb5F.CodeGen(this.scope, {
        es5: es5,
        lines: lines,
        ownProperties: ownProperties
    });
    let _ValidationError;
    if (sch.$async) _ValidationError = gen.scopeValue("Error", {
        ref: $iM4Un.default,
        code: (0, $6Vb5F._)($09a4ec6ead26992f$var$t || ($09a4ec6ead26992f$var$t = $09a4ec6ead26992f$var$_`require("ajv/dist/runtime/validation_error").default`))
    });
    const validateName = gen.scopeName("validate");
    sch.validateName = validateName;
    const schemaCxt = {
        gen: gen,
        allErrors: this.opts.allErrors,
        data: $eXNSw.default.data,
        parentData: $eXNSw.default.parentData,
        parentDataProperty: $eXNSw.default.parentDataProperty,
        dataNames: [
            $eXNSw.default.data
        ],
        dataPathArr: [
            $6Vb5F.nil
        ],
        dataLevel: 0,
        dataTypes: [],
        definedProperties: new Set(),
        topSchemaRef: gen.scopeValue("schema", this.opts.code.source === true ? {
            ref: sch.schema,
            code: (0, $6Vb5F.stringify)(sch.schema)
        } : {
            ref: sch.schema
        }),
        validateName: validateName,
        ValidationError: _ValidationError,
        schema: sch.schema,
        schemaEnv: sch,
        rootId: rootId,
        baseId: sch.baseId || rootId,
        schemaPath: $6Vb5F.nil,
        errSchemaPath: sch.schemaPath || (this.opts.jtd ? "" : "#"),
        errorPath: (0, $6Vb5F._)($09a4ec6ead26992f$var$t1 || ($09a4ec6ead26992f$var$t1 = $09a4ec6ead26992f$var$_`""`)),
        opts: this.opts,
        self: this
    };
    let sourceCode;
    try {
        this._compilations.add(sch);
        (0, $6DSbS.validateFunctionCode)(schemaCxt);
        gen.optimize(this.opts.code.optimize);
        // gen.optimize(1)
        const validateCode = gen.toString();
        sourceCode = `${gen.scopeRefs($eXNSw.default.scope)}return ${validateCode}`;
        // console.log((codeSize += sourceCode.length), (nodeCount += gen.nodeCount))
        if (this.opts.code.process) sourceCode = this.opts.code.process(sourceCode, sch);
        // console.log("\n\n\n *** \n", sourceCode)
        const makeValidate = new Function(`${$eXNSw.default.self}`, `${$eXNSw.default.scope}`, sourceCode);
        const validate = makeValidate(this, this.scope.get());
        this.scope.value(validateName, {
            ref: validate
        });
        validate.errors = null;
        validate.schema = sch.schema;
        validate.schemaEnv = sch;
        if (sch.$async) validate.$async = true;
        if (this.opts.code.source === true) validate.source = {
            validateName: validateName,
            validateCode: validateCode,
            scopeValues: gen._values
        };
        if (this.opts.unevaluated) {
            const { props: props, items: items } = schemaCxt;
            validate.evaluated = {
                props: props instanceof $6Vb5F.Name ? undefined : props,
                items: items instanceof $6Vb5F.Name ? undefined : items,
                dynamicProps: props instanceof $6Vb5F.Name,
                dynamicItems: items instanceof $6Vb5F.Name
            };
            if (validate.source) validate.source.evaluated = (0, $6Vb5F.stringify)(validate.evaluated);
        }
        sch.validate = validate;
        return sch;
    } catch (e) {
        delete sch.validate;
        delete sch.validateName;
        if (sourceCode) this.logger.error("Error compiling schema, function code:", sourceCode);
        // console.log("\n\n\n *** \n", sourceCode, this.opts)
        throw e;
    } finally{
        this._compilations.delete(sch);
    }
}
module.exports.compileSchema = $09a4ec6ead26992f$var$compileSchema;
function $09a4ec6ead26992f$var$resolveRef(root, baseId, ref) {
    var _a;
    ref = (0, $1Oy4e.resolveUrl)(this.opts.uriResolver, baseId, ref);
    const schOrFunc = root.refs[ref];
    if (schOrFunc) return schOrFunc;
    let _sch = $09a4ec6ead26992f$var$resolve.call(this, root, ref);
    if (_sch === undefined) {
        const schema = (_a = root.localRefs) === null || _a === void 0 ? void 0 : _a[ref]; // TODO maybe localRefs should hold SchemaEnv
        const { schemaId: schemaId } = this.opts;
        if (schema) _sch = new $09a4ec6ead26992f$var$SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            root: root,
            baseId: baseId
        });
    }
    if (_sch === undefined) return;
    return root.refs[ref] = $09a4ec6ead26992f$var$inlineOrCompile.call(this, _sch);
}
module.exports.resolveRef = $09a4ec6ead26992f$var$resolveRef;
function $09a4ec6ead26992f$var$inlineOrCompile(sch) {
    if ((0, $1Oy4e.inlineRef)(sch.schema, this.opts.inlineRefs)) return sch.schema;
    return sch.validate ? sch : $09a4ec6ead26992f$var$compileSchema.call(this, sch);
}
// Index of schema compilation in the currently compiled list
function $09a4ec6ead26992f$var$getCompilingSchema(schEnv) {
    for (const sch of this._compilations){
        if ($09a4ec6ead26992f$var$sameSchemaEnv(sch, schEnv)) return sch;
    }
}
module.exports.getCompilingSchema = $09a4ec6ead26992f$var$getCompilingSchema;
function $09a4ec6ead26992f$var$sameSchemaEnv(s1, s2) {
    return s1.schema === s2.schema && s1.root === s2.root && s1.baseId === s2.baseId;
}
// resolve and compile the references ($ref)
// TODO returns AnySchemaObject (if the schema can be inlined) or validation function
function $09a4ec6ead26992f$var$resolve(root, ref // reference to resolve
) {
    let sch;
    while(typeof (sch = this.refs[ref]) == "string")ref = sch;
    return sch || this.schemas[ref] || $09a4ec6ead26992f$var$resolveSchema.call(this, root, ref);
}
// Resolve schema, its root and baseId
function $09a4ec6ead26992f$var$resolveSchema(root, ref // reference to resolve
) {
    const p = this.opts.uriResolver.parse(ref);
    const refPath = (0, $1Oy4e._getFullPath)(this.opts.uriResolver, p);
    let baseId = (0, $1Oy4e.getFullPath)(this.opts.uriResolver, root.baseId, undefined);
    // TODO `Object.keys(root.schema).length > 0` should not be needed - but removing breaks 2 tests
    if (Object.keys(root.schema).length > 0 && refPath === baseId) return $09a4ec6ead26992f$var$getJsonPointer.call(this, p, root);
    const id = (0, $1Oy4e.normalizeId)(refPath);
    const schOrRef = this.refs[id] || this.schemas[id];
    if (typeof schOrRef == "string") {
        const sch = $09a4ec6ead26992f$var$resolveSchema.call(this, root, schOrRef);
        if (typeof (sch === null || sch === void 0 ? void 0 : sch.schema) !== "object") return;
        return $09a4ec6ead26992f$var$getJsonPointer.call(this, p, sch);
    }
    if (typeof (schOrRef === null || schOrRef === void 0 ? void 0 : schOrRef.schema) !== "object") return;
    if (!schOrRef.validate) $09a4ec6ead26992f$var$compileSchema.call(this, schOrRef);
    if (id === (0, $1Oy4e.normalizeId)(ref)) {
        const { schema: schema } = schOrRef;
        const { schemaId: schemaId } = this.opts;
        const schId = schema[schemaId];
        if (schId) baseId = (0, $1Oy4e.resolveUrl)(this.opts.uriResolver, baseId, schId);
        return new $09a4ec6ead26992f$var$SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            root: root,
            baseId: baseId
        });
    }
    return $09a4ec6ead26992f$var$getJsonPointer.call(this, p, schOrRef);
}
module.exports.resolveSchema = $09a4ec6ead26992f$var$resolveSchema;
const $09a4ec6ead26992f$var$PREVENT_SCOPE_CHANGE = new Set([
    "properties",
    "patternProperties",
    "enum",
    "dependencies",
    "definitions"
]);
function $09a4ec6ead26992f$var$getJsonPointer(parsedRef, { baseId: baseId, schema: schema, root: root }) {
    var _a;
    if (((_a = parsedRef.fragment) === null || _a === void 0 ? void 0 : _a[0]) !== "/") return;
    for (const part of parsedRef.fragment.slice(1).split("/")){
        if (typeof schema === "boolean") return;
        const partSchema = schema[(0, $k2074.unescapeFragment)(part)];
        if (partSchema === undefined) return;
        schema = partSchema;
        // TODO PREVENT_SCOPE_CHANGE could be defined in keyword def?
        const schId = typeof schema === "object" && schema[this.opts.schemaId];
        if (!$09a4ec6ead26992f$var$PREVENT_SCOPE_CHANGE.has(part) && schId) baseId = (0, $1Oy4e.resolveUrl)(this.opts.uriResolver, baseId, schId);
    }
    let env;
    if (typeof schema != "boolean" && schema.$ref && !(0, $k2074.schemaHasRulesButRef)(schema, this.RULES)) {
        const $ref = (0, $1Oy4e.resolveUrl)(this.opts.uriResolver, baseId, schema.$ref);
        env = $09a4ec6ead26992f$var$resolveSchema.call(this, root, $ref);
    }
    // even though resolution failed we need to return SchemaEnv to throw exception
    // so that compileAsync loads missing schema.
    const { schemaId: schemaId } = this.opts;
    env = env || new $09a4ec6ead26992f$var$SchemaEnv({
        schema: schema,
        schemaId: schemaId,
        root: root,
        baseId: baseId
    });
    if (env.schema !== env.root.schema) return env;
    return undefined;
}

});

parcelRequire.register("RgrKG", function(module, exports) {
module.exports = JSON.parse('{"$id":"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#","description":"Meta-schema for $data reference (JSON AnySchema extension proposal)","type":"object","required":["$data"],"properties":{"$data":{"type":"string","anyOf":[{"format":"relative-json-pointer"},{"format":"json-pointer"}]}},"additionalProperties":false}');

});

parcelRequire.register("bXTio", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $h0FgQ = parcelRequire("h0FgQ");
$h0FgQ.code = 'require("ajv/dist/runtime/uri").default';
module.exports.default = $h0FgQ;

});
parcelRequire.register("h0FgQ", function(module, exports) {
/** @license URI.js v4.4.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    "use strict";
    function merge() {
        for(var _len = arguments.length, sets = Array(_len), _key = 0; _key < _len; _key++)sets[_key] = arguments[_key];
        if (sets.length > 1) {
            sets[0] = sets[0].slice(0, -1);
            var xl = sets.length - 1;
            for(var x = 1; x < xl; ++x)sets[x] = sets[x].slice(1, -1);
            sets[xl] = sets[xl].slice(1);
            return sets.join("");
        } else return sets[0];
    }
    function subexp(str) {
        return "(?:" + str + ")";
    }
    function typeOf(o) {
        return o === undefined ? "undefined" : o === null ? "null" : Object.prototype.toString.call(o).split(" ").pop().split("]").shift().toLowerCase();
    }
    function toUpperCase(str) {
        return str.toUpperCase();
    }
    function toArray(obj) {
        return obj !== undefined && obj !== null ? obj instanceof Array ? obj : typeof obj.length !== "number" || obj.split || obj.setInterval || obj.call ? [
            obj
        ] : Array.prototype.slice.call(obj) : [];
    }
    function assign(target, source) {
        var obj = target;
        if (source) for(var key in source)obj[key] = source[key];
        return obj;
    }
    function buildExps(isIRI) {
        var ALPHA$$ = "[A-Za-z]", CR$ = "[\\x0D]", DIGIT$$ = "[0-9]", DQUOTE$$ = "[\\x22]", HEXDIG$$ = merge(DIGIT$$, "[A-Fa-f]"), //case-insensitive
        LF$$ = "[\\x0A]", SP$$ = "[\\x20]", PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)), //expanded
        GEN_DELIMS$$ = "[\\:\\/\\?\\#\\[\\]\\@]", SUB_DELIMS$$ = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", RESERVED$$ = merge(GEN_DELIMS$$, SUB_DELIMS$$), UCSCHAR$$ = isIRI ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]", //subset, excludes bidi control characters
        IPRIVATE$$ = isIRI ? "[\\uE000-\\uF8FF]" : "[]", //subset
        UNRESERVED$$ = merge(ALPHA$$, DIGIT$$, "[\\-\\.\\_\\~]", UCSCHAR$$), SCHEME$ = subexp(ALPHA$$ + merge(ALPHA$$, DIGIT$$, "[\\+\\-\\.]") + "*"), USERINFO$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]")) + "*"), DEC_OCTET$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("[1-9]" + DIGIT$$) + "|" + DIGIT$$), DEC_OCTET_RELAXED$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("0?[1-9]" + DIGIT$$) + "|0?0?" + DIGIT$$), //relaxed parsing rules
        IPV4ADDRESS$ = subexp(DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$), H16$ = subexp(HEXDIG$$ + "{1,4}"), LS32$ = subexp(subexp(H16$ + "\\:" + H16$) + "|" + IPV4ADDRESS$), IPV6ADDRESS1$ = subexp(subexp(H16$ + "\\:") + "{6}" + LS32$), //                           6( h16 ":" ) ls32
        IPV6ADDRESS2$ = subexp("\\:\\:" + subexp(H16$ + "\\:") + "{5}" + LS32$), //                      "::" 5( h16 ":" ) ls32
        IPV6ADDRESS3$ = subexp(subexp(H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{4}" + LS32$), //[               h16 ] "::" 4( h16 ":" ) ls32
        IPV6ADDRESS4$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,1}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{3}" + LS32$), //[ *1( h16 ":" ) h16 ] "::" 3( h16 ":" ) ls32
        IPV6ADDRESS5$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,2}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{2}" + LS32$), //[ *2( h16 ":" ) h16 ] "::" 2( h16 ":" ) ls32
        IPV6ADDRESS6$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,3}" + H16$) + "?\\:\\:" + H16$ + "\\:" + LS32$), //[ *3( h16 ":" ) h16 ] "::"    h16 ":"   ls32
        IPV6ADDRESS7$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,4}" + H16$) + "?\\:\\:" + LS32$), //[ *4( h16 ":" ) h16 ] "::"              ls32
        IPV6ADDRESS8$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,5}" + H16$) + "?\\:\\:" + H16$), //[ *5( h16 ":" ) h16 ] "::"              h16
        IPV6ADDRESS9$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,6}" + H16$) + "?\\:\\:"), //[ *6( h16 ":" ) h16 ] "::"
        IPV6ADDRESS$ = subexp([
            IPV6ADDRESS1$,
            IPV6ADDRESS2$,
            IPV6ADDRESS3$,
            IPV6ADDRESS4$,
            IPV6ADDRESS5$,
            IPV6ADDRESS6$,
            IPV6ADDRESS7$,
            IPV6ADDRESS8$,
            IPV6ADDRESS9$
        ].join("|")), ZONEID$ = subexp(subexp(UNRESERVED$$ + "|" + PCT_ENCODED$) + "+"), //RFC 6874
        IPV6ADDRZ$ = subexp(IPV6ADDRESS$ + "\\%25" + ZONEID$), //RFC 6874
        IPV6ADDRZ_RELAXED$ = subexp(IPV6ADDRESS$ + subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + ZONEID$), //RFC 6874, with relaxed parsing rules
        IPVFUTURE$ = subexp("[vV]" + HEXDIG$$ + "+\\." + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]") + "+"), IP_LITERAL$ = subexp("\\[" + subexp(IPV6ADDRZ_RELAXED$ + "|" + IPV6ADDRESS$ + "|" + IPVFUTURE$) + "\\]"), //RFC 6874
        REG_NAME$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$)) + "*"), HOST$ = subexp(IP_LITERAL$ + "|" + IPV4ADDRESS$ + "(?!" + REG_NAME$ + ")" + "|" + REG_NAME$), PORT$ = subexp(DIGIT$$ + "*"), AUTHORITY$ = subexp(subexp(USERINFO$ + "@") + "?" + HOST$ + subexp("\\:" + PORT$) + "?"), PCHAR$ = subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@]")), SEGMENT$ = subexp(PCHAR$ + "*"), SEGMENT_NZ$ = subexp(PCHAR$ + "+"), SEGMENT_NZ_NC$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\@]")) + "+"), PATH_ABEMPTY$ = subexp(subexp("\\/" + SEGMENT$) + "*"), PATH_ABSOLUTE$ = subexp("\\/" + subexp(SEGMENT_NZ$ + PATH_ABEMPTY$) + "?"), //simplified
        PATH_NOSCHEME$ = subexp(SEGMENT_NZ_NC$ + PATH_ABEMPTY$), //simplified
        PATH_ROOTLESS$ = subexp(SEGMENT_NZ$ + PATH_ABEMPTY$), //simplified
        PATH_EMPTY$ = "(?!" + PCHAR$ + ")", PATH$ = subexp(PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$), QUERY$ = subexp(subexp(PCHAR$ + "|" + merge("[\\/\\?]", IPRIVATE$$)) + "*"), FRAGMENT$ = subexp(subexp(PCHAR$ + "|[\\/\\?]") + "*"), HIER_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$), URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"), RELATIVE_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$), RELATIVE$ = subexp(RELATIVE_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"), URI_REFERENCE$ = subexp(URI$ + "|" + RELATIVE$), ABSOLUTE_URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?"), GENERIC_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", RELATIVE_REF$ = "^(){0}" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", ABSOLUTE_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?$", SAMEDOC_REF$ = "^" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", AUTHORITY_REF$ = "^" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?$";
        return {
            NOT_SCHEME: new RegExp(merge("[^]", ALPHA$$, DIGIT$$, "[\\+\\-\\.]"), "g"),
            NOT_USERINFO: new RegExp(merge("[^\\%\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_HOST: new RegExp(merge("[^\\%\\[\\]\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_PATH: new RegExp(merge("[^\\%\\/\\:\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_PATH_NOSCHEME: new RegExp(merge("[^\\%\\/\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_QUERY: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]", IPRIVATE$$), "g"),
            NOT_FRAGMENT: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]"), "g"),
            ESCAPE: new RegExp(merge("[^]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            UNRESERVED: new RegExp(UNRESERVED$$, "g"),
            OTHER_CHARS: new RegExp(merge("[^\\%]", UNRESERVED$$, RESERVED$$), "g"),
            PCT_ENCODED: new RegExp(PCT_ENCODED$, "g"),
            IPV4ADDRESS: new RegExp("^(" + IPV4ADDRESS$ + ")$"),
            IPV6ADDRESS: new RegExp("^\\[?(" + IPV6ADDRESS$ + ")" + subexp(subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + "(" + ZONEID$ + ")") + "?\\]?$") //RFC 6874, with relaxed parsing rules
        };
    }
    var URI_PROTOCOL = buildExps(false);
    var IRI_PROTOCOL = buildExps(true);
    var slicedToArray = function() {
        function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;
            try {
                for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                    _arr.push(_s.value);
                    if (i && _arr.length === i) break;
                }
            } catch (err) {
                _d = true;
                _e = err;
            } finally{
                try {
                    if (!_n && _i["return"]) _i["return"]();
                } finally{
                    if (_d) throw _e;
                }
            }
            return _arr;
        }
        return function(arr, i) {
            if (Array.isArray(arr)) return arr;
            else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
            else throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
    }();
    var toConsumableArray = function(arr) {
        if (Array.isArray(arr)) {
            for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
            return arr2;
        } else return Array.from(arr);
    };
    /** Highest positive signed 32-bit float value */ var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
    /** Bootstring parameters */ var base = 36;
    var tMin = 1;
    var tMax = 26;
    var skew = 38;
    var damp = 700;
    var initialBias = 72;
    var initialN = 128; // 0x80
    var delimiter = "-"; // '\x2D'
    /** Regular expressions */ var regexPunycode = /^xn--/;
    var regexNonASCII = /[^\0-\x7E]/; // non-ASCII chars
    var regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
    /** Error messages */ var errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    };
    /** Convenience shortcuts */ var baseMinusTMin = base - tMin;
    var floor = Math.floor;
    var stringFromCharCode = String.fromCharCode;
    /*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function error$1(type) {
        throw new RangeError(errors[type]);
    }
    /**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function map(array, fn) {
        var result = [];
        var length = array.length;
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {Array} A new string of characters returned by the callback
 * function.
 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function ucs2decode(string) {
        var output = [];
        var counter = 0;
        var length = string.length;
        while(counter < length){
            var value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // It's a high surrogate, and there is a next character.
                var extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) // Low surrogate.
                output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // It's an unmatched surrogate; only append this code unit, in case the
                    // next code unit is the high surrogate of a surrogate pair.
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ var ucs2encode = function ucs2encode(array) {
        return String.fromCodePoint.apply(String, toConsumableArray(array));
    };
    /**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ var basicToDigit = function basicToDigit(codePoint) {
        if (codePoint - 0x30 < 0x0A) return codePoint - 0x16;
        if (codePoint - 0x41 < 0x1A) return codePoint - 0x41;
        if (codePoint - 0x61 < 0x1A) return codePoint - 0x61;
        return base;
    };
    /**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ var digitToBasic = function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    };
    /**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ var adapt = function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    };
    /**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ var decode = function decode(input) {
        // Don't use UCS-2.
        var output = [];
        var inputLength = input.length;
        var i = 0;
        var n = initialN;
        var bias = initialBias;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        var basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(var j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error$1("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(var index = basic > 0 ? basic + 1 : 0; index < inputLength;)/* no final expression */ {
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            var oldi = i;
            for(var w = 1, k = base;; k += base){
                if (index >= inputLength) error$1("invalid-input");
                var digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error$1("overflow");
                i += digit * w;
                var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                var baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error$1("overflow");
                w *= baseMinusT;
            }
            var out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error$1("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output.
            output.splice(i++, 0, n);
        }
        return String.fromCodePoint.apply(String, output);
    };
    /**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ var encode = function encode(input) {
        var output = [];
        // Convert the input in UCS-2 to an array of Unicode code points.
        input = ucs2decode(input);
        // Cache the length.
        var inputLength = input.length;
        // Initialize the state.
        var n = initialN;
        var delta = 0;
        var bias = initialBias;
        // Handle the basic code points.
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _currentValue2 = _step.value;
                if (_currentValue2 < 0x80) output.push(stringFromCharCode(_currentValue2));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
        var basicLength = output.length;
        var handledCPCount = basicLength;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string with a delimiter unless it's empty.
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            var m = maxInt;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;
            try {
                for(var _iterator2 = input[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var currentValue = _step2.value;
                    if (currentValue >= n && currentValue < m) m = currentValue;
                }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow.
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
                } finally{
                    if (_didIteratorError2) throw _iteratorError2;
                }
            }
            var handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error$1("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;
            try {
                for(var _iterator3 = input[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                    var _currentValue = _step3.value;
                    if (_currentValue < n && ++delta > maxInt) error$1("overflow");
                    if (_currentValue == n) {
                        // Represent delta as a generalized variable-length integer.
                        var q = delta;
                        for(var k = base;; k += base){
                            var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                            if (q < t) break;
                            var qMinusT = q - t;
                            var baseMinusT = base - t;
                            output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                            q = floor(qMinusT / baseMinusT);
                        }
                        output.push(stringFromCharCode(digitToBasic(q, 0)));
                        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                        delta = 0;
                        ++handledCPCount;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) _iterator3.return();
                } finally{
                    if (_didIteratorError3) throw _iteratorError3;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    };
    /**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ var toUnicode = function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    };
    /**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ var toASCII = function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    };
    /*--------------------------------------------------------------------------*/ /** Define the public API */ var punycode = {
        /**
  * A string representing the current Punycode.js version number.
  * @memberOf punycode
  * @type String
  */ "version": "2.1.0",
        /**
  * An object of methods to convert from JavaScript's internal character
  * representation (UCS-2) to Unicode code points, and back.
  * @see <https://mathiasbynens.be/notes/javascript-encoding>
  * @memberOf punycode
  * @type Object
  */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /**
 * URI.js
 *
 * @fileoverview An RFC 3986 compliant, scheme extendable URI parsing/validating/resolving library for JavaScript.
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @see http://github.com/garycourt/uri-js
 */ /**
 * Copyright 2011 Gary Court. All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are
 * permitted provided that the following conditions are met:
 *
 *    1. Redistributions of source code must retain the above copyright notice, this list of
 *       conditions and the following disclaimer.
 *
 *    2. Redistributions in binary form must reproduce the above copyright notice, this list
 *       of conditions and the following disclaimer in the documentation and/or other materials
 *       provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY GARY COURT ``AS IS'' AND ANY EXPRESS OR IMPLIED
 * WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL GARY COURT OR
 * CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
 * ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
 * ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * The views and conclusions contained in the software and documentation are those of the
 * authors and should not be interpreted as representing official policies, either expressed
 * or implied, of Gary Court.
 */ var SCHEMES = {};
    function pctEncChar(chr) {
        var c = chr.charCodeAt(0);
        var e = void 0;
        if (c < 16) e = "%0" + c.toString(16).toUpperCase();
        else if (c < 128) e = "%" + c.toString(16).toUpperCase();
        else if (c < 2048) e = "%" + (c >> 6 | 192).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
        else e = "%" + (c >> 12 | 224).toString(16).toUpperCase() + "%" + (c >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
        return e;
    }
    function pctDecChars(str) {
        var newStr = "";
        var i = 0;
        var il = str.length;
        while(i < il){
            var c = parseInt(str.substr(i + 1, 2), 16);
            if (c < 128) {
                newStr += String.fromCharCode(c);
                i += 3;
            } else if (c >= 194 && c < 224) {
                if (il - i >= 6) {
                    var c2 = parseInt(str.substr(i + 4, 2), 16);
                    newStr += String.fromCharCode((c & 31) << 6 | c2 & 63);
                } else newStr += str.substr(i, 6);
                i += 6;
            } else if (c >= 224) {
                if (il - i >= 9) {
                    var _c = parseInt(str.substr(i + 4, 2), 16);
                    var c3 = parseInt(str.substr(i + 7, 2), 16);
                    newStr += String.fromCharCode((c & 15) << 12 | (_c & 63) << 6 | c3 & 63);
                } else newStr += str.substr(i, 9);
                i += 9;
            } else {
                newStr += str.substr(i, 3);
                i += 3;
            }
        }
        return newStr;
    }
    function _normalizeComponentEncoding(components, protocol) {
        function decodeUnreserved(str) {
            var decStr = pctDecChars(str);
            return !decStr.match(protocol.UNRESERVED) ? str : decStr;
        }
        if (components.scheme) components.scheme = String(components.scheme).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_SCHEME, "");
        if (components.userinfo !== undefined) components.userinfo = String(components.userinfo).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_USERINFO, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.host !== undefined) components.host = String(components.host).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_HOST, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.path !== undefined) components.path = String(components.path).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(components.scheme ? protocol.NOT_PATH : protocol.NOT_PATH_NOSCHEME, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.query !== undefined) components.query = String(components.query).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_QUERY, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.fragment !== undefined) components.fragment = String(components.fragment).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_FRAGMENT, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        return components;
    }
    function _stripLeadingZeros(str) {
        return str.replace(/^0*(.*)/, "$1") || "0";
    }
    function _normalizeIPv4(host, protocol) {
        var matches = host.match(protocol.IPV4ADDRESS) || [];
        var _matches = slicedToArray(matches, 2), address = _matches[1];
        if (address) return address.split(".").map(_stripLeadingZeros).join(".");
        else return host;
    }
    function _normalizeIPv6(host, protocol) {
        var matches = host.match(protocol.IPV6ADDRESS) || [];
        var _matches2 = slicedToArray(matches, 3), address = _matches2[1], zone = _matches2[2];
        if (address) {
            var _address$toLowerCase$ = address.toLowerCase().split("::").reverse(), _address$toLowerCase$2 = slicedToArray(_address$toLowerCase$, 2), last = _address$toLowerCase$2[0], first = _address$toLowerCase$2[1];
            var firstFields = first ? first.split(":").map(_stripLeadingZeros) : [];
            var lastFields = last.split(":").map(_stripLeadingZeros);
            var isLastFieldIPv4Address = protocol.IPV4ADDRESS.test(lastFields[lastFields.length - 1]);
            var fieldCount = isLastFieldIPv4Address ? 7 : 8;
            var lastFieldsStart = lastFields.length - fieldCount;
            var fields = Array(fieldCount);
            for(var x = 0; x < fieldCount; ++x)fields[x] = firstFields[x] || lastFields[lastFieldsStart + x] || "";
            if (isLastFieldIPv4Address) fields[fieldCount - 1] = _normalizeIPv4(fields[fieldCount - 1], protocol);
            var allZeroFields = fields.reduce(function(acc, field, index) {
                if (!field || field === "0") {
                    var lastLongest = acc[acc.length - 1];
                    if (lastLongest && lastLongest.index + lastLongest.length === index) lastLongest.length++;
                    else acc.push({
                        index: index,
                        length: 1
                    });
                }
                return acc;
            }, []);
            var longestZeroFields = allZeroFields.sort(function(a, b) {
                return b.length - a.length;
            })[0];
            var newHost = void 0;
            if (longestZeroFields && longestZeroFields.length > 1) {
                var newFirst = fields.slice(0, longestZeroFields.index);
                var newLast = fields.slice(longestZeroFields.index + longestZeroFields.length);
                newHost = newFirst.join(":") + "::" + newLast.join(":");
            } else newHost = fields.join(":");
            if (zone) newHost += "%" + zone;
            return newHost;
        } else return host;
    }
    var URI_PARSE = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i;
    var NO_MATCH_IS_UNDEFINED = "".match(/(){0}/)[1] === undefined;
    function parse(uriString) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var components = {};
        var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
        if (options.reference === "suffix") uriString = (options.scheme ? options.scheme + ":" : "") + "//" + uriString;
        var matches = uriString.match(URI_PARSE);
        if (matches) {
            if (NO_MATCH_IS_UNDEFINED) {
                //store each component
                components.scheme = matches[1];
                components.userinfo = matches[3];
                components.host = matches[4];
                components.port = parseInt(matches[5], 10);
                components.path = matches[6] || "";
                components.query = matches[7];
                components.fragment = matches[8];
                //fix port number
                if (isNaN(components.port)) components.port = matches[5];
            } else {
                //IE FIX for improper RegExp matching
                //store each component
                components.scheme = matches[1] || undefined;
                components.userinfo = uriString.indexOf("@") !== -1 ? matches[3] : undefined;
                components.host = uriString.indexOf("//") !== -1 ? matches[4] : undefined;
                components.port = parseInt(matches[5], 10);
                components.path = matches[6] || "";
                components.query = uriString.indexOf("?") !== -1 ? matches[7] : undefined;
                components.fragment = uriString.indexOf("#") !== -1 ? matches[8] : undefined;
                //fix port number
                if (isNaN(components.port)) components.port = uriString.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? matches[4] : undefined;
            }
            if (components.host) //normalize IP hosts
            components.host = _normalizeIPv6(_normalizeIPv4(components.host, protocol), protocol);
            //determine reference type
            if (components.scheme === undefined && components.userinfo === undefined && components.host === undefined && components.port === undefined && !components.path && components.query === undefined) components.reference = "same-document";
            else if (components.scheme === undefined) components.reference = "relative";
            else if (components.fragment === undefined) components.reference = "absolute";
            else components.reference = "uri";
            //check for reference errors
            if (options.reference && options.reference !== "suffix" && options.reference !== components.reference) components.error = components.error || "URI is not a " + options.reference + " reference.";
            //find scheme handler
            var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
            //check if scheme can't handle IRIs
            if (!options.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
                //if host component is a domain name
                if (components.host && (options.domainHost || schemeHandler && schemeHandler.domainHost)) //convert Unicode IDN -> ASCII IDN
                try {
                    components.host = punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase());
                } catch (e) {
                    components.error = components.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
                }
                //convert IRI -> URI
                _normalizeComponentEncoding(components, URI_PROTOCOL);
            } else //normalize encodings
            _normalizeComponentEncoding(components, protocol);
            //perform scheme specific parsing
            if (schemeHandler && schemeHandler.parse) schemeHandler.parse(components, options);
        } else components.error = components.error || "URI can not be parsed.";
        return components;
    }
    function _recomposeAuthority(components, options) {
        var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
        var uriTokens = [];
        if (components.userinfo !== undefined) {
            uriTokens.push(components.userinfo);
            uriTokens.push("@");
        }
        if (components.host !== undefined) //normalize IP hosts, add brackets and escape zone separator for IPv6
        uriTokens.push(_normalizeIPv6(_normalizeIPv4(String(components.host), protocol), protocol).replace(protocol.IPV6ADDRESS, function(_, $1, $2) {
            return "[" + $1 + ($2 ? "%25" + $2 : "") + "]";
        }));
        if (typeof components.port === "number" || typeof components.port === "string") {
            uriTokens.push(":");
            uriTokens.push(String(components.port));
        }
        return uriTokens.length ? uriTokens.join("") : undefined;
    }
    var RDS1 = /^\.\.?\//;
    var RDS2 = /^\/\.(\/|$)/;
    var RDS3 = /^\/\.\.(\/|$)/;
    var RDS5 = /^\/?(?:.|\n)*?(?=\/|$)/;
    function removeDotSegments(input) {
        var output = [];
        while(input.length){
            if (input.match(RDS1)) input = input.replace(RDS1, "");
            else if (input.match(RDS2)) input = input.replace(RDS2, "/");
            else if (input.match(RDS3)) {
                input = input.replace(RDS3, "/");
                output.pop();
            } else if (input === "." || input === "..") input = "";
            else {
                var im = input.match(RDS5);
                if (im) {
                    var s = im[0];
                    input = input.slice(s.length);
                    output.push(s);
                } else throw new Error("Unexpected dot segment condition");
            }
        }
        return output.join("");
    }
    function serialize(components) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var protocol = options.iri ? IRI_PROTOCOL : URI_PROTOCOL;
        var uriTokens = [];
        //find scheme handler
        var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
        //perform scheme specific serialization
        if (schemeHandler && schemeHandler.serialize) schemeHandler.serialize(components, options);
        if (components.host) {
            //if host component is an IPv6 address
            if (protocol.IPV6ADDRESS.test(components.host)) ;
            else if (options.domainHost || schemeHandler && schemeHandler.domainHost) //convert IDN via punycode
            try {
                components.host = !options.iri ? punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase()) : punycode.toUnicode(components.host);
            } catch (e) {
                components.error = components.error || "Host's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
            }
        }
        //normalize encoding
        _normalizeComponentEncoding(components, protocol);
        if (options.reference !== "suffix" && components.scheme) {
            uriTokens.push(components.scheme);
            uriTokens.push(":");
        }
        var authority = _recomposeAuthority(components, options);
        if (authority !== undefined) {
            if (options.reference !== "suffix") uriTokens.push("//");
            uriTokens.push(authority);
            if (components.path && components.path.charAt(0) !== "/") uriTokens.push("/");
        }
        if (components.path !== undefined) {
            var s = components.path;
            if (!options.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) s = removeDotSegments(s);
            if (authority === undefined) s = s.replace(/^\/\//, "/%2F"); //don't allow the path to start with "//"
            uriTokens.push(s);
        }
        if (components.query !== undefined) {
            uriTokens.push("?");
            uriTokens.push(components.query);
        }
        if (components.fragment !== undefined) {
            uriTokens.push("#");
            uriTokens.push(components.fragment);
        }
        return uriTokens.join(""); //merge tokens into a string
    }
    function resolveComponents(base, relative) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var skipNormalization = arguments[3];
        var target = {};
        if (!skipNormalization) {
            base = parse(serialize(base, options), options); //normalize base components
            relative = parse(serialize(relative, options), options); //normalize relative components
        }
        options = options || {};
        if (!options.tolerant && relative.scheme) {
            target.scheme = relative.scheme;
            //target.authority = relative.authority;
            target.userinfo = relative.userinfo;
            target.host = relative.host;
            target.port = relative.port;
            target.path = removeDotSegments(relative.path || "");
            target.query = relative.query;
        } else {
            if (relative.userinfo !== undefined || relative.host !== undefined || relative.port !== undefined) {
                //target.authority = relative.authority;
                target.userinfo = relative.userinfo;
                target.host = relative.host;
                target.port = relative.port;
                target.path = removeDotSegments(relative.path || "");
                target.query = relative.query;
            } else {
                if (!relative.path) {
                    target.path = base.path;
                    if (relative.query !== undefined) target.query = relative.query;
                    else target.query = base.query;
                } else {
                    if (relative.path.charAt(0) === "/") target.path = removeDotSegments(relative.path);
                    else {
                        if ((base.userinfo !== undefined || base.host !== undefined || base.port !== undefined) && !base.path) target.path = "/" + relative.path;
                        else if (!base.path) target.path = relative.path;
                        else target.path = base.path.slice(0, base.path.lastIndexOf("/") + 1) + relative.path;
                        target.path = removeDotSegments(target.path);
                    }
                    target.query = relative.query;
                }
                //target.authority = base.authority;
                target.userinfo = base.userinfo;
                target.host = base.host;
                target.port = base.port;
            }
            target.scheme = base.scheme;
        }
        target.fragment = relative.fragment;
        return target;
    }
    function resolve(baseURI, relativeURI, options) {
        var schemelessOptions = assign({
            scheme: "null"
        }, options);
        return serialize(resolveComponents(parse(baseURI, schemelessOptions), parse(relativeURI, schemelessOptions), schemelessOptions, true), schemelessOptions);
    }
    function normalize(uri, options) {
        if (typeof uri === "string") uri = serialize(parse(uri, options), options);
        else if (typeOf(uri) === "object") uri = parse(serialize(uri, options), options);
        return uri;
    }
    function equal(uriA, uriB, options) {
        if (typeof uriA === "string") uriA = serialize(parse(uriA, options), options);
        else if (typeOf(uriA) === "object") uriA = serialize(uriA, options);
        if (typeof uriB === "string") uriB = serialize(parse(uriB, options), options);
        else if (typeOf(uriB) === "object") uriB = serialize(uriB, options);
        return uriA === uriB;
    }
    function escapeComponent(str, options) {
        return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.ESCAPE : IRI_PROTOCOL.ESCAPE, pctEncChar);
    }
    function unescapeComponent(str, options) {
        return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.PCT_ENCODED : IRI_PROTOCOL.PCT_ENCODED, pctDecChars);
    }
    var handler = {
        scheme: "http",
        domainHost: true,
        parse: function parse(components, options) {
            //report missing host
            if (!components.host) components.error = components.error || "HTTP URIs must have a host.";
            return components;
        },
        serialize: function serialize(components, options) {
            var secure = String(components.scheme).toLowerCase() === "https";
            //normalize the default port
            if (components.port === (secure ? 443 : 80) || components.port === "") components.port = undefined;
            //normalize the empty path
            if (!components.path) components.path = "/";
            //NOTE: We do not parse query strings for HTTP URIs
            //as WWW Form Url Encoded query strings are part of the HTML4+ spec,
            //and not the HTTP spec.
            return components;
        }
    };
    var handler$1 = {
        scheme: "https",
        domainHost: handler.domainHost,
        parse: handler.parse,
        serialize: handler.serialize
    };
    function isSecure(wsComponents) {
        return typeof wsComponents.secure === "boolean" ? wsComponents.secure : String(wsComponents.scheme).toLowerCase() === "wss";
    }
    //RFC 6455
    var handler$2 = {
        scheme: "ws",
        domainHost: true,
        parse: function parse(components, options) {
            var wsComponents = components;
            //indicate if the secure flag is set
            wsComponents.secure = isSecure(wsComponents);
            //construct resouce name
            wsComponents.resourceName = (wsComponents.path || "/") + (wsComponents.query ? "?" + wsComponents.query : "");
            wsComponents.path = undefined;
            wsComponents.query = undefined;
            return wsComponents;
        },
        serialize: function serialize(wsComponents, options) {
            //normalize the default port
            if (wsComponents.port === (isSecure(wsComponents) ? 443 : 80) || wsComponents.port === "") wsComponents.port = undefined;
            //ensure scheme matches secure flag
            if (typeof wsComponents.secure === "boolean") {
                wsComponents.scheme = wsComponents.secure ? "wss" : "ws";
                wsComponents.secure = undefined;
            }
            //reconstruct path from resource name
            if (wsComponents.resourceName) {
                var _wsComponents$resourc = wsComponents.resourceName.split("?"), _wsComponents$resourc2 = slicedToArray(_wsComponents$resourc, 2), path = _wsComponents$resourc2[0], query = _wsComponents$resourc2[1];
                wsComponents.path = path && path !== "/" ? path : undefined;
                wsComponents.query = query;
                wsComponents.resourceName = undefined;
            }
            //forbid fragment component
            wsComponents.fragment = undefined;
            return wsComponents;
        }
    };
    var handler$3 = {
        scheme: "wss",
        domainHost: handler$2.domainHost,
        parse: handler$2.parse,
        serialize: handler$2.serialize
    };
    var O = {};
    var isIRI = true;
    //RFC 3986
    var UNRESERVED$$ = "[A-Za-z0-9\\-\\.\\_\\~" + (isIRI ? "\\xA0-\\u200D\\u2010-\\u2029\\u202F-\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF" : "") + "]";
    var HEXDIG$$ = "[0-9A-Fa-f]"; //case-insensitive
    var PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)); //expanded
    //RFC 5322, except these symbols as per RFC 6068: @ : / ? # [ ] & ; =
    //const ATEXT$$ = "[A-Za-z0-9\\!\\#\\$\\%\\&\\'\\*\\+\\-\\/\\=\\?\\^\\_\\`\\{\\|\\}\\~]";
    //const WSP$$ = "[\\x20\\x09]";
    //const OBS_QTEXT$$ = "[\\x01-\\x08\\x0B\\x0C\\x0E-\\x1F\\x7F]";  //(%d1-8 / %d11-12 / %d14-31 / %d127)
    //const QTEXT$$ = merge("[\\x21\\x23-\\x5B\\x5D-\\x7E]", OBS_QTEXT$$);  //%d33 / %d35-91 / %d93-126 / obs-qtext
    //const VCHAR$$ = "[\\x21-\\x7E]";
    //const WSP$$ = "[\\x20\\x09]";
    //const OBS_QP$ = subexp("\\\\" + merge("[\\x00\\x0D\\x0A]", OBS_QTEXT$$));  //%d0 / CR / LF / obs-qtext
    //const FWS$ = subexp(subexp(WSP$$ + "*" + "\\x0D\\x0A") + "?" + WSP$$ + "+");
    //const QUOTED_PAIR$ = subexp(subexp("\\\\" + subexp(VCHAR$$ + "|" + WSP$$)) + "|" + OBS_QP$);
    //const QUOTED_STRING$ = subexp('\\"' + subexp(FWS$ + "?" + QCONTENT$) + "*" + FWS$ + "?" + '\\"');
    var ATEXT$$ = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]";
    var QTEXT$$ = "[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]";
    var VCHAR$$ = merge(QTEXT$$, '[\\"\\\\]');
    var SOME_DELIMS$$ = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]";
    var UNRESERVED = new RegExp(UNRESERVED$$, "g");
    var PCT_ENCODED = new RegExp(PCT_ENCODED$, "g");
    var NOT_LOCAL_PART = new RegExp(merge("[^]", ATEXT$$, "[\\.]", '[\\"]', VCHAR$$), "g");
    var NOT_HFNAME = new RegExp(merge("[^]", UNRESERVED$$, SOME_DELIMS$$), "g");
    var NOT_HFVALUE = NOT_HFNAME;
    function decodeUnreserved(str) {
        var decStr = pctDecChars(str);
        return !decStr.match(UNRESERVED) ? str : decStr;
    }
    var handler$4 = {
        scheme: "mailto",
        parse: function parse$$1(components, options) {
            var mailtoComponents = components;
            var to = mailtoComponents.to = mailtoComponents.path ? mailtoComponents.path.split(",") : [];
            mailtoComponents.path = undefined;
            if (mailtoComponents.query) {
                var unknownHeaders = false;
                var headers = {};
                var hfields = mailtoComponents.query.split("&");
                for(var x = 0, xl = hfields.length; x < xl; ++x){
                    var hfield = hfields[x].split("=");
                    switch(hfield[0]){
                        case "to":
                            var toAddrs = hfield[1].split(",");
                            for(var _x = 0, _xl = toAddrs.length; _x < _xl; ++_x)to.push(toAddrs[_x]);
                            break;
                        case "subject":
                            mailtoComponents.subject = unescapeComponent(hfield[1], options);
                            break;
                        case "body":
                            mailtoComponents.body = unescapeComponent(hfield[1], options);
                            break;
                        default:
                            unknownHeaders = true;
                            headers[unescapeComponent(hfield[0], options)] = unescapeComponent(hfield[1], options);
                            break;
                    }
                }
                if (unknownHeaders) mailtoComponents.headers = headers;
            }
            mailtoComponents.query = undefined;
            for(var _x2 = 0, _xl2 = to.length; _x2 < _xl2; ++_x2){
                var addr = to[_x2].split("@");
                addr[0] = unescapeComponent(addr[0]);
                if (!options.unicodeSupport) //convert Unicode IDN -> ASCII IDN
                try {
                    addr[1] = punycode.toASCII(unescapeComponent(addr[1], options).toLowerCase());
                } catch (e) {
                    mailtoComponents.error = mailtoComponents.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
                }
                else addr[1] = unescapeComponent(addr[1], options).toLowerCase();
                to[_x2] = addr.join("@");
            }
            return mailtoComponents;
        },
        serialize: function serialize$$1(mailtoComponents, options) {
            var components = mailtoComponents;
            var to = toArray(mailtoComponents.to);
            if (to) {
                for(var x = 0, xl = to.length; x < xl; ++x){
                    var toAddr = String(to[x]);
                    var atIdx = toAddr.lastIndexOf("@");
                    var localPart = toAddr.slice(0, atIdx).replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_LOCAL_PART, pctEncChar);
                    var domain = toAddr.slice(atIdx + 1);
                    //convert IDN via punycode
                    try {
                        domain = !options.iri ? punycode.toASCII(unescapeComponent(domain, options).toLowerCase()) : punycode.toUnicode(domain);
                    } catch (e) {
                        components.error = components.error || "Email address's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
                    }
                    to[x] = localPart + "@" + domain;
                }
                components.path = to.join(",");
            }
            var headers = mailtoComponents.headers = mailtoComponents.headers || {};
            if (mailtoComponents.subject) headers["subject"] = mailtoComponents.subject;
            if (mailtoComponents.body) headers["body"] = mailtoComponents.body;
            var fields = [];
            for(var name in headers)if (headers[name] !== O[name]) fields.push(name.replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFNAME, pctEncChar) + "=" + headers[name].replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFVALUE, pctEncChar));
            if (fields.length) components.query = fields.join("&");
            return components;
        }
    };
    var URN_PARSE = /^([^\:]+)\:(.*)/;
    //RFC 2141
    var handler$5 = {
        scheme: "urn",
        parse: function parse$$1(components, options) {
            var matches = components.path && components.path.match(URN_PARSE);
            var urnComponents = components;
            if (matches) {
                var scheme = options.scheme || urnComponents.scheme || "urn";
                var nid = matches[1].toLowerCase();
                var nss = matches[2];
                var urnScheme = scheme + ":" + (options.nid || nid);
                var schemeHandler = SCHEMES[urnScheme];
                urnComponents.nid = nid;
                urnComponents.nss = nss;
                urnComponents.path = undefined;
                if (schemeHandler) urnComponents = schemeHandler.parse(urnComponents, options);
            } else urnComponents.error = urnComponents.error || "URN can not be parsed.";
            return urnComponents;
        },
        serialize: function serialize$$1(urnComponents, options) {
            var scheme = options.scheme || urnComponents.scheme || "urn";
            var nid = urnComponents.nid;
            var urnScheme = scheme + ":" + (options.nid || nid);
            var schemeHandler = SCHEMES[urnScheme];
            if (schemeHandler) urnComponents = schemeHandler.serialize(urnComponents, options);
            var uriComponents = urnComponents;
            var nss = urnComponents.nss;
            uriComponents.path = (nid || options.nid) + ":" + nss;
            return uriComponents;
        }
    };
    var UUID = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/;
    //RFC 4122
    var handler$6 = {
        scheme: "urn:uuid",
        parse: function parse(urnComponents, options) {
            var uuidComponents = urnComponents;
            uuidComponents.uuid = uuidComponents.nss;
            uuidComponents.nss = undefined;
            if (!options.tolerant && (!uuidComponents.uuid || !uuidComponents.uuid.match(UUID))) uuidComponents.error = uuidComponents.error || "UUID is not valid.";
            return uuidComponents;
        },
        serialize: function serialize(uuidComponents, options) {
            var urnComponents = uuidComponents;
            //normalize UUID
            urnComponents.nss = (uuidComponents.uuid || "").toLowerCase();
            return urnComponents;
        }
    };
    SCHEMES[handler.scheme] = handler;
    SCHEMES[handler$1.scheme] = handler$1;
    SCHEMES[handler$2.scheme] = handler$2;
    SCHEMES[handler$3.scheme] = handler$3;
    SCHEMES[handler$4.scheme] = handler$4;
    SCHEMES[handler$5.scheme] = handler$5;
    SCHEMES[handler$6.scheme] = handler$6;
    exports1.SCHEMES = SCHEMES;
    exports1.pctEncChar = pctEncChar;
    exports1.pctDecChars = pctDecChars;
    exports1.parse = parse;
    exports1.removeDotSegments = removeDotSegments;
    exports1.serialize = serialize;
    exports1.resolveComponents = resolveComponents;
    exports1.resolve = resolve;
    exports1.normalize = normalize;
    exports1.equal = equal;
    exports1.escapeComponent = escapeComponent;
    exports1.unescapeComponent = unescapeComponent;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});

});



parcelRequire.register("6yzWZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aUSAP = parcelRequire("aUSAP");

var $bre9O = parcelRequire("bre9O");

var $h2qty = parcelRequire("h2qty");

var $o75Mp = parcelRequire("o75Mp");

var $1f3mY = parcelRequire("1f3mY");
const $4c61ce12611d5a50$var$draft7Vocabularies = [
    $aUSAP.default,
    $bre9O.default,
    (0, $h2qty.default)(),
    $o75Mp.default,
    $1f3mY.metadataVocabulary,
    $1f3mY.contentVocabulary
];
module.exports.default = $4c61ce12611d5a50$var$draft7Vocabularies;

});
parcelRequire.register("aUSAP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $BUfus = parcelRequire("BUfus");

var $jCbdL = parcelRequire("jCbdL");
const $7f297b6749e5abdf$var$core = [
    "$schema",
    "$id",
    "$defs",
    "$vocabulary",
    {
        keyword: "$comment"
    },
    "definitions",
    $BUfus.default,
    $jCbdL.default
];
module.exports.default = $7f297b6749e5abdf$var$core;

});
parcelRequire.register("BUfus", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $071f16aa1c239289$var$def = {
    keyword: "id",
    code () {
        throw new Error('NOT SUPPORTED: keyword "id", use "$id" for schema ID');
    }
};
module.exports.default = $071f16aa1c239289$var$def;

});

parcelRequire.register("jCbdL", function(module, exports) {
"use strict";
let $e47a4530d87f6096$var$_ = (t)=>t, $e47a4530d87f6096$var$t, $e47a4530d87f6096$var$t1, $e47a4530d87f6096$var$t2, $e47a4530d87f6096$var$t3, $e47a4530d87f6096$var$t4, $e47a4530d87f6096$var$t5, $e47a4530d87f6096$var$t6, $e47a4530d87f6096$var$t7, $e47a4530d87f6096$var$t8;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.callRef = module.exports.getValidate = void 0;

var $6XLO0 = parcelRequire("6XLO0");

var $5Cgzr = parcelRequire("5Cgzr");

var $6Vb5F = parcelRequire("6Vb5F");

var $eXNSw = parcelRequire("eXNSw");

var $PkPFY = parcelRequire("PkPFY");

var $k2074 = parcelRequire("k2074");
const $e47a4530d87f6096$var$def = {
    keyword: "$ref",
    schemaType: "string",
    code (cxt) {
        const { gen: gen, schema: $ref, it: it } = cxt;
        const { baseId: baseId, schemaEnv: env, validateName: validateName, opts: opts, self: self } = it;
        const { root: root } = env;
        if (($ref === "#" || $ref === "#/") && baseId === root.baseId) return callRootRef();
        const schOrEnv = $PkPFY.resolveRef.call(self, root, baseId, $ref);
        if (schOrEnv === undefined) throw new $6XLO0.default(it.opts.uriResolver, baseId, $ref);
        if (schOrEnv instanceof $PkPFY.SchemaEnv) return callValidate(schOrEnv);
        return inlineRefSchema(schOrEnv);
        function callRootRef() {
            if (env === root) return $e47a4530d87f6096$var$callRef(cxt, validateName, env, env.$async);
            const rootName = gen.scopeValue("root", {
                ref: root
            });
            return $e47a4530d87f6096$var$callRef(cxt, (0, $6Vb5F._)($e47a4530d87f6096$var$t || ($e47a4530d87f6096$var$t = $e47a4530d87f6096$var$_`${0}.validate`), rootName), root, root.$async);
        }
        function callValidate(sch) {
            const v = $e47a4530d87f6096$var$getValidate(cxt, sch);
            $e47a4530d87f6096$var$callRef(cxt, v, sch, sch.$async);
        }
        function inlineRefSchema(sch) {
            const schName = gen.scopeValue("schema", opts.code.source === true ? {
                ref: sch,
                code: (0, $6Vb5F.stringify)(sch)
            } : {
                ref: sch
            });
            const valid = gen.name("valid");
            const schCxt = cxt.subschema({
                schema: sch,
                dataTypes: [],
                schemaPath: $6Vb5F.nil,
                topSchemaRef: schName,
                errSchemaPath: $ref
            }, valid);
            cxt.mergeEvaluated(schCxt);
            cxt.ok(valid);
        }
    }
};
function $e47a4530d87f6096$var$getValidate(cxt, sch) {
    const { gen: gen } = cxt;
    return sch.validate ? gen.scopeValue("validate", {
        ref: sch.validate
    }) : (0, $6Vb5F._)($e47a4530d87f6096$var$t1 || ($e47a4530d87f6096$var$t1 = $e47a4530d87f6096$var$_`${0}.validate`), gen.scopeValue("wrapper", {
        ref: sch
    }));
}
module.exports.getValidate = $e47a4530d87f6096$var$getValidate;
function $e47a4530d87f6096$var$callRef(cxt, v, sch, $async) {
    const { gen: gen, it: it } = cxt;
    const { allErrors: allErrors, schemaEnv: env, opts: opts } = it;
    const passCxt = opts.passContext ? $eXNSw.default.this : $6Vb5F.nil;
    if ($async) callAsyncRef();
    else callSyncRef();
    function callAsyncRef() {
        if (!env.$async) throw new Error("async schema referenced by sync schema");
        const valid = gen.let("valid");
        gen.try(()=>{
            gen.code((0, $6Vb5F._)($e47a4530d87f6096$var$t2 || ($e47a4530d87f6096$var$t2 = $e47a4530d87f6096$var$_`await ${0}`), (0, $5Cgzr.callValidateCode)(cxt, v, passCxt)));
            addEvaluatedFrom(v); // TODO will not work with async, it has to be returned with the result
            if (!allErrors) gen.assign(valid, true);
        }, (e)=>{
            gen.if((0, $6Vb5F._)($e47a4530d87f6096$var$t3 || ($e47a4530d87f6096$var$t3 = $e47a4530d87f6096$var$_`!(${0} instanceof ${0})`), e, it.ValidationError), ()=>gen.throw(e));
            addErrorsFrom(e);
            if (!allErrors) gen.assign(valid, false);
        });
        cxt.ok(valid);
    }
    function callSyncRef() {
        cxt.result((0, $5Cgzr.callValidateCode)(cxt, v, passCxt), ()=>addEvaluatedFrom(v), ()=>addErrorsFrom(v));
    }
    function addErrorsFrom(source) {
        const errs = (0, $6Vb5F._)($e47a4530d87f6096$var$t4 || ($e47a4530d87f6096$var$t4 = $e47a4530d87f6096$var$_`${0}.errors`), source);
        gen.assign($eXNSw.default.vErrors, (0, $6Vb5F._)($e47a4530d87f6096$var$t5 || ($e47a4530d87f6096$var$t5 = $e47a4530d87f6096$var$_`${0} === null ? ${0} : ${0}.concat(${0})`), $eXNSw.default.vErrors, errs, $eXNSw.default.vErrors, errs)); // TODO tagged
        gen.assign($eXNSw.default.errors, (0, $6Vb5F._)($e47a4530d87f6096$var$t6 || ($e47a4530d87f6096$var$t6 = $e47a4530d87f6096$var$_`${0}.length`), $eXNSw.default.vErrors));
    }
    function addEvaluatedFrom(source) {
        var _a;
        if (!it.opts.unevaluated) return;
        const schEvaluated = (_a = sch === null || sch === void 0 ? void 0 : sch.validate) === null || _a === void 0 ? void 0 : _a.evaluated;
        // TODO refactor
        if (it.props !== true) {
            if (schEvaluated && !schEvaluated.dynamicProps) {
                if (schEvaluated.props !== undefined) it.props = $k2074.mergeEvaluated.props(gen, schEvaluated.props, it.props);
            } else {
                const props = gen.var("props", (0, $6Vb5F._)($e47a4530d87f6096$var$t7 || ($e47a4530d87f6096$var$t7 = $e47a4530d87f6096$var$_`${0}.evaluated.props`), source));
                it.props = $k2074.mergeEvaluated.props(gen, props, it.props, $6Vb5F.Name);
            }
        }
        if (it.items !== true) {
            if (schEvaluated && !schEvaluated.dynamicItems) {
                if (schEvaluated.items !== undefined) it.items = $k2074.mergeEvaluated.items(gen, schEvaluated.items, it.items);
            } else {
                const items = gen.var("items", (0, $6Vb5F._)($e47a4530d87f6096$var$t8 || ($e47a4530d87f6096$var$t8 = $e47a4530d87f6096$var$_`${0}.evaluated.items`), source));
                it.items = $k2074.mergeEvaluated.items(gen, items, it.items, $6Vb5F.Name);
            }
        }
    }
}
module.exports.callRef = $e47a4530d87f6096$var$callRef;
module.exports.default = $e47a4530d87f6096$var$def;

});


parcelRequire.register("bre9O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ahxNo = parcelRequire("ahxNo");

var $feueo = parcelRequire("feueo");

var $9egL7 = parcelRequire("9egL7");

var $4fmH6 = parcelRequire("4fmH6");

var $b4v8m = parcelRequire("b4v8m");

var $27xhT = parcelRequire("27xhT");

var $1CEqr = parcelRequire("1CEqr");

var $FfFgQ = parcelRequire("FfFgQ");

var $dK2HK = parcelRequire("dK2HK");

var $3MnT0 = parcelRequire("3MnT0");
const $853d32a63189477d$var$validation = [
    // number
    $ahxNo.default,
    $feueo.default,
    // string
    $9egL7.default,
    $4fmH6.default,
    // object
    $b4v8m.default,
    $27xhT.default,
    // array
    $1CEqr.default,
    $FfFgQ.default,
    // any
    {
        keyword: "type",
        schemaType: [
            "string",
            "array"
        ]
    },
    {
        keyword: "nullable",
        schemaType: "boolean"
    },
    $dK2HK.default,
    $3MnT0.default
];
module.exports.default = $853d32a63189477d$var$validation;

});
parcelRequire.register("ahxNo", function(module, exports) {
"use strict";
let $77c5b506d6a95fe1$var$_ = (t)=>t, $77c5b506d6a95fe1$var$t, $77c5b506d6a95fe1$var$t1, $77c5b506d6a95fe1$var$t2;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6Vb5F = parcelRequire("6Vb5F");
const $77c5b506d6a95fe1$var$ops = $6Vb5F.operators;
const $77c5b506d6a95fe1$var$KWDs = {
    maximum: {
        okStr: "<=",
        ok: $77c5b506d6a95fe1$var$ops.LTE,
        fail: $77c5b506d6a95fe1$var$ops.GT
    },
    minimum: {
        okStr: ">=",
        ok: $77c5b506d6a95fe1$var$ops.GTE,
        fail: $77c5b506d6a95fe1$var$ops.LT
    },
    exclusiveMaximum: {
        okStr: "<",
        ok: $77c5b506d6a95fe1$var$ops.LT,
        fail: $77c5b506d6a95fe1$var$ops.GTE
    },
    exclusiveMinimum: {
        okStr: ">",
        ok: $77c5b506d6a95fe1$var$ops.GT,
        fail: $77c5b506d6a95fe1$var$ops.LTE
    }
};
const $77c5b506d6a95fe1$var$error = {
    message: ({ keyword: keyword, schemaCode: schemaCode })=>(0, $6Vb5F.str)($77c5b506d6a95fe1$var$t || ($77c5b506d6a95fe1$var$t = $77c5b506d6a95fe1$var$_`must be ${0} ${0}`), $77c5b506d6a95fe1$var$KWDs[keyword].okStr, schemaCode),
    params: ({ keyword: keyword, schemaCode: schemaCode })=>(0, $6Vb5F._)($77c5b506d6a95fe1$var$t1 || ($77c5b506d6a95fe1$var$t1 = $77c5b506d6a95fe1$var$_`{comparison: ${0}, limit: ${0}}`), $77c5b506d6a95fe1$var$KWDs[keyword].okStr, schemaCode)
};
const $77c5b506d6a95fe1$var$def = {
    keyword: Object.keys($77c5b506d6a95fe1$var$KWDs),
    type: "number",
    schemaType: "number",
    $data: true,
    error: $77c5b506d6a95fe1$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode } = cxt;
        cxt.fail$data((0, $6Vb5F._)($77c5b506d6a95fe1$var$t2 || ($77c5b506d6a95fe1$var$t2 = $77c5b506d6a95fe1$var$_`${0} ${0} ${0} || isNaN(${0})`), data, $77c5b506d6a95fe1$var$KWDs[keyword].fail, schemaCode, data));
    }
};
module.exports.default = $77c5b506d6a95fe1$var$def;

});

parcelRequire.register("feueo", function(module, exports) {
"use strict";
let $b16f9d1a05eb97f5$var$_ = (t)=>t, $b16f9d1a05eb97f5$var$t, $b16f9d1a05eb97f5$var$t1, $b16f9d1a05eb97f5$var$t2, $b16f9d1a05eb97f5$var$t3, $b16f9d1a05eb97f5$var$t4;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6Vb5F = parcelRequire("6Vb5F");
const $b16f9d1a05eb97f5$var$error = {
    message: ({ schemaCode: schemaCode })=>(0, $6Vb5F.str)($b16f9d1a05eb97f5$var$t || ($b16f9d1a05eb97f5$var$t = $b16f9d1a05eb97f5$var$_`must be multiple of ${0}`), schemaCode),
    params: ({ schemaCode: schemaCode })=>(0, $6Vb5F._)($b16f9d1a05eb97f5$var$t1 || ($b16f9d1a05eb97f5$var$t1 = $b16f9d1a05eb97f5$var$_`{multipleOf: ${0}}`), schemaCode)
};
const $b16f9d1a05eb97f5$var$def = {
    keyword: "multipleOf",
    type: "number",
    schemaType: "number",
    $data: true,
    error: $b16f9d1a05eb97f5$var$error,
    code (cxt) {
        const { gen: gen, data: data, schemaCode: schemaCode, it: it } = cxt;
        // const bdt = bad$DataType(schemaCode, <string>def.schemaType, $data)
        const prec = it.opts.multipleOfPrecision;
        const res = gen.let("res");
        const invalid = prec ? (0, $6Vb5F._)($b16f9d1a05eb97f5$var$t2 || ($b16f9d1a05eb97f5$var$t2 = $b16f9d1a05eb97f5$var$_`Math.abs(Math.round(${0}) - ${0}) > 1e-${0}`), res, res, prec) : (0, $6Vb5F._)($b16f9d1a05eb97f5$var$t3 || ($b16f9d1a05eb97f5$var$t3 = $b16f9d1a05eb97f5$var$_`${0} !== parseInt(${0})`), res, res);
        cxt.fail$data((0, $6Vb5F._)($b16f9d1a05eb97f5$var$t4 || ($b16f9d1a05eb97f5$var$t4 = $b16f9d1a05eb97f5$var$_`(${0} === 0 || (${0} = ${0}/${0}, ${0}))`), schemaCode, res, data, schemaCode, invalid));
    }
};
module.exports.default = $b16f9d1a05eb97f5$var$def;

});

parcelRequire.register("9egL7", function(module, exports) {
"use strict";
let $6b826bd69b42badd$var$_ = (t)=>t, $6b826bd69b42badd$var$t, $6b826bd69b42badd$var$t1, $6b826bd69b42badd$var$t2, $6b826bd69b42badd$var$t3, $6b826bd69b42badd$var$t4;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6Vb5F = parcelRequire("6Vb5F");

var $k2074 = parcelRequire("k2074");

var $8DSD6 = parcelRequire("8DSD6");
const $6b826bd69b42badd$var$error = {
    message ({ keyword: keyword, schemaCode: schemaCode }) {
        const comp = keyword === "maxLength" ? "more" : "fewer";
        return (0, $6Vb5F.str)($6b826bd69b42badd$var$t || ($6b826bd69b42badd$var$t = $6b826bd69b42badd$var$_`must NOT have ${0} than ${0} characters`), comp, schemaCode);
    },
    params: ({ schemaCode: schemaCode })=>(0, $6Vb5F._)($6b826bd69b42badd$var$t1 || ($6b826bd69b42badd$var$t1 = $6b826bd69b42badd$var$_`{limit: ${0}}`), schemaCode)
};
const $6b826bd69b42badd$var$def = {
    keyword: [
        "maxLength",
        "minLength"
    ],
    type: "string",
    schemaType: "number",
    $data: true,
    error: $6b826bd69b42badd$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode, it: it } = cxt;
        const op = keyword === "maxLength" ? $6Vb5F.operators.GT : $6Vb5F.operators.LT;
        const len = it.opts.unicode === false ? (0, $6Vb5F._)($6b826bd69b42badd$var$t2 || ($6b826bd69b42badd$var$t2 = $6b826bd69b42badd$var$_`${0}.length`), data) : (0, $6Vb5F._)($6b826bd69b42badd$var$t3 || ($6b826bd69b42badd$var$t3 = $6b826bd69b42badd$var$_`${0}(${0})`), (0, $k2074.useFunc)(cxt.gen, $8DSD6.default), data);
        cxt.fail$data((0, $6Vb5F._)($6b826bd69b42badd$var$t4 || ($6b826bd69b42badd$var$t4 = $6b826bd69b42badd$var$_`${0} ${0} ${0}`), len, op, schemaCode));
    }
};
module.exports.default = $6b826bd69b42badd$var$def;

});
parcelRequire.register("8DSD6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// https://mathiasbynens.be/notes/javascript-encoding
// https://github.com/bestiejs/punycode.js - punycode.ucs2.decode
function $64ac578fd33c1daa$var$ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while(pos < len){
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            // high surrogate, and there is a next character
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00) pos++; // low surrogate
        }
    }
    return length;
}
module.exports.default = $64ac578fd33c1daa$var$ucs2length;
$64ac578fd33c1daa$var$ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';

});


parcelRequire.register("4fmH6", function(module, exports) {
"use strict";
let $317a2abaa262acf0$var$_ = (t)=>t, $317a2abaa262acf0$var$t, $317a2abaa262acf0$var$t1, $317a2abaa262acf0$var$t2, $317a2abaa262acf0$var$t3;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5Cgzr = parcelRequire("5Cgzr");

var $6Vb5F = parcelRequire("6Vb5F");
const $317a2abaa262acf0$var$error = {
    message: ({ schemaCode: schemaCode })=>(0, $6Vb5F.str)($317a2abaa262acf0$var$t || ($317a2abaa262acf0$var$t = $317a2abaa262acf0$var$_`must match pattern "${0}"`), schemaCode),
    params: ({ schemaCode: schemaCode })=>(0, $6Vb5F._)($317a2abaa262acf0$var$t1 || ($317a2abaa262acf0$var$t1 = $317a2abaa262acf0$var$_`{pattern: ${0}}`), schemaCode)
};
const $317a2abaa262acf0$var$def = {
    keyword: "pattern",
    type: "string",
    schemaType: "string",
    $data: true,
    error: $317a2abaa262acf0$var$error,
    code (cxt) {
        const { data: data, $data: $data, schema: schema, schemaCode: schemaCode, it: it } = cxt;
        // TODO regexp should be wrapped in try/catchs
        const u = it.opts.unicodeRegExp ? "u" : "";
        const regExp = $data ? (0, $6Vb5F._)($317a2abaa262acf0$var$t2 || ($317a2abaa262acf0$var$t2 = $317a2abaa262acf0$var$_`(new RegExp(${0}, ${0}))`), schemaCode, u) : (0, $5Cgzr.usePattern)(cxt, schema);
        cxt.fail$data((0, $6Vb5F._)($317a2abaa262acf0$var$t3 || ($317a2abaa262acf0$var$t3 = $317a2abaa262acf0$var$_`!${0}.test(${0})`), regExp, data));
    }
};
module.exports.default = $317a2abaa262acf0$var$def;

});

parcelRequire.register("b4v8m", function(module, exports) {
"use strict";
let $80f837f9aca85737$var$_ = (t)=>t, $80f837f9aca85737$var$t, $80f837f9aca85737$var$t1, $80f837f9aca85737$var$t2;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6Vb5F = parcelRequire("6Vb5F");
const $80f837f9aca85737$var$error = {
    message ({ keyword: keyword, schemaCode: schemaCode }) {
        const comp = keyword === "maxProperties" ? "more" : "fewer";
        return (0, $6Vb5F.str)($80f837f9aca85737$var$t || ($80f837f9aca85737$var$t = $80f837f9aca85737$var$_`must NOT have ${0} than ${0} properties`), comp, schemaCode);
    },
    params: ({ schemaCode: schemaCode })=>(0, $6Vb5F._)($80f837f9aca85737$var$t1 || ($80f837f9aca85737$var$t1 = $80f837f9aca85737$var$_`{limit: ${0}}`), schemaCode)
};
const $80f837f9aca85737$var$def = {
    keyword: [
        "maxProperties",
        "minProperties"
    ],
    type: "object",
    schemaType: "number",
    $data: true,
    error: $80f837f9aca85737$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode } = cxt;
        const op = keyword === "maxProperties" ? $6Vb5F.operators.GT : $6Vb5F.operators.LT;
        cxt.fail$data((0, $6Vb5F._)($80f837f9aca85737$var$t2 || ($80f837f9aca85737$var$t2 = $80f837f9aca85737$var$_`Object.keys(${0}).length ${0} ${0}`), data, op, schemaCode));
    }
};
module.exports.default = $80f837f9aca85737$var$def;

});

parcelRequire.register("27xhT", function(module, exports) {
"use strict";
let $18b60e7431f4d222$var$_ = (t)=>t, $18b60e7431f4d222$var$t, $18b60e7431f4d222$var$t1;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5Cgzr = parcelRequire("5Cgzr");

var $6Vb5F = parcelRequire("6Vb5F");

var $k2074 = parcelRequire("k2074");
const $18b60e7431f4d222$var$error = {
    message: ({ params: { missingProperty: missingProperty } })=>(0, $6Vb5F.str)($18b60e7431f4d222$var$t || ($18b60e7431f4d222$var$t = $18b60e7431f4d222$var$_`must have required property '${0}'`), missingProperty),
    params: ({ params: { missingProperty: missingProperty } })=>(0, $6Vb5F._)($18b60e7431f4d222$var$t1 || ($18b60e7431f4d222$var$t1 = $18b60e7431f4d222$var$_`{missingProperty: ${0}}`), missingProperty)
};
const $18b60e7431f4d222$var$def = {
    keyword: "required",
    type: "object",
    schemaType: "array",
    $data: true,
    error: $18b60e7431f4d222$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, schemaCode: schemaCode, data: data, $data: $data, it: it } = cxt;
        const { opts: opts } = it;
        if (!$data && schema.length === 0) return;
        const useLoop = schema.length >= opts.loopRequired;
        if (it.allErrors) allErrorsMode();
        else exitOnErrorMode();
        if (opts.strictRequired) {
            const props = cxt.parentSchema.properties;
            const { definedProperties: definedProperties } = cxt.it;
            for (const requiredKey of schema)if ((props === null || props === void 0 ? void 0 : props[requiredKey]) === undefined && !definedProperties.has(requiredKey)) {
                const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
                const msg = `required property "${requiredKey}" is not defined at "${schemaPath}" (strictRequired)`;
                (0, $k2074.checkStrictMode)(it, msg, it.opts.strictRequired);
            }
        }
        function allErrorsMode() {
            if (useLoop || $data) cxt.block$data($6Vb5F.nil, loopAllRequired);
            else for (const prop of schema)(0, $5Cgzr.checkReportMissingProp)(cxt, prop);
        }
        function exitOnErrorMode() {
            const missing = gen.let("missing");
            if (useLoop || $data) {
                const valid = gen.let("valid", true);
                cxt.block$data(valid, ()=>loopUntilMissing(missing, valid));
                cxt.ok(valid);
            } else {
                gen.if((0, $5Cgzr.checkMissingProp)(cxt, schema, missing));
                (0, $5Cgzr.reportMissingProp)(cxt, missing);
                gen.else();
            }
        }
        function loopAllRequired() {
            gen.forOf("prop", schemaCode, (prop)=>{
                cxt.setParams({
                    missingProperty: prop
                });
                gen.if((0, $5Cgzr.noPropertyInData)(gen, data, prop, opts.ownProperties), ()=>cxt.error());
            });
        }
        function loopUntilMissing(missing, valid) {
            cxt.setParams({
                missingProperty: missing
            });
            gen.forOf(missing, schemaCode, ()=>{
                gen.assign(valid, (0, $5Cgzr.propertyInData)(gen, data, missing, opts.ownProperties));
                gen.if((0, $6Vb5F.not)(valid), ()=>{
                    cxt.error();
                    gen.break();
                });
            }, $6Vb5F.nil);
        }
    }
};
module.exports.default = $18b60e7431f4d222$var$def;

});

parcelRequire.register("1CEqr", function(module, exports) {
"use strict";
let $12e8b2bb4dd5f0b1$var$_ = (t)=>t, $12e8b2bb4dd5f0b1$var$t, $12e8b2bb4dd5f0b1$var$t1, $12e8b2bb4dd5f0b1$var$t2;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6Vb5F = parcelRequire("6Vb5F");
const $12e8b2bb4dd5f0b1$var$error = {
    message ({ keyword: keyword, schemaCode: schemaCode }) {
        const comp = keyword === "maxItems" ? "more" : "fewer";
        return (0, $6Vb5F.str)($12e8b2bb4dd5f0b1$var$t || ($12e8b2bb4dd5f0b1$var$t = $12e8b2bb4dd5f0b1$var$_`must NOT have ${0} than ${0} items`), comp, schemaCode);
    },
    params: ({ schemaCode: schemaCode })=>(0, $6Vb5F._)($12e8b2bb4dd5f0b1$var$t1 || ($12e8b2bb4dd5f0b1$var$t1 = $12e8b2bb4dd5f0b1$var$_`{limit: ${0}}`), schemaCode)
};
const $12e8b2bb4dd5f0b1$var$def = {
    keyword: [
        "maxItems",
        "minItems"
    ],
    type: "array",
    schemaType: "number",
    $data: true,
    error: $12e8b2bb4dd5f0b1$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode } = cxt;
        const op = keyword === "maxItems" ? $6Vb5F.operators.GT : $6Vb5F.operators.LT;
        cxt.fail$data((0, $6Vb5F._)($12e8b2bb4dd5f0b1$var$t2 || ($12e8b2bb4dd5f0b1$var$t2 = $12e8b2bb4dd5f0b1$var$_`${0}.length ${0} ${0}`), data, op, schemaCode));
    }
};
module.exports.default = $12e8b2bb4dd5f0b1$var$def;

});

parcelRequire.register("FfFgQ", function(module, exports) {
"use strict";
let $07bffb1fd7e8658d$var$_ = (t)=>t, $07bffb1fd7e8658d$var$t, $07bffb1fd7e8658d$var$t1, $07bffb1fd7e8658d$var$t2, $07bffb1fd7e8658d$var$t3, $07bffb1fd7e8658d$var$t4, $07bffb1fd7e8658d$var$t5, $07bffb1fd7e8658d$var$t6, $07bffb1fd7e8658d$var$t7, $07bffb1fd7e8658d$var$t8, $07bffb1fd7e8658d$var$t9, $07bffb1fd7e8658d$var$t10, $07bffb1fd7e8658d$var$t11, $07bffb1fd7e8658d$var$t12, $07bffb1fd7e8658d$var$t13, $07bffb1fd7e8658d$var$t14, $07bffb1fd7e8658d$var$t15, $07bffb1fd7e8658d$var$t16;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5jmf7 = parcelRequire("5jmf7");

var $6Vb5F = parcelRequire("6Vb5F");

var $k2074 = parcelRequire("k2074");

var $535rz = parcelRequire("535rz");
const $07bffb1fd7e8658d$var$error = {
    message: ({ params: { i: i, j: j } })=>(0, $6Vb5F.str)($07bffb1fd7e8658d$var$t || ($07bffb1fd7e8658d$var$t = $07bffb1fd7e8658d$var$_`must NOT have duplicate items (items ## ${0} and ${0} are identical)`), j, i),
    params: ({ params: { i: i, j: j } })=>(0, $6Vb5F._)($07bffb1fd7e8658d$var$t1 || ($07bffb1fd7e8658d$var$t1 = $07bffb1fd7e8658d$var$_`{i: ${0}, j: ${0}}`), i, j)
};
const $07bffb1fd7e8658d$var$def = {
    keyword: "uniqueItems",
    type: "array",
    schemaType: "boolean",
    $data: true,
    error: $07bffb1fd7e8658d$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schema: schema, parentSchema: parentSchema, schemaCode: schemaCode, it: it } = cxt;
        if (!$data && !schema) return;
        const valid = gen.let("valid");
        const itemTypes = parentSchema.items ? (0, $5jmf7.getSchemaTypes)(parentSchema.items) : [];
        cxt.block$data(valid, validateUniqueItems, (0, $6Vb5F._)($07bffb1fd7e8658d$var$t2 || ($07bffb1fd7e8658d$var$t2 = $07bffb1fd7e8658d$var$_`${0} === false`), schemaCode));
        cxt.ok(valid);
        function validateUniqueItems() {
            const i = gen.let("i", (0, $6Vb5F._)($07bffb1fd7e8658d$var$t3 || ($07bffb1fd7e8658d$var$t3 = $07bffb1fd7e8658d$var$_`${0}.length`), data));
            const j = gen.let("j");
            cxt.setParams({
                i: i,
                j: j
            });
            gen.assign(valid, true);
            gen.if((0, $6Vb5F._)($07bffb1fd7e8658d$var$t4 || ($07bffb1fd7e8658d$var$t4 = $07bffb1fd7e8658d$var$_`${0} > 1`), i), ()=>(canOptimize() ? loopN : loopN2)(i, j));
        }
        function canOptimize() {
            return itemTypes.length > 0 && !itemTypes.some((t)=>t === "object" || t === "array");
        }
        function loopN(i, j) {
            const item = gen.name("item");
            const wrongType = (0, $5jmf7.checkDataTypes)(itemTypes, item, it.opts.strictNumbers, $5jmf7.DataType.Wrong);
            const indices = gen.const("indices", (0, $6Vb5F._)($07bffb1fd7e8658d$var$t5 || ($07bffb1fd7e8658d$var$t5 = $07bffb1fd7e8658d$var$_`{}`)));
            gen.for((0, $6Vb5F._)($07bffb1fd7e8658d$var$t6 || ($07bffb1fd7e8658d$var$t6 = $07bffb1fd7e8658d$var$_`;${0}--;`), i), ()=>{
                gen.let(item, (0, $6Vb5F._)($07bffb1fd7e8658d$var$t7 || ($07bffb1fd7e8658d$var$t7 = $07bffb1fd7e8658d$var$_`${0}[${0}]`), data, i));
                gen.if(wrongType, (0, $6Vb5F._)($07bffb1fd7e8658d$var$t8 || ($07bffb1fd7e8658d$var$t8 = $07bffb1fd7e8658d$var$_`continue`)));
                if (itemTypes.length > 1) gen.if((0, $6Vb5F._)($07bffb1fd7e8658d$var$t9 || ($07bffb1fd7e8658d$var$t9 = $07bffb1fd7e8658d$var$_`typeof ${0} == "string"`), item), (0, $6Vb5F._)($07bffb1fd7e8658d$var$t10 || ($07bffb1fd7e8658d$var$t10 = $07bffb1fd7e8658d$var$_`${0} += "_"`), item));
                gen.if((0, $6Vb5F._)($07bffb1fd7e8658d$var$t11 || ($07bffb1fd7e8658d$var$t11 = $07bffb1fd7e8658d$var$_`typeof ${0}[${0}] == "number"`), indices, item), ()=>{
                    gen.assign(j, (0, $6Vb5F._)($07bffb1fd7e8658d$var$t12 || ($07bffb1fd7e8658d$var$t12 = $07bffb1fd7e8658d$var$_`${0}[${0}]`), indices, item));
                    cxt.error();
                    gen.assign(valid, false).break();
                }).code((0, $6Vb5F._)($07bffb1fd7e8658d$var$t13 || ($07bffb1fd7e8658d$var$t13 = $07bffb1fd7e8658d$var$_`${0}[${0}] = ${0}`), indices, item, i));
            });
        }
        function loopN2(i, j) {
            const eql = (0, $k2074.useFunc)(gen, $535rz.default);
            const outer = gen.name("outer");
            gen.label(outer).for((0, $6Vb5F._)($07bffb1fd7e8658d$var$t14 || ($07bffb1fd7e8658d$var$t14 = $07bffb1fd7e8658d$var$_`;${0}--;`), i), ()=>gen.for((0, $6Vb5F._)($07bffb1fd7e8658d$var$t15 || ($07bffb1fd7e8658d$var$t15 = $07bffb1fd7e8658d$var$_`${0} = ${0}; ${0}--;`), j, i, j), ()=>gen.if((0, $6Vb5F._)($07bffb1fd7e8658d$var$t16 || ($07bffb1fd7e8658d$var$t16 = $07bffb1fd7e8658d$var$_`${0}(${0}[${0}], ${0}[${0}])`), eql, data, i, data, j), ()=>{
                        cxt.error();
                        gen.assign(valid, false).break(outer);
                    })));
        }
    }
};
module.exports.default = $07bffb1fd7e8658d$var$def;

});
parcelRequire.register("535rz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $brcIF = parcelRequire("brcIF");
$brcIF.code = 'require("ajv/dist/runtime/equal").default';
module.exports.default = $brcIF;

});


parcelRequire.register("dK2HK", function(module, exports) {
"use strict";
let $a011ab4d9d5d25d7$var$_ = (t)=>t, $a011ab4d9d5d25d7$var$t, $a011ab4d9d5d25d7$var$t1, $a011ab4d9d5d25d7$var$t2;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6Vb5F = parcelRequire("6Vb5F");

var $k2074 = parcelRequire("k2074");

var $535rz = parcelRequire("535rz");
const $a011ab4d9d5d25d7$var$error = {
    message: "must be equal to constant",
    params: ({ schemaCode: schemaCode })=>(0, $6Vb5F._)($a011ab4d9d5d25d7$var$t || ($a011ab4d9d5d25d7$var$t = $a011ab4d9d5d25d7$var$_`{allowedValue: ${0}}`), schemaCode)
};
const $a011ab4d9d5d25d7$var$def = {
    keyword: "const",
    $data: true,
    error: $a011ab4d9d5d25d7$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schemaCode: schemaCode, schema: schema } = cxt;
        if ($data || schema && typeof schema == "object") cxt.fail$data((0, $6Vb5F._)($a011ab4d9d5d25d7$var$t1 || ($a011ab4d9d5d25d7$var$t1 = $a011ab4d9d5d25d7$var$_`!${0}(${0}, ${0})`), (0, $k2074.useFunc)(gen, $535rz.default), data, schemaCode));
        else cxt.fail((0, $6Vb5F._)($a011ab4d9d5d25d7$var$t2 || ($a011ab4d9d5d25d7$var$t2 = $a011ab4d9d5d25d7$var$_`${0} !== ${0}`), schema, data));
    }
};
module.exports.default = $a011ab4d9d5d25d7$var$def;

});

parcelRequire.register("3MnT0", function(module, exports) {
"use strict";
let $2c0862190808cc11$var$_ = (t)=>t, $2c0862190808cc11$var$t, $2c0862190808cc11$var$t1, $2c0862190808cc11$var$t2, $2c0862190808cc11$var$t3;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6Vb5F = parcelRequire("6Vb5F");

var $k2074 = parcelRequire("k2074");

var $535rz = parcelRequire("535rz");
const $2c0862190808cc11$var$error = {
    message: "must be equal to one of the allowed values",
    params: ({ schemaCode: schemaCode })=>(0, $6Vb5F._)($2c0862190808cc11$var$t || ($2c0862190808cc11$var$t = $2c0862190808cc11$var$_`{allowedValues: ${0}}`), schemaCode)
};
const $2c0862190808cc11$var$def = {
    keyword: "enum",
    schemaType: "array",
    $data: true,
    error: $2c0862190808cc11$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schema: schema, schemaCode: schemaCode, it: it } = cxt;
        if (!$data && schema.length === 0) throw new Error("enum must have non-empty array");
        const useLoop = schema.length >= it.opts.loopEnum;
        let eql;
        const getEql = ()=>eql !== null && eql !== void 0 ? eql : eql = (0, $k2074.useFunc)(gen, $535rz.default);
        let valid;
        if (useLoop || $data) {
            valid = gen.let("valid");
            cxt.block$data(valid, loopEnum);
        } else {
            /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
            const vSchema = gen.const("vSchema", schemaCode);
            valid = (0, $6Vb5F.or)(...schema.map((_x, i)=>equalCode(vSchema, i)));
        }
        cxt.pass(valid);
        function loopEnum() {
            gen.assign(valid, false);
            gen.forOf("v", schemaCode, (v)=>gen.if((0, $6Vb5F._)($2c0862190808cc11$var$t1 || ($2c0862190808cc11$var$t1 = $2c0862190808cc11$var$_`${0}(${0}, ${0})`), getEql(), data, v), ()=>gen.assign(valid, true).break()));
        }
        function equalCode(vSchema, i) {
            const sch = schema[i];
            return typeof sch === "object" && sch !== null ? (0, $6Vb5F._)($2c0862190808cc11$var$t2 || ($2c0862190808cc11$var$t2 = $2c0862190808cc11$var$_`${0}(${0}, ${0}[${0}])`), getEql(), data, vSchema, i) : (0, $6Vb5F._)($2c0862190808cc11$var$t3 || ($2c0862190808cc11$var$t3 = $2c0862190808cc11$var$_`${0} === ${0}`), data, sch);
        }
    }
};
module.exports.default = $2c0862190808cc11$var$def;

});


parcelRequire.register("h2qty", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d9B6h = parcelRequire("d9B6h");

var $ltajn = parcelRequire("ltajn");

var $dVb3N = parcelRequire("dVb3N");

var $2TwKU = parcelRequire("2TwKU");

var $7Dfna = parcelRequire("7Dfna");

var $cLdCl = parcelRequire("cLdCl");

var $8RENI = parcelRequire("8RENI");

var $alimY = parcelRequire("alimY");

var $3DoGS = parcelRequire("3DoGS");

var $athxJ = parcelRequire("athxJ");

var $4rdR8 = parcelRequire("4rdR8");

var $h56cK = parcelRequire("h56cK");

var $f9Qyb = parcelRequire("f9Qyb");

var $4JEQq = parcelRequire("4JEQq");

var $bbzFB = parcelRequire("bbzFB");

var $fgOuR = parcelRequire("fgOuR");
function $c6772914b76f4b58$var$getApplicator(draft2020 = false) {
    const applicator = [
        // any
        $4rdR8.default,
        $h56cK.default,
        $f9Qyb.default,
        $4JEQq.default,
        $bbzFB.default,
        $fgOuR.default,
        // object
        $8RENI.default,
        $alimY.default,
        $cLdCl.default,
        $3DoGS.default,
        $athxJ.default
    ];
    // array
    if (draft2020) applicator.push($ltajn.default, $2TwKU.default);
    else applicator.push($d9B6h.default, $dVb3N.default);
    applicator.push($7Dfna.default);
    return applicator;
}
module.exports.default = $c6772914b76f4b58$var$getApplicator;

});
parcelRequire.register("d9B6h", function(module, exports) {
"use strict";
let $9938e4fed7457934$var$_ = (t)=>t, $9938e4fed7457934$var$t, $9938e4fed7457934$var$t1, $9938e4fed7457934$var$t2, $9938e4fed7457934$var$t3, $9938e4fed7457934$var$t4;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateAdditionalItems = void 0;

var $6Vb5F = parcelRequire("6Vb5F");

var $k2074 = parcelRequire("k2074");
const $9938e4fed7457934$var$error = {
    message: ({ params: { len: len } })=>(0, $6Vb5F.str)($9938e4fed7457934$var$t || ($9938e4fed7457934$var$t = $9938e4fed7457934$var$_`must NOT have more than ${0} items`), len),
    params: ({ params: { len: len } })=>(0, $6Vb5F._)($9938e4fed7457934$var$t1 || ($9938e4fed7457934$var$t1 = $9938e4fed7457934$var$_`{limit: ${0}}`), len)
};
const $9938e4fed7457934$var$def = {
    keyword: "additionalItems",
    type: "array",
    schemaType: [
        "boolean",
        "object"
    ],
    before: "uniqueItems",
    error: $9938e4fed7457934$var$error,
    code (cxt) {
        const { parentSchema: parentSchema, it: it } = cxt;
        const { items: items } = parentSchema;
        if (!Array.isArray(items)) {
            (0, $k2074.checkStrictMode)(it, '"additionalItems" is ignored when "items" is not an array of schemas');
            return;
        }
        $9938e4fed7457934$var$validateAdditionalItems(cxt, items);
    }
};
function $9938e4fed7457934$var$validateAdditionalItems(cxt, items) {
    const { gen: gen, schema: schema, data: data, keyword: keyword, it: it } = cxt;
    it.items = true;
    const len = gen.const("len", (0, $6Vb5F._)($9938e4fed7457934$var$t2 || ($9938e4fed7457934$var$t2 = $9938e4fed7457934$var$_`${0}.length`), data));
    if (schema === false) {
        cxt.setParams({
            len: items.length
        });
        cxt.pass((0, $6Vb5F._)($9938e4fed7457934$var$t3 || ($9938e4fed7457934$var$t3 = $9938e4fed7457934$var$_`${0} <= ${0}`), len, items.length));
    } else if (typeof schema == "object" && !(0, $k2074.alwaysValidSchema)(it, schema)) {
        const valid = gen.var("valid", (0, $6Vb5F._)($9938e4fed7457934$var$t4 || ($9938e4fed7457934$var$t4 = $9938e4fed7457934$var$_`${0} <= ${0}`), len, items.length)); // TODO var
        gen.if((0, $6Vb5F.not)(valid), ()=>validateItems(valid));
        cxt.ok(valid);
    }
    function validateItems(valid) {
        gen.forRange("i", items.length, len, (i)=>{
            cxt.subschema({
                keyword: keyword,
                dataProp: i,
                dataPropType: $k2074.Type.Num
            }, valid);
            if (!it.allErrors) gen.if((0, $6Vb5F.not)(valid), ()=>gen.break());
        });
    }
}
module.exports.validateAdditionalItems = $9938e4fed7457934$var$validateAdditionalItems;
module.exports.default = $9938e4fed7457934$var$def;

});

parcelRequire.register("ltajn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dVb3N = parcelRequire("dVb3N");
const $fa144e0f3948ed3d$var$def = {
    keyword: "prefixItems",
    type: "array",
    schemaType: [
        "array"
    ],
    before: "uniqueItems",
    code: (cxt)=>(0, $dVb3N.validateTuple)(cxt, "items")
};
module.exports.default = $fa144e0f3948ed3d$var$def;

});
parcelRequire.register("dVb3N", function(module, exports) {
"use strict";
let $a2292d934957567e$var$_ = (t)=>t, $a2292d934957567e$var$t, $a2292d934957567e$var$t1;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateTuple = void 0;

var $6Vb5F = parcelRequire("6Vb5F");

var $k2074 = parcelRequire("k2074");

var $5Cgzr = parcelRequire("5Cgzr");
const $a2292d934957567e$var$def = {
    keyword: "items",
    type: "array",
    schemaType: [
        "object",
        "array",
        "boolean"
    ],
    before: "uniqueItems",
    code (cxt) {
        const { schema: schema, it: it } = cxt;
        if (Array.isArray(schema)) return $a2292d934957567e$var$validateTuple(cxt, "additionalItems", schema);
        it.items = true;
        if ((0, $k2074.alwaysValidSchema)(it, schema)) return;
        cxt.ok((0, $5Cgzr.validateArray)(cxt));
    }
};
function $a2292d934957567e$var$validateTuple(cxt, extraItems, schArr = cxt.schema) {
    const { gen: gen, parentSchema: parentSchema, data: data, keyword: keyword, it: it } = cxt;
    checkStrictTuple(parentSchema);
    if (it.opts.unevaluated && schArr.length && it.items !== true) it.items = $k2074.mergeEvaluated.items(gen, schArr.length, it.items);
    const valid = gen.name("valid");
    const len = gen.const("len", (0, $6Vb5F._)($a2292d934957567e$var$t || ($a2292d934957567e$var$t = $a2292d934957567e$var$_`${0}.length`), data));
    schArr.forEach((sch, i)=>{
        if ((0, $k2074.alwaysValidSchema)(it, sch)) return;
        gen.if((0, $6Vb5F._)($a2292d934957567e$var$t1 || ($a2292d934957567e$var$t1 = $a2292d934957567e$var$_`${0} > ${0}`), len, i), ()=>cxt.subschema({
                keyword: keyword,
                schemaProp: i,
                dataProp: i
            }, valid));
        cxt.ok(valid);
    });
    function checkStrictTuple(sch) {
        const { opts: opts, errSchemaPath: errSchemaPath } = it;
        const l = schArr.length;
        const fullTuple = l === sch.minItems && (l === sch.maxItems || sch[extraItems] === false);
        if (opts.strictTuples && !fullTuple) {
            const msg = `"${keyword}" is ${l}-tuple, but minItems or maxItems/${extraItems} are not specified or different at path "${errSchemaPath}"`;
            (0, $k2074.checkStrictMode)(it, msg, opts.strictTuples);
        }
    }
}
module.exports.validateTuple = $a2292d934957567e$var$validateTuple;
module.exports.default = $a2292d934957567e$var$def;

});


parcelRequire.register("2TwKU", function(module, exports) {
"use strict";
let $21ba206a75a98c5f$var$_ = (t)=>t, $21ba206a75a98c5f$var$t, $21ba206a75a98c5f$var$t1;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6Vb5F = parcelRequire("6Vb5F");

var $k2074 = parcelRequire("k2074");

var $5Cgzr = parcelRequire("5Cgzr");

var $d9B6h = parcelRequire("d9B6h");
const $21ba206a75a98c5f$var$error = {
    message: ({ params: { len: len } })=>(0, $6Vb5F.str)($21ba206a75a98c5f$var$t || ($21ba206a75a98c5f$var$t = $21ba206a75a98c5f$var$_`must NOT have more than ${0} items`), len),
    params: ({ params: { len: len } })=>(0, $6Vb5F._)($21ba206a75a98c5f$var$t1 || ($21ba206a75a98c5f$var$t1 = $21ba206a75a98c5f$var$_`{limit: ${0}}`), len)
};
const $21ba206a75a98c5f$var$def = {
    keyword: "items",
    type: "array",
    schemaType: [
        "object",
        "boolean"
    ],
    before: "uniqueItems",
    error: $21ba206a75a98c5f$var$error,
    code (cxt) {
        const { schema: schema, parentSchema: parentSchema, it: it } = cxt;
        const { prefixItems: prefixItems } = parentSchema;
        it.items = true;
        if ((0, $k2074.alwaysValidSchema)(it, schema)) return;
        if (prefixItems) (0, $d9B6h.validateAdditionalItems)(cxt, prefixItems);
        else cxt.ok((0, $5Cgzr.validateArray)(cxt));
    }
};
module.exports.default = $21ba206a75a98c5f$var$def;

});

parcelRequire.register("7Dfna", function(module, exports) {
"use strict";
let $58e819a2e5ad8af0$var$_ = (t)=>t, $58e819a2e5ad8af0$var$t, $58e819a2e5ad8af0$var$t1, $58e819a2e5ad8af0$var$t2, $58e819a2e5ad8af0$var$t3, $58e819a2e5ad8af0$var$t4, $58e819a2e5ad8af0$var$t5, $58e819a2e5ad8af0$var$t6, $58e819a2e5ad8af0$var$t7, $58e819a2e5ad8af0$var$t8, $58e819a2e5ad8af0$var$t9, $58e819a2e5ad8af0$var$t10, $58e819a2e5ad8af0$var$t11;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6Vb5F = parcelRequire("6Vb5F");

var $k2074 = parcelRequire("k2074");
const $58e819a2e5ad8af0$var$error = {
    message: ({ params: { min: min, max: max } })=>max === undefined ? (0, $6Vb5F.str)($58e819a2e5ad8af0$var$t || ($58e819a2e5ad8af0$var$t = $58e819a2e5ad8af0$var$_`must contain at least ${0} valid item(s)`), min) : (0, $6Vb5F.str)($58e819a2e5ad8af0$var$t1 || ($58e819a2e5ad8af0$var$t1 = $58e819a2e5ad8af0$var$_`must contain at least ${0} and no more than ${0} valid item(s)`), min, max),
    params: ({ params: { min: min, max: max } })=>max === undefined ? (0, $6Vb5F._)($58e819a2e5ad8af0$var$t2 || ($58e819a2e5ad8af0$var$t2 = $58e819a2e5ad8af0$var$_`{minContains: ${0}}`), min) : (0, $6Vb5F._)($58e819a2e5ad8af0$var$t3 || ($58e819a2e5ad8af0$var$t3 = $58e819a2e5ad8af0$var$_`{minContains: ${0}, maxContains: ${0}}`), min, max)
};
const $58e819a2e5ad8af0$var$def = {
    keyword: "contains",
    type: "array",
    schemaType: [
        "object",
        "boolean"
    ],
    before: "uniqueItems",
    trackErrors: true,
    error: $58e819a2e5ad8af0$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, data: data, it: it } = cxt;
        let min;
        let max;
        const { minContains: minContains, maxContains: maxContains } = parentSchema;
        if (it.opts.next) {
            min = minContains === undefined ? 1 : minContains;
            max = maxContains;
        } else min = 1;
        const len = gen.const("len", (0, $6Vb5F._)($58e819a2e5ad8af0$var$t4 || ($58e819a2e5ad8af0$var$t4 = $58e819a2e5ad8af0$var$_`${0}.length`), data));
        cxt.setParams({
            min: min,
            max: max
        });
        if (max === undefined && min === 0) {
            (0, $k2074.checkStrictMode)(it, `"minContains" == 0 without "maxContains": "contains" keyword ignored`);
            return;
        }
        if (max !== undefined && min > max) {
            (0, $k2074.checkStrictMode)(it, `"minContains" > "maxContains" is always invalid`);
            cxt.fail();
            return;
        }
        if ((0, $k2074.alwaysValidSchema)(it, schema)) {
            let cond = (0, $6Vb5F._)($58e819a2e5ad8af0$var$t5 || ($58e819a2e5ad8af0$var$t5 = $58e819a2e5ad8af0$var$_`${0} >= ${0}`), len, min);
            if (max !== undefined) cond = (0, $6Vb5F._)($58e819a2e5ad8af0$var$t6 || ($58e819a2e5ad8af0$var$t6 = $58e819a2e5ad8af0$var$_`${0} && ${0} <= ${0}`), cond, len, max);
            cxt.pass(cond);
            return;
        }
        it.items = true;
        const valid = gen.name("valid");
        if (max === undefined && min === 1) validateItems(valid, ()=>gen.if(valid, ()=>gen.break()));
        else if (min === 0) {
            gen.let(valid, true);
            if (max !== undefined) gen.if((0, $6Vb5F._)($58e819a2e5ad8af0$var$t7 || ($58e819a2e5ad8af0$var$t7 = $58e819a2e5ad8af0$var$_`${0}.length > 0`), data), validateItemsWithCount);
        } else {
            gen.let(valid, false);
            validateItemsWithCount();
        }
        cxt.result(valid, ()=>cxt.reset());
        function validateItemsWithCount() {
            const schValid = gen.name("_valid");
            const count = gen.let("count", 0);
            validateItems(schValid, ()=>gen.if(schValid, ()=>checkLimits(count)));
        }
        function validateItems(_valid, block) {
            gen.forRange("i", 0, len, (i)=>{
                cxt.subschema({
                    keyword: "contains",
                    dataProp: i,
                    dataPropType: $k2074.Type.Num,
                    compositeRule: true
                }, _valid);
                block();
            });
        }
        function checkLimits(count) {
            gen.code((0, $6Vb5F._)($58e819a2e5ad8af0$var$t8 || ($58e819a2e5ad8af0$var$t8 = $58e819a2e5ad8af0$var$_`${0}++`), count));
            if (max === undefined) gen.if((0, $6Vb5F._)($58e819a2e5ad8af0$var$t9 || ($58e819a2e5ad8af0$var$t9 = $58e819a2e5ad8af0$var$_`${0} >= ${0}`), count, min), ()=>gen.assign(valid, true).break());
            else {
                gen.if((0, $6Vb5F._)($58e819a2e5ad8af0$var$t10 || ($58e819a2e5ad8af0$var$t10 = $58e819a2e5ad8af0$var$_`${0} > ${0}`), count, max), ()=>gen.assign(valid, false).break());
                if (min === 1) gen.assign(valid, true);
                else gen.if((0, $6Vb5F._)($58e819a2e5ad8af0$var$t11 || ($58e819a2e5ad8af0$var$t11 = $58e819a2e5ad8af0$var$_`${0} >= ${0}`), count, min), ()=>gen.assign(valid, true));
            }
        }
    }
};
module.exports.default = $58e819a2e5ad8af0$var$def;

});

parcelRequire.register("cLdCl", function(module, exports) {
"use strict";
let $94a46ff6e9501a50$var$_ = (t)=>t, $94a46ff6e9501a50$var$t, $94a46ff6e9501a50$var$t1, $94a46ff6e9501a50$var$t2;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateSchemaDeps = module.exports.validatePropertyDeps = module.exports.error = void 0;

var $6Vb5F = parcelRequire("6Vb5F");

var $k2074 = parcelRequire("k2074");

var $5Cgzr = parcelRequire("5Cgzr");
module.exports.error = {
    message: ({ params: { property: property, depsCount: depsCount, deps: deps } })=>{
        const property_ies = depsCount === 1 ? "property" : "properties";
        return (0, $6Vb5F.str)($94a46ff6e9501a50$var$t || ($94a46ff6e9501a50$var$t = $94a46ff6e9501a50$var$_`must have ${0} ${0} when property ${0} is present`), property_ies, deps, property);
    },
    params: ({ params: { property: property, depsCount: depsCount, deps: deps, missingProperty: missingProperty } })=>(0, $6Vb5F._)($94a46ff6e9501a50$var$t1 || ($94a46ff6e9501a50$var$t1 = $94a46ff6e9501a50$var$_`{property: ${0},
    missingProperty: ${0},
    depsCount: ${0},
    deps: ${0}}`), property, missingProperty, depsCount, deps)
};
const $94a46ff6e9501a50$var$def = {
    keyword: "dependencies",
    type: "object",
    schemaType: "object",
    error: module.exports.error,
    code (cxt) {
        const [propDeps, schDeps] = $94a46ff6e9501a50$var$splitDependencies(cxt);
        $94a46ff6e9501a50$var$validatePropertyDeps(cxt, propDeps);
        $94a46ff6e9501a50$var$validateSchemaDeps(cxt, schDeps);
    }
};
function $94a46ff6e9501a50$var$splitDependencies({ schema: schema }) {
    const propertyDeps = {};
    const schemaDeps = {};
    for(const key in schema){
        if (key === "__proto__") continue;
        const deps = Array.isArray(schema[key]) ? propertyDeps : schemaDeps;
        deps[key] = schema[key];
    }
    return [
        propertyDeps,
        schemaDeps
    ];
}
function $94a46ff6e9501a50$var$validatePropertyDeps(cxt, propertyDeps = cxt.schema) {
    const { gen: gen, data: data, it: it } = cxt;
    if (Object.keys(propertyDeps).length === 0) return;
    const missing = gen.let("missing");
    for(const prop in propertyDeps){
        const deps = propertyDeps[prop];
        if (deps.length === 0) continue;
        const hasProperty = (0, $5Cgzr.propertyInData)(gen, data, prop, it.opts.ownProperties);
        cxt.setParams({
            property: prop,
            depsCount: deps.length,
            deps: deps.join(", ")
        });
        if (it.allErrors) gen.if(hasProperty, ()=>{
            for (const depProp of deps)(0, $5Cgzr.checkReportMissingProp)(cxt, depProp);
        });
        else {
            gen.if((0, $6Vb5F._)($94a46ff6e9501a50$var$t2 || ($94a46ff6e9501a50$var$t2 = $94a46ff6e9501a50$var$_`${0} && (${0})`), hasProperty, (0, $5Cgzr.checkMissingProp)(cxt, deps, missing)));
            (0, $5Cgzr.reportMissingProp)(cxt, missing);
            gen.else();
        }
    }
}
module.exports.validatePropertyDeps = $94a46ff6e9501a50$var$validatePropertyDeps;
function $94a46ff6e9501a50$var$validateSchemaDeps(cxt, schemaDeps = cxt.schema) {
    const { gen: gen, data: data, keyword: keyword, it: it } = cxt;
    const valid = gen.name("valid");
    for(const prop in schemaDeps){
        if ((0, $k2074.alwaysValidSchema)(it, schemaDeps[prop])) continue;
        gen.if((0, $5Cgzr.propertyInData)(gen, data, prop, it.opts.ownProperties), ()=>{
            const schCxt = cxt.subschema({
                keyword: keyword,
                schemaProp: prop
            }, valid);
            cxt.mergeValidEvaluated(schCxt, valid);
        }, ()=>gen.var(valid, true) // TODO var
        );
        cxt.ok(valid);
    }
}
module.exports.validateSchemaDeps = $94a46ff6e9501a50$var$validateSchemaDeps;
module.exports.default = $94a46ff6e9501a50$var$def;

});

parcelRequire.register("8RENI", function(module, exports) {
"use strict";
let $6742ec28638d8ed5$var$_ = (t)=>t, $6742ec28638d8ed5$var$t;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6Vb5F = parcelRequire("6Vb5F");

var $k2074 = parcelRequire("k2074");
const $6742ec28638d8ed5$var$error = {
    message: "property name must be valid",
    params: ({ params: params })=>(0, $6Vb5F._)($6742ec28638d8ed5$var$t || ($6742ec28638d8ed5$var$t = $6742ec28638d8ed5$var$_`{propertyName: ${0}}`), params.propertyName)
};
const $6742ec28638d8ed5$var$def = {
    keyword: "propertyNames",
    type: "object",
    schemaType: [
        "object",
        "boolean"
    ],
    error: $6742ec28638d8ed5$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, data: data, it: it } = cxt;
        if ((0, $k2074.alwaysValidSchema)(it, schema)) return;
        const valid = gen.name("valid");
        gen.forIn("key", data, (key)=>{
            cxt.setParams({
                propertyName: key
            });
            cxt.subschema({
                keyword: "propertyNames",
                data: key,
                dataTypes: [
                    "string"
                ],
                propertyName: key,
                compositeRule: true
            }, valid);
            gen.if((0, $6Vb5F.not)(valid), ()=>{
                cxt.error(true);
                if (!it.allErrors) gen.break();
            });
        });
        cxt.ok(valid);
    }
};
module.exports.default = $6742ec28638d8ed5$var$def;

});

parcelRequire.register("alimY", function(module, exports) {
"use strict";
let $787a1d5d2215ebf7$var$_ = (t)=>t, $787a1d5d2215ebf7$var$t, $787a1d5d2215ebf7$var$t1, $787a1d5d2215ebf7$var$t2, $787a1d5d2215ebf7$var$t3, $787a1d5d2215ebf7$var$t4;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5Cgzr = parcelRequire("5Cgzr");

var $6Vb5F = parcelRequire("6Vb5F");

var $eXNSw = parcelRequire("eXNSw");

var $k2074 = parcelRequire("k2074");
const $787a1d5d2215ebf7$var$error = {
    message: "must NOT have additional properties",
    params: ({ params: params })=>(0, $6Vb5F._)($787a1d5d2215ebf7$var$t || ($787a1d5d2215ebf7$var$t = $787a1d5d2215ebf7$var$_`{additionalProperty: ${0}}`), params.additionalProperty)
};
const $787a1d5d2215ebf7$var$def = {
    keyword: "additionalProperties",
    type: [
        "object"
    ],
    schemaType: [
        "boolean",
        "object"
    ],
    allowUndefined: true,
    trackErrors: true,
    error: $787a1d5d2215ebf7$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, data: data, errsCount: errsCount, it: it } = cxt;
        /* istanbul ignore if */ if (!errsCount) throw new Error("ajv implementation error");
        const { allErrors: allErrors, opts: opts } = it;
        it.props = true;
        if (opts.removeAdditional !== "all" && (0, $k2074.alwaysValidSchema)(it, schema)) return;
        const props = (0, $5Cgzr.allSchemaProperties)(parentSchema.properties);
        const patProps = (0, $5Cgzr.allSchemaProperties)(parentSchema.patternProperties);
        checkAdditionalProperties();
        cxt.ok((0, $6Vb5F._)($787a1d5d2215ebf7$var$t1 || ($787a1d5d2215ebf7$var$t1 = $787a1d5d2215ebf7$var$_`${0} === ${0}`), errsCount, $eXNSw.default.errors));
        function checkAdditionalProperties() {
            gen.forIn("key", data, (key)=>{
                if (!props.length && !patProps.length) additionalPropertyCode(key);
                else gen.if(isAdditional(key), ()=>additionalPropertyCode(key));
            });
        }
        function isAdditional(key) {
            let definedProp;
            if (props.length > 8) {
                // TODO maybe an option instead of hard-coded 8?
                const propsSchema = (0, $k2074.schemaRefOrVal)(it, parentSchema.properties, "properties");
                definedProp = (0, $5Cgzr.isOwnProperty)(gen, propsSchema, key);
            } else if (props.length) definedProp = (0, $6Vb5F.or)(...props.map((p)=>(0, $6Vb5F._)($787a1d5d2215ebf7$var$t2 || ($787a1d5d2215ebf7$var$t2 = $787a1d5d2215ebf7$var$_`${0} === ${0}`), key, p)));
            else definedProp = $6Vb5F.nil;
            if (patProps.length) definedProp = (0, $6Vb5F.or)(definedProp, ...patProps.map((p)=>(0, $6Vb5F._)($787a1d5d2215ebf7$var$t3 || ($787a1d5d2215ebf7$var$t3 = $787a1d5d2215ebf7$var$_`${0}.test(${0})`), (0, $5Cgzr.usePattern)(cxt, p), key)));
            return (0, $6Vb5F.not)(definedProp);
        }
        function deleteAdditional(key) {
            gen.code((0, $6Vb5F._)($787a1d5d2215ebf7$var$t4 || ($787a1d5d2215ebf7$var$t4 = $787a1d5d2215ebf7$var$_`delete ${0}[${0}]`), data, key));
        }
        function additionalPropertyCode(key) {
            if (opts.removeAdditional === "all" || opts.removeAdditional && schema === false) {
                deleteAdditional(key);
                return;
            }
            if (schema === false) {
                cxt.setParams({
                    additionalProperty: key
                });
                cxt.error();
                if (!allErrors) gen.break();
                return;
            }
            if (typeof schema == "object" && !(0, $k2074.alwaysValidSchema)(it, schema)) {
                const valid = gen.name("valid");
                if (opts.removeAdditional === "failing") {
                    applyAdditionalSchema(key, valid, false);
                    gen.if((0, $6Vb5F.not)(valid), ()=>{
                        cxt.reset();
                        deleteAdditional(key);
                    });
                } else {
                    applyAdditionalSchema(key, valid);
                    if (!allErrors) gen.if((0, $6Vb5F.not)(valid), ()=>gen.break());
                }
            }
        }
        function applyAdditionalSchema(key, valid, errors) {
            const subschema = {
                keyword: "additionalProperties",
                dataProp: key,
                dataPropType: $k2074.Type.Str
            };
            if (errors === false) Object.assign(subschema, {
                compositeRule: true,
                createErrors: false,
                allErrors: false
            });
            cxt.subschema(subschema, valid);
        }
    }
};
module.exports.default = $787a1d5d2215ebf7$var$def;

});

parcelRequire.register("3DoGS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6DSbS = parcelRequire("6DSbS");

var $5Cgzr = parcelRequire("5Cgzr");

var $k2074 = parcelRequire("k2074");

var $alimY = parcelRequire("alimY");
const $2a582aa1cd1711e2$var$def = {
    keyword: "properties",
    type: "object",
    schemaType: "object",
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, data: data, it: it } = cxt;
        if (it.opts.removeAdditional === "all" && parentSchema.additionalProperties === undefined) $alimY.default.code(new $6DSbS.KeywordCxt(it, $alimY.default, "additionalProperties"));
        const allProps = (0, $5Cgzr.allSchemaProperties)(schema);
        for (const prop of allProps)it.definedProperties.add(prop);
        if (it.opts.unevaluated && allProps.length && it.props !== true) it.props = $k2074.mergeEvaluated.props(gen, (0, $k2074.toHash)(allProps), it.props);
        const properties = allProps.filter((p)=>!(0, $k2074.alwaysValidSchema)(it, schema[p]));
        if (properties.length === 0) return;
        const valid = gen.name("valid");
        for (const prop of properties){
            if (hasDefault(prop)) applyPropertySchema(prop);
            else {
                gen.if((0, $5Cgzr.propertyInData)(gen, data, prop, it.opts.ownProperties));
                applyPropertySchema(prop);
                if (!it.allErrors) gen.else().var(valid, true);
                gen.endIf();
            }
            cxt.it.definedProperties.add(prop);
            cxt.ok(valid);
        }
        function hasDefault(prop) {
            return it.opts.useDefaults && !it.compositeRule && schema[prop].default !== undefined;
        }
        function applyPropertySchema(prop) {
            cxt.subschema({
                keyword: "properties",
                schemaProp: prop,
                dataProp: prop
            }, valid);
        }
    }
};
module.exports.default = $2a582aa1cd1711e2$var$def;

});

parcelRequire.register("athxJ", function(module, exports) {
"use strict";
let $79fa38858d191b6b$var$_ = (t)=>t, $79fa38858d191b6b$var$t, $79fa38858d191b6b$var$t1;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5Cgzr = parcelRequire("5Cgzr");

var $6Vb5F = parcelRequire("6Vb5F");

var $k2074 = parcelRequire("k2074");

var $k2074 = parcelRequire("k2074");
const $79fa38858d191b6b$var$def = {
    keyword: "patternProperties",
    type: "object",
    schemaType: "object",
    code (cxt) {
        const { gen: gen, schema: schema, data: data, parentSchema: parentSchema, it: it } = cxt;
        const { opts: opts } = it;
        const patterns = (0, $5Cgzr.allSchemaProperties)(schema);
        const alwaysValidPatterns = patterns.filter((p)=>(0, $k2074.alwaysValidSchema)(it, schema[p]));
        if (patterns.length === 0 || alwaysValidPatterns.length === patterns.length && (!it.opts.unevaluated || it.props === true)) return;
        const checkProperties = opts.strictSchema && !opts.allowMatchingProperties && parentSchema.properties;
        const valid = gen.name("valid");
        if (it.props !== true && !(it.props instanceof $6Vb5F.Name)) it.props = (0, $k2074.evaluatedPropsToName)(gen, it.props);
        const { props: props } = it;
        validatePatternProperties();
        function validatePatternProperties() {
            for (const pat of patterns){
                if (checkProperties) checkMatchingProperties(pat);
                if (it.allErrors) validateProperties(pat);
                else {
                    gen.var(valid, true); // TODO var
                    validateProperties(pat);
                    gen.if(valid);
                }
            }
        }
        function checkMatchingProperties(pat) {
            for(const prop in checkProperties)if (new RegExp(pat).test(prop)) (0, $k2074.checkStrictMode)(it, `property ${prop} matches pattern ${pat} (use allowMatchingProperties)`);
        }
        function validateProperties(pat) {
            gen.forIn("key", data, (key)=>{
                gen.if((0, $6Vb5F._)($79fa38858d191b6b$var$t || ($79fa38858d191b6b$var$t = $79fa38858d191b6b$var$_`${0}.test(${0})`), (0, $5Cgzr.usePattern)(cxt, pat), key), ()=>{
                    const alwaysValid = alwaysValidPatterns.includes(pat);
                    if (!alwaysValid) cxt.subschema({
                        keyword: "patternProperties",
                        schemaProp: pat,
                        dataProp: key,
                        dataPropType: $k2074.Type.Str
                    }, valid);
                    if (it.opts.unevaluated && props !== true) gen.assign((0, $6Vb5F._)($79fa38858d191b6b$var$t1 || ($79fa38858d191b6b$var$t1 = $79fa38858d191b6b$var$_`${0}[${0}]`), props, key), true);
                    else if (!alwaysValid && !it.allErrors) // can short-circuit if `unevaluatedProperties` is not supported (opts.next === false)
                    // or if all properties were evaluated (props === true)
                    gen.if((0, $6Vb5F.not)(valid), ()=>gen.break());
                });
            });
        }
    }
};
module.exports.default = $79fa38858d191b6b$var$def;

});

parcelRequire.register("4rdR8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $k2074 = parcelRequire("k2074");
const $33b46e8e98abb996$var$def = {
    keyword: "not",
    schemaType: [
        "object",
        "boolean"
    ],
    trackErrors: true,
    code (cxt) {
        const { gen: gen, schema: schema, it: it } = cxt;
        if ((0, $k2074.alwaysValidSchema)(it, schema)) {
            cxt.fail();
            return;
        }
        const valid = gen.name("valid");
        cxt.subschema({
            keyword: "not",
            compositeRule: true,
            createErrors: false,
            allErrors: false
        }, valid);
        cxt.failResult(valid, ()=>cxt.reset(), ()=>cxt.error());
    },
    error: {
        message: "must NOT be valid"
    }
};
module.exports.default = $33b46e8e98abb996$var$def;

});

parcelRequire.register("h56cK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5Cgzr = parcelRequire("5Cgzr");
const $c6f7b766dd45085c$var$def = {
    keyword: "anyOf",
    schemaType: "array",
    trackErrors: true,
    code: $5Cgzr.validateUnion,
    error: {
        message: "must match a schema in anyOf"
    }
};
module.exports.default = $c6f7b766dd45085c$var$def;

});

parcelRequire.register("f9Qyb", function(module, exports) {
"use strict";
let $b09075af1ba9f81e$var$_ = (t)=>t, $b09075af1ba9f81e$var$t, $b09075af1ba9f81e$var$t1, $b09075af1ba9f81e$var$t2;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6Vb5F = parcelRequire("6Vb5F");

var $k2074 = parcelRequire("k2074");
const $b09075af1ba9f81e$var$error = {
    message: "must match exactly one schema in oneOf",
    params: ({ params: params })=>(0, $6Vb5F._)($b09075af1ba9f81e$var$t || ($b09075af1ba9f81e$var$t = $b09075af1ba9f81e$var$_`{passingSchemas: ${0}}`), params.passing)
};
const $b09075af1ba9f81e$var$def = {
    keyword: "oneOf",
    schemaType: "array",
    trackErrors: true,
    error: $b09075af1ba9f81e$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, it: it } = cxt;
        /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
        if (it.opts.discriminator && parentSchema.discriminator) return;
        const schArr = schema;
        const valid = gen.let("valid", false);
        const passing = gen.let("passing", null);
        const schValid = gen.name("_valid");
        cxt.setParams({
            passing: passing
        });
        // TODO possibly fail straight away (with warning or exception) if there are two empty always valid schemas
        gen.block(validateOneOf);
        cxt.result(valid, ()=>cxt.reset(), ()=>cxt.error(true));
        function validateOneOf() {
            schArr.forEach((sch, i)=>{
                let schCxt;
                if ((0, $k2074.alwaysValidSchema)(it, sch)) gen.var(schValid, true);
                else schCxt = cxt.subschema({
                    keyword: "oneOf",
                    schemaProp: i,
                    compositeRule: true
                }, schValid);
                if (i > 0) gen.if((0, $6Vb5F._)($b09075af1ba9f81e$var$t1 || ($b09075af1ba9f81e$var$t1 = $b09075af1ba9f81e$var$_`${0} && ${0}`), schValid, valid)).assign(valid, false).assign(passing, (0, $6Vb5F._)($b09075af1ba9f81e$var$t2 || ($b09075af1ba9f81e$var$t2 = $b09075af1ba9f81e$var$_`[${0}, ${0}]`), passing, i)).else();
                gen.if(schValid, ()=>{
                    gen.assign(valid, true);
                    gen.assign(passing, i);
                    if (schCxt) cxt.mergeEvaluated(schCxt, $6Vb5F.Name);
                });
            });
        }
    }
};
module.exports.default = $b09075af1ba9f81e$var$def;

});

parcelRequire.register("4JEQq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $k2074 = parcelRequire("k2074");
const $372b0c45e23994ab$var$def = {
    keyword: "allOf",
    schemaType: "array",
    code (cxt) {
        const { gen: gen, schema: schema, it: it } = cxt;
        /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
        const valid = gen.name("valid");
        schema.forEach((sch, i)=>{
            if ((0, $k2074.alwaysValidSchema)(it, sch)) return;
            const schCxt = cxt.subschema({
                keyword: "allOf",
                schemaProp: i
            }, valid);
            cxt.ok(valid);
            cxt.mergeEvaluated(schCxt);
        });
    }
};
module.exports.default = $372b0c45e23994ab$var$def;

});

parcelRequire.register("bbzFB", function(module, exports) {
"use strict";
let $824c64174dfeeb93$var$_ = (t)=>t, $824c64174dfeeb93$var$t, $824c64174dfeeb93$var$t1, $824c64174dfeeb93$var$t2;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6Vb5F = parcelRequire("6Vb5F");

var $k2074 = parcelRequire("k2074");
const $824c64174dfeeb93$var$error = {
    message: ({ params: params })=>(0, $6Vb5F.str)($824c64174dfeeb93$var$t || ($824c64174dfeeb93$var$t = $824c64174dfeeb93$var$_`must match "${0}" schema`), params.ifClause),
    params: ({ params: params })=>(0, $6Vb5F._)($824c64174dfeeb93$var$t1 || ($824c64174dfeeb93$var$t1 = $824c64174dfeeb93$var$_`{failingKeyword: ${0}}`), params.ifClause)
};
const $824c64174dfeeb93$var$def = {
    keyword: "if",
    schemaType: [
        "object",
        "boolean"
    ],
    trackErrors: true,
    error: $824c64174dfeeb93$var$error,
    code (cxt) {
        const { gen: gen, parentSchema: parentSchema, it: it } = cxt;
        if (parentSchema.then === undefined && parentSchema.else === undefined) (0, $k2074.checkStrictMode)(it, '"if" without "then" and "else" is ignored');
        const hasThen = $824c64174dfeeb93$var$hasSchema(it, "then");
        const hasElse = $824c64174dfeeb93$var$hasSchema(it, "else");
        if (!hasThen && !hasElse) return;
        const valid = gen.let("valid", true);
        const schValid = gen.name("_valid");
        validateIf();
        cxt.reset();
        if (hasThen && hasElse) {
            const ifClause = gen.let("ifClause");
            cxt.setParams({
                ifClause: ifClause
            });
            gen.if(schValid, validateClause("then", ifClause), validateClause("else", ifClause));
        } else if (hasThen) gen.if(schValid, validateClause("then"));
        else gen.if((0, $6Vb5F.not)(schValid), validateClause("else"));
        cxt.pass(valid, ()=>cxt.error(true));
        function validateIf() {
            const schCxt = cxt.subschema({
                keyword: "if",
                compositeRule: true,
                createErrors: false,
                allErrors: false
            }, schValid);
            cxt.mergeEvaluated(schCxt);
        }
        function validateClause(keyword, ifClause) {
            return ()=>{
                const schCxt = cxt.subschema({
                    keyword: keyword
                }, schValid);
                gen.assign(valid, schValid);
                cxt.mergeValidEvaluated(schCxt, valid);
                if (ifClause) gen.assign(ifClause, (0, $6Vb5F._)($824c64174dfeeb93$var$t2 || ($824c64174dfeeb93$var$t2 = $824c64174dfeeb93$var$_`${0}`), keyword));
                else cxt.setParams({
                    ifClause: keyword
                });
            };
        }
    }
};
function $824c64174dfeeb93$var$hasSchema(it, keyword) {
    const schema = it.schema[keyword];
    return schema !== undefined && !(0, $k2074.alwaysValidSchema)(it, schema);
}
module.exports.default = $824c64174dfeeb93$var$def;

});

parcelRequire.register("fgOuR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $k2074 = parcelRequire("k2074");
const $b1df853a8fe51a60$var$def = {
    keyword: [
        "then",
        "else"
    ],
    schemaType: [
        "object",
        "boolean"
    ],
    code ({ keyword: keyword, parentSchema: parentSchema, it: it }) {
        if (parentSchema.if === undefined) (0, $k2074.checkStrictMode)(it, `"${keyword}" without "if" is ignored`);
    }
};
module.exports.default = $b1df853a8fe51a60$var$def;

});


parcelRequire.register("o75Mp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2rXj1 = parcelRequire("2rXj1");
const $0487be5f98a50e29$var$format = [
    $2rXj1.default
];
module.exports.default = $0487be5f98a50e29$var$format;

});
parcelRequire.register("2rXj1", function(module, exports) {
"use strict";
let $1c8c1b4d975160a6$var$_ = (t)=>t, $1c8c1b4d975160a6$var$t, $1c8c1b4d975160a6$var$t1, $1c8c1b4d975160a6$var$t2, $1c8c1b4d975160a6$var$t3, $1c8c1b4d975160a6$var$t4, $1c8c1b4d975160a6$var$t5, $1c8c1b4d975160a6$var$t6, $1c8c1b4d975160a6$var$t7, $1c8c1b4d975160a6$var$t8, $1c8c1b4d975160a6$var$t9, $1c8c1b4d975160a6$var$t10, $1c8c1b4d975160a6$var$t11, $1c8c1b4d975160a6$var$t12, $1c8c1b4d975160a6$var$t13, $1c8c1b4d975160a6$var$t14, $1c8c1b4d975160a6$var$t15, $1c8c1b4d975160a6$var$t16;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6Vb5F = parcelRequire("6Vb5F");
const $1c8c1b4d975160a6$var$error = {
    message: ({ schemaCode: schemaCode })=>(0, $6Vb5F.str)($1c8c1b4d975160a6$var$t || ($1c8c1b4d975160a6$var$t = $1c8c1b4d975160a6$var$_`must match format "${0}"`), schemaCode),
    params: ({ schemaCode: schemaCode })=>(0, $6Vb5F._)($1c8c1b4d975160a6$var$t1 || ($1c8c1b4d975160a6$var$t1 = $1c8c1b4d975160a6$var$_`{format: ${0}}`), schemaCode)
};
const $1c8c1b4d975160a6$var$def = {
    keyword: "format",
    type: [
        "number",
        "string"
    ],
    schemaType: "string",
    $data: true,
    error: $1c8c1b4d975160a6$var$error,
    code (cxt, ruleType) {
        const { gen: gen, data: data, $data: $data, schema: schema, schemaCode: schemaCode, it: it } = cxt;
        const { opts: opts, errSchemaPath: errSchemaPath, schemaEnv: schemaEnv, self: self } = it;
        if (!opts.validateFormats) return;
        if ($data) validate$DataFormat();
        else validateFormat();
        function validate$DataFormat() {
            const fmts = gen.scopeValue("formats", {
                ref: self.formats,
                code: opts.code.formats
            });
            const fDef = gen.const("fDef", (0, $6Vb5F._)($1c8c1b4d975160a6$var$t2 || ($1c8c1b4d975160a6$var$t2 = $1c8c1b4d975160a6$var$_`${0}[${0}]`), fmts, schemaCode));
            const fType = gen.let("fType");
            const format = gen.let("format");
            // TODO simplify
            gen.if((0, $6Vb5F._)($1c8c1b4d975160a6$var$t3 || ($1c8c1b4d975160a6$var$t3 = $1c8c1b4d975160a6$var$_`typeof ${0} == "object" && !(${0} instanceof RegExp)`), fDef, fDef), ()=>gen.assign(fType, (0, $6Vb5F._)($1c8c1b4d975160a6$var$t4 || ($1c8c1b4d975160a6$var$t4 = $1c8c1b4d975160a6$var$_`${0}.type || "string"`), fDef)).assign(format, (0, $6Vb5F._)($1c8c1b4d975160a6$var$t5 || ($1c8c1b4d975160a6$var$t5 = $1c8c1b4d975160a6$var$_`${0}.validate`), fDef)), ()=>gen.assign(fType, (0, $6Vb5F._)($1c8c1b4d975160a6$var$t6 || ($1c8c1b4d975160a6$var$t6 = $1c8c1b4d975160a6$var$_`"string"`))).assign(format, fDef));
            cxt.fail$data((0, $6Vb5F.or)(unknownFmt(), invalidFmt()));
            function unknownFmt() {
                if (opts.strictSchema === false) return $6Vb5F.nil;
                return (0, $6Vb5F._)($1c8c1b4d975160a6$var$t7 || ($1c8c1b4d975160a6$var$t7 = $1c8c1b4d975160a6$var$_`${0} && !${0}`), schemaCode, format);
            }
            function invalidFmt() {
                const callFormat = schemaEnv.$async ? (0, $6Vb5F._)($1c8c1b4d975160a6$var$t8 || ($1c8c1b4d975160a6$var$t8 = $1c8c1b4d975160a6$var$_`(${0}.async ? await ${0}(${0}) : ${0}(${0}))`), fDef, format, data, format, data) : (0, $6Vb5F._)($1c8c1b4d975160a6$var$t9 || ($1c8c1b4d975160a6$var$t9 = $1c8c1b4d975160a6$var$_`${0}(${0})`), format, data);
                const validData = (0, $6Vb5F._)($1c8c1b4d975160a6$var$t10 || ($1c8c1b4d975160a6$var$t10 = $1c8c1b4d975160a6$var$_`(typeof ${0} == "function" ? ${0} : ${0}.test(${0}))`), format, callFormat, format, data);
                return (0, $6Vb5F._)($1c8c1b4d975160a6$var$t11 || ($1c8c1b4d975160a6$var$t11 = $1c8c1b4d975160a6$var$_`${0} && ${0} !== true && ${0} === ${0} && !${0}`), format, format, fType, ruleType, validData);
            }
        }
        function validateFormat() {
            const formatDef = self.formats[schema];
            if (!formatDef) {
                unknownFormat();
                return;
            }
            if (formatDef === true) return;
            const [fmtType, format, fmtRef] = getFormat(formatDef);
            if (fmtType === ruleType) cxt.pass(validCondition());
            function unknownFormat() {
                if (opts.strictSchema === false) {
                    self.logger.warn(unknownMsg());
                    return;
                }
                throw new Error(unknownMsg());
                function unknownMsg() {
                    return `unknown format "${schema}" ignored in schema at path "${errSchemaPath}"`;
                }
            }
            function getFormat(fmtDef) {
                const code = fmtDef instanceof RegExp ? (0, $6Vb5F.regexpCode)(fmtDef) : opts.code.formats ? (0, $6Vb5F._)($1c8c1b4d975160a6$var$t12 || ($1c8c1b4d975160a6$var$t12 = $1c8c1b4d975160a6$var$_`${0}${0}`), opts.code.formats, (0, $6Vb5F.getProperty)(schema)) : undefined;
                const fmt = gen.scopeValue("formats", {
                    key: schema,
                    ref: fmtDef,
                    code: code
                });
                if (typeof fmtDef == "object" && !(fmtDef instanceof RegExp)) return [
                    fmtDef.type || "string",
                    fmtDef.validate,
                    (0, $6Vb5F._)($1c8c1b4d975160a6$var$t13 || ($1c8c1b4d975160a6$var$t13 = $1c8c1b4d975160a6$var$_`${0}.validate`), fmt)
                ];
                return [
                    "string",
                    fmtDef,
                    fmt
                ];
            }
            function validCondition() {
                if (typeof formatDef == "object" && !(formatDef instanceof RegExp) && formatDef.async) {
                    if (!schemaEnv.$async) throw new Error("async format in sync schema");
                    return (0, $6Vb5F._)($1c8c1b4d975160a6$var$t14 || ($1c8c1b4d975160a6$var$t14 = $1c8c1b4d975160a6$var$_`await ${0}(${0})`), fmtRef, data);
                }
                return typeof format == "function" ? (0, $6Vb5F._)($1c8c1b4d975160a6$var$t15 || ($1c8c1b4d975160a6$var$t15 = $1c8c1b4d975160a6$var$_`${0}(${0})`), fmtRef, data) : (0, $6Vb5F._)($1c8c1b4d975160a6$var$t16 || ($1c8c1b4d975160a6$var$t16 = $1c8c1b4d975160a6$var$_`${0}.test(${0})`), fmtRef, data);
            }
        }
    }
};
module.exports.default = $1c8c1b4d975160a6$var$def;

});


parcelRequire.register("1f3mY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.contentVocabulary = module.exports.metadataVocabulary = void 0;
module.exports.metadataVocabulary = [
    "title",
    "description",
    "default",
    "deprecated",
    "readOnly",
    "writeOnly",
    "examples"
];
module.exports.contentVocabulary = [
    "contentMediaType",
    "contentEncoding",
    "contentSchema"
];

});


parcelRequire.register("eqmRb", function(module, exports) {
"use strict";
let $a8053945de2e222d$var$_ = (t)=>t, $a8053945de2e222d$var$t, $a8053945de2e222d$var$t1, $a8053945de2e222d$var$t2, $a8053945de2e222d$var$t3;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6Vb5F = parcelRequire("6Vb5F");

var $9N2aC = parcelRequire("9N2aC");

var $PkPFY = parcelRequire("PkPFY");

var $k2074 = parcelRequire("k2074");
const $a8053945de2e222d$var$error = {
    message: ({ params: { discrError: discrError, tagName: tagName } })=>discrError === $9N2aC.DiscrError.Tag ? `tag "${tagName}" must be string` : `value of tag "${tagName}" must be in oneOf`,
    params: ({ params: { discrError: discrError, tag: tag, tagName: tagName } })=>(0, $6Vb5F._)($a8053945de2e222d$var$t || ($a8053945de2e222d$var$t = $a8053945de2e222d$var$_`{error: ${0}, tag: ${0}, tagValue: ${0}}`), discrError, tagName, tag)
};
const $a8053945de2e222d$var$def = {
    keyword: "discriminator",
    type: "object",
    schemaType: "object",
    error: $a8053945de2e222d$var$error,
    code (cxt) {
        const { gen: gen, data: data, schema: schema, parentSchema: parentSchema, it: it } = cxt;
        const { oneOf: oneOf } = parentSchema;
        if (!it.opts.discriminator) throw new Error("discriminator: requires discriminator option");
        const tagName = schema.propertyName;
        if (typeof tagName != "string") throw new Error("discriminator: requires propertyName");
        if (schema.mapping) throw new Error("discriminator: mapping is not supported");
        if (!oneOf) throw new Error("discriminator: requires oneOf keyword");
        const valid = gen.let("valid", false);
        const tag = gen.const("tag", (0, $6Vb5F._)($a8053945de2e222d$var$t1 || ($a8053945de2e222d$var$t1 = $a8053945de2e222d$var$_`${0}${0}`), data, (0, $6Vb5F.getProperty)(tagName)));
        gen.if((0, $6Vb5F._)($a8053945de2e222d$var$t2 || ($a8053945de2e222d$var$t2 = $a8053945de2e222d$var$_`typeof ${0} == "string"`), tag), ()=>validateMapping(), ()=>cxt.error(false, {
                discrError: $9N2aC.DiscrError.Tag,
                tag: tag,
                tagName: tagName
            }));
        cxt.ok(valid);
        function validateMapping() {
            const mapping = getMapping();
            gen.if(false);
            for(const tagValue in mapping){
                gen.elseIf((0, $6Vb5F._)($a8053945de2e222d$var$t3 || ($a8053945de2e222d$var$t3 = $a8053945de2e222d$var$_`${0} === ${0}`), tag, tagValue));
                gen.assign(valid, applyTagSchema(mapping[tagValue]));
            }
            gen.else();
            cxt.error(false, {
                discrError: $9N2aC.DiscrError.Mapping,
                tag: tag,
                tagName: tagName
            });
            gen.endIf();
        }
        function applyTagSchema(schemaProp) {
            const _valid = gen.name("valid");
            const schCxt = cxt.subschema({
                keyword: "oneOf",
                schemaProp: schemaProp
            }, _valid);
            cxt.mergeEvaluated(schCxt, $6Vb5F.Name);
            return _valid;
        }
        function getMapping() {
            var _a;
            const oneOfMapping = {};
            const topRequired = hasRequired(parentSchema);
            let tagRequired = true;
            for(let i = 0; i < oneOf.length; i++){
                let sch = oneOf[i];
                if ((sch === null || sch === void 0 ? void 0 : sch.$ref) && !(0, $k2074.schemaHasRulesButRef)(sch, it.self.RULES)) {
                    sch = $PkPFY.resolveRef.call(it.self, it.schemaEnv.root, it.baseId, sch === null || sch === void 0 ? void 0 : sch.$ref);
                    if (sch instanceof $PkPFY.SchemaEnv) sch = sch.schema;
                }
                const propSch = (_a = sch === null || sch === void 0 ? void 0 : sch.properties) === null || _a === void 0 ? void 0 : _a[tagName];
                if (typeof propSch != "object") throw new Error(`discriminator: oneOf subschemas (or referenced schemas) must have "properties/${tagName}"`);
                tagRequired = tagRequired && (topRequired || hasRequired(sch));
                addMappings(propSch, i);
            }
            if (!tagRequired) throw new Error(`discriminator: "${tagName}" must be required`);
            return oneOfMapping;
            function hasRequired({ required: required }) {
                return Array.isArray(required) && required.includes(tagName);
            }
            function addMappings(sch, i) {
                if (sch.const) addMapping(sch.const, i);
                else if (sch.enum) for (const tagValue of sch.enum)addMapping(tagValue, i);
                else throw new Error(`discriminator: "properties/${tagName}" must have "const" or "enum"`);
            }
            function addMapping(tagValue, i) {
                if (typeof tagValue != "string" || tagValue in oneOfMapping) throw new Error(`discriminator: "${tagName}" values must be unique strings`);
                oneOfMapping[tagValue] = i;
            }
        }
    }
};
module.exports.default = $a8053945de2e222d$var$def;

});
parcelRequire.register("9N2aC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiscrError = void 0;
var $720a5f9cb92ddeb6$var$DiscrError;
(function(DiscrError) {
    DiscrError["Tag"] = "tag";
    DiscrError["Mapping"] = "mapping";
})($720a5f9cb92ddeb6$var$DiscrError = module.exports.DiscrError || (module.exports.DiscrError = {}));

});


parcelRequire.register("cmDZ6", function(module, exports) {
module.exports = JSON.parse('{"$schema":"http://json-schema.org/draft-07/schema#","$id":"http://json-schema.org/draft-07/schema#","title":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"nonNegativeInteger":{"type":"integer","minimum":0},"nonNegativeIntegerDefault0":{"allOf":[{"$ref":"#/definitions/nonNegativeInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"uniqueItems":true,"default":[]}},"type":["object","boolean"],"properties":{"$id":{"type":"string","format":"uri-reference"},"$schema":{"type":"string","format":"uri"},"$ref":{"type":"string","format":"uri-reference"},"$comment":{"type":"string"},"title":{"type":"string"},"description":{"type":"string"},"default":true,"readOnly":{"type":"boolean","default":false},"examples":{"type":"array","items":true},"multipleOf":{"type":"number","exclusiveMinimum":0},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"number"},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"number"},"maxLength":{"$ref":"#/definitions/nonNegativeInteger"},"minLength":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"$ref":"#"},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":true},"maxItems":{"$ref":"#/definitions/nonNegativeInteger"},"minItems":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"contains":{"$ref":"#"},"maxProperties":{"$ref":"#/definitions/nonNegativeInteger"},"minProperties":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"$ref":"#"},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"propertyNames":{"format":"regex"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"propertyNames":{"$ref":"#"},"const":true,"enum":{"type":"array","items":true,"minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"contentMediaType":{"type":"string"},"contentEncoding":{"type":"string"},"if":{"$ref":"#"},"then":{"$ref":"#"},"else":{"$ref":"#"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"default":true}');

});


parcelRequire.register("5Lqwq", function(module, exports) {
"use strict";
let _ = (t)=>t, t;
Object.defineProperty(exports, "__esModule", {
    value: true
});

var $kaAoy = parcelRequire("kaAoy");

var $2vhIO = parcelRequire("2vhIO");

var $6Vb5F = parcelRequire("6Vb5F");
const fullName = new $6Vb5F.Name("fullFormats");
const fastName = new $6Vb5F.Name("fastFormats");
const formatsPlugin = (ajv, opts = {
    keywords: true
})=>{
    if (Array.isArray(opts)) {
        addFormats(ajv, opts, $kaAoy.fullFormats, fullName);
        return ajv;
    }
    const [formats, exportName] = opts.mode === "fast" ? [
        $kaAoy.fastFormats,
        fastName
    ] : [
        $kaAoy.fullFormats,
        fullName
    ];
    const list = opts.formats || $kaAoy.formatNames;
    addFormats(ajv, list, formats, exportName);
    if (opts.keywords) $2vhIO.default(ajv);
    return ajv;
};
formatsPlugin.get = (name, mode = "full")=>{
    const formats = mode === "fast" ? $kaAoy.fastFormats : $kaAoy.fullFormats;
    const f = formats[name];
    if (!f) throw new Error(`Unknown format "${name}"`);
    return f;
};
function addFormats(ajv, list, fs, exportName) {
    var _a;
    var _b;
    (_a = (_b = ajv.opts.code).formats) !== null && _a !== void 0 ? _a : _b.formats = $6Vb5F._(t || (t = _`require("ajv-formats/dist/formats").${0}`), exportName);
    for (const f of list)ajv.addFormat(f, fs[f]);
}
module.exports = exports = formatsPlugin;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = formatsPlugin;

});
parcelRequire.register("kaAoy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatNames = module.exports.fastFormats = module.exports.fullFormats = void 0;
function $eaf0f91868be3de0$var$fmtDef(validate, compare) {
    return {
        validate: validate,
        compare: compare
    };
}
module.exports.fullFormats = {
    // date: http://tools.ietf.org/html/rfc3339#section-5.6
    date: $eaf0f91868be3de0$var$fmtDef($eaf0f91868be3de0$var$date, $eaf0f91868be3de0$var$compareDate),
    // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
    time: $eaf0f91868be3de0$var$fmtDef($eaf0f91868be3de0$var$time, $eaf0f91868be3de0$var$compareTime),
    "date-time": $eaf0f91868be3de0$var$fmtDef($eaf0f91868be3de0$var$date_time, $eaf0f91868be3de0$var$compareDateTime),
    // duration: https://tools.ietf.org/html/rfc3339#appendix-A
    duration: /^P(?!$)((\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?|(\d+W)?)$/,
    uri: $eaf0f91868be3de0$var$uri,
    "uri-reference": /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
    // uri-template: https://tools.ietf.org/html/rfc6570
    "uri-template": /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i,
    // For the source: https://gist.github.com/dperini/729294
    // For test cases: https://mathiasbynens.be/demo/url-regex
    url: /^(?:https?|ftp):\/\/(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)(?:\.(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu,
    email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
    hostname: /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i,
    // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
    ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
    ipv6: /^((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/i,
    regex: $eaf0f91868be3de0$var$regex,
    // uuid: http://tools.ietf.org/html/rfc4122
    uuid: /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i,
    // JSON-pointer: https://tools.ietf.org/html/rfc6901
    // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
    "json-pointer": /^(?:\/(?:[^~/]|~0|~1)*)*$/,
    "json-pointer-uri-fragment": /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i,
    // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
    "relative-json-pointer": /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/,
    byte: // the following formats are used by the openapi specification: https://spec.openapis.org/oas/v3.0.0#data-types
    // byte: https://github.com/miguelmota/is-base64
    $eaf0f91868be3de0$var$byte,
    // signed 32 bit integer
    int32: {
        type: "number",
        validate: $eaf0f91868be3de0$var$validateInt32
    },
    // signed 64 bit integer
    int64: {
        type: "number",
        validate: $eaf0f91868be3de0$var$validateInt64
    },
    // C-type float
    float: {
        type: "number",
        validate: $eaf0f91868be3de0$var$validateNumber
    },
    // C-type double
    double: {
        type: "number",
        validate: $eaf0f91868be3de0$var$validateNumber
    },
    // hint to the UI to hide input strings
    password: true,
    // unchecked string payload
    binary: true
};
module.exports.fastFormats = {
    ...module.exports.fullFormats,
    date: $eaf0f91868be3de0$var$fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d$/, $eaf0f91868be3de0$var$compareDate),
    time: $eaf0f91868be3de0$var$fmtDef(/^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i, $eaf0f91868be3de0$var$compareTime),
    "date-time": $eaf0f91868be3de0$var$fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i, $eaf0f91868be3de0$var$compareDateTime),
    // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
    uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
    "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
    // email (sources from jsen validator):
    // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
    // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'wilful violation')
    email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i
};
module.exports.formatNames = Object.keys(module.exports.fullFormats);
function $eaf0f91868be3de0$var$isLeapYear(year) {
    // https://tools.ietf.org/html/rfc3339#appendix-C
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
const $eaf0f91868be3de0$var$DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
const $eaf0f91868be3de0$var$DAYS = [
    0,
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $eaf0f91868be3de0$var$date(str) {
    // full-date from http://tools.ietf.org/html/rfc3339#section-5.6
    const matches = $eaf0f91868be3de0$var$DATE.exec(str);
    if (!matches) return false;
    const year = +matches[1];
    const month = +matches[2];
    const day = +matches[3];
    return month >= 1 && month <= 12 && day >= 1 && day <= (month === 2 && $eaf0f91868be3de0$var$isLeapYear(year) ? 29 : $eaf0f91868be3de0$var$DAYS[month]);
}
function $eaf0f91868be3de0$var$compareDate(d1, d2) {
    if (!(d1 && d2)) return undefined;
    if (d1 > d2) return 1;
    if (d1 < d2) return -1;
    return 0;
}
const $eaf0f91868be3de0$var$TIME = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
function $eaf0f91868be3de0$var$time(str, withTimeZone) {
    const matches = $eaf0f91868be3de0$var$TIME.exec(str);
    if (!matches) return false;
    const hour = +matches[1];
    const minute = +matches[2];
    const second = +matches[3];
    const timeZone = matches[5];
    return (hour <= 23 && minute <= 59 && second <= 59 || hour === 23 && minute === 59 && second === 60) && (!withTimeZone || timeZone !== "");
}
function $eaf0f91868be3de0$var$compareTime(t1, t2) {
    if (!(t1 && t2)) return undefined;
    const a1 = $eaf0f91868be3de0$var$TIME.exec(t1);
    const a2 = $eaf0f91868be3de0$var$TIME.exec(t2);
    if (!(a1 && a2)) return undefined;
    t1 = a1[1] + a1[2] + a1[3] + (a1[4] || "");
    t2 = a2[1] + a2[2] + a2[3] + (a2[4] || "");
    if (t1 > t2) return 1;
    if (t1 < t2) return -1;
    return 0;
}
const $eaf0f91868be3de0$var$DATE_TIME_SEPARATOR = /t|\s/i;
function $eaf0f91868be3de0$var$date_time(str) {
    // http://tools.ietf.org/html/rfc3339#section-5.6
    const dateTime = str.split($eaf0f91868be3de0$var$DATE_TIME_SEPARATOR);
    return dateTime.length === 2 && $eaf0f91868be3de0$var$date(dateTime[0]) && $eaf0f91868be3de0$var$time(dateTime[1], true);
}
function $eaf0f91868be3de0$var$compareDateTime(dt1, dt2) {
    if (!(dt1 && dt2)) return undefined;
    const [d1, t1] = dt1.split($eaf0f91868be3de0$var$DATE_TIME_SEPARATOR);
    const [d2, t2] = dt2.split($eaf0f91868be3de0$var$DATE_TIME_SEPARATOR);
    const res = $eaf0f91868be3de0$var$compareDate(d1, d2);
    if (res === undefined) return undefined;
    return res || $eaf0f91868be3de0$var$compareTime(t1, t2);
}
const $eaf0f91868be3de0$var$NOT_URI_FRAGMENT = /\/|:/;
const $eaf0f91868be3de0$var$URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
function $eaf0f91868be3de0$var$uri(str) {
    // http://jmrware.com/articles/2009/uri_regexp/URI_regex.html + optional protocol + required "."
    return $eaf0f91868be3de0$var$NOT_URI_FRAGMENT.test(str) && $eaf0f91868be3de0$var$URI.test(str);
}
const $eaf0f91868be3de0$var$BYTE = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/gm;
function $eaf0f91868be3de0$var$byte(str) {
    $eaf0f91868be3de0$var$BYTE.lastIndex = 0;
    return $eaf0f91868be3de0$var$BYTE.test(str);
}
const $eaf0f91868be3de0$var$MIN_INT32 = -(2 ** 31);
const $eaf0f91868be3de0$var$MAX_INT32 = 2 ** 31 - 1;
function $eaf0f91868be3de0$var$validateInt32(value) {
    return Number.isInteger(value) && value <= $eaf0f91868be3de0$var$MAX_INT32 && value >= $eaf0f91868be3de0$var$MIN_INT32;
}
function $eaf0f91868be3de0$var$validateInt64(value) {
    // JSON and javascript max Int is 2**53, so any int that passes isInteger is valid for Int64
    return Number.isInteger(value);
}
function $eaf0f91868be3de0$var$validateNumber() {
    return true;
}
const $eaf0f91868be3de0$var$Z_ANCHOR = /[^\\]\\Z/;
function $eaf0f91868be3de0$var$regex(str) {
    if ($eaf0f91868be3de0$var$Z_ANCHOR.test(str)) return false;
    try {
        new RegExp(str);
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRequire.register("2vhIO", function(module, exports) {
"use strict";
let $1d2c3933f618b047$var$_ = (t)=>t, $1d2c3933f618b047$var$t, $1d2c3933f618b047$var$t1, $1d2c3933f618b047$var$t2, $1d2c3933f618b047$var$t3, $1d2c3933f618b047$var$t4, $1d2c3933f618b047$var$t5, $1d2c3933f618b047$var$t6, $1d2c3933f618b047$var$t7;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatLimitDefinition = void 0;

var $6XRb5 = parcelRequire("6XRb5");

var $6Vb5F = parcelRequire("6Vb5F");
const $1d2c3933f618b047$var$ops = $6Vb5F.operators;
const $1d2c3933f618b047$var$KWDs = {
    formatMaximum: {
        okStr: "<=",
        ok: $1d2c3933f618b047$var$ops.LTE,
        fail: $1d2c3933f618b047$var$ops.GT
    },
    formatMinimum: {
        okStr: ">=",
        ok: $1d2c3933f618b047$var$ops.GTE,
        fail: $1d2c3933f618b047$var$ops.LT
    },
    formatExclusiveMaximum: {
        okStr: "<",
        ok: $1d2c3933f618b047$var$ops.LT,
        fail: $1d2c3933f618b047$var$ops.GTE
    },
    formatExclusiveMinimum: {
        okStr: ">",
        ok: $1d2c3933f618b047$var$ops.GT,
        fail: $1d2c3933f618b047$var$ops.LTE
    }
};
const $1d2c3933f618b047$var$error = {
    message: ({ keyword: keyword, schemaCode: schemaCode })=>$6Vb5F.str($1d2c3933f618b047$var$t || ($1d2c3933f618b047$var$t = $1d2c3933f618b047$var$_`should be ${0} ${0}`), $1d2c3933f618b047$var$KWDs[keyword].okStr, schemaCode),
    params: ({ keyword: keyword, schemaCode: schemaCode })=>$6Vb5F._($1d2c3933f618b047$var$t1 || ($1d2c3933f618b047$var$t1 = $1d2c3933f618b047$var$_`{comparison: ${0}, limit: ${0}}`), $1d2c3933f618b047$var$KWDs[keyword].okStr, schemaCode)
};
module.exports.formatLimitDefinition = {
    keyword: Object.keys($1d2c3933f618b047$var$KWDs),
    type: "string",
    schemaType: "string",
    $data: true,
    error: $1d2c3933f618b047$var$error,
    code (cxt) {
        const { gen: gen, data: data, schemaCode: schemaCode, keyword: keyword, it: it } = cxt;
        const { opts: opts, self: self } = it;
        if (!opts.validateFormats) return;
        const fCxt = new $6XRb5.KeywordCxt(it, self.RULES.all.format.definition, "format");
        if (fCxt.$data) validate$DataFormat();
        else validateFormat();
        function validate$DataFormat() {
            const fmts = gen.scopeValue("formats", {
                ref: self.formats,
                code: opts.code.formats
            });
            const fmt = gen.const("fmt", $6Vb5F._($1d2c3933f618b047$var$t2 || ($1d2c3933f618b047$var$t2 = $1d2c3933f618b047$var$_`${0}[${0}]`), fmts, fCxt.schemaCode));
            cxt.fail$data($6Vb5F.or($6Vb5F._($1d2c3933f618b047$var$t3 || ($1d2c3933f618b047$var$t3 = $1d2c3933f618b047$var$_`typeof ${0} != "object"`), fmt), $6Vb5F._($1d2c3933f618b047$var$t4 || ($1d2c3933f618b047$var$t4 = $1d2c3933f618b047$var$_`${0} instanceof RegExp`), fmt), $6Vb5F._($1d2c3933f618b047$var$t5 || ($1d2c3933f618b047$var$t5 = $1d2c3933f618b047$var$_`typeof ${0}.compare != "function"`), fmt), compareCode(fmt)));
        }
        function validateFormat() {
            const format = fCxt.schema;
            const fmtDef = self.formats[format];
            if (!fmtDef || fmtDef === true) return;
            if (typeof fmtDef != "object" || fmtDef instanceof RegExp || typeof fmtDef.compare != "function") throw new Error(`"${keyword}": format "${format}" does not define "compare" function`);
            const fmt = gen.scopeValue("formats", {
                key: format,
                ref: fmtDef,
                code: opts.code.formats ? $6Vb5F._($1d2c3933f618b047$var$t6 || ($1d2c3933f618b047$var$t6 = $1d2c3933f618b047$var$_`${0}${0}`), opts.code.formats, $6Vb5F.getProperty(format)) : undefined
            });
            cxt.fail$data(compareCode(fmt));
        }
        function compareCode(fmt) {
            return $6Vb5F._($1d2c3933f618b047$var$t7 || ($1d2c3933f618b047$var$t7 = $1d2c3933f618b047$var$_`${0}.compare(${0}, ${0}) ${0} 0`), fmt, data, schemaCode, $1d2c3933f618b047$var$KWDs[keyword].fail);
        }
    },
    dependencies: [
        "format"
    ]
};
const $1d2c3933f618b047$var$formatLimitPlugin = (ajv)=>{
    ajv.addKeyword(module.exports.formatLimitDefinition);
    return ajv;
};
module.exports.default = $1d2c3933f618b047$var$formatLimitPlugin;

});


parcelRequire.register("3HNTe", function(module, exports) {
/* UAParser.js v1.0.35
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ (function(window1, undefined) {
    "use strict";
    var LIBVERSION = "1.0.35", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 350;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", VIERA = "Viera", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS";
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1];
            j = k = 0;
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) this[q[0]] = q[1].call(this, match);
                            else this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return str;
    };
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: [
            "NT 5.1",
            "NT 5.2"
        ],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: [
            "NT 6.4",
            "NT 10.0"
        ],
        RT: "ARM"
    };
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
                /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                /(heytap|ovi)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat(Win) Desktop"
                ]
            ],
            [
                /micromessenger\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i
            ],
            [
                [
                    NAME,
                    "360 " + BROWSER
                ]
            ],
            [
                /(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 " + BROWSER
                ],
                VERSION
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(metasr)[\/ ]?([\w\.]+)/i,
                /(lbbrowser)/i,
                /\[(linkedin)app\]/i
            ],
            [
                NAME
            ],
            [
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(chromium|instagram)[\/ ]([-\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(navigator|netscape\d?)\/([-\w\.]+)/i
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                /(links) \(([\w\.]+)/i,
                /panasonic;(viera)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(cobalt)\/([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]([-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(poco[\w ]+)(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rmx[12]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(pixel c)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(playbook);[-\w\),; ]+(rim)/i
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(nexus 9)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /smart-tv.+(samsung)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /((pebble))app/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( 2| pro)?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                /microsoft (windows) (vista|xp)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows) nt 6\.2; (arm)/i,
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
                /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Windows"
                ],
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /ios;fbsv\/([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                /crkey\/([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    if ("object" !== UNDEF_TYPE) {
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) window1.UAParser = UAParser;
    }
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser;
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});

parcelRequire.register("kg9hQ", function(module, exports) {

var $7dgut = parcelRequire("7dgut");
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t, y, e, I, i, o, a, h, C, T, d, p, F, n, r, s, c, P, E, q, g, m, w, l, v, b, x, S, u, k, _, f, A, O, B, R, j, D, M, U, N, z, L, H, W, G, V, Y, X, J, K, Q, Z, vt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
        return typeof t;
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, $ = function(pt) {
        var gt = "1.3", mt = {
            a0: [
                2383.94,
                3370.39
            ],
            a1: [
                1683.78,
                2383.94
            ],
            a2: [
                1190.55,
                1683.78
            ],
            a3: [
                841.89,
                1190.55
            ],
            a4: [
                595.28,
                841.89
            ],
            a5: [
                419.53,
                595.28
            ],
            a6: [
                297.64,
                419.53
            ],
            a7: [
                209.76,
                297.64
            ],
            a8: [
                147.4,
                209.76
            ],
            a9: [
                104.88,
                147.4
            ],
            a10: [
                73.7,
                104.88
            ],
            b0: [
                2834.65,
                4008.19
            ],
            b1: [
                2004.09,
                2834.65
            ],
            b2: [
                1417.32,
                2004.09
            ],
            b3: [
                1000.63,
                1417.32
            ],
            b4: [
                708.66,
                1000.63
            ],
            b5: [
                498.9,
                708.66
            ],
            b6: [
                354.33,
                498.9
            ],
            b7: [
                249.45,
                354.33
            ],
            b8: [
                175.75,
                249.45
            ],
            b9: [
                124.72,
                175.75
            ],
            b10: [
                87.87,
                124.72
            ],
            c0: [
                2599.37,
                3676.54
            ],
            c1: [
                1836.85,
                2599.37
            ],
            c2: [
                1298.27,
                1836.85
            ],
            c3: [
                918.43,
                1298.27
            ],
            c4: [
                649.13,
                918.43
            ],
            c5: [
                459.21,
                649.13
            ],
            c6: [
                323.15,
                459.21
            ],
            c7: [
                229.61,
                323.15
            ],
            c8: [
                161.57,
                229.61
            ],
            c9: [
                113.39,
                161.57
            ],
            c10: [
                79.37,
                113.39
            ],
            dl: [
                311.81,
                623.62
            ],
            letter: [
                612,
                792
            ],
            "government-letter": [
                576,
                756
            ],
            legal: [
                612,
                1008
            ],
            "junior-legal": [
                576,
                360
            ],
            ledger: [
                1224,
                792
            ],
            tabloid: [
                792,
                1224
            ],
            "credit-card": [
                153,
                243
            ]
        };
        function wt(o) {
            var a = {};
            this.subscribe = function(t, e, n) {
                if ("function" != typeof e) return !1;
                a.hasOwnProperty(t) || (a[t] = {});
                var r = Math.random().toString(35);
                return a[t][r] = [
                    e,
                    !!n
                ], r;
            }, this.unsubscribe = function(t) {
                for(var e in a)if (a[e][t]) return delete a[e][t], !0;
                return !1;
            }, this.publish = function(t) {
                if (a.hasOwnProperty(t)) {
                    var e = Array.prototype.slice.call(arguments, 1), n = [];
                    for(var r in a[t]){
                        var i = a[t][r];
                        try {
                            i[0].apply(o, e);
                        } catch (t) {
                            pt.console && console.error("jsPDF PubSub Error", t.message, t);
                        }
                        i[1] && n.push(r);
                    }
                    n.length && n.forEach(this.unsubscribe);
                }
            };
        }
        function yt(t, e, n, r) {
            var i = {};
            "object" === (void 0 === t ? "undefined" : vt(t)) && (t = (i = t).orientation, e = i.unit || e, n = i.format || n, r = i.compress || i.compressPdf || r), e = e || "mm", n = n || "a4", t = ("" + (t || "P")).toLowerCase();
            ("" + n).toLowerCase();
            var K, w, y, o, u, v, a, s, h, c, l, f = !!r && "function" == typeof Uint8Array, Q = i.textColor || "0 g", d = i.drawColor || "0 G", Z = i.fontSize || 16, $ = i.charSpace || 0, tt = i.R2L || !1, et = i.lineHeight || 1.15, p = i.lineWidth || .200025, g = "00000000000000000000000000000000", m = 2, b = !1, x = [], nt = {}, S = {}, k = 0, _ = [], A = [], I = [], C = [], T = [], F = 0, P = 0, E = 0, q = {
                title: "",
                subject: "",
                author: "",
                keywords: "",
                creator: ""
            }, O = {}, rt = new wt(O), B = i.hotfixes || [], R = function(t) {
                var e, n = t.ch1, r = t.ch2, i = t.ch3, o = t.ch4, a = (t.precision, "draw" === t.pdfColorType ? [
                    "G",
                    "RG",
                    "K"
                ] : [
                    "g",
                    "rg",
                    "k"
                ]);
                if ("string" == typeof n && "#" !== n.charAt(0)) {
                    var s = new RGBColor(n);
                    s.ok && (n = s.toHex());
                }
                if ("string" == typeof n && /^#[0-9A-Fa-f]{3}$/.test(n) && (n = "#" + n[1] + n[1] + n[2] + n[2] + n[3] + n[3]), "string" == typeof n && /^#[0-9A-Fa-f]{6}$/.test(n)) {
                    var h = parseInt(n.substr(1), 16);
                    n = h >> 16 & 255, r = h >> 8 & 255, i = 255 & h;
                }
                if (void 0 === r || void 0 === o && n === r && r === i) {
                    if ("string" == typeof n) e = n + " " + a[0];
                    else switch(t.precision){
                        case 2:
                            e = N(n / 255) + " " + a[0];
                            break;
                        case 3:
                        default:
                            e = z(n / 255) + " " + a[0];
                    }
                } else if (void 0 === o || "object" === (void 0 === o ? "undefined" : vt(o))) {
                    if ("string" == typeof n) e = [
                        n,
                        r,
                        i,
                        a[1]
                    ].join(" ");
                    else switch(t.precision){
                        case 2:
                            e = [
                                N(n / 255),
                                N(r / 255),
                                N(i / 255),
                                a[1]
                            ].join(" ");
                            break;
                        default:
                        case 3:
                            e = [
                                z(n / 255),
                                z(r / 255),
                                z(i / 255),
                                a[1]
                            ].join(" ");
                    }
                    o && 0 === o.a && (e = [
                        "255",
                        "255",
                        "255",
                        a[1]
                    ].join(" "));
                } else if ("string" == typeof n) e = [
                    n,
                    r,
                    i,
                    o,
                    a[2]
                ].join(" ");
                else switch(t.precision){
                    case 2:
                        e = [
                            N(n),
                            N(r),
                            N(i),
                            N(o),
                            a[2]
                        ].join(" ");
                        break;
                    case 3:
                    default:
                        e = [
                            z(n),
                            z(r),
                            z(i),
                            z(o),
                            a[2]
                        ].join(" ");
                }
                return e;
            }, j = function(t) {
                var e = function(t) {
                    return ("0" + parseInt(t)).slice(-2);
                }, n = t.getTimezoneOffset(), r = n < 0 ? "+" : "-", i = Math.floor(Math.abs(n / 60)), o = Math.abs(n % 60), a = [
                    r,
                    e(i),
                    "'",
                    e(o),
                    "'"
                ].join("");
                return [
                    "D:",
                    t.getFullYear(),
                    e(t.getMonth() + 1),
                    e(t.getDate()),
                    e(t.getHours()),
                    e(t.getMinutes()),
                    e(t.getSeconds()),
                    a
                ].join("");
            }, D = function(t) {
                var e;
                return void 0 === (void 0 === t ? "undefined" : vt(t)) && (t = new Date), e = "object" === (void 0 === t ? "undefined" : vt(t)) && "[object Date]" === Object.prototype.toString.call(t) ? j(t) : /^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|\-0[0-9]|\-1[0-1])\'(0[0-9]|[1-5][0-9])\'?$/.test(t) ? t : j(new Date), c = e;
            }, M = function(t) {
                var e = c;
                return "jsDate" === t && (e = function(t) {
                    var e = parseInt(t.substr(2, 4), 10), n = parseInt(t.substr(6, 2), 10) - 1, r = parseInt(t.substr(8, 2), 10), i = parseInt(t.substr(10, 2), 10), o = parseInt(t.substr(12, 2), 10), a = parseInt(t.substr(14, 2), 10);
                    parseInt(t.substr(16, 2), 10), parseInt(t.substr(20, 2), 10);
                    return new Date(e, n, r, i, o, a, 0);
                }(c)), e;
            }, U = function(t) {
                return t = t || "12345678901234567890123456789012".split("").map(function() {
                    return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
                }).join(""), g = t;
            }, N = function(t) {
                return t.toFixed(2);
            }, z = function(t) {
                return t.toFixed(3);
            }, it = function(t) {
                t = "string" == typeof t ? t : t.toString(), b ? _[o].push(t) : (E += t.length + 1, C.push(t));
            }, L = function() {
                return x[++m] = E, it(m + " 0 obj"), m;
            }, H = function(t) {
                it("stream"), it(t), it("endstream");
            }, W = function() {
                for(var t in it("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), it("/Font <<"), nt)nt.hasOwnProperty(t) && it("/" + t + " " + nt[t].objectNumber + " 0 R");
                it(">>"), it("/XObject <<"), rt.publish("putXobjectDict"), it(">>");
            }, G = function() {
                !function() {
                    for(var t in nt)nt.hasOwnProperty(t) && (e = nt[t], rt.publish("putFont", {
                        font: e,
                        out: it,
                        newObject: L
                    }), !0 !== e.isAlreadyPutted && (e.objectNumber = L(), it("<<"), it("/Type /Font"), it("/BaseFont /" + e.postScriptName), it("/Subtype /Type1"), "string" == typeof e.encoding && it("/Encoding /" + e.encoding), it("/FirstChar 32"), it("/LastChar 255"), it(">>"), it("endobj")));
                    var e;
                }(), rt.publish("putResources"), x[2] = E, it("2 0 obj"), it("<<"), W(), it(">>"), it("endobj"), rt.publish("postPutResources");
            }, V = function(t, e, n) {
                S.hasOwnProperty(e) || (S[e] = {}), S[e][n] = t;
            }, Y = function(t, e, n, r) {
                var i = "F" + (Object.keys(nt).length + 1).toString(10), o = nt[i] = {
                    id: i,
                    postScriptName: t,
                    fontName: e,
                    fontStyle: n,
                    encoding: r,
                    metadata: {}
                };
                return V(i, e, n), rt.publish("addFont", o), i;
            }, ot = function(t, e) {
                return (function(t, e) {
                    var n, r, i, o, a, s, h, c, l;
                    if (i = (e = e || {}).sourceEncoding || "Unicode", a = e.outputEncoding, (e.autoencode || a) && nt[K].metadata && nt[K].metadata[i] && nt[K].metadata[i].encoding && (o = nt[K].metadata[i].encoding, !a && nt[K].encoding && (a = nt[K].encoding), !a && o.codePages && (a = o.codePages[0]), "string" == typeof a && (a = o[a]), a)) {
                        for(h = !1, s = [], n = 0, r = t.length; n < r; n++)(c = a[t.charCodeAt(n)]) ? s.push(String.fromCharCode(c)) : s.push(t[n]), s[n].charCodeAt(0) >> 8 && (h = !0);
                        t = s.join("");
                    }
                    for(n = t.length; void 0 === h && 0 !== n;)t.charCodeAt(n - 1) >> 8 && (h = !0), n--;
                    if (!h) return t;
                    for(s = e.noBOM ? [] : [
                        254,
                        255
                    ], n = 0, r = t.length; n < r; n++){
                        if ((l = (c = t.charCodeAt(n)) >> 8) >> 8) throw new Error("Character at position " + n + " of string '" + t + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
                        s.push(l), s.push(c - (l << 8));
                    }
                    return String.fromCharCode.apply(void 0, s);
                })(t, e).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
            }, X = function() {
                (function(t, e) {
                    var n = "string" == typeof e && e.toLowerCase();
                    if ("string" == typeof t) {
                        var r = t.toLowerCase();
                        mt.hasOwnProperty(r) && (t = mt[r][0] / w, e = mt[r][1] / w);
                    }
                    if (Array.isArray(t) && (e = t[1], t = t[0]), n) {
                        switch(n.substr(0, 1)){
                            case "l":
                                t < e && (n = "s");
                                break;
                            case "p":
                                e < t && (n = "s");
                        }
                        "s" === n && (y = t, t = e, e = y);
                    }
                    b = !0, _[++k] = [], I[k] = {
                        width: Number(t) || u,
                        height: Number(e) || v
                    }, A[k] = {}, J(k);
                }).apply(this, arguments), it(N(p * w) + " w"), it(d), 0 !== F && it(F + " J"), 0 !== P && it(P + " j"), rt.publish("addPage", {
                    pageNumber: k
                });
            }, J = function(t) {
                0 < t && t <= k && (u = I[o = t].width, v = I[t].height);
            }, at = function(t, e, n) {
                var r, i = void 0;
                return n = n || {}, t = void 0 !== t ? t : nt[K].fontName, e = void 0 !== e ? e : nt[K].fontStyle, r = t.toLowerCase(), void 0 !== S[r] && void 0 !== S[r][e] ? i = S[r][e] : void 0 !== S[t] && void 0 !== S[t][e] ? i = S[t][e] : !1 === n.disableWarning && console.warn("Unable to look up font label for font '" + t + "', '" + e + "'. Refer to getFontList() for available fonts."), i || n.noFallback || null == (i = S.times[e]) && (i = S.times.normal), i;
            }, st = function() {
                b = !1, m = 2, E = 0, C = [], x = [], T = [], rt.publish("buildDocument"), it("%PDF-" + gt), it("%\xba\xdf\xac\xe0"), function() {
                    var t, e, n, r, i, o, a, s, h, c = [];
                    for(a = pt.adler32cs || yt.API.adler32cs, f && void 0 === a && (f = !1), t = 1; t <= k; t++){
                        if (c.push(L()), s = (u = I[t].width) * w, h = (v = I[t].height) * w, it("<</Type /Page"), it("/Parent 1 0 R"), it("/Resources 2 0 R"), it("/MediaBox [0 0 " + N(s) + " " + N(h) + "]"), rt.publish("putPage", {
                            pageNumber: t,
                            page: _[t]
                        }), it("/Contents " + (m + 1) + " 0 R"), it(">>"), it("endobj"), e = _[t].join("\n"), L(), f) {
                            for(n = [], r = e.length; r--;)n[r] = e.charCodeAt(r);
                            o = a.from(e), (i = new Deflater(6)).append(new Uint8Array(n)), e = i.flush(), (n = new Uint8Array(e.length + 6)).set(new Uint8Array([
                                120,
                                156
                            ])), n.set(e, 2), n.set(new Uint8Array([
                                255 & o,
                                o >> 8 & 255,
                                o >> 16 & 255,
                                o >> 24 & 255
                            ]), e.length + 2), e = String.fromCharCode.apply(null, n), it("<</Length " + e.length + " /Filter [/FlateDecode]>>");
                        } else it("<</Length " + e.length + ">>");
                        H(e), it("endobj");
                    }
                    x[1] = E, it("1 0 obj"), it("<</Type /Pages");
                    var l = "/Kids [";
                    for(r = 0; r < k; r++)l += c[r] + " 0 R ";
                    it(l + "]"), it("/Count " + k), it(">>"), it("endobj"), rt.publish("postPutPages");
                }(), function() {
                    rt.publish("putAdditionalObjects");
                    for(var t = 0; t < T.length; t++){
                        var e = T[t];
                        x[e.objId] = E, it(e.objId + " 0 obj"), it(e.content), it("endobj");
                    }
                    m += T.length, rt.publish("postPutAdditionalObjects");
                }(), G(), L(), it("<<"), function() {
                    for(var t in it("/Producer (jsPDF " + yt.version + ")"), q)q.hasOwnProperty(t) && q[t] && it("/" + t.substr(0, 1).toUpperCase() + t.substr(1) + " (" + ot(q[t]) + ")");
                    it("/CreationDate (" + c + ")");
                }(), it(">>"), it("endobj"), L(), it("<<"), function() {
                    switch(it("/Type /Catalog"), it("/Pages 1 0 R"), s || (s = "fullwidth"), s){
                        case "fullwidth":
                            it("/OpenAction [3 0 R /FitH null]");
                            break;
                        case "fullheight":
                            it("/OpenAction [3 0 R /FitV null]");
                            break;
                        case "fullpage":
                            it("/OpenAction [3 0 R /Fit]");
                            break;
                        case "original":
                            it("/OpenAction [3 0 R /XYZ null null 1]");
                            break;
                        default:
                            var t = "" + s;
                            "%" === t.substr(t.length - 1) && (s = parseInt(s) / 100), "number" == typeof s && it("/OpenAction [3 0 R /XYZ null null " + N(s) + "]");
                    }
                    switch(h || (h = "continuous"), h){
                        case "continuous":
                            it("/PageLayout /OneColumn");
                            break;
                        case "single":
                            it("/PageLayout /SinglePage");
                            break;
                        case "two":
                        case "twoleft":
                            it("/PageLayout /TwoColumnLeft");
                            break;
                        case "tworight":
                            it("/PageLayout /TwoColumnRight");
                    }
                    a && it("/PageMode /" + a), rt.publish("putCatalog");
                }(), it(">>"), it("endobj");
                var t, e = E, n = "0000000000";
                for(it("xref"), it("0 " + (m + 1)), it(n + " 65535 f "), t = 1; t <= m; t++){
                    var r = x[t];
                    it("function" == typeof r ? (n + x[t]()).slice(-10) + " 00000 n " : (n + x[t]).slice(-10) + " 00000 n ");
                }
                return it("trailer"), it("<<"), it("/Size " + (m + 1)), it("/Root " + m + " 0 R"), it("/Info " + (m - 1) + " 0 R"), it("/ID [ <" + g + "> <" + g + "> ]"), it(">>"), it("startxref"), it("" + e), it("%%EOF"), b = !0, C.join("\n");
            }, ht = function(t) {
                var e = "S";
                return "F" === t ? e = "f" : "FD" === t || "DF" === t ? e = "B" : "f" !== t && "f*" !== t && "B" !== t && "B*" !== t || (e = t), e;
            }, ct = function() {
                for(var t = st(), e = t.length, n = new ArrayBuffer(e), r = new Uint8Array(n); e--;)r[e] = t.charCodeAt(e);
                return n;
            }, lt = function() {
                return new Blob([
                    ct()
                ], {
                    type: "application/pdf"
                });
            }, ut = ((l = function(t, e) {
                var n = "dataur" === ("" + t).substr(0, 6) ? "data:application/pdf;base64," + btoa(st()) : 0;
                switch(t){
                    case void 0:
                        return st();
                    case "save":
                        if ("object" === ("undefined" == typeof navigator ? "undefined" : vt(navigator)) && navigator.getUserMedia && (void 0 === pt.URL || void 0 === pt.URL.createObjectURL)) return O.output("dataurlnewwindow");
                        bt(lt(), e), "function" == typeof bt.unload && pt.setTimeout && setTimeout(bt.unload, 911);
                        break;
                    case "arraybuffer":
                        return ct();
                    case "blob":
                        return lt();
                    case "bloburi":
                    case "bloburl":
                        return pt.URL && pt.URL.createObjectURL(lt()) || void 0;
                    case "datauristring":
                    case "dataurlstring":
                        return n;
                    case "dataurlnewwindow":
                        var r = pt.open(n);
                        if (r || "undefined" == typeof safari) return r;
                    case "datauri":
                    case "dataurl":
                        return pt.document.location.href = n;
                    default:
                        throw new Error('Output type "' + t + '" is not supported.');
                }
            }).foo = function() {
                try {
                    return l.apply(this, arguments);
                } catch (t) {
                    var e = t.stack || "";
                    ~e.indexOf(" at ") && (e = e.split(" at ")[1]);
                    var n = "Error in function " + e.split("\n")[0].split("<")[0] + ": " + t.message;
                    if (!pt.console) throw new Error(n);
                    pt.console.error(n, t), pt.alert && alert(n);
                }
            }, (l.foo.bar = l).foo), ft = function(t) {
                return !0 === Array.isArray(B) && -1 < B.indexOf(t);
            };
            switch(e){
                case "pt":
                    w = 1;
                    break;
                case "mm":
                    w = 72 / 25.4;
                    break;
                case "cm":
                    w = 72 / 2.54;
                    break;
                case "in":
                    w = 72;
                    break;
                case "px":
                    w = 1 == ft("px_scaling") ? .75 : 96 / 72;
                    break;
                case "pc":
                case "em":
                    w = 12;
                    break;
                case "ex":
                    w = 6;
                    break;
                default:
                    throw "Invalid unit: " + e;
            }
            for(var dt in D(), U(), O.internal = {
                pdfEscape: ot,
                getStyle: ht,
                getFont: function() {
                    return nt[at.apply(O, arguments)];
                },
                getFontSize: function() {
                    return Z;
                },
                getCharSpace: function() {
                    return $;
                },
                getTextColor: function() {
                    var t = Q.split(" ");
                    if (2 === t.length && "g" === t[1]) {
                        var e = parseFloat(t[0]);
                        t = [
                            e,
                            e,
                            e,
                            "r"
                        ];
                    }
                    for(var n = "#", r = 0; r < 3; r++)n += ("0" + Math.floor(255 * parseFloat(t[r])).toString(16)).slice(-2);
                    return n;
                },
                getLineHeight: function() {
                    return Z * et;
                },
                write: function(t) {
                    it(1 === arguments.length ? t : Array.prototype.join.call(arguments, " "));
                },
                getCoordinateString: function(t) {
                    return N(t * w);
                },
                getVerticalCoordinateString: function(t) {
                    return N((v - t) * w);
                },
                collections: {},
                newObject: L,
                newAdditionalObject: function() {
                    var t = 2 * _.length + 1, e = {
                        objId: t += T.length,
                        content: ""
                    };
                    return T.push(e), e;
                },
                newObjectDeferred: function() {
                    return x[++m] = function() {
                        return E;
                    }, m;
                },
                newObjectDeferredBegin: function(t) {
                    x[t] = E;
                },
                putStream: H,
                events: rt,
                scaleFactor: w,
                pageSize: {
                    getWidth: function() {
                        return u;
                    },
                    getHeight: function() {
                        return v;
                    }
                },
                output: function(t, e) {
                    return ut(t, e);
                },
                getNumberOfPages: function() {
                    return _.length - 1;
                },
                pages: _,
                out: it,
                f2: N,
                getPageInfo: function(t) {
                    return {
                        objId: 2 * (t - 1) + 3,
                        pageNumber: t,
                        pageContext: A[t]
                    };
                },
                getCurrentPageInfo: function() {
                    return {
                        objId: 2 * (o - 1) + 3,
                        pageNumber: o,
                        pageContext: A[o]
                    };
                },
                getPDFVersion: function() {
                    return gt;
                },
                hasHotfix: ft
            }, O.addPage = function() {
                return X.apply(this, arguments), this;
            }, O.setPage = function() {
                return J.apply(this, arguments), this;
            }, O.insertPage = function(t) {
                return this.addPage(), this.movePage(o, t), this;
            }, O.movePage = function(t, e) {
                if (e < t) {
                    for(var n = _[t], r = I[t], i = A[t], o = t; e < o; o--)_[o] = _[o - 1], I[o] = I[o - 1], A[o] = A[o - 1];
                    _[e] = n, I[e] = r, A[e] = i, this.setPage(e);
                } else if (t < e) {
                    for(n = _[t], r = I[t], i = A[t], o = t; o < e; o++)_[o] = _[o + 1], I[o] = I[o + 1], A[o] = A[o + 1];
                    _[e] = n, I[e] = r, A[e] = i, this.setPage(e);
                }
                return this;
            }, O.deletePage = function() {
                return (function(t) {
                    0 < t && t <= k && (_.splice(t, 1), I.splice(t, 1), --k < o && (o = k), this.setPage(o));
                }).apply(this, arguments), this;
            }, O.setCreationDate = function(t) {
                return D(t), this;
            }, O.getCreationDate = function(t) {
                return M(t);
            }, O.setFileId = function(t) {
                return U(t), this;
            }, O.getFileId = function() {
                return g;
            }, O.setDisplayMode = function(t, e, n) {
                if (s = t, h = e, -1 == [
                    void 0,
                    null,
                    "UseNone",
                    "UseOutlines",
                    "UseThumbs",
                    "FullScreen"
                ].indexOf(a = n)) throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + n + '" is not recognized.');
                return this;
            }, O.text = function(t, e, n, i) {
                var r, o, a = "", s = et, h = this;
                function c(t) {
                    for(var e, n = t.concat(), r = [], i = n.length; i--;)"string" == typeof (e = n.shift()) ? r.push(e) : "[object Array]" === Object.prototype.toString.call(t) && 1 === e.length ? r.push(e[0]) : r.push([
                        e[0],
                        e[1],
                        e[2]
                    ]);
                    return r;
                }
                function l(t, e) {
                    var n;
                    if ("string" == typeof t) n = e(t)[0];
                    else if ("[object Array]" === Object.prototype.toString.call(t)) {
                        for(var r, i, o = t.concat(), a = [], s = o.length; s--;)"string" == typeof (r = o.shift()) ? a.push(e(r)[0]) : "[object Array]" === Object.prototype.toString.call(r) && "string" === r[0] && (i = e(r[0], r[1], r[2]), a.push([
                            i[0],
                            i[1],
                            i[2]
                        ]));
                        n = a;
                    }
                    return n;
                }
                "number" == typeof t && (o = n, n = e, e = t, t = o);
                var u = i, f = arguments[4], d = arguments[5];
                "object" === (void 0 === u ? "undefined" : vt(u)) && null !== u || ("string" == typeof f && (d = f, f = null), "string" == typeof u && (d = u, u = null), "number" == typeof u && (f = u, u = null), i = {
                    flags: u,
                    angle: f,
                    align: d
                });
                var p = !1, g = !0;
                if ("string" == typeof t) p = !0;
                else if ("[object Array]" === Object.prototype.toString.call(t)) {
                    for(var m, w = t.concat(), y = [], v = w.length; v--;)("string" != typeof (m = w.shift()) || "[object Array]" === Object.prototype.toString.call(m) && "string" != typeof m[0]) && (g = !1);
                    p = g;
                }
                if (!1 === p) throw new Error('Type of text must be string or Array. "' + t + '" is not recognized.');
                var b = nt[K].encoding;
                "WinAnsiEncoding" !== b && "StandardEncoding" !== b || (t = l(t, function(t, e, n) {
                    var r;
                    return [
                        (r = t, r = r.split("	").join(Array(i.TabLen || 9).join(" ")), ot(r, u)),
                        e,
                        n
                    ];
                })), "string" == typeof t && (t = t.match(/[\r?\n]/) ? t.split(/\r\n|\r|\n/g) : [
                    t
                ]), 0 < (j = i.maxWidth || 0) && ("string" == typeof t ? t = h.splitTextToSize(t, j) : "[object Array]" === Object.prototype.toString.call(t) && (t = h.splitTextToSize(t.join(" "), j)));
                var x = {
                    text: t,
                    x: e,
                    y: n,
                    options: i,
                    mutex: {
                        pdfEscape: ot,
                        activeFontKey: K,
                        fonts: nt,
                        activeFontSize: Z
                    }
                };
                rt.publish("preProcessText", x), t = x.text;
                f = (i = x.options).angle;
                var S = h.internal.scaleFactor, k = (h.internal.pageSize.getHeight(), []);
                if (f) {
                    f *= Math.PI / 180;
                    var _ = Math.cos(f), A = Math.sin(f), I = function(t) {
                        return t.toFixed(2);
                    };
                    k = [
                        I(_),
                        I(A),
                        I(-1 * A),
                        I(_)
                    ];
                }
                void 0 !== (R = i.charSpace) && (a += R + " Tc\n");
                i.lang;
                var C = -1, T = i.renderingMode || i.stroke, F = h.internal.getCurrentPageInfo().pageContext;
                switch(T){
                    case 0:
                    case !1:
                    case "fill":
                        C = 0;
                        break;
                    case 1:
                    case !0:
                    case "stroke":
                        C = 1;
                        break;
                    case 2:
                    case "fillThenStroke":
                        C = 2;
                        break;
                    case 3:
                    case "invisible":
                        C = 3;
                        break;
                    case 4:
                    case "fillAndAddForClipping":
                        C = 4;
                        break;
                    case 5:
                    case "strokeAndAddPathForClipping":
                        C = 5;
                        break;
                    case 6:
                    case "fillThenStrokeAndAddToPathForClipping":
                        C = 6;
                        break;
                    case 7:
                    case "addToPathForClipping":
                        C = 7;
                }
                var P = F.usedRenderingMode || -1;
                -1 !== C ? a += C + " Tr\n" : -1 !== P && (a += "0 Tr\n"), -1 !== C && (F.usedRenderingMode = C);
                d = i.align || "left";
                var E = Z * s, q = h.internal.pageSize.getHeight(), O = h.internal.pageSize.getWidth(), B = (S = h.internal.scaleFactor, nt[K]), R = i.charSpace || $, j = i.maxWidth || 0, D = (u = {}, []);
                if ("[object Array]" === Object.prototype.toString.call(t)) {
                    var M, U;
                    y = c(t);
                    "left" !== d && (U = y.map(function(t) {
                        return h.getStringUnitWidth(t, {
                            font: B,
                            charSpace: R,
                            fontSize: Z
                        }) * Z / S;
                    }));
                    var N, z = Math.max.apply(Math, U), L = 0;
                    if ("right" === d) {
                        e -= U[0], t = [];
                        var H = 0;
                        for(v = y.length; H < v; H++)U[H], 0 === H ? (N = e * S, M = (q - n) * S) : (N = (L - U[H]) * S, M = -E), t.push([
                            y[H],
                            N,
                            M
                        ]), L = U[H];
                    } else if ("center" === d) {
                        e -= U[0] / 2, t = [];
                        for(H = 0, v = y.length; H < v; H++)U[H], 0 === H ? (N = e * S, M = (q - n) * S) : (N = (L - U[H]) / 2 * S, M = -E), t.push([
                            y[H],
                            N,
                            M
                        ]), L = U[H];
                    } else if ("left" === d) {
                        t = [];
                        for(H = 0, v = y.length; H < v; H++)M = 0 === H ? (q - n) * S : -E, N = 0 === H ? e * S : 0, t.push(y[H]);
                    } else {
                        if ("justify" !== d) throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
                        t = [];
                        for(j = 0 !== j ? j : O, H = 0, v = y.length; H < v; H++)M = 0 === H ? (q - n) * S : -E, N = 0 === H ? e * S : 0, H < v - 1 && D.push(((j - U[H]) / (y[H].split(" ").length - 1) * S).toFixed(2)), t.push([
                            y[H],
                            N,
                            M
                        ]);
                    }
                }
                !0 === ("boolean" == typeof i.R2L ? i.R2L : tt) && (t = l(t, function(t, e, n) {
                    return [
                        t.split("").reverse().join(""),
                        e,
                        n
                    ];
                }));
                x = {
                    text: t,
                    x: e,
                    y: n,
                    options: i,
                    mutex: {
                        pdfEscape: ot,
                        activeFontKey: K,
                        fonts: nt,
                        activeFontSize: Z
                    }
                };
                rt.publish("postProcessText", x), t = x.text, r = x.mutex.isHex;
                y = c(t);
                t = [];
                var W, G, V, Y = 0, X = (v = y.length, "");
                for(H = 0; H < v; H++)X = "", "[object Array]" !== Object.prototype.toString.call(y[H]) ? (W = parseFloat(e * S).toFixed(2), G = parseFloat((q - n) * S).toFixed(2), V = (r ? "<" : "(") + y[H] + (r ? ">" : ")")) : "[object Array]" === Object.prototype.toString.call(y[H]) && (W = parseFloat(y[H][1]).toFixed(2), G = parseFloat(y[H][2]).toFixed(2), V = (r ? "<" : "(") + y[H][0] + (r ? ">" : ")"), Y = 1), void 0 !== D && void 0 !== D[H] && (X = D[H] + " Tw\n"), 0 !== k.length && 0 === H ? t.push(X + k.join(" ") + " " + W + " " + G + " Tm\n" + V) : 1 === Y || 0 === Y && 0 === H ? t.push(X + W + " " + G + " Td\n" + V) : t.push(X + V);
                t = 0 === Y ? t.join(" Tj\nT* ") : t.join(" Tj\n"), t += " Tj\n";
                var J = "BT\n/" + K + " " + Z + " Tf\n" + (Z * s).toFixed(2) + " TL\n" + Q + "\n";
                return J += a, J += t, it(J += "ET"), h;
            }, O.lstext = function(t, e, n, r) {
                console.warn("jsPDF.lstext is deprecated");
                for(var i = 0, o = t.length; i < o; i++, e += r)this.text(t[i], e, n);
                return this;
            }, O.line = function(t, e, n, r) {
                return this.lines([
                    [
                        n - t,
                        r - e
                    ]
                ], t, e);
            }, O.clip = function() {
                it("W"), it("S");
            }, O.clip_fixed = function(t) {
                it("evenodd" === t ? "W*" : "W"), it("n");
            }, O.lines = function(t, e, n, r, i, o) {
                var a, s, h, c, l, u, f, d, p, g, m;
                for("number" == typeof t && (y = n, n = e, e = t, t = y), r = r || [
                    1,
                    1
                ], it(z(e * w) + " " + z((v - n) * w) + " m "), a = r[0], s = r[1], c = t.length, g = e, m = n, h = 0; h < c; h++)2 === (l = t[h]).length ? (g = l[0] * a + g, m = l[1] * s + m, it(z(g * w) + " " + z((v - m) * w) + " l")) : (u = l[0] * a + g, f = l[1] * s + m, d = l[2] * a + g, p = l[3] * s + m, g = l[4] * a + g, m = l[5] * s + m, it(z(u * w) + " " + z((v - f) * w) + " " + z(d * w) + " " + z((v - p) * w) + " " + z(g * w) + " " + z((v - m) * w) + " c"));
                return o && it(" h"), null !== i && it(ht(i)), this;
            }, O.rect = function(t, e, n, r, i) {
                ht(i);
                return it([
                    N(t * w),
                    N((v - e) * w),
                    N(n * w),
                    N(-r * w),
                    "re"
                ].join(" ")), null !== i && it(ht(i)), this;
            }, O.triangle = function(t, e, n, r, i, o, a) {
                return this.lines([
                    [
                        n - t,
                        r - e
                    ],
                    [
                        i - n,
                        o - r
                    ],
                    [
                        t - i,
                        e - o
                    ]
                ], t, e, [
                    1,
                    1
                ], a, !0), this;
            }, O.roundedRect = function(t, e, n, r, i, o, a) {
                var s = 4 / 3 * (Math.SQRT2 - 1);
                return this.lines([
                    [
                        n - 2 * i,
                        0
                    ],
                    [
                        i * s,
                        0,
                        i,
                        o - o * s,
                        i,
                        o
                    ],
                    [
                        0,
                        r - 2 * o
                    ],
                    [
                        0,
                        o * s,
                        -i * s,
                        o,
                        -i,
                        o
                    ],
                    [
                        2 * i - n,
                        0
                    ],
                    [
                        -i * s,
                        0,
                        -i,
                        -o * s,
                        -i,
                        -o
                    ],
                    [
                        0,
                        2 * o - r
                    ],
                    [
                        0,
                        -o * s,
                        i * s,
                        -o,
                        i,
                        -o
                    ]
                ], t + i, e, [
                    1,
                    1
                ], a), this;
            }, O.ellipse = function(t, e, n, r, i) {
                var o = 4 / 3 * (Math.SQRT2 - 1) * n, a = 4 / 3 * (Math.SQRT2 - 1) * r;
                return it([
                    N((t + n) * w),
                    N((v - e) * w),
                    "m",
                    N((t + n) * w),
                    N((v - (e - a)) * w),
                    N((t + o) * w),
                    N((v - (e - r)) * w),
                    N(t * w),
                    N((v - (e - r)) * w),
                    "c"
                ].join(" ")), it([
                    N((t - o) * w),
                    N((v - (e - r)) * w),
                    N((t - n) * w),
                    N((v - (e - a)) * w),
                    N((t - n) * w),
                    N((v - e) * w),
                    "c"
                ].join(" ")), it([
                    N((t - n) * w),
                    N((v - (e + a)) * w),
                    N((t - o) * w),
                    N((v - (e + r)) * w),
                    N(t * w),
                    N((v - (e + r)) * w),
                    "c"
                ].join(" ")), it([
                    N((t + o) * w),
                    N((v - (e + r)) * w),
                    N((t + n) * w),
                    N((v - (e + a)) * w),
                    N((t + n) * w),
                    N((v - e) * w),
                    "c"
                ].join(" ")), null !== i && it(ht(i)), this;
            }, O.circle = function(t, e, n, r) {
                return this.ellipse(t, e, n, n, r);
            }, O.setProperties = function(t) {
                for(var e in q)q.hasOwnProperty(e) && t[e] && (q[e] = t[e]);
                return this;
            }, O.setFontSize = function(t) {
                return Z = t, this;
            }, O.setFont = function(t, e) {
                return K = at(t, e), this;
            }, O.setFontStyle = O.setFontType = function(t) {
                return K = at(void 0, t), this;
            }, O.getFontList = function() {
                var t, e, n, r = {};
                for(t in S)if (S.hasOwnProperty(t)) for(e in r[t] = n = [], S[t])S[t].hasOwnProperty(e) && n.push(e);
                return r;
            }, O.addFont = function(t, e, n, r) {
                Y(t, e, n, r = r || "Identity-H");
            }, O.setLineWidth = function(t) {
                return it((t * w).toFixed(2) + " w"), this;
            }, O.setDrawColor = function(t, e, n, r) {
                return it(R({
                    ch1: t,
                    ch2: e,
                    ch3: n,
                    ch4: r,
                    pdfColorType: "draw",
                    precision: 2
                })), this;
            }, O.setFillColor = function(t, e, n, r) {
                return it(R({
                    ch1: t,
                    ch2: e,
                    ch3: n,
                    ch4: r,
                    pdfColorType: "fill",
                    precision: 2
                })), this;
            }, O.setTextColor = function(t, e, n, r) {
                return Q = R({
                    ch1: t,
                    ch2: e,
                    ch3: n,
                    ch4: r,
                    pdfColorType: "text",
                    precision: 3
                }), this;
            }, O.setCharSpace = function(t) {
                return $ = t, this;
            }, O.setR2L = function(t) {
                return tt = t, this;
            }, O.CapJoinStyles = {
                0: 0,
                butt: 0,
                but: 0,
                miter: 0,
                1: 1,
                round: 1,
                rounded: 1,
                circle: 1,
                2: 2,
                projecting: 2,
                project: 2,
                square: 2,
                bevel: 2
            }, O.setLineCap = function(t) {
                var e = this.CapJoinStyles[t];
                if (void 0 === e) throw new Error("Line cap style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
                return it((F = e) + " J"), this;
            }, O.setLineJoin = function(t) {
                var e = this.CapJoinStyles[t];
                if (void 0 === e) throw new Error("Line join style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
                return it((P = e) + " j"), this;
            }, O.output = ut, O.save = function(t) {
                O.output("save", t);
            }, yt.API)yt.API.hasOwnProperty(dt) && ("events" === dt && yt.API.events.length ? function(t, e) {
                var n, r, i;
                for(i = e.length - 1; -1 !== i; i--)n = e[i][0], r = e[i][1], t.subscribe.apply(t, [
                    n
                ].concat("function" == typeof r ? [
                    r
                ] : r));
            }(rt, yt.API.events) : O[dt] = yt.API[dt]);
            return function() {
                for(var t = "helvetica", e = "times", n = "courier", r = "normal", i = "bold", o = "italic", a = "bolditalic", s = [
                    [
                        "Helvetica",
                        t,
                        r,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Helvetica-Bold",
                        t,
                        i,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Helvetica-Oblique",
                        t,
                        o,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Helvetica-BoldOblique",
                        t,
                        a,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Courier",
                        n,
                        r,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Courier-Bold",
                        n,
                        i,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Courier-Oblique",
                        n,
                        o,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Courier-BoldOblique",
                        n,
                        a,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Times-Roman",
                        e,
                        r,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Times-Bold",
                        e,
                        i,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Times-Italic",
                        e,
                        o,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Times-BoldItalic",
                        e,
                        a,
                        "WinAnsiEncoding"
                    ],
                    [
                        "ZapfDingbats",
                        "zapfdingbats",
                        r,
                        null
                    ],
                    [
                        "Symbol",
                        "symbol",
                        r,
                        null
                    ]
                ], h = 0, c = s.length; h < c; h++){
                    var l = Y(s[h][0], s[h][1], s[h][2], s[h][3]), u = s[h][0].split("-");
                    V(l, u[0], u[1] || "");
                }
                rt.publish("addFonts", {
                    fonts: nt,
                    dictionary: S
                });
            }(), K = "F1", X(n, t), rt.publish("initialized"), O;
        }
        return yt.API = {
            events: []
        }, yt.version = "0.0.0", "function" == typeof define && define.amd ? define("jsPDF", function() {
            return yt;
        }) : (0, module.exports) ? (module.exports = yt, module.exports.jsPDF = yt) : pt.jsPDF = yt, yt;
    }("undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")());
    /** @preserve
   * jsPDF - PDF Document creation from JavaScript
   * Version 1.4.1 Built on 2018-06-06T07:49:34.040Z
   *                           CommitID 3233f44044
   *
   * Copyright (c) 2010-2016 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
   *               2010 Aaron Spike, https://github.com/acspike
   *               2012 Willow Systems Corporation, willow-systems.com
   *               2012 Pablo Hess, https://github.com/pablohess
   *               2012 Florian Jenett, https://github.com/fjenett
   *               2013 Warren Weckesser, https://github.com/warrenweckesser
   *               2013 Youssef Beddad, https://github.com/lifof
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2013 Stefan Slonevskiy, https://github.com/stefslon
   *               2013 Jeremy Morel, https://github.com/jmorel
   *               2013 Christoph Hartmann, https://github.com/chris-rock
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Makes, https://github.com/dollaruw
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Steven Spungin, https://github.com/Flamenco
   *               2014 Kenneth Glassey, https://github.com/Gavvers
   *
   * Licensed under the MIT License
   *
   * Contributor(s):
   *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
   *    kim3er, mfo, alnorth, Flamenco
   */ /**
   * jsPDF AcroForm Plugin Copyright (c) 2016 Alexander Weidt,
   * https://github.com/BiggA94
   * 
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */ !function(n, t) {
        var l, a, e = 1, r = function(t, e) {
            t.prototype = Object.create(e.prototype), t.prototype.constructor = t;
        }, s = function(t) {
            return t * (e / 1);
        }, h = function(t) {
            var e = new I, n = N.internal.getHeight(t) || 0, r = N.internal.getWidth(t) || 0;
            return e.BBox = [
                0,
                0,
                r.toFixed(2),
                n.toFixed(2)
            ], e;
        }, i = function(t, e, n) {
            t = t || 0;
            var r = 1;
            if (r <<= e - 1, 1 == (n = n || 1)) t = t | r;
            else t = t & ~r;
            return t;
        }, o = function(t, e, n) {
            n = n || 1.3, t = t || 0;
            return 1 == e.readOnly && (t = i(t, 1)), 1 == e.required && (t = i(t, 2)), 1 == e.noExport && (t = i(t, 3)), 1 == e.multiline && (t = i(t, 13)), e.password && (t = i(t, 14)), e.noToggleToOff && (t = i(t, 15)), e.radio && (t = i(t, 16)), e.pushbutton && (t = i(t, 17)), e.combo && (t = i(t, 18)), e.edit && (t = i(t, 19)), e.sort && (t = i(t, 20)), e.fileSelect && 1.4 <= n && (t = i(t, 21)), e.multiSelect && 1.4 <= n && (t = i(t, 22)), e.doNotSpellCheck && 1.4 <= n && (t = i(t, 23)), 1 == e.doNotScroll && 1.4 <= n && (t = i(t, 24)), e.richText && 1.4 <= n && (t = i(t, 25)), t;
        }, u = function(t) {
            var e = t[0], n = t[1], r = t[2], i = t[3], o = {};
            return Array.isArray(e) ? (e[0] = s(e[0]), e[1] = s(e[1]), e[2] = s(e[2]), e[3] = s(e[3])) : (e = s(e), n = s(n), r = s(r), i = s(i)), o.lowerLeft_X = e || 0, o.lowerLeft_Y = s(a) - n - i || 0, o.upperRight_X = e + r || 0, o.upperRight_Y = s(a) - n || 0, [
                o.lowerLeft_X.toFixed(2),
                o.lowerLeft_Y.toFixed(2),
                o.upperRight_X.toFixed(2),
                o.upperRight_Y.toFixed(2)
            ];
        }, f = function(t) {
            if (t.appearanceStreamContent) return t.appearanceStreamContent;
            if (t.V || t.DV) {
                var e = [], n = t.V || t.DV, r = c(t, n);
                e.push("/Tx BMC"), e.push("q"), e.push("/F1 " + r.fontSize.toFixed(2) + " Tf"), e.push("1 0 0 1 0 0 Tm"), e.push("BT"), e.push(r.text), e.push("ET"), e.push("Q"), e.push("EMC");
                var i = new h(t);
                return i.stream = e.join("\n"), i;
            }
        }, c = function(t, e, i, n) {
            n = n || 12, i = i || "helvetica";
            var r = {
                text: "",
                fontSize: ""
            }, o = (e = ")" == (e = "(" == e.substr(0, 1) ? e.substr(1) : e).substr(e.length - 1) ? e.substr(0, e.length - 1) : e).split(" "), a = n, s = N.internal.getHeight(t) || 0;
            s = s < 0 ? -s : s;
            var h = N.internal.getWidth(t) || 0;
            h = h < 0 ? -h : h;
            var c = function(t, e, n) {
                if (t + 1 < o.length) {
                    var r = e + " " + o[t + 1];
                    return A(r, n + "px", i).width <= h - 4;
                }
                return !1;
            };
            a++;
            t: for(;;){
                e = "";
                var l = A("3", --a + "px", i).height, u = t.multiline ? s - a : (s - l) / 2, f = -2, d = u += 2, p = 0, g = 0, m = 0;
                if (a <= 0) {
                    a = 12, e = "(...) Tj\n", e += "% Width of Text: " + A(e, "1px").width + ", FieldWidth:" + h + "\n";
                    break;
                }
                m = A(o[0] + " ", a + "px", i).width;
                var w = "", y = 0;
                for(var v in o){
                    w = " " == (w += o[v] + " ").substr(w.length - 1) ? w.substr(0, w.length - 1) : w;
                    var b = parseInt(v);
                    m = A(w + " ", a + "px", i).width;
                    var x = c(b, w, a), S = v >= o.length - 1;
                    if (!x || S) {
                        if (x || S) {
                            if (S) g = b;
                            else if (t.multiline && s < (l + 2) * (y + 2) + 2) continue t;
                        } else {
                            if (!t.multiline) continue t;
                            if (s < (l + 2) * (y + 2) + 2) continue t;
                            g = b;
                        }
                        for(var k = "", _ = p; _ <= g; _++)k += o[_] + " ";
                        switch(k = " " == k.substr(k.length - 1) ? k.substr(0, k.length - 1) : k, m = A(k, a + "px", i).width, t.Q){
                            case 2:
                                f = h - m - 2;
                                break;
                            case 1:
                                f = (h - m) / 2;
                                break;
                            case 0:
                            default:
                                f = 2;
                        }
                        e += f.toFixed(2) + " " + d.toFixed(2) + " Td\n", e += "(" + k + ") Tj\n", e += -f.toFixed(2) + " 0 Td\n", d = -(a + 2), m = 0, p = g + 1, y++, w = "";
                    } else w += " ";
                }
                break;
            }
            return r.text = e, r.fontSize = a, r;
        }, A = function(t, e, n) {
            n = n || "helvetica";
            var r = l.internal.getFont(n), i = l.getStringUnitWidth(t, {
                font: r,
                fontSize: parseFloat(e),
                charSpace: 0
            }) * parseFloat(e);
            return {
                height: l.getStringUnitWidth("3", {
                    font: r,
                    fontSize: parseFloat(e),
                    charSpace: 0
                }) * parseFloat(e) * 1.5,
                width: i
            };
        }, d = {
            fields: [],
            xForms: [],
            acroFormDictionaryRoot: null,
            printedOut: !1,
            internal: null,
            isInitialized: !1
        }, p = function() {
            for(var t in l.internal.acroformPlugin.acroFormDictionaryRoot.Fields){
                var e = l.internal.acroformPlugin.acroFormDictionaryRoot.Fields[t];
                e.hasAnnotation && m.call(l, e);
            }
        }, g = function(t) {
            l.internal.acroformPlugin.printedOut && (l.internal.acroformPlugin.printedOut = !1, l.internal.acroformPlugin.acroFormDictionaryRoot = null), l.internal.acroformPlugin.acroFormDictionaryRoot || x.call(l), l.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(t);
        }, m = function(t) {
            var e = {
                type: "reference",
                object: t
            };
            l.annotationPlugin.annotations[l.internal.getPageInfo(t.page).pageNumber].push(e);
        }, w = function() {
            void 0 !== l.internal.acroformPlugin.acroFormDictionaryRoot ? l.internal.write("/AcroForm " + l.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R") : console.log("Root missing...");
        }, y = function() {
            l.internal.events.unsubscribe(l.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete l.internal.acroformPlugin.acroFormDictionaryRoot._eventID, l.internal.acroformPlugin.printedOut = !0;
        }, v = function(t) {
            var e = !t;
            t || (l.internal.newObjectDeferredBegin(l.internal.acroformPlugin.acroFormDictionaryRoot.objId), l.internal.out(l.internal.acroformPlugin.acroFormDictionaryRoot.getString()));
            t = t || l.internal.acroformPlugin.acroFormDictionaryRoot.Kids;
            for(var n in t){
                var r = t[n], i = r.Rect;
                r.Rect && (r.Rect = u.call(this, r.Rect)), l.internal.newObjectDeferredBegin(r.objId);
                var o = r.objId + " 0 obj\n<<\n";
                if ("object" === (void 0 === r ? "undefined" : vt(r)) && "function" == typeof r.getContent && (o += r.getContent()), r.Rect = i, r.hasAppearanceStream && !r.appearanceStreamContent) {
                    var a = f.call(this, r);
                    o += "/AP << /N " + a + " >>\n", l.internal.acroformPlugin.xForms.push(a);
                }
                if (r.appearanceStreamContent) {
                    for(var s in o += "/AP << ", r.appearanceStreamContent){
                        var h = r.appearanceStreamContent[s];
                        if (o += "/" + s + " ", o += "<< ", 1 <= Object.keys(h).length || Array.isArray(h)) for(var n in h){
                            var c;
                            "function" == typeof (c = h[n]) && (c = c.call(this, r)), o += "/" + n + " " + c + " ", 0 <= l.internal.acroformPlugin.xForms.indexOf(c) || l.internal.acroformPlugin.xForms.push(c);
                        }
                        else "function" == typeof (c = h) && (c = c.call(this, r)), o += "/" + n + " " + c + " \n", 0 <= l.internal.acroformPlugin.xForms.indexOf(c) || l.internal.acroformPlugin.xForms.push(c);
                        o += " >>\n";
                    }
                    o += ">>\n";
                }
                o += ">>\nendobj\n", l.internal.out(o);
            }
            e && b.call(this, l.internal.acroformPlugin.xForms);
        }, b = function(t) {
            for(var e in t){
                var n = e, r = t[e];
                l.internal.newObjectDeferredBegin(r && r.objId);
                var i = "";
                "object" === (void 0 === r ? "undefined" : vt(r)) && "function" == typeof r.getString && (i = r.getString()), l.internal.out(i), delete t[n];
            }
        }, x = function() {
            if (void 0 !== this.internal && (void 0 === this.internal.acroformPlugin || !1 === this.internal.acroformPlugin.isInitialized)) {
                if (l = this, T.FieldNum = 0, this.internal.acroformPlugin = JSON.parse(JSON.stringify(d)), this.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("Exception while creating AcroformDictionary");
                e = l.internal.scaleFactor, a = l.internal.pageSize.getHeight(), l.internal.acroformPlugin.acroFormDictionaryRoot = new C, l.internal.acroformPlugin.acroFormDictionaryRoot._eventID = l.internal.events.subscribe("postPutResources", y), l.internal.events.subscribe("buildDocument", p), l.internal.events.subscribe("putCatalog", w), l.internal.events.subscribe("postPutPages", v), l.internal.acroformPlugin.isInitialized = !0;
            }
        }, S = function(t) {
            if (Array.isArray(t)) {
                var e = " [";
                for(var n in t)e += t[n].toString(), e += n < t.length - 1 ? " " : "";
                return e += "]";
            }
        }, k = function(t) {
            return 0 !== (t = t || "").indexOf("(") && (t = "(" + t), ")" != t.substring(t.length - 1) && (t += ")"), t;
        }, _ = function() {
            var t;
            Object.defineProperty(this, "objId", {
                get: function() {
                    return t || (t = l.internal.newObjectDeferred()), t || console.log("Couldn't create Object ID"), t;
                },
                configurable: !1
            });
        };
        _.prototype.toString = function() {
            return this.objId + " 0 R";
        }, _.prototype.getString = function() {
            var t = this.objId + " 0 obj\n<<";
            return t += this.getContent() + ">>\n", this.stream && (t += "stream\n", t += this.stream, t += "\nendstream\n"), t += "endobj\n";
        }, _.prototype.getContent = function() {
            var t = "";
            return t += function(t) {
                var e = "", n = Object.keys(t).filter(function(t) {
                    return "content" != t && "appearanceStreamContent" != t && "_" != t.substring(0, 1);
                });
                for(var r in n){
                    var i = n[r], o = t[i];
                    o && (Array.isArray(o) ? e += "/" + i + " " + S(o) + "\n" : e += o instanceof _ ? "/" + i + " " + o.objId + " 0 R\n" : "/" + i + " " + o + "\n");
                }
                return e;
            }(this);
        };
        var I = function() {
            var e;
            _.call(this), this.Type = "/XObject", this.Subtype = "/Form", this.FormType = 1, this.BBox, this.Matrix, this.Resources = "2 0 R", this.PieceInfo, Object.defineProperty(this, "Length", {
                enumerable: !0,
                get: function() {
                    return void 0 !== e ? e.length : 0;
                }
            }), Object.defineProperty(this, "stream", {
                enumerable: !1,
                set: function(t) {
                    e = t.trim();
                },
                get: function() {
                    return e || null;
                }
            });
        };
        r(I, _);
        var C = function() {
            _.call(this);
            var t = [];
            Object.defineProperty(this, "Kids", {
                enumerable: !1,
                configurable: !0,
                get: function() {
                    return 0 < t.length ? t : void 0;
                }
            }), Object.defineProperty(this, "Fields", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return t;
                }
            }), this.DA;
        };
        r(C, _);
        var T = function t() {
            var e;
            _.call(this), Object.defineProperty(this, "Rect", {
                enumerable: !0,
                configurable: !1,
                get: function() {
                    if (e) return e;
                },
                set: function(t) {
                    e = t;
                }
            });
            var n, r, i, o, a = "";
            Object.defineProperty(this, "FT", {
                enumerable: !0,
                set: function(t) {
                    a = t;
                },
                get: function() {
                    return a;
                }
            }), Object.defineProperty(this, "T", {
                enumerable: !0,
                configurable: !1,
                set: function(t) {
                    n = t;
                },
                get: function() {
                    if (!n || n.length < 1) {
                        if (this instanceof j) return;
                        return "(FieldObject" + t.FieldNum++ + ")";
                    }
                    return "(" == n.substring(0, 1) && n.substring(n.length - 1) ? n : "(" + n + ")";
                }
            }), Object.defineProperty(this, "DA", {
                enumerable: !0,
                get: function() {
                    if (r) return "(" + r + ")";
                },
                set: function(t) {
                    r = t;
                }
            }), Object.defineProperty(this, "DV", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    if (i) return i;
                },
                set: function(t) {
                    i = t;
                }
            }), Object.defineProperty(this, "V", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    if (o) return o;
                },
                set: function(t) {
                    o = t;
                }
            }), Object.defineProperty(this, "Type", {
                enumerable: !0,
                get: function() {
                    return this.hasAnnotation ? "/Annot" : null;
                }
            }), Object.defineProperty(this, "Subtype", {
                enumerable: !0,
                get: function() {
                    return this.hasAnnotation ? "/Widget" : null;
                }
            }), this.BG, Object.defineProperty(this, "hasAnnotation", {
                enumerable: !1,
                get: function() {
                    return !!(this.Rect || this.BC || this.BG);
                }
            }), Object.defineProperty(this, "hasAppearanceStream", {
                enumerable: !1,
                configurable: !0,
                writable: !0
            }), Object.defineProperty(this, "page", {
                enumerable: !1,
                configurable: !0,
                writable: !0
            });
        };
        r(T, _);
        var F = function() {
            T.call(this), this.FT = "/Ch", this.Opt = [], this.V = "()", this.TI = 0;
            var e = !1;
            Object.defineProperty(this, "combo", {
                enumerable: !1,
                get: function() {
                    return e;
                },
                set: function(t) {
                    e = t;
                }
            }), Object.defineProperty(this, "edit", {
                enumerable: !0,
                set: function(t) {
                    1 == t ? (this._edit = !0, this.combo = !0) : this._edit = !1;
                },
                get: function() {
                    return !!this._edit && this._edit;
                },
                configurable: !1
            }), this.hasAppearanceStream = !0;
        };
        r(F, T);
        var P = function() {
            F.call(this), this.combo = !1;
        };
        r(P, F);
        var E = function() {
            P.call(this), this.combo = !0;
        };
        r(E, P);
        var q = function() {
            E.call(this), this.edit = !0;
        };
        r(q, E);
        var O = function() {
            T.call(this), this.FT = "/Btn";
        };
        r(O, T);
        var B = function() {
            O.call(this);
            var e = !0;
            Object.defineProperty(this, "pushbutton", {
                enumerable: !1,
                get: function() {
                    return e;
                },
                set: function(t) {
                    e = t;
                }
            });
        };
        r(B, O);
        var R = function() {
            O.call(this);
            var e = !0;
            Object.defineProperty(this, "radio", {
                enumerable: !1,
                get: function() {
                    return e;
                },
                set: function(t) {
                    e = t;
                }
            });
            var n, t = [];
            Object.defineProperty(this, "Kids", {
                enumerable: !0,
                get: function() {
                    if (0 < t.length) return t;
                }
            }), Object.defineProperty(this, "__Kids", {
                get: function() {
                    return t;
                }
            }), Object.defineProperty(this, "noToggleToOff", {
                enumerable: !1,
                get: function() {
                    return n;
                },
                set: function(t) {
                    n = t;
                }
            });
        };
        r(R, O);
        var j = function(t, e) {
            T.call(this), this.Parent = t, this._AppearanceType = N.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(e), this.F = i(this.F, 3, 1), this.MK = this._AppearanceType.createMK(), this.AS = "/Off", this._Name = e;
        };
        r(j, T), R.prototype.setAppearance = function(t) {
            if ("createAppearanceStream" in t && "createMK" in t) for(var e in this.__Kids){
                var n = this.__Kids[e];
                n.appearanceStreamContent = t.createAppearanceStream(n._Name), n.MK = t.createMK();
            }
            else console.log("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
        }, R.prototype.createOption = function(t) {
            this.__Kids.length;
            var e = new j(this, t);
            return this.__Kids.push(e), n.addField(e), e;
        };
        var D = function() {
            O.call(this), this.appearanceStreamContent = N.CheckBox.createAppearanceStream(), this.MK = N.CheckBox.createMK(), this.AS = "/On", this.V = "/On";
        };
        r(D, O);
        var M = function() {
            var e, n;
            T.call(this), this.DA = N.createDefaultAppearanceStream(), this.F = 4, Object.defineProperty(this, "V", {
                get: function() {
                    return e ? k(e) : e;
                },
                enumerable: !0,
                set: function(t) {
                    e = t;
                }
            }), Object.defineProperty(this, "DV", {
                get: function() {
                    return n ? k(n) : n;
                },
                enumerable: !0,
                set: function(t) {
                    n = t;
                }
            });
            var r = !1;
            Object.defineProperty(this, "multiline", {
                enumerable: !1,
                get: function() {
                    return r;
                },
                set: function(t) {
                    r = t;
                }
            });
            var i = !1;
            Object.defineProperty(this, "fileSelect", {
                enumerable: !1,
                get: function() {
                    return i;
                },
                set: function(t) {
                    i = t;
                }
            });
            var o = !1;
            Object.defineProperty(this, "doNotSpellCheck", {
                enumerable: !1,
                get: function() {
                    return o;
                },
                set: function(t) {
                    o = t;
                }
            });
            var a = !1;
            Object.defineProperty(this, "doNotScroll", {
                enumerable: !1,
                get: function() {
                    return a;
                },
                set: function(t) {
                    a = t;
                }
            });
            var s = !1;
            Object.defineProperty(this, "MaxLen", {
                enumerable: !0,
                get: function() {
                    return s;
                },
                set: function(t) {
                    s = t;
                }
            }), Object.defineProperty(this, "hasAppearanceStream", {
                enumerable: !1,
                get: function() {
                    return this.V || this.DV;
                }
            });
        };
        r(M, T);
        var U = function() {
            M.call(this);
            var e = !0;
            Object.defineProperty(this, "password", {
                enumerable: !1,
                get: function() {
                    return e;
                },
                set: function(t) {
                    e = t;
                }
            });
        };
        r(U, M);
        var N = {
            CheckBox: {
                createAppearanceStream: function() {
                    return {
                        N: {
                            On: N.CheckBox.YesNormal
                        },
                        D: {
                            On: N.CheckBox.YesPushDown,
                            Off: N.CheckBox.OffPushDown
                        }
                    };
                },
                createMK: function() {
                    return "<< /CA (3)>>";
                },
                YesPushDown: function(t) {
                    var e = h(t), n = [], r = l.internal.getFont("zapfdingbats", "normal").id;
                    t.Q = 1;
                    var i = c(t, "3", "ZapfDingbats", 50);
                    return n.push("0.749023 g"), n.push("0 0 " + N.internal.getWidth(t).toFixed(2) + " " + N.internal.getHeight(t).toFixed(2) + " re"), n.push("f"), n.push("BMC"), n.push("q"), n.push("0 0 1 rg"), n.push("/" + r + " " + i.fontSize.toFixed(2) + " Tf 0 g"), n.push("BT"), n.push(i.text), n.push("ET"), n.push("Q"), n.push("EMC"), e.stream = n.join("\n"), e;
                },
                YesNormal: function(t) {
                    var e = h(t), n = l.internal.getFont("zapfdingbats", "normal").id, r = [];
                    t.Q = 1;
                    var i = N.internal.getHeight(t), o = N.internal.getWidth(t), a = c(t, "3", "ZapfDingbats", .9 * i);
                    return r.push("1 g"), r.push("0 0 " + o.toFixed(2) + " " + i.toFixed(2) + " re"), r.push("f"), r.push("q"), r.push("0 0 1 rg"), r.push("0 0 " + (o - 1).toFixed(2) + " " + (i - 1).toFixed(2) + " re"), r.push("W"), r.push("n"), r.push("0 g"), r.push("BT"), r.push("/" + n + " " + a.fontSize.toFixed(2) + " Tf 0 g"), r.push(a.text), r.push("ET"), r.push("Q"), e.stream = r.join("\n"), e;
                },
                OffPushDown: function(t) {
                    var e = h(t), n = [];
                    return n.push("0.749023 g"), n.push("0 0 " + N.internal.getWidth(t).toFixed(2) + " " + N.internal.getHeight(t).toFixed(2) + " re"), n.push("f"), e.stream = n.join("\n"), e;
                }
            },
            RadioButton: {
                Circle: {
                    createAppearanceStream: function(t) {
                        var e = {
                            D: {
                                Off: N.RadioButton.Circle.OffPushDown
                            },
                            N: {}
                        };
                        return e.N[t] = N.RadioButton.Circle.YesNormal, e.D[t] = N.RadioButton.Circle.YesPushDown, e;
                    },
                    createMK: function() {
                        return "<< /CA (l)>>";
                    },
                    YesNormal: function(t) {
                        var e = h(t), n = [], r = N.internal.getWidth(t) <= N.internal.getHeight(t) ? N.internal.getWidth(t) / 4 : N.internal.getHeight(t) / 4;
                        r *= .9;
                        var i = N.internal.Bezier_C;
                        return n.push("q"), n.push("1 0 0 1 " + N.internal.getWidth(t) / 2 + " " + N.internal.getHeight(t) / 2 + " cm"), n.push(r + " 0 m"), n.push(r + " " + r * i + " " + r * i + " " + r + " 0 " + r + " c"), n.push("-" + r * i + " " + r + " -" + r + " " + r * i + " -" + r + " 0 c"), n.push("-" + r + " -" + r * i + " -" + r * i + " -" + r + " 0 -" + r + " c"), n.push(r * i + " -" + r + " " + r + " -" + r * i + " " + r + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
                    },
                    YesPushDown: function(t) {
                        var e = h(t), n = [], r = N.internal.getWidth(t) <= N.internal.getHeight(t) ? N.internal.getWidth(t) / 4 : N.internal.getHeight(t) / 4, i = 2 * (r *= .9), o = i * N.internal.Bezier_C, a = r * N.internal.Bezier_C;
                        return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + (N.internal.getWidth(t) / 2).toFixed(2) + " " + (N.internal.getHeight(t) / 2).toFixed(2) + " cm"), n.push(i + " 0 m"), n.push(i + " " + o + " " + o + " " + i + " 0 " + i + " c"), n.push("-" + o + " " + i + " -" + i + " " + o + " -" + i + " 0 c"), n.push("-" + i + " -" + o + " -" + o + " -" + i + " 0 -" + i + " c"), n.push(o + " -" + i + " " + i + " -" + o + " " + i + " 0 c"), n.push("f"), n.push("Q"), n.push("0 g"), n.push("q"), n.push("1 0 0 1 " + (N.internal.getWidth(t) / 2).toFixed(2) + " " + (N.internal.getHeight(t) / 2).toFixed(2) + " cm"), n.push(r + " 0 m"), n.push(r + " " + a + " " + a + " " + r + " 0 " + r + " c"), n.push("-" + a + " " + r + " -" + r + " " + a + " -" + r + " 0 c"), n.push("-" + r + " -" + a + " -" + a + " -" + r + " 0 -" + r + " c"), n.push(a + " -" + r + " " + r + " -" + a + " " + r + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
                    },
                    OffPushDown: function(t) {
                        var e = h(t), n = [], r = N.internal.getWidth(t) <= N.internal.getHeight(t) ? N.internal.getWidth(t) / 4 : N.internal.getHeight(t) / 4, i = 2 * (r *= .9), o = i * N.internal.Bezier_C;
                        return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + (N.internal.getWidth(t) / 2).toFixed(2) + " " + (N.internal.getHeight(t) / 2).toFixed(2) + " cm"), n.push(i + " 0 m"), n.push(i + " " + o + " " + o + " " + i + " 0 " + i + " c"), n.push("-" + o + " " + i + " -" + i + " " + o + " -" + i + " 0 c"), n.push("-" + i + " -" + o + " -" + o + " -" + i + " 0 -" + i + " c"), n.push(o + " -" + i + " " + i + " -" + o + " " + i + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
                    }
                },
                Cross: {
                    createAppearanceStream: function(t) {
                        var e = {
                            D: {
                                Off: N.RadioButton.Cross.OffPushDown
                            },
                            N: {}
                        };
                        return e.N[t] = N.RadioButton.Cross.YesNormal, e.D[t] = N.RadioButton.Cross.YesPushDown, e;
                    },
                    createMK: function() {
                        return "<< /CA (8)>>";
                    },
                    YesNormal: function(t) {
                        var e = h(t), n = [], r = N.internal.calculateCross(t);
                        return n.push("q"), n.push("1 1 " + (N.internal.getWidth(t) - 2).toFixed(2) + " " + (N.internal.getHeight(t) - 2).toFixed(2) + " re"), n.push("W"), n.push("n"), n.push(r.x1.x.toFixed(2) + " " + r.x1.y.toFixed(2) + " m"), n.push(r.x2.x.toFixed(2) + " " + r.x2.y.toFixed(2) + " l"), n.push(r.x4.x.toFixed(2) + " " + r.x4.y.toFixed(2) + " m"), n.push(r.x3.x.toFixed(2) + " " + r.x3.y.toFixed(2) + " l"), n.push("s"), n.push("Q"), e.stream = n.join("\n"), e;
                    },
                    YesPushDown: function(t) {
                        var e = h(t), n = N.internal.calculateCross(t), r = [];
                        return r.push("0.749023 g"), r.push("0 0 " + N.internal.getWidth(t).toFixed(2) + " " + N.internal.getHeight(t).toFixed(2) + " re"), r.push("f"), r.push("q"), r.push("1 1 " + (N.internal.getWidth(t) - 2).toFixed(2) + " " + (N.internal.getHeight(t) - 2).toFixed(2) + " re"), r.push("W"), r.push("n"), r.push(n.x1.x.toFixed(2) + " " + n.x1.y.toFixed(2) + " m"), r.push(n.x2.x.toFixed(2) + " " + n.x2.y.toFixed(2) + " l"), r.push(n.x4.x.toFixed(2) + " " + n.x4.y.toFixed(2) + " m"), r.push(n.x3.x.toFixed(2) + " " + n.x3.y.toFixed(2) + " l"), r.push("s"), r.push("Q"), e.stream = r.join("\n"), e;
                    },
                    OffPushDown: function(t) {
                        var e = h(t), n = [];
                        return n.push("0.749023 g"), n.push("0 0 " + N.internal.getWidth(t).toFixed(2) + " " + N.internal.getHeight(t).toFixed(2) + " re"), n.push("f"), e.stream = n.join("\n"), e;
                    }
                }
            },
            createDefaultAppearanceStream: function(t) {
                return "/F1 0 Tf 0 g";
            }
        };
        N.internal = {
            Bezier_C: .551915024494,
            calculateCross: function(t) {
                var e, n, r = N.internal.getWidth(t), i = N.internal.getHeight(t), o = (n = i) < (e = r) ? n : e;
                return {
                    x1: {
                        x: (r - o) / 2,
                        y: (i - o) / 2 + o
                    },
                    x2: {
                        x: (r - o) / 2 + o,
                        y: (i - o) / 2
                    },
                    x3: {
                        x: (r - o) / 2,
                        y: (i - o) / 2
                    },
                    x4: {
                        x: (r - o) / 2 + o,
                        y: (i - o) / 2 + o
                    }
                };
            }
        }, N.internal.getWidth = function(t) {
            var e = 0;
            return "object" === (void 0 === t ? "undefined" : vt(t)) && (e = s(t.Rect[2])), e;
        }, N.internal.getHeight = function(t) {
            var e = 0;
            return "object" === (void 0 === t ? "undefined" : vt(t)) && (e = s(t.Rect[3])), e;
        }, n.addField = function(t) {
            return x.call(this), t instanceof M ? this.addTextField.call(this, t) : t instanceof F ? this.addChoiceField.call(this, t) : t instanceof O ? this.addButton.call(this, t) : t instanceof j ? g.call(this, t) : t && g.call(this, t), t.page = l.internal.getCurrentPageInfo().pageNumber, this;
        }, n.addButton = function(t) {
            x.call(this);
            var e = t || new T;
            e.FT = "/Btn", e.Ff = o(e.Ff, t, l.internal.getPDFVersion()), g.call(this, e);
        }, n.addTextField = function(t) {
            x.call(this);
            var e = t || new T;
            e.FT = "/Tx", e.Ff = o(e.Ff, t, l.internal.getPDFVersion()), g.call(this, e);
        }, n.addChoiceField = function(t) {
            x.call(this);
            var e = t || new T;
            e.FT = "/Ch", e.Ff = o(e.Ff, t, l.internal.getPDFVersion()), g.call(this, e);
        }, "object" == (void 0 === t ? "undefined" : vt(t)) && (t.ChoiceField = F, t.ListBox = P, t.ComboBox = E, t.EditBox = q, t.Button = O, t.PushButton = B, t.RadioButton = R, t.CheckBox = D, t.TextField = M, t.PasswordField = U, t.AcroForm = {
            Appearance: N
        }), n.AcroFormChoiceField = F, n.AcroFormListBox = P, n.AcroFormComboBox = E, n.AcroFormEditBox = q, n.AcroFormButton = O, n.AcroFormPushButton = B, n.AcroFormRadioButton = R, n.AcroFormCheckBox = D, n.AcroFormTextField = M, n.AcroFormPasswordField = U, n.AcroForm = {
            ChoiceField: F,
            ListBox: P,
            ComboBox: E,
            EditBox: q,
            Button: O,
            PushButton: B,
            RadioButton: R,
            CheckBox: D,
            TextField: M,
            PasswordField: U
        };
    }($.API, "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global), $.API.addHTML = function(t, p, g, s, m) {
        if ("undefined" == typeof html2canvas && "undefined" == typeof rasterizeHTML) throw new Error("You need either https://github.com/niklasvh/html2canvas or https://github.com/cburgmer/rasterizeHTML.js");
        "number" != typeof p && (s = p, m = g), "function" == typeof s && (m = s, s = null), "function" != typeof m && (m = function() {});
        var e = this.internal, w = e.scaleFactor, y = e.pageSize.getWidth(), v = e.pageSize.getHeight();
        if ((s = s || {}).onrendered = (function(h) {
            p = parseInt(p) || 0, g = parseInt(g) || 0;
            var t = s.dim || {}, c = Object.assign({
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                useFor: "content"
            }, s.margin), e = t.h || Math.min(v, h.height / w), l = t.w || Math.min(y, h.width / w) - p, u = s.format || "JPEG", f = s.imageCompression || "SLOW";
            if (h.height > v - c.top - c.bottom && s.pagesplit) {
                var d = function(t, e, n, r, i) {
                    var o = document.createElement("canvas");
                    o.height = i, o.width = r;
                    var a = o.getContext("2d");
                    return a.mozImageSmoothingEnabled = !1, a.webkitImageSmoothingEnabled = !1, a.msImageSmoothingEnabled = !1, a.imageSmoothingEnabled = !1, a.fillStyle = s.backgroundColor || "#ffffff", a.fillRect(0, 0, r, i), a.drawImage(t, e, n, r, i, 0, 0, r, i), o;
                }, n = (function() {
                    for(var t, e, n = 0, r = 0, i = {}, o = !1;;){
                        var a;
                        if (r = 0, i.top = 0 !== n ? c.top : g, i.left = 0 !== n ? c.left : p, o = (y - c.left - c.right) * w < h.width, "content" === c.useFor ? 0 === n ? (t = Math.min((y - c.left) * w, h.width), e = Math.min((v - c.top) * w, h.height - n)) : (t = Math.min(y * w, h.width), e = Math.min(v * w, h.height - n), i.top = 0) : (t = Math.min((y - c.left - c.right) * w, h.width), e = Math.min((v - c.bottom - c.top) * w, h.height - n)), o) for(;;){
                            "content" === c.useFor && (0 === r ? t = Math.min((y - c.left) * w, h.width) : (t = Math.min(y * w, h.width - r), i.left = 0));
                            var s = [
                                a = d(h, r, n, t, e),
                                i.left,
                                i.top,
                                a.width / w,
                                a.height / w,
                                u,
                                null,
                                f
                            ];
                            if (this.addImage.apply(this, s), (r += t) >= h.width) break;
                            this.addPage();
                        }
                        else s = [
                            a = d(h, 0, n, t, e),
                            i.left,
                            i.top,
                            a.width / w,
                            a.height / w,
                            u,
                            null,
                            f
                        ], this.addImage.apply(this, s);
                        if ((n += e) >= h.height) break;
                        this.addPage();
                    }
                    m(l, n, null, s);
                }).bind(this);
                if ("CANVAS" === h.nodeName) {
                    var r = new Image;
                    r.onload = n, r.src = h.toDataURL("image/png"), h = r;
                } else n();
            } else {
                var i = Math.random().toString(35), o = [
                    h,
                    p,
                    g,
                    l,
                    e,
                    u,
                    i,
                    f
                ];
                this.addImage.apply(this, o), m(l, e, i, o);
            }
        }).bind(this), "undefined" != typeof html2canvas && !s.rstz) return html2canvas(t, s);
        if ("undefined" != typeof rasterizeHTML) {
            var n = "drawDocument";
            return "string" == typeof t && (n = /^http/.test(t) ? "drawURL" : "drawHTML"), s.width = s.width || y * w, rasterizeHTML[n](t, void 0, s).then(function(t) {
                s.onrendered(t.image);
            }, function(t) {
                m(null, t);
            });
        }
        return null;
    }, /** @preserve
   * jsPDF addImage plugin
   * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
   *               2013 Chris Dowling, https://github.com/gingerchris
   *               2013 Trinh Ho, https://github.com/ineedfat
   *               2013 Edwin Alejandro Perez, https://github.com/eaparango
   *               2013 Norah Smith, https://github.com/burnburnrocket
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   */ function(b) {
        var x = "addImage_", h = {
            PNG: [
                [
                    137,
                    80,
                    78,
                    71
                ]
            ],
            TIFF: [
                [
                    77,
                    77,
                    0,
                    42
                ],
                [
                    73,
                    73,
                    42,
                    0
                ]
            ],
            JPEG: [
                [
                    255,
                    216,
                    255,
                    224,
                    void 0,
                    void 0,
                    74,
                    70,
                    73,
                    70,
                    0
                ],
                [
                    255,
                    216,
                    255,
                    225,
                    void 0,
                    void 0,
                    69,
                    120,
                    105,
                    102,
                    0,
                    0
                ]
            ],
            JPEG2000: [
                [
                    0,
                    0,
                    0,
                    12,
                    106,
                    80,
                    32,
                    32
                ]
            ],
            GIF87a: [
                [
                    71,
                    73,
                    70,
                    56,
                    55,
                    97
                ]
            ],
            GIF89a: [
                [
                    71,
                    73,
                    70,
                    56,
                    57,
                    97
                ]
            ],
            BMP: [
                [
                    66,
                    77
                ],
                [
                    66,
                    65
                ],
                [
                    67,
                    73
                ],
                [
                    67,
                    80
                ],
                [
                    73,
                    67
                ],
                [
                    80,
                    84
                ]
            ]
        };
        b.getImageFileTypeByImageData = function(t, e) {
            var n, r;
            e = e || "UNKNOWN";
            var i, o, a, s = "UNKNOWN";
            for(a in h)for(i = h[a], n = 0; n < i.length; n += 1){
                for(o = !0, r = 0; r < i[n].length; r += 1)if (void 0 !== i[n][r] && i[n][r] !== t.charCodeAt(r)) {
                    o = !1;
                    break;
                }
                if (!0 === o) {
                    s = a;
                    break;
                }
            }
            return "UNKOWN" === s && "UNKNOWN" !== e && (console.warn('FileType of Image not recognized. Processing image as "' + e + '".'), s = e), s;
        };
        var n = function t(e) {
            var n = this.internal.newObject(), r = this.internal.write, i = this.internal.putStream;
            if (e.n = n, r("<</Type /XObject"), r("/Subtype /Image"), r("/Width " + e.w), r("/Height " + e.h), e.cs === this.color_spaces.INDEXED ? r("/ColorSpace [/Indexed /DeviceRGB " + (e.pal.length / 3 - 1) + " " + ("smask" in e ? n + 2 : n + 1) + " 0 R]") : (r("/ColorSpace /" + e.cs), e.cs === this.color_spaces.DEVICE_CMYK && r("/Decode [1 0 1 0 1 0 1 0]")), r("/BitsPerComponent " + e.bpc), "f" in e && r("/Filter /" + e.f), "dp" in e && r("/DecodeParms <<" + e.dp + ">>"), "trns" in e && e.trns.constructor == Array) {
                for(var o = "", a = 0, s = e.trns.length; a < s; a++)o += e.trns[a] + " " + e.trns[a] + " ";
                r("/Mask [" + o + "]");
            }
            if ("smask" in e && r("/SMask " + (n + 1) + " 0 R"), r("/Length " + e.data.length + ">>"), i(e.data), r("endobj"), "smask" in e) {
                var h = "/Predictor " + e.p + " /Colors 1 /BitsPerComponent " + e.bpc + " /Columns " + e.w, c = {
                    w: e.w,
                    h: e.h,
                    cs: "DeviceGray",
                    bpc: e.bpc,
                    dp: h,
                    data: e.smask
                };
                "f" in e && (c.f = e.f), t.call(this, c);
            }
            e.cs === this.color_spaces.INDEXED && (this.internal.newObject(), r("<< /Length " + e.pal.length + ">>"), i(this.arrayBufferToBinaryString(new Uint8Array(e.pal))), r("endobj"));
        }, S = function() {
            var t = this.internal.collections[x + "images"];
            for(var e in t)n.call(this, t[e]);
        }, k = function() {
            var t, e = this.internal.collections[x + "images"], n = this.internal.write;
            for(var r in e)n("/I" + (t = e[r]).i, t.n, "0", "R");
        }, _ = function(t) {
            return "function" == typeof b["process" + t.toUpperCase()];
        }, A = function(t) {
            return "object" === (void 0 === t ? "undefined" : vt(t)) && 1 === t.nodeType;
        }, I = function(t, e) {
            if ("IMG" === t.nodeName && t.hasAttribute("src")) {
                var n = "" + t.getAttribute("src");
                if (0 === n.indexOf("data:image/")) return n;
                !e && /\.png(?:[?#].*)?$/i.test(n) && (e = "png");
            }
            if ("CANVAS" === t.nodeName) var r = t;
            else {
                (r = document.createElement("canvas")).width = t.clientWidth || t.width, r.height = t.clientHeight || t.height;
                var i = r.getContext("2d");
                if (!i) throw "addImage requires canvas to be supported by browser.";
                i.drawImage(t, 0, 0, r.width, r.height);
            }
            return r.toDataURL("png" == ("" + e).toLowerCase() ? "image/png" : "image/jpeg");
        }, C = function(t, e) {
            var n;
            if (e) {
                for(var r in e)if (t === e[r].alias) {
                    n = e[r];
                    break;
                }
            }
            return n;
        };
        b.color_spaces = {
            DEVICE_RGB: "DeviceRGB",
            DEVICE_GRAY: "DeviceGray",
            DEVICE_CMYK: "DeviceCMYK",
            CAL_GREY: "CalGray",
            CAL_RGB: "CalRGB",
            LAB: "Lab",
            ICC_BASED: "ICCBased",
            INDEXED: "Indexed",
            PATTERN: "Pattern",
            SEPARATION: "Separation",
            DEVICE_N: "DeviceN"
        }, b.decode = {
            DCT_DECODE: "DCTDecode",
            FLATE_DECODE: "FlateDecode",
            LZW_DECODE: "LZWDecode",
            JPX_DECODE: "JPXDecode",
            JBIG2_DECODE: "JBIG2Decode",
            ASCII85_DECODE: "ASCII85Decode",
            ASCII_HEX_DECODE: "ASCIIHexDecode",
            RUN_LENGTH_DECODE: "RunLengthDecode",
            CCITT_FAX_DECODE: "CCITTFaxDecode"
        }, b.image_compression = {
            NONE: "NONE",
            FAST: "FAST",
            MEDIUM: "MEDIUM",
            SLOW: "SLOW"
        }, b.sHashCode = function(t) {
            return t = t || "", Array.prototype.reduce && t.split("").reduce(function(t, e) {
                return (t = (t << 5) - t + e.charCodeAt(0)) & t;
            }, 0);
        }, b.isString = function(t) {
            return "string" == typeof t;
        }, b.validateStringAsBase64 = function(t) {
            var e = !0;
            return (t = t || "").length % 4 != 0 && (e = !1), !1 === /[A-Za-z0-9\/]+/.test(t.substr(0, t.length - 2)) && (e = !1), !1 === /[A-Za-z0-9\/][A-Za-z0-9+\/]|[A-Za-z0-9+\/]=|==/.test(t.substr(-2)) && (e = !1), e;
        }, b.extractInfoFromBase64DataURI = function(t) {
            return /^data:([\w]+?\/([\w]+?));base64,(.+)$/g.exec(t);
        }, b.supportsArrayBuffer = function() {
            return "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array;
        }, b.isArrayBuffer = function(t) {
            return !!this.supportsArrayBuffer() && t instanceof ArrayBuffer;
        }, b.isArrayBufferView = function(t) {
            return !!this.supportsArrayBuffer() && "undefined" != typeof Uint32Array && (t instanceof Int8Array || t instanceof Uint8Array || "undefined" != typeof Uint8ClampedArray && t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array || t instanceof Float64Array);
        }, b.binaryStringToUint8Array = function(t) {
            for(var e = t.length, n = new Uint8Array(e), r = 0; r < e; r++)n[r] = t.charCodeAt(r);
            return n;
        }, b.arrayBufferToBinaryString = function(t) {
            if ("function" == typeof atob) return atob(this.arrayBufferToBase64(t));
            if ("function" == typeof TextDecoder) {
                var e = new TextDecoder("ascii");
                if ("ascii" === e.encoding) return e.decode(t);
            }
            for(var n = this.isArrayBuffer(t) ? t : new Uint8Array(t), r = 20480, i = "", o = Math.ceil(n.byteLength / r), a = 0; a < o; a++)i += String.fromCharCode.apply(null, n.slice(a * r, a * r + r));
            return i;
        }, b.arrayBufferToBase64 = function(t) {
            for(var e, n = "", r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", i = new Uint8Array(t), o = i.byteLength, a = o % 3, s = o - a, h = 0; h < s; h += 3)n += r[(16515072 & (e = i[h] << 16 | i[h + 1] << 8 | i[h + 2])) >> 18] + r[(258048 & e) >> 12] + r[(4032 & e) >> 6] + r[63 & e];
            return 1 == a ? n += r[(252 & (e = i[s])) >> 2] + r[(3 & e) << 4] + "==" : 2 == a && (n += r[(64512 & (e = i[s] << 8 | i[s + 1])) >> 10] + r[(1008 & e) >> 4] + r[(15 & e) << 2] + "="), n;
        }, b.createImageInfo = function(t, e, n, r, i, o, a, s, h, c, l, u, f) {
            var d = {
                alias: s,
                w: e,
                h: n,
                cs: r,
                bpc: i,
                i: a,
                data: t
            };
            return o && (d.f = o), h && (d.dp = h), c && (d.trns = c), l && (d.pal = l), u && (d.smask = u), f && (d.p = f), d;
        }, b.addImage = function(t, e, n, r, i, o, a, s, h) {
            var c = "";
            if ("string" != typeof e) {
                var l = o;
                o = i, i = r, r = n, n = e, e = l;
            }
            if ("object" === (void 0 === t ? "undefined" : vt(t)) && !A(t) && "imageData" in t) {
                var u = t;
                t = u.imageData, e = u.format || e, n = u.x || n || 0, r = u.y || r || 0, i = u.w || i, o = u.h || o, a = u.alias || a, s = u.compression || s, h = u.rotation || u.angle || h;
            }
            if (isNaN(n) || isNaN(r)) throw console.error("jsPDF.addImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addImage");
            var f, d, p, g, m, w, y, v = (function() {
                var t = this.internal.collections[x + "images"];
                return t || (this.internal.collections[x + "images"] = t = {}, this.internal.events.subscribe("putResources", S), this.internal.events.subscribe("putXobjectDict", k)), t;
            }).call(this);
            if (!(f = C(t, v)) && (A(t) && (t = I(t, e)), (null == (y = a) || 0 === y.length) && (a = "string" == typeof (w = t) && b.sHashCode(w)), !(f = C(a, v)))) {
                if (this.isString(t) && ("" !== (c = this.convertStringToImageData(t)) ? t = c : void 0 !== (c = this.loadImageFile(t)) && (t = c)), e = this.getImageFileTypeByImageData(t, e), !_(e)) throw new Error("addImage does not support files of type '" + e + "', please ensure that a plugin for '" + e + "' support is added.");
                if (this.supportsArrayBuffer() && (t instanceof Uint8Array || (d = t, t = this.binaryStringToUint8Array(t))), !(f = this["process" + e.toUpperCase()](t, (m = 0, (g = v) && (m = Object.keys ? Object.keys(g).length : function(t) {
                    var e = 0;
                    for(var n in t)t.hasOwnProperty(n) && e++;
                    return e;
                }(g)), m), a, ((p = s) && "string" == typeof p && (p = p.toUpperCase()), p in b.image_compression ? p : b.image_compression.NONE), d))) throw new Error("An unkwown error occurred whilst processing the image");
            }
            return (function(t, e, n, r, i, o, a, s) {
                var h = (function(t, e, n) {
                    return t || e || (e = t = -96), t < 0 && (t = -1 * n.w * 72 / t / this.internal.scaleFactor), e < 0 && (e = -1 * n.h * 72 / e / this.internal.scaleFactor), 0 === t && (t = e * n.w / n.h), 0 === e && (e = t * n.h / n.w), [
                        t,
                        e
                    ];
                }).call(this, n, r, i), c = this.internal.getCoordinateString, l = this.internal.getVerticalCoordinateString;
                if (n = h[0], r = h[1], a[o] = i, s) {
                    s *= Math.PI / 180;
                    var u = Math.cos(s), f = Math.sin(s), d = function(t) {
                        return t.toFixed(4);
                    }, p = [
                        d(u),
                        d(f),
                        d(-1 * f),
                        d(u),
                        0,
                        0,
                        "cm"
                    ];
                }
                this.internal.write("q"), s ? (this.internal.write([
                    1,
                    "0",
                    "0",
                    1,
                    c(t),
                    l(e + r),
                    "cm"
                ].join(" ")), this.internal.write(p.join(" ")), this.internal.write([
                    c(n),
                    "0",
                    "0",
                    c(r),
                    "0",
                    "0",
                    "cm"
                ].join(" "))) : this.internal.write([
                    c(n),
                    "0",
                    "0",
                    c(r),
                    c(t),
                    l(e + r),
                    "cm"
                ].join(" ")), this.internal.write("/I" + i.i + " Do"), this.internal.write("Q");
            }).call(this, n, r, i, o, f, f.i, v, h), this;
        }, b.convertStringToImageData = function(t) {
            var e, n = "";
            this.isString(t) && (null !== (e = this.extractInfoFromBase64DataURI(t)) ? b.validateStringAsBase64(e[3]) && (n = atob(e[3])) : b.validateStringAsBase64(t) && (n = atob(t)));
            return n;
        };
        var c = function(t, e) {
            return t.subarray(e, e + 5);
        };
        b.processJPEG = function(t, e, n, r, i, o) {
            var a, s = this.decode.DCT_DECODE;
            if (!this.isString(t) && !this.isArrayBuffer(t) && !this.isArrayBufferView(t)) return null;
            if (this.isString(t) && (a = function(t) {
                var e;
                if ((t.charCodeAt(0), t.charCodeAt(1), t.charCodeAt(2), t.charCodeAt(3), !t.charCodeAt(6) === "J".charCodeAt(0)) || !t.charCodeAt(7) === "F".charCodeAt(0) || !t.charCodeAt(8) === "I".charCodeAt(0) || !t.charCodeAt(9) === "F".charCodeAt(0) || (t.charCodeAt(10), false)) throw new Error("getJpegSize requires a binary string jpeg file");
                for(var n = 256 * t.charCodeAt(4) + t.charCodeAt(5), r = 4, i = t.length; r < i;){
                    if (r += n, 255 !== t.charCodeAt(r)) throw new Error("getJpegSize could not find the size of the image");
                    if (192 === t.charCodeAt(r + 1) || 193 === t.charCodeAt(r + 1) || 194 === t.charCodeAt(r + 1) || 195 === t.charCodeAt(r + 1) || 196 === t.charCodeAt(r + 1) || 197 === t.charCodeAt(r + 1) || 198 === t.charCodeAt(r + 1) || 199 === t.charCodeAt(r + 1)) return e = 256 * t.charCodeAt(r + 5) + t.charCodeAt(r + 6), [
                        256 * t.charCodeAt(r + 7) + t.charCodeAt(r + 8),
                        e,
                        t.charCodeAt(r + 9)
                    ];
                    r += 2, n = 256 * t.charCodeAt(r) + t.charCodeAt(r + 1);
                }
            }(t)), this.isArrayBuffer(t) && (t = new Uint8Array(t)), this.isArrayBufferView(t) && (a = function(t) {
                if (65496 != (t[0] << 8 | t[1])) throw new Error("Supplied data is not a JPEG");
                for(var e, n = t.length, r = (t[4] << 8) + t[5], i = 4; i < n;){
                    if (r = ((e = c(t, i += r))[2] << 8) + e[3], (192 === e[1] || 194 === e[1]) && 255 === e[0] && 7 < r) return {
                        width: ((e = c(t, i + 5))[2] << 8) + e[3],
                        height: (e[0] << 8) + e[1],
                        numcomponents: e[4]
                    };
                    i += 2;
                }
                throw new Error("getJpegSizeFromBytes could not find the size of the image");
            }(t), t = i || this.arrayBufferToBinaryString(t)), void 0 === o) switch(a.numcomponents){
                case 1:
                    o = this.color_spaces.DEVICE_GRAY;
                    break;
                case 4:
                    o = this.color_spaces.DEVICE_CMYK;
                    break;
                default:
                case 3:
                    o = this.color_spaces.DEVICE_RGB;
            }
            return this.createImageInfo(t, a.width, a.height, o, 8, s, e, n);
        }, b.processJPG = function() {
            return this.processJPEG.apply(this, arguments);
        }, b.loadImageFile = function(t, e, n) {
            e = e || !0, n = n || function() {};
            Object.prototype.toString.call("undefined" != typeof $7dgut ? $7dgut : 0);
            if (void 0 !== ("undefined" == typeof window ? "undefined" : vt(window)) && "object" === ("undefined" == typeof location ? "undefined" : vt(location)) && "http" === location.protocol.substr(0, 4)) return function(t, e, n) {
                var r = new XMLHttpRequest, i = [], o = 0, a = function(t) {
                    var e = t.length, n = String.fromCharCode;
                    for(o = 0; o < e; o += 1)i.push(n(255 & t.charCodeAt(o)));
                    return i.join("");
                };
                if (r.open("GET", t, !e), r.overrideMimeType("text/plain; charset=x-user-defined"), !1 === e && (r.onload = function() {
                    return a(this.responseText);
                }), r.send(null), 200 === r.status) return e ? a(r.responseText) : void 0;
                console.warn('Unable to load file "' + t + '"');
            }(t, e);
        }, b.getImageProperties = function(t) {
            var e, n, r = "";
            if (A(t) && (t = I(t)), this.isString(t) && ("" !== (r = this.convertStringToImageData(t)) ? t = r : void 0 !== (r = this.loadImageFile(t)) && (t = r)), n = this.getImageFileTypeByImageData(t), !_(n)) throw new Error("addImage does not support files of type '" + n + "', please ensure that a plugin for '" + n + "' support is added.");
            if (this.supportsArrayBuffer() && (t instanceof Uint8Array || (t = this.binaryStringToUint8Array(t))), !(e = this["process" + n.toUpperCase()](t))) throw new Error("An unkwown error occurred whilst processing the image");
            return {
                fileType: n,
                width: e.w,
                height: e.h,
                colorSpace: e.cs,
                compressionMode: e.f,
                bitsPerComponent: e.bpc
            };
        };
    }($.API), /**
   * jsPDF Annotations PlugIn
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ t = $.API, y = {
        annotations: [],
        f2: function(t) {
            return t.toFixed(2);
        },
        notEmpty: function(t) {
            if (void 0 !== t && "" != t) return !0;
        }
    }, $.API.annotationPlugin = y, $.API.events.push([
        "addPage",
        function(t) {
            this.annotationPlugin.annotations[t.pageNumber] = [];
        }
    ]), t.events.push([
        "putPage",
        function(t) {
            for(var e = this.annotationPlugin.annotations[t.pageNumber], n = !1, r = 0; r < e.length && !n; r++)switch((h = e[r]).type){
                case "link":
                    if (y.notEmpty(h.options.url) || y.notEmpty(h.options.pageNumber)) {
                        n = !0;
                        break;
                    }
                case "reference":
                case "text":
                case "freetext":
                    n = !0;
            }
            if (0 != n) {
                this.internal.write("/Annots [");
                var i = this.annotationPlugin.f2, o = this.internal.scaleFactor, a = this.internal.pageSize.getHeight(), s = this.internal.getPageInfo(t.pageNumber);
                for(r = 0; r < e.length; r++){
                    var h;
                    switch((h = e[r]).type){
                        case "reference":
                            this.internal.write(" " + h.object.objId + " 0 R ");
                            break;
                        case "text":
                            var c = this.internal.newAdditionalObject(), l = this.internal.newAdditionalObject(), u = h.title || "Note";
                            m = "<</Type /Annot /Subtype /Text " + (d = "/Rect [" + i(h.bounds.x * o) + " " + i(a - (h.bounds.y + h.bounds.h) * o) + " " + i((h.bounds.x + h.bounds.w) * o) + " " + i((a - h.bounds.y) * o) + "] ") + "/Contents (" + h.contents + ")", m += " /Popup " + l.objId + " 0 R", m += " /P " + s.objId + " 0 R", m += " /T (" + u + ") >>", c.content = m;
                            var f = c.objId + " 0 R";
                            m = "<</Type /Annot /Subtype /Popup " + (d = "/Rect [" + i((h.bounds.x + 30) * o) + " " + i(a - (h.bounds.y + h.bounds.h) * o) + " " + i((h.bounds.x + h.bounds.w + 30) * o) + " " + i((a - h.bounds.y) * o) + "] ") + " /Parent " + f, h.open && (m += " /Open true"), m += " >>", l.content = m, this.internal.write(c.objId, "0 R", l.objId, "0 R");
                            break;
                        case "freetext":
                            var d = "/Rect [" + i(h.bounds.x * o) + " " + i((a - h.bounds.y) * o) + " " + i(h.bounds.x + h.bounds.w * o) + " " + i(a - (h.bounds.y + h.bounds.h) * o) + "] ", p = h.color || "#000000";
                            m = "<</Type /Annot /Subtype /FreeText " + d + "/Contents (" + h.contents + ")", m += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + p + ")", m += " /Border [0 0 0]", m += " >>", this.internal.write(m);
                            break;
                        case "link":
                            if (h.options.name) {
                                var g = this.annotations._nameMap[h.options.name];
                                h.options.pageNumber = g.page, h.options.top = g.y;
                            } else h.options.top || (h.options.top = 0);
                            d = "/Rect [" + i(h.x * o) + " " + i((a - h.y) * o) + " " + i((h.x + h.w) * o) + " " + i((a - (h.y + h.h)) * o) + "] ";
                            var m = "";
                            if (h.options.url) m = "<</Type /Annot /Subtype /Link " + d + "/Border [0 0 0] /A <</S /URI /URI (" + h.options.url + ") >>";
                            else if (h.options.pageNumber) switch(m = "<</Type /Annot /Subtype /Link " + d + "/Border [0 0 0] /Dest [" + (t = this.internal.getPageInfo(h.options.pageNumber)).objId + " 0 R", h.options.magFactor = h.options.magFactor || "XYZ", h.options.magFactor){
                                case "Fit":
                                    m += " /Fit]";
                                    break;
                                case "FitH":
                                    m += " /FitH " + h.options.top + "]";
                                    break;
                                case "FitV":
                                    h.options.left = h.options.left || 0, m += " /FitV " + h.options.left + "]";
                                    break;
                                case "XYZ":
                                default:
                                    var w = i((a - h.options.top) * o);
                                    h.options.left = h.options.left || 0, void 0 === h.options.zoom && (h.options.zoom = 0), m += " /XYZ " + h.options.left + " " + w + " " + h.options.zoom + "]";
                            }
                            "" != m && (m += " >>", this.internal.write(m));
                    }
                }
                this.internal.write("]");
            }
        }
    ]), t.createAnnotation = function(t) {
        switch(t.type){
            case "link":
                this.link(t.bounds.x, t.bounds.y, t.bounds.w, t.bounds.h, t);
                break;
            case "text":
            case "freetext":
                this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push(t);
        }
    }, t.link = function(t, e, n, r, i) {
        this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push({
            x: t,
            y: e,
            w: n,
            h: r,
            options: i,
            type: "link"
        });
    }, t.textWithLink = function(t, e, n, r) {
        var i = this.getTextWidth(t), o = this.internal.getLineHeight() / this.internal.scaleFactor;
        return this.text(t, e, n), n += .2 * o, this.link(e, n - o, i, o, r), i;
    }, t.getTextWidth = function(t) {
        var e = this.internal.getFontSize();
        return this.getStringUnitWidth(t) * e / this.internal.scaleFactor;
    }, t.getLineHeight = function() {
        return this.internal.getLineHeight();
    }, function(t) {
        var a = Object.keys({
            ar: "Arabic (Standard)",
            "ar-DZ": "Arabic (Algeria)",
            "ar-BH": "Arabic (Bahrain)",
            "ar-EG": "Arabic (Egypt)",
            "ar-IQ": "Arabic (Iraq)",
            "ar-JO": "Arabic (Jordan)",
            "ar-KW": "Arabic (Kuwait)",
            "ar-LB": "Arabic (Lebanon)",
            "ar-LY": "Arabic (Libya)",
            "ar-MA": "Arabic (Morocco)",
            "ar-OM": "Arabic (Oman)",
            "ar-QA": "Arabic (Qatar)",
            "ar-SA": "Arabic (Saudi Arabia)",
            "ar-SY": "Arabic (Syria)",
            "ar-TN": "Arabic (Tunisia)",
            "ar-AE": "Arabic (U.A.E.)",
            "ar-YE": "Arabic (Yemen)",
            fa: "Persian",
            "fa-IR": "Persian/Iran",
            ur: "Urdu"
        }), u = {
            1569: [
                65152
            ],
            1570: [
                65153,
                65154,
                65153,
                65154
            ],
            1571: [
                65155,
                65156,
                65155,
                65156
            ],
            1572: [
                65157,
                65158
            ],
            1573: [
                65159,
                65160,
                65159,
                65160
            ],
            1574: [
                65161,
                65162,
                65163,
                65164
            ],
            1575: [
                65165,
                65166,
                65165,
                65166
            ],
            1576: [
                65167,
                65168,
                65169,
                65170
            ],
            1577: [
                65171,
                65172
            ],
            1578: [
                65173,
                65174,
                65175,
                65176
            ],
            1579: [
                65177,
                65178,
                65179,
                65180
            ],
            1580: [
                65181,
                65182,
                65183,
                65184
            ],
            1581: [
                65185,
                65186,
                65187,
                65188
            ],
            1582: [
                65189,
                65190,
                65191,
                65192
            ],
            1583: [
                65193,
                65194,
                65193
            ],
            1584: [
                65195,
                65196,
                65195
            ],
            1585: [
                65197,
                65198,
                65197
            ],
            1586: [
                65199,
                65200,
                65199
            ],
            1587: [
                65201,
                65202,
                65203,
                65204
            ],
            1588: [
                65205,
                65206,
                65207,
                65208
            ],
            1589: [
                65209,
                65210,
                65211,
                65212
            ],
            1590: [
                65213,
                65214,
                65215,
                65216
            ],
            1591: [
                65217,
                65218,
                65219,
                65220
            ],
            1592: [
                65221,
                65222,
                65223,
                65224
            ],
            1593: [
                65225,
                65226,
                65227,
                65228
            ],
            1594: [
                65229,
                65230,
                65231,
                65232
            ],
            1601: [
                65233,
                65234,
                65235,
                65236
            ],
            1602: [
                65237,
                65238,
                65239,
                65240
            ],
            1603: [
                65241,
                65242,
                65243,
                65244
            ],
            1604: [
                65245,
                65246,
                65247,
                65248
            ],
            1605: [
                65249,
                65250,
                65251,
                65252
            ],
            1606: [
                65253,
                65254,
                65255,
                65256
            ],
            1607: [
                65257,
                65258,
                65259,
                65260
            ],
            1608: [
                65261,
                65262,
                65261
            ],
            1609: [
                65263,
                65264,
                64488,
                64489
            ],
            1610: [
                65265,
                65266,
                65267,
                65268
            ],
            1649: [
                64336,
                64337
            ],
            1655: [
                64477
            ],
            1657: [
                64358,
                64359,
                64360,
                64361
            ],
            1658: [
                64350,
                64351,
                64352,
                64353
            ],
            1659: [
                64338,
                64339,
                64340,
                64341
            ],
            1662: [
                64342,
                64343,
                64344,
                64345
            ],
            1663: [
                64354,
                64355,
                64356,
                64357
            ],
            1664: [
                64346,
                64347,
                64348,
                64349
            ],
            1667: [
                64374,
                64375,
                64376,
                64377
            ],
            1668: [
                64370,
                64371,
                64372,
                64373
            ],
            1670: [
                64378,
                64379,
                64380,
                64381
            ],
            1671: [
                64382,
                64383,
                64384,
                64385
            ],
            1672: [
                64392,
                64393
            ],
            1676: [
                64388,
                64389
            ],
            1677: [
                64386,
                64387
            ],
            1678: [
                64390,
                64391
            ],
            1681: [
                64396,
                64397
            ],
            1688: [
                64394,
                64395,
                64394
            ],
            1700: [
                64362,
                64363,
                64364,
                64365
            ],
            1702: [
                64366,
                64367,
                64368,
                64369
            ],
            1705: [
                64398,
                64399,
                64400,
                64401
            ],
            1709: [
                64467,
                64468,
                64469,
                64470
            ],
            1711: [
                64402,
                64403,
                64404,
                64405
            ],
            1713: [
                64410,
                64411,
                64412,
                64413
            ],
            1715: [
                64406,
                64407,
                64408,
                64409
            ],
            1722: [
                64414,
                64415
            ],
            1723: [
                64416,
                64417,
                64418,
                64419
            ],
            1726: [
                64426,
                64427,
                64428,
                64429
            ],
            1728: [
                64420,
                64421
            ],
            1729: [
                64422,
                64423,
                64424,
                64425
            ],
            1733: [
                64480,
                64481
            ],
            1734: [
                64473,
                64474
            ],
            1735: [
                64471,
                64472
            ],
            1736: [
                64475,
                64476
            ],
            1737: [
                64482,
                64483
            ],
            1739: [
                64478,
                64479
            ],
            1740: [
                64508,
                64509,
                64510,
                64511
            ],
            1744: [
                64484,
                64485,
                64486,
                64487
            ],
            1746: [
                64430,
                64431
            ],
            1747: [
                64432,
                64433
            ]
        }, f = {
            1570: [
                65269,
                65270,
                65269,
                65270
            ],
            1571: [
                65271,
                65272,
                65271,
                65272
            ],
            1573: [
                65273,
                65274,
                65273,
                65274
            ],
            1575: [
                65275,
                65276,
                65275,
                65276
            ]
        }, d = {
            1570: [
                65153,
                65154,
                65153,
                65154
            ],
            1571: [
                65155,
                65156,
                65155,
                65156
            ],
            1573: [
                65159,
                65160,
                65159,
                65160
            ],
            1575: [
                65165,
                65166,
                65165,
                65166
            ]
        }, p = {
            1612: 64606,
            1613: 64607,
            1614: 64608,
            1615: 64609,
            1616: 64610
        }, e = [
            1570,
            1571,
            1573,
            1575
        ], n = [
            1569,
            1570,
            1571,
            1572,
            1573,
            1575,
            1577,
            1583,
            1584,
            1585,
            1586,
            1608,
            1688
        ], o = 0, s = 1, h = 2, c = 3;
        function g(t) {
            return void 0 !== t && void 0 !== u[t.charCodeAt(0)];
        }
        function l(t) {
            return void 0 !== t && 0 <= n.indexOf(t.charCodeAt(0));
        }
        function m(t) {
            return void 0 !== t && 0 <= e.indexOf(t.charCodeAt(0));
        }
        function w(t) {
            return g(t) && 2 <= u[t.charCodeAt(0)].length;
        }
        function y(t, e, n, r) {
            var i;
            return g(t) ? (r = r || {}, u = Object.assign(u, r), !w(t) || !g(e) && !g(n) || !g(n) && l(e) || l(t) && !g(e) || l(t) && m(e) || l(t) && l(e) ? (u = Object.assign(u, d), o) : g(i = t) && 4 == u[i.charCodeAt(0)].length && g(e) && !l(e) && g(n) && w(n) ? (u = Object.assign(u, d), c) : l(t) || !g(n) ? (u = Object.assign(u, d), s) : (u = Object.assign(u, d), h)) : -1;
        }
        var v = t.processArabic = function(t, e) {
            t = t || "", e = e || !1;
            var n, r, i, o = "", a = 0, s = 0, h = "", c = "", l = "";
            for(a = 0; a < t.length; a += 1)h = t[a], c = t[a - 1], l = t[a + 1], g(h) ? void 0 !== c && 1604 === c.charCodeAt(0) && m(h) ? (s = y(h, t[a - 2], t[a + 1], f), n = String.fromCharCode(f[h.charCodeAt(0)][s]), o = o.substr(0, o.length - 1) + n) : void 0 !== c && 1617 === c.charCodeAt(0) && void 0 !== (r = h) && void 0 !== p[r.charCodeAt(0)] ? (s = y(h, t[a - 2], t[a + 1], d), n = String.fromCharCode(p[h.charCodeAt(0)][s]), o = o.substr(0, o.length - 1) + n) : (s = y(h, c, l, d), o += String.fromCharCode(u[h.charCodeAt(0)][s])) : o += e ? ({
                "(": ")",
                ")": "("
            })[i = h] || i : h;
            return e ? o.split("").reverse().join("") : o;
        };
        t.events.push([
            "preProcessText",
            function(t) {
                var e = t.text, n = (t.x, t.y, t.options || {}), r = (t.mutex, n.lang), i = [];
                if (0 <= a.indexOf(r)) {
                    if ("[object Array]" === Object.prototype.toString.call(e)) {
                        var o = 0;
                        for(i = [], o = 0; o < e.length; o += 1)"[object Array]" === Object.prototype.toString.call(e[o]) ? i.push([
                            v(e[o][0], !0),
                            e[o][1],
                            e[o][2]
                        ]) : i.push([
                            v(e[o], !0)
                        ]);
                        t.text = i;
                    } else t.text = v(e, !0);
                    void 0 === n.charSpace && (t.options.charSpace = 0), !0 === n.R2L && (t.options.R2L = !1);
                }
            }
        ]);
    }($.API), $.API.autoPrint = function(t) {
        var e;
        switch((t = t || {}).variant = t.variant || "non-conform", t.variant){
            case "javascript":
                this.addJS("print({});");
                break;
            case "non-conform":
            default:
                this.internal.events.subscribe("postPutResources", function() {
                    e = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
                }), this.internal.events.subscribe("putCatalog", function() {
                    this.internal.out("/OpenAction " + e + " 0 R");
                });
        }
        return this;
    }, /**
   * jsPDF Canvas PlugIn
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ (e = $.API).events.push([
        "initialized",
        function() {
            this.canvas.pdf = this;
        }
    ]), e.canvas = {
        getContext: function(t) {
            return (this.pdf.context2d._canvas = this).pdf.context2d;
        },
        childNodes: []
    }, Object.defineProperty(e.canvas, "width", {
        get: function() {
            return this._width;
        },
        set: function(t) {
            this._width = t, this.getContext("2d").pageWrapX = t + 1;
        }
    }), Object.defineProperty(e.canvas, "height", {
        get: function() {
            return this._height;
        },
        set: function(t) {
            this._height = t, this.getContext("2d").pageWrapY = t + 1;
        }
    }), /** ====================================================================
   * jsPDF Cell plugin
   * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
   *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Hall, james@parall.ax
   *               2014 Diego Casorran, https://github.com/diegocr
   *
   * 
   * ====================================================================
   */ I = $.API, C = {
        x: void 0,
        y: void 0,
        w: void 0,
        h: void 0,
        ln: void 0
    }, T = 1, d = function(t, e, n, r, i) {
        C = {
            x: t,
            y: e,
            w: n,
            h: r,
            ln: i
        };
    }, p = function() {
        return C;
    }, F = {
        left: 0,
        top: 0,
        bottom: 0
    }, I.setHeaderFunction = function(t) {
        h = t;
    }, I.getTextDimensions = function(e) {
        i = this.internal.getFont().fontName, o = this.table_font_size || this.internal.getFontSize(), a = this.internal.getFont().fontStyle;
        var t, n, r = 19.049976 / 25.4;
        (n = document.createElement("font")).id = "jsPDFCell";
        try {
            n.style.fontStyle = a;
        } catch (t) {
            n.style.fontWeight = a;
        }
        n.style.fontSize = o + "pt", n.style.fontFamily = i;
        try {
            n.textContent = e;
        } catch (t) {
            n.innerText = e;
        }
        return document.body.appendChild(n), t = {
            w: (n.offsetWidth + 1) * r,
            h: (n.offsetHeight + 1) * r
        }, document.body.removeChild(n), t;
    }, I.cellAddPage = function() {
        var t = this.margins || F;
        this.addPage(), d(t.left, t.top, void 0, void 0), T += 1;
    }, I.cellInitialize = function() {
        C = {
            x: void 0,
            y: void 0,
            w: void 0,
            h: void 0,
            ln: void 0
        }, T = 1;
    }, I.cell = function(t, e, n, r, i, o, a) {
        var s = p(), h = !1;
        if (void 0 !== s.ln) {
            if (s.ln === o) t = s.x + s.w, e = s.y;
            else {
                var c = this.margins || F;
                s.y + s.h + r + 13 >= this.internal.pageSize.getHeight() - c.bottom && (this.cellAddPage(), h = !0, this.printHeaders && this.tableHeaderRow && this.printHeaderRow(o, !0)), e = p().y + p().h, h && (e = 23);
            }
        }
        if (void 0 !== i[0]) {
            if (this.printingHeaderRow ? this.rect(t, e, n, r, "FD") : this.rect(t, e, n, r), "right" === a) {
                i instanceof Array || (i = [
                    i
                ]);
                for(var l = 0; l < i.length; l++){
                    var u = i[l], f = this.getStringUnitWidth(u) * this.internal.getFontSize();
                    this.text(u, t + n - f - 3, e + this.internal.getLineHeight() * (l + 1));
                }
            } else this.text(i, t + 3, e + this.internal.getLineHeight());
        }
        return d(t, e, n, r, o), this;
    }, I.arrayMax = function(t, e) {
        var n, r, i, o = t[0];
        for(n = 0, r = t.length; n < r; n += 1)i = t[n], e ? -1 === e(o, i) && (o = i) : o < i && (o = i);
        return o;
    }, I.table = function(t, e, n, r, i) {
        if (!n) throw "No data for PDF table";
        var o, a, s, h, c, l, u, f, d, p, g = [], m = [], w = {}, y = {}, v = [], b = [], x = !1, S = !0, k = 12, _ = F;
        if (_.width = this.internal.pageSize.getWidth(), i && (!0 === i.autoSize && (x = !0), !1 === i.printHeaders && (S = !1), i.fontSize && (k = i.fontSize), i.css && void 0 !== i.css["font-size"] && (k = 16 * i.css["font-size"]), i.margins && (_ = i.margins)), this.lnMod = 0, C = {
            x: void 0,
            y: void 0,
            w: void 0,
            h: void 0,
            ln: void 0
        }, T = 1, this.printHeaders = S, this.margins = _, this.setFontSize(k), this.table_font_size = k, null == r) g = Object.keys(n[0]);
        else if (r[0] && "string" != typeof r[0]) for(a = 0, s = r.length; a < s; a += 1)o = r[a], g.push(o.name), m.push(o.prompt), y[o.name] = o.width * (19.049976 / 25.4);
        else g = r;
        if (x) for(p = function(t) {
            return t[o];
        }, a = 0, s = g.length; a < s; a += 1){
            for(w[o = g[a]] = n.map(p), v.push(this.getTextDimensions(m[a] || o).w), u = 0, h = (l = w[o]).length; u < h; u += 1)c = l[u], v.push(this.getTextDimensions(c).w);
            y[o] = I.arrayMax(v), v = [];
        }
        if (S) {
            var A = this.calculateLineHeight(g, y, m.length ? m : g);
            for(a = 0, s = g.length; a < s; a += 1)o = g[a], b.push([
                t,
                e,
                y[o],
                A,
                String(m.length ? m[a] : o)
            ]);
            this.setTableHeaderRow(b), this.printHeaderRow(1, !1);
        }
        for(a = 0, s = n.length; a < s; a += 1)for(f = n[a], A = this.calculateLineHeight(g, y, f), u = 0, d = g.length; u < d; u += 1)o = g[u], this.cell(t, e, y[o], A, f[o], a + 2, o.align);
        return this.lastCellPos = C, this.table_x = t, this.table_y = e, this;
    }, I.calculateLineHeight = function(t, e, n) {
        for(var r, i = 0, o = 0; o < t.length; o++){
            n[r = t[o]] = this.splitTextToSize(String(n[r]), e[r] - 3);
            var a = this.internal.getLineHeight() * n[r].length + 3;
            i < a && (i = a);
        }
        return i;
    }, I.setTableHeaderRow = function(t) {
        this.tableHeaderRow = t;
    }, I.printHeaderRow = function(t, e) {
        if (!this.tableHeaderRow) throw "Property tableHeaderRow does not exist.";
        var n, r, i, o;
        if (this.printingHeaderRow = !0, void 0 !== h) {
            var a = h(this, T);
            d(a[0], a[1], a[2], a[3], -1);
        }
        this.setFontStyle("bold");
        var s = [];
        for(i = 0, o = this.tableHeaderRow.length; i < o; i += 1)this.setFillColor(200, 200, 200), n = this.tableHeaderRow[i], e && (this.margins.top = 13, n[1] = this.margins && this.margins.top || 0, s.push(n)), r = [].concat(n), this.cell.apply(this, r.concat(t));
        0 < s.length && this.setTableHeaderRow(s), this.setFontStyle("normal"), this.printingHeaderRow = !1;
    }, /**
   * jsPDF Context2D PlugIn Copyright (c) 2014 Steven Spungin (TwelveTone LLC) steven@twelvetone.tv
   *
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */ function(t) {
        t.events.push([
            "initialized",
            function() {
                ((this.context2d.pdf = this).context2d.internal.pdf = this).context2d.ctx = new e, this.context2d.ctxStack = [], this.context2d.path = [];
            }
        ]), t.context2d = {
            pageWrapXEnabled: !1,
            pageWrapYEnabled: !1,
            pageWrapX: 9999999,
            pageWrapY: 9999999,
            ctx: new e,
            f2: function(t) {
                return t.toFixed(2);
            },
            fillRect: function(t, e, n, r) {
                if (!this._isFillTransparent()) {
                    t = this._wrapX(t), e = this._wrapY(e);
                    var i = this._matrix_map_rect(this.ctx._transform, {
                        x: t,
                        y: e,
                        w: n,
                        h: r
                    });
                    this.pdf.rect(i.x, i.y, i.w, i.h, "f");
                }
            },
            strokeRect: function(t, e, n, r) {
                if (!this._isStrokeTransparent()) {
                    t = this._wrapX(t), e = this._wrapY(e);
                    var i = this._matrix_map_rect(this.ctx._transform, {
                        x: t,
                        y: e,
                        w: n,
                        h: r
                    });
                    this.pdf.rect(i.x, i.y, i.w, i.h, "s");
                }
            },
            clearRect: function(t, e, n, r) {
                if (!this.ctx.ignoreClearRect) {
                    t = this._wrapX(t), e = this._wrapY(e);
                    var i = this._matrix_map_rect(this.ctx._transform, {
                        x: t,
                        y: e,
                        w: n,
                        h: r
                    });
                    this.save(), this.setFillStyle("#ffffff"), this.pdf.rect(i.x, i.y, i.w, i.h, "f"), this.restore();
                }
            },
            save: function() {
                this.ctx._fontSize = this.pdf.internal.getFontSize();
                var t = new e;
                t.copy(this.ctx), this.ctxStack.push(this.ctx), this.ctx = t;
            },
            restore: function() {
                this.ctx = this.ctxStack.pop(), this.setFillStyle(this.ctx.fillStyle), this.setStrokeStyle(this.ctx.strokeStyle), this.setFont(this.ctx.font), this.pdf.setFontSize(this.ctx._fontSize), this.setLineCap(this.ctx.lineCap), this.setLineWidth(this.ctx.lineWidth), this.setLineJoin(this.ctx.lineJoin);
            },
            rect: function(t, e, n, r) {
                this.moveTo(t, e), this.lineTo(t + n, e), this.lineTo(t + n, e + r), this.lineTo(t, e + r), this.lineTo(t, e), this.closePath();
            },
            beginPath: function() {
                this.path = [];
            },
            closePath: function() {
                this.path.push({
                    type: "close"
                });
            },
            _getRGBA: function(t) {
                var e, n, r, i, o = new RGBColor(t);
                if (!t) return {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 0,
                    style: t
                };
                if (this.internal.rxTransparent.test(t)) i = r = n = e = 0;
                else {
                    var a = this.internal.rxRgb.exec(t);
                    null != a ? (e = parseInt(a[1]), n = parseInt(a[2]), r = parseInt(a[3]), i = 1) : null != (a = this.internal.rxRgba.exec(t)) ? (e = parseInt(a[1]), n = parseInt(a[2]), r = parseInt(a[3]), i = parseFloat(a[4])) : (i = 1, "#" != t.charAt(0) && (t = o.ok ? o.toHex() : "#000000"), 4 === t.length ? (e = t.substring(1, 2), e += e, n = t.substring(2, 3), n += n, r = t.substring(3, 4), r += r) : (e = t.substring(1, 3), n = t.substring(3, 5), r = t.substring(5, 7)), e = parseInt(e, 16), n = parseInt(n, 16), r = parseInt(r, 16));
                }
                return {
                    r: e,
                    g: n,
                    b: r,
                    a: i,
                    style: t
                };
            },
            setFillStyle: function(t) {
                var e = this._getRGBA(t);
                this.ctx.fillStyle = t, this.ctx._isFillTransparent = 0 === e.a, this.ctx._fillOpacity = e.a, this.pdf.setFillColor(e.r, e.g, e.b, {
                    a: e.a
                }), this.pdf.setTextColor(e.r, e.g, e.b, {
                    a: e.a
                });
            },
            setStrokeStyle: function(t) {
                var e = this._getRGBA(t);
                this.ctx.strokeStyle = e.style, this.ctx._isStrokeTransparent = 0 === e.a, this.ctx._strokeOpacity = e.a, 0 === e.a ? this.pdf.setDrawColor(255, 255, 255) : (e.a, this.pdf.setDrawColor(e.r, e.g, e.b));
            },
            fillText: function(t, e, n, r) {
                if (!this._isFillTransparent()) {
                    e = this._wrapX(e), n = this._wrapY(n);
                    var i = this._matrix_map_point(this.ctx._transform, [
                        e,
                        n
                    ]);
                    e = i[0], n = i[1];
                    var o = 57.2958 * this._matrix_rotation(this.ctx._transform);
                    if (0 < this.ctx._clip_path.length) {
                        var a;
                        (a = window.outIntercept ? "group" === window.outIntercept.type ? window.outIntercept.stream : window.outIntercept : this.internal.getCurrentPage()).push("q");
                        var s = this.path;
                        this.path = this.ctx._clip_path, this.ctx._clip_path = [], this._fill(null, !0), this.ctx._clip_path = this.path, this.path = s;
                    }
                    var h = 1;
                    try {
                        h = this._matrix_decompose(this._getTransform()).scale[0];
                    } catch (t) {
                        console.warn(t);
                    }
                    if (h < .01) this.pdf.text(t, e, this._getBaseline(n), null, o);
                    else {
                        var c = this.pdf.internal.getFontSize();
                        this.pdf.setFontSize(c * h), this.pdf.text(t, e, this._getBaseline(n), null, o), this.pdf.setFontSize(c);
                    }
                    0 < this.ctx._clip_path.length && a.push("Q");
                }
            },
            strokeText: function(t, e, n, r) {
                if (!this._isStrokeTransparent()) {
                    e = this._wrapX(e), n = this._wrapY(n);
                    var i = this._matrix_map_point(this.ctx._transform, [
                        e,
                        n
                    ]);
                    e = i[0], n = i[1];
                    var o = 57.2958 * this._matrix_rotation(this.ctx._transform);
                    if (0 < this.ctx._clip_path.length) {
                        var a;
                        (a = window.outIntercept ? "group" === window.outIntercept.type ? window.outIntercept.stream : window.outIntercept : this.internal.getCurrentPage()).push("q");
                        var s = this.path;
                        this.path = this.ctx._clip_path, this.ctx._clip_path = [], this._fill(null, !0), this.ctx._clip_path = this.path, this.path = s;
                    }
                    var h = 1;
                    try {
                        h = this._matrix_decompose(this._getTransform()).scale[0];
                    } catch (t) {
                        console.warn(t);
                    }
                    if (1 === h) this.pdf.text(t, e, this._getBaseline(n), {
                        stroke: !0
                    }, o);
                    else {
                        var c = this.pdf.internal.getFontSize();
                        this.pdf.setFontSize(c * h), this.pdf.text(t, e, this._getBaseline(n), {
                            stroke: !0
                        }, o), this.pdf.setFontSize(c);
                    }
                    0 < this.ctx._clip_path.length && a.push("Q");
                }
            },
            setFont: function(t) {
                if (this.ctx.font = t, null != (c = /\s*(\w+)\s+(\w+)\s+(\w+)\s+([\d\.]+)(px|pt|em)\s+(.*)?/.exec(t))) {
                    var e = c[1], n = (c[2], c[3]), r = c[4], i = c[5], o = c[6];
                    r = "px" === i ? Math.floor(parseFloat(r)) : "em" === i ? Math.floor(parseFloat(r) * this.pdf.getFontSize()) : Math.floor(parseFloat(r)), this.pdf.setFontSize(r), "bold" === n || "700" === n ? this.pdf.setFontStyle("bold") : "italic" === e ? this.pdf.setFontStyle("italic") : this.pdf.setFontStyle("normal"), l = "bold" === n || "700" === n ? "italic" === e ? "bolditalic" : "bold" : "italic" === e ? "italic" : "normal";
                    for(var a = o.toLowerCase().split(/\s*,\s*/), s = "Times", h = 0; h < a.length; h++){
                        if (void 0 !== this.pdf.internal.getFont(a[h], l, {
                            noFallback: !0,
                            disableWarning: !0
                        })) {
                            s = a[h];
                            break;
                        }
                        if ("bolditalic" === l && void 0 !== this.pdf.internal.getFont(a[h], "bold", {
                            noFallback: !0,
                            disableWarning: !0
                        })) s = a[h], l = "bold";
                        else if (void 0 !== this.pdf.internal.getFont(a[h], "normal", {
                            noFallback: !0,
                            disableWarning: !0
                        })) {
                            s = a[h], l = "normal";
                            break;
                        }
                    }
                    this.pdf.setFont(s, l);
                } else {
                    var c = /\s*(\d+)(pt|px|em)\s+([\w "]+)\s*([\w "]+)?/.exec(t);
                    if (null != c) {
                        var l, u = c[1], f = (c[2], c[3]);
                        (l = c[4]) || (l = "normal"), u = "em" === i ? Math.floor(parseFloat(r) * this.pdf.getFontSize()) : Math.floor(parseFloat(u)), this.pdf.setFontSize(u), this.pdf.setFont(f, l);
                    }
                }
            },
            setTextBaseline: function(t) {
                this.ctx.textBaseline = t;
            },
            getTextBaseline: function() {
                return this.ctx.textBaseline;
            },
            setTextAlign: function(t) {
                this.ctx.textAlign = t;
            },
            getTextAlign: function() {
                return this.ctx.textAlign;
            },
            setLineWidth: function(t) {
                this.ctx.lineWidth = t, this.pdf.setLineWidth(t);
            },
            setLineCap: function(t) {
                this.ctx.lineCap = t, this.pdf.setLineCap(t);
            },
            setLineJoin: function(t) {
                this.ctx.lineJoin = t, this.pdf.setLineJoin(t);
            },
            moveTo: function(t, e) {
                t = this._wrapX(t), e = this._wrapY(e);
                var n = this._matrix_map_point(this.ctx._transform, [
                    t,
                    e
                ]), r = {
                    type: "mt",
                    x: t = n[0],
                    y: e = n[1]
                };
                this.path.push(r);
            },
            _wrapX: function(t) {
                return this.pageWrapXEnabled ? t % this.pageWrapX : t;
            },
            _wrapY: function(t) {
                return this.pageWrapYEnabled ? (this._gotoPage(this._page(t)), (t - this.lastBreak) % this.pageWrapY) : t;
            },
            transform: function(t, e, n, r, i, o) {
                this.ctx._transform = this._matrix_multiply(this.ctx._transform, [
                    t,
                    e,
                    n,
                    r,
                    i,
                    o
                ]);
            },
            setTransform: function(t, e, n, r, i, o) {
                this.ctx._transform = [
                    t,
                    e,
                    n,
                    r,
                    i,
                    o
                ];
            },
            _getTransform: function() {
                return this.ctx._transform;
            },
            lastBreak: 0,
            pageBreaks: [],
            _page: function(t) {
                if (this.pageWrapYEnabled) {
                    for(var e = this.lastBreak = 0, n = 0, r = 0; r < this.pageBreaks.length; r++)if (t >= this.pageBreaks[r]) {
                        e++, 0 === this.lastBreak && n++;
                        var i = this.pageBreaks[r] - this.lastBreak;
                        this.lastBreak = this.pageBreaks[r], n += Math.floor(i / this.pageWrapY);
                    }
                    if (0 === this.lastBreak) n += Math.floor(t / this.pageWrapY) + 1;
                    return n + e;
                }
                return this.pdf.internal.getCurrentPageInfo().pageNumber;
            },
            _gotoPage: function(t) {},
            lineTo: function(t, e) {
                t = this._wrapX(t), e = this._wrapY(e);
                var n = this._matrix_map_point(this.ctx._transform, [
                    t,
                    e
                ]), r = {
                    type: "lt",
                    x: t = n[0],
                    y: e = n[1]
                };
                this.path.push(r);
            },
            bezierCurveTo: function(t, e, n, r, i, o) {
                var a;
                t = this._wrapX(t), e = this._wrapY(e), n = this._wrapX(n), r = this._wrapY(r), i = this._wrapX(i), o = this._wrapY(o), i = (a = this._matrix_map_point(this.ctx._transform, [
                    i,
                    o
                ]))[0], o = a[1];
                var s = {
                    type: "bct",
                    x1: t = (a = this._matrix_map_point(this.ctx._transform, [
                        t,
                        e
                    ]))[0],
                    y1: e = a[1],
                    x2: n = (a = this._matrix_map_point(this.ctx._transform, [
                        n,
                        r
                    ]))[0],
                    y2: r = a[1],
                    x: i,
                    y: o
                };
                this.path.push(s);
            },
            quadraticCurveTo: function(t, e, n, r) {
                var i;
                t = this._wrapX(t), e = this._wrapY(e), n = this._wrapX(n), r = this._wrapY(r), n = (i = this._matrix_map_point(this.ctx._transform, [
                    n,
                    r
                ]))[0], r = i[1];
                var o = {
                    type: "qct",
                    x1: t = (i = this._matrix_map_point(this.ctx._transform, [
                        t,
                        e
                    ]))[0],
                    y1: e = i[1],
                    x: n,
                    y: r
                };
                this.path.push(o);
            },
            arc: function(t, e, n, r, i, o) {
                if (t = this._wrapX(t), e = this._wrapY(e), !this._matrix_is_identity(this.ctx._transform)) {
                    var a = this._matrix_map_point(this.ctx._transform, [
                        t,
                        e
                    ]);
                    t = a[0], e = a[1];
                    var s = this._matrix_map_point(this.ctx._transform, [
                        0,
                        0
                    ]), h = this._matrix_map_point(this.ctx._transform, [
                        0,
                        n
                    ]);
                    n = Math.sqrt(Math.pow(h[0] - s[0], 2) + Math.pow(h[1] - s[1], 2));
                }
                var c = {
                    type: "arc",
                    x: t,
                    y: e,
                    radius: n,
                    startAngle: r,
                    endAngle: i,
                    anticlockwise: o
                };
                this.path.push(c);
            },
            drawImage: function(t, e, n, r, i, o, a, s, h) {
                void 0 !== o && (e = o, n = a, r = s, i = h), e = this._wrapX(e), n = this._wrapY(n);
                var c, l = this._matrix_map_rect(this.ctx._transform, {
                    x: e,
                    y: n,
                    w: r,
                    h: i
                }), u = (this._matrix_map_rect(this.ctx._transform, {
                    x: o,
                    y: a,
                    w: s,
                    h: h
                }), /data:image\/(\w+).*/i.exec(t));
                c = null != u ? u[1] : "png", this.pdf.addImage(t, c, l.x, l.y, l.w, l.h);
            },
            _matrix_multiply: function(t, e) {
                var n = e[0], r = e[1], i = e[2], o = e[3], a = e[4], s = e[5], h = n * t[0] + r * t[2], c = i * t[0] + o * t[2], l = a * t[0] + s * t[2] + t[4];
                return r = n * t[1] + r * t[3], o = i * t[1] + o * t[3], s = a * t[1] + s * t[3] + t[5], [
                    n = h,
                    r,
                    i = c,
                    o,
                    a = l,
                    s
                ];
            },
            _matrix_rotation: function(t) {
                return Math.atan2(t[2], t[0]);
            },
            _matrix_decompose: function(t) {
                var e = t[0], n = t[1], r = t[2], i = t[3], o = Math.sqrt(e * e + n * n), a = (e /= o) * r + (n /= o) * i;
                r -= e * a, i -= n * a;
                var s = Math.sqrt(r * r + i * i);
                return a /= s, e * (i /= s) < n * (r /= s) && (e = -e, n = -n, a = -a, o = -o), {
                    scale: [
                        o,
                        0,
                        0,
                        s,
                        0,
                        0
                    ],
                    translate: [
                        1,
                        0,
                        0,
                        1,
                        t[4],
                        t[5]
                    ],
                    rotate: [
                        e,
                        n,
                        -n,
                        e,
                        0,
                        0
                    ],
                    skew: [
                        1,
                        0,
                        a,
                        1,
                        0,
                        0
                    ]
                };
            },
            _matrix_map_point: function(t, e) {
                var n = t[0], r = t[1], i = t[2], o = t[3], a = t[4], s = t[5], h = e[0], c = e[1];
                return [
                    h * n + c * i + a,
                    h * r + c * o + s
                ];
            },
            _matrix_map_point_obj: function(t, e) {
                var n = this._matrix_map_point(t, [
                    e.x,
                    e.y
                ]);
                return {
                    x: n[0],
                    y: n[1]
                };
            },
            _matrix_map_rect: function(t, e) {
                var n = this._matrix_map_point(t, [
                    e.x,
                    e.y
                ]), r = this._matrix_map_point(t, [
                    e.x + e.w,
                    e.y + e.h
                ]);
                return {
                    x: n[0],
                    y: n[1],
                    w: r[0] - n[0],
                    h: r[1] - n[1]
                };
            },
            _matrix_is_identity: function(t) {
                return 1 == t[0] && 0 == t[1] && 0 == t[2] && 1 == t[3] && 0 == t[4] && 0 == t[5];
            },
            rotate: function(t) {
                var e = [
                    Math.cos(t),
                    Math.sin(t),
                    -Math.sin(t),
                    Math.cos(t),
                    0,
                    0
                ];
                this.ctx._transform = this._matrix_multiply(this.ctx._transform, e);
            },
            scale: function(t, e) {
                var n = [
                    t,
                    0,
                    0,
                    e,
                    0,
                    0
                ];
                this.ctx._transform = this._matrix_multiply(this.ctx._transform, n);
            },
            translate: function(t, e) {
                var n = [
                    1,
                    0,
                    0,
                    1,
                    t,
                    e
                ];
                this.ctx._transform = this._matrix_multiply(this.ctx._transform, n);
            },
            stroke: function() {
                if (0 < this.ctx._clip_path.length) {
                    var t;
                    (t = window.outIntercept ? "group" === window.outIntercept.type ? window.outIntercept.stream : window.outIntercept : this.internal.getCurrentPage()).push("q");
                    var e = this.path;
                    this.path = this.ctx._clip_path, this.ctx._clip_path = [], this._stroke(!0), this.ctx._clip_path = this.path, this.path = e, this._stroke(!1), t.push("Q");
                } else this._stroke(!1);
            },
            _stroke: function(t) {
                if (t || !this._isStrokeTransparent()) {
                    for(var e = [], n = this.path, r = 0; r < n.length; r++){
                        var i = n[r];
                        switch(i.type){
                            case "mt":
                                e.push({
                                    start: i,
                                    deltas: [],
                                    abs: []
                                });
                                break;
                            case "lt":
                                var o = [
                                    i.x - n[r - 1].x,
                                    i.y - n[r - 1].y
                                ];
                                e[e.length - 1].deltas.push(o), e[e.length - 1].abs.push(i);
                                break;
                            case "bct":
                                o = [
                                    i.x1 - n[r - 1].x,
                                    i.y1 - n[r - 1].y,
                                    i.x2 - n[r - 1].x,
                                    i.y2 - n[r - 1].y,
                                    i.x - n[r - 1].x,
                                    i.y - n[r - 1].y
                                ];
                                e[e.length - 1].deltas.push(o);
                                break;
                            case "qct":
                                var a = n[r - 1].x + 2 / 3 * (i.x1 - n[r - 1].x), s = n[r - 1].y + 2 / 3 * (i.y1 - n[r - 1].y), h = i.x + 2 / 3 * (i.x1 - i.x), c = i.y + 2 / 3 * (i.y1 - i.y), l = i.x, u = i.y;
                                o = [
                                    a - n[r - 1].x,
                                    s - n[r - 1].y,
                                    h - n[r - 1].x,
                                    c - n[r - 1].y,
                                    l - n[r - 1].x,
                                    u - n[r - 1].y
                                ];
                                e[e.length - 1].deltas.push(o);
                                break;
                            case "arc":
                                0 == e.length && e.push({
                                    start: {
                                        x: 0,
                                        y: 0
                                    },
                                    deltas: [],
                                    abs: []
                                }), e[e.length - 1].arc = !0, Array.isArray(e[e.length - 1].abs) && e[e.length - 1].abs.push(i);
                        }
                    }
                    for(r = 0; r < e.length; r++){
                        var f;
                        if (f = r == e.length - 1 ? "s" : null, e[r].arc) for(var d = e[r].abs, p = 0; p < d.length; p++){
                            var g = d[p], m = 360 * g.startAngle / (2 * Math.PI), w = 360 * g.endAngle / (2 * Math.PI), y = g.x, v = g.y;
                            this.internal.arc2(this, y, v, g.radius, m, w, g.anticlockwise, f, t);
                        }
                        else {
                            y = e[r].start.x, v = e[r].start.y;
                            t ? (this.pdf.lines(e[r].deltas, y, v, null, null), this.pdf.clip_fixed()) : this.pdf.lines(e[r].deltas, y, v, null, f);
                        }
                    }
                }
            },
            _isFillTransparent: function() {
                return this.ctx._isFillTransparent || 0 == this.globalAlpha;
            },
            _isStrokeTransparent: function() {
                return this.ctx._isStrokeTransparent || 0 == this.globalAlpha;
            },
            fill: function(t) {
                if (0 < this.ctx._clip_path.length) {
                    var e;
                    (e = window.outIntercept ? "group" === window.outIntercept.type ? window.outIntercept.stream : window.outIntercept : this.internal.getCurrentPage()).push("q");
                    var n = this.path;
                    this.path = this.ctx._clip_path, this.ctx._clip_path = [], this._fill(t, !0), this.ctx._clip_path = this.path, this.path = n, this._fill(t, !1), e.push("Q");
                } else this._fill(t, !1);
            },
            _fill: function(t, e) {
                if (!this._isFillTransparent()) {
                    var n, r = "function" == typeof this.pdf.internal.newObject2;
                    n = window.outIntercept ? "group" === window.outIntercept.type ? window.outIntercept.stream : window.outIntercept : this.internal.getCurrentPage();
                    var i = [], o = window.outIntercept;
                    if (r) switch(this.ctx.globalCompositeOperation){
                        case "normal":
                        case "source-over":
                            break;
                        case "destination-in":
                        case "destination-out":
                            var a = this.pdf.internal.newStreamObject(), s = this.pdf.internal.newObject2();
                            s.push("<</Type /ExtGState"), s.push("/SMask <</S /Alpha /G " + a.objId + " 0 R>>"), s.push(">>");
                            var h = "MASK" + s.objId;
                            this.pdf.internal.addGraphicsState(h, s.objId);
                            var c = "/" + h + " gs";
                            n.splice(0, 0, "q"), n.splice(1, 0, c), n.push("Q"), window.outIntercept = a;
                            break;
                        default:
                            var l = "/" + this.pdf.internal.blendModeMap[this.ctx.globalCompositeOperation.toUpperCase()];
                            l && this.pdf.internal.out(l + " gs");
                    }
                    var u = this.ctx.globalAlpha;
                    if (this.ctx._fillOpacity < 1 && (u = this.ctx._fillOpacity), r) {
                        var f = this.pdf.internal.newObject2();
                        f.push("<</Type /ExtGState"), f.push("/CA " + u), f.push("/ca " + u), f.push(">>");
                        h = "GS_O_" + f.objId;
                        this.pdf.internal.addGraphicsState(h, f.objId), this.pdf.internal.out("/" + h + " gs");
                    }
                    for(var d = this.path, p = 0; p < d.length; p++){
                        var g = d[p];
                        switch(g.type){
                            case "mt":
                                i.push({
                                    start: g,
                                    deltas: [],
                                    abs: []
                                });
                                break;
                            case "lt":
                                var m = [
                                    g.x - d[p - 1].x,
                                    g.y - d[p - 1].y
                                ];
                                i[i.length - 1].deltas.push(m), i[i.length - 1].abs.push(g);
                                break;
                            case "bct":
                                m = [
                                    g.x1 - d[p - 1].x,
                                    g.y1 - d[p - 1].y,
                                    g.x2 - d[p - 1].x,
                                    g.y2 - d[p - 1].y,
                                    g.x - d[p - 1].x,
                                    g.y - d[p - 1].y
                                ];
                                i[i.length - 1].deltas.push(m);
                                break;
                            case "qct":
                                var w = d[p - 1].x + 2 / 3 * (g.x1 - d[p - 1].x), y = d[p - 1].y + 2 / 3 * (g.y1 - d[p - 1].y), v = g.x + 2 / 3 * (g.x1 - g.x), b = g.y + 2 / 3 * (g.y1 - g.y), x = g.x, S = g.y;
                                m = [
                                    w - d[p - 1].x,
                                    y - d[p - 1].y,
                                    v - d[p - 1].x,
                                    b - d[p - 1].y,
                                    x - d[p - 1].x,
                                    S - d[p - 1].y
                                ];
                                i[i.length - 1].deltas.push(m);
                                break;
                            case "arc":
                                0 === i.length && i.push({
                                    deltas: [],
                                    abs: []
                                }), i[i.length - 1].arc = !0, Array.isArray(i[i.length - 1].abs) && i[i.length - 1].abs.push(g);
                                break;
                            case "close":
                                i.push({
                                    close: !0
                                });
                        }
                    }
                    for(p = 0; p < i.length; p++){
                        var k;
                        if (p == i.length - 1 ? (k = "f", "evenodd" === t && (k += "*")) : k = null, i[p].close) this.pdf.internal.out("h"), k && this.pdf.internal.out(k);
                        else if (i[p].arc) {
                            i[p].start && this.internal.move2(this, i[p].start.x, i[p].start.y);
                            for(var _ = i[p].abs, A = 0; A < _.length; A++){
                                var I = _[A];
                                if (void 0 !== I.startAngle) {
                                    var C = 360 * I.startAngle / (2 * Math.PI), T = 360 * I.endAngle / (2 * Math.PI), F = I.x, P = I.y;
                                    if (0 === A && this.internal.move2(this, F, P), this.internal.arc2(this, F, P, I.radius, C, T, I.anticlockwise, null, e), A === _.length - 1 && i[p].start) {
                                        F = i[p].start.x, P = i[p].start.y;
                                        this.internal.line2(E, F, P);
                                    }
                                } else this.internal.line2(E, I.x, I.y);
                            }
                        } else {
                            F = i[p].start.x, P = i[p].start.y;
                            e ? (this.pdf.lines(i[p].deltas, F, P, null, null), this.pdf.clip_fixed()) : this.pdf.lines(i[p].deltas, F, P, null, k);
                        }
                    }
                    window.outIntercept = o;
                }
            },
            pushMask: function() {
                if ("function" == typeof this.pdf.internal.newObject2) {
                    var t = this.pdf.internal.newStreamObject(), e = this.pdf.internal.newObject2();
                    e.push("<</Type /ExtGState"), e.push("/SMask <</S /Alpha /G " + t.objId + " 0 R>>"), e.push(">>");
                    var n = "MASK" + e.objId;
                    this.pdf.internal.addGraphicsState(n, e.objId);
                    var r = "/" + n + " gs";
                    this.pdf.internal.out(r);
                } else console.log("jsPDF v2 not enabled");
            },
            clip: function() {
                if (0 < this.ctx._clip_path.length) for(var t = 0; t < this.path.length; t++)this.ctx._clip_path.push(this.path[t]);
                else this.ctx._clip_path = this.path;
                this.path = [];
            },
            measureText: function(n) {
                var r = this.pdf;
                return {
                    getWidth: function() {
                        var t = r.internal.getFontSize(), e = r.getStringUnitWidth(n) * t / r.internal.scaleFactor;
                        return e *= 1.3333;
                    },
                    get width () {
                        return this.getWidth(n);
                    }
                };
            },
            _getBaseline: function(t) {
                var e = parseInt(this.pdf.internal.getFontSize()), n = .25 * e;
                switch(this.ctx.textBaseline){
                    case "bottom":
                        return t - n;
                    case "top":
                        return t + e;
                    case "hanging":
                        return t + e - n;
                    case "middle":
                        return t + e / 2 - n;
                    case "ideographic":
                        return t;
                    case "alphabetic":
                    default:
                        return t;
                }
            }
        };
        var E = t.context2d;
        function e() {
            this._isStrokeTransparent = !1, this._strokeOpacity = 1, this.strokeStyle = "#000000", this.fillStyle = "#000000", this._isFillTransparent = !1, this._fillOpacity = 1, this.font = "12pt times", this.textBaseline = "alphabetic", this.textAlign = "start", this.lineWidth = 1, this.lineJoin = "miter", this.lineCap = "butt", this._transform = [
                1,
                0,
                0,
                1,
                0,
                0
            ], this.globalCompositeOperation = "normal", this.globalAlpha = 1, this._clip_path = [], this.ignoreClearRect = !1, this.copy = function(t) {
                this._isStrokeTransparent = t._isStrokeTransparent, this._strokeOpacity = t._strokeOpacity, this.strokeStyle = t.strokeStyle, this._isFillTransparent = t._isFillTransparent, this._fillOpacity = t._fillOpacity, this.fillStyle = t.fillStyle, this.font = t.font, this.lineWidth = t.lineWidth, this.lineJoin = t.lineJoin, this.lineCap = t.lineCap, this.textBaseline = t.textBaseline, this.textAlign = t.textAlign, this._fontSize = t._fontSize, this._transform = t._transform.slice(0), this.globalCompositeOperation = t.globalCompositeOperation, this.globalAlpha = t.globalAlpha, this._clip_path = t._clip_path.slice(0), this.ignoreClearRect = t.ignoreClearRect;
            };
        }
        Object.defineProperty(E, "fillStyle", {
            set: function(t) {
                this.setFillStyle(t);
            },
            get: function() {
                return this.ctx.fillStyle;
            }
        }), Object.defineProperty(E, "strokeStyle", {
            set: function(t) {
                this.setStrokeStyle(t);
            },
            get: function() {
                return this.ctx.strokeStyle;
            }
        }), Object.defineProperty(E, "lineWidth", {
            set: function(t) {
                this.setLineWidth(t);
            },
            get: function() {
                return this.ctx.lineWidth;
            }
        }), Object.defineProperty(E, "lineCap", {
            set: function(t) {
                this.setLineCap(t);
            },
            get: function() {
                return this.ctx.lineCap;
            }
        }), Object.defineProperty(E, "lineJoin", {
            set: function(t) {
                this.setLineJoin(t);
            },
            get: function() {
                return this.ctx.lineJoin;
            }
        }), Object.defineProperty(E, "miterLimit", {
            set: function(t) {
                this.ctx.miterLimit = t;
            },
            get: function() {
                return this.ctx.miterLimit;
            }
        }), Object.defineProperty(E, "textBaseline", {
            set: function(t) {
                this.setTextBaseline(t);
            },
            get: function() {
                return this.getTextBaseline();
            }
        }), Object.defineProperty(E, "textAlign", {
            set: function(t) {
                this.setTextAlign(t);
            },
            get: function() {
                return this.getTextAlign();
            }
        }), Object.defineProperty(E, "font", {
            set: function(t) {
                this.setFont(t);
            },
            get: function() {
                return this.ctx.font;
            }
        }), Object.defineProperty(E, "globalCompositeOperation", {
            set: function(t) {
                this.ctx.globalCompositeOperation = t;
            },
            get: function() {
                return this.ctx.globalCompositeOperation;
            }
        }), Object.defineProperty(E, "globalAlpha", {
            set: function(t) {
                this.ctx.globalAlpha = t;
            },
            get: function() {
                return this.ctx.globalAlpha;
            }
        }), Object.defineProperty(E, "canvas", {
            get: function() {
                return {
                    parentNode: !1,
                    style: !1
                };
            }
        }), Object.defineProperty(E, "ignoreClearRect", {
            set: function(t) {
                this.ctx.ignoreClearRect = t;
            },
            get: function() {
                return this.ctx.ignoreClearRect;
            }
        }), E.internal = {}, E.internal.rxRgb = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/, E.internal.rxRgba = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d\.]+)\s*\)/, E.internal.rxTransparent = /transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/, E.internal.arc = function(t, e, n, r, i, o, a, s) {
            for(var h = this.pdf.internal.scaleFactor, c = this.pdf.internal.pageSize.getHeight(), l = this.pdf.internal.f2, u = i * (Math.PI / 180), f = o * (Math.PI / 180), d = this.createArc(r, u, f, a), p = 0; p < d.length; p++){
                var g = d[p];
                0 === p ? this.pdf.internal.out([
                    l((g.x1 + e) * h),
                    l((c - (g.y1 + n)) * h),
                    "m",
                    l((g.x2 + e) * h),
                    l((c - (g.y2 + n)) * h),
                    l((g.x3 + e) * h),
                    l((c - (g.y3 + n)) * h),
                    l((g.x4 + e) * h),
                    l((c - (g.y4 + n)) * h),
                    "c"
                ].join(" ")) : this.pdf.internal.out([
                    l((g.x2 + e) * h),
                    l((c - (g.y2 + n)) * h),
                    l((g.x3 + e) * h),
                    l((c - (g.y3 + n)) * h),
                    l((g.x4 + e) * h),
                    l((c - (g.y4 + n)) * h),
                    "c"
                ].join(" ")), t._lastPoint = {
                    x: e,
                    y: n
                };
            }
            null !== s && this.pdf.internal.out(this.pdf.internal.getStyle(s));
        }, E.internal.arc2 = function(t, e, n, r, i, o, a, s, h) {
            var c = e, l = n;
            h ? (this.arc(t, c, l, r, i, o, a, null), this.pdf.clip_fixed()) : this.arc(t, c, l, r, i, o, a, s);
        }, E.internal.move2 = function(t, e, n) {
            var r = this.pdf.internal.scaleFactor, i = this.pdf.internal.pageSize.getHeight(), o = this.pdf.internal.f2;
            this.pdf.internal.out([
                o(e * r),
                o((i - n) * r),
                "m"
            ].join(" ")), t._lastPoint = {
                x: e,
                y: n
            };
        }, E.internal.line2 = function(t, e, n) {
            var r = this.pdf.internal.scaleFactor, i = this.pdf.internal.pageSize.getHeight(), o = this.pdf.internal.f2, a = {
                x: e,
                y: n
            };
            this.pdf.internal.out([
                o(a.x * r),
                o((i - a.y) * r),
                "l"
            ].join(" ")), t._lastPoint = a;
        }, E.internal.createArc = function(t, e, n, r) {
            var i = 2 * Math.PI, o = Math.PI / 2, a = e;
            for((a < i || i < a) && (a %= i), a < 0 && (a = i + a); n < e;)e -= i;
            var s = Math.abs(n - e);
            s < i && r && (s = i - s);
            for(var h = [], c = r ? -1 : 1, l = a; 1e-5 < s;){
                var u = l + c * Math.min(s, o);
                h.push(this.createSmallArc(t, l, u)), s -= Math.abs(u - l), l = u;
            }
            return h;
        }, E.internal.getCurrentPage = function() {
            return this.pdf.internal.pages[this.pdf.internal.getCurrentPageInfo().pageNumber];
        }, E.internal.createSmallArc = function(t, e, n) {
            var r = (n - e) / 2, i = t * Math.cos(r), o = t * Math.sin(r), a = i, s = -o, h = a * a + s * s, c = h + a * i + s * o, l = 4 / 3 * (Math.sqrt(2 * h * c) - c) / (a * o - s * i), u = a - l * s, f = s + l * a, d = u, p = -f, g = r + e, m = Math.cos(g), w = Math.sin(g);
            return {
                x1: t * Math.cos(e),
                y1: t * Math.sin(e),
                x2: u * m - f * w,
                y2: u * w + f * m,
                x3: d * m - p * w,
                y3: d * w + p * m,
                x4: t * Math.cos(n),
                y4: t * Math.sin(n)
            };
        };
    }($.API, "undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")()), /** @preserve
   * jsPDF fromHTML plugin. BETA stage. API subject to change. Needs browser
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Daniel Husar, https://github.com/danielhusar
   *               2014 Wolfgang Gassler, https://github.com/woolfg
   *               2014 Steven Spungin, https://github.com/flamenco
   *
   * 
   * ====================================================================
   */ function(t) {
        var T, F, i, a, s, h, c, l, P, v, f, u, d, n, E, q, p, g, m, O;
        T = function() {
            return function(t) {
                return e.prototype = t, new e;
            };
            function e() {}
        }(), v = function(t) {
            var e, n, r, i, o, a, s;
            for(n = 0, r = t.length, e = void 0, a = i = !1; !i && n !== r;)(e = t[n] = t[n].trimLeft()) && (i = !0), n++;
            for(n = r - 1; r && !a && -1 !== n;)(e = t[n] = t[n].trimRight()) && (a = !0), n--;
            for(o = /\s+$/g, s = !0, n = 0; n !== r;)"\u2028" != t[n] && (e = t[n].replace(/\s+/g, " "), s && (e = e.trimLeft()), e && (s = o.test(e)), t[n] = e), n++;
            return t;
        }, u = function(t) {
            var e, n, r;
            for(e = void 0, n = (r = t.split(",")).shift(); !e && n;)e = i[n.trim().toLowerCase()], n = r.shift();
            return e;
        }, d = function(t) {
            var e;
            return -1 < (t = "auto" === t ? "0px" : t).indexOf("em") && !isNaN(Number(t.replace("em", ""))) && (t = 18.719 * Number(t.replace("em", "")) + "px"), -1 < t.indexOf("pt") && !isNaN(Number(t.replace("pt", ""))) && (t = 1.333 * Number(t.replace("pt", "")) + "px"), (e = n[t]) ? e : void 0 !== (e = ({
                "xx-small": 9,
                "x-small": 11,
                small: 13,
                medium: 16,
                large: 19,
                "x-large": 23,
                "xx-large": 28,
                auto: 0
            })[t]) ? n[t] = e / 16 : (e = parseFloat(t)) ? n[t] = e / 16 : (e = t.match(/([\d\.]+)(px)/), Array.isArray(e) && 3 === e.length ? n[t] = parseFloat(e[1]) / 16 : n[t] = 1);
        }, P = function(t) {
            var e, n, r, i, o;
            return o = t, i = document.defaultView && document.defaultView.getComputedStyle ? document.defaultView.getComputedStyle(o, null) : o.currentStyle ? o.currentStyle : o.style, n = void 0, (e = {})["font-family"] = u((r = function(t) {
                return t = t.replace(/-\D/g, function(t) {
                    return t.charAt(1).toUpperCase();
                }), i[t];
            })("font-family")) || "times", e["font-style"] = a[r("font-style")] || "normal", e["text-align"] = s[r("text-align")] || "left", "bold" === (n = h[r("font-weight")] || "normal") && ("normal" === e["font-style"] ? e["font-style"] = n : e["font-style"] = n + e["font-style"]), e["font-size"] = d(r("font-size")) || 1, e["line-height"] = d(r("line-height")) || 1, e.display = "inline" === r("display") ? "inline" : "block", n = "block" === e.display, e["margin-top"] = n && d(r("margin-top")) || 0, e["margin-bottom"] = n && d(r("margin-bottom")) || 0, e["padding-top"] = n && d(r("padding-top")) || 0, e["padding-bottom"] = n && d(r("padding-bottom")) || 0, e["margin-left"] = n && d(r("margin-left")) || 0, e["margin-right"] = n && d(r("margin-right")) || 0, e["padding-left"] = n && d(r("padding-left")) || 0, e["padding-right"] = n && d(r("padding-right")) || 0, e["page-break-before"] = r("page-break-before") || "auto", e.float = c[r("cssFloat")] || "none", e.clear = l[r("clear")] || "none", e.color = r("color"), e;
        }, E = function(t, e, n) {
            var r, i, o, a, s;
            if (o = !1, a = i = void 0, r = n["#" + t.id]) {
                if ("function" == typeof r) o = r(t, e);
                else for(i = 0, a = r.length; !o && i !== a;)o = r[i](t, e), i++;
            }
            if (r = n[t.nodeName], !o && r) {
                if ("function" == typeof r) o = r(t, e);
                else for(i = 0, a = r.length; !o && i !== a;)o = r[i](t, e), i++;
            }
            for(s = "string" == typeof t.className ? t.className.split(" ") : [], i = 0; i < s.length; i++)if (r = n["." + s[i]], !o && r) {
                if ("function" == typeof r) o = r(t, e);
                else for(i = 0, a = r.length; !o && i !== a;)o = r[i](t, e), i++;
            }
            return o;
        }, O = function(t, e) {
            var n, r, i, o, a, s, h, c, l;
            for(n = [], r = [], i = 0, l = t.rows[0].cells.length, h = t.clientWidth; i < l;)c = t.rows[0].cells[i], r[i] = {
                name: c.textContent.toLowerCase().replace(/\s+/g, ""),
                prompt: c.textContent.replace(/\r?\n/g, ""),
                width: c.clientWidth / h * e.pdf.internal.pageSize.getWidth()
            }, i++;
            for(i = 1; i < t.rows.length;){
                for(s = t.rows[i], a = {}, o = 0; o < s.cells.length;)a[r[o].name] = s.cells[o].textContent.replace(/\r?\n/g, ""), o++;
                n.push(a), i++;
            }
            return {
                rows: n,
                headers: r
            };
        };
        var B = {
            SCRIPT: 1,
            STYLE: 1,
            NOSCRIPT: 1,
            OBJECT: 1,
            EMBED: 1,
            SELECT: 1
        }, R = 1;
        F = function(t, i, e) {
            var n, r, o, a, s, h, c, l;
            for(r = t.childNodes, n = void 0, (s = "block" === (o = P(t)).display) && (i.setBlockBoundary(), i.setBlockStyle(o)), a = 0, h = r.length; a < h;){
                if ("object" === (void 0 === (n = r[a]) ? "undefined" : vt(n))) {
                    if (i.executeWatchFunctions(n), 1 === n.nodeType && "HEADER" === n.nodeName) {
                        var u = n, f = i.pdf.margins_doc.top;
                        i.pdf.internal.events.subscribe("addPage", function(t) {
                            i.y = f, F(u, i, e), i.pdf.margins_doc.top = i.y + 10, i.y += 10;
                        }, !1);
                    }
                    if (8 === n.nodeType && "#comment" === n.nodeName) ~n.textContent.indexOf("ADD_PAGE") && (i.pdf.addPage(), i.y = i.pdf.margins_doc.top);
                    else if (1 !== n.nodeType || B[n.nodeName]) {
                        if (3 === n.nodeType) {
                            var d = n.nodeValue;
                            if (n.nodeValue && "LI" === n.parentNode.nodeName) {
                                if ("OL" === n.parentNode.parentNode.nodeName) d = R++ + ". " + d;
                                else {
                                    var p = o["font-size"], g = (3 - .75 * p) * i.pdf.internal.scaleFactor, m = .75 * p * i.pdf.internal.scaleFactor, w = 1.74 * p / i.pdf.internal.scaleFactor;
                                    l = function(t, e) {
                                        this.pdf.circle(t + g, e + m, w, "FD");
                                    };
                                }
                            }
                            16 & n.ownerDocument.body.compareDocumentPosition(n) && i.addText(d, o);
                        } else "string" == typeof n && i.addText(n, o);
                    } else {
                        var y;
                        if ("IMG" === n.nodeName) {
                            var v = n.getAttribute("src");
                            y = q[i.pdf.sHashCode(v) || v];
                        }
                        if (y) {
                            i.pdf.internal.pageSize.getHeight() - i.pdf.margins_doc.bottom < i.y + n.height && i.y > i.pdf.margins_doc.top && (i.pdf.addPage(), i.y = i.pdf.margins_doc.top, i.executeWatchFunctions(n));
                            var b = P(n), x = i.x, S = 12 / i.pdf.internal.scaleFactor, k = (b["margin-left"] + b["padding-left"]) * S, _ = (b["margin-right"] + b["padding-right"]) * S, A = (b["margin-top"] + b["padding-top"]) * S, I = (b["margin-bottom"] + b["padding-bottom"]) * S;
                            void 0 !== b.float && "right" === b.float ? x += i.settings.width - n.width - _ : x += k, i.pdf.addImage(y, x, i.y + A, n.width, n.height), y = void 0, "right" === b.float || "left" === b.float ? (i.watchFunctions.push((function(t, e, n, r) {
                                return i.y >= e ? (i.x += t, i.settings.width += n, !0) : !!(r && 1 === r.nodeType && !B[r.nodeName] && i.x + r.width > i.pdf.margins_doc.left + i.pdf.margins_doc.width) && (i.x += t, i.y = e, i.settings.width += n, !0);
                            }).bind(this, "left" === b.float ? -n.width - k - _ : 0, i.y + n.height + A + I, n.width)), i.watchFunctions.push((function(t, e, n) {
                                return !(i.y < t && e === i.pdf.internal.getNumberOfPages()) || 1 === n.nodeType && "both" === P(n).clear && (i.y = t, !0);
                            }).bind(this, i.y + n.height, i.pdf.internal.getNumberOfPages())), i.settings.width -= n.width + k + _, "left" === b.float && (i.x += n.width + k + _)) : i.y += n.height + A + I;
                        } else if ("TABLE" === n.nodeName) c = O(n, i), i.y += 10, i.pdf.table(i.x, i.y, c.rows, c.headers, {
                            autoSize: !1,
                            printHeaders: e.printHeaders,
                            margins: i.pdf.margins_doc,
                            css: P(n)
                        }), i.y = i.pdf.lastCellPos.y + i.pdf.lastCellPos.h + 20;
                        else if ("OL" === n.nodeName || "UL" === n.nodeName) R = 1, E(n, i, e) || F(n, i, e), i.y += 10;
                        else if ("LI" === n.nodeName) {
                            var C = i.x;
                            i.x += 20 / i.pdf.internal.scaleFactor, i.y += 3, E(n, i, e) || F(n, i, e), i.x = C;
                        } else "BR" === n.nodeName ? (i.y += o["font-size"] * i.pdf.internal.scaleFactor, i.addText("\u2028", T(o))) : E(n, i, e) || F(n, i, e);
                    }
                }
                a++;
            }
            if (e.outY = i.y, s) return i.setBlockBoundary(l);
        }, q = {}, p = function(t, o, e, n) {
            var a, r = t.getElementsByTagName("img"), i = r.length, s = 0;
            function h() {
                o.pdf.internal.events.publish("imagesLoaded"), n(a);
            }
            function c(e, n, r) {
                if (e) {
                    var i = new Image;
                    a = ++s, i.crossOrigin = "", i.onerror = i.onload = function() {
                        if (i.complete && (0 === i.src.indexOf("data:image/") && (i.width = n || i.width || 0, i.height = r || i.height || 0), i.width + i.height)) {
                            var t = o.pdf.sHashCode(e) || e;
                            q[t] = q[t] || i;
                        }
                        --s || h();
                    }, i.src = e;
                }
            }
            for(; i--;)c(r[i].getAttribute("src"), r[i].width, r[i].height);
            return s || h();
        }, g = function(t, o, a) {
            var s = t.getElementsByTagName("footer");
            if (0 < s.length) {
                s = s[0];
                var e = o.pdf.internal.write, n = o.y;
                o.pdf.internal.write = function() {}, F(s, o, a);
                var h = Math.ceil(o.y - n) + 5;
                o.y = n, o.pdf.internal.write = e, o.pdf.margins_doc.bottom += h;
                for(var r = function(t) {
                    var e = void 0 !== t ? t.pageNumber : 1, n = o.y;
                    o.y = o.pdf.internal.pageSize.getHeight() - o.pdf.margins_doc.bottom, o.pdf.margins_doc.bottom -= h;
                    for(var r = s.getElementsByTagName("span"), i = 0; i < r.length; ++i)-1 < (" " + r[i].className + " ").replace(/[\n\t]/g, " ").indexOf(" pageCounter ") && (r[i].innerHTML = e), -1 < (" " + r[i].className + " ").replace(/[\n\t]/g, " ").indexOf(" totalPages ") && (r[i].innerHTML = "###jsPDFVarTotalPages###");
                    F(s, o, a), o.pdf.margins_doc.bottom += h, o.y = n;
                }, i = s.getElementsByTagName("span"), c = 0; c < i.length; ++c)-1 < (" " + i[c].className + " ").replace(/[\n\t]/g, " ").indexOf(" totalPages ") && o.pdf.internal.events.subscribe("htmlRenderingFinished", o.pdf.putTotalPages.bind(o.pdf, "###jsPDFVarTotalPages###"), !0);
                o.pdf.internal.events.subscribe("addPage", r, !1), r(), B.FOOTER = 1;
            }
        }, m = function(t, e, n, r, i, o) {
            if (!e) return !1;
            var a, s, h, c;
            "string" == typeof e || e.parentNode || (e = "" + e.innerHTML), "string" == typeof e && (a = e.replace(/<\/?script[^>]*?>/gi, ""), c = "jsPDFhtmlText" + Date.now().toString() + (1e3 * Math.random()).toFixed(0), (h = document.createElement("div")).style.cssText = "position: absolute !important;clip: rect(1px 1px 1px 1px); /* IE6, IE7 */clip: rect(1px, 1px, 1px, 1px);padding:0 !important;border:0 !important;height: 1px !important;width: 1px !important; top:auto;left:-100px;overflow: hidden;", h.innerHTML = '<iframe style="height:1px;width:1px" name="' + c + '" />', document.body.appendChild(h), (s = window.frames[c]).document.open(), s.document.writeln(a), s.document.close(), e = s.document.body);
            var l, u = new f(t, n, r, i);
            return p.call(this, e, u, i.elementHandlers, function(t) {
                g(e, u, i.elementHandlers), F(e, u, i.elementHandlers), u.pdf.internal.events.publish("htmlRenderingFinished"), l = u.dispose(), "function" == typeof o ? o(l) : t && console.error("jsPDF Warning: rendering issues? provide a callback to fromHTML!");
            }), l || {
                x: u.x,
                y: u.y
            };
        }, (f = function(t, e, n, r) {
            return this.pdf = t, this.x = e, this.y = n, this.settings = r, this.watchFunctions = [], this.init(), this;
        }).prototype.init = function() {
            return this.paragraph = {
                text: [],
                style: []
            }, this.pdf.internal.write("q");
        }, f.prototype.dispose = function() {
            return this.pdf.internal.write("Q"), {
                x: this.x,
                y: this.y,
                ready: !0
            };
        }, f.prototype.executeWatchFunctions = function(t) {
            var e = !1, n = [];
            if (0 < this.watchFunctions.length) {
                for(var r = 0; r < this.watchFunctions.length; ++r)!0 === this.watchFunctions[r](t) ? e = !0 : n.push(this.watchFunctions[r]);
                this.watchFunctions = n;
            }
            return e;
        }, f.prototype.splitFragmentsIntoLines = function(t, e) {
            var n, r, i, o, a, s, h, c, l, u, f, d, p, g;
            for(u = this.pdf.internal.scaleFactor, o = {}, s = h = c = g = a = i = l = r = void 0, d = [
                f = []
            ], n = 0, p = this.settings.width; t.length;)if (a = t.shift(), g = e.shift(), a) {
                if ((i = o[(r = g["font-family"]) + (l = g["font-style"])]) || (i = this.pdf.internal.getFont(r, l).metadata.Unicode, o[r + l] = i), c = {
                    widths: i.widths,
                    kerning: i.kerning,
                    fontSize: 12 * g["font-size"],
                    textIndent: n
                }, h = this.pdf.getStringUnitWidth(a, c) * c.fontSize / u, "\u2028" == a) f = [], d.push(f);
                else if (p < n + h) {
                    for(s = this.pdf.splitTextToSize(a, p, c), f.push([
                        s.shift(),
                        g
                    ]); s.length;)f = [
                        [
                            s.shift(),
                            g
                        ]
                    ], d.push(f);
                    n = this.pdf.getStringUnitWidth(f[0][0], c) * c.fontSize / u;
                } else f.push([
                    a,
                    g
                ]), n += h;
            }
            if (void 0 !== g["text-align"] && ("center" === g["text-align"] || "right" === g["text-align"] || "justify" === g["text-align"])) for(var m = 0; m < d.length; ++m){
                var w = this.pdf.getStringUnitWidth(d[m][0][0], c) * c.fontSize / u;
                0 < m && (d[m][0][1] = T(d[m][0][1]));
                var y = p - w;
                if ("right" === g["text-align"]) d[m][0][1]["margin-left"] = y;
                else if ("center" === g["text-align"]) d[m][0][1]["margin-left"] = y / 2;
                else if ("justify" === g["text-align"]) {
                    var v = d[m][0][0].split(" ").length - 1;
                    d[m][0][1]["word-spacing"] = y / v, m === d.length - 1 && (d[m][0][1]["word-spacing"] = 0);
                }
            }
            return d;
        }, f.prototype.RenderTextFragment = function(t, e) {
            var n, r;
            r = 0, this.pdf.internal.pageSize.getHeight() - this.pdf.margins_doc.bottom < this.y + this.pdf.internal.getFontSize() && (this.pdf.internal.write("ET", "Q"), this.pdf.addPage(), this.y = this.pdf.margins_doc.top, this.pdf.internal.write("q", "BT", this.getPdfColor(e.color), this.pdf.internal.getCoordinateString(this.x), this.pdf.internal.getVerticalCoordinateString(this.y), "Td"), r = Math.max(r, e["line-height"], e["font-size"]), this.pdf.internal.write(0, (-12 * r).toFixed(2), "Td")), n = this.pdf.internal.getFont(e["font-family"], e["font-style"]);
            var i = this.getPdfColor(e.color);
            i !== this.lastTextColor && (this.pdf.internal.write(i), this.lastTextColor = i), void 0 !== e["word-spacing"] && 0 < e["word-spacing"] && this.pdf.internal.write(e["word-spacing"].toFixed(2), "Tw"), this.pdf.internal.write("/" + n.id, (12 * e["font-size"]).toFixed(2), "Tf", "(" + this.pdf.internal.pdfEscape(t) + ") Tj"), void 0 !== e["word-spacing"] && this.pdf.internal.write(0, "Tw");
        }, f.prototype.getPdfColor = function(t) {
            var e, n, r, i = new RGBColor(t), o = /rgb\s*\(\s*(\d+),\s*(\d+),\s*(\d+\s*)\)/.exec(t);
            if (null != o ? (e = parseInt(o[1]), n = parseInt(o[2]), r = parseInt(o[3])) : ("#" != t.charAt(0) && (t = i.ok ? i.toHex() : "#000000"), e = t.substring(1, 3), e = parseInt(e, 16), n = t.substring(3, 5), n = parseInt(n, 16), r = t.substring(5, 7), r = parseInt(r, 16)), "string" == typeof e && /^#[0-9A-Fa-f]{6}$/.test(e)) {
                var a = parseInt(e.substr(1), 16);
                e = a >> 16 & 255, n = a >> 8 & 255, r = 255 & a;
            }
            var s = this.f3;
            return 0 === e && 0 === n && 0 === r || void 0 === n ? s(e / 255) + " g" : [
                s(e / 255),
                s(n / 255),
                s(r / 255),
                "rg"
            ].join(" ");
        }, f.prototype.f3 = function(t) {
            return t.toFixed(3);
        }, f.prototype.renderParagraph = function(t) {
            var e, n, r, i, o, a, s, h, c, l, u, f, d;
            if (r = v(this.paragraph.text), f = this.paragraph.style, e = this.paragraph.blockstyle, this.paragraph.priorblockstyle, this.paragraph = {
                text: [],
                style: [],
                blockstyle: {},
                priorblockstyle: e
            }, r.join("").trim()) {
                s = this.splitFragmentsIntoLines(r, f), h = a = void 0, n = 12 / this.pdf.internal.scaleFactor, this.priorMarginBottom = this.priorMarginBottom || 0, u = (Math.max((e["margin-top"] || 0) - this.priorMarginBottom, 0) + (e["padding-top"] || 0)) * n, l = ((e["margin-bottom"] || 0) + (e["padding-bottom"] || 0)) * n, this.priorMarginBottom = e["margin-bottom"] || 0, "always" === e["page-break-before"] && (this.pdf.addPage(), this.y = 0, u = ((e["margin-top"] || 0) + (e["padding-top"] || 0)) * n), c = this.pdf.internal.write, o = i = void 0, this.y += u, c("q", "BT 0 g", this.pdf.internal.getCoordinateString(this.x), this.pdf.internal.getVerticalCoordinateString(this.y), "Td");
                for(var p = 0; s.length;){
                    for(i = h = 0, o = (a = s.shift()).length; i !== o;)a[i][0].trim() && (h = Math.max(h, a[i][1]["line-height"], a[i][1]["font-size"]), d = 7 * a[i][1]["font-size"]), i++;
                    var g = 0, m = 0;
                    for(void 0 !== a[0][1]["margin-left"] && 0 < a[0][1]["margin-left"] && (g = (m = this.pdf.internal.getCoordinateString(a[0][1]["margin-left"])) - p, p = m), c(g + Math.max(e["margin-left"] || 0, 0) * n, (-12 * h).toFixed(2), "Td"), i = 0, o = a.length; i !== o;)a[i][0] && this.RenderTextFragment(a[i][0], a[i][1]), i++;
                    if (this.y += h * n, this.executeWatchFunctions(a[0][1]) && 0 < s.length) {
                        var w = [], y = [];
                        s.forEach(function(t) {
                            for(var e = 0, n = t.length; e !== n;)t[e][0] && (w.push(t[e][0] + " "), y.push(t[e][1])), ++e;
                        }), s = this.splitFragmentsIntoLines(v(w), y), c("ET", "Q"), c("q", "BT 0 g", this.pdf.internal.getCoordinateString(this.x), this.pdf.internal.getVerticalCoordinateString(this.y), "Td");
                    }
                }
                return t && "function" == typeof t && t.call(this, this.x - 9, this.y - d / 2), c("ET", "Q"), this.y += l;
            }
        }, f.prototype.setBlockBoundary = function(t) {
            return this.renderParagraph(t);
        }, f.prototype.setBlockStyle = function(t) {
            return this.paragraph.blockstyle = t;
        }, f.prototype.addText = function(t, e) {
            return this.paragraph.text.push(t), this.paragraph.style.push(e);
        }, i = {
            helvetica: "helvetica",
            "sans-serif": "helvetica",
            "times new roman": "times",
            serif: "times",
            times: "times",
            monospace: "courier",
            courier: "courier"
        }, h = {
            100: "normal",
            200: "normal",
            300: "normal",
            400: "normal",
            500: "bold",
            600: "bold",
            700: "bold",
            800: "bold",
            900: "bold",
            normal: "normal",
            bold: "bold",
            bolder: "bold",
            lighter: "normal"
        }, a = {
            normal: "normal",
            italic: "italic",
            oblique: "italic"
        }, s = {
            left: "left",
            right: "right",
            center: "center",
            justify: "justify"
        }, c = {
            none: "none",
            right: "right",
            left: "left"
        }, l = {
            none: "none",
            both: "both"
        }, n = {
            normal: 1
        }, t.fromHTML = function(t, e, n, r, i, o) {
            return this.margins_doc = o || {
                top: 0,
                bottom: 0
            }, r || (r = {}), r.elementHandlers || (r.elementHandlers = {}), m(this, t, isNaN(e) ? 4 : e, isNaN(n) ? 4 : n, r, i);
        };
    }($.API), $.API.addJS = function(t) {
        return s = t, this.internal.events.subscribe("postPutResources", function(t) {
            n = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + (n + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), r = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + s + ")"), this.internal.out(">>"), this.internal.out("endobj");
        }), this.internal.events.subscribe("putCatalog", function() {
            void 0 !== n && void 0 !== r && this.internal.out("/Names <</JavaScript " + n + " 0 R>>");
        }), this;
    }, /**
   * jsPDF Outline PlugIn
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ (c = $.API).events.push([
        "postPutResources",
        function() {
            var t = this, e = /^(\d+) 0 obj$/;
            if (0 < this.outline.root.children.length) for(var n = t.outline.render().split(/\r\n/), r = 0; r < n.length; r++){
                var i = n[r], o = e.exec(i);
                if (null != o) {
                    var a = o[1];
                    t.internal.newObjectDeferredBegin(a);
                }
                t.internal.write(i);
            }
            if (this.outline.createNamedDestinations) {
                var s = this.internal.pages.length, h = [];
                for(r = 0; r < s; r++){
                    var c = t.internal.newObject();
                    h.push(c);
                    var l = t.internal.getPageInfo(r + 1);
                    t.internal.write("<< /D[" + l.objId + " 0 R /XYZ null null null]>> endobj");
                }
                var u = t.internal.newObject();
                for(t.internal.write("<< /Names [ "), r = 0; r < h.length; r++)t.internal.write("(page_" + (r + 1) + ")" + h[r] + " 0 R");
                t.internal.write(" ] >>", "endobj"), t.internal.newObject(), t.internal.write("<< /Dests " + u + " 0 R"), t.internal.write(">>", "endobj");
            }
        }
    ]), c.events.push([
        "putCatalog",
        function() {
            0 < this.outline.root.children.length && (this.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && this.internal.write("/Names " + namesOid + " 0 R"));
        }
    ]), c.events.push([
        "initialized",
        function() {
            var o = this;
            o.outline = {
                createNamedDestinations: !1,
                root: {
                    children: []
                }
            }, o.outline.add = function(t, e, n) {
                var r = {
                    title: e,
                    options: n,
                    children: []
                };
                return null == t && (t = this.root), t.children.push(r), r;
            }, o.outline.render = function() {
                return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = o, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
            }, o.outline.genIds_r = function(t) {
                t.id = o.internal.newObjectDeferred();
                for(var e = 0; e < t.children.length; e++)this.genIds_r(t.children[e]);
            }, o.outline.renderRoot = function(t) {
                this.objStart(t), this.line("/Type /Outlines"), 0 < t.children.length && (this.line("/First " + this.makeRef(t.children[0])), this.line("/Last " + this.makeRef(t.children[t.children.length - 1]))), this.line("/Count " + this.count_r({
                    count: 0
                }, t)), this.objEnd();
            }, o.outline.renderItems = function(t) {
                for(var e = 0; e < t.children.length; e++){
                    var n = t.children[e];
                    this.objStart(n), this.line("/Title " + this.makeString(n.title)), this.line("/Parent " + this.makeRef(t)), 0 < e && this.line("/Prev " + this.makeRef(t.children[e - 1])), e < t.children.length - 1 && this.line("/Next " + this.makeRef(t.children[e + 1])), 0 < n.children.length && (this.line("/First " + this.makeRef(n.children[0])), this.line("/Last " + this.makeRef(n.children[n.children.length - 1])));
                    var r = this.count = this.count_r({
                        count: 0
                    }, n);
                    if (0 < r && this.line("/Count " + r), n.options && n.options.pageNumber) {
                        var i = o.internal.getPageInfo(n.options.pageNumber);
                        this.line("/Dest [" + i.objId + " 0 R /XYZ 0 " + this.ctx.pdf.internal.pageSize.getHeight() * this.ctx.pdf.internal.scaleFactor + " 0]");
                    }
                    this.objEnd();
                }
                for(e = 0; e < t.children.length; e++)n = t.children[e], this.renderItems(n);
            }, o.outline.line = function(t) {
                this.ctx.val += t + "\r\n";
            }, o.outline.makeRef = function(t) {
                return t.id + " 0 R";
            }, o.outline.makeString = function(t) {
                return "(" + o.internal.pdfEscape(t) + ")";
            }, o.outline.objStart = function(t) {
                this.ctx.val += "\r\n" + t.id + " 0 obj\r\n<<\r\n";
            }, o.outline.objEnd = function(t) {
                this.ctx.val += ">> \r\nendobj\r\n";
            }, o.outline.count_r = function(t, e) {
                for(var n = 0; n < e.children.length; n++)t.count++, this.count_r(t, e.children[n]);
                return t.count;
            };
        }
    ]), /**@preserve
   *  ====================================================================
   * jsPDF PNG PlugIn
   * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   * ====================================================================
   */ P = $.API, E = function() {
        var t = "function" == typeof Deflater;
        if (!t) throw new Error("requires deflate.js for compression");
        return t;
    }, q = function(t, e, n, r) {
        var i = 5, o = b;
        switch(r){
            case P.image_compression.FAST:
                i = 3, o = v;
                break;
            case P.image_compression.MEDIUM:
                i = 6, o = x;
                break;
            case P.image_compression.SLOW:
                i = 9, o = S;
        }
        t = w(t, e, n, o);
        var a = new Uint8Array(g(i)), s = m(t), h = new Deflater(i), c = h.append(t), l = h.flush(), u = a.length + c.length + l.length, f = new Uint8Array(u + 4);
        return f.set(a), f.set(c, a.length), f.set(l, a.length + c.length), f[u++] = s >>> 24 & 255, f[u++] = s >>> 16 & 255, f[u++] = s >>> 8 & 255, f[u++] = 255 & s, P.arrayBufferToBinaryString(f);
    }, g = function(t, e) {
        var n = Math.LOG2E * Math.log(32768) - 8 << 4 | 8, r = n << 8;
        return r |= Math.min(3, (e - 1 & 255) >> 1) << 6, r |= 0, [
            n,
            255 & (r += 31 - r % 31)
        ];
    }, m = function(t, e) {
        for(var n, r = 1, i = 0, o = t.length, a = 0; 0 < o;){
            for(o -= n = e < o ? e : o; i += r += t[a++], --n;);
            r %= 65521, i %= 65521;
        }
        return (i << 16 | r) >>> 0;
    }, w = function(t, e, n, r) {
        for(var i, o, a, s = t.length / e, h = new Uint8Array(t.length + s), c = k(), l = 0; l < s; l++){
            if (a = l * e, i = t.subarray(a, a + e), r) h.set(r(i, n, o), a + l);
            else {
                for(var u = 0, f = c.length, d = []; u < f; u++)d[u] = c[u](i, n, o);
                var p = _(d.concat());
                h.set(d[p], a + l);
            }
            o = i;
        }
        return h;
    }, l = function(t, e, n) {
        var r = Array.apply([], t);
        return r.unshift(0), r;
    }, v = function(t, e, n) {
        var r, i = [], o = 0, a = t.length;
        for(i[0] = 1; o < a; o++)r = t[o - e] || 0, i[o + 1] = t[o] - r + 256 & 255;
        return i;
    }, b = function(t, e, n) {
        var r, i = [], o = 0, a = t.length;
        for(i[0] = 2; o < a; o++)r = n && n[o] || 0, i[o + 1] = t[o] - r + 256 & 255;
        return i;
    }, x = function(t, e, n) {
        var r, i, o = [], a = 0, s = t.length;
        for(o[0] = 3; a < s; a++)r = t[a - e] || 0, i = n && n[a] || 0, o[a + 1] = t[a] + 256 - (r + i >>> 1) & 255;
        return o;
    }, S = function(t, e, n) {
        var r, i, o, a, s = [], h = 0, c = t.length;
        for(s[0] = 4; h < c; h++)r = t[h - e] || 0, i = n && n[h] || 0, o = n && n[h - e] || 0, a = u(r, i, o), s[h + 1] = t[h] - a + 256 & 255;
        return s;
    }, u = function(t, e, n) {
        var r = t + e - n, i = Math.abs(r - t), o = Math.abs(r - e), a = Math.abs(r - n);
        return i <= o && i <= a ? t : o <= a ? e : n;
    }, k = function() {
        return [
            l,
            v,
            b,
            x,
            S
        ];
    }, _ = function(t) {
        for(var e, n, r, i = 0, o = t.length; i < o;)((e = f(t[i].slice(1))) < n || !n) && (n = e, r = i), i++;
        return r;
    }, f = function(t) {
        for(var e = 0, n = t.length, r = 0; e < n;)r += Math.abs(t[e++]);
        return r;
    }, P.processPNG = function(t, e, n, r, i) {
        var o, a, s, h, c, l, u = this.color_spaces.DEVICE_RGB, f = this.decode.FLATE_DECODE, d = 8;
        if (this.isArrayBuffer(t) && (t = new Uint8Array(t)), this.isArrayBufferView(t)) {
            if ("function" != typeof PNG || "function" != typeof kt) throw new Error("PNG support requires png.js and zlib.js");
            if (t = (o = new PNG(t)).imgData, d = o.bits, u = o.colorSpace, h = o.colors, -1 !== [
                4,
                6
            ].indexOf(o.colorType)) {
                if (8 === o.bits) for(var p, g = (I = 32 == o.pixelBitlength ? new Uint32Array(o.decodePixels().buffer) : 16 == o.pixelBitlength ? new Uint16Array(o.decodePixels().buffer) : new Uint8Array(o.decodePixels().buffer)).length, m = new Uint8Array(g * o.colors), w = new Uint8Array(g), y = o.pixelBitlength - o.bits, v = 0, b = 0; v < g; v++){
                    for(x = I[v], p = 0; p < y;)m[b++] = x >>> p & 255, p += o.bits;
                    w[v] = x >>> p & 255;
                }
                if (16 === o.bits) {
                    g = (I = new Uint32Array(o.decodePixels().buffer)).length, m = new Uint8Array(g * (32 / o.pixelBitlength) * o.colors), w = new Uint8Array(g * (32 / o.pixelBitlength));
                    for(var x, S = 1 < o.colors, k = b = v = 0; v < g;)x = I[v++], m[b++] = x >>> 0 & 255, S && (m[b++] = x >>> 16 & 255, x = I[v++], m[b++] = x >>> 0 & 255), w[k++] = x >>> 16 & 255;
                    d = 8;
                }
                r !== P.image_compression.NONE && E() ? (t = q(m, o.width * o.colors, o.colors, r), l = q(w, o.width, 1, r)) : (t = m, l = w, f = null);
            }
            if (3 === o.colorType && (u = this.color_spaces.INDEXED, c = o.palette, o.transparency.indexed)) {
                var _ = o.transparency.indexed, A = 0;
                for(v = 0, g = _.length; v < g; ++v)A += _[v];
                if ((A /= 255) == g - 1 && -1 !== _.indexOf(0)) s = [
                    _.indexOf(0)
                ];
                else if (A !== g) {
                    var I = o.decodePixels();
                    for(w = new Uint8Array(I.length), v = 0, g = I.length; v < g; v++)w[v] = _[I[v]];
                    l = q(w, o.width, 1);
                }
            }
            var C = function(t) {
                var e;
                switch(t){
                    case P.image_compression.FAST:
                        e = 11;
                        break;
                    case P.image_compression.MEDIUM:
                        e = 13;
                        break;
                    case P.image_compression.SLOW:
                        e = 14;
                        break;
                    default:
                        e = 12;
                }
                return e;
            }(r);
            return a = f === this.decode.FLATE_DECODE ? "/Predictor " + C + " /Colors " + h + " /BitsPerComponent " + d + " /Columns " + o.width : "/Colors " + h + " /BitsPerComponent " + d + " /Columns " + o.width, (this.isArrayBuffer(t) || this.isArrayBufferView(t)) && (t = this.arrayBufferToBinaryString(t)), (l && this.isArrayBuffer(l) || this.isArrayBufferView(l)) && (l = this.arrayBufferToBinaryString(l)), this.createImageInfo(t, o.width, o.height, u, d, f, e, n, a, s, c, l, C);
        }
        throw new Error("Unsupported PNG image data, try using JPEG instead.");
    }, /**
   * jsPDF gif Support PlugIn
   * Copyright (c) 2017 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ (A = $.API).processGIF89A = function(t, e, n, r, i) {
        var o = new mt(t), a = o.width, s = o.height, h = [];
        o.decodeAndBlitFrameRGBA(0, h);
        var c = {
            data: h,
            width: a,
            height: s
        }, l = new yt(100).encode(c, 100);
        return A.processJPEG.call(this, l, e, n, r);
    }, A.processGIF87A = A.processGIF89A, /**
   * jsPDF bmp Support PlugIn
   * Copyright (c) 2018 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ (O = $.API).processBMP = function(t, e, n, r, i) {
        var o = new xt(t, !1), a = o.width, s = o.height, h = {
            data: o.getData(),
            width: a,
            height: s
        }, c = new yt(100).encode(h, 100);
        return O.processJPEG.call(this, c, e, n, r);
    }, $.API.setLanguage = function(t) {
        return void 0 === this.internal.languageSettings && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), void 0 !== ({
            af: "Afrikaans",
            sq: "Albanian",
            ar: "Arabic (Standard)",
            "ar-DZ": "Arabic (Algeria)",
            "ar-BH": "Arabic (Bahrain)",
            "ar-EG": "Arabic (Egypt)",
            "ar-IQ": "Arabic (Iraq)",
            "ar-JO": "Arabic (Jordan)",
            "ar-KW": "Arabic (Kuwait)",
            "ar-LB": "Arabic (Lebanon)",
            "ar-LY": "Arabic (Libya)",
            "ar-MA": "Arabic (Morocco)",
            "ar-OM": "Arabic (Oman)",
            "ar-QA": "Arabic (Qatar)",
            "ar-SA": "Arabic (Saudi Arabia)",
            "ar-SY": "Arabic (Syria)",
            "ar-TN": "Arabic (Tunisia)",
            "ar-AE": "Arabic (U.A.E.)",
            "ar-YE": "Arabic (Yemen)",
            an: "Aragonese",
            hy: "Armenian",
            as: "Assamese",
            ast: "Asturian",
            az: "Azerbaijani",
            eu: "Basque",
            be: "Belarusian",
            bn: "Bengali",
            bs: "Bosnian",
            br: "Breton",
            bg: "Bulgarian",
            my: "Burmese",
            ca: "Catalan",
            ch: "Chamorro",
            ce: "Chechen",
            zh: "Chinese",
            "zh-HK": "Chinese (Hong Kong)",
            "zh-CN": "Chinese (PRC)",
            "zh-SG": "Chinese (Singapore)",
            "zh-TW": "Chinese (Taiwan)",
            cv: "Chuvash",
            co: "Corsican",
            cr: "Cree",
            hr: "Croatian",
            cs: "Czech",
            da: "Danish",
            nl: "Dutch (Standard)",
            "nl-BE": "Dutch (Belgian)",
            en: "English",
            "en-AU": "English (Australia)",
            "en-BZ": "English (Belize)",
            "en-CA": "English (Canada)",
            "en-IE": "English (Ireland)",
            "en-JM": "English (Jamaica)",
            "en-NZ": "English (New Zealand)",
            "en-PH": "English (Philippines)",
            "en-ZA": "English (South Africa)",
            "en-TT": "English (Trinidad & Tobago)",
            "en-GB": "English (United Kingdom)",
            "en-US": "English (United States)",
            "en-ZW": "English (Zimbabwe)",
            eo: "Esperanto",
            et: "Estonian",
            fo: "Faeroese",
            fj: "Fijian",
            fi: "Finnish",
            fr: "French (Standard)",
            "fr-BE": "French (Belgium)",
            "fr-CA": "French (Canada)",
            "fr-FR": "French (France)",
            "fr-LU": "French (Luxembourg)",
            "fr-MC": "French (Monaco)",
            "fr-CH": "French (Switzerland)",
            fy: "Frisian",
            fur: "Friulian",
            gd: "Gaelic (Scots)",
            "gd-IE": "Gaelic (Irish)",
            gl: "Galacian",
            ka: "Georgian",
            de: "German (Standard)",
            "de-AT": "German (Austria)",
            "de-DE": "German (Germany)",
            "de-LI": "German (Liechtenstein)",
            "de-LU": "German (Luxembourg)",
            "de-CH": "German (Switzerland)",
            el: "Greek",
            gu: "Gujurati",
            ht: "Haitian",
            he: "Hebrew",
            hi: "Hindi",
            hu: "Hungarian",
            is: "Icelandic",
            id: "Indonesian",
            iu: "Inuktitut",
            ga: "Irish",
            it: "Italian (Standard)",
            "it-CH": "Italian (Switzerland)",
            ja: "Japanese",
            kn: "Kannada",
            ks: "Kashmiri",
            kk: "Kazakh",
            km: "Khmer",
            ky: "Kirghiz",
            tlh: "Klingon",
            ko: "Korean",
            "ko-KP": "Korean (North Korea)",
            "ko-KR": "Korean (South Korea)",
            la: "Latin",
            lv: "Latvian",
            lt: "Lithuanian",
            lb: "Luxembourgish",
            mk: "FYRO Macedonian",
            ms: "Malay",
            ml: "Malayalam",
            mt: "Maltese",
            mi: "Maori",
            mr: "Marathi",
            mo: "Moldavian",
            nv: "Navajo",
            ng: "Ndonga",
            ne: "Nepali",
            no: "Norwegian",
            nb: "Norwegian (Bokmal)",
            nn: "Norwegian (Nynorsk)",
            oc: "Occitan",
            or: "Oriya",
            om: "Oromo",
            fa: "Persian",
            "fa-IR": "Persian/Iran",
            pl: "Polish",
            pt: "Portuguese",
            "pt-BR": "Portuguese (Brazil)",
            pa: "Punjabi",
            "pa-IN": "Punjabi (India)",
            "pa-PK": "Punjabi (Pakistan)",
            qu: "Quechua",
            rm: "Rhaeto-Romanic",
            ro: "Romanian",
            "ro-MO": "Romanian (Moldavia)",
            ru: "Russian",
            "ru-MO": "Russian (Moldavia)",
            sz: "Sami (Lappish)",
            sg: "Sango",
            sa: "Sanskrit",
            sc: "Sardinian",
            sd: "Sindhi",
            si: "Singhalese",
            sr: "Serbian",
            sk: "Slovak",
            sl: "Slovenian",
            so: "Somani",
            sb: "Sorbian",
            es: "Spanish",
            "es-AR": "Spanish (Argentina)",
            "es-BO": "Spanish (Bolivia)",
            "es-CL": "Spanish (Chile)",
            "es-CO": "Spanish (Colombia)",
            "es-CR": "Spanish (Costa Rica)",
            "es-DO": "Spanish (Dominican Republic)",
            "es-EC": "Spanish (Ecuador)",
            "es-SV": "Spanish (El Salvador)",
            "es-GT": "Spanish (Guatemala)",
            "es-HN": "Spanish (Honduras)",
            "es-MX": "Spanish (Mexico)",
            "es-NI": "Spanish (Nicaragua)",
            "es-PA": "Spanish (Panama)",
            "es-PY": "Spanish (Paraguay)",
            "es-PE": "Spanish (Peru)",
            "es-PR": "Spanish (Puerto Rico)",
            "es-ES": "Spanish (Spain)",
            "es-UY": "Spanish (Uruguay)",
            "es-VE": "Spanish (Venezuela)",
            sx: "Sutu",
            sw: "Swahili",
            sv: "Swedish",
            "sv-FI": "Swedish (Finland)",
            "sv-SV": "Swedish (Sweden)",
            ta: "Tamil",
            tt: "Tatar",
            te: "Teluga",
            th: "Thai",
            tig: "Tigre",
            ts: "Tsonga",
            tn: "Tswana",
            tr: "Turkish",
            tk: "Turkmen",
            uk: "Ukrainian",
            hsb: "Upper Sorbian",
            ur: "Urdu",
            ve: "Venda",
            vi: "Vietnamese",
            vo: "Volapuk",
            wa: "Walloon",
            cy: "Welsh",
            xh: "Xhosa",
            ji: "Yiddish",
            zu: "Zulu"
        })[t] && (this.internal.languageSettings.languageCode = t, !1 === this.internal.languageSettings.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
            this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
        }), this.internal.languageSettings.isSubscribed = !0)), this;
    }, /** @preserve
   * jsPDF split_text_to_size plugin - MIT license.
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Diego Casorran, https://github.com/diegocr
   */ B = $.API, R = B.getCharWidthsArray = function(t, e) {
        var n, r, i, o = (e = e || {}).font || this.internal.getFont(), a = e.fontSize || this.internal.getFontSize(), s = e.charSpace || this.internal.getCharSpace(), h = e.widths ? e.widths : o.metadata.Unicode.widths, c = h.fof ? h.fof : 1, l = e.kerning ? e.kerning : o.metadata.Unicode.kerning, u = l.fof ? l.fof : 1, f = 0, d = h[0] || c, p = [];
        for(n = 0, r = t.length; n < r; n++)i = t.charCodeAt(n), "function" == typeof o.metadata.widthOfString ? p.push((o.metadata.widthOfGlyph(o.metadata.characterToGlyph(i)) + s * (1e3 / a) || 0) / 1e3) : p.push((h[i] || d) / c + (l[i] && l[i][f] || 0) / u), f = i;
        return p;
    }, j = B.getArraySum = function(t) {
        for(var e = t.length, n = 0; e;)n += t[--e];
        return n;
    }, D = B.getStringUnitWidth = function(t, e) {
        var n = (e = e || {}).fontSize || this.internal.getFontSize(), r = e.font || this.internal.getFont(), i = e.charSpace || this.internal.getCharSpace();
        return "function" == typeof r.metadata.widthOfString ? r.metadata.widthOfString(t, n, i) / n : j(R.apply(this, arguments));
    }, M = function(t, e, n, r) {
        for(var i = [], o = 0, a = t.length, s = 0; o !== a && s + e[o] < n;)s += e[o], o++;
        i.push(t.slice(0, o));
        var h = o;
        for(s = 0; o !== a;)s + e[o] > r && (i.push(t.slice(h, o)), s = 0, h = o), s += e[o], o++;
        return h !== o && i.push(t.slice(h, o)), i;
    }, U = function(t, e, n) {
        n || (n = {});
        var r, i, o, a, s, h, c = [], l = [
            c
        ], u = n.textIndent || 0, f = 0, d = 0, p = t.split(" "), g = R.apply(this, [
            " ",
            n
        ])[0];
        if (h = -1 === n.lineIndent ? p[0].length + 2 : n.lineIndent || 0) {
            var m = Array(h).join(" "), w = [];
            p.map(function(t) {
                1 < (t = t.split(/\s*\n/)).length ? w = w.concat(t.map(function(t, e) {
                    return (e && t.length ? "\n" : "") + t;
                })) : w.push(t[0]);
            }), p = w, h = D.apply(this, [
                m,
                n
            ]);
        }
        for(o = 0, a = p.length; o < a; o++){
            var y = 0;
            if (r = p[o], h && "\n" == r[0] && (r = r.substr(1), y = 1), i = R.apply(this, [
                r,
                n
            ]), e < u + f + (d = j(i)) || y) {
                if (e < d) {
                    for(s = M.apply(this, [
                        r,
                        i,
                        e - (u + f),
                        e
                    ]), c.push(s.shift()), c = [
                        s.pop()
                    ]; s.length;)l.push([
                        s.shift()
                    ]);
                    d = j(i.slice(r.length - (c[0] ? c[0].length : 0)));
                } else c = [
                    r
                ];
                l.push(c), u = d + h, f = g;
            } else c.push(r), u += f + d, f = g;
        }
        if (h) var v = function(t, e) {
            return (e ? m : "") + t.join(" ");
        };
        else v = function(t) {
            return t.join(" ");
        };
        return l.map(v);
    }, B.splitTextToSize = function(t, e, n) {
        var r, i = (n = n || {}).fontSize || this.internal.getFontSize(), o = (function(t) {
            var e = {
                0: 1
            }, n = {};
            if (t.widths && t.kerning) return {
                widths: t.widths,
                kerning: t.kerning
            };
            var r = this.internal.getFont(t.fontName, t.fontStyle), i = "Unicode";
            return r.metadata[i] ? {
                widths: r.metadata[i].widths || e,
                kerning: r.metadata[i].kerning || n
            } : {
                font: r.metadata,
                fontSize: this.internal.getFontSize(),
                charSpace: this.internal.getCharSpace()
            };
        }).call(this, n);
        r = Array.isArray(t) ? t : t.split(/\r?\n/);
        var a = 1 * this.internal.scaleFactor * e / i;
        o.textIndent = n.textIndent ? 1 * n.textIndent * this.internal.scaleFactor / i : 0, o.lineIndent = n.lineIndent;
        var s, h, c = [];
        for(s = 0, h = r.length; s < h; s++)c = c.concat(U.apply(this, [
            r[s],
            a,
            o
        ]));
        return c;
    }, /** @preserve 
  jsPDF standard_fonts_metrics plugin
  Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
  MIT license.
  */ N = $.API, L = {
        codePages: [
            "WinAnsiEncoding"
        ],
        WinAnsiEncoding: (z = function(t) {
            for(var e = "klmnopqrstuvwxyz", n = {}, r = 0; r < e.length; r++)n[e[r]] = "0123456789abcdef"[r];
            var i, o, a, s, h, c = {}, l = 1, u = c, f = [], d = "", p = "", g = t.length - 1;
            for(r = 1; r != g;)h = t[r], r += 1, "'" == h ? o ? (s = o.join(""), o = i) : o = [] : o ? o.push(h) : "{" == h ? (f.push([
                u,
                s
            ]), u = {}, s = i) : "}" == h ? ((a = f.pop())[0][a[1]] = u, s = i, u = a[0]) : "-" == h ? l = -1 : s === i ? n.hasOwnProperty(h) ? (d += n[h], s = parseInt(d, 16) * l, l = 1, d = "") : d += h : n.hasOwnProperty(h) ? (p += n[h], u[s] = parseInt(p, 16) * l, l = 1, s = i, p = "") : p += h;
            return c;
        })("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")
    }, H = {
        Unicode: {
            Courier: L,
            "Courier-Bold": L,
            "Courier-BoldOblique": L,
            "Courier-Oblique": L,
            Helvetica: L,
            "Helvetica-Bold": L,
            "Helvetica-BoldOblique": L,
            "Helvetica-Oblique": L,
            "Times-Roman": L,
            "Times-Bold": L,
            "Times-BoldItalic": L,
            "Times-Italic": L
        }
    }, W = {
        Unicode: {
            "Courier-Oblique": z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-BoldItalic": z("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),
            "Helvetica-Bold": z("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            Courier: z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-BoldOblique": z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Bold": z("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),
            Symbol: z("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),
            Helvetica: z("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),
            "Helvetica-BoldOblique": z("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            ZapfDingbats: z("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-Bold": z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Italic": z("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),
            "Times-Roman": z("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),
            "Helvetica-Oblique": z("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")
        }
    }, N.events.push([
        "addFont",
        function(t) {
            var e, n, r, i = "Unicode";
            (e = W[i][t.postScriptName]) && ((n = t.metadata[i] ? t.metadata[i] : t.metadata[i] = {}).widths = e.widths, n.kerning = e.kerning), (r = H[i][t.postScriptName]) && ((n = t.metadata[i] ? t.metadata[i] : t.metadata[i] = {}).encoding = r).codePages && r.codePages.length && (t.encoding = r.codePages[0]);
        }
    ]), G = $, "undefined" != typeof self && self || "undefined" != typeof $parcel$global && $parcel$global || "undefined" != typeof window && window || Function("return this")(), G.API.events.push([
        "addFont",
        function(t) {
            G.API.existsFileInVFS(t.postScriptName) ? (t.metadata = G.API.TTFFont.open(t.postScriptName, t.fontName, G.API.getFileFromVFS(t.postScriptName), t.encoding), t.metadata.Unicode = t.metadata.Unicode || {
                encoding: {},
                kerning: {},
                widths: []
            }) : 14 < t.id.slice(1) && console.error("Font does not exist in FileInVFS, import fonts or remove declaration doc.addFont('" + t.postScriptName + "').");
        }
    ]), /** @preserve
  jsPDF SVG plugin
  Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
  */ (V = $.API).addSvg = function(t, e, n, r, i) {
        if (void 0 === e || void 0 === n) throw new Error("addSVG needs values for 'x' and 'y'");
        function o(t) {
            for(var e = parseFloat(t[1]), n = parseFloat(t[2]), r = [], i = 3, o = t.length; i < o;)"c" === t[i] ? (r.push([
                parseFloat(t[i + 1]),
                parseFloat(t[i + 2]),
                parseFloat(t[i + 3]),
                parseFloat(t[i + 4]),
                parseFloat(t[i + 5]),
                parseFloat(t[i + 6])
            ]), i += 7) : "l" === t[i] ? (r.push([
                parseFloat(t[i + 1]),
                parseFloat(t[i + 2])
            ]), i += 3) : i += 1;
            return [
                e,
                n,
                r
            ];
        }
        var a, s, h, c, l, u, f, d, p = (c = document, d = c.createElement("iframe"), l = ".jsPDF_sillysvg_iframe {display:none;position:absolute;}", (f = (u = c).createElement("style")).type = "text/css", f.styleSheet ? f.styleSheet.cssText = l : f.appendChild(u.createTextNode(l)), u.getElementsByTagName("head")[0].appendChild(f), d.name = "childframe", d.setAttribute("width", 0), d.setAttribute("height", 0), d.setAttribute("frameborder", "0"), d.setAttribute("scrolling", "no"), d.setAttribute("seamless", "seamless"), d.setAttribute("class", "jsPDF_sillysvg_iframe"), c.body.appendChild(d), d), g = (a = t, (h = ((s = p).contentWindow || s.contentDocument).document).write(a), h.close(), h.getElementsByTagName("svg")[0]), m = [
            1,
            1
        ], w = parseFloat(g.getAttribute("width")), y = parseFloat(g.getAttribute("height"));
        w && y && (r && i ? m = [
            r / w,
            i / y
        ] : r ? m = [
            r / w,
            r / w
        ] : i && (m = [
            i / y,
            i / y
        ]));
        var v, b, x, S, k = g.childNodes;
        for(v = 0, b = k.length; v < b; v++)(x = k[v]).tagName && "PATH" === x.tagName.toUpperCase() && ((S = o(x.getAttribute("d").split(" ")))[0] = S[0] * m[0] + e, S[1] = S[1] * m[1] + n, this.lines.call(this, S[2], S[0], S[1], m));
        return this;
    }, V.addSVG = V.addSvg, V.addSvgAsImage = function(t, e, n, r, i, o, a, s) {
        if (isNaN(e) || isNaN(n)) throw console.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
        if (isNaN(r) || isNaN(i)) throw console.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
        var h = document.createElement("canvas");
        h.width = r, h.height = i;
        var c = h.getContext("2d");
        return c.fillStyle = "#fff", c.fillRect(0, 0, h.width, h.height), canvg(h, t, {
            ignoreMouse: !0,
            ignoreAnimation: !0,
            ignoreDimensions: !0,
            ignoreClear: !0
        }), this.addImage(h.toDataURL("image/jpeg", 1), e, n, r, i, a, s), this;
    }, $.API.putTotalPages = function(t) {
        for(var e = new RegExp(t, "g"), n = 1; n <= this.internal.getNumberOfPages(); n++)for(var r = 0; r < this.internal.pages[n].length; r++)this.internal.pages[n][r] = this.internal.pages[n][r].replace(e, this.internal.getNumberOfPages());
        return this;
    }, $.API.viewerPreferences = function(t, e) {
        var n;
        t = t || {}, e = e || !1;
        var r, i, o = {
            HideToolbar: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.3
            },
            HideMenubar: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.3
            },
            HideWindowUI: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.3
            },
            FitWindow: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.3
            },
            CenterWindow: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.3
            },
            DisplayDocTitle: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.4
            },
            NonFullScreenPageMode: {
                defaultValue: "UseNone",
                value: "UseNone",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "UseNone",
                    "UseOutlines",
                    "UseThumbs",
                    "UseOC"
                ],
                pdfVersion: 1.3
            },
            Direction: {
                defaultValue: "L2R",
                value: "L2R",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "L2R",
                    "R2L"
                ],
                pdfVersion: 1.3
            },
            ViewArea: {
                defaultValue: "CropBox",
                value: "CropBox",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "MediaBox",
                    "CropBox",
                    "TrimBox",
                    "BleedBox",
                    "ArtBox"
                ],
                pdfVersion: 1.4
            },
            ViewClip: {
                defaultValue: "CropBox",
                value: "CropBox",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "MediaBox",
                    "CropBox",
                    "TrimBox",
                    "BleedBox",
                    "ArtBox"
                ],
                pdfVersion: 1.4
            },
            PrintArea: {
                defaultValue: "CropBox",
                value: "CropBox",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "MediaBox",
                    "CropBox",
                    "TrimBox",
                    "BleedBox",
                    "ArtBox"
                ],
                pdfVersion: 1.4
            },
            PrintClip: {
                defaultValue: "CropBox",
                value: "CropBox",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "MediaBox",
                    "CropBox",
                    "TrimBox",
                    "BleedBox",
                    "ArtBox"
                ],
                pdfVersion: 1.4
            },
            PrintScaling: {
                defaultValue: "AppDefault",
                value: "AppDefault",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "AppDefault",
                    "None"
                ],
                pdfVersion: 1.6
            },
            Duplex: {
                defaultValue: "",
                value: "none",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "Simplex",
                    "DuplexFlipShortEdge",
                    "DuplexFlipLongEdge",
                    "none"
                ],
                pdfVersion: 1.7
            },
            PickTrayByPDFSize: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.7
            },
            PrintPageRange: {
                defaultValue: "",
                value: "",
                type: "array",
                explicitSet: !1,
                valueSet: null,
                pdfVersion: 1.7
            },
            NumCopies: {
                defaultValue: 1,
                value: 1,
                type: "integer",
                explicitSet: !1,
                valueSet: null,
                pdfVersion: 1.7
            }
        }, a = Object.keys(o), s = [], h = 0, c = 0, l = 0, u = !0;
        function f(t, e) {
            var n, r = !1;
            for(n = 0; n < t.length; n += 1)t[n] === e && (r = !0);
            return r;
        }
        if (void 0 === this.internal.viewerpreferences && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(o)), this.internal.viewerpreferences.isSubscribed = !1), n = this.internal.viewerpreferences.configuration, "reset" === t || !0 === e) {
            var d = a.length;
            for(l = 0; l < d; l += 1)n[a[l]].value = n[a[l]].defaultValue, n[a[l]].explicitSet = !1;
        }
        if ("object" === (void 0 === t ? "undefined" : vt(t))) {
            for(r in t)if (i = t[r], f(a, r) && void 0 !== i) {
                if ("boolean" === n[r].type && "boolean" == typeof i) n[r].value = i;
                else if ("name" === n[r].type && f(n[r].valueSet, i)) n[r].value = i;
                else if ("integer" === n[r].type && Number.isInteger(i)) n[r].value = i;
                else if ("array" === n[r].type) {
                    for(h = 0; h < i.length; h += 1)if (u = !0, 1 === i[h].length && "number" == typeof i[h][0]) s.push(String(i[h]));
                    else if (1 < i[h].length) {
                        for(c = 0; c < i[h].length; c += 1)"number" != typeof i[h][c] && (u = !1);
                        !0 === u && s.push(String(i[h].join("-")));
                    }
                    n[r].value = String(s);
                } else n[r].value = n[r].defaultValue;
                n[r].explicitSet = !0;
            }
        }
        return !1 === this.internal.viewerpreferences.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
            var t, e = [];
            for(t in n)!0 === n[t].explicitSet && ("name" === n[t].type ? e.push("/" + t + " /" + n[t].value) : e.push("/" + t + " " + n[t].value));
            0 !== e.length && this.internal.write("/ViewerPreferences\n<<\n" + e.join("\n") + "\n>>");
        }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = n, this;
    }, /** ==================================================================== 
   * jsPDF XMP metadata plugin
   * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
   * 
   * 
   * ====================================================================
   */ Y = $.API, K = J = X = "", Y.addMetadata = function(t, e) {
        return J = e || "http://jspdf.default.namespaceuri/", X = t, this.internal.events.subscribe("postPutResources", function() {
            if (X) {
                var t = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + J + '"><jspdf:metadata>', e = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')), n = unescape(encodeURIComponent(t)), r = unescape(encodeURIComponent(X)), i = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")), o = unescape(encodeURIComponent("</x:xmpmeta>")), a = n.length + r.length + i.length + e.length + o.length;
                K = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + a + " >>"), this.internal.write("stream"), this.internal.write(e + n + r + i + o), this.internal.write("endstream"), this.internal.write("endobj");
            } else K = "";
        }), this.internal.events.subscribe("putCatalog", function() {
            K && this.internal.write("/Metadata " + K + " 0 R");
        }), this;
    }, function(l, t) {
        var e = l.API, m = [
            0
        ];
        e.events.push([
            "putFont",
            function(t) {
                !function(t, e, n) {
                    if (t.metadata instanceof l.API.TTFFont && "Identity-H" === t.encoding) {
                        for(var r = t.metadata.Unicode.widths, i = t.metadata.subset.encode(m), o = "", a = 0; a < i.length; a++)o += String.fromCharCode(i[a]);
                        var s = n();
                        e("<<"), e("/Length " + o.length), e("/Length1 " + o.length), e(">>"), e("stream"), e(o), e("endstream"), e("endobj");
                        var h = n();
                        e("<<"), e("/Type /FontDescriptor"), e("/FontName /" + t.fontName), e("/FontFile2 " + s + " 0 R"), e("/FontBBox " + l.API.PDFObject.convert(t.metadata.bbox)), e("/Flags " + t.metadata.flags), e("/StemV " + t.metadata.stemV), e("/ItalicAngle " + t.metadata.italicAngle), e("/Ascent " + t.metadata.ascender), e("/Descent " + t.metadata.decender), e("/CapHeight " + t.metadata.capHeight), e(">>"), e("endobj");
                        var c = n();
                        e("<<"), e("/Type /Font"), e("/BaseFont /" + t.fontName), e("/FontDescriptor " + h + " 0 R"), e("/W " + l.API.PDFObject.convert(r)), e("/CIDToGIDMap /Identity"), e("/DW 1000"), e("/Subtype /CIDFontType2"), e("/CIDSystemInfo"), e("<<"), e("/Supplement 0"), e("/Registry (Adobe)"), e("/Ordering (" + t.encoding + ")"), e(">>"), e(">>"), e("endobj"), t.objectNumber = n(), e("<<"), e("/Type /Font"), e("/Subtype /Type0"), e("/BaseFont /" + t.fontName), e("/Encoding /" + t.encoding), e("/DescendantFonts [" + c + " 0 R]"), e(">>"), e("endobj"), t.isAlreadyPutted = !0;
                    }
                }(t.font, t.out, t.newObject);
            }
        ]);
        e.events.push([
            "putFont",
            function(t) {
                !function(t, e, n) {
                    if (t.metadata instanceof l.API.TTFFont && "WinAnsiEncoding" === t.encoding) {
                        t.metadata.Unicode.widths;
                        for(var r = t.metadata.rawData, i = "", o = 0; o < r.length; o++)i += String.fromCharCode(r[o]);
                        var a = n();
                        e("<<"), e("/Length " + i.length), e("/Length1 " + i.length), e(">>"), e("stream"), e(i), e("endstream"), e("endobj");
                        var s = n();
                        for(e("<<"), e("/Descent " + t.metadata.decender), e("/CapHeight " + t.metadata.capHeight), e("/StemV " + t.metadata.stemV), e("/Type /FontDescriptor"), e("/FontFile2 " + a + " 0 R"), e("/Flags 96"), e("/FontBBox " + l.API.PDFObject.convert(t.metadata.bbox)), e("/FontName /" + t.fontName), e("/ItalicAngle " + t.metadata.italicAngle), e("/Ascent " + t.metadata.ascender), e(">>"), e("endobj"), t.objectNumber = n(), o = 0; o < t.metadata.hmtx.widths.length; o++)t.metadata.hmtx.widths[o] = parseInt(t.metadata.hmtx.widths[o] * (1e3 / t.metadata.head.unitsPerEm));
                        e("<</Subtype/TrueType/Type/Font/BaseFont/" + t.fontName + "/FontDescriptor " + s + " 0 R/Encoding/" + t.encoding + " /FirstChar 29 /LastChar 255 /Widths " + l.API.PDFObject.convert(t.metadata.hmtx.widths) + ">>"), e("endobj"), t.isAlreadyPutted = !0;
                    }
                }(t.font, t.out, t.newObject);
            }
        ]);
        var c = function(t) {
            var e, n, r = t.text || "", i = t.x, o = t.y, a = t.options || {}, s = t.mutex || {}, h = s.pdfEscape, c = s.activeFontKey, l = s.fonts, u = (s.activeFontSize, ""), f = 0, d = "", p = l[n = c].encoding;
            if ("Identity-H" !== l[n].encoding) return {
                text: r,
                x: i,
                y: o,
                options: a,
                mutex: s
            };
            for(d = r, n = c, "[object Array]" === Object.prototype.toString.call(r) && (d = r[0]), f = 0; f < d.length; f += 1)l[n].metadata.hasOwnProperty("cmap") && (e = l[n].metadata.cmap.unicode.codeMap[d[f].charCodeAt(0)]), e ? u += d[f] : d[f].charCodeAt(0) < 256 && l[n].metadata.hasOwnProperty("Unicode") ? u += d[f] : u += "";
            var g = "";
            return parseInt(n.slice(1)) < 14 || "WinAnsiEncoding" === p ? g = function(t) {
                for(var e = "", n = 0; n < t.length; n++)e += "" + t.charCodeAt(n).toString(16);
                return e;
            }(h(u, n)) : "Identity-H" === p && (g = function(t, e) {
                for(var n, r = e.metadata.Unicode.widths, i = [
                    "",
                    "0",
                    "00",
                    "000",
                    "0000"
                ], o = [
                    ""
                ], a = 0, s = t.length; a < s; ++a){
                    if (n = e.metadata.characterToGlyph(t.charCodeAt(a)), m.push(n), -1 == r.indexOf(n) && (r.push(n), r.push([
                        parseInt(e.metadata.widthOfGlyph(n), 10)
                    ])), "0" == n) return o.join("");
                    n = n.toString(16), o.push(i[4 - n.length], n);
                }
                return o.join("");
            }(u, l[n])), s.isHex = !0, {
                text: g,
                x: i,
                y: o,
                options: a,
                mutex: s
            };
        };
        e.events.push([
            "postProcessText",
            function(t) {
                var e = t.text || "", n = t.x, r = t.y, i = t.options, o = t.mutex, a = (i.lang, []), s = {
                    text: e,
                    x: n,
                    y: r,
                    options: i,
                    mutex: o
                };
                if ("[object Array]" === Object.prototype.toString.call(e)) {
                    var h = 0;
                    for(h = 0; h < e.length; h += 1)"[object Array]" === Object.prototype.toString.call(e[h]) && 3 === e[h].length ? a.push([
                        c(Object.assign({}, s, {
                            text: e[h][0]
                        })).text,
                        e[h][1],
                        e[h][2]
                    ]) : a.push(c(Object.assign({}, s, {
                        text: e[h]
                    })).text);
                    t.text = a;
                } else t.text = c(Object.assign({}, s, {
                    text: e
                })).text;
            }
        ]);
    }($, "undefined" != typeof self && self || "undefined" != typeof $parcel$global && $parcel$global || "undefined" != typeof window && window || Function("return this")()), Q = $.API, Z = {}, Q.existsFileInVFS = function(t) {
        return Z.hasOwnProperty(t);
    }, Q.addFileToVFS = function(t, e) {
        return Z[t] = e, this;
    }, Q.getFileFromVFS = function(t) {
        return Z.hasOwnProperty(t) ? Z[t] : null;
    }, function(t) {
        if (t.URL = t.URL || t.webkitURL, t.Blob && t.URL) try {
            return new Blob;
        } catch (t) {}
        var s = t.BlobBuilder || t.WebKitBlobBuilder || t.MozBlobBuilder || function(t) {
            var s = function(t) {
                return Object.prototype.toString.call(t).match(/^\[object\s(.*)\]$/)[1];
            }, e = function() {
                this.data = [];
            }, h = function(t, e, n) {
                this.data = t, this.size = t.length, this.type = e, this.encoding = n;
            }, n = e.prototype, r = h.prototype, c = t.FileReaderSync, l = function(t) {
                this.code = this[this.name = t];
            }, i = "NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR".split(" "), o = i.length, a = t.URL || t.webkitURL || t, u = a.createObjectURL, f = a.revokeObjectURL, d = a, p = t.btoa, g = t.atob, m = t.ArrayBuffer, w = t.Uint8Array, y = /^[\w-]+:\/*\[?[\w\.:-]+\]?(?::[0-9]+)?/;
            for(h.fake = r.fake = !0; o--;)l.prototype[i[o]] = o + 1;
            return a.createObjectURL || (d = t.URL = function(t) {
                var e, n = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
                return n.href = t, "origin" in n || ("data:" === n.protocol.toLowerCase() ? n.origin = null : (e = t.match(y), n.origin = e && e[1])), n;
            }), d.createObjectURL = function(t) {
                var e, n = t.type;
                return null === n && (n = "application/octet-stream"), t instanceof h ? (e = "data:" + n, "base64" === t.encoding ? e + ";base64," + t.data : "URI" === t.encoding ? e + "," + decodeURIComponent(t.data) : p ? e + ";base64," + p(t.data) : e + "," + encodeURIComponent(t.data)) : u ? u.call(a, t) : void 0;
            }, d.revokeObjectURL = function(t) {
                "data:" !== t.substring(0, 5) && f && f.call(a, t);
            }, n.append = function(t) {
                var e = this.data;
                if (w && (t instanceof m || t instanceof w)) {
                    for(var n = "", r = new w(t), i = 0, o = r.length; i < o; i++)n += String.fromCharCode(r[i]);
                    e.push(n);
                } else if ("Blob" === s(t) || "File" === s(t)) {
                    if (!c) throw new l("NOT_READABLE_ERR");
                    var a = new c;
                    e.push(a.readAsBinaryString(t));
                } else t instanceof h ? "base64" === t.encoding && g ? e.push(g(t.data)) : "URI" === t.encoding ? e.push(decodeURIComponent(t.data)) : "raw" === t.encoding && e.push(t.data) : ("string" != typeof t && (t += ""), e.push(unescape(encodeURIComponent(t))));
            }, n.getBlob = function(t) {
                return arguments.length || (t = null), new h(this.data.join(""), t, "raw");
            }, n.toString = function() {
                return "[object BlobBuilder]";
            }, r.slice = function(t, e, n) {
                var r = arguments.length;
                return r < 3 && (n = null), new h(this.data.slice(t, 1 < r ? e : this.data.length), n, this.encoding);
            }, r.toString = function() {
                return "[object Blob]";
            }, r.close = function() {
                this.size = 0, delete this.data;
            }, e;
        }(t);
        t.Blob = function(t, e) {
            var n = e && e.type || "", r = new s;
            if (t) for(var i = 0, o = t.length; i < o; i++)Uint8Array && t[i] instanceof Uint8Array ? r.append(t[i].buffer) : r.append(t[i]);
            var a = r.getBlob(n);
            return !a.slice && a.webkitSlice && (a.slice = a.webkitSlice), a;
        };
        var e = Object.getPrototypeOf || function(t) {
            return t.__proto__;
        };
        t.Blob.prototype = e(new t.Blob);
    }("undefined" != typeof self && self || "undefined" != typeof window && window || window.content || window);
    var tt, et, nt, rt, it, ot, at, st, ht, ct, lt, ut, ft, dt, pt, gt, bt = bt || function(s) {
        if (!(void 0 === s || "undefined" != typeof navigator && /MSIE [1-9]\./.test(navigator.userAgent))) {
            var t = s.document, h = function() {
                return s.URL || s.webkitURL || s;
            }, c = t.createElementNS("http://www.w3.org/1999/xhtml", "a"), l = "download" in c, u = /constructor/i.test(s.HTMLElement) || s.safari, f = /CriOS\/[\d]+/.test(navigator.userAgent), d = function(t) {
                (s.setImmediate || s.setTimeout)(function() {
                    throw t;
                }, 0);
            }, p = function(t) {
                setTimeout(function() {
                    "string" == typeof t ? h().revokeObjectURL(t) : t.remove();
                }, 4e4);
            }, g = function(t) {
                return /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type) ? new Blob([
                    String.fromCharCode(65279),
                    t
                ], {
                    type: t.type
                }) : t;
            }, r = function(t, n, e) {
                e || (t = g(t));
                var r, i = this, o = "application/octet-stream" === t.type, a = function() {
                    !function(t, e, n) {
                        for(var r = (e = [].concat(e)).length; r--;){
                            var i = t["on" + e[r]];
                            if ("function" == typeof i) try {
                                i.call(t, n || t);
                            } catch (t) {
                                d(t);
                            }
                        }
                    }(i, "writestart progress write writeend".split(" "));
                };
                if (i.readyState = i.INIT, l) return r = h().createObjectURL(t), void setTimeout(function() {
                    var t, e;
                    c.href = r, c.download = n, t = c, e = new MouseEvent("click"), t.dispatchEvent(e), a(), p(r), i.readyState = i.DONE;
                });
                !function() {
                    if ((f || o && u) && s.FileReader) {
                        var e = new FileReader;
                        return e.onloadend = function() {
                            var t = f ? e.result : e.result.replace(/^data:[^;]*;/, "data:attachment/file;");
                            s.open(t, "_blank") || (s.location.href = t), t = void 0, i.readyState = i.DONE, a();
                        }, e.readAsDataURL(t), i.readyState = i.INIT;
                    }
                    r || (r = h().createObjectURL(t)), o ? s.location.href = r : s.open(r, "_blank") || (s.location.href = r);
                    i.readyState = i.DONE, a(), p(r);
                }();
            }, e = r.prototype;
            return "undefined" != typeof navigator && navigator.msSaveOrOpenBlob ? function(t, e, n) {
                return e = e || t.name || "download", n || (t = g(t)), navigator.msSaveOrOpenBlob(t, e);
            } : (e.abort = function() {}, e.readyState = e.INIT = 0, e.WRITING = 1, e.DONE = 2, e.error = e.onwritestart = e.onprogress = e.onwrite = e.onabort = e.onerror = e.onwriteend = null, function(t, e, n) {
                return new r(t, e || t.name || "download", n);
            });
        }
    }("undefined" != typeof self && self || "undefined" != typeof window && window || window.content);
    function mt(x) {
        var t = 0;
        if (71 !== x[t++] || 73 !== x[t++] || 70 !== x[t++] || 56 !== x[t++] || 56 != (x[t++] + 1 & 253) || 97 !== x[t++]) throw "Invalid GIF 87a/89a header.";
        var S = x[t++] | x[t++] << 8, e = x[t++] | x[t++] << 8, n = x[t++], r = n >> 7, i = 1 << (7 & n) + 1;
        x[t++];
        x[t++];
        var o = null;
        r && (o = t, t += 3 * i);
        var a = !0, s = [], h = 0, c = null, l = 0, u = null;
        for(this.width = S, this.height = e; a && t < x.length;)switch(x[t++]){
            case 33:
                switch(x[t++]){
                    case 255:
                        if (11 !== x[t] || 78 == x[t + 1] && 69 == x[t + 2] && 84 == x[t + 3] && 83 == x[t + 4] && 67 == x[t + 5] && 65 == x[t + 6] && 80 == x[t + 7] && 69 == x[t + 8] && 50 == x[t + 9] && 46 == x[t + 10] && 48 == x[t + 11] && 3 == x[t + 12] && 1 == x[t + 13] && 0 == x[t + 16]) t += 14, u = x[t++] | x[t++] << 8, t++;
                        else for(t += 12;;){
                            if (0 === (_ = x[t++])) break;
                            t += _;
                        }
                        break;
                    case 249:
                        if (4 !== x[t++] || 0 !== x[t + 4]) throw "Invalid graphics extension block.";
                        var f = x[t++];
                        h = x[t++] | x[t++] << 8, c = x[t++], 0 == (1 & f) && (c = null), l = f >> 2 & 7, t++;
                        break;
                    case 254:
                        for(;;){
                            if (0 === (_ = x[t++])) break;
                            t += _;
                        }
                        break;
                    default:
                        throw "Unknown graphic control label: 0x" + x[t - 1].toString(16);
                }
                break;
            case 44:
                var d = x[t++] | x[t++] << 8, p = x[t++] | x[t++] << 8, g = x[t++] | x[t++] << 8, m = x[t++] | x[t++] << 8, w = x[t++], y = w >> 6 & 1, v = o, b = !1;
                if (w >> 7) {
                    b = !0;
                    v = t, t += 3 * (1 << (7 & w) + 1);
                }
                var k = t;
                for(t++;;){
                    var _;
                    if (0 === (_ = x[t++])) break;
                    t += _;
                }
                s.push({
                    x: d,
                    y: p,
                    width: g,
                    height: m,
                    has_local_palette: b,
                    palette_offset: v,
                    data_offset: k,
                    data_length: t - k,
                    transparent_index: c,
                    interlaced: !!y,
                    delay: h,
                    disposal: l
                });
                break;
            case 59:
                a = !1;
                break;
            default:
                throw "Unknown gif block: 0x" + x[t - 1].toString(16);
        }
        this.numFrames = function() {
            return s.length;
        }, this.loopCount = function() {
            return u;
        }, this.frameInfo = function(t) {
            if (t < 0 || t >= s.length) throw "Frame index out of range.";
            return s[t];
        }, this.decodeAndBlitFrameBGRA = function(t, e) {
            var n = this.frameInfo(t), r = n.width * n.height, i = new Uint8Array(r);
            wt(x, n.data_offset, i, r);
            var o = n.palette_offset, a = n.transparent_index;
            null === a && (a = 256);
            var s = n.width, h = S - s, c = s, l = 4 * (n.y * S + n.x), u = 4 * ((n.y + n.height) * S + n.x), f = l, d = 4 * h;
            !0 === n.interlaced && (d += 4 * (s + h) * 7);
            for(var p = 8, g = 0, m = i.length; g < m; ++g){
                var w = i[g];
                if (0 === c && (c = s, u <= (f += d) && (d = h + 4 * (s + h) * (p - 1), f = l + (s + h) * (p << 1), p >>= 1)), w === a) f += 4;
                else {
                    var y = x[o + 3 * w], v = x[o + 3 * w + 1], b = x[o + 3 * w + 2];
                    e[f++] = b, e[f++] = v, e[f++] = y, e[f++] = 255;
                }
                --c;
            }
        }, this.decodeAndBlitFrameRGBA = function(t, e) {
            var n = this.frameInfo(t), r = n.width * n.height, i = new Uint8Array(r);
            wt(x, n.data_offset, i, r);
            var o = n.palette_offset, a = n.transparent_index;
            null === a && (a = 256);
            var s = n.width, h = S - s, c = s, l = 4 * (n.y * S + n.x), u = 4 * ((n.y + n.height) * S + n.x), f = l, d = 4 * h;
            !0 === n.interlaced && (d += 4 * (s + h) * 7);
            for(var p = 8, g = 0, m = i.length; g < m; ++g){
                var w = i[g];
                if (0 === c && (c = s, u <= (f += d) && (d = h + 4 * (s + h) * (p - 1), f = l + (s + h) * (p << 1), p >>= 1)), w === a) f += 4;
                else {
                    var y = x[o + 3 * w], v = x[o + 3 * w + 1], b = x[o + 3 * w + 2];
                    e[f++] = y, e[f++] = v, e[f++] = b, e[f++] = 255;
                }
                --c;
            }
        };
    }
    function wt(t, e, n, r) {
        for(var i = t[e++], o = 1 << i, a = o + 1, s = a + 1, h = i + 1, c = (1 << h) - 1, l = 0, u = 0, f = 0, d = t[e++], p = new Int32Array(4096), g = null;;){
            for(; l < 16 && 0 !== d;)u |= t[e++] << l, l += 8, 1 === d ? d = t[e++] : --d;
            if (l < h) break;
            var m = u & c;
            if (u >>= h, l -= h, m !== o) {
                if (m === a) break;
                for(var w = m < s ? m : g, y = 0, v = w; o < v;)v = p[v] >> 8, ++y;
                var b = v;
                if (r < f + y + (w !== m ? 1 : 0)) return void console.log("Warning, gif stream longer than expected.");
                n[f++] = b;
                var x = f += y;
                for(w !== m && (n[f++] = b), v = w; y--;)v = p[v], n[--x] = 255 & v, v >>= 8;
                null !== g && s < 4096 && (p[s++] = g << 8 | b, c + 1 <= s && h < 12 && (++h, c = c << 1 | 1)), g = m;
            } else s = a + 1, c = (1 << (h = i + 1)) - 1, g = null;
        }
        return f !== r && console.log("Warning, gif stream shorter than expected."), n;
    }
    (0, module.exports) ? module.exports.saveAs = bt : "undefined" != typeof define && null !== define && null !== define.amd && define("FileSaver.js", function() {
        return bt;
    }), $.API.adler32cs = (ot = "function" == typeof ArrayBuffer && "function" == typeof Uint8Array, at = null, st = function() {
        if (!ot) return function() {
            return !1;
        };
        try {
            var t = {};
            "function" == typeof t.Buffer && (at = t.Buffer);
        } catch (t) {}
        return function(t) {
            return t instanceof ArrayBuffer || null !== at && t instanceof at;
        };
    }(), ht = null !== at ? function(t) {
        return new at(t, "utf8").toString("binary");
    } : function(t) {
        return unescape(encodeURIComponent(t));
    }, ct = 65521, lt = function(t, e) {
        for(var n = 65535 & t, r = t >>> 16, i = 0, o = e.length; i < o; i++)n = (n + (255 & e.charCodeAt(i))) % ct, r = (r + n) % ct;
        return (r << 16 | n) >>> 0;
    }, ut = function(t, e) {
        for(var n = 65535 & t, r = t >>> 16, i = 0, o = e.length; i < o; i++)n = (n + e[i]) % ct, r = (r + n) % ct;
        return (r << 16 | n) >>> 0;
    }, dt = (ft = {}).Adler32 = (((it = (rt = function(t) {
        if (!(this instanceof rt)) throw new TypeError("Constructor cannot called be as a function.");
        if (!isFinite(t = null == t ? 1 : +t)) throw new Error("First arguments needs to be a finite number.");
        this.checksum = t >>> 0;
    }).prototype = {}).constructor = rt).from = ((tt = function(t) {
        if (!(this instanceof rt)) throw new TypeError("Constructor cannot called be as a function.");
        if (null == t) throw new Error("First argument needs to be a string.");
        this.checksum = lt(1, t.toString());
    }).prototype = it, tt), rt.fromUtf8 = ((et = function(t) {
        if (!(this instanceof rt)) throw new TypeError("Constructor cannot called be as a function.");
        if (null == t) throw new Error("First argument needs to be a string.");
        var e = ht(t.toString());
        this.checksum = lt(1, e);
    }).prototype = it, et), ot && (rt.fromBuffer = ((nt = function(t) {
        if (!(this instanceof rt)) throw new TypeError("Constructor cannot called be as a function.");
        if (!st(t)) throw new Error("First argument needs to be ArrayBuffer.");
        var e = new Uint8Array(t);
        return this.checksum = ut(1, e);
    }).prototype = it, nt)), it.update = function(t) {
        if (null == t) throw new Error("First argument needs to be a string.");
        return t = t.toString(), this.checksum = lt(this.checksum, t);
    }, it.updateUtf8 = function(t) {
        if (null == t) throw new Error("First argument needs to be a string.");
        var e = ht(t.toString());
        return this.checksum = lt(this.checksum, e);
    }, ot && (it.updateBuffer = function(t) {
        if (!st(t)) throw new Error("First argument needs to be ArrayBuffer.");
        var e = new Uint8Array(t);
        return this.checksum = ut(this.checksum, e);
    }), it.clone = function() {
        return new dt(this.checksum);
    }, rt), ft.from = function(t) {
        if (null == t) throw new Error("First argument needs to be a string.");
        return lt(1, t.toString());
    }, ft.fromUtf8 = function(t) {
        if (null == t) throw new Error("First argument needs to be a string.");
        var e = ht(t.toString());
        return lt(1, e);
    }, ot && (ft.fromBuffer = function(t) {
        if (!st(t)) throw new Error("First argument need to be ArrayBuffer.");
        var e = new Uint8Array(t);
        return ut(1, e);
    }), ft);
    try {
        module.exports.GifWriter = function(w, t, e, n) {
            var y = 0, r = void 0 === (n = void 0 === n ? {} : n).loop ? null : n.loop, v = void 0 === n.palette ? null : n.palette;
            if (t <= 0 || e <= 0 || 65535 < t || 65535 < e) throw "Width/Height invalid.";
            function b(t) {
                var e = t.length;
                if (e < 2 || 256 < e || e & e - 1) throw "Invalid code/color length, must be power of 2 and 2 .. 256.";
                return e;
            }
            w[y++] = 71, w[y++] = 73, w[y++] = 70, w[y++] = 56, w[y++] = 57, w[y++] = 97;
            var i = 0, o = 0;
            if (null !== v) {
                for(var a = b(v); a >>= 1;)++i;
                if (a = 1 << i, --i, void 0 !== n.background) {
                    if (a <= (o = n.background)) throw "Background index out of range.";
                    if (0 === o) throw "Background index explicitly passed as 0.";
                }
            }
            if (w[y++] = 255 & t, w[y++] = t >> 8 & 255, w[y++] = 255 & e, w[y++] = e >> 8 & 255, w[y++] = (null !== v ? 128 : 0) | i, w[y++] = o, w[y++] = 0, null !== v) for(var s = 0, h = v.length; s < h; ++s){
                var c = v[s];
                w[y++] = c >> 16 & 255, w[y++] = c >> 8 & 255, w[y++] = 255 & c;
            }
            if (null !== r) {
                if (r < 0 || 65535 < r) throw "Loop count invalid.";
                w[y++] = 33, w[y++] = 255, w[y++] = 11, w[y++] = 78, w[y++] = 69, w[y++] = 84, w[y++] = 83, w[y++] = 67, w[y++] = 65, w[y++] = 80, w[y++] = 69, w[y++] = 50, w[y++] = 46, w[y++] = 48, w[y++] = 3, w[y++] = 1, w[y++] = 255 & r, w[y++] = r >> 8 & 255, w[y++] = 0;
            }
            var x = !1;
            this.addFrame = function(t, e, n, r, i, o) {
                if (!0 === x && (--y, x = !1), o = void 0 === o ? {} : o, t < 0 || e < 0 || 65535 < t || 65535 < e) throw "x/y invalid.";
                if (n <= 0 || r <= 0 || 65535 < n || 65535 < r) throw "Width/Height invalid.";
                if (i.length < n * r) throw "Not enough pixels for the frame size.";
                var a = !0, s = o.palette;
                if (null == s && (a = !1, s = v), null == s) throw "Must supply either a local or global palette.";
                for(var h = b(s), c = 0; h >>= 1;)++c;
                h = 1 << c;
                var l = void 0 === o.delay ? 0 : o.delay, u = void 0 === o.disposal ? 0 : o.disposal;
                if (u < 0 || 3 < u) throw "Disposal out of range.";
                var f = !1, d = 0;
                if (void 0 !== o.transparent && null !== o.transparent && (f = !0, (d = o.transparent) < 0 || h <= d)) throw "Transparent color index.";
                if ((0 !== u || f || 0 !== l) && (w[y++] = 33, w[y++] = 249, w[y++] = 4, w[y++] = u << 2 | (!0 === f ? 1 : 0), w[y++] = 255 & l, w[y++] = l >> 8 & 255, w[y++] = d, w[y++] = 0), w[y++] = 44, w[y++] = 255 & t, w[y++] = t >> 8 & 255, w[y++] = 255 & e, w[y++] = e >> 8 & 255, w[y++] = 255 & n, w[y++] = n >> 8 & 255, w[y++] = 255 & r, w[y++] = r >> 8 & 255, w[y++] = !0 === a ? 128 | c - 1 : 0, !0 === a) for(var p = 0, g = s.length; p < g; ++p){
                    var m = s[p];
                    w[y++] = m >> 16 & 255, w[y++] = m >> 8 & 255, w[y++] = 255 & m;
                }
                y = function(e, n, t, r) {
                    e[n++] = t;
                    var i = n++, o = 1 << t, a = o - 1, s = o + 1, h = s + 1, c = t + 1, l = 0, u = 0;
                    function f(t) {
                        for(; t <= l;)e[n++] = 255 & u, u >>= 8, l -= 8, n === i + 256 && (e[i] = 255, i = n++);
                    }
                    function d(t) {
                        u |= t << l, l += c, f(8);
                    }
                    var p = r[0] & a, g = {};
                    d(o);
                    for(var m = 1, w = r.length; m < w; ++m){
                        var y = r[m] & a, v = p << 8 | y, b = g[v];
                        if (void 0 === b) {
                            for(u |= p << l, l += c; 8 <= l;)e[n++] = 255 & u, u >>= 8, l -= 8, n === i + 256 && (e[i] = 255, i = n++);
                            4096 === h ? (d(o), h = s + 1, c = t + 1, g = {}) : (1 << c <= h && ++c, g[v] = h++), p = y;
                        } else p = b;
                    }
                    return d(p), d(s), f(1), i + 1 === n ? e[i] = 0 : (e[i] = n - i - 1, e[n++] = 0), n;
                }(w, y, c < 2 ? 2 : c, i);
            }, this.end = function() {
                return !1 === x && (w[y++] = 59, x = !0), y;
            };
        }, module.exports.GifReader = mt;
    } catch (t) {}
    /*
    Copyright (c) 2008, Adobe Systems Incorporated
    All rights reserved.

    Redistribution and use in source and binary forms, with or without 
    modification, are permitted provided that the following conditions are
    met:

    * Redistributions of source code must retain the above copyright notice, 
      this list of conditions and the following disclaimer.
    
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the 
      documentation and/or other materials provided with the distribution.
    
    * Neither the name of Adobe Systems Incorporated nor the names of its 
      contributors may be used to endorse or promote products derived from 
      this software without specific prior written permission.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
    IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
    THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
    PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
    CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
    EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
    PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
    PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
    LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
    NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
    SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */ function yt(t) {
        var S, k, _, A, e, u = Math.floor, I = new Array(64), C = new Array(64), T = new Array(64), F = new Array(64), w = new Array(65535), y = new Array(65535), Q = new Array(64), v = new Array(64), P = [], E = 0, q = 7, O = new Array(64), B = new Array(64), R = new Array(64), n = new Array(256), j = new Array(2048), b = [
            0,
            1,
            5,
            6,
            14,
            15,
            27,
            28,
            2,
            4,
            7,
            13,
            16,
            26,
            29,
            42,
            3,
            8,
            12,
            17,
            25,
            30,
            41,
            43,
            9,
            11,
            18,
            24,
            31,
            40,
            44,
            53,
            10,
            19,
            23,
            32,
            39,
            45,
            52,
            54,
            20,
            22,
            33,
            38,
            46,
            51,
            55,
            60,
            21,
            34,
            37,
            47,
            50,
            56,
            59,
            61,
            35,
            36,
            48,
            49,
            57,
            58,
            62,
            63
        ], D = [
            0,
            0,
            1,
            5,
            1,
            1,
            1,
            1,
            1,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], M = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ], U = [
            0,
            0,
            2,
            1,
            3,
            3,
            2,
            4,
            3,
            5,
            5,
            4,
            4,
            0,
            0,
            1,
            125
        ], N = [
            1,
            2,
            3,
            0,
            4,
            17,
            5,
            18,
            33,
            49,
            65,
            6,
            19,
            81,
            97,
            7,
            34,
            113,
            20,
            50,
            129,
            145,
            161,
            8,
            35,
            66,
            177,
            193,
            21,
            82,
            209,
            240,
            36,
            51,
            98,
            114,
            130,
            9,
            10,
            22,
            23,
            24,
            25,
            26,
            37,
            38,
            39,
            40,
            41,
            42,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            90,
            99,
            100,
            101,
            102,
            103,
            104,
            105,
            106,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            131,
            132,
            133,
            134,
            135,
            136,
            137,
            138,
            146,
            147,
            148,
            149,
            150,
            151,
            152,
            153,
            154,
            162,
            163,
            164,
            165,
            166,
            167,
            168,
            169,
            170,
            178,
            179,
            180,
            181,
            182,
            183,
            184,
            185,
            186,
            194,
            195,
            196,
            197,
            198,
            199,
            200,
            201,
            202,
            210,
            211,
            212,
            213,
            214,
            215,
            216,
            217,
            218,
            225,
            226,
            227,
            228,
            229,
            230,
            231,
            232,
            233,
            234,
            241,
            242,
            243,
            244,
            245,
            246,
            247,
            248,
            249,
            250
        ], z = [
            0,
            0,
            3,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            0,
            0,
            0,
            0,
            0
        ], L = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ], H = [
            0,
            0,
            2,
            1,
            2,
            4,
            4,
            3,
            4,
            7,
            5,
            4,
            4,
            0,
            1,
            2,
            119
        ], W = [
            0,
            1,
            2,
            3,
            17,
            4,
            5,
            33,
            49,
            6,
            18,
            65,
            81,
            7,
            97,
            113,
            19,
            34,
            50,
            129,
            8,
            20,
            66,
            145,
            161,
            177,
            193,
            9,
            35,
            51,
            82,
            240,
            21,
            98,
            114,
            209,
            10,
            22,
            36,
            52,
            225,
            37,
            241,
            23,
            24,
            25,
            26,
            38,
            39,
            40,
            41,
            42,
            53,
            54,
            55,
            56,
            57,
            58,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            90,
            99,
            100,
            101,
            102,
            103,
            104,
            105,
            106,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            130,
            131,
            132,
            133,
            134,
            135,
            136,
            137,
            138,
            146,
            147,
            148,
            149,
            150,
            151,
            152,
            153,
            154,
            162,
            163,
            164,
            165,
            166,
            167,
            168,
            169,
            170,
            178,
            179,
            180,
            181,
            182,
            183,
            184,
            185,
            186,
            194,
            195,
            196,
            197,
            198,
            199,
            200,
            201,
            202,
            210,
            211,
            212,
            213,
            214,
            215,
            216,
            217,
            218,
            226,
            227,
            228,
            229,
            230,
            231,
            232,
            233,
            234,
            242,
            243,
            244,
            245,
            246,
            247,
            248,
            249,
            250
        ];
        function r(t, e) {
            for(var n = 0, r = 0, i = new Array, o = 1; o <= 16; o++){
                for(var a = 1; a <= t[o]; a++)i[e[r]] = [], i[e[r]][0] = n, i[e[r]][1] = o, r++, n++;
                n *= 2;
            }
            return i;
        }
        function G(t) {
            for(var e = t[0], n = t[1] - 1; 0 <= n;)e & 1 << n && (E |= 1 << q), n--, --q < 0 && (255 == E ? (V(255), V(0)) : V(E), q = 7, E = 0);
        }
        function V(t) {
            P.push(t);
        }
        function Y(t) {
            V(t >> 8 & 255), V(255 & t);
        }
        function X(t, e, n, r, i) {
            for(var o, a = i[0], s = i[240], h = function(t, e) {
                var n, r, i, o, a, s, h, c, l, u, f = 0;
                for(l = 0; l < 8; ++l){
                    n = t[f], r = t[f + 1], i = t[f + 2], o = t[f + 3], a = t[f + 4], s = t[f + 5], h = t[f + 6];
                    var d = n + (c = t[f + 7]), p = n - c, g = r + h, m = r - h, w = i + s, y = i - s, v = o + a, b = o - a, x = d + v, S = d - v, k = g + w, _ = g - w;
                    t[f] = x + k, t[f + 4] = x - k;
                    var A = .707106781 * (_ + S);
                    t[f + 2] = S + A, t[f + 6] = S - A;
                    var I = .382683433 * ((x = b + y) - (_ = m + p)), C = .5411961 * x + I, T = 1.306562965 * _ + I, F = .707106781 * (k = y + m), P = p + F, E = p - F;
                    t[f + 5] = E + C, t[f + 3] = E - C, t[f + 1] = P + T, t[f + 7] = P - T, f += 8;
                }
                for(l = f = 0; l < 8; ++l){
                    n = t[f], r = t[f + 8], i = t[f + 16], o = t[f + 24], a = t[f + 32], s = t[f + 40], h = t[f + 48];
                    var q = n + (c = t[f + 56]), O = n - c, B = r + h, R = r - h, j = i + s, D = i - s, M = o + a, U = o - a, N = q + M, z = q - M, L = B + j, H = B - j;
                    t[f] = N + L, t[f + 32] = N - L;
                    var W = .707106781 * (H + z);
                    t[f + 16] = z + W, t[f + 48] = z - W;
                    var G = .382683433 * ((N = U + D) - (H = R + O)), V = .5411961 * N + G, Y = 1.306562965 * H + G, X = .707106781 * (L = D + R), J = O + X, K = O - X;
                    t[f + 40] = K + V, t[f + 24] = K - V, t[f + 8] = J + Y, t[f + 56] = J - Y, f++;
                }
                for(l = 0; l < 64; ++l)u = t[l] * e[l], Q[l] = 0 < u ? u + .5 | 0 : u - .5 | 0;
                return Q;
            }(t, e), c = 0; c < 64; ++c)v[b[c]] = h[c];
            var l = v[0] - n;
            n = v[0], 0 == l ? G(r[0]) : (G(r[y[o = 32767 + l]]), G(w[o]));
            for(var u = 63; 0 < u && 0 == v[u]; u--);
            if (0 == u) return G(a), n;
            for(var f, d = 1; d <= u;){
                for(var p = d; 0 == v[d] && d <= u; ++d);
                var g = d - p;
                if (16 <= g) {
                    f = g >> 4;
                    for(var m = 1; m <= f; ++m)G(s);
                    g &= 15;
                }
                o = 32767 + v[d], G(i[(g << 4) + y[o]]), G(w[o]), d++;
            }
            return 63 != u && G(a), n;
        }
        function J(t) {
            if (t <= 0 && (t = 1), 100 < t && (t = 100), e != t) (function(t) {
                for(var e = [
                    16,
                    11,
                    10,
                    16,
                    24,
                    40,
                    51,
                    61,
                    12,
                    12,
                    14,
                    19,
                    26,
                    58,
                    60,
                    55,
                    14,
                    13,
                    16,
                    24,
                    40,
                    57,
                    69,
                    56,
                    14,
                    17,
                    22,
                    29,
                    51,
                    87,
                    80,
                    62,
                    18,
                    22,
                    37,
                    56,
                    68,
                    109,
                    103,
                    77,
                    24,
                    35,
                    55,
                    64,
                    81,
                    104,
                    113,
                    92,
                    49,
                    64,
                    78,
                    87,
                    103,
                    121,
                    120,
                    101,
                    72,
                    92,
                    95,
                    98,
                    112,
                    100,
                    103,
                    99
                ], n = 0; n < 64; n++){
                    var r = u((e[n] * t + 50) / 100);
                    r < 1 ? r = 1 : 255 < r && (r = 255), I[b[n]] = r;
                }
                for(var i = [
                    17,
                    18,
                    24,
                    47,
                    99,
                    99,
                    99,
                    99,
                    18,
                    21,
                    26,
                    66,
                    99,
                    99,
                    99,
                    99,
                    24,
                    26,
                    56,
                    99,
                    99,
                    99,
                    99,
                    99,
                    47,
                    66,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99
                ], o = 0; o < 64; o++){
                    var a = u((i[o] * t + 50) / 100);
                    a < 1 ? a = 1 : 255 < a && (a = 255), C[b[o]] = a;
                }
                for(var s = [
                    1,
                    1.387039845,
                    1.306562965,
                    1.175875602,
                    1,
                    .785694958,
                    .5411961,
                    .275899379
                ], h = 0, c = 0; c < 8; c++)for(var l = 0; l < 8; l++)T[h] = 1 / (I[b[h]] * s[c] * s[l] * 8), F[h] = 1 / (C[b[h]] * s[c] * s[l] * 8), h++;
            })(t < 50 ? Math.floor(5e3 / t) : Math.floor(200 - 2 * t)), e = t;
        }
        this.encode = function(t, e) {
            var n, r;
            (new Date).getTime();
            e && J(e), P = new Array, E = 0, q = 7, Y(65496), Y(65504), Y(16), V(74), V(70), V(73), V(70), V(0), V(1), V(1), V(0), Y(1), Y(1), V(0), V(0), function() {
                Y(65499), Y(132), V(0);
                for(var t = 0; t < 64; t++)V(I[t]);
                V(1);
                for(var e = 0; e < 64; e++)V(C[e]);
            }(), n = t.width, r = t.height, Y(65472), Y(17), V(8), Y(r), Y(n), V(3), V(1), V(17), V(0), V(2), V(17), V(1), V(3), V(17), V(1), function() {
                Y(65476), Y(418), V(0);
                for(var t = 0; t < 16; t++)V(D[t + 1]);
                for(var e = 0; e <= 11; e++)V(M[e]);
                V(16);
                for(var n = 0; n < 16; n++)V(U[n + 1]);
                for(var r = 0; r <= 161; r++)V(N[r]);
                V(1);
                for(var i = 0; i < 16; i++)V(z[i + 1]);
                for(var o = 0; o <= 11; o++)V(L[o]);
                V(17);
                for(var a = 0; a < 16; a++)V(H[a + 1]);
                for(var s = 0; s <= 161; s++)V(W[s]);
            }(), Y(65498), Y(12), V(3), V(1), V(0), V(2), V(17), V(3), V(17), V(0), V(63), V(0);
            var i = 0, o = 0, a = 0;
            E = 0, q = 7, this.encode.displayName = "_encode_";
            for(var s, h, c, l, u, f, d, p, g, m = t.data, w = t.width, y = t.height, v = 4 * w, b = 0; b < y;){
                for(s = 0; s < v;){
                    for(f = u = v * b + s, d = -1, g = p = 0; g < 64; g++)f = u + (p = g >> 3) * v + (d = 4 * (7 & g)), y <= b + p && (f -= v * (b + 1 + p - y)), v <= s + d && (f -= s + d - v + 4), h = m[f++], c = m[f++], l = m[f++], O[g] = (j[h] + j[c + 256 >> 0] + j[l + 512 >> 0] >> 16) - 128, B[g] = (j[h + 768 >> 0] + j[c + 1024 >> 0] + j[l + 1280 >> 0] >> 16) - 128, R[g] = (j[h + 1280 >> 0] + j[c + 1536 >> 0] + j[l + 1792 >> 0] >> 16) - 128;
                    i = X(O, T, i, S, _), o = X(B, F, o, k, A), a = X(R, F, a, k, A), s += 32;
                }
                b += 8;
            }
            if (0 <= q) {
                var x = [];
                x[1] = q + 1, x[0] = (1 << q + 1) - 1, G(x);
            }
            return Y(65497), new Uint8Array(P);
        }, function() {
            (new Date).getTime();
            t || (t = 50), function() {
                for(var t = String.fromCharCode, e = 0; e < 256; e++)n[e] = t(e);
            }(), S = r(D, M), k = r(z, L), _ = r(U, N), A = r(H, W), function() {
                for(var t = 1, e = 2, n = 1; n <= 15; n++){
                    for(var r = t; r < e; r++)y[32767 + r] = n, w[32767 + r] = [], w[32767 + r][1] = n, w[32767 + r][0] = r;
                    for(var i = -(e - 1); i <= -t; i++)y[32767 + i] = n, w[32767 + i] = [], w[32767 + i][1] = n, w[32767 + i][0] = e - 1 + i;
                    t <<= 1, e <<= 1;
                }
            }(), function() {
                for(var t = 0; t < 256; t++)j[t] = 19595 * t, j[t + 256 >> 0] = 38470 * t, j[t + 512 >> 0] = 7471 * t + 32768, j[t + 768 >> 0] = -11059 * t, j[t + 1024 >> 0] = -21709 * t, j[t + 1280 >> 0] = 32768 * t + 8421375, j[t + 1536 >> 0] = -27439 * t, j[t + 1792 >> 0] = -5329 * t;
            }(), J(t), (new Date).getTime();
        }();
    }
    try {
        module.exports = yt;
    } catch (t) {}
    function xt(t, e) {
        if (this.pos = 0, this.buffer = t, this.datav = new DataView(t.buffer), this.is_with_alpha = !!e, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, -1 === [
            "BM",
            "BA",
            "CI",
            "CP",
            "IC",
            "PT"
        ].indexOf(this.flag)) throw new Error("Invalid BMP File");
        this.parseHeader(), this.parseBGR();
    }
    xt.prototype.parseHeader = function() {
        if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, 16 === this.bitPP && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
            var t = 0 === this.colors ? 1 << this.bitPP : this.colors;
            this.palette = new Array(t);
            for(var e = 0; e < t; e++){
                var n = this.datav.getUint8(this.pos++, !0), r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0);
                this.palette[e] = {
                    red: i,
                    green: r,
                    blue: n,
                    quad: o
                };
            }
        }
        this.height < 0 && (this.height *= -1, this.bottom_up = !1);
    }, xt.prototype.parseBGR = function() {
        this.pos = this.offset;
        try {
            var t = "bit" + this.bitPP, e = this.width * this.height * 4;
            this.data = new Uint8Array(e), this[t]();
        } catch (t) {
            console.log("bit decode error:" + t);
        }
    }, xt.prototype.bit1 = function() {
        var t = Math.ceil(this.width / 8), e = t % 4, n = 0 <= this.height ? this.height - 1 : -this.height;
        for(n = this.height - 1; 0 <= n; n--){
            for(var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < t; i++)for(var o = this.datav.getUint8(this.pos++, !0), a = r * this.width * 4 + 8 * i * 4, s = 0; s < 8 && 8 * i + s < this.width; s++){
                var h = this.palette[o >> 7 - s & 1];
                this.data[a + 4 * s] = h.blue, this.data[a + 4 * s + 1] = h.green, this.data[a + 4 * s + 2] = h.red, this.data[a + 4 * s + 3] = 255;
            }
            0 != e && (this.pos += 4 - e);
        }
    }, xt.prototype.bit4 = function() {
        for(var t = Math.ceil(this.width / 2), e = t % 4, n = this.height - 1; 0 <= n; n--){
            for(var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < t; i++){
                var o = this.datav.getUint8(this.pos++, !0), a = r * this.width * 4 + 2 * i * 4, s = o >> 4, h = 15 & o, c = this.palette[s];
                if (this.data[a] = c.blue, this.data[a + 1] = c.green, this.data[a + 2] = c.red, this.data[a + 3] = 255, 2 * i + 1 >= this.width) break;
                c = this.palette[h], this.data[a + 4] = c.blue, this.data[a + 4 + 1] = c.green, this.data[a + 4 + 2] = c.red, this.data[a + 4 + 3] = 255;
            }
            0 != e && (this.pos += 4 - e);
        }
    }, xt.prototype.bit8 = function() {
        for(var t = this.width % 4, e = this.height - 1; 0 <= e; e--){
            for(var n = this.bottom_up ? e : this.height - 1 - e, r = 0; r < this.width; r++){
                var i = this.datav.getUint8(this.pos++, !0), o = n * this.width * 4 + 4 * r;
                if (i < this.palette.length) {
                    var a = this.palette[i];
                    this.data[o] = a.red, this.data[o + 1] = a.green, this.data[o + 2] = a.blue, this.data[o + 3] = 255;
                } else this.data[o] = 255, this.data[o + 1] = 255, this.data[o + 2] = 255, this.data[o + 3] = 255;
            }
            0 != t && (this.pos += 4 - t);
        }
    }, xt.prototype.bit15 = function() {
        for(var t = this.width % 3, e = parseInt("11111", 2), n = this.height - 1; 0 <= n; n--){
            for(var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < this.width; i++){
                var o = this.datav.getUint16(this.pos, !0);
                this.pos += 2;
                var a = (o & e) / e * 255 | 0, s = (o >> 5 & e) / e * 255 | 0, h = (o >> 10 & e) / e * 255 | 0, c = o >> 15 ? 255 : 0, l = r * this.width * 4 + 4 * i;
                this.data[l] = h, this.data[l + 1] = s, this.data[l + 2] = a, this.data[l + 3] = c;
            }
            this.pos += t;
        }
    }, xt.prototype.bit16 = function() {
        for(var t = this.width % 3, e = parseInt("11111", 2), n = parseInt("111111", 2), r = this.height - 1; 0 <= r; r--){
            for(var i = this.bottom_up ? r : this.height - 1 - r, o = 0; o < this.width; o++){
                var a = this.datav.getUint16(this.pos, !0);
                this.pos += 2;
                var s = (a & e) / e * 255 | 0, h = (a >> 5 & n) / n * 255 | 0, c = (a >> 11) / e * 255 | 0, l = i * this.width * 4 + 4 * o;
                this.data[l] = c, this.data[l + 1] = h, this.data[l + 2] = s, this.data[l + 3] = 255;
            }
            this.pos += t;
        }
    }, xt.prototype.bit24 = function() {
        for(var t = this.height - 1; 0 <= t; t--){
            for(var e = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++){
                var r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), a = e * this.width * 4 + 4 * n;
                this.data[a] = o, this.data[a + 1] = i, this.data[a + 2] = r, this.data[a + 3] = 255;
            }
            this.pos += this.width % 4;
        }
    }, xt.prototype.bit32 = function() {
        for(var t = this.height - 1; 0 <= t; t--)for(var e = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++){
            var r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), s = e * this.width * 4 + 4 * n;
            this.data[s] = o, this.data[s + 1] = i, this.data[s + 2] = r, this.data[s + 3] = a;
        }
    }, xt.prototype.getData = function() {
        return this.data;
    };
    try {
        module.exports = function(t) {
            var e = new xt(t);
            return {
                data: e.getData(),
                width: e.width,
                height: e.height
            };
        };
    } catch (t) {}
    /*
   Copyright (c) 2013 Gildas Lormeau. All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions are met:

   1. Redistributions of source code must retain the above copyright notice,
   this list of conditions and the following disclaimer.

   2. Redistributions in binary form must reproduce the above copyright 
   notice, this list of conditions and the following disclaimer in 
   the documentation and/or other materials provided with the distribution.

   3. The names of the authors may not be used to endorse or promote products
   derived from this software without specific prior written permission.

   THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
   INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
   FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
   INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
   INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
   LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
   OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
   EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   */ /*
   Copyright (c) 2013 Gildas Lormeau. All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions are met:

   1. Redistributions of source code must retain the above copyright notice,
   this list of conditions and the following disclaimer.

   2. Redistributions in binary form must reproduce the above copyright 
   notice, this list of conditions and the following disclaimer in 
   the documentation and/or other materials provided with the distribution.

   3. The names of the authors may not be used to endorse or promote products
   derived from this software without specific prior written permission.

   THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
   INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
   FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
   INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
   INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
   LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
   OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
   EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   */ !function(t) {
        var p = 15, g = 573, e = [
            0,
            1,
            2,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            6,
            6,
            7,
            7,
            7,
            7,
            8,
            8,
            8,
            8,
            8,
            8,
            8,
            8,
            9,
            9,
            9,
            9,
            9,
            9,
            9,
            9,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            0,
            0,
            16,
            17,
            18,
            18,
            19,
            19,
            20,
            20,
            20,
            20,
            21,
            21,
            21,
            21,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29
        ];
        function ut() {
            var d = this;
            function h(t, e) {
                for(var n = 0; n |= 1 & t, t >>>= 1, n <<= 1, 0 < --e;);
                return n >>> 1;
            }
            d.build_tree = function(t) {
                var e, n, r, i = d.dyn_tree, o = d.stat_desc.static_tree, a = d.stat_desc.elems, s = -1;
                for(t.heap_len = 0, t.heap_max = g, e = 0; e < a; e++)0 !== i[2 * e] ? (t.heap[++t.heap_len] = s = e, t.depth[e] = 0) : i[2 * e + 1] = 0;
                for(; t.heap_len < 2;)i[2 * (r = t.heap[++t.heap_len] = s < 2 ? ++s : 0)] = 1, t.depth[r] = 0, t.opt_len--, o && (t.static_len -= o[2 * r + 1]);
                for(d.max_code = s, e = Math.floor(t.heap_len / 2); 1 <= e; e--)t.pqdownheap(i, e);
                for(r = a; e = t.heap[1], t.heap[1] = t.heap[t.heap_len--], t.pqdownheap(i, 1), n = t.heap[1], t.heap[--t.heap_max] = e, t.heap[--t.heap_max] = n, i[2 * r] = i[2 * e] + i[2 * n], t.depth[r] = Math.max(t.depth[e], t.depth[n]) + 1, i[2 * e + 1] = i[2 * n + 1] = r, t.heap[1] = r++, t.pqdownheap(i, 1), 2 <= t.heap_len;);
                t.heap[--t.heap_max] = t.heap[1], function(t) {
                    var e, n, r, i, o, a, s = d.dyn_tree, h = d.stat_desc.static_tree, c = d.stat_desc.extra_bits, l = d.stat_desc.extra_base, u = d.stat_desc.max_length, f = 0;
                    for(i = 0; i <= p; i++)t.bl_count[i] = 0;
                    for(s[2 * t.heap[t.heap_max] + 1] = 0, e = t.heap_max + 1; e < g; e++)u < (i = s[2 * s[2 * (n = t.heap[e]) + 1] + 1] + 1) && (i = u, f++), s[2 * n + 1] = i, n > d.max_code || (t.bl_count[i]++, o = 0, l <= n && (o = c[n - l]), a = s[2 * n], t.opt_len += a * (i + o), h && (t.static_len += a * (h[2 * n + 1] + o)));
                    if (0 !== f) {
                        do {
                            for(i = u - 1; 0 === t.bl_count[i];)i--;
                            t.bl_count[i]--, t.bl_count[i + 1] += 2, t.bl_count[u]--, f -= 2;
                        }while (0 < f);
                        for(i = u; 0 !== i; i--)for(n = t.bl_count[i]; 0 !== n;)(r = t.heap[--e]) > d.max_code || (s[2 * r + 1] != i && (t.opt_len += (i - s[2 * r + 1]) * s[2 * r], s[2 * r + 1] = i), n--);
                    }
                }(t), function(t, e, n) {
                    var r, i, o, a = [], s = 0;
                    for(r = 1; r <= p; r++)a[r] = s = s + n[r - 1] << 1;
                    for(i = 0; i <= e; i++)0 !== (o = t[2 * i + 1]) && (t[2 * i] = h(a[o]++, o));
                }(i, d.max_code, t.bl_count);
            };
        }
        function ft(t, e, n, r, i) {
            var o = this;
            o.static_tree = t, o.extra_bits = e, o.extra_base = n, o.elems = r, o.max_length = i;
        }
        ut._length_code = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            12,
            12,
            13,
            13,
            13,
            13,
            14,
            14,
            14,
            14,
            15,
            15,
            15,
            15,
            16,
            16,
            16,
            16,
            16,
            16,
            16,
            16,
            17,
            17,
            17,
            17,
            17,
            17,
            17,
            17,
            18,
            18,
            18,
            18,
            18,
            18,
            18,
            18,
            19,
            19,
            19,
            19,
            19,
            19,
            19,
            19,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            28
        ], ut.base_length = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            10,
            12,
            14,
            16,
            20,
            24,
            28,
            32,
            40,
            48,
            56,
            64,
            80,
            96,
            112,
            128,
            160,
            192,
            224,
            0
        ], ut.base_dist = [
            0,
            1,
            2,
            3,
            4,
            6,
            8,
            12,
            16,
            24,
            32,
            48,
            64,
            96,
            128,
            192,
            256,
            384,
            512,
            768,
            1024,
            1536,
            2048,
            3072,
            4096,
            6144,
            8192,
            12288,
            16384,
            24576
        ], ut.d_code = function(t) {
            return t < 256 ? e[t] : e[256 + (t >>> 7)];
        }, ut.extra_lbits = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0
        ], ut.extra_dbits = [
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13
        ], ut.extra_blbits = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2,
            3,
            7
        ], ut.bl_order = [
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ], ft.static_ltree = [
            12,
            8,
            140,
            8,
            76,
            8,
            204,
            8,
            44,
            8,
            172,
            8,
            108,
            8,
            236,
            8,
            28,
            8,
            156,
            8,
            92,
            8,
            220,
            8,
            60,
            8,
            188,
            8,
            124,
            8,
            252,
            8,
            2,
            8,
            130,
            8,
            66,
            8,
            194,
            8,
            34,
            8,
            162,
            8,
            98,
            8,
            226,
            8,
            18,
            8,
            146,
            8,
            82,
            8,
            210,
            8,
            50,
            8,
            178,
            8,
            114,
            8,
            242,
            8,
            10,
            8,
            138,
            8,
            74,
            8,
            202,
            8,
            42,
            8,
            170,
            8,
            106,
            8,
            234,
            8,
            26,
            8,
            154,
            8,
            90,
            8,
            218,
            8,
            58,
            8,
            186,
            8,
            122,
            8,
            250,
            8,
            6,
            8,
            134,
            8,
            70,
            8,
            198,
            8,
            38,
            8,
            166,
            8,
            102,
            8,
            230,
            8,
            22,
            8,
            150,
            8,
            86,
            8,
            214,
            8,
            54,
            8,
            182,
            8,
            118,
            8,
            246,
            8,
            14,
            8,
            142,
            8,
            78,
            8,
            206,
            8,
            46,
            8,
            174,
            8,
            110,
            8,
            238,
            8,
            30,
            8,
            158,
            8,
            94,
            8,
            222,
            8,
            62,
            8,
            190,
            8,
            126,
            8,
            254,
            8,
            1,
            8,
            129,
            8,
            65,
            8,
            193,
            8,
            33,
            8,
            161,
            8,
            97,
            8,
            225,
            8,
            17,
            8,
            145,
            8,
            81,
            8,
            209,
            8,
            49,
            8,
            177,
            8,
            113,
            8,
            241,
            8,
            9,
            8,
            137,
            8,
            73,
            8,
            201,
            8,
            41,
            8,
            169,
            8,
            105,
            8,
            233,
            8,
            25,
            8,
            153,
            8,
            89,
            8,
            217,
            8,
            57,
            8,
            185,
            8,
            121,
            8,
            249,
            8,
            5,
            8,
            133,
            8,
            69,
            8,
            197,
            8,
            37,
            8,
            165,
            8,
            101,
            8,
            229,
            8,
            21,
            8,
            149,
            8,
            85,
            8,
            213,
            8,
            53,
            8,
            181,
            8,
            117,
            8,
            245,
            8,
            13,
            8,
            141,
            8,
            77,
            8,
            205,
            8,
            45,
            8,
            173,
            8,
            109,
            8,
            237,
            8,
            29,
            8,
            157,
            8,
            93,
            8,
            221,
            8,
            61,
            8,
            189,
            8,
            125,
            8,
            253,
            8,
            19,
            9,
            275,
            9,
            147,
            9,
            403,
            9,
            83,
            9,
            339,
            9,
            211,
            9,
            467,
            9,
            51,
            9,
            307,
            9,
            179,
            9,
            435,
            9,
            115,
            9,
            371,
            9,
            243,
            9,
            499,
            9,
            11,
            9,
            267,
            9,
            139,
            9,
            395,
            9,
            75,
            9,
            331,
            9,
            203,
            9,
            459,
            9,
            43,
            9,
            299,
            9,
            171,
            9,
            427,
            9,
            107,
            9,
            363,
            9,
            235,
            9,
            491,
            9,
            27,
            9,
            283,
            9,
            155,
            9,
            411,
            9,
            91,
            9,
            347,
            9,
            219,
            9,
            475,
            9,
            59,
            9,
            315,
            9,
            187,
            9,
            443,
            9,
            123,
            9,
            379,
            9,
            251,
            9,
            507,
            9,
            7,
            9,
            263,
            9,
            135,
            9,
            391,
            9,
            71,
            9,
            327,
            9,
            199,
            9,
            455,
            9,
            39,
            9,
            295,
            9,
            167,
            9,
            423,
            9,
            103,
            9,
            359,
            9,
            231,
            9,
            487,
            9,
            23,
            9,
            279,
            9,
            151,
            9,
            407,
            9,
            87,
            9,
            343,
            9,
            215,
            9,
            471,
            9,
            55,
            9,
            311,
            9,
            183,
            9,
            439,
            9,
            119,
            9,
            375,
            9,
            247,
            9,
            503,
            9,
            15,
            9,
            271,
            9,
            143,
            9,
            399,
            9,
            79,
            9,
            335,
            9,
            207,
            9,
            463,
            9,
            47,
            9,
            303,
            9,
            175,
            9,
            431,
            9,
            111,
            9,
            367,
            9,
            239,
            9,
            495,
            9,
            31,
            9,
            287,
            9,
            159,
            9,
            415,
            9,
            95,
            9,
            351,
            9,
            223,
            9,
            479,
            9,
            63,
            9,
            319,
            9,
            191,
            9,
            447,
            9,
            127,
            9,
            383,
            9,
            255,
            9,
            511,
            9,
            0,
            7,
            64,
            7,
            32,
            7,
            96,
            7,
            16,
            7,
            80,
            7,
            48,
            7,
            112,
            7,
            8,
            7,
            72,
            7,
            40,
            7,
            104,
            7,
            24,
            7,
            88,
            7,
            56,
            7,
            120,
            7,
            4,
            7,
            68,
            7,
            36,
            7,
            100,
            7,
            20,
            7,
            84,
            7,
            52,
            7,
            116,
            7,
            3,
            8,
            131,
            8,
            67,
            8,
            195,
            8,
            35,
            8,
            163,
            8,
            99,
            8,
            227,
            8
        ], ft.static_dtree = [
            0,
            5,
            16,
            5,
            8,
            5,
            24,
            5,
            4,
            5,
            20,
            5,
            12,
            5,
            28,
            5,
            2,
            5,
            18,
            5,
            10,
            5,
            26,
            5,
            6,
            5,
            22,
            5,
            14,
            5,
            30,
            5,
            1,
            5,
            17,
            5,
            9,
            5,
            25,
            5,
            5,
            5,
            21,
            5,
            13,
            5,
            29,
            5,
            3,
            5,
            19,
            5,
            11,
            5,
            27,
            5,
            7,
            5,
            23,
            5
        ], ft.static_l_desc = new ft(ft.static_ltree, ut.extra_lbits, 257, 286, p), ft.static_d_desc = new ft(ft.static_dtree, ut.extra_dbits, 0, 30, p), ft.static_bl_desc = new ft(null, ut.extra_blbits, 0, 19, 7);
        function n(t, e, n, r, i) {
            var o = this;
            o.good_length = t, o.max_lazy = e, o.nice_length = n, o.max_chain = r, o.func = i;
        }
        var dt = [
            new n(0, 0, 0, 0, 0),
            new n(4, 4, 8, 4, 1),
            new n(4, 5, 16, 8, 1),
            new n(4, 6, 32, 32, 1),
            new n(4, 4, 16, 16, 2),
            new n(8, 16, 32, 32, 2),
            new n(8, 16, 128, 128, 2),
            new n(8, 32, 128, 256, 2),
            new n(32, 128, 258, 1024, 2),
            new n(32, 258, 258, 4096, 2)
        ], pt = [
            "need dictionary",
            "stream end",
            "",
            "",
            "stream error",
            "data error",
            "",
            "buffer error",
            "",
            ""
        ], gt = 262;
        function mt(t, e, n, r) {
            var i = t[2 * e], o = t[2 * n];
            return i < o || i == o && r[e] <= r[n];
        }
        function r() {
            var h, c, l, u, f, d, p, g, i, m, w, y, v, a, b, x, S, k, _, A, I, C, T, F, P, E, q, O, B, R, s, j, D, M, U, N, z, o, L, H, W, G = this, V = new ut, Y = new ut, X = new ut;
            function J() {
                var t;
                for(t = 0; t < 286; t++)s[2 * t] = 0;
                for(t = 0; t < 30; t++)j[2 * t] = 0;
                for(t = 0; t < 19; t++)D[2 * t] = 0;
                s[512] = 1, G.opt_len = G.static_len = 0, N = o = 0;
            }
            function K(t, e) {
                var n, r, i = -1, o = t[1], a = 0, s = 7, h = 4;
                for(0 === o && (s = 138, h = 3), t[2 * (e + 1) + 1] = 65535, n = 0; n <= e; n++)r = o, o = t[2 * (n + 1) + 1], ++a < s && r == o || (a < h ? D[2 * r] += a : 0 !== r ? (r != i && D[2 * r]++, D[32]++) : a <= 10 ? D[34]++ : D[36]++, i = r, (a = 0) === o ? (s = 138, h = 3) : r == o ? (s = 6, h = 3) : (s = 7, h = 4));
            }
            function Q(t) {
                G.pending_buf[G.pending++] = t;
            }
            function Z(t) {
                Q(255 & t), Q(t >>> 8 & 255);
            }
            function $(t, e) {
                var n, r = e;
                16 - r < W ? (Z(H |= (n = t) << W & 65535), H = n >>> 16 - W, W += r - 16) : (H |= t << W & 65535, W += r);
            }
            function tt(t, e) {
                var n = 2 * t;
                $(65535 & e[n], 65535 & e[n + 1]);
            }
            function et(t, e) {
                var n, r, i = -1, o = t[1], a = 0, s = 7, h = 4;
                for(0 === o && (s = 138, h = 3), n = 0; n <= e; n++)if (r = o, o = t[2 * (n + 1) + 1], !(++a < s && r == o)) {
                    if (a < h) for(; tt(r, D), 0 != --a;);
                    else 0 !== r ? (r != i && (tt(r, D), a--), tt(16, D), $(a - 3, 2)) : a <= 10 ? (tt(17, D), $(a - 3, 3)) : (tt(18, D), $(a - 11, 7));
                    i = r, (a = 0) === o ? (s = 138, h = 3) : r == o ? (s = 6, h = 3) : (s = 7, h = 4);
                }
            }
            function nt() {
                16 == W ? (Z(H), W = H = 0) : 8 <= W && (Q(255 & H), H >>>= 8, W -= 8);
            }
            function rt(t, e) {
                var n, r, i;
                if (G.pending_buf[z + 2 * N] = t >>> 8 & 255, G.pending_buf[z + 2 * N + 1] = 255 & t, G.pending_buf[M + N] = 255 & e, N++, 0 === t ? s[2 * e]++ : (o++, t--, s[2 * (ut._length_code[e] + 256 + 1)]++, j[2 * ut.d_code(t)]++), 0 == (8191 & N) && 2 < q) {
                    for(n = 8 * N, r = I - S, i = 0; i < 30; i++)n += j[2 * i] * (5 + ut.extra_dbits[i]);
                    if (n >>>= 3, o < Math.floor(N / 2) && n < Math.floor(r / 2)) return !0;
                }
                return N == U - 1;
            }
            function it(t, e) {
                var n, r, i, o, a = 0;
                if (0 !== N) for(; n = G.pending_buf[z + 2 * a] << 8 & 65280 | 255 & G.pending_buf[z + 2 * a + 1], r = 255 & G.pending_buf[M + a], a++, 0 === n ? tt(r, t) : (tt((i = ut._length_code[r]) + 256 + 1, t), 0 !== (o = ut.extra_lbits[i]) && $(r -= ut.base_length[i], o), tt(i = ut.d_code(--n), e), 0 !== (o = ut.extra_dbits[i]) && $(n -= ut.base_dist[i], o)), a < N;);
                tt(256, t), L = t[513];
            }
            function ot() {
                8 < W ? Z(H) : 0 < W && Q(255 & H), W = H = 0;
            }
            function at(t, e, n) {
                var r, i, o;
                $(0 + (n ? 1 : 0), 3), r = t, i = e, o = !0, ot(), L = 8, o && (Z(i), Z(~i)), G.pending_buf.set(g.subarray(r, r + i), G.pending), G.pending += i;
            }
            function e(t, e, n) {
                var r, i, o = 0;
                0 < q ? (V.build_tree(G), Y.build_tree(G), o = function() {
                    var t;
                    for(K(s, V.max_code), K(j, Y.max_code), X.build_tree(G), t = 18; 3 <= t && 0 === D[2 * ut.bl_order[t] + 1]; t--);
                    return G.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                }(), r = G.opt_len + 3 + 7 >>> 3, (i = G.static_len + 3 + 7 >>> 3) <= r && (r = i)) : r = i = e + 5, e + 4 <= r && -1 != t ? at(t, e, n) : i == r ? ($(2 + (n ? 1 : 0), 3), it(ft.static_ltree, ft.static_dtree)) : ($(4 + (n ? 1 : 0), 3), function(t, e, n) {
                    var r;
                    for($(t - 257, 5), $(e - 1, 5), $(n - 4, 4), r = 0; r < n; r++)$(D[2 * ut.bl_order[r] + 1], 3);
                    et(s, t - 1), et(j, e - 1);
                }(V.max_code + 1, Y.max_code + 1, o + 1), it(s, j)), J(), n && ot();
            }
            function st(t) {
                e(0 <= S ? S : -1, I - S, t), S = I, h.flush_pending();
            }
            function ht() {
                var t, e, n, r;
                do {
                    if (0 === (r = i - T - I) && 0 === I && 0 === T) r = f;
                    else if (-1 == r) r--;
                    else if (f + f - gt <= I) {
                        for(g.set(g.subarray(f, f + f), 0), C -= f, I -= f, S -= f, n = t = v; e = 65535 & w[--n], w[n] = f <= e ? e - f : 0, 0 != --t;);
                        for(n = t = f; e = 65535 & m[--n], m[n] = f <= e ? e - f : 0, 0 != --t;);
                        r += f;
                    }
                    if (0 === h.avail_in) return;
                    t = h.read_buf(g, I + T, r), 3 <= (T += t) && (y = ((y = 255 & g[I]) << x ^ 255 & g[I + 1]) & b);
                }while (T < gt && 0 !== h.avail_in);
            }
            function ct(t) {
                var e, n, r = P, i = I, o = F, a = f - gt < I ? I - (f - gt) : 0, s = R, h = p, c = I + 258, l = g[i + o - 1], u = g[i + o];
                B <= F && (r >>= 2), T < s && (s = T);
                do if (g[(e = t) + o] == u && g[e + o - 1] == l && g[e] == g[i] && g[++e] == g[i + 1]) {
                    i += 2, e++;
                    do ;
                    while (g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && i < c);
                    if (n = 258 - (c - i), i = c - 258, o < n) {
                        if (C = t, s <= (o = n)) break;
                        l = g[i + o - 1], u = g[i + o];
                    }
                }
                while ((t = 65535 & m[t & h]) > a && 0 != --r);
                return o <= T ? o : T;
            }
            function lt(t) {
                return t.total_in = t.total_out = 0, t.msg = null, G.pending = 0, G.pending_out = 0, c = 113, u = 0, V.dyn_tree = s, V.stat_desc = ft.static_l_desc, Y.dyn_tree = j, Y.stat_desc = ft.static_d_desc, X.dyn_tree = D, X.stat_desc = ft.static_bl_desc, W = H = 0, L = 8, J(), function() {
                    var t;
                    for(i = 2 * f, t = w[v - 1] = 0; t < v - 1; t++)w[t] = 0;
                    E = dt[q].max_lazy, B = dt[q].good_length, R = dt[q].nice_length, P = dt[q].max_chain, k = F = 2, y = A = T = S = I = 0;
                }(), 0;
            }
            G.depth = [], G.bl_count = [], G.heap = [], s = [], j = [], D = [], G.pqdownheap = function(t, e) {
                for(var n = G.heap, r = n[e], i = e << 1; i <= G.heap_len && (i < G.heap_len && mt(t, n[i + 1], n[i], G.depth) && i++, !mt(t, r, n[i], G.depth));)n[e] = n[i], e = i, i <<= 1;
                n[e] = r;
            }, G.deflateInit = function(t, e, n, r, i, o) {
                return r || (r = 8), i || (i = 8), o || (o = 0), t.msg = null, -1 == e && (e = 6), i < 1 || 9 < i || 8 != r || n < 9 || 15 < n || e < 0 || 9 < e || o < 0 || 2 < o ? -2 : (t.dstate = G, p = (f = 1 << (d = n)) - 1, b = (v = 1 << (a = i + 7)) - 1, x = Math.floor((a + 3 - 1) / 3), g = new Uint8Array(2 * f), m = [], w = [], U = 1 << i + 6, G.pending_buf = new Uint8Array(4 * U), l = 4 * U, z = Math.floor(U / 2), M = 3 * U, q = e, O = o, lt(t));
            }, G.deflateEnd = function() {
                return 42 != c && 113 != c && 666 != c ? -2 : (G.pending_buf = null, g = m = w = null, G.dstate = null, 113 == c ? -3 : 0);
            }, G.deflateParams = function(t, e, n) {
                var r = 0;
                return -1 == e && (e = 6), e < 0 || 9 < e || n < 0 || 2 < n ? -2 : (dt[q].func != dt[e].func && 0 !== t.total_in && (r = t.deflate(1)), q != e && (E = dt[q = e].max_lazy, B = dt[q].good_length, R = dt[q].nice_length, P = dt[q].max_chain), O = n, r);
            }, G.deflateSetDictionary = function(t, e, n) {
                var r, i = n, o = 0;
                if (!e || 42 != c) return -2;
                if (i < 3) return 0;
                for(f - gt < i && (o = n - (i = f - gt)), g.set(e.subarray(o, o + i), 0), S = I = i, y = ((y = 255 & g[0]) << x ^ 255 & g[1]) & b, r = 0; r <= i - 3; r++)y = (y << x ^ 255 & g[r + 2]) & b, m[r & p] = w[y], w[y] = r;
                return 0;
            }, G.deflate = function(t, e) {
                var n, r, i, o, a, s;
                if (4 < e || e < 0) return -2;
                if (!t.next_out || !t.next_in && 0 !== t.avail_in || 666 == c && 4 != e) return t.msg = pt[4], -2;
                if (0 === t.avail_out) return t.msg = pt[7], -5;
                if (h = t, o = u, u = e, 42 == c && (r = 8 + (d - 8 << 4) << 8, 3 < (i = (q - 1 & 255) >> 1) && (i = 3), r |= i << 6, 0 !== I && (r |= 32), c = 113, Q((s = r += 31 - r % 31) >> 8 & 255), Q(255 & s)), 0 !== G.pending) {
                    if (h.flush_pending(), 0 === h.avail_out) return u = -1, 0;
                } else if (0 === h.avail_in && e <= o && 4 != e) return h.msg = pt[7], -5;
                if (666 == c && 0 !== h.avail_in) return t.msg = pt[7], -5;
                if (0 !== h.avail_in || 0 !== T || 0 != e && 666 != c) {
                    switch(a = -1, dt[q].func){
                        case 0:
                            a = function(t) {
                                var e, n = 65535;
                                for(l - 5 < n && (n = l - 5);;){
                                    if (T <= 1) {
                                        if (ht(), 0 === T && 0 == t) return 0;
                                        if (0 === T) break;
                                    }
                                    if (I += T, e = S + n, ((T = 0) === I || e <= I) && (T = I - e, I = e, st(!1), 0 === h.avail_out)) return 0;
                                    if (f - gt <= I - S && (st(!1), 0 === h.avail_out)) return 0;
                                }
                                return st(4 == t), 0 === h.avail_out ? 4 == t ? 2 : 0 : 4 == t ? 3 : 1;
                            }(e);
                            break;
                        case 1:
                            a = function(t) {
                                for(var e, n = 0;;){
                                    if (T < gt) {
                                        if (ht(), T < gt && 0 == t) return 0;
                                        if (0 === T) break;
                                    }
                                    if (3 <= T && (y = (y << x ^ 255 & g[I + 2]) & b, n = 65535 & w[y], m[I & p] = w[y], w[y] = I), 0 !== n && (I - n & 65535) <= f - gt && 2 != O && (k = ct(n)), 3 <= k) {
                                        if (e = rt(I - C, k - 3), T -= k, k <= E && 3 <= T) {
                                            for(k--; y = (y << x ^ 255 & g[++I + 2]) & b, n = 65535 & w[y], m[I & p] = w[y], w[y] = I, 0 != --k;);
                                            I++;
                                        } else I += k, k = 0, y = ((y = 255 & g[I]) << x ^ 255 & g[I + 1]) & b;
                                    } else e = rt(0, 255 & g[I]), T--, I++;
                                    if (e && (st(!1), 0 === h.avail_out)) return 0;
                                }
                                return st(4 == t), 0 === h.avail_out ? 4 == t ? 2 : 0 : 4 == t ? 3 : 1;
                            }(e);
                            break;
                        case 2:
                            a = function(t) {
                                for(var e, n, r = 0;;){
                                    if (T < gt) {
                                        if (ht(), T < gt && 0 == t) return 0;
                                        if (0 === T) break;
                                    }
                                    if (3 <= T && (y = (y << x ^ 255 & g[I + 2]) & b, r = 65535 & w[y], m[I & p] = w[y], w[y] = I), F = k, _ = C, k = 2, 0 !== r && F < E && (I - r & 65535) <= f - gt && (2 != O && (k = ct(r)), k <= 5 && (1 == O || 3 == k && 4096 < I - C) && (k = 2)), 3 <= F && k <= F) {
                                        for(n = I + T - 3, e = rt(I - 1 - _, F - 3), T -= F - 1, F -= 2; ++I <= n && (y = (y << x ^ 255 & g[I + 2]) & b, r = 65535 & w[y], m[I & p] = w[y], w[y] = I), 0 != --F;);
                                        if (A = 0, k = 2, I++, e && (st(!1), 0 === h.avail_out)) return 0;
                                    } else if (0 !== A) {
                                        if ((e = rt(0, 255 & g[I - 1])) && st(!1), I++, T--, 0 === h.avail_out) return 0;
                                    } else A = 1, I++, T--;
                                }
                                return 0 !== A && (e = rt(0, 255 & g[I - 1]), A = 0), st(4 == t), 0 === h.avail_out ? 4 == t ? 2 : 0 : 4 == t ? 3 : 1;
                            }(e);
                    }
                    if (2 != a && 3 != a || (c = 666), 0 == a || 2 == a) return 0 === h.avail_out && (u = -1), 0;
                    if (1 == a) {
                        if (1 == e) $(2, 3), tt(256, ft.static_ltree), nt(), 1 + L + 10 - W < 9 && ($(2, 3), tt(256, ft.static_ltree), nt()), L = 7;
                        else if (at(0, 0, !1), 3 == e) for(n = 0; n < v; n++)w[n] = 0;
                        if (h.flush_pending(), 0 === h.avail_out) return u = -1, 0;
                    }
                }
                return 4 != e ? 0 : 1;
            };
        }
        function i() {
            var t = this;
            t.next_in_index = 0, t.next_out_index = 0, t.avail_in = 0, t.total_in = 0, t.avail_out = 0, t.total_out = 0;
        }
        i.prototype = {
            deflateInit: function(t, e) {
                return this.dstate = new r, e || (e = p), this.dstate.deflateInit(this, t, e);
            },
            deflate: function(t) {
                return this.dstate ? this.dstate.deflate(this, t) : -2;
            },
            deflateEnd: function() {
                if (!this.dstate) return -2;
                var t = this.dstate.deflateEnd();
                return this.dstate = null, t;
            },
            deflateParams: function(t, e) {
                return this.dstate ? this.dstate.deflateParams(this, t, e) : -2;
            },
            deflateSetDictionary: function(t, e) {
                return this.dstate ? this.dstate.deflateSetDictionary(this, t, e) : -2;
            },
            read_buf: function(t, e, n) {
                var r = this, i = r.avail_in;
                return n < i && (i = n), 0 === i ? 0 : (r.avail_in -= i, t.set(r.next_in.subarray(r.next_in_index, r.next_in_index + i), e), r.next_in_index += i, r.total_in += i, i);
            },
            flush_pending: function() {
                var t = this, e = t.dstate.pending;
                e > t.avail_out && (e = t.avail_out), 0 !== e && (t.next_out.set(t.dstate.pending_buf.subarray(t.dstate.pending_out, t.dstate.pending_out + e), t.next_out_index), t.next_out_index += e, t.dstate.pending_out += e, t.total_out += e, t.avail_out -= e, t.dstate.pending -= e, 0 === t.dstate.pending && (t.dstate.pending_out = 0));
            }
        };
        var o = t.zip || t;
        o.Deflater = o._jzlib_Deflater = function(t) {
            var s = new i, h = new Uint8Array(512), e = t ? t.level : -1;
            void 0 === e && (e = -1), s.deflateInit(e), s.next_out = h, this.append = function(t, e) {
                var n, r = [], i = 0, o = 0, a = 0;
                if (t.length) {
                    s.next_in_index = 0, s.next_in = t, s.avail_in = t.length;
                    do {
                        if (s.next_out_index = 0, s.avail_out = 512, 0 != s.deflate(0)) throw new Error("deflating: " + s.msg);
                        s.next_out_index && (512 == s.next_out_index ? r.push(new Uint8Array(h)) : r.push(new Uint8Array(h.subarray(0, s.next_out_index)))), a += s.next_out_index, e && 0 < s.next_in_index && s.next_in_index != i && (e(s.next_in_index), i = s.next_in_index);
                    }while (0 < s.avail_in || 0 === s.avail_out);
                    return n = new Uint8Array(a), r.forEach(function(t) {
                        n.set(t, o), o += t.length;
                    }), n;
                }
            }, this.flush = function() {
                var t, e, n = [], r = 0, i = 0;
                do {
                    if (s.next_out_index = 0, s.avail_out = 512, 1 != (t = s.deflate(4)) && 0 != t) throw new Error("deflating: " + s.msg);
                    0 < 512 - s.avail_out && n.push(new Uint8Array(h.subarray(0, s.next_out_index))), i += s.next_out_index;
                }while (0 < s.avail_in || 0 === s.avail_out);
                return s.deflateEnd(), e = new Uint8Array(i), n.forEach(function(t) {
                    e.set(t, r), r += t.length;
                }), e;
            };
        };
    }("undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")()), /**
   * A class to parse color values
   * @author Stoyan Stefanov <sstoo@gmail.com>
   * @link   http://www.phpied.com/rgb-color-parser-in-javascript/
   * @license Use it if you like it
   */ function(t) {
        function f(t) {
            var e;
            this.ok = !1, "#" == t.charAt(0) && (t = t.substr(1, 6)), t = (t = t.replace(/ /g, "")).toLowerCase();
            var l = {
                aliceblue: "f0f8ff",
                antiquewhite: "faebd7",
                aqua: "00ffff",
                aquamarine: "7fffd4",
                azure: "f0ffff",
                beige: "f5f5dc",
                bisque: "ffe4c4",
                black: "000000",
                blanchedalmond: "ffebcd",
                blue: "0000ff",
                blueviolet: "8a2be2",
                brown: "a52a2a",
                burlywood: "deb887",
                cadetblue: "5f9ea0",
                chartreuse: "7fff00",
                chocolate: "d2691e",
                coral: "ff7f50",
                cornflowerblue: "6495ed",
                cornsilk: "fff8dc",
                crimson: "dc143c",
                cyan: "00ffff",
                darkblue: "00008b",
                darkcyan: "008b8b",
                darkgoldenrod: "b8860b",
                darkgray: "a9a9a9",
                darkgreen: "006400",
                darkkhaki: "bdb76b",
                darkmagenta: "8b008b",
                darkolivegreen: "556b2f",
                darkorange: "ff8c00",
                darkorchid: "9932cc",
                darkred: "8b0000",
                darksalmon: "e9967a",
                darkseagreen: "8fbc8f",
                darkslateblue: "483d8b",
                darkslategray: "2f4f4f",
                darkturquoise: "00ced1",
                darkviolet: "9400d3",
                deeppink: "ff1493",
                deepskyblue: "00bfff",
                dimgray: "696969",
                dodgerblue: "1e90ff",
                feldspar: "d19275",
                firebrick: "b22222",
                floralwhite: "fffaf0",
                forestgreen: "228b22",
                fuchsia: "ff00ff",
                gainsboro: "dcdcdc",
                ghostwhite: "f8f8ff",
                gold: "ffd700",
                goldenrod: "daa520",
                gray: "808080",
                green: "008000",
                greenyellow: "adff2f",
                honeydew: "f0fff0",
                hotpink: "ff69b4",
                indianred: "cd5c5c",
                indigo: "4b0082",
                ivory: "fffff0",
                khaki: "f0e68c",
                lavender: "e6e6fa",
                lavenderblush: "fff0f5",
                lawngreen: "7cfc00",
                lemonchiffon: "fffacd",
                lightblue: "add8e6",
                lightcoral: "f08080",
                lightcyan: "e0ffff",
                lightgoldenrodyellow: "fafad2",
                lightgrey: "d3d3d3",
                lightgreen: "90ee90",
                lightpink: "ffb6c1",
                lightsalmon: "ffa07a",
                lightseagreen: "20b2aa",
                lightskyblue: "87cefa",
                lightslateblue: "8470ff",
                lightslategray: "778899",
                lightsteelblue: "b0c4de",
                lightyellow: "ffffe0",
                lime: "00ff00",
                limegreen: "32cd32",
                linen: "faf0e6",
                magenta: "ff00ff",
                maroon: "800000",
                mediumaquamarine: "66cdaa",
                mediumblue: "0000cd",
                mediumorchid: "ba55d3",
                mediumpurple: "9370d8",
                mediumseagreen: "3cb371",
                mediumslateblue: "7b68ee",
                mediumspringgreen: "00fa9a",
                mediumturquoise: "48d1cc",
                mediumvioletred: "c71585",
                midnightblue: "191970",
                mintcream: "f5fffa",
                mistyrose: "ffe4e1",
                moccasin: "ffe4b5",
                navajowhite: "ffdead",
                navy: "000080",
                oldlace: "fdf5e6",
                olive: "808000",
                olivedrab: "6b8e23",
                orange: "ffa500",
                orangered: "ff4500",
                orchid: "da70d6",
                palegoldenrod: "eee8aa",
                palegreen: "98fb98",
                paleturquoise: "afeeee",
                palevioletred: "d87093",
                papayawhip: "ffefd5",
                peachpuff: "ffdab9",
                peru: "cd853f",
                pink: "ffc0cb",
                plum: "dda0dd",
                powderblue: "b0e0e6",
                purple: "800080",
                red: "ff0000",
                rosybrown: "bc8f8f",
                royalblue: "4169e1",
                saddlebrown: "8b4513",
                salmon: "fa8072",
                sandybrown: "f4a460",
                seagreen: "2e8b57",
                seashell: "fff5ee",
                sienna: "a0522d",
                silver: "c0c0c0",
                skyblue: "87ceeb",
                slateblue: "6a5acd",
                slategray: "708090",
                snow: "fffafa",
                springgreen: "00ff7f",
                steelblue: "4682b4",
                tan: "d2b48c",
                teal: "008080",
                thistle: "d8bfd8",
                tomato: "ff6347",
                turquoise: "40e0d0",
                violet: "ee82ee",
                violetred: "d02090",
                wheat: "f5deb3",
                white: "ffffff",
                whitesmoke: "f5f5f5",
                yellow: "ffff00",
                yellowgreen: "9acd32"
            };
            for(var n in l)t == n && (t = l[n]);
            for(var u = [
                {
                    re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
                    example: [
                        "rgb(123, 234, 45)",
                        "rgb(255,234,245)"
                    ],
                    process: function(t) {
                        return [
                            parseInt(t[1]),
                            parseInt(t[2]),
                            parseInt(t[3])
                        ];
                    }
                },
                {
                    re: /^(\w{2})(\w{2})(\w{2})$/,
                    example: [
                        "#00ff00",
                        "336699"
                    ],
                    process: function(t) {
                        return [
                            parseInt(t[1], 16),
                            parseInt(t[2], 16),
                            parseInt(t[3], 16)
                        ];
                    }
                },
                {
                    re: /^(\w{1})(\w{1})(\w{1})$/,
                    example: [
                        "#fb0",
                        "f0f"
                    ],
                    process: function(t) {
                        return [
                            parseInt(t[1] + t[1], 16),
                            parseInt(t[2] + t[2], 16),
                            parseInt(t[3] + t[3], 16)
                        ];
                    }
                }
            ], r = 0; r < u.length; r++){
                var i = u[r].re, o = u[r].process, a = i.exec(t);
                a && (e = o(a), this.r = e[0], this.g = e[1], this.b = e[2], this.ok = !0);
            }
            this.r = this.r < 0 || isNaN(this.r) ? 0 : 255 < this.r ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : 255 < this.g ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : 255 < this.b ? 255 : this.b, this.toRGB = function() {
                return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
            }, this.toHex = function() {
                var t = this.r.toString(16), e = this.g.toString(16), n = this.b.toString(16);
                return 1 == t.length && (t = "0" + t), 1 == e.length && (e = "0" + e), 1 == n.length && (n = "0" + n), "#" + t + e + n;
            }, this.getHelpXML = function() {
                for(var t = new Array, e = 0; e < u.length; e++)for(var n = u[e].example, r = 0; r < n.length; r++)t[t.length] = n[r];
                for(var i in l)t[t.length] = i;
                var o = document.createElement("ul");
                o.setAttribute("id", "rgbcolor-examples");
                for(e = 0; e < t.length; e++)try {
                    var a = document.createElement("li"), s = new f(t[e]), h = document.createElement("div");
                    h.style.cssText = "margin: 3px; border: 1px solid black; background:" + s.toHex() + "; color:" + s.toHex(), h.appendChild(document.createTextNode("test"));
                    var c = document.createTextNode(" " + t[e] + " -> " + s.toRGB() + " -> " + s.toHex());
                    a.appendChild(h), a.appendChild(c), o.appendChild(a);
                } catch (t) {}
                return o;
            };
        }
        "undefined" != typeof define && define.amd ? define("RGBColor", function() {
            return f;
        }) : (0, module.exports) && (module.exports = f), t.RGBColor = f;
    }("undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")()), function(t) {
        var e;
        module.exports = t();
    }(function() {
        return (function o(a, s, h) {
            function c(n, t) {
                if (!s[n]) {
                    if (!a[n]) {
                        var e = undefined;
                        if (!t && e) return e(n, !0);
                        if (l) return l(n, !0);
                        var r = new Error("Cannot find module '" + n + "'");
                        throw r.code = "MODULE_NOT_FOUND", r;
                    }
                    var i = s[n] = {
                        exports: {}
                    };
                    a[n][0].call(i.exports, function(t) {
                        var e = a[n][1][t];
                        return c(e || t);
                    }, i, i.exports, o, a, s, h);
                }
                return s[n].exports;
            }
            for(var l = undefined, t = 0; t < h.length; t++)c(h[t]);
            return c;
        })({
            1: [
                function(t, q, O) {
                    (function(E) {
                        !function(t) {
                            var e = "object" == typeof O && O, n = "object" == typeof q && q && q.exports == e && q, r = "object" == typeof E && E;
                            r.global !== r && r.window !== r || (t = r);
                            var i, o, w = 2147483647, y = 36, v = 1, b = 26, a = 38, s = 700, x = 72, S = 128, k = "-", h = /^xn--/, c = /[^ -~]/, l = /\x2E|\u3002|\uFF0E|\uFF61/g, u = {
                                overflow: "Overflow: input needs wider integers to process",
                                "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                                "invalid-input": "Invalid input"
                            }, f = y - v, _ = Math.floor, A = String.fromCharCode;
                            function I(t) {
                                throw RangeError(u[t]);
                            }
                            function d(t, e) {
                                for(var n = t.length; n--;)t[n] = e(t[n]);
                                return t;
                            }
                            function p(t, e) {
                                return d(t.split(l), e).join(".");
                            }
                            function C(t) {
                                for(var e, n, r = [], i = 0, o = t.length; i < o;)55296 <= (e = t.charCodeAt(i++)) && e <= 56319 && i < o ? 56320 == (64512 & (n = t.charCodeAt(i++))) ? r.push(((1023 & e) << 10) + (1023 & n) + 65536) : (r.push(e), i--) : r.push(e);
                                return r;
                            }
                            function T(t) {
                                return d(t, function(t) {
                                    var e = "";
                                    return 65535 < t && (e += A((t -= 65536) >>> 10 & 1023 | 55296), t = 56320 | 1023 & t), e += A(t);
                                }).join("");
                            }
                            function F(t, e) {
                                return t + 22 + 75 * (t < 26) - ((0 != e) << 5);
                            }
                            function P(t, e, n) {
                                var r = 0;
                                for(t = n ? _(t / s) : t >> 1, t += _(t / e); f * b >> 1 < t; r += y)t = _(t / f);
                                return _(r + (f + 1) * t / (t + a));
                            }
                            function g(t) {
                                var e, n, r, i, o, a, s, h, c, l, u, f = [], d = t.length, p = 0, g = S, m = x;
                                for((n = t.lastIndexOf(k)) < 0 && (n = 0), r = 0; r < n; ++r)128 <= t.charCodeAt(r) && I("not-basic"), f.push(t.charCodeAt(r));
                                for(i = 0 < n ? n + 1 : 0; i < d;){
                                    for(o = p, a = 1, s = y; d <= i && I("invalid-input"), u = t.charCodeAt(i++), (y <= (h = u - 48 < 10 ? u - 22 : u - 65 < 26 ? u - 65 : u - 97 < 26 ? u - 97 : y) || h > _((w - p) / a)) && I("overflow"), p += h * a, !(h < (c = s <= m ? v : m + b <= s ? b : s - m)); s += y)a > _(w / (l = y - c)) && I("overflow"), a *= l;
                                    m = P(p - o, e = f.length + 1, 0 == o), _(p / e) > w - g && I("overflow"), g += _(p / e), p %= e, f.splice(p++, 0, g);
                                }
                                return T(f);
                            }
                            function m(t) {
                                var e, n, r, i, o, a, s, h, c, l, u, f, d, p, g, m = [];
                                for(f = (t = C(t)).length, e = S, o = x, a = n = 0; a < f; ++a)(u = t[a]) < 128 && m.push(A(u));
                                for(r = i = m.length, i && m.push(k); r < f;){
                                    for(s = w, a = 0; a < f; ++a)e <= (u = t[a]) && u < s && (s = u);
                                    for(s - e > _((w - n) / (d = r + 1)) && I("overflow"), n += (s - e) * d, e = s, a = 0; a < f; ++a)if ((u = t[a]) < e && ++n > w && I("overflow"), u == e) {
                                        for(h = n, c = y; !(h < (l = c <= o ? v : o + b <= c ? b : c - o)); c += y)g = h - l, p = y - l, m.push(A(F(l + g % p, 0))), h = _(g / p);
                                        m.push(A(F(h, 0))), o = P(n, d, r == i), n = 0, ++r;
                                    }
                                    ++n, ++e;
                                }
                                return m.join("");
                            }
                            if (i = {
                                version: "1.2.4",
                                ucs2: {
                                    decode: C,
                                    encode: T
                                },
                                decode: g,
                                encode: m,
                                toASCII: function(t) {
                                    return p(t, function(t) {
                                        return c.test(t) ? "xn--" + m(t) : t;
                                    });
                                },
                                toUnicode: function(t) {
                                    return p(t, function(t) {
                                        return h.test(t) ? g(t.slice(4).toLowerCase()) : t;
                                    });
                                }
                            }, e && !e.nodeType) {
                                if (n) n.exports = i;
                                else for(o in i)i.hasOwnProperty(o) && (e[o] = i[o]);
                            } else t.punycode = i;
                        }(this);
                    }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                },
                {}
            ],
            2: [
                function(t, e, n) {
                    var i = t("./log");
                    function u(t, e) {
                        for(var n = 3 === t.nodeType ? document.createTextNode(t.nodeValue) : t.cloneNode(!1), r = t.firstChild; r;)!0 !== e && 1 === r.nodeType && "SCRIPT" === r.nodeName || n.appendChild(u(r, e)), r = r.nextSibling;
                        return 1 === t.nodeType && (n._scrollTop = t.scrollTop, n._scrollLeft = t.scrollLeft, "CANVAS" === t.nodeName ? function(e, t) {
                            try {
                                t && (t.width = e.width, t.height = e.height, t.getContext("2d").putImageData(e.getContext("2d").getImageData(0, 0, e.width, e.height), 0, 0));
                            } catch (t) {
                                i("Unable to copy canvas content from", e, t);
                            }
                        }(t, n) : "TEXTAREA" !== t.nodeName && "SELECT" !== t.nodeName || (n.value = t.value)), n;
                    }
                    e.exports = function(o, t, e, n, a, s, h) {
                        var c = u(o.documentElement, a.javascriptEnabled), l = t.createElement("iframe");
                        return l.className = "html2canvas-container", l.style.visibility = "hidden", l.style.position = "fixed", l.style.left = "-10000px", l.style.top = "0px", l.style.border = "0", l.width = e, l.height = n, l.scrolling = "no", t.body.appendChild(l), new Promise(function(e) {
                            var t, n, r, i = l.contentWindow.document;
                            l.contentWindow.onload = l.onload = function() {
                                var t = setInterval(function() {
                                    0 < i.body.childNodes.length && (!function t(e) {
                                        if (1 === e.nodeType) {
                                            e.scrollTop = e._scrollTop, e.scrollLeft = e._scrollLeft;
                                            for(var n = e.firstChild; n;)t(n), n = n.nextSibling;
                                        }
                                    }(i.documentElement), clearInterval(t), "view" === a.type && (l.contentWindow.scrollTo(s, h), !/(iPad|iPhone|iPod)/g.test(navigator.userAgent) || l.contentWindow.scrollY === h && l.contentWindow.scrollX === s || (i.documentElement.style.top = -h + "px", i.documentElement.style.left = -s + "px", i.documentElement.style.position = "absolute")), e(l));
                                }, 50);
                            }, i.open(), i.write("<!DOCTYPE html><html></html>"), n = s, r = h, !(t = o).defaultView || n === t.defaultView.pageXOffset && r === t.defaultView.pageYOffset || t.defaultView.scrollTo(n, r), i.replaceChild(i.adoptNode(c), i.documentElement), i.close();
                        });
                    };
                },
                {
                    "./log": 13
                }
            ],
            3: [
                function(t, e, n) {
                    function r(t) {
                        this.r = 0, this.g = 0, this.b = 0, this.a = null;
                        this.fromArray(t) || this.namedColor(t) || this.rgb(t) || this.rgba(t) || this.hex6(t) || this.hex3(t);
                    }
                    r.prototype.darken = function(t) {
                        var e = 1 - t;
                        return new r([
                            Math.round(this.r * e),
                            Math.round(this.g * e),
                            Math.round(this.b * e),
                            this.a
                        ]);
                    }, r.prototype.isTransparent = function() {
                        return 0 === this.a;
                    }, r.prototype.isBlack = function() {
                        return 0 === this.r && 0 === this.g && 0 === this.b;
                    }, r.prototype.fromArray = function(t) {
                        return Array.isArray(t) && (this.r = Math.min(t[0], 255), this.g = Math.min(t[1], 255), this.b = Math.min(t[2], 255), 3 < t.length && (this.a = t[3])), Array.isArray(t);
                    };
                    var i = /^#([a-f0-9]{3})$/i;
                    r.prototype.hex3 = function(t) {
                        var e;
                        return null !== (e = t.match(i)) && (this.r = parseInt(e[1][0] + e[1][0], 16), this.g = parseInt(e[1][1] + e[1][1], 16), this.b = parseInt(e[1][2] + e[1][2], 16)), null !== e;
                    };
                    var o = /^#([a-f0-9]{6})$/i;
                    r.prototype.hex6 = function(t) {
                        var e = null;
                        return null !== (e = t.match(o)) && (this.r = parseInt(e[1].substring(0, 2), 16), this.g = parseInt(e[1].substring(2, 4), 16), this.b = parseInt(e[1].substring(4, 6), 16)), null !== e;
                    };
                    var a = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
                    r.prototype.rgb = function(t) {
                        var e;
                        return null !== (e = t.match(a)) && (this.r = Number(e[1]), this.g = Number(e[2]), this.b = Number(e[3])), null !== e;
                    };
                    var s = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/;
                    r.prototype.rgba = function(t) {
                        var e;
                        return null !== (e = t.match(s)) && (this.r = Number(e[1]), this.g = Number(e[2]), this.b = Number(e[3]), this.a = Number(e[4])), null !== e;
                    }, r.prototype.toString = function() {
                        return null !== this.a && 1 !== this.a ? "rgba(" + [
                            this.r,
                            this.g,
                            this.b,
                            this.a
                        ].join(",") + ")" : "rgb(" + [
                            this.r,
                            this.g,
                            this.b
                        ].join(",") + ")";
                    }, r.prototype.namedColor = function(t) {
                        t = t.toLowerCase();
                        var e = h[t];
                        if (e) this.r = e[0], this.g = e[1], this.b = e[2];
                        else if ("transparent" === t) return this.r = this.g = this.b = this.a = 0, !0;
                        return !!e;
                    }, r.prototype.isColor = !0;
                    var h = {
                        aliceblue: [
                            240,
                            248,
                            255
                        ],
                        antiquewhite: [
                            250,
                            235,
                            215
                        ],
                        aqua: [
                            0,
                            255,
                            255
                        ],
                        aquamarine: [
                            127,
                            255,
                            212
                        ],
                        azure: [
                            240,
                            255,
                            255
                        ],
                        beige: [
                            245,
                            245,
                            220
                        ],
                        bisque: [
                            255,
                            228,
                            196
                        ],
                        black: [
                            0,
                            0,
                            0
                        ],
                        blanchedalmond: [
                            255,
                            235,
                            205
                        ],
                        blue: [
                            0,
                            0,
                            255
                        ],
                        blueviolet: [
                            138,
                            43,
                            226
                        ],
                        brown: [
                            165,
                            42,
                            42
                        ],
                        burlywood: [
                            222,
                            184,
                            135
                        ],
                        cadetblue: [
                            95,
                            158,
                            160
                        ],
                        chartreuse: [
                            127,
                            255,
                            0
                        ],
                        chocolate: [
                            210,
                            105,
                            30
                        ],
                        coral: [
                            255,
                            127,
                            80
                        ],
                        cornflowerblue: [
                            100,
                            149,
                            237
                        ],
                        cornsilk: [
                            255,
                            248,
                            220
                        ],
                        crimson: [
                            220,
                            20,
                            60
                        ],
                        cyan: [
                            0,
                            255,
                            255
                        ],
                        darkblue: [
                            0,
                            0,
                            139
                        ],
                        darkcyan: [
                            0,
                            139,
                            139
                        ],
                        darkgoldenrod: [
                            184,
                            134,
                            11
                        ],
                        darkgray: [
                            169,
                            169,
                            169
                        ],
                        darkgreen: [
                            0,
                            100,
                            0
                        ],
                        darkgrey: [
                            169,
                            169,
                            169
                        ],
                        darkkhaki: [
                            189,
                            183,
                            107
                        ],
                        darkmagenta: [
                            139,
                            0,
                            139
                        ],
                        darkolivegreen: [
                            85,
                            107,
                            47
                        ],
                        darkorange: [
                            255,
                            140,
                            0
                        ],
                        darkorchid: [
                            153,
                            50,
                            204
                        ],
                        darkred: [
                            139,
                            0,
                            0
                        ],
                        darksalmon: [
                            233,
                            150,
                            122
                        ],
                        darkseagreen: [
                            143,
                            188,
                            143
                        ],
                        darkslateblue: [
                            72,
                            61,
                            139
                        ],
                        darkslategray: [
                            47,
                            79,
                            79
                        ],
                        darkslategrey: [
                            47,
                            79,
                            79
                        ],
                        darkturquoise: [
                            0,
                            206,
                            209
                        ],
                        darkviolet: [
                            148,
                            0,
                            211
                        ],
                        deeppink: [
                            255,
                            20,
                            147
                        ],
                        deepskyblue: [
                            0,
                            191,
                            255
                        ],
                        dimgray: [
                            105,
                            105,
                            105
                        ],
                        dimgrey: [
                            105,
                            105,
                            105
                        ],
                        dodgerblue: [
                            30,
                            144,
                            255
                        ],
                        firebrick: [
                            178,
                            34,
                            34
                        ],
                        floralwhite: [
                            255,
                            250,
                            240
                        ],
                        forestgreen: [
                            34,
                            139,
                            34
                        ],
                        fuchsia: [
                            255,
                            0,
                            255
                        ],
                        gainsboro: [
                            220,
                            220,
                            220
                        ],
                        ghostwhite: [
                            248,
                            248,
                            255
                        ],
                        gold: [
                            255,
                            215,
                            0
                        ],
                        goldenrod: [
                            218,
                            165,
                            32
                        ],
                        gray: [
                            128,
                            128,
                            128
                        ],
                        green: [
                            0,
                            128,
                            0
                        ],
                        greenyellow: [
                            173,
                            255,
                            47
                        ],
                        grey: [
                            128,
                            128,
                            128
                        ],
                        honeydew: [
                            240,
                            255,
                            240
                        ],
                        hotpink: [
                            255,
                            105,
                            180
                        ],
                        indianred: [
                            205,
                            92,
                            92
                        ],
                        indigo: [
                            75,
                            0,
                            130
                        ],
                        ivory: [
                            255,
                            255,
                            240
                        ],
                        khaki: [
                            240,
                            230,
                            140
                        ],
                        lavender: [
                            230,
                            230,
                            250
                        ],
                        lavenderblush: [
                            255,
                            240,
                            245
                        ],
                        lawngreen: [
                            124,
                            252,
                            0
                        ],
                        lemonchiffon: [
                            255,
                            250,
                            205
                        ],
                        lightblue: [
                            173,
                            216,
                            230
                        ],
                        lightcoral: [
                            240,
                            128,
                            128
                        ],
                        lightcyan: [
                            224,
                            255,
                            255
                        ],
                        lightgoldenrodyellow: [
                            250,
                            250,
                            210
                        ],
                        lightgray: [
                            211,
                            211,
                            211
                        ],
                        lightgreen: [
                            144,
                            238,
                            144
                        ],
                        lightgrey: [
                            211,
                            211,
                            211
                        ],
                        lightpink: [
                            255,
                            182,
                            193
                        ],
                        lightsalmon: [
                            255,
                            160,
                            122
                        ],
                        lightseagreen: [
                            32,
                            178,
                            170
                        ],
                        lightskyblue: [
                            135,
                            206,
                            250
                        ],
                        lightslategray: [
                            119,
                            136,
                            153
                        ],
                        lightslategrey: [
                            119,
                            136,
                            153
                        ],
                        lightsteelblue: [
                            176,
                            196,
                            222
                        ],
                        lightyellow: [
                            255,
                            255,
                            224
                        ],
                        lime: [
                            0,
                            255,
                            0
                        ],
                        limegreen: [
                            50,
                            205,
                            50
                        ],
                        linen: [
                            250,
                            240,
                            230
                        ],
                        magenta: [
                            255,
                            0,
                            255
                        ],
                        maroon: [
                            128,
                            0,
                            0
                        ],
                        mediumaquamarine: [
                            102,
                            205,
                            170
                        ],
                        mediumblue: [
                            0,
                            0,
                            205
                        ],
                        mediumorchid: [
                            186,
                            85,
                            211
                        ],
                        mediumpurple: [
                            147,
                            112,
                            219
                        ],
                        mediumseagreen: [
                            60,
                            179,
                            113
                        ],
                        mediumslateblue: [
                            123,
                            104,
                            238
                        ],
                        mediumspringgreen: [
                            0,
                            250,
                            154
                        ],
                        mediumturquoise: [
                            72,
                            209,
                            204
                        ],
                        mediumvioletred: [
                            199,
                            21,
                            133
                        ],
                        midnightblue: [
                            25,
                            25,
                            112
                        ],
                        mintcream: [
                            245,
                            255,
                            250
                        ],
                        mistyrose: [
                            255,
                            228,
                            225
                        ],
                        moccasin: [
                            255,
                            228,
                            181
                        ],
                        navajowhite: [
                            255,
                            222,
                            173
                        ],
                        navy: [
                            0,
                            0,
                            128
                        ],
                        oldlace: [
                            253,
                            245,
                            230
                        ],
                        olive: [
                            128,
                            128,
                            0
                        ],
                        olivedrab: [
                            107,
                            142,
                            35
                        ],
                        orange: [
                            255,
                            165,
                            0
                        ],
                        orangered: [
                            255,
                            69,
                            0
                        ],
                        orchid: [
                            218,
                            112,
                            214
                        ],
                        palegoldenrod: [
                            238,
                            232,
                            170
                        ],
                        palegreen: [
                            152,
                            251,
                            152
                        ],
                        paleturquoise: [
                            175,
                            238,
                            238
                        ],
                        palevioletred: [
                            219,
                            112,
                            147
                        ],
                        papayawhip: [
                            255,
                            239,
                            213
                        ],
                        peachpuff: [
                            255,
                            218,
                            185
                        ],
                        peru: [
                            205,
                            133,
                            63
                        ],
                        pink: [
                            255,
                            192,
                            203
                        ],
                        plum: [
                            221,
                            160,
                            221
                        ],
                        powderblue: [
                            176,
                            224,
                            230
                        ],
                        purple: [
                            128,
                            0,
                            128
                        ],
                        rebeccapurple: [
                            102,
                            51,
                            153
                        ],
                        red: [
                            255,
                            0,
                            0
                        ],
                        rosybrown: [
                            188,
                            143,
                            143
                        ],
                        royalblue: [
                            65,
                            105,
                            225
                        ],
                        saddlebrown: [
                            139,
                            69,
                            19
                        ],
                        salmon: [
                            250,
                            128,
                            114
                        ],
                        sandybrown: [
                            244,
                            164,
                            96
                        ],
                        seagreen: [
                            46,
                            139,
                            87
                        ],
                        seashell: [
                            255,
                            245,
                            238
                        ],
                        sienna: [
                            160,
                            82,
                            45
                        ],
                        silver: [
                            192,
                            192,
                            192
                        ],
                        skyblue: [
                            135,
                            206,
                            235
                        ],
                        slateblue: [
                            106,
                            90,
                            205
                        ],
                        slategray: [
                            112,
                            128,
                            144
                        ],
                        slategrey: [
                            112,
                            128,
                            144
                        ],
                        snow: [
                            255,
                            250,
                            250
                        ],
                        springgreen: [
                            0,
                            255,
                            127
                        ],
                        steelblue: [
                            70,
                            130,
                            180
                        ],
                        tan: [
                            210,
                            180,
                            140
                        ],
                        teal: [
                            0,
                            128,
                            128
                        ],
                        thistle: [
                            216,
                            191,
                            216
                        ],
                        tomato: [
                            255,
                            99,
                            71
                        ],
                        turquoise: [
                            64,
                            224,
                            208
                        ],
                        violet: [
                            238,
                            130,
                            238
                        ],
                        wheat: [
                            245,
                            222,
                            179
                        ],
                        white: [
                            255,
                            255,
                            255
                        ],
                        whitesmoke: [
                            245,
                            245,
                            245
                        ],
                        yellow: [
                            255,
                            255,
                            0
                        ],
                        yellowgreen: [
                            154,
                            205,
                            50
                        ]
                    };
                    e.exports = r;
                },
                {}
            ],
            4: [
                function(t, e, n) {
                    var p = t("./support"), d = t("./renderers/canvas"), g = t("./imageloader"), m = t("./nodeparser"), r = t("./nodecontainer"), w = t("./log"), i = t("./utils"), y = t("./clone"), v = t("./proxy").loadUrlDocument, b = i.getBounds, x = "data-html2canvas-node", S = 0;
                    function o(t, e) {
                        var n, r, i = S++;
                        if ((e = e || {}).logging && (w.options.logging = !0, w.options.start = Date.now()), e.async = void 0 === e.async || e.async, e.allowTaint = void 0 !== e.allowTaint && e.allowTaint, e.removeContainer = void 0 === e.removeContainer || e.removeContainer, e.javascriptEnabled = void 0 !== e.javascriptEnabled && e.javascriptEnabled, e.imageTimeout = void 0 === e.imageTimeout ? 1e4 : e.imageTimeout, e.renderer = "function" == typeof e.renderer ? e.renderer : d, e.strict = !!e.strict, "string" == typeof t) {
                            if ("string" != typeof e.proxy) return Promise.reject("Proxy must be used when rendering url");
                            var o = null != e.width ? e.width : window.innerWidth, a = null != e.height ? e.height : window.innerHeight;
                            return v((n = t, r = document.createElement("a"), r.href = n, r.href = r.href, r), e.proxy, document, o, a, e).then(function(t) {
                                return k(t.contentWindow.document.documentElement, t, e, o, a);
                            });
                        }
                        var s, h, c, l, u, f = (void 0 === t ? [
                            document.documentElement
                        ] : t.length ? t : [
                            t
                        ])[0];
                        return f.setAttribute(x + i, i), (s = f.ownerDocument, h = e, c = f.ownerDocument.defaultView.innerWidth, l = f.ownerDocument.defaultView.innerHeight, u = i, y(s, s, c, l, h, s.defaultView.pageXOffset, s.defaultView.pageYOffset).then(function(t) {
                            w("Document cloned");
                            var e = x + u, n = "[" + e + "='" + u + "']";
                            s.querySelector(n).removeAttribute(e);
                            var r = t.contentWindow, i = r.document.querySelector(n), o = "function" == typeof h.onclone ? Promise.resolve(h.onclone(r.document)) : Promise.resolve(!0);
                            return o.then(function() {
                                return k(i, t, h, c, l);
                            });
                        })).then(function(t) {
                            return "function" == typeof e.onrendered && (w("options.onrendered is deprecated, html2canvas returns a Promise containing the canvas"), e.onrendered(t)), t;
                        });
                    }
                    o.CanvasRenderer = d, o.NodeContainer = r, o.log = w, o.utils = i;
                    var a = "undefined" == typeof document || "function" != typeof Object.create || "function" != typeof document.createElement("canvas").getContext ? function() {
                        return Promise.reject("No canvas support");
                    } : o;
                    function k(n, r, i, t, e) {
                        var o, a, s = r.contentWindow, h = new p(s.document), c = new g(i, h), l = b(n), u = "view" === i.type ? t : (o = s.document, Math.max(Math.max(o.body.scrollWidth, o.documentElement.scrollWidth), Math.max(o.body.offsetWidth, o.documentElement.offsetWidth), Math.max(o.body.clientWidth, o.documentElement.clientWidth))), f = "view" === i.type ? e : (a = s.document, Math.max(Math.max(a.body.scrollHeight, a.documentElement.scrollHeight), Math.max(a.body.offsetHeight, a.documentElement.offsetHeight), Math.max(a.body.clientHeight, a.documentElement.clientHeight))), d = new i.renderer(u, f, c, i, document);
                        return new m(n, d, h, c, i).ready.then(function() {
                            var t, e;
                            return w("Finished rendering"), t = "view" === i.type ? _(d.canvas, {
                                width: d.canvas.width,
                                height: d.canvas.height,
                                top: 0,
                                left: 0,
                                x: 0,
                                y: 0
                            }) : n === s.document.body || n === s.document.documentElement || null != i.canvas ? d.canvas : _(d.canvas, {
                                width: null != i.width ? i.width : l.width,
                                height: null != i.height ? i.height : l.height,
                                top: l.top,
                                left: l.left,
                                x: 0,
                                y: 0
                            }), e = r, i.removeContainer && (e.parentNode.removeChild(e), w("Cleaned up container")), t;
                        });
                    }
                    function _(t, e) {
                        var n = document.createElement("canvas"), r = Math.min(t.width - 1, Math.max(0, e.left)), i = Math.min(t.width, Math.max(1, e.left + e.width)), o = Math.min(t.height - 1, Math.max(0, e.top)), a = Math.min(t.height, Math.max(1, e.top + e.height));
                        n.width = e.width, n.height = e.height;
                        var s = i - r, h = a - o;
                        return w("Cropping canvas at:", "left:", e.left, "top:", e.top, "width:", s, "height:", h), w("Resulting crop with width", e.width, "and height", e.height, "with x", r, "and y", o), n.getContext("2d").drawImage(t, r, o, s, h, e.x, e.y, s, h), n;
                    }
                    e.exports = a;
                },
                {
                    "./clone": 2,
                    "./imageloader": 11,
                    "./log": 13,
                    "./nodecontainer": 14,
                    "./nodeparser": 15,
                    "./proxy": 16,
                    "./renderers/canvas": 20,
                    "./support": 22,
                    "./utils": 26
                }
            ],
            5: [
                function(t, e, n) {
                    var r = t("./log"), i = t("./utils").smallImage;
                    e.exports = function t(e) {
                        if (this.src = e, r("DummyImageContainer for", e), !this.promise || !this.image) {
                            r("Initiating DummyImageContainer"), t.prototype.image = new Image;
                            var n = this.image;
                            t.prototype.promise = new Promise(function(t, e) {
                                n.onload = t, n.onerror = e, n.src = i(), !0 === n.complete && t(n);
                            });
                        }
                    };
                },
                {
                    "./log": 13,
                    "./utils": 26
                }
            ],
            6: [
                function(t, e, n) {
                    var h = t("./utils").smallImage;
                    e.exports = function(t, e) {
                        var n, r, i = document.createElement("div"), o = document.createElement("img"), a = document.createElement("span"), s = "Hidden Text";
                        i.style.visibility = "hidden", i.style.fontFamily = t, i.style.fontSize = e, i.style.margin = 0, i.style.padding = 0, document.body.appendChild(i), o.src = h(), o.width = 1, o.height = 1, o.style.margin = 0, o.style.padding = 0, o.style.verticalAlign = "baseline", a.style.fontFamily = t, a.style.fontSize = e, a.style.margin = 0, a.style.padding = 0, a.appendChild(document.createTextNode(s)), i.appendChild(a), i.appendChild(o), n = o.offsetTop - a.offsetTop + 1, i.removeChild(a), i.appendChild(document.createTextNode(s)), i.style.lineHeight = "normal", o.style.verticalAlign = "super", r = o.offsetTop - i.offsetTop + 1, document.body.removeChild(i), this.baseline = n, this.lineWidth = 1, this.middle = r;
                    };
                },
                {
                    "./utils": 26
                }
            ],
            7: [
                function(t, e, n) {
                    var r = t("./font");
                    function i() {
                        this.data = {};
                    }
                    i.prototype.getMetrics = function(t, e) {
                        return void 0 === this.data[t + "-" + e] && (this.data[t + "-" + e] = new r(t, e)), this.data[t + "-" + e];
                    }, e.exports = i;
                },
                {
                    "./font": 6
                }
            ],
            8: [
                function(o, t, e) {
                    var a = o("./utils").getBounds, i = o("./proxy").loadUrlDocument;
                    function n(e, t, n) {
                        this.image = null, this.src = e;
                        var r = this, i = a(e);
                        this.promise = (t ? new Promise(function(t) {
                            "about:blank" === e.contentWindow.document.URL || null == e.contentWindow.document.documentElement ? e.contentWindow.onload = e.onload = function() {
                                t(e);
                            } : t(e);
                        }) : this.proxyLoad(n.proxy, i, n)).then(function(t) {
                            return o("./core")(t.contentWindow.document.documentElement, {
                                type: "view",
                                width: t.width,
                                height: t.height,
                                proxy: n.proxy,
                                javascriptEnabled: n.javascriptEnabled,
                                removeContainer: n.removeContainer,
                                allowTaint: n.allowTaint,
                                imageTimeout: n.imageTimeout / 2
                            });
                        }).then(function(t) {
                            return r.image = t;
                        });
                    }
                    n.prototype.proxyLoad = function(t, e, n) {
                        var r = this.src;
                        return i(r.src, t, r.ownerDocument, e.width, e.height, n);
                    }, t.exports = n;
                },
                {
                    "./core": 4,
                    "./proxy": 16,
                    "./utils": 26
                }
            ],
            9: [
                function(t, e, n) {
                    function r(t) {
                        this.src = t.value, this.colorStops = [], this.type = null, this.x0 = .5, this.y0 = .5, this.x1 = .5, this.y1 = .5, this.promise = Promise.resolve(!0);
                    }
                    r.TYPES = {
                        LINEAR: 1,
                        RADIAL: 2
                    }, r.REGEXP_COLORSTOP = /^\s*(rgba?\(\s*\d{1,3},\s*\d{1,3},\s*\d{1,3}(?:,\s*[0-9\.]+)?\s*\)|[a-z]{3,20}|#[a-f0-9]{3,6})(?:\s+(\d{1,3}(?:\.\d+)?)(%|px)?)?(?:\s|$)/i, e.exports = r;
                },
                {}
            ],
            10: [
                function(t, e, n) {
                    e.exports = function(n, r) {
                        this.src = n, this.image = new Image;
                        var i = this;
                        this.tainted = null, this.promise = new Promise(function(t, e) {
                            i.image.onload = t, i.image.onerror = e, r && (i.image.crossOrigin = "anonymous"), i.image.src = n, !0 === i.image.complete && t(i.image);
                        });
                    };
                },
                {}
            ],
            11: [
                function(t, e, n) {
                    var o = t("./log"), r = t("./imagecontainer"), i = t("./dummyimagecontainer"), a = t("./proxyimagecontainer"), s = t("./framecontainer"), h = t("./svgcontainer"), c = t("./svgnodecontainer"), l = t("./lineargradientcontainer"), u = t("./webkitgradientcontainer"), f = t("./utils").bind;
                    function d(t, e) {
                        this.link = null, this.options = t, this.support = e, this.origin = this.getOrigin(window.location.href);
                    }
                    d.prototype.findImages = function(t) {
                        var e = [];
                        return t.reduce(function(t, e) {
                            switch(e.node.nodeName){
                                case "IMG":
                                    return t.concat([
                                        {
                                            args: [
                                                e.node.src
                                            ],
                                            method: "url"
                                        }
                                    ]);
                                case "svg":
                                case "IFRAME":
                                    return t.concat([
                                        {
                                            args: [
                                                e.node
                                            ],
                                            method: e.node.nodeName
                                        }
                                    ]);
                            }
                            return t;
                        }, []).forEach(this.addImage(e, this.loadImage), this), e;
                    }, d.prototype.findBackgroundImage = function(t, e) {
                        return e.parseBackgroundImages().filter(this.hasImageBackground).forEach(this.addImage(t, this.loadImage), this), t;
                    }, d.prototype.addImage = function(n, r) {
                        return function(e) {
                            e.args.forEach(function(t) {
                                this.imageExists(n, t) || (n.splice(0, 0, r.call(this, e)), o("Added image #" + n.length, "string" == typeof t ? t.substring(0, 100) : t));
                            }, this);
                        };
                    }, d.prototype.hasImageBackground = function(t) {
                        return "none" !== t.method;
                    }, d.prototype.loadImage = function(t) {
                        if ("url" === t.method) {
                            var e = t.args[0];
                            return !this.isSVG(e) || this.support.svg || this.options.allowTaint ? e.match(/data:image\/.*;base64,/i) ? new r(e.replace(/url\(['"]{0,}|['"]{0,}\)$/gi, ""), !1) : this.isSameOrigin(e) || !0 === this.options.allowTaint || this.isSVG(e) ? new r(e, !1) : this.support.cors && !this.options.allowTaint && this.options.useCORS ? new r(e, !0) : this.options.proxy ? new a(e, this.options.proxy) : new i(e) : new h(e);
                        }
                        return "linear-gradient" === t.method ? new l(t) : "gradient" === t.method ? new u(t) : "svg" === t.method ? new c(t.args[0], this.support.svg) : "IFRAME" === t.method ? new s(t.args[0], this.isSameOrigin(t.args[0].src), this.options) : new i(t);
                    }, d.prototype.isSVG = function(t) {
                        return "svg" === t.substring(t.length - 3).toLowerCase() || h.prototype.isInline(t);
                    }, d.prototype.imageExists = function(t, e) {
                        return t.some(function(t) {
                            return t.src === e;
                        });
                    }, d.prototype.isSameOrigin = function(t) {
                        return this.getOrigin(t) === this.origin;
                    }, d.prototype.getOrigin = function(t) {
                        var e = this.link || (this.link = document.createElement("a"));
                        return e.href = t, e.href = e.href, e.protocol + e.hostname + e.port;
                    }, d.prototype.getPromise = function(e) {
                        return this.timeout(e, this.options.imageTimeout).catch(function() {
                            return new i(e.src).promise.then(function(t) {
                                e.image = t;
                            });
                        });
                    }, d.prototype.get = function(e) {
                        var n = null;
                        return this.images.some(function(t) {
                            return (n = t).src === e;
                        }) ? n : null;
                    }, d.prototype.fetch = function(t) {
                        return this.images = t.reduce(f(this.findBackgroundImage, this), this.findImages(t)), this.images.forEach(function(e, n) {
                            e.promise.then(function() {
                                o("Succesfully loaded image #" + (n + 1), e);
                            }, function(t) {
                                o("Failed loading image #" + (n + 1), e, t);
                            });
                        }), this.ready = Promise.all(this.images.map(this.getPromise, this)), o("Finished searching images"), this;
                    }, d.prototype.timeout = function(n, r) {
                        var i, t = Promise.race([
                            n.promise,
                            new Promise(function(t, e) {
                                i = setTimeout(function() {
                                    o("Timed out loading image", n), e(n);
                                }, r);
                            })
                        ]).then(function(t) {
                            return clearTimeout(i), t;
                        });
                        return t.catch(function() {
                            clearTimeout(i);
                        }), t;
                    }, e.exports = d;
                },
                {
                    "./dummyimagecontainer": 5,
                    "./framecontainer": 8,
                    "./imagecontainer": 10,
                    "./lineargradientcontainer": 12,
                    "./log": 13,
                    "./proxyimagecontainer": 17,
                    "./svgcontainer": 23,
                    "./svgnodecontainer": 24,
                    "./utils": 26,
                    "./webkitgradientcontainer": 27
                }
            ],
            12: [
                function(t, e, n) {
                    var i = t("./gradientcontainer"), o = t("./color");
                    function r(t) {
                        i.apply(this, arguments), this.type = i.TYPES.LINEAR;
                        var e = r.REGEXP_DIRECTION.test(t.args[0]) || !i.REGEXP_COLORSTOP.test(t.args[0]);
                        e ? t.args[0].split(/\s+/).reverse().forEach(function(t, e) {
                            switch(t){
                                case "left":
                                    this.x0 = 0, this.x1 = 1;
                                    break;
                                case "top":
                                    this.y0 = 0, this.y1 = 1;
                                    break;
                                case "right":
                                    this.x0 = 1, this.x1 = 0;
                                    break;
                                case "bottom":
                                    this.y0 = 1, this.y1 = 0;
                                    break;
                                case "to":
                                    var n = this.y0, r = this.x0;
                                    this.y0 = this.y1, this.x0 = this.x1, this.x1 = r, this.y1 = n;
                                    break;
                                case "center":
                                    break;
                                default:
                                    var i = .01 * parseFloat(t, 10);
                                    if (isNaN(i)) break;
                                    0 === e ? (this.y0 = i, this.y1 = 1 - this.y0) : (this.x0 = i, this.x1 = 1 - this.x0);
                            }
                        }, this) : (this.y0 = 0, this.y1 = 1), this.colorStops = t.args.slice(e ? 1 : 0).map(function(t) {
                            var e = t.match(i.REGEXP_COLORSTOP), n = +e[2], r = 0 === n ? "%" : e[3];
                            return {
                                color: new o(e[1]),
                                stop: "%" === r ? n / 100 : null
                            };
                        }), null === this.colorStops[0].stop && (this.colorStops[0].stop = 0), null === this.colorStops[this.colorStops.length - 1].stop && (this.colorStops[this.colorStops.length - 1].stop = 1), this.colorStops.forEach(function(n, r) {
                            null === n.stop && this.colorStops.slice(r).some(function(t, e) {
                                return null !== t.stop && (n.stop = (t.stop - this.colorStops[r - 1].stop) / (e + 1) + this.colorStops[r - 1].stop, !0);
                            }, this);
                        }, this);
                    }
                    r.prototype = Object.create(i.prototype), r.REGEXP_DIRECTION = /^\s*(?:to|left|right|top|bottom|center|\d{1,3}(?:\.\d+)?%?)(?:\s|$)/i, e.exports = r;
                },
                {
                    "./color": 3,
                    "./gradientcontainer": 9
                }
            ],
            13: [
                function(t, e, n) {
                    var r = function() {
                        r.options.logging && window.console && window.console.log && Function.prototype.bind.call(window.console.log, window.console).apply(window.console, [
                            Date.now() - r.options.start + "ms",
                            "html2canvas:"
                        ].concat([].slice.call(arguments, 0)));
                    };
                    r.options = {
                        logging: !1
                    }, e.exports = r;
                },
                {}
            ],
            14: [
                function(t, e, n) {
                    var o = t("./color"), r = t("./utils"), i = r.getBounds, a = r.parseBackgrounds, s = r.offsetBounds;
                    function h(t, e) {
                        this.node = t, this.parent = e, this.stack = null, this.bounds = null, this.borders = null, this.clip = [], this.backgroundClip = [], this.offsetBounds = null, this.visible = null, this.computedStyles = null, this.colors = {}, this.styles = {}, this.backgroundImages = null, this.transformData = null, this.transformMatrix = null, this.isPseudoElement = !1, this.opacity = null;
                    }
                    function c(t) {
                        return -1 !== t.toString().indexOf("%");
                    }
                    function l(t) {
                        return t.replace("px", "");
                    }
                    function u(t) {
                        return parseFloat(t);
                    }
                    h.prototype.cloneTo = function(t) {
                        t.visible = this.visible, t.borders = this.borders, t.bounds = this.bounds, t.clip = this.clip, t.backgroundClip = this.backgroundClip, t.computedStyles = this.computedStyles, t.styles = this.styles, t.backgroundImages = this.backgroundImages, t.opacity = this.opacity;
                    }, h.prototype.getOpacity = function() {
                        return null === this.opacity ? this.opacity = this.cssFloat("opacity") : this.opacity;
                    }, h.prototype.assignStack = function(t) {
                        (this.stack = t).children.push(this);
                    }, h.prototype.isElementVisible = function() {
                        return this.node.nodeType === Node.TEXT_NODE ? this.parent.visible : "none" !== this.css("display") && "hidden" !== this.css("visibility") && !this.node.hasAttribute("data-html2canvas-ignore") && ("INPUT" !== this.node.nodeName || "hidden" !== this.node.getAttribute("type"));
                    }, h.prototype.css = function(t) {
                        return this.computedStyles || (this.computedStyles = this.isPseudoElement ? this.parent.computedStyle(this.before ? ":before" : ":after") : this.computedStyle(null)), this.styles[t] || (this.styles[t] = this.computedStyles[t]);
                    }, h.prototype.prefixedCss = function(e) {
                        var n = this.css(e);
                        return void 0 === n && [
                            "webkit",
                            "moz",
                            "ms",
                            "o"
                        ].some(function(t) {
                            return void 0 !== (n = this.css(t + e.substr(0, 1).toUpperCase() + e.substr(1)));
                        }, this), void 0 === n ? null : n;
                    }, h.prototype.computedStyle = function(t) {
                        return this.node.ownerDocument.defaultView.getComputedStyle(this.node, t);
                    }, h.prototype.cssInt = function(t) {
                        var e = parseInt(this.css(t), 10);
                        return isNaN(e) ? 0 : e;
                    }, h.prototype.color = function(t) {
                        return this.colors[t] || (this.colors[t] = new o(this.css(t)));
                    }, h.prototype.cssFloat = function(t) {
                        var e = parseFloat(this.css(t));
                        return isNaN(e) ? 0 : e;
                    }, h.prototype.fontWeight = function() {
                        var t = this.css("fontWeight");
                        switch(parseInt(t, 10)){
                            case 401:
                                t = "bold";
                                break;
                            case 400:
                                t = "normal";
                        }
                        return t;
                    }, h.prototype.parseClip = function() {
                        var t = this.css("clip").match(this.CLIP);
                        return t ? {
                            top: parseInt(t[1], 10),
                            right: parseInt(t[2], 10),
                            bottom: parseInt(t[3], 10),
                            left: parseInt(t[4], 10)
                        } : null;
                    }, h.prototype.parseBackgroundImages = function() {
                        return this.backgroundImages || (this.backgroundImages = a(this.css("backgroundImage")));
                    }, h.prototype.cssList = function(t, e) {
                        var n = (this.css(t) || "").split(",");
                        return 1 === (n = (n = n[e || 0] || n[0] || "auto").trim().split(" ")).length && (n = [
                            n[0],
                            c(n[0]) ? "auto" : n[0]
                        ]), n;
                    }, h.prototype.parseBackgroundSize = function(t, e, n) {
                        var r, i, o = this.cssList("backgroundSize", n);
                        if (c(o[0])) r = t.width * parseFloat(o[0]) / 100;
                        else {
                            if (/contain|cover/.test(o[0])) {
                                var a = t.width / t.height, s = e.width / e.height;
                                return a < s ^ "contain" === o[0] ? {
                                    width: t.height * s,
                                    height: t.height
                                } : {
                                    width: t.width,
                                    height: t.width / s
                                };
                            }
                            r = parseInt(o[0], 10);
                        }
                        return i = "auto" === o[0] && "auto" === o[1] ? e.height : "auto" === o[1] ? r / e.width * e.height : c(o[1]) ? t.height * parseFloat(o[1]) / 100 : parseInt(o[1], 10), "auto" === o[0] && (r = i / e.height * e.width), {
                            width: r,
                            height: i
                        };
                    }, h.prototype.parseBackgroundPosition = function(t, e, n, r) {
                        var i, o, a = this.cssList("backgroundPosition", n);
                        return i = c(a[0]) ? (t.width - (r || e).width) * (parseFloat(a[0]) / 100) : parseInt(a[0], 10), o = "auto" === a[1] ? i / e.width * e.height : c(a[1]) ? (t.height - (r || e).height) * parseFloat(a[1]) / 100 : parseInt(a[1], 10), "auto" === a[0] && (i = o / e.height * e.width), {
                            left: i,
                            top: o
                        };
                    }, h.prototype.parseBackgroundRepeat = function(t) {
                        return this.cssList("backgroundRepeat", t)[0];
                    }, h.prototype.parseTextShadows = function() {
                        var t = this.css("textShadow"), e = [];
                        if (t && "none" !== t) for(var n = t.match(this.TEXT_SHADOW_PROPERTY), r = 0; n && r < n.length; r++){
                            var i = n[r].match(this.TEXT_SHADOW_VALUES);
                            e.push({
                                color: new o(i[0]),
                                offsetX: i[1] ? parseFloat(i[1].replace("px", "")) : 0,
                                offsetY: i[2] ? parseFloat(i[2].replace("px", "")) : 0,
                                blur: i[3] ? i[3].replace("px", "") : 0
                            });
                        }
                        return e;
                    }, h.prototype.parseTransform = function() {
                        if (!this.transformData) {
                            if (this.hasTransform()) {
                                var t = this.parseBounds(), e = this.prefixedCss("transformOrigin").split(" ").map(l).map(u);
                                e[0] += t.left, e[1] += t.top, this.transformData = {
                                    origin: e,
                                    matrix: this.parseTransformMatrix()
                                };
                            } else this.transformData = {
                                origin: [
                                    0,
                                    0
                                ],
                                matrix: [
                                    1,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0
                                ]
                            };
                        }
                        return this.transformData;
                    }, h.prototype.parseTransformMatrix = function() {
                        if (!this.transformMatrix) {
                            var t = this.prefixedCss("transform"), e = t ? function(t) {
                                if (t && "matrix" === t[1]) return t[2].split(",").map(function(t) {
                                    return parseFloat(t.trim());
                                });
                                if (t && "matrix3d" === t[1]) {
                                    var e = t[2].split(",").map(function(t) {
                                        return parseFloat(t.trim());
                                    });
                                    return [
                                        e[0],
                                        e[1],
                                        e[4],
                                        e[5],
                                        e[12],
                                        e[13]
                                    ];
                                }
                            }(t.match(this.MATRIX_PROPERTY)) : null;
                            this.transformMatrix = e || [
                                1,
                                0,
                                0,
                                1,
                                0,
                                0
                            ];
                        }
                        return this.transformMatrix;
                    }, h.prototype.parseBounds = function() {
                        return this.bounds || (this.bounds = this.hasTransform() ? s(this.node) : i(this.node));
                    }, h.prototype.hasTransform = function() {
                        return "1,0,0,1,0,0" !== this.parseTransformMatrix().join(",") || this.parent && this.parent.hasTransform();
                    }, h.prototype.getValue = function() {
                        var t, e, n = this.node.value || "";
                        return "SELECT" === this.node.tagName ? (t = this.node, n = (e = t.options[t.selectedIndex || 0]) && e.text || "") : "password" === this.node.type && (n = Array(n.length + 1).join("•")), 0 === n.length ? this.node.placeholder || "" : n;
                    }, h.prototype.MATRIX_PROPERTY = /(matrix|matrix3d)\((.+)\)/, h.prototype.TEXT_SHADOW_PROPERTY = /((rgba|rgb)\([^\)]+\)(\s-?\d+px){0,})/g, h.prototype.TEXT_SHADOW_VALUES = /(-?\d+px)|(#.+)|(rgb\(.+\))|(rgba\(.+\))/g, h.prototype.CLIP = /^rect\((\d+)px,? (\d+)px,? (\d+)px,? (\d+)px\)$/, e.exports = h;
                },
                {
                    "./color": 3,
                    "./utils": 26
                }
            ],
            15: [
                function(t, e, n) {
                    var s = t("./log"), h = t("punycode"), c = t("./nodecontainer"), f = t("./textcontainer"), d = t("./pseudoelementcontainer"), l = t("./fontmetrics"), u = t("./color"), p = t("./stackingcontext"), r = t("./utils"), g = r.bind, a = r.getBounds, m = r.parseBackgrounds, w = r.offsetBounds;
                    function i(t, e, n, r, i) {
                        s("Starting NodeParser"), this.renderer = e, this.options = i, this.range = null, this.support = n, this.renderQueue = [], this.stack = new p(!0, 1, t.ownerDocument, null);
                        var o = new c(t, null);
                        if (i.background && e.rectangle(0, 0, e.width, e.height, new u(i.background)), t === t.ownerDocument.documentElement) {
                            var a = new c(o.color("backgroundColor").isTransparent() ? t.ownerDocument.body : t.ownerDocument.documentElement, null);
                            e.rectangle(0, 0, e.width, e.height, a.color("backgroundColor"));
                        }
                        o.visibile = o.isElementVisible(), this.createPseudoHideStyles(t.ownerDocument), this.disableAnimations(t.ownerDocument), this.nodes = L([
                            o
                        ].concat(this.getChildren(o)).filter(function(t) {
                            return t.visible = t.isElementVisible();
                        }).map(this.getPseudoElements, this)), this.fontMetrics = new l, s("Fetched nodes, total:", this.nodes.length), s("Calculate overflow clips"), this.calculateOverflowClips(), s("Start fetching images"), this.images = r.fetch(this.nodes.filter(j)), this.ready = this.images.ready.then(g(function() {
                            return s("Images loaded, starting parsing"), s("Creating stacking contexts"), this.createStackingContexts(), s("Sorting stacking contexts"), this.sortStackingContexts(this.stack), this.parse(this.stack), s("Render queue created with " + this.renderQueue.length + " items"), new Promise(g(function(t) {
                                i.async ? "function" == typeof i.async ? i.async.call(this, this.renderQueue, t) : 0 < this.renderQueue.length ? (this.renderIndex = 0, this.asyncRenderer(this.renderQueue, t)) : t() : (this.renderQueue.forEach(this.paint, this), t());
                            }, this));
                        }, this));
                    }
                    function o(t) {
                        return t.parent && t.parent.clip.length;
                    }
                    function y() {}
                    i.prototype.calculateOverflowClips = function() {
                        this.nodes.forEach(function(t) {
                            if (j(t)) {
                                D(t) && t.appendToDOM(), t.borders = this.parseBorders(t);
                                var e = "hidden" === t.css("overflow") ? [
                                    t.borders.clip
                                ] : [], n = t.parseClip();
                                n && -1 !== [
                                    "absolute",
                                    "fixed"
                                ].indexOf(t.css("position")) && e.push([
                                    [
                                        "rect",
                                        t.bounds.left + n.left,
                                        t.bounds.top + n.top,
                                        n.right - n.left,
                                        n.bottom - n.top
                                    ]
                                ]), t.clip = o(t) ? t.parent.clip.concat(e) : e, t.backgroundClip = "hidden" !== t.css("overflow") ? t.clip.concat([
                                    t.borders.clip
                                ]) : t.clip, D(t) && t.cleanDOM();
                            } else M(t) && (t.clip = o(t) ? t.parent.clip : []);
                            D(t) || (t.bounds = null);
                        }, this);
                    }, i.prototype.asyncRenderer = function(t, e, n) {
                        n = n || Date.now(), this.paint(t[this.renderIndex++]), t.length === this.renderIndex ? e() : n + 20 > Date.now() ? this.asyncRenderer(t, e, n) : setTimeout(g(function() {
                            this.asyncRenderer(t, e);
                        }, this), 0);
                    }, i.prototype.createPseudoHideStyles = function(t) {
                        this.createStyles(t, "." + d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + ':before { content: "" !important; display: none !important; }.' + d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER + ':after { content: "" !important; display: none !important; }');
                    }, i.prototype.disableAnimations = function(t) {
                        this.createStyles(t, "* { -webkit-animation: none !important; -moz-animation: none !important; -o-animation: none !important; animation: none !important; -webkit-transition: none !important; -moz-transition: none !important; -o-transition: none !important; transition: none !important;}");
                    }, i.prototype.createStyles = function(t, e) {
                        var n = t.createElement("style");
                        n.innerHTML = e, t.body.appendChild(n);
                    }, i.prototype.getPseudoElements = function(t) {
                        var e = [
                            [
                                t
                            ]
                        ];
                        if (t.node.nodeType === Node.ELEMENT_NODE) {
                            var n = this.getPseudoElement(t, ":before"), r = this.getPseudoElement(t, ":after");
                            n && e.push(n), r && e.push(r);
                        }
                        return L(e);
                    }, i.prototype.getPseudoElement = function(t, e) {
                        var n = t.computedStyle(e);
                        if (!n || !n.content || "none" === n.content || "-moz-alt-content" === n.content || "none" === n.display) return null;
                        for(var r, i, o = (r = n.content, (i = r.substr(0, 1)) === r.substr(r.length - 1) && i.match(/'|"/) ? r.substr(1, r.length - 2) : r), a = "url" === o.substr(0, 3), s = document.createElement(a ? "img" : "html2canvaspseudoelement"), h = new d(s, t, e), c = n.length - 1; 0 <= c; c--){
                            var l = n.item(c).replace(/(\-[a-z])/g, function(t) {
                                return t.toUpperCase().replace("-", "");
                            });
                            s.style[l] = n[l];
                        }
                        if (s.className = d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER, a) return s.src = m(o)[0].args[0], [
                            h
                        ];
                        var u = document.createTextNode(o);
                        return s.appendChild(u), [
                            h,
                            new f(u, h)
                        ];
                    }, i.prototype.getChildren = function(n) {
                        return L([].filter.call(n.node.childNodes, q).map(function(t) {
                            var e = [
                                t.nodeType === Node.TEXT_NODE ? new f(t, n) : new c(t, n)
                            ].filter(z);
                            return t.nodeType === Node.ELEMENT_NODE && e.length && "TEXTAREA" !== t.tagName ? e[0].isElementVisible() ? e.concat(this.getChildren(e[0])) : [] : e;
                        }, this));
                    }, i.prototype.newStackingContext = function(t, e) {
                        var n = new p(e, t.getOpacity(), t.node, t.parent);
                        t.cloneTo(n), (e ? n.getParentStack(this) : n.parent.stack).contexts.push(n), t.stack = n;
                    }, i.prototype.createStackingContexts = function() {
                        this.nodes.forEach(function(t) {
                            var e, n;
                            j(t) && (this.isRootElement(t) || t.getOpacity() < 1 || (n = (e = t).css("position"), "auto" !== (-1 !== [
                                "absolute",
                                "relative",
                                "fixed"
                            ].indexOf(n) ? e.css("zIndex") : "auto")) || this.isBodyWithTransparentRoot(t) || t.hasTransform()) ? this.newStackingContext(t, !0) : j(t) && (O(t) && T(t) || -1 !== [
                                "inline-block",
                                "inline-table"
                            ].indexOf(t.css("display")) || B(t)) ? this.newStackingContext(t, !1) : t.assignStack(t.parent.stack);
                        }, this);
                    }, i.prototype.isBodyWithTransparentRoot = function(t) {
                        return "BODY" === t.node.nodeName && t.parent.color("backgroundColor").isTransparent();
                    }, i.prototype.isRootElement = function(t) {
                        return null === t.parent;
                    }, i.prototype.sortStackingContexts = function(t) {
                        var n;
                        t.contexts.sort((n = t.contexts.slice(0), function(t, e) {
                            return t.cssInt("zIndex") + n.indexOf(t) / n.length - (e.cssInt("zIndex") + n.indexOf(e) / n.length);
                        })), t.contexts.forEach(this.sortStackingContexts, this);
                    }, i.prototype.parseTextBounds = function(a) {
                        return function(t, e, n) {
                            if ("none" !== a.parent.css("textDecoration").substr(0, 4) || 0 !== t.trim().length) {
                                if (this.support.rangeBounds && !a.parent.hasTransform()) {
                                    var r = n.slice(0, e).join("").length;
                                    return this.getRangeBounds(a.node, r, t.length);
                                }
                                if (a.node && "string" == typeof a.node.data) {
                                    var i = a.node.splitText(t.length), o = this.getWrapperBounds(a.node, a.parent.hasTransform());
                                    return a.node = i, o;
                                }
                            } else this.support.rangeBounds && !a.parent.hasTransform() || (a.node = a.node.splitText(t.length));
                            return {};
                        };
                    }, i.prototype.getWrapperBounds = function(t, e) {
                        var n = t.ownerDocument.createElement("html2canvaswrapper"), r = t.parentNode, i = t.cloneNode(!0);
                        n.appendChild(t.cloneNode(!0)), r.replaceChild(n, t);
                        var o = e ? w(n) : a(n);
                        return r.replaceChild(i, n), o;
                    }, i.prototype.getRangeBounds = function(t, e, n) {
                        var r = this.range || (this.range = t.ownerDocument.createRange());
                        return r.setStart(t, e), r.setEnd(t, e + n), r.getBoundingClientRect();
                    }, i.prototype.parse = function(t) {
                        var e = t.contexts.filter(I), n = t.children.filter(j), r = n.filter(R(B)), i = r.filter(R(O)).filter(R(F)), o = n.filter(R(O)).filter(B), a = r.filter(R(O)).filter(F), s = t.contexts.concat(r.filter(O)).filter(T), h = t.children.filter(M).filter(E), c = t.contexts.filter(C);
                        e.concat(i).concat(o).concat(a).concat(s).concat(h).concat(c).forEach(function(t) {
                            this.renderQueue.push(t), P(t) && (this.parse(t), this.renderQueue.push(new y));
                        }, this);
                    }, i.prototype.paint = function(t) {
                        try {
                            t instanceof y ? this.renderer.ctx.restore() : M(t) ? (D(t.parent) && t.parent.appendToDOM(), this.paintText(t), D(t.parent) && t.parent.cleanDOM()) : this.paintNode(t);
                        } catch (t) {
                            if (s(t), this.options.strict) throw t;
                        }
                    }, i.prototype.paintNode = function(t) {
                        P(t) && (this.renderer.setOpacity(t.opacity), this.renderer.ctx.save(), t.hasTransform() && this.renderer.setTransform(t.parseTransform())), "INPUT" === t.node.nodeName && "checkbox" === t.node.type ? this.paintCheckbox(t) : "INPUT" === t.node.nodeName && "radio" === t.node.type ? this.paintRadio(t) : this.paintElement(t);
                    }, i.prototype.paintElement = function(n) {
                        var r = n.parseBounds();
                        this.renderer.clip(n.backgroundClip, function() {
                            this.renderer.renderBackground(n, r, n.borders.borders.map(N));
                        }, this), this.renderer.clip(n.clip, function() {
                            this.renderer.renderBorders(n.borders.borders);
                        }, this), this.renderer.clip(n.backgroundClip, function() {
                            switch(n.node.nodeName){
                                case "svg":
                                case "IFRAME":
                                    var t = this.images.get(n.node);
                                    t ? this.renderer.renderImage(n, r, n.borders, t) : s("Error loading <" + n.node.nodeName + ">", n.node);
                                    break;
                                case "IMG":
                                    var e = this.images.get(n.node.src);
                                    e ? this.renderer.renderImage(n, r, n.borders, e) : s("Error loading <img>", n.node.src);
                                    break;
                                case "CANVAS":
                                    this.renderer.renderImage(n, r, n.borders, {
                                        image: n.node
                                    });
                                    break;
                                case "SELECT":
                                case "INPUT":
                                case "TEXTAREA":
                                    this.paintFormValue(n);
                            }
                        }, this);
                    }, i.prototype.paintCheckbox = function(t) {
                        var e = t.parseBounds(), n = Math.min(e.width, e.height), r = {
                            width: n - 1,
                            height: n - 1,
                            top: e.top,
                            left: e.left
                        }, i = [
                            3,
                            3
                        ], o = [
                            i,
                            i,
                            i,
                            i
                        ], a = [
                            1,
                            1,
                            1,
                            1
                        ].map(function(t) {
                            return {
                                color: new u("#A5A5A5"),
                                width: t
                            };
                        }), s = S(r, o, a);
                        this.renderer.clip(t.backgroundClip, function() {
                            this.renderer.rectangle(r.left + 1, r.top + 1, r.width - 2, r.height - 2, new u("#DEDEDE")), this.renderer.renderBorders(b(a, r, s, o)), t.node.checked && (this.renderer.font(new u("#424242"), "normal", "normal", "bold", n - 3 + "px", "arial"), this.renderer.text("✔", r.left + n / 6, r.top + n - 1));
                        }, this);
                    }, i.prototype.paintRadio = function(t) {
                        var e = t.parseBounds(), n = Math.min(e.width, e.height) - 2;
                        this.renderer.clip(t.backgroundClip, function() {
                            this.renderer.circleStroke(e.left + 1, e.top + 1, n, new u("#DEDEDE"), 1, new u("#A5A5A5")), t.node.checked && this.renderer.circle(Math.ceil(e.left + n / 4) + 1, Math.ceil(e.top + n / 4) + 1, Math.floor(n / 2), new u("#424242"));
                        }, this);
                    }, i.prototype.paintFormValue = function(e) {
                        var t = e.getValue();
                        if (0 < t.length) {
                            var n = e.node.ownerDocument, r = n.createElement("html2canvaswrapper");
                            [
                                "lineHeight",
                                "textAlign",
                                "fontFamily",
                                "fontWeight",
                                "fontSize",
                                "color",
                                "paddingLeft",
                                "paddingTop",
                                "paddingRight",
                                "paddingBottom",
                                "width",
                                "height",
                                "borderLeftStyle",
                                "borderTopStyle",
                                "borderLeftWidth",
                                "borderTopWidth",
                                "boxSizing",
                                "whiteSpace",
                                "wordWrap"
                            ].forEach(function(t) {
                                try {
                                    r.style[t] = e.css(t);
                                } catch (t) {
                                    s("html2canvas: Parse: Exception caught in renderFormValue: " + t.message);
                                }
                            });
                            var i = e.parseBounds();
                            r.style.position = "fixed", r.style.left = i.left + "px", r.style.top = i.top + "px", r.textContent = t, n.body.appendChild(r), this.paintText(new f(r.firstChild, e)), n.body.removeChild(r);
                        }
                    }, i.prototype.paintText = function(n) {
                        n.applyTextTransform();
                        var t, e = h.ucs2.decode(n.node.data), r = this.options.letterRendering && !/^(normal|none|0px)$/.test(n.parent.css("letterSpacing")) || (t = n.node.data, /[^\u0000-\u00ff]/.test(t)) ? e.map(function(t) {
                            return h.ucs2.encode([
                                t
                            ]);
                        }) : function(t) {
                            var e, n = [], r = 0, i = !1;
                            for(; t.length;)o = t[r], -1 !== [
                                32,
                                13,
                                10,
                                9,
                                45
                            ].indexOf(o) === i ? ((e = t.splice(0, r)).length && n.push(h.ucs2.encode(e)), i = !i, r = 0) : r++, r >= t.length && (e = t.splice(0, r)).length && n.push(h.ucs2.encode(e));
                            var o;
                            return n;
                        }(e), i = n.parent.fontWeight(), o = n.parent.css("fontSize"), a = n.parent.css("fontFamily"), s = n.parent.parseTextShadows();
                        this.renderer.font(n.parent.color("color"), n.parent.css("fontStyle"), n.parent.css("fontVariant"), i, o, a), s.length ? this.renderer.fontShadow(s[0].color, s[0].offsetX, s[0].offsetY, s[0].blur) : this.renderer.clearShadow(), this.renderer.clip(n.parent.clip, function() {
                            r.map(this.parseTextBounds(n), this).forEach(function(t, e) {
                                t && !1 === /^\s*$/.test(r[e]) && (this.renderer.text(r[e], t.left, t.bottom), this.renderTextDecoration(n.parent, t, this.fontMetrics.getMetrics(a, o)));
                            }, this);
                        }, this);
                    }, i.prototype.renderTextDecoration = function(t, e, n) {
                        switch(t.css("textDecoration").split(" ")[0]){
                            case "underline":
                                this.renderer.rectangle(e.left, Math.round(e.top + n.baseline + n.lineWidth), e.width, 1, t.color("color"));
                                break;
                            case "overline":
                                this.renderer.rectangle(e.left, Math.round(e.top), e.width, 1, t.color("color"));
                                break;
                            case "line-through":
                                this.renderer.rectangle(e.left, Math.ceil(e.top + n.middle + n.lineWidth), e.width, 1, t.color("color"));
                        }
                    };
                    var v = {
                        inset: [
                            [
                                "darken",
                                .6
                            ],
                            [
                                "darken",
                                .1
                            ],
                            [
                                "darken",
                                .1
                            ],
                            [
                                "darken",
                                .6
                            ]
                        ]
                    };
                    function b(a, s, h, c) {
                        return a.map(function(t, e) {
                            if (0 < t.width) {
                                var n = s.left, r = s.top, i = s.width, o = s.height - a[2].width;
                                switch(e){
                                    case 0:
                                        o = a[0].width, t.args = _({
                                            c1: [
                                                n,
                                                r
                                            ],
                                            c2: [
                                                n + i,
                                                r
                                            ],
                                            c3: [
                                                n + i - a[1].width,
                                                r + o
                                            ],
                                            c4: [
                                                n + a[3].width,
                                                r + o
                                            ]
                                        }, c[0], c[1], h.topLeftOuter, h.topLeftInner, h.topRightOuter, h.topRightInner);
                                        break;
                                    case 1:
                                        n = s.left + s.width - a[1].width, i = a[1].width, t.args = _({
                                            c1: [
                                                n + i,
                                                r
                                            ],
                                            c2: [
                                                n + i,
                                                r + o + a[2].width
                                            ],
                                            c3: [
                                                n,
                                                r + o
                                            ],
                                            c4: [
                                                n,
                                                r + a[0].width
                                            ]
                                        }, c[1], c[2], h.topRightOuter, h.topRightInner, h.bottomRightOuter, h.bottomRightInner);
                                        break;
                                    case 2:
                                        r = r + s.height - a[2].width, o = a[2].width, t.args = _({
                                            c1: [
                                                n + i,
                                                r + o
                                            ],
                                            c2: [
                                                n,
                                                r + o
                                            ],
                                            c3: [
                                                n + a[3].width,
                                                r
                                            ],
                                            c4: [
                                                n + i - a[3].width,
                                                r
                                            ]
                                        }, c[2], c[3], h.bottomRightOuter, h.bottomRightInner, h.bottomLeftOuter, h.bottomLeftInner);
                                        break;
                                    case 3:
                                        i = a[3].width, t.args = _({
                                            c1: [
                                                n,
                                                r + o + a[2].width
                                            ],
                                            c2: [
                                                n,
                                                r
                                            ],
                                            c3: [
                                                n + i,
                                                r + a[0].width
                                            ],
                                            c4: [
                                                n + i,
                                                r + o
                                            ]
                                        }, c[3], c[0], h.bottomLeftOuter, h.bottomLeftInner, h.topLeftOuter, h.topLeftInner);
                                }
                            }
                            return t;
                        });
                    }
                    function x(t, e, n, r) {
                        var i = (Math.sqrt(2) - 1) / 3 * 4, o = n * i, a = r * i, s = t + n, h = e + r;
                        return {
                            topLeft: k({
                                x: t,
                                y: h
                            }, {
                                x: t,
                                y: h - a
                            }, {
                                x: s - o,
                                y: e
                            }, {
                                x: s,
                                y: e
                            }),
                            topRight: k({
                                x: t,
                                y: e
                            }, {
                                x: t + o,
                                y: e
                            }, {
                                x: s,
                                y: h - a
                            }, {
                                x: s,
                                y: h
                            }),
                            bottomRight: k({
                                x: s,
                                y: e
                            }, {
                                x: s,
                                y: e + a
                            }, {
                                x: t + o,
                                y: h
                            }, {
                                x: t,
                                y: h
                            }),
                            bottomLeft: k({
                                x: s,
                                y: h
                            }, {
                                x: s - o,
                                y: h
                            }, {
                                x: t,
                                y: e + a
                            }, {
                                x: t,
                                y: e
                            })
                        };
                    }
                    function S(t, e, n) {
                        var r = t.left, i = t.top, o = t.width, a = t.height, s = e[0][0] < o / 2 ? e[0][0] : o / 2, h = e[0][1] < a / 2 ? e[0][1] : a / 2, c = e[1][0] < o / 2 ? e[1][0] : o / 2, l = e[1][1] < a / 2 ? e[1][1] : a / 2, u = e[2][0] < o / 2 ? e[2][0] : o / 2, f = e[2][1] < a / 2 ? e[2][1] : a / 2, d = e[3][0] < o / 2 ? e[3][0] : o / 2, p = e[3][1] < a / 2 ? e[3][1] : a / 2, g = o - c, m = a - f, w = o - u, y = a - p;
                        return {
                            topLeftOuter: x(r, i, s, h).topLeft.subdivide(.5),
                            topLeftInner: x(r + n[3].width, i + n[0].width, Math.max(0, s - n[3].width), Math.max(0, h - n[0].width)).topLeft.subdivide(.5),
                            topRightOuter: x(r + g, i, c, l).topRight.subdivide(.5),
                            topRightInner: x(r + Math.min(g, o + n[3].width), i + n[0].width, g > o + n[3].width ? 0 : c - n[3].width, l - n[0].width).topRight.subdivide(.5),
                            bottomRightOuter: x(r + w, i + m, u, f).bottomRight.subdivide(.5),
                            bottomRightInner: x(r + Math.min(w, o - n[3].width), i + Math.min(m, a + n[0].width), Math.max(0, u - n[1].width), f - n[2].width).bottomRight.subdivide(.5),
                            bottomLeftOuter: x(r, i + y, d, p).bottomLeft.subdivide(.5),
                            bottomLeftInner: x(r + n[3].width, i + y, Math.max(0, d - n[3].width), p - n[2].width).bottomLeft.subdivide(.5)
                        };
                    }
                    function k(s, h, c, l) {
                        var u = function(t, e, n) {
                            return {
                                x: t.x + (e.x - t.x) * n,
                                y: t.y + (e.y - t.y) * n
                            };
                        };
                        return {
                            start: s,
                            startControl: h,
                            endControl: c,
                            end: l,
                            subdivide: function(t) {
                                var e = u(s, h, t), n = u(h, c, t), r = u(c, l, t), i = u(e, n, t), o = u(n, r, t), a = u(i, o, t);
                                return [
                                    k(s, e, i, a),
                                    k(a, o, r, l)
                                ];
                            },
                            curveTo: function(t) {
                                t.push([
                                    "bezierCurve",
                                    h.x,
                                    h.y,
                                    c.x,
                                    c.y,
                                    l.x,
                                    l.y
                                ]);
                            },
                            curveToReversed: function(t) {
                                t.push([
                                    "bezierCurve",
                                    c.x,
                                    c.y,
                                    h.x,
                                    h.y,
                                    s.x,
                                    s.y
                                ]);
                            }
                        };
                    }
                    function _(t, e, n, r, i, o, a) {
                        var s = [];
                        return 0 < e[0] || 0 < e[1] ? (s.push([
                            "line",
                            r[1].start.x,
                            r[1].start.y
                        ]), r[1].curveTo(s)) : s.push([
                            "line",
                            t.c1[0],
                            t.c1[1]
                        ]), 0 < n[0] || 0 < n[1] ? (s.push([
                            "line",
                            o[0].start.x,
                            o[0].start.y
                        ]), o[0].curveTo(s), s.push([
                            "line",
                            a[0].end.x,
                            a[0].end.y
                        ]), a[0].curveToReversed(s)) : (s.push([
                            "line",
                            t.c2[0],
                            t.c2[1]
                        ]), s.push([
                            "line",
                            t.c3[0],
                            t.c3[1]
                        ])), 0 < e[0] || 0 < e[1] ? (s.push([
                            "line",
                            i[1].end.x,
                            i[1].end.y
                        ]), i[1].curveToReversed(s)) : s.push([
                            "line",
                            t.c4[0],
                            t.c4[1]
                        ]), s;
                    }
                    function A(t, e, n, r, i, o, a) {
                        0 < e[0] || 0 < e[1] ? (t.push([
                            "line",
                            r[0].start.x,
                            r[0].start.y
                        ]), r[0].curveTo(t), r[1].curveTo(t)) : t.push([
                            "line",
                            o,
                            a
                        ]), (0 < n[0] || 0 < n[1]) && t.push([
                            "line",
                            i[0].start.x,
                            i[0].start.y
                        ]);
                    }
                    function I(t) {
                        return t.cssInt("zIndex") < 0;
                    }
                    function C(t) {
                        return 0 < t.cssInt("zIndex");
                    }
                    function T(t) {
                        return 0 === t.cssInt("zIndex");
                    }
                    function F(t) {
                        return -1 !== [
                            "inline",
                            "inline-block",
                            "inline-table"
                        ].indexOf(t.css("display"));
                    }
                    function P(t) {
                        return t instanceof p;
                    }
                    function E(t) {
                        return 0 < t.node.data.trim().length;
                    }
                    function q(t) {
                        return t.nodeType === Node.TEXT_NODE || t.nodeType === Node.ELEMENT_NODE;
                    }
                    function O(t) {
                        return "static" !== t.css("position");
                    }
                    function B(t) {
                        return "none" !== t.css("float");
                    }
                    function R(t) {
                        var e = this;
                        return function() {
                            return !t.apply(e, arguments);
                        };
                    }
                    function j(t) {
                        return t.node.nodeType === Node.ELEMENT_NODE;
                    }
                    function D(t) {
                        return !0 === t.isPseudoElement;
                    }
                    function M(t) {
                        return t.node.nodeType === Node.TEXT_NODE;
                    }
                    function U(t) {
                        return parseInt(t, 10);
                    }
                    function N(t) {
                        return t.width;
                    }
                    function z(t) {
                        return t.node.nodeType !== Node.ELEMENT_NODE || -1 === [
                            "SCRIPT",
                            "HEAD",
                            "TITLE",
                            "OBJECT",
                            "BR",
                            "OPTION"
                        ].indexOf(t.node.nodeName);
                    }
                    function L(t) {
                        return [].concat.apply([], t);
                    }
                    i.prototype.parseBorders = function(o) {
                        var r, t = o.parseBounds(), e = (r = o, [
                            "TopLeft",
                            "TopRight",
                            "BottomRight",
                            "BottomLeft"
                        ].map(function(t) {
                            var e = r.css("border" + t + "Radius"), n = e.split(" ");
                            return n.length <= 1 && (n[1] = n[0]), n.map(U);
                        })), n = [
                            "Top",
                            "Right",
                            "Bottom",
                            "Left"
                        ].map(function(t, e) {
                            var n = o.css("border" + t + "Style"), r = o.color("border" + t + "Color");
                            "inset" === n && r.isBlack() && (r = new u([
                                255,
                                255,
                                255,
                                r.a
                            ]));
                            var i = v[n] ? v[n][e] : null;
                            return {
                                width: o.cssInt("border" + t + "Width"),
                                color: i ? r[i[0]](i[1]) : r,
                                args: null
                            };
                        }), i = S(t, e, n);
                        return {
                            clip: this.parseBackgroundClip(o, i, n, e, t),
                            borders: b(n, t, i, e)
                        };
                    }, i.prototype.parseBackgroundClip = function(t, e, n, r, i) {
                        var o = [];
                        switch(t.css("backgroundClip")){
                            case "content-box":
                            case "padding-box":
                                A(o, r[0], r[1], e.topLeftInner, e.topRightInner, i.left + n[3].width, i.top + n[0].width), A(o, r[1], r[2], e.topRightInner, e.bottomRightInner, i.left + i.width - n[1].width, i.top + n[0].width), A(o, r[2], r[3], e.bottomRightInner, e.bottomLeftInner, i.left + i.width - n[1].width, i.top + i.height - n[2].width), A(o, r[3], r[0], e.bottomLeftInner, e.topLeftInner, i.left + n[3].width, i.top + i.height - n[2].width);
                                break;
                            default:
                                A(o, r[0], r[1], e.topLeftOuter, e.topRightOuter, i.left, i.top), A(o, r[1], r[2], e.topRightOuter, e.bottomRightOuter, i.left + i.width, i.top), A(o, r[2], r[3], e.bottomRightOuter, e.bottomLeftOuter, i.left + i.width, i.top + i.height), A(o, r[3], r[0], e.bottomLeftOuter, e.topLeftOuter, i.left, i.top + i.height);
                        }
                        return o;
                    }, e.exports = i;
                },
                {
                    "./color": 3,
                    "./fontmetrics": 7,
                    "./log": 13,
                    "./nodecontainer": 14,
                    "./pseudoelementcontainer": 18,
                    "./stackingcontext": 21,
                    "./textcontainer": 25,
                    "./utils": 26,
                    punycode: 1
                }
            ],
            16: [
                function(t, e, n) {
                    var a = t("./xhr"), r = t("./utils"), s = t("./log"), h = t("./clone"), c = r.decode64;
                    function l(t, e, n) {
                        var r = "withCredentials" in new XMLHttpRequest;
                        if (!e) return Promise.reject("No proxy configured");
                        var i = f(r), o = d(e, t, i);
                        return r ? a(o) : u(n, o, i).then(function(t) {
                            return c(t.content);
                        });
                    }
                    var i = 0;
                    function u(i, o, a) {
                        return new Promise(function(e, n) {
                            var t = i.createElement("script"), r = function() {
                                delete window.html2canvas.proxy[a], i.body.removeChild(t);
                            };
                            window.html2canvas.proxy[a] = function(t) {
                                r(), e(t);
                            }, t.src = o, t.onerror = function(t) {
                                r(), n(t);
                            }, i.body.appendChild(t);
                        });
                    }
                    function f(t) {
                        return t ? "" : "html2canvas_" + Date.now() + "_" + ++i + "_" + Math.round(1e5 * Math.random());
                    }
                    function d(t, e, n) {
                        return t + "?url=" + encodeURIComponent(e) + (n.length ? "&callback=html2canvas.proxy." + n : "");
                    }
                    n.Proxy = l, n.ProxyURL = function(t, e, n) {
                        var r = "crossOrigin" in new Image, i = f(r), o = d(e, t, i);
                        return r ? Promise.resolve(o) : u(n, o, i).then(function(t) {
                            return "data:" + t.type + ";base64," + t.content;
                        });
                    }, n.loadUrlDocument = function(t, e, n, r, i, o) {
                        var a;
                        return new l(t, e, window.document).then((a = t, function(e) {
                            var n, t = new DOMParser;
                            try {
                                n = t.parseFromString(e, "text/html");
                            } catch (t) {
                                s("DOMParser not supported, falling back to createHTMLDocument"), n = document.implementation.createHTMLDocument("");
                                try {
                                    n.open(), n.write(e), n.close();
                                } catch (t) {
                                    s("createHTMLDocument write not supported, falling back to document.body.innerHTML"), n.body.innerHTML = e;
                                }
                            }
                            var r = n.querySelector("base");
                            if (!r || !r.href.host) {
                                var i = n.createElement("base");
                                i.href = a, n.head.insertBefore(i, n.head.firstChild);
                            }
                            return n;
                        })).then(function(t) {
                            return h(t, n, r, i, o, 0, 0);
                        });
                    };
                },
                {
                    "./clone": 2,
                    "./log": 13,
                    "./utils": 26,
                    "./xhr": 28
                }
            ],
            17: [
                function(t, e, n) {
                    var o = t("./proxy").ProxyURL;
                    e.exports = function(n, r) {
                        var t = document.createElement("a");
                        t.href = n, n = t.href, this.src = n, this.image = new Image;
                        var i = this;
                        this.promise = new Promise(function(t, e) {
                            i.image.crossOrigin = "Anonymous", i.image.onload = t, i.image.onerror = e, new o(n, r, document).then(function(t) {
                                i.image.src = t;
                            }).catch(e);
                        });
                    };
                },
                {
                    "./proxy": 16
                }
            ],
            18: [
                function(t, e, n) {
                    var r = t("./nodecontainer");
                    function i(t, e, n) {
                        r.call(this, t, e), this.isPseudoElement = !0, this.before = ":before" === n;
                    }
                    i.prototype.cloneTo = function(t) {
                        i.prototype.cloneTo.call(this, t), t.isPseudoElement = !0, t.before = this.before;
                    }, (i.prototype = Object.create(r.prototype)).appendToDOM = function() {
                        this.before ? this.parent.node.insertBefore(this.node, this.parent.node.firstChild) : this.parent.node.appendChild(this.node), this.parent.node.className += " " + this.getHideClass();
                    }, i.prototype.cleanDOM = function() {
                        this.node.parentNode.removeChild(this.node), this.parent.node.className = this.parent.node.className.replace(this.getHideClass(), "");
                    }, i.prototype.getHideClass = function() {
                        return this["PSEUDO_HIDE_ELEMENT_CLASS_" + (this.before ? "BEFORE" : "AFTER")];
                    }, i.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = "___html2canvas___pseudoelement_before", i.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER = "___html2canvas___pseudoelement_after", e.exports = i;
                },
                {
                    "./nodecontainer": 14
                }
            ],
            19: [
                function(t, e, n) {
                    var h = t("./log");
                    function r(t, e, n, r, i) {
                        this.width = t, this.height = e, this.images = n, this.options = r, this.document = i;
                    }
                    r.prototype.renderImage = function(t, e, n, r) {
                        var i = t.cssInt("paddingLeft"), o = t.cssInt("paddingTop"), a = t.cssInt("paddingRight"), s = t.cssInt("paddingBottom"), h = n.borders, c = e.width - (h[1].width + h[3].width + i + a), l = e.height - (h[0].width + h[2].width + o + s);
                        this.drawImage(r, 0, 0, r.image.width || c, r.image.height || l, e.left + i + h[3].width, e.top + o + h[0].width, c, l);
                    }, r.prototype.renderBackground = function(t, e, n) {
                        0 < e.height && 0 < e.width && (this.renderBackgroundColor(t, e), this.renderBackgroundImage(t, e, n));
                    }, r.prototype.renderBackgroundColor = function(t, e) {
                        var n = t.color("backgroundColor");
                        n.isTransparent() || this.rectangle(e.left, e.top, e.width, e.height, n);
                    }, r.prototype.renderBorders = function(t) {
                        t.forEach(this.renderBorder, this);
                    }, r.prototype.renderBorder = function(t) {
                        t.color.isTransparent() || null === t.args || this.drawShape(t.args, t.color);
                    }, r.prototype.renderBackgroundImage = function(o, a, s) {
                        o.parseBackgroundImages().reverse().forEach(function(t, e, n) {
                            switch(t.method){
                                case "url":
                                    var r = this.images.get(t.args[0]);
                                    r ? this.renderBackgroundRepeating(o, a, r, n.length - (e + 1), s) : h("Error loading background-image", t.args[0]);
                                    break;
                                case "linear-gradient":
                                case "gradient":
                                    var i = this.images.get(t.value);
                                    i ? this.renderBackgroundGradient(i, a, s) : h("Error loading background-image", t.args[0]);
                                    break;
                                case "none":
                                    break;
                                default:
                                    h("Unknown background-image type", t.args[0]);
                            }
                        }, this);
                    }, r.prototype.renderBackgroundRepeating = function(t, e, n, r, i) {
                        var o = t.parseBackgroundSize(e, n.image, r), a = t.parseBackgroundPosition(e, n.image, r, o);
                        switch(t.parseBackgroundRepeat(r)){
                            case "repeat-x":
                            case "repeat no-repeat":
                                this.backgroundRepeatShape(n, a, o, e, e.left + i[3], e.top + a.top + i[0], 99999, o.height, i);
                                break;
                            case "repeat-y":
                            case "no-repeat repeat":
                                this.backgroundRepeatShape(n, a, o, e, e.left + a.left + i[3], e.top + i[0], o.width, 99999, i);
                                break;
                            case "no-repeat":
                                this.backgroundRepeatShape(n, a, o, e, e.left + a.left + i[3], e.top + a.top + i[0], o.width, o.height, i);
                                break;
                            default:
                                this.renderBackgroundRepeat(n, a, o, {
                                    top: e.top,
                                    left: e.left
                                }, i[3], i[0]);
                        }
                    }, e.exports = r;
                },
                {
                    "./log": 13
                }
            ],
            20: [
                function(t, e, n) {
                    var r = t("../renderer"), i = t("../lineargradientcontainer"), o = t("../log");
                    function a(t, e) {
                        r.apply(this, arguments), this.canvas = this.options.canvas || this.document.createElement("canvas"), this.options.canvas || (this.canvas.width = t, this.canvas.height = e), this.ctx = this.canvas.getContext("2d"), this.taintCtx = this.document.createElement("canvas").getContext("2d"), this.ctx.textBaseline = "bottom", this.variables = {}, o("Initialized CanvasRenderer with size", t, "x", e);
                    }
                    function s(t) {
                        return 0 < t.length;
                    }
                    (a.prototype = Object.create(r.prototype)).setFillStyle = function(t) {
                        return this.ctx.fillStyle = "object" == typeof t && t.isColor ? t.toString() : t, this.ctx;
                    }, a.prototype.rectangle = function(t, e, n, r, i) {
                        this.setFillStyle(i).fillRect(t, e, n, r);
                    }, a.prototype.circle = function(t, e, n, r) {
                        this.setFillStyle(r), this.ctx.beginPath(), this.ctx.arc(t + n / 2, e + n / 2, n / 2, 0, 2 * Math.PI, !0), this.ctx.closePath(), this.ctx.fill();
                    }, a.prototype.circleStroke = function(t, e, n, r, i, o) {
                        this.circle(t, e, n, r), this.ctx.strokeStyle = o.toString(), this.ctx.stroke();
                    }, a.prototype.drawShape = function(t, e) {
                        this.shape(t), this.setFillStyle(e).fill();
                    }, a.prototype.taints = function(e) {
                        if (null === e.tainted) {
                            this.taintCtx.drawImage(e.image, 0, 0);
                            try {
                                this.taintCtx.getImageData(0, 0, 1, 1), e.tainted = !1;
                            } catch (t) {
                                this.taintCtx = document.createElement("canvas").getContext("2d"), e.tainted = !0;
                            }
                        }
                        return e.tainted;
                    }, a.prototype.drawImage = function(t, e, n, r, i, o, a, s, h) {
                        this.taints(t) && !this.options.allowTaint || this.ctx.drawImage(t.image, e, n, r, i, o, a, s, h);
                    }, a.prototype.clip = function(t, e, n) {
                        this.ctx.save(), t.filter(s).forEach(function(t) {
                            this.shape(t).clip();
                        }, this), e.call(n), this.ctx.restore();
                    }, a.prototype.shape = function(t) {
                        return this.ctx.beginPath(), t.forEach(function(t, e) {
                            "rect" === t[0] ? this.ctx.rect.apply(this.ctx, t.slice(1)) : this.ctx[0 === e ? "moveTo" : t[0] + "To"].apply(this.ctx, t.slice(1));
                        }, this), this.ctx.closePath(), this.ctx;
                    }, a.prototype.font = function(t, e, n, r, i, o) {
                        this.setFillStyle(t).font = [
                            e,
                            n,
                            r,
                            i,
                            o
                        ].join(" ").split(",")[0];
                    }, a.prototype.fontShadow = function(t, e, n, r) {
                        this.setVariable("shadowColor", t.toString()).setVariable("shadowOffsetY", e).setVariable("shadowOffsetX", n).setVariable("shadowBlur", r);
                    }, a.prototype.clearShadow = function() {
                        this.setVariable("shadowColor", "rgba(0,0,0,0)");
                    }, a.prototype.setOpacity = function(t) {
                        this.ctx.globalAlpha = t;
                    }, a.prototype.setTransform = function(t) {
                        this.ctx.translate(t.origin[0], t.origin[1]), this.ctx.transform.apply(this.ctx, t.matrix), this.ctx.translate(-t.origin[0], -t.origin[1]);
                    }, a.prototype.setVariable = function(t, e) {
                        return this.variables[t] !== e && (this.variables[t] = this.ctx[t] = e), this;
                    }, a.prototype.text = function(t, e, n) {
                        this.ctx.fillText(t, e, n);
                    }, a.prototype.backgroundRepeatShape = function(t, e, n, r, i, o, a, s, h) {
                        var c = [
                            [
                                "line",
                                Math.round(i),
                                Math.round(o)
                            ],
                            [
                                "line",
                                Math.round(i + a),
                                Math.round(o)
                            ],
                            [
                                "line",
                                Math.round(i + a),
                                Math.round(s + o)
                            ],
                            [
                                "line",
                                Math.round(i),
                                Math.round(s + o)
                            ]
                        ];
                        this.clip([
                            c
                        ], function() {
                            this.renderBackgroundRepeat(t, e, n, r, h[3], h[0]);
                        }, this);
                    }, a.prototype.renderBackgroundRepeat = function(t, e, n, r, i, o) {
                        var a = Math.round(r.left + e.left + i), s = Math.round(r.top + e.top + o);
                        this.setFillStyle(this.ctx.createPattern(this.resizeImage(t, n), "repeat")), this.ctx.translate(a, s), this.ctx.fill(), this.ctx.translate(-a, -s);
                    }, a.prototype.renderBackgroundGradient = function(t, e) {
                        if (t instanceof i) {
                            var n = this.ctx.createLinearGradient(e.left + e.width * t.x0, e.top + e.height * t.y0, e.left + e.width * t.x1, e.top + e.height * t.y1);
                            t.colorStops.forEach(function(t) {
                                n.addColorStop(t.stop, t.color.toString());
                            }), this.rectangle(e.left, e.top, e.width, e.height, n);
                        }
                    }, a.prototype.resizeImage = function(t, e) {
                        var n = t.image;
                        if (n.width === e.width && n.height === e.height) return n;
                        var r = document.createElement("canvas");
                        return r.width = e.width, r.height = e.height, r.getContext("2d").drawImage(n, 0, 0, n.width, n.height, 0, 0, e.width, e.height), r;
                    }, e.exports = a;
                },
                {
                    "../lineargradientcontainer": 12,
                    "../log": 13,
                    "../renderer": 19
                }
            ],
            21: [
                function(t, e, n) {
                    var i = t("./nodecontainer");
                    function r(t, e, n, r) {
                        i.call(this, n, r), this.ownStacking = t, this.contexts = [], this.children = [], this.opacity = (this.parent ? this.parent.stack.opacity : 1) * e;
                    }
                    (r.prototype = Object.create(i.prototype)).getParentStack = function(t) {
                        var e = this.parent ? this.parent.stack : null;
                        return e ? e.ownStacking ? e : e.getParentStack(t) : t.stack;
                    }, e.exports = r;
                },
                {
                    "./nodecontainer": 14
                }
            ],
            22: [
                function(t, e, n) {
                    function r(t) {
                        this.rangeBounds = this.testRangeBounds(t), this.cors = this.testCORS(), this.svg = this.testSVG();
                    }
                    r.prototype.testRangeBounds = function(t) {
                        var e, n, r = !1;
                        return t.createRange && (e = t.createRange()).getBoundingClientRect && ((n = t.createElement("boundtest")).style.height = "123px", n.style.display = "block", t.body.appendChild(n), e.selectNode(n), 123 === e.getBoundingClientRect().height && (r = !0), t.body.removeChild(n)), r;
                    }, r.prototype.testCORS = function() {
                        return void 0 !== (new Image).crossOrigin;
                    }, r.prototype.testSVG = function() {
                        var t = new Image, e = document.createElement("canvas"), n = e.getContext("2d");
                        t.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
                        try {
                            n.drawImage(t, 0, 0), e.toDataURL();
                        } catch (t) {
                            return !1;
                        }
                        return !0;
                    }, e.exports = r;
                },
                {}
            ],
            23: [
                function(t, e, n) {
                    var r = t("./xhr"), i = t("./utils").decode64;
                    function o(t) {
                        this.src = t, this.image = null;
                        var n = this;
                        this.promise = this.hasFabric().then(function() {
                            return n.isInline(t) ? Promise.resolve(n.inlineFormatting(t)) : r(t);
                        }).then(function(e) {
                            return new Promise(function(t) {
                                window.html2canvas.svg.fabric.loadSVGFromString(e, n.createCanvas.call(n, t));
                            });
                        });
                    }
                    o.prototype.hasFabric = function() {
                        return window.html2canvas.svg && window.html2canvas.svg.fabric ? Promise.resolve() : Promise.reject(new Error("html2canvas.svg.js is not loaded, cannot render svg"));
                    }, o.prototype.inlineFormatting = function(t) {
                        return /^data:image\/svg\+xml;base64,/.test(t) ? this.decode64(this.removeContentType(t)) : this.removeContentType(t);
                    }, o.prototype.removeContentType = function(t) {
                        return t.replace(/^data:image\/svg\+xml(;base64)?,/, "");
                    }, o.prototype.isInline = function(t) {
                        return /^data:image\/svg\+xml/i.test(t);
                    }, o.prototype.createCanvas = function(r) {
                        var i = this;
                        return function(t, e) {
                            var n = new window.html2canvas.svg.fabric.StaticCanvas("c");
                            i.image = n.lowerCanvasEl, n.setWidth(e.width).setHeight(e.height).add(window.html2canvas.svg.fabric.util.groupSVGElements(t, e)).renderAll(), r(n.lowerCanvasEl);
                        };
                    }, o.prototype.decode64 = function(t) {
                        return "function" == typeof window.atob ? window.atob(t) : i(t);
                    }, e.exports = o;
                },
                {
                    "./utils": 26,
                    "./xhr": 28
                }
            ],
            24: [
                function(t, e, n) {
                    var r = t("./svgcontainer");
                    function i(n, t) {
                        this.src = n, this.image = null;
                        var r = this;
                        this.promise = t ? new Promise(function(t, e) {
                            r.image = new Image, r.image.onload = t, r.image.onerror = e, r.image.src = "data:image/svg+xml," + (new XMLSerializer).serializeToString(n), !0 === r.image.complete && t(r.image);
                        }) : this.hasFabric().then(function() {
                            return new Promise(function(t) {
                                window.html2canvas.svg.fabric.parseSVGDocument(n, r.createCanvas.call(r, t));
                            });
                        });
                    }
                    i.prototype = Object.create(r.prototype), e.exports = i;
                },
                {
                    "./svgcontainer": 23
                }
            ],
            25: [
                function(t, e, n) {
                    var r = t("./nodecontainer");
                    function i(t, e) {
                        r.call(this, t, e);
                    }
                    function o(t, e, n) {
                        if (0 < t.length) return e + n.toUpperCase();
                    }
                    (i.prototype = Object.create(r.prototype)).applyTextTransform = function() {
                        this.node.data = this.transform(this.parent.css("textTransform"));
                    }, i.prototype.transform = function(t) {
                        var e = this.node.data;
                        switch(t){
                            case "lowercase":
                                return e.toLowerCase();
                            case "capitalize":
                                return e.replace(/(^|\s|:|-|\(|\))([a-z])/g, o);
                            case "uppercase":
                                return e.toUpperCase();
                            default:
                                return e;
                        }
                    }, e.exports = i;
                },
                {
                    "./nodecontainer": 14
                }
            ],
            26: [
                function(t, e, n) {
                    n.smallImage = function() {
                        return "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
                    }, n.bind = function(t, e) {
                        return function() {
                            return t.apply(e, arguments);
                        };
                    }, /*
   * base64-arraybuffer
   * https://github.com/niklasvh/base64-arraybuffer
   *
   * Copyright (c) 2012 Niklas von Hertzen
   * Licensed under the MIT license.
   */ n.decode64 = function(t) {
                        var e, n, r, i, o, a, s, h = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", c = t.length, l = "";
                        for(e = 0; e < c; e += 4)o = h.indexOf(t[e]) << 2 | (n = h.indexOf(t[e + 1])) >> 4, a = (15 & n) << 4 | (r = h.indexOf(t[e + 2])) >> 2, s = (3 & r) << 6 | (i = h.indexOf(t[e + 3])), l += 64 === r ? String.fromCharCode(o) : 64 === i || -1 === i ? String.fromCharCode(o, a) : String.fromCharCode(o, a, s);
                        return l;
                    }, n.getBounds = function(t) {
                        if (t.getBoundingClientRect) {
                            var e = t.getBoundingClientRect(), n = null == t.offsetWidth ? e.width : t.offsetWidth;
                            return {
                                top: e.top,
                                bottom: e.bottom || e.top + e.height,
                                right: e.left + n,
                                left: e.left,
                                width: n,
                                height: null == t.offsetHeight ? e.height : t.offsetHeight
                            };
                        }
                        return {};
                    }, n.offsetBounds = function(t) {
                        var e = t.offsetParent ? n.offsetBounds(t.offsetParent) : {
                            top: 0,
                            left: 0
                        };
                        return {
                            top: t.offsetTop + e.top,
                            bottom: t.offsetTop + t.offsetHeight + e.top,
                            right: t.offsetLeft + e.left + t.offsetWidth,
                            left: t.offsetLeft + e.left,
                            width: t.offsetWidth,
                            height: t.offsetHeight
                        };
                    }, n.parseBackgrounds = function(t) {
                        var e, n, r, i, o, a, s, h = [], c = 0, l = 0, u = function() {
                            e && ('"' === n.substr(0, 1) && (n = n.substr(1, n.length - 2)), n && s.push(n), "-" === e.substr(0, 1) && 0 < (i = e.indexOf("-", 1) + 1) && (r = e.substr(0, i), e = e.substr(i)), h.push({
                                prefix: r,
                                method: e.toLowerCase(),
                                value: o,
                                args: s,
                                image: null
                            })), s = [], e = r = n = o = "";
                        };
                        return s = [], e = r = n = o = "", t.split("").forEach(function(t) {
                            if (!(0 === c && -1 < " \r\n	".indexOf(t))) {
                                switch(t){
                                    case '"':
                                        a ? a === t && (a = null) : a = t;
                                        break;
                                    case "(":
                                        if (a) break;
                                        if (0 === c) return c = 1, void (o += t);
                                        l++;
                                        break;
                                    case ")":
                                        if (a) break;
                                        if (1 === c) {
                                            if (0 === l) return c = 0, o += t, void u();
                                            l--;
                                        }
                                        break;
                                    case ",":
                                        if (a) break;
                                        if (0 === c) return void u();
                                        if (1 === c && 0 === l && !e.match(/^url$/i)) return s.push(n), n = "", void (o += t);
                                }
                                o += t, 0 === c ? e += t : n += t;
                            }
                        }), u(), h;
                    };
                },
                {}
            ],
            27: [
                function(t, e, n) {
                    var r = t("./gradientcontainer");
                    function i(t) {
                        r.apply(this, arguments), this.type = "linear" === t.args[0] ? r.TYPES.LINEAR : r.TYPES.RADIAL;
                    }
                    i.prototype = Object.create(r.prototype), e.exports = i;
                },
                {
                    "./gradientcontainer": 9
                }
            ],
            28: [
                function(t, e, n) {
                    e.exports = function(r) {
                        return new Promise(function(t, e) {
                            var n = new XMLHttpRequest;
                            n.open("GET", r), n.onload = function() {
                                200 === n.status ? t(n.responseText) : e(new Error(n.statusText));
                            }, n.onerror = function() {
                                e(new Error("Network Error"));
                            }, n.send();
                        });
                    };
                },
                {}
            ]
        }, {}, [
            4
        ])(4);
    }), function(t) {
        var n = "+".charCodeAt(0), r = "/".charCodeAt(0), i = "0".charCodeAt(0), o = "a".charCodeAt(0), a = "A".charCodeAt(0), s = "-".charCodeAt(0), h = "_".charCodeAt(0), l = function(t) {
            var e = t.charCodeAt(0);
            return e === n || e === s ? 62 : e === r || e === h ? 63 : e < i ? -1 : e < i + 10 ? e - i + 26 + 26 : e < a + 26 ? e - a : e < o + 26 ? e - o + 26 : void 0;
        };
        t.API.TTFFont = function() {
            function i(t, e, n) {
                var r;
                if (this.rawData = t, r = this.contents = new X(t), this.contents.pos = 4, "ttcf" === r.readString(4)) {
                    if (!e) throw new Error("Must specify a font name for TTC files.");
                    throw new Error("Font " + e + " not found in TTC file.");
                }
                r.pos = 0, this.parse(), this.subset = new T(this), this.registerTTF();
            }
            return i.open = function(t, e, n, r) {
                return new i(function(t) {
                    var e, n, r, i, o, a;
                    if (0 < t.length % 4) throw new Error("Invalid string. Length must be a multiple of 4");
                    var s = t.length;
                    o = "=" === t.charAt(s - 2) ? 2 : "=" === t.charAt(s - 1) ? 1 : 0, a = new Uint8Array(3 * t.length / 4 - o), r = 0 < o ? t.length - 4 : t.length;
                    var h = 0;
                    function c(t) {
                        a[h++] = t;
                    }
                    for(n = e = 0; e < r; e += 4, n += 3)c((16711680 & (i = l(t.charAt(e)) << 18 | l(t.charAt(e + 1)) << 12 | l(t.charAt(e + 2)) << 6 | l(t.charAt(e + 3)))) >> 16), c((65280 & i) >> 8), c(255 & i);
                    return 2 === o ? c(255 & (i = l(t.charAt(e)) << 2 | l(t.charAt(e + 1)) >> 4)) : 1 === o && (c((i = l(t.charAt(e)) << 10 | l(t.charAt(e + 1)) << 4 | l(t.charAt(e + 2)) >> 2) >> 8 & 255), c(255 & i)), a;
                }(n), e, r);
            }, i.prototype.parse = function() {
                return this.directory = new e(this.contents), this.head = new d(this), this.name = new b(this), this.cmap = new m(this), this.hhea = new g(this), this.maxp = new x(this), this.hmtx = new S(this), this.post = new y(this), this.os2 = new w(this), this.loca = new C(this), this.glyf = new _(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [
                    this.head.xMin,
                    this.head.yMin,
                    this.head.xMax,
                    this.head.yMax
                ];
            }, i.prototype.registerTTF = function() {
                var i, t, e, n, r;
                if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = (function() {
                    var t, e, n, r;
                    for(r = [], t = 0, e = (n = this.bbox).length; t < e; t++)i = n[t], r.push(Math.round(i * this.scaleFactor));
                    return r;
                }).call(this), this.stemV = 0, this.post.exists ? (e = 255 & (n = this.post.italic_angle), !0 & (t = n >> 16) && (t = -(1 + (65535 ^ t))), this.italicAngle = +(t + "." + e)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = 1 === (r = this.familyClass) || 2 === r || 3 === r || 4 === r || 5 === r || 7 === r, this.isScript = 10 === this.familyClass, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), 0 !== this.italicAngle && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw new Error("No unicode cmap for font");
            }, i.prototype.characterToGlyph = function(t) {
                var e;
                return (null != (e = this.cmap.unicode) ? e.codeMap[t] : void 0) || 0;
            }, i.prototype.widthOfGlyph = function(t) {
                var e;
                return e = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(t).advance * e;
            }, i.prototype.widthOfString = function(t, e, n) {
                var r, i, o, a, s;
                for(i = a = o = 0, s = (t = "" + t).length; 0 <= s ? a < s : s < a; i = 0 <= s ? ++a : --a)r = t.charCodeAt(i), o += this.widthOfGlyph(this.characterToGlyph(r)) + n * (1e3 / e) || 0;
                return o * (e / 1e3);
            }, i.prototype.lineHeight = function(t, e) {
                var n;
                return null == e && (e = !1), n = e ? this.lineGap : 0, (this.ascender + n - this.decender) / 1e3 * t;
            }, i;
        }();
        var c, X = function() {
            function t(t) {
                this.data = null != t ? t : [], this.pos = 0, this.length = this.data.length;
            }
            return t.prototype.readByte = function() {
                return this.data[this.pos++];
            }, t.prototype.writeByte = function(t) {
                return this.data[this.pos++] = t;
            }, t.prototype.readUInt32 = function() {
                return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
            }, t.prototype.writeUInt32 = function(t) {
                return this.writeByte(t >>> 24 & 255), this.writeByte(t >> 16 & 255), this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
            }, t.prototype.readInt32 = function() {
                var t;
                return 2147483648 <= (t = this.readUInt32()) ? t - 4294967296 : t;
            }, t.prototype.writeInt32 = function(t) {
                return t < 0 && (t += 4294967296), this.writeUInt32(t);
            }, t.prototype.readUInt16 = function() {
                return this.readByte() << 8 | this.readByte();
            }, t.prototype.writeUInt16 = function(t) {
                return this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
            }, t.prototype.readInt16 = function() {
                var t;
                return 32768 <= (t = this.readUInt16()) ? t - 65536 : t;
            }, t.prototype.writeInt16 = function(t) {
                return t < 0 && (t += 65536), this.writeUInt16(t);
            }, t.prototype.readString = function(t) {
                var e, n, r;
                for(n = [], e = r = 0; 0 <= t ? r < t : t < r; e = 0 <= t ? ++r : --r)n[e] = String.fromCharCode(this.readByte());
                return n.join("");
            }, t.prototype.writeString = function(t) {
                var e, n, r, i;
                for(i = [], e = n = 0, r = t.length; 0 <= r ? n < r : r < n; e = 0 <= r ? ++n : --n)i.push(this.writeByte(t.charCodeAt(e)));
                return i;
            }, t.prototype.readShort = function() {
                return this.readInt16();
            }, t.prototype.writeShort = function(t) {
                return this.writeInt16(t);
            }, t.prototype.readLongLong = function() {
                var t, e, n, r, i, o, a, s;
                return t = this.readByte(), e = this.readByte(), n = this.readByte(), r = this.readByte(), i = this.readByte(), o = this.readByte(), a = this.readByte(), s = this.readByte(), 128 & t ? -1 * (72057594037927940 * (255 ^ t) + 281474976710656 * (255 ^ e) + 1099511627776 * (255 ^ n) + 4294967296 * (255 ^ r) + 16777216 * (255 ^ i) + 65536 * (255 ^ o) + 256 * (255 ^ a) + (255 ^ s) + 1) : 72057594037927940 * t + 281474976710656 * e + 1099511627776 * n + 4294967296 * r + 16777216 * i + 65536 * o + 256 * a + s;
            }, t.prototype.readInt = function() {
                return this.readInt32();
            }, t.prototype.writeInt = function(t) {
                return this.writeInt32(t);
            }, t.prototype.read = function(t) {
                var e, n;
                for(e = [], n = 0; 0 <= t ? n < t : t < n; 0 <= t ? ++n : --n)e.push(this.readByte());
                return e;
            }, t.prototype.write = function(t) {
                var e, n, r, i;
                for(i = [], n = 0, r = t.length; n < r; n++)e = t[n], i.push(this.writeByte(e));
                return i;
            }, t;
        }(), e = function() {
            var p;
            function t(t) {
                var e, n, r;
                for(this.scalarType = t.readInt(), this.tableCount = t.readShort(), this.searchRange = t.readShort(), this.entrySelector = t.readShort(), this.rangeShift = t.readShort(), this.tables = {}, n = 0, r = this.tableCount; 0 <= r ? n < r : r < n; 0 <= r ? ++n : --n)e = {
                    tag: t.readString(4),
                    checksum: t.readInt(),
                    offset: t.readInt(),
                    length: t.readInt()
                }, this.tables[e.tag] = e;
            }
            return t.prototype.encode = function(t) {
                var e, n, r, i, o, a, s, h, c, l, u, f, d;
                for(d in u = Object.keys(t).length, a = Math.log(2), c = 16 * Math.floor(Math.log(u) / a), i = Math.floor(c / a), h = 16 * u - c, (n = new X).writeInt(this.scalarType), n.writeShort(u), n.writeShort(c), n.writeShort(i), n.writeShort(h), r = 16 * u, s = n.pos + r, o = null, f = [], t)for(l = t[d], n.writeString(d), n.writeInt(p(l)), n.writeInt(s), n.writeInt(l.length), f = f.concat(l), "head" === d && (o = s), s += l.length; s % 4;)f.push(0), s++;
                return n.write(f), e = 2981146554 - p(n.data), n.pos = o + 8, n.writeUInt32(e), n.data;
            }, p = function(t) {
                var e, n, r, i;
                for(t = k.call(t); t.length % 4;)t.push(0);
                for(n = new X(t), r = e = 0, i = t.length; r < i; r += 4)e += n.readUInt32();
                return 4294967295 & e;
            }, t;
        }(), u = {}.hasOwnProperty, f = function(t, e) {
            for(var n in e)u.call(e, n) && (t[n] = e[n]);
            function r() {
                this.constructor = t;
            }
            return r.prototype = e.prototype, t.prototype = new r, t.__super__ = e.prototype, t;
        };
        c = function() {
            function t(t) {
                var e;
                this.file = t, e = this.file.directory.tables[this.tag], this.exists = !!e, e && (this.offset = e.offset, this.length = e.length, this.parse(this.file.contents));
            }
            return t.prototype.parse = function() {}, t.prototype.encode = function() {}, t.prototype.raw = function() {
                return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
            }, t;
        }();
        var d = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "head", e.prototype.parse = function(t) {
                return t.pos = this.offset, this.version = t.readInt(), this.revision = t.readInt(), this.checkSumAdjustment = t.readInt(), this.magicNumber = t.readInt(), this.flags = t.readShort(), this.unitsPerEm = t.readShort(), this.created = t.readLongLong(), this.modified = t.readLongLong(), this.xMin = t.readShort(), this.yMin = t.readShort(), this.xMax = t.readShort(), this.yMax = t.readShort(), this.macStyle = t.readShort(), this.lowestRecPPEM = t.readShort(), this.fontDirectionHint = t.readShort(), this.indexToLocFormat = t.readShort(), this.glyphDataFormat = t.readShort();
            }, e;
        }(), p = function() {
            function t(n, t) {
                var e, r, i, o, a, s, h, c, l, u, f, d, p, g, m, w, y, v;
                switch(this.platformID = n.readUInt16(), this.encodingID = n.readShort(), this.offset = t + n.readInt(), l = n.pos, n.pos = this.offset, this.format = n.readUInt16(), this.length = n.readUInt16(), this.language = n.readUInt16(), this.isUnicode = 3 === this.platformID && 1 === this.encodingID && 4 === this.format || 0 === this.platformID && 4 === this.format, this.codeMap = {}, this.format){
                    case 0:
                        for(s = m = 0; m < 256; s = ++m)this.codeMap[s] = n.readByte();
                        break;
                    case 4:
                        for(f = n.readUInt16(), u = f / 2, n.pos += 6, i = function() {
                            var t, e;
                            for(e = [], s = t = 0; 0 <= u ? t < u : u < t; s = 0 <= u ? ++t : --t)e.push(n.readUInt16());
                            return e;
                        }(), n.pos += 2, p = function() {
                            var t, e;
                            for(e = [], s = t = 0; 0 <= u ? t < u : u < t; s = 0 <= u ? ++t : --t)e.push(n.readUInt16());
                            return e;
                        }(), h = function() {
                            var t, e;
                            for(e = [], s = t = 0; 0 <= u ? t < u : u < t; s = 0 <= u ? ++t : --t)e.push(n.readUInt16());
                            return e;
                        }(), c = function() {
                            var t, e;
                            for(e = [], s = t = 0; 0 <= u ? t < u : u < t; s = 0 <= u ? ++t : --t)e.push(n.readUInt16());
                            return e;
                        }(), r = (this.length - n.pos + this.offset) / 2, a = function() {
                            var t, e;
                            for(e = [], s = t = 0; 0 <= r ? t < r : r < t; s = 0 <= r ? ++t : --t)e.push(n.readUInt16());
                            return e;
                        }(), s = w = 0, v = i.length; w < v; s = ++w)for(g = i[s], e = y = d = p[s]; d <= g ? y <= g : g <= y; e = d <= g ? ++y : --y)0 === c[s] ? o = e + h[s] : 0 !== (o = a[c[s] / 2 + (e - d) - (u - s)] || 0) && (o += h[s]), this.codeMap[e] = 65535 & o;
                }
                n.pos = l;
            }
            return t.encode = function(t, e) {
                var n, r, i, o, a, s, h, c, l, u, f, d, p, g, m, w, y, v, b, x, S, k, _, A, I, C, T, F, P, E, q, O, B, R, j, D, M, U, N, z, L, H, W, G, V, Y;
                switch(F = new X, o = Object.keys(t).sort(function(t, e) {
                    return t - e;
                }), e){
                    case "macroman":
                        for(p = 0, g = function() {
                            var t, e;
                            for(e = [], d = t = 0; t < 256; d = ++t)e.push(0);
                            return e;
                        }(), w = {
                            0: 0
                        }, i = {}, P = 0, B = o.length; P < B; P++)null == w[W = t[r = o[P]]] && (w[W] = ++p), i[r] = {
                            old: t[r],
                            new: w[t[r]]
                        }, g[r] = w[t[r]];
                        return F.writeUInt16(1), F.writeUInt16(0), F.writeUInt32(12), F.writeUInt16(0), F.writeUInt16(262), F.writeUInt16(0), F.write(g), {
                            charMap: i,
                            subtable: F.data,
                            maxGlyphID: p + 1
                        };
                    case "unicode":
                        for(C = [], l = [], w = {}, n = {}, m = h = null, E = y = 0, R = o.length; E < R; E++)null == w[b = t[r = o[E]]] && (w[b] = ++y), n[r] = {
                            old: b,
                            new: w[b]
                        }, a = w[b] - r, null != m && a === h || (m && l.push(m), C.push(r), h = a), m = r;
                        for(m && l.push(m), l.push(65535), C.push(65535), A = 2 * (_ = C.length), k = 2 * Math.pow(Math.log(_) / Math.LN2, 2), u = Math.log(k / 2) / Math.LN2, S = 2 * _ - k, s = [], x = [], f = [], d = q = 0, j = C.length; q < j; d = ++q){
                            if (I = C[d], c = l[d], 65535 === I) {
                                s.push(0), x.push(0);
                                break;
                            }
                            if (32768 <= I - (T = n[I].new)) for(s.push(0), x.push(2 * (f.length + _ - d)), r = O = I; I <= c ? O <= c : c <= O; r = I <= c ? ++O : --O)f.push(n[r].new);
                            else s.push(T - I), x.push(0);
                        }
                        for(F.writeUInt16(3), F.writeUInt16(1), F.writeUInt32(12), F.writeUInt16(4), F.writeUInt16(16 + 8 * _ + 2 * f.length), F.writeUInt16(0), F.writeUInt16(A), F.writeUInt16(k), F.writeUInt16(u), F.writeUInt16(S), L = 0, D = l.length; L < D; L++)r = l[L], F.writeUInt16(r);
                        for(F.writeUInt16(0), H = 0, M = C.length; H < M; H++)r = C[H], F.writeUInt16(r);
                        for(G = 0, U = s.length; G < U; G++)a = s[G], F.writeUInt16(a);
                        for(V = 0, N = x.length; V < N; V++)v = x[V], F.writeUInt16(v);
                        for(Y = 0, z = f.length; Y < z; Y++)p = f[Y], F.writeUInt16(p);
                        return {
                            charMap: n,
                            subtable: F.data,
                            maxGlyphID: y + 1
                        };
                }
            }, t;
        }(), m = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "cmap", e.prototype.parse = function(t) {
                var e, n, r;
                for(t.pos = this.offset, this.version = t.readUInt16(), n = t.readUInt16(), this.tables = [], this.unicode = null, r = 0; 0 <= n ? r < n : n < r; 0 <= n ? ++r : --r)e = new p(t, this.offset), this.tables.push(e), e.isUnicode && null == this.unicode && (this.unicode = e);
                return !0;
            }, e.encode = function(t, e) {
                var n, r;
                return null == e && (e = "macroman"), n = p.encode(t, e), (r = new X).writeUInt16(0), r.writeUInt16(1), n.table = r.data.concat(n.subtable), n;
            }, e;
        }(), g = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "hhea", e.prototype.parse = function(t) {
                return t.pos = this.offset, this.version = t.readInt(), this.ascender = t.readShort(), this.decender = t.readShort(), this.lineGap = t.readShort(), this.advanceWidthMax = t.readShort(), this.minLeftSideBearing = t.readShort(), this.minRightSideBearing = t.readShort(), this.xMaxExtent = t.readShort(), this.caretSlopeRise = t.readShort(), this.caretSlopeRun = t.readShort(), this.caretOffset = t.readShort(), t.pos += 8, this.metricDataFormat = t.readShort(), this.numberOfMetrics = t.readUInt16();
            }, e;
        }(), w = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "OS/2", e.prototype.parse = function(n) {
                if (n.pos = this.offset, this.version = n.readUInt16(), this.averageCharWidth = n.readShort(), this.weightClass = n.readUInt16(), this.widthClass = n.readUInt16(), this.type = n.readShort(), this.ySubscriptXSize = n.readShort(), this.ySubscriptYSize = n.readShort(), this.ySubscriptXOffset = n.readShort(), this.ySubscriptYOffset = n.readShort(), this.ySuperscriptXSize = n.readShort(), this.ySuperscriptYSize = n.readShort(), this.ySuperscriptXOffset = n.readShort(), this.ySuperscriptYOffset = n.readShort(), this.yStrikeoutSize = n.readShort(), this.yStrikeoutPosition = n.readShort(), this.familyClass = n.readShort(), this.panose = function() {
                    var t, e;
                    for(e = [], t = 0; t < 10; ++t)e.push(n.readByte());
                    return e;
                }(), this.charRange = function() {
                    var t, e;
                    for(e = [], t = 0; t < 4; ++t)e.push(n.readInt());
                    return e;
                }(), this.vendorID = n.readString(4), this.selection = n.readShort(), this.firstCharIndex = n.readShort(), this.lastCharIndex = n.readShort(), 0 < this.version && (this.ascent = n.readShort(), this.descent = n.readShort(), this.lineGap = n.readShort(), this.winAscent = n.readShort(), this.winDescent = n.readShort(), this.codePageRange = function() {
                    var t, e;
                    for(e = [], t = 0; t < 2; ++t)e.push(n.readInt());
                    return e;
                }(), 1 < this.version)) return this.xHeight = n.readShort(), this.capHeight = n.readShort(), this.defaultChar = n.readShort(), this.breakChar = n.readShort(), this.maxContext = n.readShort();
            }, e;
        }(), y = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "post", e.prototype.parse = function(r) {
                var t, e, n, i;
                switch(r.pos = this.offset, this.format = r.readInt(), this.italicAngle = r.readInt(), this.underlinePosition = r.readShort(), this.underlineThickness = r.readShort(), this.isFixedPitch = r.readInt(), this.minMemType42 = r.readInt(), this.maxMemType42 = r.readInt(), this.minMemType1 = r.readInt(), this.maxMemType1 = r.readInt(), this.format){
                    case 65536:
                        break;
                    case 131072:
                        for(e = r.readUInt16(), this.glyphNameIndex = [], n = 0; 0 <= e ? n < e : e < n; 0 <= e ? ++n : --n)this.glyphNameIndex.push(r.readUInt16());
                        for(this.names = [], i = []; r.pos < this.offset + this.length;)t = r.readByte(), i.push(this.names.push(r.readString(t)));
                        return i;
                    case 151552:
                        return e = r.readUInt16(), this.offsets = r.read(e);
                    case 196608:
                        break;
                    case 262144:
                        return this.map = (function() {
                            var t, e, n;
                            for(n = [], t = 0, e = this.file.maxp.numGlyphs; 0 <= e ? t < e : e < t; 0 <= e ? ++t : --t)n.push(r.readUInt32());
                            return n;
                        }).call(this);
                }
            }, e;
        }(), v = function(t, e) {
            this.raw = t, this.length = t.length, this.platformID = e.platformID, this.encodingID = e.encodingID, this.languageID = e.languageID;
        }, b = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "name", e.prototype.parse = function(t) {
                var e, n, r, i, o, a, s, h, c, l, u, f;
                for(t.pos = this.offset, t.readShort(), e = t.readShort(), a = t.readShort(), n = [], i = c = 0; 0 <= e ? c < e : e < c; i = 0 <= e ? ++c : --c)n.push({
                    platformID: t.readShort(),
                    encodingID: t.readShort(),
                    languageID: t.readShort(),
                    nameID: t.readShort(),
                    length: t.readShort(),
                    offset: this.offset + a + t.readShort()
                });
                for(s = {}, i = l = 0, u = n.length; l < u; i = ++l)r = n[i], t.pos = r.offset, h = t.readString(r.length), o = new v(h, r), null == s[f = r.nameID] && (s[f] = []), s[r.nameID].push(o);
                return this.strings = s, this.copyright = s[0], this.fontFamily = s[1], this.fontSubfamily = s[2], this.uniqueSubfamily = s[3], this.fontName = s[4], this.version = s[5], this.postscriptName = s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, ""), this.trademark = s[7], this.manufacturer = s[8], this.designer = s[9], this.description = s[10], this.vendorUrl = s[11], this.designerUrl = s[12], this.license = s[13], this.licenseUrl = s[14], this.preferredFamily = s[15], this.preferredSubfamily = s[17], this.compatibleFull = s[18], this.sampleText = s[19];
            }, e;
        }(), x = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "maxp", e.prototype.parse = function(t) {
                return t.pos = this.offset, this.version = t.readInt(), this.numGlyphs = t.readUInt16(), this.maxPoints = t.readUInt16(), this.maxContours = t.readUInt16(), this.maxCompositePoints = t.readUInt16(), this.maxComponentContours = t.readUInt16(), this.maxZones = t.readUInt16(), this.maxTwilightPoints = t.readUInt16(), this.maxStorage = t.readUInt16(), this.maxFunctionDefs = t.readUInt16(), this.maxInstructionDefs = t.readUInt16(), this.maxStackElements = t.readUInt16(), this.maxSizeOfInstructions = t.readUInt16(), this.maxComponentElements = t.readUInt16(), this.maxComponentDepth = t.readUInt16();
            }, e;
        }(), S = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "hmtx", e.prototype.parse = function(n) {
                var t, r, i, e, o, a, s;
                for(n.pos = this.offset, this.metrics = [], e = 0, a = this.file.hhea.numberOfMetrics; 0 <= a ? e < a : a < e; 0 <= a ? ++e : --e)this.metrics.push({
                    advance: n.readUInt16(),
                    lsb: n.readInt16()
                });
                for(r = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = function() {
                    var t, e;
                    for(e = [], t = 0; 0 <= r ? t < r : r < t; 0 <= r ? ++t : --t)e.push(n.readInt16());
                    return e;
                }(), this.widths = (function() {
                    var t, e, n, r;
                    for(r = [], t = 0, e = (n = this.metrics).length; t < e; t++)i = n[t], r.push(i.advance);
                    return r;
                }).call(this), t = this.widths[this.widths.length - 1], s = [], o = 0; 0 <= r ? o < r : r < o; 0 <= r ? ++o : --o)s.push(this.widths.push(t));
                return s;
            }, e.prototype.forGlyph = function(t) {
                return t in this.metrics ? this.metrics[t] : {
                    advance: this.metrics[this.metrics.length - 1].advance,
                    lsb: this.leftSideBearings[t - this.metrics.length]
                };
            }, e;
        }(), k = [].slice, _ = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "glyf", e.prototype.parse = function(t) {
                return this.cache = {};
            }, e.prototype.glyphFor = function(t) {
                var e, n, r, i, o, a, s, h, c, l;
                return t in this.cache ? this.cache[t] : (i = this.file.loca, e = this.file.contents, n = i.indexOf(t), 0 === (r = i.lengthOf(t)) ? this.cache[t] = null : (e.pos = this.offset + n, o = (a = new X(e.read(r))).readShort(), h = a.readShort(), l = a.readShort(), s = a.readShort(), c = a.readShort(), this.cache[t] = -1 === o ? new I(a, h, l, s, c) : new A(a, o, h, l, s, c), this.cache[t]));
            }, e.prototype.encode = function(t, e, n) {
                var r, i, o, a, s;
                for(o = [], i = [], a = 0, s = e.length; a < s; a++)r = t[e[a]], i.push(o.length), r && (o = o.concat(r.encode(n)));
                return i.push(o.length), {
                    table: o,
                    offsets: i
                };
            }, e;
        }(), A = function() {
            function t(t, e, n, r, i, o) {
                this.raw = t, this.numberOfContours = e, this.xMin = n, this.yMin = r, this.xMax = i, this.yMax = o, this.compound = !1;
            }
            return t.prototype.encode = function() {
                return this.raw.data;
            }, t;
        }(), I = function() {
            function t(t, e, n, r, i) {
                var o, a;
                for(this.raw = t, this.xMin = e, this.yMin = n, this.xMax = r, this.yMax = i, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], o = this.raw; a = o.readShort(), this.glyphOffsets.push(o.pos), this.glyphIDs.push(o.readShort()), 32 & a;)o.pos += 1 & a ? 4 : 2, 128 & a ? o.pos += 8 : 64 & a ? o.pos += 4 : 8 & a && (o.pos += 2);
            }
            return t.prototype.encode = function(t) {
                var e, n, r, i, o;
                for(n = new X(k.call(this.raw.data)), e = r = 0, i = (o = this.glyphIDs).length; r < i; e = ++r)o[e], n.pos = this.glyphOffsets[e];
                return n.data;
            }, t;
        }(), C = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "loca", e.prototype.parse = function(r) {
                var t;
                return r.pos = this.offset, t = this.file.head.indexToLocFormat, this.offsets = 0 === t ? (function() {
                    var t, e, n;
                    for(n = [], t = 0, e = this.length; t < e; t += 2)n.push(2 * r.readUInt16());
                    return n;
                }).call(this) : (function() {
                    var t, e, n;
                    for(n = [], t = 0, e = this.length; t < e; t += 4)n.push(r.readUInt32());
                    return n;
                }).call(this);
            }, e.prototype.indexOf = function(t) {
                return this.offsets[t];
            }, e.prototype.lengthOf = function(t) {
                return this.offsets[t + 1] - this.offsets[t];
            }, e.prototype.encode = function(t, e) {
                for(var n = new Uint32Array(this.offsets.length), r = 0, i = 0, o = 0; o < n.length; ++o)if (n[o] = r, i < e.length && e[i] == o) {
                    ++i, n[o] = r;
                    var a = this.offsets[o], s = this.offsets[o + 1] - a;
                    0 < s && (r += s);
                }
                for(var h = new Array(4 * n.length), c = 0; c < n.length; ++c)h[4 * c + 3] = 255 & n[c], h[4 * c + 2] = (65280 & n[c]) >> 8, h[4 * c + 1] = (16711680 & n[c]) >> 16, h[4 * c] = (4278190080 & n[c]) >> 24;
                return h;
            }, e;
        }(), T = function() {
            function t(t) {
                this.font = t, this.subset = {}, this.unicodes = {}, this.next = 33;
            }
            return t.prototype.generateCmap = function() {
                var t, e, n, r, i;
                for(e in r = this.font.cmap.tables[0].codeMap, t = {}, i = this.subset)n = i[e], t[e] = r[n];
                return t;
            }, t.prototype.glyphsFor = function(t) {
                var e, n, r, i, o, a, s;
                for(r = {}, o = 0, a = t.length; o < a; o++)r[i = t[o]] = this.font.glyf.glyphFor(i);
                for(i in e = [], r)(null != (n = r[i]) ? n.compound : void 0) && e.push.apply(e, n.glyphIDs);
                if (0 < e.length) for(i in s = this.glyphsFor(e))n = s[i], r[i] = n;
                return r;
            }, t.prototype.encode = function(t) {
                var e, n, r, i, o, a, s, h, c, l, u, f, d, p, g;
                for(n in e = m.encode(this.generateCmap(), "unicode"), i = this.glyphsFor(t), u = {
                    0: 0
                }, g = e.charMap)u[(a = g[n]).old] = a.new;
                for(f in l = e.maxGlyphID, i)f in u || (u[f] = l++);
                return h = function(t) {
                    var e, n;
                    for(e in n = {}, t)n[t[e]] = e;
                    return n;
                }(u), c = Object.keys(h).sort(function(t, e) {
                    return t - e;
                }), d = function() {
                    var t, e, n;
                    for(n = [], t = 0, e = c.length; t < e; t++)o = c[t], n.push(h[o]);
                    return n;
                }(), r = this.font.glyf.encode(i, d, u), s = this.font.loca.encode(r.offsets, d), p = {
                    cmap: this.font.cmap.raw(),
                    glyf: r.table,
                    loca: s,
                    hmtx: this.font.hmtx.raw(),
                    hhea: this.font.hhea.raw(),
                    maxp: this.font.maxp.raw(),
                    post: this.font.post.raw(),
                    name: this.font.name.raw(),
                    head: this.font.head.raw()
                }, this.font.os2.exists && (p["OS/2"] = this.font.os2.raw()), this.font.directory.encode(p);
            }, t;
        }();
        t.API.PDFObject = function() {
            var o;
            function a() {}
            return o = function(t, e) {
                return (Array(e + 1).join("0") + t).slice(-e);
            }, a.convert = function(r) {
                var i, t, e, n;
                if (Array.isArray(r)) return "[" + (function() {
                    var t, e, n;
                    for(n = [], t = 0, e = r.length; t < e; t++)i = r[t], n.push(a.convert(i));
                    return n;
                })().join(" ") + "]";
                if ("string" == typeof r) return "/" + r;
                if (null != r ? r.isString : void 0) return "(" + r + ")";
                if (r instanceof Date) return "(D:" + o(r.getUTCFullYear(), 4) + o(r.getUTCMonth(), 2) + o(r.getUTCDate(), 2) + o(r.getUTCHours(), 2) + o(r.getUTCMinutes(), 2) + o(r.getUTCSeconds(), 2) + "Z)";
                if ("[object Object]" === ({}).toString.call(r)) {
                    for(t in e = [
                        "<<"
                    ], r)n = r[t], e.push("/" + t + " " + a.convert(n));
                    return e.push(">>"), e.join("\n");
                }
                return "" + r;
            }, a;
        }();
    }($), /*
  # PNG.js
  # Copyright (c) 2011 Devon Govett
  # MIT LICENSE
  # 
  # 
  */ pt = "undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")(), gt = function() {
        var c, n, r;
        function i(t) {
            var e, n, r, i, o, a, s, h, c, l, u, f, d, p;
            for(this.data = t, this.pos = 8, this.palette = [], this.imgData = [], this.transparency = {}, this.animation = null, this.text = {}, a = null;;){
                switch(e = this.readUInt32(), c = (function() {
                    var t, e;
                    for(e = [], t = 0; t < 4; ++t)e.push(String.fromCharCode(this.data[this.pos++]));
                    return e;
                }).call(this).join("")){
                    case "IHDR":
                        this.width = this.readUInt32(), this.height = this.readUInt32(), this.bits = this.data[this.pos++], this.colorType = this.data[this.pos++], this.compressionMethod = this.data[this.pos++], this.filterMethod = this.data[this.pos++], this.interlaceMethod = this.data[this.pos++];
                        break;
                    case "acTL":
                        this.animation = {
                            numFrames: this.readUInt32(),
                            numPlays: this.readUInt32() || 1 / 0,
                            frames: []
                        };
                        break;
                    case "PLTE":
                        this.palette = this.read(e);
                        break;
                    case "fcTL":
                        a && this.animation.frames.push(a), this.pos += 4, a = {
                            width: this.readUInt32(),
                            height: this.readUInt32(),
                            xOffset: this.readUInt32(),
                            yOffset: this.readUInt32()
                        }, o = this.readUInt16(), i = this.readUInt16() || 100, a.delay = 1e3 * o / i, a.disposeOp = this.data[this.pos++], a.blendOp = this.data[this.pos++], a.data = [];
                        break;
                    case "IDAT":
                    case "fdAT":
                        for("fdAT" === c && (this.pos += 4, e -= 4), t = (null != a ? a.data : void 0) || this.imgData, f = 0; 0 <= e ? f < e : e < f; 0 <= e ? ++f : --f)t.push(this.data[this.pos++]);
                        break;
                    case "tRNS":
                        switch(this.transparency = {}, this.colorType){
                            case 3:
                                if (r = this.palette.length / 3, this.transparency.indexed = this.read(e), this.transparency.indexed.length > r) throw new Error("More transparent colors than palette size");
                                if (0 < (l = r - this.transparency.indexed.length)) for(d = 0; 0 <= l ? d < l : l < d; 0 <= l ? ++d : --d)this.transparency.indexed.push(255);
                                break;
                            case 0:
                                this.transparency.grayscale = this.read(e)[0];
                                break;
                            case 2:
                                this.transparency.rgb = this.read(e);
                        }
                        break;
                    case "tEXt":
                        s = (u = this.read(e)).indexOf(0), h = String.fromCharCode.apply(String, u.slice(0, s)), this.text[h] = String.fromCharCode.apply(String, u.slice(s + 1));
                        break;
                    case "IEND":
                        return a && this.animation.frames.push(a), this.colors = (function() {
                            switch(this.colorType){
                                case 0:
                                case 3:
                                case 4:
                                    return 1;
                                case 2:
                                case 6:
                                    return 3;
                            }
                        }).call(this), this.hasAlphaChannel = 4 === (p = this.colorType) || 6 === p, n = this.colors + (this.hasAlphaChannel ? 1 : 0), this.pixelBitlength = this.bits * n, this.colorSpace = (function() {
                            switch(this.colors){
                                case 1:
                                    return "DeviceGray";
                                case 3:
                                    return "DeviceRGB";
                            }
                        }).call(this), void (this.imgData = new Uint8Array(this.imgData));
                    default:
                        this.pos += e;
                }
                if (this.pos += 4, this.pos > this.data.length) throw new Error("Incomplete or corrupt PNG file");
            }
        }
        i.load = function(t, e, n) {
            var r;
            return "function" == typeof e && (n = e), (r = new XMLHttpRequest).open("GET", t, !0), r.responseType = "arraybuffer", r.onload = function() {
                var t;
                return t = new i(new Uint8Array(r.response || r.mozResponseArrayBuffer)), "function" == typeof (null != e ? e.getContext : void 0) && t.render(e), "function" == typeof n ? n(t) : void 0;
            }, r.send(null);
        }, i.prototype.read = function(t) {
            var e, n;
            for(n = [], e = 0; 0 <= t ? e < t : t < e; 0 <= t ? ++e : --e)n.push(this.data[this.pos++]);
            return n;
        }, i.prototype.readUInt32 = function() {
            return this.data[this.pos++] << 24 | this.data[this.pos++] << 16 | this.data[this.pos++] << 8 | this.data[this.pos++];
        }, i.prototype.readUInt16 = function() {
            return this.data[this.pos++] << 8 | this.data[this.pos++];
        }, i.prototype.decodePixels = function(E) {
            var q = this.pixelBitlength / 8, O = new Uint8Array(this.width * this.height * q), B = 0, R = this;
            if (null == E && (E = this.imgData), 0 === E.length) return new Uint8Array(0);
            function t(t, e, n, r) {
                var i, o, a, s, h, c, l, u, f, d, p, g, m, w, y, v, b, x, S, k, _, A = Math.ceil((R.width - t) / n), I = Math.ceil((R.height - e) / r), C = R.width == A && R.height == I;
                for(w = q * A, g = C ? O : new Uint8Array(w * I), c = E.length, o = m = 0; m < I && B < c;){
                    switch(E[B++]){
                        case 0:
                            for(s = b = 0; b < w; s = b += 1)g[o++] = E[B++];
                            break;
                        case 1:
                            for(s = x = 0; x < w; s = x += 1)i = E[B++], h = s < q ? 0 : g[o - q], g[o++] = (i + h) % 256;
                            break;
                        case 2:
                            for(s = S = 0; S < w; s = S += 1)i = E[B++], a = (s - s % q) / q, y = m && g[(m - 1) * w + a * q + s % q], g[o++] = (y + i) % 256;
                            break;
                        case 3:
                            for(s = k = 0; k < w; s = k += 1)i = E[B++], a = (s - s % q) / q, h = s < q ? 0 : g[o - q], y = m && g[(m - 1) * w + a * q + s % q], g[o++] = (i + Math.floor((h + y) / 2)) % 256;
                            break;
                        case 4:
                            for(s = _ = 0; _ < w; s = _ += 1)i = E[B++], a = (s - s % q) / q, h = s < q ? 0 : g[o - q], 0 === m ? y = v = 0 : (y = g[(m - 1) * w + a * q + s % q], v = a && g[(m - 1) * w + (a - 1) * q + s % q]), l = h + y - v, u = Math.abs(l - h), d = Math.abs(l - y), p = Math.abs(l - v), f = u <= d && u <= p ? h : d <= p ? y : v, g[o++] = (i + f) % 256;
                            break;
                        default:
                            throw new Error("Invalid filter algorithm: " + E[B - 1]);
                    }
                    if (!C) {
                        var T = ((e + m * r) * R.width + t) * q, F = m * w;
                        for(s = 0; s < A; s += 1){
                            for(var P = 0; P < q; P += 1)O[T++] = g[F++];
                            T += (n - 1) * q;
                        }
                    }
                    m++;
                }
            }
            return E = (E = new kt(E)).getBytes(), 1 == R.interlaceMethod ? (t(0, 0, 8, 8), t(4, 0, 8, 8), t(0, 4, 4, 8), t(2, 0, 4, 4), t(0, 2, 2, 4), t(1, 0, 2, 2), t(0, 1, 1, 2)) : t(0, 0, 1, 1), O;
        }, i.prototype.decodePalette = function() {
            var t, e, n, r, i, o, a, s, h;
            for(n = this.palette, o = this.transparency.indexed || [], i = new Uint8Array((o.length || 0) + n.length), r = 0, n.length, e = a = t = 0, s = n.length; a < s; e = a += 3)i[r++] = n[e], i[r++] = n[e + 1], i[r++] = n[e + 2], i[r++] = null != (h = o[t++]) ? h : 255;
            return i;
        }, i.prototype.copyToImageData = function(t, e) {
            var n, r, i, o, a, s, h, c, l, u, f;
            if (r = this.colors, l = null, n = this.hasAlphaChannel, this.palette.length && (l = null != (f = this._decodedPalette) ? f : this._decodedPalette = this.decodePalette(), r = 4, n = !0), c = (i = t.data || t).length, a = l || e, o = s = 0, 1 === r) for(; o < c;)h = l ? 4 * e[o / 4] : s, u = a[h++], i[o++] = u, i[o++] = u, i[o++] = u, i[o++] = n ? a[h++] : 255, s = h;
            else for(; o < c;)h = l ? 4 * e[o / 4] : s, i[o++] = a[h++], i[o++] = a[h++], i[o++] = a[h++], i[o++] = n ? a[h++] : 255, s = h;
        }, i.prototype.decode = function() {
            var t;
            return t = new Uint8Array(this.width * this.height * 4), this.copyToImageData(t, this.decodePixels()), t;
        };
        try {
            n = pt.document.createElement("canvas"), r = n.getContext("2d");
        } catch (t) {
            return -1;
        }
        return c = function(t) {
            var e;
            return r.width = t.width, r.height = t.height, r.clearRect(0, 0, t.width, t.height), r.putImageData(t, 0, 0), (e = new Image).src = n.toDataURL(), e;
        }, i.prototype.decodeFrames = function(t) {
            var e, n, r, i, o, a, s, h;
            if (this.animation) {
                for(h = [], n = o = 0, a = (s = this.animation.frames).length; o < a; n = ++o)e = s[n], r = t.createImageData(e.width, e.height), i = this.decodePixels(new Uint8Array(e.data)), this.copyToImageData(r, i), e.imageData = r, h.push(e.image = c(r));
                return h;
            }
        }, i.prototype.renderFrame = function(t, e) {
            var n, r, i;
            return n = (r = this.animation.frames)[e], i = r[e - 1], 0 === e && t.clearRect(0, 0, this.width, this.height), 1 === (null != i ? i.disposeOp : void 0) ? t.clearRect(i.xOffset, i.yOffset, i.width, i.height) : 2 === (null != i ? i.disposeOp : void 0) && t.putImageData(i.imageData, i.xOffset, i.yOffset), 0 === n.blendOp && t.clearRect(n.xOffset, n.yOffset, n.width, n.height), t.drawImage(n.image, n.xOffset, n.yOffset);
        }, i.prototype.animate = function(n) {
            var r, i, o, a, s, t, h = this;
            return i = 0, t = this.animation, a = t.numFrames, o = t.frames, s = t.numPlays, (r = function() {
                var t, e;
                if (t = i++ % a, e = o[t], h.renderFrame(n, t), 1 < a && i / a < s) return h.animation._timeout = setTimeout(r, e.delay);
            })();
        }, i.prototype.stopAnimation = function() {
            var t;
            return clearTimeout(null != (t = this.animation) ? t._timeout : void 0);
        }, i.prototype.render = function(t) {
            var e, n;
            return t._png && t._png.stopAnimation(), t._png = this, t.width = this.width, t.height = this.height, e = t.getContext("2d"), this.animation ? (this.decodeFrames(e), this.animate(e)) : (n = e.createImageData(this.width, this.height), this.copyToImageData(n, this.decodePixels()), e.putImageData(n, 0, 0));
        }, i;
    }(), pt.PNG = gt;
    /*
   * Extracted from pdf.js
   * https://github.com/andreasgal/pdf.js
   *
   * Copyright (c) 2011 Mozilla Foundation
   *
   * Contributors: Andreas Gal <gal@mozilla.com>
   *               Chris G Jones <cjones@mozilla.com>
   *               Shaon Barman <shaon.barman@gmail.com>
   *               Vivien Nicolas <21@vingtetun.org>
   *               Justin D'Arcangelo <justindarc@gmail.com>
   *               Yury Delendik
   *
   * 
   */ var St = function() {
        function t() {
            this.pos = 0, this.bufferLength = 0, this.eof = !1, this.buffer = null;
        }
        return t.prototype = {
            ensureBuffer: function(t) {
                var e = this.buffer, n = e ? e.byteLength : 0;
                if (t < n) return e;
                for(var r = 512; r < t;)r <<= 1;
                for(var i = new Uint8Array(r), o = 0; o < n; ++o)i[o] = e[o];
                return this.buffer = i;
            },
            getByte: function() {
                for(var t = this.pos; this.bufferLength <= t;){
                    if (this.eof) return null;
                    this.readBlock();
                }
                return this.buffer[this.pos++];
            },
            getBytes: function(t) {
                var e = this.pos;
                if (t) {
                    this.ensureBuffer(e + t);
                    for(var n = e + t; !this.eof && this.bufferLength < n;)this.readBlock();
                    var r = this.bufferLength;
                    r < n && (n = r);
                } else {
                    for(; !this.eof;)this.readBlock();
                    n = this.bufferLength;
                }
                return this.pos = n, this.buffer.subarray(e, n);
            },
            lookChar: function() {
                for(var t = this.pos; this.bufferLength <= t;){
                    if (this.eof) return null;
                    this.readBlock();
                }
                return String.fromCharCode(this.buffer[this.pos]);
            },
            getChar: function() {
                for(var t = this.pos; this.bufferLength <= t;){
                    if (this.eof) return null;
                    this.readBlock();
                }
                return String.fromCharCode(this.buffer[this.pos++]);
            },
            makeSubStream: function(t, e, n) {
                for(var r = t + e; this.bufferLength <= r && !this.eof;)this.readBlock();
                return new Stream(this.buffer, t, e, n);
            },
            skip: function(t) {
                t || (t = 1), this.pos += t;
            },
            reset: function() {
                this.pos = 0;
            }
        }, t;
    }(), kt = function() {
        if ("undefined" != typeof Uint32Array) {
            var F = new Uint32Array([
                16,
                17,
                18,
                0,
                8,
                7,
                9,
                6,
                10,
                5,
                11,
                4,
                12,
                3,
                13,
                2,
                14,
                1,
                15
            ]), P = new Uint32Array([
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                65547,
                65549,
                65551,
                65553,
                131091,
                131095,
                131099,
                131103,
                196643,
                196651,
                196659,
                196667,
                262211,
                262227,
                262243,
                262259,
                327811,
                327843,
                327875,
                327907,
                258,
                258,
                258
            ]), E = new Uint32Array([
                1,
                2,
                3,
                4,
                65541,
                65543,
                131081,
                131085,
                196625,
                196633,
                262177,
                262193,
                327745,
                327777,
                393345,
                393409,
                459009,
                459137,
                524801,
                525057,
                590849,
                591361,
                657409,
                658433,
                724993,
                727041,
                794625,
                798721,
                868353,
                876545
            ]), q = [
                new Uint32Array([
                    459008,
                    524368,
                    524304,
                    524568,
                    459024,
                    524400,
                    524336,
                    590016,
                    459016,
                    524384,
                    524320,
                    589984,
                    524288,
                    524416,
                    524352,
                    590048,
                    459012,
                    524376,
                    524312,
                    589968,
                    459028,
                    524408,
                    524344,
                    590032,
                    459020,
                    524392,
                    524328,
                    59e4,
                    524296,
                    524424,
                    524360,
                    590064,
                    459010,
                    524372,
                    524308,
                    524572,
                    459026,
                    524404,
                    524340,
                    590024,
                    459018,
                    524388,
                    524324,
                    589992,
                    524292,
                    524420,
                    524356,
                    590056,
                    459014,
                    524380,
                    524316,
                    589976,
                    459030,
                    524412,
                    524348,
                    590040,
                    459022,
                    524396,
                    524332,
                    590008,
                    524300,
                    524428,
                    524364,
                    590072,
                    459009,
                    524370,
                    524306,
                    524570,
                    459025,
                    524402,
                    524338,
                    590020,
                    459017,
                    524386,
                    524322,
                    589988,
                    524290,
                    524418,
                    524354,
                    590052,
                    459013,
                    524378,
                    524314,
                    589972,
                    459029,
                    524410,
                    524346,
                    590036,
                    459021,
                    524394,
                    524330,
                    590004,
                    524298,
                    524426,
                    524362,
                    590068,
                    459011,
                    524374,
                    524310,
                    524574,
                    459027,
                    524406,
                    524342,
                    590028,
                    459019,
                    524390,
                    524326,
                    589996,
                    524294,
                    524422,
                    524358,
                    590060,
                    459015,
                    524382,
                    524318,
                    589980,
                    459031,
                    524414,
                    524350,
                    590044,
                    459023,
                    524398,
                    524334,
                    590012,
                    524302,
                    524430,
                    524366,
                    590076,
                    459008,
                    524369,
                    524305,
                    524569,
                    459024,
                    524401,
                    524337,
                    590018,
                    459016,
                    524385,
                    524321,
                    589986,
                    524289,
                    524417,
                    524353,
                    590050,
                    459012,
                    524377,
                    524313,
                    589970,
                    459028,
                    524409,
                    524345,
                    590034,
                    459020,
                    524393,
                    524329,
                    590002,
                    524297,
                    524425,
                    524361,
                    590066,
                    459010,
                    524373,
                    524309,
                    524573,
                    459026,
                    524405,
                    524341,
                    590026,
                    459018,
                    524389,
                    524325,
                    589994,
                    524293,
                    524421,
                    524357,
                    590058,
                    459014,
                    524381,
                    524317,
                    589978,
                    459030,
                    524413,
                    524349,
                    590042,
                    459022,
                    524397,
                    524333,
                    590010,
                    524301,
                    524429,
                    524365,
                    590074,
                    459009,
                    524371,
                    524307,
                    524571,
                    459025,
                    524403,
                    524339,
                    590022,
                    459017,
                    524387,
                    524323,
                    589990,
                    524291,
                    524419,
                    524355,
                    590054,
                    459013,
                    524379,
                    524315,
                    589974,
                    459029,
                    524411,
                    524347,
                    590038,
                    459021,
                    524395,
                    524331,
                    590006,
                    524299,
                    524427,
                    524363,
                    590070,
                    459011,
                    524375,
                    524311,
                    524575,
                    459027,
                    524407,
                    524343,
                    590030,
                    459019,
                    524391,
                    524327,
                    589998,
                    524295,
                    524423,
                    524359,
                    590062,
                    459015,
                    524383,
                    524319,
                    589982,
                    459031,
                    524415,
                    524351,
                    590046,
                    459023,
                    524399,
                    524335,
                    590014,
                    524303,
                    524431,
                    524367,
                    590078,
                    459008,
                    524368,
                    524304,
                    524568,
                    459024,
                    524400,
                    524336,
                    590017,
                    459016,
                    524384,
                    524320,
                    589985,
                    524288,
                    524416,
                    524352,
                    590049,
                    459012,
                    524376,
                    524312,
                    589969,
                    459028,
                    524408,
                    524344,
                    590033,
                    459020,
                    524392,
                    524328,
                    590001,
                    524296,
                    524424,
                    524360,
                    590065,
                    459010,
                    524372,
                    524308,
                    524572,
                    459026,
                    524404,
                    524340,
                    590025,
                    459018,
                    524388,
                    524324,
                    589993,
                    524292,
                    524420,
                    524356,
                    590057,
                    459014,
                    524380,
                    524316,
                    589977,
                    459030,
                    524412,
                    524348,
                    590041,
                    459022,
                    524396,
                    524332,
                    590009,
                    524300,
                    524428,
                    524364,
                    590073,
                    459009,
                    524370,
                    524306,
                    524570,
                    459025,
                    524402,
                    524338,
                    590021,
                    459017,
                    524386,
                    524322,
                    589989,
                    524290,
                    524418,
                    524354,
                    590053,
                    459013,
                    524378,
                    524314,
                    589973,
                    459029,
                    524410,
                    524346,
                    590037,
                    459021,
                    524394,
                    524330,
                    590005,
                    524298,
                    524426,
                    524362,
                    590069,
                    459011,
                    524374,
                    524310,
                    524574,
                    459027,
                    524406,
                    524342,
                    590029,
                    459019,
                    524390,
                    524326,
                    589997,
                    524294,
                    524422,
                    524358,
                    590061,
                    459015,
                    524382,
                    524318,
                    589981,
                    459031,
                    524414,
                    524350,
                    590045,
                    459023,
                    524398,
                    524334,
                    590013,
                    524302,
                    524430,
                    524366,
                    590077,
                    459008,
                    524369,
                    524305,
                    524569,
                    459024,
                    524401,
                    524337,
                    590019,
                    459016,
                    524385,
                    524321,
                    589987,
                    524289,
                    524417,
                    524353,
                    590051,
                    459012,
                    524377,
                    524313,
                    589971,
                    459028,
                    524409,
                    524345,
                    590035,
                    459020,
                    524393,
                    524329,
                    590003,
                    524297,
                    524425,
                    524361,
                    590067,
                    459010,
                    524373,
                    524309,
                    524573,
                    459026,
                    524405,
                    524341,
                    590027,
                    459018,
                    524389,
                    524325,
                    589995,
                    524293,
                    524421,
                    524357,
                    590059,
                    459014,
                    524381,
                    524317,
                    589979,
                    459030,
                    524413,
                    524349,
                    590043,
                    459022,
                    524397,
                    524333,
                    590011,
                    524301,
                    524429,
                    524365,
                    590075,
                    459009,
                    524371,
                    524307,
                    524571,
                    459025,
                    524403,
                    524339,
                    590023,
                    459017,
                    524387,
                    524323,
                    589991,
                    524291,
                    524419,
                    524355,
                    590055,
                    459013,
                    524379,
                    524315,
                    589975,
                    459029,
                    524411,
                    524347,
                    590039,
                    459021,
                    524395,
                    524331,
                    590007,
                    524299,
                    524427,
                    524363,
                    590071,
                    459011,
                    524375,
                    524311,
                    524575,
                    459027,
                    524407,
                    524343,
                    590031,
                    459019,
                    524391,
                    524327,
                    589999,
                    524295,
                    524423,
                    524359,
                    590063,
                    459015,
                    524383,
                    524319,
                    589983,
                    459031,
                    524415,
                    524351,
                    590047,
                    459023,
                    524399,
                    524335,
                    590015,
                    524303,
                    524431,
                    524367,
                    590079
                ]),
                9
            ], O = [
                new Uint32Array([
                    327680,
                    327696,
                    327688,
                    327704,
                    327684,
                    327700,
                    327692,
                    327708,
                    327682,
                    327698,
                    327690,
                    327706,
                    327686,
                    327702,
                    327694,
                    0,
                    327681,
                    327697,
                    327689,
                    327705,
                    327685,
                    327701,
                    327693,
                    327709,
                    327683,
                    327699,
                    327691,
                    327707,
                    327687,
                    327703,
                    327695,
                    0
                ]),
                5
            ];
            return (t.prototype = Object.create(St.prototype)).getBits = function(t) {
                for(var e, n = this.codeSize, r = this.codeBuf, i = this.bytes, o = this.bytesPos; n < t;)void 0 === (e = i[o++]) && B("Bad encoding in flate stream"), r |= e << n, n += 8;
                return e = r & (1 << t) - 1, this.codeBuf = r >> t, this.codeSize = n -= t, this.bytesPos = o, e;
            }, t.prototype.getCode = function(t) {
                for(var e = t[0], n = t[1], r = this.codeSize, i = this.codeBuf, o = this.bytes, a = this.bytesPos; r < n;){
                    var s;
                    void 0 === (s = o[a++]) && B("Bad encoding in flate stream"), i |= s << r, r += 8;
                }
                var h = e[i & (1 << n) - 1], c = h >> 16, l = 65535 & h;
                return (0 == r || r < c || 0 == c) && B("Bad encoding in flate stream"), this.codeBuf = i >> c, this.codeSize = r - c, this.bytesPos = a, l;
            }, t.prototype.generateHuffmanTable = function(t) {
                for(var e = t.length, n = 0, r = 0; r < e; ++r)t[r] > n && (n = t[r]);
                for(var i = 1 << n, o = new Uint32Array(i), a = 1, s = 0, h = 2; a <= n; ++a, s <<= 1, h <<= 1)for(var c = 0; c < e; ++c)if (t[c] == a) {
                    var l = 0, u = s;
                    for(r = 0; r < a; ++r)l = l << 1 | 1 & u, u >>= 1;
                    for(r = l; r < i; r += h)o[r] = a << 16 | c;
                    ++s;
                }
                return [
                    o,
                    n
                ];
            }, t.prototype.readBlock = function() {
                function t(t, e, n, r, i) {
                    for(var o = t.getBits(n) + r; 0 < o--;)e[h++] = i;
                }
                var e = this.getBits(3);
                if (1 & e && (this.eof = !0), 0 != (e >>= 1)) {
                    var n, r;
                    if (1 == e) n = q, r = O;
                    else if (2 == e) {
                        for(var i = this.getBits(5) + 257, o = this.getBits(5) + 1, a = this.getBits(4) + 4, s = Array(F.length), h = 0; h < a;)s[F[h++]] = this.getBits(3);
                        for(var c = this.generateHuffmanTable(s), l = 0, u = (h = 0, i + o), f = new Array(u); h < u;){
                            var d = this.getCode(c);
                            16 == d ? t(this, f, 2, 3, l) : 17 == d ? t(this, f, 3, 3, l = 0) : 18 == d ? t(this, f, 7, 11, l = 0) : f[h++] = l = d;
                        }
                        n = this.generateHuffmanTable(f.slice(0, i)), r = this.generateHuffmanTable(f.slice(i, u));
                    } else B("Unknown block type in flate stream");
                    for(var p = (I = this.buffer) ? I.length : 0, g = this.bufferLength;;){
                        var m = this.getCode(n);
                        if (m < 256) p <= g + 1 && (p = (I = this.ensureBuffer(g + 1)).length), I[g++] = m;
                        else {
                            if (256 == m) return void (this.bufferLength = g);
                            var w = (m = P[m -= 257]) >> 16;
                            0 < w && (w = this.getBits(w));
                            l = (65535 & m) + w;
                            m = this.getCode(r), 0 < (w = (m = E[m]) >> 16) && (w = this.getBits(w));
                            var y = (65535 & m) + w;
                            p <= g + l && (p = (I = this.ensureBuffer(g + l)).length);
                            for(var v = 0; v < l; ++v, ++g)I[g] = I[g - y];
                        }
                    }
                } else {
                    var b, x = this.bytes, S = this.bytesPos;
                    void 0 === (b = x[S++]) && B("Bad block header in flate stream");
                    var k = b;
                    void 0 === (b = x[S++]) && B("Bad block header in flate stream"), k |= b << 8, void 0 === (b = x[S++]) && B("Bad block header in flate stream");
                    var _ = b;
                    void 0 === (b = x[S++]) && B("Bad block header in flate stream"), (_ |= b << 8) != (65535 & ~k) && B("Bad uncompressed block length in flate stream"), this.codeBuf = 0, this.codeSize = 0;
                    var A = this.bufferLength, I = this.ensureBuffer(A + k), C = A + k;
                    this.bufferLength = C;
                    for(var T = A; T < C; ++T){
                        if (void 0 === (b = x[S++])) {
                            this.eof = !0;
                            break;
                        }
                        I[T] = b;
                    }
                    this.bytesPos = S;
                }
            }, t;
        }
        function B(t) {
            throw new Error(t);
        }
        function t(t) {
            var e = 0, n = t[e++], r = t[e++];
            -1 != n && -1 != r || B("Invalid header in flate stream"), 8 != (15 & n) && B("Unknown compression method in flate stream"), ((n << 8) + r) % 31 != 0 && B("Bad FCHECK in flate stream"), 32 & r && B("FDICT bit set in flate stream"), this.bytes = t, this.bytesPos = 2, this.codeSize = 0, this.codeBuf = 0, St.call(this);
        }
    }();
    return function(t) {
        if ("object" != typeof t.console) {
            t.console = {};
            for(var e, n, r = t.console, i = function() {}, o = [
                "memory"
            ], a = "assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(","); e = o.pop();)r[e] || (r[e] = {});
            for(; n = a.pop();)r[n] || (r[n] = i);
        }
        var s, h, c, l, u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        void 0 === t.btoa && (t.btoa = function(t) {
            var e, n, r, i, o, a = 0, s = 0, h = "", c = [];
            if (!t) return t;
            for(; e = (o = t.charCodeAt(a++) << 16 | t.charCodeAt(a++) << 8 | t.charCodeAt(a++)) >> 18 & 63, n = o >> 12 & 63, r = o >> 6 & 63, i = 63 & o, c[s++] = u.charAt(e) + u.charAt(n) + u.charAt(r) + u.charAt(i), a < t.length;);
            h = c.join("");
            var l = t.length % 3;
            return (l ? h.slice(0, l - 3) : h) + "===".slice(l || 3);
        }), void 0 === t.atob && (t.atob = function(t) {
            var e, n, r, i, o, a, s = 0, h = 0, c = [];
            if (!t) return t;
            for(t += ""; e = (a = u.indexOf(t.charAt(s++)) << 18 | u.indexOf(t.charAt(s++)) << 12 | (i = u.indexOf(t.charAt(s++))) << 6 | (o = u.indexOf(t.charAt(s++)))) >> 16 & 255, n = a >> 8 & 255, r = 255 & a, c[h++] = 64 == i ? String.fromCharCode(e) : 64 == o ? String.fromCharCode(e, n) : String.fromCharCode(e, n, r), s < t.length;);
            return c.join("");
        }), Array.prototype.map || (Array.prototype.map = function(t) {
            if (null == this || "function" != typeof t) throw new TypeError;
            for(var e = Object(this), n = e.length >>> 0, r = new Array(n), i = 1 < arguments.length ? arguments[1] : void 0, o = 0; o < n; o++)o in e && (r[o] = t.call(i, e[o], o, e));
            return r;
        }), Array.isArray || (Array.isArray = function(t) {
            return "[object Array]" === Object.prototype.toString.call(t);
        }), Array.prototype.forEach || (Array.prototype.forEach = function(t, e) {
            if (null == this || "function" != typeof t) throw new TypeError;
            for(var n = Object(this), r = n.length >>> 0, i = 0; i < r; i++)i in n && t.call(e, n[i], i, n);
        }), Object.keys || (Object.keys = (s = Object.prototype.hasOwnProperty, h = !({
            toString: null
        }).propertyIsEnumerable("toString"), l = (c = [
            "toString",
            "toLocaleString",
            "valueOf",
            "hasOwnProperty",
            "isPrototypeOf",
            "propertyIsEnumerable",
            "constructor"
        ]).length, function(t) {
            if ("object" != typeof t && ("function" != typeof t || null === t)) throw new TypeError;
            var e, n, r = [];
            for(e in t)s.call(t, e) && r.push(e);
            if (h) for(n = 0; n < l; n++)s.call(t, c[n]) && r.push(c[n]);
            return r;
        })), "function" != typeof Object.assign && (Object.assign = function(t) {
            if (null == t) throw new TypeError("Cannot convert undefined or null to object");
            t = Object(t);
            for(var e = 1; e < arguments.length; e++){
                var n = arguments[e];
                if (null != n) for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
            }
            return t;
        }), String.prototype.trim || (String.prototype.trim = function() {
            return this.replace(/^\s+|\s+$/g, "");
        }), String.prototype.trimLeft || (String.prototype.trimLeft = function() {
            return this.replace(/^\s+/g, "");
        }), String.prototype.trimRight || (String.prototype.trimRight = function() {
            return this.replace(/\s+$/g, "");
        });
    }("undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")()), $;
});

});
parcelRequire.register("7dgut", function(module, exports) {
// shim for using process in browser
var $540689f746aefe05$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $540689f746aefe05$var$cachedSetTimeout;
var $540689f746aefe05$var$cachedClearTimeout;
function $540689f746aefe05$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $540689f746aefe05$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $540689f746aefe05$var$cachedSetTimeout = setTimeout;
        else $540689f746aefe05$var$cachedSetTimeout = $540689f746aefe05$var$defaultSetTimout;
    } catch (e) {
        $540689f746aefe05$var$cachedSetTimeout = $540689f746aefe05$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $540689f746aefe05$var$cachedClearTimeout = clearTimeout;
        else $540689f746aefe05$var$cachedClearTimeout = $540689f746aefe05$var$defaultClearTimeout;
    } catch (e) {
        $540689f746aefe05$var$cachedClearTimeout = $540689f746aefe05$var$defaultClearTimeout;
    }
})();
function $540689f746aefe05$var$runTimeout(fun) {
    if ($540689f746aefe05$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($540689f746aefe05$var$cachedSetTimeout === $540689f746aefe05$var$defaultSetTimout || !$540689f746aefe05$var$cachedSetTimeout) && setTimeout) {
        $540689f746aefe05$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $540689f746aefe05$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $540689f746aefe05$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $540689f746aefe05$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $540689f746aefe05$var$runClearTimeout(marker) {
    if ($540689f746aefe05$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($540689f746aefe05$var$cachedClearTimeout === $540689f746aefe05$var$defaultClearTimeout || !$540689f746aefe05$var$cachedClearTimeout) && clearTimeout) {
        $540689f746aefe05$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $540689f746aefe05$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $540689f746aefe05$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $540689f746aefe05$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $540689f746aefe05$var$queue = [];
var $540689f746aefe05$var$draining = false;
var $540689f746aefe05$var$currentQueue;
var $540689f746aefe05$var$queueIndex = -1;
function $540689f746aefe05$var$cleanUpNextTick() {
    if (!$540689f746aefe05$var$draining || !$540689f746aefe05$var$currentQueue) return;
    $540689f746aefe05$var$draining = false;
    if ($540689f746aefe05$var$currentQueue.length) $540689f746aefe05$var$queue = $540689f746aefe05$var$currentQueue.concat($540689f746aefe05$var$queue);
    else $540689f746aefe05$var$queueIndex = -1;
    if ($540689f746aefe05$var$queue.length) $540689f746aefe05$var$drainQueue();
}
function $540689f746aefe05$var$drainQueue() {
    if ($540689f746aefe05$var$draining) return;
    var timeout = $540689f746aefe05$var$runTimeout($540689f746aefe05$var$cleanUpNextTick);
    $540689f746aefe05$var$draining = true;
    var len = $540689f746aefe05$var$queue.length;
    while(len){
        $540689f746aefe05$var$currentQueue = $540689f746aefe05$var$queue;
        $540689f746aefe05$var$queue = [];
        while(++$540689f746aefe05$var$queueIndex < len)if ($540689f746aefe05$var$currentQueue) $540689f746aefe05$var$currentQueue[$540689f746aefe05$var$queueIndex].run();
        $540689f746aefe05$var$queueIndex = -1;
        len = $540689f746aefe05$var$queue.length;
    }
    $540689f746aefe05$var$currentQueue = null;
    $540689f746aefe05$var$draining = false;
    $540689f746aefe05$var$runClearTimeout(timeout);
}
$540689f746aefe05$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $540689f746aefe05$var$queue.push(new $540689f746aefe05$var$Item(fun, args));
    if ($540689f746aefe05$var$queue.length === 1 && !$540689f746aefe05$var$draining) $540689f746aefe05$var$runTimeout($540689f746aefe05$var$drainQueue);
};
// v8 likes predictible objects
function $540689f746aefe05$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$540689f746aefe05$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$540689f746aefe05$var$process.title = "browser";
$540689f746aefe05$var$process.browser = true;
$540689f746aefe05$var$process.env = {};
$540689f746aefe05$var$process.argv = [];
$540689f746aefe05$var$process.version = ""; // empty string to avoid regexp issues
$540689f746aefe05$var$process.versions = {};
function $540689f746aefe05$var$noop() {}
$540689f746aefe05$var$process.on = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.addListener = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.once = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.off = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.removeListener = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.removeAllListeners = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.emit = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.prependListener = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.prependOnceListener = $540689f746aefe05$var$noop;
$540689f746aefe05$var$process.listeners = function(name) {
    return [];
};
$540689f746aefe05$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$540689f746aefe05$var$process.cwd = function() {
    return "/";
};
$540689f746aefe05$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$540689f746aefe05$var$process.umask = function() {
    return 0;
};

});


parcelRequire.register("bEEeD", function(module, exports) {
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return "";
        var codeUnits = [];
        var index = -1;
        var result = "";
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === "=") {
            bufferLength--;
            if (base64[base64.length - 2] === "=") bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = "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";
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = "!";
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = "strict";
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                "normal",
                "auto",
                "loose"
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === "strict" ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: "normal",
            wordBreak: "normal"
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === "break-all" || options.wordBreak === "break-word") classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === "keep-all" ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === "undefined" ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === "url" && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ""
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = "";
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = "";
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = "";
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === "undefined" ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== "undefined" ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case "rem":
            case "em":
                return 16 * token.number; // TODO use correct font-size
            case "px":
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = "deg";
    var GRAD = "grad";
    var RAD = "rad";
    var TURN = "turn";
    var angle = {
        name: "angle",
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(" ");
        switch(sideOrCorner){
            case "to bottom right":
            case "to right bottom":
            case "left top":
            case "top left":
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case "to top":
            case "bottom":
                return deg(0);
            case "to bottom left":
            case "to left bottom":
            case "right top":
            case "top right":
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case "to right":
            case "left":
                return deg(90);
            case "to top left":
            case "to left top":
            case "right bottom":
            case "bottom right":
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case "to bottom":
            case "top":
                return deg(180);
            case "to top right":
            case "to right top":
            case "left bottom":
            case "bottom left":
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case "to left":
            case "right":
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: "color",
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === "undefined") throw new Error('Attempting to parse an unsupported color function "' + value.name + '"');
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== "undefined") return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== "undefined" && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: "background-clip",
        initialValue: "border-box",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case "padding-box":
                        return 1 /* PADDING_BOX */ ;
                    case "content-box":
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === "number" ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === "to") {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    "top",
                    "left",
                    "right",
                    "bottom"
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === "linear") {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === "radial") {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === "from") {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === "to") {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === "color-stop") {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = "closest-side";
    var FARTHEST_SIDE = "farthest-side";
    var CLOSEST_CORNER = "closest-corner";
    var FARTHEST_CORNER = "farthest-corner";
    var CIRCLE = "circle";
    var ELLIPSE = "ellipse";
    var COVER = "cover";
    var CONTAIN = "contain";
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case "center":
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case "top":
                            case "left":
                                position.push(ZERO_LENGTH);
                                return acc;
                            case "right":
                            case "bottom":
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case "at":
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case "center":
                        position.push(FIFTY_PERCENT);
                        return false;
                    case "top":
                    case "left":
                        position.push(ZERO_LENGTH);
                        return false;
                    case "right":
                    case "bottom":
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: "image",
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === "undefined") throw new Error('Attempting to parse an unsupported image function "' + value.name + '"');
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === "none") && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        "linear-gradient": linearGradient,
        "-moz-linear-gradient": prefixLinearGradient,
        "-ms-linear-gradient": prefixLinearGradient,
        "-o-linear-gradient": prefixLinearGradient,
        "-webkit-linear-gradient": prefixLinearGradient,
        "radial-gradient": radialGradient,
        "-moz-radial-gradient": prefixRadialGradient,
        "-ms-radial-gradient": prefixRadialGradient,
        "-o-radial-gradient": prefixRadialGradient,
        "-webkit-radial-gradient": prefixRadialGradient,
        "-webkit-gradient": webkitGradient
    };
    var backgroundImage = {
        name: "background-image",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: "background-origin",
        initialValue: "border-box",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case "padding-box":
                        return 1 /* PADDING_BOX */ ;
                    case "content-box":
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: "background-position",
        initialValue: "0% 0%",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: "background-repeat",
        initialValue: "repeat",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(" ");
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case "no-repeat":
                return 1 /* NO_REPEAT */ ;
            case "repeat-x":
            case "repeat no-repeat":
                return 2 /* REPEAT_X */ ;
            case "repeat-y":
            case "no-repeat repeat":
                return 3 /* REPEAT_Y */ ;
            case "repeat":
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: "background-size",
        initialValue: "0",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: "transparent",
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: "color"
        };
    };
    var borderTopColor = borderColorForSide("top");
    var borderRightColor = borderColorForSide("right");
    var borderBottomColor = borderColorForSide("bottom");
    var borderLeftColor = borderColorForSide("left");
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: "0 0",
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide("top-left");
    var borderTopRightRadius = borderRadiusForSide("top-right");
    var borderBottomRightRadius = borderRadiusForSide("bottom-right");
    var borderBottomLeftRadius = borderRadiusForSide("bottom-left");
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: "solid",
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case "none":
                        return 0 /* NONE */ ;
                    case "dashed":
                        return 2 /* DASHED */ ;
                    case "dotted":
                        return 3 /* DOTTED */ ;
                    case "double":
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide("top");
    var borderRightStyle = borderStyleForSide("right");
    var borderBottomStyle = borderStyleForSide("bottom");
    var borderLeftStyle = borderStyleForSide("left");
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: "0",
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide("top");
    var borderRightWidth = borderWidthForSide("right");
    var borderBottomWidth = borderWidthForSide("bottom");
    var borderLeftWidth = borderWidthForSide("left");
    var color = {
        name: "color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var direction = {
        name: "direction",
        initialValue: "ltr",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case "rtl":
                    return 1 /* RTL */ ;
                case "ltr":
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: "display",
        initialValue: "inline-block",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case "block":
            case "-webkit-box":
                return 2 /* BLOCK */ ;
            case "inline":
                return 4 /* INLINE */ ;
            case "run-in":
                return 8 /* RUN_IN */ ;
            case "flow":
                return 16 /* FLOW */ ;
            case "flow-root":
                return 32 /* FLOW_ROOT */ ;
            case "table":
                return 64 /* TABLE */ ;
            case "flex":
            case "-webkit-flex":
                return 128 /* FLEX */ ;
            case "grid":
            case "-ms-grid":
                return 256 /* GRID */ ;
            case "ruby":
                return 512 /* RUBY */ ;
            case "subgrid":
                return 1024 /* SUBGRID */ ;
            case "list-item":
                return 2048 /* LIST_ITEM */ ;
            case "table-row-group":
                return 4096 /* TABLE_ROW_GROUP */ ;
            case "table-header-group":
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case "table-footer-group":
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case "table-row":
                return 32768 /* TABLE_ROW */ ;
            case "table-cell":
                return 65536 /* TABLE_CELL */ ;
            case "table-column-group":
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case "table-column":
                return 262144 /* TABLE_COLUMN */ ;
            case "table-caption":
                return 524288 /* TABLE_CAPTION */ ;
            case "ruby-base":
                return 1048576 /* RUBY_BASE */ ;
            case "ruby-text":
                return 2097152 /* RUBY_TEXT */ ;
            case "ruby-base-container":
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case "ruby-text-container":
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case "contents":
                return 16777216 /* CONTENTS */ ;
            case "inline-block":
                return 33554432 /* INLINE_BLOCK */ ;
            case "inline-list-item":
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case "inline-table":
                return 134217728 /* INLINE_TABLE */ ;
            case "inline-flex":
                return 268435456 /* INLINE_FLEX */ ;
            case "inline-grid":
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: "float",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case "left":
                    return 1 /* LEFT */ ;
                case "right":
                    return 2 /* RIGHT */ ;
                case "inline-start":
                    return 3 /* INLINE_START */ ;
                case "inline-end":
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: "letter-spacing",
        initialValue: "0",
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "normal") return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: "line-break",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case "strict":
                    return LINE_BREAK.STRICT;
                case "normal":
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: "line-height",
        initialValue: "normal",
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === "normal") return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: "list-style-image",
        initialValue: "none",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "none") return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: "list-style-position",
        initialValue: "outside",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case "inside":
                    return 0 /* INSIDE */ ;
                case "outside":
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: "list-style-type",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case "disc":
                    return 0 /* DISC */ ;
                case "circle":
                    return 1 /* CIRCLE */ ;
                case "square":
                    return 2 /* SQUARE */ ;
                case "decimal":
                    return 3 /* DECIMAL */ ;
                case "cjk-decimal":
                    return 4 /* CJK_DECIMAL */ ;
                case "decimal-leading-zero":
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case "lower-roman":
                    return 6 /* LOWER_ROMAN */ ;
                case "upper-roman":
                    return 7 /* UPPER_ROMAN */ ;
                case "lower-greek":
                    return 8 /* LOWER_GREEK */ ;
                case "lower-alpha":
                    return 9 /* LOWER_ALPHA */ ;
                case "upper-alpha":
                    return 10 /* UPPER_ALPHA */ ;
                case "arabic-indic":
                    return 11 /* ARABIC_INDIC */ ;
                case "armenian":
                    return 12 /* ARMENIAN */ ;
                case "bengali":
                    return 13 /* BENGALI */ ;
                case "cambodian":
                    return 14 /* CAMBODIAN */ ;
                case "cjk-earthly-branch":
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case "cjk-heavenly-stem":
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case "cjk-ideographic":
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case "devanagari":
                    return 18 /* DEVANAGARI */ ;
                case "ethiopic-numeric":
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case "georgian":
                    return 20 /* GEORGIAN */ ;
                case "gujarati":
                    return 21 /* GUJARATI */ ;
                case "gurmukhi":
                    return 22 /* GURMUKHI */ ;
                case "hebrew":
                    return 22 /* HEBREW */ ;
                case "hiragana":
                    return 23 /* HIRAGANA */ ;
                case "hiragana-iroha":
                    return 24 /* HIRAGANA_IROHA */ ;
                case "japanese-formal":
                    return 25 /* JAPANESE_FORMAL */ ;
                case "japanese-informal":
                    return 26 /* JAPANESE_INFORMAL */ ;
                case "kannada":
                    return 27 /* KANNADA */ ;
                case "katakana":
                    return 28 /* KATAKANA */ ;
                case "katakana-iroha":
                    return 29 /* KATAKANA_IROHA */ ;
                case "khmer":
                    return 30 /* KHMER */ ;
                case "korean-hangul-formal":
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case "korean-hanja-formal":
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case "korean-hanja-informal":
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case "lao":
                    return 34 /* LAO */ ;
                case "lower-armenian":
                    return 35 /* LOWER_ARMENIAN */ ;
                case "malayalam":
                    return 36 /* MALAYALAM */ ;
                case "mongolian":
                    return 37 /* MONGOLIAN */ ;
                case "myanmar":
                    return 38 /* MYANMAR */ ;
                case "oriya":
                    return 39 /* ORIYA */ ;
                case "persian":
                    return 40 /* PERSIAN */ ;
                case "simp-chinese-formal":
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case "simp-chinese-informal":
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case "tamil":
                    return 43 /* TAMIL */ ;
                case "telugu":
                    return 44 /* TELUGU */ ;
                case "thai":
                    return 45 /* THAI */ ;
                case "tibetan":
                    return 46 /* TIBETAN */ ;
                case "trad-chinese-formal":
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case "trad-chinese-informal":
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case "upper-armenian":
                    return 49 /* UPPER_ARMENIAN */ ;
                case "disclosure-open":
                    return 50 /* DISCLOSURE_OPEN */ ;
                case "disclosure-closed":
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case "none":
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: "0",
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide("top");
    var marginRight = marginForSide("right");
    var marginBottom = marginForSide("bottom");
    var marginLeft = marginForSide("left");
    var overflow = {
        name: "overflow",
        initialValue: "visible",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case "hidden":
                        return 1 /* HIDDEN */ ;
                    case "scroll":
                        return 2 /* SCROLL */ ;
                    case "clip":
                        return 3 /* CLIP */ ;
                    case "auto":
                        return 4 /* AUTO */ ;
                    case "visible":
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: "overflow-wrap",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case "break-word":
                    return "break-word" /* BREAK_WORD */ ;
                case "normal":
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: "0",
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: "length-percentage"
        };
    };
    var paddingTop = paddingForSide("top");
    var paddingRight = paddingForSide("right");
    var paddingBottom = paddingForSide("bottom");
    var paddingLeft = paddingForSide("left");
    var textAlign = {
        name: "text-align",
        initialValue: "left",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case "right":
                    return 2 /* RIGHT */ ;
                case "center":
                case "justify":
                    return 1 /* CENTER */ ;
                case "left":
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: "position",
        initialValue: "static",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case "relative":
                    return 1 /* RELATIVE */ ;
                case "absolute":
                    return 2 /* ABSOLUTE */ ;
                case "fixed":
                    return 3 /* FIXED */ ;
                case "sticky":
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: "text-shadow",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: "text-transform",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case "uppercase":
                    return 2 /* UPPERCASE */ ;
                case "lowercase":
                    return 1 /* LOWERCASE */ ;
                case "capitalize":
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: "transform",
        initialValue: "none",
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "none") return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === "undefined") throw new Error('Attempting to parse an unsupported transform function "' + token.name + '"');
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: "transform-origin",
        initialValue: "50% 50%",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: "visible",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case "hidden":
                    return 1 /* HIDDEN */ ;
                case "collapse":
                    return 2 /* COLLAPSE */ ;
                case "visible":
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: "word-break",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case "break-all":
                    return WORD_BREAK.BREAK_ALL;
                case "keep-all":
                    return WORD_BREAK.KEEP_ALL;
                case "normal":
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: "z-index",
        initialValue: "auto",
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: "time",
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case "s":
                    return 1000 * value.number;
                case "ms":
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: "opacity",
        initialValue: "1",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var textDecorationLine = {
        name: "text-decoration-line",
        initialValue: "none",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case "underline":
                        return 1 /* UNDERLINE */ ;
                    case "overline":
                        return 2 /* OVERLINE */ ;
                    case "line-through":
                        return 3 /* LINE_THROUGH */ ;
                    case "none":
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: "",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(" "));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(" "));
            return results.map(function(result) {
                return result.indexOf(" ") === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: "0",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "length"
    };
    var fontWeight = {
        name: "font-weight",
        initialValue: "normal",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case "bold":
                    return 700;
                case "normal":
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: "font-variant",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: "font-style",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case "oblique":
                    return "oblique" /* OBLIQUE */ ;
                case "italic":
                    return "italic" /* ITALIC */ ;
                case "normal":
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: "content",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: "counter-increment",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: "counter-reset",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== "none") {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: "duration",
        initialValue: "0s",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: "quotes",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return "";
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return "";
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: "box-shadow",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, "inset")) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: "paint-order",
        initialValue: "normal",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case "stroke":
                        layers.push(1 /* STROKE */ );
                        break;
                    case "fill":
                        layers.push(0 /* FILL */ );
                        break;
                    case "markers":
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: "currentcolor",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: "0",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== "undefined" ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case "angle":
                        return angle.parse(context, parser.parseComponentValue());
                    case "color":
                        return color$1.parse(context, parser.parseComponentValue());
                    case "image":
                        return image.parse(context, parser.parseComponentValue());
                    case "length":
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case "length-percentage":
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case "time":
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = "data-html2canvas-debug";
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case "all":
                return 1 /* ALL */ ;
            case "clone":
                return 2 /* CLONE */ ;
            case "parse":
                return 3 /* PARSE */ ;
            case "render":
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = "0s";
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = "none";
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = "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";
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === "=") {
            bufferLength--;
            if (base64[base64.length - 2] === "=") bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return "";
        var codeUnits = [];
        var index = -1;
        var result = "";
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement("boundtest");
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = "block";
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement("boundtest");
        testElement.style.width = "50px";
        testElement.style.display = "block";
        testElement.style.fontSize = "12px";
        testElement.style.letterSpacing = "0px";
        testElement.style.wordSpacing = "0px";
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof "".repeat === "function" ? "&#128104;".repeat(10) : "";
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== "undefined";
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === "string";
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement("canvas");
        var ctx = canvas.getContext("2d");
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement("canvas");
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext("2d");
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = "rgb(0, 255, 0)";
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = "red";
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = "red";
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement("div");
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = "http://www.w3.org/2000/svg";
        var svg = document.createElementNS(xmlns, "svg");
        var foreignObject = document.createElementNS(xmlns, "foreignObject");
        svg.setAttributeNS(null, "width", width.toString());
        svg.setAttributeNS(null, "height", height.toString());
        foreignObject.setAttributeNS(null, "width", "100%");
        foreignObject.setAttributeNS(null, "height", "100%");
        foreignObject.setAttributeNS(null, "x", x.toString());
        foreignObject.setAttributeNS(null, "y", y.toString());
        foreignObject.setAttributeNS(null, "externalResourcesRequired", "true");
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, "SUPPORT_RANGE_BOUNDS", {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, "SUPPORT_WORD_BREAKING", {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, "SUPPORT_SVG_DRAWING", {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === "function" && typeof window.fetch === "function" ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, "SUPPORT_FOREIGNOBJECT_DRAWING", {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_IMAGES", {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, "SUPPORT_RESPONSE_TYPE", {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = "withCredentials" in new XMLHttpRequest();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_XHR", {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== "undefined" && Intl.Segmenter);
            Object.defineProperty(FEATURES, "SUPPORT_NATIVE_TEXT_SEGMENTATION", {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement("html2canvaswrapper");
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error("Node has no owner document");
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: "grapheme"
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: "word"
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? "break-word" : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = "";
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = "";
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute("width", bounds.width + "px");
            img.setAttribute("height", bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === "boolean" && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: "px",
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join("•") : node.value;
        return value.length === 0 ? node.placeholder || "" : value;
    };
    var CHECKBOX = "checkbox";
    var RADIO = "radio";
    var PASSWORD = "password";
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || "" : "";
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        "OL",
        "UL",
        "MENU"
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== "undefined" && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === "object";
    };
    var isLIElement = function(node) {
        return node.tagName === "LI";
    };
    var isOLElement = function(node) {
        return node.tagName === "OL";
    };
    var isInputElement = function(node) {
        return node.tagName === "INPUT";
    };
    var isHTMLElement = function(node) {
        return node.tagName === "HTML";
    };
    var isSVGElement = function(node) {
        return node.tagName === "svg";
    };
    var isBodyElement = function(node) {
        return node.tagName === "BODY";
    };
    var isCanvasElement = function(node) {
        return node.tagName === "CANVAS";
    };
    var isVideoElement = function(node) {
        return node.tagName === "VIDEO";
    };
    var isImageElement = function(node) {
        return node.tagName === "IMG";
    };
    var isIFrameElement = function(node) {
        return node.tagName === "IFRAME";
    };
    var isStyleElement = function(node) {
        return node.tagName === "STYLE";
    };
    var isScriptElement = function(node) {
        return node.tagName === "SCRIPT";
    };
    var isTextareaElement = function(node) {
        return node.tagName === "TEXTAREA";
    };
    var isSelectElement = function(node) {
        return node.tagName === "SELECT";
    };
    var isSlotElement = function(node) {
        return node.tagName === "SLOT";
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf("-") > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            "M",
            "CM",
            "D",
            "CD",
            "C",
            "XC",
            "L",
            "XL",
            "X",
            "IX",
            "V",
            "IV",
            "I"
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "Ք",
            "Փ",
            "Ւ",
            "Ց",
            "Ր",
            "Տ",
            "Վ",
            "Ս",
            "Ռ",
            "Ջ",
            "Պ",
            "Չ",
            "Ո",
            "Շ",
            "Ն",
            "Յ",
            "Մ",
            "Ճ",
            "Ղ",
            "Ձ",
            "Հ",
            "Կ",
            "Ծ",
            "Խ",
            "Լ",
            "Ի",
            "Ժ",
            "Թ",
            "Ը",
            "Է",
            "Զ",
            "Ե",
            "Դ",
            "Գ",
            "Բ",
            "Ա"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "י׳",
            "ט׳",
            "ח׳",
            "ז׳",
            "ו׳",
            "ה׳",
            "ד׳",
            "ג׳",
            "ב׳",
            "א׳",
            "ת",
            "ש",
            "ר",
            "ק",
            "צ",
            "פ",
            "ע",
            "ס",
            "נ",
            "מ",
            "ל",
            "כ",
            "יט",
            "יח",
            "יז",
            "טז",
            "טו",
            "י",
            "ט",
            "ח",
            "ז",
            "ו",
            "ה",
            "ד",
            "ג",
            "ב",
            "א"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "ჵ",
            "ჰ",
            "ჯ",
            "ჴ",
            "ხ",
            "ჭ",
            "წ",
            "ძ",
            "ც",
            "ჩ",
            "შ",
            "ყ",
            "ღ",
            "ქ",
            "ფ",
            "ჳ",
            "ტ",
            "ს",
            "რ",
            "ჟ",
            "პ",
            "ო",
            "ჲ",
            "ნ",
            "მ",
            "ლ",
            "კ",
            "ი",
            "თ",
            "ჱ",
            "ზ",
            "ვ",
            "ე",
            "დ",
            "გ",
            "ბ",
            "ა"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, "") + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = "";
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? "-" : "") + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = ". ";
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== "") string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : "") + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : "") + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "十百千萬";
    var CHINESE_FORMAL_MULTIPLIERS = "拾佰仟萬";
    var JAPANESE_NEGATIVE = "マイナス";
    var KOREAN_NEGATIVE = "마이너스";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? ". " : "";
        var cjkSuffix = appendSuffix ? "、" : "";
        var koreanSuffix = appendSuffix ? ", " : "";
        var spaceSuffix = appendSuffix ? " " : "";
        switch(type){
            case 0 /* DISC */ :
                return "•" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "◦" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "◾" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "〇一二三四五六七八九", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "子丑寅卯辰巳午未申酉戌亥", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "甲乙丙丁戊己庚辛壬癸", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "零一二三四五六七八九", CHINESE_INFORMAL_MULTIPLIERS, "負", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "零壹貳參肆伍陸柒捌玖", CHINESE_FORMAL_MULTIPLIERS, "負", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "零一二三四五六七八九", CHINESE_INFORMAL_MULTIPLIERS, "负", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "零壹贰叁肆伍陆柒捌玖", CHINESE_FORMAL_MULTIPLIERS, "负", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "〇一二三四五六七八九", "十百千万", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "零壱弐参四伍六七八九", "拾百千万", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "영일이삼사오육칠팔구", "십백천만", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "零一二三四五六七八九", "十百千萬", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "零壹貳參四五六七八九", "拾百千", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = "data-html2canvas-ignore";
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error("Cloned element does not have an owner document");
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn("Unable to restore scroll position for cloned document");
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === "undefined") return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === "function") return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = "";
                }
                if (clone.loading === "lazy") clone.loading = "eager";
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement("html2canvascustomelement");
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === "string") return css + rule.cssText;
                        return css;
                    }, "");
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error("Unable to access cssRules property", e);
                if (e.name !== "SecurityError") throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement("img");
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext("2d");
                var clonedCtx = clonedCanvas.getContext("2d");
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext("webgl2")) !== null && _a !== void 0 ? _a : canvas.getContext("webgl");
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement("canvas");
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext("2d");
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement("canvas");
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== "function" || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === "function") {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = "none";
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ":before");
                var styleAfter = window1.getComputedStyle(node, ":after");
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === "none" || value === "-moz-alt-content" || style.display === "none") return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement("html2canvaspseudoelement");
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement("img");
                    img.src = token.value;
                    img.style.opacity = "1";
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === "attr") {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ""));
                    } else if (token.name === "counter") {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === "counters") {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : "";
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case "open-quote":
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case "close-quote":
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement("iframe");
        cloneIframeContainer.className = "html2canvas-container";
        cloneIframeContainer.style.visibility = "hidden";
        cloneIframeContainer.style.position = "fixed";
        cloneIframeContainer.style.left = "-10000px";
        cloneIframeContainer.style.top = "0px";
        cloneIframeContainer.style.border = "0";
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = "no"; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, "true");
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === "complete") {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        "all",
        "d",
        "content" // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = "";
        if (doctype) {
            str += "<!DOCTYPE ";
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += '"' + doctype.publicId + '"';
            if (doctype.systemId) str += '"' + doctype.systemId + '"';
            str += ">";
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ":before";
    var PSEUDO_AFTER = ":after";
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = "___html2canvas___pseudoelement_before";
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = "___html2canvas___pseudoelement_after";
    var PSEUDO_HIDE_ELEMENT_STYLE = '{\n    content: "" !important;\n    display: none !important;\n}';
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement("style");
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return "about:blank";
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement("a");
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = "about:blank";
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === "string" && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = "anonymous";
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== "undefined";
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error("No proxy defined");
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? "blob" : "text";
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === "text") resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener("load", function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener("error", function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf("?") > -1 ? "&" : "?";
                xhr.open("GET", "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== "text" && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === "blob";
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === "svg" || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === "number" && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === "number";
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === "undefined") return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    var SAMPLE_TEXT = "Hidden Text";
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement("div");
            var img = this._document.createElement("img");
            var span = this._document.createElement("span");
            var body = this._document.body;
            container.style.visibility = "hidden";
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = "0";
            container.style.padding = "0";
            container.style.whiteSpace = "nowrap";
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = "0";
            img.style.padding = "0";
            img.style.verticalAlign = "baseline";
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = "0";
            span.style.padding = "0";
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = "normal";
            img.style.verticalAlign = "super";
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === "undefined") this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            _this.ctx = _this.canvas.getContext("2d");
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = "bottom";
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === "normal" || variant === "small-caps";
            }).join("");
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(", ");
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(" "),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? "rtl" : "ltr";
                    this.ctx.textAlign = "left";
                    this.ctx.textBaseline = "alphabetic";
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = "";
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? "miter" : "round";
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = "";
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = "miter";
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = "alphabetic";
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = "alphabetic";
                                this.ctx.textAlign = "left";
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = "middle";
                                this.ctx.textAlign = "right";
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = "bottom";
                                this.ctx.textAlign = "left";
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement("canvas");
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), "repeat");
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement("canvas");
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext("2d");
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, "repeat");
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : "rgba(0,0,0,1)";
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = "round";
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return "center";
            case 2 /* RIGHT */ :
                return "right";
            case 0 /* LEFT */ :
            default:
                return "left";
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        "-apple-system",
        "system-ui"
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            _this.ctx = _this.canvas.getContext("2d");
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.debug === "function") // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== "undefined" && window.console && typeof console.info === "function") // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.warn === "function") // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.error === "function") // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== "undefined") CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== "object") return [
                            2 /*return*/ ,
                            Promise.reject("Invalid element provided as first argument")
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === "string" ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});

});





var $cQNHH = parcelRequire("cQNHH");
var $a9f83e4b0471c6a5$exports = {};
function $a9f83e4b0471c6a5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$a9f83e4b0471c6a5$exports = $a9f83e4b0471c6a5$var$_classCallCheck, $a9f83e4b0471c6a5$exports.__esModule = true, $a9f83e4b0471c6a5$exports["default"] = $a9f83e4b0471c6a5$exports;


var $9f3907a168aa1363$exports = {};
var $e812de78b1ad752e$exports = {};
var $92c821aaa75261e8$exports = {};
function $92c821aaa75261e8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $92c821aaa75261e8$exports = $92c821aaa75261e8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $92c821aaa75261e8$exports.__esModule = true, $92c821aaa75261e8$exports["default"] = $92c821aaa75261e8$exports, $92c821aaa75261e8$var$_typeof(obj);
}
$92c821aaa75261e8$exports = $92c821aaa75261e8$var$_typeof, $92c821aaa75261e8$exports.__esModule = true, $92c821aaa75261e8$exports["default"] = $92c821aaa75261e8$exports;


var $e812de78b1ad752e$var$_typeof = $92c821aaa75261e8$exports.default;
var $ec17919703ef27d5$exports = {};

var $ec17919703ef27d5$var$_typeof = $92c821aaa75261e8$exports.default;
function $ec17919703ef27d5$var$_toPrimitive(input, hint) {
    if ($ec17919703ef27d5$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ec17919703ef27d5$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
$ec17919703ef27d5$exports = $ec17919703ef27d5$var$_toPrimitive, $ec17919703ef27d5$exports.__esModule = true, $ec17919703ef27d5$exports["default"] = $ec17919703ef27d5$exports;


function $e812de78b1ad752e$var$_toPropertyKey(arg) {
    var key = $ec17919703ef27d5$exports(arg, "string");
    return $e812de78b1ad752e$var$_typeof(key) === "symbol" ? key : String(key);
}
$e812de78b1ad752e$exports = $e812de78b1ad752e$var$_toPropertyKey, $e812de78b1ad752e$exports.__esModule = true, $e812de78b1ad752e$exports["default"] = $e812de78b1ad752e$exports;


function $9f3907a168aa1363$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e812de78b1ad752e$exports(descriptor.key), descriptor);
    }
}
function $9f3907a168aa1363$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9f3907a168aa1363$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9f3907a168aa1363$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
$9f3907a168aa1363$exports = $9f3907a168aa1363$var$_createClass, $9f3907a168aa1363$exports.__esModule = true, $9f3907a168aa1363$exports["default"] = $9f3907a168aa1363$exports;


var $68c1297b1f20e9e6$exports = {};

function $68c1297b1f20e9e6$var$_defineProperty(obj, key, value) {
    key = $e812de78b1ad752e$exports(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$68c1297b1f20e9e6$exports = $68c1297b1f20e9e6$var$_defineProperty, $68c1297b1f20e9e6$exports.__esModule = true, $68c1297b1f20e9e6$exports["default"] = $68c1297b1f20e9e6$exports;



var $cQNHH = parcelRequire("cQNHH");
var $9f230ac92c6adfbf$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var $9f230ac92c6adfbf$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "…",
    "&#8230;": "…",
    "&#x2F;": "/",
    "&#47;": "/"
};
var $9f230ac92c6adfbf$var$unescapeHtmlEntity = function unescapeHtmlEntity(m) {
    return $9f230ac92c6adfbf$var$htmlEntities[m];
};
var $9f230ac92c6adfbf$export$e8bacd2802a88316 = function unescape(text) {
    return text.replace($9f230ac92c6adfbf$var$matchHtmlEntity, $9f230ac92c6adfbf$var$unescapeHtmlEntity);
};


function $d304d355ba45eefd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d304d355ba45eefd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d304d355ba45eefd$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($68c1297b1f20e9e6$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d304d355ba45eefd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $d304d355ba45eefd$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: (0, $9f230ac92c6adfbf$export$e8bacd2802a88316)
};
var $d304d355ba45eefd$var$i18nInstance;
var $d304d355ba45eefd$export$5603ab5ced17ce64 = (0, $cQNHH.createContext)();
function $d304d355ba45eefd$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $d304d355ba45eefd$var$defaultOptions = $d304d355ba45eefd$var$_objectSpread($d304d355ba45eefd$var$_objectSpread({}, $d304d355ba45eefd$var$defaultOptions), options);
}
function $d304d355ba45eefd$export$212bb2fc580a90a8() {
    return $d304d355ba45eefd$var$defaultOptions;
}
var $d304d355ba45eefd$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, (/*@__PURE__*/$parcel$interopDefault($a9f83e4b0471c6a5$exports)))(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($9f3907a168aa1363$exports)))(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $d304d355ba45eefd$export$a039134f2fc7e0(instance) {
    $d304d355ba45eefd$var$i18nInstance = instance;
}
function $d304d355ba45eefd$export$64af334f494c2f47() {
    return $d304d355ba45eefd$var$i18nInstance;
}
var $d304d355ba45eefd$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init: function init(instance) {
        $d304d355ba45eefd$export$2e2366488d12e20d(instance.options.react);
        $d304d355ba45eefd$export$a039134f2fc7e0(instance);
    }
};
function $d304d355ba45eefd$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $d304d355ba45eefd$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($d304d355ba45eefd$var$_objectSpread($d304d355ba45eefd$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $d304d355ba45eefd$export$704200e5d0b9e8f() {
    var i18n = $d304d355ba45eefd$export$64af334f494c2f47();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


function $22bbb2509fd1048a$export$1325e8699caa160f(_ref) {
    var i18n = _ref.i18n, defaultNS = _ref.defaultNS, children = _ref.children;
    var value = (0, $cQNHH.useMemo)(function() {
        return {
            i18n: i18n,
            defaultNS: defaultNS
        };
    }, [
        i18n,
        defaultNS
    ]);
    return (0, $cQNHH.createElement)((0, $d304d355ba45eefd$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $cQNHH = parcelRequire("cQNHH");
var $11f8a89d85a36f13$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11f8a89d85a36f13$var$ReactIs, $11f8a89d85a36f13$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$11f8a89d85a36f13$exports = (parcelRequire("j3WDN"))();


var $9bd1503a8dce057e$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $9bd1503a8dce057e$var$hasElementType = typeof Element !== "undefined";
var $9bd1503a8dce057e$var$hasMap = typeof Map === "function";
var $9bd1503a8dce057e$var$hasSet = typeof Set === "function";
var $9bd1503a8dce057e$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $9bd1503a8dce057e$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$9bd1503a8dce057e$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($9bd1503a8dce057e$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$9bd1503a8dce057e$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($9bd1503a8dce057e$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($9bd1503a8dce057e$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($9bd1503a8dce057e$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$9bd1503a8dce057e$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$9bd1503a8dce057e$exports = function isEqual(a, b) {
    try {
        return $9bd1503a8dce057e$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};


var $e5f9c2c26e21f232$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $e5f9c2c26e21f232$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$e5f9c2c26e21f232$exports = $e5f9c2c26e21f232$var$invariant;


var $d207b1f9e234bcf7$exports = {};
//
$d207b1f9e234bcf7$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $2829dc11bf9151d9$var$a() {
    return $2829dc11bf9151d9$var$a = Object.assign || function(t) {
        for(var e = 1; e < arguments.length; e++){
            var r = arguments[e];
            for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
        }
        return t;
    }, $2829dc11bf9151d9$var$a.apply(this, arguments);
}
function $2829dc11bf9151d9$var$s(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t, $2829dc11bf9151d9$var$c(t, e);
}
function $2829dc11bf9151d9$var$c(t, e) {
    return $2829dc11bf9151d9$var$c = Object.setPrototypeOf || function(t, e) {
        return t.__proto__ = e, t;
    }, $2829dc11bf9151d9$var$c(t, e);
}
function $2829dc11bf9151d9$var$u(t, e) {
    if (null == t) return {};
    var r, n, i = {}, o = Object.keys(t);
    for(n = 0; n < o.length; n++)e.indexOf(r = o[n]) >= 0 || (i[r] = t[r]);
    return i;
}
var $2829dc11bf9151d9$var$l = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title",
    FRAGMENT: "Symbol(react.fragment)"
}, $2829dc11bf9151d9$var$p = {
    rel: [
        "amphtml",
        "canonical",
        "alternate"
    ]
}, $2829dc11bf9151d9$var$f = {
    type: [
        "application/ld+json"
    ]
}, $2829dc11bf9151d9$var$d = {
    charset: "",
    name: [
        "robots",
        "description"
    ],
    property: [
        "og:type",
        "og:title",
        "og:url",
        "og:image",
        "og:image:alt",
        "og:description",
        "twitter:url",
        "twitter:title",
        "twitter:description",
        "twitter:image",
        "twitter:image:alt",
        "twitter:card",
        "twitter:site"
    ]
}, $2829dc11bf9151d9$var$h = Object.keys($2829dc11bf9151d9$var$l).map(function(t) {
    return $2829dc11bf9151d9$var$l[t];
}), $2829dc11bf9151d9$var$m = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
}, $2829dc11bf9151d9$var$y = Object.keys($2829dc11bf9151d9$var$m).reduce(function(t, e) {
    return t[$2829dc11bf9151d9$var$m[e]] = e, t;
}, {}), $2829dc11bf9151d9$var$T = function(t, e) {
    for(var r = t.length - 1; r >= 0; r -= 1){
        var n = t[r];
        if (Object.prototype.hasOwnProperty.call(n, e)) return n[e];
    }
    return null;
}, $2829dc11bf9151d9$var$g = function(t) {
    var e = $2829dc11bf9151d9$var$T(t, $2829dc11bf9151d9$var$l.TITLE), r = $2829dc11bf9151d9$var$T(t, "titleTemplate");
    if (Array.isArray(e) && (e = e.join("")), r && e) return r.replace(/%s/g, function() {
        return e;
    });
    var n = $2829dc11bf9151d9$var$T(t, "defaultTitle");
    return e || n || void 0;
}, $2829dc11bf9151d9$var$b = function(t) {
    return $2829dc11bf9151d9$var$T(t, "onChangeClientState") || function() {};
}, $2829dc11bf9151d9$var$v = function(t, e) {
    return e.filter(function(e) {
        return void 0 !== e[t];
    }).map(function(e) {
        return e[t];
    }).reduce(function(t, e) {
        return $2829dc11bf9151d9$var$a({}, t, e);
    }, {});
}, $2829dc11bf9151d9$var$A = function(t, e) {
    return e.filter(function(t) {
        return void 0 !== t[$2829dc11bf9151d9$var$l.BASE];
    }).map(function(t) {
        return t[$2829dc11bf9151d9$var$l.BASE];
    }).reverse().reduce(function(e, r) {
        if (!e.length) for(var n = Object.keys(r), i = 0; i < n.length; i += 1){
            var o = n[i].toLowerCase();
            if (-1 !== t.indexOf(o) && r[o]) return e.concat(r);
        }
        return e;
    }, []);
}, $2829dc11bf9151d9$var$C = function(t, e, r) {
    var n = {};
    return r.filter(function(e) {
        return !!Array.isArray(e[t]) || (void 0 !== e[t] && console && "function" == typeof console.warn && console.warn("Helmet: " + t + ' should be of type "Array". Instead found type "' + typeof e[t] + '"'), !1);
    }).map(function(e) {
        return e[t];
    }).reverse().reduce(function(t, r) {
        var i = {};
        r.filter(function(t) {
            for(var r, o = Object.keys(t), a = 0; a < o.length; a += 1){
                var s = o[a], c = s.toLowerCase();
                -1 === e.indexOf(c) || "rel" === r && "canonical" === t[r].toLowerCase() || "rel" === c && "stylesheet" === t[c].toLowerCase() || (r = c), -1 === e.indexOf(s) || "innerHTML" !== s && "cssText" !== s && "itemprop" !== s || (r = s);
            }
            if (!r || !t[r]) return !1;
            var u = t[r].toLowerCase();
            return n[r] || (n[r] = {}), i[r] || (i[r] = {}), !n[r][u] && (i[r][u] = !0, !0);
        }).reverse().forEach(function(e) {
            return t.push(e);
        });
        for(var o = Object.keys(i), s = 0; s < o.length; s += 1){
            var c = o[s], u = $2829dc11bf9151d9$var$a({}, n[c], i[c]);
            n[c] = u;
        }
        return t;
    }, []).reverse();
}, $2829dc11bf9151d9$var$O = function(t, e) {
    if (Array.isArray(t) && t.length) {
        for(var r = 0; r < t.length; r += 1)if (t[r][e]) return !0;
    }
    return !1;
}, $2829dc11bf9151d9$var$S = function(t) {
    return Array.isArray(t) ? t.join("") : t;
}, $2829dc11bf9151d9$var$E = function(t, e) {
    return Array.isArray(t) ? t.reduce(function(t, r) {
        return function(t, e) {
            for(var r = Object.keys(t), n = 0; n < r.length; n += 1)if (e[r[n]] && e[r[n]].includes(t[r[n]])) return !0;
            return !1;
        }(r, e) ? t.priority.push(r) : t.default.push(r), t;
    }, {
        priority: [],
        default: []
    }) : {
        default: t
    };
}, $2829dc11bf9151d9$var$I = function(t, e) {
    var r;
    return $2829dc11bf9151d9$var$a({}, t, ((r = {})[e] = void 0, r));
}, $2829dc11bf9151d9$var$P = [
    $2829dc11bf9151d9$var$l.NOSCRIPT,
    $2829dc11bf9151d9$var$l.SCRIPT,
    $2829dc11bf9151d9$var$l.STYLE
], $2829dc11bf9151d9$var$w = function(t, e) {
    return void 0 === e && (e = !0), !1 === e ? String(t) : String(t).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
}, $2829dc11bf9151d9$var$x = function(t) {
    return Object.keys(t).reduce(function(e, r) {
        var n = void 0 !== t[r] ? r + '="' + t[r] + '"' : "" + r;
        return e ? e + " " + n : n;
    }, "");
}, $2829dc11bf9151d9$var$L = function(t, e) {
    return void 0 === e && (e = {}), Object.keys(t).reduce(function(e, r) {
        return e[$2829dc11bf9151d9$var$m[r] || r] = t[r], e;
    }, e);
}, $2829dc11bf9151d9$var$j = function(e, r) {
    return r.map(function(r, n) {
        var i, o = ((i = {
            key: n
        })["data-rh"] = !0, i);
        return Object.keys(r).forEach(function(t) {
            var e = $2829dc11bf9151d9$var$m[t] || t;
            "innerHTML" === e || "cssText" === e ? o.dangerouslySetInnerHTML = {
                __html: r.innerHTML || r.cssText
            } : o[e] = r[t];
        }), (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(e, o);
    });
}, $2829dc11bf9151d9$var$M = function(e, r, n) {
    switch(e){
        case $2829dc11bf9151d9$var$l.TITLE:
            return {
                toComponent: function() {
                    var e, n, i, o;
                    return n = r.titleAttributes, (i = {
                        key: e = r.title
                    })["data-rh"] = !0, o = $2829dc11bf9151d9$var$L(n, i), [
                        (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($2829dc11bf9151d9$var$l.TITLE, o, e)
                    ];
                },
                toString: function() {
                    return function(t, e, r, n) {
                        var i = $2829dc11bf9151d9$var$x(r), o = $2829dc11bf9151d9$var$S(e);
                        return i ? "<" + t + ' data-rh="true" ' + i + ">" + $2829dc11bf9151d9$var$w(o, n) + "</" + t + ">" : "<" + t + ' data-rh="true">' + $2829dc11bf9151d9$var$w(o, n) + "</" + t + ">";
                    }(e, r.title, r.titleAttributes, n);
                }
            };
        case "bodyAttributes":
        case "htmlAttributes":
            return {
                toComponent: function() {
                    return $2829dc11bf9151d9$var$L(r);
                },
                toString: function() {
                    return $2829dc11bf9151d9$var$x(r);
                }
            };
        default:
            return {
                toComponent: function() {
                    return $2829dc11bf9151d9$var$j(e, r);
                },
                toString: function() {
                    return function(t, e, r) {
                        return e.reduce(function(e, n) {
                            var i = Object.keys(n).filter(function(t) {
                                return !("innerHTML" === t || "cssText" === t);
                            }).reduce(function(t, e) {
                                var i = void 0 === n[e] ? e : e + '="' + $2829dc11bf9151d9$var$w(n[e], r) + '"';
                                return t ? t + " " + i : i;
                            }, ""), o = n.innerHTML || n.cssText || "", a = -1 === $2829dc11bf9151d9$var$P.indexOf(t);
                            return e + "<" + t + ' data-rh="true" ' + i + (a ? "/>" : ">" + o + "</" + t + ">");
                        }, "");
                    }(e, r, n);
                }
            };
    }
}, $2829dc11bf9151d9$var$k = function(t) {
    var e = t.baseTag, r = t.bodyAttributes, n = t.encode, i = t.htmlAttributes, o = t.noscriptTags, a = t.styleTags, s = t.title, c = void 0 === s ? "" : s, u = t.titleAttributes, h = t.linkTags, m = t.metaTags, y = t.scriptTags, T = {
        toComponent: function() {},
        toString: function() {
            return "";
        }
    };
    if (t.prioritizeSeoTags) {
        var g = function(t) {
            var e = t.linkTags, r = t.scriptTags, n = t.encode, i = $2829dc11bf9151d9$var$E(t.metaTags, $2829dc11bf9151d9$var$d), o = $2829dc11bf9151d9$var$E(e, $2829dc11bf9151d9$var$p), a = $2829dc11bf9151d9$var$E(r, $2829dc11bf9151d9$var$f);
            return {
                priorityMethods: {
                    toComponent: function() {
                        return [].concat($2829dc11bf9151d9$var$j($2829dc11bf9151d9$var$l.META, i.priority), $2829dc11bf9151d9$var$j($2829dc11bf9151d9$var$l.LINK, o.priority), $2829dc11bf9151d9$var$j($2829dc11bf9151d9$var$l.SCRIPT, a.priority));
                    },
                    toString: function() {
                        return $2829dc11bf9151d9$var$M($2829dc11bf9151d9$var$l.META, i.priority, n) + " " + $2829dc11bf9151d9$var$M($2829dc11bf9151d9$var$l.LINK, o.priority, n) + " " + $2829dc11bf9151d9$var$M($2829dc11bf9151d9$var$l.SCRIPT, a.priority, n);
                    }
                },
                metaTags: i.default,
                linkTags: o.default,
                scriptTags: a.default
            };
        }(t);
        T = g.priorityMethods, h = g.linkTags, m = g.metaTags, y = g.scriptTags;
    }
    return {
        priority: T,
        base: $2829dc11bf9151d9$var$M($2829dc11bf9151d9$var$l.BASE, e, n),
        bodyAttributes: $2829dc11bf9151d9$var$M("bodyAttributes", r, n),
        htmlAttributes: $2829dc11bf9151d9$var$M("htmlAttributes", i, n),
        link: $2829dc11bf9151d9$var$M($2829dc11bf9151d9$var$l.LINK, h, n),
        meta: $2829dc11bf9151d9$var$M($2829dc11bf9151d9$var$l.META, m, n),
        noscript: $2829dc11bf9151d9$var$M($2829dc11bf9151d9$var$l.NOSCRIPT, o, n),
        script: $2829dc11bf9151d9$var$M($2829dc11bf9151d9$var$l.SCRIPT, y, n),
        style: $2829dc11bf9151d9$var$M($2829dc11bf9151d9$var$l.STYLE, a, n),
        title: $2829dc11bf9151d9$var$M($2829dc11bf9151d9$var$l.TITLE, {
            title: c,
            titleAttributes: u
        }, n)
    };
}, $2829dc11bf9151d9$var$H = [], $2829dc11bf9151d9$export$a9cf6990c9c7feb9 = function(t, e) {
    var r = this;
    void 0 === e && (e = "undefined" != typeof document), this.instances = [], this.value = {
        setHelmet: function(t) {
            r.context.helmet = t;
        },
        helmetInstances: {
            get: function() {
                return r.canUseDOM ? $2829dc11bf9151d9$var$H : r.instances;
            },
            add: function(t) {
                (r.canUseDOM ? $2829dc11bf9151d9$var$H : r.instances).push(t);
            },
            remove: function(t) {
                var e = (r.canUseDOM ? $2829dc11bf9151d9$var$H : r.instances).indexOf(t);
                (r.canUseDOM ? $2829dc11bf9151d9$var$H : r.instances).splice(e, 1);
            }
        }
    }, this.context = t, this.canUseDOM = e, e || (t.helmet = $2829dc11bf9151d9$var$k({
        baseTag: [],
        bodyAttributes: {},
        encodeSpecialCharacters: !0,
        htmlAttributes: {},
        linkTags: [],
        metaTags: [],
        noscriptTags: [],
        scriptTags: [],
        styleTags: [],
        title: "",
        titleAttributes: {}
    }));
}, $2829dc11bf9151d9$var$R = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createContext({}), $2829dc11bf9151d9$var$D = (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).shape({
    setHelmet: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).func,
    helmetInstances: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).shape({
        get: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).func,
        add: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).func,
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).func
    })
}), $2829dc11bf9151d9$var$U = "undefined" != typeof document, $2829dc11bf9151d9$export$4719288a8f5f7e71 = /*#__PURE__*/ function(e) {
    function r(t) {
        var n;
        return (n = e.call(this, t) || this).helmetData = new $2829dc11bf9151d9$export$a9cf6990c9c7feb9(n.props.context, r.canUseDOM), n;
    }
    return $2829dc11bf9151d9$var$s(r, e), r.prototype.render = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($2829dc11bf9151d9$var$R.Provider, {
            value: this.helmetData.value
        }, this.props.children);
    }, r;
}((0, $cQNHH.Component));
$2829dc11bf9151d9$export$4719288a8f5f7e71.canUseDOM = $2829dc11bf9151d9$var$U, $2829dc11bf9151d9$export$4719288a8f5f7e71.propTypes = {
    context: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).shape({
        helmet: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).shape()
    }),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).node.isRequired
}, $2829dc11bf9151d9$export$4719288a8f5f7e71.defaultProps = {
    context: {}
}, $2829dc11bf9151d9$export$4719288a8f5f7e71.displayName = "HelmetProvider";
var $2829dc11bf9151d9$var$Y = function(t, e) {
    var r, n = document.head || document.querySelector($2829dc11bf9151d9$var$l.HEAD), i = n.querySelectorAll(t + "[data-rh]"), o = [].slice.call(i), a = [];
    return e && e.length && e.forEach(function(e) {
        var n = document.createElement(t);
        for(var i in e)Object.prototype.hasOwnProperty.call(e, i) && ("innerHTML" === i ? n.innerHTML = e.innerHTML : "cssText" === i ? n.styleSheet ? n.styleSheet.cssText = e.cssText : n.appendChild(document.createTextNode(e.cssText)) : n.setAttribute(i, void 0 === e[i] ? "" : e[i]));
        n.setAttribute("data-rh", "true"), o.some(function(t, e) {
            return r = e, n.isEqualNode(t);
        }) ? o.splice(r, 1) : a.push(n);
    }), o.forEach(function(t) {
        return t.parentNode.removeChild(t);
    }), a.forEach(function(t) {
        return n.appendChild(t);
    }), {
        oldTags: o,
        newTags: a
    };
}, $2829dc11bf9151d9$var$B = function(t, e) {
    var r = document.getElementsByTagName(t)[0];
    if (r) {
        for(var n = r.getAttribute("data-rh"), i = n ? n.split(",") : [], o = [].concat(i), a = Object.keys(e), s = 0; s < a.length; s += 1){
            var c = a[s], u = e[c] || "";
            r.getAttribute(c) !== u && r.setAttribute(c, u), -1 === i.indexOf(c) && i.push(c);
            var l = o.indexOf(c);
            -1 !== l && o.splice(l, 1);
        }
        for(var p = o.length - 1; p >= 0; p -= 1)r.removeAttribute(o[p]);
        i.length === o.length ? r.removeAttribute("data-rh") : r.getAttribute("data-rh") !== a.join(",") && r.setAttribute("data-rh", a.join(","));
    }
}, $2829dc11bf9151d9$var$K = function(t, e) {
    var r = t.baseTag, n = t.htmlAttributes, i = t.linkTags, o = t.metaTags, a = t.noscriptTags, s = t.onChangeClientState, c = t.scriptTags, u = t.styleTags, p = t.title, f = t.titleAttributes;
    $2829dc11bf9151d9$var$B($2829dc11bf9151d9$var$l.BODY, t.bodyAttributes), $2829dc11bf9151d9$var$B($2829dc11bf9151d9$var$l.HTML, n), function(t, e) {
        void 0 !== t && document.title !== t && (document.title = $2829dc11bf9151d9$var$S(t)), $2829dc11bf9151d9$var$B($2829dc11bf9151d9$var$l.TITLE, e);
    }(p, f);
    var d = {
        baseTag: $2829dc11bf9151d9$var$Y($2829dc11bf9151d9$var$l.BASE, r),
        linkTags: $2829dc11bf9151d9$var$Y($2829dc11bf9151d9$var$l.LINK, i),
        metaTags: $2829dc11bf9151d9$var$Y($2829dc11bf9151d9$var$l.META, o),
        noscriptTags: $2829dc11bf9151d9$var$Y($2829dc11bf9151d9$var$l.NOSCRIPT, a),
        scriptTags: $2829dc11bf9151d9$var$Y($2829dc11bf9151d9$var$l.SCRIPT, c),
        styleTags: $2829dc11bf9151d9$var$Y($2829dc11bf9151d9$var$l.STYLE, u)
    }, h = {}, m = {};
    Object.keys(d).forEach(function(t) {
        var e = d[t], r = e.newTags, n = e.oldTags;
        r.length && (h[t] = r), n.length && (m[t] = d[t].oldTags);
    }), e && e(), s(t, h, m);
}, $2829dc11bf9151d9$var$_ = null, $2829dc11bf9151d9$var$z = /*#__PURE__*/ function(t) {
    function e() {
        for(var e, r = arguments.length, n = new Array(r), i = 0; i < r; i++)n[i] = arguments[i];
        return (e = t.call.apply(t, [
            this
        ].concat(n)) || this).rendered = !1, e;
    }
    $2829dc11bf9151d9$var$s(e, t);
    var r = e.prototype;
    return r.shouldComponentUpdate = function(t) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($d207b1f9e234bcf7$exports)))(t, this.props);
    }, r.componentDidUpdate = function() {
        this.emitChange();
    }, r.componentWillUnmount = function() {
        this.props.context.helmetInstances.remove(this), this.emitChange();
    }, r.emitChange = function() {
        var t, e, r = this.props.context, n = r.setHelmet, i = null, o = (t = r.helmetInstances.get().map(function(t) {
            var e = $2829dc11bf9151d9$var$a({}, t.props);
            return delete e.context, e;
        }), {
            baseTag: $2829dc11bf9151d9$var$A([
                "href"
            ], t),
            bodyAttributes: $2829dc11bf9151d9$var$v("bodyAttributes", t),
            defer: $2829dc11bf9151d9$var$T(t, "defer"),
            encode: $2829dc11bf9151d9$var$T(t, "encodeSpecialCharacters"),
            htmlAttributes: $2829dc11bf9151d9$var$v("htmlAttributes", t),
            linkTags: $2829dc11bf9151d9$var$C($2829dc11bf9151d9$var$l.LINK, [
                "rel",
                "href"
            ], t),
            metaTags: $2829dc11bf9151d9$var$C($2829dc11bf9151d9$var$l.META, [
                "name",
                "charset",
                "http-equiv",
                "property",
                "itemprop"
            ], t),
            noscriptTags: $2829dc11bf9151d9$var$C($2829dc11bf9151d9$var$l.NOSCRIPT, [
                "innerHTML"
            ], t),
            onChangeClientState: $2829dc11bf9151d9$var$b(t),
            scriptTags: $2829dc11bf9151d9$var$C($2829dc11bf9151d9$var$l.SCRIPT, [
                "src",
                "innerHTML"
            ], t),
            styleTags: $2829dc11bf9151d9$var$C($2829dc11bf9151d9$var$l.STYLE, [
                "cssText"
            ], t),
            title: $2829dc11bf9151d9$var$g(t),
            titleAttributes: $2829dc11bf9151d9$var$v("titleAttributes", t),
            prioritizeSeoTags: $2829dc11bf9151d9$var$O(t, "prioritizeSeoTags")
        });
        $2829dc11bf9151d9$export$4719288a8f5f7e71.canUseDOM ? (e = o, $2829dc11bf9151d9$var$_ && cancelAnimationFrame($2829dc11bf9151d9$var$_), e.defer ? $2829dc11bf9151d9$var$_ = requestAnimationFrame(function() {
            $2829dc11bf9151d9$var$K(e, function() {
                $2829dc11bf9151d9$var$_ = null;
            });
        }) : ($2829dc11bf9151d9$var$K(e), $2829dc11bf9151d9$var$_ = null)) : $2829dc11bf9151d9$var$k && (i = $2829dc11bf9151d9$var$k(o)), n(i);
    }, r.init = function() {
        this.rendered || (this.rendered = !0, this.props.context.helmetInstances.add(this), this.emitChange());
    }, r.render = function() {
        return this.init(), null;
    }, e;
}((0, $cQNHH.Component));
$2829dc11bf9151d9$var$z.propTypes = {
    context: $2829dc11bf9151d9$var$D.isRequired
}, $2829dc11bf9151d9$var$z.displayName = "HelmetDispatcher";
var $2829dc11bf9151d9$var$F = [
    "children"
], $2829dc11bf9151d9$var$G = [
    "children"
], $2829dc11bf9151d9$export$dcef8f9bb9a41431 = /*#__PURE__*/ function(e) {
    function r() {
        return e.apply(this, arguments) || this;
    }
    $2829dc11bf9151d9$var$s(r, e);
    var o = r.prototype;
    return o.shouldComponentUpdate = function(t) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($9bd1503a8dce057e$exports)))($2829dc11bf9151d9$var$I(this.props, "helmetData"), $2829dc11bf9151d9$var$I(t, "helmetData"));
    }, o.mapNestedChildrenToProps = function(t, e) {
        if (!e) return null;
        switch(t.type){
            case $2829dc11bf9151d9$var$l.SCRIPT:
            case $2829dc11bf9151d9$var$l.NOSCRIPT:
                return {
                    innerHTML: e
                };
            case $2829dc11bf9151d9$var$l.STYLE:
                return {
                    cssText: e
                };
            default:
                throw new Error("<" + t.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        }
    }, o.flattenArrayTypeChildren = function(t) {
        var e, r = t.child, n = t.arrayTypeChildren;
        return $2829dc11bf9151d9$var$a({}, n, ((e = {})[r.type] = [].concat(n[r.type] || [], [
            $2829dc11bf9151d9$var$a({}, t.newChildProps, this.mapNestedChildrenToProps(r, t.nestedChildren))
        ]), e));
    }, o.mapObjectTypeChildren = function(t) {
        var e, r, n = t.child, i = t.newProps, o = t.newChildProps, s = t.nestedChildren;
        switch(n.type){
            case $2829dc11bf9151d9$var$l.TITLE:
                return $2829dc11bf9151d9$var$a({}, i, ((e = {})[n.type] = s, e.titleAttributes = $2829dc11bf9151d9$var$a({}, o), e));
            case $2829dc11bf9151d9$var$l.BODY:
                return $2829dc11bf9151d9$var$a({}, i, {
                    bodyAttributes: $2829dc11bf9151d9$var$a({}, o)
                });
            case $2829dc11bf9151d9$var$l.HTML:
                return $2829dc11bf9151d9$var$a({}, i, {
                    htmlAttributes: $2829dc11bf9151d9$var$a({}, o)
                });
            default:
                return $2829dc11bf9151d9$var$a({}, i, ((r = {})[n.type] = $2829dc11bf9151d9$var$a({}, o), r));
        }
    }, o.mapArrayTypeChildrenToProps = function(t, e) {
        var r = $2829dc11bf9151d9$var$a({}, e);
        return Object.keys(t).forEach(function(e) {
            var n;
            r = $2829dc11bf9151d9$var$a({}, r, ((n = {})[e] = t[e], n));
        }), r;
    }, o.warnOnInvalidChildren = function(t, e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($e5f9c2c26e21f232$exports)))($2829dc11bf9151d9$var$h.some(function(e) {
            return t.type === e;
        }), "function" == typeof t.type ? "You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information." : "Only elements types " + $2829dc11bf9151d9$var$h.join(", ") + " are allowed. Helmet does not support rendering <" + t.type + "> elements. Refer to our API for more information."), (0, (/*@__PURE__*/$parcel$interopDefault($e5f9c2c26e21f232$exports)))(!e || "string" == typeof e || Array.isArray(e) && !e.some(function(t) {
            return "string" != typeof t;
        }), "Helmet expects a string as a child of <" + t.type + ">. Did you forget to wrap your children in braces? ( <" + t.type + ">{``}</" + t.type + "> ) Refer to our API for more information."), !0;
    }, o.mapChildrenToProps = function(e, r) {
        var n = this, i = {};
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Children.forEach(e, function(t) {
            if (t && t.props) {
                var e = t.props, o = e.children, a = $2829dc11bf9151d9$var$u(e, $2829dc11bf9151d9$var$F), s = Object.keys(a).reduce(function(t, e) {
                    return t[$2829dc11bf9151d9$var$y[e] || e] = a[e], t;
                }, {}), c = t.type;
                switch("symbol" == typeof c ? c = c.toString() : n.warnOnInvalidChildren(t, o), c){
                    case $2829dc11bf9151d9$var$l.FRAGMENT:
                        r = n.mapChildrenToProps(o, r);
                        break;
                    case $2829dc11bf9151d9$var$l.LINK:
                    case $2829dc11bf9151d9$var$l.META:
                    case $2829dc11bf9151d9$var$l.NOSCRIPT:
                    case $2829dc11bf9151d9$var$l.SCRIPT:
                    case $2829dc11bf9151d9$var$l.STYLE:
                        i = n.flattenArrayTypeChildren({
                            child: t,
                            arrayTypeChildren: i,
                            newChildProps: s,
                            nestedChildren: o
                        });
                        break;
                    default:
                        r = n.mapObjectTypeChildren({
                            child: t,
                            newProps: r,
                            newChildProps: s,
                            nestedChildren: o
                        });
                }
            }
        }), this.mapArrayTypeChildrenToProps(i, r);
    }, o.render = function() {
        var e = this.props, r = e.children, n = $2829dc11bf9151d9$var$u(e, $2829dc11bf9151d9$var$G), i = $2829dc11bf9151d9$var$a({}, n), o = n.helmetData;
        return r && (i = this.mapChildrenToProps(r, i)), !o || o instanceof $2829dc11bf9151d9$export$a9cf6990c9c7feb9 || (o = new $2829dc11bf9151d9$export$a9cf6990c9c7feb9(o.context, o.instances)), o ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($2829dc11bf9151d9$var$z, $2829dc11bf9151d9$var$a({}, i, {
            context: o.value,
            helmetData: void 0
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($2829dc11bf9151d9$var$R.Consumer, null, function(e) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($2829dc11bf9151d9$var$z, $2829dc11bf9151d9$var$a({}, i, {
                context: e
            }));
        });
    }, r;
}((0, $cQNHH.Component));
$2829dc11bf9151d9$export$dcef8f9bb9a41431.propTypes = {
    base: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).object,
    bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).node),
        (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).node
    ]),
    defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    defer: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
    encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
    htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).object,
    link: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).object),
    meta: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).object),
    noscript: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).object),
    onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).func,
    script: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).object),
    style: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).object),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).object,
    titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    prioritizeSeoTags: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
    helmetData: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).object
}, $2829dc11bf9151d9$export$dcef8f9bb9a41431.defaultProps = {
    defer: !0,
    encodeSpecialCharacters: !0,
    prioritizeSeoTags: !1
}, $2829dc11bf9151d9$export$dcef8f9bb9a41431.displayName = "Helmet";


var $1557dedf291624dd$export$711117ad6ad27992 = "persist:";
var $1557dedf291624dd$export$2aaee4793dd13a52 = "persist/FLUSH";
var $1557dedf291624dd$export$1647ef958242c4e2 = "persist/REHYDRATE";
var $1557dedf291624dd$export$dd1033c27a16bbd3 = "persist/PAUSE";
var $1557dedf291624dd$export$913fe0e161ed92a2 = "persist/PERSIST";
var $1557dedf291624dd$export$5514fc3b4067675f = "persist/PURGE";
var $1557dedf291624dd$export$51e82cdd7353a0e1 = "persist/REGISTER";
var $1557dedf291624dd$export$363ebe89e6e7aeef = -1;


function $264cd2dc922416ef$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $264cd2dc922416ef$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $264cd2dc922416ef$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $264cd2dc922416ef$var$_typeof(obj);
}
function $264cd2dc922416ef$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $264cd2dc922416ef$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $264cd2dc922416ef$var$ownKeys(source, true).forEach(function(key) {
            $264cd2dc922416ef$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $264cd2dc922416ef$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $264cd2dc922416ef$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $264cd2dc922416ef$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $264cd2dc922416ef$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $264cd2dc922416ef$var$_typeof(inboundState) === "object") Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === "_persist") return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
         // otherwise hard set the new value
        newState[key] = inboundState[key];
    });
    return newState;
}



function $83ce764b840ec70d$export$2e2bcd8739ae039(config) {
    // defaults
    var blacklist = config.blacklist || null;
    var whitelist = config.whitelist || null;
    var transforms = config.transforms || [];
    var throttle = config.throttle || 0;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $1557dedf291624dd$export$711117ad6ad27992)).concat(config.key);
    var storage = config.storage;
    var serialize;
    if (config.serialize === false) serialize = function serialize(x) {
        return x;
    };
    else if (typeof config.serialize === "function") serialize = config.serialize;
    else serialize = $83ce764b840ec70d$var$defaultSerialize;
    var writeFailHandler = config.writeFailHandler || null; // initialize stateful values
    var lastState = {};
    var stagedState = {};
    var keysToProcess = [];
    var timeIterator = null;
    var writePromise = null;
    var update = function update(state) {
        // add any changed keys to the queue
        Object.keys(state).forEach(function(key) {
            if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop
            if (lastState[key] === state[key]) return; // value unchanged? noop
            if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop
            keysToProcess.push(key); // add key to queue
        }); //if any key is missing in the new state which was present in the lastState,
        //add it for processing too
        Object.keys(lastState).forEach(function(key) {
            if (state[key] === undefined && passWhitelistBlacklist(key) && keysToProcess.indexOf(key) === -1 && lastState[key] !== undefined) keysToProcess.push(key);
        }); // start the time iterator if not running (read: throttle)
        if (timeIterator === null) timeIterator = setInterval(processNextKey, throttle);
        lastState = state;
    };
    function processNextKey() {
        if (keysToProcess.length === 0) {
            if (timeIterator) clearInterval(timeIterator);
            timeIterator = null;
            return;
        }
        var key = keysToProcess.shift();
        var endState = transforms.reduce(function(subState, transformer) {
            return transformer.in(subState, key, lastState);
        }, lastState[key]);
        if (endState !== undefined) try {
            stagedState[key] = serialize(endState);
        } catch (err) {
            console.error("redux-persist/createPersistoid: error serializing state", err);
        }
        else //if the endState is undefined, no need to persist the existing serialized content
        delete stagedState[key];
        if (keysToProcess.length === 0) writeStagedState();
    }
    function writeStagedState() {
        // cleanup any removed keys just before write.
        Object.keys(stagedState).forEach(function(key) {
            if (lastState[key] === undefined) delete stagedState[key];
        });
        writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
    }
    function passWhitelistBlacklist(key) {
        if (whitelist && whitelist.indexOf(key) === -1 && key !== "_persist") return false;
        if (blacklist && blacklist.indexOf(key) !== -1) return false;
        return true;
    }
    function onWriteFail(err) {
        // @TODO add fail handlers (typically storage full)
        if (writeFailHandler) writeFailHandler(err);
    }
    var flush = function flush() {
        while(keysToProcess.length !== 0)processNextKey();
        return writePromise || Promise.resolve();
    }; // return `persistoid`
    return {
        update: update,
        flush: flush
    };
} // @NOTE in the future this may be exposed via config
function $83ce764b840ec70d$var$defaultSerialize(data) {
    return JSON.stringify(data);
}



function $1d12aaef1c331270$export$2e2bcd8739ae039(config) {
    var transforms = config.transforms || [];
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $1557dedf291624dd$export$711117ad6ad27992)).concat(config.key);
    var storage = config.storage;
    var debug = config.debug;
    var deserialize;
    if (config.deserialize === false) deserialize = function deserialize(x) {
        return x;
    };
    else if (typeof config.deserialize === "function") deserialize = config.deserialize;
    else deserialize = $1d12aaef1c331270$var$defaultDeserialize;
    return storage.getItem(storageKey).then(function(serialized) {
        if (!serialized) return undefined;
        else try {
            var state = {};
            var rawState = deserialize(serialized);
            Object.keys(rawState).forEach(function(key) {
                state[key] = transforms.reduceRight(function(subState, transformer) {
                    return transformer.out(subState, key, rawState);
                }, deserialize(rawState[key]));
            });
            return state;
        } catch (err) {
            throw err;
        }
    });
}
function $1d12aaef1c331270$var$defaultDeserialize(serial) {
    return JSON.parse(serial);
}



function $ac896aa4fa6d48b5$export$2e2bcd8739ae039(config) {
    var storage = config.storage;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $1557dedf291624dd$export$711117ad6ad27992)).concat(config.key);
    return storage.removeItem(storageKey, $ac896aa4fa6d48b5$var$warnIfRemoveError);
}
function $ac896aa4fa6d48b5$var$warnIfRemoveError(err) {}


function $75083fdd200278f4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $75083fdd200278f4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $75083fdd200278f4$var$ownKeys(source, true).forEach(function(key) {
            $75083fdd200278f4$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $75083fdd200278f4$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $75083fdd200278f4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $75083fdd200278f4$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $75083fdd200278f4$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $75083fdd200278f4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $75083fdd200278f4$var$DEFAULT_TIMEOUT = 5000;
function $75083fdd200278f4$export$2e2bcd8739ae039(config, baseReducer) {
    var version = config.version !== undefined ? config.version : (0, $1557dedf291624dd$export$363ebe89e6e7aeef);
    var debug = config.debug || false;
    var stateReconciler = config.stateReconciler === undefined ? (0, $264cd2dc922416ef$export$2e2bcd8739ae039) : config.stateReconciler;
    var getStoredState = config.getStoredState || (0, $1d12aaef1c331270$export$2e2bcd8739ae039);
    var timeout = config.timeout !== undefined ? config.timeout : $75083fdd200278f4$var$DEFAULT_TIMEOUT;
    var _persistoid = null;
    var _purge = false;
    var _paused = true;
    var conditionalUpdate = function conditionalUpdate(state) {
        // update the persistoid only if we are rehydrated and not paused
        state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
        return state;
    };
    return function(state, action) {
        var _ref = state || {}, _persist = _ref._persist, rest = $75083fdd200278f4$var$_objectWithoutProperties(_ref, [
            "_persist"
        ]); // $FlowIgnore need to update State type
        var restState = rest;
        if (action.type === (0, $1557dedf291624dd$export$913fe0e161ed92a2)) {
            var _sealed = false;
            var _rehydrate = function _rehydrate(payload, err) {
                if (!_sealed) {
                    action.rehydrate(config.key, payload, err);
                    _sealed = true;
                }
            };
            timeout && setTimeout(function() {
                !_sealed && _rehydrate(undefined, new Error('redux-persist: persist timed out for persist key "'.concat(config.key, '"')));
            }, timeout); // @NOTE PERSIST resumes if paused.
            _paused = false; // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set
            if (!_persistoid) _persistoid = (0, $83ce764b840ec70d$export$2e2bcd8739ae039)(config); // @NOTE PERSIST can be called multiple times, noop after the first
            if (_persist) // We still need to call the base reducer because there might be nested
            // uses of persistReducer which need to be aware of the PERSIST action
            return $75083fdd200278f4$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
            if (typeof action.rehydrate !== "function" || typeof action.register !== "function") throw new Error("redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.");
            action.register(config.key);
            getStoredState(config).then(function(restoredState) {
                var migrate = config.migrate || function(s, v) {
                    return Promise.resolve(s);
                };
                migrate(restoredState, version).then(function(migratedState) {
                    _rehydrate(migratedState);
                }, function(migrateErr) {
                    _rehydrate(undefined, migrateErr);
                });
            }, function(err) {
                _rehydrate(undefined, err);
            });
            return $75083fdd200278f4$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: {
                    version: version,
                    rehydrated: false
                }
            });
        } else if (action.type === (0, $1557dedf291624dd$export$5514fc3b4067675f)) {
            _purge = true;
            action.result((0, $ac896aa4fa6d48b5$export$2e2bcd8739ae039)(config));
            return $75083fdd200278f4$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $1557dedf291624dd$export$2aaee4793dd13a52)) {
            action.result(_persistoid && _persistoid.flush());
            return $75083fdd200278f4$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $1557dedf291624dd$export$dd1033c27a16bbd3)) _paused = true;
        else if (action.type === (0, $1557dedf291624dd$export$1647ef958242c4e2)) {
            // noop on restState if purging
            if (_purge) return $75083fdd200278f4$var$_objectSpread({}, restState, {
                _persist: $75083fdd200278f4$var$_objectSpread({}, _persist, {
                    rehydrated: true
                }) // @NOTE if key does not match, will continue to default else below
            });
            if (action.key === config.key) {
                var reducedState = baseReducer(restState, action);
                var inboundState = action.payload; // only reconcile state if stateReconciler and inboundState are both defined
                var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;
                var _newState = $75083fdd200278f4$var$_objectSpread({}, reconciledRest, {
                    _persist: $75083fdd200278f4$var$_objectSpread({}, _persist, {
                        rehydrated: true
                    })
                });
                return conditionalUpdate(_newState);
            }
        } // if we have not already handled PERSIST, straight passthrough
        if (!_persist) return baseReducer(state, action); // run base reducer:
        // is state modified ? return original : return updated
        var newState = baseReducer(restState, action);
        if (newState === restState) return state;
        return conditionalUpdate($75083fdd200278f4$var$_objectSpread({}, newState, {
            _persist: _persist
        }));
    };
}


function $0308e3532c157317$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $0308e3532c157317$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $0308e3532c157317$export$2e2bcd8739ae039(obj);
}



function $fbc8a6cb9709162c$export$2e2bcd8739ae039(input, hint) {
    if ((0, $0308e3532c157317$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $0308e3532c157317$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $ba41a0e043d13a82$export$2e2bcd8739ae039(arg) {
    var key = (0, $fbc8a6cb9709162c$export$2e2bcd8739ae039)(arg, "string");
    return (0, $0308e3532c157317$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $79f4448e0e3dff2f$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $ba41a0e043d13a82$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $30c69bfaa6e873b6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $30c69bfaa6e873b6$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $30c69bfaa6e873b6$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $79f4448e0e3dff2f$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $30c69bfaa6e873b6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $8bb7c10694c071aa$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $8bb7c10694c071aa$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $8bb7c10694c071aa$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $8bb7c10694c071aa$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $8bb7c10694c071aa$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $8bb7c10694c071aa$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $8bb7c10694c071aa$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $8bb7c10694c071aa$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $8bb7c10694c071aa$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($8bb7c10694c071aa$var$isDate(val)) return "date";
    if ($8bb7c10694c071aa$var$isError(val)) return "error";
    var constructorName = $8bb7c10694c071aa$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $8bb7c10694c071aa$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $8bb7c10694c071aa$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $8bb7c10694c071aa$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $8bb7c10694c071aa$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $8bb7c10694c071aa$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($8bb7c10694c071aa$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($8bb7c10694c071aa$var$formatProdErrorMessage(1));
        return enhancer($8bb7c10694c071aa$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($8bb7c10694c071aa$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($8bb7c10694c071aa$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($8bb7c10694c071aa$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($8bb7c10694c071aa$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($8bb7c10694c071aa$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$8bb7c10694c071aa$var$isPlainObject(action)) throw new Error($8bb7c10694c071aa$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($8bb7c10694c071aa$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($8bb7c10694c071aa$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($8bb7c10694c071aa$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $8bb7c10694c071aa$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($8bb7c10694c071aa$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$8bb7c10694c071aa$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $8bb7c10694c071aa$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$8bb7c10694c071aa$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $8bb7c10694c071aa$export$8928921ea2d3b126 = $8bb7c10694c071aa$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $8bb7c10694c071aa$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $8bb7c10694c071aa$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $8bb7c10694c071aa$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$8bb7c10694c071aa$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $8bb7c10694c071aa$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $8bb7c10694c071aa$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $8bb7c10694c071aa$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $8bb7c10694c071aa$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($8bb7c10694c071aa$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $8bb7c10694c071aa$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($8bb7c10694c071aa$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $8bb7c10694c071aa$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $8bb7c10694c071aa$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($8bb7c10694c071aa$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $8bb7c10694c071aa$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $8bb7c10694c071aa$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $8bb7c10694c071aa$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($8bb7c10694c071aa$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $8bb7c10694c071aa$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $8bb7c10694c071aa$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $8bb7c10694c071aa$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($8bb7c10694c071aa$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $8bb7c10694c071aa$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $30c69bfaa6e873b6$export$2e2bcd8739ae039)((0, $30c69bfaa6e873b6$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}



function $22f2e297c29da677$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $22f2e297c29da677$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $22f2e297c29da677$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $22f2e297c29da677$var$_typeof(obj);
}
function $22f2e297c29da677$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $22f2e297c29da677$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $22f2e297c29da677$var$ownKeys(source, true).forEach(function(key) {
            $22f2e297c29da677$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $22f2e297c29da677$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $22f2e297c29da677$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $22f2e297c29da677$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $22f2e297c29da677$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $22f2e297c29da677$var$_typeof(inboundState) === "object") Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === "_persist") return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
        if ($22f2e297c29da677$var$isPlainEnoughObject(reducedState[key])) {
            // if object is plain enough shallow merge the new values (hence "Level2")
            newState[key] = $22f2e297c29da677$var$_objectSpread({}, newState[key], {}, inboundState[key]);
            return;
        } // otherwise hard set
        newState[key] = inboundState[key];
    });
    return newState;
}
function $22f2e297c29da677$var$isPlainEnoughObject(o) {
    return o !== null && !Array.isArray(o) && $22f2e297c29da677$var$_typeof(o) === "object";
}


function $28da19c7a6896354$export$2e2bcd8739ae039(config, reducers) {
    config.stateReconciler = config.stateReconciler === undefined ? (0, $22f2e297c29da677$export$2e2bcd8739ae039) : config.stateReconciler;
    return (0, $75083fdd200278f4$export$2e2bcd8739ae039)(config, (0, $8bb7c10694c071aa$export$66e4520cdb265d18)(reducers));
}




function $784949253389904f$var$_toConsumableArray(arr) {
    return $784949253389904f$var$_arrayWithoutHoles(arr) || $784949253389904f$var$_iterableToArray(arr) || $784949253389904f$var$_nonIterableSpread();
}
function $784949253389904f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $784949253389904f$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $784949253389904f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $784949253389904f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $784949253389904f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $784949253389904f$var$ownKeys(source, true).forEach(function(key) {
            $784949253389904f$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $784949253389904f$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $784949253389904f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $784949253389904f$var$initialState = {
    registry: [],
    bootstrapped: false
};
var $784949253389904f$var$persistorReducer = function persistorReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $784949253389904f$var$initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $1557dedf291624dd$export$51e82cdd7353a0e1:
            return $784949253389904f$var$_objectSpread({}, state, {
                registry: [].concat($784949253389904f$var$_toConsumableArray(state.registry), [
                    action.key
                ])
            });
        case 0, $1557dedf291624dd$export$1647ef958242c4e2:
            var firstIndex = state.registry.indexOf(action.key);
            var registry = $784949253389904f$var$_toConsumableArray(state.registry);
            registry.splice(firstIndex, 1);
            return $784949253389904f$var$_objectSpread({}, state, {
                registry: registry,
                bootstrapped: registry.length === 0
            });
        default:
            return state;
    }
};
function $784949253389904f$export$2e2bcd8739ae039(store, options, cb) {
    var optionsToTest, bannedKeys;
    var boostrappedCb = cb || false;
    var _pStore = (0, $8bb7c10694c071aa$export$f51a9068ac82ea43)($784949253389904f$var$persistorReducer, $784949253389904f$var$initialState, options && options.enhancer ? options.enhancer : undefined);
    var register = function register(key) {
        _pStore.dispatch({
            type: (0, $1557dedf291624dd$export$51e82cdd7353a0e1),
            key: key
        });
    };
    var rehydrate = function rehydrate(key, payload, err) {
        var rehydrateAction = {
            type: (0, $1557dedf291624dd$export$1647ef958242c4e2),
            payload: payload,
            err: err,
            key: key // dispatch to `store` to rehydrate and `persistor` to track result
        };
        store.dispatch(rehydrateAction);
        _pStore.dispatch(rehydrateAction);
        if (boostrappedCb && persistor.getState().bootstrapped) {
            boostrappedCb();
            boostrappedCb = false;
        }
    };
    var persistor = $784949253389904f$var$_objectSpread({}, _pStore, {
        purge: function purge() {
            var results = [];
            store.dispatch({
                type: (0, $1557dedf291624dd$export$5514fc3b4067675f),
                result: function result(purgeResult) {
                    results.push(purgeResult);
                }
            });
            return Promise.all(results);
        },
        flush: function flush() {
            var results = [];
            store.dispatch({
                type: (0, $1557dedf291624dd$export$2aaee4793dd13a52),
                result: function result(flushResult) {
                    results.push(flushResult);
                }
            });
            return Promise.all(results);
        },
        pause: function pause() {
            store.dispatch({
                type: (0, $1557dedf291624dd$export$dd1033c27a16bbd3)
            });
        },
        persist: function persist() {
            store.dispatch({
                type: (0, $1557dedf291624dd$export$913fe0e161ed92a2),
                register: register,
                rehydrate: rehydrate
            });
        }
    });
    if (!(options && options.manualPersist)) persistor.persist();
    return persistor;
}



function $623cca795814b228$export$2e2bcd8739ae039(migrations, config) {
    var _ref = config || {}, debug = _ref.debug;
    return function(state, currentVersion) {
        if (!state) return Promise.resolve(undefined);
        var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : (0, $1557dedf291624dd$export$363ebe89e6e7aeef);
        if (inboundVersion === currentVersion) return Promise.resolve(state);
        if (inboundVersion > currentVersion) return Promise.resolve(state);
        var migrationKeys = Object.keys(migrations).map(function(ver) {
            return parseInt(ver);
        }).filter(function(key) {
            return currentVersion >= key && key > inboundVersion;
        }).sort(function(a, b) {
            return a - b;
        });
        try {
            var migratedState = migrationKeys.reduce(function(state, versionKey) {
                return migrations[versionKey](state);
            }, state);
            return Promise.resolve(migratedState);
        } catch (err) {
            return Promise.reject(err);
        }
    };
}


function $49331476327deeff$export$2e2bcd8739ae039(inbound, outbound) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var whitelist = config.whitelist || null;
    var blacklist = config.blacklist || null;
    function whitelistBlacklistCheck(key) {
        if (whitelist && whitelist.indexOf(key) === -1) return true;
        if (blacklist && blacklist.indexOf(key) !== -1) return true;
        return false;
    }
    return {
        in: function _in(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
        },
        out: function out(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
        }
    };
}








var $d2702be57030c372$exports = {};
$parcel$export($d2702be57030c372$exports, "applyMiddleware", function () { return $8bb7c10694c071aa$export$9ff26e0402cc7b7; }, function (v) { return $8bb7c10694c071aa$export$9ff26e0402cc7b7 = v; });
$parcel$export($d2702be57030c372$exports, "combineReducers", function () { return $8bb7c10694c071aa$export$66e4520cdb265d18; }, function (v) { return $8bb7c10694c071aa$export$66e4520cdb265d18 = v; });
$parcel$export($d2702be57030c372$exports, "compose", function () { return $8bb7c10694c071aa$export$f672e0b6f7222cd7; }, function (v) { return $8bb7c10694c071aa$export$f672e0b6f7222cd7 = v; });
$parcel$export($d2702be57030c372$exports, "createStore", function () { return $8bb7c10694c071aa$export$f51a9068ac82ea43; }, function (v) { return $8bb7c10694c071aa$export$f51a9068ac82ea43 = v; });

$parcel$export($d2702be57030c372$exports, "configureStore", function () { return $d2702be57030c372$export$7d8a5b498da695ac; });
$parcel$export($d2702be57030c372$exports, "createSlice", function () { return $d2702be57030c372$export$4d8d9bd83c24ae8b; });
function $41d1ca1be2d2941b$var$n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function $41d1ca1be2d2941b$export$541ac630993a4c84(n) {
    return !!n && !!n[$41d1ca1be2d2941b$var$Q];
}
function $41d1ca1be2d2941b$export$16e3aed3edb85946(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === $41d1ca1be2d2941b$var$Z;
    }(n) || Array.isArray(n) || !!n[$41d1ca1be2d2941b$export$6ee2082928bcb0ee] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[$41d1ca1be2d2941b$export$6ee2082928bcb0ee]) || $41d1ca1be2d2941b$var$s(n) || $41d1ca1be2d2941b$var$v(n));
}
function $41d1ca1be2d2941b$export$22e8af3f75a010e3(t) {
    return $41d1ca1be2d2941b$export$541ac630993a4c84(t) || $41d1ca1be2d2941b$var$n(23, t), t[$41d1ca1be2d2941b$var$Q].t;
}
function $41d1ca1be2d2941b$var$i(n, r, t) {
    void 0 === t && (t = !1), 0 === $41d1ca1be2d2941b$var$o(n) ? (t ? Object.keys : $41d1ca1be2d2941b$var$nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function $41d1ca1be2d2941b$var$o(n) {
    var r = n[$41d1ca1be2d2941b$var$Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : $41d1ca1be2d2941b$var$s(n) ? 2 : $41d1ca1be2d2941b$var$v(n) ? 3 : 0;
}
function $41d1ca1be2d2941b$var$u(n, r) {
    return 2 === $41d1ca1be2d2941b$var$o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function $41d1ca1be2d2941b$var$a(n, r) {
    return 2 === $41d1ca1be2d2941b$var$o(n) ? n.get(r) : n[r];
}
function $41d1ca1be2d2941b$var$f(n, r, t) {
    var e = $41d1ca1be2d2941b$var$o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function $41d1ca1be2d2941b$var$c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function $41d1ca1be2d2941b$var$s(n) {
    return $41d1ca1be2d2941b$var$X && n instanceof Map;
}
function $41d1ca1be2d2941b$var$v(n) {
    return $41d1ca1be2d2941b$var$q && n instanceof Set;
}
function $41d1ca1be2d2941b$var$p(n) {
    return n.o || n.t;
}
function $41d1ca1be2d2941b$var$l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = $41d1ca1be2d2941b$var$rn(n);
    delete r[$41d1ca1be2d2941b$var$Q];
    for(var t = $41d1ca1be2d2941b$var$nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function $41d1ca1be2d2941b$export$792f3d81ea979f55(n, e) {
    return void 0 === e && (e = !1), $41d1ca1be2d2941b$var$y(n) || $41d1ca1be2d2941b$export$541ac630993a4c84(n) || !$41d1ca1be2d2941b$export$16e3aed3edb85946(n) || ($41d1ca1be2d2941b$var$o(n) > 1 && (n.set = n.add = n.clear = n.delete = $41d1ca1be2d2941b$var$h), Object.freeze(n), e && $41d1ca1be2d2941b$var$i(n, function(n, r) {
        return $41d1ca1be2d2941b$export$792f3d81ea979f55(r, !0);
    }, !0)), n;
}
function $41d1ca1be2d2941b$var$h() {
    $41d1ca1be2d2941b$var$n(2);
}
function $41d1ca1be2d2941b$var$y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function $41d1ca1be2d2941b$var$b(r) {
    var t = $41d1ca1be2d2941b$var$tn[r];
    return t || $41d1ca1be2d2941b$var$n(18, r), t;
}
function $41d1ca1be2d2941b$var$m(n, r) {
    $41d1ca1be2d2941b$var$tn[n] || ($41d1ca1be2d2941b$var$tn[n] = r);
}
function $41d1ca1be2d2941b$var$_() {
    return $41d1ca1be2d2941b$var$U;
}
function $41d1ca1be2d2941b$var$j(n, r) {
    r && ($41d1ca1be2d2941b$var$b("Patches"), n.u = [], n.s = [], n.v = r);
}
function $41d1ca1be2d2941b$var$g(n) {
    $41d1ca1be2d2941b$var$O(n), n.p.forEach($41d1ca1be2d2941b$var$S), n.p = null;
}
function $41d1ca1be2d2941b$var$O(n) {
    n === $41d1ca1be2d2941b$var$U && ($41d1ca1be2d2941b$var$U = n.l);
}
function $41d1ca1be2d2941b$var$w(n) {
    return $41d1ca1be2d2941b$var$U = {
        p: [],
        l: $41d1ca1be2d2941b$var$U,
        h: n,
        m: !0,
        _: 0
    };
}
function $41d1ca1be2d2941b$var$S(n) {
    var r = n[$41d1ca1be2d2941b$var$Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function $41d1ca1be2d2941b$var$P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || $41d1ca1be2d2941b$var$b("ES5").S(e, r, o), o ? (i[$41d1ca1be2d2941b$var$Q].P && ($41d1ca1be2d2941b$var$g(e), $41d1ca1be2d2941b$var$n(4)), $41d1ca1be2d2941b$export$16e3aed3edb85946(r) && (r = $41d1ca1be2d2941b$var$M(e, r), e.l || $41d1ca1be2d2941b$var$x(e, r)), e.u && $41d1ca1be2d2941b$var$b("Patches").M(i[$41d1ca1be2d2941b$var$Q].t, r, e.u, e.s)) : r = $41d1ca1be2d2941b$var$M(e, i, []), $41d1ca1be2d2941b$var$g(e), e.u && e.v(e.u, e.s), r !== $41d1ca1be2d2941b$export$45b790e32b2810ee ? r : void 0;
}
function $41d1ca1be2d2941b$var$M(n, r, t) {
    if ($41d1ca1be2d2941b$var$y(r)) return r;
    var e = r[$41d1ca1be2d2941b$var$Q];
    if (!e) return $41d1ca1be2d2941b$var$i(r, function(i, o) {
        return $41d1ca1be2d2941b$var$A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return $41d1ca1be2d2941b$var$x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = $41d1ca1be2d2941b$var$l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), $41d1ca1be2d2941b$var$i(u, function(r, i) {
            return $41d1ca1be2d2941b$var$A(n, e, o, r, i, t, a);
        }), $41d1ca1be2d2941b$var$x(n, o, !1), t && n.u && $41d1ca1be2d2941b$var$b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function $41d1ca1be2d2941b$var$A(e, i, o, a, c, s, v) {
    if ($41d1ca1be2d2941b$export$541ac630993a4c84(c)) {
        var p = $41d1ca1be2d2941b$var$M(e, c, s && i && 3 !== i.i && !$41d1ca1be2d2941b$var$u(i.R, a) ? s.concat(a) : void 0);
        if ($41d1ca1be2d2941b$var$f(o, a, p), !$41d1ca1be2d2941b$export$541ac630993a4c84(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if ($41d1ca1be2d2941b$export$16e3aed3edb85946(c) && !$41d1ca1be2d2941b$var$y(c)) {
        if (!e.h.D && e._ < 1) return;
        $41d1ca1be2d2941b$var$M(e, c), i && i.A.l || $41d1ca1be2d2941b$var$x(e, c);
    }
}
function $41d1ca1be2d2941b$var$x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && $41d1ca1be2d2941b$export$792f3d81ea979f55(r, t);
}
function $41d1ca1be2d2941b$var$z(n, r) {
    var t = n[$41d1ca1be2d2941b$var$Q];
    return (t ? $41d1ca1be2d2941b$var$p(t) : n)[r];
}
function $41d1ca1be2d2941b$var$I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function $41d1ca1be2d2941b$var$k(n) {
    n.P || (n.P = !0, n.l && $41d1ca1be2d2941b$var$k(n.l));
}
function $41d1ca1be2d2941b$var$E(n) {
    n.o || (n.o = $41d1ca1be2d2941b$var$l(n.t));
}
function $41d1ca1be2d2941b$var$N(n, r, t) {
    var e = $41d1ca1be2d2941b$var$s(r) ? $41d1ca1be2d2941b$var$b("MapSet").F(r, t) : $41d1ca1be2d2941b$var$v(r) ? $41d1ca1be2d2941b$var$b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : $41d1ca1be2d2941b$var$_(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = $41d1ca1be2d2941b$var$en;
        t && (i = [
            e
        ], o = $41d1ca1be2d2941b$var$on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : $41d1ca1be2d2941b$var$b("ES5").J(r, t);
    return (t ? t.A : $41d1ca1be2d2941b$var$_()).p.push(e), e;
}
function $41d1ca1be2d2941b$export$97aac956da55dae9(e) {
    return $41d1ca1be2d2941b$export$541ac630993a4c84(e) || $41d1ca1be2d2941b$var$n(22, e), function n(r) {
        if (!$41d1ca1be2d2941b$export$16e3aed3edb85946(r)) return r;
        var e, u = r[$41d1ca1be2d2941b$var$Q], c = $41d1ca1be2d2941b$var$o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !$41d1ca1be2d2941b$var$b("ES5").K(u))) return u.t;
            u.I = !0, e = $41d1ca1be2d2941b$var$D(r, c), u.I = !1;
        } else e = $41d1ca1be2d2941b$var$D(r, c);
        return $41d1ca1be2d2941b$var$i(e, function(r, t) {
            u && $41d1ca1be2d2941b$var$a(u.t, r) === t || $41d1ca1be2d2941b$var$f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function $41d1ca1be2d2941b$var$D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return $41d1ca1be2d2941b$var$l(n);
}
function $41d1ca1be2d2941b$export$56771cf63ee491f5() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[$41d1ca1be2d2941b$var$Q];
                return $41d1ca1be2d2941b$var$en.get(r, n);
            },
            set: function(r) {
                var t = this[$41d1ca1be2d2941b$var$Q];
                $41d1ca1be2d2941b$var$en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][$41d1ca1be2d2941b$var$Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && $41d1ca1be2d2941b$var$k(t);
                    break;
                case 4:
                    o(t) && $41d1ca1be2d2941b$var$k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = $41d1ca1be2d2941b$var$nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== $41d1ca1be2d2941b$var$Q) {
                var a = r[o];
                if (void 0 === a && !$41d1ca1be2d2941b$var$u(r, o)) return !0;
                var f = t[o], s = f && f[$41d1ca1be2d2941b$var$Q];
                if (s ? s.t !== a : !$41d1ca1be2d2941b$var$c(f, a)) return !0;
            }
        }
        var v = !!r[$41d1ca1be2d2941b$var$Q];
        return e.length !== $41d1ca1be2d2941b$var$nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && $41d1ca1be2d2941b$var$n(3, JSON.stringify($41d1ca1be2d2941b$var$p(r)));
    }
    var s = {};
    $41d1ca1be2d2941b$var$m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = $41d1ca1be2d2941b$var$rn(r);
                delete o[$41d1ca1be2d2941b$var$Q];
                for(var u = $41d1ca1be2d2941b$var$nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : $41d1ca1be2d2941b$var$_(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, $41d1ca1be2d2941b$var$Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? $41d1ca1be2d2941b$export$541ac630993a4c84(t) && t[$41d1ca1be2d2941b$var$Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[$41d1ca1be2d2941b$var$Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) $41d1ca1be2d2941b$var$i(o, function(r) {
                            r !== $41d1ca1be2d2941b$var$Q && (void 0 !== e[r] || $41d1ca1be2d2941b$var$u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, $41d1ca1be2d2941b$var$k(t)));
                        }), $41d1ca1be2d2941b$var$i(e, function(n) {
                            void 0 !== o[n] || $41d1ca1be2d2941b$var$u(o, n) || (f[n] = !1, $41d1ca1be2d2941b$var$k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && ($41d1ca1be2d2941b$var$k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function $41d1ca1be2d2941b$export$d3a6659991a0696c() {
    function e(n) {
        if (!$41d1ca1be2d2941b$export$16e3aed3edb85946(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if ($41d1ca1be2d2941b$var$s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if ($41d1ca1be2d2941b$var$v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return $41d1ca1be2d2941b$var$u(n, $41d1ca1be2d2941b$export$6ee2082928bcb0ee) && (r[$41d1ca1be2d2941b$export$6ee2082928bcb0ee] = n[$41d1ca1be2d2941b$export$6ee2082928bcb0ee]), r;
    }
    function f(n) {
        return $41d1ca1be2d2941b$export$541ac630993a4c84(n) ? e(n) : n;
    }
    var c = "add";
    $41d1ca1be2d2941b$var$m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = $41d1ca1be2d2941b$var$o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || $41d1ca1be2d2941b$var$n(24), "function" == typeof f && "prototype" === p && $41d1ca1be2d2941b$var$n(24), "object" != typeof (f = $41d1ca1be2d2941b$var$a(f, p)) && $41d1ca1be2d2941b$var$n(15, i.join("/"));
                }
                var l = $41d1ca1be2d2941b$var$o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                $41d1ca1be2d2941b$var$n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        $41d1ca1be2d2941b$var$n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        $41d1ca1be2d2941b$var$i(n.R, function(n, i) {
                            var v = $41d1ca1be2d2941b$var$a(o, n), p = $41d1ca1be2d2941b$var$a(s, n), l = i ? $41d1ca1be2d2941b$var$u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === $41d1ca1be2d2941b$export$45b790e32b2810ee ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function $41d1ca1be2d2941b$export$7d9f65390203b435() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if ($41d1ca1be2d2941b$export$16e3aed3edb85946(r)) {
                var e = $41d1ca1be2d2941b$var$N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && $41d1ca1be2d2941b$var$n(3, JSON.stringify($41d1ca1be2d2941b$var$p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[$41d1ca1be2d2941b$var$Q] = {
                i: 2,
                l: r,
                A: r ? r.A : $41d1ca1be2d2941b$var$_(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return $41d1ca1be2d2941b$var$p(this[$41d1ca1be2d2941b$var$Q]).size;
            }
        }), o.has = function(n) {
            return $41d1ca1be2d2941b$var$p(this[$41d1ca1be2d2941b$var$Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[$41d1ca1be2d2941b$var$Q];
            return u(t), $41d1ca1be2d2941b$var$p(t).has(n) && $41d1ca1be2d2941b$var$p(t).get(n) === r || (e(t), $41d1ca1be2d2941b$var$k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[$41d1ca1be2d2941b$var$Q];
            return u(r), e(r), $41d1ca1be2d2941b$var$k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[$41d1ca1be2d2941b$var$Q];
            u(n), $41d1ca1be2d2941b$var$p(n).size && (e(n), $41d1ca1be2d2941b$var$k(n), n.R = new Map, $41d1ca1be2d2941b$var$i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            $41d1ca1be2d2941b$var$p(this[$41d1ca1be2d2941b$var$Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[$41d1ca1be2d2941b$var$Q];
            u(r);
            var i = $41d1ca1be2d2941b$var$p(r).get(n);
            if (r.I || !$41d1ca1be2d2941b$export$16e3aed3edb85946(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = $41d1ca1be2d2941b$var$N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return $41d1ca1be2d2941b$var$p(this[$41d1ca1be2d2941b$var$Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[$41d1ca1be2d2941b$var$V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[$41d1ca1be2d2941b$var$V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[$41d1ca1be2d2941b$var$V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[$41d1ca1be2d2941b$var$Q] = {
                i: 3,
                l: r,
                A: r ? r.A : $41d1ca1be2d2941b$var$_(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return $41d1ca1be2d2941b$var$p(this[$41d1ca1be2d2941b$var$Q]).size;
            }
        }), t.has = function(n) {
            var r = this[$41d1ca1be2d2941b$var$Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[$41d1ca1be2d2941b$var$Q];
            return u(r), this.has(n) || (o(r), $41d1ca1be2d2941b$var$k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[$41d1ca1be2d2941b$var$Q];
            return u(r), o(r), $41d1ca1be2d2941b$var$k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[$41d1ca1be2d2941b$var$Q];
            u(n), $41d1ca1be2d2941b$var$p(n).size && (o(n), $41d1ca1be2d2941b$var$k(n), n.o.clear());
        }, t.values = function() {
            var n = this[$41d1ca1be2d2941b$var$Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[$41d1ca1be2d2941b$var$Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[$41d1ca1be2d2941b$var$V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    $41d1ca1be2d2941b$var$m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function $41d1ca1be2d2941b$export$cae049b67c7d1bc9() {
    $41d1ca1be2d2941b$export$56771cf63ee491f5(), $41d1ca1be2d2941b$export$7d9f65390203b435(), $41d1ca1be2d2941b$export$d3a6659991a0696c();
}
function $41d1ca1be2d2941b$export$c05b21e3257751e5(n) {
    return n;
}
function $41d1ca1be2d2941b$export$20f911b3f8cf0b74(n) {
    return n;
}
var $41d1ca1be2d2941b$var$G, $41d1ca1be2d2941b$var$U, $41d1ca1be2d2941b$var$W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), $41d1ca1be2d2941b$var$X = "undefined" != typeof Map, $41d1ca1be2d2941b$var$q = "undefined" != typeof Set, $41d1ca1be2d2941b$var$B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, $41d1ca1be2d2941b$export$45b790e32b2810ee = $41d1ca1be2d2941b$var$W ? Symbol.for("immer-nothing") : (($41d1ca1be2d2941b$var$G = {})["immer-nothing"] = !0, $41d1ca1be2d2941b$var$G), $41d1ca1be2d2941b$export$6ee2082928bcb0ee = $41d1ca1be2d2941b$var$W ? Symbol.for("immer-draftable") : "__$immer_draftable", $41d1ca1be2d2941b$var$Q = $41d1ca1be2d2941b$var$W ? Symbol.for("immer-state") : "__$immer_state", $41d1ca1be2d2941b$var$V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", $41d1ca1be2d2941b$var$Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, $41d1ca1be2d2941b$var$Z = "" + Object.prototype.constructor, $41d1ca1be2d2941b$var$nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, $41d1ca1be2d2941b$var$rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return $41d1ca1be2d2941b$var$nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, $41d1ca1be2d2941b$var$tn = {}, $41d1ca1be2d2941b$var$en = {
    get: function(n, r) {
        if (r === $41d1ca1be2d2941b$var$Q) return n;
        var e = $41d1ca1be2d2941b$var$p(n);
        if (!$41d1ca1be2d2941b$var$u(e, r)) return function(n, r, t) {
            var e, i = $41d1ca1be2d2941b$var$I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !$41d1ca1be2d2941b$export$16e3aed3edb85946(i) ? i : i === $41d1ca1be2d2941b$var$z(n.t, r) ? ($41d1ca1be2d2941b$var$E(n), n.o[r] = $41d1ca1be2d2941b$var$N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in $41d1ca1be2d2941b$var$p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys($41d1ca1be2d2941b$var$p(n));
    },
    set: function(n, r, t) {
        var e = $41d1ca1be2d2941b$var$I($41d1ca1be2d2941b$var$p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = $41d1ca1be2d2941b$var$z($41d1ca1be2d2941b$var$p(n), r), o = null == i ? void 0 : i[$41d1ca1be2d2941b$var$Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if ($41d1ca1be2d2941b$var$c(t, i) && (void 0 !== t || $41d1ca1be2d2941b$var$u(n.t, r))) return !0;
            $41d1ca1be2d2941b$var$E(n), $41d1ca1be2d2941b$var$k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== $41d1ca1be2d2941b$var$z(n.t, r) || r in n.t ? (n.R[r] = !1, $41d1ca1be2d2941b$var$E(n), $41d1ca1be2d2941b$var$k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = $41d1ca1be2d2941b$var$p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        $41d1ca1be2d2941b$var$n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        $41d1ca1be2d2941b$var$n(12);
    }
}, $41d1ca1be2d2941b$var$on = {};
$41d1ca1be2d2941b$var$i($41d1ca1be2d2941b$var$en, function(n, r) {
    $41d1ca1be2d2941b$var$on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), $41d1ca1be2d2941b$var$on.deleteProperty = function(r, t) {
    return $41d1ca1be2d2941b$var$on.set.call(this, r, t, void 0);
}, $41d1ca1be2d2941b$var$on.set = function(r, t, e) {
    return $41d1ca1be2d2941b$var$en.set.call(this, r[0], t, e, r[0]);
};
var $41d1ca1be2d2941b$export$aaadc6ff0f822719 = function() {
    function e(r) {
        var e = this;
        this.O = $41d1ca1be2d2941b$var$B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && $41d1ca1be2d2941b$var$n(6), void 0 !== o && "function" != typeof o && $41d1ca1be2d2941b$var$n(7), $41d1ca1be2d2941b$export$16e3aed3edb85946(r)) {
                var c = $41d1ca1be2d2941b$var$w(e), s = $41d1ca1be2d2941b$var$N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? $41d1ca1be2d2941b$var$g(c) : $41d1ca1be2d2941b$var$O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return $41d1ca1be2d2941b$var$j(c, o), $41d1ca1be2d2941b$var$P(n, c);
                }, function(n) {
                    throw $41d1ca1be2d2941b$var$g(c), n;
                }) : ($41d1ca1be2d2941b$var$j(c, o), $41d1ca1be2d2941b$var$P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === $41d1ca1be2d2941b$export$45b790e32b2810ee && (f = void 0), e.D && $41d1ca1be2d2941b$export$792f3d81ea979f55(f, !0), o) {
                    var p = [], l = [];
                    $41d1ca1be2d2941b$var$b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            $41d1ca1be2d2941b$var$n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        $41d1ca1be2d2941b$export$16e3aed3edb85946(e) || $41d1ca1be2d2941b$var$n(8), $41d1ca1be2d2941b$export$541ac630993a4c84(e) && (e = $41d1ca1be2d2941b$export$97aac956da55dae9(e));
        var i = $41d1ca1be2d2941b$var$w(this), o = $41d1ca1be2d2941b$var$N(this, e, void 0);
        return o[$41d1ca1be2d2941b$var$Q].C = !0, $41d1ca1be2d2941b$var$O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[$41d1ca1be2d2941b$var$Q];
        var i = e.A;
        return $41d1ca1be2d2941b$var$j(i, t), $41d1ca1be2d2941b$var$P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !$41d1ca1be2d2941b$var$B && $41d1ca1be2d2941b$var$n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = $41d1ca1be2d2941b$var$b("Patches").$;
        return $41d1ca1be2d2941b$export$541ac630993a4c84(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), $41d1ca1be2d2941b$var$an = new $41d1ca1be2d2941b$export$aaadc6ff0f822719, $41d1ca1be2d2941b$export$b46cabe22e78bc00 = $41d1ca1be2d2941b$var$an.produce, $41d1ca1be2d2941b$export$4da66d41c9492c78 = $41d1ca1be2d2941b$var$an.produceWithPatches.bind($41d1ca1be2d2941b$var$an), $41d1ca1be2d2941b$export$573f26f60825c493 = $41d1ca1be2d2941b$var$an.setAutoFreeze.bind($41d1ca1be2d2941b$var$an), $41d1ca1be2d2941b$export$36ccd207ae29b74e = $41d1ca1be2d2941b$var$an.setUseProxies.bind($41d1ca1be2d2941b$var$an), $41d1ca1be2d2941b$export$a8b8e03e6bbe5473 = $41d1ca1be2d2941b$var$an.applyPatches.bind($41d1ca1be2d2941b$var$an), $41d1ca1be2d2941b$export$3c3214997190395f = $41d1ca1be2d2941b$var$an.createDraft.bind($41d1ca1be2d2941b$var$an), $41d1ca1be2d2941b$export$c60f5e69c521b528 = $41d1ca1be2d2941b$var$an.finishDraft.bind($41d1ca1be2d2941b$var$an);
var $41d1ca1be2d2941b$export$2e2bcd8739ae039 = $41d1ca1be2d2941b$export$b46cabe22e78bc00;



// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $5a4502fad9f03d7c$var$NOT_FOUND = "NOT_FOUND";
function $5a4502fad9f03d7c$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $5a4502fad9f03d7c$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $5a4502fad9f03d7c$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $5a4502fad9f03d7c$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $5a4502fad9f03d7c$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $5a4502fad9f03d7c$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $5a4502fad9f03d7c$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $5a4502fad9f03d7c$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $5a4502fad9f03d7c$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $5a4502fad9f03d7c$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $5a4502fad9f03d7c$var$createSingletonCache(comparator) : $5a4502fad9f03d7c$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $5a4502fad9f03d7c$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}


function $1c1264e22f566687$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $1c1264e22f566687$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $1c1264e22f566687$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $1c1264e22f566687$export$595d22ed68ca2841 = /* #__PURE__ */ $1c1264e22f566687$export$5943f4447f6ef248((0, $5a4502fad9f03d7c$export$281bff7f05488aa2));
var $1c1264e22f566687$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $1c1264e22f566687$export$595d22ed68ca2841;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};


/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $73dcf478a062659e$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $73dcf478a062659e$var$thunk = $73dcf478a062659e$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$73dcf478a062659e$var$thunk.withExtraArgument = $73dcf478a062659e$var$createThunkMiddleware;
var $73dcf478a062659e$export$2e2bcd8739ae039 = $73dcf478a062659e$var$thunk;



var $7dgut = parcelRequire("7dgut");
var $d2702be57030c372$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d2702be57030c372$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $d2702be57030c372$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $d2702be57030c372$var$__defProp = Object.defineProperty;
var $d2702be57030c372$var$__defProps = Object.defineProperties;
var $d2702be57030c372$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d2702be57030c372$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d2702be57030c372$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d2702be57030c372$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d2702be57030c372$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $d2702be57030c372$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $d2702be57030c372$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($d2702be57030c372$var$__hasOwnProp.call(b, prop)) $d2702be57030c372$var$__defNormalProp(a, prop, b[prop]);
    if ($d2702be57030c372$var$__getOwnPropSymbols) for(var _i = 0, _c = $d2702be57030c372$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($d2702be57030c372$var$__propIsEnum.call(b, prop)) $d2702be57030c372$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d2702be57030c372$var$__spreadProps = function(a, b) {
    return $d2702be57030c372$var$__defProps(a, $d2702be57030c372$var$__getOwnPropDescs(b));
};
var $d2702be57030c372$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $d2702be57030c372$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $1c1264e22f566687$export$595d22ed68ca2841).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $d2702be57030c372$var$__spreadArray([
            (0, $41d1ca1be2d2941b$export$541ac630993a4c84)(value) ? (0, $41d1ca1be2d2941b$export$97aac956da55dae9)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $d2702be57030c372$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $8bb7c10694c071aa$export$f672e0b6f7222cd7;
    return (0, $8bb7c10694c071aa$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $d2702be57030c372$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $d2702be57030c372$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
function $d2702be57030c372$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $d2702be57030c372$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $d2702be57030c372$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $d2702be57030c372$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $d2702be57030c372$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $d2702be57030c372$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $d2702be57030c372$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $d2702be57030c372$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $d2702be57030c372$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $d2702be57030c372$var$freezeDraftable(val) {
    return (0, $41d1ca1be2d2941b$export$16e3aed3edb85946)(val) ? (0, $41d1ca1be2d2941b$export$2e2bcd8739ae039)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $d2702be57030c372$var$isProduction = true;
var $d2702be57030c372$var$prefix = "Invariant failed";
function $d2702be57030c372$var$invariant(condition, message) {
    if (condition) return;
    if ($d2702be57030c372$var$isProduction) throw new Error($d2702be57030c372$var$prefix);
    throw new Error($d2702be57030c372$var$prefix + ": " + (message || ""));
}
function $d2702be57030c372$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $d2702be57030c372$var$getSerialize(serializer, decycler), indent);
}
function $d2702be57030c372$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $d2702be57030c372$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $d2702be57030c372$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $d2702be57030c372$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $d2702be57030c372$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $d2702be57030c372$var$trackProperties(isImmutable, ignorePaths, obj, path) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj)) {
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $d2702be57030c372$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $d2702be57030c372$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $d2702be57030c372$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $d2702be57030c372$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $d2702be57030c372$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $d2702be57030c372$export$53b83ca8eaab0383(val);
}
function $d2702be57030c372$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $d2702be57030c372$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $d2702be57030c372$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $d2702be57030c372$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $d2702be57030c372$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$d2702be57030c372$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $d2702be57030c372$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $d2702be57030c372$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $d2702be57030c372$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $d2702be57030c372$export$36c1185aeee5b0a6(options);
    };
}
function $d2702be57030c372$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e;
    var middlewareArray = new $d2702be57030c372$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($d2702be57030c372$var$isBoolean(thunk)) middlewareArray.push((0, $73dcf478a062659e$export$2e2bcd8739ae039));
        else middlewareArray.push((0, $73dcf478a062659e$export$2e2bcd8739ae039).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $d2702be57030c372$var$IS_PRODUCTION = true;
function $d2702be57030c372$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $d2702be57030c372$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($d2702be57030c372$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $8bb7c10694c071aa$export$66e4520cdb265d18)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$d2702be57030c372$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$d2702be57030c372$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $8bb7c10694c071aa$export$9ff26e0402cc7b7).apply(void 0, finalMiddleware);
    var finalCompose = (0, $8bb7c10694c071aa$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $d2702be57030c372$var$composeWithDevTools($d2702be57030c372$var$__spreadValues({
        trace: !$d2702be57030c372$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $d2702be57030c372$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $d2702be57030c372$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $8bb7c10694c071aa$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/createAction.ts
function $d2702be57030c372$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $d2702be57030c372$var$__spreadValues($d2702be57030c372$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $d2702be57030c372$export$b956e38827fca970(action) {
    return $d2702be57030c372$export$53b83ca8eaab0383(action) && "type" in action;
}
function $d2702be57030c372$export$ebd532f9034651f3(action) {
    return $d2702be57030c372$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($d2702be57030c372$var$isValidKey);
}
function $d2702be57030c372$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $d2702be57030c372$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/mapBuilders.ts
function $d2702be57030c372$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (type in actionsMap) throw new Error("addCase cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $d2702be57030c372$var$isStateFunction(x) {
    return typeof x === "function";
}
var $d2702be57030c372$var$hasWarnedAboutObjectNotation = false;
function $d2702be57030c372$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $d2702be57030c372$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($d2702be57030c372$var$isStateFunction(initialState)) getInitialState = function() {
        return $d2702be57030c372$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $d2702be57030c372$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $d2702be57030c372$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $41d1ca1be2d2941b$export$541ac630993a4c84)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $41d1ca1be2d2941b$export$16e3aed3edb85946)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $41d1ca1be2d2941b$export$2e2bcd8739ae039)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $d2702be57030c372$var$hasWarnedAboutObjectNotation2 = false;
function $d2702be57030c372$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $d2702be57030c372$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $7dgut;
    var initialState = typeof options.initialState == "function" ? options.initialState : $d2702be57030c372$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $d2702be57030c372$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $d2702be57030c372$export$309c7a02b0b0bc62(type, prepareCallback) : $d2702be57030c372$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $d2702be57030c372$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $d2702be57030c372$var$__spreadValues($d2702be57030c372$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $d2702be57030c372$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $d2702be57030c372$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $d2702be57030c372$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($d2702be57030c372$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $d2702be57030c372$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $d2702be57030c372$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $d2702be57030c372$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $d2702be57030c372$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $d2702be57030c372$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $d2702be57030c372$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $d2702be57030c372$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $d2702be57030c372$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $d2702be57030c372$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $d2702be57030c372$var$createSingleArgumentStateOperator(mutator) {
    var operator = $d2702be57030c372$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $d2702be57030c372$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $d2702be57030c372$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $41d1ca1be2d2941b$export$541ac630993a4c84)(state)) {
            runMutator(state);
            return state;
        } else return (0, $41d1ca1be2d2941b$export$2e2bcd8739ae039)(state, runMutator);
    };
}
// src/entities/utils.ts
function $d2702be57030c372$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $d2702be57030c372$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $d2702be57030c372$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $d2702be57030c372$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $d2702be57030c372$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $d2702be57030c372$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $d2702be57030c372$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $d2702be57030c372$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $d2702be57030c372$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $d2702be57030c372$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d2702be57030c372$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $d2702be57030c372$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $d2702be57030c372$var$__spreadValues($d2702be57030c372$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $d2702be57030c372$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $d2702be57030c372$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $d2702be57030c372$var$createStateOperator(addOneMutably),
        addMany: $d2702be57030c372$var$createStateOperator(addManyMutably),
        setOne: $d2702be57030c372$var$createStateOperator(setOneMutably),
        setMany: $d2702be57030c372$var$createStateOperator(setManyMutably),
        setAll: $d2702be57030c372$var$createStateOperator(setAllMutably),
        updateOne: $d2702be57030c372$var$createStateOperator(updateOneMutably),
        updateMany: $d2702be57030c372$var$createStateOperator(updateManyMutably),
        upsertOne: $d2702be57030c372$var$createStateOperator(upsertOneMutably),
        upsertMany: $d2702be57030c372$var$createStateOperator(upsertManyMutably),
        removeOne: $d2702be57030c372$var$createStateOperator(removeOneMutably),
        removeMany: $d2702be57030c372$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $d2702be57030c372$var$createSortedStateAdapter(selectId, sort) {
    var _c = $d2702be57030c372$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $d2702be57030c372$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($d2702be57030c372$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $d2702be57030c372$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d2702be57030c372$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $d2702be57030c372$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $d2702be57030c372$var$createStateOperator(addOneMutably),
        updateOne: $d2702be57030c372$var$createStateOperator(updateOneMutably),
        upsertOne: $d2702be57030c372$var$createStateOperator(upsertOneMutably),
        setOne: $d2702be57030c372$var$createStateOperator(setOneMutably),
        setMany: $d2702be57030c372$var$createStateOperator(setManyMutably),
        setAll: $d2702be57030c372$var$createStateOperator(setAllMutably),
        addMany: $d2702be57030c372$var$createStateOperator(addManyMutably),
        updateMany: $d2702be57030c372$var$createStateOperator(updateManyMutably),
        upsertMany: $d2702be57030c372$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $d2702be57030c372$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $d2702be57030c372$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $d2702be57030c372$var$createInitialStateFactory();
    var selectorsFactory = $d2702be57030c372$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $d2702be57030c372$var$createSortedStateAdapter(selectId, sortComparer) : $d2702be57030c372$var$createUnsortedStateAdapter(selectId);
    return $d2702be57030c372$var$__spreadValues($d2702be57030c372$var$__spreadValues($d2702be57030c372$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $d2702be57030c372$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $d2702be57030c372$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $d2702be57030c372$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $d2702be57030c372$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $d2702be57030c372$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $d2702be57030c372$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $d2702be57030c372$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $d2702be57030c372$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $d2702be57030c372$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $d2702be57030c372$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $d2702be57030c372$var$__spreadProps($d2702be57030c372$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $d2702be57030c372$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $d2702be57030c372$var$__spreadProps($d2702be57030c372$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $d2702be57030c372$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $d2702be57030c372$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $d2702be57030c372$var$__spreadProps($d2702be57030c372$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $d2702be57030c372$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $d2702be57030c372$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $d2702be57030c372$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$d2702be57030c372$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $d2702be57030c372$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $d2702be57030c372$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $d2702be57030c372$var$RejectWithValue) throw result;
                                                if (result instanceof $d2702be57030c372$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $d2702be57030c372$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($d2702be57030c372$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $d2702be57030c372$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $d2702be57030c372$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/tsHelpers.ts
var $d2702be57030c372$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/matchers.ts
var $d2702be57030c372$var$matches = function(matcher, action) {
    if ($d2702be57030c372$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $d2702be57030c372$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $d2702be57030c372$var$matches(matcher, action);
        });
    };
}
function $d2702be57030c372$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $d2702be57030c372$var$matches(matcher, action);
        });
    };
}
function $d2702be57030c372$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $d2702be57030c372$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $d2702be57030c372$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $d2702be57030c372$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$d2702be57030c372$var$isAsyncThunkArray(asyncThunks)) return $d2702be57030c372$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $d2702be57030c372$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $d2702be57030c372$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $d2702be57030c372$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$d2702be57030c372$var$isAsyncThunkArray(asyncThunks)) return $d2702be57030c372$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $d2702be57030c372$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $d2702be57030c372$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $d2702be57030c372$export$9dd1fb32974da385($d2702be57030c372$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$d2702be57030c372$var$isAsyncThunkArray(asyncThunks)) return $d2702be57030c372$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $d2702be57030c372$export$9dd1fb32974da385($d2702be57030c372$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $d2702be57030c372$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $d2702be57030c372$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$d2702be57030c372$var$isAsyncThunkArray(asyncThunks)) return $d2702be57030c372$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $d2702be57030c372$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $d2702be57030c372$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $d2702be57030c372$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$d2702be57030c372$var$isAsyncThunkArray(asyncThunks)) return $d2702be57030c372$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $d2702be57030c372$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $d2702be57030c372$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $d2702be57030c372$var$noop = function() {};
var $d2702be57030c372$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $d2702be57030c372$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $d2702be57030c372$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $d2702be57030c372$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $d2702be57030c372$var$task = "task";
var $d2702be57030c372$var$listener = "listener";
var $d2702be57030c372$var$completed = "completed";
var $d2702be57030c372$var$cancelled = "cancelled";
var $d2702be57030c372$var$taskCancelled = "task-" + $d2702be57030c372$var$cancelled;
var $d2702be57030c372$var$taskCompleted = "task-" + $d2702be57030c372$var$completed;
var $d2702be57030c372$var$listenerCancelled = $d2702be57030c372$var$listener + "-" + $d2702be57030c372$var$cancelled;
var $d2702be57030c372$var$listenerCompleted = $d2702be57030c372$var$listener + "-" + $d2702be57030c372$var$completed;
var $d2702be57030c372$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $d2702be57030c372$var$task + " " + $d2702be57030c372$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $d2702be57030c372$var$validateActive = function(signal) {
    if (signal.aborted) throw new $d2702be57030c372$export$cb1bdac908fed7f(signal.reason);
};
function $d2702be57030c372$var$raceWithSignal(signal, promise2) {
    var cleanup = $d2702be57030c372$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $d2702be57030c372$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $d2702be57030c372$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $d2702be57030c372$var$noop;
    });
}
var $d2702be57030c372$var$runTask = function(task2, cleanUp) {
    return $d2702be57030c372$var$__async(void 0, null, function() {
        var value, error_1;
        return $d2702be57030c372$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $d2702be57030c372$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $d2702be57030c372$var$createPause = function(signal) {
    return function(promise2) {
        return $d2702be57030c372$var$catchRejection($d2702be57030c372$var$raceWithSignal(signal, promise2).then(function(output) {
            $d2702be57030c372$var$validateActive(signal);
            return output;
        }));
    };
};
var $d2702be57030c372$var$createDelay = function(signal) {
    var pause = $d2702be57030c372$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $d2702be57030c372$var$assign = Object.assign;
var $d2702be57030c372$var$INTERNAL_NIL_TOKEN = {};
var $d2702be57030c372$var$alm = "listenerMiddleware";
var $d2702be57030c372$var$createFork = function(parentAbortSignal) {
    var linkControllers = function(controller) {
        return $d2702be57030c372$var$addAbortSignalListener(parentAbortSignal, function() {
            return $d2702be57030c372$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor) {
        $d2702be57030c372$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $d2702be57030c372$var$runTask(function() {
            return $d2702be57030c372$var$__async(void 0, null, function() {
                var result2;
                return $d2702be57030c372$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $d2702be57030c372$var$validateActive(parentAbortSignal);
                            $d2702be57030c372$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $d2702be57030c372$var$createPause(childAbortController.signal),
                                    delay: $d2702be57030c372$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $d2702be57030c372$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $d2702be57030c372$var$abortControllerWithReason(childAbortController, $d2702be57030c372$var$taskCompleted);
        });
        return {
            result: $d2702be57030c372$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $d2702be57030c372$var$abortControllerWithReason(childAbortController, $d2702be57030c372$var$taskCancelled);
            }
        };
    };
};
var $d2702be57030c372$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $d2702be57030c372$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $d2702be57030c372$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $d2702be57030c372$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $d2702be57030c372$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $d2702be57030c372$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $d2702be57030c372$var$catchRejection(take(predicate, timeout));
    };
};
var $d2702be57030c372$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $d2702be57030c372$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $d2702be57030c372$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $d2702be57030c372$var$createListenerEntry = function(options) {
    var _c = $d2702be57030c372$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $d2702be57030c372$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $d2702be57030c372$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $d2702be57030c372$var$abortControllerWithReason(controller, $d2702be57030c372$var$listenerCancelled);
    });
};
var $d2702be57030c372$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($d2702be57030c372$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $d2702be57030c372$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $d2702be57030c372$export$f03a6b845d3fb58b = $d2702be57030c372$export$309c7a02b0b0bc62($d2702be57030c372$var$alm + "/add");
var $d2702be57030c372$export$b1b8022855fb2b71 = $d2702be57030c372$export$309c7a02b0b0bc62($d2702be57030c372$var$alm + "/removeAll");
var $d2702be57030c372$export$b03e9483f936dccb = $d2702be57030c372$export$309c7a02b0b0bc62($d2702be57030c372$var$alm + "/remove");
var $d2702be57030c372$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $d2702be57030c372$var$__spreadArray([
        $d2702be57030c372$var$alm + "/error"
    ], args));
};
function $d2702be57030c372$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $d2702be57030c372$var$defaultErrorHandler : _c;
    $d2702be57030c372$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $d2702be57030c372$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $d2702be57030c372$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $d2702be57030c372$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $d2702be57030c372$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $d2702be57030c372$var$__async(_this, null, function() {
            var internalTaskController, take, listenerError_1;
            return $d2702be57030c372$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $d2702be57030c372$var$createTakePattern(startListening, internalTaskController.signal);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $d2702be57030c372$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $d2702be57030c372$var$createDelay(internalTaskController.signal),
                                pause: $d2702be57030c372$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $d2702be57030c372$var$createFork(internalTaskController.signal),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $d2702be57030c372$var$abortControllerWithReason(controller, $d2702be57030c372$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $d2702be57030c372$export$cb1bdac908fed7f)) $d2702be57030c372$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        $d2702be57030c372$var$abortControllerWithReason(internalTaskController, $d2702be57030c372$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $d2702be57030c372$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$d2702be57030c372$export$b956e38827fca970(action)) return next(action);
                if ($d2702be57030c372$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($d2702be57030c372$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($d2702be57030c372$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $d2702be57030c372$var$INTERNAL_NIL_TOKEN) throw new Error($d2702be57030c372$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $d2702be57030c372$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $d2702be57030c372$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $d2702be57030c372$export$8fb31c0f05df007b = "RTK_autoBatch";
var $d2702be57030c372$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$d2702be57030c372$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $d2702be57030c372$var$promise;
var $d2702be57030c372$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($d2702be57030c372$var$promise || ($d2702be57030c372$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $d2702be57030c372$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $d2702be57030c372$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $d2702be57030c372$var$createQueueWithTimer(10);
var $d2702be57030c372$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $d2702be57030c372$var$queueMicrotaskShim : options.type === "raf" ? $d2702be57030c372$var$rAF : options.type === "callback" ? options.queueNotification : $d2702be57030c372$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$d2702be57030c372$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $41d1ca1be2d2941b$export$56771cf63ee491f5)();



var $496d466e13414dc7$exports = {};
/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/ (function(root, definition) {
    "use strict";
    if (typeof define === "function" && define.amd) define(definition);
    else if (0, $496d466e13414dc7$exports) $496d466e13414dc7$exports = definition();
    else root.log = definition();
})($496d466e13414dc7$exports, function() {
    "use strict";
    // Slightly dubious tricks to cut down minimized file size
    var noop = function() {};
    var undefinedType = "undefined";
    var isIE = typeof window !== undefinedType && typeof window.navigator !== undefinedType && /Trident\/|MSIE /.test(window.navigator.userAgent);
    var logMethods = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
    ];
    // Cross-browser bind equivalent that works at least back to IE6
    function bindMethod(obj, methodName) {
        var method = obj[methodName];
        if (typeof method.bind === "function") return method.bind(obj);
        else try {
            return Function.prototype.bind.call(method, obj);
        } catch (e) {
            // Missing bind shim or IE8 + Modernizr, fallback to wrapping
            return function() {
                return Function.prototype.apply.apply(method, [
                    obj,
                    arguments
                ]);
            };
        }
    }
    // Trace() doesn't print the message in IE, so for that case we need to wrap it
    function traceForIE() {
        if (console.log) {
            if (console.log.apply) console.log.apply(console, arguments);
            else // In old IE, native console methods themselves don't have apply().
            Function.prototype.apply.apply(console.log, [
                console,
                arguments
            ]);
        }
        if (console.trace) console.trace();
    }
    // Build the best logging method possible for this env
    // Wherever possible we want to bind, not wrap, to preserve stack traces
    function realMethod(methodName) {
        if (methodName === "debug") methodName = "log";
        if (typeof console === undefinedType) return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
        else if (methodName === "trace" && isIE) return traceForIE;
        else if (console[methodName] !== undefined) return bindMethod(console, methodName);
        else if (console.log !== undefined) return bindMethod(console, "log");
        else return noop;
    }
    // These private functions always need `this` to be set properly
    function replaceLoggingMethods(level, loggerName) {
        /*jshint validthis:true */ for(var i = 0; i < logMethods.length; i++){
            var methodName = logMethods[i];
            this[methodName] = i < level ? noop : this.methodFactory(methodName, level, loggerName);
        }
        // Define log.log as an alias for log.debug
        this.log = this.debug;
    }
    // In old IE versions, the console isn't present until you first open it.
    // We build realMethod() replacements here that regenerate logging methods
    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
        return function() {
            if (typeof console !== undefinedType) {
                replaceLoggingMethods.call(this, level, loggerName);
                this[methodName].apply(this, arguments);
            }
        };
    }
    // By default, we use closely bound real methods wherever possible, and
    // otherwise we wait for a console to appear, and then try again.
    function defaultMethodFactory(methodName, level, loggerName) {
        /*jshint validthis:true */ return realMethod(methodName) || enableLoggingWhenConsoleArrives.apply(this, arguments);
    }
    function Logger(name, defaultLevel, factory) {
        var self = this;
        var currentLevel;
        defaultLevel = defaultLevel == null ? "WARN" : defaultLevel;
        var storageKey = "loglevel";
        if (typeof name === "string") storageKey += ":" + name;
        else if (typeof name === "symbol") storageKey = undefined;
        function persistLevelIfPossible(levelNum) {
            var levelName = (logMethods[levelNum] || "silent").toUpperCase();
            if (typeof window === undefinedType || !storageKey) return;
            // Use localStorage if available
            try {
                window.localStorage[storageKey] = levelName;
                return;
            } catch (ignore) {}
            // Use session cookie as fallback
            try {
                window.document.cookie = encodeURIComponent(storageKey) + "=" + levelName + ";";
            } catch (ignore) {}
        }
        function getPersistedLevel() {
            var storedLevel;
            if (typeof window === undefinedType || !storageKey) return;
            try {
                storedLevel = window.localStorage[storageKey];
            } catch (ignore) {}
            // Fallback to cookies if local storage gives us nothing
            if (typeof storedLevel === undefinedType) try {
                var cookie = window.document.cookie;
                var location = cookie.indexOf(encodeURIComponent(storageKey) + "=");
                if (location !== -1) storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
            } catch (ignore) {}
            // If the stored level is not valid, treat it as if nothing was stored.
            if (self.levels[storedLevel] === undefined) storedLevel = undefined;
            return storedLevel;
        }
        function clearPersistedLevel() {
            if (typeof window === undefinedType || !storageKey) return;
            // Use localStorage if available
            try {
                window.localStorage.removeItem(storageKey);
                return;
            } catch (ignore) {}
            // Use session cookie as fallback
            try {
                window.document.cookie = encodeURIComponent(storageKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            } catch (ignore) {}
        }
        /*
       *
       * Public logger API - see https://github.com/pimterry/loglevel for details
       *
       */ self.name = name;
        self.levels = {
            "TRACE": 0,
            "DEBUG": 1,
            "INFO": 2,
            "WARN": 3,
            "ERROR": 4,
            "SILENT": 5
        };
        self.methodFactory = factory || defaultMethodFactory;
        self.getLevel = function() {
            return currentLevel;
        };
        self.setLevel = function(level, persist) {
            if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) level = self.levels[level.toUpperCase()];
            if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
                currentLevel = level;
                if (persist !== false) persistLevelIfPossible(level);
                replaceLoggingMethods.call(self, level, name);
                if (typeof console === undefinedType && level < self.levels.SILENT) return "No console available for logging";
            } else throw "log.setLevel() called with invalid level: " + level;
        };
        self.setDefaultLevel = function(level) {
            defaultLevel = level;
            if (!getPersistedLevel()) self.setLevel(level, false);
        };
        self.resetLevel = function() {
            self.setLevel(defaultLevel, false);
            clearPersistedLevel();
        };
        self.enableAll = function(persist) {
            self.setLevel(self.levels.TRACE, persist);
        };
        self.disableAll = function(persist) {
            self.setLevel(self.levels.SILENT, persist);
        };
        // Initialize with the right level
        var initialLevel = getPersistedLevel();
        if (initialLevel == null) initialLevel = defaultLevel;
        self.setLevel(initialLevel, false);
    }
    /*
     *
     * Top-level API
     *
     */ var defaultLogger = new Logger();
    var _loggersByName = {};
    defaultLogger.getLogger = function getLogger(name) {
        if (typeof name !== "symbol" && typeof name !== "string" || name === "") throw new TypeError("You must supply a name when creating a logger.");
        var logger = _loggersByName[name];
        if (!logger) logger = _loggersByName[name] = new Logger(name, defaultLogger.getLevel(), defaultLogger.methodFactory);
        return logger;
    };
    // Grab the current global log variable in case of overwrite
    var _log = typeof window !== undefinedType ? window.log : undefined;
    defaultLogger.noConflict = function() {
        if (typeof window !== undefinedType && window.log === defaultLogger) window.log = _log;
        return defaultLogger;
    };
    defaultLogger.getLoggers = function getLoggers() {
        return _loggersByName;
    };
    // ES6 default export, for compatibility
    defaultLogger["default"] = defaultLogger;
    return defaultLogger;
});


const $bd1c05d3e19afc9d$export$10308fe6a08904fd = {
    START: "start",
    TESTING: "testing",
    FINISHED: "finished"
};
const $bd1c05d3e19afc9d$var$initialDirectorSliceState = {
    testName: null,
    testId: null,
    sessionId: null,
    currentStep: $bd1c05d3e19afc9d$export$10308fe6a08904fd.start,
    section: null,
    title: null,
    description: null,
    text: null,
    currentSectionNo: null,
    noOfSections: null,
    currentGroupNo: null,
    noOfGroups: null,
    answeredGroups: [],
    jsonSchema: null,
    readyForNextSection: false,
    textRaed: false,
    resultHtml: false,
    modalContent: null,
    modalActive: false,
    lockIOAction: false,
    submitting: false
};
const $bd1c05d3e19afc9d$var$doNextStep = (state)=>{
    if (state.sessionId) state.currentStep = $bd1c05d3e19afc9d$export$10308fe6a08904fd.TESTING;
};
const $bd1c05d3e19afc9d$var$directorSlice = (0, $d2702be57030c372$exports.createSlice)({
    name: "directorSlice",
    initialState: $bd1c05d3e19afc9d$var$initialDirectorSliceState,
    reducers: {
        nextStep (state) {
            return $bd1c05d3e19afc9d$var$doNextStep(state);
        },
        setStoreState (state, action) {
            //log.info("setStoreState", action, state);
            const { testId: testId, sessionId: sessionId, section: section } = action.payload;
            state.testId = testId ? testId : state.testId;
            state.sessionId = sessionId ? sessionId : state.sessionId;
            if (section) {
                if (section.current_section_number && state.currentSectionNo !== section.current_section_number) {
                    state.textRaed = true;
                    state.readyForNextSection = false;
                    state.title = null;
                    state.description = null;
                    state.text = null;
                }
                if (section.current_group_number && section.current_group_number === section.number_of_groups) state.readyForNextSection = true;
                state.currentSectionNo = section.current_section_number ? section.current_section_number : state.currentSectionNo;
                state.noOfSections = section.number_of_sections ? section.number_of_sections : state.noOfSections;
                state.currentGroupNo = section.current_group_number ? section.current_group_number : state.currentGroupNo;
                state.noOfGroups = section.number_of_groups ? section.number_of_groups : state.noOfGroups;
                state.answeredGroups = section.answered_groups ? section.answered_groups : state.answeredGroups;
                if (state.answeredGroups.length !== 0 || state.currentSectionNo === 1) state.textRaed = true;
                state.title = section.title ? section.title : state.title;
                state.description = section.description ? section.description : state.description;
                state.text = section.text ? section.text : state.text;
                state.jsonSchema = section.schema ? section.schema : state.jsonSchema;
            }
            $bd1c05d3e19afc9d$var$doNextStep(state);
        },
        textRaed (state) {
            state.textRaed = true;
        },
        // eslint-disable-next-line no-unused-vars
        cancelTest: (state)=>$bd1c05d3e19afc9d$var$initialDirectorSliceState,
        setResults (state, action) {
            const { resultHtml: resultHtml } = action.payload;
            state.currentStep = $bd1c05d3e19afc9d$export$10308fe6a08904fd.FINISHED;
            state.resultHtml = resultHtml;
        },
        setSubmitting (state, action) {
            const { submitting: submitting } = action.payload;
            state.submitting = submitting;
        }
    }
});
const $bd1c05d3e19afc9d$export$86d1cded24611cb8 = (state)=>state.directorReducer;
const { setStoreState: $bd1c05d3e19afc9d$export$e16717ba5a5dc549, nextStep: $bd1c05d3e19afc9d$export$1740d07632cd7131, textRaed: $bd1c05d3e19afc9d$export$e7257833db56af08, cancelTest: $bd1c05d3e19afc9d$export$5fd37d90ba0958ec, setResults: $bd1c05d3e19afc9d$export$2091f1cb24a0a89e, setSubmitting: $bd1c05d3e19afc9d$export$1c03665141dc142f } = $bd1c05d3e19afc9d$var$directorSlice.actions;
var $bd1c05d3e19afc9d$export$2e2bcd8739ae039 = $bd1c05d3e19afc9d$var$directorSlice.reducer;






const $da18f57894276811$var$initialModalSliceState = {
    modalContent: null,
    modalActive: false,
    modalHidden: false,
    modalPayload: null
};
const $da18f57894276811$var$modalSlice = (0, $d2702be57030c372$exports.createSlice)({
    name: "modalSlice",
    initialState: $da18f57894276811$var$initialModalSliceState,
    reducers: {
        activateModal (state, action) {
            const { content: content, model: model } = action.payload;
            //console.log("activateModal", action.payload, content);
            state.modalActive = true;
            state.modalHidden = false;
            state.modalContent = content;
            if (model) state.modalPayload = {
                model: model
            };
        },
        deactivateModal (state) {
            //console.log("deactivateModal");
            state.modalActive = false;
            state.modalPayload = null;
        },
        hideModal (state) {
            //console.log("deactivateModal");
            state.modalHidden = true;
        },
        unhideModal (state) {
            //console.log("deactivateModal");
            state.modalHidden = false;
        }
    }
});
const $da18f57894276811$export$97564ec4f39e372c = (state)=>state.modalReducer;
const { activateModal: $da18f57894276811$export$923d3332dd605124, deactivateModal: $da18f57894276811$export$35f4993c69cad466, hideModal: $da18f57894276811$export$af4939467128bcd0, unhideModal: $da18f57894276811$export$34c750e9d1412945 } = $da18f57894276811$var$modalSlice.actions;
var $da18f57894276811$export$2e2bcd8739ae039 = $da18f57894276811$var$modalSlice.reducer;



const $2476a2e6668a6972$export$6e25e485871219d8 = (a, v)=>{
    const i = a.indexOf(v);
    if (i === -1) a.push(v);
    else a.splice(i, 1);
    return a;
};
const $2476a2e6668a6972$export$2cdf1b96a9f86d16 = (text)=>{
    navigator.clipboard.writeText(text);
};
const $2476a2e6668a6972$export$d41d9ab3de2def3d = (string)=>{
    let hash = 0;
    let i;
    let chr;
    if (string.length === 0) return hash;
    for(i = 0; i < string.length; i++){
        chr = string.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
};
const $2476a2e6668a6972$export$169439c91a279f79 = (id)=>{
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({
        behavior: "smooth",
        block: "start"
    });
};



const $ef73d84de842ec50$var$initialSnackbarSliceState = {
    items: []
};
const $ef73d84de842ec50$export$3cf918ebc7e29d7a = 10500;
const $ef73d84de842ec50$export$87130b6dd9721cee = {
    ERROR: "ERROR",
    INFO: "INFO",
    SUCCESS: "SUCCESS"
};
const $ef73d84de842ec50$var$snackbarSlice = (0, $d2702be57030c372$exports.createSlice)({
    name: "snackbarSlice",
    initialState: $ef73d84de842ec50$var$initialSnackbarSliceState,
    reducers: {
        // removeOldItems(state, action) {
        //     console.log("removeSnackbar", state, action.payload);
        //     const now = new Date();
        //     state.items = state.items.filter(aBar => aBar.timeout < now);
        // },
        removeItem (state, action) {
            //console.log("removeSnackbar", state, action.payload);
            const { id: id } = action.payload;
            state.items = state.items.filter((aBar)=>aBar.id !== id);
        },
        addItem (state, action) {
            //console.log("addSnackbar", action.payload);
            const { text: text, type: type, props: props } = action.payload;
            const hash = (0, $2476a2e6668a6972$export$d41d9ab3de2def3d)(text);
            state.items.push({
                text: text,
                type: type,
                props: props,
                id: hash,
                timeout: new Date(new Date().getTime() + 1000).toISOString()
            });
        }
    }
});
const $ef73d84de842ec50$export$5fba9b735dabe025 = (state)=>state.snackbarReducer;
const { addItem: $ef73d84de842ec50$export$fb9705de59d96855, removeItem: //removeOldItems,
$ef73d84de842ec50$export$fe2d9b4e03920b4c } = $ef73d84de842ec50$var$snackbarSlice.actions;
var $ef73d84de842ec50$export$2e2bcd8739ae039 = $ef73d84de842ec50$var$snackbarSlice.reducer;




const $de29339268adc9ed$var$initialIdleTimerSliceState = {
    idleState: "active",
    // prompted, idle,
    timeLeft: 0
};
const $de29339268adc9ed$var$idleTimerSlice = (0, $d2702be57030c372$exports.createSlice)({
    name: "idleTimerSlice",
    initialState: $de29339268adc9ed$var$initialIdleTimerSliceState,
    reducers: {
        changeState (state, action) {
            //console.log("idleTimerSlice->changeState", action.payload); 
            const { idleState: idleState } = action.payload;
            state.idleState = idleState;
            if ([
                "active",
                "idle"
            ].includes(idleState)) //console.log("idleTimerSlice->changeState #2"); 
            state.timeLeft = 0;
        },
        setTimeleft (state, action) {
            const { timeLeft: timeLeft } = action.payload;
            //console.log("idleTimerSlice->changeState", action.payload, timeLeft);
            state.timeLeft = timeLeft;
        }
    }
});
const $de29339268adc9ed$export$c3aeaf078d419c4b = (state)=>state.idleTimerReducer;
const { changeState: $de29339268adc9ed$export$3374cfc036197cff, setTimeleft: $de29339268adc9ed$export$afe2734416016192 } = $de29339268adc9ed$var$idleTimerSlice.actions;
var $de29339268adc9ed$export$2e2bcd8739ae039 = $de29339268adc9ed$var$idleTimerSlice.reducer;


const $c54912b216653d41$var$rootReducer = (0, $8bb7c10694c071aa$export$66e4520cdb265d18)({
    directorReducer: (0, $bd1c05d3e19afc9d$export$2e2bcd8739ae039),
    modalReducer: (0, $da18f57894276811$export$2e2bcd8739ae039),
    snackbarReducer: (0, $ef73d84de842ec50$export$2e2bcd8739ae039),
    idleTimerReducer: (0, $de29339268adc9ed$export$2e2bcd8739ae039)
});
var $c54912b216653d41$export$2e2bcd8739ae039 = $c54912b216653d41$var$rootReducer;


var $46dd8dcab5d57265$export$1e511d4a378977f5;
var $46dd8dcab5d57265$export$2e2bcd8739ae039;
"use strict";
$46dd8dcab5d57265$export$1e511d4a378977f5 = true;
$46dd8dcab5d57265$export$2e2bcd8739ae039 = void 0;

var $46dd8dcab5d57265$var$_createWebStorage = $46dd8dcab5d57265$var$_interopRequireDefault((parcelRequire("8aMPt")));
function $46dd8dcab5d57265$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $46dd8dcab5d57265$var$_default = (0, $46dd8dcab5d57265$var$_createWebStorage.default)("local");
$46dd8dcab5d57265$export$2e2bcd8739ae039 = $46dd8dcab5d57265$var$_default;


//const sagaMiddleware = createSagaMiddleware();
const $2f1964277cbcb4b2$var$persistConfig = {
    key: "lerche",
    version: 1,
    storage: $46dd8dcab5d57265$export$2e2bcd8739ae039
};
const $2f1964277cbcb4b2$var$persistedReducer = (0, $75083fdd200278f4$export$2e2bcd8739ae039)($2f1964277cbcb4b2$var$persistConfig, (0, $c54912b216653d41$export$2e2bcd8739ae039));
const $2f1964277cbcb4b2$export$6f57813fe9f31bf9 = (0, $d2702be57030c372$exports.configureStore)({
    reducer: $2f1964277cbcb4b2$var$persistedReducer,
    middleware: (getDefaultMiddleware)=>getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    (0, $1557dedf291624dd$export$2aaee4793dd13a52),
                    (0, $1557dedf291624dd$export$1647ef958242c4e2),
                    (0, $1557dedf291624dd$export$dd1033c27a16bbd3),
                    (0, $1557dedf291624dd$export$913fe0e161ed92a2),
                    (0, $1557dedf291624dd$export$5514fc3b4067675f),
                    (0, $1557dedf291624dd$export$51e82cdd7353a0e1)
                ]
            }
        })
});
const $2f1964277cbcb4b2$export$7b682ac9934ca3e4 = (0, $784949253389904f$export$2e2bcd8739ae039)($2f1964277cbcb4b2$export$6f57813fe9f31bf9);
//sagaMiddleware.run(watcherSaga);
$2f1964277cbcb4b2$export$6f57813fe9f31bf9.dispatch((0, $bd1c05d3e19afc9d$export$1740d07632cd7131)({}));



var $cQNHH = parcelRequire("cQNHH");


var $cQNHH = parcelRequire("cQNHH");

const $078fc8f7799889e4$export$1db569cf9469e5b3 = `/test`;
const $078fc8f7799889e4$export$7aa67dc43ca8e63d = `/test/start`;
const $078fc8f7799889e4$export$45f15e91356025b3 = `/test/result`;
const $078fc8f7799889e4$export$43be4fd0f6d56954 = `/test/result/:type/:sessionId`;
const $078fc8f7799889e4$export$500824a38b151028 = `/`;
const $078fc8f7799889e4$export$cd0a6c3b228c8793 = `/404`;
const $078fc8f7799889e4$export$ce029234ae8b8b29 = `/more/impress`;
const $078fc8f7799889e4$export$2a280bdbd8b49d15 = `/more/privacypolicy`;



var $cQNHH = parcelRequire("cQNHH");


var $cQNHH = parcelRequire("cQNHH");
var $299d01727de4fa34$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createContext(null);
var $299d01727de4fa34$export$2e2bcd8739ae039 = $299d01727de4fa34$export$cc80c08dc91f1c00;


// Default to a dummy "batch" implementation that just runs the callback
function $b0701d75873d7faa$var$defaultNoopBatch(callback) {
    callback();
}
var $b0701d75873d7faa$var$batch = $b0701d75873d7faa$var$defaultNoopBatch; // Allow injecting another batching function later
var $b0701d75873d7faa$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $b0701d75873d7faa$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $b0701d75873d7faa$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $b0701d75873d7faa$var$batch;
};


// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $14446e5e7ca25049$var$createListenerCollection() {
    var batch = (0, $b0701d75873d7faa$export$fc47d4c0ba3bd2c6)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $14446e5e7ca25049$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $14446e5e7ca25049$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $14446e5e7ca25049$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $14446e5e7ca25049$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $14446e5e7ca25049$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}



var $cQNHH = parcelRequire("cQNHH");
var $c3562167e57b9ac3$export$700979bc83e7db82 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $cQNHH.useLayoutEffect) : (0, $cQNHH.useEffect);


function $f9587355c23ab01f$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $cQNHH.useMemo)(function() {
        var subscription = (0, $14446e5e7ca25049$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $cQNHH.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $c3562167e57b9ac3$export$700979bc83e7db82)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $299d01727de4fa34$export$cc80c08dc91f1c00);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $f9587355c23ab01f$export$2e2bcd8739ae039 = $f9587355c23ab01f$var$Provider;


function $bc57db8a5dfd3d99$export$2e2bcd8739ae039() {
    $bc57db8a5dfd3d99$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bc57db8a5dfd3d99$export$2e2bcd8739ae039.apply(this, arguments);
}


function $407e1b6a8d307018$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var $791086f2059ab2e4$exports = {};
"use strict";
var $b11f855784133fea$exports = {};
"use strict";

$b11f855784133fea$exports = (parcelRequire("bOn4p"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $791086f2059ab2e4$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $791086f2059ab2e4$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $791086f2059ab2e4$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $791086f2059ab2e4$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $791086f2059ab2e4$var$TYPE_STATICS = {};
$791086f2059ab2e4$var$TYPE_STATICS[$b11f855784133fea$exports.ForwardRef] = $791086f2059ab2e4$var$FORWARD_REF_STATICS;
$791086f2059ab2e4$var$TYPE_STATICS[$b11f855784133fea$exports.Memo] = $791086f2059ab2e4$var$MEMO_STATICS;
function $791086f2059ab2e4$var$getStatics(component) {
    // React v16.11 and below
    if ($b11f855784133fea$exports.isMemo(component)) return $791086f2059ab2e4$var$MEMO_STATICS;
     // React v16.12 and above
    return $791086f2059ab2e4$var$TYPE_STATICS[component["$$typeof"]] || $791086f2059ab2e4$var$REACT_STATICS;
}
var $791086f2059ab2e4$var$defineProperty = Object.defineProperty;
var $791086f2059ab2e4$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $791086f2059ab2e4$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $791086f2059ab2e4$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $791086f2059ab2e4$var$getPrototypeOf = Object.getPrototypeOf;
var $791086f2059ab2e4$var$objectPrototype = Object.prototype;
function $791086f2059ab2e4$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($791086f2059ab2e4$var$objectPrototype) {
            var inheritedComponent = $791086f2059ab2e4$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $791086f2059ab2e4$var$objectPrototype) $791086f2059ab2e4$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $791086f2059ab2e4$var$getOwnPropertyNames(sourceComponent);
        if ($791086f2059ab2e4$var$getOwnPropertySymbols) keys = keys.concat($791086f2059ab2e4$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $791086f2059ab2e4$var$getStatics(targetComponent);
        var sourceStatics = $791086f2059ab2e4$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$791086f2059ab2e4$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $791086f2059ab2e4$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $791086f2059ab2e4$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$791086f2059ab2e4$exports = $791086f2059ab2e4$var$hoistNonReactStatics;



var $cQNHH = parcelRequire("cQNHH");
var $362cb229db7bcf83$exports = {};
"use strict";

$362cb229db7bcf83$exports = (parcelRequire("aCwoi"));





var $65ed3c133e1cca3c$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $65ed3c133e1cca3c$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $65ed3c133e1cca3c$var$EMPTY_ARRAY = [];
var $65ed3c133e1cca3c$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $65ed3c133e1cca3c$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $65ed3c133e1cca3c$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $65ed3c133e1cca3c$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $c3562167e57b9ac3$export$700979bc83e7db82)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $65ed3c133e1cca3c$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $65ed3c133e1cca3c$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: "STORE_UPDATED",
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $65ed3c133e1cca3c$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $65ed3c133e1cca3c$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? "connectAdvanced" : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? "store" : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $299d01727de4fa34$export$cc80c08dc91f1c00) : _ref2$context, connectOptions = (0, $407e1b6a8d307018$export$2e2bcd8739ae039)(_ref2, $65ed3c133e1cca3c$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $cQNHH.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $cQNHH.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $407e1b6a8d307018$export$2e2bcd8739ae039)(props, $65ed3c133e1cca3c$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $cQNHH.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $362cb229db7bcf83$exports.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $cQNHH.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $cQNHH.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $cQNHH.useMemo)(function() {
                if (!shouldHandleStateChanges) return $65ed3c133e1cca3c$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $14446e5e7ca25049$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $cQNHH.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $cQNHH.useReducer)($65ed3c133e1cca3c$var$storeStateUpdatesReducer, $65ed3c133e1cca3c$var$EMPTY_ARRAY, $65ed3c133e1cca3c$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $cQNHH.useRef)();
            var lastWrapperProps = (0, $cQNHH.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $cQNHH.useRef)();
            var renderIsScheduled = (0, $cQNHH.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $65ed3c133e1cca3c$var$useIsomorphicLayoutEffectWithArgs($65ed3c133e1cca3c$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $65ed3c133e1cca3c$var$useIsomorphicLayoutEffectWithArgs($65ed3c133e1cca3c$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $cQNHH.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(WrappedComponent, (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $cQNHH.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(Connect, (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($791086f2059ab2e4$exports)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($791086f2059ab2e4$exports)))(Connect, WrappedComponent);
    };
}






function $dad258df30f7b7f9$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $dad258df30f7b7f9$export$2e2bcd8739ae039(objA, objB) {
    if ($dad258df30f7b7f9$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$dad258df30f7b7f9$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}


function $68c710727592cc72$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $541500ab055309a2$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}


/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $ee2d8ef86f60793c$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $05e923a997933beb$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $541500ab055309a2$export$2e2bcd8739ae039)(value)) (0, $ee2d8ef86f60793c$export$2e2bcd8739ae039)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}


function $d3170bf39762be4d$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $d3170bf39762be4d$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $d3170bf39762be4d$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $d3170bf39762be4d$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $d3170bf39762be4d$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $d1cd86ca17b8accb$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === "function" ? (0, $d3170bf39762be4d$export$8d46c7f53c8c602f)(mapDispatchToProps, "mapDispatchToProps") : undefined;
}
function $d1cd86ca17b8accb$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $d3170bf39762be4d$export$710f7c60f68acd3e)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $d1cd86ca17b8accb$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $d3170bf39762be4d$export$710f7c60f68acd3e)(function(dispatch) {
        return (0, $68c710727592cc72$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $d1cd86ca17b8accb$export$2e2bcd8739ae039 = [
    $d1cd86ca17b8accb$export$a9f27b4b187c1166,
    $d1cd86ca17b8accb$export$ba20d1a7aa0c4a90,
    $d1cd86ca17b8accb$export$94a6e55709d4d961
];



function $f238013f5df44b25$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === "function" ? (0, $d3170bf39762be4d$export$8d46c7f53c8c602f)(mapStateToProps, "mapStateToProps") : undefined;
}
function $f238013f5df44b25$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $d3170bf39762be4d$export$710f7c60f68acd3e)(function() {
        return {};
    }) : undefined;
}
var $f238013f5df44b25$export$2e2bcd8739ae039 = [
    $f238013f5df44b25$export$23fc470827b14aa,
    $f238013f5df44b25$export$514bc8c1a53c1d66
];




function $270c7512ec5a9d81$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)({}, ownProps, stateProps, dispatchProps);
}
function $270c7512ec5a9d81$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $270c7512ec5a9d81$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === "function" ? $270c7512ec5a9d81$export$5b105939c84b5234(mergeProps) : undefined;
}
function $270c7512ec5a9d81$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $270c7512ec5a9d81$export$691c327fc30bc857;
    } : undefined;
}
var $270c7512ec5a9d81$export$2e2bcd8739ae039 = [
    $270c7512ec5a9d81$export$d61b680184bc3f00,
    $270c7512ec5a9d81$export$a13ba70ef50dda6d
];




function $fca0fb3f39663207$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $ee2d8ef86f60793c$export$2e2bcd8739ae039)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $fca0fb3f39663207$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $fca0fb3f39663207$var$verify(mapStateToProps, "mapStateToProps", displayName);
    $fca0fb3f39663207$var$verify(mapDispatchToProps, "mapDispatchToProps", displayName);
    $fca0fb3f39663207$var$verify(mergeProps, "mergeProps", displayName);
}


var $0d421428fe916d65$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $0d421428fe916d65$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $0d421428fe916d65$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $0d421428fe916d65$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $407e1b6a8d307018$export$2e2bcd8739ae039)(_ref2, $0d421428fe916d65$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $0d421428fe916d65$export$d20c0c2ca6eb2b6f : $0d421428fe916d65$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


var $242ffc5071460610$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $242ffc5071460610$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $242ffc5071460610$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $242ffc5071460610$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $65ed3c133e1cca3c$export$2e2bcd8739ae039) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $f238013f5df44b25$export$2e2bcd8739ae039) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $d1cd86ca17b8accb$export$2e2bcd8739ae039) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $270c7512ec5a9d81$export$2e2bcd8739ae039) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $0d421428fe916d65$export$2e2bcd8739ae039) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $242ffc5071460610$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $dad258df30f7b7f9$export$2e2bcd8739ae039) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $dad258df30f7b7f9$export$2e2bcd8739ae039) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $dad258df30f7b7f9$export$2e2bcd8739ae039) : _ref3$areMergedPropsE, extraOptions = (0, $407e1b6a8d307018$export$2e2bcd8739ae039)(_ref3, $242ffc5071460610$var$_excluded);
        var initMapStateToProps = $242ffc5071460610$var$match(mapStateToProps, mapStateToPropsFactories, "mapStateToProps");
        var initMapDispatchToProps = $242ffc5071460610$var$match(mapDispatchToProps, mapDispatchToPropsFactories, "mapDispatchToProps");
        var initMergeProps = $242ffc5071460610$var$match(mergeProps, mergePropsFactories, "mergeProps");
        return connectHOC(selectorFactory, (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)({
            // used in error messages
            methodName: "connect",
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $242ffc5071460610$export$2e2bcd8739ae039 = /*#__PURE__*/ $242ffc5071460610$export$9f9feb656dec1fc4();




var $cQNHH = parcelRequire("cQNHH");


var $cQNHH = parcelRequire("cQNHH");

function $75078e2289739d85$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $cQNHH.useContext)((0, $299d01727de4fa34$export$cc80c08dc91f1c00));
    return contextValue;
}


function $ff938e2e2d7df602$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $299d01727de4fa34$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $299d01727de4fa34$export$cc80c08dc91f1c00) ? (0, $75078e2289739d85$export$c1275ca9a6fd3ec5) : function() {
        return (0, $cQNHH.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $ff938e2e2d7df602$export$6ccbb43953eebf8 = /*#__PURE__*/ $ff938e2e2d7df602$export$671dba69185d0304();


function $07670883d6f89641$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $299d01727de4fa34$export$cc80c08dc91f1c00);
    var useStore = context === (0, $299d01727de4fa34$export$cc80c08dc91f1c00) ? (0, $ff938e2e2d7df602$export$6ccbb43953eebf8) : (0, $ff938e2e2d7df602$export$671dba69185d0304)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $07670883d6f89641$export$8ad76b76a4c905f8 = /*#__PURE__*/ $07670883d6f89641$export$bc9b55530897c558();



var $cQNHH = parcelRequire("cQNHH");




var $bd34a43d05d9e670$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $bd34a43d05d9e670$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $cQNHH.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $cQNHH.useMemo)(function() {
        return (0, $14446e5e7ca25049$export$d567d2b9af322f8f)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $cQNHH.useRef)();
    var latestSelector = (0, $cQNHH.useRef)();
    var latestStoreState = (0, $cQNHH.useRef)();
    var latestSelectedState = (0, $cQNHH.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $c3562167e57b9ac3$export$700979bc83e7db82)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $c3562167e57b9ac3$export$700979bc83e7db82)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $bd34a43d05d9e670$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $299d01727de4fa34$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $299d01727de4fa34$export$cc80c08dc91f1c00) ? (0, $75078e2289739d85$export$c1275ca9a6fd3ec5) : function() {
        return (0, $cQNHH.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $bd34a43d05d9e670$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $bd34a43d05d9e670$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $cQNHH.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $bd34a43d05d9e670$export$2105062e25df4afe = /*#__PURE__*/ $bd34a43d05d9e670$export$2b53f90d2bd1cbfb();






/* eslint-disable import/no-unresolved */ var $a058c85580ba5e0b$exports = {};
"use strict";
function $a058c85580ba5e0b$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($a058c85580ba5e0b$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$a058c85580ba5e0b$var$checkDCE();

$a058c85580ba5e0b$exports = (parcelRequire("jozO0"));





// with standard React renderers (ReactDOM, React Native)
(0, $b0701d75873d7faa$export$4b9874722d0da7bc)((0, $a058c85580ba5e0b$exports.unstable_batchedUpdates));


function $a814487b0bb00175$export$2e2bcd8739ae039(o, p) {
    $a814487b0bb00175$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a814487b0bb00175$export$2e2bcd8739ae039(o, p);
}


function $011e5a01704cf426$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $a814487b0bb00175$export$2e2bcd8739ae039)(subClass, superClass);
}



var $cQNHH = parcelRequire("cQNHH");


function $1aed7eabf9221002$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $1aed7eabf9221002$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $1aed7eabf9221002$var$resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $1aed7eabf9221002$var$isAbsolute(to);
    var isFromAbs = from && $1aed7eabf9221002$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $1aed7eabf9221002$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $1aed7eabf9221002$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $1aed7eabf9221002$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $1aed7eabf9221002$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$1aed7eabf9221002$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $1aed7eabf9221002$export$2e2bcd8739ae039 = $1aed7eabf9221002$var$resolvePathname;


function $d44c500cb709a592$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $d44c500cb709a592$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $d44c500cb709a592$var$valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = $d44c500cb709a592$var$valueOf(a);
        var bValue = $d44c500cb709a592$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $d44c500cb709a592$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $d44c500cb709a592$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $d44c500cb709a592$export$2e2bcd8739ae039 = $d44c500cb709a592$var$valueEqual;



var $830d1f5b441d5854$var$isProduction = true;
var $830d1f5b441d5854$var$prefix = "Invariant failed";
function $830d1f5b441d5854$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($830d1f5b441d5854$var$isProduction) throw new Error($830d1f5b441d5854$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($830d1f5b441d5854$var$prefix, ": ").concat(provided) : $830d1f5b441d5854$var$prefix;
    throw new Error(value);
}


function $8933ce2f446fbaae$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $8933ce2f446fbaae$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $8933ce2f446fbaae$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function $8933ce2f446fbaae$var$stripBasename(path, prefix) {
    return $8933ce2f446fbaae$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $8933ce2f446fbaae$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $8933ce2f446fbaae$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $8933ce2f446fbaae$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $8933ce2f446fbaae$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $8933ce2f446fbaae$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $1aed7eabf9221002$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $8933ce2f446fbaae$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $d44c500cb709a592$export$2e2bcd8739ae039)(a.state, b.state);
}
function $8933ce2f446fbaae$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $8933ce2f446fbaae$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $8933ce2f446fbaae$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $8933ce2f446fbaae$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $8933ce2f446fbaae$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $8933ce2f446fbaae$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $8933ce2f446fbaae$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var $8933ce2f446fbaae$var$PopStateEvent = "popstate";
var $8933ce2f446fbaae$var$HashChangeEvent = "hashchange";
function $8933ce2f446fbaae$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $8933ce2f446fbaae$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$8933ce2f446fbaae$var$canUseDOM && (0, $830d1f5b441d5854$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $8933ce2f446fbaae$var$supportsHistory();
    var needsHashChangeListener = !$8933ce2f446fbaae$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $8933ce2f446fbaae$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $8933ce2f446fbaae$var$stripTrailingSlash($8933ce2f446fbaae$var$addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $8933ce2f446fbaae$var$stripBasename(path, basename);
        return $8933ce2f446fbaae$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $8933ce2f446fbaae$var$createTransitionManager();
    function setState(nextState) {
        (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($8933ce2f446fbaae$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($8933ce2f446fbaae$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($8933ce2f446fbaae$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $8933ce2f446fbaae$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $8933ce2f446fbaae$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $8933ce2f446fbaae$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($8933ce2f446fbaae$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($8933ce2f446fbaae$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($8933ce2f446fbaae$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($8933ce2f446fbaae$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $8933ce2f446fbaae$var$HashChangeEvent$1 = "hashchange";
var $8933ce2f446fbaae$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $8933ce2f446fbaae$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $8933ce2f446fbaae$var$stripLeadingSlash,
        decodePath: $8933ce2f446fbaae$var$addLeadingSlash
    },
    slash: {
        encodePath: $8933ce2f446fbaae$var$addLeadingSlash,
        decodePath: $8933ce2f446fbaae$var$addLeadingSlash
    }
};
function $8933ce2f446fbaae$var$stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $8933ce2f446fbaae$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $8933ce2f446fbaae$var$pushHashPath(path) {
    window.location.hash = path;
}
function $8933ce2f446fbaae$var$replaceHashPath(path) {
    window.location.replace($8933ce2f446fbaae$var$stripHash(window.location.href) + "#" + path);
}
function $8933ce2f446fbaae$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$8933ce2f446fbaae$var$canUseDOM && (0, $830d1f5b441d5854$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $8933ce2f446fbaae$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $8933ce2f446fbaae$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $8933ce2f446fbaae$var$stripTrailingSlash($8933ce2f446fbaae$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $8933ce2f446fbaae$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($8933ce2f446fbaae$var$getHashPath());
        if (basename) path = $8933ce2f446fbaae$var$stripBasename(path, basename);
        return $8933ce2f446fbaae$export$90c043f1c57770b8(path);
    }
    var transitionManager = $8933ce2f446fbaae$var$createTransitionManager();
    function setState(nextState) {
        (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $8933ce2f446fbaae$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $8933ce2f446fbaae$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $8933ce2f446fbaae$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($8933ce2f446fbaae$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($8933ce2f446fbaae$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $8933ce2f446fbaae$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $8933ce2f446fbaae$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $8933ce2f446fbaae$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = $8933ce2f446fbaae$var$stripHash(window.location.href);
        return href + "#" + encodePath(basename + $8933ce2f446fbaae$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $8933ce2f446fbaae$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $8933ce2f446fbaae$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $8933ce2f446fbaae$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $8933ce2f446fbaae$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($8933ce2f446fbaae$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $8933ce2f446fbaae$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $8933ce2f446fbaae$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $8933ce2f446fbaae$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $8933ce2f446fbaae$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($8933ce2f446fbaae$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($8933ce2f446fbaae$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($8933ce2f446fbaae$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $8933ce2f446fbaae$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $8933ce2f446fbaae$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $8933ce2f446fbaae$var$createTransitionManager();
    function setState(nextState) {
        (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $8933ce2f446fbaae$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $8933ce2f446fbaae$export$90c043f1c57770b8(entry, undefined, createKey()) : $8933ce2f446fbaae$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $8933ce2f446fbaae$export$fe53371bee54353d;
    function push(path, state) {
        var action = "PUSH";
        var location = $8933ce2f446fbaae$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $8933ce2f446fbaae$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $8933ce2f446fbaae$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}





var $304fae3974fcdc11$exports = {};
var $d9e09c375189c1c3$exports = {};
$d9e09c375189c1c3$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};


/**
 * Expose `pathToRegexp`.
 */ $304fae3974fcdc11$exports = $304fae3974fcdc11$var$pathToRegexp;
$304fae3974fcdc11$exports.parse = $304fae3974fcdc11$var$parse;
$304fae3974fcdc11$exports.compile = $304fae3974fcdc11$var$compile;
$304fae3974fcdc11$exports.tokensToFunction = $304fae3974fcdc11$var$tokensToFunction;
$304fae3974fcdc11$exports.tokensToRegExp = $304fae3974fcdc11$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $304fae3974fcdc11$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $304fae3974fcdc11$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $304fae3974fcdc11$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $304fae3974fcdc11$var$escapeGroup(pattern) : asterisk ? ".*" : "[^" + $304fae3974fcdc11$var$escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $304fae3974fcdc11$var$compile(str, options) {
    return $304fae3974fcdc11$var$tokensToFunction($304fae3974fcdc11$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $304fae3974fcdc11$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $304fae3974fcdc11$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $304fae3974fcdc11$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", $304fae3974fcdc11$var$flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $304fae3974fcdc11$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($d9e09c375189c1c3$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $304fae3974fcdc11$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $304fae3974fcdc11$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $304fae3974fcdc11$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $304fae3974fcdc11$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $304fae3974fcdc11$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $304fae3974fcdc11$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $304fae3974fcdc11$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $304fae3974fcdc11$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($304fae3974fcdc11$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $304fae3974fcdc11$var$flags(options));
    return $304fae3974fcdc11$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $304fae3974fcdc11$var$stringToRegexp(path, keys, options) {
    return $304fae3974fcdc11$var$tokensToRegExp($304fae3974fcdc11$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $304fae3974fcdc11$var$tokensToRegExp(tokens, keys, options) {
    if (!$d9e09c375189c1c3$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $304fae3974fcdc11$var$escapeString(token);
        else {
            var prefix = $304fae3974fcdc11$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $304fae3974fcdc11$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $304fae3974fcdc11$var$attachKeys(new RegExp("^" + route, $304fae3974fcdc11$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $304fae3974fcdc11$var$pathToRegexp(path, keys, options) {
    if (!$d9e09c375189c1c3$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $304fae3974fcdc11$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($d9e09c375189c1c3$exports(path)) return $304fae3974fcdc11$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $304fae3974fcdc11$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $300ca6d8fdf76bf8$exports = {};
"use strict";

$300ca6d8fdf76bf8$exports = (parcelRequire("9FMI2"));




var $a252e3f3b9c91bac$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $a252e3f3b9c91bac$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $a252e3f3b9c91bac$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $a252e3f3b9c91bac$var$commonjsGlobal[key] = ($a252e3f3b9c91bac$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $a252e3f3b9c91bac$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $a252e3f3b9c91bac$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $a252e3f3b9c91bac$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $a252e3f3b9c91bac$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $a252e3f3b9c91bac$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $011e5a01704cf426$export$2e2bcd8739ae039)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $a252e3f3b9c91bac$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($a252e3f3b9c91bac$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $a252e3f3b9c91bac$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $011e5a01704cf426$export$2e2bcd8739ae039)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $a252e3f3b9c91bac$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $a252e3f3b9c91bac$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $a252e3f3b9c91bac$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $a252e3f3b9c91bac$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createContext || $a252e3f3b9c91bac$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $a252e3f3b9c91bac$var$createNamedContext = function createNamedContext(name) {
    var context = $a252e3f3b9c91bac$var$createContext();
    context.displayName = name;
    return context;
};
var $a252e3f3b9c91bac$export$c213558b66925821 = /*#__PURE__*/ $a252e3f3b9c91bac$var$createNamedContext("Router-History");
var $a252e3f3b9c91bac$export$63baa8ccbe60bb07 = /*#__PURE__*/ $a252e3f3b9c91bac$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $a252e3f3b9c91bac$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $011e5a01704cf426$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($a252e3f3b9c91bac$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($a252e3f3b9c91bac$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $a252e3f3b9c91bac$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $011e5a01704cf426$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $8933ce2f446fbaae$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($a252e3f3b9c91bac$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Component);
var $a252e3f3b9c91bac$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $011e5a01704cf426$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $a252e3f3b9c91bac$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($a252e3f3b9c91bac$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $830d1f5b441d5854$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($a252e3f3b9c91bac$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $a252e3f3b9c91bac$var$messageType;
var $a252e3f3b9c91bac$var$cache = {};
var $a252e3f3b9c91bac$var$cacheLimit = 10000;
var $a252e3f3b9c91bac$var$cacheCount = 0;
function $a252e3f3b9c91bac$var$compilePath(path) {
    if ($a252e3f3b9c91bac$var$cache[path]) return $a252e3f3b9c91bac$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($304fae3974fcdc11$exports))).compile(path);
    if ($a252e3f3b9c91bac$var$cacheCount < $a252e3f3b9c91bac$var$cacheLimit) {
        $a252e3f3b9c91bac$var$cache[path] = generator;
        $a252e3f3b9c91bac$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $a252e3f3b9c91bac$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $a252e3f3b9c91bac$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $a252e3f3b9c91bac$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($a252e3f3b9c91bac$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $830d1f5b441d5854$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $8933ce2f446fbaae$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $a252e3f3b9c91bac$export$82476f982757e71e(to, computedMatch.params) : (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)({}, to, {
            pathname: $a252e3f3b9c91bac$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($a252e3f3b9c91bac$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $8933ce2f446fbaae$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $8933ce2f446fbaae$export$c3e8bb440bd55b18)(prevLocation, (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $a252e3f3b9c91bac$var$cache$1 = {};
var $a252e3f3b9c91bac$var$cacheLimit$1 = 10000;
var $a252e3f3b9c91bac$var$cacheCount$1 = 0;
function $a252e3f3b9c91bac$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $a252e3f3b9c91bac$var$cache$1[cacheKey] || ($a252e3f3b9c91bac$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($304fae3974fcdc11$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($a252e3f3b9c91bac$var$cacheCount$1 < $a252e3f3b9c91bac$var$cacheLimit$1) {
        pathCache[path] = result;
        $a252e3f3b9c91bac$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $a252e3f3b9c91bac$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $a252e3f3b9c91bac$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $a252e3f3b9c91bac$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Children.count(children) === 0;
}
function $a252e3f3b9c91bac$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $a252e3f3b9c91bac$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $011e5a01704cf426$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($a252e3f3b9c91bac$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $830d1f5b441d5854$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $a252e3f3b9c91bac$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $a252e3f3b9c91bac$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($a252e3f3b9c91bac$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Component);
function $a252e3f3b9c91bac$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $a252e3f3b9c91bac$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)({}, location, {
        pathname: $a252e3f3b9c91bac$var$addLeadingSlash(basename) + location.pathname
    });
}
function $a252e3f3b9c91bac$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $a252e3f3b9c91bac$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $a252e3f3b9c91bac$var$createURL(location) {
    return typeof location === "string" ? location : (0, $8933ce2f446fbaae$export$fe53371bee54353d)(location);
}
function $a252e3f3b9c91bac$var$staticHandler(methodName) {
    return function() {
        (0, $830d1f5b441d5854$export$2e2bcd8739ae039)(false);
    };
}
function $a252e3f3b9c91bac$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $a252e3f3b9c91bac$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $011e5a01704cf426$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $a252e3f3b9c91bac$var$noop;
        };
        _this.handleBlock = function() {
            return $a252e3f3b9c91bac$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $a252e3f3b9c91bac$var$addBasename(basename, (0, $8933ce2f446fbaae$export$90c043f1c57770b8)(location));
        context.url = $a252e3f3b9c91bac$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $407e1b6a8d307018$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $a252e3f3b9c91bac$var$addLeadingSlash(basename + $a252e3f3b9c91bac$var$createURL(path));
            },
            action: "POP",
            location: $a252e3f3b9c91bac$var$stripBasename(basename, (0, $8933ce2f446fbaae$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $a252e3f3b9c91bac$var$staticHandler("go"),
            goBack: $a252e3f3b9c91bac$var$staticHandler("goBack"),
            goForward: $a252e3f3b9c91bac$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($a252e3f3b9c91bac$export$55185c17a0fcbe46, (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $a252e3f3b9c91bac$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $011e5a01704cf426$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($a252e3f3b9c91bac$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $830d1f5b441d5854$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $a252e3f3b9c91bac$export$81336c211d5ff295(location.pathname, (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $a252e3f3b9c91bac$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $407e1b6a8d307018$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($a252e3f3b9c91bac$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $830d1f5b441d5854$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(Component, (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($791086f2059ab2e4$exports)))(C, Component);
}
var $a252e3f3b9c91bac$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useContext;
function $a252e3f3b9c91bac$export$3420e1dc2c4a518c() {
    return $a252e3f3b9c91bac$var$useContext($a252e3f3b9c91bac$export$c213558b66925821);
}
function $a252e3f3b9c91bac$export$45d76561a5302f2b() {
    return $a252e3f3b9c91bac$var$useContext($a252e3f3b9c91bac$export$63baa8ccbe60bb07).location;
}
function $a252e3f3b9c91bac$export$99eaa27ddbbb95ef() {
    var match = $a252e3f3b9c91bac$var$useContext($a252e3f3b9c91bac$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $a252e3f3b9c91bac$export$632be4bb944c1bc7(path) {
    var location = $a252e3f3b9c91bac$export$45d76561a5302f2b();
    var match = $a252e3f3b9c91bac$var$useContext($a252e3f3b9c91bac$export$63baa8ccbe60bb07).match;
    return path ? $a252e3f3b9c91bac$export$81336c211d5ff295(location.pathname, path) : match;
}
var $a252e3f3b9c91bac$var$global$1, $a252e3f3b9c91bac$var$key, $a252e3f3b9c91bac$var$buildNames, $a252e3f3b9c91bac$var$initialBuildName, $a252e3f3b9c91bac$var$secondaryBuildName;


var $c3f8cd880ca9b8ec$exports = {};
var $7f52aa0f59ee2ce7$exports = {};
function $7f52aa0f59ee2ce7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
$7f52aa0f59ee2ce7$exports = $7f52aa0f59ee2ce7$var$_arrayWithHoles, $7f52aa0f59ee2ce7$exports.__esModule = true, $7f52aa0f59ee2ce7$exports["default"] = $7f52aa0f59ee2ce7$exports;


var $d7680af539ad985b$exports = {};
function $d7680af539ad985b$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
$d7680af539ad985b$exports = $d7680af539ad985b$var$_iterableToArrayLimit, $d7680af539ad985b$exports.__esModule = true, $d7680af539ad985b$exports["default"] = $d7680af539ad985b$exports;


var $e42997105783b277$exports = {};
var $880ab10d2f8b10e0$exports = {};
function $880ab10d2f8b10e0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$880ab10d2f8b10e0$exports = $880ab10d2f8b10e0$var$_arrayLikeToArray, $880ab10d2f8b10e0$exports.__esModule = true, $880ab10d2f8b10e0$exports["default"] = $880ab10d2f8b10e0$exports;


function $e42997105783b277$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $880ab10d2f8b10e0$exports(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $880ab10d2f8b10e0$exports(o, minLen);
}
$e42997105783b277$exports = $e42997105783b277$var$_unsupportedIterableToArray, $e42997105783b277$exports.__esModule = true, $e42997105783b277$exports["default"] = $e42997105783b277$exports;


var $dfae104c0198040e$exports = {};
function $dfae104c0198040e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$dfae104c0198040e$exports = $dfae104c0198040e$var$_nonIterableRest, $dfae104c0198040e$exports.__esModule = true, $dfae104c0198040e$exports["default"] = $dfae104c0198040e$exports;


function $c3f8cd880ca9b8ec$var$_slicedToArray(arr, i) {
    return $7f52aa0f59ee2ce7$exports(arr) || $d7680af539ad985b$exports(arr, i) || $e42997105783b277$exports(arr, i) || $dfae104c0198040e$exports();
}
$c3f8cd880ca9b8ec$exports = $c3f8cd880ca9b8ec$var$_slicedToArray, $c3f8cd880ca9b8ec$exports.__esModule = true, $c3f8cd880ca9b8ec$exports["default"] = $c3f8cd880ca9b8ec$exports;




var $cQNHH = parcelRequire("cQNHH");

function $4dbe97e62bc6d9c7$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $4dbe97e62bc6d9c7$var$alreadyWarned = {};
function $4dbe97e62bc6d9c7$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $4dbe97e62bc6d9c7$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $4dbe97e62bc6d9c7$var$alreadyWarned[args[0]] = new Date();
    $4dbe97e62bc6d9c7$export$c106dd0671a0fc2d.apply(void 0, args);
}
function $4dbe97e62bc6d9c7$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    });
}
function $4dbe97e62bc6d9c7$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $4dbe97e62bc6d9c7$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $4dbe97e62bc6d9c7$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $4dbe97e62bc6d9c7$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        precheck: function precheck(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $4dbe97e62bc6d9c7$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}


function $aa8f0a59a97a3595$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aa8f0a59a97a3595$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $aa8f0a59a97a3595$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($68c1297b1f20e9e6$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $aa8f0a59a97a3595$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $aa8f0a59a97a3595$var$usePrevious = function usePrevious(value, ignore) {
    var ref = (0, $cQNHH.useRef)();
    (0, $cQNHH.useEffect)(function() {
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $aa8f0a59a97a3595$export$9fc83ad70ead8663(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $cQNHH.useContext)((0, $d304d355ba45eefd$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $d304d355ba45eefd$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $d304d355ba45eefd$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $4dbe97e62bc6d9c7$export$5b28268982f175ba)("You will need to pass in an i18next instance by using initReactI18next");
        var notReadyT = function notReadyT(k) {
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $4dbe97e62bc6d9c7$export$5b28268982f175ba)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    var i18nOptions = $aa8f0a59a97a3595$var$_objectSpread($aa8f0a59a97a3595$var$_objectSpread($aa8f0a59a97a3595$var$_objectSpread({}, (0, $d304d355ba45eefd$export$212bb2fc580a90a8)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $4dbe97e62bc6d9c7$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions);
    });
    function getT() {
        return i18n.getFixedT(null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    }
    var _useState = (0, $cQNHH.useState)(getT), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($c3f8cd880ca9b8ec$exports)))(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var joinedNS = namespaces.join();
    var previousJoinedNS = $aa8f0a59a97a3595$var$usePrevious(joinedNS);
    var isMounted = (0, $cQNHH.useRef)(true);
    (0, $cQNHH.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) (0, $4dbe97e62bc6d9c7$export$83be934b53fff43b)(i18n, namespaces, function() {
            if (isMounted.current) setT(getT);
        });
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        joinedNS
    ]);
    var isInitial = (0, $cQNHH.useRef)(true);
    (0, $cQNHH.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        (0, $4dbe97e62bc6d9c7$export$83be934b53fff43b)(i18n, namespaces, function() {
            resolve();
        });
    });
}


const $2cbbba7e4bf44690$var$ErrorComponent = (error)=>{
    const { t: t } = (0, $aa8f0a59a97a3595$export$9fc83ad70ead8663)();
    const history = (0, $a252e3f3b9c91bac$export$3420e1dc2c4a518c)();
    const dispatch = (0, $07670883d6f89641$export$8ad76b76a4c905f8)();
    const doCancelTest = ()=>{
        dispatch((0, $bd1c05d3e19afc9d$export$5fd37d90ba0958ec)({}));
        dispatch((0, $ef73d84de842ec50$export$fb9705de59d96855)({
            text: t("error.systemReseted.message"),
            type: (0, $ef73d84de842ec50$export$87130b6dd9721cee).INFO,
            props: {}
        }));
        history.push((0, $078fc8f7799889e4$export$7aa67dc43ca8e63d));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: t("error.errorHTML")
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("code", null, JSON.stringify(error)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("button", {
        onClick: doCancelTest,
        className: "button is-primary button--direction-right is-rounded"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "button__text"
    }, t("error.restartButton.caption")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "icon licon-arrow-circle-right"
    })));
};
const $2cbbba7e4bf44690$export$edf27be85e5f6da0 = $2cbbba7e4bf44690$var$ErrorComponent;




const $ace55934afe561b0$export$856890d3f620f53d = (log)=>({
        msg: log.message,
        level: log.level.label,
        stacktrace: log.stacktrace
    });
//remote.apply(log, { format: customJSON, url: '/logger' });
(0, (/*@__PURE__*/$parcel$interopDefault($496d466e13414dc7$exports))).enableAll();
class $ace55934afe561b0$export$e926676385687eaf extends (0, $cQNHH.Component) {
    // eslint-disable-next-line no-unused-vars
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            error: error
        };
    }
    componentDidCatch(error, info) {
        // log the error to our server with loglevel
        (0, (/*@__PURE__*/$parcel$interopDefault($496d466e13414dc7$exports))).error({
            error: error,
            info: info
        });
    }
    render() {
        if (this.state.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $2cbbba7e4bf44690$export$edf27be85e5f6da0), {
            error: this.state.error
        });
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
$ace55934afe561b0$export$e926676385687eaf.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).array
};
var $ace55934afe561b0$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($496d466e13414dc7$exports)));





var $cQNHH = parcelRequire("cQNHH");
var $13b3195589c46dae$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, $13b3195589c46dae$exports) {
        classNames.default = classNames;
        $13b3195589c46dae$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


var $14ddfb76b735dd93$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $14ddfb76b735dd93$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $14ddfb76b735dd93$exports));
try {
    regeneratorRuntime = $14ddfb76b735dd93$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $14ddfb76b735dd93$var$runtime;
    else Function("r", "regeneratorRuntime = r")($14ddfb76b735dd93$var$runtime);
}




function $60f495c72b2d87aa$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? Object(arguments[i]) : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $79f4448e0e3dff2f$export$2e2bcd8739ae039)(target, key, source[key]);
        });
    }
    return target;
}


function $b27c7f873a9dd3ed$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



function $74e0e51f770d13a2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $ba41a0e043d13a82$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $74e0e51f770d13a2$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $74e0e51f770d13a2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $74e0e51f770d13a2$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}



function $65c0a486cf6d72c2$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $4dd532cef5488db8$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $0308e3532c157317$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $65c0a486cf6d72c2$export$2e2bcd8739ae039)(self);
}


function $6f553a90612e3581$export$2e2bcd8739ae039(o) {
    $6f553a90612e3581$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6f553a90612e3581$export$2e2bcd8739ae039(o);
}




function $d629e1903a2edaca$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $a814487b0bb00175$export$2e2bcd8739ae039)(subClass, superClass);
}


var $28cc57c8969a2496$var$consoleLogger = {
    type: "logger",
    log: function log(args) {
        this.output("log", args);
    },
    warn: function warn(args) {
        this.output("warn", args);
    },
    error: function error(args) {
        this.output("error", args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var $28cc57c8969a2496$var$Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $b27c7f873a9dd3ed$export$2e2bcd8739ae039)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $74e0e51f770d13a2$export$2e2bcd8739ae039)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || "i18next:";
                this.logger = concreteLogger || $28cc57c8969a2496$var$consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, "log", "", true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, "warn", "", true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, "error", "");
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === "string") args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, (0, $60f495c72b2d87aa$export$2e2bcd8739ae039)({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }, this.options));
            }
        }
    ]);
    return Logger;
}();
var $28cc57c8969a2496$var$baseLogger = new $28cc57c8969a2496$var$Logger();
var $28cc57c8969a2496$var$EventEmitter = function() {
    function EventEmitter() {
        (0, $b27c7f873a9dd3ed$export$2e2bcd8739ae039)(this, EventEmitter);
        this.observers = {};
    }
    (0, $74e0e51f770d13a2$export$2e2bcd8739ae039)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(" ").forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers["*"]) {
                    var _cloned = [].concat(this.observers["*"]);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function $28cc57c8969a2496$var$defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $28cc57c8969a2496$var$makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function $28cc57c8969a2496$var$copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function $28cc57c8969a2496$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    var stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $28cc57c8969a2496$var$setPath(object, path, newValue) {
    var _getLastOfPath = $28cc57c8969a2496$var$getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function $28cc57c8969a2496$var$pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = $28cc57c8969a2496$var$getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $28cc57c8969a2496$var$getPath(object, path) {
    var _getLastOfPath3 = $28cc57c8969a2496$var$getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function $28cc57c8969a2496$var$getPathWithDefaults(data, defaultData, key) {
    var value = $28cc57c8969a2496$var$getPath(data, key);
    if (value !== undefined) return value;
    return $28cc57c8969a2496$var$getPath(defaultData, key);
}
function $28cc57c8969a2496$var$deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $28cc57c8969a2496$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $28cc57c8969a2496$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var $28cc57c8969a2496$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function $28cc57c8969a2496$var$escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, function(s) {
        return $28cc57c8969a2496$var$_entityMap[s];
    });
    return data;
}
var $28cc57c8969a2496$var$isIE10 = typeof window !== "undefined" && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1;
function $28cc57c8969a2496$var$deepFind(obj, path) {
    var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    var paths = path.split(keySeparator);
    var current = obj;
    for(var i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === "string" && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            var j = 2;
            var p = paths.slice(i, i + j).join(keySeparator);
            var mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (typeof mix === "string") return mix;
            if (p && typeof mix[p] === "string") return mix[p];
            var joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return $28cc57c8969a2496$var$deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
var $28cc57c8969a2496$var$ResourceStore = function(_EventEmitter) {
    (0, $d629e1903a2edaca$export$2e2bcd8739ae039)(ResourceStore, _EventEmitter);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        (0, $b27c7f873a9dd3ed$export$2e2bcd8739ae039)(this, ResourceStore);
        _this = (0, $4dd532cef5488db8$export$2e2bcd8739ae039)(this, (0, $6f553a90612e3581$export$2e2bcd8739ae039)(ResourceStore).call(this));
        if ($28cc57c8969a2496$var$isIE10) $28cc57c8969a2496$var$EventEmitter.call((0, $65c0a486cf6d72c2$export$2e2bcd8739ae039)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        if (_this.options.ignoreJSONStructure === undefined) _this.options.ignoreJSONStructure = true;
        return _this;
    }
    (0, $74e0e51f770d13a2$export$2e2bcd8739ae039)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== "string") path = path.concat(key);
                if (key && typeof key === "string") path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) path = lng.split(".");
                var result = $28cc57c8969a2496$var$getPath(this.data, path);
                if (result || !ignoreJSONStructure || typeof key !== "string") return result;
                return $28cc57c8969a2496$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = this.options.keySeparator;
                if (keySeparator === undefined) keySeparator = ".";
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                $28cc57c8969a2496$var$setPath(this.data, path, value);
                if (!options.silent) this.emit("added", lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = $28cc57c8969a2496$var$getPath(this.data, path) || {};
                if (deep) $28cc57c8969a2496$var$deepExtend(pack, resources, overwrite);
                else pack = (0, $60f495c72b2d87aa$export$2e2bcd8739ae039)({}, pack, resources);
                $28cc57c8969a2496$var$setPath(this.data, path, pack);
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit("removed", lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === "v1") return (0, $60f495c72b2d87aa$export$2e2bcd8739ae039)({}, {}, this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}($28cc57c8969a2496$var$EventEmitter);
var $28cc57c8969a2496$var$postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
var $28cc57c8969a2496$var$checkedLoadedFor = {};
var $28cc57c8969a2496$var$Translator = function(_EventEmitter) {
    (0, $d629e1903a2edaca$export$2e2bcd8739ae039)(Translator, _EventEmitter);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $b27c7f873a9dd3ed$export$2e2bcd8739ae039)(this, Translator);
        _this = (0, $4dd532cef5488db8$export$2e2bcd8739ae039)(this, (0, $6f553a90612e3581$export$2e2bcd8739ae039)(Translator).call(this));
        if ($28cc57c8969a2496$var$isIE10) $28cc57c8969a2496$var$EventEmitter.call((0, $65c0a486cf6d72c2$export$2e2bcd8739ae039)(_this));
        $28cc57c8969a2496$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, (0, $65c0a486cf6d72c2$export$2e2bcd8739ae039)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        _this.logger = $28cc57c8969a2496$var$baseLogger.create("translator");
        return _this;
    }
    (0, $74e0e51f770d13a2$export$2e2bcd8739ae039)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                if (key === undefined || key === null) return false;
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ":";
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS;
                if (nsSeparator && key.indexOf(nsSeparator) > -1) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $0308e3532c157317$export$2e2bcd8739ae039)(options) !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if (!options) options = {};
                if (keys === undefined || keys === null) return "";
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === "cimode") {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        return namespace + nsSeparator + key;
                    }
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    "[object Number]",
                    "[object Function]",
                    "[object RegExp]"
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, (0, $60f495c72b2d87aa$export$2e2bcd8739ae039)({}, options, {
                            ns: namespaces
                        })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === "[object Array]";
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, (0, $60f495c72b2d87aa$export$2e2bcd8739ae039)({}, options, {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count) : "";
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
                    var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, (0, $60f495c72b2d87aa$export$2e2bcd8739ae039)({}, options, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, fallbackValue) {
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? fallbackValue : resForMissing, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? fallbackValue : resForMissing, updateMissing, options);
                            _this2.emit("missingKey", l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init((0, $60f495c72b2d87aa$export$2e2bcd8739ae039)({}, options, {
                        interpolation: (0, $60f495c72b2d87aa$export$2e2bcd8739ae039)({}, this.options.interpolation, options.interpolation)
                    }));
                    var skipOnVariables = options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== "string" ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = (0, $60f495c72b2d87aa$export$2e2bcd8739ae039)({}, this.options.interpolation.defaultVariables, data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === "string" ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $28cc57c8969a2496$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? (0, $60f495c72b2d87aa$export$2e2bcd8739ae039)({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === "string") keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!$28cc57c8969a2496$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            $28cc57c8969a2496$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn('key "'.concat(usedKey, '" for languages "').concat(codes.join(", "), '" won\'t get resolved as namespace "').concat(usedNS, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKey = key;
                            var finalKeys = [
                                finalKey
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);
                                if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);
                                if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context));
                                if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = "defaultValue";
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}($28cc57c8969a2496$var$EventEmitter);
function $28cc57c8969a2496$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $28cc57c8969a2496$var$LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $b27c7f873a9dd3ed$export$2e2bcd8739ae039)(this, LanguageUtil);
        this.options = options;
        this.whitelist = this.options.supportedLngs || false;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $28cc57c8969a2496$var$baseLogger.create("languageUtils");
    }
    (0, $74e0e51f770d13a2$export$2e2bcd8739ae039)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return null;
                var p = code.split("-");
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === "x") return null;
                return this.formatLanguageCode(p.join("-"));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return code;
                var p = code.split("-");
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    var specialCases = [
                        "hans",
                        "hant",
                        "latn",
                        "cyrl",
                        "cans",
                        "mong",
                        "arab"
                    ];
                    var p = code.split("-");
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $28cc57c8969a2496$var$capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $28cc57c8969a2496$var$capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $28cc57c8969a2496$var$capitalize(p[2].toLowerCase());
                    }
                    return p.join("-");
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isWhitelisted",
            value: function isWhitelisted(code) {
                this.logger.deprecate("languageUtils.isWhitelisted", 'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.');
                return this.isSupportedCode(code);
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === "function") fallbacks = fallbacks(code);
                if (typeof fallbacks === "string") fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
                    if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var $28cc57c8969a2496$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var $28cc57c8969a2496$var$_rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
function $28cc57c8969a2496$var$createRules() {
    var rules = {};
    $28cc57c8969a2496$var$sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: $28cc57c8969a2496$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var $28cc57c8969a2496$var$PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $b27c7f873a9dd3ed$export$2e2bcd8739ae039)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $28cc57c8969a2496$var$baseLogger.create("pluralResolver");
        this.rules = $28cc57c8969a2496$var$createRules();
    }
    (0, $74e0e51f770d13a2$export$2e2bcd8739ae039)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var rule = this.getRule(code);
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                return this.getSuffixes(code).map(function(suffix) {
                    return key + suffix;
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var rule = this.getRule(code);
                if (!rule) return [];
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var _this2 = this;
                var rule = this.getRule(code);
                if (rule) {
                    var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                    var suffix = rule.numbers[idx];
                    if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                        if (suffix === 2) suffix = "plural";
                        else if (suffix === 1) suffix = "";
                    }
                    var returnSuffix = function returnSuffix() {
                        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                    };
                    if (this.options.compatibilityJSON === "v1") {
                        if (suffix === 1) return "";
                        if (typeof suffix === "number") return "_plural_".concat(suffix.toString());
                        return returnSuffix();
                    } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
                    else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                    return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return "";
            }
        }
    ]);
    return PluralResolver;
}();
var $28cc57c8969a2496$var$Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $b27c7f873a9dd3ed$export$2e2bcd8739ae039)(this, Interpolator);
        this.logger = $28cc57c8969a2496$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $74e0e51f770d13a2$export$2e2bcd8739ae039)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : $28cc57c8969a2496$var$escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? $28cc57c8969a2496$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
                this.suffix = iOpts.suffix ? $28cc57c8969a2496$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
                this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
                this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
                this.nestingPrefix = iOpts.nestingPrefix ? $28cc57c8969a2496$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $28cc57c8969a2496$var$regexEscape("$t(");
                this.nestingSuffix = iOpts.nestingSuffix ? $28cc57c8969a2496$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $28cc57c8969a2496$var$regexEscape(")");
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, "g");
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, "$$$$");
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = $28cc57c8969a2496$var$getPathWithDefaults(data, defaultData, key);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng, (0, $60f495c72b2d87aa$export$2e2bcd8739ae039)({}, options, data, {
                            interpolationkey: key
                        })) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format($28cc57c8969a2496$var$getPathWithDefaults(data, defaultData, k), f, lng, (0, $60f495c72b2d87aa$export$2e2bcd8739ae039)({}, options, data, {
                        interpolationkey: k
                    }));
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        value = handleFormat(match[1].trim());
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === "function") {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === "string" ? temp : "";
                            } else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));
                                value = "";
                            }
                        } else if (typeof value !== "string" && !_this.useRawValueToEscape) value = $28cc57c8969a2496$var$makeString(value);
                        var safeValue = todo.safeValue(value);
                        str = str.replace(match[0], safeValue);
                        if (skipOnVariables) {
                            todo.regex.lastIndex += safeValue.length;
                            todo.regex.lastIndex -= match[0].length;
                        } else todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions = (0, $60f495c72b2d87aa$export$2e2bcd8739ae039)({}, options);
                clonedOptions.applyPostProcessor = false;
                delete clonedOptions.defaultValue;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = (0, $60f495c72b2d87aa$export$2e2bcd8739ae039)({}, inheritedOptions, clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    var doReduce = false;
                    if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== "string") return value;
                    if (typeof value !== "string") value = $28cc57c8969a2496$var$makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = "";
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, (0, $60f495c72b2d87aa$export$2e2bcd8739ae039)({}, options, {
                            interpolationkey: match[1].trim()
                        }));
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function $28cc57c8969a2496$var$remove(arr, what) {
    var found = arr.indexOf(what);
    while(found !== -1){
        arr.splice(found, 1);
        found = arr.indexOf(what);
    }
}
var $28cc57c8969a2496$var$Connector = function(_EventEmitter) {
    (0, $d629e1903a2edaca$export$2e2bcd8739ae039)(Connector, _EventEmitter);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $b27c7f873a9dd3ed$export$2e2bcd8739ae039)(this, Connector);
        _this = (0, $4dd532cef5488db8$export$2e2bcd8739ae039)(this, (0, $6f553a90612e3581$export$2e2bcd8739ae039)(Connector).call(this));
        if ($28cc57c8969a2496$var$isIE10) $28cc57c8969a2496$var$EventEmitter.call((0, $65c0a486cf6d72c2$export$2e2bcd8739ae039)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = $28cc57c8969a2496$var$baseLogger.create("backendConnector");
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $74e0e51f770d13a2$export$2e2bcd8739ae039)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = [];
                var pending = [];
                var toLoadLanguages = [];
                var toLoadNamespaces = [];
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending.indexOf(name) < 0) pending.push(name);
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending.indexOf(name) < 0) pending.push(name);
                            if (toLoad.indexOf(name) < 0) toLoad.push(name);
                            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages.push(lng);
                });
                if (toLoad.length || pending.length) this.queue.push({
                    pending: pending,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: toLoad,
                    pending: pending,
                    toLoadLanguages: toLoadLanguages,
                    toLoadNamespaces: toLoadNamespaces
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit("failedLoading", lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    $28cc57c8969a2496$var$pushPath(q.loaded, [
                        lng
                    ], ns);
                    $28cc57c8969a2496$var$remove(q.pending, name);
                    if (err) q.errors.push(err);
                    if (q.pending.length === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = [];
                            if (q.loaded[l].length) q.loaded[l].forEach(function(ns) {
                                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit("loaded", loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                return this.backend[fcName](lng, ns, function(err, data) {
                    if (err && data && tried < 5) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                });
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn("No backend was added via i18next.use. Will not load resources.");
                    return callback && callback();
                }
                if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, "read", undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn('did not save key "'.concat(key, '" as the namespace "').concat(namespace, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                    return;
                }
                if (key === undefined || key === null || key === "") return;
                if (this.backend && this.backend.create) this.backend.create(languages, namespace, key, fallbackValue, null, (0, $60f495c72b2d87aa$export$2e2bcd8739ae039)({}, options, {
                    isUpdate: isUpdate
                }));
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}($28cc57c8969a2496$var$EventEmitter);
function $28cc57c8969a2496$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        whitelist: false,
        nonExplicitWhitelist: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $0308e3532c157317$export$2e2bcd8739ae039)(args[1]) === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if ((0, $0308e3532c157317$export$2e2bcd8739ae039)(args[2]) === "object" || (0, $0308e3532c157317$export$2e2bcd8739ae039)(args[3]) === "object") {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: false
        }
    };
}
function $28cc57c8969a2496$var$transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.whitelist) {
        if (options.whitelist && options.whitelist.indexOf("cimode") < 0) options.whitelist = options.whitelist.concat([
            "cimode"
        ]);
        options.supportedLngs = options.whitelist;
    }
    if (options.nonExplicitWhitelist) options.nonExplicitSupportedLngs = options.nonExplicitWhitelist;
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function $28cc57c8969a2496$var$noop() {}
var $28cc57c8969a2496$var$I18n = function(_EventEmitter) {
    (0, $d629e1903a2edaca$export$2e2bcd8739ae039)(I18n, _EventEmitter);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $b27c7f873a9dd3ed$export$2e2bcd8739ae039)(this, I18n);
        _this = (0, $4dd532cef5488db8$export$2e2bcd8739ae039)(this, (0, $6f553a90612e3581$export$2e2bcd8739ae039)(I18n).call(this));
        if ($28cc57c8969a2496$var$isIE10) $28cc57c8969a2496$var$EventEmitter.call((0, $65c0a486cf6d72c2$export$2e2bcd8739ae039)(_this));
        _this.options = $28cc57c8969a2496$var$transformOptions(options);
        _this.services = {};
        _this.logger = $28cc57c8969a2496$var$baseLogger;
        _this.modules = {
            external: []
        };
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $4dd532cef5488db8$export$2e2bcd8739ae039)(_this, (0, $65c0a486cf6d72c2$export$2e2bcd8739ae039)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $74e0e51f770d13a2$export$2e2bcd8739ae039)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === "function") {
                    callback = options;
                    options = {};
                }
                if (options.whitelist && !options.supportedLngs) this.logger.deprecate("whitelist", 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.');
                if (options.nonExplicitWhitelist && !options.nonExplicitSupportedLngs) this.logger.deprecate("whitelist", 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.');
                this.options = (0, $60f495c72b2d87aa$export$2e2bcd8739ae039)({}, $28cc57c8969a2496$var$get(), this.options, $28cc57c8969a2496$var$transformOptions(options));
                this.format = this.options.interpolation.format;
                if (!callback) callback = $28cc57c8969a2496$var$noop;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === "function") return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) $28cc57c8969a2496$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else $28cc57c8969a2496$var$baseLogger.init(null, this.options);
                    var lu = new $28cc57c8969a2496$var$LanguageUtil(this.options);
                    this.store = new $28cc57c8969a2496$var$ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = $28cc57c8969a2496$var$baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new $28cc57c8969a2496$var$PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    s.interpolator = new $28cc57c8969a2496$var$Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new $28cc57c8969a2496$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on("*", function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new $28cc57c8969a2496$var$Translator(this.services, this.options);
                    this.translator.on("*", function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
                var storeApi = [
                    "getResource",
                    "hasResourceBundle",
                    "getResourceBundle",
                    "getDataByLanguage"
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    "addResource",
                    "addResources",
                    "addResourceBundle",
                    "removeResourceBundle"
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = $28cc57c8969a2496$var$defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn("init: i18next is already initialized. You should call init just once!");
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log("initialized", _this2.options);
                        _this2.emit("initialized", _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== "v1" && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $28cc57c8969a2496$var$noop;
                var usedCallback = callback;
                var usedLng = typeof language === "string" ? language : this.language;
                if (typeof language === "function") usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === "cimode") return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = $28cc57c8969a2496$var$defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = $28cc57c8969a2496$var$noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
                if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
                if (module.type === "backend") this.modules.backend = module;
                if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === "languageDetector") this.modules.languageDetector = module;
                if (module.type === "i18nFormat") this.modules.i18nFormat = module;
                if (module.type === "postProcessor") $28cc57c8969a2496$var$postProcessor.addPostProcessor(module);
                if (module.type === "3rdParty") this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = $28cc57c8969a2496$var$defer();
                this.emit("languageChanging", lng);
                var done = function done(err, l) {
                    if (l) {
                        _this4.language = l;
                        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit("languageChanged", l);
                        _this4.logger.log("languageChanged", l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
                    var l = typeof lngs === "string" ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) {
                            _this4.language = l;
                            _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                        }
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) this.services.languageDetector.detect(setLng);
                else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns, keyPrefix) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $0308e3532c157317$export$2e2bcd8739ae039)(opts) !== "object") {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = (0, $60f495c72b2d87aa$export$2e2bcd8739ae039)({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    var keySeparator = _this5.options.keySeparator || ".";
                    var resultKey = keyPrefix ? "".concat(keyPrefix).concat(keySeparator).concat(key) : key;
                    return _this5.t(resultKey, options);
                };
                if (typeof lng === "string") fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                fixedT.keyPrefix = keyPrefix;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
                    return false;
                }
                var lng = this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === "cimode") return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = $28cc57c8969a2496$var$defer();
                if (!this.options.ns) {
                    callback && callback();
                    return Promise.resolve();
                }
                if (typeof ns === "string") ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = $28cc57c8969a2496$var$defer();
                if (typeof lngs === "string") lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
                if (!lng) return "rtl";
                var rtlLngs = [
                    "ar",
                    "shu",
                    "sqr",
                    "ssh",
                    "xaa",
                    "yhd",
                    "yud",
                    "aao",
                    "abh",
                    "abv",
                    "acm",
                    "acq",
                    "acw",
                    "acx",
                    "acy",
                    "adf",
                    "ads",
                    "aeb",
                    "aec",
                    "afb",
                    "ajp",
                    "apc",
                    "apd",
                    "arb",
                    "arq",
                    "ars",
                    "ary",
                    "arz",
                    "auz",
                    "avl",
                    "ayh",
                    "ayl",
                    "ayn",
                    "ayp",
                    "bbz",
                    "pga",
                    "he",
                    "iw",
                    "ps",
                    "pbt",
                    "pbu",
                    "pst",
                    "prp",
                    "prd",
                    "ug",
                    "ur",
                    "ydd",
                    "yds",
                    "yih",
                    "ji",
                    "yi",
                    "hbo",
                    "men",
                    "xmn",
                    "fa",
                    "jpr",
                    "peo",
                    "pes",
                    "prs",
                    "dv",
                    "sam"
                ];
                return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? "rtl" : "ltr";
            }
        },
        {
            key: "createInstance",
            value: function createInstance() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                return new I18n(options, callback);
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $28cc57c8969a2496$var$noop;
                var mergedOptions = (0, $60f495c72b2d87aa$export$2e2bcd8739ae039)({}, this.options, options, {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                var membersToCopy = [
                    "store",
                    "services",
                    "language"
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = (0, $60f495c72b2d87aa$export$2e2bcd8739ae039)({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new $28cc57c8969a2496$var$Translator(clone.services, clone.options);
                clone.translator.on("*", function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    options: this.options,
                    store: this.store,
                    language: this.language,
                    languages: this.languages
                };
            }
        }
    ]);
    return I18n;
}($28cc57c8969a2496$var$EventEmitter);
var $28cc57c8969a2496$var$i18next = new $28cc57c8969a2496$var$I18n();
var $28cc57c8969a2496$export$2e2bcd8739ae039 = $28cc57c8969a2496$var$i18next;




const $cdf098895d141710$var$backendHost = window.location.host.includes("localhost") ? "http://localhost:8000/api" : "https://api.lerche-lesediagnose.at";
const $cdf098895d141710$export$86cc9d96db6c637c = $cdf098895d141710$var$backendHost + "/pdfReport?session_id=";
const $cdf098895d141710$var$apiEndPoints = {
    previousGroup: $cdf098895d141710$var$backendHost + "/previousGroup",
    answersGroup: $cdf098895d141710$var$backendHost + "/answersGroup",
    startTest: $cdf098895d141710$var$backendHost + "/startTest",
    resumeTest: $cdf098895d141710$var$backendHost + "/resumeTest",
    nextSection: $cdf098895d141710$var$backendHost + "/nextSection",
    abortTest: $cdf098895d141710$var$backendHost + "/abortTest",
    textResults: $cdf098895d141710$var$backendHost + "/textResults"
};
const $cdf098895d141710$var$defaultOptions = {
    headers: {
        "Accept": "application/json",
        "Content-Type": "application/json;charset=UTF-8"
    }
};
// eslint-disable-next-line no-unused-vars
const $cdf098895d141710$var$fetchApi = async (url, payload = {}, options = {})=>{
    let finalUrl = url;
    let defOptions = Object.assign({}, $cdf098895d141710$var$defaultOptions, options);
    defOptions.headers["Content-Language"] = (0, $28cc57c8969a2496$export$2e2bcd8739ae039).language.substring(0, 2);
    defOptions.headers["Accept-Language"] = (0, $28cc57c8969a2496$export$2e2bcd8739ae039).language.substring(0, 2);
    //log.info("fetchApi", "defOptions #1", defOptions);
    if ((options === null || options === void 0 ? void 0 : options.method) && options.method === "GET") finalUrl += "?" + new URLSearchParams(payload).toString();
    else defOptions.body = JSON.stringify(payload);
    //log.info("x001 fetchApi", "defOptions #2", defOptions);
    (0, $2f1964277cbcb4b2$export$6f57813fe9f31bf9).dispatch((0, $bd1c05d3e19afc9d$export$1c03665141dc142f)({
        submitting: true
    }));
    const response = await fetch(finalUrl, defOptions).then((response)=>{
        return [
            204
        ].includes(response.status) ? {} : response.json();
    }).catch(function(error) {
        return {
            error: error.error || "error.connectingToServer",
            payload: {
                url: url,
                payload: payload,
                error: error
            }
        };
    }).finally(()=>{
        (0, $2f1964277cbcb4b2$export$6f57813fe9f31bf9).dispatch((0, $bd1c05d3e19afc9d$export$1c03665141dc142f)({
            submitting: false
        }));
    });
    if (response.error) return {
        error: response.error || "error.connectingToServer",
        payload: {
            url: url,
            payload: payload,
            error: response.error
        }
    };
    return response;
};
const $cdf098895d141710$export$e72511350a89a269 = async (sessionId)=>{
    //session
    let res = await $cdf098895d141710$var$fetchApi($cdf098895d141710$var$apiEndPoints.startTest, {
        concrete_test_code: sessionId
    }, {
        method: "POST"
    }); //
    return res;
};
const $cdf098895d141710$export$b96b69e966de3651 = async (sessionId)=>{
    return await $cdf098895d141710$var$fetchApi($cdf098895d141710$var$apiEndPoints.resumeTest, {
        session_id: sessionId
    }, {
        method: "GET"
    });
};
const $cdf098895d141710$export$d9c45e29a4259227 = async (sessionId, answers)=>{
    return await $cdf098895d141710$var$fetchApi($cdf098895d141710$var$apiEndPoints.previousGroup, {
        session_id: sessionId,
        student_answer: answers
    }, {
        method: "POST"
    });
};
const $cdf098895d141710$export$ed3a631456019f00 = async (sessionId, answers)=>{
    return await $cdf098895d141710$var$fetchApi($cdf098895d141710$var$apiEndPoints.nextSection, {
        session_id: sessionId,
        student_answer: answers
    }, {
        method: "POST"
    });
};
const $cdf098895d141710$export$c275eceb89556514 = async (sessionId)=>{
    return await $cdf098895d141710$var$fetchApi($cdf098895d141710$var$apiEndPoints.textResults, {
        session_id: sessionId,
        type: "student"
    }, {
        method: "GET"
    });
};
const $cdf098895d141710$export$588d6001e05323e6 = async (sessionId)=>{
    return await $cdf098895d141710$var$fetchApi($cdf098895d141710$var$apiEndPoints.textResults, {
        session_id: sessionId,
        type: "teacher"
    }, {
        method: "GET"
    });
};
const $cdf098895d141710$export$55c80b1906ad1f5b = async (sessionId)=>{
    return await $cdf098895d141710$var$fetchApi($cdf098895d141710$var$apiEndPoints.abortTest, {
        session_id: sessionId
    }, {
        method: "PUT"
    });
};
const $cdf098895d141710$export$6c33279ba320b667 = async (sessionId, answers)=>{
    return await $cdf098895d141710$var$fetchApi($cdf098895d141710$var$apiEndPoints.answersGroup, {
        session_id: sessionId,
        student_answer: answers
    }, {
        method: "POST"
    });
};
const $cdf098895d141710$export$302dd75f45529012 = async (sessionId, answers)=>{
    return await $cdf098895d141710$var$fetchApi($cdf098895d141710$var$apiEndPoints.answersGroup, {
        session_id: sessionId,
        complete_test: true,
        student_answer: answers
    }, {
        method: "POST"
    });
};







var $cQNHH = parcelRequire("cQNHH");



const $d81664beb83ca6c7$var$Component = ()=>{
    const history = (0, $a252e3f3b9c91bac$export$3420e1dc2c4a518c)();
    const { t: t } = (0, $aa8f0a59a97a3595$export$9fc83ad70ead8663)();
    const dispatch = (0, $07670883d6f89641$export$8ad76b76a4c905f8)();
    const directorState = (0, $bd34a43d05d9e670$export$2105062e25df4afe)((0, $bd1c05d3e19afc9d$export$86d1cded24611cb8));
    const removeModal = ()=>{
        dispatch((0, $da18f57894276811$export$35f4993c69cad466)({}));
    };
    const doCancelTest = async ()=>{
        const res = await $cdf098895d141710$export$55c80b1906ad1f5b(directorState.sessionId);
        if (!res.error) {
            dispatch((0, $bd1c05d3e19afc9d$export$5fd37d90ba0958ec)({}));
            dispatch((0, $da18f57894276811$export$35f4993c69cad466)({}));
            dispatch((0, $ef73d84de842ec50$export$fb9705de59d96855)({
                text: t("abortTest.testWasAborted.message"),
                type: (0, $ef73d84de842ec50$export$87130b6dd9721cee).INFO,
                props: {}
            }));
            history.push((0, $078fc8f7799889e4$export$500824a38b151028));
        } else dispatch((0, $ef73d84de842ec50$export$fb9705de59d96855)({
            text: t(res.error),
            type: (0, $ef73d84de842ec50$export$87130b6dd9721cee).ERROR,
            props: {}
        }));
    };
    //Todo: translate
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("header", {
        className: "modal-card-head"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("p", {
        className: "modal-card-title"
    }, t("modal.abortTest.caption"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("section", {
        className: "modal-card-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("p", {
        className: "has-text-danger has-text-weight-bold"
    }, t("modal.abortTest.content.init")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("p", null, t("modal.abortTest.content"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("footer", {
        className: "modal-card-foot"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("button", {
        onClick: doCancelTest,
        className: "button button--direction-down is-danger is-rounded"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "icon licon-trash"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "button__text"
    }, t("modal.abortTest.submitButton.caption"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("button", {
        onClick: removeModal,
        className: "button button--direction-left is-text is-rounded"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "icon licon-arrow-arc-left"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "button__text"
    }, t("modal.abortTest.cancelButton.caption")))));
};
const $d81664beb83ca6c7$export$6e1b820cdfe11a44 = $d81664beb83ca6c7$var$Component;



var $cQNHH = parcelRequire("cQNHH");



const $a198d2a782fb5cee$var$HelpComponent = ()=>{
    const { t: t } = (0, $aa8f0a59a97a3595$export$9fc83ad70ead8663)();
    const dispatch = (0, $07670883d6f89641$export$8ad76b76a4c905f8)();
    const removeModal = ()=>{
        console.log("removeModal");
        dispatch((0, $da18f57894276811$export$35f4993c69cad466)({}));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("header", {
        className: "modal-card-head"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("p", {
        className: "modal-card-title"
    }, t("modal.help.caption"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("section", {
        className: "modal-card-body",
        dangerouslySetInnerHTML: {
            __html: t("modal.help.content")
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("footer", {
        className: "modal-card-foot"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("button", {
        onClick: removeModal,
        className: "button is-text is-rounded"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "icon licon-x"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "button__text"
    }, "Schlie\xdfen"))));
};
const $a198d2a782fb5cee$export$1be7516c0280bee8 = $a198d2a782fb5cee$var$HelpComponent;







var $cQNHH = parcelRequire("cQNHH");





const $d333fd7672a532e8$var$Component = ()=>{
    const { t: t } = (0, $aa8f0a59a97a3595$export$9fc83ad70ead8663)();
    const history = (0, $a252e3f3b9c91bac$export$3420e1dc2c4a518c)();
    const dispatch = (0, $07670883d6f89641$export$8ad76b76a4c905f8)();
    const directorState = (0, $bd34a43d05d9e670$export$2105062e25df4afe)((0, $bd1c05d3e19afc9d$export$86d1cded24611cb8));
    const modalState = (0, $bd34a43d05d9e670$export$2105062e25df4afe)((0, $da18f57894276811$export$97564ec4f39e372c));
    // React.useEffect(() => {
    //     //console.log("xxx", modalState);
    //     if(modalState.modalActive) document.body.classList.add('test--out');
    //     else document.body.classList.remove('test--out');
    // }, [modalState.modalActive]);
    // const sleep = (ms) => {
    //     return new Promise(resolve => setTimeout(resolve, ms));
    //   };
    const removeModal = ()=>{
        dispatch((0, $da18f57894276811$export$34c750e9d1412945)({}));
        dispatch((0, $da18f57894276811$export$35f4993c69cad466)({}));
    };
    const goNextSection = async ()=>{
        //console.log("goNextSection", modalState.modalPayload);
        let res;
        const isLastSection = directorState.currentSectionNo === directorState.noOfSections;
        dispatch((0, $da18f57894276811$export$af4939467128bcd0)({}));
        //await sleep(5000);
        const succF = (res)=>{
            //console.log("NextSection", "onSubmitSuccess", res.error, res);
            (0, $2476a2e6668a6972$export$169439c91a279f79)("story__top");
            document.body.classList.remove("test--out");
            removeModal();
            if (isLastSection) history.push((0, $078fc8f7799889e4$export$45f15e91356025b3));
            else dispatch((0, $bd1c05d3e19afc9d$export$e16717ba5a5dc549)({
                section: res
            }));
        };
        const onSubmitFailure = (res)=>{
            //console.log("NextSection", "onSubmitFailure", res.error, res);
            document.body.classList.remove("test--out");
            dispatch((0, $da18f57894276811$export$34c750e9d1412945)({}));
            dispatch((0, $ef73d84de842ec50$export$fb9705de59d96855)({
                text: t(res.error),
                type: (0, $ef73d84de842ec50$export$87130b6dd9721cee).ERROR,
                props: {}
            }));
        };
        document.body.classList.add("test--out");
        if (isLastSection) res = $cdf098895d141710$export$302dd75f45529012(directorState.sessionId, modalState.modalPayload.model);
        else res = $cdf098895d141710$export$ed3a631456019f00(directorState.sessionId, modalState.modalPayload.model);
        res.then(succF, onSubmitFailure);
        return res;
    };
    //Todo: translate
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("section", {
        className: "modal-card-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("p", null, t("modal.nextSection.content")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "mt-25"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("button", {
        onClick: goNextSection,
        className: "button is-success button--direction-down is-rounded"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "icon licon-arrow-circle-down"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "button__text"
    }, t("modal.nextSection.submitButton.caption"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("button", {
        onClick: removeModal,
        className: "button is-text is-rounded"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "icon licon-x"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "button__text"
    }, t("modal.nextSection.cancelButton.caption"))))));
};
const $d333fd7672a532e8$export$8aa9c773570601fa = $d333fd7672a532e8$var$Component;


const $0f7a3f1d5dcb3e86$export$3d96f1ad58688d8 = {
    "Help": (0, $a198d2a782fb5cee$export$1be7516c0280bee8),
    "AbortTest": (0, $d81664beb83ca6c7$export$6e1b820cdfe11a44),
    "NextSection": (0, $d333fd7672a532e8$export$8aa9c773570601fa)
};



//import {useTranslation} from "react-i18next";
const $c503ba36b9c1ffdb$var$ModalComponent = ()=>{
    const modalState = (0, $bd34a43d05d9e670$export$2105062e25df4afe)((0, $da18f57894276811$export$97564ec4f39e372c));
    //const history = useHistory();
    //const {t} = useTranslation();
    const dispatch = (0, $07670883d6f89641$export$8ad76b76a4c905f8)();
    // console.log("ModalComponent", history.location.pathname, testUrl);
    const location = (0, $a252e3f3b9c91bac$export$45d76561a5302f2b)();
    (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useEffect(()=>{}, [
        location
    ]);
    const removeModal = ()=>{
        dispatch((0, $da18f57894276811$export$35f4993c69cad466)({}));
    };
    //log.info("ModalComponent", modalState.modalContent, modals);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))("modal", {
            "is-active": modalState.modalActive && !modalState.modalHidden
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "modal-background"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "modal-card"
    }, modalState.modalContent && (0, $0f7a3f1d5dcb3e86$export$3d96f1ad58688d8)[modalState.modalContent] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $0f7a3f1d5dcb3e86$export$3d96f1ad58688d8)[modalState.modalContent], {})), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("button", {
        onClick: removeModal,
        className: "button is-tertiary modal--close",
        "aria-label": "close"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "icon licon-x"
    })));
};
const $c503ba36b9c1ffdb$export$2b77a92f1a5ad772 = $c503ba36b9c1ffdb$var$ModalComponent;


var $a5a5a1f74bab9dcb$exports = {};

$parcel$export($a5a5a1f74bab9dcb$exports, "NavigationBar", function () { return $a5a5a1f74bab9dcb$export$214ae410b202e65a; });





var $cQNHH = parcelRequire("cQNHH");






var $38c5cf42fb206e43$exports = {};
$38c5cf42fb206e43$exports = JSON.parse('{"name":"lerche-lesediagnose","version":"1.2.9","browserslist":"> 0.25%, not dead","scripts":{"start":"parcel src/index.html","build":"parcel build src/index.html","eslint":"eslint src/ --ext .js --ext .jsx"},"dependencies":{"@material-ui/core":"^4.12.3","@reduxjs/toolkit":"^1.6.1","@types/react":"^16.8.6 || ^17.0.0","ajv":"^8.6.2","ajv-formats":"^2.1.1","classnames":"^2.3.1","html2pdf.js":"^0.9.3","i18next":"^20.6.1","i18next-browser-languagedetector":"^6.1.2","js-snackbar":"^1.1.2","lib":"^4.3.3","logger":"^0.0.1","loglevel":"^1.7.1","loglevel-plugin-remote":"^0.6.8","react":"^16.8.0 || ^17.0.0","react-device-detect":"^2.2.2","react-dom":"^16.8.0 || ^17.0.0","react-helmet-async":"^1.1.0","react-i18next":"^11.12.0","react-idle-timer":"^5.6.2","react-redux":"^7.2.4","react-router-dom":"^5.3.0","react-tooltip":"^4.2.21","redux":"^4.1.1","redux-persist":"^6.0.0","simplebar-react":"^2.3.6","uniforms":"^3.5.5","uniforms-bridge-json-schema":"^3.5.5","uniforms-unstyled":"^3.5.5"},"devDependencies":{"@babel/core":"^7.22.10","@babel/preset-env":"^7.22.10","@babel/preset-react":"^7.14.5","babel-eslint":"^10.1.0","babel-plugin-module-resolver":"^5.0.0","babel-preset-env":"^1.7.0","buffer":"^6.0.3","eslint":"^7.32.0","eslint-plugin-react":"^7.24.0","parcel":"^2.9.3","process":"^0.11.10","serve":"^14.2.0"}}');


// eslint-disable-next-line no-undef
const $a5a5a1f74bab9dcb$var$APP_VERSION = $38c5cf42fb206e43$exports.version;
const $a5a5a1f74bab9dcb$var$NavigationBarComponent = ()=>{
    const history = (0, $a252e3f3b9c91bac$export$3420e1dc2c4a518c)();
    const { t: t } = (0, $aa8f0a59a97a3595$export$9fc83ad70ead8663)();
    const dispatch = (0, $07670883d6f89641$export$8ad76b76a4c905f8)();
    const idleState = (0, $bd34a43d05d9e670$export$2105062e25df4afe)((0, $de29339268adc9ed$export$c3aeaf078d419c4b));
    const [navIsActive, setNavIsActive] = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useState(false);
    //console.log("NavigationBarComponent", history.location.pathname, testUrl);
    const goto = (target)=>history.push(target);
    const location = (0, $a252e3f3b9c91bac$export$45d76561a5302f2b)();
    (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useEffect(()=>{
        if (idleState.timeLeft > 0) document.body.classList.add("is-timeout");
        else document.body.classList.remove("is-timeout");
    }, [
        location,
        idleState.timeLeft
    ]);
    const doCancelTest = async ()=>{
        if ([
            (0, $078fc8f7799889e4$export$45f15e91356025b3)
        ].includes(history.location.pathname)) {
            dispatch((0, $bd1c05d3e19afc9d$export$5fd37d90ba0958ec)({}));
            // dispatch(addItem({text: t("abortTest.testWasAborted.message"), type: MESSAGE_TYPE.INFO, props: {}}));
            goto((0, $078fc8f7799889e4$export$500824a38b151028));
        } else dispatch((0, $da18f57894276811$export$923d3332dd605124)({
            content: "AbortTest"
        }));
    };
    //console.log("NavigationBarComponent", idleState.timeLeft);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("nav", {
        className: "navbar is-transparent",
        role: "navigation",
        "aria-label": "main navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "navbar-brand"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "navbar-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "header__logo"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("p", {
        className: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "icon licon-bird"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "header__title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("p", {
        className: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "header__name"
    }, t("app.name")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "header__subname"
    }, t("app.subname")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "header__version"
    }, $a5a5a1f74bab9dcb$var$APP_VERSION))), idleState.timeLeft > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "header__timeout"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("p", null, t("navigation.logout.message1"), " ", Math.round(idleState.timeLeft / 1000), " ", t("navigation.logout.message2")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("a", {
        role: "button",
        onClick: ()=>setNavIsActive(!navIsActive),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))("navbar-burger", {
            "is-active": navIsActive
        }),
        "aria-label": "menu",
        "aria-expanded": "false",
        "data-target": "navbarBasicExample"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        "aria-hidden": "true"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        "aria-hidden": "true"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        "aria-hidden": "true"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))("navbar-menu", {
            "is-active": navIsActive
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "navbar-start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "navbar-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "navbar-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "buttons"
    }, ![
        (0, $078fc8f7799889e4$export$7aa67dc43ca8e63d),
        (0, $078fc8f7799889e4$export$1db569cf9469e5b3),
        (0, $078fc8f7799889e4$export$45f15e91356025b3)
    ].includes(history.location.pathname) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("button", {
        onClick: goto.bind(undefined, (0, $078fc8f7799889e4$export$1db569cf9469e5b3)),
        className: "button is-small button--direction-right is-rounded is-primary header__launch__start header__launch__start--hidden"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "button__text"
    }, t("navigation.startTest.caption")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "icon licon-play-circle"
    })), [
        (0, $078fc8f7799889e4$export$1db569cf9469e5b3),
        (0, $078fc8f7799889e4$export$45f15e91356025b3)
    ].includes(history.location.pathname) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("button", {
        onClick: doCancelTest,
        className: "button is-small is-rounded is-text header__launch__stop 0header__launch__stop--hidden"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "button__text"
    }, t([
        (0, $078fc8f7799889e4$export$45f15e91356025b3)
    ].includes(history.location.pathname) ? "testResultPage.newTestButton.caption" : "navigation.cancelTest.caption")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "icon licon-x"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "navbar-item is-hoverable"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("a", {
        className: "navbar-link is-arrowless button is-small is-rounded is-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "navbar-item__text"
    }, t("navigation.more.caption")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "icon licon-list"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "navbar-dropdown is-right is-boxed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("a", {
        onClick: goto.bind(undefined, (0, $078fc8f7799889e4$export$500824a38b151028)),
        className: "navbar-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "navbar-item__text"
    }, t("navigation.home.caption"))), history.location.pathname !== (0, $078fc8f7799889e4$export$1db569cf9469e5b3) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("a", {
        onClick: goto.bind(undefined, (0, $078fc8f7799889e4$export$7aa67dc43ca8e63d)),
        className: "navbar-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "navbar-item__text"
    }, t("navigation.startTest.caption"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("a", {
        onClick: goto.bind(undefined, (0, $078fc8f7799889e4$export$2a280bdbd8b49d15)),
        className: "navbar-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "navbar-item__text"
    }, t("navigation.privacyPolicy.caption"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("a", {
        onClick: goto.bind(undefined, (0, $078fc8f7799889e4$export$ce029234ae8b8b29)),
        className: "navbar-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "navbar-item__text"
    }, t("navigation.impress.caption"))))))));
};
$a5a5a1f74bab9dcb$var$NavigationBarComponent.propTypes = {
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).object
};
const $a5a5a1f74bab9dcb$export$214ae410b202e65a = $a5a5a1f74bab9dcb$var$NavigationBarComponent;



var $cQNHH = parcelRequire("cQNHH");
function $b80c0068634c63f4$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $b80c0068634c63f4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $b80c0068634c63f4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b80c0068634c63f4$var$_typeof(obj);
}
function $b80c0068634c63f4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b80c0068634c63f4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b80c0068634c63f4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b80c0068634c63f4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b80c0068634c63f4$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $b80c0068634c63f4$var$_possibleConstructorReturn(self, call) {
    if (call && ($b80c0068634c63f4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $b80c0068634c63f4$var$_assertThisInitialized(self);
}
function $b80c0068634c63f4$var$_getPrototypeOf(o) {
    $b80c0068634c63f4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b80c0068634c63f4$var$_getPrototypeOf(o);
}
function $b80c0068634c63f4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b80c0068634c63f4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $b80c0068634c63f4$var$_setPrototypeOf(subClass, superClass);
}
function $b80c0068634c63f4$var$_setPrototypeOf(o, p) {
    $b80c0068634c63f4$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b80c0068634c63f4$var$_setPrototypeOf(o, p);
}
function $b80c0068634c63f4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $b80c0068634c63f4$export$311ca220e7478cda = /*#__PURE__*/ function(_PureComponent) {
    $b80c0068634c63f4$var$_inherits(PersistGate, _PureComponent);
    function PersistGate() {
        var _getPrototypeOf2;
        var _this;
        $b80c0068634c63f4$var$_classCallCheck(this, PersistGate);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $b80c0068634c63f4$var$_possibleConstructorReturn(this, (_getPrototypeOf2 = $b80c0068634c63f4$var$_getPrototypeOf(PersistGate)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        $b80c0068634c63f4$var$_defineProperty($b80c0068634c63f4$var$_assertThisInitialized(_this), "state", {
            bootstrapped: false
        });
        $b80c0068634c63f4$var$_defineProperty($b80c0068634c63f4$var$_assertThisInitialized(_this), "_unsubscribe", void 0);
        $b80c0068634c63f4$var$_defineProperty($b80c0068634c63f4$var$_assertThisInitialized(_this), "handlePersistorState", function() {
            var persistor = _this.props.persistor;
            var _persistor$getState = persistor.getState(), bootstrapped = _persistor$getState.bootstrapped;
            if (bootstrapped) {
                if (_this.props.onBeforeLift) Promise.resolve(_this.props.onBeforeLift()).finally(function() {
                    return _this.setState({
                        bootstrapped: true
                    });
                });
                else _this.setState({
                    bootstrapped: true
                });
                _this._unsubscribe && _this._unsubscribe();
            }
        });
        return _this;
    }
    $b80c0068634c63f4$var$_createClass(PersistGate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
                this.handlePersistorState();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._unsubscribe && this._unsubscribe();
            }
        },
        {
            key: "render",
            value: function render() {
                if (typeof this.props.children === "function") return this.props.children(this.state.bootstrapped);
                return this.state.bootstrapped ? this.props.children : this.props.loading;
            }
        }
    ]);
    return PersistGate;
}((0, $cQNHH.PureComponent));
$b80c0068634c63f4$var$_defineProperty($b80c0068634c63f4$export$311ca220e7478cda, "defaultProps", {
    children: null,
    loading: null
});




var $cQNHH = parcelRequire("cQNHH");



var $cQNHH = parcelRequire("cQNHH");






/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $7012a42bac68cf4a$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $011e5a01704cf426$export$2e2bcd8739ae039)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $8933ce2f446fbaae$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $a252e3f3b9c91bac$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $7012a42bac68cf4a$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $011e5a01704cf426$export$2e2bcd8739ae039)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $8933ce2f446fbaae$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $a252e3f3b9c91bac$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Component);
var $7012a42bac68cf4a$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $7012a42bac68cf4a$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $8933ce2f446fbaae$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $7012a42bac68cf4a$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $7012a42bac68cf4a$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).forwardRef;
if (typeof $7012a42bac68cf4a$var$forwardRef === "undefined") $7012a42bac68cf4a$var$forwardRef = $7012a42bac68cf4a$var$forwardRefShim;
function $7012a42bac68cf4a$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $7012a42bac68cf4a$var$LinkAnchor = $7012a42bac68cf4a$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $407e1b6a8d307018$export$2e2bcd8739ae039)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$7012a42bac68cf4a$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($7012a42bac68cf4a$var$forwardRefShim !== $7012a42bac68cf4a$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $7012a42bac68cf4a$export$a6c7ac8248d6e38a = $7012a42bac68cf4a$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $7012a42bac68cf4a$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $407e1b6a8d307018$export$2e2bcd8739ae039)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $a252e3f3b9c91bac$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $830d1f5b441d5854$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $7012a42bac68cf4a$var$normalizeToLocation($7012a42bac68cf4a$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $7012a42bac68cf4a$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $8933ce2f446fbaae$export$fe53371bee54353d)(context.location) === (0, $8933ce2f446fbaae$export$fe53371bee54353d)($7012a42bac68cf4a$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($7012a42bac68cf4a$var$forwardRefShim !== $7012a42bac68cf4a$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(component, props);
    });
});
var $7012a42bac68cf4a$var$toType, $7012a42bac68cf4a$var$refType;
var $7012a42bac68cf4a$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $7012a42bac68cf4a$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).forwardRef;
if (typeof $7012a42bac68cf4a$var$forwardRef$1 === "undefined") $7012a42bac68cf4a$var$forwardRef$1 = $7012a42bac68cf4a$var$forwardRefShim$1;
function $7012a42bac68cf4a$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $7012a42bac68cf4a$export$b0d92dbee9b5b60d = $7012a42bac68cf4a$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $407e1b6a8d307018$export$2e2bcd8739ae039)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $a252e3f3b9c91bac$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $830d1f5b441d5854$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $7012a42bac68cf4a$var$normalizeToLocation($7012a42bac68cf4a$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $a252e3f3b9c91bac$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $7012a42bac68cf4a$var$joinClassnames(className, activeClassName);
            style = (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)({}, style, activeStyle);
        }
        var props = (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($7012a42bac68cf4a$var$forwardRefShim$1 !== $7012a42bac68cf4a$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($7012a42bac68cf4a$export$a6c7ac8248d6e38a, props);
    });
});
var $7012a42bac68cf4a$var$ariaCurrentType;




var $cQNHH = parcelRequire("cQNHH");

const $a62c49ffb9292a68$export$aec9e034445ee8d0 = ({ ...content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $a252e3f3b9c91bac$export$e7b0ac011bb776c6), content);
};




var $cQNHH = parcelRequire("cQNHH");


const $07c0c6a15c49a4f3$var$HomePage = ()=>{
    const history = (0, $a252e3f3b9c91bac$export$3420e1dc2c4a518c)();
    (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useEffect(()=>{
        document.body.classList.add("layout--centered");
        return ()=>{
            document.body.classList.remove("layout--centered");
        };
    }, []);
    const goToTestPage = ()=>{
        history.push((0, $078fc8f7799889e4$export$7aa67dc43ca8e63d));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "section bg-primary-gradient-soft"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "container is-max-desktop"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "tree__show tree-home my-25",
        style: {
            "--result": "119"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "tree__left"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "tree-image"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "tree-birds"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "tree-bird tree-bird-1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "tree-bird tree-bird-2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "tree-bird tree-bird-3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "tree-bird tree-bird-4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "tree-bird tree-bird-5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "tree-bird tree-bird-6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "tree-bird tree-bird-7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "tree-bird tree-bird-8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "tree-bird tree-bird-9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "tree-bird tree-bird-10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "tree-bird tree-bird-11"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "tree-bird tree-bird-12"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "tree-bird tree-bird-13"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "tree-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("p", null, "Als Tiny am Bach ankam, hatte Ruby bereits ein riesiges L\xf6wenzahnblatt im Maul und knabberte voller Genuss. „Das ist so gut“, m\xfcmmelte er gen\xfcsslich. Tiny war nerv\xf6s. Sie richtete sich auf den Hinterbeinen auf, spitzte die Ohren und schnupperte aufgeregt. Doch alles war ruhig, kein Fuchsgeruch lag in der Luft. Nur gut, dass F\xfcchse so stanken, dass man sie auch gegen den Wind riechen konnte. Vorsichtig knabberte auch Tiny an einer Dotterblume, nicht ohne immer wieder horchen und zu schnuppern. „Komm Tiny, du musst etwas fressen! Sonst bleibst du immer so ein Winzling. Hier, probier‘ das einmal! Du hast wieder einmal die allerbesten Delikatessen mit deiner feinen Nase gefunden.“ Nun grub auch Tiny ihre kleinen Vorderz\xe4hne in einen saftiges Blatt und genoss, dass sich ihr Magen zunehmend f\xfcllte. Doch was war das? Aus den Wipfeln der B\xe4ume hatte sich ein bedrohlicher Schatten gel\xf6st, der sich rasch n\xe4herte. Schon sp\xfcrte Tiny das Trommeln der anderen Kaninchen, die mit ihren Hinterl\xe4ufen vor der Gefahr warnten. Tiny stie\xdf einen langgezogenen, schrillen Schrei aus: „Eule, eine Eule!“ Sie fl\xfcchtete sich tiefer die steile B\xf6schung hinab und kroch zitternd unter das gro\xdfe, feuchte Blatt einer Klette. Sie kauerte sich zitternd darunter, hoffte, dass es ihren gesamten K\xf6rper bedeckte und sie nicht mehr so sehen war. Fest krallte sie sich in den Untergrund, damit ihr K\xf6rper durch die Anspannung das Zittern aufh\xf6rte. Das Wasser des Baches schwappte gegen ihren Bauch. Ruby hingegen war ihren nat\xfcrlichen Kaninchen-Instinkten gefolgt und spurtete in Richtung der Kaninchenl\xf6cher. Im Zickzack floh er \xfcber die Wiese, die nun v\xf6llig im Dunkeln lag. \xdcber sich h\xf6rte er das leise Rauschen der Schwingen der Eule. Wann w\xfcrde sie herabst\xfcrzen und ihren Schnabel in sein Fleisch schlagen? Rubys Lunge brannte, seine Hinterl\xe4ufe schmerzten. Wo war das n\xe4chste Kaninchenloch? Ruby machte einen riesigen Satz und landete tats\xe4chlich in der N\xe4he eines Eingangs des Baus. Mit letzter Kraft st\xfcrzte er sich in die Tiefe."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "tree__right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("h1", null, "Hallo beim Lerche Lesetest!"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "box my-lh"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("h2", {
        className: "is-success"
    }, "Du bist Sch\xfcler*in"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("p", null, "und du hast bereits einen Test-Code. Dann starte den Lesetest."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "controls"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("button", {
        onClick: goToTestPage,
        className: "button button--direction-right is-rounded is-success"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "button__text"
    }, "Zum Test"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "icon licon-arrow-circle-right"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "box my-lh"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("h2", {
        className: "is-info"
    }, "Sie sind Lehrer*in"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("p", null, "Alle Informationen zur Lerche Lesediagnose, wie Sie Tests einrichten und Ihre Klassen verwalten, erfahren sie hier:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "controls"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("button", {
        onClick: ()=>{
            window.open("https://www.jungoesterreich.at/fachinformation/lesediagnose");
        },
        className: "button button--direction-up is-rounded is-info"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "button__text"
    }, "Alle Informationen"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "icon licon-arrow-square-out"
    })))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "container is-max-tablet"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("h3", null, "Ein Tool aus dem JUNG\xd6STERREICH Bildungsmedienverlag"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("p", null, "Wenn Sie interessiert sind, an weiteren spannenden Produkten aus unserem Haus, sollten Sie hier starten: ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("a", {
        href: "http://www.jungoesterreich.at"
    }, "www.jungoesterreich.at")))));
};
var $07c0c6a15c49a4f3$export$2e2bcd8739ae039 = $07c0c6a15c49a4f3$var$HomePage;



var $cQNHH = parcelRequire("cQNHH");

const $f8f29f96ada01449$var$ImpressPage = ()=>{
    const { t: t } = (0, $aa8f0a59a97a3595$export$9fc83ad70ead8663)();
    (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useEffect(()=>{
        document.body.classList.add("layout--centered");
        return ()=>{
            document.body.classList.remove("layout--centered");
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "container is-max-desktop",
        dangerouslySetInnerHTML: {
            __html: t("impress.text")
        }
    })));
};
var $f8f29f96ada01449$export$2e2bcd8739ae039 = $f8f29f96ada01449$var$ImpressPage;



var $cQNHH = parcelRequire("cQNHH");
const $1be21cc9c163ee19$var$NotFoundPage = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("p", {
        style: {
            textAlign: "center"
        }
    }, "Page not Found"));
};
var $1be21cc9c163ee19$export$2e2bcd8739ae039 = $1be21cc9c163ee19$var$NotFoundPage;



var $cQNHH = parcelRequire("cQNHH");

const $e2f1ac62ba212fe4$var$PrivacyPolicy = ()=>{
    const { t: t } = (0, $aa8f0a59a97a3595$export$9fc83ad70ead8663)();
    (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useEffect(()=>{
        document.body.classList.add("layout--centered");
        return ()=>{
            document.body.classList.remove("layout--centered");
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "container is-max-desktop",
        dangerouslySetInnerHTML: {
            __html: t("privacyPoliy.text")
        }
    })));
};
var $e2f1ac62ba212fe4$export$2e2bcd8739ae039 = $e2f1ac62ba212fe4$var$PrivacyPolicy;



var $cQNHH = parcelRequire("cQNHH");

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $bc7159ecac4d4618$var$extendStatics = function(d, b) {
    $bc7159ecac4d4618$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $bc7159ecac4d4618$var$extendStatics(d, b);
};
function $bc7159ecac4d4618$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $bc7159ecac4d4618$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $bc7159ecac4d4618$export$18ce0697a983be9b = function() {
    $bc7159ecac4d4618$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bc7159ecac4d4618$export$18ce0697a983be9b.apply(this, arguments);
};
function $bc7159ecac4d4618$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $bc7159ecac4d4618$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $bc7159ecac4d4618$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $bc7159ecac4d4618$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $bc7159ecac4d4618$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $bc7159ecac4d4618$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $bc7159ecac4d4618$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $bc7159ecac4d4618$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $bc7159ecac4d4618$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $bc7159ecac4d4618$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $bc7159ecac4d4618$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $bc7159ecac4d4618$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $bc7159ecac4d4618$export$45d3717a4c69092e(o, m, p);
}
function $bc7159ecac4d4618$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $bc7159ecac4d4618$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $bc7159ecac4d4618$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($bc7159ecac4d4618$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $bc7159ecac4d4618$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $bc7159ecac4d4618$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $bc7159ecac4d4618$export$10c90e4f7922046c(v) {
    return this instanceof $bc7159ecac4d4618$export$10c90e4f7922046c ? (this.v = v, this) : new $bc7159ecac4d4618$export$10c90e4f7922046c(v);
}
function $bc7159ecac4d4618$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $bc7159ecac4d4618$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $bc7159ecac4d4618$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $bc7159ecac4d4618$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $bc7159ecac4d4618$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $bc7159ecac4d4618$export$19a8beecd37a4c45 === "function" ? $bc7159ecac4d4618$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $bc7159ecac4d4618$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $bc7159ecac4d4618$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $bc7159ecac4d4618$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $bc7159ecac4d4618$export$45d3717a4c69092e(result, mod, k);
    }
    $bc7159ecac4d4618$var$__setModuleDefault(result, mod);
    return result;
}
function $bc7159ecac4d4618$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $bc7159ecac4d4618$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $bc7159ecac4d4618$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $bc7159ecac4d4618$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
var $bc7159ecac4d4618$export$2e2bcd8739ae039 = {
    __extends: $bc7159ecac4d4618$export$a8ba968b8961cb8a,
    __assign: $bc7159ecac4d4618$export$18ce0697a983be9b,
    __rest: $bc7159ecac4d4618$export$3c9a16f847548506,
    __decorate: $bc7159ecac4d4618$export$29e00dfd3077644b,
    __param: $bc7159ecac4d4618$export$d5ad3fd78186038f,
    __metadata: $bc7159ecac4d4618$export$f1db080c865becb9,
    __awaiter: $bc7159ecac4d4618$export$1050f835b63b671e,
    __generator: $bc7159ecac4d4618$export$67ebef60e6f28a6,
    __createBinding: $bc7159ecac4d4618$export$45d3717a4c69092e,
    __exportStar: $bc7159ecac4d4618$export$f33643c0debef087,
    __values: $bc7159ecac4d4618$export$19a8beecd37a4c45,
    __read: $bc7159ecac4d4618$export$8d051b38c9118094,
    __spread: $bc7159ecac4d4618$export$afc72e2116322959,
    __spreadArrays: $bc7159ecac4d4618$export$6388937ca91ccae8,
    __spreadArray: $bc7159ecac4d4618$export$1216008129fb82ed,
    __await: $bc7159ecac4d4618$export$10c90e4f7922046c,
    __asyncGenerator: $bc7159ecac4d4618$export$e427f37a30a4de9b,
    __asyncDelegator: $bc7159ecac4d4618$export$bbd80228419bb833,
    __asyncValues: $bc7159ecac4d4618$export$e3b29a3d6162315f,
    __makeTemplateObject: $bc7159ecac4d4618$export$4fb47efe1390b86f,
    __importStar: $bc7159ecac4d4618$export$c21735bcef00d192,
    __importDefault: $bc7159ecac4d4618$export$da59b14a69baef04,
    __classPrivateFieldGet: $bc7159ecac4d4618$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $bc7159ecac4d4618$export$d40a35129aaff81f,
    __classPrivateFieldIn: $bc7159ecac4d4618$export$81fdc39f203e4e04
};



var $cQNHH = parcelRequire("cQNHH");


var $cQNHH = parcelRequire("cQNHH");

var $cQNHH = parcelRequire("cQNHH");
const $3002b2189a02c5b2$export$a078c61943f9dbbe = (0, $cQNHH.createContext)(null);


function $8d33e3f7f35abf1d$export$87c0cf8eb5a167e0() {
    const context = (0, $cQNHH.useContext)((0, $3002b2189a02c5b2$export$a078c61943f9dbbe));
    (0, (/*@__PURE__*/$parcel$interopDefault($e5f9c2c26e21f232$exports)))(context !== null, `useForm must be used within a form.

Two most common reasons for this error are:
1. Component calling this function doesn't have a parent Form component in the tree.
2. A duplicate uniforms dependency is installed in node_modules.

For more info check FAQ: https://uniforms.tools/docs/faq/#useform-must-be-used-within-a-form
  `);
    return context;
}





var $cQNHH = parcelRequire("cQNHH");
var $ad66414c641bd16b$exports = {};
var $382452d79d8c383d$exports = {};
var $26be98534887ebf0$exports = {};
var $907546b303adca65$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $907546b303adca65$var$isArray = Array.isArray;
$907546b303adca65$exports = $907546b303adca65$var$isArray;


var $911c54c9fdeacf6a$exports = {};

var $a1985ee6d63f9116$exports = {};
var $5ea36cd4db8c52be$exports = {};
var $445e6982b2ab4cdb$exports = {};

var $iYrGz = parcelRequire("iYrGz");
/** Built-in value references. */ var $445e6982b2ab4cdb$var$Symbol = $iYrGz.Symbol;
$445e6982b2ab4cdb$exports = $445e6982b2ab4cdb$var$Symbol;


var $1f153c368112531c$exports = {};

/** Used for built-in method references. */ var $1f153c368112531c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1f153c368112531c$var$hasOwnProperty = $1f153c368112531c$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1f153c368112531c$var$nativeObjectToString = $1f153c368112531c$var$objectProto.toString;
/** Built-in value references. */ var $1f153c368112531c$var$symToStringTag = $445e6982b2ab4cdb$exports ? $445e6982b2ab4cdb$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $1f153c368112531c$var$getRawTag(value) {
    var isOwn = $1f153c368112531c$var$hasOwnProperty.call(value, $1f153c368112531c$var$symToStringTag), tag = value[$1f153c368112531c$var$symToStringTag];
    try {
        value[$1f153c368112531c$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $1f153c368112531c$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$1f153c368112531c$var$symToStringTag] = tag;
        else delete value[$1f153c368112531c$var$symToStringTag];
    }
    return result;
}
$1f153c368112531c$exports = $1f153c368112531c$var$getRawTag;


var $36c2f4d3b0620e60$exports = {};
/** Used for built-in method references. */ var $36c2f4d3b0620e60$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $36c2f4d3b0620e60$var$nativeObjectToString = $36c2f4d3b0620e60$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $36c2f4d3b0620e60$var$objectToString(value) {
    return $36c2f4d3b0620e60$var$nativeObjectToString.call(value);
}
$36c2f4d3b0620e60$exports = $36c2f4d3b0620e60$var$objectToString;


/** `Object#toString` result references. */ var $5ea36cd4db8c52be$var$nullTag = "[object Null]", $5ea36cd4db8c52be$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $5ea36cd4db8c52be$var$symToStringTag = $445e6982b2ab4cdb$exports ? $445e6982b2ab4cdb$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $5ea36cd4db8c52be$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $5ea36cd4db8c52be$var$undefinedTag : $5ea36cd4db8c52be$var$nullTag;
    return $5ea36cd4db8c52be$var$symToStringTag && $5ea36cd4db8c52be$var$symToStringTag in Object(value) ? $1f153c368112531c$exports(value) : $36c2f4d3b0620e60$exports(value);
}
$5ea36cd4db8c52be$exports = $5ea36cd4db8c52be$var$baseGetTag;


var $1e04b4bf2bb5d0fe$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $1e04b4bf2bb5d0fe$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$1e04b4bf2bb5d0fe$exports = $1e04b4bf2bb5d0fe$var$isObjectLike;


/** `Object#toString` result references. */ var $a1985ee6d63f9116$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $a1985ee6d63f9116$var$isSymbol(value) {
    return typeof value == "symbol" || $1e04b4bf2bb5d0fe$exports(value) && $5ea36cd4db8c52be$exports(value) == $a1985ee6d63f9116$var$symbolTag;
}
$a1985ee6d63f9116$exports = $a1985ee6d63f9116$var$isSymbol;


/** Used to match property names within property paths. */ var $911c54c9fdeacf6a$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $911c54c9fdeacf6a$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $911c54c9fdeacf6a$var$isKey(value, object) {
    if ($907546b303adca65$exports(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $a1985ee6d63f9116$exports(value)) return true;
    return $911c54c9fdeacf6a$var$reIsPlainProp.test(value) || !$911c54c9fdeacf6a$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$911c54c9fdeacf6a$exports = $911c54c9fdeacf6a$var$isKey;


var $d59f622f529ce430$exports = {};
var $2eda070fe506261f$exports = {};
var $b2b23a4a6cad67db$exports = {};
var $98b79fba862e1236$exports = {};
var $4f371df4ad3319b0$exports = {};
var $b459e4438e965ee6$exports = {};
var $a0f9dc3c7a32a4bf$exports = {};
var $db84e48cf9ba60ea$exports = {};
var $3fd9fe2cc12670e0$exports = {};
var $adfc8b25d27c791c$exports = {};
var $482cc7018e4dfe91$exports = {};

var $149642e59a27d046$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $149642e59a27d046$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$149642e59a27d046$exports = $149642e59a27d046$var$isObject;


/** `Object#toString` result references. */ var $482cc7018e4dfe91$var$asyncTag = "[object AsyncFunction]", $482cc7018e4dfe91$var$funcTag = "[object Function]", $482cc7018e4dfe91$var$genTag = "[object GeneratorFunction]", $482cc7018e4dfe91$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $482cc7018e4dfe91$var$isFunction(value) {
    if (!$149642e59a27d046$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $5ea36cd4db8c52be$exports(value);
    return tag == $482cc7018e4dfe91$var$funcTag || tag == $482cc7018e4dfe91$var$genTag || tag == $482cc7018e4dfe91$var$asyncTag || tag == $482cc7018e4dfe91$var$proxyTag;
}
$482cc7018e4dfe91$exports = $482cc7018e4dfe91$var$isFunction;


var $8c434c8e553e6062$exports = {};
var $e0dffd916a2ed037$exports = {};

var $iYrGz = parcelRequire("iYrGz");
/** Used to detect overreaching core-js shims. */ var $e0dffd916a2ed037$var$coreJsData = $iYrGz["__core-js_shared__"];
$e0dffd916a2ed037$exports = $e0dffd916a2ed037$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $8c434c8e553e6062$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($e0dffd916a2ed037$exports && $e0dffd916a2ed037$exports.keys && $e0dffd916a2ed037$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $8c434c8e553e6062$var$isMasked(func) {
    return !!$8c434c8e553e6062$var$maskSrcKey && $8c434c8e553e6062$var$maskSrcKey in func;
}
$8c434c8e553e6062$exports = $8c434c8e553e6062$var$isMasked;



var $ef7509e567c62560$exports = {};
/** Used for built-in method references. */ var $ef7509e567c62560$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $ef7509e567c62560$var$funcToString = $ef7509e567c62560$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $ef7509e567c62560$var$toSource(func) {
    if (func != null) {
        try {
            return $ef7509e567c62560$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$ef7509e567c62560$exports = $ef7509e567c62560$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $adfc8b25d27c791c$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $adfc8b25d27c791c$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $adfc8b25d27c791c$var$funcProto = Function.prototype, $adfc8b25d27c791c$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $adfc8b25d27c791c$var$funcToString = $adfc8b25d27c791c$var$funcProto.toString;
/** Used to check objects for own properties. */ var $adfc8b25d27c791c$var$hasOwnProperty = $adfc8b25d27c791c$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $adfc8b25d27c791c$var$reIsNative = RegExp("^" + $adfc8b25d27c791c$var$funcToString.call($adfc8b25d27c791c$var$hasOwnProperty).replace($adfc8b25d27c791c$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $adfc8b25d27c791c$var$baseIsNative(value) {
    if (!$149642e59a27d046$exports(value) || $8c434c8e553e6062$exports(value)) return false;
    var pattern = $482cc7018e4dfe91$exports(value) ? $adfc8b25d27c791c$var$reIsNative : $adfc8b25d27c791c$var$reIsHostCtor;
    return pattern.test($ef7509e567c62560$exports(value));
}
$adfc8b25d27c791c$exports = $adfc8b25d27c791c$var$baseIsNative;


var $8869f4e5cadc1b91$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $8869f4e5cadc1b91$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$8869f4e5cadc1b91$exports = $8869f4e5cadc1b91$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $3fd9fe2cc12670e0$var$getNative(object, key) {
    var value = $8869f4e5cadc1b91$exports(object, key);
    return $adfc8b25d27c791c$exports(value) ? value : undefined;
}
$3fd9fe2cc12670e0$exports = $3fd9fe2cc12670e0$var$getNative;


/* Built-in method references that are verified to be native. */ var $db84e48cf9ba60ea$var$nativeCreate = $3fd9fe2cc12670e0$exports(Object, "create");
$db84e48cf9ba60ea$exports = $db84e48cf9ba60ea$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $a0f9dc3c7a32a4bf$var$hashClear() {
    this.__data__ = $db84e48cf9ba60ea$exports ? $db84e48cf9ba60ea$exports(null) : {};
    this.size = 0;
}
$a0f9dc3c7a32a4bf$exports = $a0f9dc3c7a32a4bf$var$hashClear;


var $7055afc5a67a0fee$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7055afc5a67a0fee$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$7055afc5a67a0fee$exports = $7055afc5a67a0fee$var$hashDelete;


var $8b54bac5fbe28608$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $8b54bac5fbe28608$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $8b54bac5fbe28608$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8b54bac5fbe28608$var$hasOwnProperty = $8b54bac5fbe28608$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $8b54bac5fbe28608$var$hashGet(key) {
    var data = this.__data__;
    if ($db84e48cf9ba60ea$exports) {
        var result = data[key];
        return result === $8b54bac5fbe28608$var$HASH_UNDEFINED ? undefined : result;
    }
    return $8b54bac5fbe28608$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$8b54bac5fbe28608$exports = $8b54bac5fbe28608$var$hashGet;


var $c00ca4313f20edf0$exports = {};

/** Used for built-in method references. */ var $c00ca4313f20edf0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c00ca4313f20edf0$var$hasOwnProperty = $c00ca4313f20edf0$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c00ca4313f20edf0$var$hashHas(key) {
    var data = this.__data__;
    return $db84e48cf9ba60ea$exports ? data[key] !== undefined : $c00ca4313f20edf0$var$hasOwnProperty.call(data, key);
}
$c00ca4313f20edf0$exports = $c00ca4313f20edf0$var$hashHas;


var $44fc6ba92ae600b1$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $44fc6ba92ae600b1$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $44fc6ba92ae600b1$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $db84e48cf9ba60ea$exports && value === undefined ? $44fc6ba92ae600b1$var$HASH_UNDEFINED : value;
    return this;
}
$44fc6ba92ae600b1$exports = $44fc6ba92ae600b1$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $b459e4438e965ee6$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$b459e4438e965ee6$var$Hash.prototype.clear = $a0f9dc3c7a32a4bf$exports;
$b459e4438e965ee6$var$Hash.prototype["delete"] = $7055afc5a67a0fee$exports;
$b459e4438e965ee6$var$Hash.prototype.get = $8b54bac5fbe28608$exports;
$b459e4438e965ee6$var$Hash.prototype.has = $c00ca4313f20edf0$exports;
$b459e4438e965ee6$var$Hash.prototype.set = $44fc6ba92ae600b1$exports;
$b459e4438e965ee6$exports = $b459e4438e965ee6$var$Hash;


var $d09cc0eaa53dabc5$exports = {};
var $31ac2d7b1fd9cb18$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $31ac2d7b1fd9cb18$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$31ac2d7b1fd9cb18$exports = $31ac2d7b1fd9cb18$var$listCacheClear;


var $ebe7c063d2694d31$exports = {};
var $2e14bc977c5a1076$exports = {};
var $e8399f10b890743c$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $e8399f10b890743c$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$e8399f10b890743c$exports = $e8399f10b890743c$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $2e14bc977c5a1076$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($e8399f10b890743c$exports(array[length][0], key)) return length;
    }
    return -1;
}
$2e14bc977c5a1076$exports = $2e14bc977c5a1076$var$assocIndexOf;


/** Used for built-in method references. */ var $ebe7c063d2694d31$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $ebe7c063d2694d31$var$splice = $ebe7c063d2694d31$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ebe7c063d2694d31$var$listCacheDelete(key) {
    var data = this.__data__, index = $2e14bc977c5a1076$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $ebe7c063d2694d31$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$ebe7c063d2694d31$exports = $ebe7c063d2694d31$var$listCacheDelete;


var $6ef42258279cd4ef$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6ef42258279cd4ef$var$listCacheGet(key) {
    var data = this.__data__, index = $2e14bc977c5a1076$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$6ef42258279cd4ef$exports = $6ef42258279cd4ef$var$listCacheGet;


var $499e4936c590e112$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $499e4936c590e112$var$listCacheHas(key) {
    return $2e14bc977c5a1076$exports(this.__data__, key) > -1;
}
$499e4936c590e112$exports = $499e4936c590e112$var$listCacheHas;


var $3968a01252a41a03$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $3968a01252a41a03$var$listCacheSet(key, value) {
    var data = this.__data__, index = $2e14bc977c5a1076$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$3968a01252a41a03$exports = $3968a01252a41a03$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d09cc0eaa53dabc5$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$d09cc0eaa53dabc5$var$ListCache.prototype.clear = $31ac2d7b1fd9cb18$exports;
$d09cc0eaa53dabc5$var$ListCache.prototype["delete"] = $ebe7c063d2694d31$exports;
$d09cc0eaa53dabc5$var$ListCache.prototype.get = $6ef42258279cd4ef$exports;
$d09cc0eaa53dabc5$var$ListCache.prototype.has = $499e4936c590e112$exports;
$d09cc0eaa53dabc5$var$ListCache.prototype.set = $3968a01252a41a03$exports;
$d09cc0eaa53dabc5$exports = $d09cc0eaa53dabc5$var$ListCache;


var $3603e425c0256536$exports = {};


var $iYrGz = parcelRequire("iYrGz");
/* Built-in method references that are verified to be native. */ var $3603e425c0256536$var$Map = $3fd9fe2cc12670e0$exports($iYrGz, "Map");
$3603e425c0256536$exports = $3603e425c0256536$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $4f371df4ad3319b0$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $b459e4438e965ee6$exports,
        "map": new ($3603e425c0256536$exports || $d09cc0eaa53dabc5$exports),
        "string": new $b459e4438e965ee6$exports
    };
}
$4f371df4ad3319b0$exports = $4f371df4ad3319b0$var$mapCacheClear;


var $908a2df458e9791c$exports = {};
var $5d2932e0e458dcfc$exports = {};
var $b3d8b9b0e411dc54$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $b3d8b9b0e411dc54$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$b3d8b9b0e411dc54$exports = $b3d8b9b0e411dc54$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $5d2932e0e458dcfc$var$getMapData(map, key) {
    var data = map.__data__;
    return $b3d8b9b0e411dc54$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$5d2932e0e458dcfc$exports = $5d2932e0e458dcfc$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $908a2df458e9791c$var$mapCacheDelete(key) {
    var result = $5d2932e0e458dcfc$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$908a2df458e9791c$exports = $908a2df458e9791c$var$mapCacheDelete;


var $1397c9b9c9424e6e$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $1397c9b9c9424e6e$var$mapCacheGet(key) {
    return $5d2932e0e458dcfc$exports(this, key).get(key);
}
$1397c9b9c9424e6e$exports = $1397c9b9c9424e6e$var$mapCacheGet;


var $914e0f21a602ffdb$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $914e0f21a602ffdb$var$mapCacheHas(key) {
    return $5d2932e0e458dcfc$exports(this, key).has(key);
}
$914e0f21a602ffdb$exports = $914e0f21a602ffdb$var$mapCacheHas;


var $78c1ca44a613e973$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $78c1ca44a613e973$var$mapCacheSet(key, value) {
    var data = $5d2932e0e458dcfc$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$78c1ca44a613e973$exports = $78c1ca44a613e973$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $98b79fba862e1236$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$98b79fba862e1236$var$MapCache.prototype.clear = $4f371df4ad3319b0$exports;
$98b79fba862e1236$var$MapCache.prototype["delete"] = $908a2df458e9791c$exports;
$98b79fba862e1236$var$MapCache.prototype.get = $1397c9b9c9424e6e$exports;
$98b79fba862e1236$var$MapCache.prototype.has = $914e0f21a602ffdb$exports;
$98b79fba862e1236$var$MapCache.prototype.set = $78c1ca44a613e973$exports;
$98b79fba862e1236$exports = $98b79fba862e1236$var$MapCache;


/** Error message constants. */ var $b2b23a4a6cad67db$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $b2b23a4a6cad67db$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($b2b23a4a6cad67db$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($b2b23a4a6cad67db$var$memoize.Cache || $98b79fba862e1236$exports);
    return memoized;
}
// Expose `MapCache`.
$b2b23a4a6cad67db$var$memoize.Cache = $98b79fba862e1236$exports;
$b2b23a4a6cad67db$exports = $b2b23a4a6cad67db$var$memoize;


/** Used as the maximum memoize cache size. */ var $2eda070fe506261f$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $2eda070fe506261f$var$memoizeCapped(func) {
    var result = $b2b23a4a6cad67db$exports(func, function(key) {
        if (cache.size === $2eda070fe506261f$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$2eda070fe506261f$exports = $2eda070fe506261f$var$memoizeCapped;


/** Used to match property names within property paths. */ var $d59f622f529ce430$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $d59f622f529ce430$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $d59f622f529ce430$var$stringToPath = $2eda070fe506261f$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($d59f622f529ce430$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($d59f622f529ce430$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
$d59f622f529ce430$exports = $d59f622f529ce430$var$stringToPath;


var $0c156dec013dd29f$exports = {};
var $775dbf76926567cf$exports = {};

var $705c9649d4ad8bbf$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $705c9649d4ad8bbf$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$705c9649d4ad8bbf$exports = $705c9649d4ad8bbf$var$arrayMap;




/** Used as references for various `Number` constants. */ var $775dbf76926567cf$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $775dbf76926567cf$var$symbolProto = $445e6982b2ab4cdb$exports ? $445e6982b2ab4cdb$exports.prototype : undefined, $775dbf76926567cf$var$symbolToString = $775dbf76926567cf$var$symbolProto ? $775dbf76926567cf$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $775dbf76926567cf$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($907546b303adca65$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $705c9649d4ad8bbf$exports(value, $775dbf76926567cf$var$baseToString) + "";
    if ($a1985ee6d63f9116$exports(value)) return $775dbf76926567cf$var$symbolToString ? $775dbf76926567cf$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$775dbf76926567cf$var$INFINITY ? "-0" : result;
}
$775dbf76926567cf$exports = $775dbf76926567cf$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $0c156dec013dd29f$var$toString(value) {
    return value == null ? "" : $775dbf76926567cf$exports(value);
}
$0c156dec013dd29f$exports = $0c156dec013dd29f$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $26be98534887ebf0$var$castPath(value, object) {
    if ($907546b303adca65$exports(value)) return value;
    return $911c54c9fdeacf6a$exports(value, object) ? [
        value
    ] : $d59f622f529ce430$exports($0c156dec013dd29f$exports(value));
}
$26be98534887ebf0$exports = $26be98534887ebf0$var$castPath;


var $18a4d69693757e11$exports = {};

/** Used as references for various `Number` constants. */ var $18a4d69693757e11$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $18a4d69693757e11$var$toKey(value) {
    if (typeof value == "string" || $a1985ee6d63f9116$exports(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$18a4d69693757e11$var$INFINITY ? "-0" : result;
}
$18a4d69693757e11$exports = $18a4d69693757e11$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $382452d79d8c383d$var$baseGet(object, path) {
    path = $26be98534887ebf0$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$18a4d69693757e11$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$382452d79d8c383d$exports = $382452d79d8c383d$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $ad66414c641bd16b$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $382452d79d8c383d$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$ad66414c641bd16b$exports = $ad66414c641bd16b$var$get;


var $6a3d0a919548ff30$exports = {};
var $5f937d655a715d25$exports = {};
var $d5fccfe3d6eef89d$exports = {};

var $d5fccfe3d6eef89d$var$defineProperty = function() {
    try {
        var func = $3fd9fe2cc12670e0$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$d5fccfe3d6eef89d$exports = $d5fccfe3d6eef89d$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $5f937d655a715d25$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $d5fccfe3d6eef89d$exports) $d5fccfe3d6eef89d$exports(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
$5f937d655a715d25$exports = $5f937d655a715d25$var$baseAssignValue;


var $b24f6337425ae86b$exports = {};
var $870b9267ccbd28af$exports = {};
var $fdf3f0698d626a8f$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $fdf3f0698d626a8f$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$fdf3f0698d626a8f$exports = $fdf3f0698d626a8f$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $870b9267ccbd28af$var$baseFor = $fdf3f0698d626a8f$exports();
$870b9267ccbd28af$exports = $870b9267ccbd28af$var$baseFor;


var $df39d715863dea43$exports = {};
var $ac975ba91d655c37$exports = {};
var $00d38be10cf53217$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $00d38be10cf53217$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$00d38be10cf53217$exports = $00d38be10cf53217$var$baseTimes;


var $b2e5bee79b98c26f$exports = {};
var $1077cfde7b181686$exports = {};


/** `Object#toString` result references. */ var $1077cfde7b181686$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $1077cfde7b181686$var$baseIsArguments(value) {
    return $1e04b4bf2bb5d0fe$exports(value) && $5ea36cd4db8c52be$exports(value) == $1077cfde7b181686$var$argsTag;
}
$1077cfde7b181686$exports = $1077cfde7b181686$var$baseIsArguments;



/** Used for built-in method references. */ var $b2e5bee79b98c26f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b2e5bee79b98c26f$var$hasOwnProperty = $b2e5bee79b98c26f$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $b2e5bee79b98c26f$var$propertyIsEnumerable = $b2e5bee79b98c26f$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $b2e5bee79b98c26f$var$isArguments = $1077cfde7b181686$exports(function() {
    return arguments;
}()) ? $1077cfde7b181686$exports : function(value) {
    return $1e04b4bf2bb5d0fe$exports(value) && $b2e5bee79b98c26f$var$hasOwnProperty.call(value, "callee") && !$b2e5bee79b98c26f$var$propertyIsEnumerable.call(value, "callee");
};
$b2e5bee79b98c26f$exports = $b2e5bee79b98c26f$var$isArguments;




var $kGntY = parcelRequire("kGntY");
var $51535ec62329b798$exports = {};
/** Used as references for various `Number` constants. */ var $51535ec62329b798$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $51535ec62329b798$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $51535ec62329b798$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $51535ec62329b798$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $51535ec62329b798$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$51535ec62329b798$exports = $51535ec62329b798$var$isIndex;


var $5e25abbcac1ccf91$exports = {};
var $bfd4798c70ae2781$exports = {};

var $74787ff20f5a380f$exports = {};
/** Used as references for various `Number` constants. */ var $74787ff20f5a380f$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $74787ff20f5a380f$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $74787ff20f5a380f$var$MAX_SAFE_INTEGER;
}
$74787ff20f5a380f$exports = $74787ff20f5a380f$var$isLength;



/** `Object#toString` result references. */ var $bfd4798c70ae2781$var$argsTag = "[object Arguments]", $bfd4798c70ae2781$var$arrayTag = "[object Array]", $bfd4798c70ae2781$var$boolTag = "[object Boolean]", $bfd4798c70ae2781$var$dateTag = "[object Date]", $bfd4798c70ae2781$var$errorTag = "[object Error]", $bfd4798c70ae2781$var$funcTag = "[object Function]", $bfd4798c70ae2781$var$mapTag = "[object Map]", $bfd4798c70ae2781$var$numberTag = "[object Number]", $bfd4798c70ae2781$var$objectTag = "[object Object]", $bfd4798c70ae2781$var$regexpTag = "[object RegExp]", $bfd4798c70ae2781$var$setTag = "[object Set]", $bfd4798c70ae2781$var$stringTag = "[object String]", $bfd4798c70ae2781$var$weakMapTag = "[object WeakMap]";
var $bfd4798c70ae2781$var$arrayBufferTag = "[object ArrayBuffer]", $bfd4798c70ae2781$var$dataViewTag = "[object DataView]", $bfd4798c70ae2781$var$float32Tag = "[object Float32Array]", $bfd4798c70ae2781$var$float64Tag = "[object Float64Array]", $bfd4798c70ae2781$var$int8Tag = "[object Int8Array]", $bfd4798c70ae2781$var$int16Tag = "[object Int16Array]", $bfd4798c70ae2781$var$int32Tag = "[object Int32Array]", $bfd4798c70ae2781$var$uint8Tag = "[object Uint8Array]", $bfd4798c70ae2781$var$uint8ClampedTag = "[object Uint8ClampedArray]", $bfd4798c70ae2781$var$uint16Tag = "[object Uint16Array]", $bfd4798c70ae2781$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $bfd4798c70ae2781$var$typedArrayTags = {};
$bfd4798c70ae2781$var$typedArrayTags[$bfd4798c70ae2781$var$float32Tag] = $bfd4798c70ae2781$var$typedArrayTags[$bfd4798c70ae2781$var$float64Tag] = $bfd4798c70ae2781$var$typedArrayTags[$bfd4798c70ae2781$var$int8Tag] = $bfd4798c70ae2781$var$typedArrayTags[$bfd4798c70ae2781$var$int16Tag] = $bfd4798c70ae2781$var$typedArrayTags[$bfd4798c70ae2781$var$int32Tag] = $bfd4798c70ae2781$var$typedArrayTags[$bfd4798c70ae2781$var$uint8Tag] = $bfd4798c70ae2781$var$typedArrayTags[$bfd4798c70ae2781$var$uint8ClampedTag] = $bfd4798c70ae2781$var$typedArrayTags[$bfd4798c70ae2781$var$uint16Tag] = $bfd4798c70ae2781$var$typedArrayTags[$bfd4798c70ae2781$var$uint32Tag] = true;
$bfd4798c70ae2781$var$typedArrayTags[$bfd4798c70ae2781$var$argsTag] = $bfd4798c70ae2781$var$typedArrayTags[$bfd4798c70ae2781$var$arrayTag] = $bfd4798c70ae2781$var$typedArrayTags[$bfd4798c70ae2781$var$arrayBufferTag] = $bfd4798c70ae2781$var$typedArrayTags[$bfd4798c70ae2781$var$boolTag] = $bfd4798c70ae2781$var$typedArrayTags[$bfd4798c70ae2781$var$dataViewTag] = $bfd4798c70ae2781$var$typedArrayTags[$bfd4798c70ae2781$var$dateTag] = $bfd4798c70ae2781$var$typedArrayTags[$bfd4798c70ae2781$var$errorTag] = $bfd4798c70ae2781$var$typedArrayTags[$bfd4798c70ae2781$var$funcTag] = $bfd4798c70ae2781$var$typedArrayTags[$bfd4798c70ae2781$var$mapTag] = $bfd4798c70ae2781$var$typedArrayTags[$bfd4798c70ae2781$var$numberTag] = $bfd4798c70ae2781$var$typedArrayTags[$bfd4798c70ae2781$var$objectTag] = $bfd4798c70ae2781$var$typedArrayTags[$bfd4798c70ae2781$var$regexpTag] = $bfd4798c70ae2781$var$typedArrayTags[$bfd4798c70ae2781$var$setTag] = $bfd4798c70ae2781$var$typedArrayTags[$bfd4798c70ae2781$var$stringTag] = $bfd4798c70ae2781$var$typedArrayTags[$bfd4798c70ae2781$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $bfd4798c70ae2781$var$baseIsTypedArray(value) {
    return $1e04b4bf2bb5d0fe$exports(value) && $74787ff20f5a380f$exports(value.length) && !!$bfd4798c70ae2781$var$typedArrayTags[$5ea36cd4db8c52be$exports(value)];
}
$bfd4798c70ae2781$exports = $bfd4798c70ae2781$var$baseIsTypedArray;


var $a651a5d22085d60e$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $a651a5d22085d60e$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$a651a5d22085d60e$exports = $a651a5d22085d60e$var$baseUnary;



var $4Nl3a = parcelRequire("4Nl3a");
/* Node.js helper references. */ var $5e25abbcac1ccf91$var$nodeIsTypedArray = $4Nl3a && $4Nl3a.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $5e25abbcac1ccf91$var$isTypedArray = $5e25abbcac1ccf91$var$nodeIsTypedArray ? $a651a5d22085d60e$exports($5e25abbcac1ccf91$var$nodeIsTypedArray) : $bfd4798c70ae2781$exports;
$5e25abbcac1ccf91$exports = $5e25abbcac1ccf91$var$isTypedArray;


/** Used for built-in method references. */ var $ac975ba91d655c37$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ac975ba91d655c37$var$hasOwnProperty = $ac975ba91d655c37$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $ac975ba91d655c37$var$arrayLikeKeys(value, inherited) {
    var isArr = $907546b303adca65$exports(value), isArg = !isArr && $b2e5bee79b98c26f$exports(value), isBuff = !isArr && !isArg && $kGntY(value), isType = !isArr && !isArg && !isBuff && $5e25abbcac1ccf91$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $00d38be10cf53217$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $ac975ba91d655c37$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $51535ec62329b798$exports(key, length)))) result.push(key);
    return result;
}
$ac975ba91d655c37$exports = $ac975ba91d655c37$var$arrayLikeKeys;


var $bab2514150f58cb9$exports = {};
var $446c36e04d0ec6ac$exports = {};
/** Used for built-in method references. */ var $446c36e04d0ec6ac$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $446c36e04d0ec6ac$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $446c36e04d0ec6ac$var$objectProto;
    return value === proto;
}
$446c36e04d0ec6ac$exports = $446c36e04d0ec6ac$var$isPrototype;


var $220cbbabb89cb209$exports = {};
var $70a8acac8570f431$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $70a8acac8570f431$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$70a8acac8570f431$exports = $70a8acac8570f431$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $220cbbabb89cb209$var$nativeKeys = $70a8acac8570f431$exports(Object.keys, Object);
$220cbbabb89cb209$exports = $220cbbabb89cb209$var$nativeKeys;


/** Used for built-in method references. */ var $bab2514150f58cb9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bab2514150f58cb9$var$hasOwnProperty = $bab2514150f58cb9$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $bab2514150f58cb9$var$baseKeys(object) {
    if (!$446c36e04d0ec6ac$exports(object)) return $220cbbabb89cb209$exports(object);
    var result = [];
    for(var key in Object(object))if ($bab2514150f58cb9$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$bab2514150f58cb9$exports = $bab2514150f58cb9$var$baseKeys;


var $55e5458ff1f44d11$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $55e5458ff1f44d11$var$isArrayLike(value) {
    return value != null && $74787ff20f5a380f$exports(value.length) && !$482cc7018e4dfe91$exports(value);
}
$55e5458ff1f44d11$exports = $55e5458ff1f44d11$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $df39d715863dea43$var$keys(object) {
    return $55e5458ff1f44d11$exports(object) ? $ac975ba91d655c37$exports(object) : $bab2514150f58cb9$exports(object);
}
$df39d715863dea43$exports = $df39d715863dea43$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $b24f6337425ae86b$var$baseForOwn(object, iteratee) {
    return object && $870b9267ccbd28af$exports(object, iteratee, $df39d715863dea43$exports);
}
$b24f6337425ae86b$exports = $b24f6337425ae86b$var$baseForOwn;


var $da8cf8c214728ddf$exports = {};
var $15a251d5a5a6e36a$exports = {};
var $700c2110fabfbd0f$exports = {};
var $9d73163477354d5c$exports = {};

var $813ff5e507d7d549$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $813ff5e507d7d549$var$stackClear() {
    this.__data__ = new $d09cc0eaa53dabc5$exports;
    this.size = 0;
}
$813ff5e507d7d549$exports = $813ff5e507d7d549$var$stackClear;


var $5871d441dd7918b6$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $5871d441dd7918b6$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$5871d441dd7918b6$exports = $5871d441dd7918b6$var$stackDelete;


var $678b5cd527d0c29b$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $678b5cd527d0c29b$var$stackGet(key) {
    return this.__data__.get(key);
}
$678b5cd527d0c29b$exports = $678b5cd527d0c29b$var$stackGet;


var $536454b652b65cdd$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $536454b652b65cdd$var$stackHas(key) {
    return this.__data__.has(key);
}
$536454b652b65cdd$exports = $536454b652b65cdd$var$stackHas;


var $a0d6218d1d0f71f9$exports = {};



/** Used as the size to enable large array optimizations. */ var $a0d6218d1d0f71f9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $a0d6218d1d0f71f9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $d09cc0eaa53dabc5$exports) {
        var pairs = data.__data__;
        if (!$3603e425c0256536$exports || pairs.length < $a0d6218d1d0f71f9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $98b79fba862e1236$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$a0d6218d1d0f71f9$exports = $a0d6218d1d0f71f9$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9d73163477354d5c$var$Stack(entries) {
    var data = this.__data__ = new $d09cc0eaa53dabc5$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$9d73163477354d5c$var$Stack.prototype.clear = $813ff5e507d7d549$exports;
$9d73163477354d5c$var$Stack.prototype["delete"] = $5871d441dd7918b6$exports;
$9d73163477354d5c$var$Stack.prototype.get = $678b5cd527d0c29b$exports;
$9d73163477354d5c$var$Stack.prototype.has = $536454b652b65cdd$exports;
$9d73163477354d5c$var$Stack.prototype.set = $a0d6218d1d0f71f9$exports;
$9d73163477354d5c$exports = $9d73163477354d5c$var$Stack;


var $c44efc54af92d51f$exports = {};
var $2e30493a42a37e0c$exports = {};

var $6b2b5b15d748eef0$exports = {};
var $7eb9d4ff21def10f$exports = {};

var $431900b3c4943c5b$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $431900b3c4943c5b$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $431900b3c4943c5b$var$setCacheAdd(value) {
    this.__data__.set(value, $431900b3c4943c5b$var$HASH_UNDEFINED);
    return this;
}
$431900b3c4943c5b$exports = $431900b3c4943c5b$var$setCacheAdd;


var $2bcb8f8e2a7e5e31$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $2bcb8f8e2a7e5e31$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$2bcb8f8e2a7e5e31$exports = $2bcb8f8e2a7e5e31$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $7eb9d4ff21def10f$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $98b79fba862e1236$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$7eb9d4ff21def10f$var$SetCache.prototype.add = $7eb9d4ff21def10f$var$SetCache.prototype.push = $431900b3c4943c5b$exports;
$7eb9d4ff21def10f$var$SetCache.prototype.has = $2bcb8f8e2a7e5e31$exports;
$7eb9d4ff21def10f$exports = $7eb9d4ff21def10f$var$SetCache;


var $6a4dc3c5977ade8a$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $6a4dc3c5977ade8a$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$6a4dc3c5977ade8a$exports = $6a4dc3c5977ade8a$var$arraySome;


var $c76720e758204839$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c76720e758204839$var$cacheHas(cache, key) {
    return cache.has(key);
}
$c76720e758204839$exports = $c76720e758204839$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $6b2b5b15d748eef0$var$COMPARE_PARTIAL_FLAG = 1, $6b2b5b15d748eef0$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $6b2b5b15d748eef0$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $6b2b5b15d748eef0$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $6b2b5b15d748eef0$var$COMPARE_UNORDERED_FLAG ? new $7eb9d4ff21def10f$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$6a4dc3c5977ade8a$exports(other, function(othValue, othIndex) {
                if (!$c76720e758204839$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$6b2b5b15d748eef0$exports = $6b2b5b15d748eef0$var$equalArrays;


var $661f5a0efb42b00d$exports = {};

var $b63f17d1a8e5040d$exports = {};

var $iYrGz = parcelRequire("iYrGz");
/** Built-in value references. */ var $b63f17d1a8e5040d$var$Uint8Array = $iYrGz.Uint8Array;
$b63f17d1a8e5040d$exports = $b63f17d1a8e5040d$var$Uint8Array;




var $df369f17ac303569$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $df369f17ac303569$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$df369f17ac303569$exports = $df369f17ac303569$var$mapToArray;


var $aff20477b45dbc2b$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $aff20477b45dbc2b$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$aff20477b45dbc2b$exports = $aff20477b45dbc2b$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $661f5a0efb42b00d$var$COMPARE_PARTIAL_FLAG = 1, $661f5a0efb42b00d$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $661f5a0efb42b00d$var$boolTag = "[object Boolean]", $661f5a0efb42b00d$var$dateTag = "[object Date]", $661f5a0efb42b00d$var$errorTag = "[object Error]", $661f5a0efb42b00d$var$mapTag = "[object Map]", $661f5a0efb42b00d$var$numberTag = "[object Number]", $661f5a0efb42b00d$var$regexpTag = "[object RegExp]", $661f5a0efb42b00d$var$setTag = "[object Set]", $661f5a0efb42b00d$var$stringTag = "[object String]", $661f5a0efb42b00d$var$symbolTag = "[object Symbol]";
var $661f5a0efb42b00d$var$arrayBufferTag = "[object ArrayBuffer]", $661f5a0efb42b00d$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $661f5a0efb42b00d$var$symbolProto = $445e6982b2ab4cdb$exports ? $445e6982b2ab4cdb$exports.prototype : undefined, $661f5a0efb42b00d$var$symbolValueOf = $661f5a0efb42b00d$var$symbolProto ? $661f5a0efb42b00d$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $661f5a0efb42b00d$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $661f5a0efb42b00d$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $661f5a0efb42b00d$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $b63f17d1a8e5040d$exports(object), new $b63f17d1a8e5040d$exports(other))) return false;
            return true;
        case $661f5a0efb42b00d$var$boolTag:
        case $661f5a0efb42b00d$var$dateTag:
        case $661f5a0efb42b00d$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $e8399f10b890743c$exports(+object, +other);
        case $661f5a0efb42b00d$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $661f5a0efb42b00d$var$regexpTag:
        case $661f5a0efb42b00d$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $661f5a0efb42b00d$var$mapTag:
            var convert = $df369f17ac303569$exports;
        case $661f5a0efb42b00d$var$setTag:
            var isPartial = bitmask & $661f5a0efb42b00d$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $aff20477b45dbc2b$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $661f5a0efb42b00d$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $6b2b5b15d748eef0$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $661f5a0efb42b00d$var$symbolTag:
            if ($661f5a0efb42b00d$var$symbolValueOf) return $661f5a0efb42b00d$var$symbolValueOf.call(object) == $661f5a0efb42b00d$var$symbolValueOf.call(other);
    }
    return false;
}
$661f5a0efb42b00d$exports = $661f5a0efb42b00d$var$equalByTag;


var $7fda341af669014d$exports = {};
var $cd713587626b384f$exports = {};
var $506c40cf3d9092b3$exports = {};
var $a11a0180dd2e1e06$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $a11a0180dd2e1e06$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$a11a0180dd2e1e06$exports = $a11a0180dd2e1e06$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $506c40cf3d9092b3$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $907546b303adca65$exports(object) ? result : $a11a0180dd2e1e06$exports(result, symbolsFunc(object));
}
$506c40cf3d9092b3$exports = $506c40cf3d9092b3$var$baseGetAllKeys;


var $ff650af11a3dd492$exports = {};
var $122fd23cf4f3dd5f$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $122fd23cf4f3dd5f$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$122fd23cf4f3dd5f$exports = $122fd23cf4f3dd5f$var$arrayFilter;


var $27d4fcef3549b74f$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $27d4fcef3549b74f$var$stubArray() {
    return [];
}
$27d4fcef3549b74f$exports = $27d4fcef3549b74f$var$stubArray;


/** Used for built-in method references. */ var $ff650af11a3dd492$var$objectProto = Object.prototype;
/** Built-in value references. */ var $ff650af11a3dd492$var$propertyIsEnumerable = $ff650af11a3dd492$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ff650af11a3dd492$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $ff650af11a3dd492$var$getSymbols = !$ff650af11a3dd492$var$nativeGetSymbols ? $27d4fcef3549b74f$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $122fd23cf4f3dd5f$exports($ff650af11a3dd492$var$nativeGetSymbols(object), function(symbol) {
        return $ff650af11a3dd492$var$propertyIsEnumerable.call(object, symbol);
    });
};
$ff650af11a3dd492$exports = $ff650af11a3dd492$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $cd713587626b384f$var$getAllKeys(object) {
    return $506c40cf3d9092b3$exports(object, $df39d715863dea43$exports, $ff650af11a3dd492$exports);
}
$cd713587626b384f$exports = $cd713587626b384f$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $7fda341af669014d$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $7fda341af669014d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7fda341af669014d$var$hasOwnProperty = $7fda341af669014d$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $7fda341af669014d$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $7fda341af669014d$var$COMPARE_PARTIAL_FLAG, objProps = $cd713587626b384f$exports(object), objLength = objProps.length, othProps = $cd713587626b384f$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $7fda341af669014d$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$7fda341af669014d$exports = $7fda341af669014d$var$equalObjects;


var $438326f3e5863d71$exports = {};
var $70f85074abe831a5$exports = {};


var $iYrGz = parcelRequire("iYrGz");
/* Built-in method references that are verified to be native. */ var $70f85074abe831a5$var$DataView = $3fd9fe2cc12670e0$exports($iYrGz, "DataView");
$70f85074abe831a5$exports = $70f85074abe831a5$var$DataView;



var $14b6023f03e0738e$exports = {};


var $iYrGz = parcelRequire("iYrGz");
/* Built-in method references that are verified to be native. */ var $14b6023f03e0738e$var$Promise = $3fd9fe2cc12670e0$exports($iYrGz, "Promise");
$14b6023f03e0738e$exports = $14b6023f03e0738e$var$Promise;


var $5c4ed34720edda94$exports = {};


var $iYrGz = parcelRequire("iYrGz");
/* Built-in method references that are verified to be native. */ var $5c4ed34720edda94$var$Set = $3fd9fe2cc12670e0$exports($iYrGz, "Set");
$5c4ed34720edda94$exports = $5c4ed34720edda94$var$Set;


var $ffea52a31b98aca3$exports = {};


var $iYrGz = parcelRequire("iYrGz");
/* Built-in method references that are verified to be native. */ var $ffea52a31b98aca3$var$WeakMap = $3fd9fe2cc12670e0$exports($iYrGz, "WeakMap");
$ffea52a31b98aca3$exports = $ffea52a31b98aca3$var$WeakMap;




/** `Object#toString` result references. */ var $438326f3e5863d71$var$mapTag = "[object Map]", $438326f3e5863d71$var$objectTag = "[object Object]", $438326f3e5863d71$var$promiseTag = "[object Promise]", $438326f3e5863d71$var$setTag = "[object Set]", $438326f3e5863d71$var$weakMapTag = "[object WeakMap]";
var $438326f3e5863d71$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $438326f3e5863d71$var$dataViewCtorString = $ef7509e567c62560$exports($70f85074abe831a5$exports), $438326f3e5863d71$var$mapCtorString = $ef7509e567c62560$exports($3603e425c0256536$exports), $438326f3e5863d71$var$promiseCtorString = $ef7509e567c62560$exports($14b6023f03e0738e$exports), $438326f3e5863d71$var$setCtorString = $ef7509e567c62560$exports($5c4ed34720edda94$exports), $438326f3e5863d71$var$weakMapCtorString = $ef7509e567c62560$exports($ffea52a31b98aca3$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $438326f3e5863d71$var$getTag = $5ea36cd4db8c52be$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($70f85074abe831a5$exports && $438326f3e5863d71$var$getTag(new $70f85074abe831a5$exports(new ArrayBuffer(1))) != $438326f3e5863d71$var$dataViewTag || $3603e425c0256536$exports && $438326f3e5863d71$var$getTag(new $3603e425c0256536$exports) != $438326f3e5863d71$var$mapTag || $14b6023f03e0738e$exports && $438326f3e5863d71$var$getTag($14b6023f03e0738e$exports.resolve()) != $438326f3e5863d71$var$promiseTag || $5c4ed34720edda94$exports && $438326f3e5863d71$var$getTag(new $5c4ed34720edda94$exports) != $438326f3e5863d71$var$setTag || $ffea52a31b98aca3$exports && $438326f3e5863d71$var$getTag(new $ffea52a31b98aca3$exports) != $438326f3e5863d71$var$weakMapTag) $438326f3e5863d71$var$getTag = function(value) {
    var result = $5ea36cd4db8c52be$exports(value), Ctor = result == $438326f3e5863d71$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $ef7509e567c62560$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $438326f3e5863d71$var$dataViewCtorString:
            return $438326f3e5863d71$var$dataViewTag;
        case $438326f3e5863d71$var$mapCtorString:
            return $438326f3e5863d71$var$mapTag;
        case $438326f3e5863d71$var$promiseCtorString:
            return $438326f3e5863d71$var$promiseTag;
        case $438326f3e5863d71$var$setCtorString:
            return $438326f3e5863d71$var$setTag;
        case $438326f3e5863d71$var$weakMapCtorString:
            return $438326f3e5863d71$var$weakMapTag;
    }
    return result;
};
$438326f3e5863d71$exports = $438326f3e5863d71$var$getTag;




var $kGntY = parcelRequire("kGntY");

/** Used to compose bitmasks for value comparisons. */ var $2e30493a42a37e0c$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $2e30493a42a37e0c$var$argsTag = "[object Arguments]", $2e30493a42a37e0c$var$arrayTag = "[object Array]", $2e30493a42a37e0c$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $2e30493a42a37e0c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2e30493a42a37e0c$var$hasOwnProperty = $2e30493a42a37e0c$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $2e30493a42a37e0c$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $907546b303adca65$exports(object), othIsArr = $907546b303adca65$exports(other), objTag = objIsArr ? $2e30493a42a37e0c$var$arrayTag : $438326f3e5863d71$exports(object), othTag = othIsArr ? $2e30493a42a37e0c$var$arrayTag : $438326f3e5863d71$exports(other);
    objTag = objTag == $2e30493a42a37e0c$var$argsTag ? $2e30493a42a37e0c$var$objectTag : objTag;
    othTag = othTag == $2e30493a42a37e0c$var$argsTag ? $2e30493a42a37e0c$var$objectTag : othTag;
    var objIsObj = objTag == $2e30493a42a37e0c$var$objectTag, othIsObj = othTag == $2e30493a42a37e0c$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $kGntY(object)) {
        if (!$kGntY(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $9d73163477354d5c$exports);
        return objIsArr || $5e25abbcac1ccf91$exports(object) ? $6b2b5b15d748eef0$exports(object, other, bitmask, customizer, equalFunc, stack) : $661f5a0efb42b00d$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $2e30493a42a37e0c$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $2e30493a42a37e0c$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $2e30493a42a37e0c$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $9d73163477354d5c$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $9d73163477354d5c$exports);
    return $7fda341af669014d$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$2e30493a42a37e0c$exports = $2e30493a42a37e0c$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $c44efc54af92d51f$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$1e04b4bf2bb5d0fe$exports(value) && !$1e04b4bf2bb5d0fe$exports(other)) return value !== value && other !== other;
    return $2e30493a42a37e0c$exports(value, other, bitmask, customizer, $c44efc54af92d51f$var$baseIsEqual, stack);
}
$c44efc54af92d51f$exports = $c44efc54af92d51f$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $700c2110fabfbd0f$var$COMPARE_PARTIAL_FLAG = 1, $700c2110fabfbd0f$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $700c2110fabfbd0f$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $9d73163477354d5c$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $c44efc54af92d51f$exports(srcValue, objValue, $700c2110fabfbd0f$var$COMPARE_PARTIAL_FLAG | $700c2110fabfbd0f$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$700c2110fabfbd0f$exports = $700c2110fabfbd0f$var$baseIsMatch;


var $c9d2185c689c0787$exports = {};
var $36ce6c1ac809006e$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $36ce6c1ac809006e$var$isStrictComparable(value) {
    return value === value && !$149642e59a27d046$exports(value);
}
$36ce6c1ac809006e$exports = $36ce6c1ac809006e$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $c9d2185c689c0787$var$getMatchData(object) {
    var result = $df39d715863dea43$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $36ce6c1ac809006e$exports(value)
        ];
    }
    return result;
}
$c9d2185c689c0787$exports = $c9d2185c689c0787$var$getMatchData;


var $768a15e6ebcead7a$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $768a15e6ebcead7a$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$768a15e6ebcead7a$exports = $768a15e6ebcead7a$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $15a251d5a5a6e36a$var$baseMatches(source) {
    var matchData = $c9d2185c689c0787$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $768a15e6ebcead7a$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $700c2110fabfbd0f$exports(object, source, matchData);
    };
}
$15a251d5a5a6e36a$exports = $15a251d5a5a6e36a$var$baseMatches;


var $98df0401bd670f56$exports = {};


var $05c44fb9e9e597d3$exports = {};
var $c8a236707d53871d$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $c8a236707d53871d$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$c8a236707d53871d$exports = $c8a236707d53871d$var$baseHasIn;


var $15b616efa708855b$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $15b616efa708855b$var$hasPath(object, path, hasFunc) {
    path = $26be98534887ebf0$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $18a4d69693757e11$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $74787ff20f5a380f$exports(length) && $51535ec62329b798$exports(key, length) && ($907546b303adca65$exports(object) || $b2e5bee79b98c26f$exports(object));
}
$15b616efa708855b$exports = $15b616efa708855b$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $05c44fb9e9e597d3$var$hasIn(object, path) {
    return object != null && $15b616efa708855b$exports(object, path, $c8a236707d53871d$exports);
}
$05c44fb9e9e597d3$exports = $05c44fb9e9e597d3$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $98df0401bd670f56$var$COMPARE_PARTIAL_FLAG = 1, $98df0401bd670f56$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $98df0401bd670f56$var$baseMatchesProperty(path, srcValue) {
    if ($911c54c9fdeacf6a$exports(path) && $36ce6c1ac809006e$exports(srcValue)) return $768a15e6ebcead7a$exports($18a4d69693757e11$exports(path), srcValue);
    return function(object) {
        var objValue = $ad66414c641bd16b$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $05c44fb9e9e597d3$exports(object, path) : $c44efc54af92d51f$exports(srcValue, objValue, $98df0401bd670f56$var$COMPARE_PARTIAL_FLAG | $98df0401bd670f56$var$COMPARE_UNORDERED_FLAG);
    };
}
$98df0401bd670f56$exports = $98df0401bd670f56$var$baseMatchesProperty;


var $245bbf0693bc803c$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $245bbf0693bc803c$var$identity(value) {
    return value;
}
$245bbf0693bc803c$exports = $245bbf0693bc803c$var$identity;



var $554c5ef8b290b0c0$exports = {};
var $c9f0cd00daf8f1db$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $c9f0cd00daf8f1db$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$c9f0cd00daf8f1db$exports = $c9f0cd00daf8f1db$var$baseProperty;


var $f44763549b8aeaae$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $f44763549b8aeaae$var$basePropertyDeep(path) {
    return function(object) {
        return $382452d79d8c383d$exports(object, path);
    };
}
$f44763549b8aeaae$exports = $f44763549b8aeaae$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $554c5ef8b290b0c0$var$property(path) {
    return $911c54c9fdeacf6a$exports(path) ? $c9f0cd00daf8f1db$exports($18a4d69693757e11$exports(path)) : $f44763549b8aeaae$exports(path);
}
$554c5ef8b290b0c0$exports = $554c5ef8b290b0c0$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $da8cf8c214728ddf$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $245bbf0693bc803c$exports;
    if (typeof value == "object") return $907546b303adca65$exports(value) ? $98df0401bd670f56$exports(value[0], value[1]) : $15a251d5a5a6e36a$exports(value);
    return $554c5ef8b290b0c0$exports(value);
}
$da8cf8c214728ddf$exports = $da8cf8c214728ddf$var$baseIteratee;


/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $6a3d0a919548ff30$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $da8cf8c214728ddf$exports(iteratee, 3);
    $b24f6337425ae86b$exports(object, function(value, key, object) {
        $5f937d655a715d25$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$6a3d0a919548ff30$exports = $6a3d0a919548ff30$var$mapValues;



var $cQNHH = parcelRequire("cQNHH");
const $cf50d698743ef582$var$escapeMatch = /[.[\]]/;
const $cf50d698743ef582$var$escapeRegex = /"/g;
/** @internal */ function $cf50d698743ef582$var$escape(string) {
    return string === "" || $cf50d698743ef582$var$escapeMatch.test(string) ? `["${string.replace($cf50d698743ef582$var$escapeRegex, '\\"')}"]` : string;
}
/** @internal */ function $cf50d698743ef582$var$escapeToJoin(string, index) {
    const escaped = $cf50d698743ef582$var$escape(string);
    return escaped === string ? index ? `.${string}` : string : escaped;
}
const $cf50d698743ef582$var$unescapeMatch = /^\["(.*)"]$/;
const $cf50d698743ef582$var$unescapeRegex = /\\"/g;
/** @internal */ function $cf50d698743ef582$var$unescape(string) {
    const match = $cf50d698743ef582$var$unescapeMatch.exec(string);
    return match ? match[1].replace($cf50d698743ef582$var$unescapeRegex, '"') : string;
}
// This regular expression splits the string into three parts:
//   `prefix` is a dotted name, e.g., `object.nested.2.field` at the
//            front (hence prefix). It covers most standard usecases.
//   `subscript` is a `["..."]` subscript after the prefix. The content
//               within should be escaped by the user, e.g., `["\\""]`.
//   `rest` is anything following the subscript. The leading dot (`.`)
//          is stripped (`.a` -> `a`) if there is one. It is empty if
//          `subscript` is empty.
//
// All three parts can be empty!
const $cf50d698743ef582$var$nameRegex = /^([^.[\]]*(?:\.[^.[\]]+)*)(?:\.?(\["(?:(?:[^"]|\\")*?[^\\])?"])\.?(.*))?$/;
// eslint-disable-next-line complexity -- The complexity of it _is_ high.
function $cf50d698743ef582$var$joinNameImpl(...parts) {
    // If the first argument is `null`, then we return an escaped array of parts.
    // Otherwise, an escaped string is returned. As we may modify `parts` later,
    // this has to be checked now.
    const returnAsParts = parts[0] === null;
    // Result parts (not escaped).
    const name = [];
    // This cannot be transformed into a `.forEach` loop and the length of it
    // can not be memoized, as we modify `parts` as we go for performance reasons.
    for(let index = 0; index !== parts.length; ++index){
        const part = parts[index];
        // All falsy values except `0` are ignored.
        if (part || part === 0) {
            if (typeof part === "string") {
                // Strings are matched against the regular expression that split it into
                // three parts (all can be empty):
                //   `prefix` is a dotted name, e.g., `object.nested.2.field` at the
                //            front (hence prefix). It covers most standard usecases.
                //   `subscript` is a `["..."]` subscript after the prefix. The content
                //               within should be escaped by the user, e.g., `["\\""]`.
                //   `rest` is anything following the subscript. The leading dot (`.`)
                //          is stripped (`.a` -> `a`) if there is one. It is empty if
                //          `subscript` is empty.
                const match = $cf50d698743ef582$var$nameRegex.exec(part);
                if (match) {
                    const [, prefix, subscript, rest] = match;
                    if (prefix) {
                        // We could always `.split` the `prefix`, but it results in a severe
                        // performance hit.
                        if (prefix.includes(".")) name.push(...prefix.split("."));
                        else name.push(prefix);
                    }
                    if (subscript) {
                        // We could adjust the `nameRegex` to skip brackets and `unescape`
                        // to skip this check, but then every other call (e.g., a one in the
                        // bridge) would have to know that. The performance is not affected
                        // much by it anyway.
                        name.push($cf50d698743ef582$var$unescape(subscript));
                        // The `rest` is inlined in place as it is a single string.
                        if (rest) parts[index--] = rest;
                    }
                } else // If a string is not matching the pattern, we leave it as it is. We
                // may want to raise a warning here as it should not happen. Most
                // likely it is something that should have been escaped (e.g., `[`).
                name.push(part);
            } else if (Array.isArray(part)) // Arrays are flattened in place but only if needed, i.e., they are not
            // empty. We calculate the length of the overlapping parts to reuse the
            // `parts` array as much as possible:
            // [[], ...]              -> [[], ...]       // No change.
            // [['a'], ...]           -> ['a', ...]      // Inline in place.
            // [['a', 'b'], ...]      -> ['a', 'b', ...] // Inline with extension.
            // ['a', ['b'], ...]      -> ['a', 'b', ...] // Inline in place.
            // ['a', ['b', 'c'], ...] -> ['b', 'c', ...] // Inline with overlap.
            {
                if (part.length) {
                    const length = Math.min(index + 1, part.length);
                    index -= length;
                    parts.splice(index + 1, length, ...part);
                }
            } else // Other values -- most likely numbers and `true` -- are stringified.
            name.push("" + part);
        }
    }
    // We cannot escape the parts earlier as `escapeToJoin` depends on the index.
    return returnAsParts ? name.map($cf50d698743ef582$var$escape) : name.map($cf50d698743ef582$var$escapeToJoin).join("");
}
const $cf50d698743ef582$export$c8987bb64f9a8b89 = Object.assign($cf50d698743ef582$var$joinNameImpl, {
    escape: $cf50d698743ef582$var$escape,
    unescape: $cf50d698743ef582$var$unescape
});



function $227e5b539bfddd60$var$propagate(prop, schema, state, fallback) {
    const forcedFallbackInProp = prop === true || prop === undefined;
    const forcedFallbackInSchema = schema === true || schema === undefined;
    const schemaValue = forcedFallbackInSchema ? fallback : schema;
    const value = prop === "" || prop === false || prop === null || forcedFallbackInProp && (forcedFallbackInSchema || !state) ? "" : forcedFallbackInProp ? schemaValue : prop;
    return [
        value,
        schemaValue
    ];
}
function $227e5b539bfddd60$export$294aa081a6c6f55d(fieldName, props, options) {
    var _a;
    const context = (0, $8d33e3f7f35abf1d$export$87c0cf8eb5a167e0)();
    const name = (0, $cf50d698743ef582$export$c8987bb64f9a8b89)((options === null || options === void 0 ? void 0 : options.absoluteName) ? "" : context.name, fieldName);
    const field = context.schema.getField(name);
    const usesInitialValue = (options === null || options === void 0 ? void 0 : options.initialValue) !== false;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const onChangeCalled = usesInitialValue ? (0, $cQNHH.useRef)(false) : {
        current: false
    };
    const state = (0, (/*@__PURE__*/$parcel$interopDefault($6a3d0a919548ff30$exports)))(context.state, (prev, key)=>{
        const next = props[key];
        return next !== null && next !== undefined ? !!next : prev;
    });
    const changed = !!(0, (/*@__PURE__*/$parcel$interopDefault($ad66414c641bd16b$exports)))(context.changedMap, name);
    const error = context.schema.getError(name, context.error);
    const errorMessage = context.schema.getErrorMessage(name, context.error);
    const fieldType = context.schema.getType(name);
    const fields = context.schema.getSubfields(name);
    const schemaProps = context.schema.getProps(name, Object.assign(Object.assign({}, state), props));
    const [label, labelFallback] = $227e5b539bfddd60$var$propagate(props.label, schemaProps.label, state.label, "");
    const [placeholder] = $227e5b539bfddd60$var$propagate(props.placeholder, schemaProps.placeholder, state.placeholder, label || labelFallback);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const id = (0, $cQNHH.useMemo)(()=>context.randomId(), []);
    const onChange = (0, $cQNHH.useCallback)((value, key = name)=>{
        onChangeCalled.current = true;
        context.onChange(key, value);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        context.onChange,
        name
    ]);
    const valueFromModel = (0, (/*@__PURE__*/$parcel$interopDefault($ad66414c641bd16b$exports)))(context.model, name);
    let initialValue;
    let value = (_a = props.value) !== null && _a !== void 0 ? _a : valueFromModel;
    if (usesInitialValue) {
        if (!onChangeCalled.current) {
            if (value === undefined) {
                value = context.schema.getInitialValue(name, props);
                initialValue = value;
            } else if (props.value !== undefined && props.value !== valueFromModel) initialValue = props.value;
        }
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $cQNHH.useEffect)(()=>{
            var _a;
            const required = (_a = props.required) !== null && _a !== void 0 ? _a : schemaProps.required;
            if (required && initialValue !== undefined) onChange(initialValue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
    }
    const fieldProps = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        id: id
    }, state), {
        changed: changed,
        error: error,
        errorMessage: errorMessage,
        field: field,
        fieldType: fieldType,
        fields: fields,
        onChange: onChange,
        value: value
    }), schemaProps), props), {
        label: label,
        name: name,
        // TODO: Should we assert `typeof placeholder === 'string'`?
        placeholder: placeholder
    });
    return [
        fieldProps,
        context
    ];
}


function $754f6f9b097b957f$export$67be0aecf20e0922(defaultComponentDetector) {
    const context = (0, $cQNHH.createContext)(defaultComponentDetector);
    function AutoField(rawProps) {
        var _a, _b;
        const [props, uniforms] = (0, $227e5b539bfddd60$export$294aa081a6c6f55d)(rawProps.name, rawProps);
        const componentDetector = (0, $cQNHH.useContext)(context);
        const component = (_a = props.component) !== null && _a !== void 0 ? _a : componentDetector(props, uniforms);
        (0, (/*@__PURE__*/$parcel$interopDefault($e5f9c2c26e21f232$exports)))(component, "AutoField received no component for: %s", props.name);
        return "options" in component && ((_b = component.options) === null || _b === void 0 ? void 0 : _b.kind) === "leaf" ? (0, $cQNHH.createElement)(component.Component, props) : (0, $cQNHH.createElement)(component, rawProps);
    }
    return Object.assign(AutoField, {
        componentDetectorContext: context,
        defaultComponentDetector: defaultComponentDetector
    });
}




var $cQNHH = parcelRequire("cQNHH");


var $cQNHH = parcelRequire("cQNHH");


function $655e28ed924d8929$var$getNextContext(context, props, options) {
    // Leaf components by definition do not affect the context. `AutoField` will
    // skip most of them anyway, but if rendered directly we have to do it here.
    // An example in the core theme are the `List*Field`s.
    if ((options === null || options === void 0 ? void 0 : options.kind) === "leaf") return context;
    const changesName = props.name !== "";
    const changesState = Object.keys(context.state).some((key)=>{
        const next = props[key];
        return next !== null && next !== undefined;
    });
    // There are no other ways of affecting the context.
    if (!changesName && !changesState) return context;
    const nextContext = Object.assign({}, context);
    if (changesName) nextContext.name = nextContext.name.concat(props.name);
    if (changesState) nextContext.state = (0, (/*@__PURE__*/$parcel$interopDefault($6a3d0a919548ff30$exports)))(nextContext.state, (prev, key)=>{
        const next = props[key];
        return next !== null && next !== undefined ? !!next : prev;
    });
    return nextContext;
}
function $655e28ed924d8929$export$2fe409f101064a7f(Component, options) {
    function Field(props) {
        const [fieldProps, context] = (0, $227e5b539bfddd60$export$294aa081a6c6f55d)(props.name, props, options);
        const nextContext = $655e28ed924d8929$var$getNextContext(context, props, options);
        const body = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(Component, Object.assign({}, props, fieldProps));
        // If the context has not changed, then don't render the `Provider`. It's
        // possible that it will change at some point, but it's extremely rare, as
        // either `name` or one of the "state props" has to change.
        if (context === nextContext) return body;
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $3002b2189a02c5b2$export$a078c61943f9dbbe).Provider, {
            children: body,
            value: nextContext
        });
    }
    Field.displayName = `${Component.displayName || Component.name}Field`;
    return Object.assign(Field, {
        Component: Component,
        options: options
    });
}

const $a9d11e51a3949550$var$registered = [];
const $a9d11e51a3949550$var$registeredCache = new Set();
const $a9d11e51a3949550$export$457c3d6518dd4c6f = Object.assign(function filterDOMProps(props) {
    const filteredProps = Object.assign({}, props);
    for(const prop in props)if ($a9d11e51a3949550$var$registeredCache.has(prop)) delete filteredProps[prop];
    return filteredProps;
}, {
    register (...props) {
        props.forEach((prop)=>{
            if (!$a9d11e51a3949550$var$registeredCache.has(prop)) {
                $a9d11e51a3949550$var$registered.push(prop);
                $a9d11e51a3949550$var$registeredCache.add(prop);
            }
        });
        $a9d11e51a3949550$var$registered.sort();
    },
    registered: $a9d11e51a3949550$var$registered
});
$a9d11e51a3949550$export$457c3d6518dd4c6f.register(// These props are provided by useField directly.
"changed", "error", "errorMessage", "field", "fieldType", "fields", "initialCount", "name", "onChange", "transform", "value", // These props are provided by useField through context.state.
"disabled", "label", "placeholder", "showInlineError", // This is used by AutoField.
"component", // These is used by AutoField and bridges.
"allowedValues");


function $eac3cff8184e5e42$var$Bool(_a) {
    var { disabled: disabled, id: id, inputRef: inputRef, label: label, name: name, onChange: onChange, readOnly: readOnly, value: value } = _a, props = (0, $bc7159ecac4d4618$export$3c9a16f847548506)(_a, [
        "disabled",
        "id",
        "inputRef",
        "label",
        "name",
        "onChange",
        "readOnly",
        "value"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", Object.assign({}, (0, $a9d11e51a3949550$export$457c3d6518dd4c6f)(props)), (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("input", {
        checked: value || false,
        disabled: disabled,
        id: id,
        name: name,
        onChange: ()=>!disabled && !readOnly && onChange(!value),
        ref: inputRef,
        type: "checkbox"
    }), label && (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("label", {
        htmlFor: id
    }, label));
}
var $eac3cff8184e5e42$export$2e2bcd8739ae039 = (0, $655e28ed924d8929$export$2fe409f101064a7f)($eac3cff8184e5e42$var$Bool, {
    kind: "leaf"
});




var $cQNHH = parcelRequire("cQNHH");

/* istanbul ignore next */ const $77f60ade0a1392cc$var$DateConstructor = (typeof $parcel$global === "object" ? $parcel$global : window).Date;
const $77f60ade0a1392cc$var$dateFormat = (value, type = "datetime-local")=>value === null || value === void 0 ? void 0 : value.toISOString().slice(0, type === "datetime-local" ? -8 : -14);
function $77f60ade0a1392cc$var$Date(_a) {
    var _b;
    var { disabled: disabled, id: id, inputRef: inputRef, label: label, max: max, min: min, name: name, onChange: onChange, placeholder: placeholder, readOnly: readOnly, value: value, type: type = "datetime-local" } = _a, props = (0, $bc7159ecac4d4618$export$3c9a16f847548506)(_a, [
        "disabled",
        "id",
        "inputRef",
        "label",
        "max",
        "min",
        "name",
        "onChange",
        "placeholder",
        "readOnly",
        "value",
        "type"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", Object.assign({}, (0, $a9d11e51a3949550$export$457c3d6518dd4c6f)(props)), label && (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("label", {
        htmlFor: id
    }, label), (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("input", {
        disabled: disabled,
        id: id,
        max: $77f60ade0a1392cc$var$dateFormat(max),
        min: $77f60ade0a1392cc$var$dateFormat(min),
        name: name,
        onChange: (event)=>{
            const date = new $77f60ade0a1392cc$var$DateConstructor(event.target.valueAsNumber);
            if (date.getFullYear() < 10000) onChange(date);
            else if (isNaN(event.target.valueAsNumber)) onChange(undefined);
        },
        placeholder: placeholder,
        readOnly: readOnly,
        ref: inputRef,
        type: type,
        value: (_b = $77f60ade0a1392cc$var$dateFormat(value, type)) !== null && _b !== void 0 ? _b : ""
    }));
}
var $77f60ade0a1392cc$export$2e2bcd8739ae039 = (0, $655e28ed924d8929$export$2fe409f101064a7f)($77f60ade0a1392cc$var$Date, {
    kind: "leaf"
});




var $cQNHH = parcelRequire("cQNHH");


var $91f6c18aa89ee601$exports = {};
var $f8d808b86d77353d$exports = {};

var $15cd6c1d34a3fa2d$exports = {};
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $15cd6c1d34a3fa2d$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
$15cd6c1d34a3fa2d$exports = $15cd6c1d34a3fa2d$var$arrayEach;


var $56bc97ac634a8894$exports = {};


/** Used for built-in method references. */ var $56bc97ac634a8894$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $56bc97ac634a8894$var$hasOwnProperty = $56bc97ac634a8894$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $56bc97ac634a8894$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($56bc97ac634a8894$var$hasOwnProperty.call(object, key) && $e8399f10b890743c$exports(objValue, value)) || value === undefined && !(key in object)) $5f937d655a715d25$exports(object, key, value);
}
$56bc97ac634a8894$exports = $56bc97ac634a8894$var$assignValue;


var $3109f09833d986d6$exports = {};
var $2d8ef2c9fef9128f$exports = {};


/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $2d8ef2c9fef9128f$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $5f937d655a715d25$exports(object, key, newValue);
        else $56bc97ac634a8894$exports(object, key, newValue);
    }
    return object;
}
$2d8ef2c9fef9128f$exports = $2d8ef2c9fef9128f$var$copyObject;



/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $3109f09833d986d6$var$baseAssign(object, source) {
    return object && $2d8ef2c9fef9128f$exports(source, $df39d715863dea43$exports(source), object);
}
$3109f09833d986d6$exports = $3109f09833d986d6$var$baseAssign;


var $8d0f0cdc803e1695$exports = {};

var $798690d19e6074c0$exports = {};

var $b47c70a9143454e0$exports = {};


var $4e5e36946c9d6c21$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $4e5e36946c9d6c21$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$4e5e36946c9d6c21$exports = $4e5e36946c9d6c21$var$nativeKeysIn;


/** Used for built-in method references. */ var $b47c70a9143454e0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b47c70a9143454e0$var$hasOwnProperty = $b47c70a9143454e0$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $b47c70a9143454e0$var$baseKeysIn(object) {
    if (!$149642e59a27d046$exports(object)) return $4e5e36946c9d6c21$exports(object);
    var isProto = $446c36e04d0ec6ac$exports(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$b47c70a9143454e0$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$b47c70a9143454e0$exports = $b47c70a9143454e0$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $798690d19e6074c0$var$keysIn(object) {
    return $55e5458ff1f44d11$exports(object) ? $ac975ba91d655c37$exports(object, true) : $b47c70a9143454e0$exports(object);
}
$798690d19e6074c0$exports = $798690d19e6074c0$var$keysIn;


/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $8d0f0cdc803e1695$var$baseAssignIn(object, source) {
    return object && $2d8ef2c9fef9128f$exports(source, $798690d19e6074c0$exports(source), object);
}
$8d0f0cdc803e1695$exports = $8d0f0cdc803e1695$var$baseAssignIn;



var $gJKos = parcelRequire("gJKos");
var $00d8c0d3fbdbf9d6$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $00d8c0d3fbdbf9d6$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$00d8c0d3fbdbf9d6$exports = $00d8c0d3fbdbf9d6$var$copyArray;


var $e142fdd5f29d2a11$exports = {};


/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $e142fdd5f29d2a11$var$copySymbols(source, object) {
    return $2d8ef2c9fef9128f$exports(source, $ff650af11a3dd492$exports(source), object);
}
$e142fdd5f29d2a11$exports = $e142fdd5f29d2a11$var$copySymbols;


var $1a31c98e57dad014$exports = {};

var $1f5005babda77dd2$exports = {};

var $43b166a72a056c79$exports = {};

/** Built-in value references. */ var $43b166a72a056c79$var$getPrototype = $70a8acac8570f431$exports(Object.getPrototypeOf, Object);
$43b166a72a056c79$exports = $43b166a72a056c79$var$getPrototype;




/* Built-in method references for those with the same name as other `lodash` methods. */ var $1f5005babda77dd2$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $1f5005babda77dd2$var$getSymbolsIn = !$1f5005babda77dd2$var$nativeGetSymbols ? $27d4fcef3549b74f$exports : function(object) {
    var result = [];
    while(object){
        $a11a0180dd2e1e06$exports(result, $ff650af11a3dd492$exports(object));
        object = $43b166a72a056c79$exports(object);
    }
    return result;
};
$1f5005babda77dd2$exports = $1f5005babda77dd2$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $1a31c98e57dad014$var$copySymbolsIn(source, object) {
    return $2d8ef2c9fef9128f$exports(source, $1f5005babda77dd2$exports(source), object);
}
$1a31c98e57dad014$exports = $1a31c98e57dad014$var$copySymbolsIn;



var $a95345f485882b8f$exports = {};



/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $a95345f485882b8f$var$getAllKeysIn(object) {
    return $506c40cf3d9092b3$exports(object, $798690d19e6074c0$exports, $1f5005babda77dd2$exports);
}
$a95345f485882b8f$exports = $a95345f485882b8f$var$getAllKeysIn;



var $cebad95b53af2af1$exports = {};
/** Used for built-in method references. */ var $cebad95b53af2af1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cebad95b53af2af1$var$hasOwnProperty = $cebad95b53af2af1$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $cebad95b53af2af1$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $cebad95b53af2af1$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
$cebad95b53af2af1$exports = $cebad95b53af2af1$var$initCloneArray;


var $26efa433d34ed09d$exports = {};
var $608d317ce4aba177$exports = {};

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $608d317ce4aba177$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $b63f17d1a8e5040d$exports(result).set(new $b63f17d1a8e5040d$exports(arrayBuffer));
    return result;
}
$608d317ce4aba177$exports = $608d317ce4aba177$var$cloneArrayBuffer;


var $e4143ec9a0ca536b$exports = {};

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $e4143ec9a0ca536b$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $608d317ce4aba177$exports(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
$e4143ec9a0ca536b$exports = $e4143ec9a0ca536b$var$cloneDataView;


var $fe040d5468555871$exports = {};
/** Used to match `RegExp` flags from their coerced string values. */ var $fe040d5468555871$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $fe040d5468555871$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $fe040d5468555871$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
$fe040d5468555871$exports = $fe040d5468555871$var$cloneRegExp;


var $ca6f3e123d3581c4$exports = {};

/** Used to convert symbols to primitives and strings. */ var $ca6f3e123d3581c4$var$symbolProto = $445e6982b2ab4cdb$exports ? $445e6982b2ab4cdb$exports.prototype : undefined, $ca6f3e123d3581c4$var$symbolValueOf = $ca6f3e123d3581c4$var$symbolProto ? $ca6f3e123d3581c4$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $ca6f3e123d3581c4$var$cloneSymbol(symbol) {
    return $ca6f3e123d3581c4$var$symbolValueOf ? Object($ca6f3e123d3581c4$var$symbolValueOf.call(symbol)) : {};
}
$ca6f3e123d3581c4$exports = $ca6f3e123d3581c4$var$cloneSymbol;


var $d23937f7c963b828$exports = {};

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $d23937f7c963b828$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $608d317ce4aba177$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$d23937f7c963b828$exports = $d23937f7c963b828$var$cloneTypedArray;


/** `Object#toString` result references. */ var $26efa433d34ed09d$var$boolTag = "[object Boolean]", $26efa433d34ed09d$var$dateTag = "[object Date]", $26efa433d34ed09d$var$mapTag = "[object Map]", $26efa433d34ed09d$var$numberTag = "[object Number]", $26efa433d34ed09d$var$regexpTag = "[object RegExp]", $26efa433d34ed09d$var$setTag = "[object Set]", $26efa433d34ed09d$var$stringTag = "[object String]", $26efa433d34ed09d$var$symbolTag = "[object Symbol]";
var $26efa433d34ed09d$var$arrayBufferTag = "[object ArrayBuffer]", $26efa433d34ed09d$var$dataViewTag = "[object DataView]", $26efa433d34ed09d$var$float32Tag = "[object Float32Array]", $26efa433d34ed09d$var$float64Tag = "[object Float64Array]", $26efa433d34ed09d$var$int8Tag = "[object Int8Array]", $26efa433d34ed09d$var$int16Tag = "[object Int16Array]", $26efa433d34ed09d$var$int32Tag = "[object Int32Array]", $26efa433d34ed09d$var$uint8Tag = "[object Uint8Array]", $26efa433d34ed09d$var$uint8ClampedTag = "[object Uint8ClampedArray]", $26efa433d34ed09d$var$uint16Tag = "[object Uint16Array]", $26efa433d34ed09d$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $26efa433d34ed09d$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $26efa433d34ed09d$var$arrayBufferTag:
            return $608d317ce4aba177$exports(object);
        case $26efa433d34ed09d$var$boolTag:
        case $26efa433d34ed09d$var$dateTag:
            return new Ctor(+object);
        case $26efa433d34ed09d$var$dataViewTag:
            return $e4143ec9a0ca536b$exports(object, isDeep);
        case $26efa433d34ed09d$var$float32Tag:
        case $26efa433d34ed09d$var$float64Tag:
        case $26efa433d34ed09d$var$int8Tag:
        case $26efa433d34ed09d$var$int16Tag:
        case $26efa433d34ed09d$var$int32Tag:
        case $26efa433d34ed09d$var$uint8Tag:
        case $26efa433d34ed09d$var$uint8ClampedTag:
        case $26efa433d34ed09d$var$uint16Tag:
        case $26efa433d34ed09d$var$uint32Tag:
            return $d23937f7c963b828$exports(object, isDeep);
        case $26efa433d34ed09d$var$mapTag:
            return new Ctor;
        case $26efa433d34ed09d$var$numberTag:
        case $26efa433d34ed09d$var$stringTag:
            return new Ctor(object);
        case $26efa433d34ed09d$var$regexpTag:
            return $fe040d5468555871$exports(object);
        case $26efa433d34ed09d$var$setTag:
            return new Ctor;
        case $26efa433d34ed09d$var$symbolTag:
            return $ca6f3e123d3581c4$exports(object);
    }
}
$26efa433d34ed09d$exports = $26efa433d34ed09d$var$initCloneByTag;


var $26fa4eb409035a56$exports = {};
var $5877dada355f9fb9$exports = {};

/** Built-in value references. */ var $5877dada355f9fb9$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $5877dada355f9fb9$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$149642e59a27d046$exports(proto)) return {};
        if ($5877dada355f9fb9$var$objectCreate) return $5877dada355f9fb9$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$5877dada355f9fb9$exports = $5877dada355f9fb9$var$baseCreate;




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $26fa4eb409035a56$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$446c36e04d0ec6ac$exports(object) ? $5877dada355f9fb9$exports($43b166a72a056c79$exports(object)) : {};
}
$26fa4eb409035a56$exports = $26fa4eb409035a56$var$initCloneObject;




var $kGntY = parcelRequire("kGntY");
var $a9df28233ecc9400$exports = {};
var $1560cae5907f7835$exports = {};


/** `Object#toString` result references. */ var $1560cae5907f7835$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $1560cae5907f7835$var$baseIsMap(value) {
    return $1e04b4bf2bb5d0fe$exports(value) && $438326f3e5863d71$exports(value) == $1560cae5907f7835$var$mapTag;
}
$1560cae5907f7835$exports = $1560cae5907f7835$var$baseIsMap;




var $4Nl3a = parcelRequire("4Nl3a");
/* Node.js helper references. */ var $a9df28233ecc9400$var$nodeIsMap = $4Nl3a && $4Nl3a.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $a9df28233ecc9400$var$isMap = $a9df28233ecc9400$var$nodeIsMap ? $a651a5d22085d60e$exports($a9df28233ecc9400$var$nodeIsMap) : $1560cae5907f7835$exports;
$a9df28233ecc9400$exports = $a9df28233ecc9400$var$isMap;



var $6e717a4e4730018c$exports = {};
var $c449dfd54d3016a9$exports = {};


/** `Object#toString` result references. */ var $c449dfd54d3016a9$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $c449dfd54d3016a9$var$baseIsSet(value) {
    return $1e04b4bf2bb5d0fe$exports(value) && $438326f3e5863d71$exports(value) == $c449dfd54d3016a9$var$setTag;
}
$c449dfd54d3016a9$exports = $c449dfd54d3016a9$var$baseIsSet;




var $4Nl3a = parcelRequire("4Nl3a");
/* Node.js helper references. */ var $6e717a4e4730018c$var$nodeIsSet = $4Nl3a && $4Nl3a.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $6e717a4e4730018c$var$isSet = $6e717a4e4730018c$var$nodeIsSet ? $a651a5d22085d60e$exports($6e717a4e4730018c$var$nodeIsSet) : $c449dfd54d3016a9$exports;
$6e717a4e4730018c$exports = $6e717a4e4730018c$var$isSet;




/** Used to compose bitmasks for cloning. */ var $f8d808b86d77353d$var$CLONE_DEEP_FLAG = 1, $f8d808b86d77353d$var$CLONE_FLAT_FLAG = 2, $f8d808b86d77353d$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $f8d808b86d77353d$var$argsTag = "[object Arguments]", $f8d808b86d77353d$var$arrayTag = "[object Array]", $f8d808b86d77353d$var$boolTag = "[object Boolean]", $f8d808b86d77353d$var$dateTag = "[object Date]", $f8d808b86d77353d$var$errorTag = "[object Error]", $f8d808b86d77353d$var$funcTag = "[object Function]", $f8d808b86d77353d$var$genTag = "[object GeneratorFunction]", $f8d808b86d77353d$var$mapTag = "[object Map]", $f8d808b86d77353d$var$numberTag = "[object Number]", $f8d808b86d77353d$var$objectTag = "[object Object]", $f8d808b86d77353d$var$regexpTag = "[object RegExp]", $f8d808b86d77353d$var$setTag = "[object Set]", $f8d808b86d77353d$var$stringTag = "[object String]", $f8d808b86d77353d$var$symbolTag = "[object Symbol]", $f8d808b86d77353d$var$weakMapTag = "[object WeakMap]";
var $f8d808b86d77353d$var$arrayBufferTag = "[object ArrayBuffer]", $f8d808b86d77353d$var$dataViewTag = "[object DataView]", $f8d808b86d77353d$var$float32Tag = "[object Float32Array]", $f8d808b86d77353d$var$float64Tag = "[object Float64Array]", $f8d808b86d77353d$var$int8Tag = "[object Int8Array]", $f8d808b86d77353d$var$int16Tag = "[object Int16Array]", $f8d808b86d77353d$var$int32Tag = "[object Int32Array]", $f8d808b86d77353d$var$uint8Tag = "[object Uint8Array]", $f8d808b86d77353d$var$uint8ClampedTag = "[object Uint8ClampedArray]", $f8d808b86d77353d$var$uint16Tag = "[object Uint16Array]", $f8d808b86d77353d$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $f8d808b86d77353d$var$cloneableTags = {};
$f8d808b86d77353d$var$cloneableTags[$f8d808b86d77353d$var$argsTag] = $f8d808b86d77353d$var$cloneableTags[$f8d808b86d77353d$var$arrayTag] = $f8d808b86d77353d$var$cloneableTags[$f8d808b86d77353d$var$arrayBufferTag] = $f8d808b86d77353d$var$cloneableTags[$f8d808b86d77353d$var$dataViewTag] = $f8d808b86d77353d$var$cloneableTags[$f8d808b86d77353d$var$boolTag] = $f8d808b86d77353d$var$cloneableTags[$f8d808b86d77353d$var$dateTag] = $f8d808b86d77353d$var$cloneableTags[$f8d808b86d77353d$var$float32Tag] = $f8d808b86d77353d$var$cloneableTags[$f8d808b86d77353d$var$float64Tag] = $f8d808b86d77353d$var$cloneableTags[$f8d808b86d77353d$var$int8Tag] = $f8d808b86d77353d$var$cloneableTags[$f8d808b86d77353d$var$int16Tag] = $f8d808b86d77353d$var$cloneableTags[$f8d808b86d77353d$var$int32Tag] = $f8d808b86d77353d$var$cloneableTags[$f8d808b86d77353d$var$mapTag] = $f8d808b86d77353d$var$cloneableTags[$f8d808b86d77353d$var$numberTag] = $f8d808b86d77353d$var$cloneableTags[$f8d808b86d77353d$var$objectTag] = $f8d808b86d77353d$var$cloneableTags[$f8d808b86d77353d$var$regexpTag] = $f8d808b86d77353d$var$cloneableTags[$f8d808b86d77353d$var$setTag] = $f8d808b86d77353d$var$cloneableTags[$f8d808b86d77353d$var$stringTag] = $f8d808b86d77353d$var$cloneableTags[$f8d808b86d77353d$var$symbolTag] = $f8d808b86d77353d$var$cloneableTags[$f8d808b86d77353d$var$uint8Tag] = $f8d808b86d77353d$var$cloneableTags[$f8d808b86d77353d$var$uint8ClampedTag] = $f8d808b86d77353d$var$cloneableTags[$f8d808b86d77353d$var$uint16Tag] = $f8d808b86d77353d$var$cloneableTags[$f8d808b86d77353d$var$uint32Tag] = true;
$f8d808b86d77353d$var$cloneableTags[$f8d808b86d77353d$var$errorTag] = $f8d808b86d77353d$var$cloneableTags[$f8d808b86d77353d$var$funcTag] = $f8d808b86d77353d$var$cloneableTags[$f8d808b86d77353d$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $f8d808b86d77353d$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $f8d808b86d77353d$var$CLONE_DEEP_FLAG, isFlat = bitmask & $f8d808b86d77353d$var$CLONE_FLAT_FLAG, isFull = bitmask & $f8d808b86d77353d$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$149642e59a27d046$exports(value)) return value;
    var isArr = $907546b303adca65$exports(value);
    if (isArr) {
        result = $cebad95b53af2af1$exports(value);
        if (!isDeep) return $00d8c0d3fbdbf9d6$exports(value, result);
    } else {
        var tag = $438326f3e5863d71$exports(value), isFunc = tag == $f8d808b86d77353d$var$funcTag || tag == $f8d808b86d77353d$var$genTag;
        if ($kGntY(value)) return $gJKos(value, isDeep);
        if (tag == $f8d808b86d77353d$var$objectTag || tag == $f8d808b86d77353d$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $26fa4eb409035a56$exports(value);
            if (!isDeep) return isFlat ? $1a31c98e57dad014$exports(value, $8d0f0cdc803e1695$exports(result, value)) : $e142fdd5f29d2a11$exports(value, $3109f09833d986d6$exports(result, value));
        } else {
            if (!$f8d808b86d77353d$var$cloneableTags[tag]) return object ? value : {};
            result = $26efa433d34ed09d$exports(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $9d73163477354d5c$exports);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($6e717a4e4730018c$exports(value)) value.forEach(function(subValue) {
        result.add($f8d808b86d77353d$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($a9df28233ecc9400$exports(value)) value.forEach(function(subValue, key) {
        result.set(key, $f8d808b86d77353d$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $a95345f485882b8f$exports : $cd713587626b384f$exports : isFlat ? $798690d19e6074c0$exports : $df39d715863dea43$exports;
    var props = isArr ? undefined : keysFunc(value);
    $15cd6c1d34a3fa2d$exports(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $56bc97ac634a8894$exports(result, key, $f8d808b86d77353d$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
$f8d808b86d77353d$exports = $f8d808b86d77353d$var$baseClone;


/** Used to compose bitmasks for cloning. */ var $91f6c18aa89ee601$var$CLONE_DEEP_FLAG = 1, $91f6c18aa89ee601$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $91f6c18aa89ee601$var$cloneDeep(value) {
    return $f8d808b86d77353d$exports(value, $91f6c18aa89ee601$var$CLONE_DEEP_FLAG | $91f6c18aa89ee601$var$CLONE_SYMBOLS_FLAG);
}
$91f6c18aa89ee601$exports = $91f6c18aa89ee601$var$cloneDeep;



var $cQNHH = parcelRequire("cQNHH");

function $5b706d8c9d7540e7$var$ListAdd(_a) {
    var { disabled: disabled, initialCount: initialCount, name: name, readOnly: readOnly, value: value } = _a, props = (0, $bc7159ecac4d4618$export$3c9a16f847548506)(_a, [
        "disabled",
        "initialCount",
        "name",
        "readOnly",
        "value"
    ]);
    const nameParts = (0, $cf50d698743ef582$export$c8987bb64f9a8b89)(null, name);
    const parentName = (0, $cf50d698743ef582$export$c8987bb64f9a8b89)(nameParts.slice(0, -1));
    const parent = (0, $227e5b539bfddd60$export$294aa081a6c6f55d)(parentName, {
        initialCount: initialCount
    }, {
        absoluteName: true
    })[0];
    const limitNotReached = !disabled && !(parent.maxCount <= parent.value.length);
    function onAction(event) {
        if (limitNotReached && !readOnly && (!("key" in event) || event.key === "Enter")) parent.onChange(parent.value.concat([
            (0, (/*@__PURE__*/$parcel$interopDefault($91f6c18aa89ee601$exports)))(value)
        ]));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", Object.assign({}, (0, $a9d11e51a3949550$export$457c3d6518dd4c6f)(props), {
        onClick: onAction,
        onKeyDown: onAction,
        role: "button",
        tabIndex: 0
    }), "+");
}
var $5b706d8c9d7540e7$export$2e2bcd8739ae039 = (0, $655e28ed924d8929$export$2fe409f101064a7f)($5b706d8c9d7540e7$var$ListAdd, {
    initialValue: false,
    kind: "leaf"
});



var $cQNHH = parcelRequire("cQNHH");




var $cQNHH = parcelRequire("cQNHH");

function $5533ce9cf25f7fa9$var$ListDel(_a) {
    var { disabled: disabled, name: name, readOnly: readOnly } = _a, props = (0, $bc7159ecac4d4618$export$3c9a16f847548506)(_a, [
        "disabled",
        "name",
        "readOnly"
    ]);
    const nameParts = (0, $cf50d698743ef582$export$c8987bb64f9a8b89)(null, name);
    const nameIndex = +nameParts[nameParts.length - 1];
    const parentName = (0, $cf50d698743ef582$export$c8987bb64f9a8b89)(nameParts.slice(0, -1));
    const parent = (0, $227e5b539bfddd60$export$294aa081a6c6f55d)(parentName, {}, {
        absoluteName: true
    })[0];
    const limitNotReached = !disabled && !(parent.minCount >= parent.value.length);
    function onAction(event) {
        if (limitNotReached && !readOnly && (!("key" in event) || event.key === "Enter")) {
            const value = parent.value.slice();
            value.splice(nameIndex, 1);
            parent.onChange(value);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", Object.assign({}, (0, $a9d11e51a3949550$export$457c3d6518dd4c6f)(props), {
        onClick: onAction,
        onKeyDown: onAction,
        role: "button",
        tabIndex: 0
    }), "-");
}
var $5533ce9cf25f7fa9$export$2e2bcd8739ae039 = (0, $655e28ed924d8929$export$2fe409f101064a7f)($5533ce9cf25f7fa9$var$ListDel, {
    initialValue: false,
    kind: "leaf"
});


function $86b86fae2d672d89$var$ListItem({ children: children = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $91261836a34cd3bb$export$2e2bcd8739ae039), {
    label: null,
    name: ""
}) }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $5533ce9cf25f7fa9$export$2e2bcd8739ae039), {
        name: ""
    }), children);
}
var $86b86fae2d672d89$export$2e2bcd8739ae039 = (0, $655e28ed924d8929$export$2fe409f101064a7f)($86b86fae2d672d89$var$ListItem, {
    initialValue: false
});


function $1b000dd22449267b$var$List(_a) {
    var { children: children = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $86b86fae2d672d89$export$2e2bcd8739ae039), {
        name: "$"
    }), initialCount: initialCount, itemProps: itemProps, label: label, value: value } = _a, props = (0, $bc7159ecac4d4618$export$3c9a16f847548506)(_a, [
        "children",
        "initialCount",
        "itemProps",
        "label",
        "value"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ul", Object.assign({}, (0, $a9d11e51a3949550$export$457c3d6518dd4c6f)(props)), label && (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("label", null, label, (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $5b706d8c9d7540e7$export$2e2bcd8739ae039), {
        initialCount: initialCount,
        name: "$"
    })), value === null || value === void 0 ? void 0 : value.map((item, itemIndex)=>(0, $cQNHH.Children).map(children, (child, childIndex)=>{
            var _a;
            return (0, $cQNHH.isValidElement)(child) ? (0, $cQNHH.cloneElement)(child, Object.assign({
                key: `${itemIndex}-${childIndex}`,
                name: (_a = child.props.name) === null || _a === void 0 ? void 0 : _a.replace("$", "" + itemIndex)
            }, itemProps)) : child;
        })));
}
var $1b000dd22449267b$export$2e2bcd8739ae039 = (0, $655e28ed924d8929$export$2fe409f101064a7f)($1b000dd22449267b$var$List);




var $cQNHH = parcelRequire("cQNHH");


function $ec1631cf77f6b99a$var$Nest(_a) {
    var { children: children, fields: fields, itemProps: itemProps, label: label } = _a, props = (0, $bc7159ecac4d4618$export$3c9a16f847548506)(_a, [
        "children",
        "fields",
        "itemProps",
        "label"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", Object.assign({}, (0, $a9d11e51a3949550$export$457c3d6518dd4c6f)(props)), label && (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("label", null, label), children || fields.map((field)=>(0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $91261836a34cd3bb$export$2e2bcd8739ae039), Object.assign({
            key: field,
            name: field
        }, itemProps))));
}
var $ec1631cf77f6b99a$export$2e2bcd8739ae039 = (0, $655e28ed924d8929$export$2fe409f101064a7f)($ec1631cf77f6b99a$var$Nest);




var $cQNHH = parcelRequire("cQNHH");

function $044185b12414e69b$var$Num(_a) {
    var { decimal: decimal, disabled: disabled, id: id, inputRef: inputRef, label: label, max: max, min: min, name: name, onChange: onChange, placeholder: placeholder, readOnly: readOnly, step: step, value: value } = _a, props = (0, $bc7159ecac4d4618$export$3c9a16f847548506)(_a, [
        "decimal",
        "disabled",
        "id",
        "inputRef",
        "label",
        "max",
        "min",
        "name",
        "onChange",
        "placeholder",
        "readOnly",
        "step",
        "value"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", Object.assign({}, (0, $a9d11e51a3949550$export$457c3d6518dd4c6f)(props)), label && (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("label", {
        htmlFor: id
    }, label), (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("input", {
        disabled: disabled,
        id: id,
        max: max,
        min: min,
        name: name,
        onChange: (event)=>{
            const parse = decimal ? parseFloat : parseInt;
            const value = parse(event.target.value);
            onChange(isNaN(value) ? undefined : value);
        },
        placeholder: placeholder,
        readOnly: readOnly,
        ref: inputRef,
        step: step || (decimal ? 0.01 : 1),
        type: "number",
        value: value !== null && value !== void 0 ? value : ""
    }));
}
var $044185b12414e69b$export$2e2bcd8739ae039 = (0, $655e28ed924d8929$export$2fe409f101064a7f)($044185b12414e69b$var$Num, {
    kind: "leaf"
});



var $944cdbbf765af890$exports = {};


var $b71255abfb9fde81$exports = {};

var $924f9ddb7a57c4a6$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $924f9ddb7a57c4a6$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$924f9ddb7a57c4a6$exports = $924f9ddb7a57c4a6$var$last;


var $4844fc8ac463bf32$exports = {};

var $3919c6f9330175f8$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $3919c6f9330175f8$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$3919c6f9330175f8$exports = $3919c6f9330175f8$var$baseSlice;


/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $4844fc8ac463bf32$var$parent(object, path) {
    return path.length < 2 ? object : $382452d79d8c383d$exports(object, $3919c6f9330175f8$exports(path, 0, -1));
}
$4844fc8ac463bf32$exports = $4844fc8ac463bf32$var$parent;



/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $b71255abfb9fde81$var$baseUnset(object, path) {
    path = $26be98534887ebf0$exports(path, object);
    object = $4844fc8ac463bf32$exports(object, path);
    return object == null || delete object[$18a4d69693757e11$exports($924f9ddb7a57c4a6$exports(path))];
}
$b71255abfb9fde81$exports = $b71255abfb9fde81$var$baseUnset;




var $1eafa0ce75a149d7$exports = {};
var $05c96df1af1b04c6$exports = {};



/** `Object#toString` result references. */ var $05c96df1af1b04c6$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $05c96df1af1b04c6$var$funcProto = Function.prototype, $05c96df1af1b04c6$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $05c96df1af1b04c6$var$funcToString = $05c96df1af1b04c6$var$funcProto.toString;
/** Used to check objects for own properties. */ var $05c96df1af1b04c6$var$hasOwnProperty = $05c96df1af1b04c6$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $05c96df1af1b04c6$var$objectCtorString = $05c96df1af1b04c6$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $05c96df1af1b04c6$var$isPlainObject(value) {
    if (!$1e04b4bf2bb5d0fe$exports(value) || $5ea36cd4db8c52be$exports(value) != $05c96df1af1b04c6$var$objectTag) return false;
    var proto = $43b166a72a056c79$exports(value);
    if (proto === null) return true;
    var Ctor = $05c96df1af1b04c6$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $05c96df1af1b04c6$var$funcToString.call(Ctor) == $05c96df1af1b04c6$var$objectCtorString;
}
$05c96df1af1b04c6$exports = $05c96df1af1b04c6$var$isPlainObject;


/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $1eafa0ce75a149d7$var$customOmitClone(value) {
    return $05c96df1af1b04c6$exports(value) ? undefined : value;
}
$1eafa0ce75a149d7$exports = $1eafa0ce75a149d7$var$customOmitClone;


var $88c96ce4a7e97eb1$exports = {};
var $fe53e8a8c8d1f2d5$exports = {};
var $f9e1c02c637af82d$exports = {};

var $03279a02eba0965e$exports = {};



/** Built-in value references. */ var $03279a02eba0965e$var$spreadableSymbol = $445e6982b2ab4cdb$exports ? $445e6982b2ab4cdb$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $03279a02eba0965e$var$isFlattenable(value) {
    return $907546b303adca65$exports(value) || $b2e5bee79b98c26f$exports(value) || !!($03279a02eba0965e$var$spreadableSymbol && value && value[$03279a02eba0965e$var$spreadableSymbol]);
}
$03279a02eba0965e$exports = $03279a02eba0965e$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $f9e1c02c637af82d$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $03279a02eba0965e$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $f9e1c02c637af82d$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $a11a0180dd2e1e06$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$f9e1c02c637af82d$exports = $f9e1c02c637af82d$var$baseFlatten;


/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $fe53e8a8c8d1f2d5$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $f9e1c02c637af82d$exports(array, 1) : [];
}
$fe53e8a8c8d1f2d5$exports = $fe53e8a8c8d1f2d5$var$flatten;


var $bb6d628fedb75c45$exports = {};
var $3b5d7ad8a743684c$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $3b5d7ad8a743684c$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$3b5d7ad8a743684c$exports = $3b5d7ad8a743684c$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $bb6d628fedb75c45$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $bb6d628fedb75c45$var$overRest(func, start, transform) {
    start = $bb6d628fedb75c45$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $bb6d628fedb75c45$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $3b5d7ad8a743684c$exports(func, this, otherArgs);
    };
}
$bb6d628fedb75c45$exports = $bb6d628fedb75c45$var$overRest;


var $325c84255efacc77$exports = {};
var $82ba83192e1574d5$exports = {};
var $f532dfa85b6f2640$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $f532dfa85b6f2640$var$constant(value) {
    return function() {
        return value;
    };
}
$f532dfa85b6f2640$exports = $f532dfa85b6f2640$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $82ba83192e1574d5$var$baseSetToString = !$d5fccfe3d6eef89d$exports ? $245bbf0693bc803c$exports : function(func, string) {
    return $d5fccfe3d6eef89d$exports(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $f532dfa85b6f2640$exports(string),
        "writable": true
    });
};
$82ba83192e1574d5$exports = $82ba83192e1574d5$var$baseSetToString;


var $81481a3492fa0c3f$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $81481a3492fa0c3f$var$HOT_COUNT = 800, $81481a3492fa0c3f$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $81481a3492fa0c3f$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $81481a3492fa0c3f$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $81481a3492fa0c3f$var$nativeNow(), remaining = $81481a3492fa0c3f$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $81481a3492fa0c3f$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$81481a3492fa0c3f$exports = $81481a3492fa0c3f$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $325c84255efacc77$var$setToString = $81481a3492fa0c3f$exports($82ba83192e1574d5$exports);
$325c84255efacc77$exports = $325c84255efacc77$var$setToString;


/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $88c96ce4a7e97eb1$var$flatRest(func) {
    return $325c84255efacc77$exports($bb6d628fedb75c45$exports(func, undefined, $fe53e8a8c8d1f2d5$exports), func + "");
}
$88c96ce4a7e97eb1$exports = $88c96ce4a7e97eb1$var$flatRest;



/** Used to compose bitmasks for cloning. */ var $944cdbbf765af890$var$CLONE_DEEP_FLAG = 1, $944cdbbf765af890$var$CLONE_FLAT_FLAG = 2, $944cdbbf765af890$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $944cdbbf765af890$var$omit = $88c96ce4a7e97eb1$exports(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $705c9649d4ad8bbf$exports(paths, function(path) {
        path = $26be98534887ebf0$exports(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $2d8ef2c9fef9128f$exports(object, $a95345f485882b8f$exports(object), result);
    if (isDeep) result = $f8d808b86d77353d$exports(result, $944cdbbf765af890$var$CLONE_DEEP_FLAG | $944cdbbf765af890$var$CLONE_FLAT_FLAG | $944cdbbf765af890$var$CLONE_SYMBOLS_FLAG, $1eafa0ce75a149d7$exports);
    var length = paths.length;
    while(length--)$b71255abfb9fde81$exports(result, paths[length]);
    return result;
});
$944cdbbf765af890$exports = $944cdbbf765af890$var$omit;



var $cQNHH = parcelRequire("cQNHH");

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $46f4e6f775f39bcc$export$a143d493d941bafc;
var $46f4e6f775f39bcc$export$e4cf37d7f6fb9e0a;
var $46f4e6f775f39bcc$export$f99ded8fe4b79145;
var $46f4e6f775f39bcc$export$599f31c3813fae4d;
"use strict";
var $9c5d6f32ba272209$export$a48f0734ac7c2329;
var $9c5d6f32ba272209$export$d622b2ad8d90c771;
var $9c5d6f32ba272209$export$6100ba28696e12de;
"use strict";
$9c5d6f32ba272209$export$a48f0734ac7c2329 = $9c5d6f32ba272209$var$byteLength;
$9c5d6f32ba272209$export$d622b2ad8d90c771 = $9c5d6f32ba272209$var$toByteArray;
$9c5d6f32ba272209$export$6100ba28696e12de = $9c5d6f32ba272209$var$fromByteArray;
var $9c5d6f32ba272209$var$lookup = [];
var $9c5d6f32ba272209$var$revLookup = [];
var $9c5d6f32ba272209$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $9c5d6f32ba272209$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $9c5d6f32ba272209$var$i = 0, $9c5d6f32ba272209$var$len = $9c5d6f32ba272209$var$code.length; $9c5d6f32ba272209$var$i < $9c5d6f32ba272209$var$len; ++$9c5d6f32ba272209$var$i){
    $9c5d6f32ba272209$var$lookup[$9c5d6f32ba272209$var$i] = $9c5d6f32ba272209$var$code[$9c5d6f32ba272209$var$i];
    $9c5d6f32ba272209$var$revLookup[$9c5d6f32ba272209$var$code.charCodeAt($9c5d6f32ba272209$var$i)] = $9c5d6f32ba272209$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$9c5d6f32ba272209$var$revLookup["-".charCodeAt(0)] = 62;
$9c5d6f32ba272209$var$revLookup["_".charCodeAt(0)] = 63;
function $9c5d6f32ba272209$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $9c5d6f32ba272209$var$byteLength(b64) {
    var lens = $9c5d6f32ba272209$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $9c5d6f32ba272209$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $9c5d6f32ba272209$var$toByteArray(b64) {
    var tmp;
    var lens = $9c5d6f32ba272209$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $9c5d6f32ba272209$var$Arr($9c5d6f32ba272209$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $9c5d6f32ba272209$var$revLookup[b64.charCodeAt(i)] << 18 | $9c5d6f32ba272209$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $9c5d6f32ba272209$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $9c5d6f32ba272209$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $9c5d6f32ba272209$var$revLookup[b64.charCodeAt(i)] << 2 | $9c5d6f32ba272209$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $9c5d6f32ba272209$var$revLookup[b64.charCodeAt(i)] << 10 | $9c5d6f32ba272209$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $9c5d6f32ba272209$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $9c5d6f32ba272209$var$tripletToBase64(num) {
    return $9c5d6f32ba272209$var$lookup[num >> 18 & 0x3F] + $9c5d6f32ba272209$var$lookup[num >> 12 & 0x3F] + $9c5d6f32ba272209$var$lookup[num >> 6 & 0x3F] + $9c5d6f32ba272209$var$lookup[num & 0x3F];
}
function $9c5d6f32ba272209$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($9c5d6f32ba272209$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $9c5d6f32ba272209$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($9c5d6f32ba272209$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($9c5d6f32ba272209$var$lookup[tmp >> 2] + $9c5d6f32ba272209$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($9c5d6f32ba272209$var$lookup[tmp >> 10] + $9c5d6f32ba272209$var$lookup[tmp >> 4 & 0x3F] + $9c5d6f32ba272209$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $42ae557cc21e89b5$export$aafa59e2e03f2942;
var $42ae557cc21e89b5$export$68d8715fc104d294;
$42ae557cc21e89b5$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$42ae557cc21e89b5$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $46f4e6f775f39bcc$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$46f4e6f775f39bcc$export$a143d493d941bafc = $46f4e6f775f39bcc$var$Buffer;
$46f4e6f775f39bcc$export$e4cf37d7f6fb9e0a = $46f4e6f775f39bcc$var$SlowBuffer;
$46f4e6f775f39bcc$export$f99ded8fe4b79145 = 50;
const $46f4e6f775f39bcc$var$K_MAX_LENGTH = 0x7fffffff;
$46f4e6f775f39bcc$export$599f31c3813fae4d = $46f4e6f775f39bcc$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $46f4e6f775f39bcc$var$Buffer.TYPED_ARRAY_SUPPORT = $46f4e6f775f39bcc$var$typedArraySupport();
if (!$46f4e6f775f39bcc$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $46f4e6f775f39bcc$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($46f4e6f775f39bcc$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$46f4e6f775f39bcc$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($46f4e6f775f39bcc$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$46f4e6f775f39bcc$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $46f4e6f775f39bcc$var$createBuffer(length) {
    if (length > $46f4e6f775f39bcc$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $46f4e6f775f39bcc$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $46f4e6f775f39bcc$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $46f4e6f775f39bcc$var$allocUnsafe(arg);
    }
    return $46f4e6f775f39bcc$var$from(arg, encodingOrOffset, length);
}
$46f4e6f775f39bcc$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $46f4e6f775f39bcc$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $46f4e6f775f39bcc$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $46f4e6f775f39bcc$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($46f4e6f775f39bcc$var$isInstance(value, ArrayBuffer) || value && $46f4e6f775f39bcc$var$isInstance(value.buffer, ArrayBuffer)) return $46f4e6f775f39bcc$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($46f4e6f775f39bcc$var$isInstance(value, SharedArrayBuffer) || value && $46f4e6f775f39bcc$var$isInstance(value.buffer, SharedArrayBuffer))) return $46f4e6f775f39bcc$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $46f4e6f775f39bcc$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $46f4e6f775f39bcc$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $46f4e6f775f39bcc$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $46f4e6f775f39bcc$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $46f4e6f775f39bcc$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($46f4e6f775f39bcc$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($46f4e6f775f39bcc$var$Buffer, Uint8Array);
function $46f4e6f775f39bcc$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $46f4e6f775f39bcc$var$alloc(size, fill, encoding) {
    $46f4e6f775f39bcc$var$assertSize(size);
    if (size <= 0) return $46f4e6f775f39bcc$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $46f4e6f775f39bcc$var$createBuffer(size).fill(fill, encoding) : $46f4e6f775f39bcc$var$createBuffer(size).fill(fill);
    return $46f4e6f775f39bcc$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $46f4e6f775f39bcc$var$Buffer.alloc = function(size, fill, encoding) {
    return $46f4e6f775f39bcc$var$alloc(size, fill, encoding);
};
function $46f4e6f775f39bcc$var$allocUnsafe(size) {
    $46f4e6f775f39bcc$var$assertSize(size);
    return $46f4e6f775f39bcc$var$createBuffer(size < 0 ? 0 : $46f4e6f775f39bcc$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $46f4e6f775f39bcc$var$Buffer.allocUnsafe = function(size) {
    return $46f4e6f775f39bcc$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $46f4e6f775f39bcc$var$Buffer.allocUnsafeSlow = function(size) {
    return $46f4e6f775f39bcc$var$allocUnsafe(size);
};
function $46f4e6f775f39bcc$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$46f4e6f775f39bcc$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $46f4e6f775f39bcc$var$byteLength(string, encoding) | 0;
    let buf = $46f4e6f775f39bcc$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $46f4e6f775f39bcc$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $46f4e6f775f39bcc$var$checked(array.length) | 0;
    const buf = $46f4e6f775f39bcc$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $46f4e6f775f39bcc$var$fromArrayView(arrayView) {
    if ($46f4e6f775f39bcc$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $46f4e6f775f39bcc$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $46f4e6f775f39bcc$var$fromArrayLike(arrayView);
}
function $46f4e6f775f39bcc$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $46f4e6f775f39bcc$var$Buffer.prototype);
    return buf;
}
function $46f4e6f775f39bcc$var$fromObject(obj) {
    if ($46f4e6f775f39bcc$var$Buffer.isBuffer(obj)) {
        const len = $46f4e6f775f39bcc$var$checked(obj.length) | 0;
        const buf = $46f4e6f775f39bcc$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $46f4e6f775f39bcc$var$numberIsNaN(obj.length)) return $46f4e6f775f39bcc$var$createBuffer(0);
        return $46f4e6f775f39bcc$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $46f4e6f775f39bcc$var$fromArrayLike(obj.data);
}
function $46f4e6f775f39bcc$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $46f4e6f775f39bcc$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $46f4e6f775f39bcc$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $46f4e6f775f39bcc$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $46f4e6f775f39bcc$var$Buffer.alloc(+length);
}
$46f4e6f775f39bcc$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $46f4e6f775f39bcc$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$46f4e6f775f39bcc$var$Buffer.compare = function compare(a, b) {
    if ($46f4e6f775f39bcc$var$isInstance(a, Uint8Array)) a = $46f4e6f775f39bcc$var$Buffer.from(a, a.offset, a.byteLength);
    if ($46f4e6f775f39bcc$var$isInstance(b, Uint8Array)) b = $46f4e6f775f39bcc$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$46f4e6f775f39bcc$var$Buffer.isBuffer(a) || !$46f4e6f775f39bcc$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$46f4e6f775f39bcc$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$46f4e6f775f39bcc$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $46f4e6f775f39bcc$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $46f4e6f775f39bcc$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($46f4e6f775f39bcc$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$46f4e6f775f39bcc$var$Buffer.isBuffer(buf)) buf = $46f4e6f775f39bcc$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$46f4e6f775f39bcc$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $46f4e6f775f39bcc$var$byteLength(string, encoding) {
    if ($46f4e6f775f39bcc$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $46f4e6f775f39bcc$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $46f4e6f775f39bcc$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $46f4e6f775f39bcc$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $46f4e6f775f39bcc$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$46f4e6f775f39bcc$var$Buffer.byteLength = $46f4e6f775f39bcc$var$byteLength;
function $46f4e6f775f39bcc$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $46f4e6f775f39bcc$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $46f4e6f775f39bcc$var$utf8Slice(this, start, end);
        case "ascii":
            return $46f4e6f775f39bcc$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $46f4e6f775f39bcc$var$latin1Slice(this, start, end);
        case "base64":
            return $46f4e6f775f39bcc$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $46f4e6f775f39bcc$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$46f4e6f775f39bcc$var$Buffer.prototype._isBuffer = true;
function $46f4e6f775f39bcc$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$46f4e6f775f39bcc$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$46f4e6f775f39bcc$var$swap(this, i, i + 1);
    return this;
};
$46f4e6f775f39bcc$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $46f4e6f775f39bcc$var$swap(this, i, i + 3);
        $46f4e6f775f39bcc$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$46f4e6f775f39bcc$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $46f4e6f775f39bcc$var$swap(this, i, i + 7);
        $46f4e6f775f39bcc$var$swap(this, i + 1, i + 6);
        $46f4e6f775f39bcc$var$swap(this, i + 2, i + 5);
        $46f4e6f775f39bcc$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$46f4e6f775f39bcc$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $46f4e6f775f39bcc$var$utf8Slice(this, 0, length);
    return $46f4e6f775f39bcc$var$slowToString.apply(this, arguments);
};
$46f4e6f775f39bcc$var$Buffer.prototype.toLocaleString = $46f4e6f775f39bcc$var$Buffer.prototype.toString;
$46f4e6f775f39bcc$var$Buffer.prototype.equals = function equals(b) {
    if (!$46f4e6f775f39bcc$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $46f4e6f775f39bcc$var$Buffer.compare(this, b) === 0;
};
$46f4e6f775f39bcc$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $46f4e6f775f39bcc$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($46f4e6f775f39bcc$var$customInspectSymbol) $46f4e6f775f39bcc$var$Buffer.prototype[$46f4e6f775f39bcc$var$customInspectSymbol] = $46f4e6f775f39bcc$var$Buffer.prototype.inspect;
$46f4e6f775f39bcc$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($46f4e6f775f39bcc$var$isInstance(target, Uint8Array)) target = $46f4e6f775f39bcc$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$46f4e6f775f39bcc$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $46f4e6f775f39bcc$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($46f4e6f775f39bcc$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $46f4e6f775f39bcc$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($46f4e6f775f39bcc$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $46f4e6f775f39bcc$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $46f4e6f775f39bcc$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $46f4e6f775f39bcc$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$46f4e6f775f39bcc$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$46f4e6f775f39bcc$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $46f4e6f775f39bcc$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$46f4e6f775f39bcc$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $46f4e6f775f39bcc$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $46f4e6f775f39bcc$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($46f4e6f775f39bcc$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $46f4e6f775f39bcc$var$utf8Write(buf, string, offset, length) {
    return $46f4e6f775f39bcc$var$blitBuffer($46f4e6f775f39bcc$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $46f4e6f775f39bcc$var$asciiWrite(buf, string, offset, length) {
    return $46f4e6f775f39bcc$var$blitBuffer($46f4e6f775f39bcc$var$asciiToBytes(string), buf, offset, length);
}
function $46f4e6f775f39bcc$var$base64Write(buf, string, offset, length) {
    return $46f4e6f775f39bcc$var$blitBuffer($46f4e6f775f39bcc$var$base64ToBytes(string), buf, offset, length);
}
function $46f4e6f775f39bcc$var$ucs2Write(buf, string, offset, length) {
    return $46f4e6f775f39bcc$var$blitBuffer($46f4e6f775f39bcc$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$46f4e6f775f39bcc$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $46f4e6f775f39bcc$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $46f4e6f775f39bcc$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $46f4e6f775f39bcc$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $46f4e6f775f39bcc$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $46f4e6f775f39bcc$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$46f4e6f775f39bcc$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $46f4e6f775f39bcc$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $9c5d6f32ba272209$export$6100ba28696e12de(buf);
    else return $9c5d6f32ba272209$export$6100ba28696e12de(buf.slice(start, end));
}
function $46f4e6f775f39bcc$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $46f4e6f775f39bcc$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $46f4e6f775f39bcc$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $46f4e6f775f39bcc$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $46f4e6f775f39bcc$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $46f4e6f775f39bcc$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $46f4e6f775f39bcc$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $46f4e6f775f39bcc$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $46f4e6f775f39bcc$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $46f4e6f775f39bcc$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $46f4e6f775f39bcc$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$46f4e6f775f39bcc$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $46f4e6f775f39bcc$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $46f4e6f775f39bcc$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$46f4e6f775f39bcc$var$Buffer.prototype.readUintLE = $46f4e6f775f39bcc$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$46f4e6f775f39bcc$var$Buffer.prototype.readUintBE = $46f4e6f775f39bcc$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$46f4e6f775f39bcc$var$Buffer.prototype.readUint8 = $46f4e6f775f39bcc$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$46f4e6f775f39bcc$var$Buffer.prototype.readUint16LE = $46f4e6f775f39bcc$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$46f4e6f775f39bcc$var$Buffer.prototype.readUint16BE = $46f4e6f775f39bcc$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$46f4e6f775f39bcc$var$Buffer.prototype.readUint32LE = $46f4e6f775f39bcc$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$46f4e6f775f39bcc$var$Buffer.prototype.readUint32BE = $46f4e6f775f39bcc$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$46f4e6f775f39bcc$var$Buffer.prototype.readBigUInt64LE = $46f4e6f775f39bcc$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $46f4e6f775f39bcc$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $46f4e6f775f39bcc$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$46f4e6f775f39bcc$var$Buffer.prototype.readBigUInt64BE = $46f4e6f775f39bcc$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $46f4e6f775f39bcc$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $46f4e6f775f39bcc$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$46f4e6f775f39bcc$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$46f4e6f775f39bcc$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$46f4e6f775f39bcc$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$46f4e6f775f39bcc$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$46f4e6f775f39bcc$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$46f4e6f775f39bcc$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$46f4e6f775f39bcc$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$46f4e6f775f39bcc$var$Buffer.prototype.readBigInt64LE = $46f4e6f775f39bcc$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $46f4e6f775f39bcc$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $46f4e6f775f39bcc$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$46f4e6f775f39bcc$var$Buffer.prototype.readBigInt64BE = $46f4e6f775f39bcc$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $46f4e6f775f39bcc$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $46f4e6f775f39bcc$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$46f4e6f775f39bcc$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 4, this.length);
    return $42ae557cc21e89b5$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$46f4e6f775f39bcc$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 4, this.length);
    return $42ae557cc21e89b5$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$46f4e6f775f39bcc$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 8, this.length);
    return $42ae557cc21e89b5$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$46f4e6f775f39bcc$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 8, this.length);
    return $42ae557cc21e89b5$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $46f4e6f775f39bcc$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$46f4e6f775f39bcc$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$46f4e6f775f39bcc$var$Buffer.prototype.writeUintLE = $46f4e6f775f39bcc$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $46f4e6f775f39bcc$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeUintBE = $46f4e6f775f39bcc$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $46f4e6f775f39bcc$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeUint8 = $46f4e6f775f39bcc$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeUint16LE = $46f4e6f775f39bcc$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeUint16BE = $46f4e6f775f39bcc$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeUint32LE = $46f4e6f775f39bcc$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeUint32BE = $46f4e6f775f39bcc$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $46f4e6f775f39bcc$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $46f4e6f775f39bcc$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $46f4e6f775f39bcc$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $46f4e6f775f39bcc$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$46f4e6f775f39bcc$var$Buffer.prototype.writeBigUInt64LE = $46f4e6f775f39bcc$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $46f4e6f775f39bcc$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$46f4e6f775f39bcc$var$Buffer.prototype.writeBigUInt64BE = $46f4e6f775f39bcc$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $46f4e6f775f39bcc$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$46f4e6f775f39bcc$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $46f4e6f775f39bcc$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $46f4e6f775f39bcc$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeBigInt64LE = $46f4e6f775f39bcc$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $46f4e6f775f39bcc$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$46f4e6f775f39bcc$var$Buffer.prototype.writeBigInt64BE = $46f4e6f775f39bcc$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $46f4e6f775f39bcc$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $46f4e6f775f39bcc$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $46f4e6f775f39bcc$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $42ae557cc21e89b5$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$46f4e6f775f39bcc$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $46f4e6f775f39bcc$var$writeFloat(this, value, offset, true, noAssert);
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $46f4e6f775f39bcc$var$writeFloat(this, value, offset, false, noAssert);
};
function $46f4e6f775f39bcc$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $42ae557cc21e89b5$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$46f4e6f775f39bcc$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $46f4e6f775f39bcc$var$writeDouble(this, value, offset, true, noAssert);
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $46f4e6f775f39bcc$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$46f4e6f775f39bcc$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$46f4e6f775f39bcc$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$46f4e6f775f39bcc$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$46f4e6f775f39bcc$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $46f4e6f775f39bcc$var$Buffer.isBuffer(val) ? val : $46f4e6f775f39bcc$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $46f4e6f775f39bcc$var$errors = {};
function $46f4e6f775f39bcc$var$E(sym, getMessage, Base) {
    $46f4e6f775f39bcc$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$46f4e6f775f39bcc$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$46f4e6f775f39bcc$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$46f4e6f775f39bcc$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $46f4e6f775f39bcc$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $46f4e6f775f39bcc$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $46f4e6f775f39bcc$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $46f4e6f775f39bcc$var$checkBounds(buf, offset, byteLength) {
    $46f4e6f775f39bcc$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $46f4e6f775f39bcc$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $46f4e6f775f39bcc$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $46f4e6f775f39bcc$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $46f4e6f775f39bcc$var$checkBounds(buf, offset, byteLength);
}
function $46f4e6f775f39bcc$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $46f4e6f775f39bcc$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $46f4e6f775f39bcc$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $46f4e6f775f39bcc$var$validateNumber(value, type);
        throw new $46f4e6f775f39bcc$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $46f4e6f775f39bcc$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $46f4e6f775f39bcc$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $46f4e6f775f39bcc$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $46f4e6f775f39bcc$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($46f4e6f775f39bcc$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $46f4e6f775f39bcc$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $46f4e6f775f39bcc$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $46f4e6f775f39bcc$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $46f4e6f775f39bcc$var$base64ToBytes(str) {
    return $9c5d6f32ba272209$export$d622b2ad8d90c771($46f4e6f775f39bcc$var$base64clean(str));
}
function $46f4e6f775f39bcc$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $46f4e6f775f39bcc$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $46f4e6f775f39bcc$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $46f4e6f775f39bcc$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $46f4e6f775f39bcc$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $46f4e6f775f39bcc$var$BufferBigIntNotDefined : fn;
}
function $46f4e6f775f39bcc$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $7950c479b726d7e3$require$Buffer = $46f4e6f775f39bcc$export$a143d493d941bafc;
const $7950c479b726d7e3$var$base64 = typeof btoa === "undefined" ? /* istanbul ignore next */ /* istanbul ignore next */ (x)=>$7950c479b726d7e3$require$Buffer.from(x).toString("base64") : btoa;
const $7950c479b726d7e3$var$escape = (x)=>$7950c479b726d7e3$var$base64(encodeURIComponent(x)).replace(/=+$/, "");
function $7950c479b726d7e3$var$Radio(_a) {
    var { allowedValues: allowedValues, disabled: disabled, id: id, label: label, name: name, onChange: onChange, readOnly: readOnly, transform: transform, value: value } = _a, props = (0, $bc7159ecac4d4618$export$3c9a16f847548506)(_a, [
        "allowedValues",
        "disabled",
        "id",
        "label",
        "name",
        "onChange",
        "readOnly",
        "transform",
        "value"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", Object.assign({}, (0, (/*@__PURE__*/$parcel$interopDefault($944cdbbf765af890$exports)))((0, $a9d11e51a3949550$export$457c3d6518dd4c6f)(props), [
        "checkboxes"
    ])), label && (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("label", null, label), allowedValues === null || allowedValues === void 0 ? void 0 : allowedValues.map((item)=>(0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
            key: item
        }, (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("input", {
            checked: item === value,
            disabled: disabled,
            id: `${id}-${$7950c479b726d7e3$var$escape(item)}`,
            name: name,
            onChange: ()=>{
                if (!readOnly) onChange(item);
            },
            type: "radio"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("label", {
            htmlFor: `${id}-${$7950c479b726d7e3$var$escape(item)}`
        }, transform ? transform(item) : item))));
}
var $7950c479b726d7e3$export$2e2bcd8739ae039 = (0, $655e28ed924d8929$export$2fe409f101064a7f)($7950c479b726d7e3$var$Radio, {
    kind: "leaf"
});



var $51042a4735a266c8$exports = {};

var $e44b37e332775c4e$exports = {};



/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $e44b37e332775c4e$var$baseRest(func, start) {
    return $325c84255efacc77$exports($bb6d628fedb75c45$exports(func, start, $245bbf0693bc803c$exports), func + "");
}
$e44b37e332775c4e$exports = $e44b37e332775c4e$var$baseRest;


var $117e2282fa473456$exports = {};
var $5c5ff3c1b8c7f24d$exports = {};

var $84b958542b5dc835$exports = {};
var $8000b0af34c5de26$exports = {};
var $ab7bf18d34b14f8d$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ab7bf18d34b14f8d$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$ab7bf18d34b14f8d$exports = $ab7bf18d34b14f8d$var$baseFindIndex;


var $eee39f6043ff347e$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $eee39f6043ff347e$var$baseIsNaN(value) {
    return value !== value;
}
$eee39f6043ff347e$exports = $eee39f6043ff347e$var$baseIsNaN;


var $a7b91a9a4b1a9485$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a7b91a9a4b1a9485$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$a7b91a9a4b1a9485$exports = $a7b91a9a4b1a9485$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $8000b0af34c5de26$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $a7b91a9a4b1a9485$exports(array, value, fromIndex) : $ab7bf18d34b14f8d$exports(array, $eee39f6043ff347e$exports, fromIndex);
}
$8000b0af34c5de26$exports = $8000b0af34c5de26$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $84b958542b5dc835$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $8000b0af34c5de26$exports(array, value, 0) > -1;
}
$84b958542b5dc835$exports = $84b958542b5dc835$var$arrayIncludes;


var $789816b448af034f$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $789816b448af034f$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$789816b448af034f$exports = $789816b448af034f$var$arrayIncludesWith;





/** Used as the size to enable large array optimizations. */ var $5c5ff3c1b8c7f24d$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $5c5ff3c1b8c7f24d$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $84b958542b5dc835$exports, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $705c9649d4ad8bbf$exports(values, $a651a5d22085d60e$exports(iteratee));
    if (comparator) {
        includes = $789816b448af034f$exports;
        isCommon = false;
    } else if (values.length >= $5c5ff3c1b8c7f24d$var$LARGE_ARRAY_SIZE) {
        includes = $c76720e758204839$exports;
        isCommon = false;
        values = new $7eb9d4ff21def10f$exports(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
$5c5ff3c1b8c7f24d$exports = $5c5ff3c1b8c7f24d$var$baseDifference;



var $916c007ab6e1a37e$exports = {};




var $521f6552d1f792f0$exports = {};

var $f383cf003100300d$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $f383cf003100300d$var$noop() {
// No operation performed.
}
$f383cf003100300d$exports = $f383cf003100300d$var$noop;



/** Used as references for various `Number` constants. */ var $521f6552d1f792f0$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $521f6552d1f792f0$var$createSet = !($5c4ed34720edda94$exports && 1 / $aff20477b45dbc2b$exports(new $5c4ed34720edda94$exports([
    ,
    -0
]))[1] == $521f6552d1f792f0$var$INFINITY) ? $f383cf003100300d$exports : function(values) {
    return new $5c4ed34720edda94$exports(values);
};
$521f6552d1f792f0$exports = $521f6552d1f792f0$var$createSet;



/** Used as the size to enable large array optimizations. */ var $916c007ab6e1a37e$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $916c007ab6e1a37e$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $84b958542b5dc835$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $789816b448af034f$exports;
    } else if (length >= $916c007ab6e1a37e$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $521f6552d1f792f0$exports(array);
        if (set) return $aff20477b45dbc2b$exports(set);
        isCommon = false;
        includes = $c76720e758204839$exports;
        seen = new $7eb9d4ff21def10f$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$916c007ab6e1a37e$exports = $916c007ab6e1a37e$var$baseUniq;


/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */ function $117e2282fa473456$var$baseXor(arrays, iteratee, comparator) {
    var length = arrays.length;
    if (length < 2) return length ? $916c007ab6e1a37e$exports(arrays[0]) : [];
    var index = -1, result = Array(length);
    while(++index < length){
        var array = arrays[index], othIndex = -1;
        while(++othIndex < length)if (othIndex != index) result[index] = $5c5ff3c1b8c7f24d$exports(result[index] || array, arrays[othIndex], iteratee, comparator);
    }
    return $916c007ab6e1a37e$exports($f9e1c02c637af82d$exports(result, 1), iteratee, comparator);
}
$117e2282fa473456$exports = $117e2282fa473456$var$baseXor;


var $2c26c868e5217f3a$exports = {};


/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $2c26c868e5217f3a$var$isArrayLikeObject(value) {
    return $1e04b4bf2bb5d0fe$exports(value) && $55e5458ff1f44d11$exports(value);
}
$2c26c868e5217f3a$exports = $2c26c868e5217f3a$var$isArrayLikeObject;


/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */ var $51042a4735a266c8$var$xor = $e44b37e332775c4e$exports(function(arrays) {
    return $117e2282fa473456$exports($122fd23cf4f3dd5f$exports(arrays, $2c26c868e5217f3a$exports));
});
$51042a4735a266c8$exports = $51042a4735a266c8$var$xor;



var $cQNHH = parcelRequire("cQNHH");


var $034f165fb1beb799$require$Buffer = $46f4e6f775f39bcc$export$a143d493d941bafc;
const $034f165fb1beb799$var$base64 = typeof btoa === "undefined" ? /* istanbul ignore next */ /* istanbul ignore next */ (x)=>$034f165fb1beb799$require$Buffer.from(x).toString("base64") : btoa;
const $034f165fb1beb799$var$escape = (x)=>$034f165fb1beb799$var$base64(encodeURIComponent(x)).replace(/=+$/, "");
function $034f165fb1beb799$var$Select(_a) {
    var { allowedValues: allowedValues, checkboxes: checkboxes, disabled: disabled, fieldType: fieldType, id: id, inputRef: inputRef, label: label, name: name, onChange: onChange, placeholder: placeholder, readOnly: readOnly, required: required, disableItem: disableItem, transform: transform, value: value } = _a, props = (0, $bc7159ecac4d4618$export$3c9a16f847548506)(_a, [
        "allowedValues",
        "checkboxes",
        "disabled",
        "fieldType",
        "id",
        "inputRef",
        "label",
        "name",
        "onChange",
        "placeholder",
        "readOnly",
        "required",
        "disableItem",
        "transform",
        "value"
    ]);
    const multiple = fieldType === Array;
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", Object.assign({}, (0, $a9d11e51a3949550$export$457c3d6518dd4c6f)(props)), label && (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("label", {
        htmlFor: id
    }, label), checkboxes ? allowedValues.map((item)=>{
        var _a;
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
            key: item
        }, (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("input", {
            checked: fieldType === Array ? value.includes(item) : value === item,
            disabled: (_a = disableItem === null || disableItem === void 0 ? void 0 : disableItem(item)) !== null && _a !== void 0 ? _a : disabled,
            id: `${id}-${$034f165fb1beb799$var$escape(item)}`,
            name: name,
            onChange: ()=>{
                if (!readOnly) onChange(fieldType === Array ? (0, (/*@__PURE__*/$parcel$interopDefault($51042a4735a266c8$exports)))([
                    item
                ], value) : item);
            },
            type: "checkbox"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("label", {
            htmlFor: `${id}-${$034f165fb1beb799$var$escape(item)}`
        }, transform ? transform(item) : item));
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("select", {
        disabled: disabled,
        id: id,
        multiple: multiple,
        name: name,
        onChange: (event)=>{
            if (!readOnly) {
                const item = event.target.value;
                if (multiple) {
                    const clear = event.target.selectedIndex === -1;
                    onChange(clear ? [] : (0, (/*@__PURE__*/$parcel$interopDefault($51042a4735a266c8$exports)))([
                        item
                    ], value));
                } else onChange(item !== "" ? item : undefined);
            }
        },
        ref: inputRef,
        value: value !== null && value !== void 0 ? value : ""
    }, (!!placeholder || !required || value === undefined) && !multiple && (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("option", {
        value: "",
        disabled: required,
        hidden: required
    }, placeholder || label), allowedValues === null || allowedValues === void 0 ? void 0 : allowedValues.map((value)=>(0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("option", {
            disabled: disableItem === null || disableItem === void 0 ? void 0 : disableItem(value),
            key: value,
            value: value
        }, transform ? transform(value) : value))));
}
var $034f165fb1beb799$export$2e2bcd8739ae039 = (0, $655e28ed924d8929$export$2fe409f101064a7f)($034f165fb1beb799$var$Select, {
    kind: "leaf"
});




var $cQNHH = parcelRequire("cQNHH");

function $f732d26c1d27cc49$var$Text(_a) {
    var { autoComplete: autoComplete, disabled: disabled, id: id, inputRef: inputRef, label: label, name: name, onChange: onChange, placeholder: placeholder, readOnly: readOnly, type: type, value: value } = _a, props = (0, $bc7159ecac4d4618$export$3c9a16f847548506)(_a, [
        "autoComplete",
        "disabled",
        "id",
        "inputRef",
        "label",
        "name",
        "onChange",
        "placeholder",
        "readOnly",
        "type",
        "value"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", Object.assign({}, (0, $a9d11e51a3949550$export$457c3d6518dd4c6f)(props)), label && (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("label", {
        htmlFor: id
    }, label), (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("input", {
        autoComplete: autoComplete,
        disabled: disabled,
        id: id,
        name: name,
        onChange: (event)=>onChange(event.target.value),
        placeholder: placeholder,
        readOnly: readOnly,
        ref: inputRef,
        type: type,
        value: value !== null && value !== void 0 ? value : ""
    }));
}
$f732d26c1d27cc49$var$Text.defaultProps = {
    type: "text"
};
var $f732d26c1d27cc49$export$2e2bcd8739ae039 = (0, $655e28ed924d8929$export$2fe409f101064a7f)($f732d26c1d27cc49$var$Text, {
    kind: "leaf"
});


const $91261836a34cd3bb$var$AutoField = (0, $754f6f9b097b957f$export$67be0aecf20e0922)((props)=>{
    if (props.allowedValues) return props.checkboxes && props.fieldType !== Array ? (0, $7950c479b726d7e3$export$2e2bcd8739ae039) : (0, $034f165fb1beb799$export$2e2bcd8739ae039);
    switch(props.fieldType){
        case Array:
            return 0, $1b000dd22449267b$export$2e2bcd8739ae039;
        case Boolean:
            return 0, $eac3cff8184e5e42$export$2e2bcd8739ae039;
        case Date:
            return 0, $77f60ade0a1392cc$export$2e2bcd8739ae039;
        case Number:
            return 0, $044185b12414e69b$export$2e2bcd8739ae039;
        case Object:
            return 0, $ec1631cf77f6b99a$export$2e2bcd8739ae039;
        case String:
            return 0, $f732d26c1d27cc49$export$2e2bcd8739ae039;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($e5f9c2c26e21f232$exports)))(false, "Unsupported field type: %s", props.fieldType);
});
var $91261836a34cd3bb$export$2e2bcd8739ae039 = $91261836a34cd3bb$var$AutoField;


function $190bb506b133e116$export$2e2bcd8739ae039(_a) {
    var { autoField: autoField = (0, $91261836a34cd3bb$export$2e2bcd8739ae039), element: element = "div", fields: fields, omitFields: omitFields = [] } = _a, props = (0, $bc7159ecac4d4618$export$3c9a16f847548506)(_a, [
        "autoField",
        "element",
        "fields",
        "omitFields"
    ]);
    const { schema: schema } = (0, $8d33e3f7f35abf1d$export$87c0cf8eb5a167e0)();
    return (0, $cQNHH.createElement)(element, props, (fields !== null && fields !== void 0 ? fields : schema.getSubfields()).filter((field)=>!omitFields.includes(field)).map((field)=>(0, $cQNHH.createElement)(autoField, {
            key: field,
            name: field
        })));
}

var $02faf941b173548a$exports = {};

/** Used to compose bitmasks for cloning. */ var $02faf941b173548a$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $02faf941b173548a$var$clone(value) {
    return $f8d808b86d77353d$exports(value, $02faf941b173548a$var$CLONE_SYMBOLS_FLAG);
}
$02faf941b173548a$exports = $02faf941b173548a$var$clone;


var $64351f4bddb40f39$exports = {};

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $64351f4bddb40f39$var$isEqual(value, other) {
    return $c44efc54af92d51f$exports(value, other);
}
$64351f4bddb40f39$exports = $64351f4bddb40f39$var$isEqual;



var $81bdcb28df3588de$exports = {};
var $30ff29d4e5190fa3$exports = {};





/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $30ff29d4e5190fa3$var$baseSet(object, path, value, customizer) {
    if (!$149642e59a27d046$exports(object)) return object;
    path = $26be98534887ebf0$exports(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $18a4d69693757e11$exports(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $149642e59a27d046$exports(objValue) ? objValue : $51535ec62329b798$exports(path[index + 1]) ? [] : {};
        }
        $56bc97ac634a8894$exports(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
$30ff29d4e5190fa3$exports = $30ff29d4e5190fa3$var$baseSet;


/**
 * This method is like `_.set` except that it accepts `customizer` which is
 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
 * path creation is handled by the method instead. The `customizer` is invoked
 * with three arguments: (nsValue, key, nsObject).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {};
 *
 * _.setWith(object, '[0][1]', 'a', Object);
 * // => { '0': { '1': 'a' } }
 */ function $81bdcb28df3588de$var$setWith(object, path, value, customizer) {
    customizer = typeof customizer == "function" ? customizer : undefined;
    return object == null ? object : $30ff29d4e5190fa3$exports(object, path, value, customizer);
}
$81bdcb28df3588de$exports = $81bdcb28df3588de$var$setWith;







var $cQNHH = parcelRequire("cQNHH");


function $2ece8d16ad50fbc3$var$isObject(value) {
    return !!value && value === Object(value) && !(value instanceof Date);
}
function $2ece8d16ad50fbc3$export$59230889ac977c02(root, valueA, valueB) {
    if (!$2ece8d16ad50fbc3$var$isObject(valueA) || valueB && typeof valueA !== typeof valueB) return (0, (/*@__PURE__*/$parcel$interopDefault($64351f4bddb40f39$exports)))(valueA, valueB) ? [] : [
        root
    ];
    const changed = [
        root
    ];
    if ($2ece8d16ad50fbc3$var$isObject(valueB)) {
        for(const key in valueA)if (!(key in valueB) || !(0, (/*@__PURE__*/$parcel$interopDefault($64351f4bddb40f39$exports)))(valueA[key], valueB[key])) changed.push((0, $cf50d698743ef582$export$c8987bb64f9a8b89)(root, key));
        for(const key in valueB)if (!(key in valueA)) changed.push((0, $cf50d698743ef582$export$c8987bb64f9a8b89)(root, key));
        if (changed.length === 1) changed.pop();
    } else // eslint-disable-next-line guard-for-in
    for(const key in valueA)changed.push((0, $cf50d698743ef582$export$c8987bb64f9a8b89)(root, key));
    return changed;
}



// Workaround for SSR
// https://github.com/vazco/uniforms/issues/40
// https://github.com/facebook/react/issues/4000
function $31bc23fe21c8e35b$var$randomIdsGenerator(prefix) {
    let counter = 0;
    return ()=>`${prefix}-${("000" + (counter++).toString(36)).slice(-4)}`;
}
const $31bc23fe21c8e35b$var$randomIdPrefix = $31bc23fe21c8e35b$var$randomIdsGenerator("uniforms");
function $31bc23fe21c8e35b$export$1a0ec2f2094a09fe(prefix = $31bc23fe21c8e35b$var$randomIdPrefix()) {
    return $31bc23fe21c8e35b$var$randomIdsGenerator(prefix);
}


class $5dd5505cda296410$export$22578b9571b69853 extends (0, $cQNHH.Component) {
    componentDidMount() {
        this.mounted = true;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    componentDidUpdate(prevProps, prevState, snapshot) {}
    componentWillUnmount() {
        this.mounted = false;
        if (this.delayId) clearTimeout(this.delayId);
        // There are at least 4 places where we'd need to check, whether or not we
        // actually perform `setState` after the component gets unmounted. Instead,
        // we override it to hide the React warning. Also because React no longer
        // will raise it in the newer versions.
        // https://github.com/facebook/react/pull/22114
        // https://github.com/vazco/uniforms/issues/1152
        this.setState = ()=>{};
    }
    getContext() {
        return {
            changed: this.state.changed,
            changedMap: this.state.changedMap,
            error: this.getContextError(),
            formRef: this,
            model: this.getContextModel(),
            name: this.getContextName(),
            onChange: this.getContextOnChange(),
            onSubmit: this.getContextOnSubmit(),
            randomId: this.randomId,
            schema: this.getContextSchema(),
            state: this.getContextState(),
            submitted: this.state.submitted,
            submitting: this.state.submitting,
            validating: false
        };
    }
    getContextName() {
        return [];
    }
    getContextError() {
        return this.props.error;
    }
    getContextModel() {
        return this.getModel("form");
    }
    getContextState() {
        return {
            disabled: !!this.props.disabled,
            label: !!this.props.label,
            placeholder: !!this.props.placeholder,
            readOnly: !!this.props.readOnly,
            showInlineError: !!this.props.showInlineError
        };
    }
    getContextSchema() {
        return this.props.schema;
    }
    getContextOnChange() {
        // It's bound in constructor.
        // eslint-disable-next-line @typescript-eslint/unbound-method
        return this.onChange;
    }
    getContextOnSubmit() {
        // It's bound in constructor.
        // eslint-disable-next-line @typescript-eslint/unbound-method
        return this.onSubmit;
    }
    getModel(mode, model = this.props.model) {
        return model;
    }
    getNativeFormProps() {
        const props = (0, (/*@__PURE__*/$parcel$interopDefault($944cdbbf765af890$exports)))(this.props, [
            "autosave",
            "autosaveDelay",
            "disabled",
            "error",
            "label",
            "model",
            "modelTransform",
            "onChange",
            "onSubmit",
            "placeholder",
            "readOnly",
            "schema",
            "showInlineError"
        ]);
        return Object.assign(Object.assign({}, props), {
            // It's bound in constructor.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            onSubmit: this.onSubmit,
            key: `reset-${this.state.resetCount}`
        });
    }
    onChange(key, value) {
        // Do not set `changed` before componentDidMount
        if (this.mounted) {
            const keys = (0, $2ece8d16ad50fbc3$export$59230889ac977c02)(key, value, (0, (/*@__PURE__*/$parcel$interopDefault($ad66414c641bd16b$exports)))(this.getModel(), key));
            if (keys.length !== 0) this.setState((state)=>// If all are already marked, we can skip the update completely.
                state.changed && keys.every((key)=>!!(0, (/*@__PURE__*/$parcel$interopDefault($ad66414c641bd16b$exports)))(state.changedMap, key)) ? null : {
                    changed: true,
                    changedMap: keys.reduce((changedMap, key)=>(0, (/*@__PURE__*/$parcel$interopDefault($81bdcb28df3588de$exports)))(changedMap, key, {}, (0, (/*@__PURE__*/$parcel$interopDefault($02faf941b173548a$exports)))), (0, (/*@__PURE__*/$parcel$interopDefault($02faf941b173548a$exports)))(state.changedMap))
                });
        }
        if (this.props.onChange) this.props.onChange(key, value);
        // Do not call `onSubmit` before componentDidMount
        if (this.mounted && this.props.autosave) {
            if (this.delayId) this.delayId = clearTimeout(this.delayId);
            // Delay autosave by `autosaveDelay` milliseconds...
            this.delayId = setTimeout(()=>{
                // ...and wait for all scheduled `setState`s to commit. This is required
                // for AutoForm to validate correct model, waiting in `onChange`.
                this.setState(()=>null, ()=>{
                    this.onSubmit();
                });
            }, this.props.autosaveDelay);
        }
    }
    __reset(state) {
        return {
            changed: false,
            changedMap: Object.create(null),
            resetCount: state.resetCount + 1,
            submitted: false,
            submitting: false
        };
    }
    onReset() {
        // @ts-expect-error
        // It's bound in constructor.
        // eslint-disable-next-line @typescript-eslint/unbound-method
        this.setState(this.__reset);
    }
    onSubmit(event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.setState((state)=>state.submitted ? null : {
                submitted: true
            });
        const result = this.props.onSubmit(this.getModel("submit"));
        if (!(result instanceof Promise)) return Promise.resolve();
        this.setState({
            submitting: true
        });
        return result.finally(()=>{
            this.setState({
                submitting: false
            });
        });
    }
    render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $3002b2189a02c5b2$export$a078c61943f9dbbe).Provider, {
            value: this.getContext()
        }, (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("form", Object.assign({}, this.getNativeFormProps())));
    }
    constructor(props){
        super(props);
        // @ts-expect-error: State may be bigger, but it'll be covered by the subclasses.
        this.state = {
            changed: false,
            changedMap: Object.create(null),
            resetCount: 0,
            submitted: false,
            submitting: false
        };
        this.mounted = false;
        this.randomId = (0, $31bc23fe21c8e35b$export$1a0ec2f2094a09fe)(this.props.id);
        this.onReset = this.reset = this.onReset.bind(this);
        this.onChange = this.change = this.onChange.bind(this);
        this.onSubmit = this.submit = this.onSubmit.bind(this);
        // TODO: It shouldn't be here
        const getModel = this.getModel.bind(this);
        this.getModel = (mode, model = getModel(mode))=>mode !== undefined && this.props.modelTransform ? this.props.modelTransform(mode, model) : model;
    }
}
$5dd5505cda296410$export$22578b9571b69853.displayName = "Form";
$5dd5505cda296410$export$22578b9571b69853.defaultProps = {
    autosave: false,
    autosaveDelay: 0,
    error: null,
    label: true,
    model: Object.create(null),
    noValidate: true,
    onSubmit () {}
};




var $cQNHH = parcelRequire("cQNHH");

function $a2ee0cde73bdcc02$export$50044cd6a929afcc(Base) {
    // @ts-expect-error: Mixin class problem.
    class QuickForm extends Base {
        getNativeFormProps() {
            const _props = super.getNativeFormProps();
            const { autoField: AutoField = this.getAutoField(), errorsField: ErrorsField = this.getErrorsField(), submitField: SubmitField = this.getSubmitField() } = _props, props = (0, $bc7159ecac4d4618$export$3c9a16f847548506)(_props, [
                "autoField",
                "errorsField",
                "submitField"
            ]);
            if (!props.children) props.children = this.getContextSchema().getSubfields().map((key)=>(0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(AutoField, {
                    key: key,
                    name: key
                })).concat([
                (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(ErrorsField, {
                    key: "$ErrorsField"
                }),
                (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(SubmitField, {
                    key: "$SubmitField"
                })
            ]);
            return props;
        }
        getAutoField() {
            return ()=>null;
        }
        getErrorsField() {
            return ()=>null;
        }
        getSubmitField() {
            return ()=>null;
        }
    }
    QuickForm.Quick = $a2ee0cde73bdcc02$export$50044cd6a929afcc;
    QuickForm.displayName = `Quick${Base.displayName}`;
    return QuickForm;
}
const $a2ee0cde73bdcc02$export$fdcb8eab8950da = $a2ee0cde73bdcc02$export$50044cd6a929afcc((0, $5dd5505cda296410$export$22578b9571b69853));









function $992f7ec33ce9e127$export$a9b332c95f881e8e(Base) {
    // @ts-expect-error: Mixin class problem.
    class ValidatedForm extends Base {
        getContextError() {
            var _a;
            return (_a = super.getContextError()) !== null && _a !== void 0 ? _a : this.state.error;
        }
        getContext() {
            return Object.assign(Object.assign({}, super.getContext()), {
                validating: this.state.validating
            });
        }
        getNativeFormProps() {
            const props = super.getNativeFormProps();
            return (0, (/*@__PURE__*/$parcel$interopDefault($944cdbbf765af890$exports)))(props, [
                "onValidate",
                "validate",
                "validator"
            ]);
        }
        componentDidUpdate(prevProps, prevState, snapshot) {
            super.componentDidUpdate(prevProps, prevState, snapshot);
            const { model: model, schema: schema, validate: validate, validator: validator } = this.props;
            if (schema !== prevProps.schema || validator !== prevProps.validator) this.setState({
                validator: schema.getValidator(validator)
            }, ()=>{
                if ($992f7ec33ce9e127$var$shouldRevalidate(validate, this.state.validate)) this.onValidate();
            });
            else if (!(0, (/*@__PURE__*/$parcel$interopDefault($64351f4bddb40f39$exports)))(model, prevProps.model) && $992f7ec33ce9e127$var$shouldRevalidate(validate, this.state.validate)) this.onValidateModel(model);
        }
        onChange(key, value) {
            if ($992f7ec33ce9e127$var$shouldRevalidate(this.props.validate, this.state.validate)) this.onValidate(key, value);
            super.onChange(key, value);
        }
        __reset(state) {
            return Object.assign(Object.assign({}, super.__reset(state)), {
                error: null,
                validate: false,
                validating: false
            });
        }
        onSubmit(event) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
            this.setState({
                submitted: true,
                validate: true
            });
            const result = this.onValidate().then((error)=>{
                if (error !== null) return Promise.reject(error);
                // Validation failed (i.e. returned an error), so no error is present
                // both in the props nor the state.
                return super.onSubmit().catch((error)=>{
                    this.setState({
                        error: error
                    });
                    throw error;
                });
            });
            result.catch((0, (/*@__PURE__*/$parcel$interopDefault($f383cf003100300d$exports))));
            return result;
        }
        onValidate(key, value) {
            let model = this.getContextModel();
            if (model && key) model = (0, (/*@__PURE__*/$parcel$interopDefault($81bdcb28df3588de$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($02faf941b173548a$exports)))(model), key, (0, (/*@__PURE__*/$parcel$interopDefault($91f6c18aa89ee601$exports)))(value), (0, (/*@__PURE__*/$parcel$interopDefault($02faf941b173548a$exports))));
            return this.onValidateModel(model);
        }
        onValidateModel(originalModel) {
            const model = this.getModel("validate", originalModel);
            // Using `then` allows using the same code for both synchronous and
            // asynchronous cases. We could use `await` here, but it would make all
            // calls asynchronous, unnecessary delaying synchronous validation.
            const then = $992f7ec33ce9e127$var$makeThen(()=>{
                this.setState({
                    validating: true
                });
            });
            return then(this.state.validator(model), (error = null)=>then(this.props.onValidate(model, error), (error = null)=>{
                    var _a;
                    // Do not copy the error from props to the state.
                    error = this.props.error === error ? null : error;
                    // If the whole operation was synchronous and resulted in the same
                    // error, we can skip the re-render.
                    this.setState((state)=>state.error === error && !state.validating ? null : {
                            error: error,
                            validating: false
                        });
                    // A predefined error takes precedence over the validation one.
                    return Promise.resolve((_a = this.props.error) !== null && _a !== void 0 ? _a : error);
                }));
        }
        constructor(props){
            super(props);
            this.state = Object.assign(Object.assign({}, this.state), {
                error: null,
                validate: false,
                validating: false,
                validator: this.getContextSchema().getValidator(props.validator)
            });
            this.onValidate = this.validate = this.onValidate.bind(this);
            this.onValidateModel = this.validateModel = this.onValidateModel.bind(this);
        }
    }
    ValidatedForm.Validated = $992f7ec33ce9e127$export$a9b332c95f881e8e;
    ValidatedForm.displayName = `Validated${Base.displayName}`;
    ValidatedForm.defaultProps = Object.assign(Object.assign({}, Base.defaultProps), {
        onValidate (model, error) {
            return error;
        },
        validate: "onChangeAfterSubmit"
    });
    return ValidatedForm;
}
function $992f7ec33ce9e127$var$makeThen(callIfAsync) {
    function then(value, fn) {
        if (value instanceof Promise) {
            callIfAsync();
            return value.then(fn);
        }
        return fn(value);
    }
    return then;
}
function $992f7ec33ce9e127$var$shouldRevalidate(inProps, inState) {
    return inProps === "onChange" || inProps === "onChangeAfterSubmit" && inState;
}
const $992f7ec33ce9e127$export$f098293515c47e17 = $992f7ec33ce9e127$export$a9b332c95f881e8e((0, $5dd5505cda296410$export$22578b9571b69853));


const $f6bf0faae03d35c3$export$a4ef0f595403d451 = (0, $992f7ec33ce9e127$export$a9b332c95f881e8e)((0, $a2ee0cde73bdcc02$export$50044cd6a929afcc)((0, $5dd5505cda296410$export$22578b9571b69853)));


function $f0cd1c58b8a617a9$export$6cc2e70440926d44(Base) {
    // @ts-expect-error: Mixin class problem.
    class AutoForm extends Base {
        componentDidUpdate(prevProps, prevState, snapshot) {
            const { model: model } = this.props;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($64351f4bddb40f39$exports)))(model, prevProps.model)) this.setState({
                model: model
            });
            super.componentDidUpdate(prevProps, prevState, snapshot);
        }
        getNativeFormProps() {
            const props = super.getNativeFormProps();
            return (0, (/*@__PURE__*/$parcel$interopDefault($944cdbbf765af890$exports)))(props, [
                "onChangeModel"
            ]);
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        getModel(mode) {
            return this.state.model;
        }
        onChange(key, value) {
            super.onChange(key, value);
            this.setState((state)=>({
                    model: (0, (/*@__PURE__*/$parcel$interopDefault($81bdcb28df3588de$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($02faf941b173548a$exports)))(state.model), key, value, (0, (/*@__PURE__*/$parcel$interopDefault($02faf941b173548a$exports))))
                }), ()=>{
                if (this.props.onChangeModel) this.props.onChangeModel(this.state.model);
            });
        }
        __reset(state) {
            return Object.assign(Object.assign({}, super.__reset(state)), {
                model: this.props.model
            });
        }
        constructor(props){
            super(props);
            this.state = Object.assign(Object.assign({}, this.state), {
                model: props.model
            });
        }
    }
    AutoForm.Auto = $f0cd1c58b8a617a9$export$6cc2e70440926d44;
    AutoForm.displayName = `Auto${Base.displayName}`;
    return AutoForm;
}
const $f0cd1c58b8a617a9$export$2dc5b0d03dd97d36 = $f0cd1c58b8a617a9$export$6cc2e70440926d44((0, $f6bf0faae03d35c3$export$a4ef0f595403d451));



function $c30eebdf1e9d7abd$var$Unstyled(parent) {
    class _ extends parent {
    }
    _.Unstyled = $c30eebdf1e9d7abd$var$Unstyled;
    _.displayName = `Unstyled${parent.displayName}`;
    return _;
}
var $c30eebdf1e9d7abd$export$2e2bcd8739ae039 = $c30eebdf1e9d7abd$var$Unstyled((0, $5dd5505cda296410$export$22578b9571b69853));






var $cQNHH = parcelRequire("cQNHH");

function $ef5de80c43a12a08$export$2e2bcd8739ae039(props) {
    const { error: error, schema: schema } = (0, $8d33e3f7f35abf1d$export$87c0cf8eb5a167e0)();
    return !error && !props.children ? null : (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", Object.assign({}, (0, $a9d11e51a3949550$export$457c3d6518dd4c6f)(props)), props.children, (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("ul", null, schema.getErrorMessages(error).map((message, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("li", {
            key: index
        }, message))));
}




var $cQNHH = parcelRequire("cQNHH");

function $551fe62e47e1c4d0$export$2e2bcd8739ae039(_a) {
    var { disabled: disabled, inputRef: inputRef, readOnly: readOnly, value: value } = _a, props = (0, $bc7159ecac4d4618$export$3c9a16f847548506)(_a, [
        "disabled",
        "inputRef",
        "readOnly",
        "value"
    ]);
    const { error: error, state: state } = (0, $8d33e3f7f35abf1d$export$87c0cf8eb5a167e0)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("input", Object.assign({
        disabled: disabled === undefined ? !!(error || state.disabled) : disabled,
        readOnly: readOnly,
        ref: inputRef,
        type: "submit"
    }, value ? {
        value: value
    } : {}, (0, $a9d11e51a3949550$export$457c3d6518dd4c6f)(props)));
}


function $751035c156f81af6$var$Quick(parent) {
    class _ extends (0, $a2ee0cde73bdcc02$export$fdcb8eab8950da).Quick(parent) {
        getAutoField() {
            return 0, $91261836a34cd3bb$export$2e2bcd8739ae039;
        }
        getErrorsField() {
            return 0, $ef5de80c43a12a08$export$2e2bcd8739ae039;
        }
        getSubmitField() {
            return 0, $551fe62e47e1c4d0$export$2e2bcd8739ae039;
        }
    }
    _.Quick = $751035c156f81af6$var$Quick;
    return _;
}
var $751035c156f81af6$export$2e2bcd8739ae039 = $751035c156f81af6$var$Quick((0, $c30eebdf1e9d7abd$export$2e2bcd8739ae039));




function $d8a80abd4d9f318a$var$Validated(parent) {
    class _ extends (0, $992f7ec33ce9e127$export$f098293515c47e17).Validated(parent) {
    }
    _.Validated = $d8a80abd4d9f318a$var$Validated;
    return _;
}
var $d8a80abd4d9f318a$export$2e2bcd8739ae039 = $d8a80abd4d9f318a$var$Validated((0, $c30eebdf1e9d7abd$export$2e2bcd8739ae039));


var $cbfe7f1017506191$export$2e2bcd8739ae039 = (0, $d8a80abd4d9f318a$export$2e2bcd8739ae039).Validated((0, $751035c156f81af6$export$2e2bcd8739ae039).Quick((0, $c30eebdf1e9d7abd$export$2e2bcd8739ae039)));


function $5feaaad92be0dc02$var$Auto(parent) {
    class _ extends (0, $f0cd1c58b8a617a9$export$2dc5b0d03dd97d36).Auto(parent) {
    }
    _.Auto = $5feaaad92be0dc02$var$Auto;
    return _;
}
var $5feaaad92be0dc02$export$2e2bcd8739ae039 = $5feaaad92be0dc02$var$Auto((0, $cbfe7f1017506191$export$2e2bcd8739ae039));




var $cQNHH = parcelRequire("cQNHH");
var $86810f910e69cd42$exports = {};

$parcel$export($86810f910e69cd42$exports, "default", function () { return $86810f910e69cd42$export$2e2bcd8739ae039; });


var $cQNHH = parcelRequire("cQNHH");

const $86810f910e69cd42$var$SubmitButton = ({ cb: cb, caption: caption, buttonClasses: buttonClasses })=>{
    const { error: error, state: { disabled: disabled }, submitting: submitting, model: model, validating: validating } = (0, $8d33e3f7f35abf1d$export$87c0cf8eb5a167e0)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("button", {
        disabled: !!error || disabled || submitting || validating,
        onClick: cb && cb.bind(undefined, model),
        className: buttonClasses
    }, caption || "Sent");
};
$86810f910e69cd42$var$SubmitButton.propTypes = {
    cb: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).func,
    caption: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).object,
    buttonClasses: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string
};
var $86810f910e69cd42$export$2e2bcd8739ae039 = $86810f910e69cd42$var$SubmitButton;






var $6XRb5 = parcelRequire("6XRb5");


var $cQNHH = parcelRequire("cQNHH");


const $5d8c3b2167f286a5$var$ParentField = ({ label: //id,
label, description: description, active: active, fieldInfo: // eslint-disable-next-line no-unused-vars
fieldInfo, children: children, cardClassName: cardClassName, ...props })=>{
    //console.log("ParentField", cardClassName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        ...(0, $a9d11e51a3949550$export$457c3d6518dd4c6f)(props),
        key: label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(cardClassName, "qanda__form", {
            "qanda__form--active": active
        })
    }, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))("qanda__question", {
            "qanda__question--active": active
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("p", {
        className: "qanda__question__text"
    }, label, " "), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("p", {
        className: "qanda__question__subtext is-info"
    }, description)), children);
};
$5d8c3b2167f286a5$var$ParentField.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).any,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    description: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    fieldInfo: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    cardClassName: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).any,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool
};
var $5d8c3b2167f286a5$export$2e2bcd8739ae039 = $5d8c3b2167f286a5$var$ParentField;




var $cQNHH = parcelRequire("cQNHH");



const $f9d28d63ff3f7c25$var$CheckboxSelectField = ({ disabled: //allowedValues,
///checkboxes,
disabled, componentClasses: componentClasses, onChange: //cardClassName,
onChange, description: description, fieldType: fieldType, id: id, fieldInfo: //inputRef,
fieldInfo, label: label, readOnly: readOnly, disableItem: //required,
disableItem, options: options, value: value })=>{
    //console.log("CheckboxSelectField yy01", value, fieldType);
    const multiple = fieldType === Array;
    const handleClick = (toggleValue)=>{
        //console.log("handleClick yy011", value, toggleValue);
        if (readOnly) return;
        let newValue;
        if (multiple) newValue = (0, $2476a2e6668a6972$export$6e25e485871219d8)(value.slice(), toggleValue);
        else newValue = toggleValue;
        //console.log("handleClick", newValue, toggleValue);
        onChange(newValue);
    };
    const renderElements = ()=>{
        //console.log("checkboxSelectFiled->render yy01", value, disabled, disableItem, options);
        return options.map((element)=>{
            if (!disabled || !disableItem.includes(element.value)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($f9d28d63ff3f7c25$var$CheckboxSelectFieldElement, {
                key: element.value,
                onClick: handleClick,
                active: multiple ? value.includes(element.value) : value === element.value,
                multiple: multiple,
                ...element
            });
        });
    };
    //console.log("checkboxSelectField", componentClasses);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $5d8c3b2167f286a5$export$2e2bcd8739ae039), {
        id: id,
        label: label,
        description: description,
        active: multiple ? value.length > 0 : value !== "" && value !== undefined,
        fieldInfo: fieldInfo,
        cardClassName: (multiple ? "qanda__checks qanda__form " : " qanda__radio qanda__form ") + " " + componentClasses
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "qanda__answers"
    }, renderElements()));
};
$f9d28d63ff3f7c25$var$CheckboxSelectField.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).any,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).func,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).any,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).any,
    description: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    fieldInfo: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    allowedValues: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).array,
    disableItem: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).array,
    checkboxes: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
    fieldType: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).func,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    componentClasses: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    cardClassName: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    required: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).any,
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).shape({
        value: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).any,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string
    }))
};
const $f9d28d63ff3f7c25$var$CheckboxSelectFieldElement = ({ title: title, value: value, label: label, active: active, multiple: multiple, onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("label", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))({
            "radio qanda__checkradio": !multiple
        }, {
            "checkbox qanda__checkradio": multiple
        }, {
            "qanda__checkradio--active": active
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("input", {
        onChange: ()=>onClick(value),
        className: "qanda__checkradio__input",
        checked: active,
        type: multiple ? "checkbox" : "radio",
        name: title
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "qanda__checkradio__box"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "icon licon-check"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "qanda__checkradio__text"
    }, label));
};
$f9d28d63ff3f7c25$var$CheckboxSelectFieldElement.propTypes = {
    value: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).any,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
    multiple: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).func
};
var $f9d28d63ff3f7c25$export$2e2bcd8739ae039 = (0, $655e28ed924d8929$export$2fe409f101064a7f)($f9d28d63ff3f7c25$var$CheckboxSelectField, {
    kind: "leaf"
});





var $cQNHH = parcelRequire("cQNHH");


const $9c9589989529f74a$var$Text = ({ autoComplete: autoComplete, disabled: disabled, id: id, inputRef: inputRef, label: label, name: name, onChange: onChange, placeholder: placeholder, readOnly: readOnly, type: type, value: value, inputClassName: inputClassName, error: error, description: description, fieldInfo: fieldInfo, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $5d8c3b2167f286a5$export$2e2bcd8739ae039), {
        id: id,
        label: label,
        description: description,
        fieldInfo: fieldInfo
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("input", {
        autoComplete: autoComplete,
        disabled: disabled,
        id: id,
        name: name,
        onChange: (event)=>onChange(event.target.value),
        placeholder: placeholder,
        readOnly: readOnly,
        ref: inputRef,
        type: type,
        value: value !== null && value !== void 0 ? value : "",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(inputClassName, {
            invalid: error && props.showInlineError
        })
    }));
};
$9c9589989529f74a$var$Text.propTypes = {
    autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).any,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).any,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).func,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).any,
    inputClassName: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).any,
    description: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    fieldInfo: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    showInlineError: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool
};
$9c9589989529f74a$var$Text.defaultProps = {
    type: "text",
    value: ""
};
var $9c9589989529f74a$export$2e2bcd8739ae039 = (0, $655e28ed924d8929$export$2fe409f101064a7f)($9c9589989529f74a$var$Text, {
    kind: "leaf"
});



(0, $a9d11e51a3949550$export$457c3d6518dd4c6f).register("minCount", "maxCount");






var $c8a1a7401045e4f3$exports = {};






var $kGntY = parcelRequire("kGntY");


/** `Object#toString` result references. */ var $c8a1a7401045e4f3$var$mapTag = "[object Map]", $c8a1a7401045e4f3$var$setTag = "[object Set]";
/** Used for built-in method references. */ var $c8a1a7401045e4f3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c8a1a7401045e4f3$var$hasOwnProperty = $c8a1a7401045e4f3$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $c8a1a7401045e4f3$var$isEmpty(value) {
    if (value == null) return true;
    if ($55e5458ff1f44d11$exports(value) && ($907546b303adca65$exports(value) || typeof value == "string" || typeof value.splice == "function" || $kGntY(value) || $5e25abbcac1ccf91$exports(value) || $b2e5bee79b98c26f$exports(value))) return !value.length;
    var tag = $438326f3e5863d71$exports(value);
    if (tag == $c8a1a7401045e4f3$var$mapTag || tag == $c8a1a7401045e4f3$var$setTag) return !value.size;
    if ($446c36e04d0ec6ac$exports(value)) return !$bab2514150f58cb9$exports(value).length;
    for(var key in value){
        if ($c8a1a7401045e4f3$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
$c8a1a7401045e4f3$exports = $c8a1a7401045e4f3$var$isEmpty;


var $600e2bc7a17b3f50$exports = {};
var $c7902294e5d2b3c3$exports = {};
var $70a392fd99eb68ad$exports = {};
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $70a392fd99eb68ad$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
$70a392fd99eb68ad$exports = $70a392fd99eb68ad$var$arrayReduce;


var $dfb4b28ae81a5fe9$exports = {};
var $076c361b057ac7cc$exports = {};
var $3be694d711bdcbf2$exports = {};
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $3be694d711bdcbf2$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
$3be694d711bdcbf2$exports = $3be694d711bdcbf2$var$basePropertyOf;


/** Used to map Latin Unicode letters to basic Latin letters. */ var $076c361b057ac7cc$var$deburredLetters = {
    // Latin-1 Supplement block.
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    // Latin Extended-A block.
    "Ā": "A",
    "Ă": "A",
    "Ą": "A",
    "ā": "a",
    "ă": "a",
    "ą": "a",
    "Ć": "C",
    "Ĉ": "C",
    "Ċ": "C",
    "Č": "C",
    "ć": "c",
    "ĉ": "c",
    "ċ": "c",
    "č": "c",
    "Ď": "D",
    "Đ": "D",
    "ď": "d",
    "đ": "d",
    "Ē": "E",
    "Ĕ": "E",
    "Ė": "E",
    "Ę": "E",
    "Ě": "E",
    "ē": "e",
    "ĕ": "e",
    "ė": "e",
    "ę": "e",
    "ě": "e",
    "Ĝ": "G",
    "Ğ": "G",
    "Ġ": "G",
    "Ģ": "G",
    "ĝ": "g",
    "ğ": "g",
    "ġ": "g",
    "ģ": "g",
    "Ĥ": "H",
    "Ħ": "H",
    "ĥ": "h",
    "ħ": "h",
    "Ĩ": "I",
    "Ī": "I",
    "Ĭ": "I",
    "Į": "I",
    "İ": "I",
    "ĩ": "i",
    "ī": "i",
    "ĭ": "i",
    "į": "i",
    "ı": "i",
    "Ĵ": "J",
    "ĵ": "j",
    "Ķ": "K",
    "ķ": "k",
    "ĸ": "k",
    "Ĺ": "L",
    "Ļ": "L",
    "Ľ": "L",
    "Ŀ": "L",
    "Ł": "L",
    "ĺ": "l",
    "ļ": "l",
    "ľ": "l",
    "ŀ": "l",
    "ł": "l",
    "Ń": "N",
    "Ņ": "N",
    "Ň": "N",
    "Ŋ": "N",
    "ń": "n",
    "ņ": "n",
    "ň": "n",
    "ŋ": "n",
    "Ō": "O",
    "Ŏ": "O",
    "Ő": "O",
    "ō": "o",
    "ŏ": "o",
    "ő": "o",
    "Ŕ": "R",
    "Ŗ": "R",
    "Ř": "R",
    "ŕ": "r",
    "ŗ": "r",
    "ř": "r",
    "Ś": "S",
    "Ŝ": "S",
    "Ş": "S",
    "Š": "S",
    "ś": "s",
    "ŝ": "s",
    "ş": "s",
    "š": "s",
    "Ţ": "T",
    "Ť": "T",
    "Ŧ": "T",
    "ţ": "t",
    "ť": "t",
    "ŧ": "t",
    "Ũ": "U",
    "Ū": "U",
    "Ŭ": "U",
    "Ů": "U",
    "Ű": "U",
    "Ų": "U",
    "ũ": "u",
    "ū": "u",
    "ŭ": "u",
    "ů": "u",
    "ű": "u",
    "ų": "u",
    "Ŵ": "W",
    "ŵ": "w",
    "Ŷ": "Y",
    "ŷ": "y",
    "Ÿ": "Y",
    "Ź": "Z",
    "Ż": "Z",
    "Ž": "Z",
    "ź": "z",
    "ż": "z",
    "ž": "z",
    "Ĳ": "IJ",
    "ĳ": "ij",
    "Œ": "Oe",
    "œ": "oe",
    "ŉ": "'n",
    "ſ": "s"
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $076c361b057ac7cc$var$deburrLetter = $3be694d711bdcbf2$exports($076c361b057ac7cc$var$deburredLetters);
$076c361b057ac7cc$exports = $076c361b057ac7cc$var$deburrLetter;



/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $dfb4b28ae81a5fe9$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $dfb4b28ae81a5fe9$var$rsComboMarksRange = "\\u0300-\\u036f", $dfb4b28ae81a5fe9$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $dfb4b28ae81a5fe9$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $dfb4b28ae81a5fe9$var$rsComboRange = $dfb4b28ae81a5fe9$var$rsComboMarksRange + $dfb4b28ae81a5fe9$var$reComboHalfMarksRange + $dfb4b28ae81a5fe9$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $dfb4b28ae81a5fe9$var$rsCombo = "[" + $dfb4b28ae81a5fe9$var$rsComboRange + "]";
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $dfb4b28ae81a5fe9$var$reComboMark = RegExp($dfb4b28ae81a5fe9$var$rsCombo, "g");
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $dfb4b28ae81a5fe9$var$deburr(string) {
    string = $0c156dec013dd29f$exports(string);
    return string && string.replace($dfb4b28ae81a5fe9$var$reLatin, $076c361b057ac7cc$exports).replace($dfb4b28ae81a5fe9$var$reComboMark, "");
}
$dfb4b28ae81a5fe9$exports = $dfb4b28ae81a5fe9$var$deburr;


var $4050c1039b4e923c$exports = {};
var $9e1f5a99e3cf291e$exports = {};
/** Used to match words composed of alphanumeric characters. */ var $9e1f5a99e3cf291e$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $9e1f5a99e3cf291e$var$asciiWords(string) {
    return string.match($9e1f5a99e3cf291e$var$reAsciiWord) || [];
}
$9e1f5a99e3cf291e$exports = $9e1f5a99e3cf291e$var$asciiWords;


var $1d98506643c9fbf6$exports = {};
/** Used to detect strings that need a more robust regexp to match words. */ var $1d98506643c9fbf6$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $1d98506643c9fbf6$var$hasUnicodeWord(string) {
    return $1d98506643c9fbf6$var$reHasUnicodeWord.test(string);
}
$1d98506643c9fbf6$exports = $1d98506643c9fbf6$var$hasUnicodeWord;



var $c740847c8d4515f2$exports = {};
/** Used to compose unicode character classes. */ var $c740847c8d4515f2$var$rsAstralRange = "\ud800-\udfff", $c740847c8d4515f2$var$rsComboMarksRange = "\\u0300-\\u036f", $c740847c8d4515f2$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $c740847c8d4515f2$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $c740847c8d4515f2$var$rsComboRange = $c740847c8d4515f2$var$rsComboMarksRange + $c740847c8d4515f2$var$reComboHalfMarksRange + $c740847c8d4515f2$var$rsComboSymbolsRange, $c740847c8d4515f2$var$rsDingbatRange = "\\u2700-\\u27bf", $c740847c8d4515f2$var$rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", $c740847c8d4515f2$var$rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", $c740847c8d4515f2$var$rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", $c740847c8d4515f2$var$rsPunctuationRange = "\\u2000-\\u206f", $c740847c8d4515f2$var$rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", $c740847c8d4515f2$var$rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", $c740847c8d4515f2$var$rsVarRange = "\\ufe0e\\ufe0f", $c740847c8d4515f2$var$rsBreakRange = $c740847c8d4515f2$var$rsMathOpRange + $c740847c8d4515f2$var$rsNonCharRange + $c740847c8d4515f2$var$rsPunctuationRange + $c740847c8d4515f2$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $c740847c8d4515f2$var$rsApos = "['’]", $c740847c8d4515f2$var$rsBreak = "[" + $c740847c8d4515f2$var$rsBreakRange + "]", $c740847c8d4515f2$var$rsCombo = "[" + $c740847c8d4515f2$var$rsComboRange + "]", $c740847c8d4515f2$var$rsDigits = "\\d+", $c740847c8d4515f2$var$rsDingbat = "[" + $c740847c8d4515f2$var$rsDingbatRange + "]", $c740847c8d4515f2$var$rsLower = "[" + $c740847c8d4515f2$var$rsLowerRange + "]", $c740847c8d4515f2$var$rsMisc = "[^" + $c740847c8d4515f2$var$rsAstralRange + $c740847c8d4515f2$var$rsBreakRange + $c740847c8d4515f2$var$rsDigits + $c740847c8d4515f2$var$rsDingbatRange + $c740847c8d4515f2$var$rsLowerRange + $c740847c8d4515f2$var$rsUpperRange + "]", $c740847c8d4515f2$var$rsFitz = "\ud83c[\udffb-\udfff]", $c740847c8d4515f2$var$rsModifier = "(?:" + $c740847c8d4515f2$var$rsCombo + "|" + $c740847c8d4515f2$var$rsFitz + ")", $c740847c8d4515f2$var$rsNonAstral = "[^" + $c740847c8d4515f2$var$rsAstralRange + "]", $c740847c8d4515f2$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $c740847c8d4515f2$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $c740847c8d4515f2$var$rsUpper = "[" + $c740847c8d4515f2$var$rsUpperRange + "]", $c740847c8d4515f2$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $c740847c8d4515f2$var$rsMiscLower = "(?:" + $c740847c8d4515f2$var$rsLower + "|" + $c740847c8d4515f2$var$rsMisc + ")", $c740847c8d4515f2$var$rsMiscUpper = "(?:" + $c740847c8d4515f2$var$rsUpper + "|" + $c740847c8d4515f2$var$rsMisc + ")", $c740847c8d4515f2$var$rsOptContrLower = "(?:" + $c740847c8d4515f2$var$rsApos + "(?:d|ll|m|re|s|t|ve))?", $c740847c8d4515f2$var$rsOptContrUpper = "(?:" + $c740847c8d4515f2$var$rsApos + "(?:D|LL|M|RE|S|T|VE))?", $c740847c8d4515f2$var$reOptMod = $c740847c8d4515f2$var$rsModifier + "?", $c740847c8d4515f2$var$rsOptVar = "[" + $c740847c8d4515f2$var$rsVarRange + "]?", $c740847c8d4515f2$var$rsOptJoin = "(?:" + $c740847c8d4515f2$var$rsZWJ + "(?:" + [
    $c740847c8d4515f2$var$rsNonAstral,
    $c740847c8d4515f2$var$rsRegional,
    $c740847c8d4515f2$var$rsSurrPair
].join("|") + ")" + $c740847c8d4515f2$var$rsOptVar + $c740847c8d4515f2$var$reOptMod + ")*", $c740847c8d4515f2$var$rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", $c740847c8d4515f2$var$rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", $c740847c8d4515f2$var$rsSeq = $c740847c8d4515f2$var$rsOptVar + $c740847c8d4515f2$var$reOptMod + $c740847c8d4515f2$var$rsOptJoin, $c740847c8d4515f2$var$rsEmoji = "(?:" + [
    $c740847c8d4515f2$var$rsDingbat,
    $c740847c8d4515f2$var$rsRegional,
    $c740847c8d4515f2$var$rsSurrPair
].join("|") + ")" + $c740847c8d4515f2$var$rsSeq;
/** Used to match complex or compound words. */ var $c740847c8d4515f2$var$reUnicodeWord = RegExp([
    $c740847c8d4515f2$var$rsUpper + "?" + $c740847c8d4515f2$var$rsLower + "+" + $c740847c8d4515f2$var$rsOptContrLower + "(?=" + [
        $c740847c8d4515f2$var$rsBreak,
        $c740847c8d4515f2$var$rsUpper,
        "$"
    ].join("|") + ")",
    $c740847c8d4515f2$var$rsMiscUpper + "+" + $c740847c8d4515f2$var$rsOptContrUpper + "(?=" + [
        $c740847c8d4515f2$var$rsBreak,
        $c740847c8d4515f2$var$rsUpper + $c740847c8d4515f2$var$rsMiscLower,
        "$"
    ].join("|") + ")",
    $c740847c8d4515f2$var$rsUpper + "?" + $c740847c8d4515f2$var$rsMiscLower + "+" + $c740847c8d4515f2$var$rsOptContrLower,
    $c740847c8d4515f2$var$rsUpper + "+" + $c740847c8d4515f2$var$rsOptContrUpper,
    $c740847c8d4515f2$var$rsOrdUpper,
    $c740847c8d4515f2$var$rsOrdLower,
    $c740847c8d4515f2$var$rsDigits,
    $c740847c8d4515f2$var$rsEmoji
].join("|"), "g");
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $c740847c8d4515f2$var$unicodeWords(string) {
    return string.match($c740847c8d4515f2$var$reUnicodeWord) || [];
}
$c740847c8d4515f2$exports = $c740847c8d4515f2$var$unicodeWords;


/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $4050c1039b4e923c$var$words(string, pattern, guard) {
    string = $0c156dec013dd29f$exports(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $1d98506643c9fbf6$exports(string) ? $c740847c8d4515f2$exports(string) : $9e1f5a99e3cf291e$exports(string);
    return string.match(pattern) || [];
}
$4050c1039b4e923c$exports = $4050c1039b4e923c$var$words;


/** Used to compose unicode capture groups. */ var $c7902294e5d2b3c3$var$rsApos = "['’]";
/** Used to match apostrophes. */ var $c7902294e5d2b3c3$var$reApos = RegExp($c7902294e5d2b3c3$var$rsApos, "g");
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $c7902294e5d2b3c3$var$createCompounder(callback) {
    return function(string) {
        return $70a392fd99eb68ad$exports($4050c1039b4e923c$exports($dfb4b28ae81a5fe9$exports(string).replace($c7902294e5d2b3c3$var$reApos, "")), callback, "");
    };
}
$c7902294e5d2b3c3$exports = $c7902294e5d2b3c3$var$createCompounder;


/**
 * Converts `string`, as space separated words, to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.lowerCase('--Foo-Bar--');
 * // => 'foo bar'
 *
 * _.lowerCase('fooBar');
 * // => 'foo bar'
 *
 * _.lowerCase('__FOO_BAR__');
 * // => 'foo bar'
 */ var $600e2bc7a17b3f50$var$lowerCase = $c7902294e5d2b3c3$exports(function(result, word, index) {
    return result + (index ? " " : "") + word.toLowerCase();
});
$600e2bc7a17b3f50$exports = $600e2bc7a17b3f50$var$lowerCase;



var $fcca0af5f473a2eb$exports = {};
var $6d7eeeaf3cb2c86c$exports = {};
var $3fabfef1d6bae48c$exports = {};

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $3fabfef1d6bae48c$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $3919c6f9330175f8$exports(array, start, end);
}
$3fabfef1d6bae48c$exports = $3fabfef1d6bae48c$var$castSlice;


var $ff8ba76e6e5d8b4c$exports = {};
/** Used to compose unicode character classes. */ var $ff8ba76e6e5d8b4c$var$rsAstralRange = "\ud800-\udfff", $ff8ba76e6e5d8b4c$var$rsComboMarksRange = "\\u0300-\\u036f", $ff8ba76e6e5d8b4c$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $ff8ba76e6e5d8b4c$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $ff8ba76e6e5d8b4c$var$rsComboRange = $ff8ba76e6e5d8b4c$var$rsComboMarksRange + $ff8ba76e6e5d8b4c$var$reComboHalfMarksRange + $ff8ba76e6e5d8b4c$var$rsComboSymbolsRange, $ff8ba76e6e5d8b4c$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $ff8ba76e6e5d8b4c$var$rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $ff8ba76e6e5d8b4c$var$reHasUnicode = RegExp("[" + $ff8ba76e6e5d8b4c$var$rsZWJ + $ff8ba76e6e5d8b4c$var$rsAstralRange + $ff8ba76e6e5d8b4c$var$rsComboRange + $ff8ba76e6e5d8b4c$var$rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $ff8ba76e6e5d8b4c$var$hasUnicode(string) {
    return $ff8ba76e6e5d8b4c$var$reHasUnicode.test(string);
}
$ff8ba76e6e5d8b4c$exports = $ff8ba76e6e5d8b4c$var$hasUnicode;


var $70396cc1a7aab80a$exports = {};
var $95bb5ab88f27e8cc$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $95bb5ab88f27e8cc$var$asciiToArray(string) {
    return string.split("");
}
$95bb5ab88f27e8cc$exports = $95bb5ab88f27e8cc$var$asciiToArray;



var $e3ffe196b47647a5$exports = {};
/** Used to compose unicode character classes. */ var $e3ffe196b47647a5$var$rsAstralRange = "\ud800-\udfff", $e3ffe196b47647a5$var$rsComboMarksRange = "\\u0300-\\u036f", $e3ffe196b47647a5$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $e3ffe196b47647a5$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $e3ffe196b47647a5$var$rsComboRange = $e3ffe196b47647a5$var$rsComboMarksRange + $e3ffe196b47647a5$var$reComboHalfMarksRange + $e3ffe196b47647a5$var$rsComboSymbolsRange, $e3ffe196b47647a5$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $e3ffe196b47647a5$var$rsAstral = "[" + $e3ffe196b47647a5$var$rsAstralRange + "]", $e3ffe196b47647a5$var$rsCombo = "[" + $e3ffe196b47647a5$var$rsComboRange + "]", $e3ffe196b47647a5$var$rsFitz = "\ud83c[\udffb-\udfff]", $e3ffe196b47647a5$var$rsModifier = "(?:" + $e3ffe196b47647a5$var$rsCombo + "|" + $e3ffe196b47647a5$var$rsFitz + ")", $e3ffe196b47647a5$var$rsNonAstral = "[^" + $e3ffe196b47647a5$var$rsAstralRange + "]", $e3ffe196b47647a5$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $e3ffe196b47647a5$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $e3ffe196b47647a5$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $e3ffe196b47647a5$var$reOptMod = $e3ffe196b47647a5$var$rsModifier + "?", $e3ffe196b47647a5$var$rsOptVar = "[" + $e3ffe196b47647a5$var$rsVarRange + "]?", $e3ffe196b47647a5$var$rsOptJoin = "(?:" + $e3ffe196b47647a5$var$rsZWJ + "(?:" + [
    $e3ffe196b47647a5$var$rsNonAstral,
    $e3ffe196b47647a5$var$rsRegional,
    $e3ffe196b47647a5$var$rsSurrPair
].join("|") + ")" + $e3ffe196b47647a5$var$rsOptVar + $e3ffe196b47647a5$var$reOptMod + ")*", $e3ffe196b47647a5$var$rsSeq = $e3ffe196b47647a5$var$rsOptVar + $e3ffe196b47647a5$var$reOptMod + $e3ffe196b47647a5$var$rsOptJoin, $e3ffe196b47647a5$var$rsSymbol = "(?:" + [
    $e3ffe196b47647a5$var$rsNonAstral + $e3ffe196b47647a5$var$rsCombo + "?",
    $e3ffe196b47647a5$var$rsCombo,
    $e3ffe196b47647a5$var$rsRegional,
    $e3ffe196b47647a5$var$rsSurrPair,
    $e3ffe196b47647a5$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $e3ffe196b47647a5$var$reUnicode = RegExp($e3ffe196b47647a5$var$rsFitz + "(?=" + $e3ffe196b47647a5$var$rsFitz + ")|" + $e3ffe196b47647a5$var$rsSymbol + $e3ffe196b47647a5$var$rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $e3ffe196b47647a5$var$unicodeToArray(string) {
    return string.match($e3ffe196b47647a5$var$reUnicode) || [];
}
$e3ffe196b47647a5$exports = $e3ffe196b47647a5$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $70396cc1a7aab80a$var$stringToArray(string) {
    return $ff8ba76e6e5d8b4c$exports(string) ? $e3ffe196b47647a5$exports(string) : $95bb5ab88f27e8cc$exports(string);
}
$70396cc1a7aab80a$exports = $70396cc1a7aab80a$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $6d7eeeaf3cb2c86c$var$createCaseFirst(methodName) {
    return function(string) {
        string = $0c156dec013dd29f$exports(string);
        var strSymbols = $ff8ba76e6e5d8b4c$exports(string) ? $70396cc1a7aab80a$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $3fabfef1d6bae48c$exports(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$6d7eeeaf3cb2c86c$exports = $6d7eeeaf3cb2c86c$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $fcca0af5f473a2eb$var$upperFirst = $6d7eeeaf3cb2c86c$exports("toUpperCase");
$fcca0af5f473a2eb$exports = $fcca0af5f473a2eb$var$upperFirst;



class $f11e1a734b806e4b$export$68a44d00957434e6 {
    // Get an error for field `name` out of `error`. There is no standarized
    // format, but fields treat truthy values as a sign of being invalid. Fields
    // receive this as a `error` guaranteed prop.
    getError(name, error) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($e5f9c2c26e21f232$exports)))(false, "%s have not implemented `getError` method (args=%o).", this.constructor.name, {
            name: name,
            error: error
        });
    }
    // Get an error message for field `name` out of `error`. If there is no error,
    // return an empty string. Fields receive this as a `errorMessage` guaranteed
    // prop.
    getErrorMessage(name, error) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($e5f9c2c26e21f232$exports)))(false, "%s have not implemented `getErrorMessage` method (args=%o).", this.constructor.name, {
            name: name,
            error: error
        });
    }
    // Get all error messages from `error`. Only `ErrorsField` make use of that
    // (in builtin themes).
    getErrorMessages(error) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($e5f9c2c26e21f232$exports)))(false, "%s have not implemented `getErrorMessages` method (args=%o).", this.constructor.name, {
            error: error
        });
    }
    // Get internal field definition for field `name`. Fields receive this as a
    // `field` guaranteed prop.
    getField(name) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($e5f9c2c26e21f232$exports)))(false, "%s have not implemented `getField` method (args=%o).", this.constructor.name, {
            name: name
        });
    }
    // Get initial value of field `name`. It is used as a default when no value is
    // set (e.g. the form is rendered with an empty `model`). Additionally,
    // `props` are this field instance props. If a field is rendered multiple
    // times, this function will be called multiple times, possibly with different
    // `props`.
    getInitialValue(name, props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($e5f9c2c26e21f232$exports)))(false, "%s have not implemented `getInitialValue` method (args=%o).", this.constructor.name, {
            name: name,
            props: props
        });
    }
    // Get props defined in schema for a field `name`. There are no required nor
    // banned fields, however properties like `required` are often available.
    // Additionally, `props` are this field instance props. If a field is rendered
    // multiple times, this function will be called multiple times, possibly with
    // different `props`.
    getProps(name, props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($e5f9c2c26e21f232$exports)))(false, "%s have not implemented `getProps` method (args=%o).", this.constructor.name, {
            name: name,
            props: props
        });
    }
    // Get a list of subfields of field `name` or top-level fields, if no `name`
    // is passed.
    getSubfields(name) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($e5f9c2c26e21f232$exports)))(false, "%s have not implemented `getSubfields` method (args=%o).", this.constructor.name, {
            name: name
        });
    }
    // Get a type of field `name`. See `FieldTypeType` for details.
    getType(name) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($e5f9c2c26e21f232$exports)))(false, "%s have not implemented `getType` method (args=%o).", this.constructor.name, {
            name: name
        });
    }
    // Get a validator function. The `options` here are from the `validator` prop
    // of the form. A validator function receives a model and returns an error or
    // a promise that will resolve (not reject!) with an error. If there is no
    // error, return (or resolve with) a `null` value instead.
    // eslint-disable-next-line prettier/prettier
    getValidator(options) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($e5f9c2c26e21f232$exports)))(false, "%s have not implemented `getValidator` method (args=%o).", this.constructor.name, {
            options: options
        });
    }
    // Each bridge can have a different set of parameters.
    constructor(...args){
        (0, (/*@__PURE__*/$parcel$interopDefault($e5f9c2c26e21f232$exports)))(this.constructor !== $f11e1a734b806e4b$export$68a44d00957434e6, "Bridge cannot be instantiated (args=%o).", {
            args: args
        });
    }
}


function $3f6ef9df35d91f24$var$fieldInvariant(name, condition) {
    (0, (/*@__PURE__*/$parcel$interopDefault($e5f9c2c26e21f232$exports)))(condition, 'Field not found in schema: "%s"', name);
}
function $3f6ef9df35d91f24$var$resolveRef(reference, schema) {
    (0, (/*@__PURE__*/$parcel$interopDefault($e5f9c2c26e21f232$exports)))(reference.startsWith("#"), 'Reference is not an internal reference, and only such are allowed: "%s"', reference);
    const resolvedReference = reference.split("/").filter((part)=>part && part !== "#").reduce((definition, next)=>definition[next], schema);
    (0, (/*@__PURE__*/$parcel$interopDefault($e5f9c2c26e21f232$exports)))(resolvedReference, 'Reference not found in schema: "%s"', reference);
    return resolvedReference;
}
function $3f6ef9df35d91f24$var$resolveRefIfNeeded(partial, schema) {
    if (!("$ref" in partial)) return partial;
    const { $ref: $ref } = partial, partialWithoutRef = (0, $bc7159ecac4d4618$export$3c9a16f847548506)(partial, [
        "$ref"
    ]);
    return $3f6ef9df35d91f24$var$resolveRefIfNeeded(Object.assign({}, partialWithoutRef, $3f6ef9df35d91f24$var$resolveRef($ref, schema)), schema);
}
const $3f6ef9df35d91f24$var$partialNames = [
    "allOf",
    "anyOf",
    "oneOf"
];
const $3f6ef9df35d91f24$var$propsToRemove = [
    "default",
    "enum",
    "format",
    "isRequired",
    "title",
    "uniforms"
];
const $3f6ef9df35d91f24$var$propsToRename = [
    [
        "maxItems",
        "maxCount"
    ],
    [
        "maximum",
        "max"
    ],
    [
        "minItems",
        "minCount"
    ],
    [
        "minimum",
        "min"
    ],
    [
        "multipleOf",
        "step"
    ]
];
function $3f6ef9df35d91f24$var$pathToName(path) {
    path = path.startsWith("/") ? path.replace(/\//g, ".").replace(/~0/g, "~").replace(/~1/g, "/") : path.replace(/\[('|")(.+?)\1\]/g, ".$2").replace(/\[(.+?)\]/g, ".$1").replace(/\\'/g, "'");
    return path.slice(1);
}
class $3f6ef9df35d91f24$export$2e2bcd8739ae039 extends (0, $f11e1a734b806e4b$export$68a44d00957434e6) {
    getError(name, error) {
        const details = error === null || error === void 0 ? void 0 : error.details;
        if (!Array.isArray(details)) return null;
        const nameParts = (0, $cf50d698743ef582$export$c8987bb64f9a8b89)(null, name).map((0, $cf50d698743ef582$export$c8987bb64f9a8b89).unescape);
        const unescapedName = (0, $cf50d698743ef582$export$c8987bb64f9a8b89)(nameParts);
        const rootName = (0, $cf50d698743ef582$export$c8987bb64f9a8b89)(nameParts.slice(0, -1));
        const baseName = nameParts[nameParts.length - 1];
        const scopedError = details.find((error)=>{
            var _a;
            const path = $3f6ef9df35d91f24$var$pathToName((_a = error.instancePath) !== null && _a !== void 0 ? _a : error.dataPath);
            return unescapedName === path || rootName === path && baseName === error.params.missingProperty;
        });
        return scopedError || null;
    }
    getErrorMessage(name, error) {
        const scopedError = this.getError(name, error);
        return (scopedError === null || scopedError === void 0 ? void 0 : scopedError.message) || "";
    }
    getErrorMessages(error) {
        if (!error) return [];
        const { details: details } = error;
        return Array.isArray(details) ? details.map((error)=>error.message) : [
            error.message || error
        ];
    }
    getField(name) {
        return (0, $cf50d698743ef582$export$c8987bb64f9a8b89)(null, name).reduce((definition, next, index, array)=>{
            var _a, _b, _c;
            var _d;
            const prevName = (0, $cf50d698743ef582$export$c8987bb64f9a8b89)(array.slice(0, index));
            const nextName = (0, $cf50d698743ef582$export$c8987bb64f9a8b89)(prevName, next);
            const definitionCache = (_a = (_d = this._compiledSchema)[nextName]) !== null && _a !== void 0 ? _a : _d[nextName] = {};
            definitionCache.isRequired = !!(((_b = definition.required) === null || _b === void 0 ? void 0 : _b.includes(next)) || ((_c = this._compiledSchema[prevName].required) === null || _c === void 0 ? void 0 : _c.includes(next)));
            if (next === "$" || next === "" + parseInt(next, 10)) {
                $3f6ef9df35d91f24$var$fieldInvariant(name, definition.type === "array");
                definition = Array.isArray(definition.items) ? definition.items[parseInt(next, 10)] : definition.items;
                $3f6ef9df35d91f24$var$fieldInvariant(name, !!definition);
            } else if (definition.type === "object") {
                $3f6ef9df35d91f24$var$fieldInvariant(name, !!definition.properties);
                definition = definition.properties[(0, $cf50d698743ef582$export$c8987bb64f9a8b89).unescape(next)];
                $3f6ef9df35d91f24$var$fieldInvariant(name, !!definition);
            } else {
                let nextFound = false;
                $3f6ef9df35d91f24$var$partialNames.forEach((partialName)=>{
                    var _a;
                    (_a = definition[partialName]) === null || _a === void 0 || _a.forEach((partialElement)=>{
                        if (!nextFound) {
                            partialElement = $3f6ef9df35d91f24$var$resolveRefIfNeeded(partialElement, this.schema);
                            if (next in partialElement.properties) {
                                definition = partialElement.properties[next];
                                nextFound = true;
                            }
                        }
                    });
                });
                $3f6ef9df35d91f24$var$fieldInvariant(name, nextFound);
            }
            definition = $3f6ef9df35d91f24$var$resolveRefIfNeeded(definition, this.schema);
            // Naive computation of combined type, properties and required.
            const required = definition.required ? definition.required.slice() : [];
            const properties = definition.properties ? Object.assign({}, definition.properties) : {};
            $3f6ef9df35d91f24$var$partialNames.forEach((partialName)=>{
                var _a;
                (_a = definition[partialName]) === null || _a === void 0 || _a.forEach((partial)=>{
                    partial = $3f6ef9df35d91f24$var$resolveRefIfNeeded(partial, this.schema);
                    if (partial.required) required.push(...partial.required);
                    Object.assign(properties, partial.properties);
                    if (!definitionCache.type && partial.type) definitionCache.type = partial.type;
                });
            });
            if (required.length > 0) definitionCache.required = required;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($c8a1a7401045e4f3$exports)))(properties)) definitionCache.properties = properties;
            return definition;
        }, this.schema);
    }
    getInitialValue(name, props) {
        var _a;
        const field = this.getField(name);
        const { default: defaultValue = (_a = field.default) !== null && _a !== void 0 ? _a : (0, (/*@__PURE__*/$parcel$interopDefault($ad66414c641bd16b$exports)))(this.schema.default, name), type: type = field.type } = this._compiledSchema[name];
        if (defaultValue !== undefined) return (0, (/*@__PURE__*/$parcel$interopDefault($91f6c18aa89ee601$exports)))(defaultValue);
        if (type === "array") {
            const item = this.getInitialValue((0, $cf50d698743ef582$export$c8987bb64f9a8b89)(name, "0"));
            const items = (props === null || props === void 0 ? void 0 : props.initialCount) || 0;
            return Array.from({
                length: items
            }, ()=>item);
        }
        if (type === "object") {
            const value = {};
            this.getSubfields(name).forEach((key)=>{
                const initialValue = this.getInitialValue((0, $cf50d698743ef582$export$c8987bb64f9a8b89)(name, key));
                if (initialValue !== undefined) value[key] = initialValue;
            });
            return value;
        }
        return undefined;
    }
    getProps(name, fieldProps) {
        var _a, _b, _c;
        const field = this.getField(name);
        const props = Object.assign({}, field, field.uniforms, this._compiledSchema[name]);
        (_a = props.label) !== null && _a !== void 0 ? _a : props.label = (_b = props.title) !== null && _b !== void 0 ? _b : (0, (/*@__PURE__*/$parcel$interopDefault($fcca0af5f473a2eb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($600e2bc7a17b3f50$exports)))((0, $cf50d698743ef582$export$c8987bb64f9a8b89)(null, name).slice(-1)[0]));
        if (field.type === "number") props.decimal = true;
        if (((_c = field.uniforms) === null || _c === void 0 ? void 0 : _c.type) !== undefined) props.type = field.uniforms.type;
        if (props.required === undefined) props.required = props.isRequired;
        if (props.type === field.type) delete props.type;
        const options = (fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.options) || props.options;
        if (options) {
            if (Array.isArray(options)) {
                props.allowedValues = options.map((option)=>option.value);
                props.transform = (value)=>options.find((option)=>option.value === value).label;
            } else {
                props.allowedValues = Object.keys(options);
                props.transform = (value)=>options[value];
            }
        } else if (props.enum) props.allowedValues = props.enum;
        $3f6ef9df35d91f24$var$propsToRename.forEach(([key, newKey])=>{
            if (key in props) {
                props[newKey] = props[key];
                delete props[key];
            }
        });
        $3f6ef9df35d91f24$var$propsToRemove.forEach((key)=>{
            if (key in props) delete props[key];
        });
        return props;
    }
    getSubfields(name = "") {
        const field = this.getField(name);
        const { properties: properties = field.properties, type: type = field.type } = this._compiledSchema[name];
        if (type === "object" && properties) return Object.keys(properties).map((0, $cf50d698743ef582$export$c8987bb64f9a8b89).escape);
        return [];
    }
    getType(name) {
        const { type: _type, format: fieldFormat } = this.getField(name);
        const { type: fieldType = _type } = this._compiledSchema[name];
        if (fieldFormat === "date-time") return Date;
        if (fieldType === "string") return String;
        if (fieldType === "number") return Number;
        if (fieldType === "integer") return Number;
        if (fieldType === "object") return Object;
        if (fieldType === "array") return Array;
        if (fieldType === "boolean") return Boolean;
        (0, (/*@__PURE__*/$parcel$interopDefault($e5f9c2c26e21f232$exports)))(fieldType !== "null", 'Field "%s" can not be represented as a type null', name);
        return fieldType;
    }
    getValidator() {
        return this.validator;
    }
    constructor(schema, validator){
        super();
        this.validator = validator;
        this.schema = $3f6ef9df35d91f24$var$resolveRefIfNeeded(schema, schema);
        this._compiledSchema = {
            "": this.schema
        };
        // Memoize for performance and referential equality.
        this.getField = (0, (/*@__PURE__*/$parcel$interopDefault($b2b23a4a6cad67db$exports)))(this.getField.bind(this));
        this.getSubfields = (0, (/*@__PURE__*/$parcel$interopDefault($b2b23a4a6cad67db$exports)))(this.getSubfields.bind(this));
        this.getType = (0, (/*@__PURE__*/$parcel$interopDefault($b2b23a4a6cad67db$exports)))(this.getType.bind(this));
    }
}






var $cQNHH = parcelRequire("cQNHH");



const $2c514539bcdc355f$var$Text = ({ autoComplete: autoComplete, disabled: disabled, id: id, inputRef: inputRef, label: label, name: name, onChange: onChange, placeholder: placeholder, readOnly: readOnly, type: type, value: value, componentClassName: // eslint-disable-next-line react/prop-types
componentClassName, error: error, //description,
//fieldInfo,
...props })=>{
    const { t: t } = (0, $aa8f0a59a97a3595$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "field mb-lh"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("label", {
        className: "label"
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "control"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("input", {
        autoComplete: autoComplete,
        disabled: disabled,
        id: id,
        name: name,
        onChange: (event)=>onChange(event.target.value),
        placeholder: placeholder,
        readOnly: readOnly,
        ref: inputRef,
        type: type,
        value: value !== null && value !== void 0 ? value : "",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))("input", componentClassName, {
            invalid: error && props.showInlineError
        })
    })), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("p", {
        className: "help is-danger"
    }, t("testcodeField.helpText")), " "));
};
$2c514539bcdc355f$var$Text.propTypes = {
    autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).any,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).any,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).func,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).any,
    inputClassName: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).any,
    //description: PropTypes.string,
    //fieldInfo: PropTypes.string,
    showInlineError: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool
};
$2c514539bcdc355f$var$Text.defaultProps = {
    type: "text",
    value: ""
};
var $2c514539bcdc355f$export$2e2bcd8739ae039 = (0, $655e28ed924d8929$export$2fe409f101064a7f)($2c514539bcdc355f$var$Text, {
    kind: "leaf"
});





var $cQNHH = parcelRequire("cQNHH");



const $43ba0bd1c4f0ccf5$var$Component = ({ disabled: disabled, id: id, label: label, onChange: onChange, value: //readOnly,
//type,
value, cardClassName: cardClassName, description: //error,
description, fieldInfo: fieldInfo, years: years, ...props })=>{
    //const {t} = useTranslation();
    const [currentMonth, setCurrentMonth] = (0, $cQNHH.useState)();
    const [currentYear, setCurrentYear] = (0, $cQNHH.useState)();
    (0, $cQNHH.useEffect)(()=>{
        if (value) {
            const currentDate = new Date(value);
            setCurrentMonth(currentDate.getMonth() + 1);
            setCurrentYear(currentDate.getFullYear());
        }
    }, [
        value
    ]);
    //console.log("Component", value, currentMonth, currentYear);
    const isActive = value !== undefined && value !== "";
    const onChangeSelect = (event, type)=>{
        //console.log("onChangeSelect", event.target.value, type);
        const newVal = Number(event.target.value);
        switch(type){
            case "student_birthmonth":
                setCurrentMonth(newVal);
                if (currentYear) {
                    const newValue = new Date(currentYear, newVal - 1, 2, 0, 0, 0, 0).toISOString();
                    onChange(newValue);
                }
                break;
            case "student_birthyear":
                setCurrentYear(newVal);
                if (currentMonth) {
                    const newValue = new Date(newVal, currentMonth - 1, 2, 0, 0, 0, 0).toISOString();
                    onChange(newValue);
                }
                break;
            default:
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $5d8c3b2167f286a5$export$2e2bcd8739ae039), {
        id: id,
        label: label,
        description: description,
        fieldInfo: fieldInfo,
        cardClassName: "qanda__birthday " + cardClassName,
        active: isActive,
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "qanda__answers"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("label", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))("qanda__birthmonthyear", {
            "qanda__qanda__birthmonthyear--active": isActive
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($43ba0bd1c4f0ccf5$var$SelectFieldElement, {
        name: "student_birthmonth",
        onChange: onChangeSelect,
        disabled: disabled,
        currentValue: currentMonth,
        translateCaption: true,
        values: [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("label", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))("qanda__monthyear", {
            "qanda__qanda__monthyear--active": isActive
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($43ba0bd1c4f0ccf5$var$SelectFieldElement, {
        name: "student_birthyear",
        onChange: onChangeSelect,
        translateCaption: false,
        disabled: disabled,
        currentValue: currentYear,
        values: years
    }))));
};
$43ba0bd1c4f0ccf5$var$Component.propTypes = {
    autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).any,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).any,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).func,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).any,
    cardClassName: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).any,
    description: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    fieldInfo: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    years: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).array,
    showInlineError: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool
};
// Rolling birth-year range (ages ~6-20) so the list never goes stale. Replaces
// the old hardcoded 2006-2016 list, which excluded pupils born after 2016.
const $43ba0bd1c4f0ccf5$var$BIRTH_YEARS = Array.from({
    length: 15
}, (_, i)=>new Date().getFullYear() - 20 + i);
$43ba0bd1c4f0ccf5$var$Component.defaultProps = {
    type: "text",
    years: $43ba0bd1c4f0ccf5$var$BIRTH_YEARS
};
const $43ba0bd1c4f0ccf5$var$SelectFieldElement = ({ values: values, name: name, disabled: disabled, currentValue: currentValue, translateCaption: translateCaption, onChange: onChange })=>{
    const { t: t } = (0, $aa8f0a59a97a3595$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "select"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("select", {
        disabled: disabled,
        onChange: (e)=>onChange(e, name),
        name: name,
        defaultValue: currentValue || t("yearMonthField_" + name + "_caption")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("option", {
        disabled: true
    }, t("yearMonthField_" + name + "_caption")), values.map((aValue)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("option", {
            key: aValue,
            value: aValue
        }, !translateCaption ? aValue : t("yearMonthField_" + name + "_" + aValue));
    }), " "));
};
$43ba0bd1c4f0ccf5$var$SelectFieldElement.propTypes = {
    values: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).array,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    currentValue: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).number,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
    translateCaption: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).func
};
var $43ba0bd1c4f0ccf5$export$2e2bcd8739ae039 = (0, $655e28ed924d8929$export$2fe409f101064a7f)($43ba0bd1c4f0ccf5$var$Component, {
    kind: "leaf"
});



var $5Lqwq = parcelRequire("5Lqwq");
const $557d3048bfd0173c$var$ajv = new (0, (/*@__PURE__*/$parcel$interopDefault($6XRb5)))({
    allErrors: true,
    useDefaults: true
});
(0, (/*@__PURE__*/$parcel$interopDefault($5Lqwq)))($557d3048bfd0173c$var$ajv);
$557d3048bfd0173c$var$ajv.addVocabulary([
    "uniforms",
    "component",
    "componentClassName",
    "options",
    "label",
    "value",
    "fieldType"
]);
const $557d3048bfd0173c$export$9a4b8a3ca30b6002 = (schema)=>{
    const validator = $557d3048bfd0173c$var$ajv.compile(schema);
    //console.log("createValidator", validator);
    return (model)=>{
        var _validator_errors;
        validator(model);
        return ((_validator_errors = validator.errors) === null || _validator_errors === void 0 ? void 0 : _validator_errors.length) ? {
            details: validator.errors
        } : null;
    };
};
const $557d3048bfd0173c$export$4a133c2feeb87f9d = (schemaDefinition, customValidator)=>{
    //console.log("createUniformSchema", schemaDefinition, customValidator);
    return new (0, $3f6ef9df35d91f24$export$2e2bcd8739ae039)(schemaDefinition, customValidator ? customValidator : $557d3048bfd0173c$export$9a4b8a3ca30b6002(schemaDefinition));
};
const $557d3048bfd0173c$var$fixUniformsType = (item, id)=>{
    let fixedItem = Object.assign({}, item);
    //console.log("fixUniformsType", item);
    let mainSettings = {};
    let uniformSettings = {};
    switch(item.fieldType){
        case "MULTIPLE_CHOICE":
            uniformSettings.component = (0, $f9d28d63ff3f7c25$export$2e2bcd8739ae039);
            mainSettings.items = {
                type: "string"
            };
            break;
        case "SINGLE_CHOICE":
            uniformSettings.component = (0, $f9d28d63ff3f7c25$export$2e2bcd8739ae039);
            break;
        case "INPUT_FIELD":
            uniformSettings.component = (0, $9c9589989529f74a$export$2e2bcd8739ae039);
            break;
        case "TESTCODE_FIELD":
            uniformSettings.component = (0, $2c514539bcdc355f$export$2e2bcd8739ae039);
            break;
        case "YEAR_MONTH":
            uniformSettings.component = (0, $43ba0bd1c4f0ccf5$export$2e2bcd8739ae039);
            break;
        default:
    }
    //uniformSettings.id = id;
    uniformSettings.cardClassName = "";
    fixedItem = Object.assign(fixedItem, mainSettings);
    //fieldType is used bei uniform, therefor it needs to be removed here
    delete fixedItem.fieldType;
    fixedItem.uniforms = Object.assign(fixedItem.uniforms || {}, uniformSettings);
    //console.log("fixUniformsType fixedItem", fixedItem);
    return fixedItem;
};
const $557d3048bfd0173c$export$af88179f1a6b6206 = (jsonSchema, validator = null)=>{
    let fixedSchema = JSON.parse(jsonSchema);
    let requiredFields = [];
    //console.log("fixSchema #1", fixedSchema.properties);
    delete fixedSchema.$schema;
    //console.log("fixSchema #1.1", JSON.stringify(fixedSchema));
    Object.keys(fixedSchema.properties).forEach(function(prop) {
        var _fixedSchema_properties_prop;
        //console.log("fixSchema #2", prop, fixedSchema.properties[prop]);
        if ((_fixedSchema_properties_prop = fixedSchema.properties[prop]) === null || _fixedSchema_properties_prop === void 0 ? void 0 : _fixedSchema_properties_prop.required) requiredFields.push(prop);
        fixedSchema.properties[prop] = $557d3048bfd0173c$var$fixUniformsType(fixedSchema.properties[prop], prop);
    });
    if (requiredFields.length > 0) fixedSchema.required = requiredFields;
    //console.log("fixSchema #3", fixedSchema);
    return $557d3048bfd0173c$export$4a133c2feeb87f9d(fixedSchema, validator);
};


// const createTestDefinition = {
//     type: "object",
//     properties: {
//         email: {
//             type: 'string',
//             //pattern: "/^[a-z0-9\._%+!$&*=^|~#%{}\\-]+@([a-z0-9\-]+\.){1,}([a-z]{2,22})$",
//             format: "email",
//             title: "Email",
//             description: "get Email",
//             uniforms: {
//                 component: InputField,
//                 inputClassName: "full-width"
//             }
//         }
//     }
// };
// const editTestDefinition = {
//     type: "object",
//     properties: {
//         testId: {
//             type: 'string',
//             title: "Test type",
//             description: "Select test",
//             uniforms: {
//                 allowedValues: ["Test A", "Test B"],
//                 component: SelectField
//                 //inputClassName: "full-width"
//             }
//         },
//         active: {
//             type: 'boolean',
//             title: "Active",
//             description: "is Test acitve",
//             uniforms: {
//                 component: BoolField
//                 //inputClassName: "full-width"
//             }
//         }
//     }
// };
const $1b20f6c250d95a1e$var$startTestDefinition = JSON.stringify({
    type: "object",
    properties: {
        testOrSessionId: {
            type: "string",
            minLength: 0,
            maxLength: 1000,
            title: "Test-Code",
            uniforms: {
                placeholder: "Test-Code eingeben"
            },
            fieldType: "TESTCODE_FIELD"
        }
    }
});
const $1b20f6c250d95a1e$export$1df86cc98bcb4f8a = (0, $557d3048bfd0173c$export$af88179f1a6b6206)($1b20f6c250d95a1e$var$startTestDefinition);





const $d1c967cc2cc5f89e$var$StartTest = ()=>{
    // eslint-disable-next-line no-unused-vars
    let formRef;
    const directorState = (0, $bd34a43d05d9e670$export$2105062e25df4afe)((0, $bd1c05d3e19afc9d$export$86d1cded24611cb8));
    let history = (0, $a252e3f3b9c91bac$export$3420e1dc2c4a518c)();
    const { t: t } = (0, $aa8f0a59a97a3595$export$9fc83ad70ead8663)();
    const dispatch = (0, $07670883d6f89641$export$8ad76b76a4c905f8)();
    (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useEffect(()=>{
        document.body.classList.add("layout--centered");
        return ()=>{
            document.body.classList.remove("layout--centered");
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useEffect((0, $0278e31e45b52099$export$dad4a579cd5614b0)(directorState, history), [
        directorState
    ]);
    const handleSubmit = async ({ testOrSessionId: testOrSessionId })=>{
        //log.info("xxx", testOrSessionId);
        if (testOrSessionId && testOrSessionId.length === 8) {
            // todo: replace get current group
            //
            const res = await $cdf098895d141710$export$b96b69e966de3651(testOrSessionId);
            //log.info("StartTest", "handleSubmit", res.error);
            if (!res.error) {
                dispatch((0, $bd1c05d3e19afc9d$export$e16717ba5a5dc549)({
                    sessionId: testOrSessionId,
                    section: res
                }));
                dispatch((0, $ef73d84de842ec50$export$fb9705de59d96855)({
                    text: t("startTestPage.message.testResumed"),
                    type: (0, $ef73d84de842ec50$export$87130b6dd9721cee).SUCCESS,
                    props: {}
                }));
            } else dispatch((0, $ef73d84de842ec50$export$fb9705de59d96855)({
                text: t(res.error),
                type: (0, $ef73d84de842ec50$export$87130b6dd9721cee).ERROR,
                props: {}
            }));
        } else if (testOrSessionId && testOrSessionId.length === 6) {
            const res = await $cdf098895d141710$export$e72511350a89a269(testOrSessionId);
            //log.info("StartTest", "handleSubmit", testOrSessionId, res);
            if (!res.error) {
                dispatch((0, $bd1c05d3e19afc9d$export$e16717ba5a5dc549)({
                    sessionId: res.session_id,
                    section: res.section
                }));
                dispatch((0, $ef73d84de842ec50$export$fb9705de59d96855)({
                    text: t("startTestPage.message.testStarted"),
                    type: (0, $ef73d84de842ec50$export$87130b6dd9721cee).SUCCESS,
                    props: {}
                }));
            } else dispatch((0, $ef73d84de842ec50$export$fb9705de59d96855)({
                text: t(res.error),
                type: (0, $ef73d84de842ec50$export$87130b6dd9721cee).ERROR,
                props: {}
            }));
        } else dispatch((0, $ef73d84de842ec50$export$fb9705de59d96855)({
            text: t("startTestPage.error.testcode"),
            type: (0, $ef73d84de842ec50$export$87130b6dd9721cee).ERROR,
            props: {}
        }));
    };
    const getSubmitCaption = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
            className: "button__text"
        }, t("startTestPage.submitButton.caption")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
            className: "icon licon-arrow-circle-right"
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "container is-max-tablet",
        dangerouslySetInnerHTML: {
            __html: t("startTestPage.intro1")
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "section bg-primary-gradient-soft"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "container is-max-tablet"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: t("startTestPage.intro2")
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "box my-lh"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("h2", {
        className: "is-success"
    }, t("startTestPage.inputNumber.caption")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("p", {
        className: "mb-lh"
    }, t("startTestPage.inputNumber.text")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $5feaaad92be0dc02$export$2e2bcd8739ae039), {
        className: "",
        schema: (0, $1b20f6c250d95a1e$export$1df86cc98bcb4f8a),
        placeholder: true,
        onSubmit: handleSubmit,
        //validate="onChange"
        //onChangeModel={model => setCurrentLayer(() => model.backgroundLayer)}
        ref: (ref)=>formRef = ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("fieldset", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $190bb506b133e116$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "field mb-lh"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $86810f910e69cd42$exports.default), {
        buttonClasses: "button is-success button--direction-right is-rounded",
        caption: getSubmitCaption()
    }))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "container is-max-tablet"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "controls"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("button", {
        onClick: history.goBack,
        className: "button is-text is-rounded"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "icon licon-arrow-arc-left"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "button__text"
    }, "Zur\xfcck"))))));
};
var $d1c967cc2cc5f89e$export$2e2bcd8739ae039 = $d1c967cc2cc5f89e$var$StartTest;



var $564db6ad85661f6d$exports = {};

$parcel$export($564db6ad85661f6d$exports, "default", function () { return $564db6ad85661f6d$export$2e2bcd8739ae039; });




var $cQNHH = parcelRequire("cQNHH");




var $cQNHH = parcelRequire("cQNHH");

//import {useTranslation} from "react-i18next";
const $3909a9c103c0a0dc$var$GroupNavigation = ({ noOfGroups: noOfGroups, currentGroupNo: currentGroupNo, answeredGroups: answeredGroups })=>{
    //console.log("GroupNavigation", noOfGroups, currentGroupNo, answeredGroups);
    const groupClasses = [
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "ten"
    ];
    //const {t} = useTranslation();
    const renderElements = ()=>{
        let items = [];
        for(let i = 1; i <= noOfGroups; i++){
            let classes = {
                "qanda__bubble": true,
                "qanda__bubble--answered": answeredGroups.includes(i),
                "qanda__bubble--active": currentGroupNo === i
            };
            classes["qanda__bubble-1"] = true;
            items.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
                key: i,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(classes)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", null, i)));
        }
        return items;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "qanda__bubbles"
    }, renderElements());
};
$3909a9c103c0a0dc$var$GroupNavigation.propTypes = {
    noOfGroups: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).number,
    currentGroupNo: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).number,
    answeredGroups: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).array
};
var $3909a9c103c0a0dc$export$2e2bcd8739ae039 = $3909a9c103c0a0dc$var$GroupNavigation;


var $d5eef7b985f46066$exports = {};

$parcel$export($d5eef7b985f46066$exports, "default", function () { return $d5eef7b985f46066$export$2e2bcd8739ae039; });


var $cQNHH = parcelRequire("cQNHH");
const $54a203a48f9a4b71$var$PlainQandaButton = ({ cb: cb, classes: classes, iconClasses: iconClasses, caption: caption, disabled: disabled, dir: dir })=>{
    //console.log("QandaButton", submitting, validating, error, formRef);
    const buttonClasses = [
        "button",
        "is-rounded",
        ...classes
    ];
    const iClasses = [
        "icon",
        ...iconClasses
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("button", {
        key: caption,
        className: buttonClasses.join(" "),
        onClick: cb,
        disabled: disabled
    }, dir === "before" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: iClasses.join(" ")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "button__text"
    }, caption), dir === "after" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: iClasses.join(" ")
    }));
};
$54a203a48f9a4b71$var$PlainQandaButton.propTypes = {
    cb: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).func,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).array,
    iconClasses: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).array,
    caption: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    dir: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool
};
$54a203a48f9a4b71$var$PlainQandaButton.defaultProps = {
    cb: null,
    classes: [],
    iconClasses: [],
    caption: "Button caption",
    dir: "before",
    disabled: false
};
var $54a203a48f9a4b71$export$2e2bcd8739ae039 = $54a203a48f9a4b71$var$PlainQandaButton;




var $cQNHH = parcelRequire("cQNHH");

const $d5eef7b985f46066$var$QandaButton = ({ cb: cb, classes: classes, iconClasses: iconClasses, caption: caption, dir: //formRef,
dir })=>{
    const { error: error, state: { disabled: disabled }, model: model, submitting: submitting, validating: validating } = (0, $8d33e3f7f35abf1d$export$87c0cf8eb5a167e0)();
    //console.log("QandaButton", caption, error, disabled, submitting, validating);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $54a203a48f9a4b71$export$2e2bcd8739ae039), {
        classes: classes,
        iconClasses: iconClasses,
        cb: cb.bind(undefined, model),
        dir: dir,
        caption: caption,
        disabled: !!error || disabled || submitting || validating
    });
};
$d5eef7b985f46066$var$QandaButton.propTypes = {
    cb: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).func,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).array,
    formRef: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).func,
    iconClasses: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).array,
    caption: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    dir: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string
};
$d5eef7b985f46066$var$QandaButton.defaultProps = {
    cb: null,
    classes: [],
    iconClasses: [],
    caption: "Button caption",
    dir: "before"
};
var $d5eef7b985f46066$export$2e2bcd8739ae039 = $d5eef7b985f46066$var$QandaButton;




var $cQNHH = parcelRequire("cQNHH");


const $b49fe331cd52f107$var$SectionProgress = ({ noOfSections: noOfSections, currentSectionNo: currentSectionNo })=>{
    const sectionsCaptions = [
        "Meta",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G"
    ];
    const sectionsCaptionsLastSection = "Result";
    const { t: t } = (0, $aa8f0a59a97a3595$export$9fc83ad70ead8663)();
    const renderElements = ()=>{
        let items = [];
        for(let i = 0; i < noOfSections; i++){
            let classes = [
                "progress-step"
            ];
            if (currentSectionNo - 1 > i) classes.push("progress--done");
            if (currentSectionNo - 1 === i) classes.push("progress--active");
            let title = t("sectionProgress.caption") + " " + sectionsCaptions[i];
            if (i + 1 === noOfSections) title = t("sectionProgress.result.caption");
            if (i === 0) title = t("sectionProgress.first.caption");
            items.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
                key: i,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(classes),
                "data-tip": title
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
                className: "progress-bird"
            })));
        }
        return items;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "qanda__progress"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "progress-caption"
    }, "Los"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "progress-steps"
    }, renderElements()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
        className: "progress-caption"
    }, "Fertig"));
};
$b49fe331cd52f107$var$SectionProgress.propTypes = {
    noOfSections: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).number,
    currentSectionNo: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).number
};
var $b49fe331cd52f107$export$2e2bcd8739ae039 = $b49fe331cd52f107$var$SectionProgress;




var $cQNHH = parcelRequire("cQNHH");
/**
 * simplebar-react - v2.4.3
 * React component for SimpleBar
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat
 * Under MIT License
 */ 
var $cQNHH = parcelRequire("cQNHH");

/**
 * SimpleBar.js - v5.3.9
 * Scrollbars, simpler.
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat from a fork by Jonathan Nicol
 * Under MIT License
 */ var $bffd16f10628412f$exports = {};
var $c94afe6b07e4b008$exports = {};
var $c94afe6b07e4b008$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$c94afe6b07e4b008$exports = // eslint-disable-next-line es/no-global-this -- safe
$c94afe6b07e4b008$var$check(typeof globalThis == "object" && globalThis) || $c94afe6b07e4b008$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$c94afe6b07e4b008$var$check(typeof self == "object" && self) || $c94afe6b07e4b008$var$check(typeof $parcel$global == "object" && $parcel$global) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || $c94afe6b07e4b008$exports || Function("return this")();


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $7a28878efd9ccfee$export$2d1720544b23b823;
var $7ac8bc7445a1c6e0$exports = {};
var $ef32b2494ec6c4b3$exports = {};
$ef32b2494ec6c4b3$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$7ac8bc7445a1c6e0$exports = !$ef32b2494ec6c4b3$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});


var $2ab4df4e491115dd$exports = {};
var $74d92435c568df86$exports = {};

$74d92435c568df86$exports = !$ef32b2494ec6c4b3$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $2ab4df4e491115dd$var$call = Function.prototype.call;
$2ab4df4e491115dd$exports = $74d92435c568df86$exports ? $2ab4df4e491115dd$var$call.bind($2ab4df4e491115dd$var$call) : function() {
    return $2ab4df4e491115dd$var$call.apply($2ab4df4e491115dd$var$call, arguments);
};


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $5682c6ae0a1be4a8$export$2d1720544b23b823;
"use strict";
var $5682c6ae0a1be4a8$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $5682c6ae0a1be4a8$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $5682c6ae0a1be4a8$var$NASHORN_BUG = $5682c6ae0a1be4a8$var$getOwnPropertyDescriptor && !$5682c6ae0a1be4a8$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$5682c6ae0a1be4a8$export$2d1720544b23b823 = $5682c6ae0a1be4a8$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $5682c6ae0a1be4a8$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $5682c6ae0a1be4a8$var$$propertyIsEnumerable;


var $9b24751660596f9a$exports = {};
$9b24751660596f9a$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $e68f8d5c7ad91934$exports = {};
// toObject with fallback for non-array-like ES3 strings
var $f23c1702314ea5f4$exports = {};
var $3a4f4365992f575c$exports = {};

var $3a4f4365992f575c$var$FunctionPrototype = Function.prototype;
var $3a4f4365992f575c$var$call = $3a4f4365992f575c$var$FunctionPrototype.call;
var $3a4f4365992f575c$var$uncurryThisWithBind = $74d92435c568df86$exports && $3a4f4365992f575c$var$FunctionPrototype.bind.bind($3a4f4365992f575c$var$call, $3a4f4365992f575c$var$call);
$3a4f4365992f575c$exports = $74d92435c568df86$exports ? $3a4f4365992f575c$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $3a4f4365992f575c$var$call.apply(fn, arguments);
    };
};



var $d8174cbb4abc3bad$exports = {};

var $d8174cbb4abc3bad$var$toString = $3a4f4365992f575c$exports({}.toString);
var $d8174cbb4abc3bad$var$stringSlice = $3a4f4365992f575c$exports("".slice);
$d8174cbb4abc3bad$exports = function(it) {
    return $d8174cbb4abc3bad$var$stringSlice($d8174cbb4abc3bad$var$toString(it), 8, -1);
};


var $f23c1702314ea5f4$var$$Object = Object;
var $f23c1702314ea5f4$var$split = $3a4f4365992f575c$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$f23c1702314ea5f4$exports = $ef32b2494ec6c4b3$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$f23c1702314ea5f4$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $d8174cbb4abc3bad$exports(it) == "String" ? $f23c1702314ea5f4$var$split(it, "") : $f23c1702314ea5f4$var$$Object(it);
} : $f23c1702314ea5f4$var$$Object;


var $07b613168e2ab3af$exports = {};
var $6af58eea9c591e93$exports = {};
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$6af58eea9c591e93$exports = function(it) {
    return it === null || it === undefined;
};


var $07b613168e2ab3af$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$07b613168e2ab3af$exports = function(it) {
    if ($6af58eea9c591e93$exports(it)) throw $07b613168e2ab3af$var$$TypeError("Can't call method on " + it);
    return it;
};


$e68f8d5c7ad91934$exports = function(it) {
    return $f23c1702314ea5f4$exports($07b613168e2ab3af$exports(it));
};


var $370318bc9914ee65$exports = {};
var $c46b4f71deec6dfb$exports = {};

var $cce056444d1847a8$exports = {};
var $6360851c61ffcb03$exports = {};
var $afa937755a6ec728$exports = {};
var $afa937755a6ec728$var$documentAll = typeof document == "object" && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var $afa937755a6ec728$var$IS_HTMLDDA = typeof $afa937755a6ec728$var$documentAll == "undefined" && $afa937755a6ec728$var$documentAll !== undefined;
$afa937755a6ec728$exports = {
    all: $afa937755a6ec728$var$documentAll,
    IS_HTMLDDA: $afa937755a6ec728$var$IS_HTMLDDA
};


var $6360851c61ffcb03$var$documentAll = $afa937755a6ec728$exports.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
$6360851c61ffcb03$exports = $afa937755a6ec728$exports.IS_HTMLDDA ? function(argument) {
    return typeof argument == "function" || argument === $6360851c61ffcb03$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};



var $cce056444d1847a8$var$documentAll = $afa937755a6ec728$exports.all;
$cce056444d1847a8$exports = $afa937755a6ec728$exports.IS_HTMLDDA ? function(it) {
    return typeof it == "object" ? it !== null : $6360851c61ffcb03$exports(it) || it === $cce056444d1847a8$var$documentAll;
} : function(it) {
    return typeof it == "object" ? it !== null : $6360851c61ffcb03$exports(it);
};


var $22d4b42707cf7617$exports = {};
var $74316401f0271ba0$exports = {};


var $74316401f0271ba0$var$aFunction = function(argument) {
    return $6360851c61ffcb03$exports(argument) ? argument : undefined;
};
$74316401f0271ba0$exports = function(namespace, method) {
    return arguments.length < 2 ? $74316401f0271ba0$var$aFunction($c94afe6b07e4b008$exports[namespace]) : $c94afe6b07e4b008$exports[namespace] && $c94afe6b07e4b008$exports[namespace][method];
};



var $f429fd1b9070552d$exports = {};

$f429fd1b9070552d$exports = $3a4f4365992f575c$exports({}.isPrototypeOf);


var $80f1196ebd6e3561$exports = {};
/* eslint-disable es/no-symbol -- required for testing */ var $b8011da7a235f812$exports = {};
/* eslint-disable es/no-symbol -- required for testing */ var $fe2287d46d95f7f7$exports = {};

var $a3f4379dcfda9f1d$exports = {};
$a3f4379dcfda9f1d$exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";


var $fe2287d46d95f7f7$var$process = $c94afe6b07e4b008$exports.process;
var $fe2287d46d95f7f7$var$Deno = $c94afe6b07e4b008$exports.Deno;
var $fe2287d46d95f7f7$var$versions = $fe2287d46d95f7f7$var$process && $fe2287d46d95f7f7$var$process.versions || $fe2287d46d95f7f7$var$Deno && $fe2287d46d95f7f7$var$Deno.version;
var $fe2287d46d95f7f7$var$v8 = $fe2287d46d95f7f7$var$versions && $fe2287d46d95f7f7$var$versions.v8;
var $fe2287d46d95f7f7$var$match, $fe2287d46d95f7f7$var$version;
if ($fe2287d46d95f7f7$var$v8) {
    $fe2287d46d95f7f7$var$match = $fe2287d46d95f7f7$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $fe2287d46d95f7f7$var$version = $fe2287d46d95f7f7$var$match[0] > 0 && $fe2287d46d95f7f7$var$match[0] < 4 ? 1 : +($fe2287d46d95f7f7$var$match[0] + $fe2287d46d95f7f7$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$fe2287d46d95f7f7$var$version && $a3f4379dcfda9f1d$exports) {
    $fe2287d46d95f7f7$var$match = $a3f4379dcfda9f1d$exports.match(/Edge\/(\d+)/);
    if (!$fe2287d46d95f7f7$var$match || $fe2287d46d95f7f7$var$match[1] >= 74) {
        $fe2287d46d95f7f7$var$match = $a3f4379dcfda9f1d$exports.match(/Chrome\/(\d+)/);
        if ($fe2287d46d95f7f7$var$match) $fe2287d46d95f7f7$var$version = +$fe2287d46d95f7f7$var$match[1];
    }
}
$fe2287d46d95f7f7$exports = $fe2287d46d95f7f7$var$version;




var $b8011da7a235f812$var$$String = $c94afe6b07e4b008$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$b8011da7a235f812$exports = !!Object.getOwnPropertySymbols && !$ef32b2494ec6c4b3$exports(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$b8011da7a235f812$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $fe2287d46d95f7f7$exports && $fe2287d46d95f7f7$exports < 41;
});


$80f1196ebd6e3561$exports = $b8011da7a235f812$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $22d4b42707cf7617$var$$Object = Object;
$22d4b42707cf7617$exports = $80f1196ebd6e3561$exports ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $74316401f0271ba0$exports("Symbol");
    return $6360851c61ffcb03$exports($Symbol) && $f429fd1b9070552d$exports($Symbol.prototype, $22d4b42707cf7617$var$$Object(it));
};


var $49fc24205ad915da$exports = {};
var $d665d4188b1decb6$exports = {};

var $72ab72c146bcdb28$exports = {};
var $72ab72c146bcdb28$var$$String = String;
$72ab72c146bcdb28$exports = function(argument) {
    try {
        return $72ab72c146bcdb28$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $d665d4188b1decb6$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$d665d4188b1decb6$exports = function(argument) {
    if ($6360851c61ffcb03$exports(argument)) return argument;
    throw $d665d4188b1decb6$var$$TypeError($72ab72c146bcdb28$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$49fc24205ad915da$exports = function(V, P) {
    var func = V[P];
    return $6af58eea9c591e93$exports(func) ? undefined : $d665d4188b1decb6$exports(func);
};


var $c3ea5e11db476407$exports = {};



var $c3ea5e11db476407$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$c3ea5e11db476407$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $6360851c61ffcb03$exports(fn = input.toString) && !$cce056444d1847a8$exports(val = $2ab4df4e491115dd$exports(fn, input))) return val;
    if ($6360851c61ffcb03$exports(fn = input.valueOf) && !$cce056444d1847a8$exports(val = $2ab4df4e491115dd$exports(fn, input))) return val;
    if (pref !== "string" && $6360851c61ffcb03$exports(fn = input.toString) && !$cce056444d1847a8$exports(val = $2ab4df4e491115dd$exports(fn, input))) return val;
    throw $c3ea5e11db476407$var$$TypeError("Can't convert object to primitive value");
};


var $d3b65df0ab9cf9ba$exports = {};

var $3ff63154339103aa$exports = {};
var $c579a4c84417e00b$exports = {};
$c579a4c84417e00b$exports = false;


var $02ce69f442582777$exports = {};

var $640886f6bd52a7e9$exports = {};

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $640886f6bd52a7e9$var$defineProperty = Object.defineProperty;
$640886f6bd52a7e9$exports = function(key, value) {
    try {
        $640886f6bd52a7e9$var$defineProperty($c94afe6b07e4b008$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $c94afe6b07e4b008$exports[key] = value;
    }
    return value;
};


var $02ce69f442582777$var$SHARED = "__core-js_shared__";
var $02ce69f442582777$var$store = $c94afe6b07e4b008$exports[$02ce69f442582777$var$SHARED] || $640886f6bd52a7e9$exports($02ce69f442582777$var$SHARED, {});
$02ce69f442582777$exports = $02ce69f442582777$var$store;


($3ff63154339103aa$exports = function(key, value) {
    return $02ce69f442582777$exports[key] || ($02ce69f442582777$exports[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.30.2",
    mode: $c579a4c84417e00b$exports ? "pure" : "global",
    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.30.2/LICENSE",
    source: "https://github.com/zloirock/core-js"
});


var $aeee4efb6730916c$exports = {};

var $81779dc9898e79e5$exports = {};

var $81779dc9898e79e5$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$81779dc9898e79e5$exports = function(argument) {
    return $81779dc9898e79e5$var$$Object($07b613168e2ab3af$exports(argument));
};


var $aeee4efb6730916c$var$hasOwnProperty = $3a4f4365992f575c$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$aeee4efb6730916c$exports = Object.hasOwn || function hasOwn(it, key) {
    return $aeee4efb6730916c$var$hasOwnProperty($81779dc9898e79e5$exports(it), key);
};


var $bdacb002ab659a72$exports = {};

var $bdacb002ab659a72$var$id = 0;
var $bdacb002ab659a72$var$postfix = Math.random();
var $bdacb002ab659a72$var$toString = $3a4f4365992f575c$exports(1.0.toString);
$bdacb002ab659a72$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $bdacb002ab659a72$var$toString(++$bdacb002ab659a72$var$id + $bdacb002ab659a72$var$postfix, 36);
};




var $d3b65df0ab9cf9ba$var$Symbol = $c94afe6b07e4b008$exports.Symbol;
var $d3b65df0ab9cf9ba$var$WellKnownSymbolsStore = $3ff63154339103aa$exports("wks");
var $d3b65df0ab9cf9ba$var$createWellKnownSymbol = $80f1196ebd6e3561$exports ? $d3b65df0ab9cf9ba$var$Symbol["for"] || $d3b65df0ab9cf9ba$var$Symbol : $d3b65df0ab9cf9ba$var$Symbol && $d3b65df0ab9cf9ba$var$Symbol.withoutSetter || $bdacb002ab659a72$exports;
$d3b65df0ab9cf9ba$exports = function(name) {
    if (!$aeee4efb6730916c$exports($d3b65df0ab9cf9ba$var$WellKnownSymbolsStore, name)) $d3b65df0ab9cf9ba$var$WellKnownSymbolsStore[name] = $b8011da7a235f812$exports && $aeee4efb6730916c$exports($d3b65df0ab9cf9ba$var$Symbol, name) ? $d3b65df0ab9cf9ba$var$Symbol[name] : $d3b65df0ab9cf9ba$var$createWellKnownSymbol("Symbol." + name);
    return $d3b65df0ab9cf9ba$var$WellKnownSymbolsStore[name];
};


var $c46b4f71deec6dfb$var$$TypeError = TypeError;
var $c46b4f71deec6dfb$var$TO_PRIMITIVE = $d3b65df0ab9cf9ba$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$c46b4f71deec6dfb$exports = function(input, pref) {
    if (!$cce056444d1847a8$exports(input) || $22d4b42707cf7617$exports(input)) return input;
    var exoticToPrim = $49fc24205ad915da$exports(input, $c46b4f71deec6dfb$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $2ab4df4e491115dd$exports(exoticToPrim, input, pref);
        if (!$cce056444d1847a8$exports(result) || $22d4b42707cf7617$exports(result)) return result;
        throw $c46b4f71deec6dfb$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $c3ea5e11db476407$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$370318bc9914ee65$exports = function(argument) {
    var key = $c46b4f71deec6dfb$exports(argument, "string");
    return $22d4b42707cf7617$exports(key) ? key : key + "";
};



var $198fe53414e19fcc$exports = {};


var $cf3d32772bfe98bc$exports = {};


var $cf3d32772bfe98bc$var$document = $c94afe6b07e4b008$exports.document;
// typeof document.createElement is 'object' in old IE
var $cf3d32772bfe98bc$var$EXISTS = $cce056444d1847a8$exports($cf3d32772bfe98bc$var$document) && $cce056444d1847a8$exports($cf3d32772bfe98bc$var$document.createElement);
$cf3d32772bfe98bc$exports = function(it) {
    return $cf3d32772bfe98bc$var$EXISTS ? $cf3d32772bfe98bc$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$198fe53414e19fcc$exports = !$7ac8bc7445a1c6e0$exports && !$ef32b2494ec6c4b3$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($cf3d32772bfe98bc$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $7a28878efd9ccfee$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$7a28878efd9ccfee$export$2d1720544b23b823 = $7ac8bc7445a1c6e0$exports ? $7a28878efd9ccfee$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $e68f8d5c7ad91934$exports(O);
    P = $370318bc9914ee65$exports(P);
    if ($198fe53414e19fcc$exports) try {
        return $7a28878efd9ccfee$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($aeee4efb6730916c$exports(O, P)) return $9b24751660596f9a$exports(!$2ab4df4e491115dd$exports($5682c6ae0a1be4a8$export$2d1720544b23b823, O, P), O[P]);
};


var $bffd16f10628412f$require$getOwnPropertyDescriptor = $7a28878efd9ccfee$export$2d1720544b23b823;
var $654a7e7a1347aced$exports = {};

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $db0aedc83a0358c9$export$2d1720544b23b823;


var $9c9eb9b8589380d9$exports = {};


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$9c9eb9b8589380d9$exports = $7ac8bc7445a1c6e0$exports && $ef32b2494ec6c4b3$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});


var $5ee1781b28807bc6$exports = {};

var $5ee1781b28807bc6$var$$String = String;
var $5ee1781b28807bc6$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$5ee1781b28807bc6$exports = function(argument) {
    if ($cce056444d1847a8$exports(argument)) return argument;
    throw $5ee1781b28807bc6$var$$TypeError($5ee1781b28807bc6$var$$String(argument) + " is not an object");
};



var $db0aedc83a0358c9$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $db0aedc83a0358c9$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $db0aedc83a0358c9$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $db0aedc83a0358c9$var$ENUMERABLE = "enumerable";
var $db0aedc83a0358c9$var$CONFIGURABLE = "configurable";
var $db0aedc83a0358c9$var$WRITABLE = "writable";
$db0aedc83a0358c9$export$2d1720544b23b823 = $7ac8bc7445a1c6e0$exports ? $9c9eb9b8589380d9$exports ? function defineProperty(O, P, Attributes) {
    $5ee1781b28807bc6$exports(O);
    P = $370318bc9914ee65$exports(P);
    $5ee1781b28807bc6$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $db0aedc83a0358c9$var$WRITABLE in Attributes && !Attributes[$db0aedc83a0358c9$var$WRITABLE]) {
        var current = $db0aedc83a0358c9$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$db0aedc83a0358c9$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $db0aedc83a0358c9$var$CONFIGURABLE in Attributes ? Attributes[$db0aedc83a0358c9$var$CONFIGURABLE] : current[$db0aedc83a0358c9$var$CONFIGURABLE],
                enumerable: $db0aedc83a0358c9$var$ENUMERABLE in Attributes ? Attributes[$db0aedc83a0358c9$var$ENUMERABLE] : current[$db0aedc83a0358c9$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $db0aedc83a0358c9$var$$defineProperty(O, P, Attributes);
} : $db0aedc83a0358c9$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $5ee1781b28807bc6$exports(O);
    P = $370318bc9914ee65$exports(P);
    $5ee1781b28807bc6$exports(Attributes);
    if ($198fe53414e19fcc$exports) try {
        return $db0aedc83a0358c9$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $db0aedc83a0358c9$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};



$654a7e7a1347aced$exports = $7ac8bc7445a1c6e0$exports ? function(object, key, value) {
    return $db0aedc83a0358c9$export$2d1720544b23b823(object, key, $9b24751660596f9a$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $af717a8ded55fc97$exports = {};


var $1d083c78c0d1b21c$exports = {};





var $d3cc933ed77ed9b5$exports = {};


var $d3cc933ed77ed9b5$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $d3cc933ed77ed9b5$var$getDescriptor = $7ac8bc7445a1c6e0$exports && Object.getOwnPropertyDescriptor;
var $d3cc933ed77ed9b5$var$EXISTS = $aeee4efb6730916c$exports($d3cc933ed77ed9b5$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $d3cc933ed77ed9b5$var$PROPER = $d3cc933ed77ed9b5$var$EXISTS && (function something() {}).name === "something";
var $d3cc933ed77ed9b5$var$CONFIGURABLE = $d3cc933ed77ed9b5$var$EXISTS && (!$7ac8bc7445a1c6e0$exports || $7ac8bc7445a1c6e0$exports && $d3cc933ed77ed9b5$var$getDescriptor($d3cc933ed77ed9b5$var$FunctionPrototype, "name").configurable);
$d3cc933ed77ed9b5$exports = {
    EXISTS: $d3cc933ed77ed9b5$var$EXISTS,
    PROPER: $d3cc933ed77ed9b5$var$PROPER,
    CONFIGURABLE: $d3cc933ed77ed9b5$var$CONFIGURABLE
};


var $1d083c78c0d1b21c$require$CONFIGURABLE_FUNCTION_NAME = $d3cc933ed77ed9b5$exports.CONFIGURABLE;
var $dccd36bd9990bb14$exports = {};



var $dccd36bd9990bb14$var$functionToString = $3a4f4365992f575c$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$6360851c61ffcb03$exports($02ce69f442582777$exports.inspectSource)) $02ce69f442582777$exports.inspectSource = function(it) {
    return $dccd36bd9990bb14$var$functionToString(it);
};
$dccd36bd9990bb14$exports = $02ce69f442582777$exports.inspectSource;


var $b73686b75f23202c$exports = {};
var $e6f6f1e06a433946$exports = {};


var $e6f6f1e06a433946$var$WeakMap = $c94afe6b07e4b008$exports.WeakMap;
$e6f6f1e06a433946$exports = $6360851c61ffcb03$exports($e6f6f1e06a433946$var$WeakMap) && /native code/.test(String($e6f6f1e06a433946$var$WeakMap));







var $ad12f0a7860a35c0$exports = {};


var $ad12f0a7860a35c0$var$keys = $3ff63154339103aa$exports("keys");
$ad12f0a7860a35c0$exports = function(key) {
    return $ad12f0a7860a35c0$var$keys[key] || ($ad12f0a7860a35c0$var$keys[key] = $bdacb002ab659a72$exports(key));
};


var $070e64e6316bdf8a$exports = {};
$070e64e6316bdf8a$exports = {};


var $b73686b75f23202c$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $b73686b75f23202c$var$TypeError = $c94afe6b07e4b008$exports.TypeError;
var $b73686b75f23202c$var$WeakMap = $c94afe6b07e4b008$exports.WeakMap;
var $b73686b75f23202c$var$set, $b73686b75f23202c$var$get, $b73686b75f23202c$var$has;
var $b73686b75f23202c$var$enforce = function(it) {
    return $b73686b75f23202c$var$has(it) ? $b73686b75f23202c$var$get(it) : $b73686b75f23202c$var$set(it, {});
};
var $b73686b75f23202c$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$cce056444d1847a8$exports(it) || (state = $b73686b75f23202c$var$get(it)).type !== TYPE) throw $b73686b75f23202c$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($e6f6f1e06a433946$exports || $02ce69f442582777$exports.state) {
    var $b73686b75f23202c$var$store = $02ce69f442582777$exports.state || ($02ce69f442582777$exports.state = new $b73686b75f23202c$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $b73686b75f23202c$var$store.get = $b73686b75f23202c$var$store.get;
    $b73686b75f23202c$var$store.has = $b73686b75f23202c$var$store.has;
    $b73686b75f23202c$var$store.set = $b73686b75f23202c$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $b73686b75f23202c$var$set = function(it, metadata) {
        if ($b73686b75f23202c$var$store.has(it)) throw $b73686b75f23202c$var$TypeError($b73686b75f23202c$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $b73686b75f23202c$var$store.set(it, metadata);
        return metadata;
    };
    $b73686b75f23202c$var$get = function(it) {
        return $b73686b75f23202c$var$store.get(it) || {};
    };
    $b73686b75f23202c$var$has = function(it) {
        return $b73686b75f23202c$var$store.has(it);
    };
} else {
    var $b73686b75f23202c$var$STATE = $ad12f0a7860a35c0$exports("state");
    $070e64e6316bdf8a$exports[$b73686b75f23202c$var$STATE] = true;
    $b73686b75f23202c$var$set = function(it, metadata) {
        if ($aeee4efb6730916c$exports(it, $b73686b75f23202c$var$STATE)) throw $b73686b75f23202c$var$TypeError($b73686b75f23202c$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $654a7e7a1347aced$exports(it, $b73686b75f23202c$var$STATE, metadata);
        return metadata;
    };
    $b73686b75f23202c$var$get = function(it) {
        return $aeee4efb6730916c$exports(it, $b73686b75f23202c$var$STATE) ? it[$b73686b75f23202c$var$STATE] : {};
    };
    $b73686b75f23202c$var$has = function(it) {
        return $aeee4efb6730916c$exports(it, $b73686b75f23202c$var$STATE);
    };
}
$b73686b75f23202c$exports = {
    set: $b73686b75f23202c$var$set,
    get: $b73686b75f23202c$var$get,
    has: $b73686b75f23202c$var$has,
    enforce: $b73686b75f23202c$var$enforce,
    getterFor: $b73686b75f23202c$var$getterFor
};


var $1d083c78c0d1b21c$var$enforceInternalState = $b73686b75f23202c$exports.enforce;
var $1d083c78c0d1b21c$var$getInternalState = $b73686b75f23202c$exports.get;
var $1d083c78c0d1b21c$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $1d083c78c0d1b21c$var$defineProperty = Object.defineProperty;
var $1d083c78c0d1b21c$var$stringSlice = $3a4f4365992f575c$exports("".slice);
var $1d083c78c0d1b21c$var$replace = $3a4f4365992f575c$exports("".replace);
var $1d083c78c0d1b21c$var$join = $3a4f4365992f575c$exports([].join);
var $1d083c78c0d1b21c$var$CONFIGURABLE_LENGTH = $7ac8bc7445a1c6e0$exports && !$ef32b2494ec6c4b3$exports(function() {
    return $1d083c78c0d1b21c$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $1d083c78c0d1b21c$var$TEMPLATE = String(String).split("String");
var $1d083c78c0d1b21c$var$makeBuiltIn = $1d083c78c0d1b21c$exports = function(value, name, options) {
    if ($1d083c78c0d1b21c$var$stringSlice($1d083c78c0d1b21c$var$$String(name), 0, 7) === "Symbol(") name = "[" + $1d083c78c0d1b21c$var$replace($1d083c78c0d1b21c$var$$String(name), /^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$aeee4efb6730916c$exports(value, "name") || $1d083c78c0d1b21c$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($7ac8bc7445a1c6e0$exports) $1d083c78c0d1b21c$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($1d083c78c0d1b21c$var$CONFIGURABLE_LENGTH && options && $aeee4efb6730916c$exports(options, "arity") && value.length !== options.arity) $1d083c78c0d1b21c$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $aeee4efb6730916c$exports(options, "constructor") && options.constructor) {
            if ($7ac8bc7445a1c6e0$exports) $1d083c78c0d1b21c$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $1d083c78c0d1b21c$var$enforceInternalState(value);
    if (!$aeee4efb6730916c$exports(state, "source")) state.source = $1d083c78c0d1b21c$var$join($1d083c78c0d1b21c$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $1d083c78c0d1b21c$var$makeBuiltIn(function toString() {
    return $6360851c61ffcb03$exports(this) && $1d083c78c0d1b21c$var$getInternalState(this).source || $dccd36bd9990bb14$exports(this);
}, "toString");



$af717a8ded55fc97$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($6360851c61ffcb03$exports(value)) $1d083c78c0d1b21c$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $640886f6bd52a7e9$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $db0aedc83a0358c9$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $71a61108141ba576$exports = {};

var $8e827fa0434aab12$exports = {};


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $b16a270fb3d2ab4f$export$2d1720544b23b823;
var $b218ee0023bf2771$exports = {};



var $e367de4499ecbc5a$exports = {};

var $3743e4b324cabcb7$exports = {};
var $8e4cf644aa33a88e$exports = {};
var $ce825bab43cbef2e$exports = {};
var $ce825bab43cbef2e$var$ceil = Math.ceil;
var $ce825bab43cbef2e$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$ce825bab43cbef2e$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $ce825bab43cbef2e$var$floor : $ce825bab43cbef2e$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$8e4cf644aa33a88e$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $ce825bab43cbef2e$exports(number);
};


var $3743e4b324cabcb7$var$max = Math.max;
var $3743e4b324cabcb7$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$3743e4b324cabcb7$exports = function(index, length) {
    var integer = $8e4cf644aa33a88e$exports(index);
    return integer < 0 ? $3743e4b324cabcb7$var$max(integer + length, 0) : $3743e4b324cabcb7$var$min(integer, length);
};


var $35d003abcb910698$exports = {};
var $d958c37ad7d364d7$exports = {};

var $d958c37ad7d364d7$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$d958c37ad7d364d7$exports = function(argument) {
    return argument > 0 ? $d958c37ad7d364d7$var$min($8e4cf644aa33a88e$exports(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$35d003abcb910698$exports = function(obj) {
    return $d958c37ad7d364d7$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $e367de4499ecbc5a$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $e68f8d5c7ad91934$exports($this);
        var length = $35d003abcb910698$exports(O);
        var index = $3743e4b324cabcb7$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$e367de4499ecbc5a$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $e367de4499ecbc5a$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $e367de4499ecbc5a$var$createMethod(false)
};


var $b218ee0023bf2771$require$indexOf = $e367de4499ecbc5a$exports.indexOf;

var $b218ee0023bf2771$var$push = $3a4f4365992f575c$exports([].push);
$b218ee0023bf2771$exports = function(object, names) {
    var O = $e68f8d5c7ad91934$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$aeee4efb6730916c$exports($070e64e6316bdf8a$exports, key) && $aeee4efb6730916c$exports(O, key) && $b218ee0023bf2771$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($aeee4efb6730916c$exports(O, key = names[i++])) ~$b218ee0023bf2771$require$indexOf(result, key) || $b218ee0023bf2771$var$push(result, key);
    return result;
};


var $21ea08889b8bf21c$exports = {};
// IE8- don't enum bug keys
$21ea08889b8bf21c$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $b16a270fb3d2ab4f$var$hiddenKeys = $21ea08889b8bf21c$exports.concat("length", "prototype");
$b16a270fb3d2ab4f$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $b218ee0023bf2771$exports(O, $b16a270fb3d2ab4f$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $cd26a1774290f2df$export$2d1720544b23b823;
$cd26a1774290f2df$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $8e827fa0434aab12$var$concat = $3a4f4365992f575c$exports([].concat);
// all object keys, includes non-enumerable and symbols
$8e827fa0434aab12$exports = $74316401f0271ba0$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $b16a270fb3d2ab4f$export$2d1720544b23b823($5ee1781b28807bc6$exports(it));
    var getOwnPropertySymbols = $cd26a1774290f2df$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $8e827fa0434aab12$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$71a61108141ba576$exports = function(target, source, exceptions) {
    var keys = $8e827fa0434aab12$exports(source);
    var defineProperty = $db0aedc83a0358c9$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $7a28878efd9ccfee$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$aeee4efb6730916c$exports(target, key) && !(exceptions && $aeee4efb6730916c$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $893af0ba1ae15da8$exports = {};


var $893af0ba1ae15da8$var$replacement = /#|\.prototype\./;
var $893af0ba1ae15da8$var$isForced = function(feature, detection) {
    var value = $893af0ba1ae15da8$var$data[$893af0ba1ae15da8$var$normalize(feature)];
    return value == $893af0ba1ae15da8$var$POLYFILL ? true : value == $893af0ba1ae15da8$var$NATIVE ? false : $6360851c61ffcb03$exports(detection) ? $ef32b2494ec6c4b3$exports(detection) : !!detection;
};
var $893af0ba1ae15da8$var$normalize = $893af0ba1ae15da8$var$isForced.normalize = function(string) {
    return String(string).replace($893af0ba1ae15da8$var$replacement, ".").toLowerCase();
};
var $893af0ba1ae15da8$var$data = $893af0ba1ae15da8$var$isForced.data = {};
var $893af0ba1ae15da8$var$NATIVE = $893af0ba1ae15da8$var$isForced.NATIVE = "N";
var $893af0ba1ae15da8$var$POLYFILL = $893af0ba1ae15da8$var$isForced.POLYFILL = "P";
$893af0ba1ae15da8$exports = $893af0ba1ae15da8$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $bffd16f10628412f$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $c94afe6b07e4b008$exports;
    else if (STATIC) target = $c94afe6b07e4b008$exports[TARGET] || $640886f6bd52a7e9$exports(TARGET, {});
    else target = ($c94afe6b07e4b008$exports[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $bffd16f10628412f$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $893af0ba1ae15da8$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $71a61108141ba576$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $654a7e7a1347aced$exports(sourceProperty, "sham", true);
        $af717a8ded55fc97$exports(target, key, sourceProperty, options);
    }
};


var $5e32ecf4e6f615ac$exports = {};



var $b4875d63765839ce$exports = {};
var $b9d47d27b8f9d0bc$exports = {};
var $4e8e83964608e3d9$exports = {};

var $4e8e83964608e3d9$var$TO_STRING_TAG = $d3b65df0ab9cf9ba$exports("toStringTag");
var $4e8e83964608e3d9$var$test = {};
$4e8e83964608e3d9$var$test[$4e8e83964608e3d9$var$TO_STRING_TAG] = "z";
$4e8e83964608e3d9$exports = String($4e8e83964608e3d9$var$test) === "[object z]";





var $b9d47d27b8f9d0bc$var$TO_STRING_TAG = $d3b65df0ab9cf9ba$exports("toStringTag");
var $b9d47d27b8f9d0bc$var$$Object = Object;
// ES3 wrong here
var $b9d47d27b8f9d0bc$var$CORRECT_ARGUMENTS = $d8174cbb4abc3bad$exports(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $b9d47d27b8f9d0bc$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$b9d47d27b8f9d0bc$exports = $4e8e83964608e3d9$exports ? $d8174cbb4abc3bad$exports : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $b9d47d27b8f9d0bc$var$tryGet(O = $b9d47d27b8f9d0bc$var$$Object(it), $b9d47d27b8f9d0bc$var$TO_STRING_TAG)) == "string" ? tag : $b9d47d27b8f9d0bc$var$CORRECT_ARGUMENTS ? $d8174cbb4abc3bad$exports(O) : (result = $d8174cbb4abc3bad$exports(O)) == "Object" && $6360851c61ffcb03$exports(O.callee) ? "Arguments" : result;
};


var $b4875d63765839ce$var$$String = String;
$b4875d63765839ce$exports = function(argument) {
    if ($b9d47d27b8f9d0bc$exports(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return $b4875d63765839ce$var$$String(argument);
};


var $c9f795ef7527d5ba$exports = {};



var $fe54517bc2bf8e4d$exports = {};
// a string of all valid unicode whitespaces
$fe54517bc2bf8e4d$exports = "	\n\v\f\r \xa0              　\u2028\u2029\uFEFF";


var $c9f795ef7527d5ba$var$replace = $3a4f4365992f575c$exports("".replace);
var $c9f795ef7527d5ba$var$ltrim = RegExp("^[" + $fe54517bc2bf8e4d$exports + "]+");
var $c9f795ef7527d5ba$var$rtrim = RegExp("(^|[^" + $fe54517bc2bf8e4d$exports + "])[" + $fe54517bc2bf8e4d$exports + "]+$");
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var $c9f795ef7527d5ba$var$createMethod = function(TYPE) {
    return function($this) {
        var string = $b4875d63765839ce$exports($07b613168e2ab3af$exports($this));
        if (TYPE & 1) string = $c9f795ef7527d5ba$var$replace(string, $c9f795ef7527d5ba$var$ltrim, "");
        if (TYPE & 2) string = $c9f795ef7527d5ba$var$replace(string, $c9f795ef7527d5ba$var$rtrim, "$1");
        return string;
    };
};
$c9f795ef7527d5ba$exports = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: $c9f795ef7527d5ba$var$createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: $c9f795ef7527d5ba$var$createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: $c9f795ef7527d5ba$var$createMethod(3)
};


var $5e32ecf4e6f615ac$require$trim = $c9f795ef7527d5ba$exports.trim;

var $5e32ecf4e6f615ac$var$$parseInt = $c94afe6b07e4b008$exports.parseInt;
var $5e32ecf4e6f615ac$var$Symbol = $c94afe6b07e4b008$exports.Symbol;
var $5e32ecf4e6f615ac$var$ITERATOR = $5e32ecf4e6f615ac$var$Symbol && $5e32ecf4e6f615ac$var$Symbol.iterator;
var $5e32ecf4e6f615ac$var$hex = /^[+-]?0x/i;
var $5e32ecf4e6f615ac$var$exec = $3a4f4365992f575c$exports($5e32ecf4e6f615ac$var$hex.exec);
var $5e32ecf4e6f615ac$var$FORCED = $5e32ecf4e6f615ac$var$$parseInt($fe54517bc2bf8e4d$exports + "08") !== 8 || $5e32ecf4e6f615ac$var$$parseInt($fe54517bc2bf8e4d$exports + "0x16") !== 22 || $5e32ecf4e6f615ac$var$ITERATOR && !$ef32b2494ec6c4b3$exports(function() {
    $5e32ecf4e6f615ac$var$$parseInt(Object($5e32ecf4e6f615ac$var$ITERATOR));
});
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$5e32ecf4e6f615ac$exports = $5e32ecf4e6f615ac$var$FORCED ? function parseInt(string, radix) {
    var S = $5e32ecf4e6f615ac$require$trim($b4875d63765839ce$exports(string));
    return $5e32ecf4e6f615ac$var$$parseInt(S, radix >>> 0 || ($5e32ecf4e6f615ac$var$exec($5e32ecf4e6f615ac$var$hex, S) ? 16 : 10));
} : $5e32ecf4e6f615ac$var$$parseInt;


// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$bffd16f10628412f$exports({
    global: true,
    forced: parseInt != $5e32ecf4e6f615ac$exports
}, {
    parseInt: $5e32ecf4e6f615ac$exports
});



var $70e028091ee36497$exports = {};
"use strict";




var $f230701e392a2b6c$exports = {};


// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
$f230701e392a2b6c$exports = Object.keys || function keys(O) {
    return $b218ee0023bf2771$exports(O, $21ea08889b8bf21c$exports);
};






// eslint-disable-next-line es/no-object-assign -- safe
var $70e028091ee36497$var$$assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var $70e028091ee36497$var$defineProperty = Object.defineProperty;
var $70e028091ee36497$var$concat = $3a4f4365992f575c$exports([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
$70e028091ee36497$exports = !$70e028091ee36497$var$$assign || $ef32b2494ec6c4b3$exports(function() {
    // should have correct order of operations (Edge bug)
    if ($7ac8bc7445a1c6e0$exports && $70e028091ee36497$var$$assign({
        b: 1
    }, $70e028091ee36497$var$$assign($70e028091ee36497$var$defineProperty({}, "a", {
        enumerable: true,
        get: function() {
            $70e028091ee36497$var$defineProperty(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol();
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $70e028091ee36497$var$$assign({}, A)[symbol] != 7 || $f230701e392a2b6c$exports($70e028091ee36497$var$$assign({}, B)).join("") != alphabet;
}) ? function assign(target, source) {
    var T = $81779dc9898e79e5$exports(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $cd26a1774290f2df$export$2d1720544b23b823;
    var propertyIsEnumerable = $5682c6ae0a1be4a8$export$2d1720544b23b823;
    while(argumentsLength > index){
        var S = $f23c1702314ea5f4$exports(arguments[index++]);
        var keys = getOwnPropertySymbols ? $70e028091ee36497$var$concat($f230701e392a2b6c$exports(S), getOwnPropertySymbols(S)) : $f230701e392a2b6c$exports(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$7ac8bc7445a1c6e0$exports || $2ab4df4e491115dd$exports(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $70e028091ee36497$var$$assign;


// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$bffd16f10628412f$exports({
    target: "Object",
    stat: true,
    arity: 2,
    forced: Object.assign !== $70e028091ee36497$exports
}, {
    assign: $70e028091ee36497$exports
});


"use strict";

var $514ca641655ca4b9$exports = {};
var $b132117486d2e523$exports = {};
var $05060ac73f0e1258$exports = {};


$05060ac73f0e1258$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($d8174cbb4abc3bad$exports(fn) === "Function") return $3a4f4365992f575c$exports(fn);
};




var $b132117486d2e523$var$bind = $05060ac73f0e1258$exports($05060ac73f0e1258$exports.bind);
// optional / simple context binding
$b132117486d2e523$exports = function(fn, that) {
    $d665d4188b1decb6$exports(fn);
    return that === undefined ? fn : $74d92435c568df86$exports ? $b132117486d2e523$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};






var $c05037271cb98f86$exports = {};
var $5b66feb1626d8edf$exports = {};
var $5d01403d1692568e$exports = {};

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
$5d01403d1692568e$exports = Array.isArray || function isArray(argument) {
    return $d8174cbb4abc3bad$exports(argument) == "Array";
};


var $53294eab55adb545$exports = {};






var $53294eab55adb545$var$noop = function() {};
var $53294eab55adb545$var$empty = [];
var $53294eab55adb545$var$construct = $74316401f0271ba0$exports("Reflect", "construct");
var $53294eab55adb545$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $53294eab55adb545$var$exec = $3a4f4365992f575c$exports($53294eab55adb545$var$constructorRegExp.exec);
var $53294eab55adb545$var$INCORRECT_TO_STRING = !$53294eab55adb545$var$constructorRegExp.exec($53294eab55adb545$var$noop);
var $53294eab55adb545$var$isConstructorModern = function isConstructor(argument) {
    if (!$6360851c61ffcb03$exports(argument)) return false;
    try {
        $53294eab55adb545$var$construct($53294eab55adb545$var$noop, $53294eab55adb545$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $53294eab55adb545$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$6360851c61ffcb03$exports(argument)) return false;
    switch($b9d47d27b8f9d0bc$exports(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $53294eab55adb545$var$INCORRECT_TO_STRING || !!$53294eab55adb545$var$exec($53294eab55adb545$var$constructorRegExp, $dccd36bd9990bb14$exports(argument));
    } catch (error) {
        return true;
    }
};
$53294eab55adb545$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
$53294eab55adb545$exports = !$53294eab55adb545$var$construct || $ef32b2494ec6c4b3$exports(function() {
    var called;
    return $53294eab55adb545$var$isConstructorModern($53294eab55adb545$var$isConstructorModern.call) || !$53294eab55adb545$var$isConstructorModern(Object) || !$53294eab55adb545$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $53294eab55adb545$var$isConstructorLegacy : $53294eab55adb545$var$isConstructorModern;




var $5b66feb1626d8edf$var$SPECIES = $d3b65df0ab9cf9ba$exports("species");
var $5b66feb1626d8edf$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$5b66feb1626d8edf$exports = function(originalArray) {
    var C;
    if ($5d01403d1692568e$exports(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($53294eab55adb545$exports(C) && (C === $5b66feb1626d8edf$var$$Array || $5d01403d1692568e$exports(C.prototype))) C = undefined;
        else if ($cce056444d1847a8$exports(C)) {
            C = C[$5b66feb1626d8edf$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $5b66feb1626d8edf$var$$Array : C;
};


// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$c05037271cb98f86$exports = function(originalArray, length) {
    return new ($5b66feb1626d8edf$exports(originalArray))(length === 0 ? 0 : length);
};


var $514ca641655ca4b9$var$push = $3a4f4365992f575c$exports([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $514ca641655ca4b9$var$createMethod = function(TYPE) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var IS_FILTER_REJECT = TYPE == 7;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $81779dc9898e79e5$exports($this);
        var self = $f23c1702314ea5f4$exports(O);
        var boundFunction = $b132117486d2e523$exports(callbackfn, that);
        var length = $35d003abcb910698$exports(self);
        var index = 0;
        var create = specificCreate || $c05037271cb98f86$exports;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $514ca641655ca4b9$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $514ca641655ca4b9$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
$514ca641655ca4b9$exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $514ca641655ca4b9$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $514ca641655ca4b9$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $514ca641655ca4b9$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $514ca641655ca4b9$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $514ca641655ca4b9$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $514ca641655ca4b9$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $514ca641655ca4b9$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $514ca641655ca4b9$var$createMethod(7)
};


var $ad957b625e74b392$require$$filter = $514ca641655ca4b9$exports.filter;
var $e98e9bb60aa4b65c$exports = {};



var $e98e9bb60aa4b65c$var$SPECIES = $d3b65df0ab9cf9ba$exports("species");
$e98e9bb60aa4b65c$exports = function(METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return $fe2287d46d95f7f7$exports >= 51 || !$ef32b2494ec6c4b3$exports(function() {
        var array = [];
        var constructor = array.constructor = {};
        constructor[$e98e9bb60aa4b65c$var$SPECIES] = function() {
            return {
                foo: 1
            };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
    });
};


var $ad957b625e74b392$var$HAS_SPECIES_SUPPORT = $e98e9bb60aa4b65c$exports("filter");
// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$bffd16f10628412f$exports({
    target: "Array",
    proto: true,
    forced: !$ad957b625e74b392$var$HAS_SPECIES_SUPPORT
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $ad957b625e74b392$require$$filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});




var $1780fd2043bc3b5a$exports = {};
"use strict";


// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
$1780fd2043bc3b5a$exports = $4e8e83964608e3d9$exports ? ({}).toString : function toString() {
    return "[object " + $b9d47d27b8f9d0bc$exports(this) + "]";
};


// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!$4e8e83964608e3d9$exports) $af717a8ded55fc97$exports(Object.prototype, "toString", $1780fd2043bc3b5a$exports, {
    unsafe: true
});


var $94bffd642bf82e15$exports = {};
"use strict";

var $3923c63ff20d4602$exports = {};

var $c3b0d4e509da0a13$exports = {};
/* global ActiveXObject -- old IE, WSH */ 
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $09c5a49021b7ed65$export$2d1720544b23b823;






$09c5a49021b7ed65$export$2d1720544b23b823 = $7ac8bc7445a1c6e0$exports && !$9c9eb9b8589380d9$exports ? Object.defineProperties : function defineProperties(O, Properties) {
    $5ee1781b28807bc6$exports(O);
    var props = $e68f8d5c7ad91934$exports(Properties);
    var keys = $f230701e392a2b6c$exports(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$db0aedc83a0358c9$export$2d1720544b23b823(O, key = keys[index++], props[key]);
    return O;
};




var $7dd7234aecee320a$exports = {};

$7dd7234aecee320a$exports = $74316401f0271ba0$exports("document", "documentElement");




var $c3b0d4e509da0a13$var$GT = ">";
var $c3b0d4e509da0a13$var$LT = "<";
var $c3b0d4e509da0a13$var$PROTOTYPE = "prototype";
var $c3b0d4e509da0a13$var$SCRIPT = "script";
var $c3b0d4e509da0a13$var$IE_PROTO = $ad12f0a7860a35c0$exports("IE_PROTO");
var $c3b0d4e509da0a13$var$EmptyConstructor = function() {};
var $c3b0d4e509da0a13$var$scriptTag = function(content) {
    return $c3b0d4e509da0a13$var$LT + $c3b0d4e509da0a13$var$SCRIPT + $c3b0d4e509da0a13$var$GT + content + $c3b0d4e509da0a13$var$LT + "/" + $c3b0d4e509da0a13$var$SCRIPT + $c3b0d4e509da0a13$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $c3b0d4e509da0a13$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($c3b0d4e509da0a13$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $c3b0d4e509da0a13$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $cf3d32772bfe98bc$exports("iframe");
    var JS = "java" + $c3b0d4e509da0a13$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $7dd7234aecee320a$exports.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($c3b0d4e509da0a13$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $c3b0d4e509da0a13$var$activeXDocument;
var $c3b0d4e509da0a13$var$NullProtoObject = function() {
    try {
        $c3b0d4e509da0a13$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $c3b0d4e509da0a13$var$NullProtoObject = typeof document != "undefined" ? document.domain && $c3b0d4e509da0a13$var$activeXDocument ? $c3b0d4e509da0a13$var$NullProtoObjectViaActiveX($c3b0d4e509da0a13$var$activeXDocument) // old IE
     : $c3b0d4e509da0a13$var$NullProtoObjectViaIFrame() : $c3b0d4e509da0a13$var$NullProtoObjectViaActiveX($c3b0d4e509da0a13$var$activeXDocument); // WSH
    var length = $21ea08889b8bf21c$exports.length;
    while(length--)delete $c3b0d4e509da0a13$var$NullProtoObject[$c3b0d4e509da0a13$var$PROTOTYPE][$21ea08889b8bf21c$exports[length]];
    return $c3b0d4e509da0a13$var$NullProtoObject();
};
$070e64e6316bdf8a$exports[$c3b0d4e509da0a13$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
$c3b0d4e509da0a13$exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $c3b0d4e509da0a13$var$EmptyConstructor[$c3b0d4e509da0a13$var$PROTOTYPE] = $5ee1781b28807bc6$exports(O);
        result = new $c3b0d4e509da0a13$var$EmptyConstructor();
        $c3b0d4e509da0a13$var$EmptyConstructor[$c3b0d4e509da0a13$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$c3b0d4e509da0a13$var$IE_PROTO] = O;
    } else result = $c3b0d4e509da0a13$var$NullProtoObject();
    return Properties === undefined ? result : $09c5a49021b7ed65$export$2d1720544b23b823(result, Properties);
};



var $3923c63ff20d4602$require$defineProperty = $db0aedc83a0358c9$export$2d1720544b23b823;
var $3923c63ff20d4602$var$UNSCOPABLES = $d3b65df0ab9cf9ba$exports("unscopables");
var $3923c63ff20d4602$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($3923c63ff20d4602$var$ArrayPrototype[$3923c63ff20d4602$var$UNSCOPABLES] == undefined) $3923c63ff20d4602$require$defineProperty($3923c63ff20d4602$var$ArrayPrototype, $3923c63ff20d4602$var$UNSCOPABLES, {
    configurable: true,
    value: $c3b0d4e509da0a13$exports(null)
});
// add a key to Array.prototype[@@unscopables]
$3923c63ff20d4602$exports = function(key) {
    $3923c63ff20d4602$var$ArrayPrototype[$3923c63ff20d4602$var$UNSCOPABLES][key] = true;
};


var $0e906abec883531e$exports = {};
$0e906abec883531e$exports = {};




var $94bffd642bf82e15$require$defineProperty = $db0aedc83a0358c9$export$2d1720544b23b823;
var $d529f9d1b3911fcb$exports = {};
"use strict";





var $96da84a520342337$exports = {};
"use strict";
var $cc94909a7a910942$exports = {};
"use strict";




var $6cf582a0b0c12dc7$exports = {};




var $ba462c207ef5c083$exports = {};

$ba462c207ef5c083$exports = !$ef32b2494ec6c4b3$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $6cf582a0b0c12dc7$var$IE_PROTO = $ad12f0a7860a35c0$exports("IE_PROTO");
var $6cf582a0b0c12dc7$var$$Object = Object;
var $6cf582a0b0c12dc7$var$ObjectPrototype = $6cf582a0b0c12dc7$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$6cf582a0b0c12dc7$exports = $ba462c207ef5c083$exports ? $6cf582a0b0c12dc7$var$$Object.getPrototypeOf : function(O) {
    var object = $81779dc9898e79e5$exports(O);
    if ($aeee4efb6730916c$exports(object, $6cf582a0b0c12dc7$var$IE_PROTO)) return object[$6cf582a0b0c12dc7$var$IE_PROTO];
    var constructor = object.constructor;
    if ($6360851c61ffcb03$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $6cf582a0b0c12dc7$var$$Object ? $6cf582a0b0c12dc7$var$ObjectPrototype : null;
};





var $cc94909a7a910942$var$ITERATOR = $d3b65df0ab9cf9ba$exports("iterator");
var $cc94909a7a910942$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $cc94909a7a910942$var$IteratorPrototype, $cc94909a7a910942$var$PrototypeOfArrayIteratorPrototype, $cc94909a7a910942$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $cc94909a7a910942$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $cc94909a7a910942$var$arrayIterator)) $cc94909a7a910942$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $cc94909a7a910942$var$PrototypeOfArrayIteratorPrototype = $6cf582a0b0c12dc7$exports($6cf582a0b0c12dc7$exports($cc94909a7a910942$var$arrayIterator));
        if ($cc94909a7a910942$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $cc94909a7a910942$var$IteratorPrototype = $cc94909a7a910942$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $cc94909a7a910942$var$NEW_ITERATOR_PROTOTYPE = !$cce056444d1847a8$exports($cc94909a7a910942$var$IteratorPrototype) || $ef32b2494ec6c4b3$exports(function() {
    var test = {};
    // FF44- legacy iterators case
    return $cc94909a7a910942$var$IteratorPrototype[$cc94909a7a910942$var$ITERATOR].call(test) !== test;
});
if ($cc94909a7a910942$var$NEW_ITERATOR_PROTOTYPE) $cc94909a7a910942$var$IteratorPrototype = {};
else if ($c579a4c84417e00b$exports) $cc94909a7a910942$var$IteratorPrototype = $c3b0d4e509da0a13$exports($cc94909a7a910942$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$6360851c61ffcb03$exports($cc94909a7a910942$var$IteratorPrototype[$cc94909a7a910942$var$ITERATOR])) $af717a8ded55fc97$exports($cc94909a7a910942$var$IteratorPrototype, $cc94909a7a910942$var$ITERATOR, function() {
    return this;
});
$cc94909a7a910942$exports = {
    IteratorPrototype: $cc94909a7a910942$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $cc94909a7a910942$var$BUGGY_SAFARI_ITERATORS
};


var $96da84a520342337$require$IteratorPrototype = $cc94909a7a910942$exports.IteratorPrototype;


var $4bd97b1ef9cf1f68$exports = {};

var $4bd97b1ef9cf1f68$require$defineProperty = $db0aedc83a0358c9$export$2d1720544b23b823;


var $4bd97b1ef9cf1f68$var$TO_STRING_TAG = $d3b65df0ab9cf9ba$exports("toStringTag");
$4bd97b1ef9cf1f68$exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$aeee4efb6730916c$exports(target, $4bd97b1ef9cf1f68$var$TO_STRING_TAG)) $4bd97b1ef9cf1f68$require$defineProperty(target, $4bd97b1ef9cf1f68$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};



var $96da84a520342337$var$returnThis = function() {
    return this;
};
$96da84a520342337$exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $c3b0d4e509da0a13$exports($96da84a520342337$require$IteratorPrototype, {
        next: $9b24751660596f9a$exports(+!ENUMERABLE_NEXT, next)
    });
    $4bd97b1ef9cf1f68$exports(IteratorConstructor, TO_STRING_TAG, false, true);
    $0e906abec883531e$exports[TO_STRING_TAG] = $96da84a520342337$var$returnThis;
    return IteratorConstructor;
};



var $e016cfa487806eb2$exports = {};
/* eslint-disable no-proto -- safe */ var $0bcea5241be4b5a9$exports = {};


$0bcea5241be4b5a9$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $3a4f4365992f575c$exports($d665d4188b1decb6$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};



var $e8f05470c8e3c1e9$exports = {};

var $e8f05470c8e3c1e9$var$$String = String;
var $e8f05470c8e3c1e9$var$$TypeError = TypeError;
$e8f05470c8e3c1e9$exports = function(argument) {
    if (typeof argument == "object" || $6360851c61ffcb03$exports(argument)) return argument;
    throw $e8f05470c8e3c1e9$var$$TypeError("Can't set " + $e8f05470c8e3c1e9$var$$String(argument) + " as a prototype");
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$e016cfa487806eb2$exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $0bcea5241be4b5a9$exports(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $5ee1781b28807bc6$exports(O);
        $e8f05470c8e3c1e9$exports(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);








var $d529f9d1b3911fcb$var$PROPER_FUNCTION_NAME = $d3cc933ed77ed9b5$exports.PROPER;
var $d529f9d1b3911fcb$var$CONFIGURABLE_FUNCTION_NAME = $d3cc933ed77ed9b5$exports.CONFIGURABLE;
var $d529f9d1b3911fcb$var$IteratorPrototype = $cc94909a7a910942$exports.IteratorPrototype;
var $d529f9d1b3911fcb$var$BUGGY_SAFARI_ITERATORS = $cc94909a7a910942$exports.BUGGY_SAFARI_ITERATORS;
var $d529f9d1b3911fcb$var$ITERATOR = $d3b65df0ab9cf9ba$exports("iterator");
var $d529f9d1b3911fcb$var$KEYS = "keys";
var $d529f9d1b3911fcb$var$VALUES = "values";
var $d529f9d1b3911fcb$var$ENTRIES = "entries";
var $d529f9d1b3911fcb$var$returnThis = function() {
    return this;
};
$d529f9d1b3911fcb$exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $96da84a520342337$exports(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$d529f9d1b3911fcb$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $d529f9d1b3911fcb$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $d529f9d1b3911fcb$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $d529f9d1b3911fcb$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$d529f9d1b3911fcb$var$ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$d529f9d1b3911fcb$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $6cf582a0b0c12dc7$exports(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$c579a4c84417e00b$exports && $6cf582a0b0c12dc7$exports(CurrentIteratorPrototype) !== $d529f9d1b3911fcb$var$IteratorPrototype) {
                if ($e016cfa487806eb2$exports) $e016cfa487806eb2$exports(CurrentIteratorPrototype, $d529f9d1b3911fcb$var$IteratorPrototype);
                else if (!$6360851c61ffcb03$exports(CurrentIteratorPrototype[$d529f9d1b3911fcb$var$ITERATOR])) $af717a8ded55fc97$exports(CurrentIteratorPrototype, $d529f9d1b3911fcb$var$ITERATOR, $d529f9d1b3911fcb$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $4bd97b1ef9cf1f68$exports(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($c579a4c84417e00b$exports) $0e906abec883531e$exports[TO_STRING_TAG] = $d529f9d1b3911fcb$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($d529f9d1b3911fcb$var$PROPER_FUNCTION_NAME && DEFAULT == $d529f9d1b3911fcb$var$VALUES && nativeIterator && nativeIterator.name !== $d529f9d1b3911fcb$var$VALUES) {
        if (!$c579a4c84417e00b$exports && $d529f9d1b3911fcb$var$CONFIGURABLE_FUNCTION_NAME) $654a7e7a1347aced$exports(IterablePrototype, "name", $d529f9d1b3911fcb$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $2ab4df4e491115dd$exports(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($d529f9d1b3911fcb$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($d529f9d1b3911fcb$var$KEYS),
            entries: getIterationMethod($d529f9d1b3911fcb$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($d529f9d1b3911fcb$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $af717a8ded55fc97$exports(IterablePrototype, KEY, methods[KEY]);
        } else $bffd16f10628412f$exports({
            target: NAME,
            proto: true,
            forced: $d529f9d1b3911fcb$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$c579a4c84417e00b$exports || FORCED) && IterablePrototype[$d529f9d1b3911fcb$var$ITERATOR] !== defaultIterator) $af717a8ded55fc97$exports(IterablePrototype, $d529f9d1b3911fcb$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $0e906abec883531e$exports[NAME] = defaultIterator;
    return methods;
};


var $a292e589fca0ecad$exports = {};
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
$a292e589fca0ecad$exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};




var $94bffd642bf82e15$var$ARRAY_ITERATOR = "Array Iterator";
var $94bffd642bf82e15$var$setInternalState = $b73686b75f23202c$exports.set;
var $94bffd642bf82e15$var$getInternalState = $b73686b75f23202c$exports.getterFor($94bffd642bf82e15$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
$94bffd642bf82e15$exports = $d529f9d1b3911fcb$exports(Array, "Array", function(iterated, kind) {
    $94bffd642bf82e15$var$setInternalState(this, {
        type: $94bffd642bf82e15$var$ARRAY_ITERATOR,
        target: $e68f8d5c7ad91934$exports(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $94bffd642bf82e15$var$getInternalState(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return $a292e589fca0ecad$exports(undefined, true);
    }
    if (kind == "keys") return $a292e589fca0ecad$exports(index, false);
    if (kind == "values") return $a292e589fca0ecad$exports(target[index], false);
    return $a292e589fca0ecad$exports([
        index,
        target[index]
    ], false);
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $94bffd642bf82e15$var$values = $0e906abec883531e$exports.Arguments = $0e906abec883531e$exports.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$3923c63ff20d4602$exports("keys");
$3923c63ff20d4602$exports("values");
$3923c63ff20d4602$exports("entries");
// V8 ~ Chrome 45- bug
if (!$c579a4c84417e00b$exports && $7ac8bc7445a1c6e0$exports && $94bffd642bf82e15$var$values.name !== "values") try {
    $94bffd642bf82e15$require$defineProperty($94bffd642bf82e15$var$values, "name", {
        value: "values"
    });
} catch (error) {}


"use strict";
var $8e1afa6f21dd86ff$exports = {};




var $8e1afa6f21dd86ff$var$charAt = $3a4f4365992f575c$exports("".charAt);
var $8e1afa6f21dd86ff$var$charCodeAt = $3a4f4365992f575c$exports("".charCodeAt);
var $8e1afa6f21dd86ff$var$stringSlice = $3a4f4365992f575c$exports("".slice);
var $8e1afa6f21dd86ff$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $b4875d63765839ce$exports($07b613168e2ab3af$exports($this));
        var position = $8e4cf644aa33a88e$exports(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $8e1afa6f21dd86ff$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $8e1afa6f21dd86ff$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $8e1afa6f21dd86ff$var$charAt(S, position) : first : CONVERT_TO_STRING ? $8e1afa6f21dd86ff$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
$8e1afa6f21dd86ff$exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $8e1afa6f21dd86ff$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $8e1afa6f21dd86ff$var$createMethod(true)
};


var $0233b9ff9b327e93$require$charAt = $8e1afa6f21dd86ff$exports.charAt;




var $0233b9ff9b327e93$var$STRING_ITERATOR = "String Iterator";
var $0233b9ff9b327e93$var$setInternalState = $b73686b75f23202c$exports.set;
var $0233b9ff9b327e93$var$getInternalState = $b73686b75f23202c$exports.getterFor($0233b9ff9b327e93$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$d529f9d1b3911fcb$exports(String, "String", function(iterated) {
    $0233b9ff9b327e93$var$setInternalState(this, {
        type: $0233b9ff9b327e93$var$STRING_ITERATOR,
        string: $b4875d63765839ce$exports(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $0233b9ff9b327e93$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $a292e589fca0ecad$exports(undefined, true);
    point = $0233b9ff9b327e93$require$charAt(string, index);
    state.index += point.length;
    return $a292e589fca0ecad$exports(point, false);
});


// TODO: Remove this module from `core-js@4` since it's replaced to module below
"use strict";
var $e653b216fde7b833$exports = {};

$e653b216fde7b833$exports = !$ef32b2494ec6c4b3$exports(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});




var $92524a778dffc57e$exports = {};

$92524a778dffc57e$exports = function(target, src, options) {
    for(var key in src)$af717a8ded55fc97$exports(target, key, src[key], options);
    return target;
};


var $7880a2879e2755a2$exports = {};






var $7880a2879e2755a2$require$defineProperty = $db0aedc83a0358c9$export$2d1720544b23b823;

/* eslint-disable es/no-object-getownpropertynames -- safe */ // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $0e4744ef86631eb3$export$2d1720544b23b823;



var $0e4744ef86631eb3$require$$getOwnPropertyNames = $b16a270fb3d2ab4f$export$2d1720544b23b823;
var $ab075a5d3b8cae59$exports = {};


var $aae123b0fb54dbe5$exports = {};
"use strict";



$aae123b0fb54dbe5$exports = function(object, key, value) {
    var propertyKey = $370318bc9914ee65$exports(key);
    if (propertyKey in object) $db0aedc83a0358c9$export$2d1720544b23b823(object, propertyKey, $9b24751660596f9a$exports(0, value));
    else object[propertyKey] = value;
};


var $ab075a5d3b8cae59$var$$Array = Array;
var $ab075a5d3b8cae59$var$max = Math.max;
$ab075a5d3b8cae59$exports = function(O, start, end) {
    var length = $35d003abcb910698$exports(O);
    var k = $3743e4b324cabcb7$exports(start, length);
    var fin = $3743e4b324cabcb7$exports(end === undefined ? length : end, length);
    var result = $ab075a5d3b8cae59$var$$Array($ab075a5d3b8cae59$var$max(fin - k, 0));
    for(var n = 0; k < fin; k++, n++)$aae123b0fb54dbe5$exports(result, n, O[k]);
    result.length = n;
    return result;
};


var $0e4744ef86631eb3$var$windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $0e4744ef86631eb3$var$getWindowNames = function(it) {
    try {
        return $0e4744ef86631eb3$require$$getOwnPropertyNames(it);
    } catch (error) {
        return $ab075a5d3b8cae59$exports($0e4744ef86631eb3$var$windowNames);
    }
};
$0e4744ef86631eb3$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $0e4744ef86631eb3$var$windowNames && $d8174cbb4abc3bad$exports(it) == "Window" ? $0e4744ef86631eb3$var$getWindowNames(it) : $0e4744ef86631eb3$require$$getOwnPropertyNames($e68f8d5c7ad91934$exports(it));
};


var $3c76a3c797730931$exports = {};



var $bd32c5e18274bf33$exports = {};
// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it

$bd32c5e18274bf33$exports = $ef32b2494ec6c4b3$exports(function() {
    if (typeof ArrayBuffer == "function") {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, "a", {
            value: 8
        });
    }
});


// eslint-disable-next-line es/no-object-isextensible -- safe
var $3c76a3c797730931$var$$isExtensible = Object.isExtensible;
var $3c76a3c797730931$var$FAILS_ON_PRIMITIVES = $ef32b2494ec6c4b3$exports(function() {
    $3c76a3c797730931$var$$isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
$3c76a3c797730931$exports = $3c76a3c797730931$var$FAILS_ON_PRIMITIVES || $bd32c5e18274bf33$exports ? function isExtensible(it) {
    if (!$cce056444d1847a8$exports(it)) return false;
    if ($bd32c5e18274bf33$exports && $d8174cbb4abc3bad$exports(it) == "ArrayBuffer") return false;
    return $3c76a3c797730931$var$$isExtensible ? $3c76a3c797730931$var$$isExtensible(it) : true;
} : $3c76a3c797730931$var$$isExtensible;




var $7880a2879e2755a2$var$REQUIRED = false;
var $7880a2879e2755a2$var$METADATA = $bdacb002ab659a72$exports("meta");
var $7880a2879e2755a2$var$id = 0;
var $7880a2879e2755a2$var$setMetadata = function(it) {
    $7880a2879e2755a2$require$defineProperty(it, $7880a2879e2755a2$var$METADATA, {
        value: {
            objectID: "O" + $7880a2879e2755a2$var$id++,
            weakData: {} // weak collections IDs
        }
    });
};
var $7880a2879e2755a2$var$fastKey = function(it, create) {
    // return a primitive with prefix
    if (!$cce056444d1847a8$exports(it)) return typeof it == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
    if (!$aeee4efb6730916c$exports(it, $7880a2879e2755a2$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$3c76a3c797730931$exports(it)) return "F";
        // not necessary to add metadata
        if (!create) return "E";
        // add missing metadata
        $7880a2879e2755a2$var$setMetadata(it);
    // return object ID
    }
    return it[$7880a2879e2755a2$var$METADATA].objectID;
};
var $7880a2879e2755a2$var$getWeakData = function(it, create) {
    if (!$aeee4efb6730916c$exports(it, $7880a2879e2755a2$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$3c76a3c797730931$exports(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $7880a2879e2755a2$var$setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[$7880a2879e2755a2$var$METADATA].weakData;
};
// add metadata on freeze-family methods calling
var $7880a2879e2755a2$var$onFreeze = function(it) {
    if ($e653b216fde7b833$exports && $7880a2879e2755a2$var$REQUIRED && $3c76a3c797730931$exports(it) && !$aeee4efb6730916c$exports(it, $7880a2879e2755a2$var$METADATA)) $7880a2879e2755a2$var$setMetadata(it);
    return it;
};
var $7880a2879e2755a2$var$enable = function() {
    $7880a2879e2755a2$var$meta.enable = function() {};
    $7880a2879e2755a2$var$REQUIRED = true;
    var getOwnPropertyNames = $b16a270fb3d2ab4f$export$2d1720544b23b823;
    var splice = $3a4f4365992f575c$exports([].splice);
    var test = {};
    test[$7880a2879e2755a2$var$METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        $b16a270fb3d2ab4f$export$2d1720544b23b823 = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length = result.length; i < length; i++)if (result[i] === $7880a2879e2755a2$var$METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $bffd16f10628412f$exports({
            target: "Object",
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: $0e4744ef86631eb3$export$2d1720544b23b823
        });
    }
};
var $7880a2879e2755a2$var$meta = $7880a2879e2755a2$exports = {
    enable: $7880a2879e2755a2$var$enable,
    fastKey: $7880a2879e2755a2$var$fastKey,
    getWeakData: $7880a2879e2755a2$var$getWeakData,
    onFreeze: $7880a2879e2755a2$var$onFreeze
};
$070e64e6316bdf8a$exports[$7880a2879e2755a2$var$METADATA] = true;


var $c5fd71b45fe2ee9c$exports = {};
"use strict";






var $a2e4de0c08634121$exports = {};




var $2991b4e1fd8b5573$exports = {};


var $2991b4e1fd8b5573$var$ITERATOR = $d3b65df0ab9cf9ba$exports("iterator");
var $2991b4e1fd8b5573$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$2991b4e1fd8b5573$exports = function(it) {
    return it !== undefined && ($0e906abec883531e$exports.Array === it || $2991b4e1fd8b5573$var$ArrayPrototype[$2991b4e1fd8b5573$var$ITERATOR] === it);
};




var $19a29a0571408342$exports = {};




var $e1df7a663f850531$exports = {};





var $e1df7a663f850531$var$ITERATOR = $d3b65df0ab9cf9ba$exports("iterator");
$e1df7a663f850531$exports = function(it) {
    if (!$6af58eea9c591e93$exports(it)) return $49fc24205ad915da$exports(it, $e1df7a663f850531$var$ITERATOR) || $49fc24205ad915da$exports(it, "@@iterator") || $0e906abec883531e$exports[$b9d47d27b8f9d0bc$exports(it)];
};


var $19a29a0571408342$var$$TypeError = TypeError;
$19a29a0571408342$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $e1df7a663f850531$exports(argument) : usingIterator;
    if ($d665d4188b1decb6$exports(iteratorMethod)) return $5ee1781b28807bc6$exports($2ab4df4e491115dd$exports(iteratorMethod, argument));
    throw $19a29a0571408342$var$$TypeError($72ab72c146bcdb28$exports(argument) + " is not iterable");
};



var $981575170d5b3e8f$exports = {};



$981575170d5b3e8f$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $5ee1781b28807bc6$exports(iterator);
    try {
        innerResult = $49fc24205ad915da$exports(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $2ab4df4e491115dd$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $5ee1781b28807bc6$exports(innerResult);
    return value;
};


var $a2e4de0c08634121$var$$TypeError = TypeError;
var $a2e4de0c08634121$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $a2e4de0c08634121$var$ResultPrototype = $a2e4de0c08634121$var$Result.prototype;
$a2e4de0c08634121$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $b132117486d2e523$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $981575170d5b3e8f$exports(iterator, "normal", condition);
        return new $a2e4de0c08634121$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $5ee1781b28807bc6$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $e1df7a663f850531$exports(iterable);
        if (!iterFn) throw $a2e4de0c08634121$var$$TypeError($72ab72c146bcdb28$exports(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($2991b4e1fd8b5573$exports(iterFn)) {
            for(index = 0, length = $35d003abcb910698$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $f429fd1b9070552d$exports($a2e4de0c08634121$var$ResultPrototype, result)) return result;
            }
            return new $a2e4de0c08634121$var$Result(false);
        }
        iterator = $19a29a0571408342$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $2ab4df4e491115dd$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $981575170d5b3e8f$exports(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $f429fd1b9070552d$exports($a2e4de0c08634121$var$ResultPrototype, result)) return result;
    }
    return new $a2e4de0c08634121$var$Result(false);
};


var $0b4afd533fb758bf$exports = {};

var $0b4afd533fb758bf$var$$TypeError = TypeError;
$0b4afd533fb758bf$exports = function(it, Prototype) {
    if ($f429fd1b9070552d$exports(Prototype, it)) return it;
    throw $0b4afd533fb758bf$var$$TypeError("Incorrect invocation");
};






var $cdbb454c63fc6958$exports = {};

var $cdbb454c63fc6958$var$ITERATOR = $d3b65df0ab9cf9ba$exports("iterator");
var $cdbb454c63fc6958$var$SAFE_CLOSING = false;
try {
    var $cdbb454c63fc6958$var$called = 0;
    var $cdbb454c63fc6958$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$cdbb454c63fc6958$var$called++
            };
        },
        "return": function() {
            $cdbb454c63fc6958$var$SAFE_CLOSING = true;
        }
    };
    $cdbb454c63fc6958$var$iteratorWithReturn[$cdbb454c63fc6958$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($cdbb454c63fc6958$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
$cdbb454c63fc6958$exports = function(exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !$cdbb454c63fc6958$var$SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$cdbb454c63fc6958$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};



var $20cfd355829bb935$exports = {};



// makes subclassing work correct for wrapped built-ins
$20cfd355829bb935$exports = function($this, dummy, Wrapper) {
    var NewTarget, NewTargetPrototype;
    if (// it can work only with native `setPrototypeOf`
    $e016cfa487806eb2$exports && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    $6360851c61ffcb03$exports(NewTarget = dummy.constructor) && NewTarget !== Wrapper && $cce056444d1847a8$exports(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) $e016cfa487806eb2$exports($this, NewTargetPrototype);
    return $this;
};


$c5fd71b45fe2ee9c$exports = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf("Map") !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf("Weak") !== -1;
    var ADDER = IS_MAP ? "set" : "add";
    var NativeConstructor = $c94afe6b07e4b008$exports[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var Constructor = NativeConstructor;
    var exported = {};
    var fixMethod = function(KEY) {
        var uncurriedNativeMethod = $3a4f4365992f575c$exports(NativePrototype[KEY]);
        $af717a8ded55fc97$exports(NativePrototype, KEY, KEY == "add" ? function add(value) {
            uncurriedNativeMethod(this, value === 0 ? 0 : value);
            return this;
        } : KEY == "delete" ? function(key) {
            return IS_WEAK && !$cce056444d1847a8$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY == "get" ? function get(key) {
            return IS_WEAK && !$cce056444d1847a8$exports(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY == "has" ? function has(key) {
            return IS_WEAK && !$cce056444d1847a8$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : function set(key, value) {
            uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
            return this;
        });
    };
    var REPLACE = $893af0ba1ae15da8$exports(CONSTRUCTOR_NAME, !$6360851c61ffcb03$exports(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !$ef32b2494ec6c4b3$exports(function() {
        new NativeConstructor().entries().next();
    })));
    if (REPLACE) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        $7880a2879e2755a2$exports.enable();
    } else if ($893af0ba1ae15da8$exports(CONSTRUCTOR_NAME, true)) {
        var instance = new Constructor();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
        // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = $ef32b2494ec6c4b3$exports(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        // eslint-disable-next-line no-new -- required for testing
        var ACCEPT_ITERABLES = $cdbb454c63fc6958$exports(function(iterable) {
            new NativeConstructor(iterable);
        });
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && $ef32b2494ec6c4b3$exports(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new NativeConstructor();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            Constructor = wrapper(function(dummy, iterable) {
                $0b4afd533fb758bf$exports(dummy, NativePrototype);
                var that = $20cfd355829bb935$exports(new NativeConstructor(), dummy, Constructor);
                if (!$6af58eea9c591e93$exports(iterable)) $a2e4de0c08634121$exports(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP
                });
                return that;
            });
            Constructor.prototype = NativePrototype;
            NativePrototype.constructor = Constructor;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod("delete");
            fixMethod("has");
            IS_MAP && fixMethod("get");
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
    }
    exported[CONSTRUCTOR_NAME] = Constructor;
    $bffd16f10628412f$exports({
        global: true,
        constructor: true,
        forced: Constructor != NativeConstructor
    }, exported);
    $4bd97b1ef9cf1f68$exports(Constructor, CONSTRUCTOR_NAME);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};


var $f3108a1514b99896$exports = {};
"use strict";



var $f3108a1514b99896$require$getWeakData = $7880a2879e2755a2$exports.getWeakData;








var $f3108a1514b99896$var$setInternalState = $b73686b75f23202c$exports.set;
var $f3108a1514b99896$var$internalStateGetterFor = $b73686b75f23202c$exports.getterFor;
var $f3108a1514b99896$var$find = $514ca641655ca4b9$exports.find;
var $f3108a1514b99896$var$findIndex = $514ca641655ca4b9$exports.findIndex;
var $f3108a1514b99896$var$splice = $3a4f4365992f575c$exports([].splice);
var $f3108a1514b99896$var$id = 0;
// fallback for uncaught frozen keys
var $f3108a1514b99896$var$uncaughtFrozenStore = function(state) {
    return state.frozen || (state.frozen = new $f3108a1514b99896$var$UncaughtFrozenStore());
};
var $f3108a1514b99896$var$UncaughtFrozenStore = function() {
    this.entries = [];
};
var $f3108a1514b99896$var$findUncaughtFrozen = function(store, key) {
    return $f3108a1514b99896$var$find(store.entries, function(it) {
        return it[0] === key;
    });
};
$f3108a1514b99896$var$UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = $f3108a1514b99896$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!$f3108a1514b99896$var$findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = $f3108a1514b99896$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    "delete": function(key) {
        var index = $f3108a1514b99896$var$findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) $f3108a1514b99896$var$splice(this.entries, index, 1);
        return !!~index;
    }
};
$f3108a1514b99896$exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $0b4afd533fb758bf$exports(that, Prototype);
            $f3108a1514b99896$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: $f3108a1514b99896$var$id++,
                frozen: undefined
            });
            if (!$6af58eea9c591e93$exports(iterable)) $a2e4de0c08634121$exports(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $f3108a1514b99896$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var data = $f3108a1514b99896$require$getWeakData($5ee1781b28807bc6$exports(key), true);
            if (data === true) $f3108a1514b99896$var$uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        $92524a778dffc57e$exports(Prototype, {
            // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
            // https://tc39.es/ecma262/#sec-weakset.prototype.delete
            "delete": function(key) {
                var state = getInternalState(this);
                if (!$cce056444d1847a8$exports(key)) return false;
                var data = $f3108a1514b99896$require$getWeakData(key);
                if (data === true) return $f3108a1514b99896$var$uncaughtFrozenStore(state)["delete"](key);
                return data && $aeee4efb6730916c$exports(data, state.id) && delete data[state.id];
            },
            // `{ WeakMap, WeakSet }.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.has
            // https://tc39.es/ecma262/#sec-weakset.prototype.has
            has: function has(key) {
                var state = getInternalState(this);
                if (!$cce056444d1847a8$exports(key)) return false;
                var data = $f3108a1514b99896$require$getWeakData(key);
                if (data === true) return $f3108a1514b99896$var$uncaughtFrozenStore(state).has(key);
                return data && $aeee4efb6730916c$exports(data, state.id);
            }
        });
        $92524a778dffc57e$exports(Prototype, IS_MAP ? {
            // `WeakMap.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.get
            get: function get(key) {
                var state = getInternalState(this);
                if ($cce056444d1847a8$exports(key)) {
                    var data = $f3108a1514b99896$require$getWeakData(key);
                    if (data === true) return $f3108a1514b99896$var$uncaughtFrozenStore(state).get(key);
                    return data ? data[state.id] : undefined;
                }
            },
            // `WeakMap.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.set
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // `WeakSet.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-weakset.prototype.add
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return Constructor;
    }
};




var $5d5387f509377118$require$enforceInternalState = $b73686b75f23202c$exports.enforce;


var $5d5387f509377118$var$$Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var $5d5387f509377118$var$isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var $5d5387f509377118$var$isExtensible = $5d5387f509377118$var$$Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var $5d5387f509377118$var$isFrozen = $5d5387f509377118$var$$Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var $5d5387f509377118$var$isSealed = $5d5387f509377118$var$$Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var $5d5387f509377118$var$freeze = $5d5387f509377118$var$$Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var $5d5387f509377118$var$seal = $5d5387f509377118$var$$Object.seal;
var $5d5387f509377118$var$FROZEN = {};
var $5d5387f509377118$var$SEALED = {};
var $5d5387f509377118$var$IS_IE11 = !$c94afe6b07e4b008$exports.ActiveXObject && "ActiveXObject" in $c94afe6b07e4b008$exports;
var $5d5387f509377118$var$InternalWeakMap;
var $5d5387f509377118$var$wrapper = function(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $5d5387f509377118$var$$WeakMap = $c5fd71b45fe2ee9c$exports("WeakMap", $5d5387f509377118$var$wrapper, $f3108a1514b99896$exports);
var $5d5387f509377118$var$WeakMapPrototype = $5d5387f509377118$var$$WeakMap.prototype;
var $5d5387f509377118$var$nativeSet = $3a4f4365992f575c$exports($5d5387f509377118$var$WeakMapPrototype.set);
// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var $5d5387f509377118$var$hasMSEdgeFreezingBug = function() {
    return $e653b216fde7b833$exports && $ef32b2494ec6c4b3$exports(function() {
        var frozenArray = $5d5387f509377118$var$freeze([]);
        $5d5387f509377118$var$nativeSet(new $5d5387f509377118$var$$WeakMap(), frozenArray, 1);
        return !$5d5387f509377118$var$isFrozen(frozenArray);
    });
};
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if ($e6f6f1e06a433946$exports) {
    if ($5d5387f509377118$var$IS_IE11) {
        $5d5387f509377118$var$InternalWeakMap = $f3108a1514b99896$exports.getConstructor($5d5387f509377118$var$wrapper, "WeakMap", true);
        $7880a2879e2755a2$exports.enable();
        var $5d5387f509377118$var$nativeDelete = $3a4f4365992f575c$exports($5d5387f509377118$var$WeakMapPrototype["delete"]);
        var $5d5387f509377118$var$nativeHas = $3a4f4365992f575c$exports($5d5387f509377118$var$WeakMapPrototype.has);
        var $5d5387f509377118$var$nativeGet = $3a4f4365992f575c$exports($5d5387f509377118$var$WeakMapPrototype.get);
        $92524a778dffc57e$exports($5d5387f509377118$var$WeakMapPrototype, {
            "delete": function(key) {
                if ($cce056444d1847a8$exports(key) && !$5d5387f509377118$var$isExtensible(key)) {
                    var state = $5d5387f509377118$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $5d5387f509377118$var$InternalWeakMap();
                    return $5d5387f509377118$var$nativeDelete(this, key) || state.frozen["delete"](key);
                }
                return $5d5387f509377118$var$nativeDelete(this, key);
            },
            has: function has(key) {
                if ($cce056444d1847a8$exports(key) && !$5d5387f509377118$var$isExtensible(key)) {
                    var state = $5d5387f509377118$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $5d5387f509377118$var$InternalWeakMap();
                    return $5d5387f509377118$var$nativeHas(this, key) || state.frozen.has(key);
                }
                return $5d5387f509377118$var$nativeHas(this, key);
            },
            get: function get(key) {
                if ($cce056444d1847a8$exports(key) && !$5d5387f509377118$var$isExtensible(key)) {
                    var state = $5d5387f509377118$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $5d5387f509377118$var$InternalWeakMap();
                    return $5d5387f509377118$var$nativeHas(this, key) ? $5d5387f509377118$var$nativeGet(this, key) : state.frozen.get(key);
                }
                return $5d5387f509377118$var$nativeGet(this, key);
            },
            set: function set(key, value) {
                if ($cce056444d1847a8$exports(key) && !$5d5387f509377118$var$isExtensible(key)) {
                    var state = $5d5387f509377118$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $5d5387f509377118$var$InternalWeakMap();
                    $5d5387f509377118$var$nativeHas(this, key) ? $5d5387f509377118$var$nativeSet(this, key, value) : state.frozen.set(key, value);
                } else $5d5387f509377118$var$nativeSet(this, key, value);
                return this;
            }
        });
    // Chakra Edge frozen keys fix
    } else if ($5d5387f509377118$var$hasMSEdgeFreezingBug()) $92524a778dffc57e$exports($5d5387f509377118$var$WeakMapPrototype, {
        set: function set(key, value) {
            var arrayIntegrityLevel;
            if ($5d5387f509377118$var$isArray(key)) {
                if ($5d5387f509377118$var$isFrozen(key)) arrayIntegrityLevel = $5d5387f509377118$var$FROZEN;
                else if ($5d5387f509377118$var$isSealed(key)) arrayIntegrityLevel = $5d5387f509377118$var$SEALED;
            }
            $5d5387f509377118$var$nativeSet(this, key, value);
            if (arrayIntegrityLevel == $5d5387f509377118$var$FROZEN) $5d5387f509377118$var$freeze(key);
            if (arrayIntegrityLevel == $5d5387f509377118$var$SEALED) $5d5387f509377118$var$seal(key);
            return this;
        }
    });
}





var $25c6c31497cdd67e$exports = {};
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
$25c6c31497cdd67e$exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};


var $00af97bb43fb2f01$exports = {};
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`

var $00af97bb43fb2f01$var$classList = $cf3d32772bfe98bc$exports("span").classList;
var $00af97bb43fb2f01$var$DOMTokenListPrototype = $00af97bb43fb2f01$var$classList && $00af97bb43fb2f01$var$classList.constructor && $00af97bb43fb2f01$var$classList.constructor.prototype;
$00af97bb43fb2f01$exports = $00af97bb43fb2f01$var$DOMTokenListPrototype === Object.prototype ? undefined : $00af97bb43fb2f01$var$DOMTokenListPrototype;





var $d3096f964c0a1eab$var$ITERATOR = $d3b65df0ab9cf9ba$exports("iterator");
var $d3096f964c0a1eab$var$TO_STRING_TAG = $d3b65df0ab9cf9ba$exports("toStringTag");
var $d3096f964c0a1eab$var$ArrayValues = $94bffd642bf82e15$exports.values;
var $d3096f964c0a1eab$var$handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$d3096f964c0a1eab$var$ITERATOR] !== $d3096f964c0a1eab$var$ArrayValues) try {
            $654a7e7a1347aced$exports(CollectionPrototype, $d3096f964c0a1eab$var$ITERATOR, $d3096f964c0a1eab$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$d3096f964c0a1eab$var$ITERATOR] = $d3096f964c0a1eab$var$ArrayValues;
        }
        if (!CollectionPrototype[$d3096f964c0a1eab$var$TO_STRING_TAG]) $654a7e7a1347aced$exports(CollectionPrototype, $d3096f964c0a1eab$var$TO_STRING_TAG, COLLECTION_NAME);
        if ($25c6c31497cdd67e$exports[COLLECTION_NAME]) for(var METHOD_NAME in $94bffd642bf82e15$exports){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $94bffd642bf82e15$exports[METHOD_NAME]) try {
                $654a7e7a1347aced$exports(CollectionPrototype, METHOD_NAME, $94bffd642bf82e15$exports[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $94bffd642bf82e15$exports[METHOD_NAME];
            }
        }
    }
};
for(var $d3096f964c0a1eab$var$COLLECTION_NAME in $25c6c31497cdd67e$exports)$d3096f964c0a1eab$var$handlePrototype($c94afe6b07e4b008$exports[$d3096f964c0a1eab$var$COLLECTION_NAME] && $c94afe6b07e4b008$exports[$d3096f964c0a1eab$var$COLLECTION_NAME].prototype, $d3096f964c0a1eab$var$COLLECTION_NAME);
$d3096f964c0a1eab$var$handlePrototype($00af97bb43fb2f01$exports, "DOMTokenList");


var $125df40737e47992$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $125df40737e47992$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $125df40737e47992$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $125df40737e47992$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $125df40737e47992$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $125df40737e47992$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $125df40737e47992$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $125df40737e47992$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $125df40737e47992$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $125df40737e47992$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $125df40737e47992$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $125df40737e47992$var$root = $125df40737e47992$var$freeGlobal || $125df40737e47992$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $125df40737e47992$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $125df40737e47992$var$objectToString = $125df40737e47992$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $125df40737e47992$var$nativeMax = Math.max, $125df40737e47992$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $125df40737e47992$var$now = function() {
    return $125df40737e47992$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $125df40737e47992$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($125df40737e47992$var$FUNC_ERROR_TEXT);
    wait = $125df40737e47992$var$toNumber(wait) || 0;
    if ($125df40737e47992$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $125df40737e47992$var$nativeMax($125df40737e47992$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $125df40737e47992$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $125df40737e47992$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($125df40737e47992$var$now());
    }
    function debounced() {
        var time = $125df40737e47992$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $125df40737e47992$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($125df40737e47992$var$FUNC_ERROR_TEXT);
    if ($125df40737e47992$var$isObject(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $125df40737e47992$var$debounce(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $125df40737e47992$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $125df40737e47992$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $125df40737e47992$var$isSymbol(value) {
    return typeof value == "symbol" || $125df40737e47992$var$isObjectLike(value) && $125df40737e47992$var$objectToString.call(value) == $125df40737e47992$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $125df40737e47992$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($125df40737e47992$var$isSymbol(value)) return $125df40737e47992$var$NAN;
    if ($125df40737e47992$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $125df40737e47992$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($125df40737e47992$var$reTrim, "");
    var isBinary = $125df40737e47992$var$reIsBinary.test(value);
    return isBinary || $125df40737e47992$var$reIsOctal.test(value) ? $125df40737e47992$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $125df40737e47992$var$reIsBadHex.test(value) ? $125df40737e47992$var$NAN : +value;
}
$125df40737e47992$exports = $125df40737e47992$var$throttle;


var $c50c1c9c64c2d6c8$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $c50c1c9c64c2d6c8$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $c50c1c9c64c2d6c8$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $c50c1c9c64c2d6c8$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $c50c1c9c64c2d6c8$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $c50c1c9c64c2d6c8$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $c50c1c9c64c2d6c8$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $c50c1c9c64c2d6c8$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $c50c1c9c64c2d6c8$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $c50c1c9c64c2d6c8$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $c50c1c9c64c2d6c8$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $c50c1c9c64c2d6c8$var$root = $c50c1c9c64c2d6c8$var$freeGlobal || $c50c1c9c64c2d6c8$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $c50c1c9c64c2d6c8$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $c50c1c9c64c2d6c8$var$objectToString = $c50c1c9c64c2d6c8$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c50c1c9c64c2d6c8$var$nativeMax = Math.max, $c50c1c9c64c2d6c8$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $c50c1c9c64c2d6c8$var$now = function() {
    return $c50c1c9c64c2d6c8$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $c50c1c9c64c2d6c8$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($c50c1c9c64c2d6c8$var$FUNC_ERROR_TEXT);
    wait = $c50c1c9c64c2d6c8$var$toNumber(wait) || 0;
    if ($c50c1c9c64c2d6c8$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $c50c1c9c64c2d6c8$var$nativeMax($c50c1c9c64c2d6c8$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $c50c1c9c64c2d6c8$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $c50c1c9c64c2d6c8$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($c50c1c9c64c2d6c8$var$now());
    }
    function debounced() {
        var time = $c50c1c9c64c2d6c8$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $c50c1c9c64c2d6c8$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $c50c1c9c64c2d6c8$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $c50c1c9c64c2d6c8$var$isSymbol(value) {
    return typeof value == "symbol" || $c50c1c9c64c2d6c8$var$isObjectLike(value) && $c50c1c9c64c2d6c8$var$objectToString.call(value) == $c50c1c9c64c2d6c8$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $c50c1c9c64c2d6c8$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($c50c1c9c64c2d6c8$var$isSymbol(value)) return $c50c1c9c64c2d6c8$var$NAN;
    if ($c50c1c9c64c2d6c8$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $c50c1c9c64c2d6c8$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($c50c1c9c64c2d6c8$var$reTrim, "");
    var isBinary = $c50c1c9c64c2d6c8$var$reIsBinary.test(value);
    return isBinary || $c50c1c9c64c2d6c8$var$reIsOctal.test(value) ? $c50c1c9c64c2d6c8$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $c50c1c9c64c2d6c8$var$reIsBadHex.test(value) ? $c50c1c9c64c2d6c8$var$NAN : +value;
}
$c50c1c9c64c2d6c8$exports = $c50c1c9c64c2d6c8$var$debounce;


var $6aea992dbecd7f96$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $6aea992dbecd7f96$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used to stand-in for `undefined` hash values. */ var $6aea992dbecd7f96$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** `Object#toString` result references. */ var $6aea992dbecd7f96$var$funcTag = "[object Function]", $6aea992dbecd7f96$var$genTag = "[object GeneratorFunction]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $6aea992dbecd7f96$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $6aea992dbecd7f96$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var $6aea992dbecd7f96$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $6aea992dbecd7f96$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $6aea992dbecd7f96$var$root = $6aea992dbecd7f96$var$freeGlobal || $6aea992dbecd7f96$var$freeSelf || Function("return this")();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $6aea992dbecd7f96$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $6aea992dbecd7f96$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/** Used for built-in method references. */ var $6aea992dbecd7f96$var$arrayProto = Array.prototype, $6aea992dbecd7f96$var$funcProto = Function.prototype, $6aea992dbecd7f96$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $6aea992dbecd7f96$var$coreJsData = $6aea992dbecd7f96$var$root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var $6aea992dbecd7f96$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($6aea992dbecd7f96$var$coreJsData && $6aea992dbecd7f96$var$coreJsData.keys && $6aea992dbecd7f96$var$coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var $6aea992dbecd7f96$var$funcToString = $6aea992dbecd7f96$var$funcProto.toString;
/** Used to check objects for own properties. */ var $6aea992dbecd7f96$var$hasOwnProperty = $6aea992dbecd7f96$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $6aea992dbecd7f96$var$objectToString = $6aea992dbecd7f96$var$objectProto.toString;
/** Used to detect if a method is native. */ var $6aea992dbecd7f96$var$reIsNative = RegExp("^" + $6aea992dbecd7f96$var$funcToString.call($6aea992dbecd7f96$var$hasOwnProperty).replace($6aea992dbecd7f96$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var $6aea992dbecd7f96$var$splice = $6aea992dbecd7f96$var$arrayProto.splice;
/* Built-in method references that are verified to be native. */ var $6aea992dbecd7f96$var$Map = $6aea992dbecd7f96$var$getNative($6aea992dbecd7f96$var$root, "Map"), $6aea992dbecd7f96$var$nativeCreate = $6aea992dbecd7f96$var$getNative(Object, "create");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $6aea992dbecd7f96$var$Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $6aea992dbecd7f96$var$hashClear() {
    this.__data__ = $6aea992dbecd7f96$var$nativeCreate ? $6aea992dbecd7f96$var$nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6aea992dbecd7f96$var$hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6aea992dbecd7f96$var$hashGet(key) {
    var data = this.__data__;
    if ($6aea992dbecd7f96$var$nativeCreate) {
        var result = data[key];
        return result === $6aea992dbecd7f96$var$HASH_UNDEFINED ? undefined : result;
    }
    return $6aea992dbecd7f96$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $6aea992dbecd7f96$var$hashHas(key) {
    var data = this.__data__;
    return $6aea992dbecd7f96$var$nativeCreate ? data[key] !== undefined : $6aea992dbecd7f96$var$hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $6aea992dbecd7f96$var$hashSet(key, value) {
    var data = this.__data__;
    data[key] = $6aea992dbecd7f96$var$nativeCreate && value === undefined ? $6aea992dbecd7f96$var$HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
$6aea992dbecd7f96$var$Hash.prototype.clear = $6aea992dbecd7f96$var$hashClear;
$6aea992dbecd7f96$var$Hash.prototype["delete"] = $6aea992dbecd7f96$var$hashDelete;
$6aea992dbecd7f96$var$Hash.prototype.get = $6aea992dbecd7f96$var$hashGet;
$6aea992dbecd7f96$var$Hash.prototype.has = $6aea992dbecd7f96$var$hashHas;
$6aea992dbecd7f96$var$Hash.prototype.set = $6aea992dbecd7f96$var$hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $6aea992dbecd7f96$var$ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $6aea992dbecd7f96$var$listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6aea992dbecd7f96$var$listCacheDelete(key) {
    var data = this.__data__, index = $6aea992dbecd7f96$var$assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $6aea992dbecd7f96$var$splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6aea992dbecd7f96$var$listCacheGet(key) {
    var data = this.__data__, index = $6aea992dbecd7f96$var$assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $6aea992dbecd7f96$var$listCacheHas(key) {
    return $6aea992dbecd7f96$var$assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $6aea992dbecd7f96$var$listCacheSet(key, value) {
    var data = this.__data__, index = $6aea992dbecd7f96$var$assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
$6aea992dbecd7f96$var$ListCache.prototype.clear = $6aea992dbecd7f96$var$listCacheClear;
$6aea992dbecd7f96$var$ListCache.prototype["delete"] = $6aea992dbecd7f96$var$listCacheDelete;
$6aea992dbecd7f96$var$ListCache.prototype.get = $6aea992dbecd7f96$var$listCacheGet;
$6aea992dbecd7f96$var$ListCache.prototype.has = $6aea992dbecd7f96$var$listCacheHas;
$6aea992dbecd7f96$var$ListCache.prototype.set = $6aea992dbecd7f96$var$listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $6aea992dbecd7f96$var$MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $6aea992dbecd7f96$var$mapCacheClear() {
    this.__data__ = {
        "hash": new $6aea992dbecd7f96$var$Hash,
        "map": new ($6aea992dbecd7f96$var$Map || $6aea992dbecd7f96$var$ListCache),
        "string": new $6aea992dbecd7f96$var$Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6aea992dbecd7f96$var$mapCacheDelete(key) {
    return $6aea992dbecd7f96$var$getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6aea992dbecd7f96$var$mapCacheGet(key) {
    return $6aea992dbecd7f96$var$getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $6aea992dbecd7f96$var$mapCacheHas(key) {
    return $6aea992dbecd7f96$var$getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $6aea992dbecd7f96$var$mapCacheSet(key, value) {
    $6aea992dbecd7f96$var$getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
$6aea992dbecd7f96$var$MapCache.prototype.clear = $6aea992dbecd7f96$var$mapCacheClear;
$6aea992dbecd7f96$var$MapCache.prototype["delete"] = $6aea992dbecd7f96$var$mapCacheDelete;
$6aea992dbecd7f96$var$MapCache.prototype.get = $6aea992dbecd7f96$var$mapCacheGet;
$6aea992dbecd7f96$var$MapCache.prototype.has = $6aea992dbecd7f96$var$mapCacheHas;
$6aea992dbecd7f96$var$MapCache.prototype.set = $6aea992dbecd7f96$var$mapCacheSet;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6aea992dbecd7f96$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($6aea992dbecd7f96$var$eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $6aea992dbecd7f96$var$baseIsNative(value) {
    if (!$6aea992dbecd7f96$var$isObject(value) || $6aea992dbecd7f96$var$isMasked(value)) return false;
    var pattern = $6aea992dbecd7f96$var$isFunction(value) || $6aea992dbecd7f96$var$isHostObject(value) ? $6aea992dbecd7f96$var$reIsNative : $6aea992dbecd7f96$var$reIsHostCtor;
    return pattern.test($6aea992dbecd7f96$var$toSource(value));
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $6aea992dbecd7f96$var$getMapData(map, key) {
    var data = map.__data__;
    return $6aea992dbecd7f96$var$isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $6aea992dbecd7f96$var$getNative(object, key) {
    var value = $6aea992dbecd7f96$var$getValue(object, key);
    return $6aea992dbecd7f96$var$baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $6aea992dbecd7f96$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $6aea992dbecd7f96$var$isMasked(func) {
    return !!$6aea992dbecd7f96$var$maskSrcKey && $6aea992dbecd7f96$var$maskSrcKey in func;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $6aea992dbecd7f96$var$toSource(func) {
    if (func != null) {
        try {
            return $6aea992dbecd7f96$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $6aea992dbecd7f96$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError($6aea992dbecd7f96$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new ($6aea992dbecd7f96$var$memoize.Cache || $6aea992dbecd7f96$var$MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
$6aea992dbecd7f96$var$memoize.Cache = $6aea992dbecd7f96$var$MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $6aea992dbecd7f96$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $6aea992dbecd7f96$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $6aea992dbecd7f96$var$isObject(value) ? $6aea992dbecd7f96$var$objectToString.call(value) : "";
    return tag == $6aea992dbecd7f96$var$funcTag || tag == $6aea992dbecd7f96$var$genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $6aea992dbecd7f96$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
$6aea992dbecd7f96$exports = $6aea992dbecd7f96$var$memoize;


var $7c7d936791439820$export$402e76927ebf6a24 = [];


var $5dd2af242e72bae6$export$63c81bd924f89474 = function() {
    return (0, $7c7d936791439820$export$402e76927ebf6a24).some(function(ro) {
        return ro.activeTargets.length > 0;
    });
};



var $e0629372d3f7218c$export$8ca35300535e324d = function() {
    return (0, $7c7d936791439820$export$402e76927ebf6a24).some(function(ro) {
        return ro.skippedTargets.length > 0;
    });
};


var $9e80bbf85842db9f$var$msg = "ResizeObserver loop completed with undelivered notifications.";
var $9e80bbf85842db9f$export$888cb69481582149 = function() {
    var event;
    if (typeof ErrorEvent === "function") event = new ErrorEvent("error", {
        message: $9e80bbf85842db9f$var$msg
    });
    else {
        event = document.createEvent("Event");
        event.initEvent("error", false, false);
        event.message = $9e80bbf85842db9f$var$msg;
    }
    window.dispatchEvent(event);
};



var $5ee7eb999f1a8dce$export$416d111b83cd1483;
(function(ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})($5ee7eb999f1a8dce$export$416d111b83cd1483 || ($5ee7eb999f1a8dce$export$416d111b83cd1483 = {}));


var $9cdc52ef58782bed$export$792f3d81ea979f55 = function(obj) {
    return Object.freeze(obj);
};


var $9030374ef682d4ae$export$c9ad8cdf6bbd331c = function() {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        (0, $9cdc52ef58782bed$export$792f3d81ea979f55)(this);
    }
    return ResizeObserverSize;
}();



var $76b3fc0582c874a2$export$51d7a67026f4e0b7 = function() {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return (0, $9cdc52ef58782bed$export$792f3d81ea979f55)(this);
    }
    DOMRectReadOnly.prototype.toJSON = function() {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return {
            x: x,
            y: y,
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: width,
            height: height
        };
    };
    DOMRectReadOnly.fromRect = function(rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}();


var $2f02ca7bc8aec460$export$165b39ed277223c2 = function(target) {
    return target instanceof SVGElement && "getBBox" in target;
};
var $2f02ca7bc8aec460$export$ee695c13482bb5dd = function(target) {
    if ($2f02ca7bc8aec460$export$165b39ed277223c2(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var $2f02ca7bc8aec460$export$45a5e7f76e0caa8d = function(obj) {
    var _a;
    if (obj instanceof Element) return true;
    var scope = (_a = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var $2f02ca7bc8aec460$export$a6eb60f7e7c182ba = function(target) {
    switch(target.tagName){
        case "INPUT":
            if (target.type !== "image") break;
        case "VIDEO":
        case "AUDIO":
        case "EMBED":
        case "OBJECT":
        case "CANVAS":
        case "IFRAME":
        case "IMG":
            return true;
    }
    return false;
};



var $eb603926ec39a3ad$export$90b4d2ff6acb88af = typeof window !== "undefined" ? window : {};


var $4e24464d411fd9d4$var$cache = new WeakMap();
var $4e24464d411fd9d4$var$scrollRegexp = /auto|scroll/;
var $4e24464d411fd9d4$var$verticalRegexp = /^tb|vertical/;
var $4e24464d411fd9d4$var$IE = /msie|trident/i.test((0, $eb603926ec39a3ad$export$90b4d2ff6acb88af).navigator && (0, $eb603926ec39a3ad$export$90b4d2ff6acb88af).navigator.userAgent);
var $4e24464d411fd9d4$var$parseDimension = function(pixel) {
    return parseFloat(pixel || "0");
};
var $4e24464d411fd9d4$var$size = function(inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) inlineSize = 0;
    if (blockSize === void 0) blockSize = 0;
    if (switchSizes === void 0) switchSizes = false;
    return new (0, $9030374ef682d4ae$export$c9ad8cdf6bbd331c)((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var $4e24464d411fd9d4$var$zeroBoxes = (0, $9cdc52ef58782bed$export$792f3d81ea979f55)({
    devicePixelContentBoxSize: $4e24464d411fd9d4$var$size(),
    borderBoxSize: $4e24464d411fd9d4$var$size(),
    contentBoxSize: $4e24464d411fd9d4$var$size(),
    contentRect: new (0, $76b3fc0582c874a2$export$51d7a67026f4e0b7)(0, 0, 0, 0)
});
var $4e24464d411fd9d4$export$504d039a9c501c94 = function(target, forceRecalculation) {
    if (forceRecalculation === void 0) forceRecalculation = false;
    if ($4e24464d411fd9d4$var$cache.has(target) && !forceRecalculation) return $4e24464d411fd9d4$var$cache.get(target);
    if ((0, $2f02ca7bc8aec460$export$ee695c13482bb5dd)(target)) {
        $4e24464d411fd9d4$var$cache.set(target, $4e24464d411fd9d4$var$zeroBoxes);
        return $4e24464d411fd9d4$var$zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = (0, $2f02ca7bc8aec460$export$165b39ed277223c2)(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !$4e24464d411fd9d4$var$IE && cs.boxSizing === "border-box";
    var switchSizes = $4e24464d411fd9d4$var$verticalRegexp.test(cs.writingMode || "");
    var canScrollVertically = !svg && $4e24464d411fd9d4$var$scrollRegexp.test(cs.overflowY || "");
    var canScrollHorizontally = !svg && $4e24464d411fd9d4$var$scrollRegexp.test(cs.overflowX || "");
    var paddingTop = svg ? 0 : $4e24464d411fd9d4$var$parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : $4e24464d411fd9d4$var$parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : $4e24464d411fd9d4$var$parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : $4e24464d411fd9d4$var$parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : $4e24464d411fd9d4$var$parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : $4e24464d411fd9d4$var$parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : $4e24464d411fd9d4$var$parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : $4e24464d411fd9d4$var$parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : $4e24464d411fd9d4$var$parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : $4e24464d411fd9d4$var$parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = (0, $9cdc52ef58782bed$export$792f3d81ea979f55)({
        devicePixelContentBoxSize: $4e24464d411fd9d4$var$size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: $4e24464d411fd9d4$var$size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: $4e24464d411fd9d4$var$size(contentWidth, contentHeight, switchSizes),
        contentRect: new (0, $76b3fc0582c874a2$export$51d7a67026f4e0b7)(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    $4e24464d411fd9d4$var$cache.set(target, boxes);
    return boxes;
};
var $4e24464d411fd9d4$export$1a78030b04106bdb = function(target, observedBox, forceRecalculation) {
    var _a = $4e24464d411fd9d4$export$504d039a9c501c94(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch(observedBox){
        case (0, $5ee7eb999f1a8dce$export$416d111b83cd1483).DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case (0, $5ee7eb999f1a8dce$export$416d111b83cd1483).BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};



var $568212e3d341692b$export$226159b441fc89f8 = function() {
    function ResizeObserverEntry(target) {
        var boxes = (0, $4e24464d411fd9d4$export$504d039a9c501c94)(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = (0, $9cdc52ef58782bed$export$792f3d81ea979f55)([
            boxes.borderBoxSize
        ]);
        this.contentBoxSize = (0, $9cdc52ef58782bed$export$792f3d81ea979f55)([
            boxes.contentBoxSize
        ]);
        this.devicePixelContentBoxSize = (0, $9cdc52ef58782bed$export$792f3d81ea979f55)([
            boxes.devicePixelContentBoxSize
        ]);
    }
    return ResizeObserverEntry;
}();



var $9640df1aa25577aa$export$f8c8e3b5da1f41d2 = function(node) {
    if ((0, $2f02ca7bc8aec460$export$ee695c13482bb5dd)(node)) return Infinity;
    var depth = 0;
    var parent = node.parentNode;
    while(parent){
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};



var $bfe6cff5633de5b0$export$9cac928141e5443b = function() {
    var shallowestDepth = Infinity;
    var callbacks = [];
    (0, $7c7d936791439820$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) return;
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new (0, $568212e3d341692b$export$226159b441fc89f8)(ot.target);
            var targetDepth = (0, $9640df1aa25577aa$export$f8c8e3b5da1f41d2)(ot.target);
            entries.push(entry);
            ot.lastReportedSize = (0, $4e24464d411fd9d4$export$1a78030b04106bdb)(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) shallowestDepth = targetDepth;
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for(var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++){
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};




var $c35cd8f3acd3f840$export$9c17b8913a2a3572 = function(depth) {
    (0, $7c7d936791439820$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if ((0, $9640df1aa25577aa$export$f8c8e3b5da1f41d2)(ot.target) > depth) ro.activeTargets.push(ot);
                else ro.skippedTargets.push(ot);
            }
        });
    });
};


var $111a414970bd3877$export$e54fe5b0f43758f7 = function() {
    var depth = 0;
    (0, $c35cd8f3acd3f840$export$9c17b8913a2a3572)(depth);
    while((0, $5dd2af242e72bae6$export$63c81bd924f89474)()){
        depth = (0, $bfe6cff5633de5b0$export$9cac928141e5443b)();
        (0, $c35cd8f3acd3f840$export$9c17b8913a2a3572)(depth);
    }
    if ((0, $e0629372d3f7218c$export$8ca35300535e324d)()) (0, $9e80bbf85842db9f$export$888cb69481582149)();
    return depth > 0;
};



var $6bd054960cfc50e7$var$trigger;
var $6bd054960cfc50e7$var$callbacks = [];
var $6bd054960cfc50e7$var$notify = function() {
    return $6bd054960cfc50e7$var$callbacks.splice(0).forEach(function(cb) {
        return cb();
    });
};
var $6bd054960cfc50e7$export$4c995d4933c4abb = function(callback) {
    if (!$6bd054960cfc50e7$var$trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode("");
        var config = {
            characterData: true
        };
        new MutationObserver(function() {
            return $6bd054960cfc50e7$var$notify();
        }).observe(el_1, config);
        $6bd054960cfc50e7$var$trigger = function() {
            el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++);
        };
    }
    $6bd054960cfc50e7$var$callbacks.push(callback);
    $6bd054960cfc50e7$var$trigger();
};


var $71c6021b4a5bd228$export$5755c7b572e34c6 = function(cb) {
    (0, $6bd054960cfc50e7$export$4c995d4933c4abb)(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};


var $d7fda36b4b8ce9e1$var$watching = 0;
var $d7fda36b4b8ce9e1$var$isWatching = function() {
    return !!$d7fda36b4b8ce9e1$var$watching;
};
var $d7fda36b4b8ce9e1$var$CATCH_PERIOD = 250;
var $d7fda36b4b8ce9e1$var$observerConfig = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
var $d7fda36b4b8ce9e1$var$events = [
    "resize",
    "load",
    "transitionend",
    "animationend",
    "animationstart",
    "animationiteration",
    "keyup",
    "keydown",
    "mouseup",
    "mousedown",
    "mouseover",
    "mouseout",
    "blur",
    "focus"
];
var $d7fda36b4b8ce9e1$var$time = function(timeout) {
    if (timeout === void 0) timeout = 0;
    return Date.now() + timeout;
};
var $d7fda36b4b8ce9e1$var$scheduled = false;
var $d7fda36b4b8ce9e1$var$Scheduler = function() {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function() {
            return _this.schedule();
        };
    }
    Scheduler.prototype.run = function(timeout) {
        var _this = this;
        if (timeout === void 0) timeout = $d7fda36b4b8ce9e1$var$CATCH_PERIOD;
        if ($d7fda36b4b8ce9e1$var$scheduled) return;
        $d7fda36b4b8ce9e1$var$scheduled = true;
        var until = $d7fda36b4b8ce9e1$var$time(timeout);
        (0, $71c6021b4a5bd228$export$5755c7b572e34c6)(function() {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = (0, $111a414970bd3877$export$e54fe5b0f43758f7)();
            } finally{
                $d7fda36b4b8ce9e1$var$scheduled = false;
                timeout = until - $d7fda36b4b8ce9e1$var$time();
                if (!$d7fda36b4b8ce9e1$var$isWatching()) return;
                if (elementsHaveResized) _this.run(1000);
                else if (timeout > 0) _this.run(timeout);
                else _this.start();
            }
        });
    };
    Scheduler.prototype.schedule = function() {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function() {
        var _this = this;
        var cb = function() {
            return _this.observer && _this.observer.observe(document.body, $d7fda36b4b8ce9e1$var$observerConfig);
        };
        document.body ? cb() : (0, $eb603926ec39a3ad$export$90b4d2ff6acb88af).addEventListener("DOMContentLoaded", cb);
    };
    Scheduler.prototype.start = function() {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            $d7fda36b4b8ce9e1$var$events.forEach(function(name) {
                return (0, $eb603926ec39a3ad$export$90b4d2ff6acb88af).addEventListener(name, _this.listener, true);
            });
        }
    };
    Scheduler.prototype.stop = function() {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            $d7fda36b4b8ce9e1$var$events.forEach(function(name) {
                return (0, $eb603926ec39a3ad$export$90b4d2ff6acb88af).removeEventListener(name, _this.listener, true);
            });
            this.stopped = true;
        }
    };
    return Scheduler;
}();
var $d7fda36b4b8ce9e1$export$d30788f2c20241cd = new $d7fda36b4b8ce9e1$var$Scheduler();
var $d7fda36b4b8ce9e1$export$1f18a74d42722835 = function(n) {
    !$d7fda36b4b8ce9e1$var$watching && n > 0 && $d7fda36b4b8ce9e1$export$d30788f2c20241cd.start();
    $d7fda36b4b8ce9e1$var$watching += n;
    !$d7fda36b4b8ce9e1$var$watching && $d7fda36b4b8ce9e1$export$d30788f2c20241cd.stop();
};





var $7017e398dcd22280$var$skipNotifyOnElement = function(target) {
    return !(0, $2f02ca7bc8aec460$export$165b39ed277223c2)(target) && !(0, $2f02ca7bc8aec460$export$a6eb60f7e7c182ba)(target) && getComputedStyle(target).display === "inline";
};
var $7017e398dcd22280$export$fea412043713122 = function() {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || (0, $5ee7eb999f1a8dce$export$416d111b83cd1483).CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function() {
        var size = (0, $4e24464d411fd9d4$export$1a78030b04106bdb)(this.target, this.observedBox, true);
        if ($7017e398dcd22280$var$skipNotifyOnElement(this.target)) this.lastReportedSize = size;
        if (this.lastReportedSize.inlineSize !== size.inlineSize || this.lastReportedSize.blockSize !== size.blockSize) return true;
        return false;
    };
    return ResizeObservation;
}();


var $d7c362ca538dc541$export$d86966e6e4bc97e1 = function() {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}();



var $c539298fe5c692b6$var$observerMap = new WeakMap();
var $c539298fe5c692b6$var$getObservationIndex = function(observationTargets, target) {
    for(var i = 0; i < observationTargets.length; i += 1){
        if (observationTargets[i].target === target) return i;
    }
    return -1;
};
var $c539298fe5c692b6$export$ed99c5bafbaf8300 = function() {
    function ResizeObserverController() {}
    ResizeObserverController.connect = function(resizeObserver, callback) {
        var detail = new (0, $d7c362ca538dc541$export$d86966e6e4bc97e1)(resizeObserver, callback);
        $c539298fe5c692b6$var$observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function(resizeObserver, target, options) {
        var detail = $c539298fe5c692b6$var$observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if ($c539298fe5c692b6$var$getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && (0, $7c7d936791439820$export$402e76927ebf6a24).push(detail);
            detail.observationTargets.push(new (0, $7017e398dcd22280$export$fea412043713122)(target, options && options.box));
            (0, $d7fda36b4b8ce9e1$export$1f18a74d42722835)(1);
            (0, $d7fda36b4b8ce9e1$export$d30788f2c20241cd).schedule();
        }
    };
    ResizeObserverController.unobserve = function(resizeObserver, target) {
        var detail = $c539298fe5c692b6$var$observerMap.get(resizeObserver);
        var index = $c539298fe5c692b6$var$getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && (0, $7c7d936791439820$export$402e76927ebf6a24).splice((0, $7c7d936791439820$export$402e76927ebf6a24).indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            (0, $d7fda36b4b8ce9e1$export$1f18a74d42722835)(-1);
        }
    };
    ResizeObserverController.disconnect = function(resizeObserver) {
        var _this = this;
        var detail = $c539298fe5c692b6$var$observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function(ot) {
            return _this.unobserve(resizeObserver, ot.target);
        });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}();



var $a3af3e1d699f2831$export$9caf76241ca21a11 = function() {
    function ResizeObserver(callback) {
        if (arguments.length === 0) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        if (typeof callback !== "function") throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        (0, $c539298fe5c692b6$export$ed99c5bafbaf8300).connect(this, callback);
    }
    ResizeObserver.prototype.observe = function(target, options) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $2f02ca7bc8aec460$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $c539298fe5c692b6$export$ed99c5bafbaf8300).observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function(target) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $2f02ca7bc8aec460$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $c539298fe5c692b6$export$ed99c5bafbaf8300).unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function() {
        (0, $c539298fe5c692b6$export$ed99c5bafbaf8300).disconnect(this);
    };
    ResizeObserver.toString = function() {
        return "function ResizeObserver () { [polyfill code] }";
    };
    return ResizeObserver;
}();






var $b408a42c3e57e75c$exports = {};
var $b408a42c3e57e75c$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
$b408a42c3e57e75c$exports = $b408a42c3e57e75c$var$canUseDOM;


"use strict";

var $2a2b424bdd3a1d27$exports = {};




var $2a2b424bdd3a1d27$var$$TypeError = TypeError;
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $2a2b424bdd3a1d27$var$createMethod = function(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        $d665d4188b1decb6$exports(callbackfn);
        var O = $81779dc9898e79e5$exports(that);
        var self = $f23c1702314ea5f4$exports(O);
        var length = $35d003abcb910698$exports(O);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self) {
                memo = self[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw $2a2b424bdd3a1d27$var$$TypeError("Reduce of empty array with no initial value");
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
        return memo;
    };
};
$2a2b424bdd3a1d27$exports = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $2a2b424bdd3a1d27$var$createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $2a2b424bdd3a1d27$var$createMethod(true)
};


var $67329be64455c12d$require$$reduce = $2a2b424bdd3a1d27$exports.left;
var $1eecb10acca926a9$exports = {};
"use strict";

$1eecb10acca926a9$exports = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $ef32b2494ec6c4b3$exports(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};



var $a926afcd6be15150$exports = {};

var $7dgut = parcelRequire("7dgut");

$a926afcd6be15150$exports = typeof $7dgut != "undefined" && $d8174cbb4abc3bad$exports($7dgut) == "process";


// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $67329be64455c12d$var$CHROME_BUG = !$a926afcd6be15150$exports && $fe2287d46d95f7f7$exports > 79 && $fe2287d46d95f7f7$exports < 83;
var $67329be64455c12d$var$FORCED = $67329be64455c12d$var$CHROME_BUG || !$1eecb10acca926a9$exports("reduce");
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$bffd16f10628412f$exports({
    target: "Array",
    proto: true,
    forced: $67329be64455c12d$var$FORCED
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $67329be64455c12d$require$$reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});


"use strict";

var $d898a2200b7c9c2e$exports = {};
"use strict";



var $67a5619722832ab9$exports = {};
"use strict";

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$67a5619722832ab9$exports = function() {
    var that = $5ee1781b28807bc6$exports(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};


var $ab115c6b67148db8$exports = {};


// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $ab115c6b67148db8$var$$RegExp = $c94afe6b07e4b008$exports.RegExp;
var $ab115c6b67148db8$var$UNSUPPORTED_Y = $ef32b2494ec6c4b3$exports(function() {
    var re = $ab115c6b67148db8$var$$RegExp("a", "y");
    re.lastIndex = 2;
    return re.exec("abcd") != null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var $ab115c6b67148db8$var$MISSED_STICKY = $ab115c6b67148db8$var$UNSUPPORTED_Y || $ef32b2494ec6c4b3$exports(function() {
    return !$ab115c6b67148db8$var$$RegExp("a", "y").sticky;
});
var $ab115c6b67148db8$var$BROKEN_CARET = $ab115c6b67148db8$var$UNSUPPORTED_Y || $ef32b2494ec6c4b3$exports(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $ab115c6b67148db8$var$$RegExp("^r", "gy");
    re.lastIndex = 2;
    return re.exec("str") != null;
});
$ab115c6b67148db8$exports = {
    BROKEN_CARET: $ab115c6b67148db8$var$BROKEN_CARET,
    MISSED_STICKY: $ab115c6b67148db8$var$MISSED_STICKY,
    UNSUPPORTED_Y: $ab115c6b67148db8$var$UNSUPPORTED_Y
};





var $d898a2200b7c9c2e$require$getInternalState = $b73686b75f23202c$exports.get;
var $88d19e9175dc5125$exports = {};


// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $88d19e9175dc5125$var$$RegExp = $c94afe6b07e4b008$exports.RegExp;
$88d19e9175dc5125$exports = $ef32b2494ec6c4b3$exports(function() {
    var re = $88d19e9175dc5125$var$$RegExp(".", "s");
    return !(re.dotAll && re.exec("\n") && re.flags === "s");
});


var $f27b6df7fad9ae3a$exports = {};


// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $f27b6df7fad9ae3a$var$$RegExp = $c94afe6b07e4b008$exports.RegExp;
$f27b6df7fad9ae3a$exports = $ef32b2494ec6c4b3$exports(function() {
    var re = $f27b6df7fad9ae3a$var$$RegExp("(?<a>b)", "g");
    return re.exec("b").groups.a !== "b" || "b".replace(re, "$<a>c") !== "bc";
});


var $d898a2200b7c9c2e$var$nativeReplace = $3ff63154339103aa$exports("native-string-replace", String.prototype.replace);
var $d898a2200b7c9c2e$var$nativeExec = RegExp.prototype.exec;
var $d898a2200b7c9c2e$var$patchedExec = $d898a2200b7c9c2e$var$nativeExec;
var $d898a2200b7c9c2e$var$charAt = $3a4f4365992f575c$exports("".charAt);
var $d898a2200b7c9c2e$var$indexOf = $3a4f4365992f575c$exports("".indexOf);
var $d898a2200b7c9c2e$var$replace = $3a4f4365992f575c$exports("".replace);
var $d898a2200b7c9c2e$var$stringSlice = $3a4f4365992f575c$exports("".slice);
var $d898a2200b7c9c2e$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    $2ab4df4e491115dd$exports($d898a2200b7c9c2e$var$nativeExec, re1, "a");
    $2ab4df4e491115dd$exports($d898a2200b7c9c2e$var$nativeExec, re2, "a");
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var $d898a2200b7c9c2e$var$UNSUPPORTED_Y = $ab115c6b67148db8$exports.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $d898a2200b7c9c2e$var$NPCG_INCLUDED = /()??/.exec("")[1] !== undefined;
var $d898a2200b7c9c2e$var$PATCH = $d898a2200b7c9c2e$var$UPDATES_LAST_INDEX_WRONG || $d898a2200b7c9c2e$var$NPCG_INCLUDED || $d898a2200b7c9c2e$var$UNSUPPORTED_Y || $88d19e9175dc5125$exports || $f27b6df7fad9ae3a$exports;
if ($d898a2200b7c9c2e$var$PATCH) $d898a2200b7c9c2e$var$patchedExec = function exec(string) {
    var re = this;
    var state = $d898a2200b7c9c2e$require$getInternalState(re);
    var str = $b4875d63765839ce$exports(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = $2ab4df4e491115dd$exports($d898a2200b7c9c2e$var$patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
    }
    var groups = state.groups;
    var sticky = $d898a2200b7c9c2e$var$UNSUPPORTED_Y && re.sticky;
    var flags = $2ab4df4e491115dd$exports($67a5619722832ab9$exports, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = $d898a2200b7c9c2e$var$replace(flags, "y", "");
        if ($d898a2200b7c9c2e$var$indexOf(flags, "g") === -1) flags += "g";
        strCopy = $d898a2200b7c9c2e$var$stringSlice(str, re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && $d898a2200b7c9c2e$var$charAt(str, re.lastIndex - 1) !== "\n")) {
            source = "(?: " + source + ")";
            strCopy = " " + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp("^(?:" + source + ")", flags);
    }
    if ($d898a2200b7c9c2e$var$NPCG_INCLUDED) reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
    if ($d898a2200b7c9c2e$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = $2ab4df4e491115dd$exports($d898a2200b7c9c2e$var$nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = $d898a2200b7c9c2e$var$stringSlice(match.input, charsAdded);
            match[0] = $d898a2200b7c9c2e$var$stringSlice(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if ($d898a2200b7c9c2e$var$UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if ($d898a2200b7c9c2e$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
    $2ab4df4e491115dd$exports($d898a2200b7c9c2e$var$nativeReplace, match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) {
        match.groups = object = $c3b0d4e509da0a13$exports(null);
        for(i = 0; i < groups.length; i++){
            group = groups[i];
            object[group[0]] = match[group[1]];
        }
    }
    return match;
};
$d898a2200b7c9c2e$exports = $d898a2200b7c9c2e$var$patchedExec;


// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$bffd16f10628412f$exports({
    target: "RegExp",
    proto: true,
    forced: /./.exec !== $d898a2200b7c9c2e$exports
}, {
    exec: $d898a2200b7c9c2e$exports
});


"use strict";

var $5b3d766d3eda6ad5$exports = {};
"use strict";







var $5b3d766d3eda6ad5$var$SPECIES = $d3b65df0ab9cf9ba$exports("species");
var $5b3d766d3eda6ad5$var$RegExpPrototype = RegExp.prototype;
$5b3d766d3eda6ad5$exports = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = $d3b65df0ab9cf9ba$exports(KEY);
    var DELEGATES_TO_SYMBOL = !$ef32b2494ec6c4b3$exports(function() {
        // String methods call symbol-named RegEp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ""[KEY](O) != 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !$ef32b2494ec6c4b3$exports(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === "split") {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$5b3d766d3eda6ad5$var$SPECIES] = function() {
                return re;
            };
            re.flags = "";
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]("");
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var uncurriedNativeRegExpMethod = $05060ac73f0e1258$exports(/./[SYMBOL]);
        var methods = exec(SYMBOL, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var uncurriedNativeMethod = $05060ac73f0e1258$exports(nativeMethod);
            var $exec = regexp.exec;
            if ($exec === $d898a2200b7c9c2e$exports || $exec === $5b3d766d3eda6ad5$var$RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: uncurriedNativeRegExpMethod(regexp, str, arg2)
                };
                return {
                    done: true,
                    value: uncurriedNativeMethod(str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        $af717a8ded55fc97$exports(String.prototype, KEY, methods[0]);
        $af717a8ded55fc97$exports($5b3d766d3eda6ad5$var$RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) $654a7e7a1347aced$exports($5b3d766d3eda6ad5$var$RegExpPrototype[SYMBOL], "sham", true);
};








var $9c7837d5ab84c4d2$exports = {};
"use strict";

var $9c7837d5ab84c4d2$require$charAt = $8e1afa6f21dd86ff$exports.charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
$9c7837d5ab84c4d2$exports = function(S, index, unicode) {
    return index + (unicode ? $9c7837d5ab84c4d2$require$charAt(S, index).length : 1);
};


var $80f13eec580afce5$exports = {};





var $80f13eec580afce5$var$$TypeError = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
$80f13eec580afce5$exports = function(R, S) {
    var exec = R.exec;
    if ($6360851c61ffcb03$exports(exec)) {
        var result = $2ab4df4e491115dd$exports(exec, R, S);
        if (result !== null) $5ee1781b28807bc6$exports(result);
        return result;
    }
    if ($d8174cbb4abc3bad$exports(R) === "RegExp") return $2ab4df4e491115dd$exports($d898a2200b7c9c2e$exports, R, S);
    throw $80f13eec580afce5$var$$TypeError("RegExp#exec called on incompatible receiver");
};


// @@match logic
$5b3d766d3eda6ad5$exports("match", function(MATCH, nativeMatch, maybeCallNative) {
    return [
        // `String.prototype.match` method
        // https://tc39.es/ecma262/#sec-string.prototype.match
        function match(regexp) {
            var O = $07b613168e2ab3af$exports(this);
            var matcher = $6af58eea9c591e93$exports(regexp) ? undefined : $49fc24205ad915da$exports(regexp, MATCH);
            return matcher ? $2ab4df4e491115dd$exports(matcher, regexp, O) : new RegExp(regexp)[MATCH]($b4875d63765839ce$exports(O));
        },
        // `RegExp.prototype[@@match]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
        function(string) {
            var rx = $5ee1781b28807bc6$exports(this);
            var S = $b4875d63765839ce$exports(string);
            var res = maybeCallNative(nativeMatch, rx, S);
            if (res.done) return res.value;
            if (!rx.global) return $80f13eec580afce5$exports(rx, S);
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;
            while((result = $80f13eec580afce5$exports(rx, S)) !== null){
                var matchStr = $b4875d63765839ce$exports(result[0]);
                A[n] = matchStr;
                if (matchStr === "") rx.lastIndex = $9c7837d5ab84c4d2$exports(S, $d958c37ad7d364d7$exports(rx.lastIndex), fullUnicode);
                n++;
            }
            return n === 0 ? null : A;
        }
    ];
});




var $00970b9217fe457b$require$FUNCTION_NAME_EXISTS = $d3cc933ed77ed9b5$exports.EXISTS;

var $78f8a100effcad0d$exports = {};


$78f8a100effcad0d$exports = function(target, name, descriptor) {
    if (descriptor.get) $1d083c78c0d1b21c$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $1d083c78c0d1b21c$exports(descriptor.set, name, {
        setter: true
    });
    return $db0aedc83a0358c9$export$2d1720544b23b823(target, name, descriptor);
};


var $00970b9217fe457b$var$FunctionPrototype = Function.prototype;
var $00970b9217fe457b$var$functionToString = $3a4f4365992f575c$exports($00970b9217fe457b$var$FunctionPrototype.toString);
var $00970b9217fe457b$var$nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var $00970b9217fe457b$var$regExpExec = $3a4f4365992f575c$exports($00970b9217fe457b$var$nameRE.exec);
var $00970b9217fe457b$var$NAME = "name";
// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if ($7ac8bc7445a1c6e0$exports && !$00970b9217fe457b$require$FUNCTION_NAME_EXISTS) $78f8a100effcad0d$exports($00970b9217fe457b$var$FunctionPrototype, $00970b9217fe457b$var$NAME, {
    configurable: true,
    get: function() {
        try {
            return $00970b9217fe457b$var$regExpExec($00970b9217fe457b$var$nameRE, $00970b9217fe457b$var$functionToString(this))[1];
        } catch (error) {
            return "";
        }
    }
});


"use strict";
var $c08ec2a5b651482c$exports = {};

var $c08ec2a5b651482c$var$FunctionPrototype = Function.prototype;
var $c08ec2a5b651482c$var$apply = $c08ec2a5b651482c$var$FunctionPrototype.apply;
var $c08ec2a5b651482c$var$call = $c08ec2a5b651482c$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$c08ec2a5b651482c$exports = typeof Reflect == "object" && Reflect.apply || ($74d92435c568df86$exports ? $c08ec2a5b651482c$var$call.bind($c08ec2a5b651482c$var$apply) : function() {
    return $c08ec2a5b651482c$var$call.apply($c08ec2a5b651482c$var$apply, arguments);
});















var $2bfc0733d09dba99$exports = {};


var $2bfc0733d09dba99$var$floor = Math.floor;
var $2bfc0733d09dba99$var$charAt = $3a4f4365992f575c$exports("".charAt);
var $2bfc0733d09dba99$var$replace = $3a4f4365992f575c$exports("".replace);
var $2bfc0733d09dba99$var$stringSlice = $3a4f4365992f575c$exports("".slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var $2bfc0733d09dba99$var$SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var $2bfc0733d09dba99$var$SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
$2bfc0733d09dba99$exports = function(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = $2bfc0733d09dba99$var$SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
        namedCaptures = $81779dc9898e79e5$exports(namedCaptures);
        symbols = $2bfc0733d09dba99$var$SUBSTITUTION_SYMBOLS;
    }
    return $2bfc0733d09dba99$var$replace(replacement, symbols, function(match, ch) {
        var capture;
        switch($2bfc0733d09dba99$var$charAt(ch, 0)){
            case "$":
                return "$";
            case "&":
                return matched;
            case "`":
                return $2bfc0733d09dba99$var$stringSlice(str, 0, position);
            case "'":
                return $2bfc0733d09dba99$var$stringSlice(str, tailPos);
            case "<":
                capture = namedCaptures[$2bfc0733d09dba99$var$stringSlice(ch, 1, -1)];
                break;
            default:
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                    var f = $2bfc0733d09dba99$var$floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? $2bfc0733d09dba99$var$charAt(ch, 1) : captures[f - 1] + $2bfc0733d09dba99$var$charAt(ch, 1);
                    return match;
                }
                capture = captures[n - 1];
        }
        return capture === undefined ? "" : capture;
    });
};




var $7d71492aa31cb575$var$REPLACE = $d3b65df0ab9cf9ba$exports("replace");
var $7d71492aa31cb575$var$max = Math.max;
var $7d71492aa31cb575$var$min = Math.min;
var $7d71492aa31cb575$var$concat = $3a4f4365992f575c$exports([].concat);
var $7d71492aa31cb575$var$push = $3a4f4365992f575c$exports([].push);
var $7d71492aa31cb575$var$stringIndexOf = $3a4f4365992f575c$exports("".indexOf);
var $7d71492aa31cb575$var$stringSlice = $3a4f4365992f575c$exports("".slice);
var $7d71492aa31cb575$var$maybeToString = function(it) {
    return it === undefined ? it : String(it);
};
// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var $7d71492aa31cb575$var$REPLACE_KEEPS_$0 = function() {
    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
    return "a".replace(/./, "$0") === "$0";
}();
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var $7d71492aa31cb575$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
    if (/./[$7d71492aa31cb575$var$REPLACE]) return /./[$7d71492aa31cb575$var$REPLACE]("a", "$0") === "";
    return false;
}();
var $7d71492aa31cb575$var$REPLACE_SUPPORTS_NAMED_GROUPS = !$ef32b2494ec6c4b3$exports(function() {
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: "7"
        };
        return result;
    };
    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
    return "".replace(re, "$<a>") !== "7";
});
// @@replace logic
$5b3d766d3eda6ad5$exports("replace", function(_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = $7d71492aa31cb575$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? "$" : "$0";
    return [
        // `String.prototype.replace` method
        // https://tc39.es/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = $07b613168e2ab3af$exports(this);
            var replacer = $6af58eea9c591e93$exports(searchValue) ? undefined : $49fc24205ad915da$exports(searchValue, $7d71492aa31cb575$var$REPLACE);
            return replacer ? $2ab4df4e491115dd$exports(replacer, searchValue, O, replaceValue) : $2ab4df4e491115dd$exports(nativeReplace, $b4875d63765839ce$exports(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
        function(string, replaceValue) {
            var rx = $5ee1781b28807bc6$exports(this);
            var S = $b4875d63765839ce$exports(string);
            if (typeof replaceValue == "string" && $7d71492aa31cb575$var$stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && $7d71492aa31cb575$var$stringIndexOf(replaceValue, "$<") === -1) {
                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                if (res.done) return res.value;
            }
            var functionalReplace = $6360851c61ffcb03$exports(replaceValue);
            if (!functionalReplace) replaceValue = $b4875d63765839ce$exports(replaceValue);
            var global = rx.global;
            if (global) {
                var fullUnicode = rx.unicode;
                rx.lastIndex = 0;
            }
            var results = [];
            while(true){
                var result = $80f13eec580afce5$exports(rx, S);
                if (result === null) break;
                $7d71492aa31cb575$var$push(results, result);
                if (!global) break;
                var matchStr = $b4875d63765839ce$exports(result[0]);
                if (matchStr === "") rx.lastIndex = $9c7837d5ab84c4d2$exports(S, $d958c37ad7d364d7$exports(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = "";
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = $b4875d63765839ce$exports(result[0]);
                var position = $7d71492aa31cb575$var$max($7d71492aa31cb575$var$min($8e4cf644aa33a88e$exports(result.index), S.length), 0);
                var captures = [];
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)$7d71492aa31cb575$var$push(captures, $7d71492aa31cb575$var$maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = $7d71492aa31cb575$var$concat([
                        matched
                    ], captures, position, S);
                    if (namedCaptures !== undefined) $7d71492aa31cb575$var$push(replacerArgs, namedCaptures);
                    var replacement = $b4875d63765839ce$exports($c08ec2a5b651482c$exports(replaceValue, undefined, replacerArgs));
                } else replacement = $2bfc0733d09dba99$exports(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += $7d71492aa31cb575$var$stringSlice(S, nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + $7d71492aa31cb575$var$stringSlice(S, nextSourcePosition);
        }
    ];
}, !$7d71492aa31cb575$var$REPLACE_SUPPORTS_NAMED_GROUPS || !$7d71492aa31cb575$var$REPLACE_KEEPS_$0 || $7d71492aa31cb575$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


function $3eb03bf86efd8daa$var$getElementWindow(element) {
    if (!element || !element.ownerDocument || !element.ownerDocument.defaultView) return window;
    return element.ownerDocument.defaultView;
}
function $3eb03bf86efd8daa$var$getElementDocument(element) {
    if (!element || !element.ownerDocument) return document;
    return element.ownerDocument;
}
var $3eb03bf86efd8daa$var$cachedScrollbarWidth = null;
var $3eb03bf86efd8daa$var$cachedDevicePixelRatio = null;
if (0, (/*@__PURE__*/$parcel$interopDefault($b408a42c3e57e75c$exports))) window.addEventListener("resize", function() {
    if ($3eb03bf86efd8daa$var$cachedDevicePixelRatio !== window.devicePixelRatio) {
        $3eb03bf86efd8daa$var$cachedDevicePixelRatio = window.devicePixelRatio;
        $3eb03bf86efd8daa$var$cachedScrollbarWidth = null;
    }
});
function $3eb03bf86efd8daa$var$scrollbarWidth(el) {
    if ($3eb03bf86efd8daa$var$cachedScrollbarWidth === null) {
        var document1 = $3eb03bf86efd8daa$var$getElementDocument(el);
        if (typeof document1 === "undefined") {
            $3eb03bf86efd8daa$var$cachedScrollbarWidth = 0;
            return $3eb03bf86efd8daa$var$cachedScrollbarWidth;
        }
        var body = document1.body;
        var box = document1.createElement("div");
        box.classList.add("simplebar-hide-scrollbar");
        body.appendChild(box);
        var width = box.getBoundingClientRect().right;
        body.removeChild(box);
        $3eb03bf86efd8daa$var$cachedScrollbarWidth = width;
    }
    return $3eb03bf86efd8daa$var$cachedScrollbarWidth;
}
var $3eb03bf86efd8daa$var$SimpleBar = /*#__PURE__*/ function() {
    function SimpleBar(element, options) {
        var _this = this;
        this.onScroll = function() {
            var elWindow = $3eb03bf86efd8daa$var$getElementWindow(_this.el);
            if (!_this.scrollXTicking) {
                elWindow.requestAnimationFrame(_this.scrollX);
                _this.scrollXTicking = true;
            }
            if (!_this.scrollYTicking) {
                elWindow.requestAnimationFrame(_this.scrollY);
                _this.scrollYTicking = true;
            }
        };
        this.scrollX = function() {
            if (_this.axis.x.isOverflowing) {
                _this.showScrollbar("x");
                _this.positionScrollbar("x");
            }
            _this.scrollXTicking = false;
        };
        this.scrollY = function() {
            if (_this.axis.y.isOverflowing) {
                _this.showScrollbar("y");
                _this.positionScrollbar("y");
            }
            _this.scrollYTicking = false;
        };
        this.onMouseEnter = function() {
            _this.showScrollbar("x");
            _this.showScrollbar("y");
        };
        this.onMouseMove = function(e) {
            _this.mouseX = e.clientX;
            _this.mouseY = e.clientY;
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseMoveForAxis("x");
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseMoveForAxis("y");
        };
        this.onMouseLeave = function() {
            _this.onMouseMove.cancel();
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseLeaveForAxis("x");
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseLeaveForAxis("y");
            _this.mouseX = -1;
            _this.mouseY = -1;
        };
        this.onWindowResize = function() {
            // Recalculate scrollbarWidth in case it's a zoom
            _this.scrollbarWidth = _this.getScrollbarWidth();
            _this.hideNativeScrollbar();
        };
        this.hideScrollbars = function() {
            _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
            _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
            if (!_this.isWithinBounds(_this.axis.y.track.rect)) {
                _this.axis.y.scrollbar.el.classList.remove(_this.classNames.visible);
                _this.axis.y.isVisible = false;
            }
            if (!_this.isWithinBounds(_this.axis.x.track.rect)) {
                _this.axis.x.scrollbar.el.classList.remove(_this.classNames.visible);
                _this.axis.x.isVisible = false;
            }
        };
        this.onPointerEvent = function(e) {
            var isWithinTrackXBounds, isWithinTrackYBounds;
            _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
            _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) isWithinTrackXBounds = _this.isWithinBounds(_this.axis.x.track.rect);
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) isWithinTrackYBounds = _this.isWithinBounds(_this.axis.y.track.rect);
             // If any pointer event is called on the scrollbar
            if (isWithinTrackXBounds || isWithinTrackYBounds) {
                // Preventing the event's default action stops text being
                // selectable during the drag.
                e.preventDefault(); // Prevent event leaking
                e.stopPropagation();
                if (e.type === "mousedown") {
                    if (isWithinTrackXBounds) {
                        _this.axis.x.scrollbar.rect = _this.axis.x.scrollbar.el.getBoundingClientRect();
                        if (_this.isWithinBounds(_this.axis.x.scrollbar.rect)) _this.onDragStart(e, "x");
                        else _this.onTrackClick(e, "x");
                    }
                    if (isWithinTrackYBounds) {
                        _this.axis.y.scrollbar.rect = _this.axis.y.scrollbar.el.getBoundingClientRect();
                        if (_this.isWithinBounds(_this.axis.y.scrollbar.rect)) _this.onDragStart(e, "y");
                        else _this.onTrackClick(e, "y");
                    }
                }
            }
        };
        this.drag = function(e) {
            var eventOffset;
            var track = _this.axis[_this.draggedAxis].track;
            var trackSize = track.rect[_this.axis[_this.draggedAxis].sizeAttr];
            var scrollbar = _this.axis[_this.draggedAxis].scrollbar;
            var contentSize = _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollSizeAttr];
            var hostSize = parseInt(_this.elStyles[_this.axis[_this.draggedAxis].sizeAttr], 10);
            e.preventDefault();
            e.stopPropagation();
            if (_this.draggedAxis === "y") eventOffset = e.pageY;
            else eventOffset = e.pageX;
             // Calculate how far the user's mouse is from the top/left of the scrollbar (minus the dragOffset).
            var dragPos = eventOffset - track.rect[_this.axis[_this.draggedAxis].offsetAttr] - _this.axis[_this.draggedAxis].dragOffset; // Convert the mouse position into a percentage of the scrollbar height/width.
            var dragPerc = dragPos / (trackSize - scrollbar.size); // Scroll the content by the same percentage.
            var scrollPos = dragPerc * (contentSize - hostSize); // Fix browsers inconsistency on RTL
            if (_this.draggedAxis === "x") {
                scrollPos = _this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollbarInverted ? scrollPos - (trackSize + scrollbar.size) : scrollPos;
                scrollPos = _this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollingInverted ? -scrollPos : scrollPos;
            }
            _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollOffsetAttr] = scrollPos;
        };
        this.onEndDrag = function(e) {
            var elDocument = $3eb03bf86efd8daa$var$getElementDocument(_this.el);
            var elWindow = $3eb03bf86efd8daa$var$getElementWindow(_this.el);
            e.preventDefault();
            e.stopPropagation();
            _this.el.classList.remove(_this.classNames.dragging);
            elDocument.removeEventListener("mousemove", _this.drag, true);
            elDocument.removeEventListener("mouseup", _this.onEndDrag, true);
            _this.removePreventClickId = elWindow.setTimeout(function() {
                // Remove these asynchronously so we still suppress click events
                // generated simultaneously with mouseup.
                elDocument.removeEventListener("click", _this.preventClick, true);
                elDocument.removeEventListener("dblclick", _this.preventClick, true);
                _this.removePreventClickId = null;
            });
        };
        this.preventClick = function(e) {
            e.preventDefault();
            e.stopPropagation();
        };
        this.el = element;
        this.minScrollbarWidth = 20;
        this.options = Object.assign({}, SimpleBar.defaultOptions, options);
        this.classNames = Object.assign({}, SimpleBar.defaultOptions.classNames, this.options.classNames);
        this.axis = {
            x: {
                scrollOffsetAttr: "scrollLeft",
                sizeAttr: "width",
                scrollSizeAttr: "scrollWidth",
                offsetSizeAttr: "offsetWidth",
                offsetAttr: "left",
                overflowAttr: "overflowX",
                dragOffset: 0,
                isOverflowing: true,
                isVisible: false,
                forceVisible: false,
                track: {},
                scrollbar: {}
            },
            y: {
                scrollOffsetAttr: "scrollTop",
                sizeAttr: "height",
                scrollSizeAttr: "scrollHeight",
                offsetSizeAttr: "offsetHeight",
                offsetAttr: "top",
                overflowAttr: "overflowY",
                dragOffset: 0,
                isOverflowing: true,
                isVisible: false,
                forceVisible: false,
                track: {},
                scrollbar: {}
            }
        };
        this.removePreventClickId = null; // Don't re-instantiate over an existing one
        if (SimpleBar.instances.has(this.el)) return;
        this.recalculate = (0, (/*@__PURE__*/$parcel$interopDefault($125df40737e47992$exports)))(this.recalculate.bind(this), 64);
        this.onMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($125df40737e47992$exports)))(this.onMouseMove.bind(this), 64);
        this.hideScrollbars = (0, (/*@__PURE__*/$parcel$interopDefault($c50c1c9c64c2d6c8$exports)))(this.hideScrollbars.bind(this), this.options.timeout);
        this.onWindowResize = (0, (/*@__PURE__*/$parcel$interopDefault($c50c1c9c64c2d6c8$exports)))(this.onWindowResize.bind(this), 64, {
            leading: true
        });
        SimpleBar.getRtlHelpers = (0, (/*@__PURE__*/$parcel$interopDefault($6aea992dbecd7f96$exports)))(SimpleBar.getRtlHelpers);
        this.init();
    }
    /**
   * Static properties
   */ /**
   * Helper to fix browsers inconsistency on RTL:
   *  - Firefox inverts the scrollbar initial position
   *  - IE11 inverts both scrollbar position and scrolling offset
   * Directly inspired by @KingSora's OverlayScrollbars https://github.com/KingSora/OverlayScrollbars/blob/master/js/OverlayScrollbars.js#L1634
   */ SimpleBar.getRtlHelpers = function getRtlHelpers() {
        var dummyDiv = document.createElement("div");
        dummyDiv.innerHTML = '<div class="hs-dummy-scrollbar-size"><div style="height: 200%; width: 200%; margin: 10px 0;"></div></div>';
        var scrollbarDummyEl = dummyDiv.firstElementChild;
        document.body.appendChild(scrollbarDummyEl);
        var dummyContainerChild = scrollbarDummyEl.firstElementChild;
        scrollbarDummyEl.scrollLeft = 0;
        var dummyContainerOffset = SimpleBar.getOffset(scrollbarDummyEl);
        var dummyContainerChildOffset = SimpleBar.getOffset(dummyContainerChild);
        scrollbarDummyEl.scrollLeft = 999;
        var dummyContainerScrollOffsetAfterScroll = SimpleBar.getOffset(dummyContainerChild);
        return {
            // determines if the scrolling is responding with negative values
            isRtlScrollingInverted: dummyContainerOffset.left !== dummyContainerChildOffset.left && dummyContainerChildOffset.left - dummyContainerScrollOffsetAfterScroll.left !== 0,
            // determines if the origin scrollbar position is inverted or not (positioned on left or right)
            isRtlScrollbarInverted: dummyContainerOffset.left !== dummyContainerChildOffset.left
        };
    };
    SimpleBar.getOffset = function getOffset(el) {
        var rect = el.getBoundingClientRect();
        var elDocument = $3eb03bf86efd8daa$var$getElementDocument(el);
        var elWindow = $3eb03bf86efd8daa$var$getElementWindow(el);
        return {
            top: rect.top + (elWindow.pageYOffset || elDocument.documentElement.scrollTop),
            left: rect.left + (elWindow.pageXOffset || elDocument.documentElement.scrollLeft)
        };
    };
    var _proto = SimpleBar.prototype;
    _proto.init = function init() {
        // Save a reference to the instance, so we know this DOM node has already been instancied
        SimpleBar.instances.set(this.el, this); // We stop here on server-side
        if (0, (/*@__PURE__*/$parcel$interopDefault($b408a42c3e57e75c$exports))) {
            this.initDOM();
            this.setAccessibilityAttributes();
            this.scrollbarWidth = this.getScrollbarWidth();
            this.recalculate();
            this.initListeners();
        }
    };
    _proto.initDOM = function initDOM() {
        var _this2 = this;
        // make sure this element doesn't have the elements yet
        if (Array.prototype.filter.call(this.el.children, function(child) {
            return child.classList.contains(_this2.classNames.wrapper);
        }).length) {
            // assume that element has his DOM already initiated
            this.wrapperEl = this.el.querySelector("." + this.classNames.wrapper);
            this.contentWrapperEl = this.options.scrollableNode || this.el.querySelector("." + this.classNames.contentWrapper);
            this.contentEl = this.options.contentNode || this.el.querySelector("." + this.classNames.contentEl);
            this.offsetEl = this.el.querySelector("." + this.classNames.offset);
            this.maskEl = this.el.querySelector("." + this.classNames.mask);
            this.placeholderEl = this.findChild(this.wrapperEl, "." + this.classNames.placeholder);
            this.heightAutoObserverWrapperEl = this.el.querySelector("." + this.classNames.heightAutoObserverWrapperEl);
            this.heightAutoObserverEl = this.el.querySelector("." + this.classNames.heightAutoObserverEl);
            this.axis.x.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.horizontal);
            this.axis.y.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.vertical);
        } else {
            // Prepare DOM
            this.wrapperEl = document.createElement("div");
            this.contentWrapperEl = document.createElement("div");
            this.offsetEl = document.createElement("div");
            this.maskEl = document.createElement("div");
            this.contentEl = document.createElement("div");
            this.placeholderEl = document.createElement("div");
            this.heightAutoObserverWrapperEl = document.createElement("div");
            this.heightAutoObserverEl = document.createElement("div");
            this.wrapperEl.classList.add(this.classNames.wrapper);
            this.contentWrapperEl.classList.add(this.classNames.contentWrapper);
            this.offsetEl.classList.add(this.classNames.offset);
            this.maskEl.classList.add(this.classNames.mask);
            this.contentEl.classList.add(this.classNames.contentEl);
            this.placeholderEl.classList.add(this.classNames.placeholder);
            this.heightAutoObserverWrapperEl.classList.add(this.classNames.heightAutoObserverWrapperEl);
            this.heightAutoObserverEl.classList.add(this.classNames.heightAutoObserverEl);
            while(this.el.firstChild)this.contentEl.appendChild(this.el.firstChild);
            this.contentWrapperEl.appendChild(this.contentEl);
            this.offsetEl.appendChild(this.contentWrapperEl);
            this.maskEl.appendChild(this.offsetEl);
            this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl);
            this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl);
            this.wrapperEl.appendChild(this.maskEl);
            this.wrapperEl.appendChild(this.placeholderEl);
            this.el.appendChild(this.wrapperEl);
        }
        if (!this.axis.x.track.el || !this.axis.y.track.el) {
            var track = document.createElement("div");
            var scrollbar = document.createElement("div");
            track.classList.add(this.classNames.track);
            scrollbar.classList.add(this.classNames.scrollbar);
            track.appendChild(scrollbar);
            this.axis.x.track.el = track.cloneNode(true);
            this.axis.x.track.el.classList.add(this.classNames.horizontal);
            this.axis.y.track.el = track.cloneNode(true);
            this.axis.y.track.el.classList.add(this.classNames.vertical);
            this.el.appendChild(this.axis.x.track.el);
            this.el.appendChild(this.axis.y.track.el);
        }
        this.axis.x.scrollbar.el = this.axis.x.track.el.querySelector("." + this.classNames.scrollbar);
        this.axis.y.scrollbar.el = this.axis.y.track.el.querySelector("." + this.classNames.scrollbar);
        if (!this.options.autoHide) {
            this.axis.x.scrollbar.el.classList.add(this.classNames.visible);
            this.axis.y.scrollbar.el.classList.add(this.classNames.visible);
        }
        this.el.setAttribute("data-simplebar", "init");
    };
    _proto.setAccessibilityAttributes = function setAccessibilityAttributes() {
        var ariaLabel = this.options.ariaLabel || "scrollable content";
        this.contentWrapperEl.setAttribute("tabindex", "0");
        this.contentWrapperEl.setAttribute("role", "region");
        this.contentWrapperEl.setAttribute("aria-label", ariaLabel);
    };
    _proto.initListeners = function initListeners() {
        var _this3 = this;
        var elWindow = $3eb03bf86efd8daa$var$getElementWindow(this.el); // Event listeners
        if (this.options.autoHide) this.el.addEventListener("mouseenter", this.onMouseEnter);
        [
            "mousedown",
            "click",
            "dblclick"
        ].forEach(function(e) {
            _this3.el.addEventListener(e, _this3.onPointerEvent, true);
        });
        [
            "touchstart",
            "touchend",
            "touchmove"
        ].forEach(function(e) {
            _this3.el.addEventListener(e, _this3.onPointerEvent, {
                capture: true,
                passive: true
            });
        });
        this.el.addEventListener("mousemove", this.onMouseMove);
        this.el.addEventListener("mouseleave", this.onMouseLeave);
        this.contentWrapperEl.addEventListener("scroll", this.onScroll); // Browser zoom triggers a window resize
        elWindow.addEventListener("resize", this.onWindowResize); // Hack for https://github.com/WICG/ResizeObserver/issues/38
        var resizeObserverStarted = false;
        var resizeAnimationFrameId = null;
        var resizeObserver = elWindow.ResizeObserver || (0, $a3af3e1d699f2831$export$9caf76241ca21a11);
        this.resizeObserver = new resizeObserver(function() {
            if (!resizeObserverStarted || resizeAnimationFrameId !== null) return;
            resizeAnimationFrameId = elWindow.requestAnimationFrame(function() {
                _this3.recalculate();
                resizeAnimationFrameId = null;
            });
        });
        this.resizeObserver.observe(this.el);
        this.resizeObserver.observe(this.contentEl);
        elWindow.requestAnimationFrame(function() {
            resizeObserverStarted = true;
        }); // This is required to detect horizontal scroll. Vertical scroll only needs the resizeObserver.
        this.mutationObserver = new elWindow.MutationObserver(this.recalculate);
        this.mutationObserver.observe(this.contentEl, {
            childList: true,
            subtree: true,
            characterData: true
        });
    };
    _proto.recalculate = function recalculate() {
        var elWindow = $3eb03bf86efd8daa$var$getElementWindow(this.el);
        this.elStyles = elWindow.getComputedStyle(this.el);
        this.isRtl = this.elStyles.direction === "rtl";
        var isHeightAuto = this.heightAutoObserverEl.offsetHeight <= 1;
        var isWidthAuto = this.heightAutoObserverEl.offsetWidth <= 1;
        var contentElOffsetWidth = this.contentEl.offsetWidth;
        var contentWrapperElOffsetWidth = this.contentWrapperEl.offsetWidth;
        var elOverflowX = this.elStyles.overflowX;
        var elOverflowY = this.elStyles.overflowY;
        this.contentEl.style.padding = this.elStyles.paddingTop + " " + this.elStyles.paddingRight + " " + this.elStyles.paddingBottom + " " + this.elStyles.paddingLeft;
        this.wrapperEl.style.margin = "-" + this.elStyles.paddingTop + " -" + this.elStyles.paddingRight + " -" + this.elStyles.paddingBottom + " -" + this.elStyles.paddingLeft;
        var contentElScrollHeight = this.contentEl.scrollHeight;
        var contentElScrollWidth = this.contentEl.scrollWidth;
        this.contentWrapperEl.style.height = isHeightAuto ? "auto" : "100%"; // Determine placeholder size
        this.placeholderEl.style.width = isWidthAuto ? contentElOffsetWidth + "px" : "auto";
        this.placeholderEl.style.height = contentElScrollHeight + "px";
        var contentWrapperElOffsetHeight = this.contentWrapperEl.offsetHeight;
        this.axis.x.isOverflowing = contentElScrollWidth > contentElOffsetWidth;
        this.axis.y.isOverflowing = contentElScrollHeight > contentWrapperElOffsetHeight; // Set isOverflowing to false if user explicitely set hidden overflow
        this.axis.x.isOverflowing = elOverflowX === "hidden" ? false : this.axis.x.isOverflowing;
        this.axis.y.isOverflowing = elOverflowY === "hidden" ? false : this.axis.y.isOverflowing;
        this.axis.x.forceVisible = this.options.forceVisible === "x" || this.options.forceVisible === true;
        this.axis.y.forceVisible = this.options.forceVisible === "y" || this.options.forceVisible === true;
        this.hideNativeScrollbar(); // Set isOverflowing to false if scrollbar is not necessary (content is shorter than offset)
        var offsetForXScrollbar = this.axis.x.isOverflowing ? this.scrollbarWidth : 0;
        var offsetForYScrollbar = this.axis.y.isOverflowing ? this.scrollbarWidth : 0;
        this.axis.x.isOverflowing = this.axis.x.isOverflowing && contentElScrollWidth > contentWrapperElOffsetWidth - offsetForYScrollbar;
        this.axis.y.isOverflowing = this.axis.y.isOverflowing && contentElScrollHeight > contentWrapperElOffsetHeight - offsetForXScrollbar;
        this.axis.x.scrollbar.size = this.getScrollbarSize("x");
        this.axis.y.scrollbar.size = this.getScrollbarSize("y");
        this.axis.x.scrollbar.el.style.width = this.axis.x.scrollbar.size + "px";
        this.axis.y.scrollbar.el.style.height = this.axis.y.scrollbar.size + "px";
        this.positionScrollbar("x");
        this.positionScrollbar("y");
        this.toggleTrackVisibility("x");
        this.toggleTrackVisibility("y");
    } /**
   * Calculate scrollbar size
   */ ;
    _proto.getScrollbarSize = function getScrollbarSize(axis) {
        if (axis === void 0) axis = "y";
        if (!this.axis[axis].isOverflowing) return 0;
        var contentSize = this.contentEl[this.axis[axis].scrollSizeAttr];
        var trackSize = this.axis[axis].track.el[this.axis[axis].offsetSizeAttr];
        var scrollbarSize;
        var scrollbarRatio = trackSize / contentSize; // Calculate new height/position of drag handle.
        scrollbarSize = Math.max(~~(scrollbarRatio * trackSize), this.options.scrollbarMinSize);
        if (this.options.scrollbarMaxSize) scrollbarSize = Math.min(scrollbarSize, this.options.scrollbarMaxSize);
        return scrollbarSize;
    };
    _proto.positionScrollbar = function positionScrollbar(axis) {
        if (axis === void 0) axis = "y";
        if (!this.axis[axis].isOverflowing) return;
        var contentSize = this.contentWrapperEl[this.axis[axis].scrollSizeAttr];
        var trackSize = this.axis[axis].track.el[this.axis[axis].offsetSizeAttr];
        var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
        var scrollbar = this.axis[axis].scrollbar;
        var scrollOffset = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
        scrollOffset = axis === "x" && this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollingInverted ? -scrollOffset : scrollOffset;
        var scrollPourcent = scrollOffset / (contentSize - hostSize);
        var handleOffset = ~~((trackSize - scrollbar.size) * scrollPourcent);
        handleOffset = axis === "x" && this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollbarInverted ? handleOffset + (trackSize - scrollbar.size) : handleOffset;
        scrollbar.el.style.transform = axis === "x" ? "translate3d(" + handleOffset + "px, 0, 0)" : "translate3d(0, " + handleOffset + "px, 0)";
    };
    _proto.toggleTrackVisibility = function toggleTrackVisibility(axis) {
        if (axis === void 0) axis = "y";
        var track = this.axis[axis].track.el;
        var scrollbar = this.axis[axis].scrollbar.el;
        if (this.axis[axis].isOverflowing || this.axis[axis].forceVisible) {
            track.style.visibility = "visible";
            this.contentWrapperEl.style[this.axis[axis].overflowAttr] = "scroll";
        } else {
            track.style.visibility = "hidden";
            this.contentWrapperEl.style[this.axis[axis].overflowAttr] = "hidden";
        } // Even if forceVisible is enabled, scrollbar itself should be hidden
        if (this.axis[axis].isOverflowing) scrollbar.style.display = "block";
        else scrollbar.style.display = "none";
    };
    _proto.hideNativeScrollbar = function hideNativeScrollbar() {
        this.offsetEl.style[this.isRtl ? "left" : "right"] = this.axis.y.isOverflowing || this.axis.y.forceVisible ? "-" + this.scrollbarWidth + "px" : 0;
        this.offsetEl.style.bottom = this.axis.x.isOverflowing || this.axis.x.forceVisible ? "-" + this.scrollbarWidth + "px" : 0;
    } /**
   * On scroll event handling
   */ ;
    _proto.onMouseMoveForAxis = function onMouseMoveForAxis(axis) {
        if (axis === void 0) axis = "y";
        this.axis[axis].track.rect = this.axis[axis].track.el.getBoundingClientRect();
        this.axis[axis].scrollbar.rect = this.axis[axis].scrollbar.el.getBoundingClientRect();
        var isWithinScrollbarBoundsX = this.isWithinBounds(this.axis[axis].scrollbar.rect);
        if (isWithinScrollbarBoundsX) this.axis[axis].scrollbar.el.classList.add(this.classNames.hover);
        else this.axis[axis].scrollbar.el.classList.remove(this.classNames.hover);
        if (this.isWithinBounds(this.axis[axis].track.rect)) {
            this.showScrollbar(axis);
            this.axis[axis].track.el.classList.add(this.classNames.hover);
        } else this.axis[axis].track.el.classList.remove(this.classNames.hover);
    };
    _proto.onMouseLeaveForAxis = function onMouseLeaveForAxis(axis) {
        if (axis === void 0) axis = "y";
        this.axis[axis].track.el.classList.remove(this.classNames.hover);
        this.axis[axis].scrollbar.el.classList.remove(this.classNames.hover);
    };
    /**
   * Show scrollbar
   */ _proto.showScrollbar = function showScrollbar(axis) {
        if (axis === void 0) axis = "y";
        var scrollbar = this.axis[axis].scrollbar.el;
        if (!this.axis[axis].isVisible) {
            scrollbar.classList.add(this.classNames.visible);
            this.axis[axis].isVisible = true;
        }
        if (this.options.autoHide) this.hideScrollbars();
    } /**
   * Hide Scrollbar
   */ ;
    /**
   * on scrollbar handle drag movement starts
   */ _proto.onDragStart = function onDragStart(e, axis) {
        if (axis === void 0) axis = "y";
        var elDocument = $3eb03bf86efd8daa$var$getElementDocument(this.el);
        var elWindow = $3eb03bf86efd8daa$var$getElementWindow(this.el);
        var scrollbar = this.axis[axis].scrollbar; // Measure how far the user's mouse is from the top of the scrollbar drag handle.
        var eventOffset = axis === "y" ? e.pageY : e.pageX;
        this.axis[axis].dragOffset = eventOffset - scrollbar.rect[this.axis[axis].offsetAttr];
        this.draggedAxis = axis;
        this.el.classList.add(this.classNames.dragging);
        elDocument.addEventListener("mousemove", this.drag, true);
        elDocument.addEventListener("mouseup", this.onEndDrag, true);
        if (this.removePreventClickId === null) {
            elDocument.addEventListener("click", this.preventClick, true);
            elDocument.addEventListener("dblclick", this.preventClick, true);
        } else {
            elWindow.clearTimeout(this.removePreventClickId);
            this.removePreventClickId = null;
        }
    } /**
   * Drag scrollbar handle
   */ ;
    _proto.onTrackClick = function onTrackClick(e, axis) {
        var _this4 = this;
        if (axis === void 0) axis = "y";
        if (!this.options.clickOnTrack) return;
        var elWindow = $3eb03bf86efd8daa$var$getElementWindow(this.el);
        this.axis[axis].scrollbar.rect = this.axis[axis].scrollbar.el.getBoundingClientRect();
        var scrollbar = this.axis[axis].scrollbar;
        var scrollbarOffset = scrollbar.rect[this.axis[axis].offsetAttr];
        var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
        var scrolled = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
        var t = axis === "y" ? this.mouseY - scrollbarOffset : this.mouseX - scrollbarOffset;
        var dir = t < 0 ? -1 : 1;
        var scrollSize = dir === -1 ? scrolled - hostSize : scrolled + hostSize;
        var scrollTo = function scrollTo() {
            if (dir === -1) {
                if (scrolled > scrollSize) {
                    var _this4$contentWrapper;
                    scrolled -= _this4.options.clickOnTrackSpeed;
                    _this4.contentWrapperEl.scrollTo((_this4$contentWrapper = {}, _this4$contentWrapper[_this4.axis[axis].offsetAttr] = scrolled, _this4$contentWrapper));
                    elWindow.requestAnimationFrame(scrollTo);
                }
            } else if (scrolled < scrollSize) {
                var _this4$contentWrapper2;
                scrolled += _this4.options.clickOnTrackSpeed;
                _this4.contentWrapperEl.scrollTo((_this4$contentWrapper2 = {}, _this4$contentWrapper2[_this4.axis[axis].offsetAttr] = scrolled, _this4$contentWrapper2));
                elWindow.requestAnimationFrame(scrollTo);
            }
        };
        scrollTo();
    } /**
   * Getter for content element
   */ ;
    _proto.getContentElement = function getContentElement() {
        return this.contentEl;
    } /**
   * Getter for original scrolling element
   */ ;
    _proto.getScrollElement = function getScrollElement() {
        return this.contentWrapperEl;
    };
    _proto.getScrollbarWidth = function getScrollbarWidth() {
        // Try/catch for FF 56 throwing on undefined computedStyles
        try {
            // Detect browsers supporting CSS scrollbar styling and do not calculate
            if (getComputedStyle(this.contentWrapperEl, "::-webkit-scrollbar").display === "none" || "scrollbarWidth" in document.documentElement.style || "-ms-overflow-style" in document.documentElement.style) return 0;
            else return $3eb03bf86efd8daa$var$scrollbarWidth(this.el);
        } catch (e) {
            return $3eb03bf86efd8daa$var$scrollbarWidth(this.el);
        }
    };
    _proto.removeListeners = function removeListeners() {
        var _this5 = this;
        var elWindow = $3eb03bf86efd8daa$var$getElementWindow(this.el); // Event listeners
        if (this.options.autoHide) this.el.removeEventListener("mouseenter", this.onMouseEnter);
        [
            "mousedown",
            "click",
            "dblclick"
        ].forEach(function(e) {
            _this5.el.removeEventListener(e, _this5.onPointerEvent, true);
        });
        [
            "touchstart",
            "touchend",
            "touchmove"
        ].forEach(function(e) {
            _this5.el.removeEventListener(e, _this5.onPointerEvent, {
                capture: true,
                passive: true
            });
        });
        this.el.removeEventListener("mousemove", this.onMouseMove);
        this.el.removeEventListener("mouseleave", this.onMouseLeave);
        if (this.contentWrapperEl) this.contentWrapperEl.removeEventListener("scroll", this.onScroll);
        elWindow.removeEventListener("resize", this.onWindowResize);
        if (this.mutationObserver) this.mutationObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
         // Cancel all debounced functions
        this.recalculate.cancel();
        this.onMouseMove.cancel();
        this.hideScrollbars.cancel();
        this.onWindowResize.cancel();
    } /**
   * UnMount mutation observer and delete SimpleBar instance from DOM element
   */ ;
    _proto.unMount = function unMount() {
        this.removeListeners();
        SimpleBar.instances.delete(this.el);
    } /**
   * Check if mouse is within bounds
   */ ;
    _proto.isWithinBounds = function isWithinBounds(bbox) {
        return this.mouseX >= bbox.left && this.mouseX <= bbox.left + bbox.width && this.mouseY >= bbox.top && this.mouseY <= bbox.top + bbox.height;
    } /**
   * Find element children matches query
   */ ;
    _proto.findChild = function findChild(el, query) {
        var matches = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
        return Array.prototype.filter.call(el.children, function(child) {
            return matches.call(child, query);
        })[0];
    };
    return SimpleBar;
}();
$3eb03bf86efd8daa$var$SimpleBar.defaultOptions = {
    autoHide: true,
    forceVisible: false,
    clickOnTrack: true,
    clickOnTrackSpeed: 40,
    classNames: {
        contentEl: "simplebar-content",
        contentWrapper: "simplebar-content-wrapper",
        offset: "simplebar-offset",
        mask: "simplebar-mask",
        wrapper: "simplebar-wrapper",
        placeholder: "simplebar-placeholder",
        scrollbar: "simplebar-scrollbar",
        track: "simplebar-track",
        heightAutoObserverWrapperEl: "simplebar-height-auto-observer-wrapper",
        heightAutoObserverEl: "simplebar-height-auto-observer",
        visible: "simplebar-visible",
        horizontal: "simplebar-horizontal",
        vertical: "simplebar-vertical",
        hover: "simplebar-hover",
        dragging: "simplebar-dragging"
    },
    scrollbarMinSize: 25,
    scrollbarMaxSize: 0,
    timeout: 1000
};
$3eb03bf86efd8daa$var$SimpleBar.instances = new WeakMap();
var $3eb03bf86efd8daa$export$2e2bcd8739ae039 = $3eb03bf86efd8daa$var$SimpleBar;


function $b4aaf20354609c9d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b4aaf20354609c9d$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b4aaf20354609c9d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b4aaf20354609c9d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b4aaf20354609c9d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b4aaf20354609c9d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b4aaf20354609c9d$var$_extends() {
    $b4aaf20354609c9d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b4aaf20354609c9d$var$_extends.apply(this, arguments);
}
function $b4aaf20354609c9d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b4aaf20354609c9d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b4aaf20354609c9d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $b4aaf20354609c9d$var$_excluded = [
    "children",
    "scrollableNodeProps",
    "tag"
];
/* Deprecated
 * Hardcore this here until we can safely deprecated it.
 * Helper function to retrieve options from element attributes
 */ var $b4aaf20354609c9d$var$getOptions = function getOptions(obj) {
    var options = Array.prototype.reduce.call(obj, function(acc, attribute) {
        var option = attribute.name.match(/data-simplebar-(.+)/);
        if (option) {
            var key = option[1].replace(/\W+(.)/g, function(x, chr) {
                return chr.toUpperCase();
            });
            switch(attribute.value){
                case "true":
                    acc[key] = true;
                    break;
                case "false":
                    acc[key] = false;
                    break;
                case undefined:
                    acc[key] = true;
                    break;
                default:
                    acc[key] = attribute.value;
            }
        }
        return acc;
    }, {});
    return options;
};
var $b4aaf20354609c9d$var$SimpleBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).forwardRef(function(_ref, ref) {
    var children = _ref.children, _ref$scrollableNodePr = _ref.scrollableNodeProps, scrollableNodeProps = _ref$scrollableNodePr === void 0 ? {} : _ref$scrollableNodePr, _ref$tag = _ref.tag, tag = _ref$tag === void 0 ? "div" : _ref$tag, otherProps = $b4aaf20354609c9d$var$_objectWithoutProperties(_ref, $b4aaf20354609c9d$var$_excluded);
    var RootTag = tag;
    var instance;
    var scrollableNodeRef = (0, $cQNHH.useRef)();
    var elRef = (0, $cQNHH.useRef)();
    var contentNodeRef = (0, $cQNHH.useRef)();
    var options = {};
    var rest = {};
    var deprecatedOptions = [];
    Object.keys(otherProps).forEach(function(key) {
        if (Object.prototype.hasOwnProperty.call((0, $3eb03bf86efd8daa$export$2e2bcd8739ae039).defaultOptions, key)) options[key] = otherProps[key];
        else if (key.match(/data-simplebar-(.+)/) && key !== "data-simplebar-direction") deprecatedOptions.push({
            name: key,
            value: otherProps[key]
        });
        else rest[key] = otherProps[key];
    });
    if (deprecatedOptions.length) console.warn("simplebar-react: this way of passing options is deprecated. Pass it like normal props instead:\n        'data-simplebar-auto-hide=\"false\"' —> 'autoHide=\"false\"'\n      ");
    (0, $cQNHH.useEffect)(function() {
        scrollableNodeRef = scrollableNodeProps.ref || scrollableNodeRef;
        if (elRef.current) {
            instance = new (0, $3eb03bf86efd8daa$export$2e2bcd8739ae039)(elRef.current, $b4aaf20354609c9d$var$_objectSpread2($b4aaf20354609c9d$var$_objectSpread2($b4aaf20354609c9d$var$_objectSpread2($b4aaf20354609c9d$var$_objectSpread2({}, $b4aaf20354609c9d$var$getOptions(deprecatedOptions)), options), scrollableNodeRef && {
                scrollableNode: scrollableNodeRef.current
            }), contentNodeRef.current && {
                contentNode: contentNodeRef.current
            }));
            if (typeof ref === "function") ref(instance);
            else if (ref) ref.current = instance;
        }
        return function() {
            instance.unMount();
            instance = null;
            if (typeof ref === "function") ref(null);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(RootTag, $b4aaf20354609c9d$var$_extends({
        ref: elRef,
        "data-simplebar": true
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "simplebar-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "simplebar-height-auto-observer-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "simplebar-height-auto-observer"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "simplebar-mask"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "simplebar-offset"
    }, typeof children === "function" ? children({
        scrollableNodeRef: scrollableNodeRef,
        contentNodeRef: contentNodeRef
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", $b4aaf20354609c9d$var$_extends({}, scrollableNodeProps, {
        className: "simplebar-content-wrapper".concat(scrollableNodeProps.className ? " ".concat(scrollableNodeProps.className) : "")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "simplebar-content"
    }, children)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "simplebar-placeholder"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "simplebar-track simplebar-horizontal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "simplebar-scrollbar"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "simplebar-track simplebar-vertical"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "simplebar-scrollbar"
    })));
});
$b4aaf20354609c9d$var$SimpleBar.displayName = "SimpleBar";
$b4aaf20354609c9d$var$SimpleBar.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).func
    ]),
    scrollableNodeProps: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).object,
    tag: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string
};
var $b4aaf20354609c9d$export$2e2bcd8739ae039 = $b4aaf20354609c9d$var$SimpleBar;


//import {useTranslation} from "react-i18next";
const $06aa2820615626e8$var$ScrollArea = ({ children: children })=>{
    //console.log("ScrollArea", noOfGroups, currentGroupNo, answeredGroups);
    const scroller = (0, $cQNHH.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $b4aaf20354609c9d$export$2e2bcd8739ae039), {
        key: "scroller",
        ref: scroller,
        id: "story__scrolling",
        className: "story__scrolling"
    }, children);
};
$06aa2820615626e8$var$ScrollArea.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).node),
        (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).node
    ])
};
var $06aa2820615626e8$export$2e2bcd8739ae039 = $06aa2820615626e8$var$ScrollArea;











var $cQNHH = parcelRequire("cQNHH");

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
// find the complete implementation of crypto (msCrypto) on IE11.
var $c75d04790be86aca$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
var $c75d04790be86aca$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
function $c75d04790be86aca$export$2e2bcd8739ae039() {
    if (!$c75d04790be86aca$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return $c75d04790be86aca$var$getRandomValues($c75d04790be86aca$var$rnds8);
}


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $25e19cd973aa4af8$var$byteToHex = [];
for(var $25e19cd973aa4af8$var$i = 0; $25e19cd973aa4af8$var$i < 256; ++$25e19cd973aa4af8$var$i)$25e19cd973aa4af8$var$byteToHex[$25e19cd973aa4af8$var$i] = ($25e19cd973aa4af8$var$i + 0x100).toString(16).substr(1);
function $25e19cd973aa4af8$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $25e19cd973aa4af8$var$byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
var $25e19cd973aa4af8$export$2e2bcd8739ae039 = $25e19cd973aa4af8$var$bytesToUuid;


function $f09b5dbb9c2f17e8$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || (0, $c75d04790be86aca$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || (0, $25e19cd973aa4af8$export$2e2bcd8739ae039)(rnds);
}
var $f09b5dbb9c2f17e8$export$2e2bcd8739ae039 = $f09b5dbb9c2f17e8$var$v4;


function $46df807587d3bd98$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $46df807587d3bd98$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $46df807587d3bd98$var$ownKeys$2(Object(source), !0).forEach(function(key) {
            $46df807587d3bd98$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $46df807587d3bd98$var$ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $46df807587d3bd98$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $46df807587d3bd98$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $46df807587d3bd98$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $46df807587d3bd98$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $46df807587d3bd98$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $46df807587d3bd98$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $46df807587d3bd98$var$_extends() {
    $46df807587d3bd98$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $46df807587d3bd98$var$_extends.apply(this, arguments);
}
function $46df807587d3bd98$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $46df807587d3bd98$var$_setPrototypeOf(subClass, superClass);
}
function $46df807587d3bd98$var$_getPrototypeOf(o) {
    $46df807587d3bd98$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $46df807587d3bd98$var$_getPrototypeOf(o);
}
function $46df807587d3bd98$var$_setPrototypeOf(o, p) {
    $46df807587d3bd98$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $46df807587d3bd98$var$_setPrototypeOf(o, p);
}
function $46df807587d3bd98$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $46df807587d3bd98$var$_assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function $46df807587d3bd98$var$_possibleConstructorReturn(self1, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $46df807587d3bd98$var$_assertThisInitialized(self1);
}
function $46df807587d3bd98$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $46df807587d3bd98$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $46df807587d3bd98$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $46df807587d3bd98$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $46df807587d3bd98$var$_possibleConstructorReturn(this, result);
    };
}
function $46df807587d3bd98$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $46df807587d3bd98$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $46df807587d3bd98$var$_arrayLikeToArray(o, minLen);
}
function $46df807587d3bd98$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $46df807587d3bd98$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $46df807587d3bd98$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(e) {
                    throw e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = it.call(o);
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(e) {
            didErr = true;
            err = e;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
var $46df807587d3bd98$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $46df807587d3bd98$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $46df807587d3bd98$var$global$a = // eslint-disable-next-line es/no-global-this -- safe
$46df807587d3bd98$var$check(typeof globalThis == "object" && globalThis) || $46df807587d3bd98$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$46df807587d3bd98$var$check(typeof self == "object" && self) || $46df807587d3bd98$var$check(typeof $46df807587d3bd98$var$commonjsGlobal == "object" && $46df807587d3bd98$var$commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();
var $46df807587d3bd98$var$objectGetOwnPropertyDescriptor = {};
var $46df807587d3bd98$var$fails$9 = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
var $46df807587d3bd98$var$fails$8 = $46df807587d3bd98$var$fails$9;
// Detect IE8's incomplete defineProperty implementation
var $46df807587d3bd98$var$descriptors = !$46df807587d3bd98$var$fails$8(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});
var $46df807587d3bd98$var$fails$7 = $46df807587d3bd98$var$fails$9;
var $46df807587d3bd98$var$functionBindNative = !$46df807587d3bd98$var$fails$7(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});
var $46df807587d3bd98$var$NATIVE_BIND$2 = $46df807587d3bd98$var$functionBindNative;
var $46df807587d3bd98$var$call$4 = Function.prototype.call;
var $46df807587d3bd98$var$functionCall = $46df807587d3bd98$var$NATIVE_BIND$2 ? $46df807587d3bd98$var$call$4.bind($46df807587d3bd98$var$call$4) : function() {
    return $46df807587d3bd98$var$call$4.apply($46df807587d3bd98$var$call$4, arguments);
};
var $46df807587d3bd98$var$objectPropertyIsEnumerable = {};
var $46df807587d3bd98$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $46df807587d3bd98$var$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $46df807587d3bd98$var$NASHORN_BUG = $46df807587d3bd98$var$getOwnPropertyDescriptor$1 && !$46df807587d3bd98$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
$46df807587d3bd98$var$objectPropertyIsEnumerable.f = $46df807587d3bd98$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $46df807587d3bd98$var$getOwnPropertyDescriptor$1(this, V);
    return !!descriptor && descriptor.enumerable;
} : $46df807587d3bd98$var$$propertyIsEnumerable;
var $46df807587d3bd98$var$createPropertyDescriptor$2 = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var $46df807587d3bd98$var$NATIVE_BIND$1 = $46df807587d3bd98$var$functionBindNative;
var $46df807587d3bd98$var$FunctionPrototype$1 = Function.prototype;
var $46df807587d3bd98$var$call$3 = $46df807587d3bd98$var$FunctionPrototype$1.call;
var $46df807587d3bd98$var$uncurryThisWithBind = $46df807587d3bd98$var$NATIVE_BIND$1 && $46df807587d3bd98$var$FunctionPrototype$1.bind.bind($46df807587d3bd98$var$call$3, $46df807587d3bd98$var$call$3);
var $46df807587d3bd98$var$functionUncurryThisRaw = function(fn) {
    return $46df807587d3bd98$var$NATIVE_BIND$1 ? $46df807587d3bd98$var$uncurryThisWithBind(fn) : function() {
        return $46df807587d3bd98$var$call$3.apply(fn, arguments);
    };
};
var $46df807587d3bd98$var$uncurryThisRaw$1 = $46df807587d3bd98$var$functionUncurryThisRaw;
var $46df807587d3bd98$var$toString$1 = $46df807587d3bd98$var$uncurryThisRaw$1({}.toString);
var $46df807587d3bd98$var$stringSlice = $46df807587d3bd98$var$uncurryThisRaw$1("".slice);
var $46df807587d3bd98$var$classofRaw$2 = function(it) {
    return $46df807587d3bd98$var$stringSlice($46df807587d3bd98$var$toString$1(it), 8, -1);
};
var $46df807587d3bd98$var$classofRaw$1 = $46df807587d3bd98$var$classofRaw$2;
var $46df807587d3bd98$var$uncurryThisRaw = $46df807587d3bd98$var$functionUncurryThisRaw;
var $46df807587d3bd98$var$functionUncurryThis = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($46df807587d3bd98$var$classofRaw$1(fn) === "Function") return $46df807587d3bd98$var$uncurryThisRaw(fn);
};
var $46df807587d3bd98$var$uncurryThis$9 = $46df807587d3bd98$var$functionUncurryThis;
var $46df807587d3bd98$var$fails$6 = $46df807587d3bd98$var$fails$9;
var $46df807587d3bd98$var$classof$3 = $46df807587d3bd98$var$classofRaw$2;
var $46df807587d3bd98$var$$Object$3 = Object;
var $46df807587d3bd98$var$split = $46df807587d3bd98$var$uncurryThis$9("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var $46df807587d3bd98$var$indexedObject = $46df807587d3bd98$var$fails$6(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$46df807587d3bd98$var$$Object$3("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $46df807587d3bd98$var$classof$3(it) == "String" ? $46df807587d3bd98$var$split(it, "") : $46df807587d3bd98$var$$Object$3(it);
} : $46df807587d3bd98$var$$Object$3;
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var $46df807587d3bd98$var$isNullOrUndefined$2 = function(it) {
    return it === null || it === undefined;
};
var $46df807587d3bd98$var$isNullOrUndefined$1 = $46df807587d3bd98$var$isNullOrUndefined$2;
var $46df807587d3bd98$var$$TypeError$5 = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var $46df807587d3bd98$var$requireObjectCoercible$2 = function(it) {
    if ($46df807587d3bd98$var$isNullOrUndefined$1(it)) throw $46df807587d3bd98$var$$TypeError$5("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var $46df807587d3bd98$var$IndexedObject$1 = $46df807587d3bd98$var$indexedObject;
var $46df807587d3bd98$var$requireObjectCoercible$1 = $46df807587d3bd98$var$requireObjectCoercible$2;
var $46df807587d3bd98$var$toIndexedObject$4 = function(it) {
    return $46df807587d3bd98$var$IndexedObject$1($46df807587d3bd98$var$requireObjectCoercible$1(it));
};
var $46df807587d3bd98$var$documentAll$2 = typeof document == "object" && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $46df807587d3bd98$var$IS_HTMLDDA = typeof $46df807587d3bd98$var$documentAll$2 == "undefined" && $46df807587d3bd98$var$documentAll$2 !== undefined;
var $46df807587d3bd98$var$documentAll_1 = {
    all: $46df807587d3bd98$var$documentAll$2,
    IS_HTMLDDA: $46df807587d3bd98$var$IS_HTMLDDA
};
var $46df807587d3bd98$var$$documentAll$1 = $46df807587d3bd98$var$documentAll_1;
var $46df807587d3bd98$var$documentAll$1 = $46df807587d3bd98$var$$documentAll$1.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var $46df807587d3bd98$var$isCallable$c = $46df807587d3bd98$var$$documentAll$1.IS_HTMLDDA ? function(argument) {
    return typeof argument == "function" || argument === $46df807587d3bd98$var$documentAll$1;
} : function(argument) {
    return typeof argument == "function";
};
var $46df807587d3bd98$var$isCallable$b = $46df807587d3bd98$var$isCallable$c;
var $46df807587d3bd98$var$$documentAll = $46df807587d3bd98$var$documentAll_1;
var $46df807587d3bd98$var$documentAll = $46df807587d3bd98$var$$documentAll.all;
var $46df807587d3bd98$var$isObject$6 = $46df807587d3bd98$var$$documentAll.IS_HTMLDDA ? function(it) {
    return typeof it == "object" ? it !== null : $46df807587d3bd98$var$isCallable$b(it) || it === $46df807587d3bd98$var$documentAll;
} : function(it) {
    return typeof it == "object" ? it !== null : $46df807587d3bd98$var$isCallable$b(it);
};
var $46df807587d3bd98$var$global$9 = $46df807587d3bd98$var$global$a;
var $46df807587d3bd98$var$isCallable$a = $46df807587d3bd98$var$isCallable$c;
var $46df807587d3bd98$var$aFunction = function(argument) {
    return $46df807587d3bd98$var$isCallable$a(argument) ? argument : undefined;
};
var $46df807587d3bd98$var$getBuiltIn$5 = function(namespace, method) {
    return arguments.length < 2 ? $46df807587d3bd98$var$aFunction($46df807587d3bd98$var$global$9[namespace]) : $46df807587d3bd98$var$global$9[namespace] && $46df807587d3bd98$var$global$9[namespace][method];
};
var $46df807587d3bd98$var$uncurryThis$8 = $46df807587d3bd98$var$functionUncurryThis;
var $46df807587d3bd98$var$objectIsPrototypeOf = $46df807587d3bd98$var$uncurryThis$8({}.isPrototypeOf);
var $46df807587d3bd98$var$getBuiltIn$4 = $46df807587d3bd98$var$getBuiltIn$5;
var $46df807587d3bd98$var$engineUserAgent = $46df807587d3bd98$var$getBuiltIn$4("navigator", "userAgent") || "";
var $46df807587d3bd98$var$global$8 = $46df807587d3bd98$var$global$a;
var $46df807587d3bd98$var$userAgent = $46df807587d3bd98$var$engineUserAgent;
var $46df807587d3bd98$var$process = $46df807587d3bd98$var$global$8.process;
var $46df807587d3bd98$var$Deno = $46df807587d3bd98$var$global$8.Deno;
var $46df807587d3bd98$var$versions = $46df807587d3bd98$var$process && $46df807587d3bd98$var$process.versions || $46df807587d3bd98$var$Deno && $46df807587d3bd98$var$Deno.version;
var $46df807587d3bd98$var$v8 = $46df807587d3bd98$var$versions && $46df807587d3bd98$var$versions.v8;
var $46df807587d3bd98$var$match, $46df807587d3bd98$var$version;
if ($46df807587d3bd98$var$v8) {
    $46df807587d3bd98$var$match = $46df807587d3bd98$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $46df807587d3bd98$var$version = $46df807587d3bd98$var$match[0] > 0 && $46df807587d3bd98$var$match[0] < 4 ? 1 : +($46df807587d3bd98$var$match[0] + $46df807587d3bd98$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$46df807587d3bd98$var$version && $46df807587d3bd98$var$userAgent) {
    $46df807587d3bd98$var$match = $46df807587d3bd98$var$userAgent.match(/Edge\/(\d+)/);
    if (!$46df807587d3bd98$var$match || $46df807587d3bd98$var$match[1] >= 74) {
        $46df807587d3bd98$var$match = $46df807587d3bd98$var$userAgent.match(/Chrome\/(\d+)/);
        if ($46df807587d3bd98$var$match) $46df807587d3bd98$var$version = +$46df807587d3bd98$var$match[1];
    }
}
var $46df807587d3bd98$var$engineV8Version = $46df807587d3bd98$var$version;
/* eslint-disable es/no-symbol -- required for testing */ var $46df807587d3bd98$var$V8_VERSION = $46df807587d3bd98$var$engineV8Version;
var $46df807587d3bd98$var$fails$5 = $46df807587d3bd98$var$fails$9;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var $46df807587d3bd98$var$symbolConstructorDetection = !!Object.getOwnPropertySymbols && !$46df807587d3bd98$var$fails$5(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $46df807587d3bd98$var$V8_VERSION && $46df807587d3bd98$var$V8_VERSION < 41;
});
/* eslint-disable es/no-symbol -- required for testing */ var $46df807587d3bd98$var$NATIVE_SYMBOL$1 = $46df807587d3bd98$var$symbolConstructorDetection;
var $46df807587d3bd98$var$useSymbolAsUid = $46df807587d3bd98$var$NATIVE_SYMBOL$1 && !Symbol.sham && typeof Symbol.iterator == "symbol";
var $46df807587d3bd98$var$getBuiltIn$3 = $46df807587d3bd98$var$getBuiltIn$5;
var $46df807587d3bd98$var$isCallable$9 = $46df807587d3bd98$var$isCallable$c;
var $46df807587d3bd98$var$isPrototypeOf = $46df807587d3bd98$var$objectIsPrototypeOf;
var $46df807587d3bd98$var$USE_SYMBOL_AS_UID$1 = $46df807587d3bd98$var$useSymbolAsUid;
var $46df807587d3bd98$var$$Object$2 = Object;
var $46df807587d3bd98$var$isSymbol$2 = $46df807587d3bd98$var$USE_SYMBOL_AS_UID$1 ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $46df807587d3bd98$var$getBuiltIn$3("Symbol");
    return $46df807587d3bd98$var$isCallable$9($Symbol) && $46df807587d3bd98$var$isPrototypeOf($Symbol.prototype, $46df807587d3bd98$var$$Object$2(it));
};
var $46df807587d3bd98$var$$String$1 = String;
var $46df807587d3bd98$var$tryToString$1 = function(argument) {
    try {
        return $46df807587d3bd98$var$$String$1(argument);
    } catch (error) {
        return "Object";
    }
};
var $46df807587d3bd98$var$isCallable$8 = $46df807587d3bd98$var$isCallable$c;
var $46df807587d3bd98$var$tryToString = $46df807587d3bd98$var$tryToString$1;
var $46df807587d3bd98$var$$TypeError$4 = TypeError;
// `Assert: IsCallable(argument) is true`
var $46df807587d3bd98$var$aCallable$2 = function(argument) {
    if ($46df807587d3bd98$var$isCallable$8(argument)) return argument;
    throw $46df807587d3bd98$var$$TypeError$4($46df807587d3bd98$var$tryToString(argument) + " is not a function");
};
var $46df807587d3bd98$var$aCallable$1 = $46df807587d3bd98$var$aCallable$2;
var $46df807587d3bd98$var$isNullOrUndefined = $46df807587d3bd98$var$isNullOrUndefined$2;
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var $46df807587d3bd98$var$getMethod$1 = function(V, P) {
    var func = V[P];
    return $46df807587d3bd98$var$isNullOrUndefined(func) ? undefined : $46df807587d3bd98$var$aCallable$1(func);
};
var $46df807587d3bd98$var$call$2 = $46df807587d3bd98$var$functionCall;
var $46df807587d3bd98$var$isCallable$7 = $46df807587d3bd98$var$isCallable$c;
var $46df807587d3bd98$var$isObject$5 = $46df807587d3bd98$var$isObject$6;
var $46df807587d3bd98$var$$TypeError$3 = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var $46df807587d3bd98$var$ordinaryToPrimitive$1 = function(input, pref) {
    var fn, val;
    if (pref === "string" && $46df807587d3bd98$var$isCallable$7(fn = input.toString) && !$46df807587d3bd98$var$isObject$5(val = $46df807587d3bd98$var$call$2(fn, input))) return val;
    if ($46df807587d3bd98$var$isCallable$7(fn = input.valueOf) && !$46df807587d3bd98$var$isObject$5(val = $46df807587d3bd98$var$call$2(fn, input))) return val;
    if (pref !== "string" && $46df807587d3bd98$var$isCallable$7(fn = input.toString) && !$46df807587d3bd98$var$isObject$5(val = $46df807587d3bd98$var$call$2(fn, input))) return val;
    throw $46df807587d3bd98$var$$TypeError$3("Can't convert object to primitive value");
};
var $46df807587d3bd98$var$shared$3 = {
    exports: {}
};
var $46df807587d3bd98$var$global$7 = $46df807587d3bd98$var$global$a;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $46df807587d3bd98$var$defineProperty$2 = Object.defineProperty;
var $46df807587d3bd98$var$defineGlobalProperty$3 = function(key, value) {
    try {
        $46df807587d3bd98$var$defineProperty$2($46df807587d3bd98$var$global$7, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $46df807587d3bd98$var$global$7[key] = value;
    }
    return value;
};
var $46df807587d3bd98$var$global$6 = $46df807587d3bd98$var$global$a;
var $46df807587d3bd98$var$defineGlobalProperty$2 = $46df807587d3bd98$var$defineGlobalProperty$3;
var $46df807587d3bd98$var$SHARED = "__core-js_shared__";
var $46df807587d3bd98$var$store$3 = $46df807587d3bd98$var$global$6[$46df807587d3bd98$var$SHARED] || $46df807587d3bd98$var$defineGlobalProperty$2($46df807587d3bd98$var$SHARED, {});
var $46df807587d3bd98$var$sharedStore = $46df807587d3bd98$var$store$3;
var $46df807587d3bd98$var$store$2 = $46df807587d3bd98$var$sharedStore;
($46df807587d3bd98$var$shared$3.exports = function(key, value) {
    return $46df807587d3bd98$var$store$2[key] || ($46df807587d3bd98$var$store$2[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.25.5",
    mode: "global",
    copyright: "\xa9 2014-2022 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.25.5/LICENSE",
    source: "https://github.com/zloirock/core-js"
});
var $46df807587d3bd98$var$requireObjectCoercible = $46df807587d3bd98$var$requireObjectCoercible$2;
var $46df807587d3bd98$var$$Object$1 = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var $46df807587d3bd98$var$toObject$2 = function(argument) {
    return $46df807587d3bd98$var$$Object$1($46df807587d3bd98$var$requireObjectCoercible(argument));
};
var $46df807587d3bd98$var$uncurryThis$7 = $46df807587d3bd98$var$functionUncurryThis;
var $46df807587d3bd98$var$toObject$1 = $46df807587d3bd98$var$toObject$2;
var $46df807587d3bd98$var$hasOwnProperty = $46df807587d3bd98$var$uncurryThis$7({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var $46df807587d3bd98$var$hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
    return $46df807587d3bd98$var$hasOwnProperty($46df807587d3bd98$var$toObject$1(it), key);
};
var $46df807587d3bd98$var$uncurryThis$6 = $46df807587d3bd98$var$functionUncurryThis;
var $46df807587d3bd98$var$id = 0;
var $46df807587d3bd98$var$postfix = Math.random();
var $46df807587d3bd98$var$toString = $46df807587d3bd98$var$uncurryThis$6(1.0.toString);
var $46df807587d3bd98$var$uid$2 = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $46df807587d3bd98$var$toString(++$46df807587d3bd98$var$id + $46df807587d3bd98$var$postfix, 36);
};
var $46df807587d3bd98$var$global$5 = $46df807587d3bd98$var$global$a;
var $46df807587d3bd98$var$shared$2 = $46df807587d3bd98$var$shared$3.exports;
var $46df807587d3bd98$var$hasOwn$6 = $46df807587d3bd98$var$hasOwnProperty_1;
var $46df807587d3bd98$var$uid$1 = $46df807587d3bd98$var$uid$2;
var $46df807587d3bd98$var$NATIVE_SYMBOL = $46df807587d3bd98$var$symbolConstructorDetection;
var $46df807587d3bd98$var$USE_SYMBOL_AS_UID = $46df807587d3bd98$var$useSymbolAsUid;
var $46df807587d3bd98$var$WellKnownSymbolsStore = $46df807587d3bd98$var$shared$2("wks");
var $46df807587d3bd98$var$Symbol$1 = $46df807587d3bd98$var$global$5.Symbol;
var $46df807587d3bd98$var$symbolFor = $46df807587d3bd98$var$Symbol$1 && $46df807587d3bd98$var$Symbol$1["for"];
var $46df807587d3bd98$var$createWellKnownSymbol = $46df807587d3bd98$var$USE_SYMBOL_AS_UID ? $46df807587d3bd98$var$Symbol$1 : $46df807587d3bd98$var$Symbol$1 && $46df807587d3bd98$var$Symbol$1.withoutSetter || $46df807587d3bd98$var$uid$1;
var $46df807587d3bd98$var$wellKnownSymbol$5 = function(name) {
    if (!$46df807587d3bd98$var$hasOwn$6($46df807587d3bd98$var$WellKnownSymbolsStore, name) || !($46df807587d3bd98$var$NATIVE_SYMBOL || typeof $46df807587d3bd98$var$WellKnownSymbolsStore[name] == "string")) {
        var description = "Symbol." + name;
        if ($46df807587d3bd98$var$NATIVE_SYMBOL && $46df807587d3bd98$var$hasOwn$6($46df807587d3bd98$var$Symbol$1, name)) $46df807587d3bd98$var$WellKnownSymbolsStore[name] = $46df807587d3bd98$var$Symbol$1[name];
        else if ($46df807587d3bd98$var$USE_SYMBOL_AS_UID && $46df807587d3bd98$var$symbolFor) $46df807587d3bd98$var$WellKnownSymbolsStore[name] = $46df807587d3bd98$var$symbolFor(description);
        else $46df807587d3bd98$var$WellKnownSymbolsStore[name] = $46df807587d3bd98$var$createWellKnownSymbol(description);
    }
    return $46df807587d3bd98$var$WellKnownSymbolsStore[name];
};
var $46df807587d3bd98$var$call$1 = $46df807587d3bd98$var$functionCall;
var $46df807587d3bd98$var$isObject$4 = $46df807587d3bd98$var$isObject$6;
var $46df807587d3bd98$var$isSymbol$1 = $46df807587d3bd98$var$isSymbol$2;
var $46df807587d3bd98$var$getMethod = $46df807587d3bd98$var$getMethod$1;
var $46df807587d3bd98$var$ordinaryToPrimitive = $46df807587d3bd98$var$ordinaryToPrimitive$1;
var $46df807587d3bd98$var$wellKnownSymbol$4 = $46df807587d3bd98$var$wellKnownSymbol$5;
var $46df807587d3bd98$var$$TypeError$2 = TypeError;
var $46df807587d3bd98$var$TO_PRIMITIVE = $46df807587d3bd98$var$wellKnownSymbol$4("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var $46df807587d3bd98$var$toPrimitive$1 = function(input, pref) {
    if (!$46df807587d3bd98$var$isObject$4(input) || $46df807587d3bd98$var$isSymbol$1(input)) return input;
    var exoticToPrim = $46df807587d3bd98$var$getMethod(input, $46df807587d3bd98$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $46df807587d3bd98$var$call$1(exoticToPrim, input, pref);
        if (!$46df807587d3bd98$var$isObject$4(result) || $46df807587d3bd98$var$isSymbol$1(result)) return result;
        throw $46df807587d3bd98$var$$TypeError$2("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $46df807587d3bd98$var$ordinaryToPrimitive(input, pref);
};
var $46df807587d3bd98$var$toPrimitive = $46df807587d3bd98$var$toPrimitive$1;
var $46df807587d3bd98$var$isSymbol = $46df807587d3bd98$var$isSymbol$2;
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var $46df807587d3bd98$var$toPropertyKey$2 = function(argument) {
    var key = $46df807587d3bd98$var$toPrimitive(argument, "string");
    return $46df807587d3bd98$var$isSymbol(key) ? key : key + "";
};
var $46df807587d3bd98$var$global$4 = $46df807587d3bd98$var$global$a;
var $46df807587d3bd98$var$isObject$3 = $46df807587d3bd98$var$isObject$6;
var $46df807587d3bd98$var$document$1 = $46df807587d3bd98$var$global$4.document;
// typeof document.createElement is 'object' in old IE
var $46df807587d3bd98$var$EXISTS$1 = $46df807587d3bd98$var$isObject$3($46df807587d3bd98$var$document$1) && $46df807587d3bd98$var$isObject$3($46df807587d3bd98$var$document$1.createElement);
var $46df807587d3bd98$var$documentCreateElement$1 = function(it) {
    return $46df807587d3bd98$var$EXISTS$1 ? $46df807587d3bd98$var$document$1.createElement(it) : {};
};
var $46df807587d3bd98$var$DESCRIPTORS$7 = $46df807587d3bd98$var$descriptors;
var $46df807587d3bd98$var$fails$4 = $46df807587d3bd98$var$fails$9;
var $46df807587d3bd98$var$createElement = $46df807587d3bd98$var$documentCreateElement$1;
// Thanks to IE8 for its funny defineProperty
var $46df807587d3bd98$var$ie8DomDefine = !$46df807587d3bd98$var$DESCRIPTORS$7 && !$46df807587d3bd98$var$fails$4(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($46df807587d3bd98$var$createElement("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});
var $46df807587d3bd98$var$DESCRIPTORS$6 = $46df807587d3bd98$var$descriptors;
var $46df807587d3bd98$var$call = $46df807587d3bd98$var$functionCall;
var $46df807587d3bd98$var$propertyIsEnumerableModule = $46df807587d3bd98$var$objectPropertyIsEnumerable;
var $46df807587d3bd98$var$createPropertyDescriptor$1 = $46df807587d3bd98$var$createPropertyDescriptor$2;
var $46df807587d3bd98$var$toIndexedObject$3 = $46df807587d3bd98$var$toIndexedObject$4;
var $46df807587d3bd98$var$toPropertyKey$1 = $46df807587d3bd98$var$toPropertyKey$2;
var $46df807587d3bd98$var$hasOwn$5 = $46df807587d3bd98$var$hasOwnProperty_1;
var $46df807587d3bd98$var$IE8_DOM_DEFINE$1 = $46df807587d3bd98$var$ie8DomDefine;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $46df807587d3bd98$var$$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$46df807587d3bd98$var$objectGetOwnPropertyDescriptor.f = $46df807587d3bd98$var$DESCRIPTORS$6 ? $46df807587d3bd98$var$$getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
    O = $46df807587d3bd98$var$toIndexedObject$3(O);
    P = $46df807587d3bd98$var$toPropertyKey$1(P);
    if ($46df807587d3bd98$var$IE8_DOM_DEFINE$1) try {
        return $46df807587d3bd98$var$$getOwnPropertyDescriptor$1(O, P);
    } catch (error) {}
    if ($46df807587d3bd98$var$hasOwn$5(O, P)) return $46df807587d3bd98$var$createPropertyDescriptor$1(!$46df807587d3bd98$var$call($46df807587d3bd98$var$propertyIsEnumerableModule.f, O, P), O[P]);
};
var $46df807587d3bd98$var$objectDefineProperty = {};
var $46df807587d3bd98$var$DESCRIPTORS$5 = $46df807587d3bd98$var$descriptors;
var $46df807587d3bd98$var$fails$3 = $46df807587d3bd98$var$fails$9;
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var $46df807587d3bd98$var$v8PrototypeDefineBug = $46df807587d3bd98$var$DESCRIPTORS$5 && $46df807587d3bd98$var$fails$3(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});
var $46df807587d3bd98$var$isObject$2 = $46df807587d3bd98$var$isObject$6;
var $46df807587d3bd98$var$$String = String;
var $46df807587d3bd98$var$$TypeError$1 = TypeError;
// `Assert: Type(argument) is Object`
var $46df807587d3bd98$var$anObject$4 = function(argument) {
    if ($46df807587d3bd98$var$isObject$2(argument)) return argument;
    throw $46df807587d3bd98$var$$TypeError$1($46df807587d3bd98$var$$String(argument) + " is not an object");
};
var $46df807587d3bd98$var$DESCRIPTORS$4 = $46df807587d3bd98$var$descriptors;
var $46df807587d3bd98$var$IE8_DOM_DEFINE = $46df807587d3bd98$var$ie8DomDefine;
var $46df807587d3bd98$var$V8_PROTOTYPE_DEFINE_BUG$1 = $46df807587d3bd98$var$v8PrototypeDefineBug;
var $46df807587d3bd98$var$anObject$3 = $46df807587d3bd98$var$anObject$4;
var $46df807587d3bd98$var$toPropertyKey = $46df807587d3bd98$var$toPropertyKey$2;
var $46df807587d3bd98$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $46df807587d3bd98$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $46df807587d3bd98$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $46df807587d3bd98$var$ENUMERABLE = "enumerable";
var $46df807587d3bd98$var$CONFIGURABLE$1 = "configurable";
var $46df807587d3bd98$var$WRITABLE = "writable";
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
$46df807587d3bd98$var$objectDefineProperty.f = $46df807587d3bd98$var$DESCRIPTORS$4 ? $46df807587d3bd98$var$V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
    $46df807587d3bd98$var$anObject$3(O);
    P = $46df807587d3bd98$var$toPropertyKey(P);
    $46df807587d3bd98$var$anObject$3(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $46df807587d3bd98$var$WRITABLE in Attributes && !Attributes[$46df807587d3bd98$var$WRITABLE]) {
        var current = $46df807587d3bd98$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$46df807587d3bd98$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $46df807587d3bd98$var$CONFIGURABLE$1 in Attributes ? Attributes[$46df807587d3bd98$var$CONFIGURABLE$1] : current[$46df807587d3bd98$var$CONFIGURABLE$1],
                enumerable: $46df807587d3bd98$var$ENUMERABLE in Attributes ? Attributes[$46df807587d3bd98$var$ENUMERABLE] : current[$46df807587d3bd98$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $46df807587d3bd98$var$$defineProperty(O, P, Attributes);
} : $46df807587d3bd98$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $46df807587d3bd98$var$anObject$3(O);
    P = $46df807587d3bd98$var$toPropertyKey(P);
    $46df807587d3bd98$var$anObject$3(Attributes);
    if ($46df807587d3bd98$var$IE8_DOM_DEFINE) try {
        return $46df807587d3bd98$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $46df807587d3bd98$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};
var $46df807587d3bd98$var$DESCRIPTORS$3 = $46df807587d3bd98$var$descriptors;
var $46df807587d3bd98$var$definePropertyModule$3 = $46df807587d3bd98$var$objectDefineProperty;
var $46df807587d3bd98$var$createPropertyDescriptor = $46df807587d3bd98$var$createPropertyDescriptor$2;
var $46df807587d3bd98$var$createNonEnumerableProperty$2 = $46df807587d3bd98$var$DESCRIPTORS$3 ? function(object, key, value) {
    return $46df807587d3bd98$var$definePropertyModule$3.f(object, key, $46df807587d3bd98$var$createPropertyDescriptor(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var $46df807587d3bd98$var$makeBuiltIn$2 = {
    exports: {}
};
var $46df807587d3bd98$var$DESCRIPTORS$2 = $46df807587d3bd98$var$descriptors;
var $46df807587d3bd98$var$hasOwn$4 = $46df807587d3bd98$var$hasOwnProperty_1;
var $46df807587d3bd98$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $46df807587d3bd98$var$getDescriptor = $46df807587d3bd98$var$DESCRIPTORS$2 && Object.getOwnPropertyDescriptor;
var $46df807587d3bd98$var$EXISTS = $46df807587d3bd98$var$hasOwn$4($46df807587d3bd98$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $46df807587d3bd98$var$PROPER = $46df807587d3bd98$var$EXISTS && (function something() {}).name === "something";
var $46df807587d3bd98$var$CONFIGURABLE = $46df807587d3bd98$var$EXISTS && (!$46df807587d3bd98$var$DESCRIPTORS$2 || $46df807587d3bd98$var$DESCRIPTORS$2 && $46df807587d3bd98$var$getDescriptor($46df807587d3bd98$var$FunctionPrototype, "name").configurable);
var $46df807587d3bd98$var$functionName = {
    EXISTS: $46df807587d3bd98$var$EXISTS,
    PROPER: $46df807587d3bd98$var$PROPER,
    CONFIGURABLE: $46df807587d3bd98$var$CONFIGURABLE
};
var $46df807587d3bd98$var$uncurryThis$5 = $46df807587d3bd98$var$functionUncurryThis;
var $46df807587d3bd98$var$isCallable$6 = $46df807587d3bd98$var$isCallable$c;
var $46df807587d3bd98$var$store$1 = $46df807587d3bd98$var$sharedStore;
var $46df807587d3bd98$var$functionToString = $46df807587d3bd98$var$uncurryThis$5(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$46df807587d3bd98$var$isCallable$6($46df807587d3bd98$var$store$1.inspectSource)) $46df807587d3bd98$var$store$1.inspectSource = function(it) {
    return $46df807587d3bd98$var$functionToString(it);
};
var $46df807587d3bd98$var$inspectSource$2 = $46df807587d3bd98$var$store$1.inspectSource;
var $46df807587d3bd98$var$global$3 = $46df807587d3bd98$var$global$a;
var $46df807587d3bd98$var$isCallable$5 = $46df807587d3bd98$var$isCallable$c;
var $46df807587d3bd98$var$WeakMap$1 = $46df807587d3bd98$var$global$3.WeakMap;
var $46df807587d3bd98$var$weakMapBasicDetection = $46df807587d3bd98$var$isCallable$5($46df807587d3bd98$var$WeakMap$1) && /native code/.test(String($46df807587d3bd98$var$WeakMap$1));
var $46df807587d3bd98$var$shared$1 = $46df807587d3bd98$var$shared$3.exports;
var $46df807587d3bd98$var$uid = $46df807587d3bd98$var$uid$2;
var $46df807587d3bd98$var$keys = $46df807587d3bd98$var$shared$1("keys");
var $46df807587d3bd98$var$sharedKey$2 = function(key) {
    return $46df807587d3bd98$var$keys[key] || ($46df807587d3bd98$var$keys[key] = $46df807587d3bd98$var$uid(key));
};
var $46df807587d3bd98$var$hiddenKeys$4 = {};
var $46df807587d3bd98$var$NATIVE_WEAK_MAP = $46df807587d3bd98$var$weakMapBasicDetection;
var $46df807587d3bd98$var$global$2 = $46df807587d3bd98$var$global$a;
var $46df807587d3bd98$var$isObject$1 = $46df807587d3bd98$var$isObject$6;
var $46df807587d3bd98$var$createNonEnumerableProperty$1 = $46df807587d3bd98$var$createNonEnumerableProperty$2;
var $46df807587d3bd98$var$hasOwn$3 = $46df807587d3bd98$var$hasOwnProperty_1;
var $46df807587d3bd98$var$shared = $46df807587d3bd98$var$sharedStore;
var $46df807587d3bd98$var$sharedKey$1 = $46df807587d3bd98$var$sharedKey$2;
var $46df807587d3bd98$var$hiddenKeys$3 = $46df807587d3bd98$var$hiddenKeys$4;
var $46df807587d3bd98$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $46df807587d3bd98$var$TypeError$1 = $46df807587d3bd98$var$global$2.TypeError;
var $46df807587d3bd98$var$WeakMap = $46df807587d3bd98$var$global$2.WeakMap;
var $46df807587d3bd98$var$set, $46df807587d3bd98$var$get, $46df807587d3bd98$var$has;
var $46df807587d3bd98$var$enforce = function(it) {
    return $46df807587d3bd98$var$has(it) ? $46df807587d3bd98$var$get(it) : $46df807587d3bd98$var$set(it, {});
};
var $46df807587d3bd98$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$46df807587d3bd98$var$isObject$1(it) || (state = $46df807587d3bd98$var$get(it)).type !== TYPE) throw $46df807587d3bd98$var$TypeError$1("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($46df807587d3bd98$var$NATIVE_WEAK_MAP || $46df807587d3bd98$var$shared.state) {
    var $46df807587d3bd98$var$store = $46df807587d3bd98$var$shared.state || ($46df807587d3bd98$var$shared.state = new $46df807587d3bd98$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $46df807587d3bd98$var$store.get = $46df807587d3bd98$var$store.get;
    $46df807587d3bd98$var$store.has = $46df807587d3bd98$var$store.has;
    $46df807587d3bd98$var$store.set = $46df807587d3bd98$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $46df807587d3bd98$var$set = function(it, metadata) {
        if ($46df807587d3bd98$var$store.has(it)) throw $46df807587d3bd98$var$TypeError$1($46df807587d3bd98$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $46df807587d3bd98$var$store.set(it, metadata);
        return metadata;
    };
    $46df807587d3bd98$var$get = function(it) {
        return $46df807587d3bd98$var$store.get(it) || {};
    };
    $46df807587d3bd98$var$has = function(it) {
        return $46df807587d3bd98$var$store.has(it);
    };
} else {
    var $46df807587d3bd98$var$STATE = $46df807587d3bd98$var$sharedKey$1("state");
    $46df807587d3bd98$var$hiddenKeys$3[$46df807587d3bd98$var$STATE] = true;
    $46df807587d3bd98$var$set = function(it, metadata) {
        if ($46df807587d3bd98$var$hasOwn$3(it, $46df807587d3bd98$var$STATE)) throw $46df807587d3bd98$var$TypeError$1($46df807587d3bd98$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $46df807587d3bd98$var$createNonEnumerableProperty$1(it, $46df807587d3bd98$var$STATE, metadata);
        return metadata;
    };
    $46df807587d3bd98$var$get = function(it) {
        return $46df807587d3bd98$var$hasOwn$3(it, $46df807587d3bd98$var$STATE) ? it[$46df807587d3bd98$var$STATE] : {};
    };
    $46df807587d3bd98$var$has = function(it) {
        return $46df807587d3bd98$var$hasOwn$3(it, $46df807587d3bd98$var$STATE);
    };
}
var $46df807587d3bd98$var$internalState = {
    set: $46df807587d3bd98$var$set,
    get: $46df807587d3bd98$var$get,
    has: $46df807587d3bd98$var$has,
    enforce: $46df807587d3bd98$var$enforce,
    getterFor: $46df807587d3bd98$var$getterFor
};
var $46df807587d3bd98$var$fails$2 = $46df807587d3bd98$var$fails$9;
var $46df807587d3bd98$var$isCallable$4 = $46df807587d3bd98$var$isCallable$c;
var $46df807587d3bd98$var$hasOwn$2 = $46df807587d3bd98$var$hasOwnProperty_1;
var $46df807587d3bd98$var$DESCRIPTORS$1 = $46df807587d3bd98$var$descriptors;
var $46df807587d3bd98$var$CONFIGURABLE_FUNCTION_NAME = $46df807587d3bd98$var$functionName.CONFIGURABLE;
var $46df807587d3bd98$var$inspectSource$1 = $46df807587d3bd98$var$inspectSource$2;
var $46df807587d3bd98$var$InternalStateModule = $46df807587d3bd98$var$internalState;
var $46df807587d3bd98$var$enforceInternalState = $46df807587d3bd98$var$InternalStateModule.enforce;
var $46df807587d3bd98$var$getInternalState = $46df807587d3bd98$var$InternalStateModule.get;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $46df807587d3bd98$var$defineProperty$1 = Object.defineProperty;
var $46df807587d3bd98$var$CONFIGURABLE_LENGTH = $46df807587d3bd98$var$DESCRIPTORS$1 && !$46df807587d3bd98$var$fails$2(function() {
    return $46df807587d3bd98$var$defineProperty$1(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $46df807587d3bd98$var$TEMPLATE = String(String).split("String");
var $46df807587d3bd98$var$makeBuiltIn$1 = $46df807587d3bd98$var$makeBuiltIn$2.exports = function(value, name, options) {
    if (String(name).slice(0, 7) === "Symbol(") name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$46df807587d3bd98$var$hasOwn$2(value, "name") || $46df807587d3bd98$var$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($46df807587d3bd98$var$DESCRIPTORS$1) $46df807587d3bd98$var$defineProperty$1(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($46df807587d3bd98$var$CONFIGURABLE_LENGTH && options && $46df807587d3bd98$var$hasOwn$2(options, "arity") && value.length !== options.arity) $46df807587d3bd98$var$defineProperty$1(value, "length", {
        value: options.arity
    });
    try {
        if (options && $46df807587d3bd98$var$hasOwn$2(options, "constructor") && options.constructor) {
            if ($46df807587d3bd98$var$DESCRIPTORS$1) $46df807587d3bd98$var$defineProperty$1(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $46df807587d3bd98$var$enforceInternalState(value);
    if (!$46df807587d3bd98$var$hasOwn$2(state, "source")) state.source = $46df807587d3bd98$var$TEMPLATE.join(typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $46df807587d3bd98$var$makeBuiltIn$1(function toString() {
    return $46df807587d3bd98$var$isCallable$4(this) && $46df807587d3bd98$var$getInternalState(this).source || $46df807587d3bd98$var$inspectSource$1(this);
}, "toString");
var $46df807587d3bd98$var$isCallable$3 = $46df807587d3bd98$var$isCallable$c;
var $46df807587d3bd98$var$definePropertyModule$2 = $46df807587d3bd98$var$objectDefineProperty;
var $46df807587d3bd98$var$makeBuiltIn = $46df807587d3bd98$var$makeBuiltIn$2.exports;
var $46df807587d3bd98$var$defineGlobalProperty$1 = $46df807587d3bd98$var$defineGlobalProperty$3;
var $46df807587d3bd98$var$defineBuiltIn$1 = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($46df807587d3bd98$var$isCallable$3(value)) $46df807587d3bd98$var$makeBuiltIn(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $46df807587d3bd98$var$defineGlobalProperty$1(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $46df807587d3bd98$var$definePropertyModule$2.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};
var $46df807587d3bd98$var$objectGetOwnPropertyNames = {};
var $46df807587d3bd98$var$ceil = Math.ceil;
var $46df807587d3bd98$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var $46df807587d3bd98$var$mathTrunc = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $46df807587d3bd98$var$floor : $46df807587d3bd98$var$ceil)(n);
};
var $46df807587d3bd98$var$trunc = $46df807587d3bd98$var$mathTrunc;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var $46df807587d3bd98$var$toIntegerOrInfinity$2 = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $46df807587d3bd98$var$trunc(number);
};
var $46df807587d3bd98$var$toIntegerOrInfinity$1 = $46df807587d3bd98$var$toIntegerOrInfinity$2;
var $46df807587d3bd98$var$max = Math.max;
var $46df807587d3bd98$var$min$1 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var $46df807587d3bd98$var$toAbsoluteIndex$1 = function(index, length) {
    var integer = $46df807587d3bd98$var$toIntegerOrInfinity$1(index);
    return integer < 0 ? $46df807587d3bd98$var$max(integer + length, 0) : $46df807587d3bd98$var$min$1(integer, length);
};
var $46df807587d3bd98$var$toIntegerOrInfinity = $46df807587d3bd98$var$toIntegerOrInfinity$2;
var $46df807587d3bd98$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var $46df807587d3bd98$var$toLength$1 = function(argument) {
    return argument > 0 ? $46df807587d3bd98$var$min($46df807587d3bd98$var$toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var $46df807587d3bd98$var$toLength = $46df807587d3bd98$var$toLength$1;
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var $46df807587d3bd98$var$lengthOfArrayLike$2 = function(obj) {
    return $46df807587d3bd98$var$toLength(obj.length);
};
var $46df807587d3bd98$var$toIndexedObject$2 = $46df807587d3bd98$var$toIndexedObject$4;
var $46df807587d3bd98$var$toAbsoluteIndex = $46df807587d3bd98$var$toAbsoluteIndex$1;
var $46df807587d3bd98$var$lengthOfArrayLike$1 = $46df807587d3bd98$var$lengthOfArrayLike$2;
// `Array.prototype.{ indexOf, includes }` methods implementation
var $46df807587d3bd98$var$createMethod$1 = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $46df807587d3bd98$var$toIndexedObject$2($this);
        var length = $46df807587d3bd98$var$lengthOfArrayLike$1(O);
        var index = $46df807587d3bd98$var$toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var $46df807587d3bd98$var$arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $46df807587d3bd98$var$createMethod$1(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $46df807587d3bd98$var$createMethod$1(false)
};
var $46df807587d3bd98$var$uncurryThis$4 = $46df807587d3bd98$var$functionUncurryThis;
var $46df807587d3bd98$var$hasOwn$1 = $46df807587d3bd98$var$hasOwnProperty_1;
var $46df807587d3bd98$var$toIndexedObject$1 = $46df807587d3bd98$var$toIndexedObject$4;
var $46df807587d3bd98$var$indexOf = $46df807587d3bd98$var$arrayIncludes.indexOf;
var $46df807587d3bd98$var$hiddenKeys$2 = $46df807587d3bd98$var$hiddenKeys$4;
var $46df807587d3bd98$var$push$1 = $46df807587d3bd98$var$uncurryThis$4([].push);
var $46df807587d3bd98$var$objectKeysInternal = function(object, names) {
    var O = $46df807587d3bd98$var$toIndexedObject$1(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$46df807587d3bd98$var$hasOwn$1($46df807587d3bd98$var$hiddenKeys$2, key) && $46df807587d3bd98$var$hasOwn$1(O, key) && $46df807587d3bd98$var$push$1(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($46df807587d3bd98$var$hasOwn$1(O, key = names[i++])) ~$46df807587d3bd98$var$indexOf(result, key) || $46df807587d3bd98$var$push$1(result, key);
    return result;
};
// IE8- don't enum bug keys
var $46df807587d3bd98$var$enumBugKeys$3 = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];
var $46df807587d3bd98$var$internalObjectKeys$1 = $46df807587d3bd98$var$objectKeysInternal;
var $46df807587d3bd98$var$enumBugKeys$2 = $46df807587d3bd98$var$enumBugKeys$3;
var $46df807587d3bd98$var$hiddenKeys$1 = $46df807587d3bd98$var$enumBugKeys$2.concat("length", "prototype");
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
$46df807587d3bd98$var$objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $46df807587d3bd98$var$internalObjectKeys$1(O, $46df807587d3bd98$var$hiddenKeys$1);
};
var $46df807587d3bd98$var$objectGetOwnPropertySymbols = {};
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
$46df807587d3bd98$var$objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var $46df807587d3bd98$var$getBuiltIn$2 = $46df807587d3bd98$var$getBuiltIn$5;
var $46df807587d3bd98$var$uncurryThis$3 = $46df807587d3bd98$var$functionUncurryThis;
var $46df807587d3bd98$var$getOwnPropertyNamesModule = $46df807587d3bd98$var$objectGetOwnPropertyNames;
var $46df807587d3bd98$var$getOwnPropertySymbolsModule = $46df807587d3bd98$var$objectGetOwnPropertySymbols;
var $46df807587d3bd98$var$anObject$2 = $46df807587d3bd98$var$anObject$4;
var $46df807587d3bd98$var$concat = $46df807587d3bd98$var$uncurryThis$3([].concat);
// all object keys, includes non-enumerable and symbols
var $46df807587d3bd98$var$ownKeys$1 = $46df807587d3bd98$var$getBuiltIn$2("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $46df807587d3bd98$var$getOwnPropertyNamesModule.f($46df807587d3bd98$var$anObject$2(it));
    var getOwnPropertySymbols = $46df807587d3bd98$var$getOwnPropertySymbolsModule.f;
    return getOwnPropertySymbols ? $46df807587d3bd98$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};
var $46df807587d3bd98$var$hasOwn = $46df807587d3bd98$var$hasOwnProperty_1;
var $46df807587d3bd98$var$ownKeys = $46df807587d3bd98$var$ownKeys$1;
var $46df807587d3bd98$var$getOwnPropertyDescriptorModule = $46df807587d3bd98$var$objectGetOwnPropertyDescriptor;
var $46df807587d3bd98$var$definePropertyModule$1 = $46df807587d3bd98$var$objectDefineProperty;
var $46df807587d3bd98$var$copyConstructorProperties$1 = function(target, source, exceptions) {
    var keys = $46df807587d3bd98$var$ownKeys(source);
    var defineProperty = $46df807587d3bd98$var$definePropertyModule$1.f;
    var getOwnPropertyDescriptor = $46df807587d3bd98$var$getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$46df807587d3bd98$var$hasOwn(target, key) && !(exceptions && $46df807587d3bd98$var$hasOwn(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var $46df807587d3bd98$var$fails$1 = $46df807587d3bd98$var$fails$9;
var $46df807587d3bd98$var$isCallable$2 = $46df807587d3bd98$var$isCallable$c;
var $46df807587d3bd98$var$replacement = /#|\.prototype\./;
var $46df807587d3bd98$var$isForced$1 = function(feature, detection) {
    var value = $46df807587d3bd98$var$data[$46df807587d3bd98$var$normalize(feature)];
    return value == $46df807587d3bd98$var$POLYFILL ? true : value == $46df807587d3bd98$var$NATIVE ? false : $46df807587d3bd98$var$isCallable$2(detection) ? $46df807587d3bd98$var$fails$1(detection) : !!detection;
};
var $46df807587d3bd98$var$normalize = $46df807587d3bd98$var$isForced$1.normalize = function(string) {
    return String(string).replace($46df807587d3bd98$var$replacement, ".").toLowerCase();
};
var $46df807587d3bd98$var$data = $46df807587d3bd98$var$isForced$1.data = {};
var $46df807587d3bd98$var$NATIVE = $46df807587d3bd98$var$isForced$1.NATIVE = "N";
var $46df807587d3bd98$var$POLYFILL = $46df807587d3bd98$var$isForced$1.POLYFILL = "P";
var $46df807587d3bd98$var$isForced_1 = $46df807587d3bd98$var$isForced$1;
var $46df807587d3bd98$var$global$1 = $46df807587d3bd98$var$global$a;
var $46df807587d3bd98$var$getOwnPropertyDescriptor = $46df807587d3bd98$var$objectGetOwnPropertyDescriptor.f;
var $46df807587d3bd98$var$createNonEnumerableProperty = $46df807587d3bd98$var$createNonEnumerableProperty$2;
var $46df807587d3bd98$var$defineBuiltIn = $46df807587d3bd98$var$defineBuiltIn$1;
var $46df807587d3bd98$var$defineGlobalProperty = $46df807587d3bd98$var$defineGlobalProperty$3;
var $46df807587d3bd98$var$copyConstructorProperties = $46df807587d3bd98$var$copyConstructorProperties$1;
var $46df807587d3bd98$var$isForced = $46df807587d3bd98$var$isForced_1;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ var $46df807587d3bd98$var$_export = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $46df807587d3bd98$var$global$1;
    else if (STATIC) target = $46df807587d3bd98$var$global$1[TARGET] || $46df807587d3bd98$var$defineGlobalProperty(TARGET, {});
    else target = ($46df807587d3bd98$var$global$1[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $46df807587d3bd98$var$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $46df807587d3bd98$var$isForced(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $46df807587d3bd98$var$copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $46df807587d3bd98$var$createNonEnumerableProperty(sourceProperty, "sham", true);
        $46df807587d3bd98$var$defineBuiltIn(target, key, sourceProperty, options);
    }
};
var $46df807587d3bd98$var$uncurryThis$2 = $46df807587d3bd98$var$functionUncurryThis;
var $46df807587d3bd98$var$aCallable = $46df807587d3bd98$var$aCallable$2;
var $46df807587d3bd98$var$NATIVE_BIND = $46df807587d3bd98$var$functionBindNative;
var $46df807587d3bd98$var$bind$1 = $46df807587d3bd98$var$uncurryThis$2($46df807587d3bd98$var$uncurryThis$2.bind);
// optional / simple context binding
var $46df807587d3bd98$var$functionBindContext = function(fn, that) {
    $46df807587d3bd98$var$aCallable(fn);
    return that === undefined ? fn : $46df807587d3bd98$var$NATIVE_BIND ? $46df807587d3bd98$var$bind$1(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};
var $46df807587d3bd98$var$classof$2 = $46df807587d3bd98$var$classofRaw$2;
// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var $46df807587d3bd98$var$isArray$1 = Array.isArray || function isArray(argument) {
    return $46df807587d3bd98$var$classof$2(argument) == "Array";
};
var $46df807587d3bd98$var$wellKnownSymbol$3 = $46df807587d3bd98$var$wellKnownSymbol$5;
var $46df807587d3bd98$var$TO_STRING_TAG$1 = $46df807587d3bd98$var$wellKnownSymbol$3("toStringTag");
var $46df807587d3bd98$var$test = {};
$46df807587d3bd98$var$test[$46df807587d3bd98$var$TO_STRING_TAG$1] = "z";
var $46df807587d3bd98$var$toStringTagSupport = String($46df807587d3bd98$var$test) === "[object z]";
var $46df807587d3bd98$var$TO_STRING_TAG_SUPPORT = $46df807587d3bd98$var$toStringTagSupport;
var $46df807587d3bd98$var$isCallable$1 = $46df807587d3bd98$var$isCallable$c;
var $46df807587d3bd98$var$classofRaw = $46df807587d3bd98$var$classofRaw$2;
var $46df807587d3bd98$var$wellKnownSymbol$2 = $46df807587d3bd98$var$wellKnownSymbol$5;
var $46df807587d3bd98$var$TO_STRING_TAG = $46df807587d3bd98$var$wellKnownSymbol$2("toStringTag");
var $46df807587d3bd98$var$$Object = Object;
// ES3 wrong here
var $46df807587d3bd98$var$CORRECT_ARGUMENTS = $46df807587d3bd98$var$classofRaw(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $46df807587d3bd98$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
var $46df807587d3bd98$var$classof$1 = $46df807587d3bd98$var$TO_STRING_TAG_SUPPORT ? $46df807587d3bd98$var$classofRaw : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $46df807587d3bd98$var$tryGet(O = $46df807587d3bd98$var$$Object(it), $46df807587d3bd98$var$TO_STRING_TAG)) == "string" ? tag : $46df807587d3bd98$var$CORRECT_ARGUMENTS ? $46df807587d3bd98$var$classofRaw(O) : (result = $46df807587d3bd98$var$classofRaw(O)) == "Object" && $46df807587d3bd98$var$isCallable$1(O.callee) ? "Arguments" : result;
};
var $46df807587d3bd98$var$uncurryThis$1 = $46df807587d3bd98$var$functionUncurryThis;
var $46df807587d3bd98$var$fails = $46df807587d3bd98$var$fails$9;
var $46df807587d3bd98$var$isCallable = $46df807587d3bd98$var$isCallable$c;
var $46df807587d3bd98$var$classof = $46df807587d3bd98$var$classof$1;
var $46df807587d3bd98$var$getBuiltIn$1 = $46df807587d3bd98$var$getBuiltIn$5;
var $46df807587d3bd98$var$inspectSource = $46df807587d3bd98$var$inspectSource$2;
var $46df807587d3bd98$var$noop = function() {};
var $46df807587d3bd98$var$empty = [];
var $46df807587d3bd98$var$construct = $46df807587d3bd98$var$getBuiltIn$1("Reflect", "construct");
var $46df807587d3bd98$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $46df807587d3bd98$var$exec = $46df807587d3bd98$var$uncurryThis$1($46df807587d3bd98$var$constructorRegExp.exec);
var $46df807587d3bd98$var$INCORRECT_TO_STRING = !$46df807587d3bd98$var$constructorRegExp.exec($46df807587d3bd98$var$noop);
var $46df807587d3bd98$var$isConstructorModern = function isConstructor(argument) {
    if (!$46df807587d3bd98$var$isCallable(argument)) return false;
    try {
        $46df807587d3bd98$var$construct($46df807587d3bd98$var$noop, $46df807587d3bd98$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $46df807587d3bd98$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$46df807587d3bd98$var$isCallable(argument)) return false;
    switch($46df807587d3bd98$var$classof(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $46df807587d3bd98$var$INCORRECT_TO_STRING || !!$46df807587d3bd98$var$exec($46df807587d3bd98$var$constructorRegExp, $46df807587d3bd98$var$inspectSource(argument));
    } catch (error) {
        return true;
    }
};
$46df807587d3bd98$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var $46df807587d3bd98$var$isConstructor$1 = !$46df807587d3bd98$var$construct || $46df807587d3bd98$var$fails(function() {
    var called;
    return $46df807587d3bd98$var$isConstructorModern($46df807587d3bd98$var$isConstructorModern.call) || !$46df807587d3bd98$var$isConstructorModern(Object) || !$46df807587d3bd98$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $46df807587d3bd98$var$isConstructorLegacy : $46df807587d3bd98$var$isConstructorModern;
var $46df807587d3bd98$var$isArray = $46df807587d3bd98$var$isArray$1;
var $46df807587d3bd98$var$isConstructor = $46df807587d3bd98$var$isConstructor$1;
var $46df807587d3bd98$var$isObject = $46df807587d3bd98$var$isObject$6;
var $46df807587d3bd98$var$wellKnownSymbol$1 = $46df807587d3bd98$var$wellKnownSymbol$5;
var $46df807587d3bd98$var$SPECIES = $46df807587d3bd98$var$wellKnownSymbol$1("species");
var $46df807587d3bd98$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var $46df807587d3bd98$var$arraySpeciesConstructor$1 = function(originalArray) {
    var C;
    if ($46df807587d3bd98$var$isArray(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($46df807587d3bd98$var$isConstructor(C) && (C === $46df807587d3bd98$var$$Array || $46df807587d3bd98$var$isArray(C.prototype))) C = undefined;
        else if ($46df807587d3bd98$var$isObject(C)) {
            C = C[$46df807587d3bd98$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $46df807587d3bd98$var$$Array : C;
};
var $46df807587d3bd98$var$arraySpeciesConstructor = $46df807587d3bd98$var$arraySpeciesConstructor$1;
// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var $46df807587d3bd98$var$arraySpeciesCreate$1 = function(originalArray, length) {
    return new ($46df807587d3bd98$var$arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};
var $46df807587d3bd98$var$bind = $46df807587d3bd98$var$functionBindContext;
var $46df807587d3bd98$var$uncurryThis = $46df807587d3bd98$var$functionUncurryThis;
var $46df807587d3bd98$var$IndexedObject = $46df807587d3bd98$var$indexedObject;
var $46df807587d3bd98$var$toObject = $46df807587d3bd98$var$toObject$2;
var $46df807587d3bd98$var$lengthOfArrayLike = $46df807587d3bd98$var$lengthOfArrayLike$2;
var $46df807587d3bd98$var$arraySpeciesCreate = $46df807587d3bd98$var$arraySpeciesCreate$1;
var $46df807587d3bd98$var$push = $46df807587d3bd98$var$uncurryThis([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $46df807587d3bd98$var$createMethod = function(TYPE) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var IS_FILTER_REJECT = TYPE == 7;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $46df807587d3bd98$var$toObject($this);
        var self1 = $46df807587d3bd98$var$IndexedObject(O);
        var boundFunction = $46df807587d3bd98$var$bind(callbackfn, that);
        var length = $46df807587d3bd98$var$lengthOfArrayLike(self1);
        var index = 0;
        var create = specificCreate || $46df807587d3bd98$var$arraySpeciesCreate;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self1) {
            value = self1[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $46df807587d3bd98$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $46df807587d3bd98$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
var $46df807587d3bd98$var$arrayIteration = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $46df807587d3bd98$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $46df807587d3bd98$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $46df807587d3bd98$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $46df807587d3bd98$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $46df807587d3bd98$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $46df807587d3bd98$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $46df807587d3bd98$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $46df807587d3bd98$var$createMethod(7)
};
var $46df807587d3bd98$var$objectDefineProperties = {};
var $46df807587d3bd98$var$internalObjectKeys = $46df807587d3bd98$var$objectKeysInternal;
var $46df807587d3bd98$var$enumBugKeys$1 = $46df807587d3bd98$var$enumBugKeys$3;
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var $46df807587d3bd98$var$objectKeys$1 = Object.keys || function keys(O) {
    return $46df807587d3bd98$var$internalObjectKeys(O, $46df807587d3bd98$var$enumBugKeys$1);
};
var $46df807587d3bd98$var$DESCRIPTORS = $46df807587d3bd98$var$descriptors;
var $46df807587d3bd98$var$V8_PROTOTYPE_DEFINE_BUG = $46df807587d3bd98$var$v8PrototypeDefineBug;
var $46df807587d3bd98$var$definePropertyModule = $46df807587d3bd98$var$objectDefineProperty;
var $46df807587d3bd98$var$anObject$1 = $46df807587d3bd98$var$anObject$4;
var $46df807587d3bd98$var$toIndexedObject = $46df807587d3bd98$var$toIndexedObject$4;
var $46df807587d3bd98$var$objectKeys = $46df807587d3bd98$var$objectKeys$1;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
$46df807587d3bd98$var$objectDefineProperties.f = $46df807587d3bd98$var$DESCRIPTORS && !$46df807587d3bd98$var$V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    $46df807587d3bd98$var$anObject$1(O);
    var props = $46df807587d3bd98$var$toIndexedObject(Properties);
    var keys = $46df807587d3bd98$var$objectKeys(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$46df807587d3bd98$var$definePropertyModule.f(O, key = keys[index++], props[key]);
    return O;
};
var $46df807587d3bd98$var$getBuiltIn = $46df807587d3bd98$var$getBuiltIn$5;
var $46df807587d3bd98$var$html$1 = $46df807587d3bd98$var$getBuiltIn("document", "documentElement");
/* global ActiveXObject -- old IE, WSH */ var $46df807587d3bd98$var$anObject = $46df807587d3bd98$var$anObject$4;
var $46df807587d3bd98$var$definePropertiesModule = $46df807587d3bd98$var$objectDefineProperties;
var $46df807587d3bd98$var$enumBugKeys = $46df807587d3bd98$var$enumBugKeys$3;
var $46df807587d3bd98$var$hiddenKeys = $46df807587d3bd98$var$hiddenKeys$4;
var $46df807587d3bd98$var$html = $46df807587d3bd98$var$html$1;
var $46df807587d3bd98$var$documentCreateElement = $46df807587d3bd98$var$documentCreateElement$1;
var $46df807587d3bd98$var$sharedKey = $46df807587d3bd98$var$sharedKey$2;
var $46df807587d3bd98$var$GT = ">";
var $46df807587d3bd98$var$LT = "<";
var $46df807587d3bd98$var$PROTOTYPE = "prototype";
var $46df807587d3bd98$var$SCRIPT = "script";
var $46df807587d3bd98$var$IE_PROTO = $46df807587d3bd98$var$sharedKey("IE_PROTO");
var $46df807587d3bd98$var$EmptyConstructor = function() {};
var $46df807587d3bd98$var$scriptTag = function(content) {
    return $46df807587d3bd98$var$LT + $46df807587d3bd98$var$SCRIPT + $46df807587d3bd98$var$GT + content + $46df807587d3bd98$var$LT + "/" + $46df807587d3bd98$var$SCRIPT + $46df807587d3bd98$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $46df807587d3bd98$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($46df807587d3bd98$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $46df807587d3bd98$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $46df807587d3bd98$var$documentCreateElement("iframe");
    var JS = "java" + $46df807587d3bd98$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $46df807587d3bd98$var$html.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($46df807587d3bd98$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $46df807587d3bd98$var$activeXDocument;
var $46df807587d3bd98$var$NullProtoObject = function() {
    try {
        $46df807587d3bd98$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $46df807587d3bd98$var$NullProtoObject = typeof document != "undefined" ? document.domain && $46df807587d3bd98$var$activeXDocument ? $46df807587d3bd98$var$NullProtoObjectViaActiveX($46df807587d3bd98$var$activeXDocument) // old IE
     : $46df807587d3bd98$var$NullProtoObjectViaIFrame() : $46df807587d3bd98$var$NullProtoObjectViaActiveX($46df807587d3bd98$var$activeXDocument); // WSH
    var length = $46df807587d3bd98$var$enumBugKeys.length;
    while(length--)delete $46df807587d3bd98$var$NullProtoObject[$46df807587d3bd98$var$PROTOTYPE][$46df807587d3bd98$var$enumBugKeys[length]];
    return $46df807587d3bd98$var$NullProtoObject();
};
$46df807587d3bd98$var$hiddenKeys[$46df807587d3bd98$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var $46df807587d3bd98$var$objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $46df807587d3bd98$var$EmptyConstructor[$46df807587d3bd98$var$PROTOTYPE] = $46df807587d3bd98$var$anObject(O);
        result = new $46df807587d3bd98$var$EmptyConstructor();
        $46df807587d3bd98$var$EmptyConstructor[$46df807587d3bd98$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$46df807587d3bd98$var$IE_PROTO] = O;
    } else result = $46df807587d3bd98$var$NullProtoObject();
    return Properties === undefined ? result : $46df807587d3bd98$var$definePropertiesModule.f(result, Properties);
};
var $46df807587d3bd98$var$wellKnownSymbol = $46df807587d3bd98$var$wellKnownSymbol$5;
var $46df807587d3bd98$var$create = $46df807587d3bd98$var$objectCreate;
var $46df807587d3bd98$var$defineProperty = $46df807587d3bd98$var$objectDefineProperty.f;
var $46df807587d3bd98$var$UNSCOPABLES = $46df807587d3bd98$var$wellKnownSymbol("unscopables");
var $46df807587d3bd98$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($46df807587d3bd98$var$ArrayPrototype[$46df807587d3bd98$var$UNSCOPABLES] == undefined) $46df807587d3bd98$var$defineProperty($46df807587d3bd98$var$ArrayPrototype, $46df807587d3bd98$var$UNSCOPABLES, {
    configurable: true,
    value: $46df807587d3bd98$var$create(null)
});
// add a key to Array.prototype[@@unscopables]
var $46df807587d3bd98$var$addToUnscopables$1 = function(key) {
    $46df807587d3bd98$var$ArrayPrototype[$46df807587d3bd98$var$UNSCOPABLES][key] = true;
};
var $46df807587d3bd98$var$$ = $46df807587d3bd98$var$_export;
var $46df807587d3bd98$var$$find = $46df807587d3bd98$var$arrayIteration.find;
var $46df807587d3bd98$var$addToUnscopables = $46df807587d3bd98$var$addToUnscopables$1;
var $46df807587d3bd98$var$FIND = "find";
var $46df807587d3bd98$var$SKIPS_HOLES = true;
// Shouldn't skip holes
if ($46df807587d3bd98$var$FIND in []) Array(1)[$46df807587d3bd98$var$FIND](function() {
    $46df807587d3bd98$var$SKIPS_HOLES = false;
});
// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$46df807587d3bd98$var$$({
    target: "Array",
    proto: true,
    forced: $46df807587d3bd98$var$SKIPS_HOLES
}, {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $46df807587d3bd98$var$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$46df807587d3bd98$var$addToUnscopables($46df807587d3bd98$var$FIND);
var $46df807587d3bd98$var$CONSTANT = {
    GLOBAL: {
        HIDE: "__react_tooltip_hide_event",
        REBUILD: "__react_tooltip_rebuild_event",
        SHOW: "__react_tooltip_show_event"
    }
};
/**
 * Static methods for react-tooltip
 */ var $46df807587d3bd98$var$dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
    // Compatible with IE
    // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
    // @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
    var event;
    if (typeof window.CustomEvent === "function") event = new window.CustomEvent(eventName, {
        detail: opts
    });
    else {
        event = document.createEvent("Event");
        event.initEvent(eventName, false, true, opts);
    }
    window.dispatchEvent(event);
};
function $46df807587d3bd98$var$staticMethods(target) {
    /**
   * Hide all tooltip
   * @trigger ReactTooltip.hide()
   */ target.hide = function(target) {
        $46df807587d3bd98$var$dispatchGlobalEvent($46df807587d3bd98$var$CONSTANT.GLOBAL.HIDE, {
            target: target
        });
    };
    /**
   * Rebuild all tooltip
   * @trigger ReactTooltip.rebuild()
   */ target.rebuild = function() {
        $46df807587d3bd98$var$dispatchGlobalEvent($46df807587d3bd98$var$CONSTANT.GLOBAL.REBUILD);
    };
    /**
   * Show specific tooltip
   * @trigger ReactTooltip.show()
   */ target.show = function(target) {
        $46df807587d3bd98$var$dispatchGlobalEvent($46df807587d3bd98$var$CONSTANT.GLOBAL.SHOW, {
            target: target
        });
    };
    target.prototype.globalRebuild = function() {
        if (this.mount) {
            this.unbindListener();
            this.bindListener();
        }
    };
    target.prototype.globalShow = function(event) {
        if (this.mount) {
            var hasTarget = event && event.detail && event.detail.target && true || false;
            // Create a fake event, specific show will limit the type to `solid`
            // only `float` type cares e.clientX e.clientY
            this.showTooltip({
                currentTarget: hasTarget && event.detail.target
            }, true);
        }
    };
    target.prototype.globalHide = function(event) {
        if (this.mount) {
            var hasTarget = event && event.detail && event.detail.target && true || false;
            this.hideTooltip({
                currentTarget: hasTarget && event.detail.target
            }, hasTarget);
        }
    };
}
/**
 * Events that should be bound to the window
 */ function $46df807587d3bd98$var$windowListener(target) {
    target.prototype.bindWindowEvents = function(resizeHide) {
        // ReactTooltip.hide
        window.removeEventListener($46df807587d3bd98$var$CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.addEventListener($46df807587d3bd98$var$CONSTANT.GLOBAL.HIDE, this.globalHide, false);
        // ReactTooltip.rebuild
        window.removeEventListener($46df807587d3bd98$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.addEventListener($46df807587d3bd98$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false);
        // ReactTooltip.show
        window.removeEventListener($46df807587d3bd98$var$CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.addEventListener($46df807587d3bd98$var$CONSTANT.GLOBAL.SHOW, this.globalShow, false);
        // Resize
        if (resizeHide) {
            window.removeEventListener("resize", this.onWindowResize);
            window.addEventListener("resize", this.onWindowResize, false);
        }
    };
    target.prototype.unbindWindowEvents = function() {
        window.removeEventListener($46df807587d3bd98$var$CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.removeEventListener($46df807587d3bd98$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.removeEventListener($46df807587d3bd98$var$CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.removeEventListener("resize", this.onWindowResize);
    };
    /**
   * invoked by resize event of window
   */ target.prototype.onWindowResize = function() {
        if (!this.mount) return;
        this.hideTooltip();
    };
}
/**
 * Custom events to control showing and hiding of tooltip
 *
 * @attributes
 * - `event` {String}
 * - `eventOff` {String}
 */ var $46df807587d3bd98$var$checkStatus = function checkStatus(dataEventOff, e) {
    var show = this.state.show;
    var id = this.props.id;
    var isCapture = this.isCapture(e.currentTarget);
    var currentItem = e.currentTarget.getAttribute("currentItem");
    if (!isCapture) e.stopPropagation();
    if (show && currentItem === "true") {
        if (!dataEventOff) this.hideTooltip(e);
    } else {
        e.currentTarget.setAttribute("currentItem", "true");
        $46df807587d3bd98$var$setUntargetItems(e.currentTarget, this.getTargetArray(id));
        this.showTooltip(e);
    }
};
var $46df807587d3bd98$var$setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
    for(var i = 0; i < targetArray.length; i++)if (currentTarget !== targetArray[i]) targetArray[i].setAttribute("currentItem", "false");
    else targetArray[i].setAttribute("currentItem", "true");
};
var $46df807587d3bd98$var$customListeners = {
    id: "9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf",
    set: function set(target, event, listener) {
        if (this.id in target) {
            var map = target[this.id];
            map[event] = listener;
        } else // this is workaround for WeakMap, which is not supported in older browsers, such as IE
        Object.defineProperty(target, this.id, {
            configurable: true,
            value: $46df807587d3bd98$var$_defineProperty({}, event, listener)
        });
    },
    get: function get(target, event) {
        var map = target[this.id];
        if (map !== undefined) return map[event];
    }
};
function $46df807587d3bd98$var$customEvent(target) {
    target.prototype.isCustomEvent = function(ele) {
        var event = this.state.event;
        return event || !!ele.getAttribute("data-event");
    };
    /* Bind listener for custom event */ target.prototype.customBindListener = function(ele) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff;
        var dataEvent = ele.getAttribute("data-event") || event;
        var dataEventOff = ele.getAttribute("data-event-off") || eventOff;
        dataEvent.split(" ").forEach(function(event) {
            ele.removeEventListener(event, $46df807587d3bd98$var$customListeners.get(ele, event));
            var customListener = $46df807587d3bd98$var$checkStatus.bind(_this, dataEventOff);
            $46df807587d3bd98$var$customListeners.set(ele, event, customListener);
            ele.addEventListener(event, customListener, false);
        });
        if (dataEventOff) dataEventOff.split(" ").forEach(function(event) {
            ele.removeEventListener(event, _this.hideTooltip);
            ele.addEventListener(event, _this.hideTooltip, false);
        });
    };
    /* Unbind listener for custom event */ target.prototype.customUnbindListener = function(ele) {
        var _this$state2 = this.state, event = _this$state2.event, eventOff = _this$state2.eventOff;
        var dataEvent = event || ele.getAttribute("data-event");
        var dataEventOff = eventOff || ele.getAttribute("data-event-off");
        ele.removeEventListener(dataEvent, $46df807587d3bd98$var$customListeners.get(ele, event));
        if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
    };
}
/**
 * Util method to judge if it should follow capture model
 */ function $46df807587d3bd98$var$isCapture(target) {
    target.prototype.isCapture = function(currentTarget) {
        return currentTarget && currentTarget.getAttribute("data-iscapture") === "true" || this.props.isCapture || false;
    };
}
/**
 * Util method to get effect
 */ function $46df807587d3bd98$var$getEffect(target) {
    target.prototype.getEffect = function(currentTarget) {
        var dataEffect = currentTarget.getAttribute("data-effect");
        return dataEffect || this.props.effect || "float";
    };
}
/**
 * Util method to get effect
 */ var $46df807587d3bd98$var$makeProxy = function makeProxy(e) {
    var proxy = {};
    for(var key in e)if (typeof e[key] === "function") proxy[key] = e[key].bind(e);
    else proxy[key] = e[key];
    return proxy;
};
var $46df807587d3bd98$var$bodyListener = function bodyListener(callback, options, e) {
    var _options$respectEffec = options.respectEffect, respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec, _options$customEvent = options.customEvent, customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
    var id = this.props.id;
    var tip = null;
    var forId;
    var target = e.target;
    var lastTarget;
    // walk up parent chain until tip is found
    // there is no match if parent visible area is matched by mouse position, so some corner cases might not work as expected
    while(tip === null && target !== null){
        lastTarget = target;
        tip = target.getAttribute("data-tip") || null;
        forId = target.getAttribute("data-for") || null;
        target = target.parentElement;
    }
    target = lastTarget || e.target;
    if (this.isCustomEvent(target) && !customEvent) return;
    var isTargetBelongsToTooltip = id == null && forId == null || forId === id;
    if (tip != null && (!respectEffect || this.getEffect(target) === "float") && isTargetBelongsToTooltip) {
        var proxy = $46df807587d3bd98$var$makeProxy(e);
        proxy.currentTarget = target;
        callback(proxy);
    }
};
var $46df807587d3bd98$var$findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
    var events = {};
    targetArray.forEach(function(target) {
        var event = target.getAttribute(dataAttribute);
        if (event) event.split(" ").forEach(function(event) {
            return events[event] = true;
        });
    });
    return events;
};
var $46df807587d3bd98$var$getBody = function getBody() {
    return document.getElementsByTagName("body")[0];
};
function $46df807587d3bd98$var$bodyMode(target) {
    target.prototype.isBodyMode = function() {
        return !!this.props.bodyMode;
    };
    target.prototype.bindBodyListener = function(targetArray) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff, possibleCustomEvents = _this$state.possibleCustomEvents, possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
        var body = $46df807587d3bd98$var$getBody();
        var customEvents = $46df807587d3bd98$var$findCustomEvents(targetArray, "data-event");
        var customEventsOff = $46df807587d3bd98$var$findCustomEvents(targetArray, "data-event-off");
        if (event != null) customEvents[event] = true;
        if (eventOff != null) customEventsOff[eventOff] = true;
        possibleCustomEvents.split(" ").forEach(function(event) {
            return customEvents[event] = true;
        });
        possibleCustomEventsOff.split(" ").forEach(function(event) {
            return customEventsOff[event] = true;
        });
        this.unbindBodyListener(body);
        var listeners = this.bodyModeListeners = {};
        if (event == null) {
            listeners.mouseover = $46df807587d3bd98$var$bodyListener.bind(this, this.showTooltip, {});
            listeners.mousemove = $46df807587d3bd98$var$bodyListener.bind(this, this.updateTooltip, {
                respectEffect: true
            });
            listeners.mouseout = $46df807587d3bd98$var$bodyListener.bind(this, this.hideTooltip, {});
        }
        for(var _event in customEvents)listeners[_event] = $46df807587d3bd98$var$bodyListener.bind(this, function(e) {
            var targetEventOff = e.currentTarget.getAttribute("data-event-off") || eventOff;
            $46df807587d3bd98$var$checkStatus.call(_this, targetEventOff, e);
        }, {
            customEvent: true
        });
        for(var _event2 in customEventsOff)listeners[_event2] = $46df807587d3bd98$var$bodyListener.bind(this, this.hideTooltip, {
            customEvent: true
        });
        for(var _event3 in listeners)body.addEventListener(_event3, listeners[_event3]);
    };
    target.prototype.unbindBodyListener = function(body) {
        body = body || $46df807587d3bd98$var$getBody();
        var listeners = this.bodyModeListeners;
        for(var event in listeners)body.removeEventListener(event, listeners[event]);
    };
}
/**
 * Tracking target removing from DOM.
 * It's necessary to hide tooltip when it's target disappears.
 * Otherwise, the tooltip would be shown forever until another target
 * is triggered.
 *
 * If MutationObserver is not available, this feature just doesn't work.
 */ // https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
var $46df807587d3bd98$var$getMutationObserverClass = function getMutationObserverClass() {
    return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};
function $46df807587d3bd98$var$trackRemoval(target) {
    target.prototype.bindRemovalTracker = function() {
        var _this = this;
        var MutationObserver = $46df807587d3bd98$var$getMutationObserverClass();
        if (MutationObserver == null) return;
        var observer = new MutationObserver(function(mutations) {
            for(var m1 = 0; m1 < mutations.length; m1++){
                var mutation = mutations[m1];
                for(var m2 = 0; m2 < mutation.removedNodes.length; m2++){
                    var element = mutation.removedNodes[m2];
                    if (element === _this.state.currentTarget) {
                        _this.hideTooltip();
                        return;
                    }
                }
            }
        });
        observer.observe(window.document, {
            childList: true,
            subtree: true
        });
        this.removalTracker = observer;
    };
    target.prototype.unbindRemovalTracker = function() {
        if (this.removalTracker) {
            this.removalTracker.disconnect();
            this.removalTracker = null;
        }
    };
}
/**
 * Calculate the position of tooltip
 *
 * @params
 * - `e` {Event} the event of current mouse
 * - `target` {Element} the currentTarget of the event
 * - `node` {DOM} the react-tooltip object
 * - `place` {String} top / right / bottom / left
 * - `effect` {String} float / solid
 * - `offset` {Object} the offset to default position
 *
 * @return {Object}
 * - `isNewState` {Bool} required
 * - `newState` {Object}
 * - `position` {Object} {left: {Number}, top: {Number}}
 */ function $46df807587d3bd98$var$getPosition(e, target, node, place, desiredPlace, effect, offset) {
    var _getDimensions = $46df807587d3bd98$var$getDimensions(node), tipWidth = _getDimensions.width, tipHeight = _getDimensions.height;
    var _getDimensions2 = $46df807587d3bd98$var$getDimensions(target), targetWidth = _getDimensions2.width, targetHeight = _getDimensions2.height;
    var _getCurrentOffset = $46df807587d3bd98$var$getCurrentOffset(e, target, effect), mouseX = _getCurrentOffset.mouseX, mouseY = _getCurrentOffset.mouseY;
    var defaultOffset = $46df807587d3bd98$var$getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
    var _calculateOffset = $46df807587d3bd98$var$calculateOffset(offset), extraOffsetX = _calculateOffset.extraOffsetX, extraOffsetY = _calculateOffset.extraOffsetY;
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var _getParent = $46df807587d3bd98$var$getParent(node), parentTop = _getParent.parentTop, parentLeft = _getParent.parentLeft;
    // Get the edge offset of the tooltip
    var getTipOffsetLeft = function getTipOffsetLeft(place) {
        var offsetX = defaultOffset[place].l;
        return mouseX + offsetX + extraOffsetX;
    };
    var getTipOffsetRight = function getTipOffsetRight(place) {
        var offsetX = defaultOffset[place].r;
        return mouseX + offsetX + extraOffsetX;
    };
    var getTipOffsetTop = function getTipOffsetTop(place) {
        var offsetY = defaultOffset[place].t;
        return mouseY + offsetY + extraOffsetY;
    };
    var getTipOffsetBottom = function getTipOffsetBottom(place) {
        var offsetY = defaultOffset[place].b;
        return mouseY + offsetY + extraOffsetY;
    };
    //
    // Functions to test whether the tooltip's sides are inside
    // the client window for a given orientation p
    //
    //  _____________
    // |             | <-- Right side
    // | p = 'left'  |\
    // |             |/  |\
    // |_____________|   |_\  <-- Mouse
    //      / \           |
    //       |
    //       |
    //  Bottom side
    //
    var outsideLeft = function outsideLeft(p) {
        return getTipOffsetLeft(p) < 0;
    };
    var outsideRight = function outsideRight(p) {
        return getTipOffsetRight(p) > windowWidth;
    };
    var outsideTop = function outsideTop(p) {
        return getTipOffsetTop(p) < 0;
    };
    var outsideBottom = function outsideBottom(p) {
        return getTipOffsetBottom(p) > windowHeight;
    };
    // Check whether the tooltip with orientation p is completely inside the client window
    var outside = function outside(p) {
        return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
    };
    var inside = function inside(p) {
        return !outside(p);
    };
    var placeIsInside = {
        top: inside("top"),
        bottom: inside("bottom"),
        left: inside("left"),
        right: inside("right")
    };
    function choose() {
        var allPlaces = desiredPlace.split(",").concat(place, [
            "top",
            "bottom",
            "left",
            "right"
        ]);
        var _iterator = $46df807587d3bd98$var$_createForOfIteratorHelper(allPlaces), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var d = _step.value;
                if (placeIsInside[d]) return d;
            }
        // if nothing is inside, just use the old place.
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return place;
    }
    var chosen = choose();
    var isNewState = false;
    var newPlace;
    if (chosen && chosen !== place) {
        isNewState = true;
        newPlace = chosen;
    }
    if (isNewState) return {
        isNewState: true,
        newState: {
            place: newPlace
        }
    };
    return {
        isNewState: false,
        position: {
            left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
            top: parseInt(getTipOffsetTop(place) - parentTop, 10)
        }
    };
}
var $46df807587d3bd98$var$getDimensions = function getDimensions(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), height = _node$getBoundingClie.height, width = _node$getBoundingClie.width;
    return {
        height: parseInt(height, 10),
        width: parseInt(width, 10)
    };
};
// Get current mouse offset
var $46df807587d3bd98$var$getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
    var boundingClientRect = currentTarget.getBoundingClientRect();
    var targetTop = boundingClientRect.top;
    var targetLeft = boundingClientRect.left;
    var _getDimensions3 = $46df807587d3bd98$var$getDimensions(currentTarget), targetWidth = _getDimensions3.width, targetHeight = _getDimensions3.height;
    if (effect === "float") return {
        mouseX: e.clientX,
        mouseY: e.clientY
    };
    return {
        mouseX: targetLeft + targetWidth / 2,
        mouseY: targetTop + targetHeight / 2
    };
};
// List all possibility of tooltip final offset
// This is useful in judging if it is necessary for tooltip to switch position when out of window
var $46df807587d3bd98$var$getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
    var top;
    var right;
    var bottom;
    var left;
    var disToMouse = 3;
    var triangleHeight = 2;
    var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
    if (effect === "float") {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(tipHeight + disToMouse + triangleHeight),
            b: -disToMouse
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: disToMouse + cursorHeight,
            b: tipHeight + disToMouse + triangleHeight + cursorHeight
        };
        left = {
            l: -(tipWidth + disToMouse + triangleHeight),
            r: -disToMouse,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: disToMouse,
            r: tipWidth + disToMouse + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    } else if (effect === "solid") {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(targetHeight / 2 + tipHeight + triangleHeight),
            b: -(targetHeight / 2)
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: targetHeight / 2,
            b: targetHeight / 2 + tipHeight + triangleHeight
        };
        left = {
            l: -(tipWidth + targetWidth / 2 + triangleHeight),
            r: -(targetWidth / 2),
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: targetWidth / 2,
            r: tipWidth + targetWidth / 2 + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    }
    return {
        top: top,
        bottom: bottom,
        left: left,
        right: right
    };
};
// Consider additional offset into position calculation
var $46df807587d3bd98$var$calculateOffset = function calculateOffset(offset) {
    var extraOffsetX = 0;
    var extraOffsetY = 0;
    if (Object.prototype.toString.apply(offset) === "[object String]") offset = JSON.parse(offset.toString().replace(/'/g, '"'));
    for(var key in offset){
        if (key === "top") extraOffsetY -= parseInt(offset[key], 10);
        else if (key === "bottom") extraOffsetY += parseInt(offset[key], 10);
        else if (key === "left") extraOffsetX -= parseInt(offset[key], 10);
        else if (key === "right") extraOffsetX += parseInt(offset[key], 10);
    }
    return {
        extraOffsetX: extraOffsetX,
        extraOffsetY: extraOffsetY
    };
};
// Get the offset of the parent elements
var $46df807587d3bd98$var$getParent = function getParent(currentTarget) {
    var currentParent = currentTarget;
    while(currentParent){
        var computedStyle = window.getComputedStyle(currentParent);
        // transform and will-change: transform change the containing block
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_Block
        if (computedStyle.getPropertyValue("transform") !== "none" || computedStyle.getPropertyValue("will-change") === "transform") break;
        currentParent = currentParent.parentElement;
    }
    var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
    var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
    return {
        parentTop: parentTop,
        parentLeft: parentLeft
    };
};
/**
 * To get the tooltip content
 * it may comes from data-tip or this.props.children
 * it should support multiline
 *
 * @params
 * - `tip` {String} value of data-tip
 * - `children` {ReactElement} this.props.children
 * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
 *
 * @return
 * - String or react component
 */ function $46df807587d3bd98$var$TipContent(tip, children, getContent, multiline) {
    if (children) return children;
    if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
    if (getContent === null) return null; // Tip not exist and children is null or undefined
    var regexp = /<br\s*\/?>/;
    if (!multiline || multiline === "false" || !regexp.test(tip)) // No trim(), so that user can keep their input
    return tip;
    // Multiline tooltip content
    return tip.split(regexp).map(function(d, i) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
            key: i,
            className: "multi-line"
        }, d);
    });
}
/**
 * Support aria- and role in ReactTooltip
 *
 * @params props {Object}
 * @return {Object}
 */ function $46df807587d3bd98$var$parseAria(props) {
    var ariaObj = {};
    Object.keys(props).filter(function(prop) {
        // aria-xxx and role is acceptable
        return /(^aria-\w+$|^role$)/.test(prop);
    }).forEach(function(prop) {
        ariaObj[prop] = props[prop];
    });
    return ariaObj;
}
/**
 * Convert nodelist to array
 * @see https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/core/createArrayFromMixed.js#L24
 * NodeLists are functions in Safari
 */ function $46df807587d3bd98$var$nodeListToArray(nodeList) {
    var length = nodeList.length;
    if (nodeList.hasOwnProperty) return Array.prototype.slice.call(nodeList);
    return new Array(length).fill().map(function(index) {
        return nodeList[index];
    });
}
function $46df807587d3bd98$var$generateUUID() {
    return "t" + (0, $f09b5dbb9c2f17e8$export$2e2bcd8739ae039)();
}
var $46df807587d3bd98$var$baseCss = '.__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip::before, .__react_component_tooltip::after {\n  content: "";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0;\n  margin-left: 0;\n  visibility: visible;\n}\n.__react_component_tooltip.place-top::before {\n  bottom: 0;\n  left: 50%;\n  margin-left: -11px;\n}\n.__react_component_tooltip.place-bottom::before {\n  top: 0;\n  left: 50%;\n  margin-left: -11px;\n}\n.__react_component_tooltip.place-left::before {\n  right: 0;\n  top: 50%;\n  margin-top: -9px;\n}\n.__react_component_tooltip.place-right::before {\n  left: 0;\n  top: 50%;\n  margin-top: -9px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0;\n  text-align: center;\n}';
/**
 * Default pop-up style values (text color, background color).
 */ var $46df807587d3bd98$var$defaultColors = {
    dark: {
        text: "#fff",
        background: "#222",
        border: "transparent",
        arrow: "#222"
    },
    success: {
        text: "#fff",
        background: "#8DC572",
        border: "transparent",
        arrow: "#8DC572"
    },
    warning: {
        text: "#fff",
        background: "#F0AD4E",
        border: "transparent",
        arrow: "#F0AD4E"
    },
    error: {
        text: "#fff",
        background: "#BE6464",
        border: "transparent",
        arrow: "#BE6464"
    },
    info: {
        text: "#fff",
        background: "#337AB7",
        border: "transparent",
        arrow: "#337AB7"
    },
    light: {
        text: "#222",
        background: "#fff",
        border: "transparent",
        arrow: "#fff"
    }
};
function $46df807587d3bd98$var$getDefaultPopupColors(type) {
    return $46df807587d3bd98$var$defaultColors[type] ? $46df807587d3bd98$var$_objectSpread2({}, $46df807587d3bd98$var$defaultColors[type]) : undefined;
}
var $46df807587d3bd98$var$DEFAULT_PADDING = "8px 21px";
var $46df807587d3bd98$var$DEFAULT_RADIUS = {
    tooltip: 3,
    arrow: 0
};
/**
 * Generates the specific tooltip style for use on render.
 */ function $46df807587d3bd98$var$generateTooltipStyle(uuid, customColors, type, hasBorder, padding, radius) {
    return $46df807587d3bd98$var$generateStyle(uuid, $46df807587d3bd98$var$getPopupColors(customColors, type, hasBorder), padding, radius);
}
/**
 * Generates the tooltip style rules based on the element-specified "data-type" property.
 */ function $46df807587d3bd98$var$generateStyle(uuid, colors) {
    var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $46df807587d3bd98$var$DEFAULT_PADDING;
    var radius = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $46df807587d3bd98$var$DEFAULT_RADIUS;
    var textColor = colors.text;
    var backgroundColor = colors.background;
    var borderColor = colors.border;
    var arrowColor = colors.arrow;
    var arrowRadius = radius.arrow;
    var tooltipRadius = radius.tooltip;
    return "\n  	.".concat(uuid, " {\n	    color: ").concat(textColor, ";\n	    background: ").concat(backgroundColor, ";\n	    border: 1px solid ").concat(borderColor, ";\n	    border-radius: ").concat(tooltipRadius, "px;\n	    padding: ").concat(padding, ";\n  	}\n\n  	.").concat(uuid, ".place-top {\n        margin-top: -10px;\n    }\n    .").concat(uuid, '.place-top::before {\n        content: "";\n        background-color: inherit;\n        position: absolute;\n        z-index: 2;\n        width: 20px;\n        height: 12px;\n    }\n    .').concat(uuid, '.place-top::after {\n        content: "";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ').concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        bottom: -6px;\n        left: 50%;\n        margin-left: -6px;\n        transform: rotate(135deg);\n    }\n\n    .").concat(uuid, ".place-bottom {\n        margin-top: 10px;\n    }\n    .").concat(uuid, '.place-bottom::before {\n        content: "";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 18px;\n        height: 10px;\n    }\n    .').concat(uuid, '.place-bottom::after {\n        content: "";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ').concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        top: -6px;\n        left: 50%;\n        margin-left: -6px;\n        transform: rotate(45deg);\n    }\n\n    .").concat(uuid, ".place-left {\n        margin-left: -10px;\n    }\n    .").concat(uuid, '.place-left::before {\n        content: "";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 10px;\n        height: 18px;\n    }\n    .').concat(uuid, '.place-left::after {\n        content: "";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ').concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        right: -6px;\n        top: 50%;\n        margin-top: -6px;\n        transform: rotate(45deg);\n    }\n\n    .").concat(uuid, ".place-right {\n        margin-left: 10px;\n    }\n    .").concat(uuid, '.place-right::before {\n        content: "";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 10px;\n        height: 18px;\n    }\n    .').concat(uuid, '.place-right::after {\n        content: "";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ').concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        left: -6px;\n        top: 50%;\n        margin-top: -6px;\n        transform: rotate(-135deg);\n    }\n  ");
}
function $46df807587d3bd98$var$getPopupColors(customColors, type, hasBorder) {
    var textColor = customColors.text;
    var backgroundColor = customColors.background;
    var borderColor = customColors.border;
    var arrowColor = customColors.arrow ? customColors.arrow : customColors.background;
    var colors = $46df807587d3bd98$var$getDefaultPopupColors(type);
    if (textColor) colors.text = textColor;
    if (backgroundColor) colors.background = backgroundColor;
    if (hasBorder) {
        if (borderColor) colors.border = borderColor;
        else colors.border = type === "light" ? "black" : "white";
    }
    if (arrowColor) colors.arrow = arrowColor;
    return colors;
}
var $46df807587d3bd98$var$_class, $46df807587d3bd98$var$_class2;
/* Polyfill */ var $46df807587d3bd98$export$2e2bcd8739ae039 = $46df807587d3bd98$var$staticMethods($46df807587d3bd98$var$_class = $46df807587d3bd98$var$windowListener($46df807587d3bd98$var$_class = $46df807587d3bd98$var$customEvent($46df807587d3bd98$var$_class = $46df807587d3bd98$var$isCapture($46df807587d3bd98$var$_class = $46df807587d3bd98$var$getEffect($46df807587d3bd98$var$_class = $46df807587d3bd98$var$bodyMode($46df807587d3bd98$var$_class = $46df807587d3bd98$var$trackRemoval($46df807587d3bd98$var$_class = ($46df807587d3bd98$var$_class2 = /*#__PURE__*/ function(_React$Component) {
    $46df807587d3bd98$var$_inherits(ReactTooltip, _React$Component);
    var _super = $46df807587d3bd98$var$_createSuper(ReactTooltip);
    function ReactTooltip(props) {
        var _this;
        $46df807587d3bd98$var$_classCallCheck(this, ReactTooltip);
        _this = _super.call(this, props);
        _this.state = {
            uuid: props.uuid || $46df807587d3bd98$var$generateUUID(),
            place: props.place || "top",
            // Direction of tooltip
            desiredPlace: props.place || "top",
            type: props.type || "dark",
            // Color theme of tooltip
            effect: props.effect || "float",
            // float or fixed
            show: false,
            border: false,
            borderClass: "border",
            customColors: {},
            customRadius: {},
            offset: {},
            padding: props.padding,
            extraClass: "",
            html: false,
            delayHide: 0,
            delayShow: 0,
            event: props.event || null,
            eventOff: props.eventOff || null,
            currentEvent: null,
            // Current mouse event
            currentTarget: null,
            // Current target of mouse event
            ariaProps: $46df807587d3bd98$var$parseAria(props),
            // aria- and role attributes
            isEmptyTip: false,
            disable: false,
            possibleCustomEvents: props.possibleCustomEvents || "",
            possibleCustomEventsOff: props.possibleCustomEventsOff || "",
            originTooltip: null,
            isMultiline: false
        };
        _this.bind([
            "showTooltip",
            "updateTooltip",
            "hideTooltip",
            "hideTooltipOnScroll",
            "getTooltipContent",
            "globalRebuild",
            "globalShow",
            "globalHide",
            "onWindowResize",
            "mouseOnToolTip"
        ]);
        _this.mount = true;
        _this.delayShowLoop = null;
        _this.delayHideLoop = null;
        _this.delayReshow = null;
        _this.intervalUpdateContent = null;
        return _this;
    }
    /**
   * For unify the bind and unbind listener
   */ $46df807587d3bd98$var$_createClass(ReactTooltip, [
        {
            key: "bind",
            value: function bind(methodArray) {
                var _this2 = this;
                methodArray.forEach(function(method) {
                    _this2[method] = _this2[method].bind(_this2);
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props = this.props;
                _this$props.insecure;
                var resizeHide = _this$props.resizeHide, disableInternalStyle = _this$props.disableInternalStyle;
                this.mount = true;
                this.bindListener(); // Bind listener for tooltip
                this.bindWindowEvents(resizeHide); // Bind global event for static method
                if (!disableInternalStyle) this.injectStyles(); // Inject styles for each DOM root having tooltip.
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mount = false;
                this.clearTimer();
                this.unbindListener();
                this.removeScrollListener(this.state.currentTarget);
                this.unbindWindowEvents();
            }
        },
        {
            key: "injectStyles",
            value: function injectStyles() {
                var tooltipRef = this.tooltipRef;
                if (!tooltipRef) return;
                var parentNode = tooltipRef.parentNode;
                while(parentNode.parentNode)parentNode = parentNode.parentNode;
                var domRoot;
                switch(parentNode.constructor.name){
                    case "Document":
                    case "HTMLDocument":
                    case undefined:
                        domRoot = parentNode.head;
                        break;
                    case "ShadowRoot":
                    default:
                        domRoot = parentNode;
                        break;
                }
                // Prevent styles duplication.
                if (!domRoot.querySelector("style[data-react-tooltip]")) {
                    var style = document.createElement("style");
                    style.textContent = $46df807587d3bd98$var$baseCss;
                    style.setAttribute("data-react-tooltip", "true");
                    domRoot.appendChild(style);
                }
            }
        },
        {
            key: "mouseOnToolTip",
            value: function mouseOnToolTip() {
                var show = this.state.show;
                if (show && this.tooltipRef) {
                    /* old IE or Firefox work around */ if (!this.tooltipRef.matches) {
                        /* old IE work around */ if (this.tooltipRef.msMatchesSelector) this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
                        else /* old Firefox work around */ this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
                    }
                    return this.tooltipRef.matches(":hover");
                }
                return false;
            }
        },
        {
            key: "getTargetArray",
            value: function getTargetArray(id) {
                var targetArray = [];
                var selector;
                if (!id) selector = "[data-tip]:not([data-for])";
                else {
                    var escaped = id.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
                    selector = '[data-tip][data-for="'.concat(escaped, '"]');
                }
                // Scan document for shadow DOM elements
                $46df807587d3bd98$var$nodeListToArray(document.getElementsByTagName("*")).filter(function(element) {
                    return element.shadowRoot;
                }).forEach(function(element) {
                    targetArray = targetArray.concat($46df807587d3bd98$var$nodeListToArray(element.shadowRoot.querySelectorAll(selector)));
                });
                return targetArray.concat($46df807587d3bd98$var$nodeListToArray(document.querySelectorAll(selector)));
            }
        },
        {
            key: "bindListener",
            value: function bindListener() {
                var _this3 = this;
                var _this$props2 = this.props, id = _this$props2.id, globalEventOff = _this$props2.globalEventOff, isCapture = _this$props2.isCapture;
                var targetArray = this.getTargetArray(id);
                targetArray.forEach(function(target) {
                    if (target.getAttribute("currentItem") === null) target.setAttribute("currentItem", "false");
                    _this3.unbindBasicListener(target);
                    if (_this3.isCustomEvent(target)) _this3.customUnbindListener(target);
                });
                if (this.isBodyMode()) this.bindBodyListener(targetArray);
                else targetArray.forEach(function(target) {
                    var isCaptureMode = _this3.isCapture(target);
                    var effect = _this3.getEffect(target);
                    if (_this3.isCustomEvent(target)) {
                        _this3.customBindListener(target);
                        return;
                    }
                    target.addEventListener("mouseenter", _this3.showTooltip, isCaptureMode);
                    target.addEventListener("focus", _this3.showTooltip, isCaptureMode);
                    if (effect === "float") target.addEventListener("mousemove", _this3.updateTooltip, isCaptureMode);
                    target.addEventListener("mouseleave", _this3.hideTooltip, isCaptureMode);
                    target.addEventListener("blur", _this3.hideTooltip, isCaptureMode);
                });
                // Global event to hide tooltip
                if (globalEventOff) {
                    window.removeEventListener(globalEventOff, this.hideTooltip);
                    window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
                }
                // Track removal of targetArray elements from DOM
                this.bindRemovalTracker();
            }
        },
        {
            key: "unbindListener",
            value: function unbindListener() {
                var _this4 = this;
                var _this$props3 = this.props, id = _this$props3.id, globalEventOff = _this$props3.globalEventOff;
                if (this.isBodyMode()) this.unbindBodyListener();
                else {
                    var targetArray = this.getTargetArray(id);
                    targetArray.forEach(function(target) {
                        _this4.unbindBasicListener(target);
                        if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
                    });
                }
                if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
                this.unbindRemovalTracker();
            }
        },
        {
            key: "unbindBasicListener",
            value: function unbindBasicListener(target) {
                var isCaptureMode = this.isCapture(target);
                target.removeEventListener("mouseenter", this.showTooltip, isCaptureMode);
                target.removeEventListener("mousemove", this.updateTooltip, isCaptureMode);
                target.removeEventListener("mouseleave", this.hideTooltip, isCaptureMode);
            }
        },
        {
            key: "getTooltipContent",
            value: function getTooltipContent() {
                var _this$props4 = this.props, getContent = _this$props4.getContent, children = _this$props4.children;
                // Generate tooltip content
                var content;
                if (getContent) {
                    if (Array.isArray(getContent)) content = getContent[0] && getContent[0](this.state.originTooltip);
                    else content = getContent(this.state.originTooltip);
                }
                return $46df807587d3bd98$var$TipContent(this.state.originTooltip, children, content, this.state.isMultiline);
            }
        },
        {
            key: "isEmptyTip",
            value: function isEmptyTip(placeholder) {
                return typeof placeholder === "string" && placeholder === "" || placeholder === null;
            }
        },
        {
            key: "showTooltip",
            value: function showTooltip(e, isGlobalCall) {
                if (!this.tooltipRef) return;
                if (isGlobalCall) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement) return;
                }
                // Get the tooltip content
                // calculate in this phrase so that tip width height can be detected
                var _this$props5 = this.props, multiline = _this$props5.multiline, getContent = _this$props5.getContent;
                var originTooltip = e.currentTarget.getAttribute("data-tip");
                var isMultiline = e.currentTarget.getAttribute("data-multiline") || multiline || false;
                // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
                var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;
                // if it needs to skip adding hide listener to scroll
                var scrollHide = true;
                if (e.currentTarget.getAttribute("data-scroll-hide")) scrollHide = e.currentTarget.getAttribute("data-scroll-hide") === "true";
                else if (this.props.scrollHide != null) scrollHide = this.props.scrollHide;
                // adding aria-describedby to target to make tooltips read by screen readers
                if (e && e.currentTarget && e.currentTarget.setAttribute) e.currentTarget.setAttribute("aria-describedby", this.props.id || this.state.uuid);
                // Make sure the correct place is set
                var desiredPlace = e.currentTarget.getAttribute("data-place") || this.props.place || "top";
                var effect = switchToSolid && "solid" || this.getEffect(e.currentTarget);
                var offset = e.currentTarget.getAttribute("data-offset") || this.props.offset || {};
                var result = $46df807587d3bd98$var$getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace.split(",")[0], desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
                var place = result.isNewState ? result.newState.place : desiredPlace.split(",")[0];
                // To prevent previously created timers from triggering
                this.clearTimer();
                var target = e.currentTarget;
                var reshowDelay = this.state.show ? target.getAttribute("data-delay-update") || this.props.delayUpdate : 0;
                var self1 = this;
                var updateState = function updateState() {
                    self1.setState({
                        originTooltip: originTooltip,
                        isMultiline: isMultiline,
                        desiredPlace: desiredPlace,
                        place: place,
                        type: target.getAttribute("data-type") || self1.props.type || "dark",
                        customColors: {
                            text: target.getAttribute("data-text-color") || self1.props.textColor || null,
                            background: target.getAttribute("data-background-color") || self1.props.backgroundColor || null,
                            border: target.getAttribute("data-border-color") || self1.props.borderColor || null,
                            arrow: target.getAttribute("data-arrow-color") || self1.props.arrowColor || null
                        },
                        customRadius: {
                            tooltip: target.getAttribute("data-tooltip-radius") || self1.props.tooltipRadius || "3",
                            arrow: target.getAttribute("data-arrow-radius") || self1.props.arrowRadius || "0"
                        },
                        effect: effect,
                        offset: offset,
                        padding: target.getAttribute("data-padding") || self1.props.padding,
                        html: (target.getAttribute("data-html") ? target.getAttribute("data-html") === "true" : self1.props.html) || false,
                        delayShow: target.getAttribute("data-delay-show") || self1.props.delayShow || 0,
                        delayHide: target.getAttribute("data-delay-hide") || self1.props.delayHide || 0,
                        delayUpdate: target.getAttribute("data-delay-update") || self1.props.delayUpdate || 0,
                        border: (target.getAttribute("data-border") ? target.getAttribute("data-border") === "true" : self1.props.border) || false,
                        borderClass: target.getAttribute("data-border-class") || self1.props.borderClass || "border",
                        extraClass: target.getAttribute("data-class") || self1.props["class"] || self1.props.className || "",
                        disable: (target.getAttribute("data-tip-disable") ? target.getAttribute("data-tip-disable") === "true" : self1.props.disable) || false,
                        currentTarget: target
                    }, function() {
                        if (scrollHide) self1.addScrollListener(self1.state.currentTarget);
                        self1.updateTooltip(e);
                        if (getContent && Array.isArray(getContent)) self1.intervalUpdateContent = setInterval(function() {
                            if (self1.mount) {
                                var _getContent = self1.props.getContent;
                                var placeholder = $46df807587d3bd98$var$TipContent(originTooltip, "", _getContent[0](), isMultiline);
                                var isEmptyTip = self1.isEmptyTip(placeholder);
                                self1.setState({
                                    isEmptyTip: isEmptyTip
                                });
                                self1.updatePosition();
                            }
                        }, getContent[1]);
                    });
                };
                // If there is no delay call immediately, don't allow events to get in first.
                if (reshowDelay) this.delayReshow = setTimeout(updateState, reshowDelay);
                else updateState();
            }
        },
        {
            key: "updateTooltip",
            value: function updateTooltip(e) {
                var _this5 = this;
                var _this$state = this.state, delayShow = _this$state.delayShow, disable = _this$state.disable;
                var _this$props6 = this.props, afterShow = _this$props6.afterShow, disableProp = _this$props6.disable;
                var placeholder = this.getTooltipContent();
                var eventTarget = e.currentTarget || e.target;
                // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                if (this.mouseOnToolTip()) return;
                // if the tooltip is empty, disable the tooltip
                if (this.isEmptyTip(placeholder) || disable || disableProp) return;
                var delayTime = !this.state.show ? parseInt(delayShow, 10) : 0;
                var updateState = function updateState() {
                    if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
                        var isInvisible = !_this5.state.show;
                        _this5.setState({
                            currentEvent: e,
                            currentTarget: eventTarget,
                            show: true
                        }, function() {
                            _this5.updatePosition(function() {
                                if (isInvisible && afterShow) afterShow(e);
                            });
                        });
                    }
                };
                if (this.delayShowLoop) clearTimeout(this.delayShowLoop);
                if (delayTime) this.delayShowLoop = setTimeout(updateState, delayTime);
                else {
                    this.delayShowLoop = null;
                    updateState();
                }
            }
        },
        {
            key: "listenForTooltipExit",
            value: function listenForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.addEventListener("mouseleave", this.hideTooltip);
            }
        },
        {
            key: "removeListenerForTooltipExit",
            value: function removeListenerForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.removeEventListener("mouseleave", this.hideTooltip);
            }
        },
        {
            key: "hideTooltip",
            value: function hideTooltip(e, hasTarget) {
                var _this6 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
                    isScroll: false
                };
                var disable = this.state.disable;
                var isScroll = options.isScroll;
                var delayHide = isScroll ? 0 : this.state.delayHide;
                var _this$props7 = this.props, afterHide = _this$props7.afterHide, disableProp = _this$props7.disable;
                var placeholder = this.getTooltipContent();
                if (!this.mount) return;
                if (this.isEmptyTip(placeholder) || disable || disableProp) return; // if the tooltip is empty, disable the tooltip
                if (hasTarget) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement || !this.state.show) return;
                }
                // clean up aria-describedby when hiding tooltip
                if (e && e.currentTarget && e.currentTarget.removeAttribute) e.currentTarget.removeAttribute("aria-describedby");
                var resetState = function resetState() {
                    var isVisible = _this6.state.show;
                    // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                    if (_this6.mouseOnToolTip()) {
                        _this6.listenForTooltipExit();
                        return;
                    }
                    _this6.removeListenerForTooltipExit();
                    _this6.setState({
                        show: false
                    }, function() {
                        _this6.removeScrollListener(_this6.state.currentTarget);
                        if (isVisible && afterHide) afterHide(e);
                    });
                };
                this.clearTimer();
                if (delayHide) this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
                else resetState();
            }
        },
        {
            key: "hideTooltipOnScroll",
            value: function hideTooltipOnScroll(event, hasTarget) {
                this.hideTooltip(event, hasTarget, {
                    isScroll: true
                });
            }
        },
        {
            key: "addScrollListener",
            value: function addScrollListener(currentTarget) {
                var isCaptureMode = this.isCapture(currentTarget);
                window.addEventListener("scroll", this.hideTooltipOnScroll, isCaptureMode);
            }
        },
        {
            key: "removeScrollListener",
            value: function removeScrollListener(currentTarget) {
                var isCaptureMode = this.isCapture(currentTarget);
                window.removeEventListener("scroll", this.hideTooltipOnScroll, isCaptureMode);
            }
        },
        {
            key: "updatePosition",
            value: function updatePosition(callbackAfter) {
                var _this7 = this;
                var _this$state2 = this.state, currentEvent = _this$state2.currentEvent, currentTarget = _this$state2.currentTarget, place = _this$state2.place, desiredPlace = _this$state2.desiredPlace, effect = _this$state2.effect, offset = _this$state2.offset;
                var node = this.tooltipRef;
                var result = $46df807587d3bd98$var$getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.isNewState) // Switch to reverse placement
                return this.setState(result.newState, function() {
                    _this7.updatePosition(callbackAfter);
                });
                if (callbackAfter && typeof callbackAfter === "function") callbackAfter();
                // Set tooltip position
                node.style.left = result.position.left + "px";
                node.style.top = result.position.top + "px";
            }
        },
        {
            key: "clearTimer",
            value: function clearTimer() {
                if (this.delayShowLoop) {
                    clearTimeout(this.delayShowLoop);
                    this.delayShowLoop = null;
                }
                if (this.delayHideLoop) {
                    clearTimeout(this.delayHideLoop);
                    this.delayHideLoop = null;
                }
                if (this.delayReshow) {
                    clearTimeout(this.delayReshow);
                    this.delayReshow = null;
                }
                if (this.intervalUpdateContent) {
                    clearInterval(this.intervalUpdateContent);
                    this.intervalUpdateContent = null;
                }
            }
        },
        {
            key: "hasCustomColors",
            value: function hasCustomColors() {
                var _this8 = this;
                return Boolean(Object.keys(this.state.customColors).find(function(color) {
                    return color !== "border" && _this8.state.customColors[color];
                }) || this.state.border && this.state.customColors["border"]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this9 = this;
                var _this$state3 = this.state, extraClass = _this$state3.extraClass, html = _this$state3.html, ariaProps = _this$state3.ariaProps, disable = _this$state3.disable, uuid = _this$state3.uuid;
                var content = this.getTooltipContent();
                var isEmptyTip = this.isEmptyTip(content);
                var style = this.props.disableInternalStyle ? "" : $46df807587d3bd98$var$generateTooltipStyle(this.state.uuid, this.state.customColors, this.state.type, this.state.border, this.state.padding, this.state.customRadius);
                var tooltipClass = "__react_component_tooltip" + " ".concat(this.state.uuid) + (this.state.show && !disable && !isEmptyTip ? " show" : "") + (this.state.border ? " " + this.state.borderClass : "") + " place-".concat(this.state.place) + // top, bottom, left, right
                " type-".concat(this.hasCustomColors() ? "custom" : this.state.type) + // dark, success, warning, error, info, light, custom
                (this.props.delayUpdate ? " allow_hover" : "") + (this.props.clickable ? " allow_click" : "");
                var Wrapper = this.props.wrapper;
                if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) Wrapper = ReactTooltip.defaultProps.wrapper;
                var wrapperClassName = [
                    tooltipClass,
                    extraClass
                ].filter(Boolean).join(" ");
                if (html) {
                    var htmlContent = "".concat(content).concat(style ? '\n<style aria-hidden="true">'.concat(style, "</style>") : "");
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(Wrapper, $46df807587d3bd98$var$_extends({
                        className: "".concat(wrapperClassName),
                        id: this.props.id || uuid,
                        ref: function ref(_ref) {
                            return _this9.tooltipRef = _ref;
                        }
                    }, ariaProps, {
                        "data-id": "tooltip",
                        dangerouslySetInnerHTML: {
                            __html: htmlContent
                        }
                    }));
                } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(Wrapper, $46df807587d3bd98$var$_extends({
                    className: "".concat(wrapperClassName),
                    id: this.props.id || uuid
                }, ariaProps, {
                    ref: function ref(_ref2) {
                        return _this9.tooltipRef = _ref2;
                    },
                    "data-id": "tooltip"
                }), style && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("style", {
                    dangerouslySetInnerHTML: {
                        __html: style
                    },
                    "aria-hidden": "true"
                }), content);
            }
        }
    ], [
        {
            key: "propTypes",
            get: function get() {
                return {
                    uuid: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
                    children: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).any,
                    place: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
                    type: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
                    effect: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
                    offset: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).object,
                    padding: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
                    multiline: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
                    border: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
                    borderClass: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
                    textColor: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
                    backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
                    borderColor: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
                    arrowColor: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
                    arrowRadius: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
                    tooltipRadius: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
                    insecure: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
                    "class": (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
                    id: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
                    html: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
                    delayHide: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).number,
                    delayUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).number,
                    delayShow: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).number,
                    event: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
                    eventOff: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
                    isCapture: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
                    globalEventOff: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
                    getContent: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).any,
                    afterShow: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).func,
                    afterHide: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).func,
                    overridePosition: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).func,
                    disable: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
                    scrollHide: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
                    resizeHide: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
                    wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
                    bodyMode: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
                    possibleCustomEvents: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
                    possibleCustomEventsOff: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
                    clickable: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
                    disableInternalStyle: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var ariaProps = prevState.ariaProps;
                var newAriaProps = $46df807587d3bd98$var$parseAria(nextProps);
                var isChanged = Object.keys(newAriaProps).some(function(props) {
                    return newAriaProps[props] !== ariaProps[props];
                });
                if (!isChanged) return null;
                return $46df807587d3bd98$var$_objectSpread2($46df807587d3bd98$var$_objectSpread2({}, prevState), {}, {
                    ariaProps: newAriaProps
                });
            }
        }
    ]);
    return ReactTooltip;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Component), $46df807587d3bd98$var$_defineProperty($46df807587d3bd98$var$_class2, "defaultProps", {
    insecure: true,
    resizeHide: true,
    wrapper: "div",
    clickable: false
}), $46df807587d3bd98$var$_defineProperty($46df807587d3bd98$var$_class2, "supportedWrappers", [
    "div",
    "span"
]), $46df807587d3bd98$var$_defineProperty($46df807587d3bd98$var$_class2, "displayName", "ReactTooltip"), $46df807587d3bd98$var$_class2)) || $46df807587d3bd98$var$_class) || $46df807587d3bd98$var$_class) || $46df807587d3bd98$var$_class) || $46df807587d3bd98$var$_class) || $46df807587d3bd98$var$_class) || $46df807587d3bd98$var$_class) || $46df807587d3bd98$var$_class;



const $564db6ad85661f6d$var$TestPage = ()=>{
    const directorState = (0, $bd34a43d05d9e670$export$2105062e25df4afe)((0, $bd1c05d3e19afc9d$export$86d1cded24611cb8));
    const { t: t } = (0, $aa8f0a59a97a3595$export$9fc83ad70ead8663)();
    const history = (0, $a252e3f3b9c91bac$export$3420e1dc2c4a518c)();
    const dispatch = (0, $07670883d6f89641$export$8ad76b76a4c905f8)();
    let formRef;
    (0, $cQNHH.useEffect)((0, $0278e31e45b52099$export$dad4a579cd5614b0)(directorState, history), [
        directorState
    ]);
    (0, $cQNHH.useEffect)(()=>{
        if (directorState === null || directorState === void 0 ? void 0 : directorState.sessionId) $cdf098895d141710$export$b96b69e966de3651(directorState.sessionId).then((res)=>{
            if ((res === null || res === void 0 ? void 0 : res.error.includes("Can't find the session.")) || (res === null || res === void 0 ? void 0 : res.error.includes("Die Session wurde nicht gefunden."))) {
                dispatch((0, $bd1c05d3e19afc9d$export$5fd37d90ba0958ec)({}));
                history.push((0, $078fc8f7799889e4$export$7aa67dc43ca8e63d));
            }
        }).catch((err)=>{
            if ((err === null || err === void 0 ? void 0 : err.error.includes("Can't find the session.")) || (err === null || err === void 0 ? void 0 : err.error.includes("Die Session wurde nicht gefunden."))) {
                dispatch((0, $bd1c05d3e19afc9d$export$5fd37d90ba0958ec)({}));
                history.push((0, $078fc8f7799889e4$export$7aa67dc43ca8e63d));
            }
        });
    }, []);
    (0, $cQNHH.useEffect)(()=>{
        (0, $46df807587d3bd98$export$2e2bcd8739ae039).rebuild();
        document.body.classList.add("layout--test", "test--in");
        return ()=>{
            document.body.classList.remove("layout--test", "test--in");
        };
    }, []);
    const onSubmitSuccess = (res)=>{
        //log.info("TestPage", "cbBackward", res.error, res);
        dispatch((0, $bd1c05d3e19afc9d$export$e16717ba5a5dc549)({
            section: res
        }));
    };
    const onSubmitFailure = (res)=>{
        dispatch((0, $ef73d84de842ec50$export$fb9705de59d96855)({
            text: t(res.error),
            type: (0, $ef73d84de842ec50$export$87130b6dd9721cee).ERROR,
            props: {}
        }));
    };
    const cbForeward = (model)=>{
        //log.info("x001 TestPage", "cbForeward", directorState.submitting, model);
        if (directorState.submitting) //console.log("x001 cbForeward submitting");
        return;
        const res = $cdf098895d141710$export$6c33279ba320b667(directorState.sessionId, model);
        res.then(onSubmitSuccess, onSubmitFailure);
        return res;
    };
    const cbBackward = async (model)=>{
        //log.info("x001 TestPage", "cbBackward", directorState.submitting, model);
        if (directorState.submitting) //console.log("x001 cbBackward submitting");
        return;
        const res = $cdf098895d141710$export$d9c45e29a4259227(directorState.sessionId, model);
        res.then(onSubmitSuccess, onSubmitFailure);
        return res;
    };
    const nextSection = async (model)=>{
        if (directorState.submitting) //console.log("x001 nextSection submitting");
        return;
        dispatch((0, $da18f57894276811$export$923d3332dd605124)({
            content: "NextSection",
            model: model
        }));
    };
    // const finishTest = async (model) => {
    //     if (directorState.submitting) {
    //         //console.log("x001 nextSection submitting");
    //         //return;
    //     }
    //     const res = ioCalls.submitAnswers(directorState.sessionId, model);
    //     const succF = (res) => {
    //         if (!res.error) {
    //             history.push(testResultUrl);
    //         } else dispatch(addItem({ text: t(res.error), type: MESSAGE_TYPE.ERROR, props: {} }));
    //     };
    //     res.then(succF, onSubmitFailure);
    //     return res;
    // };
    const onClickCard = (selectedCardIndex)=>{
        //console.log("xxx", directorState.currentGroupNo, selectedCardIndex);
        if (directorState.currentGroupNo - 1 > selectedCardIndex) cbBackward();
        if (directorState.currentGroupNo - 1 < selectedCardIndex) cbForeward();
    };
    const getForm = (uniformSchema)=>{
        let nextSectionCaption = t("testPage.nextSectionButton.caption");
        let nextSectionInfo = t("testPage.answeredAllQuestions.text");
        // meta section
        if (directorState.currentSectionNo === 1) {
            nextSectionCaption = t("testPage.meta.nextSectionButton.caption");
            nextSectionInfo = t("testPage.answeredAllQuestionsMeta.text");
        }
        const showFinishTestButton = directorState.currentSectionNo === directorState.noOfSections;
        let introElement = null;
        if (directorState.description) introElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
            className: "qanda__intro"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("p", {
            className: "qanda__intro__text"
        }, directorState.description));
        //console.log("getForm /showFinishTestButton / directorState.readyForNextSection yyy01", showFinishTestButton, directorState.readyForNextSection);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Fragment, null, directorState.noOfGroups > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $3909a9c103c0a0dc$export$2e2bcd8739ae039), {
            noOfGroups: directorState.noOfGroups,
            currentGroupNo: directorState.currentGroupNo,
            answeredGroups: directorState.answeredGroups
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $5feaaad92be0dc02$export$2e2bcd8739ae039), {
            className: "",
            schema: uniformSchema,
            placeholder: true,
            //onSubmit={handleSubmit}
            validate: "onChange",
            //onChangeModel={model => setCurrentLayer(() => model.backgroundLayer)}
            ref: (ref)=>formRef = ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
            className: "qanda__cards",
            key: "cards"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
            className: "qanda__cards-holder is-multiple is-active-card-id-" + (directorState.currentGroupNo - 1)
        }, [
            ...Array(directorState.noOfGroups)
        ].map((x, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
                key: "card-" + i,
                onClick: onClickCard.bind(undefined, i),
                className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))("card-id-" + i, "qanda__card", {
                    "qanda__card--test": directorState.currentSectionNo !== 1
                }, {
                    "qanda__card--meta": directorState.currentSectionNo === 1
                }, "qanda__card--active")
            }, introElement, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
                className: "qanda__forms"
            }, i === directorState.currentGroupNo - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $190bb506b133e116$export$2e2bcd8739ae039), {
                element: "span"
            })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
            className: "qanda__controls",
            key: "controls"
        }, directorState.noOfGroups !== 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
            className: "qanda__backforward",
            key: "foreward"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $d5eef7b985f46066$exports.default), {
            cb: cbBackward,
            dir: "before",
            formRef: formRef,
            classes: [
                "button--direction-left",
                "qanda__back",
                "qanda__back--active",
                directorState.currentGroupNo > 1 ? "" : "qanda__back--invisible"
            ],
            iconClasses: [
                "licon-caret-left"
            ],
            caption: t("testPage.prevButton.caption")
        }), directorState.noOfGroups !== directorState.currentGroupNo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $d5eef7b985f46066$exports.default), {
            cb: cbForeward,
            dir: "after",
            formRef: formRef,
            classes: [
                "button--direction-right",
                "is-primary",
                "qanda__forward",
                "qanda__forward--active",
                directorState.currentGroupNo < directorState.noOfGroups ? "" : "qanda__forward--invisible"
            ],
            iconClasses: [
                "licon-caret-right"
            ],
            caption: t("testPage.nextButton.caption")
        })), directorState.readyForNextSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
            className: "qanda__complete"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("p", {
            className: "little-info"
        }, nextSectionInfo), directorState.currentSectionNo !== 1 && !showFinishTestButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $d5eef7b985f46066$exports.default), {
            cb: nextSection,
            dir: "after",
            formRef: formRef,
            classes: [
                "button--direction-down",
                "is-success"
            ],
            iconClasses: [
                "licon-arrow-circle-down"
            ],
            caption: nextSectionCaption
        }), directorState.currentSectionNo !== 1 && showFinishTestButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $d5eef7b985f46066$exports.default), {
            cb: nextSection,
            formRef: formRef,
            dir: "after",
            classes: [
                "button--direction-right",
                "is-rounded",
                "is-success"
            ],
            iconClasses: [
                "licon-arrow-circle-right"
            ],
            caption: t("testPage.finishTestButton.caption")
        }), directorState.currentSectionNo === 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $d5eef7b985f46066$exports.default), {
            cb: nextSection,
            formRef: formRef,
            dir: "after",
            classes: [
                "button--direction-down",
                "is-success"
            ],
            iconClasses: [
                "licon-arrow-circle-down"
            ],
            caption: nextSectionCaption
        })))));
    };
    // const copySessionID = () => {
    //     copyToClipboard(directorState.sessionId);
    //     dispatch(addItem({ text: t("testPage.session-Code.copied"), type: MESSAGE_TYPE.INFO, props: {} }));
    // };
    const getIntro = (inForm = false, noIcon = false)=>{
        let intro = [];
        let introText = t("testPage.default.section.intro");
        let className = "qanda__card--test";
        // eslint-disable-next-line react/jsx-key
        let iconElement = [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
                key: "icon-info",
                className: "icon licon-info is-info"
            })
        ];
        if (directorState.currentSectionNo === 1) {
            introText = t("testPage.meta.section.intro");
            className = "qanda__card--meta";
            iconElement = [];
        }
        intro.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
            className: "qanda__intro",
            key: "intro"
        }, !noIcon && iconElement, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("p", {
            className: "qanda__intro__text is-info"
        }, introText)));
        if (inForm) return intro;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
            className: "qanda__cards"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
            className: "qanda__cards-holder"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))("qanda__card", "qanda__card--active", className)
        }, intro)));
    };
    const triggerRead = ()=>{
        //console.log("triggerRead");
        dispatch((0, $bd1c05d3e19afc9d$export$e7257833db56af08)({}));
        (0, $2476a2e6668a6972$export$169439c91a279f79)("story__top");
    };
    const getTestForm = (jsonSchema)=>{
        const uniformSchema = (0, $557d3048bfd0173c$export$af88179f1a6b6206)(jsonSchema);
        //log.info("TestPage", "getTestForm", jsonSchema, uniformSchema);
        //console.log("getTestForm yyy01");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
            className: "layout__left"
        }, !directorState.text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
            className: "metabg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
            key: "icon-bird",
            className: "icon licon-bird metabg__icon"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
            key: "text",
            className: "metabg__text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", null, "zwitscher"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", null, "zwitscher"))), directorState.text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
            className: "story"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $06aa2820615626e8$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("a", {
            id: "story__top"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
            className: "story__header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("h2", {
            className: "story__title"
        }, directorState.title), directorState.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("p", {
            className: "little-info"
        }, directorState.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
            className: "story__text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("p", {
            dangerouslySetInnerHTML: {
                __html: directorState.text
            }
        })), !directorState.textRaed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))("story__complete", {
                "story__complete--invisible": directorState.textRaed
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("p", {
            className: "little-info"
        }, t("testPage.textRaedButton.info"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
            key: "trigger",
            className: "helper-trigger"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("a", {
            onClick: ()=>{
                dispatch((0, $da18f57894276811$export$923d3332dd605124)({
                    content: "Help"
                }));
            },
            className: "icon licon-info is-info",
            title: "Tooltipp und/oder Modal"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("button", {
            onClick: triggerRead,
            className: "button button--direction-right is-rounded is-primary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
            key: "text",
            className: "button__text"
        }, t("testPage.textRaedButton.caption")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
            key: "icon",
            className: "icon licon-arrow-circle-right"
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
            className: "layout__right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
            className: "qanda"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
            className: "qanda__header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("p", {
            className: "qanda__header__item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("span", {
            className: "qanda__header--title"
        }, "Test-Code: ", directorState.sessionId))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $b49fe331cd52f107$export$2e2bcd8739ae039), {
            noOfSections: directorState.noOfSections + 1,
            currentSectionNo: directorState.currentSectionNo
        }), directorState.textRaed && uniformSchema && getForm(uniformSchema), !directorState.textRaed && getIntro(false, true)))));
    };
    //log.info("TestPage", directorState.jsonSchema);
    //console.log("render yyy01");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Fragment, null, directorState.jsonSchema && getTestForm(directorState.jsonSchema));
};
var $564db6ad85661f6d$export$2e2bcd8739ae039 = $564db6ad85661f6d$var$TestPage;




var $d3ce02cc19e55c73$exports = {};
"use strict";
Object.defineProperty($d3ce02cc19e55c73$exports, "__esModule", {
    value: true
});
function $d3ce02cc19e55c73$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $cQNHH = parcelRequire("cQNHH");
var $d3ce02cc19e55c73$var$React__default = $d3ce02cc19e55c73$var$_interopDefault($cQNHH);

var $3HNTe = parcelRequire("3HNTe");
var $d3ce02cc19e55c73$var$ClientUAInstance = new $3HNTe();
var $d3ce02cc19e55c73$var$browser = $d3ce02cc19e55c73$var$ClientUAInstance.getBrowser();
var $d3ce02cc19e55c73$var$cpu = $d3ce02cc19e55c73$var$ClientUAInstance.getCPU();
var $d3ce02cc19e55c73$var$device = $d3ce02cc19e55c73$var$ClientUAInstance.getDevice();
var $d3ce02cc19e55c73$var$engine = $d3ce02cc19e55c73$var$ClientUAInstance.getEngine();
var $d3ce02cc19e55c73$var$os = $d3ce02cc19e55c73$var$ClientUAInstance.getOS();
var $d3ce02cc19e55c73$var$ua = $d3ce02cc19e55c73$var$ClientUAInstance.getUA();
var $d3ce02cc19e55c73$var$setUa = function setUa(userAgentString) {
    return $d3ce02cc19e55c73$var$ClientUAInstance.setUA(userAgentString);
};
var $d3ce02cc19e55c73$var$parseUserAgent = function parseUserAgent(userAgent) {
    if (!userAgent) {
        console.error("No userAgent string was provided");
        return;
    }
    var UserAgentInstance = new $3HNTe(userAgent);
    return {
        UA: UserAgentInstance,
        browser: UserAgentInstance.getBrowser(),
        cpu: UserAgentInstance.getCPU(),
        device: UserAgentInstance.getDevice(),
        engine: UserAgentInstance.getEngine(),
        os: UserAgentInstance.getOS(),
        ua: UserAgentInstance.getUA(),
        setUserAgent: function setUserAgent(userAgentString) {
            return UserAgentInstance.setUA(userAgentString);
        }
    };
};
var $d3ce02cc19e55c73$var$UAHelper = /*#__PURE__*/ Object.freeze({
    ClientUAInstance: $d3ce02cc19e55c73$var$ClientUAInstance,
    browser: $d3ce02cc19e55c73$var$browser,
    cpu: $d3ce02cc19e55c73$var$cpu,
    device: $d3ce02cc19e55c73$var$device,
    engine: $d3ce02cc19e55c73$var$engine,
    os: $d3ce02cc19e55c73$var$os,
    ua: $d3ce02cc19e55c73$var$ua,
    setUa: $d3ce02cc19e55c73$var$setUa,
    parseUserAgent: $d3ce02cc19e55c73$var$parseUserAgent
});
function $d3ce02cc19e55c73$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d3ce02cc19e55c73$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d3ce02cc19e55c73$var$ownKeys(Object(source), true).forEach(function(key) {
            $d3ce02cc19e55c73$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d3ce02cc19e55c73$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d3ce02cc19e55c73$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d3ce02cc19e55c73$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $d3ce02cc19e55c73$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d3ce02cc19e55c73$var$_typeof(obj);
}
function $d3ce02cc19e55c73$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d3ce02cc19e55c73$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d3ce02cc19e55c73$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d3ce02cc19e55c73$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d3ce02cc19e55c73$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $d3ce02cc19e55c73$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d3ce02cc19e55c73$var$_extends() {
    $d3ce02cc19e55c73$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d3ce02cc19e55c73$var$_extends.apply(this, arguments);
}
function $d3ce02cc19e55c73$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $d3ce02cc19e55c73$var$_setPrototypeOf(subClass, superClass);
}
function $d3ce02cc19e55c73$var$_getPrototypeOf(o) {
    $d3ce02cc19e55c73$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d3ce02cc19e55c73$var$_getPrototypeOf(o);
}
function $d3ce02cc19e55c73$var$_setPrototypeOf(o, p) {
    $d3ce02cc19e55c73$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d3ce02cc19e55c73$var$_setPrototypeOf(o, p);
}
function $d3ce02cc19e55c73$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d3ce02cc19e55c73$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d3ce02cc19e55c73$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d3ce02cc19e55c73$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d3ce02cc19e55c73$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $d3ce02cc19e55c73$var$_assertThisInitialized(self);
}
function $d3ce02cc19e55c73$var$_slicedToArray(arr, i) {
    return $d3ce02cc19e55c73$var$_arrayWithHoles(arr) || $d3ce02cc19e55c73$var$_iterableToArrayLimit(arr, i) || $d3ce02cc19e55c73$var$_unsupportedIterableToArray(arr, i) || $d3ce02cc19e55c73$var$_nonIterableRest();
}
function $d3ce02cc19e55c73$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $d3ce02cc19e55c73$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $d3ce02cc19e55c73$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d3ce02cc19e55c73$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d3ce02cc19e55c73$var$_arrayLikeToArray(o, minLen);
}
function $d3ce02cc19e55c73$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d3ce02cc19e55c73$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $d3ce02cc19e55c73$var$DeviceTypes = {
    Mobile: "mobile",
    Tablet: "tablet",
    SmartTv: "smarttv",
    Console: "console",
    Wearable: "wearable",
    Embedded: "embedded",
    Browser: undefined
};
var $d3ce02cc19e55c73$var$BrowserTypes = {
    Chrome: "Chrome",
    Firefox: "Firefox",
    Opera: "Opera",
    Yandex: "Yandex",
    Safari: "Safari",
    InternetExplorer: "Internet Explorer",
    Edge: "Edge",
    Chromium: "Chromium",
    Ie: "IE",
    MobileSafari: "Mobile Safari",
    EdgeChromium: "Edge Chromium",
    MIUI: "MIUI Browser",
    SamsungBrowser: "Samsung Browser"
};
var $d3ce02cc19e55c73$var$OsTypes = {
    IOS: "iOS",
    Android: "Android",
    WindowsPhone: "Windows Phone",
    Windows: "Windows",
    MAC_OS: "Mac OS"
};
var $d3ce02cc19e55c73$var$InitialDeviceTypes = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
};
var $d3ce02cc19e55c73$var$checkDeviceType = function checkDeviceType(type) {
    switch(type){
        case $d3ce02cc19e55c73$var$DeviceTypes.Mobile:
            return {
                isMobile: true
            };
        case $d3ce02cc19e55c73$var$DeviceTypes.Tablet:
            return {
                isTablet: true
            };
        case $d3ce02cc19e55c73$var$DeviceTypes.SmartTv:
            return {
                isSmartTV: true
            };
        case $d3ce02cc19e55c73$var$DeviceTypes.Console:
            return {
                isConsole: true
            };
        case $d3ce02cc19e55c73$var$DeviceTypes.Wearable:
            return {
                isWearable: true
            };
        case $d3ce02cc19e55c73$var$DeviceTypes.Browser:
            return {
                isBrowser: true
            };
        case $d3ce02cc19e55c73$var$DeviceTypes.Embedded:
            return {
                isEmbedded: true
            };
        default:
            return $d3ce02cc19e55c73$var$InitialDeviceTypes;
    }
};
var $d3ce02cc19e55c73$var$setUserAgent = function setUserAgent(userAgent) {
    return $d3ce02cc19e55c73$var$setUa(userAgent);
};
var $d3ce02cc19e55c73$var$setDefaults = function setDefaults(p) {
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "none";
    return p ? p : d;
};
var $d3ce02cc19e55c73$var$getNavigatorInstance = function getNavigatorInstance() {
    if (typeof window !== "undefined") {
        if (window.navigator || navigator) return window.navigator || navigator;
    }
    return false;
};
var $d3ce02cc19e55c73$var$isIOS13Check = function isIOS13Check(type) {
    var nav = $d3ce02cc19e55c73$var$getNavigatorInstance();
    return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === "MacIntel" && nav.maxTouchPoints > 1 && !window.MSStream);
};
var $d3ce02cc19e55c73$var$browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
    return {
        isBrowser: isBrowser,
        browserMajorVersion: $d3ce02cc19e55c73$var$setDefaults(browser.major),
        browserFullVersion: $d3ce02cc19e55c73$var$setDefaults(browser.version),
        browserName: $d3ce02cc19e55c73$var$setDefaults(browser.name),
        engineName: $d3ce02cc19e55c73$var$setDefaults(engine.name),
        engineVersion: $d3ce02cc19e55c73$var$setDefaults(engine.version),
        osName: $d3ce02cc19e55c73$var$setDefaults(os.name),
        osVersion: $d3ce02cc19e55c73$var$setDefaults(os.version),
        userAgent: $d3ce02cc19e55c73$var$setDefaults(ua)
    };
};
var $d3ce02cc19e55c73$var$mobilePayload = function mobilePayload(type, device, os, ua) {
    return $d3ce02cc19e55c73$var$_objectSpread2({}, type, {
        vendor: $d3ce02cc19e55c73$var$setDefaults(device.vendor),
        model: $d3ce02cc19e55c73$var$setDefaults(device.model),
        os: $d3ce02cc19e55c73$var$setDefaults(os.name),
        osVersion: $d3ce02cc19e55c73$var$setDefaults(os.version),
        ua: $d3ce02cc19e55c73$var$setDefaults(ua)
    });
};
var $d3ce02cc19e55c73$var$smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
    return {
        isSmartTV: isSmartTV,
        engineName: $d3ce02cc19e55c73$var$setDefaults(engine.name),
        engineVersion: $d3ce02cc19e55c73$var$setDefaults(engine.version),
        osName: $d3ce02cc19e55c73$var$setDefaults(os.name),
        osVersion: $d3ce02cc19e55c73$var$setDefaults(os.version),
        userAgent: $d3ce02cc19e55c73$var$setDefaults(ua)
    };
};
var $d3ce02cc19e55c73$var$consolePayload = function consolePayload(isConsole, engine, os, ua) {
    return {
        isConsole: isConsole,
        engineName: $d3ce02cc19e55c73$var$setDefaults(engine.name),
        engineVersion: $d3ce02cc19e55c73$var$setDefaults(engine.version),
        osName: $d3ce02cc19e55c73$var$setDefaults(os.name),
        osVersion: $d3ce02cc19e55c73$var$setDefaults(os.version),
        userAgent: $d3ce02cc19e55c73$var$setDefaults(ua)
    };
};
var $d3ce02cc19e55c73$var$wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
    return {
        isWearable: isWearable,
        engineName: $d3ce02cc19e55c73$var$setDefaults(engine.name),
        engineVersion: $d3ce02cc19e55c73$var$setDefaults(engine.version),
        osName: $d3ce02cc19e55c73$var$setDefaults(os.name),
        osVersion: $d3ce02cc19e55c73$var$setDefaults(os.version),
        userAgent: $d3ce02cc19e55c73$var$setDefaults(ua)
    };
};
var $d3ce02cc19e55c73$var$embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
    return {
        isEmbedded: isEmbedded,
        vendor: $d3ce02cc19e55c73$var$setDefaults(device.vendor),
        model: $d3ce02cc19e55c73$var$setDefaults(device.model),
        engineName: $d3ce02cc19e55c73$var$setDefaults(engine.name),
        engineVersion: $d3ce02cc19e55c73$var$setDefaults(engine.version),
        osName: $d3ce02cc19e55c73$var$setDefaults(os.name),
        osVersion: $d3ce02cc19e55c73$var$setDefaults(os.version),
        userAgent: $d3ce02cc19e55c73$var$setDefaults(ua)
    };
};
function $d3ce02cc19e55c73$var$deviceDetect(userAgent) {
    var _ref = userAgent ? $d3ce02cc19e55c73$var$parseUserAgent(userAgent) : $d3ce02cc19e55c73$var$UAHelper, device = _ref.device, browser = _ref.browser, engine = _ref.engine, os = _ref.os, ua = _ref.ua;
    var type = $d3ce02cc19e55c73$var$checkDeviceType(device.type);
    var isBrowser = type.isBrowser, isMobile = type.isMobile, isTablet = type.isTablet, isSmartTV = type.isSmartTV, isConsole = type.isConsole, isWearable = type.isWearable, isEmbedded = type.isEmbedded;
    if (isBrowser) return $d3ce02cc19e55c73$var$browserPayload(isBrowser, browser, engine, os, ua);
    if (isSmartTV) return $d3ce02cc19e55c73$var$smartTvPayload(isSmartTV, engine, os, ua);
    if (isConsole) return $d3ce02cc19e55c73$var$consolePayload(isConsole, engine, os, ua);
    if (isMobile) return $d3ce02cc19e55c73$var$mobilePayload(type, device, os, ua);
    if (isTablet) return $d3ce02cc19e55c73$var$mobilePayload(type, device, os, ua);
    if (isWearable) return $d3ce02cc19e55c73$var$wearablePayload(isWearable, engine, os, ua);
    if (isEmbedded) return $d3ce02cc19e55c73$var$embeddedPayload(isEmbedded, device, engine, os, ua);
}
var $d3ce02cc19e55c73$var$isMobileType = function isMobileType(_ref) {
    var type = _ref.type;
    return type === $d3ce02cc19e55c73$var$DeviceTypes.Mobile;
};
var $d3ce02cc19e55c73$var$isTabletType = function isTabletType(_ref2) {
    var type = _ref2.type;
    return type === $d3ce02cc19e55c73$var$DeviceTypes.Tablet;
};
var $d3ce02cc19e55c73$var$isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
    var type = _ref3.type;
    return type === $d3ce02cc19e55c73$var$DeviceTypes.Mobile || type === $d3ce02cc19e55c73$var$DeviceTypes.Tablet;
};
var $d3ce02cc19e55c73$var$isSmartTVType = function isSmartTVType(_ref4) {
    var type = _ref4.type;
    return type === $d3ce02cc19e55c73$var$DeviceTypes.SmartTv;
};
var $d3ce02cc19e55c73$var$isBrowserType = function isBrowserType(_ref5) {
    var type = _ref5.type;
    return type === $d3ce02cc19e55c73$var$DeviceTypes.Browser;
};
var $d3ce02cc19e55c73$var$isWearableType = function isWearableType(_ref6) {
    var type = _ref6.type;
    return type === $d3ce02cc19e55c73$var$DeviceTypes.Wearable;
};
var $d3ce02cc19e55c73$var$isConsoleType = function isConsoleType(_ref7) {
    var type = _ref7.type;
    return type === $d3ce02cc19e55c73$var$DeviceTypes.Console;
};
var $d3ce02cc19e55c73$var$isEmbeddedType = function isEmbeddedType(_ref8) {
    var type = _ref8.type;
    return type === $d3ce02cc19e55c73$var$DeviceTypes.Embedded;
};
var $d3ce02cc19e55c73$var$getMobileVendor = function getMobileVendor(_ref9) {
    var vendor = _ref9.vendor;
    return $d3ce02cc19e55c73$var$setDefaults(vendor);
};
var $d3ce02cc19e55c73$var$getMobileModel = function getMobileModel(_ref10) {
    var model = _ref10.model;
    return $d3ce02cc19e55c73$var$setDefaults(model);
};
var $d3ce02cc19e55c73$var$getDeviceType = function getDeviceType(_ref11) {
    var type = _ref11.type;
    return $d3ce02cc19e55c73$var$setDefaults(type, "browser");
}; // os types
var $d3ce02cc19e55c73$var$isAndroidType = function isAndroidType(_ref12) {
    var name = _ref12.name;
    return name === $d3ce02cc19e55c73$var$OsTypes.Android;
};
var $d3ce02cc19e55c73$var$isWindowsType = function isWindowsType(_ref13) {
    var name = _ref13.name;
    return name === $d3ce02cc19e55c73$var$OsTypes.Windows;
};
var $d3ce02cc19e55c73$var$isMacOsType = function isMacOsType(_ref14) {
    var name = _ref14.name;
    return name === $d3ce02cc19e55c73$var$OsTypes.MAC_OS;
};
var $d3ce02cc19e55c73$var$isWinPhoneType = function isWinPhoneType(_ref15) {
    var name = _ref15.name;
    return name === $d3ce02cc19e55c73$var$OsTypes.WindowsPhone;
};
var $d3ce02cc19e55c73$var$isIOSType = function isIOSType(_ref16) {
    var name = _ref16.name;
    return name === $d3ce02cc19e55c73$var$OsTypes.IOS;
};
var $d3ce02cc19e55c73$var$getOsVersion = function getOsVersion(_ref17) {
    var version = _ref17.version;
    return $d3ce02cc19e55c73$var$setDefaults(version);
};
var $d3ce02cc19e55c73$var$getOsName = function getOsName(_ref18) {
    var name = _ref18.name;
    return $d3ce02cc19e55c73$var$setDefaults(name);
}; // browser types
var $d3ce02cc19e55c73$var$isChromeType = function isChromeType(_ref19) {
    var name = _ref19.name;
    return name === $d3ce02cc19e55c73$var$BrowserTypes.Chrome;
};
var $d3ce02cc19e55c73$var$isFirefoxType = function isFirefoxType(_ref20) {
    var name = _ref20.name;
    return name === $d3ce02cc19e55c73$var$BrowserTypes.Firefox;
};
var $d3ce02cc19e55c73$var$isChromiumType = function isChromiumType(_ref21) {
    var name = _ref21.name;
    return name === $d3ce02cc19e55c73$var$BrowserTypes.Chromium;
};
var $d3ce02cc19e55c73$var$isEdgeType = function isEdgeType(_ref22) {
    var name = _ref22.name;
    return name === $d3ce02cc19e55c73$var$BrowserTypes.Edge;
};
var $d3ce02cc19e55c73$var$isYandexType = function isYandexType(_ref23) {
    var name = _ref23.name;
    return name === $d3ce02cc19e55c73$var$BrowserTypes.Yandex;
};
var $d3ce02cc19e55c73$var$isSafariType = function isSafariType(_ref24) {
    var name = _ref24.name;
    return name === $d3ce02cc19e55c73$var$BrowserTypes.Safari || name === $d3ce02cc19e55c73$var$BrowserTypes.MobileSafari;
};
var $d3ce02cc19e55c73$var$isMobileSafariType = function isMobileSafariType(_ref25) {
    var name = _ref25.name;
    return name === $d3ce02cc19e55c73$var$BrowserTypes.MobileSafari;
};
var $d3ce02cc19e55c73$var$isOperaType = function isOperaType(_ref26) {
    var name = _ref26.name;
    return name === $d3ce02cc19e55c73$var$BrowserTypes.Opera;
};
var $d3ce02cc19e55c73$var$isIEType = function isIEType(_ref27) {
    var name = _ref27.name;
    return name === $d3ce02cc19e55c73$var$BrowserTypes.InternetExplorer || name === $d3ce02cc19e55c73$var$BrowserTypes.Ie;
};
var $d3ce02cc19e55c73$var$isMIUIType = function isMIUIType(_ref28) {
    var name = _ref28.name;
    return name === $d3ce02cc19e55c73$var$BrowserTypes.MIUI;
};
var $d3ce02cc19e55c73$var$isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
    var name = _ref29.name;
    return name === $d3ce02cc19e55c73$var$BrowserTypes.SamsungBrowser;
};
var $d3ce02cc19e55c73$var$getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
    var version = _ref30.version;
    return $d3ce02cc19e55c73$var$setDefaults(version);
};
var $d3ce02cc19e55c73$var$getBrowserVersion = function getBrowserVersion(_ref31) {
    var major = _ref31.major;
    return $d3ce02cc19e55c73$var$setDefaults(major);
};
var $d3ce02cc19e55c73$var$getBrowserName = function getBrowserName(_ref32) {
    var name = _ref32.name;
    return $d3ce02cc19e55c73$var$setDefaults(name);
}; // engine types
var $d3ce02cc19e55c73$var$getEngineName = function getEngineName(_ref33) {
    var name = _ref33.name;
    return $d3ce02cc19e55c73$var$setDefaults(name);
};
var $d3ce02cc19e55c73$var$getEngineVersion = function getEngineVersion(_ref34) {
    var version = _ref34.version;
    return $d3ce02cc19e55c73$var$setDefaults(version);
};
var $d3ce02cc19e55c73$var$isElectronType = function isElectronType() {
    var nav = $d3ce02cc19e55c73$var$getNavigatorInstance();
    var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
    return typeof ua === "string" ? /electron/.test(ua) : false;
};
var $d3ce02cc19e55c73$var$isEdgeChromiumType = function isEdgeChromiumType(ua) {
    return typeof ua === "string" && ua.indexOf("Edg/") !== -1;
};
var $d3ce02cc19e55c73$var$getIOS13 = function getIOS13() {
    var nav = $d3ce02cc19e55c73$var$getNavigatorInstance();
    return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === "MacIntel" && nav.maxTouchPoints > 1) && !window.MSStream;
};
var $d3ce02cc19e55c73$var$getIPad13 = function getIPad13() {
    return $d3ce02cc19e55c73$var$isIOS13Check("iPad");
};
var $d3ce02cc19e55c73$var$getIphone13 = function getIphone13() {
    return $d3ce02cc19e55c73$var$isIOS13Check("iPhone");
};
var $d3ce02cc19e55c73$var$getIPod13 = function getIPod13() {
    return $d3ce02cc19e55c73$var$isIOS13Check("iPod");
};
var $d3ce02cc19e55c73$var$getUseragent = function getUseragent(userAg) {
    return $d3ce02cc19e55c73$var$setDefaults(userAg);
};
function $d3ce02cc19e55c73$var$buildSelectorsObject(options) {
    var _ref = options ? options : $d3ce02cc19e55c73$var$UAHelper, device = _ref.device, browser = _ref.browser, os = _ref.os, engine = _ref.engine, ua = _ref.ua;
    return {
        isSmartTV: $d3ce02cc19e55c73$var$isSmartTVType(device),
        isConsole: $d3ce02cc19e55c73$var$isConsoleType(device),
        isWearable: $d3ce02cc19e55c73$var$isWearableType(device),
        isEmbedded: $d3ce02cc19e55c73$var$isEmbeddedType(device),
        isMobileSafari: $d3ce02cc19e55c73$var$isMobileSafariType(browser) || $d3ce02cc19e55c73$var$getIPad13(),
        isChromium: $d3ce02cc19e55c73$var$isChromiumType(browser),
        isMobile: $d3ce02cc19e55c73$var$isMobileAndTabletType(device) || $d3ce02cc19e55c73$var$getIPad13(),
        isMobileOnly: $d3ce02cc19e55c73$var$isMobileType(device),
        isTablet: $d3ce02cc19e55c73$var$isTabletType(device) || $d3ce02cc19e55c73$var$getIPad13(),
        isBrowser: $d3ce02cc19e55c73$var$isBrowserType(device),
        isDesktop: $d3ce02cc19e55c73$var$isBrowserType(device),
        isAndroid: $d3ce02cc19e55c73$var$isAndroidType(os),
        isWinPhone: $d3ce02cc19e55c73$var$isWinPhoneType(os),
        isIOS: $d3ce02cc19e55c73$var$isIOSType(os) || $d3ce02cc19e55c73$var$getIPad13(),
        isChrome: $d3ce02cc19e55c73$var$isChromeType(browser),
        isFirefox: $d3ce02cc19e55c73$var$isFirefoxType(browser),
        isSafari: $d3ce02cc19e55c73$var$isSafariType(browser),
        isOpera: $d3ce02cc19e55c73$var$isOperaType(browser),
        isIE: $d3ce02cc19e55c73$var$isIEType(browser),
        osVersion: $d3ce02cc19e55c73$var$getOsVersion(os),
        osName: $d3ce02cc19e55c73$var$getOsName(os),
        fullBrowserVersion: $d3ce02cc19e55c73$var$getBrowserFullVersion(browser),
        browserVersion: $d3ce02cc19e55c73$var$getBrowserVersion(browser),
        browserName: $d3ce02cc19e55c73$var$getBrowserName(browser),
        mobileVendor: $d3ce02cc19e55c73$var$getMobileVendor(device),
        mobileModel: $d3ce02cc19e55c73$var$getMobileModel(device),
        engineName: $d3ce02cc19e55c73$var$getEngineName(engine),
        engineVersion: $d3ce02cc19e55c73$var$getEngineVersion(engine),
        getUA: $d3ce02cc19e55c73$var$getUseragent(ua),
        isEdge: $d3ce02cc19e55c73$var$isEdgeType(browser) || $d3ce02cc19e55c73$var$isEdgeChromiumType(ua),
        isYandex: $d3ce02cc19e55c73$var$isYandexType(browser),
        deviceType: $d3ce02cc19e55c73$var$getDeviceType(device),
        isIOS13: $d3ce02cc19e55c73$var$getIOS13(),
        isIPad13: $d3ce02cc19e55c73$var$getIPad13(),
        isIPhone13: $d3ce02cc19e55c73$var$getIphone13(),
        isIPod13: $d3ce02cc19e55c73$var$getIPod13(),
        isElectron: $d3ce02cc19e55c73$var$isElectronType(),
        isEdgeChromium: $d3ce02cc19e55c73$var$isEdgeChromiumType(ua),
        isLegacyEdge: $d3ce02cc19e55c73$var$isEdgeType(browser) && !$d3ce02cc19e55c73$var$isEdgeChromiumType(ua),
        isWindows: $d3ce02cc19e55c73$var$isWindowsType(os),
        isMacOs: $d3ce02cc19e55c73$var$isMacOsType(os),
        isMIUI: $d3ce02cc19e55c73$var$isMIUIType(browser),
        isSamsungBrowser: $d3ce02cc19e55c73$var$isSamsungBrowserType(browser)
    };
}
var $d3ce02cc19e55c73$var$isSmartTV = $d3ce02cc19e55c73$var$isSmartTVType($d3ce02cc19e55c73$var$device);
var $d3ce02cc19e55c73$var$isConsole = $d3ce02cc19e55c73$var$isConsoleType($d3ce02cc19e55c73$var$device);
var $d3ce02cc19e55c73$var$isWearable = $d3ce02cc19e55c73$var$isWearableType($d3ce02cc19e55c73$var$device);
var $d3ce02cc19e55c73$var$isEmbedded = $d3ce02cc19e55c73$var$isEmbeddedType($d3ce02cc19e55c73$var$device);
var $d3ce02cc19e55c73$var$isMobileSafari = $d3ce02cc19e55c73$var$isMobileSafariType($d3ce02cc19e55c73$var$browser) || $d3ce02cc19e55c73$var$getIPad13();
var $d3ce02cc19e55c73$var$isChromium = $d3ce02cc19e55c73$var$isChromiumType($d3ce02cc19e55c73$var$browser);
var $d3ce02cc19e55c73$var$isMobile = $d3ce02cc19e55c73$var$isMobileAndTabletType($d3ce02cc19e55c73$var$device) || $d3ce02cc19e55c73$var$getIPad13();
var $d3ce02cc19e55c73$var$isMobileOnly = $d3ce02cc19e55c73$var$isMobileType($d3ce02cc19e55c73$var$device);
var $d3ce02cc19e55c73$var$isTablet = $d3ce02cc19e55c73$var$isTabletType($d3ce02cc19e55c73$var$device) || $d3ce02cc19e55c73$var$getIPad13();
var $d3ce02cc19e55c73$var$isBrowser = $d3ce02cc19e55c73$var$isBrowserType($d3ce02cc19e55c73$var$device);
var $d3ce02cc19e55c73$var$isDesktop = $d3ce02cc19e55c73$var$isBrowserType($d3ce02cc19e55c73$var$device);
var $d3ce02cc19e55c73$var$isAndroid = $d3ce02cc19e55c73$var$isAndroidType($d3ce02cc19e55c73$var$os);
var $d3ce02cc19e55c73$var$isWinPhone = $d3ce02cc19e55c73$var$isWinPhoneType($d3ce02cc19e55c73$var$os);
var $d3ce02cc19e55c73$var$isIOS = $d3ce02cc19e55c73$var$isIOSType($d3ce02cc19e55c73$var$os) || $d3ce02cc19e55c73$var$getIPad13();
var $d3ce02cc19e55c73$var$isChrome = $d3ce02cc19e55c73$var$isChromeType($d3ce02cc19e55c73$var$browser);
var $d3ce02cc19e55c73$var$isFirefox = $d3ce02cc19e55c73$var$isFirefoxType($d3ce02cc19e55c73$var$browser);
var $d3ce02cc19e55c73$var$isSafari = $d3ce02cc19e55c73$var$isSafariType($d3ce02cc19e55c73$var$browser);
var $d3ce02cc19e55c73$var$isOpera = $d3ce02cc19e55c73$var$isOperaType($d3ce02cc19e55c73$var$browser);
var $d3ce02cc19e55c73$var$isIE = $d3ce02cc19e55c73$var$isIEType($d3ce02cc19e55c73$var$browser);
var $d3ce02cc19e55c73$var$osVersion = $d3ce02cc19e55c73$var$getOsVersion($d3ce02cc19e55c73$var$os);
var $d3ce02cc19e55c73$var$osName = $d3ce02cc19e55c73$var$getOsName($d3ce02cc19e55c73$var$os);
var $d3ce02cc19e55c73$var$fullBrowserVersion = $d3ce02cc19e55c73$var$getBrowserFullVersion($d3ce02cc19e55c73$var$browser);
var $d3ce02cc19e55c73$var$browserVersion = $d3ce02cc19e55c73$var$getBrowserVersion($d3ce02cc19e55c73$var$browser);
var $d3ce02cc19e55c73$var$browserName = $d3ce02cc19e55c73$var$getBrowserName($d3ce02cc19e55c73$var$browser);
var $d3ce02cc19e55c73$var$mobileVendor = $d3ce02cc19e55c73$var$getMobileVendor($d3ce02cc19e55c73$var$device);
var $d3ce02cc19e55c73$var$mobileModel = $d3ce02cc19e55c73$var$getMobileModel($d3ce02cc19e55c73$var$device);
var $d3ce02cc19e55c73$var$engineName = $d3ce02cc19e55c73$var$getEngineName($d3ce02cc19e55c73$var$engine);
var $d3ce02cc19e55c73$var$engineVersion = $d3ce02cc19e55c73$var$getEngineVersion($d3ce02cc19e55c73$var$engine);
var $d3ce02cc19e55c73$var$getUA = $d3ce02cc19e55c73$var$getUseragent($d3ce02cc19e55c73$var$ua);
var $d3ce02cc19e55c73$var$isEdge = $d3ce02cc19e55c73$var$isEdgeType($d3ce02cc19e55c73$var$browser) || $d3ce02cc19e55c73$var$isEdgeChromiumType($d3ce02cc19e55c73$var$ua);
var $d3ce02cc19e55c73$var$isYandex = $d3ce02cc19e55c73$var$isYandexType($d3ce02cc19e55c73$var$browser);
var $d3ce02cc19e55c73$var$deviceType = $d3ce02cc19e55c73$var$getDeviceType($d3ce02cc19e55c73$var$device);
var $d3ce02cc19e55c73$var$isIOS13 = $d3ce02cc19e55c73$var$getIOS13();
var $d3ce02cc19e55c73$var$isIPad13 = $d3ce02cc19e55c73$var$getIPad13();
var $d3ce02cc19e55c73$var$isIPhone13 = $d3ce02cc19e55c73$var$getIphone13();
var $d3ce02cc19e55c73$var$isIPod13 = $d3ce02cc19e55c73$var$getIPod13();
var $d3ce02cc19e55c73$var$isElectron = $d3ce02cc19e55c73$var$isElectronType();
var $d3ce02cc19e55c73$var$isEdgeChromium = $d3ce02cc19e55c73$var$isEdgeChromiumType($d3ce02cc19e55c73$var$ua);
var $d3ce02cc19e55c73$var$isLegacyEdge = $d3ce02cc19e55c73$var$isEdgeType($d3ce02cc19e55c73$var$browser) && !$d3ce02cc19e55c73$var$isEdgeChromiumType($d3ce02cc19e55c73$var$ua);
var $d3ce02cc19e55c73$var$isWindows = $d3ce02cc19e55c73$var$isWindowsType($d3ce02cc19e55c73$var$os);
var $d3ce02cc19e55c73$var$isMacOs = $d3ce02cc19e55c73$var$isMacOsType($d3ce02cc19e55c73$var$os);
var $d3ce02cc19e55c73$var$isMIUI = $d3ce02cc19e55c73$var$isMIUIType($d3ce02cc19e55c73$var$browser);
var $d3ce02cc19e55c73$var$isSamsungBrowser = $d3ce02cc19e55c73$var$isSamsungBrowserType($d3ce02cc19e55c73$var$browser);
var $d3ce02cc19e55c73$var$getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
    if (!userAgent || typeof userAgent !== "string") {
        console.error("No valid user agent string was provided");
        return;
    }
    var _UAHelper$parseUserAg = $d3ce02cc19e55c73$var$parseUserAgent(userAgent), device = _UAHelper$parseUserAg.device, browser = _UAHelper$parseUserAg.browser, os = _UAHelper$parseUserAg.os, engine = _UAHelper$parseUserAg.engine, ua = _UAHelper$parseUserAg.ua;
    return $d3ce02cc19e55c73$var$buildSelectorsObject({
        device: device,
        browser: browser,
        os: os,
        engine: engine,
        ua: ua
    });
};
var $d3ce02cc19e55c73$var$AndroidView = function AndroidView(_ref) {
    var renderWithFragment = _ref.renderWithFragment, children = _ref.children, props = $d3ce02cc19e55c73$var$_objectWithoutProperties(_ref, [
        "renderWithFragment",
        "children"
    ]);
    return $d3ce02cc19e55c73$var$isAndroid ? renderWithFragment ? $d3ce02cc19e55c73$var$React__default.createElement($cQNHH.Fragment, null, children) : $d3ce02cc19e55c73$var$React__default.createElement("div", props, children) : null;
};
var $d3ce02cc19e55c73$var$BrowserView = function BrowserView(_ref2) {
    var renderWithFragment = _ref2.renderWithFragment, children = _ref2.children, props = $d3ce02cc19e55c73$var$_objectWithoutProperties(_ref2, [
        "renderWithFragment",
        "children"
    ]);
    return $d3ce02cc19e55c73$var$isBrowser ? renderWithFragment ? $d3ce02cc19e55c73$var$React__default.createElement($cQNHH.Fragment, null, children) : $d3ce02cc19e55c73$var$React__default.createElement("div", props, children) : null;
};
var $d3ce02cc19e55c73$var$IEView = function IEView(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment, children = _ref3.children, props = $d3ce02cc19e55c73$var$_objectWithoutProperties(_ref3, [
        "renderWithFragment",
        "children"
    ]);
    return $d3ce02cc19e55c73$var$isIE ? renderWithFragment ? $d3ce02cc19e55c73$var$React__default.createElement($cQNHH.Fragment, null, children) : $d3ce02cc19e55c73$var$React__default.createElement("div", props, children) : null;
};
var $d3ce02cc19e55c73$var$IOSView = function IOSView(_ref4) {
    var renderWithFragment = _ref4.renderWithFragment, children = _ref4.children, props = $d3ce02cc19e55c73$var$_objectWithoutProperties(_ref4, [
        "renderWithFragment",
        "children"
    ]);
    return $d3ce02cc19e55c73$var$isIOS ? renderWithFragment ? $d3ce02cc19e55c73$var$React__default.createElement($cQNHH.Fragment, null, children) : $d3ce02cc19e55c73$var$React__default.createElement("div", props, children) : null;
};
var $d3ce02cc19e55c73$var$MobileView = function MobileView(_ref5) {
    var renderWithFragment = _ref5.renderWithFragment, children = _ref5.children, props = $d3ce02cc19e55c73$var$_objectWithoutProperties(_ref5, [
        "renderWithFragment",
        "children"
    ]);
    return $d3ce02cc19e55c73$var$isMobile ? renderWithFragment ? $d3ce02cc19e55c73$var$React__default.createElement($cQNHH.Fragment, null, children) : $d3ce02cc19e55c73$var$React__default.createElement("div", props, children) : null;
};
var $d3ce02cc19e55c73$var$TabletView = function TabletView(_ref6) {
    var renderWithFragment = _ref6.renderWithFragment, children = _ref6.children, props = $d3ce02cc19e55c73$var$_objectWithoutProperties(_ref6, [
        "renderWithFragment",
        "children"
    ]);
    return $d3ce02cc19e55c73$var$isTablet ? renderWithFragment ? $d3ce02cc19e55c73$var$React__default.createElement($cQNHH.Fragment, null, children) : $d3ce02cc19e55c73$var$React__default.createElement("div", props, children) : null;
};
var $d3ce02cc19e55c73$var$WinPhoneView = function WinPhoneView(_ref7) {
    var renderWithFragment = _ref7.renderWithFragment, children = _ref7.children, props = $d3ce02cc19e55c73$var$_objectWithoutProperties(_ref7, [
        "renderWithFragment",
        "children"
    ]);
    return $d3ce02cc19e55c73$var$isWinPhone ? renderWithFragment ? $d3ce02cc19e55c73$var$React__default.createElement($cQNHH.Fragment, null, children) : $d3ce02cc19e55c73$var$React__default.createElement("div", props, children) : null;
};
var $d3ce02cc19e55c73$var$MobileOnlyView = function MobileOnlyView(_ref8) {
    var renderWithFragment = _ref8.renderWithFragment, children = _ref8.children, viewClassName = _ref8.viewClassName, style = _ref8.style, props = $d3ce02cc19e55c73$var$_objectWithoutProperties(_ref8, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return $d3ce02cc19e55c73$var$isMobileOnly ? renderWithFragment ? $d3ce02cc19e55c73$var$React__default.createElement($cQNHH.Fragment, null, children) : $d3ce02cc19e55c73$var$React__default.createElement("div", props, children) : null;
};
var $d3ce02cc19e55c73$var$SmartTVView = function SmartTVView(_ref9) {
    var renderWithFragment = _ref9.renderWithFragment, children = _ref9.children, props = $d3ce02cc19e55c73$var$_objectWithoutProperties(_ref9, [
        "renderWithFragment",
        "children"
    ]);
    return $d3ce02cc19e55c73$var$isSmartTV ? renderWithFragment ? $d3ce02cc19e55c73$var$React__default.createElement($cQNHH.Fragment, null, children) : $d3ce02cc19e55c73$var$React__default.createElement("div", props, children) : null;
};
var $d3ce02cc19e55c73$var$ConsoleView = function ConsoleView(_ref10) {
    var renderWithFragment = _ref10.renderWithFragment, children = _ref10.children, props = $d3ce02cc19e55c73$var$_objectWithoutProperties(_ref10, [
        "renderWithFragment",
        "children"
    ]);
    return $d3ce02cc19e55c73$var$isConsole ? renderWithFragment ? $d3ce02cc19e55c73$var$React__default.createElement($cQNHH.Fragment, null, children) : $d3ce02cc19e55c73$var$React__default.createElement("div", props, children) : null;
};
var $d3ce02cc19e55c73$var$WearableView = function WearableView(_ref11) {
    var renderWithFragment = _ref11.renderWithFragment, children = _ref11.children, props = $d3ce02cc19e55c73$var$_objectWithoutProperties(_ref11, [
        "renderWithFragment",
        "children"
    ]);
    return $d3ce02cc19e55c73$var$isWearable ? renderWithFragment ? $d3ce02cc19e55c73$var$React__default.createElement($cQNHH.Fragment, null, children) : $d3ce02cc19e55c73$var$React__default.createElement("div", props, children) : null;
};
var $d3ce02cc19e55c73$var$CustomView = function CustomView(_ref12) {
    var renderWithFragment = _ref12.renderWithFragment, children = _ref12.children, viewClassName = _ref12.viewClassName, style = _ref12.style, condition = _ref12.condition, props = $d3ce02cc19e55c73$var$_objectWithoutProperties(_ref12, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style",
        "condition"
    ]);
    return condition ? renderWithFragment ? $d3ce02cc19e55c73$var$React__default.createElement($cQNHH.Fragment, null, children) : $d3ce02cc19e55c73$var$React__default.createElement("div", props, children) : null;
};
function $d3ce02cc19e55c73$var$withOrientationChange(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        $d3ce02cc19e55c73$var$_inherits(_class, _React$Component);
        function _class(props) {
            var _this;
            $d3ce02cc19e55c73$var$_classCallCheck(this, _class);
            _this = $d3ce02cc19e55c73$var$_possibleConstructorReturn(this, $d3ce02cc19e55c73$var$_getPrototypeOf(_class).call(this, props));
            _this.isEventListenerAdded = false;
            _this.handleOrientationChange = _this.handleOrientationChange.bind($d3ce02cc19e55c73$var$_assertThisInitialized(_this));
            _this.onOrientationChange = _this.onOrientationChange.bind($d3ce02cc19e55c73$var$_assertThisInitialized(_this));
            _this.onPageLoad = _this.onPageLoad.bind($d3ce02cc19e55c73$var$_assertThisInitialized(_this));
            _this.state = {
                isLandscape: false,
                isPortrait: false
            };
            return _this;
        }
        $d3ce02cc19e55c73$var$_createClass(_class, [
            {
                key: "handleOrientationChange",
                value: function handleOrientationChange() {
                    if (!this.isEventListenerAdded) this.isEventListenerAdded = true;
                    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
                    this.setState({
                        isPortrait: orientation === 0,
                        isLandscape: orientation === 90
                    });
                }
            },
            {
                key: "onOrientationChange",
                value: function onOrientationChange() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "onPageLoad",
                value: function onPageLoad() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if ((typeof window === "undefined" ? "undefined" : $d3ce02cc19e55c73$var$_typeof(window)) !== undefined && $d3ce02cc19e55c73$var$isMobile) {
                        if (!this.isEventListenerAdded) {
                            this.handleOrientationChange();
                            window.addEventListener("load", this.onPageLoad, false);
                        } else window.removeEventListener("load", this.onPageLoad, false);
                        window.addEventListener("resize", this.onOrientationChange, false);
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    window.removeEventListener("resize", this.onOrientationChange, false);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $d3ce02cc19e55c73$var$React__default.createElement(WrappedComponent, $d3ce02cc19e55c73$var$_extends({}, this.props, {
                        isLandscape: this.state.isLandscape,
                        isPortrait: this.state.isPortrait
                    }));
                }
            }
        ]);
        return _class;
    }($d3ce02cc19e55c73$var$React__default.Component);
}
function $d3ce02cc19e55c73$var$useMobileOrientation() {
    var _useState = $cQNHH.useState(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        return {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? "portrait" : "landscape"
        };
    }), _useState2 = $d3ce02cc19e55c73$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var handleOrientationChange = $cQNHH.useCallback(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        var next = {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? "portrait" : "landscape"
        };
        state.orientation !== next.orientation && setState(next);
    }, [
        state.orientation
    ]);
    $cQNHH.useEffect(function() {
        if ((typeof window === "undefined" ? "undefined" : $d3ce02cc19e55c73$var$_typeof(window)) !== undefined && $d3ce02cc19e55c73$var$isMobile) {
            handleOrientationChange();
            window.addEventListener("load", handleOrientationChange, false);
            window.addEventListener("resize", handleOrientationChange, false);
        }
        return function() {
            window.removeEventListener("resize", handleOrientationChange, false);
            window.removeEventListener("load", handleOrientationChange, false);
        };
    }, [
        handleOrientationChange
    ]);
    return state;
}
function $d3ce02cc19e55c73$var$useDeviceData(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    return $d3ce02cc19e55c73$var$parseUserAgent(hookUserAgent);
}
function $d3ce02cc19e55c73$var$useDeviceSelectors(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    var deviceData = $d3ce02cc19e55c73$var$useDeviceData(hookUserAgent);
    var selectors = $d3ce02cc19e55c73$var$buildSelectorsObject(deviceData);
    return [
        selectors,
        deviceData
    ];
}
$d3ce02cc19e55c73$exports.AndroidView = $d3ce02cc19e55c73$var$AndroidView;
$d3ce02cc19e55c73$exports.BrowserTypes = $d3ce02cc19e55c73$var$BrowserTypes;
$d3ce02cc19e55c73$exports.BrowserView = $d3ce02cc19e55c73$var$BrowserView;
$d3ce02cc19e55c73$exports.ConsoleView = $d3ce02cc19e55c73$var$ConsoleView;
$d3ce02cc19e55c73$exports.CustomView = $d3ce02cc19e55c73$var$CustomView;
$d3ce02cc19e55c73$exports.IEView = $d3ce02cc19e55c73$var$IEView;
$d3ce02cc19e55c73$exports.IOSView = $d3ce02cc19e55c73$var$IOSView;
$d3ce02cc19e55c73$exports.MobileOnlyView = $d3ce02cc19e55c73$var$MobileOnlyView;
$d3ce02cc19e55c73$exports.MobileView = $d3ce02cc19e55c73$var$MobileView;
$d3ce02cc19e55c73$exports.OsTypes = $d3ce02cc19e55c73$var$OsTypes;
$d3ce02cc19e55c73$exports.SmartTVView = $d3ce02cc19e55c73$var$SmartTVView;
$d3ce02cc19e55c73$exports.TabletView = $d3ce02cc19e55c73$var$TabletView;
$d3ce02cc19e55c73$exports.WearableView = $d3ce02cc19e55c73$var$WearableView;
$d3ce02cc19e55c73$exports.WinPhoneView = $d3ce02cc19e55c73$var$WinPhoneView;
$d3ce02cc19e55c73$exports.browserName = $d3ce02cc19e55c73$var$browserName;
$d3ce02cc19e55c73$exports.browserVersion = $d3ce02cc19e55c73$var$browserVersion;
$d3ce02cc19e55c73$exports.deviceDetect = $d3ce02cc19e55c73$var$deviceDetect;
$d3ce02cc19e55c73$exports.deviceType = $d3ce02cc19e55c73$var$deviceType;
$d3ce02cc19e55c73$exports.engineName = $d3ce02cc19e55c73$var$engineName;
$d3ce02cc19e55c73$exports.engineVersion = $d3ce02cc19e55c73$var$engineVersion;
$d3ce02cc19e55c73$exports.fullBrowserVersion = $d3ce02cc19e55c73$var$fullBrowserVersion;
$d3ce02cc19e55c73$exports.getSelectorsByUserAgent = $d3ce02cc19e55c73$var$getSelectorsByUserAgent;
$d3ce02cc19e55c73$exports.getUA = $d3ce02cc19e55c73$var$getUA;
$d3ce02cc19e55c73$exports.isAndroid = $d3ce02cc19e55c73$var$isAndroid;
$d3ce02cc19e55c73$exports.isBrowser = $d3ce02cc19e55c73$var$isBrowser;
$d3ce02cc19e55c73$exports.isChrome = $d3ce02cc19e55c73$var$isChrome;
$d3ce02cc19e55c73$exports.isChromium = $d3ce02cc19e55c73$var$isChromium;
$d3ce02cc19e55c73$exports.isConsole = $d3ce02cc19e55c73$var$isConsole;
$d3ce02cc19e55c73$exports.isDesktop = $d3ce02cc19e55c73$var$isDesktop;
$d3ce02cc19e55c73$exports.isEdge = $d3ce02cc19e55c73$var$isEdge;
$d3ce02cc19e55c73$exports.isEdgeChromium = $d3ce02cc19e55c73$var$isEdgeChromium;
$d3ce02cc19e55c73$exports.isElectron = $d3ce02cc19e55c73$var$isElectron;
$d3ce02cc19e55c73$exports.isEmbedded = $d3ce02cc19e55c73$var$isEmbedded;
$d3ce02cc19e55c73$exports.isFirefox = $d3ce02cc19e55c73$var$isFirefox;
$d3ce02cc19e55c73$exports.isIE = $d3ce02cc19e55c73$var$isIE;
$d3ce02cc19e55c73$exports.isIOS = $d3ce02cc19e55c73$var$isIOS;
$d3ce02cc19e55c73$exports.isIOS13 = $d3ce02cc19e55c73$var$isIOS13;
$d3ce02cc19e55c73$exports.isIPad13 = $d3ce02cc19e55c73$var$isIPad13;
$d3ce02cc19e55c73$exports.isIPhone13 = $d3ce02cc19e55c73$var$isIPhone13;
$d3ce02cc19e55c73$exports.isIPod13 = $d3ce02cc19e55c73$var$isIPod13;
$d3ce02cc19e55c73$exports.isLegacyEdge = $d3ce02cc19e55c73$var$isLegacyEdge;
$d3ce02cc19e55c73$exports.isMIUI = $d3ce02cc19e55c73$var$isMIUI;
$d3ce02cc19e55c73$exports.isMacOs = $d3ce02cc19e55c73$var$isMacOs;
$d3ce02cc19e55c73$exports.isMobile = $d3ce02cc19e55c73$var$isMobile;
$d3ce02cc19e55c73$exports.isMobileOnly = $d3ce02cc19e55c73$var$isMobileOnly;
$d3ce02cc19e55c73$exports.isMobileSafari = $d3ce02cc19e55c73$var$isMobileSafari;
$d3ce02cc19e55c73$exports.isOpera = $d3ce02cc19e55c73$var$isOpera;
$d3ce02cc19e55c73$exports.isSafari = $d3ce02cc19e55c73$var$isSafari;
$d3ce02cc19e55c73$exports.isSamsungBrowser = $d3ce02cc19e55c73$var$isSamsungBrowser;
$d3ce02cc19e55c73$exports.isSmartTV = $d3ce02cc19e55c73$var$isSmartTV;
$d3ce02cc19e55c73$exports.isTablet = $d3ce02cc19e55c73$var$isTablet;
$d3ce02cc19e55c73$exports.isWearable = $d3ce02cc19e55c73$var$isWearable;
$d3ce02cc19e55c73$exports.isWinPhone = $d3ce02cc19e55c73$var$isWinPhone;
$d3ce02cc19e55c73$exports.isWindows = $d3ce02cc19e55c73$var$isWindows;
$d3ce02cc19e55c73$exports.isYandex = $d3ce02cc19e55c73$var$isYandex;
$d3ce02cc19e55c73$exports.mobileModel = $d3ce02cc19e55c73$var$mobileModel;
$d3ce02cc19e55c73$exports.mobileVendor = $d3ce02cc19e55c73$var$mobileVendor;
$d3ce02cc19e55c73$exports.osName = $d3ce02cc19e55c73$var$osName;
$d3ce02cc19e55c73$exports.osVersion = $d3ce02cc19e55c73$var$osVersion;
$d3ce02cc19e55c73$exports.parseUserAgent = $d3ce02cc19e55c73$var$parseUserAgent;
$d3ce02cc19e55c73$exports.setUserAgent = $d3ce02cc19e55c73$var$setUserAgent;
$d3ce02cc19e55c73$exports.useDeviceData = $d3ce02cc19e55c73$var$useDeviceData;
$d3ce02cc19e55c73$exports.useDeviceSelectors = $d3ce02cc19e55c73$var$useDeviceSelectors;
$d3ce02cc19e55c73$exports.useMobileOrientation = $d3ce02cc19e55c73$var$useMobileOrientation;
$d3ce02cc19e55c73$exports.withOrientationChange = $d3ce02cc19e55c73$var$withOrientationChange;




var $cQNHH = parcelRequire("cQNHH");






var $d2e7b2d329133c02$exports = {};

var $7dgut = parcelRequire("7dgut");


/**
 * html2pdf.js v0.9.3
 * Copyright (c) 2021 Erik Koopmans
 * Released under the MIT License.
 */ (function(global1, factory) {
    $d2e7b2d329133c02$exports = factory((parcelRequire("kg9hQ")), (parcelRequire("bEEeD")));
})($d2e7b2d329133c02$exports, function(jsPDF, html2canvas) {
    "use strict";
    jsPDF = jsPDF && jsPDF.hasOwnProperty("default") ? jsPDF["default"] : jsPDF;
    html2canvas = html2canvas && html2canvas.hasOwnProperty("default") ? html2canvas["default"] : html2canvas;
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    // Determine the type of a variable/object.
    var objType = function objType(obj) {
        var type = typeof obj === "undefined" ? "undefined" : _typeof(obj);
        if (type === "undefined") return "undefined";
        else if (type === "string" || obj instanceof String) return "string";
        else if (type === "number" || obj instanceof Number) return "number";
        else if (type === "function" || obj instanceof Function) return "function";
        else if (!!obj && obj.constructor === Array) return "array";
        else if (obj && obj.nodeType === 1) return "element";
        else if (type === "object") return "object";
        else return "unknown";
    };
    // Create an HTML element with optional className, innerHTML, and style.
    var createElement = function createElement(tagName, opt) {
        var el = document.createElement(tagName);
        if (opt.className) el.className = opt.className;
        if (opt.innerHTML) {
            el.innerHTML = opt.innerHTML;
            var scripts = el.getElementsByTagName("script");
            for(var i = scripts.length; i-- > 0;)scripts[i].parentNode.removeChild(scripts[i]);
        }
        for(var key in opt.style)el.style[key] = opt.style[key];
        return el;
    };
    // Deep-clone a node and preserve contents/properties.
    var cloneNode = function cloneNode(node, javascriptEnabled) {
        // Recursively clone the node.
        var clone = node.nodeType === 3 ? document.createTextNode(node.nodeValue) : node.cloneNode(false);
        for(var child = node.firstChild; child; child = child.nextSibling)if (javascriptEnabled === true || child.nodeType !== 1 || child.nodeName !== "SCRIPT") clone.appendChild(cloneNode(child, javascriptEnabled));
        if (node.nodeType === 1) {
            // Preserve contents/properties of special nodes.
            if (node.nodeName === "CANVAS") {
                clone.width = node.width;
                clone.height = node.height;
                clone.getContext("2d").drawImage(node, 0, 0);
            } else if (node.nodeName === "TEXTAREA" || node.nodeName === "SELECT") clone.value = node.value;
            // Preserve the node's scroll position when it loads.
            clone.addEventListener("load", function() {
                clone.scrollTop = node.scrollTop;
                clone.scrollLeft = node.scrollLeft;
            }, true);
        }
        // Return the cloned node.
        return clone;
    };
    // Convert units from px using the conversion value 'k' from jsPDF.
    var unitConvert = function unitConvert(obj, k) {
        if (objType(obj) === "number") return obj * 72 / 96 / k;
        else {
            var newObj = {};
            for(var key in obj)newObj[key] = obj[key] * 72 / 96 / k;
            return newObj;
        }
    };
    // Convert units to px using the conversion value 'k' from jsPDF.
    var toPx = function toPx(val, k) {
        return Math.floor(val * k / 72 * 96);
    };
    var commonjsGlobal = typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
    function commonjsRequire() {
        throw new Error("Dynamic requires are not currently supported by rollup-plugin-commonjs");
    }
    function createCommonjsModule(fn, module1) {
        return module1 = {
            exports: {}
        }, fn(module1, module1.exports), module1.exports;
    }
    var es6Promise = createCommonjsModule(function(module1, exports) {
        /*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.5+7f2b526d
 */ (function(global1, factory) {
            module1.exports = factory();
        })(commonjsGlobal, function() {
            function objectOrFunction(x) {
                var type = typeof x;
                return x !== null && (type === "object" || type === "function");
            }
            function isFunction(x) {
                return typeof x === "function";
            }
            var _isArray = void 0;
            if (Array.isArray) _isArray = Array.isArray;
            else _isArray = function(x) {
                return Object.prototype.toString.call(x) === "[object Array]";
            };
            var isArray = _isArray;
            var len = 0;
            var vertxNext = void 0;
            var customSchedulerFn = void 0;
            var asap = function asap(callback, arg) {
                queue[len] = callback;
                queue[len + 1] = arg;
                len += 2;
                if (len === 2) {
                    // If len is 2, that means that we need to schedule an async flush.
                    // If additional callbacks are queued before the queue is flushed, they
                    // will be processed by this flush that we are scheduling.
                    if (customSchedulerFn) customSchedulerFn(flush);
                    else scheduleFlush();
                }
            };
            function setScheduler(scheduleFn) {
                customSchedulerFn = scheduleFn;
            }
            function setAsap(asapFn) {
                asap = asapFn;
            }
            var browserWindow = typeof window !== "undefined" ? window : undefined;
            var browserGlobal = browserWindow || {};
            var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
            var isNode = typeof self === "undefined" && typeof $7dgut !== "undefined" && ({}).toString.call($7dgut) === "[object process]";
            // test for web worker but not in IE10
            var isWorker = typeof Uint8ClampedArray !== "undefined" && typeof importScripts !== "undefined" && typeof MessageChannel !== "undefined";
            // node
            function useNextTick() {
                // node version 0.10.x displays a deprecation warning when nextTick is used recursively
                // see https://github.com/cujojs/when/issues/410 for details
                return function() {
                    return $7dgut.nextTick(flush);
                };
            }
            // vertx
            function useVertxTimer() {
                if (typeof vertxNext !== "undefined") return function() {
                    vertxNext(flush);
                };
                return useSetTimeout();
            }
            function useMutationObserver() {
                var iterations = 0;
                var observer = new BrowserMutationObserver(flush);
                var node = document.createTextNode("");
                observer.observe(node, {
                    characterData: true
                });
                return function() {
                    node.data = iterations = ++iterations % 2;
                };
            }
            // web worker
            function useMessageChannel() {
                var channel = new MessageChannel();
                channel.port1.onmessage = flush;
                return function() {
                    return channel.port2.postMessage(0);
                };
            }
            function useSetTimeout() {
                // Store setTimeout reference so es6-promise will be unaffected by
                // other code modifying setTimeout (like sinon.useFakeTimers())
                var globalSetTimeout = setTimeout;
                return function() {
                    return globalSetTimeout(flush, 1);
                };
            }
            var queue = new Array(1000);
            function flush() {
                for(var i = 0; i < len; i += 2){
                    var callback = queue[i];
                    var arg = queue[i + 1];
                    callback(arg);
                    queue[i] = undefined;
                    queue[i + 1] = undefined;
                }
                len = 0;
            }
            function attemptVertx() {
                try {
                    var vertx = Function("return this")().require("vertx");
                    vertxNext = vertx.runOnLoop || vertx.runOnContext;
                    return useVertxTimer();
                } catch (e) {
                    return useSetTimeout();
                }
            }
            var scheduleFlush = void 0;
            // Decide what async method to use to triggering processing of queued callbacks:
            if (isNode) scheduleFlush = useNextTick();
            else if (BrowserMutationObserver) scheduleFlush = useMutationObserver();
            else if (isWorker) scheduleFlush = useMessageChannel();
            else if (browserWindow === undefined && typeof commonjsRequire === "function") scheduleFlush = attemptVertx();
            else scheduleFlush = useSetTimeout();
            function then(onFulfillment, onRejection) {
                var parent = this;
                var child = new this.constructor(noop);
                if (child[PROMISE_ID] === undefined) makePromise(child);
                var _state = parent._state;
                if (_state) {
                    var callback = arguments[_state - 1];
                    asap(function() {
                        return invokeCallback(_state, child, callback, parent._result);
                    });
                } else subscribe(parent, child, onFulfillment, onRejection);
                return child;
            }
            /**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/ function resolve$1(object) {
                /*jshint validthis:true */ var Constructor = this;
                if (object && typeof object === "object" && object.constructor === Constructor) return object;
                var promise = new Constructor(noop);
                resolve(promise, object);
                return promise;
            }
            var PROMISE_ID = Math.random().toString(36).substring(2);
            function noop() {}
            var PENDING = void 0;
            var FULFILLED = 1;
            var REJECTED = 2;
            var TRY_CATCH_ERROR = {
                error: null
            };
            function selfFulfillment() {
                return new TypeError("You cannot resolve a promise with itself");
            }
            function cannotReturnOwn() {
                return new TypeError("A promises callback cannot return that same promise.");
            }
            function getThen(promise) {
                try {
                    return promise.then;
                } catch (error) {
                    TRY_CATCH_ERROR.error = error;
                    return TRY_CATCH_ERROR;
                }
            }
            function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
                try {
                    then$$1.call(value, fulfillmentHandler, rejectionHandler);
                } catch (e) {
                    return e;
                }
            }
            function handleForeignThenable(promise, thenable, then$$1) {
                asap(function(promise) {
                    var sealed = false;
                    var error = tryThen(then$$1, thenable, function(value) {
                        if (sealed) return;
                        sealed = true;
                        if (thenable !== value) resolve(promise, value);
                        else fulfill(promise, value);
                    }, function(reason) {
                        if (sealed) return;
                        sealed = true;
                        reject(promise, reason);
                    }, "Settle: " + (promise._label || " unknown promise"));
                    if (!sealed && error) {
                        sealed = true;
                        reject(promise, error);
                    }
                }, promise);
            }
            function handleOwnThenable(promise, thenable) {
                if (thenable._state === FULFILLED) fulfill(promise, thenable._result);
                else if (thenable._state === REJECTED) reject(promise, thenable._result);
                else subscribe(thenable, undefined, function(value) {
                    return resolve(promise, value);
                }, function(reason) {
                    return reject(promise, reason);
                });
            }
            function handleMaybeThenable(promise, maybeThenable, then$$1) {
                if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) handleOwnThenable(promise, maybeThenable);
                else {
                    if (then$$1 === TRY_CATCH_ERROR) {
                        reject(promise, TRY_CATCH_ERROR.error);
                        TRY_CATCH_ERROR.error = null;
                    } else if (then$$1 === undefined) fulfill(promise, maybeThenable);
                    else if (isFunction(then$$1)) handleForeignThenable(promise, maybeThenable, then$$1);
                    else fulfill(promise, maybeThenable);
                }
            }
            function resolve(promise, value) {
                if (promise === value) reject(promise, selfFulfillment());
                else if (objectOrFunction(value)) handleMaybeThenable(promise, value, getThen(value));
                else fulfill(promise, value);
            }
            function publishRejection(promise) {
                if (promise._onerror) promise._onerror(promise._result);
                publish(promise);
            }
            function fulfill(promise, value) {
                if (promise._state !== PENDING) return;
                promise._result = value;
                promise._state = FULFILLED;
                if (promise._subscribers.length !== 0) asap(publish, promise);
            }
            function reject(promise, reason) {
                if (promise._state !== PENDING) return;
                promise._state = REJECTED;
                promise._result = reason;
                asap(publishRejection, promise);
            }
            function subscribe(parent, child, onFulfillment, onRejection) {
                var _subscribers = parent._subscribers;
                var length = _subscribers.length;
                parent._onerror = null;
                _subscribers[length] = child;
                _subscribers[length + FULFILLED] = onFulfillment;
                _subscribers[length + REJECTED] = onRejection;
                if (length === 0 && parent._state) asap(publish, parent);
            }
            function publish(promise) {
                var subscribers = promise._subscribers;
                var settled = promise._state;
                if (subscribers.length === 0) return;
                var child = void 0, callback = void 0, detail = promise._result;
                for(var i = 0; i < subscribers.length; i += 3){
                    child = subscribers[i];
                    callback = subscribers[i + settled];
                    if (child) invokeCallback(settled, child, callback, detail);
                    else callback(detail);
                }
                promise._subscribers.length = 0;
            }
            function tryCatch(callback, detail) {
                try {
                    return callback(detail);
                } catch (e) {
                    TRY_CATCH_ERROR.error = e;
                    return TRY_CATCH_ERROR;
                }
            }
            function invokeCallback(settled, promise, callback, detail) {
                var hasCallback = isFunction(callback), value = void 0, error = void 0, succeeded = void 0, failed = void 0;
                if (hasCallback) {
                    value = tryCatch(callback, detail);
                    if (value === TRY_CATCH_ERROR) {
                        failed = true;
                        error = value.error;
                        value.error = null;
                    } else succeeded = true;
                    if (promise === value) {
                        reject(promise, cannotReturnOwn());
                        return;
                    }
                } else {
                    value = detail;
                    succeeded = true;
                }
                if (promise._state !== PENDING) ;
                else if (hasCallback && succeeded) resolve(promise, value);
                else if (failed) reject(promise, error);
                else if (settled === FULFILLED) fulfill(promise, value);
                else if (settled === REJECTED) reject(promise, value);
            }
            function initializePromise(promise, resolver) {
                try {
                    resolver(function resolvePromise(value) {
                        resolve(promise, value);
                    }, function rejectPromise(reason) {
                        reject(promise, reason);
                    });
                } catch (e) {
                    reject(promise, e);
                }
            }
            var id = 0;
            function nextId() {
                return id++;
            }
            function makePromise(promise) {
                promise[PROMISE_ID] = id++;
                promise._state = undefined;
                promise._result = undefined;
                promise._subscribers = [];
            }
            function validationError() {
                return new Error("Array Methods must be provided an Array");
            }
            var Enumerator = function() {
                function Enumerator(Constructor, input) {
                    this._instanceConstructor = Constructor;
                    this.promise = new Constructor(noop);
                    if (!this.promise[PROMISE_ID]) makePromise(this.promise);
                    if (isArray(input)) {
                        this.length = input.length;
                        this._remaining = input.length;
                        this._result = new Array(this.length);
                        if (this.length === 0) fulfill(this.promise, this._result);
                        else {
                            this.length = this.length || 0;
                            this._enumerate(input);
                            if (this._remaining === 0) fulfill(this.promise, this._result);
                        }
                    } else reject(this.promise, validationError());
                }
                Enumerator.prototype._enumerate = function _enumerate(input) {
                    for(var i = 0; this._state === PENDING && i < input.length; i++)this._eachEntry(input[i], i);
                };
                Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
                    var c = this._instanceConstructor;
                    var resolve$$1 = c.resolve;
                    if (resolve$$1 === resolve$1) {
                        var _then = getThen(entry);
                        if (_then === then && entry._state !== PENDING) this._settledAt(entry._state, i, entry._result);
                        else if (typeof _then !== "function") {
                            this._remaining--;
                            this._result[i] = entry;
                        } else if (c === Promise$1) {
                            var promise = new c(noop);
                            handleMaybeThenable(promise, entry, _then);
                            this._willSettleAt(promise, i);
                        } else this._willSettleAt(new c(function(resolve$$1) {
                            return resolve$$1(entry);
                        }), i);
                    } else this._willSettleAt(resolve$$1(entry), i);
                };
                Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
                    var promise = this.promise;
                    if (promise._state === PENDING) {
                        this._remaining--;
                        if (state === REJECTED) reject(promise, value);
                        else this._result[i] = value;
                    }
                    if (this._remaining === 0) fulfill(promise, this._result);
                };
                Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
                    var enumerator = this;
                    subscribe(promise, undefined, function(value) {
                        return enumerator._settledAt(FULFILLED, i, value);
                    }, function(reason) {
                        return enumerator._settledAt(REJECTED, i, reason);
                    });
                };
                return Enumerator;
            }();
            /**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/ function all(entries) {
                return new Enumerator(this, entries).promise;
            }
            /**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/ function race(entries) {
                /*jshint validthis:true */ var Constructor = this;
                if (!isArray(entries)) return new Constructor(function(_, reject) {
                    return reject(new TypeError("You must pass an array to race."));
                });
                else return new Constructor(function(resolve, reject) {
                    var length = entries.length;
                    for(var i = 0; i < length; i++)Constructor.resolve(entries[i]).then(resolve, reject);
                });
            }
            /**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/ function reject$1(reason) {
                /*jshint validthis:true */ var Constructor = this;
                var promise = new Constructor(noop);
                reject(promise, reason);
                return promise;
            }
            function needsResolver() {
                throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
            }
            function needsNew() {
                throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
            }
            /**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/ var Promise$1 = function() {
                function Promise(resolver) {
                    this[PROMISE_ID] = nextId();
                    this._result = this._state = undefined;
                    this._subscribers = [];
                    if (noop !== resolver) {
                        typeof resolver !== "function" && needsResolver();
                        this instanceof Promise ? initializePromise(this, resolver) : needsNew();
                    }
                }
                /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */ /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */ Promise.prototype.catch = function _catch(onRejection) {
                    return this.then(null, onRejection);
                };
                /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */ Promise.prototype.finally = function _finally(callback) {
                    var promise = this;
                    var constructor = promise.constructor;
                    if (isFunction(callback)) return promise.then(function(value) {
                        return constructor.resolve(callback()).then(function() {
                            return value;
                        });
                    }, function(reason) {
                        return constructor.resolve(callback()).then(function() {
                            throw reason;
                        });
                    });
                    return promise.then(callback, callback);
                };
                return Promise;
            }();
            Promise$1.prototype.then = then;
            Promise$1.all = all;
            Promise$1.race = race;
            Promise$1.resolve = resolve$1;
            Promise$1.reject = reject$1;
            Promise$1._setScheduler = setScheduler;
            Promise$1._setAsap = setAsap;
            Promise$1._asap = asap;
            /*global self*/ function polyfill() {
                var local = void 0;
                if (typeof commonjsGlobal !== "undefined") local = commonjsGlobal;
                else if (typeof self !== "undefined") local = self;
                else try {
                    local = Function("return this")();
                } catch (e) {
                    throw new Error("polyfill failed because global object is unavailable in this environment");
                }
                var P = local.Promise;
                if (P) {
                    var promiseToString = null;
                    try {
                        promiseToString = Object.prototype.toString.call(P.resolve());
                    } catch (e) {
                    // silently ignored
                    }
                    if (promiseToString === "[object Promise]" && !P.cast) return;
                }
                local.Promise = Promise$1;
            }
            // Strange compat..
            Promise$1.polyfill = polyfill;
            Promise$1.Promise = Promise$1;
            return Promise$1;
        });
    });
    var Promise$1 = es6Promise.Promise;
    /* ----- CONSTRUCTOR ----- */ var Worker = function Worker(opt) {
        // Create the root parent for the proto chain, and the starting Worker.
        var root = _extends(Worker.convert(Promise$1.resolve()), JSON.parse(JSON.stringify(Worker.template)));
        var self1 = Worker.convert(Promise$1.resolve(), root);
        // Set progress, optional settings, and return.
        self1 = self1.setProgress(1, Worker, 1, [
            Worker
        ]);
        self1 = self1.set(opt);
        return self1;
    };
    // Boilerplate for subclassing Promise.
    Worker.prototype = Object.create(Promise$1.prototype);
    Worker.prototype.constructor = Worker;
    // Converts/casts promises into Workers.
    Worker.convert = function convert(promise, inherit) {
        // Uses prototypal inheritance to receive changes made to ancestors' properties.
        promise.__proto__ = inherit || Worker.prototype;
        return promise;
    };
    Worker.template = {
        prop: {
            src: null,
            container: null,
            overlay: null,
            canvas: null,
            img: null,
            pdf: null,
            pageSize: null
        },
        progress: {
            val: 0,
            state: null,
            n: 0,
            stack: []
        },
        opt: {
            filename: "file.pdf",
            margin: [
                0,
                0,
                0,
                0
            ],
            image: {
                type: "jpeg",
                quality: 0.95
            },
            enableLinks: true,
            html2canvas: {},
            jsPDF: {}
        }
    };
    /* ----- FROM / TO ----- */ Worker.prototype.from = function from(src, type) {
        function getType(src) {
            switch(objType(src)){
                case "string":
                    return "string";
                case "element":
                    return src.nodeName.toLowerCase === "canvas" ? "canvas" : "element";
                default:
                    return "unknown";
            }
        }
        return this.then(function from_main() {
            type = type || getType(src);
            switch(type){
                case "string":
                    return this.set({
                        src: createElement("div", {
                            innerHTML: src
                        })
                    });
                case "element":
                    return this.set({
                        src: src
                    });
                case "canvas":
                    return this.set({
                        canvas: src
                    });
                case "img":
                    return this.set({
                        img: src
                    });
                default:
                    return this.error("Unknown source type.");
            }
        });
    };
    Worker.prototype.to = function to(target) {
        // Route the 'to' request to the appropriate method.
        switch(target){
            case "container":
                return this.toContainer();
            case "canvas":
                return this.toCanvas();
            case "img":
                return this.toImg();
            case "pdf":
                return this.toPdf();
            default:
                return this.error("Invalid target.");
        }
    };
    Worker.prototype.toContainer = function toContainer() {
        // Set up function prerequisites.
        var prereqs = [
            function checkSrc() {
                return this.prop.src || this.error("Cannot duplicate - no source HTML.");
            },
            function checkPageSize() {
                return this.prop.pageSize || this.setPageSize();
            }
        ];
        return this.thenList(prereqs).then(function toContainer_main() {
            // Define the CSS styles for the container and its overlay parent.
            var overlayCSS = {
                position: "fixed",
                overflow: "hidden",
                zIndex: 1000,
                left: 0,
                right: 0,
                bottom: 0,
                top: 0,
                backgroundColor: "rgba(0,0,0,0.8)"
            };
            var containerCSS = {
                position: "absolute",
                width: this.prop.pageSize.inner.width + this.prop.pageSize.unit,
                left: 0,
                right: 0,
                top: 0,
                height: "auto",
                margin: "auto",
                backgroundColor: "white"
            };
            // Set the overlay to hidden (could be changed in the future to provide a print preview).
            overlayCSS.opacity = 0;
            // Create and attach the elements.
            var source = cloneNode(this.prop.src, this.opt.html2canvas.javascriptEnabled);
            this.prop.overlay = createElement("div", {
                className: "html2pdf__overlay",
                style: overlayCSS
            });
            this.prop.container = createElement("div", {
                className: "html2pdf__container",
                style: containerCSS
            });
            this.prop.container.appendChild(source);
            this.prop.overlay.appendChild(this.prop.container);
            document.body.appendChild(this.prop.overlay);
        });
    };
    Worker.prototype.toCanvas = function toCanvas() {
        // Set up function prerequisites.
        var prereqs = [
            function checkContainer() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        // Fulfill prereqs then create the canvas.
        return this.thenList(prereqs).then(function toCanvas_main() {
            // Handle old-fashioned 'onrendered' argument.
            var options = _extends({}, this.opt.html2canvas);
            delete options.onrendered;
            return html2canvas(this.prop.container, options);
        }).then(function toCanvas_post(canvas) {
            // Handle old-fashioned 'onrendered' argument.
            var onRendered = this.opt.html2canvas.onrendered || function() {};
            onRendered(canvas);
            this.prop.canvas = canvas;
            document.body.removeChild(this.prop.overlay);
        });
    };
    Worker.prototype.toImg = function toImg() {
        // Set up function prerequisites.
        var prereqs = [
            function checkCanvas() {
                return this.prop.canvas || this.toCanvas();
            }
        ];
        // Fulfill prereqs then create the image.
        return this.thenList(prereqs).then(function toImg_main() {
            var imgData = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
            this.prop.img = document.createElement("img");
            this.prop.img.src = imgData;
        });
    };
    Worker.prototype.toPdf = function toPdf() {
        // Set up function prerequisites.
        var prereqs = [
            function checkCanvas() {
                return this.prop.canvas || this.toCanvas();
            }
        ];
        // Fulfill prereqs then create the image.
        return this.thenList(prereqs).then(function toPdf_main() {
            // Create local copies of frequently used properties.
            var canvas = this.prop.canvas;
            var opt = this.opt;
            // Calculate the number of pages.
            var pxFullHeight = canvas.height;
            var pxPageHeight = Math.floor(canvas.width * this.prop.pageSize.inner.ratio);
            var nPages = Math.ceil(pxFullHeight / pxPageHeight);
            // Define pageHeight separately so it can be trimmed on the final page.
            var pageHeight = this.prop.pageSize.inner.height;
            // Create a one-page canvas to split up the full image.
            var pageCanvas = document.createElement("canvas");
            var pageCtx = pageCanvas.getContext("2d");
            pageCanvas.width = canvas.width;
            pageCanvas.height = pxPageHeight;
            // Initialize the PDF.
            this.prop.pdf = this.prop.pdf || new jsPDF(opt.jsPDF);
            for(var page = 0; page < nPages; page++){
                // Trim the final page to reduce file size.
                if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
                    pageCanvas.height = pxFullHeight % pxPageHeight;
                    pageHeight = pageCanvas.height * this.prop.pageSize.inner.width / pageCanvas.width;
                }
                // Display the page.
                var w = pageCanvas.width;
                var h = pageCanvas.height;
                pageCtx.fillStyle = "white";
                pageCtx.fillRect(0, 0, w, h);
                pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);
                // Add the page to the PDF.
                if (page) this.prop.pdf.addPage();
                var imgData = pageCanvas.toDataURL("image/" + opt.image.type, opt.image.quality);
                this.prop.pdf.addImage(imgData, opt.image.type, opt.margin[1], opt.margin[0], this.prop.pageSize.inner.width, pageHeight);
            }
        });
    };
    /* ----- OUTPUT / SAVE ----- */ Worker.prototype.output = function output(type, options, src) {
        // Redirect requests to the correct function (outputPdf / outputImg).
        src = src || "pdf";
        if (src.toLowerCase() === "img" || src.toLowerCase() === "image") return this.outputImg(type, options);
        else return this.outputPdf(type, options);
    };
    Worker.prototype.outputPdf = function outputPdf(type, options) {
        // Set up function prerequisites.
        var prereqs = [
            function checkPdf() {
                return this.prop.pdf || this.toPdf();
            }
        ];
        // Fulfill prereqs then perform the appropriate output.
        return this.thenList(prereqs).then(function outputPdf_main() {
            /* Currently implemented output types:
     *    https://rawgit.com/MrRio/jsPDF/master/docs/jspdf.js.html#line992
     *  save(options), arraybuffer, blob, bloburi/bloburl,
     *  datauristring/dataurlstring, dataurlnewwindow, datauri/dataurl
     */ return this.prop.pdf.output(type, options);
        });
    };
    Worker.prototype.outputImg = function outputImg(type, options) {
        // Set up function prerequisites.
        var prereqs = [
            function checkImg() {
                return this.prop.img || this.toImg();
            }
        ];
        // Fulfill prereqs then perform the appropriate output.
        return this.thenList(prereqs).then(function outputImg_main() {
            switch(type){
                case undefined:
                case "img":
                    return this.prop.img;
                case "datauristring":
                case "dataurlstring":
                    return this.prop.img.src;
                case "datauri":
                case "dataurl":
                    return document.location.href = this.prop.img.src;
                default:
                    throw 'Image output type "' + type + '" is not supported.';
            }
        });
    };
    Worker.prototype.save = function save(filename) {
        // Set up function prerequisites.
        var prereqs = [
            function checkPdf() {
                return this.prop.pdf || this.toPdf();
            }
        ];
        // Fulfill prereqs, update the filename (if provided), and save the PDF.
        return this.thenList(prereqs).set(filename ? {
            filename: filename
        } : null).then(function save_main() {
            this.prop.pdf.save(this.opt.filename);
        });
    };
    /* ----- SET / GET ----- */ Worker.prototype.set = function set$$1(opt) {
        // TODO: Implement ordered pairs?
        // Silently ignore invalid or empty input.
        if (objType(opt) !== "object") return this;
        // Build an array of setter functions to queue.
        var fns = Object.keys(opt || {}).map(function(key) {
            if (key in Worker.template.prop) // Set pre-defined properties.
            return function set_prop() {
                this.prop[key] = opt[key];
            };
            else switch(key){
                case "margin":
                    return this.setMargin.bind(this, opt.margin);
                case "jsPDF":
                    return function set_jsPDF() {
                        this.opt.jsPDF = opt.jsPDF;
                        return this.setPageSize();
                    };
                case "pageSize":
                    return this.setPageSize.bind(this, opt.pageSize);
                default:
                    // Set any other properties in opt.
                    return function set_opt() {
                        this.opt[key] = opt[key];
                    };
            }
        }, this);
        // Set properties within the promise chain.
        return this.then(function set_main() {
            return this.thenList(fns);
        });
    };
    Worker.prototype.get = function get$$1(key, cbk) {
        return this.then(function get_main() {
            // Fetch the requested property, either as a predefined prop or in opt.
            var val = key in Worker.template.prop ? this.prop[key] : this.opt[key];
            return cbk ? cbk(val) : val;
        });
    };
    Worker.prototype.setMargin = function setMargin(margin) {
        return this.then(function setMargin_main() {
            // Parse the margin property: [top, left, bottom, right].
            switch(objType(margin)){
                case "number":
                    margin = [
                        margin,
                        margin,
                        margin,
                        margin
                    ];
                case "array":
                    if (margin.length === 2) margin = [
                        margin[0],
                        margin[1],
                        margin[0],
                        margin[1]
                    ];
                    if (margin.length === 4) break;
                default:
                    return this.error("Invalid margin array.");
            }
            // Set the margin property, then update pageSize.
            this.opt.margin = margin;
        }).then(this.setPageSize);
    };
    Worker.prototype.setPageSize = function setPageSize(pageSize) {
        return this.then(function setPageSize_main() {
            // Retrieve page-size based on jsPDF settings, if not explicitly provided.
            pageSize = pageSize || jsPDF.getPageSize(this.opt.jsPDF);
            // Add 'inner' field if not present.
            if (!pageSize.hasOwnProperty("inner")) {
                pageSize.inner = {
                    width: pageSize.width - this.opt.margin[1] - this.opt.margin[3],
                    height: pageSize.height - this.opt.margin[0] - this.opt.margin[2]
                };
                pageSize.inner.px = {
                    width: toPx(pageSize.inner.width, pageSize.k),
                    height: toPx(pageSize.inner.height, pageSize.k)
                };
                pageSize.inner.ratio = pageSize.inner.height / pageSize.inner.width;
            }
            // Attach pageSize to this.
            this.prop.pageSize = pageSize;
        });
    };
    Worker.prototype.setProgress = function setProgress(val, state, n, stack) {
        // Immediately update all progress values.
        if (val != null) this.progress.val = val;
        if (state != null) this.progress.state = state;
        if (n != null) this.progress.n = n;
        if (stack != null) this.progress.stack = stack;
        this.progress.ratio = this.progress.val / this.progress.state;
        // Return this for command chaining.
        return this;
    };
    Worker.prototype.updateProgress = function updateProgress(val, state, n, stack) {
        // Immediately update all progress values, using setProgress.
        return this.setProgress(val ? this.progress.val + val : null, state ? state : null, n ? this.progress.n + n : null, stack ? this.progress.stack.concat(stack) : null);
    };
    /* ----- PROMISE MAPPING ----- */ Worker.prototype.then = function then(onFulfilled, onRejected) {
        // Wrap `this` for encapsulation.
        var self1 = this;
        return this.thenCore(onFulfilled, onRejected, function then_main(onFulfilled, onRejected) {
            // Update progress while queuing, calling, and resolving `then`.
            self1.updateProgress(null, null, 1, [
                onFulfilled
            ]);
            return Promise$1.prototype.then.call(this, function then_pre(val) {
                self1.updateProgress(null, onFulfilled);
                return val;
            }).then(onFulfilled, onRejected).then(function then_post(val) {
                self1.updateProgress(1);
                return val;
            });
        });
    };
    Worker.prototype.thenCore = function thenCore(onFulfilled, onRejected, thenBase) {
        // Handle optional thenBase parameter.
        thenBase = thenBase || Promise$1.prototype.then;
        // Wrap `this` for encapsulation and bind it to the promise handlers.
        var self1 = this;
        if (onFulfilled) onFulfilled = onFulfilled.bind(self1);
        if (onRejected) onRejected = onRejected.bind(self1);
        // Cast self into a Promise to avoid polyfills recursively defining `then`.
        var isNative = Promise$1.toString().indexOf("[native code]") !== -1 && Promise$1.name === "Promise";
        var selfPromise = isNative ? self1 : Worker.convert(_extends({}, self1), Promise$1.prototype);
        // Return the promise, after casting it into a Worker and preserving props.
        var returnVal = thenBase.call(selfPromise, onFulfilled, onRejected);
        return Worker.convert(returnVal, self1.__proto__);
    };
    Worker.prototype.thenExternal = function thenExternal(onFulfilled, onRejected) {
        // Call `then` and return a standard promise (exits the Worker chain).
        return Promise$1.prototype.then.call(this, onFulfilled, onRejected);
    };
    Worker.prototype.thenList = function thenList(fns) {
        // Queue a series of promise 'factories' into the promise chain.
        var self1 = this;
        fns.forEach(function thenList_forEach(fn) {
            self1 = self1.thenCore(fn);
        });
        return self1;
    };
    Worker.prototype["catch"] = function(onRejected) {
        // Bind `this` to the promise handler, call `catch`, and return a Worker.
        if (onRejected) onRejected = onRejected.bind(this);
        var returnVal = Promise$1.prototype["catch"].call(this, onRejected);
        return Worker.convert(returnVal, this);
    };
    Worker.prototype.catchExternal = function catchExternal(onRejected) {
        // Call `catch` and return a standard promise (exits the Worker chain).
        return Promise$1.prototype["catch"].call(this, onRejected);
    };
    Worker.prototype.error = function error(msg) {
        // Throw the error in the Promise chain.
        return this.then(function error_main() {
            throw new Error(msg);
        });
    };
    /* ----- ALIASES ----- */ Worker.prototype.using = Worker.prototype.set;
    Worker.prototype.saveAs = Worker.prototype.save;
    Worker.prototype.export = Worker.prototype.output;
    Worker.prototype.run = Worker.prototype.then;
    // Import dependencies.
    // Get dimensions of a PDF page, as determined by jsPDF.
    jsPDF.getPageSize = function(orientation, unit, format) {
        // Decode options object
        if ((typeof orientation === "undefined" ? "undefined" : _typeof(orientation)) === "object") {
            var options = orientation;
            orientation = options.orientation;
            unit = options.unit || unit;
            format = options.format || format;
        }
        // Default options
        unit = unit || "mm";
        format = format || "a4";
        orientation = ("" + (orientation || "P")).toLowerCase();
        var format_as_string = ("" + format).toLowerCase();
        // Size in pt of various paper formats
        var pageFormats = {
            "a0": [
                2383.94,
                3370.39
            ],
            "a1": [
                1683.78,
                2383.94
            ],
            "a2": [
                1190.55,
                1683.78
            ],
            "a3": [
                841.89,
                1190.55
            ],
            "a4": [
                595.28,
                841.89
            ],
            "a5": [
                419.53,
                595.28
            ],
            "a6": [
                297.64,
                419.53
            ],
            "a7": [
                209.76,
                297.64
            ],
            "a8": [
                147.40,
                209.76
            ],
            "a9": [
                104.88,
                147.40
            ],
            "a10": [
                73.70,
                104.88
            ],
            "b0": [
                2834.65,
                4008.19
            ],
            "b1": [
                2004.09,
                2834.65
            ],
            "b2": [
                1417.32,
                2004.09
            ],
            "b3": [
                1000.63,
                1417.32
            ],
            "b4": [
                708.66,
                1000.63
            ],
            "b5": [
                498.90,
                708.66
            ],
            "b6": [
                354.33,
                498.90
            ],
            "b7": [
                249.45,
                354.33
            ],
            "b8": [
                175.75,
                249.45
            ],
            "b9": [
                124.72,
                175.75
            ],
            "b10": [
                87.87,
                124.72
            ],
            "c0": [
                2599.37,
                3676.54
            ],
            "c1": [
                1836.85,
                2599.37
            ],
            "c2": [
                1298.27,
                1836.85
            ],
            "c3": [
                918.43,
                1298.27
            ],
            "c4": [
                649.13,
                918.43
            ],
            "c5": [
                459.21,
                649.13
            ],
            "c6": [
                323.15,
                459.21
            ],
            "c7": [
                229.61,
                323.15
            ],
            "c8": [
                161.57,
                229.61
            ],
            "c9": [
                113.39,
                161.57
            ],
            "c10": [
                79.37,
                113.39
            ],
            "dl": [
                311.81,
                623.62
            ],
            "letter": [
                612,
                792
            ],
            "government-letter": [
                576,
                756
            ],
            "legal": [
                612,
                1008
            ],
            "junior-legal": [
                576,
                360
            ],
            "ledger": [
                1224,
                792
            ],
            "tabloid": [
                792,
                1224
            ],
            "credit-card": [
                153,
                243
            ]
        };
        // Unit conversion
        switch(unit){
            case "pt":
                var k = 1;
                break;
            case "mm":
                var k = 72 / 25.4;
                break;
            case "cm":
                var k = 72 / 2.54;
                break;
            case "in":
                var k = 72;
                break;
            case "px":
                var k = 0.75;
                break;
            case "pc":
                var k = 12;
                break;
            case "em":
                var k = 12;
                break;
            case "ex":
                var k = 6;
                break;
            default:
                throw "Invalid unit: " + unit;
        }
        // Dimensions are stored as user units and converted to points on output
        if (pageFormats.hasOwnProperty(format_as_string)) {
            var pageHeight = pageFormats[format_as_string][1] / k;
            var pageWidth = pageFormats[format_as_string][0] / k;
        } else try {
            var pageHeight = format[1];
            var pageWidth = format[0];
        } catch (err) {
            throw new Error("Invalid format: " + format);
        }
        // Handle page orientation
        if (orientation === "p" || orientation === "portrait") {
            orientation = "p";
            if (pageWidth > pageHeight) {
                var tmp = pageWidth;
                pageWidth = pageHeight;
                pageHeight = tmp;
            }
        } else if (orientation === "l" || orientation === "landscape") {
            orientation = "l";
            if (pageHeight > pageWidth) {
                var tmp = pageWidth;
                pageWidth = pageHeight;
                pageHeight = tmp;
            }
        } else throw "Invalid orientation: " + orientation;
        // Return information (k is the unit conversion ratio from pts)
        var info = {
            "width": pageWidth,
            "height": pageHeight,
            "unit": unit,
            "k": k
        };
        return info;
    };
    /* Pagebreak plugin:

    Adds page-break functionality to the html2pdf library. Page-breaks can be
    enabled by CSS styles, set on individual elements using selectors, or
    avoided from breaking inside all elements.

    Options on the `opt.pagebreak` object:

    mode:   String or array of strings: 'avoid-all', 'css', and/or 'legacy'
            Default: ['css', 'legacy']

    before: String or array of CSS selectors for which to add page-breaks
            before each element. Can be a specific element with an ID
            ('#myID'), all elements of a type (e.g. 'img'), all of a class
            ('.myClass'), or even '*' to match every element.

    after:  Like 'before', but adds a page-break immediately after the element.

    avoid:  Like 'before', but avoids page-breaks on these elements. You can
            enable this feature on every element using the 'avoid-all' mode.
*/ // Refs to original functions.
    var orig = {
        toContainer: Worker.prototype.toContainer
    };
    // Add pagebreak default options to the Worker template.
    Worker.template.opt.pagebreak = {
        mode: [
            "css",
            "legacy"
        ],
        before: [],
        after: [],
        avoid: []
    };
    Worker.prototype.toContainer = function toContainer() {
        return orig.toContainer.call(this).then(function toContainer_pagebreak() {
            // Setup root element and inner page height.
            var root = this.prop.container;
            var pxPageHeight = this.prop.pageSize.inner.px.height;
            // Check all requested modes.
            var modeSrc = [].concat(this.opt.pagebreak.mode);
            var mode = {
                avoidAll: modeSrc.indexOf("avoid-all") !== -1,
                css: modeSrc.indexOf("css") !== -1,
                legacy: modeSrc.indexOf("legacy") !== -1
            };
            // Get arrays of all explicitly requested elements.
            var select = {};
            var self1 = this;
            [
                "before",
                "after",
                "avoid"
            ].forEach(function(key) {
                var all = mode.avoidAll && key === "avoid";
                select[key] = all ? [] : [].concat(self1.opt.pagebreak[key] || []);
                if (select[key].length > 0) select[key] = Array.prototype.slice.call(root.querySelectorAll(select[key].join(", ")));
            });
            // Get all legacy page-break elements.
            var legacyEls = root.querySelectorAll(".html2pdf__page-break");
            legacyEls = Array.prototype.slice.call(legacyEls);
            // Loop through all elements.
            var els = root.querySelectorAll("*");
            Array.prototype.forEach.call(els, function pagebreak_loop(el) {
                // Setup pagebreak rules based on legacy and avoidAll modes.
                var rules = {
                    before: false,
                    after: mode.legacy && legacyEls.indexOf(el) !== -1,
                    avoid: mode.avoidAll
                };
                // Add rules for css mode.
                if (mode.css) {
                    // TODO: Check if this is valid with iFrames.
                    var style = window.getComputedStyle(el);
                    // TODO: Handle 'left' and 'right' correctly.
                    // TODO: Add support for 'avoid' on breakBefore/After.
                    var breakOpt = [
                        "always",
                        "page",
                        "left",
                        "right"
                    ];
                    var avoidOpt = [
                        "avoid",
                        "avoid-page"
                    ];
                    rules = {
                        before: rules.before || breakOpt.indexOf(style.breakBefore || style.pageBreakBefore) !== -1,
                        after: rules.after || breakOpt.indexOf(style.breakAfter || style.pageBreakAfter) !== -1,
                        avoid: rules.avoid || avoidOpt.indexOf(style.breakInside || style.pageBreakInside) !== -1
                    };
                }
                // Add rules for explicit requests.
                Object.keys(rules).forEach(function(key) {
                    rules[key] = rules[key] || select[key].indexOf(el) !== -1;
                });
                // Get element position on the screen.
                // TODO: Subtract the top of the container from clientRect.top/bottom?
                var clientRect = el.getBoundingClientRect();
                // Avoid: Check if a break happens mid-element.
                if (rules.avoid && !rules.before) {
                    var startPage = Math.floor(clientRect.top / pxPageHeight);
                    var endPage = Math.floor(clientRect.bottom / pxPageHeight);
                    var nPages = Math.abs(clientRect.bottom - clientRect.top) / pxPageHeight;
                    // Turn on rules.before if the el is broken and is at most one page long.
                    if (endPage !== startPage && nPages <= 1) rules.before = true;
                }
                // Before: Create a padding div to push the element to the next page.
                if (rules.before) {
                    var pad = createElement("div", {
                        style: {
                            display: "block",
                            height: pxPageHeight - clientRect.top % pxPageHeight + "px"
                        }
                    });
                    el.parentNode.insertBefore(pad, el);
                }
                // After: Create a padding div to fill the remaining page.
                if (rules.after) {
                    var pad = createElement("div", {
                        style: {
                            display: "block",
                            height: pxPageHeight - clientRect.bottom % pxPageHeight + "px"
                        }
                    });
                    el.parentNode.insertBefore(pad, el.nextSibling);
                }
            });
        });
    };
    // Add hyperlink functionality to the PDF creation.
    // Main link array, and refs to original functions.
    var linkInfo = [];
    var orig$1 = {
        toContainer: Worker.prototype.toContainer,
        toPdf: Worker.prototype.toPdf
    };
    Worker.prototype.toContainer = function toContainer() {
        return orig$1.toContainer.call(this).then(function toContainer_hyperlink() {
            // Retrieve hyperlink info if the option is enabled.
            if (this.opt.enableLinks) {
                // Find all anchor tags and get the container's bounds for reference.
                var container = this.prop.container;
                var links = container.querySelectorAll("a");
                var containerRect = unitConvert(container.getBoundingClientRect(), this.prop.pageSize.k);
                linkInfo = [];
                // Loop through each anchor tag.
                Array.prototype.forEach.call(links, function(link) {
                    // Treat each client rect as a separate link (for text-wrapping).
                    var clientRects = link.getClientRects();
                    for(var i = 0; i < clientRects.length; i++){
                        var clientRect = unitConvert(clientRects[i], this.prop.pageSize.k);
                        clientRect.left -= containerRect.left;
                        clientRect.top -= containerRect.top;
                        var page = Math.floor(clientRect.top / this.prop.pageSize.inner.height) + 1;
                        var top = this.opt.margin[0] + clientRect.top % this.prop.pageSize.inner.height;
                        var left = this.opt.margin[1] + clientRect.left;
                        linkInfo.push({
                            page: page,
                            top: top,
                            left: left,
                            clientRect: clientRect,
                            link: link
                        });
                    }
                }, this);
            }
        });
    };
    Worker.prototype.toPdf = function toPdf() {
        return orig$1.toPdf.call(this).then(function toPdf_hyperlink() {
            // Add hyperlinks if the option is enabled.
            if (this.opt.enableLinks) {
                // Attach each anchor tag based on info from toContainer().
                linkInfo.forEach(function(l) {
                    this.prop.pdf.setPage(l.page);
                    this.prop.pdf.link(l.left, l.top, l.clientRect.width, l.clientRect.height, {
                        url: l.link.href
                    });
                }, this);
                // Reset the active page of the PDF to the final page.
                var nPages = this.prop.pdf.internal.getNumberOfPages();
                this.prop.pdf.setPage(nPages);
            }
        });
    };
    /**
 * Generate a PDF from an HTML element or string using html2canvas and jsPDF.
 *
 * @param {Element|string} source The source element or HTML string.
 * @param {Object=} opt An object of optional settings: 'margin', 'filename',
 *    'image' ('type' and 'quality'), and 'html2canvas' / 'jspdf', which are
 *    sent as settings to their corresponding functions.
 */ var html2pdf = function html2pdf(src, opt) {
        // Create a new worker with the given options.
        var worker = new html2pdf.Worker(opt);
        if (src) // If src is specified, perform the traditional 'simple' operation.
        return worker.from(src).save();
        else // Otherwise, return the worker for new Promise-based operation.
        return worker;
    };
    html2pdf.Worker = Worker;
    return html2pdf;
});


const $67bd4636d5eb8477$var$testResult = ()=>{
    let formRef;
    let { type: type, sessionId: sessionId } = (0, $a252e3f3b9c91bac$export$99eaa27ddbbb95ef)();
    const directorState = (0, $bd34a43d05d9e670$export$2105062e25df4afe)((0, $bd1c05d3e19afc9d$export$86d1cded24611cb8));
    let history = (0, $a252e3f3b9c91bac$export$3420e1dc2c4a518c)();
    const { t: t } = (0, $aa8f0a59a97a3595$export$9fc83ad70ead8663)();
    const dispatch = (0, $07670883d6f89641$export$8ad76b76a4c905f8)();
    const onSubmitFailure = (res)=>{
        dispatch((0, $ef73d84de842ec50$export$fb9705de59d96855)({
            text: t(res.error),
            type: (0, $ef73d84de842ec50$export$87130b6dd9721cee).ERROR,
            props: {}
        }));
    };
    const printResult = ()=>{
        const el = document.body;
        el.classList.add("layout--result-print");
        const opt = {
            margin: [
                0,
                0,
                0,
                0
            ],
            filename: "Lerche_Lesetest.pdf",
            image: {
                type: "jpeg",
                quality: 0.98
            },
            html2canvas: {
                height: el.offsetHeight,
                width: el.offsetWidth,
                scale: 2,
                logging: false,
                dpi: 192
            },
            jsPDF: {
                unit: "mm",
                format: "a4",
                orientation: "portrait"
            }
        };
        const clonedElement = el.cloneNode(true);
        el.classList.remove("layout--result-print");
        console.log("xxx", (0, $d3ce02cc19e55c73$exports.isSafari));
        if (0, $d3ce02cc19e55c73$exports.isSafari) (0, (/*@__PURE__*/$parcel$interopDefault($d2e7b2d329133c02$exports)))().set(opt).from(clonedElement).output("dataurlnewwindow", "Lerche_Lesetest.pdf");
        else (0, (/*@__PURE__*/$parcel$interopDefault($d2e7b2d329133c02$exports)))().set(opt).from(clonedElement).save();
        clonedElement.remove();
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useEffect(()=>{
        const successF = (res)=>{
            //log.info("testResult", "useEffect", res);
            if (res.error) dispatch((0, $ef73d84de842ec50$export$fb9705de59d96855)({
                text: t(res.error),
                type: (0, $ef73d84de842ec50$export$87130b6dd9721cee).ERROR,
                props: {}
            }));
            else dispatch((0, $bd1c05d3e19afc9d$export$2091f1cb24a0a89e)({
                resultHtml: res.result_html
            }));
        };
        let resultRes;
        if (type === "teacher") resultRes = $cdf098895d141710$export$588d6001e05323e6(directorState.sessionId || sessionId);
        else resultRes = $cdf098895d141710$export$c275eceb89556514(directorState.sessionId || sessionId);
        resultRes.then(successF, onSubmitFailure);
        document.body.classList.add("layout--centered", "layout--result");
        return ()=>{
            document.body.classList.remove("layout--centered", "layout--result");
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useEffect(()=>{
        const dlButton = document.querySelector("#dl-button");
        //console.log("xxx directorState.resultHtml", dlButton);
        if (dlButton) dlButton.onclick = printResult;
    }, [
        directorState.resultHtml
    ]);
    const doCancelTest = async ()=>{
        dispatch((0, $bd1c05d3e19afc9d$export$5fd37d90ba0958ec)({}));
        dispatch((0, $ef73d84de842ec50$export$fb9705de59d96855)({
            text: t("abortTest.testWasFinished.message"),
            type: (0, $ef73d84de842ec50$export$87130b6dd9721cee).INFO,
            props: {}
        }));
        history.push((0, $078fc8f7799889e4$export$7aa67dc43ca8e63d));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Fragment, null, directorState.resultHtml && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: directorState.resultHtml
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "section section-result-controls"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "container is-max-tablet"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "controls"
    }, !sessionId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $54a203a48f9a4b71$export$2e2bcd8739ae039), {
        cb: printResult,
        formRef: formRef,
        classes: [
            "button--direction-down",
            "is-rounded",
            "is-success"
        ],
        iconClasses: [
            "icon licon-cloud-arrow-down"
        ],
        caption: t("testResultPage.pdfButton.caption")
    }), " ", !sessionId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $54a203a48f9a4b71$export$2e2bcd8739ae039), {
        cb: doCancelTest,
        dir: "after",
        formRef: formRef,
        classes: [
            "button--direction-right",
            "is-rounded",
            "is-text"
        ],
        iconClasses: [
            "icon licon-arrow-arc-right"
        ],
        caption: t("testResultPage.newTestButton.caption")
    }))))));
};
var $67bd4636d5eb8477$export$2e2bcd8739ae039 = $67bd4636d5eb8477$var$testResult;



const $0278e31e45b52099$export$3565eb3d00ca5a74 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $a252e3f3b9c91bac$export$b5d5cf8927ab7262), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $a62c49ffb9292a68$export$aec9e034445ee8d0), {
        exact: true,
        path: (0, $078fc8f7799889e4$export$1db569cf9469e5b3),
        component: (0, $564db6ad85661f6d$exports.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $a62c49ffb9292a68$export$aec9e034445ee8d0), {
        exact: true,
        path: (0, $078fc8f7799889e4$export$7aa67dc43ca8e63d),
        component: (0, $d1c967cc2cc5f89e$export$2e2bcd8739ae039)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $a62c49ffb9292a68$export$aec9e034445ee8d0), {
        exact: true,
        path: (0, $078fc8f7799889e4$export$45f15e91356025b3),
        component: (0, $67bd4636d5eb8477$export$2e2bcd8739ae039)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $a62c49ffb9292a68$export$aec9e034445ee8d0), {
        exact: true,
        path: (0, $078fc8f7799889e4$export$43be4fd0f6d56954),
        component: (0, $67bd4636d5eb8477$export$2e2bcd8739ae039)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $a62c49ffb9292a68$export$aec9e034445ee8d0), {
        exact: true,
        path: (0, $078fc8f7799889e4$export$500824a38b151028),
        component: (0, $07c0c6a15c49a4f3$export$2e2bcd8739ae039)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $a62c49ffb9292a68$export$aec9e034445ee8d0), {
        exact: true,
        path: (0, $078fc8f7799889e4$export$ce029234ae8b8b29),
        component: (0, $f8f29f96ada01449$export$2e2bcd8739ae039)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $a62c49ffb9292a68$export$aec9e034445ee8d0), {
        exact: true,
        path: (0, $078fc8f7799889e4$export$2a280bdbd8b49d15),
        component: (0, $e2f1ac62ba212fe4$export$2e2bcd8739ae039)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $a62c49ffb9292a68$export$aec9e034445ee8d0), {
        path: (0, $078fc8f7799889e4$export$cd0a6c3b228c8793),
        component: (0, $1be21cc9c163ee19$export$2e2bcd8739ae039)
    }));
};
const $0278e31e45b52099$export$dad4a579cd5614b0 = (directorState, history)=>{
    //log.info("create autoRoute", directorState.sessionId, directorState.currentStep);
    return ()=>{
        if (directorState.sessionId) {
            if (directorState.currentStep === (0, $bd1c05d3e19afc9d$export$10308fe6a08904fd).FINISHED) {
                //log.info("autoRoute to testResultUrl");
                history.push((0, $078fc8f7799889e4$export$45f15e91356025b3));
                return;
            } else {
                //log.info("autoRoute to testUrl");
                history.push((0, $078fc8f7799889e4$export$1db569cf9469e5b3));
                return;
            }
        }
    };
};






var $cQNHH = parcelRequire("cQNHH");


const $ada42d0516c3337f$export$48db0aa9830045c5 = {
    ERROR: "is-danger",
    INFO: "",
    SUCCESS: "is-success"
};
const $ada42d0516c3337f$var$SnackbarComponent = ()=>{
    const snackbarState = (0, $bd34a43d05d9e670$export$2105062e25df4afe)((0, $ef73d84de842ec50$export$5fba9b735dabe025));
    const dispatch1 = (0, $07670883d6f89641$export$8ad76b76a4c905f8)();
    let shownSnacks = new Set();
    (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useEffect(()=>{}, [
        snackbarState.items
    ]);
    const getSnackbars = ()=>{
        let bars = [];
        snackbarState.items.forEach((aBar)=>{
            if (!shownSnacks.has(aBar.id)) setTimeout(()=>{
                // console.log("remove id", shownSnacks, aBar.id);
                shownSnacks.delete(aBar.id);
                dispatch1((0, $ef73d84de842ec50$export$fe2d9b4e03920b4c)({
                    id: aBar.id
                }));
            }, (0, $ef73d84de842ec50$export$3cf918ebc7e29d7a));
            bars.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($ada42d0516c3337f$var$SnackbarItemComponent, {
                key: aBar.id,
                id: aBar.id,
                classname: $ada42d0516c3337f$export$48db0aa9830045c5[aBar.type],
                text: aBar.text
            }));
            shownSnacks.add(aBar.id);
        });
        return bars;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))("snackbars")
    }, getSnackbars(), " ");
};
const $ada42d0516c3337f$var$SnackbarItemComponent = ({ id: id, classname: classname, text: text })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        key: id,
        className: "snackbar notification " + classname
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("p", {
        onClick: ()=>{
            dispatch((0, $ef73d84de842ec50$export$fe2d9b4e03920b4c)({
                id: id
            }));
        }
    }, text, " "));
};
$ada42d0516c3337f$var$SnackbarItemComponent.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).any,
    classname: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string
};
const $ada42d0516c3337f$export$9689b5d1b3e00abd = $ada42d0516c3337f$var$SnackbarComponent;








var $cQNHH = parcelRequire("cQNHH");

var $cQNHH = parcelRequire("cQNHH");
var $631967a987e4dc9c$var$bt = Object.create, $631967a987e4dc9c$var$ke = Object.defineProperty;
var $631967a987e4dc9c$var$gt = Object.getOwnPropertyDescriptor;
var $631967a987e4dc9c$var$yt = Object.getOwnPropertyNames;
var $631967a987e4dc9c$var$wt = Object.getPrototypeOf, $631967a987e4dc9c$var$Lt = Object.prototype.hasOwnProperty;
var $631967a987e4dc9c$var$Pt = (t)=>$631967a987e4dc9c$var$ke(t, "__esModule", {
        value: !0
    });
var $631967a987e4dc9c$var$Mt = (t, e)=>()=>(e || t((e = {
            exports: {}
        }).exports, e), e.exports);
var $631967a987e4dc9c$var$kt = (t, e, n)=>{
    if (e && typeof e == "object" || typeof e == "function") for (let i of $631967a987e4dc9c$var$yt(e))!$631967a987e4dc9c$var$Lt.call(t, i) && i !== "default" && $631967a987e4dc9c$var$ke(t, i, {
        get: ()=>e[i],
        enumerable: !(n = $631967a987e4dc9c$var$gt(e, i)) || n.enumerable
    });
    return t;
}, $631967a987e4dc9c$var$xt = (t)=>$631967a987e4dc9c$var$kt($631967a987e4dc9c$var$Pt($631967a987e4dc9c$var$ke(t != null ? $631967a987e4dc9c$var$bt($631967a987e4dc9c$var$wt(t)) : {}, "default", t && t.__esModule && "default" in t ? {
        get: ()=>t.default,
        enumerable: !0
    } : {
        value: t,
        enumerable: !0
    })), t);
var $631967a987e4dc9c$var$Je = $631967a987e4dc9c$var$Mt((he, Ye)=>{
    (function(t, e) {
        typeof he == "object" && typeof Ye != "undefined" ? e(he) : typeof define == "function" && define.amd ? define([
            "exports"
        ], e) : (t = typeof globalThis != "undefined" ? globalThis : t || self, e(t.fastUniqueNumbers = {}));
    })(he, function(t) {
        "use strict";
        var e = function(d) {
            return function(h) {
                var o = d(h);
                return h.add(o), o;
            };
        }, n = function(d) {
            return function(h, o) {
                return d.set(h, o), o;
            };
        }, i = Number.MAX_SAFE_INTEGER === void 0 ? 9007199254740991 : Number.MAX_SAFE_INTEGER, l = 536870912, m = l * 2, g = function(d, h) {
            return function(o) {
                var V = h.get(o), w = V === void 0 ? o.size : V < m ? V + 1 : 0;
                if (!o.has(w)) return d(o, w);
                if (o.size < l) {
                    for(; o.has(w);)w = Math.floor(Math.random() * m);
                    return d(o, w);
                }
                if (o.size > i) throw new Error("Congratulations, you created a collection of unique numbers which uses all available integers!");
                for(; o.has(w);)w = Math.floor(Math.random() * i);
                return d(o, w);
            };
        }, R = new WeakMap, B = n(R), p = g(B, R), c = e(p);
        t.addUniqueNumber = c, t.generateUniqueNumber = p, Object.defineProperty(t, "__esModule", {
            value: !0
        });
    });
});
function $631967a987e4dc9c$export$1b06ce49faf19067(t) {
    return (0, $cQNHH.forwardRef)(function(n, i) {
        let l = {
            ...n
        }, m = $631967a987e4dc9c$export$3e1c2ef16041091f(l);
        return typeof i == "function" ? i(m) : i && (i.current = m), (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(t, {
            ...n,
            ...m
        });
    });
}
var $631967a987e4dc9c$var$je = class extends (0, $cQNHH.Component) {
}, $631967a987e4dc9c$export$c0b73c5063fae2ae = class extends $631967a987e4dc9c$var$je {
    constructor(e){
        super(e);
        this.onPresenceChange && e.setOnPresenceChange(this.onPresenceChange.bind(this)), this.onPrompt && e.setOnPrompt(this.onPrompt.bind(this)), this.onIdle && e.setOnIdle(this.onIdle.bind(this)), this.onActive && e.setOnActive(this.onActive.bind(this)), this.onAction && e.setOnAction(this.onAction.bind(this)), this.onMessage && e.setOnMessage(this.onMessage.bind(this));
    }
};
var $631967a987e4dc9c$var$se = $631967a987e4dc9c$var$xt($631967a987e4dc9c$var$Je());
var $631967a987e4dc9c$var$ze = (t)=>t.method !== void 0 && t.method === "call";
var $631967a987e4dc9c$var$Xe = (t)=>t.error === null && typeof t.id == "number";
var $631967a987e4dc9c$var$Ke = (t)=>{
    let e = new Map([
        [
            0,
            ()=>{}
        ]
    ]), n = new Map([
        [
            0,
            ()=>{}
        ]
    ]), i = new Map, l = new Worker(t);
    return l.addEventListener("message", ({ data: p })=>{
        if ($631967a987e4dc9c$var$ze(p)) {
            let { params: { timerId: c, timerType: f } } = p;
            if (f === "interval") {
                let d = e.get(c);
                if (typeof d == "number") {
                    let h = i.get(d);
                    if (h === void 0 || h.timerId !== c || h.timerType !== f) throw new Error("The timer is in an undefined state.");
                } else if (typeof d != "undefined") d();
                else throw new Error("The timer is in an undefined state.");
            } else if (f === "timeout") {
                let d = n.get(c);
                if (typeof d == "number") {
                    let h = i.get(d);
                    if (h === void 0 || h.timerId !== c || h.timerType !== f) throw new Error("The timer is in an undefined state.");
                } else if (typeof d != "undefined") d(), n.delete(c);
                else throw new Error("The timer is in an undefined state.");
            }
        } else if ($631967a987e4dc9c$var$Xe(p)) {
            let { id: c } = p, f = i.get(c);
            if (f === void 0) throw new Error("The timer is in an undefined state.");
            let { timerId: d, timerType: h } = f;
            i.delete(c), h === "interval" ? e.delete(d) : n.delete(d);
        } else {
            let { error: { message: c } } = p;
            throw new Error(c);
        }
    }), {
        clearInterval: (p)=>{
            let c = (0, $631967a987e4dc9c$var$se.generateUniqueNumber)(i);
            i.set(c, {
                timerId: p,
                timerType: "interval"
            }), e.set(p, c), l.postMessage({
                id: c,
                method: "clear",
                params: {
                    timerId: p,
                    timerType: "interval"
                }
            });
        },
        clearTimeout: (p)=>{
            let c = (0, $631967a987e4dc9c$var$se.generateUniqueNumber)(i);
            i.set(c, {
                timerId: p,
                timerType: "timeout"
            }), n.set(p, c), l.postMessage({
                id: c,
                method: "clear",
                params: {
                    timerId: p,
                    timerType: "timeout"
                }
            });
        },
        setInterval: (p, c)=>{
            let f = (0, $631967a987e4dc9c$var$se.generateUniqueNumber)(e);
            return e.set(f, ()=>{
                p(), typeof e.get(f) == "function" && l.postMessage({
                    id: null,
                    method: "set",
                    params: {
                        delay: c,
                        now: performance.now(),
                        timerId: f,
                        timerType: "interval"
                    }
                });
            }), l.postMessage({
                id: null,
                method: "set",
                params: {
                    delay: c,
                    now: performance.now(),
                    timerId: f,
                    timerType: "interval"
                }
            }), f;
        },
        setTimeout: (p, c)=>{
            let f = (0, $631967a987e4dc9c$var$se.generateUniqueNumber)(n);
            return n.set(f, p), l.postMessage({
                id: null,
                method: "set",
                params: {
                    delay: c,
                    now: performance.now(),
                    timerId: f,
                    timerType: "timeout"
                }
            }), f;
        }
    };
};
var $631967a987e4dc9c$var$ae = null, $631967a987e4dc9c$var$Qe = (t, e)=>()=>{
        if ($631967a987e4dc9c$var$ae !== null) return $631967a987e4dc9c$var$ae;
        let n = new Blob([
            e
        ], {
            type: "application/javascript; charset=utf-8"
        }), i = URL.createObjectURL(n);
        return $631967a987e4dc9c$var$ae = t(i), $631967a987e4dc9c$var$ae.setTimeout(()=>URL.revokeObjectURL(i), 0), $631967a987e4dc9c$var$ae;
    };
var $631967a987e4dc9c$var$Ze = `(()=>{"use strict";const e=new Map,t=new Map,r=(e,t)=>{let r,o;const i=performance.now();r=i,o=e-Math.max(0,i-t);return{expected:r+o,remainingDelay:o}},o=(e,t,r,i)=>{const s=performance.now();s>r?postMessage({id:null,method:"call",params:{timerId:t,timerType:i}}):e.set(t,setTimeout(o,r-s,e,t,r,i))};addEventListener("message",(i=>{let{data:s}=i;try{if("clear"===s.method){const{id:r,params:{timerId:o,timerType:i}}=s;if("interval"===i)(t=>{const r=e.get(t);if(void 0===r)throw new Error('There is no interval scheduled with the given id "'.concat(t,'".'));clearTimeout(r),e.delete(t)})(o),postMessage({error:null,id:r});else{if("timeout"!==i)throw new Error('The given type "'.concat(i,'" is not supported'));(e=>{const r=t.get(e);if(void 0===r)throw new Error('There is no timeout scheduled with the given id "'.concat(e,'".'));clearTimeout(r),t.delete(e)})(o),postMessage({error:null,id:r})}}else{if("set"!==s.method)throw new Error('The given method "'.concat(s.method,'" is not supported'));{const{params:{delay:i,now:n,timerId:a,timerType:d}}=s;if("interval"===d)((t,i,s)=>{const{expected:n,remainingDelay:a}=r(t,s);e.set(i,setTimeout(o,a,e,i,n,"interval"))})(i,a,n);else{if("timeout"!==d)throw new Error('The given type "'.concat(d,'" is not supported'));((e,i,s)=>{const{expected:n,remainingDelay:a}=r(e,s);t.set(i,setTimeout(o,a,t,i,n,"timeout"))})(i,a,n)}}}}catch(e){postMessage({error:{message:e.message},id:s.id,result:null})}}))})();`;
var $631967a987e4dc9c$var$ve = $631967a987e4dc9c$var$Qe($631967a987e4dc9c$var$Ke, $631967a987e4dc9c$var$Ze), $631967a987e4dc9c$var$et = (t)=>$631967a987e4dc9c$var$ve().clearInterval(t), $631967a987e4dc9c$var$tt = (t)=>$631967a987e4dc9c$var$ve().clearTimeout(t), $631967a987e4dc9c$var$rt = (t, e)=>$631967a987e4dc9c$var$ve().setInterval(t, e), $631967a987e4dc9c$var$nt = (t, e)=>$631967a987e4dc9c$var$ve().setTimeout(t, e);
var $631967a987e4dc9c$var$A = (typeof window == "undefined" ? "undefined" : typeof window) == "object";
var $631967a987e4dc9c$var$E = {
    setTimeout: $631967a987e4dc9c$var$A ? setTimeout.bind(window) : setTimeout,
    clearTimeout: $631967a987e4dc9c$var$A ? clearTimeout.bind(window) : clearTimeout,
    setInterval: $631967a987e4dc9c$var$A ? setInterval.bind(window) : setInterval,
    clearInterval: $631967a987e4dc9c$var$A ? clearInterval.bind(window) : clearInterval
}, $631967a987e4dc9c$export$427b263b93108fff = {
    setTimeout: $631967a987e4dc9c$var$nt,
    clearTimeout: $631967a987e4dc9c$var$tt,
    setInterval: $631967a987e4dc9c$var$rt,
    clearInterval: $631967a987e4dc9c$var$et
};
function $631967a987e4dc9c$export$5ca7e2fccac21705() {
    $631967a987e4dc9c$var$E.setTimeout = setTimeout, $631967a987e4dc9c$var$E.clearTimeout = clearTimeout, $631967a987e4dc9c$var$E.setInterval = setInterval, $631967a987e4dc9c$var$E.clearInterval = clearInterval, $631967a987e4dc9c$export$427b263b93108fff.setTimeout = setTimeout, $631967a987e4dc9c$export$427b263b93108fff.clearTimeout = clearTimeout, $631967a987e4dc9c$export$427b263b93108fff.setInterval = setInterval, $631967a987e4dc9c$export$427b263b93108fff.clearInterval = clearInterval;
}
function $631967a987e4dc9c$var$it(t) {
    $631967a987e4dc9c$var$E.setTimeout = t.setTimeout, $631967a987e4dc9c$var$E.clearTimeout = t.clearTimeout, $631967a987e4dc9c$var$E.setInterval = t.setInterval, $631967a987e4dc9c$var$E.clearInterval = t.clearInterval;
}
var $631967a987e4dc9c$var$Q = {}, $631967a987e4dc9c$var$ot = class {
    onStorage(e) {
        if (e.storageArea !== window.localStorage || e.key.substring(0, this.name.length) !== this.name || e.newValue === null) return;
        let n = JSON.parse(e.newValue);
        this.mc.port2.postMessage(n);
    }
    postMessage(e) {
        if (this.closed) throw new Error("InvalidStateError");
        let n = JSON.stringify(e), i = `${this.name}:${String(Date.now())}${String(Math.random())}`;
        window.localStorage.setItem(i, n), $631967a987e4dc9c$var$E.setTimeout(()=>{
            window.localStorage.removeItem(i);
        }, 500), $631967a987e4dc9c$var$Q[this.name].forEach((l)=>{
            l !== this && l.mc.port2.postMessage(JSON.parse(n));
        });
    }
    close() {
        if (this.closed) return;
        this.closed = !0, this.mc.port1.close(), this.mc.port2.close(), window.removeEventListener("storage", this.onStorage);
        let e = $631967a987e4dc9c$var$Q[this.name].indexOf(this);
        $631967a987e4dc9c$var$Q[this.name].splice(e, 1);
    }
    get onmessage() {
        return this.mc.port1.onmessage;
    }
    set onmessage(e) {
        this.mc.port1.onmessage = e;
    }
    get onmessageerror() {
        return this.mc.port1.onmessageerror;
    }
    set onmessageerror(e) {
        this.mc.port1.onmessageerror = e;
    }
    addEventListener(e, n) {
        return this.mc.port1.addEventListener(e, n);
    }
    removeEventListener(e, n) {
        return this.mc.port1.removeEventListener(e, n);
    }
    dispatchEvent(e) {
        return this.mc.port1.dispatchEvent(e);
    }
    constructor(e){
        this.closed = !1;
        this.mc = new MessageChannel;
        this.name = e, $631967a987e4dc9c$var$Q[e] = $631967a987e4dc9c$var$Q[e] || [], $631967a987e4dc9c$var$Q[e].push(this), this.mc.port1.start(), this.mc.port2.start(), this.onStorage = this.onStorage.bind(this), window.addEventListener("storage", this.onStorage);
    }
}, $631967a987e4dc9c$var$st = typeof window == "undefined" ? void 0 : typeof window.BroadcastChannel == "function" ? window.BroadcastChannel : $631967a987e4dc9c$var$ot;
function $631967a987e4dc9c$var$at(t = 0) {
    return new Promise((e)=>$631967a987e4dc9c$var$E.setTimeout(e, t));
}
function $631967a987e4dc9c$var$Te() {
    return Math.random().toString(36).substring(2);
}
var $631967a987e4dc9c$var$a;
(function(o) {
    o[o.APPLY = 0] = "APPLY", o[o.TELL = 1] = "TELL", o[o.CLOSE = 2] = "CLOSE", o[o.REGISTER = 3] = "REGISTER", o[o.DEREGISTER = 4] = "DEREGISTER", o[o.IDLE = 5] = "IDLE", o[o.ACTIVE = 6] = "ACTIVE", o[o.PROMPT = 7] = "PROMPT", o[o.START = 8] = "START", o[o.RESET = 9] = "RESET", o[o.ACTIVATE = 10] = "ACTIVATE", o[o.PAUSE = 11] = "PAUSE", o[o.RESUME = 12] = "RESUME", o[o.MESSAGE = 13] = "MESSAGE";
})($631967a987e4dc9c$var$a || ($631967a987e4dc9c$var$a = {}));
var $631967a987e4dc9c$var$xe = class {
    async apply() {
        if (this.isLeader || this.isDead) return !1;
        if (this.isApplying) return this.reApply = !0, !1;
        this.isApplying = !0;
        let e = !1, n = (i)=>{
            let { token: l, action: m } = i.data;
            l !== this.token && (m === $631967a987e4dc9c$var$a.APPLY && l > this.token && (e = !0), m === $631967a987e4dc9c$var$a.TELL && (e = !0));
        };
        this.channel.addEventListener("message", n);
        try {
            return this.sendAction($631967a987e4dc9c$var$a.APPLY), await $631967a987e4dc9c$var$at(this.options.responseTime), this.channel.removeEventListener("message", n), this.isApplying = !1, e ? this.reApply ? this.apply() : !1 : (this.assumeLead(), !0);
        } catch  {
            return !1;
        }
    }
    awaitLeadership() {
        if (this.isLeader) return Promise.resolve();
        let e = !1, n = null;
        return new Promise((i)=>{
            let l = ()=>{
                if (e) return;
                e = !0;
                try {
                    $631967a987e4dc9c$var$E.clearInterval(n);
                } catch  {}
                let g = this.intervals.indexOf(n);
                g >= 0 && this.intervals.splice(g, 1), this.channel.removeEventListener("message", m), i();
            };
            n = $631967a987e4dc9c$var$E.setInterval(()=>{
                this.apply().then(()=>{
                    this.isLeader && l();
                });
            }, this.options.fallbackInterval), this.intervals.push(n);
            let m = (g)=>{
                let { action: R } = g.data;
                R === $631967a987e4dc9c$var$a.CLOSE && this.apply().then(()=>{
                    this.isLeader && l();
                });
            };
            this.channel.addEventListener("message", m);
        });
    }
    sendAction(e) {
        this.channel.postMessage({
            action: e,
            token: this.token
        });
    }
    assumeLead() {
        this.isLeader = !0;
        let e = (n)=>{
            let { action: i } = n.data;
            i === $631967a987e4dc9c$var$a.APPLY && this.sendAction($631967a987e4dc9c$var$a.TELL);
        };
        return this.channel.addEventListener("message", e), this.listeners.push(e), this.sendAction($631967a987e4dc9c$var$a.TELL);
    }
    waitForLeadership() {
        return this.deferred ? this.deferred : (this.deferred = this.awaitLeadership(), this.deferred);
    }
    close() {
        if (!this.isDead) {
            this.isDead = !0, this.isLeader = !1, this.sendAction($631967a987e4dc9c$var$a.CLOSE);
            try {
                this.listeners.forEach((e)=>this.channel.removeEventListener("message", e)), this.intervals.forEach((e)=>$631967a987e4dc9c$var$E.clearInterval(e));
            } catch  {}
        }
    }
    constructor(e, n){
        this.token = $631967a987e4dc9c$var$Te();
        this.isLeader = !1;
        this.isDead = !1;
        this.isApplying = !1;
        this.reApply = !1;
        this.intervals = [];
        this.listeners = [];
        this.channel = e, this.options = n, this.apply = this.apply.bind(this), this.awaitLeadership = this.awaitLeadership.bind(this), this.sendAction = this.sendAction.bind(this);
    }
};
var $631967a987e4dc9c$var$k;
(function(i) {
    i[i.PROMPTED = 0] = "PROMPTED", i[i.ACTIVE = 1] = "ACTIVE", i[i.IDLE = 2] = "IDLE";
})($631967a987e4dc9c$var$k || ($631967a987e4dc9c$var$k = {}));
var $631967a987e4dc9c$var$Ae = class {
    get isLeader() {
        if (!this.elector) throw new Error('❌ Leader election is not enabled. To Enable it set the "leaderElection" property to true.');
        return this.elector.isLeader;
    }
    prompt(e = this.token) {
        this.registry.set(e, 0);
        let n = [
            ...this.registry.values()
        ].every((i)=>i === 0);
        e === this.token && this.send($631967a987e4dc9c$var$a.PROMPT), n && this.options.onPrompt();
    }
    idle(e = this.token) {
        this.registry.set(e, 2);
        let n = [
            ...this.registry.values()
        ].every((i)=>i === 2);
        e === this.token && this.send($631967a987e4dc9c$var$a.IDLE), !this.allIdle && n && (this.allIdle = !0, this.options.onIdle());
    }
    active(e = this.token) {
        this.allIdle = !1, this.registry.set(e, 1);
        let n = [
            ...this.registry.values()
        ].some((i)=>i === 1);
        e === this.token && this.send($631967a987e4dc9c$var$a.ACTIVE), n && this.options.onActive(), this.isLastActive = e === this.token;
    }
    start(e = this.token) {
        this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send($631967a987e4dc9c$var$a.START) : this.options.start(!0), this.isLastActive = e === this.token;
    }
    reset(e = this.token) {
        this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send($631967a987e4dc9c$var$a.RESET) : this.options.reset(!0), this.isLastActive = e === this.token;
    }
    activate(e = this.token) {
        this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send($631967a987e4dc9c$var$a.ACTIVATE) : this.options.activate(!0), this.isLastActive = e === this.token;
    }
    pause(e = this.token) {
        e === this.token ? this.send($631967a987e4dc9c$var$a.PAUSE) : this.options.pause(!0);
    }
    resume(e = this.token) {
        e === this.token ? this.send($631967a987e4dc9c$var$a.RESUME) : this.options.resume(!0);
    }
    message(e) {
        try {
            this.channel.postMessage({
                action: $631967a987e4dc9c$var$a.MESSAGE,
                token: this.token,
                data: e
            });
        } catch  {}
    }
    send(e) {
        try {
            this.channel.postMessage({
                action: e,
                token: this.token
            });
        } catch  {}
    }
    close() {
        this.options.leaderElection && this.elector.close(), this.send($631967a987e4dc9c$var$a.DEREGISTER), this.channel.close();
    }
    constructor(e){
        this.token = $631967a987e4dc9c$var$Te();
        this.registry = new Map;
        this.allIdle = !1;
        this.isLastActive = !1;
        let { channelName: n } = e;
        if (this.options = e, this.channel = new $631967a987e4dc9c$var$st(n), this.registry.set(this.token, 1), e.leaderElection) {
            let i = {
                fallbackInterval: 2e3,
                responseTime: 100
            };
            this.elector = new $631967a987e4dc9c$var$xe(this.channel, i), this.elector.waitForLeadership();
        }
        this.channel.addEventListener("message", (i)=>{
            let { action: l, token: m, data: g } = i.data;
            switch(l){
                case $631967a987e4dc9c$var$a.REGISTER:
                    this.registry.set(m, 2);
                    break;
                case $631967a987e4dc9c$var$a.DEREGISTER:
                    this.registry.delete(m);
                    break;
                case $631967a987e4dc9c$var$a.IDLE:
                    this.idle(m);
                    break;
                case $631967a987e4dc9c$var$a.ACTIVE:
                    this.active(m);
                    break;
                case $631967a987e4dc9c$var$a.PROMPT:
                    this.prompt(m);
                    break;
                case $631967a987e4dc9c$var$a.START:
                    this.start(m);
                    break;
                case $631967a987e4dc9c$var$a.RESET:
                    this.reset(m);
                    break;
                case $631967a987e4dc9c$var$a.ACTIVATE:
                    this.activate(m);
                    break;
                case $631967a987e4dc9c$var$a.PAUSE:
                    this.pause(m);
                    break;
                case $631967a987e4dc9c$var$a.RESUME:
                    this.resume(m);
                    break;
                case $631967a987e4dc9c$var$a.MESSAGE:
                    this.options.onMessage(g);
                    break;
            }
        }), this.send($631967a987e4dc9c$var$a.REGISTER);
    }
};
var $631967a987e4dc9c$var$lt = $631967a987e4dc9c$var$A ? document : null, $631967a987e4dc9c$export$1b94debb2480fd98 = [
    "mousemove",
    "keydown",
    "wheel",
    "DOMMouseScroll",
    "mousewheel",
    "mousedown",
    "touchstart",
    "touchmove",
    "MSPointerDown",
    "MSPointerMove",
    "visibilitychange",
    "focus"
];
function $631967a987e4dc9c$var$ct(t, e) {
    let n;
    function i(...l) {
        n && clearTimeout(n), n = setTimeout(()=>{
            t(...l), n = null;
        }, e);
    }
    return i.cancel = function() {
        clearTimeout(n);
    }, i;
}
function $631967a987e4dc9c$var$Ie(t, e) {
    let n = 0;
    return function(...i) {
        let l = new Date().getTime();
        if (!(l - n < e)) return n = l, t(...i);
    };
}
var $631967a987e4dc9c$var$T = ()=>Date.now();
var $631967a987e4dc9c$var$Z = 2147483647;
function $631967a987e4dc9c$export$3e1c2ef16041091f({ timeout: t = 1200000, promptTimeout: e = 0, promptBeforeIdle: n = 0, element: i = $631967a987e4dc9c$var$lt, events: l = $631967a987e4dc9c$export$1b94debb2480fd98, timers: m, immediateEvents: g = [], onPresenceChange: R = ()=>{}, onPrompt: B = ()=>{}, onIdle: p = ()=>{}, onActive: c = ()=>{}, onAction: f = ()=>{}, onMessage: d = ()=>{}, debounce: h = 0, throttle: o = 0, eventsThrottle: V = 200, startOnMount: w = !0, startManually: _ = !1, stopOnIdle: ce = !1, crossTab: Y = !1, name: Oe = "idle-timer", syncTimers: ee = 0, leaderElection: Ce = !1 } = {}) {
    let Re = (0, $cQNHH.useRef)($631967a987e4dc9c$var$T()), ue = (0, $cQNHH.useRef)($631967a987e4dc9c$var$T()), L = (0, $cQNHH.useRef)(null), S = (0, $cQNHH.useRef)(null), F = (0, $cQNHH.useRef)(0), te = (0, $cQNHH.useRef)(0), D = (0, $cQNHH.useRef)(0), x = (0, $cQNHH.useRef)(0), v = (0, $cQNHH.useRef)(!1), b = (0, $cQNHH.useRef)(!1), H = (0, $cQNHH.useRef)(!1), U = (0, $cQNHH.useRef)(!0), re = (0, $cQNHH.useRef)(!1), N = (0, $cQNHH.useRef)(null), s = (0, $cQNHH.useRef)(null), O = (0, $cQNHH.useRef)(t), G = (0, $cQNHH.useRef)(0);
    (0, $cQNHH.useEffect)(()=>{
        if (e && console.warn("⚠️ IdleTimer -- The `promptTimeout` property has been deprecated in favor of `promptBeforeIdle`. It will be removed in the next major release."), n && e) throw new Error("❌ Both promptTimeout and promptBeforeIdle can not be set. The promptTimeout property will be deprecated in a future version.");
        if (t >= $631967a987e4dc9c$var$Z) throw new Error(`\u274C The value for the timeout property must fit in a 32 bit signed integer, ${$631967a987e4dc9c$var$Z}.`);
        if (e >= $631967a987e4dc9c$var$Z) throw new Error(`\u274C The value for the promptTimeout property must fit in a 32 bit signed integer, ${$631967a987e4dc9c$var$Z}.`);
        if (n >= $631967a987e4dc9c$var$Z) throw new Error(`\u274C The value for the promptBeforeIdle property must fit in a 32 bit signed integer, ${$631967a987e4dc9c$var$Z}.`);
        if (n >= t) throw new Error(`\u274C The value for the promptBeforeIdle property must be less than the timeout property, ${t}.`);
        if (n ? (O.current = t - n, G.current = n) : (O.current = t, G.current = e), !U.current) {
            if (_) return;
            v.current && (J.current(null, P), s.current && s.current.active()), X();
        }
    }, [
        t,
        e,
        n,
        _
    ]);
    let De = (0, $cQNHH.useRef)(ce);
    (0, $cQNHH.useEffect)(()=>{
        De.current = ce;
    }, [
        ce
    ]);
    let He = (0, $cQNHH.useRef)(g), ne = (0, $cQNHH.useRef)(i), be = (0, $cQNHH.useRef)([
        ...new Set([
            ...l,
            ...g
        ]).values()
    ]), ie = (0, $cQNHH.useRef)(R);
    (0, $cQNHH.useEffect)(()=>{
        ie.current = R;
    }, [
        R
    ]);
    let me = (0, $cQNHH.useRef)(B);
    (0, $cQNHH.useEffect)(()=>{
        me.current = B;
    }, [
        B
    ]);
    let de = (0, $cQNHH.useRef)(p);
    (0, $cQNHH.useEffect)(()=>{
        de.current = p;
    }, [
        p
    ]);
    let J = (0, $cQNHH.useRef)(c);
    (0, $cQNHH.useEffect)(()=>{
        J.current = c;
    }, [
        c
    ]);
    let pe = (0, $cQNHH.useRef)(f);
    (0, $cQNHH.useEffect)(()=>{
        pe.current = f;
    }, [
        f
    ]);
    let z = (0, $cQNHH.useRef)(d);
    (0, $cQNHH.useEffect)(()=>{
        z.current = d;
    }, [
        d
    ]);
    let q = (0, $cQNHH.useMemo)(()=>{
        let r = (M, K)=>pe.current(M, K);
        return h > 0 ? $631967a987e4dc9c$var$ct(r, h) : o > 0 ? $631967a987e4dc9c$var$Ie(r, o) : r;
    }, [
        o,
        h
    ]), Ne = (0, $cQNHH.useRef)();
    (0, $cQNHH.useEffect)(()=>{
        Y && ee && (Ne.current = $631967a987e4dc9c$var$Ie(()=>{
            s.current.active();
        }, ee));
    }, [
        Y,
        ee
    ]);
    let C = ()=>{
        N.current !== null && ($631967a987e4dc9c$var$E.clearTimeout(N.current), N.current = null);
    }, j = (r, M = !0)=>{
        C(), N.current = $631967a987e4dc9c$var$E.setTimeout(ye, r || O.current), M && (S.current = $631967a987e4dc9c$var$T());
    }, _e = (r)=>{
        !b.current && !v.current && (me.current(r, P), ie.current({
            type: "active",
            prompted: !0
        }, P)), x.current = 0, D.current = $631967a987e4dc9c$var$T(), b.current = !0, j(G.current, !1);
    }, Fe = ()=>{
        C(), v.current || (de.current(null, P), ie.current({
            type: "idle"
        }, P)), v.current = !0, L.current = $631967a987e4dc9c$var$T(), De.current ? $() : b.current && (D.current = 0, b.current = !1);
    }, ge = (r)=>{
        C(), (v.current || b.current) && (J.current(r, P), ie.current({
            type: "active",
            prompted: !1
        }, P)), b.current = !1, D.current = 0, v.current = !1, F.current += $631967a987e4dc9c$var$T() - L.current, te.current += $631967a987e4dc9c$var$T() - L.current, W(), j();
    }, ye = (r)=>{
        if (!v.current) {
            q.cancel && q.cancel();
            let K = $631967a987e4dc9c$var$T() - S.current;
            if (!(O.current + G.current < K) && G.current > 0 && !b.current) {
                s.current ? s.current.prompt() : _e(r);
                return;
            }
            s.current ? s.current.idle() : Fe();
            return;
        }
        s.current ? s.current.active() : ge(r);
    }, we = (r)=>{
        if (!w && !S.current && (S.current = $631967a987e4dc9c$var$T(), J.current(null, P)), q(r, P), b.current) return;
        if (C(), !v.current && He.current.includes(r.type)) {
            ye(r);
            return;
        }
        let M = $631967a987e4dc9c$var$T() - S.current;
        if (v.current && !ce || !v.current && M >= O.current) {
            ye(r);
            return;
        }
        H.current = !1, x.current = 0, D.current = 0, j(), Y && ee && Ne.current();
    }, fe = (0, $cQNHH.useRef)(we);
    (0, $cQNHH.useEffect)(()=>{
        let r = re.current;
        r && $(), V > 0 ? fe.current = $631967a987e4dc9c$var$Ie(we, V) : fe.current = we, r && W();
    }, [
        V,
        o,
        h,
        pe,
        Y,
        ee
    ]);
    let W = ()=>{
        !$631967a987e4dc9c$var$A || !ne.current || re.current || (be.current.forEach((r)=>{
            ne.current.addEventListener(r, fe.current, {
                capture: !0,
                passive: !0
            });
        }), re.current = !0);
    }, $ = (r = !1)=>{
        !$631967a987e4dc9c$var$A || !ne.current || (re.current || r) && (be.current.forEach((M)=>{
            ne.current.removeEventListener(M, fe.current, {
                capture: !0
            });
        }), re.current = !1);
    }, X = (0, $cQNHH.useCallback)((r)=>{
        C(), W(), v.current = !1, b.current = !1, H.current = !1, x.current = 0, D.current = 0, s.current && !r && s.current.start(), j();
    }, [
        N,
        v,
        O,
        s
    ]), Le = (0, $cQNHH.useCallback)((r)=>{
        C(), W(), ue.current = $631967a987e4dc9c$var$T(), F.current += $631967a987e4dc9c$var$T() - L.current, te.current += $631967a987e4dc9c$var$T() - L.current, F.current = 0, v.current = !1, b.current = !1, H.current = !1, x.current = 0, D.current = 0, s.current && !r && s.current.reset(), _ || j();
    }, [
        N,
        v,
        O,
        _,
        s
    ]), Ue = (0, $cQNHH.useCallback)((r)=>{
        C(), W(), (v.current || b.current) && ge(), v.current = !1, b.current = !1, H.current = !1, x.current = 0, D.current = 0, ue.current = $631967a987e4dc9c$var$T(), s.current && !r && s.current.activate(), j();
    }, [
        N,
        v,
        b,
        O,
        s
    ]), Pe = (0, $cQNHH.useCallback)((r = !1)=>H.current ? !1 : (x.current = We(), H.current = !0, $(), C(), s.current && !r && s.current.pause(), !0), [
        N,
        s
    ]), Me = (0, $cQNHH.useCallback)((r = !1)=>H.current ? (H.current = !1, b.current || W(), v.current || j(x.current), D.current && (D.current = $631967a987e4dc9c$var$T()), s.current && !r && s.current.resume(), !0) : !1, [
        N,
        O,
        x,
        s
    ]), ut = (0, $cQNHH.useCallback)((r, M)=>{
        s.current ? (M && z.current(r, P), s.current.message(r)) : M && z.current(r, P);
    }, [
        d
    ]), mt = (0, $cQNHH.useCallback)(()=>v.current, [
        v
    ]), dt = (0, $cQNHH.useCallback)(()=>b.current, [
        b
    ]), pt = (0, $cQNHH.useCallback)(()=>s.current ? s.current.isLeader : null, [
        s
    ]), ft = (0, $cQNHH.useCallback)(()=>s.current ? s.current.isLastActive : null, [
        s
    ]), ht = (0, $cQNHH.useCallback)(()=>s.current ? s.current.token : null, [
        s
    ]), We = (0, $cQNHH.useCallback)(()=>{
        if (H.current) return x.current;
        let r = x.current ? x.current : G.current + O.current, M = S.current ? $631967a987e4dc9c$var$T() - S.current : 0, K = Math.floor(r - M);
        return K < 0 ? 0 : Math.abs(K);
    }, [
        O,
        G,
        b,
        x,
        S
    ]), Be = (0, $cQNHH.useCallback)(()=>Math.round($631967a987e4dc9c$var$T() - ue.current), [
        ue
    ]), Ve = (0, $cQNHH.useCallback)(()=>Math.round($631967a987e4dc9c$var$T() - Re.current), [
        Re
    ]), vt = (0, $cQNHH.useCallback)(()=>L.current ? new Date(L.current) : null, [
        L
    ]), Tt = (0, $cQNHH.useCallback)(()=>S.current ? new Date(S.current) : null, [
        S
    ]), Ge = (0, $cQNHH.useCallback)(()=>v.current ? Math.round($631967a987e4dc9c$var$T() - L.current + F.current) : Math.round(F.current), [
        L,
        F
    ]), qe = (0, $cQNHH.useCallback)(()=>v.current ? Math.round($631967a987e4dc9c$var$T() - L.current + te.current) : Math.round(te.current), [
        L,
        te
    ]), It = (0, $cQNHH.useCallback)(()=>{
        let r = Math.round(Be() - Ge());
        return r >= 0 ? r : 0;
    }, [
        L,
        F
    ]), Et = (0, $cQNHH.useCallback)(()=>{
        let r = Math.round(Ve() - qe());
        return r >= 0 ? r : 0;
    }, [
        L,
        F
    ]);
    (0, $cQNHH.useEffect)(()=>{
        if (h > 0 && o > 0) throw new Error("❌ onAction can either be throttled or debounced, not both.");
        m && $631967a987e4dc9c$var$it(m);
        let r = ()=>{
            s.current && s.current.close(), q.cancel && q.cancel(), C(), $(!0);
        };
        return $631967a987e4dc9c$var$A && window.addEventListener("beforeunload", r), ()=>{
            $631967a987e4dc9c$var$A && window.removeEventListener("beforeunload", r), s.current && s.current.close(), q.cancel && q.cancel(), C(), $(!0);
        };
    }, []), (0, $cQNHH.useEffect)(()=>{
        s.current && s.current.close(), Y ? s.current = new $631967a987e4dc9c$var$Ae({
            channelName: Oe,
            leaderElection: Ce,
            onPrompt: ()=>{
                _e();
            },
            onIdle: ()=>{
                Fe();
            },
            onActive: ()=>{
                ge();
            },
            onMessage: (r)=>{
                z.current(r, P);
            },
            start: X,
            reset: Le,
            activate: Ue,
            pause: Pe,
            resume: Me
        }) : s.current = null;
    }, [
        Y,
        Oe,
        Ce,
        me,
        de,
        J,
        z,
        X,
        Le,
        Pe,
        Me
    ]), (0, $cQNHH.useEffect)(()=>{
        U.current || (C(), $(!0)), !_ && (w ? X() : W());
    }, [
        _,
        w,
        U
    ]), (0, $cQNHH.useEffect)(()=>{
        if (!U.current) {
            let r = [
                ...new Set([
                    ...l,
                    ...g
                ]).values()
            ];
            if ($(), be.current = r, ne.current = i, He.current = g, _) return;
            w ? X() : W();
        }
    }, [
        i,
        JSON.stringify(l),
        JSON.stringify(g),
        U,
        _,
        w
    ]), (0, $cQNHH.useEffect)(()=>{
        U.current && (U.current = !1);
    }, [
        U
    ]);
    let P = {
        message: ut,
        start: X,
        reset: Le,
        activate: Ue,
        pause: Pe,
        resume: Me,
        isIdle: mt,
        isPrompted: dt,
        isLeader: pt,
        isLastActiveTab: ft,
        getTabId: ht,
        getRemainingTime: We,
        getElapsedTime: Be,
        getTotalElapsedTime: Ve,
        getLastIdleTime: vt,
        getLastActiveTime: Tt,
        getIdleTime: Ge,
        getTotalIdleTime: qe,
        getActiveTime: It,
        getTotalActiveTime: Et,
        setOnPresenceChange: (r)=>{
            R = r, ie.current = r;
        },
        setOnPrompt: (r)=>{
            B = r, me.current = r;
        },
        setOnIdle: (r)=>{
            p = r, de.current = r;
        },
        setOnActive: (r)=>{
            c = r, J.current = r;
        },
        setOnAction: (r)=>{
            f = r, pe.current = r;
        },
        setOnMessage: (r)=>{
            d = r, z.current = r;
        }
    };
    return P;
}
var $631967a987e4dc9c$export$e28ea38f1e83b132 = (0, $cQNHH.createContext)(null);
function $631967a987e4dc9c$export$17ce2adb9f89ccf5(t) {
    let e = $631967a987e4dc9c$export$3e1c2ef16041091f(t);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement($631967a987e4dc9c$export$e28ea38f1e83b132.Provider, {
        value: e
    }, t.children);
}
var $631967a987e4dc9c$export$ee38aa87a63cd016 = $631967a987e4dc9c$export$e28ea38f1e83b132.Consumer;
function $631967a987e4dc9c$export$1f7d3dee7d83ab6e() {
    return (0, $cQNHH.useContext)($631967a987e4dc9c$export$e28ea38f1e83b132);
}




const $4fe6e9d5eba9a108$var$idleTime = 840000;
const $4fe6e9d5eba9a108$var$promptTime = 60000;
//import {useTranslation} from "react-i18next";
let $4fe6e9d5eba9a108$var$countDownId;
const $4fe6e9d5eba9a108$var$IdleTimerComponent = ({ children: children })=>{
    const dispatch = (0, $07670883d6f89641$export$8ad76b76a4c905f8)();
    const idleTimerState = (0, $bd34a43d05d9e670$export$2105062e25df4afe)((0, $de29339268adc9ed$export$c3aeaf078d419c4b));
    const history = (0, $a252e3f3b9c91bac$export$3420e1dc2c4a518c)();
    const location = (0, $a252e3f3b9c91bac$export$45d76561a5302f2b)();
    (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).useEffect(()=>{
        if ([
            (0, $078fc8f7799889e4$export$500824a38b151028),
            (0, $078fc8f7799889e4$export$7aa67dc43ca8e63d)
        ].includes(location.pathname)) {
            dispatch((0, $de29339268adc9ed$export$3374cfc036197cff)({
                idleState: "active"
            }));
            pause();
        } else start();
    }, [
        location
    ]);
    const onIdle = ()=>{
        // Close Modal Prompt
        // Do some idle action like log out your user
        //console.log("onIdle", event);
        dispatch((0, $de29339268adc9ed$export$3374cfc036197cff)({
            idleState: "idle"
        }));
        if ($4fe6e9d5eba9a108$var$countDownId) clearInterval($4fe6e9d5eba9a108$var$countDownId);
        console.log("onIdle CANCEL TEST");
        dispatch((0, $bd1c05d3e19afc9d$export$5fd37d90ba0958ec)());
        history.push((0, $078fc8f7799889e4$export$500824a38b151028));
    };
    const onActive = (event)=>{
        // Close Modal Prompt
        // Do some active action
        //console.log("onActive", event);
        dispatch((0, $de29339268adc9ed$export$3374cfc036197cff)({
            idleState: "active"
        }));
    };
    const onAction = (event)=>{
        // Close Modal Prompt
        // Do some active action
        //console.log("onAction", idleTimerState);
        if (idleTimerState.idleState === "prompted") {
            reset();
            if ($4fe6e9d5eba9a108$var$countDownId) clearInterval($4fe6e9d5eba9a108$var$countDownId);
            dispatch((0, $de29339268adc9ed$export$3374cfc036197cff)({
                idleState: "active"
            }));
        }
    };
    const onPrompt = (event)=>{
        // Close Modal Prompt
        // Do some active action
        //console.log("onPrompt", event);
        dispatch((0, $de29339268adc9ed$export$3374cfc036197cff)({
            idleState: "prompted"
        }));
        $4fe6e9d5eba9a108$var$countDownId = setInterval(()=>{
            // eslint-disable-next-line no-use-before-define
            dispatch((0, $de29339268adc9ed$export$afe2734416016192)({
                timeLeft: getRemainingTime()
            }));
        }, 1000);
    };
    const { start: start, pause: pause, reset: reset, getRemainingTime: getRemainingTime } = (0, $631967a987e4dc9c$export$3e1c2ef16041091f)({
        onIdle: onIdle,
        onActive: onActive,
        onAction: onAction,
        onPrompt: onPrompt,
        crossTab: true,
        timers: (0, $631967a987e4dc9c$export$427b263b93108fff),
        timeout: $4fe6e9d5eba9a108$var$idleTime,
        promptTimeout: $4fe6e9d5eba9a108$var$promptTime
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Fragment, null, children);
};
const $4fe6e9d5eba9a108$export$32e97eb3036d7c1e = $4fe6e9d5eba9a108$var$IdleTimerComponent;


const $7f43f642c5f7bfaa$var$App = ()=>{
    const { t: t } = (0, $aa8f0a59a97a3595$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $f9587355c23ab01f$export$2e2bcd8739ae039), {
        store: (0, $2f1964277cbcb4b2$export$6f57813fe9f31bf9)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $b80c0068634c63f4$export$311ca220e7478cda), {
        loading: null,
        persistor: (0, $2f1964277cbcb4b2$export$7b682ac9934ca3e4)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $2829dc11bf9151d9$export$4719288a8f5f7e71), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $2829dc11bf9151d9$export$dcef8f9bb9a41431), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("title", null, t("app.name") + " – " + t("app.subname")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("meta", {
        httpEquiv: "X-UA-Compatible",
        content: "IE=edge,chrome=1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("meta", {
        name: "theme-color",
        content: "#E78704"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("meta", {
        name: "msapplication-navbutton-color",
        content: "#E78704"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("meta", {
        name: "apple-mobile-web-app-status-bar-style",
        content: "#E78704"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("meta", {
        name: "author",
        content: "Transporter – Creating Your Web"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("meta", {
        name: "publisher",
        content: "Transporter – Creating Your Web"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("meta", {
        name: "copyright",
        content: "Transporter – Creating Your Web"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $7012a42bac68cf4a$export$9ba4e89fdfa1fc54), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $ace55934afe561b0$export$e926676385687eaf), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $4fe6e9d5eba9a108$export$32e97eb3036d7c1e), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "modals"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $c503ba36b9c1ffdb$export$2b77a92f1a5ad772), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "header",
        id: "header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $a5a5a1f74bab9dcb$exports.NavigationBar), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement("div", {
        className: "layout"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $0278e31e45b52099$export$3565eb3d00ca5a74), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $46df807587d3bd98$export$2e2bcd8739ae039), {
        type: "light",
        className: "tooltip",
        multiline: true,
        delayShow: 100,
        delayHide: 0,
        padding: "100px 100px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $ada42d0516c3337f$export$9689b5d1b3e00abd), null))))));
};
var $7f43f642c5f7bfaa$export$2e2bcd8739ae039 = $7f43f642c5f7bfaa$var$App;




var $22921c12d3d12565$var$arr = [];
var $22921c12d3d12565$var$each = $22921c12d3d12565$var$arr.forEach;
var $22921c12d3d12565$var$slice = $22921c12d3d12565$var$arr.slice;
function $22921c12d3d12565$var$defaults(obj) {
    $22921c12d3d12565$var$each.call($22921c12d3d12565$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var $22921c12d3d12565$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var $22921c12d3d12565$var$serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || "/";
    var value = encodeURIComponent(val);
    var str = "".concat(name, "=").concat(value);
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error("maxAge should be a Number");
        str += "; Max-Age=".concat(Math.floor(maxAge));
    }
    if (opt.domain) {
        if (!$22921c12d3d12565$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=".concat(opt.domain);
    }
    if (opt.path) {
        if (!$22921c12d3d12565$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=".concat(opt.path);
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=".concat(opt.expires.toUTCString());
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
};
var $22921c12d3d12565$var$cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: "/",
            sameSite: "strict"
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $22921c12d3d12565$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, "", -1);
    }
};
var $22921c12d3d12565$var$cookie$1 = {
    name: "cookie",
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== "undefined") {
            var c = $22921c12d3d12565$var$cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== "undefined") $22921c12d3d12565$var$cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var $22921c12d3d12565$var$querystring = {
    name: "querystring",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var search = window.location.search;
            if (!window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1) search = window.location.hash.substring(window.location.hash.indexOf("?"));
            var query = search.substring(1);
            var params = query.split("&");
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf("=");
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $22921c12d3d12565$var$hasLocalStorageSupport = null;
var $22921c12d3d12565$var$localStorageAvailable = function localStorageAvailable() {
    if ($22921c12d3d12565$var$hasLocalStorageSupport !== null) return $22921c12d3d12565$var$hasLocalStorageSupport;
    try {
        $22921c12d3d12565$var$hasLocalStorageSupport = window !== "undefined" && window.localStorage !== null;
        var testKey = "i18next.translate.boo";
        window.localStorage.setItem(testKey, "foo");
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $22921c12d3d12565$var$hasLocalStorageSupport = false;
    }
    return $22921c12d3d12565$var$hasLocalStorageSupport;
};
var $22921c12d3d12565$var$localStorage = {
    name: "localStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && $22921c12d3d12565$var$localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && $22921c12d3d12565$var$localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var $22921c12d3d12565$var$hasSessionStorageSupport = null;
var $22921c12d3d12565$var$sessionStorageAvailable = function sessionStorageAvailable() {
    if ($22921c12d3d12565$var$hasSessionStorageSupport !== null) return $22921c12d3d12565$var$hasSessionStorageSupport;
    try {
        $22921c12d3d12565$var$hasSessionStorageSupport = window !== "undefined" && window.sessionStorage !== null;
        var testKey = "i18next.translate.boo";
        window.sessionStorage.setItem(testKey, "foo");
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $22921c12d3d12565$var$hasSessionStorageSupport = false;
    }
    return $22921c12d3d12565$var$hasSessionStorageSupport;
};
var $22921c12d3d12565$var$sessionStorage = {
    name: "sessionStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && $22921c12d3d12565$var$sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && $22921c12d3d12565$var$sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var $22921c12d3d12565$var$navigator$1 = {
    name: "navigator",
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== "undefined") {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $22921c12d3d12565$var$htmlTag = {
    name: "htmlTag",
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== "undefined" ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === "function") found = htmlTag.getAttribute("lang");
        return found;
    }
};
var $22921c12d3d12565$var$path = {
    name: "path",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === "number") {
                    if (typeof language[options.lookupFromPathIndex] !== "string") return undefined;
                    found = language[options.lookupFromPathIndex].replace("/", "");
                } else found = language[0].replace("/", "");
            }
        }
        return found;
    }
};
var $22921c12d3d12565$var$subdomain = {
    name: "subdomain",
    lookup: function lookup(options) {
        // If given get the subdomain index else 1
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === "number" ? options.lookupFromSubdomainIndex + 1 : 1; // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        var language = typeof window !== "undefined" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i); // if there is no match (null) return undefined
        if (!language) return undefined; // return the given group match
        return language[lookupFromSubdomainIndex];
    }
};
function $22921c12d3d12565$var$getDefaults() {
    return {
        order: [
            "querystring",
            "cookie",
            "localStorage",
            "sessionStorage",
            "navigator",
            "htmlTag"
        ],
        lookupQuerystring: "lng",
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
        lookupSessionStorage: "i18nextLng",
        // cache user language
        caches: [
            "localStorage"
        ],
        excludeCacheFor: [
            "cimode"
        ] // cookieMinutes: 10,
    };
}
var $22921c12d3d12565$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $b27c7f873a9dd3ed$export$2e2bcd8739ae039)(this, Browser);
        this.type = "languageDetector";
        this.detectors = {};
        this.init(services, options);
    }
    (0, $74e0e51f770d13a2$export$2e2bcd8739ae039)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $22921c12d3d12565$var$defaults(options, this.options || {}, $22921c12d3d12565$var$getDefaults()); // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector($22921c12d3d12565$var$cookie$1);
                this.addDetector($22921c12d3d12565$var$querystring);
                this.addDetector($22921c12d3d12565$var$localStorage);
                this.addDetector($22921c12d3d12565$var$sessionStorage);
                this.addDetector($22921c12d3d12565$var$navigator$1);
                this.addDetector($22921c12d3d12565$var$htmlTag);
                this.addDetector($22921c12d3d12565$var$path);
                this.addDetector($22921c12d3d12565$var$subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === "string") lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
    return Browser;
}();
$22921c12d3d12565$export$2e2bcd8739ae039.type = "languageDetector";



var $cQNHH = parcelRequire("cQNHH");

var $8aa7b6e23832ccb3$exports = {};
$8aa7b6e23832ccb3$exports = JSON.parse('{"app.name":"Lerche","app.subname":"Lesediagnose","error.errorHTML":"<h2>Leider ist ein Fehler aufgetreten. Bitte konktatieren sie einen Adminstrator und \xfcbermitteln folgende Informationen</h2>","error.connectingToServer":"Fehler bei der Kommunikation mit dem Server","error.communicatingWithServer":"Fehler bei der Kommunikation mit dem Server","error.restartButton.caption":"Die Seite neu starten","error.systemReseted.message":"Seite wurde neu gestartet","Can\'t find the session.":"Der Test mit diesem Session–Code ist nicht vorhanden","No test found.":"Der Test mit diesem Test–Code ist nicht vorhanden","sectionProgress.first.caption":"Deine Daten","sectionProgress.result.caption":"Ergebnis","sectionProgress.caption":"Abschnitt","testPage.testName.caption":"Test","testPage.testId.caption":"Session–Code","testPage.nextSectionButton.caption":"Zum n\xe4chsten Abschnitt","testPage.meta.nextSectionButton.caption":"Los geht\'s!","testPage.finishTestButton.caption":"Zum Ergebnis","testPage.session-Code.copied":"Session-Code wurde in die Zwischenablage kopiert","testPage.textRaedButton.info":"Hast du alles gelesen?","testPage.textRaedButton.caption":"Zu den Fragen","testPage.prevButton.caption":"Zur vorherigen Frage","testPage.nextButton.caption":"Zur n\xe4chsten Frage","testPage.answeredAllQuestions.text":"Hast du alle Fragen beantwortet?","testPage.answeredAllQuestionsMeta.text":"Hast du alles ausgef\xfcllt","testPage.default.section.intro":"Bitte lies dir den Text auf der linken Seite gut durch. Klicke anschlie\xdfend auf den Button unter dem Text.","testPage.meta.section.intro":"Bevor der Test beginnt, braucht es noch ein paar Daten von dir. Bitte w\xe4hle sorgf\xe4ltig aus!","modal.help.caption":"Hilfe","modal.help.content":"<p class=\\"mb-lh\\">Bei diesem Test musst du Fragen zu verschiedenen Texten beantworten. Im linken Bereich erscheint der Text, im rechten die Fragen. Insgesamt sind es f\xfcnf Abschnitte (A, B, C, D, E), die du bearbeiten musst.</p><div class=\\"content notification is-info is-light\\"><p class=\\"has-text-weight-bold\\">Diese Tipps sollen dir dabei helfen:</p><ul><li>Wechsle nicht von einem Abschnitt zum n\xe4chsten, ohne die Fragen zu beantworten!</li><li>Es ist nicht schlimm, wenn du mal eine Frage nicht beantworten kannst. Klicke einfach weiter.</li><li>Auch mehrere L\xf6sungen k\xf6nnen richtig sein. \xdcberlege genau!</li><li>Versuche, den gesamten Test ohne Unterbrechung durchzuf\xfchren.</li></ul></div>","modal.nextSection.content":"Hast du alle Fragen beantwortet und m\xf6chtest nichts mehr \xe4ndern?","modal.nextSection.submitButton.caption":"Ok, weiter","modal.nextSection.cancelButton.caption":"Hoppla, zur\xfcck","modal.abortTest.caption":"Test abbrechen","modal.abortTest.content.init":"Achtung!","modal.abortTest.content":"Wenn du den Test abbrichst, geht dein Fortschritt verloren!","modal.abortTest.submitButton.caption":"Test abbrechen","modal.abortTest.cancelButton.caption":"Zur\xfcck zum Test","navigation.home.caption":"Startseite","navigation.startTest.caption":"Test starten","navigation.toTest.caption":"Zum Test","navigation.cancelTest.caption":"Test abbrechen","navigation.finishTest.caption":"Test abschlie\xdfen","navigation.logout.message1":"Du wirst in  ","navigation.logout.message2":" Sekunden automatisch abgemeldet.","navigation.more.caption":"Mehr","navigation.impress.caption":"Impressum","navigation.privacyPolicy.caption":"Datenschutzerkl\xe4rung","navigation.help.caption":"Hilfe","startTestPage.intro1":"<h1>Bevor du mit dem Test startest!</h1><div class=\'notification is-info 0is-light my-lh\'><p>Bitte lies dir die Anleitung gut durch. Ganz unten kannst du den Test starten.</p></div>","startTestPage.intro2":"<div class=\'box my-lh\'><p class=\'has-text-weight-bold mb-10\'><span class=\'icon icon-text licon-number-circle-one\'></span> Deine Daten</p><h2 class=\'is-info\'>Wer bist du?</h2><p>Am Beginn des Tests fragen wir dich nach einigen wichtigen Daten. Die brauchen wir f\xfcr die Auswertung.</p></div><div class=\'box my-lh\'><p class=\'has-text-weight-bold mb-10\'><span class=\'icon icon-text licon-number-circle-two\'></span> Der Lesetest</p><h2 class=\'is-info\'>Lesen und Fragen beantworten</h2><p>W\xe4hrend des Tests siehst du auf der linken Seite einen Text und auf der rechten Seite die Fragen. Versuche, die passende Antwort zu finden. Die Antwort ergibt sich direkt aus dem Text, aber manchmal musst du auch kombinieren.</p><p>Diese Punkte sind wichtig:</p><div class=\'notification is-info is-light\'><p class=\'has-text-weight-bold\'>Es k\xf6nnen eine oder auch mehrere Antworten richtig sein.<br/>Ist eine Frage zu schwer, kannst du auch ohne Antwort weiterklicken.</p></div></div><div class=\'box my-lh\'><p class=\'has-text-weight-bold mb-10\'><span class=\'icon icon-text licon-number-circle-three\'></span> Dein Ergebnis</p><h2 class=\'is-info\'>So gut kannst du lesen</h2><p>Am Ende des Tests zeigen wir dir dein Ergebnis und geben dir Tipps wie du im Lesen noch besser werden kannst.</p></div>","startTestPage.inputNumber.caption":"Jetzt gehts los!","startTestPage.inputNumber.text":"Bitte gib den Test-Code ein, den dir deine Lehrerin oder dein Lehrer gegeben hat.","startTestPage.submitButton.caption":"Test starten","startTestPage.message.testStarted":"Der Test wurde erfolgreich gestartet!","startTestPage.message.testResumed":"Der Test wird fortgef\xfchrt!","startTestPage.error.testcode":"Dieser Testcode ist ung\xfcltig. Bitte gib den Test-Code ein, den dir deine Lehrerin oder dein Lehrer gegeben hat.","abortTest.testWasAborted.message":"Der Test wurde abgebrochen","abortTest.testWasFinished.message":"Der Test wurde abgeschlossen","testcodeField.helpText":"Bitte gib einen g\xfcltigen Test-Code ein.","testResultPage.intro":"<h1>Geschafft!</h1>","testResultPage.nextStep.info":"Was willst du machen?","testResultPage.printButton.caption":"Mein Ergebnis drucken","testResultPage.pdfButton.caption":"Ergebnis herunterladen","testResultPage.newTestButton.caption":"Zur Startseite","help.caption":"Hilfe","privacyPoliy.text":"<div class=“content is-max-tablet”><h1>Datenschutzerkl\xe4rung</h1><h3>1. Datenschutzrechtlicher Verantwortlicher</h3><p><span class=“is-uppercase”>Jung\xf6sterreich</span> Zeitschriftenverlag GmbH &amp; Co KG<br/>6020 Innsbruck<br/>Sillgasse 8</p><p>Tel: +43 512 587205-0<br/>E-Mail: <a href=\'mailto:datenschutz@jungoesterreich.at\'>datenschutz@jungoesterreich.at</a></p><p>Rechtsform: Kommanditgesellschaft<br/>FN 209942 p Landesgericht Innsbruck</p><h3>2. Allgemeines</h3><p>Es ist uns wichtig, dass Sie bei der Nutzung unseres Angebots auf die Einhaltung des Datenschutzes gem\xe4\xdf den gesetzlichen Bestimmungen bzw. der EU-Datenschutz-Grundverordnung (DSGVO) vertrauen k\xf6nnen und wissen, welche personenbezogenen Daten wir w\xe4hrend Ihres Besuchs dieser Website und bei der Inanspruchnahme unseres Angebots erheben und wie wir diese nutzen. Dar\xfcber informieren wir Sie in den nachfolgenden Hinweisen. </p><h3>3. Verarbeitungszwecke</h3><p>\xdcber die Internetseite lerche-lesediagnose.at stellen wir Ihnen das Werkzeug „LERCHE – Die Lesediagnose” in Form einer Website zur Verf\xfcgung. Dazu verarbeiten wir Ihre personenbezogenen Daten zu folgenden Zwecken:</p><p>A) Anzeige der Website<br/>B) Testaktivierung<br/>C) Testdurchf\xfchrung</p><p>Die Verarbeitungen st\xfctzen sich auf den Rechtm\xe4\xdfigkeitsgrund „Vertragserf\xfcllung” gem. Art. 6 Abs. 1 lit. b DSGVO. Wenn Sie uns die f\xfcr die Verarbeitung notwendigen Daten nicht zur Verf\xfcgung stellen, k\xf6nnen Sie „LERCHE – Die Lesediagnose” nicht nutzen.</p><h4>A) Anzeige der Website</h4><p>Wir erheben bei der Nutzung der Website folgende personenbezogenen Daten:</p><ul><li>IP-Adresse des Nutzers</li><li>Datum, Uhrzeit der Anfrage</li><li>Inhalt (angezeigte Seite)</li><li>Zugriffsstatus (http-Statuscode)</li><li>\xdcbertragene Datenmenge</li><li>Verwendetes Betriebssystem</li><li>Sprache, Version der verwendeten Browser-Software</li></ul><p>Die Verarbeitung dieser Daten ist zur Anzeige der Website und f\xfcr die Aufrechterhaltung der IT-Sicherheit notwendig.</p><h4>B) Testaktivierung</h4><p>Wir verarbeiten bei der Testaktivierung nur den eingegebenen Test-Code, um jeden Test eindeutig zuzuordnen.</p><h4>C) Testdurchf\xfchrung</h4><p>Vor und w\xe4hrend der Durchf\xfchrung des Tests verarbeiten wir folgende Daten:</p><ul><li>Test-Code</li><li>Schulstufe</li><li>Schultyp</li><li>Geschlecht</li><li>Alter</li><li>Sprache</li><li>Sozio Economic Status</li></ul><p>Wir speichern die Eingaben und das Ergebnis eines Tests in einer Datenbank. Dies erfolgt pseudonymisiert durch die Zuordnung zu einem Test-Code.</p><h3>4. Verwendung von Cookies</h3><p>Wir verwenden ausschlie\xdflich Cookies, die dazu dienen, die Funktionen der Website und die erfolgreiche Durchf\xfchrung des Tests zu gew\xe4hrleisten.</p><h3>5. Empf\xe4nger von Daten</h3><p>Die erhobenen und berechneten Daten der durchgef\xfchrten Tests (siehe Punkt 6.) bleiben auf der Testplattform pseudonymisiert gespeichert (siehe Punkt C).</p><h5>Auftragsverarbeiter</h5><p>F\xfcr den Schutz Ihrer Daten bleiben wir auch bei Heranziehung eines Auftragsverarbeiters verantwortlich. Als Auftragsverarbeiter ziehen wir als Webhoster Amazon Web Services (<a href=\'http://aws.amazon.com/de/\'>aws.amazon.com/de/</a>) und als Dienstleister f\xfcr die Erstellung und Fehlerbehebung der Lesediagnose-Applikation die Transporter Werbeagentur (<a href=\'http://transporter.at\'>transporter.at</a>) hinzu.</p><h3>6. Datensicherheit</h3><p>Die von uns erhobenen und verarbeiteten Daten werden vertraulich behandelt und durch geeignete und angemessene technische und organisatorische Vorkehrungen vor Verlust und Ver\xe4nderungen sowie dem unberechtigten Zugriff Dritter gesch\xfctzt.</p><h3>7. Automatisierte Entscheidung und Profiling</h3><p>Es finden weder eine automatisierte Entscheidungsfindung noch Profiling statt. Die Beurteilung der Teilnehmer erfolgt in pseudonymisierter Form. Nach Durchf\xfchrung des Tests wird das Ergebnis online angezeigt. Ein sp\xe4terer R\xfcckschluss auf die Testperson ist nicht m\xf6glich.</p><h3>8. Betroffenenrechte</h3><p>Soweit die gesetzlichen Voraussetzungen nach den Art. 15. bis 22. DSGVO vorliegen, haben Sie hinsichtlich Ihrer bei uns verarbeiteten personenbezogenen Daten folgende Rechte (sog. Betroffenenrechte):</p><p>Sie k\xf6nnen jederzeit bei uns Auskunft dar\xfcber verlangen, ob personenbezogene Daten und welche Kategorien personenbezogener Daten \xfcber Sie bei uns gespeichert sind, zu welchen Zwecken diese verarbeitet werden und welche Empf\xe4nger oder Kategorien von Empf\xe4ngern diese ggf. erhalten. Ferner k\xf6nnen Sie die weiteren in Art. 15. DSGVO aufgez\xe4hlten Informationen zu Ihren personenbezogenen Daten bei uns erfragen (Recht auf Auskunft).</p><p>Gem\xe4\xdf den gesetzlichen Voraussetzungen haben Sie au\xdferdem ein Recht auf Berichtigung (Art. 16. DSGVO), ein Recht auf L\xf6schung (Art. 17. DSGVO), ein Recht auf Einschr\xe4nkung der Verarbeitung (Sperrung) (Art. 18. DSGVO) sowie ein Recht auf Widerspruch (Art. 21 DSGVO) Ihrer personenbezogenen Daten.</p><p>Sie haben weiter gem\xe4\xdf Art. 20. DSGVO das Recht, die Sie betreffenden personenbezogenen Daten, die Sie uns bereitgestellt haben, in einem strukturierten, g\xe4ngigen und maschinenlesbaren Format von uns zu erhalten; Sie k\xf6nnen diese personenbezogenen Daten auch an andere Verantwortliche \xfcbermitteln oder \xfcbermitteln lassen (Recht auf Daten\xfcbertragbarkeit).</p><p>Sie haben auch Anspruch auf jederzeitigen Widerruf Ihrer erteilten Einwilligungen.</p><p>Dar\xfcber hinaus haben Sie das Recht, bei Datenverarbeitungen, die nach Art. 6 Abs. 1. lit. f) DSGVO auf den berechtigten Interessen des Verantwortlichen oder eines Dritten beruhen (vgl. Ziffern 3. a. bis e. sowie Ziffern 4. a. bis e.), bei Vorliegen der gesetzlichen Voraussetzungen nach Art. 21. DSGVO der Datenverarbeitung zu widersprechen.</p><p>Zur Geltendmachung Ihrer Betroffenenrechte k\xf6nnen Sie sich jederzeit unter <a href=\'mailto:datenschutz@jungoesterreich.at”>datenschutz@jungoesterreich.at</a> an uns wenden.</p><p>Sie haben gem\xe4\xdf Art. 77. Abs. 1 DSGVO au\xdferdem das Recht, sich bei einer Aufsichtsbeh\xf6rde zu beschweren, wenn Sie der Ansicht sein sollten, dass die Verarbeitung Ihrer personenbezogenen Daten gegen das Datenschutzrecht verst\xf6\xdft. In \xd6sterreich ist dies die Datenschutzbeh\xf6rde:</p><p>\xd6sterreichische Datenschutzbeh\xf6rde<br/>Barichgasse 40-42<br/>1030 Wien</p></div>","impress.text":"<div class=“content is-max-tablet”><h1>Impressum</h1><p>lerche-lesediagnose.at, eine Website bzw. ein Dienst von</p><h3>„Jung\xf6sterreich”</h3><p>Zeitschriftenverlag GmbH &amp; Co KG<br/>6020 Innsbruck<br/>Sillgasse 8</p><p>Tel: +43 512 587205<br/>E-Mail: <a href=“mailto:info@jungoesterreich.at”>info@jungoesterreich.at</a></p><p>Rechtsform: Kommanditgesellschaft<br/>FN 209942 p Landesgericht Innsbruck<br/>UID-Nr. ATU52100006</p><h3>Unbeschr\xe4nkt haftende Gesellschafterin</h3><p>„Jung\xf6sterreich”<br/>Zeitschriftenverlag GmbH<br/>6020 Innsbruck<br/>Sillgasse 8</p><p>Rechtsform: Gesellschaft mit beschr\xe4nkter Haftung<br/>FN 209506 y Landesgericht Innsbruck </p><h3>Herausgeberin</h3><p>Kathrin-Theresa Madl</p><h3>Gesch\xe4ftsf\xfchrung</h3><p>Kathrin-Theresa Madl, Dr. Christoph Schreder</p><h3>Mitherausgeber</h3><p>SOS-Kinderdorf (Gemeinn\xfctziger Verein), Mag. Nora Deinhammer, Stafflerstra\xdfe 10a, 6020 Innsbruck<br/>WWF \xd6sterreich (Gemeinn\xfctziger Verein), Mag. Andrea Johanides, Ottakringer Stra\xdfe 114–116, 1160 Wien</p></div>","yearMonthField_student_birthmonth_caption":"Monat","yearMonthField_student_birthyear_caption":"Jahr","yearMonthField_student_birthmonth_1":"J\xe4nner","yearMonthField_student_birthmonth_2":"Februar","yearMonthField_student_birthmonth_3":"M\xe4rz","yearMonthField_student_birthmonth_4":"April","yearMonthField_student_birthmonth_5":"Mai","yearMonthField_student_birthmonth_6":"Juni","yearMonthField_student_birthmonth_7":"Juli","yearMonthField_student_birthmonth_8":"August","yearMonthField_student_birthmonth_9":"September","yearMonthField_student_birthmonth_10":"Oktober","yearMonthField_student_birthmonth_11":"November","yearMonthField_student_birthmonth_12":"Dezember"}');



//import common_en from "./translations/en/common.json";
(0, $28cc57c8969a2496$export$2e2bcd8739ae039).use((0, $d304d355ba45eefd$export$ae7e14d40d89f296)) // passes i18n down to react-i18next
.use((0, $22921c12d3d12565$export$2e2bcd8739ae039)) // options see https://github.com/i18next/i18next-browser-languageDetector
.init({
    resources: {
        de: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($8aa7b6e23832ccb3$exports)))
        }
    },
    //lng: "de", // if you're using a language detector, do not define the lng option
    fallbackLng: "de",
    debug: false,
    interpolation: {
        escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
});
//console.log("i18n.language", i18n.language);
(0, (/*@__PURE__*/$parcel$interopDefault($a058c85580ba5e0b$exports))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).StrictMode, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $22bbb2509fd1048a$export$1325e8699caa160f), {
    i18n: (0, $28cc57c8969a2496$export$2e2bcd8739ae039)
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $7f43f642c5f7bfaa$export$2e2bcd8739ae039), null))), document.getElementById("root"));


//# sourceMappingURL=index.bf34f6e0.js.map
